
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("emFCc", function(module, exports) {
$parcel$export(module.exports, "default", () => $38580732cfbfbbae$export$2e2bcd8739ae039);

var $qrY1c = parcelRequire("qrY1c");
// Yes, this is a kind of re-export, yes they're bad - however we need a separate asset to act as a "jump asset"
// to allow us to apply the `unstable_forceSkipWrappedAssets` optimisation to the route map. If it was the entry
// point of the bundle this wouldn't work, we still need a wrapped entry point.
const $38580732cfbfbbae$var$getSpaRoutesAsync = ()=>(0, $qrY1c.getSpaRoutes)();
var $38580732cfbfbbae$export$2e2bcd8739ae039 = $38580732cfbfbbae$var$getSpaRoutesAsync;

});
parcelRegister("qrY1c", function(module, exports) {
$parcel$export(module.exports, "getSpaRoutes", () => $d48f2d8fb891a8d9$export$10439de9ce871f28);
/*
 * This file is generated. Do not modify manually
 * If you are adding or deleting a route, please run "yarn dev routes:generate-route-assets"
 * to re-generate this SPA route map and RouteName/RouteGroup types then commit the changes.
 * @generated SignedSource<<6c20aec832772fe2bece7d1f0c13f0ca>>
 * @codegen-command: yarn dev routes:generate-route-map --filter spa
 */ 
var $3y68D = parcelRequire("3y68D");

var $fJ15R = parcelRequire("fJ15R");

var $1R3CQ = parcelRequire("1R3CQ");

var $4eOkX = parcelRequire("4eOkX");

var $iGXDp = parcelRequire("iGXDp");

var $jMKrp = parcelRequire("jMKrp");

var $gK0o2 = parcelRequire("gK0o2");

var $7WGkO = parcelRequire("7WGkO");

var $aPhVH = parcelRequire("aPhVH");

var $9JhPg = parcelRequire("9JhPg");

var $7y12x = parcelRequire("7y12x");

var $54Mg6 = parcelRequire("54Mg6");

var $kZGLD = parcelRequire("kZGLD");

var $5y94r = parcelRequire("5y94r");

var $3cJRB = parcelRequire("3cJRB");

var $apVTf = parcelRequire("apVTf");

var $2PFkC = parcelRequire("2PFkC");

var $7lkHZ = parcelRequire("7lkHZ");

var $fxZdD = parcelRequire("fxZdD");

var $aCLGk = parcelRequire("aCLGk");

var $eJqY3 = parcelRequire("eJqY3");

var $1lOAz = parcelRequire("1lOAz");

var $eOLN9 = parcelRequire("eOLN9");

var $2bnuQ = parcelRequire("2bnuQ");

var $iDdAu = parcelRequire("iDdAu");

var $3cedS = parcelRequire("3cedS");

var $cLZj8 = parcelRequire("cLZj8");

var $Nhl2o = parcelRequire("Nhl2o");

var $g0EQq = parcelRequire("g0EQq");

var $5NEJc = parcelRequire("5NEJc");

var $9AeX2 = parcelRequire("9AeX2");

var $hjFNU = parcelRequire("hjFNU");

var $3w7LE = parcelRequire("3w7LE");

var $eFriF = parcelRequire("eFriF");

var $9enxs = parcelRequire("9enxs");

var $hMZzF = parcelRequire("hMZzF");

var $jVidq = parcelRequire("jVidq");

var $c7xWN = parcelRequire("c7xWN");

var $8WI0C = parcelRequire("8WI0C");

var $7w4wA = parcelRequire("7w4wA");

var $bGwGo = parcelRequire("bGwGo");

var $dRVNt = parcelRequire("dRVNt");

var $9qNa5 = parcelRequire("9qNa5");

var $2MZpi = parcelRequire("2MZpi");

var $5JNuq = parcelRequire("5JNuq");

var $1w4c6 = parcelRequire("1w4c6");

var $bP5Jb = parcelRequire("bP5Jb");

var $d065h = parcelRequire("d065h");

var $8LcdF = parcelRequire("8LcdF");

var $7O1yF = parcelRequire("7O1yF");

var $66eA2 = parcelRequire("66eA2");

var $5GAw8 = parcelRequire("5GAw8");

var $amJJx = parcelRequire("amJJx");

var $eijnk = parcelRequire("eijnk");

var $fvYEf = parcelRequire("fvYEf");

var $kNuDg = parcelRequire("kNuDg");

var $XhYcm = parcelRequire("XhYcm");

var $4OGAK = parcelRequire("4OGAK");

var $5wrsY = parcelRequire("5wrsY");

var $e2Odp = parcelRequire("e2Odp");

var $djb2Z = parcelRequire("djb2Z");

var $5xUFr = parcelRequire("5xUFr");

var $45FXR = parcelRequire("45FXR");

var $d5FsU = parcelRequire("d5FsU");

var $7kn5P = parcelRequire("7kn5P");

var $gjSfP = parcelRequire("gjSfP");

var $7aHwj = parcelRequire("7aHwj");

var $hULAZ = parcelRequire("hULAZ");

var $8WHEn = parcelRequire("8WHEn");

var $6BJfU = parcelRequire("6BJfU");

var $a7Dk4 = parcelRequire("a7Dk4");

var $eAKSk = parcelRequire("eAKSk");

var $j9RxE = parcelRequire("j9RxE");

var $cprgG = parcelRequire("cprgG");

var $aGmFb = parcelRequire("aGmFb");

var $7x2TW = parcelRequire("7x2TW");

var $d6OfK = parcelRequire("d6OfK");

var $4vMYX = parcelRequire("4vMYX");

var $13I6Z = parcelRequire("13I6Z");

var $5IMFp = parcelRequire("5IMFp");

var $eCSHY = parcelRequire("eCSHY");

var $k7BXo = parcelRequire("k7BXo");

var $5ClpU = parcelRequire("5ClpU");

var $74BfF = parcelRequire("74BfF");

var $2r2Qz = parcelRequire("2r2Qz");

var $cyLCh = parcelRequire("cyLCh");

var $gUidc = parcelRequire("gUidc");

var $6p8i9 = parcelRequire("6p8i9");

var $4RXNm = parcelRequire("4RXNm");

var $94WeZ = parcelRequire("94WeZ");

var $81S4s = parcelRequire("81S4s");

var $cGZ5m = parcelRequire("cGZ5m");

var $lw6zb = parcelRequire("lw6zb");

var $h6dkb = parcelRequire("h6dkb");

var $V63Fz = parcelRequire("V63Fz");

var $ktWm2 = parcelRequire("ktWm2");

var $jru5K = parcelRequire("jru5K");

var $2BDh0 = parcelRequire("2BDh0");

var $c7HRO = parcelRequire("c7HRO");

var $2wLap = parcelRequire("2wLap");

var $3arhy = parcelRequire("3arhy");

var $9IZNs = parcelRequire("9IZNs");

var $1YKQh = parcelRequire("1YKQh");

var $2vkb8 = parcelRequire("2vkb8");

var $ek1TG = parcelRequire("ek1TG");

var $5vEtc = parcelRequire("5vEtc");

var $bHvbN = parcelRequire("bHvbN");

var $7NfJj = parcelRequire("7NfJj");

var $iCaX0 = parcelRequire("iCaX0");

var $36fLu = parcelRequire("36fLu");

var $e54wO = parcelRequire("e54wO");

var $ft8RF = parcelRequire("ft8RF");

var $bwD6U = parcelRequire("bwD6U");

var $frNhT = parcelRequire("frNhT");

var $iZ2AQ = parcelRequire("iZ2AQ");

var $2d55w = parcelRequire("2d55w");

var $3bo4c = parcelRequire("3bo4c");

var $kINnF = parcelRequire("kINnF");

var $fkKo1 = parcelRequire("fkKo1");

var $4BD3h = parcelRequire("4BD3h");

var $czPgr = parcelRequire("czPgr");

var $7Zjtg = parcelRequire("7Zjtg");

var $1Jz0d = parcelRequire("1Jz0d");

var $kJhhx = parcelRequire("kJhhx");

var $5Ufi9 = parcelRequire("5Ufi9");

var $l8WGY = parcelRequire("l8WGY");

var $d29rL = parcelRequire("d29rL");

var $47SW5 = parcelRequire("47SW5");

var $jP5bP = parcelRequire("jP5bP");

var $lmaBn = parcelRequire("lmaBn");

var $6egyA = parcelRequire("6egyA");

var $5JjgV = parcelRequire("5JjgV");

var $gTM9q = parcelRequire("gTM9q");

var $bJd2N = parcelRequire("bJd2N");

var $2Q9dT = parcelRequire("2Q9dT");

var $hr8RB = parcelRequire("hr8RB");

var $haVHi = parcelRequire("haVHi");

var $gCQuB = parcelRequire("gCQuB");

var $4gFBe = parcelRequire("4gFBe");

var $dCYpv = parcelRequire("dCYpv");

var $ezywV = parcelRequire("ezywV");

var $iXFOs = parcelRequire("iXFOs");

var $dqsu7 = parcelRequire("dqsu7");

var $j3oaw = parcelRequire("j3oaw");

var $atZb5 = parcelRequire("atZb5");

var $bcSH6 = parcelRequire("bcSH6");

var $L6NLT = parcelRequire("L6NLT");

var $d1pTa = parcelRequire("d1pTa");

var $42xEn = parcelRequire("42xEn");

var $6y1qE = parcelRequire("6y1qE");

var $5UUbR = parcelRequire("5UUbR");

var $djdJN = parcelRequire("djdJN");

var $5ylat = parcelRequire("5ylat");

var $dEChv = parcelRequire("dEChv");

var $7YInD = parcelRequire("7YInD");

var $kXXTW = parcelRequire("kXXTW");

var $6aBHI = parcelRequire("6aBHI");

var $85n74 = parcelRequire("85n74");

var $ekFnU = parcelRequire("ekFnU");

var $3s5Pk = parcelRequire("3s5Pk");

var $Vlf4X = parcelRequire("Vlf4X");

var $7JuWl = parcelRequire("7JuWl");

var $4kc5Q = parcelRequire("4kc5Q");

var $ksM4d = parcelRequire("ksM4d");

var $czFX6 = parcelRequire("czFX6");

var $keKPA = parcelRequire("keKPA");

var $437TO = parcelRequire("437TO");

var $6HVt9 = parcelRequire("6HVt9");

var $7RQxY = parcelRequire("7RQxY");

var $5ZQVr = parcelRequire("5ZQVr");

var $1PFei = parcelRequire("1PFei");

var $11NnB = parcelRequire("11NnB");

var $gRPtE = parcelRequire("gRPtE");

var $4xmZV = parcelRequire("4xmZV");

var $bv6P6 = parcelRequire("bv6P6");

var $lGtFG = parcelRequire("lGtFG");

var $ilnMG = parcelRequire("ilnMG");

var $3baNr = parcelRequire("3baNr");

var $fuBQx = parcelRequire("fuBQx");

var $4Bcd1 = parcelRequire("4Bcd1");

var $flxCZ = parcelRequire("flxCZ");

var $k85NS = parcelRequire("k85NS");

var $dyOQA = parcelRequire("dyOQA");

var $898Bv = parcelRequire("898Bv");

var $2Z13m = parcelRequire("2Z13m");

var $cZnHb = parcelRequire("cZnHb");

var $ExJeP = parcelRequire("ExJeP");

var $5CWoo = parcelRequire("5CWoo");

var $fBUuA = parcelRequire("fBUuA");

var $3WFhy = parcelRequire("3WFhy");

var $7T8Ox = parcelRequire("7T8Ox");

var $8H8bx = parcelRequire("8H8bx");

var $bI8Dj = parcelRequire("bI8Dj");

var $4cnHJ = parcelRequire("4cnHJ");

var $g6DXA = parcelRequire("g6DXA");

var $tNfGA = parcelRequire("tNfGA");

var $4szwi = parcelRequire("4szwi");

var $f7XdL = parcelRequire("f7XdL");

var $goUY1 = parcelRequire("goUY1");

var $cpLuR = parcelRequire("cpLuR");

var $5KbgO = parcelRequire("5KbgO");

var $d3qbB = parcelRequire("d3qbB");

var $kLk7C = parcelRequire("kLk7C");

var $fcC3H = parcelRequire("fcC3H");

var $4CAXG = parcelRequire("4CAXG");

var $kZ7rD = parcelRequire("kZ7rD");

var $dChQF = parcelRequire("dChQF");

var $67YRM = parcelRequire("67YRM");

var $bWzV9 = parcelRequire("bWzV9");

var $aieAu = parcelRequire("aieAu");

var $hEWb7 = parcelRequire("hEWb7");

var $dVpvh = parcelRequire("dVpvh");

var $iLf1F = parcelRequire("iLf1F");

var $2zDjc = parcelRequire("2zDjc");

var $izkie = parcelRequire("izkie");

var $9Isj0 = parcelRequire("9Isj0");

var $bs2w3 = parcelRequire("bs2w3");

var $jlE2b = parcelRequire("jlE2b");

var $kDttK = parcelRequire("kDttK");

var $20DnI = parcelRequire("20DnI");

var $81vTA = parcelRequire("81vTA");

var $f0p1P = parcelRequire("f0p1P");

var $1yaIP = parcelRequire("1yaIP");

var $bksGt = parcelRequire("bksGt");

var $WOvcu = parcelRequire("WOvcu");

var $kTUT3 = parcelRequire("kTUT3");

var $cHL3P = parcelRequire("cHL3P");

var $fSwF2 = parcelRequire("fSwF2");

var $4VbNK = parcelRequire("4VbNK");

var $25Xvp = parcelRequire("25Xvp");

var $5uVut = parcelRequire("5uVut");

var $qU7hK = parcelRequire("qU7hK");

var $9cLPB = parcelRequire("9cLPB");

var $cVu4s = parcelRequire("cVu4s");

var $dceq5 = parcelRequire("dceq5");

var $i1SxF = parcelRequire("i1SxF");

var $64vgo = parcelRequire("64vgo");

var $9hXyI = parcelRequire("9hXyI");

var $1PXic = parcelRequire("1PXic");

var $pX4Kl = parcelRequire("pX4Kl");

var $7lW5H = parcelRequire("7lW5H");

var $7RzXN = parcelRequire("7RzXN");

var $8M7gQ = parcelRequire("8M7gQ");

var $1kuHh = parcelRequire("1kuHh");

var $amP5i = parcelRequire("amP5i");

var $4AyGF = parcelRequire("4AyGF");

var $MBVfl = parcelRequire("MBVfl");

var $4w8EY = parcelRequire("4w8EY");

var $eYdQw = parcelRequire("eYdQw");

var $lOn6l = parcelRequire("lOn6l");

var $37pqk = parcelRequire("37pqk");

var $gymKR = parcelRequire("gymKR");

var $dJkii = parcelRequire("dJkii");

var $7M3Qw = parcelRequire("7M3Qw");

var $kSzi3 = parcelRequire("kSzi3");

var $eIWvD = parcelRequire("eIWvD");

var $5HdwO = parcelRequire("5HdwO");

var $9kaa4 = parcelRequire("9kaa4");

var $7lqd9 = parcelRequire("7lqd9");

var $bxEah = parcelRequire("bxEah");

var $ytX2z = parcelRequire("ytX2z");

var $5rr5U = parcelRequire("5rr5U");

var $fFeTt = parcelRequire("fFeTt");

var $9onbT = parcelRequire("9onbT");

var $i6owk = parcelRequire("i6owk");

var $6tmSj = parcelRequire("6tmSj");

var $2KqMs = parcelRequire("2KqMs");

var $5ZNYc = parcelRequire("5ZNYc");

var $hPiSX = parcelRequire("hPiSX");

var $5JYqa = parcelRequire("5JYqa");

var $ljCsD = parcelRequire("ljCsD");

var $lIqxK = parcelRequire("lIqxK");

var $2Q6z2 = parcelRequire("2Q6z2");

var $c0nCS = parcelRequire("c0nCS");

var $1U37F = parcelRequire("1U37F");

var $3ZA2n = parcelRequire("3ZA2n");

var $ghxYA = parcelRequire("ghxYA");

var $bMvJs = parcelRequire("bMvJs");

var $ffcU3 = parcelRequire("ffcU3");

var $eWBMh = parcelRequire("eWBMh");

var $7lsw4 = parcelRequire("7lsw4");

var $bMj4d = parcelRequire("bMj4d");

var $6XPJ5 = parcelRequire("6XPJ5");

var $1fi5O = parcelRequire("1fi5O");

var $3DoQq = parcelRequire("3DoQq");

var $dpAnL = parcelRequire("dpAnL");

var $20wcj = parcelRequire("20wcj");

var $1lGts = parcelRequire("1lGts");

var $j3R4j = parcelRequire("j3R4j");

var $gG5r4 = parcelRequire("gG5r4");

var $jYWZX = parcelRequire("jYWZX");

var $21gXe = parcelRequire("21gXe");

var $5jjQ1 = parcelRequire("5jjQ1");

var $1MGof = parcelRequire("1MGof");

var $i5Fsz = parcelRequire("i5Fsz");

var $3mrXC = parcelRequire("3mrXC");

var $4SqLF = parcelRequire("4SqLF");

var $bRYwY = parcelRequire("bRYwY");

var $C784O = parcelRequire("C784O");

var $6hSMD = parcelRequire("6hSMD");

var $bWZUz = parcelRequire("bWZUz");

var $ihfrS = parcelRequire("ihfrS");

var $kMe3w = parcelRequire("kMe3w");

var $id9nd = parcelRequire("id9nd");

var $7K8ER = parcelRequire("7K8ER");

var $hefqI = parcelRequire("hefqI");

var $bIDIn = parcelRequire("bIDIn");

var $iaJjO = parcelRequire("iaJjO");

var $flrMb = parcelRequire("flrMb");

var $10xT1 = parcelRequire("10xT1");

var $5oAgu = parcelRequire("5oAgu");

var $k5e75 = parcelRequire("k5e75");

var $leBbj = parcelRequire("leBbj");

var $jlwtU = parcelRequire("jlwtU");

var $3yeCC = parcelRequire("3yeCC");

var $4FBBR = parcelRequire("4FBBR");

var $d5Bb9 = parcelRequire("d5Bb9");

var $jSGUL = parcelRequire("jSGUL");

var $bJXfU = parcelRequire("bJXfU");

var $k3Rn6 = parcelRequire("k3Rn6");

var $5DVEh = parcelRequire("5DVEh");

var $jJEm7 = parcelRequire("jJEm7");

var $flxMn = parcelRequire("flxMn");

var $iJbtQ = parcelRequire("iJbtQ");

var $98Umx = parcelRequire("98Umx");

var $33RDm = parcelRequire("33RDm");

var $9a7o3 = parcelRequire("9a7o3");

var $7Al9R = parcelRequire("7Al9R");

var $4p5og = parcelRequire("4p5og");

var $01dV2 = parcelRequire("01dV2");

var $eDNar = parcelRequire("eDNar");

var $cWeYh = parcelRequire("cWeYh");

var $0eLvf = parcelRequire("0eLvf");

var $avhOT = parcelRequire("avhOT");

var $jXIBH = parcelRequire("jXIBH");

var $f0kp3 = parcelRequire("f0kp3");

var $1zTPx = parcelRequire("1zTPx");

var $hpFrr = parcelRequire("hpFrr");

var $deNkw = parcelRequire("deNkw");

var $b89Z5 = parcelRequire("b89Z5");

var $i7x71 = parcelRequire("i7x71");

var $iifeU = parcelRequire("iifeU");

var $6szZq = parcelRequire("6szZq");

var $bWhAh = parcelRequire("bWhAh");

var $e8aTE = parcelRequire("e8aTE");

var $iIHov = parcelRequire("iIHov");

var $iuWdX = parcelRequire("iuWdX");

var $1hrj9 = parcelRequire("1hrj9");

var $aanGM = parcelRequire("aanGM");

var $35zIt = parcelRequire("35zIt");

var $7V5F5 = parcelRequire("7V5F5");

var $lAyQF = parcelRequire("lAyQF");

var $9Gw9x = parcelRequire("9Gw9x");

var $jhJLH = parcelRequire("jhJLH");

var $uS0Wn = parcelRequire("uS0Wn");

var $3CKd6 = parcelRequire("3CKd6");

var $emNcb = parcelRequire("emNcb");

var $bb3Kz = parcelRequire("bb3Kz");

var $fAxRm = parcelRequire("fAxRm");

var $gLtBa = parcelRequire("gLtBa");

var $3d0g1 = parcelRequire("3d0g1");

var $7mEsO = parcelRequire("7mEsO");

var $j2UMI = parcelRequire("j2UMI");

var $l29cD = parcelRequire("l29cD");

var $eze04 = parcelRequire("eze04");

var $9B4ho = parcelRequire("9B4ho");

var $dMtOC = parcelRequire("dMtOC");

var $2cgig = parcelRequire("2cgig");

var $9GvQT = parcelRequire("9GvQT");

var $65d18 = parcelRequire("65d18");

var $7ucgW = parcelRequire("7ucgW");

var $dVWks = parcelRequire("dVWks");

var $0MUFU = parcelRequire("0MUFU");

var $1yqW3 = parcelRequire("1yqW3");

var $9rb1x = parcelRequire("9rb1x");

var $af0ih = parcelRequire("af0ih");

var $8Qqsd = parcelRequire("8Qqsd");

var $d1As4 = parcelRequire("d1As4");

var $9tjWC = parcelRequire("9tjWC");

var $kwERN = parcelRequire("kwERN");

var $773VE = parcelRequire("773VE");

var $jiUh1 = parcelRequire("jiUh1");

var $8Iv3H = parcelRequire("8Iv3H");

var $f83an = parcelRequire("f83an");

var $cWPJr = parcelRequire("cWPJr");

var $4BOoE = parcelRequire("4BOoE");

var $h7Red = parcelRequire("h7Red");

var $7Pdre = parcelRequire("7Pdre");

var $20zzw = parcelRequire("20zzw");

var $h4zAy = parcelRequire("h4zAy");

var $4WoRT = parcelRequire("4WoRT");

var $im6xk = parcelRequire("im6xk");

var $6P2Hr = parcelRequire("6P2Hr");

var $lJuD5 = parcelRequire("lJuD5");

var $kjUZx = parcelRequire("kjUZx");

var $4yidD = parcelRequire("4yidD");

var $ikmMT = parcelRequire("ikmMT");

var $cw1uU = parcelRequire("cw1uU");

var $3wFf4 = parcelRequire("3wFf4");

var $85Rgm = parcelRequire("85Rgm");

var $2Uft0 = parcelRequire("2Uft0");

var $jCXKu = parcelRequire("jCXKu");

var $k25kz = parcelRequire("k25kz");

var $ebqmN = parcelRequire("ebqmN");

var $43NlL = parcelRequire("43NlL");

var $2LDVV = parcelRequire("2LDVV");

var $9RMhv = parcelRequire("9RMhv");

var $h3kpF = parcelRequire("h3kpF");

var $23ehb = parcelRequire("23ehb");

var $70AS8 = parcelRequire("70AS8");

var $ceWLf = parcelRequire("ceWLf");

var $fKViZ = parcelRequire("fKViZ");

var $5k4zE = parcelRequire("5k4zE");

var $5w2Cj = parcelRequire("5w2Cj");

var $cq7wq = parcelRequire("cq7wq");

var $bBqyO = parcelRequire("bBqyO");

var $cM5pJ = parcelRequire("cM5pJ");

var $95uMc = parcelRequire("95uMc");

var $61kne = parcelRequire("61kne");

var $85bCZ = parcelRequire("85bCZ");

var $ihexr = parcelRequire("ihexr");

var $3jDGC = parcelRequire("3jDGC");

var $kmfhe = parcelRequire("kmfhe");

var $3VkWO = parcelRequire("3VkWO");

var $grzdo = parcelRequire("grzdo");

var $b29TL = parcelRequire("b29TL");

var $csLF9 = parcelRequire("csLF9");

var $dTlAf = parcelRequire("dTlAf");

var $dKx89 = parcelRequire("dKx89");

var $bWmUQ = parcelRequire("bWmUQ");

var $hT9aM = parcelRequire("hT9aM");

var $dpK5U = parcelRequire("dpK5U");

var $f60wn = parcelRequire("f60wn");

var $18Mhr = parcelRequire("18Mhr");

var $iCcmc = parcelRequire("iCcmc");

var $f0hVi = parcelRequire("f0hVi");

var $j9UDw = parcelRequire("j9UDw");

var $fmhFi = parcelRequire("fmhFi");

var $1Zxl4 = parcelRequire("1Zxl4");

var $2rBHC = parcelRequire("2rBHC");

var $lxP9C = parcelRequire("lxP9C");

var $etWAS = parcelRequire("etWAS");

var $lMs1U = parcelRequire("lMs1U");

var $apRSQ = parcelRequire("apRSQ");

var $evzjc = parcelRequire("evzjc");

var $dG9Ao = parcelRequire("dG9Ao");

var $eksQM = parcelRequire("eksQM");

var $a0D4V = parcelRequire("a0D4V");

var $7mKmY = parcelRequire("7mKmY");

var $5UnPY = parcelRequire("5UnPY");

var $dOUgk = parcelRequire("dOUgk");

var $kxzOk = parcelRequire("kxzOk");

var $3uU32 = parcelRequire("3uU32");

var $bpzvw = parcelRequire("bpzvw");

var $ff2yD = parcelRequire("ff2yD");

var $fHVxn = parcelRequire("fHVxn");

var $5Ojcr = parcelRequire("5Ojcr");

var $3Yt6X = parcelRequire("3Yt6X");

var $hAJ7N = parcelRequire("hAJ7N");

var $e9fEq = parcelRequire("e9fEq");

var $jxIae = parcelRequire("jxIae");

var $19r4K = parcelRequire("19r4K");

var $1Dztl = parcelRequire("1Dztl");

var $1O3Ea = parcelRequire("1O3Ea");

var $e9Gfy = parcelRequire("e9Gfy");

var $7RDKl = parcelRequire("7RDKl");

var $b2ykh = parcelRequire("b2ykh");

var $g8YQf = parcelRequire("g8YQf");

var $4OHhm = parcelRequire("4OHhm");

var $3qny0 = parcelRequire("3qny0");

var $yk8YA = parcelRequire("yk8YA");

var $kt0QB = parcelRequire("kt0QB");

var $9oXBQ = parcelRequire("9oXBQ");

var $iBuWD = parcelRequire("iBuWD");

var $jLhoT = parcelRequire("jLhoT");

var $6Lgr4 = parcelRequire("6Lgr4");

var $4KZfr = parcelRequire("4KZfr");

var $b7rZt = parcelRequire("b7rZt");

var $5QSRE = parcelRequire("5QSRE");

var $02HAY = parcelRequire("02HAY");

var $9QPcQ = parcelRequire("9QPcQ");

var $aZHdl = parcelRequire("aZHdl");

var $307rd = parcelRequire("307rd");

var $cLEqv = parcelRequire("cLEqv");

var $i0o2E = parcelRequire("i0o2E");

var $fQjCK = parcelRequire("fQjCK");

var $kDBV4 = parcelRequire("kDBV4");

var $3gALM = parcelRequire("3gALM");

var $6l8wI = parcelRequire("6l8wI");

var $kzJod = parcelRequire("kzJod");

var $2jzeY = parcelRequire("2jzeY");

var $80YBd = parcelRequire("80YBd");

var $lfdJB = parcelRequire("lfdJB");

var $d8BX1 = parcelRequire("d8BX1");

var $hDTQX = parcelRequire("hDTQX");

var $3NN4E = parcelRequire("3NN4E");

var $6034y = parcelRequire("6034y");

var $lCqer = parcelRequire("lCqer");

var $4YOsq = parcelRequire("4YOsq");

var $3Rt1x = parcelRequire("3Rt1x");

var $6cbbu = parcelRequire("6cbbu");

var $bSbiO = parcelRequire("bSbiO");

var $2M4fN = parcelRequire("2M4fN");

var $kqm46 = parcelRequire("kqm46");

var $8LN4T = parcelRequire("8LN4T");

var $27YPb = parcelRequire("27YPb");

var $5tYtA = parcelRequire("5tYtA");

var $BcNEN = parcelRequire("BcNEN");

var $2uDzR = parcelRequire("2uDzR");

var $8hfgf = parcelRequire("8hfgf");

var $57C4N = parcelRequire("57C4N");

var $9vC5r = parcelRequire("9vC5r");

var $4XaE0 = parcelRequire("4XaE0");

var $3OnXm = parcelRequire("3OnXm");

var $4qGpF = parcelRequire("4qGpF");

var $cBUST = parcelRequire("cBUST");

var $bGvUH = parcelRequire("bGvUH");

var $aWhYZ = parcelRequire("aWhYZ");

var $6S0Dc = parcelRequire("6S0Dc");

var $hGerI = parcelRequire("hGerI");

var $6mL7K = parcelRequire("6mL7K");

var $5S3BI = parcelRequire("5S3BI");

var $6gpWo = parcelRequire("6gpWo");

var $iUcGR = parcelRequire("iUcGR");

var $2n5BQ = parcelRequire("2n5BQ");

var $fToBW = parcelRequire("fToBW");

var $jcgn0 = parcelRequire("jcgn0");

var $apCqz = parcelRequire("apCqz");

var $lkzh1 = parcelRequire("lkzh1");

var $1tJbT = parcelRequire("1tJbT");

var $1p45F = parcelRequire("1p45F");

var $1IT3x = parcelRequire("1IT3x");

var $eXAfa = parcelRequire("eXAfa");

var $WBDy8 = parcelRequire("WBDy8");

var $d0HTh = parcelRequire("d0HTh");

var $43iIQ = parcelRequire("43iIQ");

var $70DsH = parcelRequire("70DsH");

var $4ZKoO = parcelRequire("4ZKoO");

var $ebcb6 = parcelRequire("ebcb6");

var $7HZi8 = parcelRequire("7HZi8");

var $lw128 = parcelRequire("lw128");

var $hAgX3 = parcelRequire("hAgX3");

var $5xDmP = parcelRequire("5xDmP");

var $fKnCL = parcelRequire("fKnCL");

var $39J1B = parcelRequire("39J1B");

var $7Toln = parcelRequire("7Toln");

var $cTtTO = parcelRequire("cTtTO");

var $hyqfi = parcelRequire("hyqfi");

var $dP6oq = parcelRequire("dP6oq");

var $fpNbL = parcelRequire("fpNbL");

var $kYXsc = parcelRequire("kYXsc");

var $g3St3 = parcelRequire("g3St3");

var $1cWr6 = parcelRequire("1cWr6");

var $e2eAj = parcelRequire("e2eAj");

var $hhVkJ = parcelRequire("hhVkJ");

var $kD0Ge = parcelRequire("kD0Ge");

var $gEBbt = parcelRequire("gEBbt");

var $2PL7S = parcelRequire("2PL7S");

var $4GWTX = parcelRequire("4GWTX");

var $agCim = parcelRequire("agCim");

var $cnG0j = parcelRequire("cnG0j");

var $ghBxE = parcelRequire("ghBxE");

var $lMO7Z = parcelRequire("lMO7Z");

var $fvFxE = parcelRequire("fvFxE");

var $dut0s = parcelRequire("dut0s");

var $jUCVx = parcelRequire("jUCVx");

var $fBXou = parcelRequire("fBXou");

var $28WgX = parcelRequire("28WgX");

var $ekqRf = parcelRequire("ekqRf");

var $fPxUZ = parcelRequire("fPxUZ");

var $gqwG0 = parcelRequire("gqwG0");

var $8CLhe = parcelRequire("8CLhe");

var $d3dv3 = parcelRequire("d3dv3");

var $izixQ = parcelRequire("izixQ");

var $gZq43 = parcelRequire("gZq43");

var $9uidf = parcelRequire("9uidf");

var $lHdES = parcelRequire("lHdES");

var $8gAuW = parcelRequire("8gAuW");

var $jgRv0 = parcelRequire("jgRv0");

var $iBcSa = parcelRequire("iBcSa");

var $bJiYi = parcelRequire("bJiYi");

var $9NWq7 = parcelRequire("9NWq7");

var $hnYNr = parcelRequire("hnYNr");

var $gSlgn = parcelRequire("gSlgn");

var $cENRX = parcelRequire("cENRX");

var $f0Lah = parcelRequire("f0Lah");

var $5psoN = parcelRequire("5psoN");

var $1kaFK = parcelRequire("1kaFK");

var $kRlsB = parcelRequire("kRlsB");

var $cK5xr = parcelRequire("cK5xr");

var $43qOr = parcelRequire("43qOr");

var $gYfl3 = parcelRequire("gYfl3");

var $jo8cE = parcelRequire("jo8cE");

var $kKMOG = parcelRequire("kKMOG");

var $aNCbW = parcelRequire("aNCbW");

var $2AYKc = parcelRequire("2AYKc");

var $cJqhS = parcelRequire("cJqhS");

var $ejo5K = parcelRequire("ejo5K");

var $hnRYr = parcelRequire("hnRYr");

var $88nEe = parcelRequire("88nEe");

var $4nTz0 = parcelRequire("4nTz0");

var $8W2c8 = parcelRequire("8W2c8");

var $5gnJR = parcelRequire("5gnJR");

var $gkm2X = parcelRequire("gkm2X");

var $csjBW = parcelRequire("csjBW");

var $lj5Av = parcelRequire("lj5Av");

var $byNoq = parcelRequire("byNoq");

var $4aSHo = parcelRequire("4aSHo");

var $aNXAx = parcelRequire("aNXAx");

var $jueBm = parcelRequire("jueBm");

var $lMawn = parcelRequire("lMawn");

var $hK8mq = parcelRequire("hK8mq");

var $33rS9 = parcelRequire("33rS9");

var $6PPxR = parcelRequire("6PPxR");

var $5JTZa = parcelRequire("5JTZa");

var $jSZVk = parcelRequire("jSZVk");

var $8JIqa = parcelRequire("8JIqa");

var $bTXFE = parcelRequire("bTXFE");

var $exjbO = parcelRequire("exjbO");

var $37n4w = parcelRequire("37n4w");

var $l7Kcl = parcelRequire("l7Kcl");

var $kbvuM = parcelRequire("kbvuM");

var $1XNI6 = parcelRequire("1XNI6");

var $8RT9n = parcelRequire("8RT9n");

var $9kqeg = parcelRequire("9kqeg");

var $hRXMa = parcelRequire("hRXMa");

var $lPhuN = parcelRequire("lPhuN");

var $4Cdj7 = parcelRequire("4Cdj7");

var $lxvYO = parcelRequire("lxvYO");

var $6XvFv = parcelRequire("6XvFv");

var $jZv6V = parcelRequire("jZv6V");

var $b5gw6 = parcelRequire("b5gw6");

var $2YbyC = parcelRequire("2YbyC");

var $hykoI = parcelRequire("hykoI");

var $2dAZL = parcelRequire("2dAZL");

var $6Rmp2 = parcelRequire("6Rmp2");

var $3FQCK = parcelRequire("3FQCK");

var $5v5xs = parcelRequire("5v5xs");

var $9vlCj = parcelRequire("9vlCj");

var $algSY = parcelRequire("algSY");

var $chmwv = parcelRequire("chmwv");

var $ilU7w = parcelRequire("ilU7w");

var $jP8P4 = parcelRequire("jP8P4");

var $1DVzF = parcelRequire("1DVzF");

var $7ccps = parcelRequire("7ccps");

var $1Pj99 = parcelRequire("1Pj99");

var $ff5dM = parcelRequire("ff5dM");

var $aLXiu = parcelRequire("aLXiu");

var $kHsPZ = parcelRequire("kHsPZ");

var $30PHd = parcelRequire("30PHd");

var $aGFMx = parcelRequire("aGFMx");

var $fFZgu = parcelRequire("fFZgu");

var $hAVk6 = parcelRequire("hAVk6");

var $72a1U = parcelRequire("72a1U");

var $luRFY = parcelRequire("luRFY");

var $3dqLQ = parcelRequire("3dqLQ");

var $gxAJV = parcelRequire("gxAJV");

var $dLExR = parcelRequire("dLExR");

var $5zVch = parcelRequire("5zVch");

var $2ZnyJ = parcelRequire("2ZnyJ");

var $lGz7G = parcelRequire("lGz7G");

var $aPs1z = parcelRequire("aPs1z");

var $91LPB = parcelRequire("91LPB");

var $e6ehT = parcelRequire("e6ehT");

var $gAUgF = parcelRequire("gAUgF");

var $7eIYH = parcelRequire("7eIYH");

var $6dPXJ = parcelRequire("6dPXJ");

var $k80dv = parcelRequire("k80dv");

var $dw2ce = parcelRequire("dw2ce");

var $eSIYo = parcelRequire("eSIYo");

var $gLWOL = parcelRequire("gLWOL");

var $YXwcg = parcelRequire("YXwcg");

var $lFKeR = parcelRequire("lFKeR");

var $1xutc = parcelRequire("1xutc");

var $ed2hW = parcelRequire("ed2hW");

var $9iKlG = parcelRequire("9iKlG");

var $dfVfw = parcelRequire("dfVfw");

var $fWDhV = parcelRequire("fWDhV");

var $khKzX = parcelRequire("khKzX");

var $kzxfE = parcelRequire("kzxfE");

var $eF6xc = parcelRequire("eF6xc");

var $7wJLb = parcelRequire("7wJLb");

var $hN6Yh = parcelRequire("hN6Yh");

var $5dzzd = parcelRequire("5dzzd");

var $eyWIM = parcelRequire("eyWIM");

var $5OhH5 = parcelRequire("5OhH5");

var $eOJip = parcelRequire("eOJip");

var $jG7gV = parcelRequire("jG7gV");

var $P4w4L = parcelRequire("P4w4L");

var $8mw4w = parcelRequire("8mw4w");

var $gJeDi = parcelRequire("gJeDi");

var $sK3EH = parcelRequire("sK3EH");

var $cOBeu = parcelRequire("cOBeu");

var $b4ktm = parcelRequire("b4ktm");

var $bbpTw = parcelRequire("bbpTw");

var $hSovm = parcelRequire("hSovm");

var $bwfaS = parcelRequire("bwfaS");

var $3B2tH = parcelRequire("3B2tH");

var $k5ls9 = parcelRequire("k5ls9");

var $4MZMG = parcelRequire("4MZMG");

var $24gKw = parcelRequire("24gKw");

var $g09EF = parcelRequire("g09EF");

var $as2yW = parcelRequire("as2yW");

var $jlw0X = parcelRequire("jlw0X");

var $VMQYl = parcelRequire("VMQYl");

var $8t3Bs = parcelRequire("8t3Bs");

var $gqlkg = parcelRequire("gqlkg");

var $4W2Ve = parcelRequire("4W2Ve");

var $2qWaR = parcelRequire("2qWaR");

var $1rAP5 = parcelRequire("1rAP5");

var $4MsHe = parcelRequire("4MsHe");

var $ASOiD = parcelRequire("ASOiD");

var $bxGoH = parcelRequire("bxGoH");

var $7dAIb = parcelRequire("7dAIb");

var $53Ske = parcelRequire("53Ske");

var $l6W7I = parcelRequire("l6W7I");

var $77YbO = parcelRequire("77YbO");

var $dNIAB = parcelRequire("dNIAB");

var $zhYLc = parcelRequire("zhYLc");

var $kZdpv = parcelRequire("kZdpv");

var $g70C8 = parcelRequire("g70C8");

var $ckYTZ = parcelRequire("ckYTZ");
const $d48f2d8fb891a8d9$export$10439de9ce871f28 = ()=>[
        (0, $3y68D.advancedAdminControlsRouteEntry),
        (0, $fJ15R.aiAnswersRouteEntry),
        (0, $1R3CQ.aiFirstCreateRouteEntry),
        (0, $4eOkX.alertPoliciesRouteEntry),
        (0, $iGXDp.applinksAdministrationEditRouteEntry),
        (0, $jMKrp.applinksAdministrationListRouteEntry),
        (0, $gK0o2.applinksExtraAuthHealthcheckRouteEntry),
        (0, $7WGkO.appRequestsRouteEntry),
        (0, $aPhVH.archivedIssuesRedirectRouteEntry),
        (0, $9JhPg.archivedPlansRouteEntry),
        (0, $7y12x.archivedProjectDirectLinkRouteEntry),
        (0, $54Mg6.archivedProjectsDirectoryRouteEntry),
        (0, $kZGLD.archivedWorkItemsJsmRouteEntry),
        (0, $5y94r.archivedWorkItemsJswCompanyRouteEntry),
        (0, $3cJRB.archivedWorkItemsJswRouteEntry),
        (0, $apVTf.archivedWorkItemsJwmRouteEntry),
        (0, $2PFkC.arjCalendarEmbedRouteEntry),
        (0, $7lkHZ.arjDependenciesEmbedRouteEntry),
        (0, $fxZdD.arjIncrementEmbedRouteEntry),
        (0, $aCLGk.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $eJqY3.arjSettingsDependenciesRouteEntry),
        (0, $1lOAz.arjSettingsFinancialYearPageRouteEntry),
        (0, $eOLN9.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $2bnuQ.arjSettingsLoadingLimitsRouteEntry),
        (0, $iDdAu.arjSettingsPermissionsRouteEntry),
        (0, $3cedS.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $cLZj8.arjSummaryEmbedRouteEntry),
        (0, $Nhl2o.arjTimelineEmbedRouteEntry),
        (0, $g0EQq.assetsAnalyticsDataViewCreateRouteEntry),
        (0, $5NEJc.assetsAnalyticsDataViewDetailsRouteEntry),
        (0, $9AeX2.assetsAnalyticsDataViewListRouteEntry),
        (0, $hjFNU.assetsConfigurationRouteEntry),
        (0, $3w7LE.assetsDashboardsDetailRouteEntry),
        (0, $eFriF.assetsDashboardsRouteEntry),
        (0, $9enxs.assetsDataManagerDataSourceRouteEntry),
        (0, $hMZzF.assetsDataManagerGettingStartedRouteEntry),
        (0, $jVidq.assetsDataManagerObjectClassesRouteEntry),
        (0, $c7xWN.assetsDataManagerObjectClassViewRouteEntry),
        (0, $8WI0C.assetsDataManagerObjectDetailViewRouteEntry),
        (0, $7w4wA.assetsForYouRouteEntry),
        (0, $bGwGo.assetsObjectRouteEntry),
        (0, $dRVNt.assetsObjectTypeConfigurationRouteEntry),
        (0, $9qNa5.assetsReportsRouteEntry),
        (0, $2MZpi.assetsReportsTemplateRouteEntry),
        (0, $5JNuq.assetsReportsUnsubscribeRouteEntry),
        (0, $1w4c6.assetsRouteEntry),
        (0, $bP5Jb.assetsSchemaConfigurationRouteEntry),
        (0, $d065h.assetsSchemaRouteEntry),
        (0, $8LcdF.assetsSchemasRouteEntry),
        (0, $7O1yF.assetsSearchRouteEntry),
        (0, $66eA2.boardsDirectoryRedirectRouteEntry),
        (0, $5GAw8.boardsDirectoryRouteEntry),
        (0, $amJJx.browseConversationsRouteEntry),
        (0, $eijnk.browseIntentsRouteEntry),
        (0, $fvYEf.browseIssueEmbedRouteEntry),
        (0, $kNuDg.browseIssueRouteEntry),
        (0, $XhYcm.browseProjectRedirectRouteEntry),
        (0, $4OGAK.browseStandardFlowsRouteEntry),
        (0, $5wrsY.classicBusinessOverviewCalendarRouteEntry),
        (0, $e2Odp.classicBusinessOverviewSummaryRouteEntry),
        (0, $djb2Z.classicBusinessOverviewTimelineRouteEntry),
        (0, $5xUFr.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $45FXR.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $d5FsU.classicBusinessProjectApprovalsRouteEntry),
        (0, $7kn5P.classicBusinessProjectFormBuilderRouteEntry),
        (0, $gjSfP.classicBusinessProjectFormRouteEntry),
        (0, $7aHwj.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $hULAZ.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $8WHEn.classicBusinessProjectFormSubmitRouteEntry),
        (0, $6BJfU.classicBusinessProjectPagesRouteEntry),
        (0, $a7Dk4.classicBusinessProjectShortcutRouteEntry),
        (0, $eAKSk.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $j9RxE.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $cprgG.classicProjectSettingsDetailsRouteEntry),
        (0, $aGmFb.classicProjectSettingsFeaturesRouteEntry),
        (0, $7x2TW.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $d6OfK.classicProjectSettingsOpsgenieRouteEntry),
        (0, $4vMYX.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $13I6Z.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $5IMFp.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $eCSHY.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $k7BXo.classicProjectSettingsToolchainRouteEntry),
        (0, $5ClpU.classicSoftwareBacklogEmbedRouteEntry),
        (0, $74BfF.classicSoftwareBacklogRouteEntry),
        (0, $2r2Qz.classicSoftwareBoardEmbedRouteEntry),
        (0, $cyLCh.classicSoftwareBoardRouteEntry),
        (0, $gUidc.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $6p8i9.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $4RXNm.classicSoftwareBoardSettingsRouteEntry),
        (0, $94WeZ.cmpVelocityRouteEntry),
        (0, $81S4s.communicationsStakeholderGroupsRouteEntry),
        (0, $cGZ5m.communicationsStakeholdersRouteEntry),
        (0, $lw6zb.communicationsStatusPageConfigurationRouteEntry),
        (0, $h6dkb.communicationsStatusPageCreateRouteEntry),
        (0, $V63Fz.communicationsStatusPageDetailsRouteEntry),
        (0, $ktWm2.communicationsStatusPageManageRouteEntry),
        (0, $jru5K.communicationsStatusPageRouteEntry),
        (0, $2BDh0.compassProductSettingsRouteEntry),
        (0, $c7HRO.connectGeneralInvalidRouteEntry),
        (0, $2wLap.connectGeneralRouteEntry),
        (0, $3arhy.connectGeneralServiceDeskProjectRouteEntry),
        (0, $9IZNs.connectProjectRouteEntry),
        (0, $1YKQh.createProjectRouteEntry),
        (0, $2vkb8.customerServiceCustomerDetailsRouteEntry),
        (0, $ek1TG.customerServiceCustomersRouteEntry),
        (0, $5vEtc.customerServiceEscalationsRouteEntry),
        (0, $bHvbN.customerServiceGetStartedRouteEntry),
        (0, $7NfJj.customerServiceOrganizationDetailsRouteEntry),
        (0, $iCaX0.customerServiceOrganizationsRouteEntry),
        (0, $36fLu.customerServiceProductsRouteEntry),
        (0, $e54wO.customIssueRouteEntry),
        (0, $ft8RF.customPracticeQueueBoardRouteEntry),
        (0, $bwD6U.customPracticeQueueCalendarRouteEntry),
        (0, $frNhT.customPracticeQueueRouteEntry),
        (0, $iZ2AQ.customQueueBoardRouteEntry),
        (0, $2d55w.customQueueCalendarRouteEntry),
        (0, $3bo4c.customQueueRouteEntry),
        (0, $kINnF.dashboardEditRouteEntry),
        (0, $fkKo1.dashboardRouteEntry),
        (0, $4BD3h.dashboardsDirectoryRedirectRouteEntry),
        (0, $czPgr.dashboardsDirectoryRouteEntry),
        (0, $7Zjtg.dashboardViewEmbedRouteEntry),
        (0, $1Jz0d.dashboardViewRouteEntry),
        (0, $kJhhx.dashboardWallboardRouteEntry),
        (0, $5Ufi9.devopsConnectedProjectRouteEntry),
        (0, $l8WGY.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $d29rL.emailNotificationsLogAccessRouteEntry),
        (0, $47SW5.eocAlertIssueSyncingCreateRouteEntry),
        (0, $jP5bP.eocAlertIssueSyncingDetailRouteEntry),
        (0, $lmaBn.eocAlertIssueSyncingRouteEntry),
        (0, $6egyA.eocApiKeyManagementRouteEntry),
        (0, $5JjgV.eocAssignCustomRolesRouteEntry),
        (0, $gTM9q.eocAutomationsRouteEntry),
        (0, $bJd2N.eocCustomRolesRouteEntry),
        (0, $2Q9dT.eocGlobalAlertListRedirectRouteEntry),
        (0, $hr8RB.eocGlobalAlertListRouteEntry),
        (0, $haVHi.eocGlobalAlertsDetailRouteEntry),
        (0, $gCQuB.eocGlobalGroupDetailRouteEntry),
        (0, $4gFBe.eocGlobalHeartbeatsRouteEntry),
        (0, $dCYpv.eocGlobalMaintenanceRouteEntry),
        (0, $ezywV.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $iXFOs.eocGlobalReportsNav4RouteEntry),
        (0, $dqsu7.eocHeartbeatsRouteEntry),
        (0, $j3oaw.eocMaintenanceRouteEntry),
        (0, $atZb5.eocOnCallRedirectRouteEntry),
        (0, $bcSH6.eocOnCallRouteEntry),
        (0, $L6NLT.eocOverviewAllTeamsRouteEntry),
        (0, $d1pTa.eocOverviewRouteEntry),
        (0, $42xEn.eocPermissionsRouteEntry),
        (0, $6y1qE.eocReportsTeamRedirectRouteEntry),
        (0, $5UUbR.eocReportsTeamRouteEntry),
        (0, $djdJN.eocReportsUnsubscribeRouteEntry),
        (0, $5ylat.eocScheduleGlobalRouteEntry),
        (0, $dEChv.eocTeamAlertDetailRouteEntry),
        (0, $7YInD.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $kXXTW.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $6aBHI.eocTeamAlertIssueSyncingRouteEntry),
        (0, $85n74.eocTeamAlertListRouteEntry),
        (0, $ekFnU.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $3s5Pk.eocTeamCustomerLogsRouteEntry),
        (0, $Vlf4X.eocTeamGroupDetailRouteEntry),
        (0, $7JuWl.eocUserNotificationsRouteEntry),
        (0, $4kc5Q.errorsNotFoundRouteEntry),
        (0, $ksM4d.externalImportRouteEntry),
        (0, $czFX6.filtersDirectoryRedirectRouteEntry),
        (0, $keKPA.filtersDirectoryRouteEntry),
        (0, $437TO.findAppsRouteEntry),
        (0, $6HVt9.forgeAdminRouteEntry),
        (0, $7RQxY.forgeAdminSettingsRouteEntry),
        (0, $5ZQVr.forgeFieldContextualConfigurationRouteEntry),
        (0, $1PFei.forgeGlobalRouteEntry),
        (0, $11NnB.forgePersonalSettingsRouteEntry),
        (0, $gRPtE.forgeProjectRouteEntry),
        (0, $4xmZV.forgeProjectServicedeskRouteEntry),
        (0, $bv6P6.forgeServicedeskQueueRouteEntry),
        (0, $lGtFG.generalPersonalSettingsRouteEntry),
        (0, $ilnMG.globalEscalationsRouteEntry),
        (0, $3baNr.globalIncomingCallDetailRouteEntry),
        (0, $fuBQx.globalIncomingCallRouteEntry),
        (0, $4Bcd1.globalIntegrationCreateRouteEntry),
        (0, $flxCZ.globalIntegrationDetailRouteEntry),
        (0, $k85NS.globalIntegrationListRouteEntry),
        (0, $dyOQA.globalIntegrationLogRouteEntry),
        (0, $898Bv.globalIntegrationsRouteEntry),
        (0, $2Z13m.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $cZnHb.globalMailSettingsRouteEntry),
        (0, $ExJeP.globalPoliciesRouteEntry),
        (0, $5CWoo.globalSettingsContactAdministratorRouteEntry),
        (0, $fBUuA.globalSettingsCustomFieldsRouteEntry),
        (0, $3WFhy.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $7T8Ox.globalSettingsFormDataConnectionsRouteEntry),
        (0, $8H8bx.globalSettingsGlobalPermissionsRouteEntry),
        (0, $bI8Dj.globalSettingsIssueFieldSchemeRouteEntry),
        (0, $4cnHJ.globalSettingsIssueFieldSchemesConfigRouteEntry),
        (0, $g6DXA.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $tNfGA.globalSettingsIssueFieldScreensRouteEntry),
        (0, $4szwi.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $f7XdL.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $goUY1.globalSettingsIssueHierarchyRouteEntry),
        (0, $cpLuR.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $5KbgO.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $d3qbB.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $kLk7C.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $fcC3H.globalSettingsIssueTypesRouteEntry),
        (0, $4CAXG.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $kZ7rD.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $dChQF.globalSettingsIssueWorkflow1RouteEntry),
        (0, $67YRM.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $bWzV9.globalSettingsLegacyFieldLayoutRouteEntry),
        (0, $aieAu.globalSettingsOptimizeFieldConfigurationSchemeRouteEntry),
        (0, $hEWb7.globalSettingsOptimizeWorkTypeSchemeRouteEntry),
        (0, $dVpvh.globalSettingsPerformanceCustomFieldCleanupRouteEntry),
        (0, $iLf1F.globalSettingsPerformanceCustomFieldProjectLimitRouteEntry),
        (0, $2zDjc.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $izkie.globalSettingsPerformanceDashboardRouteEntry),
        (0, $9Isj0.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $bs2w3.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $jlE2b.globalSettingsPerformanceOverviewRouteEntry),
        (0, $kDttK.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $20DnI.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $81vTA.globalSettingsPerformanceWorkTypeProjectLimitRouteEntry),
        (0, $f0p1P.globalSettingsPerformanceWorkTypeRouteEntry),
        (0, $1yaIP.globalSettingsPermissionSchemesRouteEntry),
        (0, $bksGt.globalSettingsSystemBulkMailRouteEntry),
        (0, $WOvcu.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $kTUT3.helpCenterSettingsAgentStudioRouteEntry),
        (0, $cHL3P.helpCenterSettingsAnalyticsRouteEntry),
        (0, $fSwF2.helpCenterSettingsArticlesRouteEntry),
        (0, $4VbNK.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $25Xvp.helpCenterSettingsBrandingRouteEntry),
        (0, $5uVut.helpCenterSettingsCreateArticleRouteEntry),
        (0, $qU7hK.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $9cLPB.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $cVu4s.helpCenterSettingsDetailsRouteEntry),
        (0, $dceq5.helpCenterSettingsEmailRouteEntry),
        (0, $i1SxF.helpCenterSettingsFormEditRouteEntry),
        (0, $64vgo.helpCenterSettingsFormsRouteEntry),
        (0, $9hXyI.helpCenterSettingsKbRouteEntry),
        (0, $1PXic.helpCenterSettingsNotFoundRouteEntry),
        (0, $pX4Kl.helpCenterSettingsServiceHubsRouteEntry),
        (0, $7lW5H.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $7RzXN.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $8M7gQ.helpCenterSettingsSupportWebsiteRouteEntry),
        (0, $1kuHh.helpCenterSettingsWidgetConfigurationCustomizeRouteEntry),
        (0, $amP5i.helpCenterSettingsWidgetConfigurationInstallRouteEntry),
        (0, $4AyGF.helpCenterSettingsWidgetConfigurationRouteEntry),
        (0, $MBVfl.homeOnboardingRedirectRouteEntry),
        (0, $4w8EY.homeRedirectRouteEntry),
        (0, $eYdQw.issueCreateEmbedRouteEntry),
        (0, $lOn6l.issueNavigatorGlobalJiraRouteEntry),
        (0, $37pqk.issueNavigatorGlobalRouteEntry),
        (0, $gymKR.issueNavigatorProjectBusinessCustomEmbedRouteEntry),
        (0, $dJkii.issueNavigatorProjectBusinessEmbedRouteEntry),
        (0, $7M3Qw.issueNavigatorProjectBusinessRouteEntry),
        (0, $kSzi3.issueNavigatorProjectClassicCustomEmbedRouteEntry),
        (0, $eIWvD.issueNavigatorProjectClassicEmbedRouteEntry),
        (0, $5HdwO.issueNavigatorProjectClassicRouteEntry),
        (0, $9kaa4.issueNavigatorProjectListServicedeskRouteEntry),
        (0, $7lqd9.issueNavigatorProjectServicedeskRouteEntry),
        (0, $bxEah.issueNavigatorProjectSoftwareCustomEmbedRouteEntry),
        (0, $ytX2z.issueNavigatorProjectSoftwareEmbedRouteEntry),
        (0, $5rr5U.issueNavigatorProjectSoftwareRouteEntry),
        (0, $fFeTt.jiraBusinessAttachmentsRouteEntry),
        (0, $9onbT.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $i6owk.jiraBusinessBoardEmbedRouteEntry),
        (0, $6tmSj.jiraBusinessBoardRouteEntry),
        (0, $2KqMs.jiraBusinessCalendarCustomEmbedRouteEntry),
        (0, $5ZNYc.jiraBusinessCalendarEmbedRouteEntry),
        (0, $hPiSX.jiraBusinessCalendarRouteEntry),
        (0, $5JYqa.jiraBusinessListCustomEmbedRouteEntry),
        (0, $ljCsD.jiraBusinessListEmbedRouteEntry),
        (0, $lIqxK.jiraBusinessListRouteEntry),
        (0, $2Q6z2.jiraBusinessOverviewRedirectRouteEntry),
        (0, $c0nCS.jiraBusinessProjectRedirectRouteEntry),
        (0, $1U37F.jiraBusinessReportsOverviewRouteEntry),
        (0, $3ZA2n.jiraBusinessSummaryEmbedRouteEntry),
        (0, $ghxYA.jiraBusinessSummaryRouteEntry),
        (0, $bMvJs.jiraBusinessTimelineEmbedRouteEntry),
        (0, $ffcU3.jiraBusinessTimelineRouteEntry),
        (0, $eWBMh.jiraHomeRouteEntry),
        (0, $7lsw4.jiraSearchRouteEntry),
        (0, $bMj4d.jsmBoardRouteEntry),
        (0, $6XPJ5.knowledgeHubAllArticlesRouteEntry),
        (0, $1fi5O.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $3DoQq.knowledgeHubArticleInCategoryRouteEntry),
        (0, $dpAnL.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $20wcj.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $1lGts.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $j3R4j.knowledgeHubCategoryPageRouteEntry),
        (0, $gG5r4.knowledgeHubCategoryRouteEntry),
        (0, $jYWZX.knowledgeHubDraftsRouteEntry),
        (0, $21gXe.knowledgeHubLandingRouteEntry),
        (0, $5jjQ1.knowledgeHubSearchRouteEntry),
        (0, $1MGof.knowledgeHubSetupRouteEntry),
        (0, $i5Fsz.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $3mrXC.landingPageRouteEntry),
        (0, $4SqLF.legacyPlanPageRedirectRouteEntry),
        (0, $bRYwY.legacyPlanReportPageRedirectRouteEntry),
        (0, $C784O.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $6hSMD.legacyProjectReleasesNoteRouteEntry),
        (0, $bWZUz.legacyRapidBoardRouteEntry),
        (0, $ihfrS.legacyRedirectRouteEntry),
        (0, $kMe3w.listRouteEntry),
        (0, $id9nd.loginEmbedRouteEntry),
        (0, $7K8ER.manageProjectsDirectoryRouteEntry),
        (0, $hefqI.mergeTeamsRouteEntry),
        (0, $bIDIn.newRovoSearchRouteEntry),
        (0, $iaJjO.notificationLogsRouteEntry),
        (0, $flrMb.notificationsPersonalSettingsRouteEntry),
        (0, $10xT1.oldJiraHomeRouteEntry),
        (0, $5oAgu.opsgenieScheduleRedirectRouteEntry),
        (0, $k5e75.opsgenieScheduleRouteEntry),
        (0, $leBbj.opsNotificationsPersonalSettingsRouteEntry),
        (0, $jlwtU.peopleProfilesRouteEntry),
        (0, $3yeCC.performanceRouteEntry),
        (0, $4FBBR.personalSettingsRouteEntry),
        (0, $d5Bb9.piCreateIssueEmbedRouteEntry),
        (0, $jSGUL.piEditIssueEmbedRouteEntry),
        (0, $bJXfU.planExportPageRouteEntry),
        (0, $k3Rn6.planIncrementRouteEntry),
        (0, $5DVEh.planIncrementsRouteEntry),
        (0, $jJEm7.planPageRouteEntry),
        (0, $flxMn.planPageWithoutScenarioIdRouteEntry),
        (0, $iJbtQ.planReportPageRouteEntry),
        (0, $98Umx.plansDirectoryRouteEntry),
        (0, $33RDm.planSetupPageRouteEntry),
        (0, $9a7o3.planUpsellRouteEntry),
        (0, $7Al9R.planViewNotFoundRouteEntry),
        (0, $4p5og.polarisCollectionsRouteEntry),
        (0, $01dV2.polarisIdeasRouteEntry),
        (0, $eDNar.polarisOnboardingRouteEntry),
        (0, $cWeYh.polarisSettingsAccessRouteEntry),
        (0, $0eLvf.polarisSettingsDatesRouteEntry),
        (0, $avhOT.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $jXIBH.polarisSettingsGlobalFieldsRouteEntry),
        (0, $f0kp3.polarisSettingsViewBlueprintsRouteEntry),
        (0, $1zTPx.polarisUnlicensedRouteEntry),
        (0, $hpFrr.productsJcsCustomerAccessRouteEntry),
        (0, $deNkw.productsJcsFormFieldsRouteEntry),
        (0, $b89Z5.productsJsmAuthenticationSettingsRouteEntry),
        (0, $i7x71.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $iifeU.productsJsmComplianceRouteEntry),
        (0, $6szZq.productsJsmConfigurationRouteEntry),
        (0, $bWhAh.productsJsmCustomerAccessRouteEntry),
        (0, $e8aTE.productsJsmEmailRequestsRouteEntry),
        (0, $iIHov.productsJsmFeatureUsageRouteEntry),
        (0, $iuWdX.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $1hrj9.productsJsmGlobalOpsReportsRouteEntry),
        (0, $aanGM.productsJsmIncidentManagementToolsRouteEntry),
        (0, $35zIt.productsJsmKbPermissionsRouteEntry),
        (0, $7V5F5.productsJsmOrganizationsDetailsRouteEntry),
        (0, $lAyQF.productsJsmOrganizationsRouteEntry),
        (0, $9Gw9x.productsJswConfigurationRouteEntry),
        (0, $jhJLH.productsJswGuestAccessRouteEntry),
        (0, $uS0Wn.productsJswStorageManagementRouteEntry),
        (0, $3CKd6.productsOnboardingHubCreateRouteEntry),
        (0, $emNcb.productsOnboardingHubEditRouteEntry),
        (0, $bb3Kz.productsOnboardingHubRouteEntry),
        (0, $fAxRm.proformaExportRouteEntry),
        (0, $gLtBa.proformaIssueFormsGeneralRouteEntry),
        (0, $3d0g1.projectComponentsRedirectRouteEntry),
        (0, $7mEsO.projectComponentsRouteEntry),
        (0, $j2UMI.projectDirectoryRedirectRouteEntry),
        (0, $l29cD.projectIssueNavigatorRouteEntry),
        (0, $eze04.projectNotFoundRouteEntry),
        (0, $9B4ho.projectPagesLegacyRouteEntry),
        (0, $dMtOC.projectPagesRouteEntry),
        (0, $2cgig.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $9GvQT.projectsDirectoryManageRedirectRouteEntry),
        (0, $65d18.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $7ucgW.projectsDirectoryRedirectRouteEntry),
        (0, $dVWks.projectsDirectoryRouteEntry),
        (0, $0MUFU.projectServiceDeskRouteEntry),
        (0, $1yqW3.projectSettingsAutomationCRouteEntry),
        (0, $9rb1x.projectSettingsAutomationRouteEntry),
        (0, $af0ih.projectSettingsComponentsRouteEntry),
        (0, $8Qqsd.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $d1As4.projectSettingsCoreAccessRouteEntry),
        (0, $9tjWC.projectSettingsCoreApprovalsRouteEntry),
        (0, $kwERN.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $773VE.projectSettingsCoreAppsRouteEntry),
        (0, $jiUh1.projectSettingsCoreAutomationRouteEntry),
        (0, $8Iv3H.projectSettingsCoreAutomationV2RouteEntry),
        (0, $f83an.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $cWPJr.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $4BOoE.projectSettingsCoreDetailsRouteEntry),
        (0, $h7Red.projectSettingsCoreFieldsRouteEntry),
        (0, $7Pdre.projectSettingsCoreForgeAppsRouteEntry),
        (0, $20zzw.projectSettingsCoreIssueTypesRouteEntry),
        (0, $h4zAy.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $4WoRT.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $im6xk.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $6P2Hr.projectSettingsCoreNotificationsRouteEntry),
        (0, $lJuD5.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $kjUZx.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $4yidD.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $ikmMT.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $cw1uU.projectSettingsForgeAppsRouteEntry),
        (0, $3wFf4.projectSettingsOpsgenieRouteEntry),
        (0, $85Rgm.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $2Uft0.projectSettingsServicedeskAccessRouteEntry),
        (0, $jCXKu.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $k25kz.projectSettingsServicedeskAppsRouteEntry),
        (0, $ebqmN.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $43NlL.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $2LDVV.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $9RMhv.projectSettingsServicedeskAutomationRouteEntry),
        (0, $h3kpF.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $23ehb.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $70AS8.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $ceWLf.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $fKViZ.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $5k4zE.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $5w2Cj.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $cq7wq.projectSettingsServicedeskChannelsRouteEntry),
        (0, $bBqyO.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $cM5pJ.projectSettingsServicedeskChatRouteEntry),
        (0, $95uMc.projectSettingsServicedeskClassicAppsRouteEntry),
        (0, $61kne.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $85bCZ.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $ihexr.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $3jDGC.projectSettingsServicedeskDetailsRouteEntry),
        (0, $kmfhe.projectSettingsServicedeskEmailRouteEntry),
        (0, $3VkWO.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $grzdo.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $b29TL.projectSettingsServicedeskFieldsRouteEntry),
        (0, $csLF9.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $dTlAf.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $dKx89.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $bWmUQ.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $hT9aM.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $dpK5U.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $f60wn.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $18Mhr.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $iCcmc.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $f0hVi.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $j9UDw.projectSettingsServicedeskJourneysRouteEntry),
        (0, $fmhFi.projectSettingsServicedeskKbRouteEntry),
        (0, $1Zxl4.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $2rBHC.projectSettingsServicedeskLanguageRouteEntry),
        (0, $lxP9C.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $etWAS.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $lMs1U.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $apRSQ.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $evzjc.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $dG9Ao.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $eksQM.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $a0D4V.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $7mKmY.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $5UnPY.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $dOUgk.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $kxzOk.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $3uU32.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $bpzvw.projectSettingsServicedeskRedirectRouteEntry),
        (0, $ff2yD.projectSettingsServicedeskRovoServiceAgentRouteEntry),
        (0, $fHVxn.projectSettingsServicedeskSurveysRouteEntry),
        (0, $5Ojcr.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $3Yt6X.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $hAJ7N.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $e9fEq.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $jxIae.projectSettingsServicedeskWidgetRouteEntry),
        (0, $19r4K.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $1Dztl.projectSettingsSoftwareAccessRouteEntry),
        (0, $1O3Ea.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $e9Gfy.projectSettingsSoftwareAppsRouteEntry),
        (0, $7RDKl.projectSettingsSoftwareAutomationRouteEntry),
        (0, $b2ykh.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $g8YQf.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $4OHhm.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $3qny0.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $yk8YA.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $kt0QB.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $9oXBQ.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $iBuWD.projectSettingsSoftwareDetailsRouteEntry),
        (0, $jLhoT.projectSettingsSoftwareFieldsRouteEntry),
        (0, $6Lgr4.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $4KZfr.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $b7rZt.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $5QSRE.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $02HAY.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $9QPcQ.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $aZHdl.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $307rd.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $cLEqv.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $i0o2E.projectSettingsSoftwareRedirectRouteEntry),
        (0, $fQjCK.projectSettingsToolchainRouteEntry),
        (0, $kDBV4.projectSettingsVersionsRouteEntry),
        (0, $3gALM.projectsRedirectRouteEntry),
        (0, $6l8wI.projectVersionsRouteEntry),
        (0, $kzJod.promotionsRouteEntry),
        (0, $2jzeY.rapidboardBacklog1RouteEntry),
        (0, $80YBd.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $lfdJB.rapidboardReport1RouteEntry),
        (0, $d8BX1.rapidboardReportRouteEntry),
        (0, $hDTQX.rapidboardUserBacklogRouteEntry),
        (0, $3NN4E.rapidboardUserReportRouteEntry),
        (0, $6034y.rapidboardUserReportsOverviewRouteEntry),
        (0, $lCqer.roleBasedNotificationDetailRouteEntry),
        (0, $4YOsq.roleBasedNotificationsRouteEntry),
        (0, $3Rt1x.rovoSearchRouteEntry),
        (0, $6cbbu.sandboxBundlerBifrostEntrypointsRouteEntry),
        (0, $bSbiO.sandboxBundlerBifrostRLLRouteEntry),
        (0, $2M4fN.sandboxBundlerRouteEntry),
        (0, $kqm46.sandboxRelayEchoPageUsingEntryPointRouteEntry),
        (0, $8LN4T.sandboxRelayEchoPageUsingRLLRouteEntry),
        (0, $27YPb.sandboxRelayJiraPageRouteEntry),
        (0, $5tYtA.secureFiltersDirectoryRedirectRouteEntry),
        (0, $BcNEN.selectedDashboardRouteEntry),
        (0, $2uDzR.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $8hfgf.servicedeskCalendarRouteEntry),
        (0, $57C4N.servicedeskChangeCalendarRouteEntry),
        (0, $9vC5r.servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry),
        (0, $4XaE0.servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry),
        (0, $3OnXm.servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry),
        (0, $4qGpF.servicedeskCmdbAssetsDashboardsDetailRouteEntry),
        (0, $cBUST.servicedeskCmdbAssetsDashboardsRouteEntry),
        (0, $bGvUH.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $aWhYZ.servicedeskCmdbAssetsObjectRouteEntry),
        (0, $6S0Dc.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $hGerI.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $6mL7K.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $5S3BI.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $6gpWo.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $iUcGR.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $2n5BQ.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $fToBW.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $jcgn0.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $apCqz.servicedeskCmdbInsightObject4RouteEntry),
        (0, $lkzh1.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $1tJbT.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $1p45F.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $1IT3x.servicedeskCmdbInsightRouteEntry),
        (0, $eXAfa.servicedeskConnectProjectRouteEntry),
        (0, $WBDy8.servicedeskCreateProjectRouteEntry),
        (0, $d0HTh.servicedeskCustomerDetailsRouteEntry),
        (0, $43iIQ.servicedeskCustomersV2RouteEntry),
        (0, $70DsH.servicedeskGettingStartedRouteEntry),
        (0, $4ZKoO.servicedeskIssueRouteEntry),
        (0, $ebcb6.servicedeskItsmSampleSpaceRouteEntry),
        (0, $7HZi8.servicedeskKbRequestsReports2RouteEntry),
        (0, $lw128.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $hAgX3.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $5xDmP.servicedeskOncallScheduleRouteEntry),
        (0, $fKnCL.servicedeskOrganizationDetailsRouteEntry),
        (0, $39J1B.servicedeskOrganizationsRouteEntry),
        (0, $7Toln.servicedeskOrganizationV2RouteEntry),
        (0, $cTtTO.servicedeskPlaybooksEditRouteEntry),
        (0, $hyqfi.servicedeskPlaybooksListOnlyRouteEntry),
        (0, $dP6oq.servicedeskPlaybooksListRouteEntry),
        (0, $fpNbL.servicedeskPlaybooksLogsRouteEntry),
        (0, $kYXsc.servicedeskPlaybooksTemplateCreateRouteEntry),
        (0, $g3St3.servicedeskPlaybooksTemplatesRouteEntry),
        (0, $1cWr6.servicedeskPracticeEditRouteEntry),
        (0, $e2eAj.servicedeskPracticeIssueRouteEntry),
        (0, $hhVkJ.servicedeskPracticeLandingRouteEntry),
        (0, $kD0Ge.servicedeskPracticeManageViewRouteEntry),
        (0, $gEBbt.servicedeskPracticeNewRouteEntry),
        (0, $2PL7S.servicedeskPracticeViewsConfigRouteEntry),
        (0, $4GWTX.serviceDeskProductsRouteEntry),
        (0, $agCim.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $cnG0j.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $ghBxE.servicedeskProjectDashboardsEditableRouteEntry),
        (0, $lMO7Z.servicedeskProjectDashboardsListRouteEntry),
        (0, $fvFxE.servicedeskProjectSummaryRouteEntry),
        (0, $dut0s.servicedeskQueuesAddonRouteEntry),
        (0, $jUCVx.servicedeskQueuesEditRouteEntry),
        (0, $fBXou.servicedeskQueuesIssueRouteEntry),
        (0, $28WgX.servicedeskQueuesLandingRouteEntry),
        (0, $ekqRf.servicedeskQueuesManageViewRouteEntry),
        (0, $fPxUZ.servicedeskQueuesNewRouteEntry),
        (0, $gqwG0.servicedeskQueuesViewsConfigRouteEntry),
        (0, $8CLhe.servicedeskReports1RouteEntry),
        (0, $d3dv3.servicedeskReportsCustom4RouteEntry),
        (0, $izixQ.servicedeskReportsCustomCreateRouteEntry),
        (0, $gZq43.servicedeskReportsCustomEditRouteEntry),
        (0, $9uidf.servicedeskReportsCustomIssueRouteEntry),
        (0, $lHdES.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $8gAuW.servicedeskReportsSatisfaction2RouteEntry),
        (0, $jgRv0.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $iBcSa.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $bJiYi.servicedeskReportsTypeRouteEntry),
        (0, $9NWq7.servicedeskReportsWorkloadRouteEntry),
        (0, $hnYNr.servicedeskServiceDetailsRouteEntry),
        (0, $gSlgn.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $cENRX.servicedeskServiceModalEditRouteEntry),
        (0, $f0Lah.servicedeskServiceModalNewRouteEntry),
        (0, $5psoN.servicedeskServicesRouteEntry),
        (0, $1kaFK.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $kRlsB.servicedeskSlaSettingsRouteEntry),
        (0, $cK5xr.servicedeskWorkflowConfigRouteEntry),
        (0, $43qOr.settingsAutomationRouteEntry),
        (0, $gYfl3.settingsCmdbFieldConfigRouteEntry),
        (0, $jo8cE.settingsOauthCredentialsRouteEntry),
        (0, $kKMOG.settingsRouteEntry),
        (0, $aNCbW.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $2AYKc.softwareBacklogEmbedRouteEntry),
        (0, $cJqhS.softwareBacklogRouteEntry),
        (0, $ejo5K.softwareBoardEmbedRouteEntry),
        (0, $hnRYr.softwareBoardRouteEntry),
        (0, $88nEe.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $4nTz0.softwareBoardViewNotFoundRouteEntry),
        (0, $8W2c8.softwareCalendarClassicCustomEmbedRouteEntry),
        (0, $5gnJR.softwareCalendarClassicEmbedRouteEntry),
        (0, $gkm2X.softwareCalendarClassicRouteEntry),
        (0, $csjBW.softwareCalendarCustomEmbedRouteEntry),
        (0, $lj5Av.softwareCalendarEmbedRouteEntry),
        (0, $byNoq.softwareCalendarRouteEntry),
        (0, $4aSHo.softwareCapacityClassicCustomEmbedRouteEntry),
        (0, $aNXAx.softwareCapacityClassicEmbedRouteEntry),
        (0, $jueBm.softwareCapacityClassicRouteEntry),
        (0, $lMawn.softwareCapacityCustomEmbedRouteEntry),
        (0, $hK8mq.softwareCapacityEmbedRouteEntry),
        (0, $33rS9.softwareCapacityRouteEntry),
        (0, $6PPxR.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $5JTZa.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $jSZVk.softwareCodeClassicRouteEntry),
        (0, $8JIqa.softwareCodeRouteEntry),
        (0, $bTXFE.softwareDeploymentsClassicRouteEntry),
        (0, $exjbO.softwareDeploymentsNextGenRouteEntry),
        (0, $37n4w.softwareFormBuilderClassicRouteEntry),
        (0, $l7Kcl.softwareFormBuilderRouteEntry),
        (0, $kbvuM.softwareFormClassicRouteEntry),
        (0, $1XNI6.softwareFormRouteEntry),
        (0, $8RT9n.softwareFormSubmitClassicPublicRouteEntry),
        (0, $9kqeg.softwareFormSubmitClassicRouteEntry),
        (0, $hRXMa.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $lPhuN.softwareFormSubmitEmbedRouteEntry),
        (0, $4Cdj7.softwareFormSubmitPublicRouteEntry),
        (0, $lxvYO.softwareFormSubmitRouteEntry),
        (0, $6XvFv.softwareGoalsClassicRouteEntry),
        (0, $jZv6V.softwareGoalsRouteEntry),
        (0, $b5gw6.softwareInboxClassicRouteEntry),
        (0, $2YbyC.softwareInboxNextGenRouteEntry),
        (0, $hykoI.softwareIncidentsClassicRouteEntry),
        (0, $2dAZL.softwareIncidentsNextGenRouteEntry),
        (0, $6Rmp2.softwareListClassicRouteEntry),
        (0, $3FQCK.softwareListCustomEmbedClassicRouteEntry),
        (0, $5v5xs.softwareListCustomEmbedRouteEntry),
        (0, $9vlCj.softwareListEmbedClassicRouteEntry),
        (0, $algSY.softwareListEmbedRouteEntry),
        (0, $chmwv.softwareListRouteEntry),
        (0, $ilU7w.softwareNextgenRedirectRouteEntry),
        (0, $jP8P4.softwareOnboardingGetStartedRouteEntry),
        (0, $1DVzF.softwareOnboardingRouteEntry),
        (0, $7ccps.softwarePeriscopeClassicRouteEntry),
        (0, $1Pj99.softwarePeriscopeNextGenRouteEntry),
        (0, $ff5dM.softwarePlanCalendarRouteEntry),
        (0, $aLXiu.softwarePlanDependenciesRouteEntry),
        (0, $kHsPZ.softwarePlanReleasesRouteEntry),
        (0, $30PHd.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $aGFMx.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $fFZgu.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $hAVk6.softwarePlanSettingsFeaturesRouteEntry),
        (0, $72a1U.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $luRFY.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $3dqLQ.softwarePlanSettingsPermissionsRouteEntry),
        (0, $gxAJV.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $dLExR.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $5zVch.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $2ZnyJ.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $lGz7G.softwarePlanSettingsScenariosRouteEntry),
        (0, $aPs1z.softwarePlanSettingsSchedulingRouteEntry),
        (0, $91LPB.softwarePlanSummaryRouteEntry),
        (0, $e6ehT.softwarePlanTeamsRouteEntry),
        (0, $gAUgF.softwarePlanTimelineRouteEntry),
        (0, $7eIYH.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $6dPXJ.softwareProformaIssueFormsDirectRouteEntry),
        (0, $k80dv.softwareReleaseNotesRouteEntry),
        (0, $dw2ce.softwareReportsBurndownRouteEntry),
        (0, $eSIYo.softwareReportsBurnupRouteEntry),
        (0, $gLWOL.softwareReportsControlRouteEntry),
        (0, $YXwcg.softwareReportsCumulativeRouteEntry),
        (0, $lFKeR.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $1xutc.softwareReportsCycleTimeClassicRouteEntry),
        (0, $ed2hW.softwareReportsCycleTimeRouteEntry),
        (0, $9iKlG.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $dfVfw.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $fWDhV.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $khKzX.softwareReportsOverviewBoardlessRouteEntry),
        (0, $kzxfE.softwareReportsOverviewRouteEntry),
        (0, $eF6xc.softwareReportsRouteEntry),
        (0, $7wJLb.softwareReportsVelocityRouteEntry),
        (0, $hN6Yh.softwareRoadmapClassicRouteEntry),
        (0, $5dzzd.softwareRoadmapRedirectRouteEntry),
        (0, $eyWIM.softwareRoadmapRouteEntry),
        (0, $5OhH5.softwareSecurityClassicRouteEntry),
        (0, $eOJip.softwareSecurityNextGenRouteEntry),
        (0, $jG7gV.softwareStaffingRouteEntry),
        (0, $P4w4L.softwareSummaryClassicRouteEntry),
        (0, $8mw4w.softwareSummaryEmbedClassicRouteEntry),
        (0, $gJeDi.softwareSummaryEmbedRouteEntry),
        (0, $sK3EH.softwareSummaryRouteEntry),
        (0, $cOBeu.softwareTimelineClassicRouteEntry),
        (0, $b4ktm.softwareTimelineRouteEntry),
        (0, $bbpTw.softwareVersionDetailEmbedRouteEntry),
        (0, $hSovm.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $bwfaS.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $3B2tH.softwareVersionDetailRouteEntry),
        (0, $k5ls9.softwareViewNotFoundClassicRouteEntry),
        (0, $4MZMG.softwareViewNotFoundRouteEntry),
        (0, $24gKw.systemConfigurationRedirectRouteEntry),
        (0, $g09EF.systemConfigurationRouteEntry),
        (0, $as2yW.systemDashboardEditRouteEntry),
        (0, $jlw0X.teamIntegrationCreateRouteEntry),
        (0, $VMQYl.teamIntegrationDetailRouteEntry),
        (0, $8t3Bs.teamIntegrationListRouteEntry),
        (0, $gqlkg.teamIntegrationLogRouteEntry),
        (0, $4W2Ve.teamIntegrationsRouteEntry),
        (0, $2qWaR.trashedPlanDirectLinkRouteEntry),
        (0, $1rAP5.trashPlansRouteEntry),
        (0, $4MsHe.trashProjectsDirectoryRedirectRouteEntry),
        (0, $ASOiD.trashProjectsDirectoryRouteEntry),
        (0, $bxGoH.unlockOperationsRouteEntry),
        (0, $7dAIb.userBoardRouteEntry),
        (0, $53Ske.userBoardSettingsRouteEntry),
        (0, $l6W7I.userBoardVelocityRouteEntry),
        (0, $77YbO.userBoardViewNotFoundRouteEntry),
        (0, $dNIAB.userSegmentationRouteEntry),
        (0, $zhYLc.viewIntentRouteEntry),
        (0, $kZdpv.viewStandardFlowRouteEntry),
        (0, $g70C8.whoIsOnCallRouteEntry),
        (0, $ckYTZ.workItemRouteEntry)
    ];

});
parcelRegister("3y68D", function(module, exports) {
$parcel$export(module.exports, "advancedAdminControlsRouteEntry", () => $ac3dae7adf49ddcd$export$3ec532d564f54af1);

var $5mqRM = parcelRequire("5mqRM");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1Krly = parcelRequire("1Krly");

var $enHI7 = parcelRequire("enHI7");

var $5fjzQ = parcelRequire("5fjzQ");

var $9BJU1 = parcelRequire("9BJU1");

var $g8uYY = parcelRequire("g8uYY");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");
const $ac3dae7adf49ddcd$var$advancedAdminControlsEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5mqRM.advancedAdminControlsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $ac3dae7adf49ddcd$export$3ec532d564f54af1 = (0, $6xToB.createEntry)((0, $1Krly.advancedAdminControlsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'advanced-admin-controls',
        component: (0, $9BJU1.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('jira_advanced_admin_controls_fg')) return undefined;
            if ((0, $cxKOj.expValEquals)('jira_advanced_admin_controls', 'cohort', 'treatment', 'not-enrolled')) return $ac3dae7adf49ddcd$var$advancedAdminControlsEntryPointPage;
        },
        canTransitionIn: ()=>!!(0, $cxKOj.expValEquals)('jira_advanced_admin_controls', 'cohort', 'treatment', 'not-enrolled'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-advanced-admin-controls-entries/src/advancedAdminControlsRouteEntry.tsx',
                whichExportToUse: 'advancedAdminControlsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5mqRM", function(module, exports) {
$parcel$export(module.exports, "advancedAdminControlsEntryPoint", () => $ca80283e1329998f$export$d36cfa5d623f95a3);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $gsAPC = parcelRequire("gsAPC");

var $ln7dp = parcelRequire("ln7dp");

const $ca80283e1329998f$export$d36cfa5d623f95a3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8Cf4K")), {
        moduleId: "1dc2db7d",
        moduleName: "AdvancedAdminControlsPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { appEditions: appEditions, cloudId: cloudId, orgId: orgId, productEntitlementDetails: productEntitlementDetails } = tenantContext;
        // Generate a unique sessionId for this page session using crypto.randomUUID
        // This approach is used throughout the codebase (e.g., in servicedesk/journeys, assets-app)
        // This sessionId will be used in both the GraphQL recommendations query and analytics events
        const sessionId = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString();
        // Calculate current time once to avoid volatile variable usage in render logic
        const currentTime = Date.now();
        const trialEndTime = productEntitlementDetails?.['jira-software']?.trialEndTime;
        const firstPredunningEndTime = productEntitlementDetails?.['jira-software']?.firstPredunningEndTime;
        const isInTrial = !!trialEndTime && currentTime <= trialEndTime;
        const isInPreDunning = !!firstPredunningEndTime && currentTime <= firstPredunningEndTime;
        const queries = {
            advancedAdminControlsRecommendationsQuery: {
                parameters: (0, $ln7dp.default),
                variables: {
                    context: {
                        useCase: 'jiraAdvancedAdminControlsRerank',
                        tenantId: cloudId,
                        product: 'jira',
                        sessionId: sessionId,
                        orgId: orgId,
                        custom: {
                            edition: appEditions?.software,
                            isInTrial: isInTrial,
                            isInPreDunning: isInPreDunning
                        }
                    },
                    first: 10
                },
                fetchPolicy: 'store-or-network'
            },
            advancedAdminControlsLayoutQuery: {
                parameters: (0, $gsAPC.default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    hamsProductKey: 'jira-software.ondemand',
                    offeringKey: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07'
                }
            }
        };
        return {
            queries: queries,
            extraProps: {
                sessionId: sessionId
            }
        };
    }
});

});
parcelRegister("gsAPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $42841ebb2d7968a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f19257e88527a61f4bca15a13f770d0>>
 * @relayHash bc75795be1cb380085bbe683a4ccfb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cbc6236c66852430098645f68e7799c060cb21e390fad8fc94c0569eff9e20a

var $37Ewn = parcelRequire("37Ewn");
const $42841ebb2d7968a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = [
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = [
        v8 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AdvancedAdminControlsLayoutQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v6 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePayment",
                                                                            "plural": false,
                                                                            "selections": v6 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AdvancedAdminControlsLayoutQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePayment",
                                                                            "plural": false,
                                                                            "selections": v9 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6cbc6236c66852430098645f68e7799c060cb21e390fad8fc94c0569eff9e20a",
            "metadata": {},
            "name": "AdvancedAdminControlsLayoutQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42841ebb2d7968a6$var$node.hash = "58d5d16f69e1a5d03bb40ed9b8da66c1";
(0, $37Ewn.PreloadableQueryRegistry).set($42841ebb2d7968a6$var$node.params.id, $42841ebb2d7968a6$var$node);
var $42841ebb2d7968a6$export$2e2bcd8739ae039 = $42841ebb2d7968a6$var$node;

});

parcelRegister("ln7dp", function(module, exports) {
$parcel$export(module.exports, "default", () => $164707d49f59459d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<709f1d42f289f59960e5ef6f5c887467>>
 * @relayHash 0ec9ccb99f55638b4d90964ba0233fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a85e2c0b063405d75f696fe88da52aef8cfe3874acb5e94a320058cbe2f8069

var $37Ewn = parcelRequire("37Ewn");
const $164707d49f59459d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AdvancedAdminControlsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AdvancedAdminControlsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6a85e2c0b063405d75f696fe88da52aef8cfe3874acb5e94a320058cbe2f8069",
            "metadata": {},
            "name": "AdvancedAdminControlsRecommendationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$164707d49f59459d$var$node.hash = "a07263cc5d40b6fd5933c2b74ed403c6";
(0, $37Ewn.PreloadableQueryRegistry).set($164707d49f59459d$var$node.params.id, $164707d49f59459d$var$node);
var $164707d49f59459d$export$2e2bcd8739ae039 = $164707d49f59459d$var$node;

});

parcelRegister("8Cf4K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jnw0A").then(()=>parcelRequire('l4mr2'));

});


parcelRegister("kHlOR", function(module, exports) {
$parcel$export(module.exports, "LazyAtlassianNavigation", () => $484a81aa80a53037$export$4caed23aa0274abb);

var $75yrv = parcelRequire("75yrv");

var $lOI8W = parcelRequire("lOI8W");

var $bQWwW = parcelRequire("bQWwW");

const $484a81aa80a53037$export$4caed23aa0274abb = (0, $bQWwW.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("96SSt"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $75yrv.JS_EVAL_START))) {
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});

parcelRegister("yRJUA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLayout", () => $150f50faaae72217$export$e6aef6083548e882);

var $7h3uc = parcelRequire("7h3uc");

var $6dwgv = parcelRequire("6dwgv");
const $150f50faaae72217$export$e6aef6083548e882 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout));

});

parcelRegister("2nHUF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c03066d31b31d1d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("lQtJb")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
const $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar, null)));
$7c03066d31b31d1d$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $7c03066d31b31d1d$export$2e2bcd8739ae039 = $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar;

});
parcelRegister("8Dw1w", function(module, exports) {
$parcel$export(module.exports, "SidebarBoundary", () => $b66ffc7f89ff7516$export$1edc778464f08256);

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $2imLM = parcelRequire("2imLM");

var $4EKqI = parcelRequire("4EKqI");

var $dysGT = parcelRequire("dysGT");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $gpE1B = parcelRequire("gpE1B");
const $b66ffc7f89ff7516$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $8Q9Ns.useSidebarFail)();
    const onSuccess = (0, $8Q9Ns.useSidebarSuccess)();
    const onError = (0, $eJOHy.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysGT.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "nav-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "nav-sidebar-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        }))
    }, children)));
};

});
parcelRegister("hOBHo", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $f058582c63bdf80a$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $f058582c63bdf80a$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $f058582c63bdf80a$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $f058582c63bdf80a$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $f058582c63bdf80a$export$1d10ee0c85c3cb21);
const $f058582c63bdf80a$export$6635720e40ea7a7a = 'navigation.top';
const $f058582c63bdf80a$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $f058582c63bdf80a$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $f058582c63bdf80a$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $f058582c63bdf80a$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("03pp6", function(module, exports) {
$parcel$export(module.exports, "pageSegmentStore", () => $9b842795409a6159$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $9b842795409a6159$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $9b842795409a6159$export$a018e347341b3640);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $hqYEY = parcelRequire("hqYEY");

var $kQnVX = parcelRequire("kQnVX");

var $6dnL8 = parcelRequire("6dnL8");

var $hOBHo = parcelRequire("hOBHo");

const $9b842795409a6159$var$createTopNavPageSegment = ()=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$8df02628d98cae7e = {
    ADDONS: (0, $hqYEY.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $9b842795409a6159$var$createSidebarPageSegment = ()=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)]: $9b842795409a6159$var$createTopNavPageSegment,
        [(0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $9b842795409a6159$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $9b842795409a6159$export$906025848d54198d = (segmentKey = (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eJOHy.useRef)(false);
    const segment = (0, $eJOHy.useRef)($9b842795409a6159$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eJOHy.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $hOBHo.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $6dnL8.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $9b842795409a6159$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $9b842795409a6159$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $kQnVX.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $9b842795409a6159$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $9b842795409a6159$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});

parcelRegister("dysGT", function(module, exports) {
$parcel$export(module.exports, "SidebarErrorBoundary", () => $c7f6dd1cac39f594$export$62853c5766dad0c4);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $kQnVX = parcelRequire("kQnVX");

var $ea4Iz = parcelRequire("ea4Iz");
const $c7f6dd1cac39f594$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $kQnVX.getUserLocation)();
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ea4Iz.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("ea4Iz", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $9b4051d45e6e7b1f$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $jLjxj = parcelRequire("jLjxj");

var $lRq8t = parcelRequire("lRq8t");

var $lh7Oqf = parcelRequire("lh7Oqf");

var $6aoQW = parcelRequire("6aoQW");
const $9b4051d45e6e7b1f$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rkowr30 _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $9b4051d45e6e7b1f$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lh7Oqf))),
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $6aoQW.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $6aoQW.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("code", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.error
        ])
    }, "ERROR: ", (0, $jLjxj.getErrorHash)(error)));
};

});
parcelRegister("lh7Oqf", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("6aoQW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f850c5d954b638cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f850c5d954b638cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("8Q9Ns", function(module, exports) {
$parcel$export(module.exports, "SidebarRenderStart", () => $b1d0fa6e8dcb9f72$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1d0fa6e8dcb9f72$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6);

var $eJOHy = parcelRequire("eJOHy");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $XQ5wK = parcelRequire("XQ5wK");

var $hih5V = parcelRequire("hih5V");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $5grHY = parcelRequire("5grHY");

var $gCY1z = parcelRequire("gCY1z");

var $eES78 = parcelRequire("eES78");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1d0fa6e8dcb9f72$var$useSidebarId } = (0, $XQ5wK.createValueController)('sidebar-id');
const $b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $eES78.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1d0fa6e8dcb9f72$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $gCY1z.useRouter)();
    const pageId = (0, $5grHY.usePageId)();
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $eES78.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eJOHy.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1d0fa6e8dcb9f72$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1d0fa6e8dcb9f72$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1d0fa6e8dcb9f72$var$useSidebarId();
    const route = (0, $hih5V.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eJOHy.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eJOHy.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $eES78.SIDEBAR_EXPERIENCE)
    });
    return (0, $eJOHy.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6 = ()=>(0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("XQ5wK", function(module, exports) {
$parcel$export(module.exports, "createValueController", () => $a097180df6b282dc$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $a097180df6b282dc$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $GtRbT.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $6E16M.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $iJq0l.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});


parcelRegister("gpE1B", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $65e95951f2fce7be$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");
const $65e95951f2fce7be$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65e95951f2fce7be$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $65e95951f2fce7be$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1f4h _u5f3idpf _n3tdpxbi _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("diNYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c44efaa9252dc1d8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c44efaa9252dc1d8$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $c44efaa9252dc1d8$export$2e2bcd8739ae039 = $c44efaa9252dc1d8$var$Section;

});

parcelRegister("6seod", function(module, exports) {
$parcel$export(module.exports, "default", () => $982e2949d673f589$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $982e2949d673f589$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {
        isSideNavSkeleton: true,
        ...props
    });
};
var $982e2949d673f589$export$2e2bcd8739ae039 = $982e2949d673f589$var$SkeletonItem;

});



parcelRegister("7DXwW", function(module, exports) {
$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $2ebdd972899a51f4$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $2ebdd972899a51f4$export$edbd543f308bbef5);

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");
const $2ebdd972899a51f4$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $2ebdd972899a51f4$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("lQtJb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ilGII")
]).then(()=>parcelRequire('cuk8p'));

});


parcelRegister("1Krly", function(module, exports) {
$parcel$export(module.exports, "advancedAdminControlsRoute", () => $ca05ce4a27f27131$export$558faffd77301243);
const $ca05ce4a27f27131$export$558faffd77301243 = {
    name: 'global-settings-advanced-admin-controls',
    path: '/jira/settings/system/advanced-admin-controls',
    exact: true
};

});

parcelRegister("9BJU1", function(module, exports) {
$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $6c1420c5acf0f215$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $6c1420c5acf0f215$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $6c1420c5acf0f215$export$57c5c0b5a0cdb5b7 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3xPh7")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
const $6c1420c5acf0f215$var$AsyncNotFoundErrorPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6c1420c5acf0f215$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });
var $6c1420c5acf0f215$export$2e2bcd8739ae039 = $6c1420c5acf0f215$var$AsyncNotFoundErrorPage;

});
parcelRegister("1F9cm", function(module, exports) {
$parcel$export(module.exports, "LazyPage", () => $115917303a5a4975$export$a18c9c3dd309b8e6);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $eSnSE = parcelRequire("eSnSE");

var $2imLM = parcelRequire("2imLM");

var $hih5V = parcelRequire("hih5V");

var $1Mugv = parcelRequire("1Mugv");

var $cH6Qf = parcelRequire("cH6Qf");

var $lq8Ki = parcelRequire("lq8Ki");
const $115917303a5a4975$var$LOCATION = 'lazy-page';
const $115917303a5a4975$export$fb85bbdbfb3e6869 = ()=>null;
const $115917303a5a4975$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $6OSA0.default) : $115917303a5a4975$export$fb85bbdbfb3e6869);
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) (0, $eSnSE.default).safeWarnWithoutCustomerData($115917303a5a4975$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, route.bifrost?.bifrostGroup !== 'shell-only' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "LazyPage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Mugv.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)))));
};

});

parcelRegister("3xPh7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("kVX56"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("7UJZZ")
]).then(()=>parcelRequire('4534k'));

});


parcelRegister("g8uYY", function(module, exports) {
$parcel$export(module.exports, "createChromelessEntryPoint", () => $d4128f4ca41a15cd$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $d4128f4ca41a15cd$export$955a7619d2679b4c);

var $8xgJ5 = parcelRequire("8xgJ5");


var $6zXPf = parcelRequire("6zXPf");

var $4cTDP = parcelRequire("4cTDP");
const $d4128f4ca41a15cd$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $d4128f4ca41a15cd$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $ce4cfb37df77ff19$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $8xgJ5.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $d4128f4ca41a15cd$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $6zXPf.getWillShowNav4)() ? {
                        [(0, $ce4cfb37df77ff19$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined,
                    ...page.redirect && (0, $4cTDP.fg)('redirect_all_new_jira_users_to_user_segmentation') ? {
                        [(0, $ce4cfb37df77ff19$export$5ef29550cd5a8266)]: {
                            entryPoint: page.redirect,
                            entryPointParams: entryPointParams
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $d4128f4ca41a15cd$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
const $ce4cfb37df77ff19$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $ce4cfb37df77ff19$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $ce4cfb37df77ff19$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $ce4cfb37df77ff19$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $ce4cfb37df77ff19$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
const $ce4cfb37df77ff19$export$5ef29550cd5a8266 = '___pageLayoutRedirect';



parcelRegister("fJ15R", function(module, exports) {
$parcel$export(module.exports, "aiAnswersRouteEntry", () => $4ac7d6a703d7e8db$export$7aab6c3a99455d30);

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4AC9x = parcelRequire("4AC9x");

var $cRzUS = parcelRequire("cRzUS");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $7b25q = parcelRequire("7b25q");

var $c6t96 = parcelRequire("c6t96");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $4ac7d6a703d7e8db$var$aiAnswersPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c6t96.aiAnswersEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $4ac7d6a703d7e8db$export$7aab6c3a99455d30 = (0, $6xToB.createEntry)((0, $cRzUS.aiAnswersRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $4ac7d6a703d7e8db$var$aiAnswersPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7b25q.VirtualAgentAiAnswersSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $4AC9x.servicedeskVirtualAgentAiAnswersKbResource)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/aiAnswersRouteEntry.tsx',
                whichExportToUse: 'aiAnswersRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1f2LE", function(module, exports) {
$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $34d9b7a65dd1d6b8$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $34d9b7a65dd1d6b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

var $4cTDP = parcelRequire("4cTDP");

var $i67QL = parcelRequire("i67QL");
const $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint = new Set([
    'servicedesk-queues-custom-view',
    'servicedesk-practice-custom-view',
    'issue'
]);

const $34d9b7a65dd1d6b8$export$4553575c70a669bf = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("butUa")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$4553575c70a669bf, null)));
const $34d9b7a65dd1d6b8$export$c72ea37d21335def = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i67QL.LazyForPaintServicedeskSidebar), null)));
const $34d9b7a65dd1d6b8$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isLazyForPaintRoute = (0, $kfvK2.useIsActiveRoute)((0, $4cTDP.fg)('queues_sidebar_lazyafterpaint_to_lazyforpaint') ? $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint : 'issue');
    return isLazyForPaintRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar, null);
});
$34d9b7a65dd1d6b8$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$34d9b7a65dd1d6b8$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $34d9b7a65dd1d6b8$export$2e2bcd8739ae039 = $34d9b7a65dd1d6b8$var$ServicedeskSidebar;

});
parcelRegister("i67QL", function(module, exports) {
$parcel$export(module.exports, "LazyForPaintServicedeskSidebar", () => $d27c58e19a795fc8$export$15e3805736f2222d);

var $bQWwW = parcelRequire("bQWwW");

var $7DXwW = parcelRequire("7DXwW");

const $d27c58e19a795fc8$export$15e3805736f2222d = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("butUa")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

});
parcelRegister("butUa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("f861S")
]).then(()=>parcelRequire('eQ0q2'));

});



parcelRegister("1PvPk", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $bd8fec0596296dc8$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $bd8fec0596296dc8$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $bd8fec0596296dc8$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $bd8fec0596296dc8$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $bd8fec0596296dc8$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $bd8fec0596296dc8$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $bd8fec0596296dc8$export$e1016cce62543991);
$parcel$export(module.exports, "getTriageButtonPermissionResource", () => $bd8fec0596296dc8$export$425007869b82cef8);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $bd8fec0596296dc8$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $bd8fec0596296dc8$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $bd8fec0596296dc8$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $bd8fec0596296dc8$export$54079077c6768752);
$parcel$export(module.exports, "getIssueViewResources", () => $bd8fec0596296dc8$export$590e911b4187f266);

var $lopBx = parcelRequire("lopBx");

var $4cTDP = parcelRequire("4cTDP");

var $hHbzj = parcelRequire("hHbzj");

var $3qMzf = parcelRequire("3qMzf");

var $gq8OO = parcelRequire("gq8OO");

var $5FSZM = parcelRequire("5FSZM");

var $6zZVV = parcelRequire("6zZVV");

var $dHUNm = parcelRequire("dHUNm");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $85Ze9 = parcelRequire("85Ze9");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $cu1g7 = parcelRequire("cu1g7");

var $kgDPH = parcelRequire("kgDPH");

var $iWhpv = parcelRequire("iWhpv");

var $JHxCO = parcelRequire("JHxCO");

var $h60sh = parcelRequire("h60sh");

var $aGQ56 = parcelRequire("aGQ56");

var $aEWXS = parcelRequire("aEWXS");

var $arxGJ = parcelRequire("arxGJ");

var $g9kBK = parcelRequire("g9kBK");

var $bTfc4 = parcelRequire("bTfc4");

var $5L7qx = parcelRequire("5L7qx");

var $ePaI2 = parcelRequire("ePaI2");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $c0h8V = parcelRequire("c0h8V");

var $fbgOh = parcelRequire("fbgOh");

var $lzT4f = parcelRequire("lzT4f");

var $esUDP = parcelRequire("esUDP");

var $jIhkm = parcelRequire("jIhkm");
const $bd8fec0596296dc8$var$getQueueSidebarViewAllQueuesResource = ()=>(0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)() && (0, $4cTDP.fg)('migrate_queue_sidebar_all_queues_expansion_to_be'), (0, $aGQ56.queueSidebarViewAllQueuesResource));
const $bd8fec0596296dc8$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('more_for_nav_4_level_3'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$bd8fec0596296dc8$export$41a9145ddbba28e5(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementGpEndDateResource))
    ];
const $bd8fec0596296dc8$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        (0, $dZRaT.projectContextResource),
        $bd8fec0596296dc8$var$getQueueSidebarViewAllQueuesResource(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $aGQ56.queueNav4SidebarSelectionResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $aGQ56.queueSidebarQueuesCategoryStateResource)),
        ...$bd8fec0596296dc8$export$9c1c5e389bd00e56(),
        ...$bd8fec0596296dc8$export$2c543d6accc1eb9b()
    ];
const $bd8fec0596296dc8$export$9c1c5e389bd00e56 = ()=>[
        (0, $aGQ56.priorityGroupByProjectIdResourceSsr),
        (0, $g9kBK.featuresResource),
        (0, $gq8OO.staticSidebarJsmReportsResource),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $4VIcO.getConsolidationStateResource)()),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $iWhpv.servicedeskIsItsmProjectResource)),
        (0, $aEWXS.nav3QueueGroupsStateResource)
    ];
const $bd8fec0596296dc8$export$2c543d6accc1eb9b = ()=>[
        (0, $aGQ56.queuesNavigationItems),
        (0, $h60sh.requiredProjectProperties),
        (0, $h60sh.requiredFrontendProperties),
        (0, $hHbzj.forgeServiceDeskQueueModuleResource),
        (0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $dZRaT.projectContextResourceWithCache)),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $h60sh.firstProjectResource))
    ];
const $bd8fec0596296dc8$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $JHxCO.servicedeskPracticesResource),
        (0, $kgDPH.serviceDeskContextResource),
        (0, $cu1g7.serviceDeskAnalyticsContextResource),
        (0, $h60sh.firstProjectResource),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $lopBx.isFedRamp)(), (0, $arxGJ.virtualAgentOnboardingResource))
    ];
const $bd8fec0596296dc8$export$a8b852f03a310dc0 = ()=>[
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $kgDPH.serviceDeskContextResource),
        (0, $cu1g7.serviceDeskAnalyticsContextResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementGpEndDateResource))
    ];
const $bd8fec0596296dc8$export$70b97995f4d5ef9f = ()=>[
        ...$bd8fec0596296dc8$export$a8b852f03a310dc0(),
        ...$bd8fec0596296dc8$export$bc0bd65e6da57c1f(),
        (0, $5FSZM.getCalendarFilterFieldsResource)()
    ];
const $bd8fec0596296dc8$export$e1016cce62543991 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ssr_view_queues_issuelist'), (0, $aGQ56.issueListSsrResource))
    ];
const $bd8fec0596296dc8$export$425007869b82cef8 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('convert_jsm_global_triage_button_into_sync'), (0, $aGQ56.triageButtonPermissionResource))
    ];
const $bd8fec0596296dc8$export$ed87d3b71544c4ef = ()=>[
        (0, $85Ze9.kbConfluenceContextResource)
    ];
const $bd8fec0596296dc8$export$9e0cf1fab0581096 = ()=>[
        (0, $ePaI2.workspaceResource)
    ];
const $bd8fec0596296dc8$export$5f7bcaa978a3e51 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dZRaT.projectContextResource))
    ];
const $bd8fec0596296dc8$export$54079077c6768752 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $fbgOh.getEditModelResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $27Owl.getBoardDetailsResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dZRaT.projectContextResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $c0h8V.uifBoardResource)),
        ...(0, $alzbz.getRapidboardResources)().map((resource)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];
const $bd8fec0596296dc8$export$590e911b4187f266 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $jIhkm.issueCollapsibleGroupDataResource))
    ];

});
parcelRegister("gq8OO", function(module, exports) {
$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e907d070057d33a1$export$ec28065a31cce4ce);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $aGpYW = parcelRequire("aGpYW");
const $e907d070057d33a1$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e907d070057d33a1$export$ec28065a31cce4ce = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e907d070057d33a1$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e907d070057d33a1$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $aGpYW.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("aGpYW", function(module, exports) {
$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $2ca8e623397ccc3d$export$c1dd51127051647d);

var $3ugTQ = parcelRequire("3ugTQ");
const $2ca8e623397ccc3d$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $3ugTQ.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("5FSZM", function(module, exports) {
$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $613ce22e40063fc2$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $613ce22e40063fc2$export$70361b748d216408);

var $eJOHy = parcelRequire("eJOHy");

var $dMM78 = parcelRequire("dMM78");

var $3ugTQ = parcelRequire("3ugTQ");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");

var $7OmKg = parcelRequire("7OmKg");


var $iPdm8 = parcelRequire("iPdm8");
const $613ce22e40063fc2$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $4632d48377e7873d$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: {
                        jqlTerms: [
                            (0, $7OmKg.REQUEST_TYPE_FILTER),
                            (0, $7OmKg.SERVICE_DESK_ORIGIN_FILTER),
                            (0, $7OmKg.SERVICE_DESK_ORIGIN_DUPLICATE_FILTER)
                        ]
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $iPdm8.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) (0, $iPdm8.reportError)(error);
        return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $613ce22e40063fc2$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $4632d48377e7873d$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
        return [
            {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate.key,
                fieldType: requestTypeField.type
            },
            ...(0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS)
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) (0, $iPdm8.reportError)(error);
        return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $613ce22e40063fc2$var$filterFieldsResource = (0, $l1VxS.createResource)({
    type: (0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return (0, $4cTDP.fg)('move_jsm_views_rt_filter_to_new_query') ? $613ce22e40063fc2$var$fetchFilterFields(cloudId) : $613ce22e40063fc2$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $613ce22e40063fc2$export$5f02bf5f04197ed7 = ()=>$613ce22e40063fc2$var$filterFieldsResource;
const $613ce22e40063fc2$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $eJrcF.useResource)($613ce22e40063fc2$var$filterFieldsResource);
    (0, $eJOHy.useEffect)(()=>{
        if (!isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $iPdm8.TARGET_FILTER_TYPE))) && (0, $4cTDP.fg)('move_jsm_views_rt_filter_to_new_query')) (0, $iPdm8.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("7OmKg", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $500296557fea2aa7$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $500296557fea2aa7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $500296557fea2aa7$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $500296557fea2aa7$export$2c388650eabddf5e);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_FILTER", () => $500296557fea2aa7$export$2fcf90614ee15858);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_DUPLICATE_FILTER", () => $500296557fea2aa7$export$43482ff574598f59);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $500296557fea2aa7$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $500296557fea2aa7$export$2912f30d4328fc00);
const $500296557fea2aa7$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $500296557fea2aa7$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $500296557fea2aa7$export$d57b6b390e78d90f = 'jsd-shield';
const $500296557fea2aa7$export$2c388650eabddf5e = 'request type';
const $500296557fea2aa7$export$2fcf90614ee15858 = 'service desk origin';
const $500296557fea2aa7$export$43482ff574598f59 = 'cf[10010]';
const $500296557fea2aa7$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $500296557fea2aa7$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $4632d48377e7873d$export$546e90157aa718d4 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $4632d48377e7873d$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;

parcelRegister("iPdm8", function(module, exports) {
$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $99c8aba5accb3f4b$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $99c8aba5accb3f4b$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $99c8aba5accb3f4b$export$af2aa11c88c551af);

var $9pTd3 = parcelRequire("9pTd3");

var $7OmKg = parcelRequire("7OmKg");
const $99c8aba5accb3f4b$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $99c8aba5accb3f4b$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $99c8aba5accb3f4b$export$b33b857ad1d9900e = (error)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $7OmKg.RESOURCE_TYPE_NAME),
            packageName: (0, $7OmKg.PACKAGE_NAME),
            teamName: (0, $7OmKg.TEAM_NAME)
        }
    });
};
const $99c8aba5accb3f4b$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $99c8aba5accb3f4b$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $99c8aba5accb3f4b$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("5ddA0", function(module, exports) {
$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $83fdf796383be00f$export$4847c29b4786b3b4);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $24e7X = parcelRequire("24e7X");
const $83fdf796383be00f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $83fdf796383be00f$export$4847c29b4786b3b4 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$83fdf796383be00f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $83fdf796383be00f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $24e7X.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("24e7X", function(module, exports) {
$parcel$export(module.exports, "fetchShortcuts", () => $59a57dc5b45b5a5a$export$49d696bf2525d700);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");
const $59a57dc5b45b5a5a$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $hgi0g.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("85Ze9", function(module, exports) {
$parcel$export(module.exports, "kbConfluenceContextResource", () => $3ddbed7e0cde1711$export$8b58be1423986d17);

var $l1VxS = parcelRequire("l1VxS");


const $3ddbed7e0cde1711$var$getDataLoader = ()=>(parcelRequire("iY0Xp"));
const $3ddbed7e0cde1711$export$8b58be1423986d17 = (0, $l1VxS.createResource)({
    type: (0, $146576bfaf2f1c5a$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $3ddbed7e0cde1711$var$getDataLoader,
    maxAge: Infinity
});

});
const $146576bfaf2f1c5a$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("iY0Xp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hj5jD").then(()=>parcelRequire('inoGB'));

});


parcelRegister("kgDPH", function(module, exports) {
$parcel$export(module.exports, "serviceDeskContextResource", () => $5ade9d115ab90445$export$5eaaf465969a9171);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $5ade9d115ab90445$var$getDataLoader = ()=>(parcelRequire("4Lgr6"));
const $5ade9d115ab90445$export$5eaaf465969a9171 = (0, $l1VxS.createResource)({
    type: (0, $ae1f145ea4ba545a$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $fcQiO.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $5ade9d115ab90445$var$getDataLoader,
    maxAge: Infinity
});

});
const $ae1f145ea4ba545a$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("4Lgr6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9VGhB").then(()=>parcelRequire('c0Tkr'));

});


parcelRegister("iWhpv", function(module, exports) {
$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $20362448f0bcac55$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $20362448f0bcac55$export$7bb46948fb84f164);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $20362448f0bcac55$var$getDataLoader = ()=>(parcelRequire("hcosG"));
const $20362448f0bcac55$var$ONE_DAY_IN_MILLIS = 86400000;
const $20362448f0bcac55$export$920308cef4e291b1 = (0, $l1VxS.createResource)({
    type: (0, $d87510ea5f50e0bd$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $20362448f0bcac55$var$getDataLoader,
    maxAge: $20362448f0bcac55$var$ONE_DAY_IN_MILLIS
});
const $20362448f0bcac55$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)($20362448f0bcac55$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $d87510ea5f50e0bd$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("hcosG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("cEpbi")
]).then(()=>parcelRequire('bJETC'));

});


parcelRegister("JHxCO", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticesResource", () => $446148a1d016b5d1$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $446148a1d016b5d1$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $446148a1d016b5d1$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $446148a1d016b5d1$export$4d46346ef0bdc6b9);

var $eJOHy = parcelRequire("eJOHy");

var $fcQiO = parcelRequire("fcQiO");

var $jlJsl = parcelRequire("jlJsl");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $446148a1d016b5d1$var$getDataLoader = ()=>(parcelRequire("efuMY"));
const $446148a1d016b5d1$var$ONE_DAY_IN_MILLIS = 86400000;
const $446148a1d016b5d1$export$2ae319305481e7de = (0, $l1VxS.createResource)({
    type: (0, $6d5c2d68fdd6fc0f$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $446148a1d016b5d1$var$getDataLoader,
    maxAge: $446148a1d016b5d1$var$ONE_DAY_IN_MILLIS
});
const $446148a1d016b5d1$var$queuesOrder = [
    ...(0, $jlJsl.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $446148a1d016b5d1$var$workCategoryOrder = [
    ...$446148a1d016b5d1$var$queuesOrder,
    (0, $jlJsl.DEVELOPER_ESCALATION)
];
const $446148a1d016b5d1$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $446148a1d016b5d1$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $446148a1d016b5d1$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $446148a1d016b5d1$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $446148a1d016b5d1$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $446148a1d016b5d1$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $446148a1d016b5d1$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
const $6d5c2d68fdd6fc0f$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("efuMY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("acuke").then(()=>parcelRequire('4E57L'));

});


parcelRegister("h60sh", function(module, exports) {
$parcel$export(module.exports, "requiredProjectProperties", () => $2793aada3a9f7a33$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $2793aada3a9f7a33$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $2793aada3a9f7a33$export$f620cebb7e8eeeae);

var $9Dhvc = parcelRequire("9Dhvc");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
const $2793aada3a9f7a33$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0];

const $2793aada3a9f7a33$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("hpUmO"));
const $2793aada3a9f7a33$export$fbeae45a65f4a5a6 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $2793aada3a9f7a33$var$getKey,
    getDataLoader: $2793aada3a9f7a33$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $2793aada3a9f7a33$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("b0Mow"));
const $2793aada3a9f7a33$var$ONE_DAY_IN_MILLIS = 86400000;
const $2793aada3a9f7a33$export$47241956725e3029 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $2793aada3a9f7a33$var$getKey,
    getDataLoader: $2793aada3a9f7a33$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $2793aada3a9f7a33$var$ONE_DAY_IN_MILLIS
});

const $2793aada3a9f7a33$var$getFirstProjectDataLoader = ()=>(parcelRequire("96ORs"));
const $2793aada3a9f7a33$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $2793aada3a9f7a33$export$f620cebb7e8eeeae = (0, $l1VxS.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $2793aada3a9f7a33$var$getFirstProjectDataLoader,
    maxAge: $2793aada3a9f7a33$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("hpUmO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jCLhY").then(()=>parcelRequire('aiZVu'));

});

parcelRegister("b0Mow", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fJQbu").then(()=>parcelRequire('dcEuZ'));

});

parcelRegister("96ORs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a905R").then(()=>parcelRequire('91ovr'));

});


parcelRegister("aGQ56", function(module, exports) {
$parcel$export(module.exports, "queuesNavigationItems", () => $afd2eec712bd1e40$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $afd2eec712bd1e40$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $afd2eec712bd1e40$export$b55fde45b61f13f4);
$parcel$export(module.exports, "priorityGroupCrossProjectResource", () => $afd2eec712bd1e40$export$ce17a222de842d7c);
$parcel$export(module.exports, "issueListSsrResource", () => $afd2eec712bd1e40$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $afd2eec712bd1e40$export$5b6f88b653545aa1);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $afd2eec712bd1e40$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $afd2eec712bd1e40$export$9e9033d678058efa);
$parcel$export(module.exports, "triageButtonPermissionResource", () => $afd2eec712bd1e40$export$11d6dc3c9b9c69ec);

var $9Dhvc = parcelRequire("9Dhvc");

var $9pTd3 = parcelRequire("9pTd3");


var $5j85B = parcelRequire("5j85B");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $FppkK = parcelRequire("FppkK");

var $4cTDP = parcelRequire("4cTDP");

var $l9f4K = parcelRequire("l9f4K");

var $dhGgY = parcelRequire("dhGgY");

var $6zqFp = parcelRequire("6zqFp");

const $afd2eec712bd1e40$var$getDataLoader = ()=>(parcelRequire("lfDzB"));

const $afd2eec712bd1e40$var$getPriorityGroupDataLoader = ()=>(parcelRequire("fTcCJ"));

const $afd2eec712bd1e40$var$fetchIssueListDataLoader = ()=>(parcelRequire("7dZQL"));
const $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.queueId', '')}`;
const $afd2eec712bd1e40$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}`;
const $afd2eec712bd1e40$export$4fed8be571897bef = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$1f9ab301771fe42e = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getPriorityGroupDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey;
        try {
            const projectId = match.params.projectId ? +match.params.projectId : undefined;
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupCrossProjectNoProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: []
};
const $afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdStart',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!projectKey) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectKey',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if (!cloudId) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoCloudId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $4cTDP.fg)('switch-queue-groups-read-to-jira')) return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        let data;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupByProjectIdProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (!data) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextData',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const projectId = data?.projectId;
        if (!projectId) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextProjectId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        try {
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupByProjectIdGettingPriorityGroupsDataError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ]
};
const $afd2eec712bd1e40$export$b55fde45b61f13f4 = (0, $l1VxS.createResource)($afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload);
const $afd2eec712bd1e40$export$ce17a222de842d7c = (0, $l1VxS.createResource)({
    ...$afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload,
    isBrowserOnly: true
});
const $afd2eec712bd1e40$export$3d03cbaac8581e65 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $afd2eec712bd1e40$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $afd2eec712bd1e40$export$5b6f88b653545aa1 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $afd2eec712bd1e40$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$dead630ba04fdfe4 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$9e9033d678058efa = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$11d6dc3c9b9c69ec = (0, $l1VxS.createResource)({
    type: (0, $6zqFp.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getKey: ()=>(0, $6zqFp.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getData: async ()=>{
        return (0, $6zqFp.getTriageButtonPermission)();
    },
    maxAge: (0, $l9f4K.ONE_HOUR_IN_MILLIS)
});

});
const $c8eeacd6960f72dc$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("5j85B", function(module, exports) {
$parcel$export(module.exports, "consumeDependency", () => $9d19e695d8895e78$export$a973ef9e17a326f);
async function $9d19e695d8895e78$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.data;
}

});

parcelRegister("l9f4K", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $3365e8184adaa319$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $3365e8184adaa319$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $3365e8184adaa319$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $3365e8184adaa319$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $3365e8184adaa319$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $3365e8184adaa319$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $3365e8184adaa319$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $3365e8184adaa319$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $3365e8184adaa319$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $3365e8184adaa319$export$5a00268156ea5027);
$parcel$export(module.exports, "ONE_HOUR_IN_MILLIS", () => $3365e8184adaa319$export$86e172ab3db1a556);
const $3365e8184adaa319$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $3365e8184adaa319$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $3365e8184adaa319$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $3365e8184adaa319$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $3365e8184adaa319$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $3365e8184adaa319$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $3365e8184adaa319$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $3365e8184adaa319$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $3365e8184adaa319$export$9b99689db482a6bb = 'queues-category-state';
const $3365e8184adaa319$export$5a00268156ea5027 = 86400000;
const $3365e8184adaa319$export$86e172ab3db1a556 = 3600000;

});

parcelRegister("dhGgY", function(module, exports) {
$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $3c68df8ab7c5fa41$export$cf2bd2ec601ed920);

var $llUmI = parcelRequire("llUmI");

var $6Abnv = parcelRequire("6Abnv");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $4cTDP = parcelRequire("4cTDP");
const $3c68df8ab7c5fa41$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $hgi0g.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}&operation=fetchPriorityGroups`);
};
const $3c68df8ab7c5fa41$var$fetchGroupByKeyViaJira = async (projectKey, projectId)=>{
    const queryParams = projectId ? `projectId=${projectId}` : `projectKey=${projectKey}`;
    return (0, $hgi0g.default)(`/rest/servicedesk/latest/servicedesk/queue-group/groups?${queryParams}&operation=fetchPriorityGroups`);
};
const $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $llUmI.default), {
        projectAri: projectAri
    }).toPromise();
    if (!result?.queuesprioritygroups_priorityGroups?.results) (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'priorityGroupByProjectIdNoPriorityGroupsGraphql',
            packageName: 'jiraRouterResourcesServiceDeskQueues',
            teamName: 'jsm-flash'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $3c68df8ab7c5fa41$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    let data;
    if ((0, $4cTDP.fg)('switch-queue-groups-read-to-jira')) data = await $3c68df8ab7c5fa41$var$fetchGroupByKeyViaJira(projectKey, projectId);
    else if (projectId) data = await $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql(projectId, cloudId);
    else {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $3c68df8ab7c5fa41$var$fetchGroupsByKey(projectKey, cloudId);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("llUmI", function(module, exports) {
$parcel$export(module.exports, "default", () => $49a175edfdfe7540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $49a175edfdfe7540$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$49a175edfdfe7540$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $49a175edfdfe7540$export$2e2bcd8739ae039 = $49a175edfdfe7540$var$node;

});

parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});


parcelRegister("6zqFp", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION", () => $04c4f19ce515c68b$export$e79aee80d521b352);
$parcel$export(module.exports, "getTriageButtonPermission", () => $04c4f19ce515c68b$export$6a9c765d370d71c8);

var $3ugTQ = parcelRequire("3ugTQ");

var $dMM78 = parcelRequire("dMM78");

var $9pTd3 = parcelRequire("9pTd3");
const $04c4f19ce515c68b$export$e79aee80d521b352 = 'triage-button-permission';
const $04c4f19ce515c68b$export$6a9c765d370d71c8 = async ()=>{
    const permissionsUrl = '/rest/api/3/mypermissions?permissions=MOVE_ISSUES%2CEDIT_ISSUES%2CBULK_CHANGE';
    const aiStatusUrl = '/rest/latest/aiconfig/optin/jira-servicedesk';
    try {
        const [permissions, aiStatus] = await Promise.all([
            (0, $3ugTQ.performGetRequest)(permissionsUrl),
            (0, $3ugTQ.performGetRequest)(aiStatusUrl)
        ]);
        return {
            hasPermission: permissions.permissions.MOVE_ISSUES?.havePermission && permissions.permissions.EDIT_ISSUES?.havePermission && permissions.permissions.BULK_CHANGE?.havePermission,
            hasAiEnabled: aiStatus.isEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fetchTriageButtonPermissionError',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        // Return default values on error
        return {
            hasPermission: false,
            hasAiEnabled: false
        };
    }
};

});

parcelRegister("lfDzB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("gGEaT")
]).then(()=>parcelRequire('fIAjW'));

});

parcelRegister("fTcCJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aQC4s").then(()=>parcelRequire('9Uve2'));

});

parcelRegister("7dZQL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dgQcw").then(()=>parcelRequire('22Hs1'));

});


parcelRegister("aEWXS", function(module, exports) {
$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $474104609766e589$export$53d0e5294221581);

var $9Dhvc = parcelRequire("9Dhvc");

var $l1VxS = parcelRequire("l1VxS");

var $9pTd3 = parcelRequire("9pTd3");

var $bBtQo = parcelRequire("bBtQo");

var $l9f4K = parcelRequire("l9f4K");

var $7KiwK = parcelRequire("7KiwK");
const $474104609766e589$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0];
const $474104609766e589$export$53d0e5294221581 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $474104609766e589$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $474104609766e589$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $7KiwK.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("7KiwK", function(module, exports) {
$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $7032001ee4a89aff$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $7032001ee4a89aff$export$87bc602eb5671315);

var $FppkK = parcelRequire("FppkK");

var $9pTd3 = parcelRequire("9pTd3");
const $7032001ee4a89aff$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $7032001ee4a89aff$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $FppkK.setUserProperties)(accountId, `${$7032001ee4a89aff$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $7032001ee4a89aff$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $FppkK.getUserProperty)(accountId, `${$7032001ee4a89aff$export$bb10a02fc2feb574}_${projectKey}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("arxGJ", function(module, exports) {
$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $43d426eb1ac4453c$export$d39827c053fda3aa);

var $4cTDP = parcelRequire("4cTDP");

var $9FYIg = parcelRequire("9FYIg");

var $b2FR1 = parcelRequire("b2FR1");
const $43d426eb1ac4453c$export$d39827c053fda3aa = (0, $9FYIg.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $b2FR1.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4cTDP.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("b2FR1", function(module, exports) {
$parcel$export(module.exports, "default", () => $899915286ad9e08f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b9b2b5e8b99e05cc5ed4d2f22d07d90>>
 * @relayHash 3279cb796ca15f5627d629f70f5f37ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997

var $bXR9c = parcelRequire("bXR9c");
const $899915286ad9e08f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997",
        "metadata": {},
        "name": "VirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $899915286ad9e08f$export$2e2bcd8739ae039 = $899915286ad9e08f$var$node;

});
parcelRegister("bXR9c", function(module, exports) {
$parcel$export(module.exports, "default", () => $34b15431a198dc56$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $34b15431a198dc56$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("g9kBK", function(module, exports) {
$parcel$export(module.exports, "featuresResource", () => $64d699e1b049a1a4$export$16f81cc9da2c6c47);

var $9Dhvc = parcelRequire("9Dhvc");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");


const $64d699e1b049a1a4$var$getDataLoader = ()=>Promise.resolve((parcelRequire("dYpVn")));
const $64d699e1b049a1a4$var$ONE_DAY_IN_MILLIS = 86400000;
const $64d699e1b049a1a4$export$16f81cc9da2c6c47 = (0, $l1VxS.createResource)({
    type: (0, $48cfe47ee1d47a2f$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $64d699e1b049a1a4$var$getDataLoader,
    maxAge: $64d699e1b049a1a4$var$ONE_DAY_IN_MILLIS
});

});
const $48cfe47ee1d47a2f$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';


parcelRegister("bTfc4", function(module, exports) {
$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $36ca214696dd8d52$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $36ca214696dd8d52$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $36ca214696dd8d52$export$31c6945718067be3);

var $l1VxS = parcelRequire("l1VxS");


const $36ca214696dd8d52$export$b2b94ce8ba590cc8 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("2m1Su"))
});

const $36ca214696dd8d52$export$e81d7afef87ae597 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("9y9a6"))
});

const $36ca214696dd8d52$export$31c6945718067be3 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("3IKZI")),
    maxAge: Number.MAX_SAFE_INTEGER
});

});
const $225391858474824e$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $225391858474824e$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $225391858474824e$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("2m1Su", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3awDD").then(()=>parcelRequire('fsQkp'));

});

parcelRegister("9y9a6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9jswB").then(()=>parcelRequire('5DyWZ'));

});

parcelRegister("3IKZI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cBSfN").then(()=>parcelRequire('cbo1b'));

});


parcelRegister("27Owl", function(module, exports) {
$parcel$export(module.exports, "boardDetailsResource", () => $649dd820db29afaa$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $649dd820db29afaa$export$b67eabcfc08e7c62);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");

var $blWcH = parcelRequire("blWcH");
const $649dd820db29afaa$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $hgi0g.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $649dd820db29afaa$export$6c6984c55b171c5d = (0, $l1VxS.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $blWcH.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $blWcH.getConfigFromRouterContext)(routerContext)) return $649dd820db29afaa$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $649dd820db29afaa$export$b67eabcfc08e7c62 = ()=>$649dd820db29afaa$export$6c6984c55b171c5d;

});
parcelRegister("blWcH", function(module, exports) {
$parcel$export(module.exports, "buildAllDataQueryParams", () => $6a4cf61bbd4e46b4$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $6a4cf61bbd4e46b4$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $6a4cf61bbd4e46b4$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $6a4cf61bbd4e46b4$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $6a4cf61bbd4e46b4$export$1705c550e5b835bf);

var $4cTDP = parcelRequire("4cTDP");

var $6XhAO = parcelRequire("6XhAO");

var $q8NP8 = parcelRequire("q8NP8");
const $6a4cf61bbd4e46b4$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $6a4cf61bbd4e46b4$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $6a4cf61bbd4e46b4$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $6a4cf61bbd4e46b4$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $6a4cf61bbd4e46b4$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $6XhAO.WRM_RESOURCES_ARRAY);
    if ((0, $4cTDP.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $6a4cf61bbd4e46b4$export$62c86c4062215346(view);
            return [
                ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $6XhAO.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $6XhAO.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $6a4cf61bbd4e46b4$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("6XhAO", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $a8c4ab1630e67bda$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $a8c4ab1630e67bda$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $a8c4ab1630e67bda$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $a8c4ab1630e67bda$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $a8c4ab1630e67bda$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $a8c4ab1630e67bda$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$1f599d2eef0a7281);
const $a8c4ab1630e67bda$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $a8c4ab1630e67bda$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $a8c4ab1630e67bda$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $a8c4ab1630e67bda$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $a8c4ab1630e67bda$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $a8c4ab1630e67bda$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $a8c4ab1630e67bda$export$ccd0929652c235de = [];
const $a8c4ab1630e67bda$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $a8c4ab1630e67bda$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("q8NP8", function(module, exports) {
$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $388fe636b9cb51cc$export$99d0df2f58f37dfe);

var $6XhAO = parcelRequire("6XhAO");
const $388fe636b9cb51cc$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $6XhAO.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $6XhAO.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $6XhAO.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("alzbz", function(module, exports) {
$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $d3a00a694785eff5$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $d3a00a694785eff5$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $d3a00a694785eff5$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $d3a00a694785eff5$export$ee826506b3baa13a);

var $4cTDP = parcelRequire("4cTDP");

var $4kRUy = parcelRequire("4kRUy");

var $5L7qx = parcelRequire("5L7qx");

var $kmK2e = parcelRequire("kmK2e");

var $451Ow = parcelRequire("451Ow");

var $4pqJW = parcelRequire("4pqJW");
const $d3a00a694785eff5$export$d8d4641986a9ac7f = ()=>!false;
const $d3a00a694785eff5$export$462ca08d6ce67848 = ()=>!$d3a00a694785eff5$export$d8d4641986a9ac7f();
const $d3a00a694785eff5$export$3a5e56bd5231a56b = ()=>[
        (0, $4pqJW.wrmBundleResource),
        (0, $5L7qx.resourceWithCondition2)($d3a00a694785eff5$export$462ca08d6ce67848, (0, $451Ow.rapidboardResource))
    ];
const $d3a00a694785eff5$export$1c63de7f548f965f = ()=>(0, $kmK2e.boardDataResource);
const $d3a00a694785eff5$export$ee826506b3baa13a = (isUserOrEmbedBacklog = false)=>[
        (0, $5L7qx.resourceWithCondition2)(()=>($d3a00a694785eff5$export$d8d4641986a9ac7f() || (0, $4cTDP.fg)('enable_ssr_for_cmp_backlog')) && (isUserOrEmbedBacklog || !(0, $4cTDP.fg)('backlog_relay_data_resource')), (0, $4kRUy.uifBacklogResource))
    ];

});
parcelRegister("4kRUy", function(module, exports) {
$parcel$export(module.exports, "uifBacklogResource", () => $c3662b34dad9676c$export$c182dffb98985208);

var $l1VxS = parcelRequire("l1VxS");


const $c3662b34dad9676c$export$c182dffb98985208 = (0, $l1VxS.createResource)({
    type: (0, $63ba8ce42e431ec8$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("fHd9n")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

});
const $63ba8ce42e431ec8$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';

parcelRegister("fHd9n", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5ff9A").then(()=>parcelRequire('cvbpu'));

});


parcelRegister("kmK2e", function(module, exports) {
$parcel$export(module.exports, "boardDataResource", () => $7ee5fa79b31b97ea$export$138fa635416978f7);

var $l1VxS = parcelRequire("l1VxS");

var $6XhAO = parcelRequire("6XhAO");

var $8QGVd = parcelRequire("8QGVd");

const $7ee5fa79b31b97ea$export$138fa635416978f7 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $8QGVd.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $8QGVd.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("nKbCn")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("8QGVd", function(module, exports) {
$parcel$export(module.exports, "isBoardRoute", () => $94656fa01dfef750$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $94656fa01dfef750$export$bcb853db5e3e8054);
const $94656fa01dfef750$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $94656fa01dfef750$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("nKbCn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dbBUH").then(()=>parcelRequire('btTZq'));

});


parcelRegister("451Ow", function(module, exports) {
$parcel$export(module.exports, "rapidboardResource", () => $22f6993f0f896f9c$export$d0f42a55e7c5752c);

var $l1VxS = parcelRequire("l1VxS");

var $6XhAO = parcelRequire("6XhAO");

const $22f6993f0f896f9c$export$d0f42a55e7c5752c = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("12d8R")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("12d8R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4S1dY").then(()=>parcelRequire('a7NHJ'));

});


parcelRegister("4pqJW", function(module, exports) {
$parcel$export(module.exports, "wrmBundleResource", () => $af9fd9dae3624e0c$export$f199d15b7cd18df1);

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");

var $6XhAO = parcelRequire("6XhAO");

var $blWcH = parcelRequire("blWcH");

const $af9fd9dae3624e0c$export$f199d15b7cd18df1 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $4cTDP.fg)('reports-overview-page-migration')) return (0, $blWcH.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("jmMYb")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("jmMYb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dSNZF").then(()=>parcelRequire('6Y0wG'));

});



parcelRegister("c0h8V", function(module, exports) {
$parcel$export(module.exports, "uifBoardResource", () => $e44f77f60fe564e6$export$b65bcbbccad354ac);

var $l1VxS = parcelRequire("l1VxS");


const $e44f77f60fe564e6$export$b65bcbbccad354ac = (0, $l1VxS.createResource)({
    type: (0, $deaac3eb1a0f3204$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("6NHmH")),
    maxAge: 0
});

});
const $deaac3eb1a0f3204$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("6NHmH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cPGW6").then(()=>parcelRequire('5Uxlx'));

});


parcelRegister("fbgOh", function(module, exports) {
$parcel$export(module.exports, "editModelResource", () => $eeba0f4399f27fcb$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $eeba0f4399f27fcb$export$5b9bac2cc4bf4511);

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $hgi0g = parcelRequire("hgi0g");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");

var $blWcH = parcelRequire("blWcH");
const $eeba0f4399f27fcb$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $hgi0g.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $eeba0f4399f27fcb$export$ab9a4786826fd2d = (0, $l1VxS.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $blWcH.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $blWcH.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $eeba0f4399f27fcb$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $eeba0f4399f27fcb$export$5b9bac2cc4bf4511 = ()=>(0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('board-settings-graphql-refactor_cyvz9'), $eeba0f4399f27fcb$export$ab9a4786826fd2d);

});

parcelRegister("esUDP", function(module, exports) {
$parcel$export(module.exports, "jsmProjectMenuContentSidebarResource", () => $5c2c15eb6f3db6bb$export$c7d29d5f00e667f5);

var $9FYIg = parcelRequire("9FYIg");

var $bBtQo = parcelRequire("bBtQo");

var $73XfD = parcelRequire("73XfD");

var $hBje1 = parcelRequire("hBje1");
const $5c2c15eb6f3db6bb$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    let { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $73XfD.default),
        variables: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
};
const $5c2c15eb6f3db6bb$export$c7d29d5f00e667f5 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
    getQuery: $5c2c15eb6f3db6bb$export$71eec30d9db46a56
}));

});
parcelRegister("73XfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8c7cb456a86a586$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32df6e83baaf72977e3e095da2daeeef>>
 * @relayHash d32c91de1a0c938d346ccddd080ca54d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 558440f5dc1d01ea96ee5362ed3db743ce602559ebd97a47035ce2ee9f71acde
const $a8c7cb456a86a586$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
        "kind": "LinkedField",
        "name": "hiddenMenuItems",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProjectLevelSidebarMenuItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "itemId"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ 
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "558440f5dc1d01ea96ee5362ed3db743ce602559ebd97a47035ce2ee9f71acde",
            "metadata": {},
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a8c7cb456a86a586$var$node.hash = "0ce17ff55164386bf24d619856f960f5";
var $a8c7cb456a86a586$export$2e2bcd8739ae039 = $a8c7cb456a86a586$var$node;

});

parcelRegister("hBje1", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0507489b8f939505$export$f4b29e78f4c0a526);
const $0507489b8f939505$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("jIhkm", function(module, exports) {
$parcel$export(module.exports, "issueCollapsibleGroupDataResource", () => $b5513ffcc897291a$export$36e5daae4cc63ce1);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3ugTQ = parcelRequire("3ugTQ");

var $7hVvO = parcelRequire("7hVvO");

var $aQFRz = parcelRequire("aQFRz");
const $b5513ffcc897291a$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $bBtQo.getProjectKey)(match, query);
    return `issue.collapsible-group.${projectKey}`;
};
const $b5513ffcc897291a$export$36e5daae4cc63ce1 = (0, $l1VxS.createResource)({
    type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
    getKey: $b5513ffcc897291a$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $b5513ffcc897291a$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        try {
            return await (0, $3ugTQ.performGetRequest)(requestUrl);
        } catch (error) {
            if (!!error && typeof error === 'object' && 'statusCode' in error && error.statusCode === (0, $aQFRz.NOT_FOUND)) return;
            throw (0, $7hVvO.createResourceError)({
                component: 'spa.view.routes.issue-view.collapsible-group.getData',
                message: 'An error was thrown while prefetching issue collapsible group data'
            }, error);
        }
    }
});

});
parcelRegister("7hVvO", function(module, exports) {
$parcel$export(module.exports, "createResourceError", () => $57ba68f5ed9efef2$export$13487d18466bc8a5);

var $eSnSE = parcelRequire("eSnSE");
class $57ba68f5ed9efef2$var$ResourceErrorClass extends Error {
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $57ba68f5ed9efef2$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $57ba68f5ed9efef2$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("4AC9x", function(module, exports) {
$parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", () => $38c41c9fdd9e8b38$export$6aecd43ca01da0d9);

var $l1VxS = parcelRequire("l1VxS");

const $38c41c9fdd9e8b38$var$getDataLoader = ()=>(parcelRequire("3x3PJ"));
const $38c41c9fdd9e8b38$export$6aecd43ca01da0d9 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $38c41c9fdd9e8b38$var$getDataLoader,
    isBrowserOnly: true
});

});
parcelRegister("3x3PJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("683lQ").then(()=>parcelRequire('4gt09'));

});


parcelRegister("cRzUS", function(module, exports) {
$parcel$export(module.exports, "aiAnswersRoute", () => $74c36845f4070411$export$57dc115194d72385);
const $74c36845f4070411$export$57dc115194d72385 = {
    name: 'project-settings-servicedesk-virtualagent-ai-answers',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
};

});

parcelRegister("aQoXd", function(module, exports) {
$parcel$export(module.exports, "serviceProjectLayout", () => $1fa61a55f28068ec$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $1fa61a55f28068ec$export$820f9bb834280408);

var $FhXEJ = parcelRequire("FhXEJ");

var $7h3uc = parcelRequire("7h3uc");

var $f61QS = parcelRequire("f61QS");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bwUbt = parcelRequire("bwUbt");

var $bQWwW = parcelRequire("bQWwW");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1fa61a55f28068ec$var$withServiceProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $FhXEJ.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$ProjectBuilder = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aBN5p")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("89aDa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hvgnR")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $1fa61a55f28068ec$export$e321cb31c875d1ba = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {
    globalComponents: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$Onboarding),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).globalComponents.map($1fa61a55f28068ec$var$withServiceProjectContext),
        $1fa61a55f28068ec$var$withServiceProjectContext((0, $f61QS.AsyncJsmCustomDomainChangeBoardingFlag)),
        $1fa61a55f28068ec$var$ProjectBuilder
    ],
    rightSidebars: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$RightSidebars),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).rightSidebars.map($1fa61a55f28068ec$var$withServiceProjectContext)
    ]
});
const $1fa61a55f28068ec$export$820f9bb834280408 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    rightSidebars: [
        $1fa61a55f28068ec$var$RightSidebars
    ]
});

});
parcelRegister("f61QS", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $1961db39384c0e0d$export$b1ef5e3da6e1959d);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hOgCp")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $1961db39384c0e0d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("hOgCp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jRam1").then(()=>parcelRequire('lKRQ7'));

});


parcelRegister("jbfEb", function(module, exports) {
$parcel$export(module.exports, "projectLayout", () => $ca707d874a48fc97$export$204149bac601d20c);

var $h6Od4 = parcelRequire("h6Od4");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca707d874a48fc97$var$withAnyProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca707d874a48fc97$var$ProjectTrackers = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hzNDk")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $ca707d874a48fc97$var$rightSidebars = ()=>[];
const $ca707d874a48fc97$var$globalComponents = [
    $ca707d874a48fc97$var$withAnyProjectContext($ca707d874a48fc97$var$ProjectTrackers),
    $ca707d874a48fc97$var$withAnyProjectContext((0, $h6Od4.ProjectRouteListener))
];
const $ca707d874a48fc97$export$204149bac601d20c = (0, $6dwgv.createLayout)({
    globalComponents: $ca707d874a48fc97$var$globalComponents,
    rightSidebars: $ca707d874a48fc97$var$rightSidebars()
});

});
parcelRegister("h6Od4", function(module, exports) {
$parcel$export(module.exports, "ProjectRouteListener", () => $759f7c84282a636f$export$159f09d701320911);

var $eJOHy = parcelRequire("eJOHy");

var $dZRaT = parcelRequire("dZRaT");

var $kAwwe = parcelRequire("kAwwe");

var $eJrcF = parcelRequire("eJrcF");

var $7A5g5 = parcelRequire("7A5g5");
const $759f7c84282a636f$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $kAwwe.useIsAdmin)();
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    (0, $eJOHy.useEffect)(()=>{
        if (isSiteAdmin) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $7A5g5.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eJOHy.useEffect)(()=>()=>(0, $7A5g5.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});

parcelRegister("hzNDk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gOuNw").then(()=>parcelRequire('lu6uO'));

});


parcelRegister("bwUbt", function(module, exports) {
$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $b899726b5c2e771b$export$2562b2d784eadc10);

var $eJOHy = parcelRequire("eJOHy");

var $jmQek = parcelRequire("jmQek");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
const $b899726b5c2e771b$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null));
    const name = (0, $6dwgv.coalesce)(Component.displayName) ?? (0, $6dwgv.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aKdgA")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kxU5R")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $b899726b5c2e771b$export$2562b2d784eadc10 = (0, $6dwgv.createLayout)({
    globalComponents: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$Onboarding)
    ],
    rightSidebars: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$RightSidebars)
    ]
});

});
parcelRegister("jmQek", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7838320445e919b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $5aeix = parcelRequire("5aeix");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $e7838320445e919b$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $5aeix.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
$e7838320445e919b$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $e7838320445e919b$export$2e2bcd8739ae039 = $e7838320445e919b$var$AppPermissionsCheck;

});
parcelRegister("5aeix", function(module, exports) {
$parcel$export(module.exports, "isDevelopmentEnv", () => $b42edb9e31c9a622$export$48e5fb80244b95c5);
const $b42edb9e31c9a622$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("aKdgA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("jD0ep")
]).then(()=>parcelRequire('R6Cjs'));

});

parcelRegister("kxU5R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("7rAm2")
]).then(()=>parcelRequire('dHOBZ'));

});


parcelRegister("aBN5p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("9qY9x")
]).then(()=>parcelRequire('dQKu6'));

});

parcelRegister("89aDa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dHHIn")
]).then(()=>parcelRequire('dln7i'));

});

parcelRegister("hvgnR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("azviO")
]).then(()=>parcelRequire('byH1L'));

});


parcelRegister("gy2Qg", function(module, exports) {
$parcel$export(module.exports, "APP_NAMES", () => $85c827d4cf4c7c38$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $85c827d4cf4c7c38$export$f31a652635bd75fe);
const $85c827d4cf4c7c38$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    ROVO_SERVICE_AGENT_SETTINGS: 'servicedesk.rovo-service-agent.settings',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    LIST: 'servicedesk.list',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_GET_STARTED: 'servicedesk.customer-service-get-started',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    PROJECT_DASHBOARDS_DASHBOARD_LIST: 'servicedesk.project-dashboards.dashboard-list',
    PROJECT_DASHBOARDS_DASHBOARD_EDITABLE: 'servicedesk.project-dashboards.dashboard-editable',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
    VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE: 'servicedesk.insight-cmdb-assets_dashboards_list_page',
    INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE: 'servicedesk.insight-cmdb-assets_dashboards_detail_page',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings',
    ASSETS_APP_SEARCH_RESULTS: 'assets-app.search-results-page',
    ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE: 'assets-app.data-manager.getting-started-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE: 'assets-app.data-manager.object-classes-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE: 'assets-app.data-manager.object-detail-view',
    ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE: 'assets-app.data-manager.data-source',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE: 'assets-app.data-manager.object-class-view',
    ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE: 'assets-app.analytics.data-view.create',
    ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE: 'assets-app.analytics.data-view.details',
    ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE: 'assets-app.analytics.data-view.list',
    ASSETS_APP_FOR_YOU_PAGE: 'assets-app.for-you-page'
};
// To match the FE error analytics pipeline convention
const $85c827d4cf4c7c38$var$ANALYTICS_PACKAGE_NAMES = {
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ROVO_SERVICE_AGENT_SETTINGS]: 'servicedeskRovoServiceAgentSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.LIST]: 'servicedeskList',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_GET_STARTED]: 'servicedeskCustomerServiceGetStarted',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PROJECT_DASHBOARDS_DASHBOARD_EDITABLE]: 'servicedeskProjectDashboardsEditable',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PROJECT_DASHBOARDS_DASHBOARD_LIST]: 'servicedeskProjectDashboardsList',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE]: 'servicedeskAssetsDashboardsListPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE]: 'servicedeskAssetsDashboardsDetailPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_SEARCH_RESULTS]: 'assetsAppSearchResultsPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE]: 'assetsAppDataManagerGettingStartedPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE]: 'assetsAppDataManagerObjectClassesPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE]: 'assetsAppDataManagerDataSource',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE]: 'assetsAppDataManagerObjectClassView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE]: 'assetsAppDataManagerObjectDetailView',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE]: 'assetsAppAnalyticsDataViewCreatePage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE]: 'assetsAppAnalyticsDataViewDetailsPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE]: 'assetsAppAnalyticsDataViewListPage',
    [$85c827d4cf4c7c38$export$4116f3d0d9d6bed7.ASSETS_APP_FOR_YOU_PAGE]: 'assetsAppForYouPage'
};
const $85c827d4cf4c7c38$export$f31a652635bd75fe = (appName)=>$85c827d4cf4c7c38$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("7b25q", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentAiAnswersSkeleton", () => $bce0a78f2a17a140$export$5fe1280883d32350);
/* VirtualAgentAiAnswersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $2jCgZ = parcelRequire("2jCgZ");
const $bce0a78f2a17a140$var$customCssStyles = null;
const $bce0a78f2a17a140$export$5fe1280883d32350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2jCgZ))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("6umqd", function(module, exports) {
$parcel$export(module.exports, "AppSkeletonImage", () => $6fd9b34505fd2b50$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $ft2u5 = parcelRequire("ft2u5");


var $lRq8t = parcelRequire("lRq8t");

var $kGbze = parcelRequire("kGbze");
const $6fd9b34505fd2b50$var$skeletonImageStyles = null;
const $6fd9b34505fd2b50$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $eJOHy.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6fd9b34505fd2b50$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $kGbze.default).loading)}...`,
        className: (0, $hcewu.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ft2u5.FallbackIndicator), null));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6fd9b34505fd2b50$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kGbze", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c19230ed94f1839$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8c19230ed94f1839$var$messages = (0, $7qGN1.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});
var $8c19230ed94f1839$export$2e2bcd8739ae039 = $8c19230ed94f1839$var$messages;

});


parcelRegister("2jCgZ", function(module, exports) {
module.exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();

});


parcelRegister("c6t96", function(module, exports) {
$parcel$export(module.exports, "aiAnswersEntryPoint", () => $f7deb369b3c292ad$export$5dcf9a7e1076ac6);

var $7RTNb = parcelRequire("7RTNb");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $f7deb369b3c292ad$export$5dcf9a7e1076ac6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("WENb2")), {
        moduleId: "ff1963f0",
        moduleName: "VirtualAgentAiAnswers",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $7RTNb.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("7RTNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0551b42d4116744b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2702878b66a66141a19c05889ae86fb>>
 * @relayHash 2d278c9e0c75c6d425a9db309679ce31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd9c0ac98e0e793b9900a96bdf07bf556f39d1a3575aa76e35a52d59f1a352a2

var $bXR9c = parcelRequire("bXR9c");

var $37Ewn = parcelRequire("37Ewn");
const $0551b42d4116744b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v2 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "VirtualAgentAiAnswersSrcQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "virtualAgentConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "VirtualAgentAiAnswers731BadPattern"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "VirtualAgentAiAnswers"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "VirtualAgentAiAnswers165BadPattern"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "virtualAgent.virtualAgentEntitlements"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "virtualAgent"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "VirtualAgentAiAnswersSrcQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAiResponsesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultJiraRequestTypeId"
                                                }
                                            ],
                                            "type": "VirtualAgentConfiguration"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v4 /*: any*/ ,
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                }
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bd9c0ac98e0e793b9900a96bdf07bf556f39d1a3575aa76e35a52d59f1a352a2",
            "metadata": {},
            "name": "VirtualAgentAiAnswersSrcQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
            }
        }
    };
}();
$0551b42d4116744b$var$node.hash = "434025d17175bad10ebc38027af48a42";
(0, $37Ewn.PreloadableQueryRegistry).set($0551b42d4116744b$var$node.params.id, $0551b42d4116744b$var$node);
var $0551b42d4116744b$export$2e2bcd8739ae039 = $0551b42d4116744b$var$node;

});

parcelRegister("WENb2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cTfQX").then(()=>parcelRequire('5ATSG'));

});


parcelRegister("cAYFR", function(module, exports) {
$parcel$export(module.exports, "FedRAMPFallbackRedirectToProjectSettings", () => $3d6eb1ca1636e510$export$3b12aad1f47d85f8);

var $1DBt0 = parcelRequire("1DBt0");
const $3d6eb1ca1636e510$export$3b12aad1f47d85f8 = (0, $1DBt0.defaultRedirectForSettings)((0, $1DBt0.SERVICE_DESK_PRODUCT));

});
parcelRegister("1DBt0", function(module, exports) {
$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $d050639f5e7918b5$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $d050639f5e7918b5$export$c9b0516439c55d7a);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $d050639f5e7918b5$export$5575497f0592ee94 = 'servicedesk';
const $d050639f5e7918b5$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});



parcelRegister("1R3CQ", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateRouteEntry", () => $989e17b5b9ded44a$export$71ab6d11c27a9714);
// softwareBoardRouteEntry.tsx

var $6xToB = parcelRequire("6xToB");

var $gYgtG = parcelRequire("gYgtG");

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $lyOXX = parcelRequire("lyOXX");

var $667UM = parcelRequire("667UM");
const $989e17b5b9ded44a$var$AIFCEmbedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $lyOXX.aiFirstCreateEntryPoint)
});
const $989e17b5b9ded44a$export$71ab6d11c27a9714 = (0, $6xToB.createEntry)(// baseRoute refers to the static route definition above
(0, $gYgtG.aiFirstCreateRoute), ()=>({
        group: 'aifc',
        layout: (0, $7K5Ea.chromelessLayout),
        entryPoint: ()=>$989e17b5b9ded44a$var$AIFCEmbedPageEntryPoint,
        resources: [
            (0, $667UM.aiFirstCreateResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-ai-first-create-entries/src/aiFirstCreateRouteEntry.tsx',
                whichExportToUse: 'aiFirstCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gYgtG", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateRoute", () => $2d5e99580b83df2c$export$26b67ee2546d8cb5);
const $2d5e99580b83df2c$export$26b67ee2546d8cb5 = {
    name: 'ai-first-create-embed',
    path: '/jira/ai-first-create/embed',
    exact: true,
    query: [
        'projectKey?',
        'action?'
    ]
};

});

parcelRegister("7K5Ea", function(module, exports) {
$parcel$export(module.exports, "chromelessLayout", () => $4e04f7c98ccdcac5$export$17e73ed8c35891cb);

var $6dwgv = parcelRequire("6dwgv");
const $4e04f7c98ccdcac5$export$17e73ed8c35891cb = (0, $6dwgv.createLayout)({
    isChromeless: true
});

});

parcelRegister("lyOXX", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateEntryPoint", () => $a546645f99e32bb6$export$fa2e9ac39dfac6e1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a546645f99e32bb6$export$fa2e9ac39dfac6e1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9tPwL")), {
        moduleId: "6a15db65",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9tPwL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("WYIXX").then(()=>parcelRequire('9K9Yj'));

});


parcelRegister("667UM", function(module, exports) {
$parcel$export(module.exports, "aiFirstCreateResource", () => $db8ed2352e19fd68$export$bd331d97cac8d22f);
$parcel$export(module.exports, "useAIFirstCreateResource", () => $db8ed2352e19fd68$export$1bd7204011937813);

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $fcQiO = parcelRequire("fcQiO");

const $db8ed2352e19fd68$var$RESOURCE_TYPE_AI_FIRST_CREATE_FIELDS = 'AI_FIRST_CREATE_FIELDS';
const $db8ed2352e19fd68$var$getAIFirstCreateResource = async (projectId)=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: (0, $55987de775be8333$export$2b91517d6d5b4365),
                variables: {
                    projectId: projectId,
                    withNumberFormat: true,
                    issueType: null
                }
            })
        });
        return response;
    } catch (error) {
        return undefined;
    }
};
const $db8ed2352e19fd68$export$bd331d97cac8d22f = (0, $l1VxS.createResource)({
    type: $db8ed2352e19fd68$var$RESOURCE_TYPE_AI_FIRST_CREATE_FIELDS,
    getKey: ({ query: query })=>`${$db8ed2352e19fd68$var$RESOURCE_TYPE_AI_FIRST_CREATE_FIELDS}:${query.projectKey}`,
    getData: async ({ match: match }, _storeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(match);
        if (!projectKeyOrId) return undefined;
        return $db8ed2352e19fd68$var$getAIFirstCreateResource(projectKeyOrId);
    },
    isBrowserOnly: true,
    isCritical: true,
    maxAge: 0,
    maxCache: 0
});
const $db8ed2352e19fd68$export$1bd7204011937813 = ()=>(0, $eJrcF.useResource)($db8ed2352e19fd68$export$bd331d97cac8d22f);

});
const $55987de775be8333$export$2b91517d6d5b4365 = `
query AIFirstCreateFields($project: JiraProjectInput, $issueType: JiraIssueTypeInput, $issueTypes: String, $requestTypes: String, $withNumberFormat: Boolean!) {
  jiraIssueCreateFields(
    fieldsFilter: USER_CONFIGURED_FIELDS
    project: $project
    issueType: $issueType
  ) {
    ... on JiraIssueCreateFields {
      fields {
        nodes {
          ...BaseFieldFragment
          ...ProjectFieldFragmentWithoutClassification
          ...IssueTypeFieldSearchFragment
          ...RequestTypeFieldSearchFragment
          ...TextFieldFragment
          ...RichTextFieldFragment
          ...ComponentsFieldFragment
          ...VersionFieldFragment
          ...MultiVersionFieldFragment
          ...PriorityFieldFragment
          ...SprintFieldFragment
          ...LabelWithColorFieldFragment
          ...SingleUserPickerFieldFragment
          ...MultiUserPickerFieldFragment
          ...PeopleFieldFragment
          ...SecurityFieldFragment
          ...IssueRestrictionFieldFragment
          ...ColorFieldFragment
          ...ResolutionFieldFragment
          ...SingleSelectFieldFragment
          ...MultiSelectFieldFragment
          ...NumberFieldFragment
          ...UrlFieldFragment
          ...EpicLinkFieldFragment
          ...DatePickerFieldFragment
          ...DateTimePickerFieldFragment
          ...CascadingSelectFieldFragment
          ...AttachmentsFieldFragment
          ...CheckboxFieldFragment
          ...SingleGroupPickerFieldFragment
          ...MultiGroupPickerFieldFragment
          ...TeamFieldFragment
          ...AtlassianTeamFieldFragment
          ...RadioSelectFieldFragment
          ...AffectedServicesFieldFragment
          ...CMDBFieldFragment
          ...OrganizationsFieldFragment
          ...ConnectTextFieldFragment
          ...ConnectNumberFieldFragment
          ...ConnectSingleSelectFieldFragment
          ...ConnectMultiSelectFieldFragment
          ...ConnectRichTextFieldFragment
          ...AssetFieldFragment
          ...ForgeStringFieldFragment
          ...ForgeNumberFieldFragment
          ...ForgeSingleUserPickerFieldFragment
          ...ForgeMultiUserPickerFieldFragment
          ...ForgeGroupPickerFieldFragment
          ...ForgeMultiGroupPickerFieldFragment
          ...ForgeStringsFieldFragment
          ...ForgeObjectFieldFragment
          ...ForgeDateTimePickerFieldFragment
          ...TimeTrackingFieldFragment
          ...WorkLogFieldFragment
          ...JsmMultiUserPickerFieldFragment
          ...JsmPeopleFieldFragment
          ...ParentLinkFieldFragment
          ...DataClassificationFieldFragmentWithOrgDefault
          ...ParentFieldFragment
          ...StatusFieldFragment
          __typename
        }
        __typename
      }
      errors {
        identifier
        extensions {
          ... on JiraIssueFieldUnsupportedErrorExtension {
            fieldName
            fieldType
            isRequiredField
            __typename
          }
          ... on JiraIssueFieldValueValidationErrorExtension {
            errorType
            message
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    ... on QueryError {
      message
      __typename
    }
    __typename
  }
}

fragment BaseFieldFragment on JiraIssueField {
  fieldId
  name
  type
  description
  ... on JiraIssueFieldConfiguration {
    fieldConfig {
      isRequired
      isEditable
      nonEditableReason {
        message
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment ProjectFieldFragmentWithoutClassification on JiraProjectField {
  project {
    ...Project
    __typename
  }
  searchUrl
  __typename
}

fragment Project on JiraProject {
  id: projectId
  name
  avatar {
    large
    __typename
  }
  projectType
  simplified
  key
  __typename
}

fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
  issueType {
    ...IssueType
    __typename
  }
  issueTypes(searchBy: $issueTypes) {
    nodes {
      ...IssueType
      __typename
    }
    __typename
  }
  __typename
}

fragment IssueType on JiraIssueType {
  id: issueTypeId
  name
  avatar {
    large
    __typename
  }
  __typename
}

fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
  requestType {
    ...RequestType
    __typename
  }
  requestTypes(searchBy: $requestTypes) {
    nodes {
      ...RequestType
      __typename
    }
    __typename
  }
  __typename
}

fragment RequestType on JsmRequestType {
  requestTypeId
  name
  description
  helpText
  key
  issueType {
    issueTypeId
    __typename
  }
  avatar {
    large
    __typename
  }
  practices {
    key
    __typename
  }
  __typename
}

fragment TextFieldFragment on JiraSingleLineTextField {
  text
  __typename
}

fragment RichTextFieldFragment on JiraRichTextField {
  richText {
    plainText
    adfValue {
      json
      __typename
    }
    __typename
  }
  renderer
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  ...JiraAdminRichTextFieldConfigFragment
  __typename
}

fragment JiraMediaContextFragment on JiraMediaContext {
  uploadToken {
    ... on JiraMediaUploadToken {
      endpointUrl
      clientId
      targetCollection
      token
      tokenDurationInMin
      __typename
    }
    ... on QueryError {
      message
      __typename
    }
    __typename
  }
  __typename
}

fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
  adminRichTextConfig {
    aiEnabledByProject
    __typename
  }
  __typename
}

fragment ComponentsFieldFragment on JiraComponentsField {
  selectedComponents {
    ...Component
    __typename
  }
  components {
    nodes {
      ...Component
      __typename
    }
    __typename
  }
  __typename
}

fragment Component on JiraComponent {
  id: componentId
  name
  __typename
}

fragment VersionFieldFragment on JiraSingleVersionPickerField {
  version {
    ...Version
    __typename
  }
  versions {
    nodes {
      ...Version
      __typename
    }
    __typename
  }
  __typename
}

fragment Version on JiraVersion {
  id: versionId
  name
  status
  __typename
}

fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
  selectedVersions {
    ...Version
    __typename
  }
  versions {
    nodes {
      ...Version
      __typename
    }
    __typename
  }
  __typename
}

fragment PriorityFieldFragment on JiraPriorityField {
  priority {
    ...Priority
    __typename
  }
  priorities {
    nodes {
      ...Priority
      __typename
    }
    __typename
  }
  __typename
}

fragment Priority on JiraPriority {
  name
  id: priorityId
  iconUrl
  __typename
}

fragment SprintFieldFragment on JiraSprintField {
  selectedSprints {
    ...Sprint
    __typename
  }
  searchUrl
  __typename
}

fragment Sprint on JiraSprint {
  sprintId
  name
  state
  __typename
}

fragment LabelWithColorFieldFragment on JiraLabelsField {
  selectedLabels {
    ...LabelWithColor
    __typename
  }
  searchUrl
  __typename
}

fragment LabelWithColor on JiraLabel {
  id: labelId
  name
  color {
    colorKey
    __typename
  }
  __typename
}

fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
  user {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment UserFragment on User {
  accountId
  name
  picture
  __typename
}

fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment SecurityFieldFragment on JiraSecurityLevelField {
  securityLevel {
    ...SecurityLevel
    __typename
  }
  securityLevels {
    nodes {
      ...SecurityLevel
      __typename
    }
    __typename
  }
  __typename
}

fragment SecurityLevel on JiraSecurityLevel {
  id: securityId
  name
  description
  __typename
}

fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
  selectedRoles {
    ...UserRoles
    __typename
  }
  __typename
}

fragment UserRoles on JiraRole {
  roleId
  __typename
}

fragment ColorFieldFragment on JiraColorField {
  color {
    colorKey
    __typename
  }
  __typename
}

fragment ResolutionFieldFragment on JiraResolutionField {
  resolution {
    ...Resolution
    __typename
  }
  resolutions {
    nodes {
      ...Resolution
      __typename
    }
    __typename
  }
  __typename
}

fragment Resolution on JiraResolution {
  name
  id: resolutionId
  __typename
}

fragment SingleSelectFieldFragment on JiraSingleSelectField {
  fieldOption {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment Option on JiraOption {
  id: optionId
  value
  __typename
}

fragment MultiSelectFieldFragment on JiraMultipleSelectField {
  selectedFieldOptions {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  searchUrl
  __typename
}

fragment NumberFieldFragment on JiraNumberField {
  number
  formatConfig @include(if: $withNumberFormat) {
    formatStyle
    formatUnit
    formatDecimals
    __typename
  }
  __typename
}

fragment UrlFieldFragment on JiraUrlField {
  url
  __typename
}

fragment EpicLinkFieldFragment on JiraEpicLinkField {
  epic {
    ...Epic
    __typename
  }
  searchUrl
  __typename
}

fragment Epic on JiraEpic {
  name
  key
  summary
  __typename
}

fragment DatePickerFieldFragment on JiraDatePickerField {
  date
  __typename
}

fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
  dateTime
  __typename
}

fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
  cascadingOption {
    parentOptionValue {
      ...Option
      __typename
    }
    childOptionValue {
      ...Option
      __typename
    }
    __typename
  }
  cascadingOptions {
    nodes {
      parentOptionValue {
        ...Option
        __typename
      }
      childOptionValues {
        ...Option
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment AttachmentsFieldFragment on JiraAttachmentsField {
  maxAllowedTotalAttachmentsSize
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  __typename
}

fragment CheckboxFieldFragment on JiraCheckboxesField {
  selectedFieldOptions {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
  selectedGroup {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment Group on JiraGroup {
  groupId
  name
  __typename
}

fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
  selectedGroups {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment PeopleFieldFragment on JiraPeopleField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  isMulti
  __typename
}

fragment TeamFieldFragment on JiraTeamField {
  selectedTeam {
    ...Team
    __typename
  }
  searchUrl
  __typename
}

fragment Team on JiraTeam {
  name
  teamId
  __typename
}

fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
  JiraAtlassianTeamField: selectedTeam {
    ...AtlassianTeam
    __typename
  }
  searchUrl
  __typename
}

fragment AtlassianTeam on JiraAtlassianTeam {
  name
  teamId
  avatar {
    small
    __typename
  }
  __typename
}

fragment RadioSelectFieldFragment on JiraRadioSelectField {
  selectedOption {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
  selectedAffectedServices {
    ...AffectedService
    __typename
  }
  searchUrl
  __typename
}

fragment AffectedService on JiraAffectedService {
  serviceId
  __typename
}

fragment CMDBFieldFragment on JiraCMDBField {
  searchUrl
  isMulti
  attributesIncludedInAutoCompleteSearch
  selectedCmdbObjects {
    id
    objectId
    workspaceId
    label
    __typename
  }
  __typename
}

fragment OrganizationsFieldFragment on JsmOrganizationField {
  selectedOrganizations {
    ...Organization
    __typename
  }
  searchUrl
  __typename
}

fragment Organization on JsmOrganization {
  organizationId
  organizationName
  domain
  __typename
}

fragment ConnectTextFieldFragment on JiraConnectTextField {
  text
  __typename
}

fragment ConnectNumberFieldFragment on JiraConnectNumberField {
  number
  __typename
}

fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
  fieldOption {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
  selectedFieldOptions {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
  richText {
    plainText
    adfValue {
      json
      __typename
    }
    __typename
  }
  renderer
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  __typename
}

fragment AssetFieldFragment on JiraAssetField {
  selectedAssets {
    ...Asset
    __typename
  }
  searchUrl
  __typename
}

fragment Asset on JiraAsset {
  serializedOrigin
  appKey
  originId
  value
  __typename
}

fragment ForgeStringFieldFragment on JiraForgeStringField {
  text
  __typename
}

fragment ForgeNumberFieldFragment on JiraForgeNumberField {
  number
  __typename
}

fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
  user {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
  selectedGroup {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
  selectedGroups {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeStringsFieldFragment on JiraForgeStringsField {
  selectedLabels {
    ...Label
    __typename
  }
  searchUrl
  __typename
}

fragment Label on JiraLabel {
  id: labelId
  name
  __typename
}

fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
  dateTime
  __typename
}

fragment ForgeObjectFieldFragment on JiraForgeObjectField {
  object
  __typename
}

fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
  timeTrackingSettings {
    workingDaysPerWeek
    workingHoursPerDay
    defaultFormat
    defaultUnit
    isJiraConfiguredTimeTrackingEnabled
    __typename
  }
  originalEstimate {
    timeInSeconds
    __typename
  }
  __typename
}

fragment WorkLogFieldFragment on JiraWorkLogField {
  timeTrackingSettings {
    workingDaysPerWeek
    workingHoursPerDay
    defaultFormat
    defaultUnit
    isJiraConfiguredTimeTrackingEnabled
    __typename
  }
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  __typename
}

fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment JsmPeopleFieldFragment on JsmPeopleField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  isMulti
  __typename
}

fragment ParentLinkFieldFragment on JiraParentIssueField {
  searchUrl
  parentIssue {
    ...Issue
    __typename
  }
  __typename
}

fragment Issue on JiraIssue {
  key
  issueId
  avatar {
    large
    __typename
  }
  __typename
}

fragment ParentFieldFragment on JiraParentIssueField {
  parentIssue {
    ...ParentIssue
    __typename
  }
  __typename
}

fragment ParentIssue on JiraIssue {
  key
  issueId
  avatar {
    large
    __typename
  }
  issueColorField {
    color {
      colorKey
      __typename
    }
    __typename
  }
  fieldsById(ids: ["summary", "issuetype"]) {
    edges {
      node {
        ... on JiraSingleLineTextField {
          text
          __typename
        }
        ... on JiraIssueTypeField {
          issueType {
            name
            avatar {
              xsmall
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment StatusFieldFragment on JiraStatusField {
  name
  description
  aliasFieldId
  __typename
}

fragment DataClassificationFieldFragmentWithOrgDefault on JiraDataClassificationField {
  classificationLevel {
    ...ClassificationLevel
    __typename
  }
  defaultClassificationLevel {
    ...ClassificationLevel
    __typename
  }
  organizationClassificationLevel {
    ...ClassificationLevel
    __typename
  }
  classificationLevels(
    filterByCriteria: {filterByStatus: [PUBLISHED], filterByType: [USER]}
  ) {
    edges {
      node {
        ...ClassificationLevel
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment ClassificationLevel on JiraClassificationLevel {
  id
  name
  color {
    colorKey
    __typename
  }
  definition
  status
  __typename
}
`;



parcelRegister("4eOkX", function(module, exports) {
$parcel$export(module.exports, "alertPoliciesRouteEntry", () => $c8e4371804662a65$export$eb1e2324ca2031e2);

var $8rb87 = parcelRequire("8rb87");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $foqWb = parcelRequire("foqWb");

var $fIZNm = parcelRequire("fIZNm");
const $c8e4371804662a65$export$eb1e2324ca2031e2 = (0, $6xToB.createEntry)((0, $foqWb.alertPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $fIZNm.AlertPoliciesComponent),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $8rb87.resources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fIZNm.LazyAlertPolicies),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-policies-entries/src/alertPoliciesRouteEntry.tsx',
                whichExportToUse: 'alertPoliciesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8rb87", function(module, exports) {
$parcel$export(module.exports, "teamPolicyResource", () => $93c8fb6a9ec29e8b$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $93c8fb6a9ec29e8b$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $93c8fb6a9ec29e8b$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $93c8fb6a9ec29e8b$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $eXY0W = parcelRequire("eXY0W");
const $93c8fb6a9ec29e8b$export$10d7fa513f08ef83 = (0, $l1VxS.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $eXY0W.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $93c8fb6a9ec29e8b$export$6d5f23d9118ad678 = (0, $l1VxS.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $eXY0W.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $93c8fb6a9ec29e8b$export$7aed80da979a5112 = (0, $l1VxS.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $eXY0W.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $93c8fb6a9ec29e8b$export$4cb385c2db8b1e99 = (0, $l1VxS.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $eXY0W.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $93c8fb6a9ec29e8b$export$bc99aaabaf7b70a7 = ()=>[
        $93c8fb6a9ec29e8b$export$10d7fa513f08ef83,
        $93c8fb6a9ec29e8b$export$7aed80da979a5112,
        $93c8fb6a9ec29e8b$export$4cb385c2db8b1e99,
        $93c8fb6a9ec29e8b$export$6d5f23d9118ad678
    ];

});
parcelRegister("eXY0W", function(module, exports) {
$parcel$export(module.exports, "getTeamPolicies", () => $35ce8cdcfaa505d6$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $35ce8cdcfaa505d6$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $35ce8cdcfaa505d6$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $35ce8cdcfaa505d6$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $35ce8cdcfaa505d6$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $35ce8cdcfaa505d6$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $35ce8cdcfaa505d6$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $35ce8cdcfaa505d6$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $35ce8cdcfaa505d6$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $35ce8cdcfaa505d6$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $35ce8cdcfaa505d6$export$8eabce250a2dd205);

var $9ppkU = parcelRequire("9ppkU");
const $35ce8cdcfaa505d6$export$fead0944caa1c797 = (teamId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $35ce8cdcfaa505d6$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $9ppkU.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $9ppkU.eocFetch)(`/v1/alerts/policies`);
};
const $35ce8cdcfaa505d6$export$342525d9423e55ad = (teamId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $35ce8cdcfaa505d6$export$f630cbf5586dce0a = ()=>{
    return (0, $9ppkU.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $35ce8cdcfaa505d6$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $9ppkU.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $35ce8cdcfaa505d6$export$57186d786c96b52a = (payload)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $35ce8cdcfaa505d6$export$6fecd226d8e55346 = (payload)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $35ce8cdcfaa505d6$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $35ce8cdcfaa505d6$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $35ce8cdcfaa505d6$export$b0108c51b962e788 = (payload)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $35ce8cdcfaa505d6$export$8eabce250a2dd205 = (payload)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("dEcKp", function(module, exports) {
$parcel$export(module.exports, "teamResource", () => $16f66425f6563dbc$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $16f66425f6563dbc$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $16f66425f6563dbc$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $klugx = parcelRequire("klugx");
const $16f66425f6563dbc$export$87453d709b90ccdf = (0, $l1VxS.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $klugx.getTeamByIdEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $16f66425f6563dbc$export$3b3b9a5b0eddde66 = (0, $l1VxS.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $klugx.getSidebarRightsEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $16f66425f6563dbc$export$bc99aaabaf7b70a7 = ()=>[
        $16f66425f6563dbc$export$87453d709b90ccdf,
        $16f66425f6563dbc$export$3b3b9a5b0eddde66
    ];

});
parcelRegister("klugx", function(module, exports) {
$parcel$export(module.exports, "getTeamByIdEndpoint", () => $2afb46d9e52381c2$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $2afb46d9e52381c2$export$6f1f62156c62eb91);

var $9ppkU = parcelRequire("9ppkU");
const $2afb46d9e52381c2$export$bcb25b347f39b3f3 = (teamId)=>(0, $9ppkU.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $2afb46d9e52381c2$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("c1Kop", function(module, exports) {
$parcel$export(module.exports, "LazyTeamDashboardSidebar", () => $4a26c3dc042851d2$export$a1b7c53ff39475a6);
$parcel$export(module.exports, "default", () => $4a26c3dc042851d2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $4a26c3dc042851d2$export$a1b7c53ff39475a6 = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("8Qb3J")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $4a26c3dc042851d2$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4a26c3dc042851d2$export$a1b7c53ff39475a6, null));
$4a26c3dc042851d2$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $4a26c3dc042851d2$export$2e2bcd8739ae039 = $4a26c3dc042851d2$var$TeamDashboardSidebar;

});
parcelRegister("8Qb3J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bboUq")
]).then(()=>parcelRequire('5LuJb'));

});


parcelRegister("GnSwp", function(module, exports) {
$parcel$export(module.exports, "LazyHorizontalOperationsNav", () => $ec25041ec319e5b9$export$409c821653bbc63b);
$parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", () => $ec25041ec319e5b9$export$82108adf6887e32e);
$parcel$export(module.exports, "AsyncHorizontalOperationsNav", () => $ec25041ec319e5b9$export$1eb785f071697cc5);
$parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", () => $ec25041ec319e5b9$export$27e50c09ebb514f);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $ec25041ec319e5b9$export$409c821653bbc63b = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hpZyt")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});

const $ec25041ec319e5b9$export$82108adf6887e32e = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hpZyt")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});
const $ec25041ec319e5b9$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec25041ec319e5b9$export$409c821653bbc63b, null)));
const $ec25041ec319e5b9$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec25041ec319e5b9$export$82108adf6887e32e, null)));

});
parcelRegister("hpZyt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("zjABI").then(()=>parcelRequire('52F2e'));

});


parcelRegister("igwPu", function(module, exports) {
$parcel$export(module.exports, "opsTeamLayout", () => $7ca1ff23f01b3063$export$53dd27149810df73);

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ca1ff23f01b3063$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("QWtmw")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ca1ff23f01b3063$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("53sqf")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $7ca1ff23f01b3063$export$53dd27149810df73 = (0, $6dwgv.createLayout)({
    get globalComponents () {
        return [
            $7ca1ff23f01b3063$var$Onboarding
        ];
    },
    rightSidebars: [
        $7ca1ff23f01b3063$var$RightSidebars
    ]
});

});
parcelRegister("QWtmw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Hzot").then(()=>parcelRequire('8Yee7'));

});

parcelRegister("53sqf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("wl2zH").then(()=>parcelRequire('1xWR7'));

});


parcelRegister("foqWb", function(module, exports) {
$parcel$export(module.exports, "alertPoliciesRoute", () => $6e93536b27e73219$export$eab7ea9e54b67f16);
const $6e93536b27e73219$export$eab7ea9e54b67f16 = {
    name: 'eoc-team-policies',
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};

});

parcelRegister("fIZNm", function(module, exports) {
$parcel$export(module.exports, "LazyAlertPolicies", () => $3fe39b958e365a8c$export$3079046c31ee50f7);
$parcel$export(module.exports, "AlertPoliciesComponent", () => $3fe39b958e365a8c$export$882bdfb7e45bd440);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3fe39b958e365a8c$export$3079046c31ee50f7 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2d7X0")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $3fe39b958e365a8c$export$882bdfb7e45bd440 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3fe39b958e365a8c$export$3079046c31ee50f7,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });

});
parcelRegister("2d7X0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("99qJc").then(()=>parcelRequire('62BDU'));

});



parcelRegister("iGXDp", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationEditRouteEntry", () => $553281c391405d7c$export$2bedce19ce74cc31);

var $5WMoK = parcelRequire("5WMoK");

var $bEyFu = parcelRequire("bEyFu");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");
const $553281c391405d7c$export$2bedce19ce74cc31 = (0, $6xToB.createEntry)((0, $bEyFu.applinksAdministrationEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-administration',
        component: (0, $bJscI.componentWithFG)('applinks-933-new-applinks-frontend', (0, $5WMoK.default), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4cTDP.fg)('applinks-933-new-applinks-frontend'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-applinks-entries/src/applinksAdministrationEditRouteEntry.tsx',
                whichExportToUse: 'applinksAdministrationEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5WMoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $5890f8a2a0798b1d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cH6Qf = parcelRequire("cH6Qf");

var $4EKqI = parcelRequire("4EKqI");

var $aV23b = parcelRequire("aV23b");

var $jJaSe = parcelRequire("jJaSe");

var $iOvkp = parcelRequire("iOvkp");
const $5890f8a2a0798b1d$var$EditPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "applinks-administration-edit-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOvkp.default), {
        id: props.match.params.applinkId ?? null,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null)));
var $5890f8a2a0798b1d$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($5890f8a2a0798b1d$var$EditPage);

});
parcelRegister("aV23b", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $1d4b19068776b455$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $1d4b19068776b455$export$e9b9096e887386fe);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $5ya7R = parcelRequire("5ya7R");
const $1d4b19068776b455$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $1d4b19068776b455$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($1d4b19068776b455$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ya7R.RedirectToLoginPage), null);
    });

});
parcelRegister("5ya7R", function(module, exports) {
$parcel$export(module.exports, "RedirectToLoginPage", () => $3692ea1fd0794252$export$938182bd3fddc3a8);

var $eJOHy = parcelRequire("eJOHy");

var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");

var $gr8eh = parcelRequire("gr8eh");
const $3692ea1fd0794252$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$3692ea1fd0794252$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $3692ea1fd0794252$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $gCY1z.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $95O7y.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr8eh.default), {
        url: path
    });
};

});
parcelRegister("gr8eh", function(module, exports) {
$parcel$export(module.exports, "default", () => $afdbf783998da05f$export$2e2bcd8739ae039);

var $gRw8I = parcelRequire("gRw8I");
const $afdbf783998da05f$var$FullPageRedirect = ({ url: url })=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};
var $afdbf783998da05f$export$2e2bcd8739ae039 = $afdbf783998da05f$var$FullPageRedirect;

});



parcelRegister("iOvkp", function(module, exports) {
$parcel$export(module.exports, "default", () => $3679c3a616797707$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jJaSe = parcelRequire("jJaSe");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $fiWfm = parcelRequire("fiWfm");
const $3679c3a616797707$export$c2248d8896966a26 = (props)=>{
    const [state, setState] = (0, $eJOHy.useState)({
        applinkStatus: null,
        applinkEditPageData: null,
        isLoading: true
    });
    const doRefreshStatus = (0, $eJOHy.useCallback)(()=>{
        setState((prev)=>({
                ...prev,
                applinkStatus: null
            }));
        if (props.id) (0, $dk6v8.fetchApplinkStatus)(props.id).then((status)=>{
            setState((prev)=>({
                    ...prev,
                    applinkStatus: status
                }));
        }).catch((err)=>{
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.refreshStatus', 'Failed to refresh applink status when requested by the edit form.', maybeError);
        });
    }, [
        props.id
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const loadAllData = async ()=>{
            if (props.id === null) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Edit form was loaded but no applink id was provided');
                setState((prev)=>({
                        ...prev,
                        applinkEditPageData: null,
                        isLoading: false
                    }));
                return;
            }
            setState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            try {
                // Load applink data and status in parallel
                const [applinkData, status] = await Promise.all([
                    (0, $dk6v8.fetchApplink)(props.id),
                    (0, $dk6v8.fetchApplinkStatus)(props.id).catch((err)=>{
                        const maybeError = err instanceof Error ? err : undefined;
                        (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Failed to fetch applink status (as part of initial form load)', maybeError);
                        return null;
                    })
                ]);
                let pageData = null;
                if (applinkData.system) pageData = {
                    kind: 'ERROR',
                    err: 'NOT_EDITABLE'
                };
                else if (applinkData.data.isOAuth2) try {
                    const configInfo = await (0, $dk6v8.getOAuth2ConfigInfo)(applinkData.id);
                    pageData = {
                        kind: 'OAUTH2',
                        applink: applinkData,
                        oauth2ConfigInfo: configInfo
                    };
                } catch (err) {
                    const maybeError = err instanceof Error ? err : undefined;
                    (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Failed to fetch OAuth 2.0 config info (as part of initial form load)', maybeError);
                    pageData = {
                        kind: 'OAUTH2',
                        applink: applinkData,
                        oauth2ConfigInfo: null
                    };
                }
                else pageData = {
                    kind: 'OAUTH1',
                    applink: applinkData
                };
                setState({
                    applinkStatus: status,
                    applinkEditPageData: pageData,
                    isLoading: false
                });
            } catch (err) {
                const maybeError = err instanceof Error ? err : undefined;
                (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.loadAllData', 'Failed to fetch applink data with miscellaneous error (as part of initial form load)', maybeError);
                setState((prev)=>({
                        ...prev,
                        applinkEditPageData: null,
                        isLoading: false
                    }));
            }
        };
        loadAllData();
    }, [
        props.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fiWfm.default), {
        isLoading: state.isLoading,
        data: state.applinkEditPageData,
        status: state.applinkStatus,
        onRequestStatusRefresh: doRefreshStatus
    });
};
var $3679c3a616797707$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($3679c3a616797707$export$c2248d8896966a26);

});
parcelRegister("dk6v8", function(module, exports) {
$parcel$export(module.exports, "fetchApplinks", () => $2f3ebcd049804547$export$7d33a91e6040b0be);
$parcel$export(module.exports, "fetchApplink", () => $2f3ebcd049804547$export$83c7eee86d1c94d8);
$parcel$export(module.exports, "putApplinkOAuthOne3LOProvider", () => $2f3ebcd049804547$export$3dacb27b68ab90a0);
$parcel$export(module.exports, "putApplinkOAuthOne2LOProvider", () => $2f3ebcd049804547$export$5c11b39b43a73f24);
$parcel$export(module.exports, "fetchApplinkStatus", () => $2f3ebcd049804547$export$c2ced85273a49248);
$parcel$export(module.exports, "putApplinkOAuth1Config", () => $2f3ebcd049804547$export$6d608f63c710962a);
$parcel$export(module.exports, "fetchApplinkManifestForUrl", () => $2f3ebcd049804547$export$5c23e2a46ea336ab);
$parcel$export(module.exports, "fetchThisManifest", () => $2f3ebcd049804547$export$48b19736241944be);
$parcel$export(module.exports, "putApplink", () => $2f3ebcd049804547$export$a125e209bab7ab22);
$parcel$export(module.exports, "deleteApplink", () => $2f3ebcd049804547$export$feb8ae153e366f15);
$parcel$export(module.exports, "createOAuth2Applink", () => $2f3ebcd049804547$export$66ba448fdbc72aae);
$parcel$export(module.exports, "updateApplinkV3", () => $2f3ebcd049804547$export$56336a061718f25b);
$parcel$export(module.exports, "getOAuth2ConfigInfo", () => $2f3ebcd049804547$export$5647ab3ff2444637);
$parcel$export(module.exports, "putOAuth2ConfigInfo", () => $2f3ebcd049804547$export$d1898e36341527c0);
$parcel$export(module.exports, "autoConfigureApplinkConsumer", () => $2f3ebcd049804547$export$9e76392093878436);

var $hgi0g = parcelRequire("hgi0g");

var $3ugTQ = parcelRequire("3ugTQ");

var $d6B0e = parcelRequire("d6B0e");
const $2f3ebcd049804547$export$7d33a91e6040b0be = ()=>(0, $hgi0g.default)((0, $d6B0e.APPLINKS_V3_QUERY_URL));
const $2f3ebcd049804547$export$83c7eee86d1c94d8 = (id)=>(0, $hgi0g.default)((0, $d6B0e.APPLINKS_V3_QUERY_SINGULAR_URL)(id));
const $2f3ebcd049804547$var$putApplinkProvider = (id, provider)=>(0, $hgi0g.default)(`/rest/applinks/3.0/applicationlink/${id}/authentication/provider`, {
        method: 'PUT',
        body: JSON.stringify({
            config: {},
            provider: provider
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$3dacb27b68ab90a0 = (id)=>$2f3ebcd049804547$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.OAuthAuthenticationProvider');
const $2f3ebcd049804547$export$5c11b39b43a73f24 = (id)=>$2f3ebcd049804547$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.TwoLeggedOAuthAuthenticationProvider');
const $2f3ebcd049804547$export$c2ced85273a49248 = (id)=>(0, $hgi0g.default)(`/rest/applinks/3.0/status/${id}`);
const $2f3ebcd049804547$export$6d608f63c710962a = (id, oauthStatus)=>(0, $3ugTQ.performPutRequest)(`/rest/applinks/3.0/status/${id}/oauth`, {
        body: JSON.stringify(oauthStatus),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$5c23e2a46ea336ab = (url)=>(0, $hgi0g.default)(`/rest/applinks/3.0/applicationlinkForm/manifest.json?url=${encodeURIComponent(url)}`);
const $2f3ebcd049804547$export$48b19736241944be = ()=>(0, $hgi0g.default)('/rest/applinks/3.0/manifest.json');
const $2f3ebcd049804547$export$a125e209bab7ab22 = (entity)=>(0, $hgi0g.default)('/rest/applinks/3.0/applicationlink', {
        method: 'PUT',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$feb8ae153e366f15 = (id)=>(0, $hgi0g.default)(`/rest/applinks/3.0/applicationlink/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$66ba448fdbc72aae = (entity)=>(0, $hgi0g.default)('/rest/applinks/3.0/applinks', {
        method: 'POST',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$56336a061718f25b = (id, entity)=>(0, $3ugTQ.performPutRequest)(`/rest/applinks/3.0/applinks/${id}`, {
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$5647ab3ff2444637 = (id)=>(0, $hgi0g.default)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$d1898e36341527c0 = (id, config)=>(0, $3ugTQ.performPutRequest)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        body: JSON.stringify(config),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $2f3ebcd049804547$export$9e76392093878436 = (id)=>(0, $hgi0g.default)(`/rest/applinks-oauth/1.0/applicationlink/${id}/authentication/consumer?autoConfigure=true`, {
        method: 'PUT',
        body: JSON.stringify({
            twoLOAllowed: true,
            executingTwoLOUser: null,
            twoLOImpersonationAllowed: false
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });

});
parcelRegister("d6B0e", function(module, exports) {
$parcel$export(module.exports, "THIS_PRODUCT_NAME_STRING", () => $95b0b9f64b46b209$export$cb011d75c76c2448);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_URL", () => $95b0b9f64b46b209$export$cb3573e4866c43b5);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_SINGULAR_URL", () => $95b0b9f64b46b209$export$1f3cdd5be8767e2d);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL_LEGACY", () => $95b0b9f64b46b209$export$2802d3ce755ebd3d);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL", () => $95b0b9f64b46b209$export$4b42a32ba8ad826e);
$parcel$export(module.exports, "APPLINKS_EDIT_PAGE_URL_FOR_ID", () => $95b0b9f64b46b209$export$d55239c5fe633298);
$parcel$export(module.exports, "APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK", () => $95b0b9f64b46b209$export$2b004bc5d3a0b021);
const $95b0b9f64b46b209$export$cb011d75c76c2448 = 'Jira';
const $95b0b9f64b46b209$export$cb3573e4866c43b5 = '/rest/applinks/3.0/applinks?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems';
const $95b0b9f64b46b209$export$1f3cdd5be8767e2d = (id)=>`/rest/applinks/3.0/applinks/${id}?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems`;
const $95b0b9f64b46b209$export$2802d3ce755ebd3d = '/plugins/servlet/applinks/listApplicationLinks';
const $95b0b9f64b46b209$export$4b42a32ba8ad826e = '/jira/settings/applinks';
const $95b0b9f64b46b209$export$d55239c5fe633298 = (id)=>`/jira/settings/applinks/${id}/edit`;
const $95b0b9f64b46b209$export$2b004bc5d3a0b021 = 'com.atlassian.applinks.api.auth.types.ThreeLeggedOAuth2AuthenticationProvider';

});


parcelRegister("fiWfm", function(module, exports) {
$parcel$export(module.exports, "default", () => $b549349dad026c92$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $7ep4S = parcelRequire("7ep4S");

var $6MnLl = parcelRequire("6MnLl");

var $5bY40 = parcelRequire("5bY40");

var $fE5VD = parcelRequire("fE5VD");
var $16YBi = parcelRequire("16YBi");

var $9QgTI = parcelRequire("9QgTI");

var $gHI4w = parcelRequire("gHI4w");

var $bskNA = parcelRequire("bskNA");

var $5vQ2T = parcelRequire("5vQ2T");

var $2pgjF = parcelRequire("2pgjF");

var $lRq8t = parcelRequire("lRq8t");

var $i0t2M = parcelRequire("i0t2M");

var $a4pY2 = parcelRequire("a4pY2");

var $d6B0e = parcelRequire("d6B0e");

var $5k5J5 = parcelRequire("5k5J5");

var $Z7XR9 = parcelRequire("Z7XR9");

var $6ZEHi = parcelRequire("6ZEHi");

var $gowAx = parcelRequire("gowAx");

var $9at1p = parcelRequire("9at1p");

var $3Ex3J = parcelRequire("3Ex3J");

var $eBoKt = parcelRequire("eBoKt");

var $40lC8 = parcelRequire("40lC8");
const $b549349dad026c92$var$styles = {
    applinksPageContents: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f5o3v _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $b549349dad026c92$var$DisplayError = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $b549349dad026c92$var$styles.applinksPageContents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: props.header,
        description: props.description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
            href: "/plugins/servlet/applinks/listApplicationLinks",
            appearance: "primary"
        }, formatMessage((0, $3Ex3J.default).seeAllApplinksButton))
    }));
};
const $b549349dad026c92$var$ApplinksEditPageContents = (props)=>{
    const [errorFlags, setErrorFlags] = (0, $eJOHy.useState)([]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const breadcrumbs = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16YBi.default), {
            onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE5VD.default), {
            text: formatMessage((0, $gowAx.default).applicationLinksTitle),
            key: "Application Links",
            href: (0, $d6B0e.APPLINKS_LIST_PAGE_URL)
        })), [
        formatMessage
    ]);
    const addFlag = (0, $eJOHy.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    const renderStatusError = (0, $eJOHy.useCallback)(()=>{
        if (props.status && !props.status.working) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5k5J5.ErrorStatusSectionMessage), {
            err: props.status.error ? (0, $Z7XR9.ERRORS)[props.status.error.type] : (0, $Z7XR9.ERRORS).UNKNOWN,
            context: props.status
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    }, [
        props.status
    ]);
    const renderContents = (0, $eJOHy.useCallback)(()=>{
        if (props.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            alignInline: "center",
            space: "space.100",
            xcss: $b549349dad026c92$var$styles.applinksPageContents
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null));
        if (props.data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b549349dad026c92$var$DisplayError, {
            header: formatMessage((0, $3Ex3J.default).applinkNotFoundHeader),
            description: formatMessage((0, $3Ex3J.default).applinkNotFoundDescription)
        });
        if (props.data.kind === 'ERROR') {
            props.data.err;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b549349dad026c92$var$DisplayError, {
                header: formatMessage((0, $3Ex3J.default).applinkNotEditableHeader),
                description: formatMessage((0, $9at1p.default).systemLinkDescription)
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            grow: "fill",
            xcss: $b549349dad026c92$var$styles.applinksPageContents
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
            breadcrumbs: breadcrumbs()
        }, formatMessage((0, $3Ex3J.default).editMainTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $3Ex3J.default).securedByMessage, {
            authMethod: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, props.data.applink.data.isOAuth2 ? 'OAuth 2.0' : 'OAuth 1.0')
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default), {
            applicationType: (0, $a4pY2.lookupTypeByTypeId)(props.data.applink.type, false),
            displayUrl: props.data.applink.displayUrl,
            heading: formatMessage((0, $3Ex3J.default).productCardHeader),
            statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ZEHi.StatusLozengeV3), {
                status: props.status
            })
        }), renderStatusError()), props.data.kind === 'OAUTH2' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eBoKt.default), {
            applink: props.data.applink,
            oauth2ConfigInfo: props.data.oauth2ConfigInfo,
            onDisplayError: addFlag,
            onRequestStatusRefresh: props.onRequestStatusRefresh
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40lC8.default), {
            applink: props.data.applink,
            status: props.status,
            onDisplayError: addFlag
        }));
    }, [
        addFlag,
        breadcrumbs,
        formatMessage,
        props.data,
        props.isLoading,
        props.onRequestStatusRefresh,
        props.status,
        renderStatusError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "applinks-administration-edit-page",
        teamName: "olympus",
        packageName: "applinksAdministrationEditPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bskNA.ModalContextProvider), null, renderContents()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.ErrorFlag), {
            id: `flag-${idx}`,
            testId: `applinks-administration.ui.edit.error-flag-${idx}`,
            key: `flag-${idx}`,
            title: formatMessage((0, $3Ex3J.default).errorFlagTitle),
            description: err
        });
    }))));
};
var $b549349dad026c92$export$2e2bcd8739ae039 = $b549349dad026c92$var$ApplinksEditPageContents;

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("gHI4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ff4753a1da78f6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1BWxH = parcelRequire("1BWxH");
const $0ff4753a1da78f6d$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1BWxH.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ff4753a1da78f6d$var$ActionsWrapper, null, actions) : null
    });
var $0ff4753a1da78f6d$export$2e2bcd8739ae039 = $0ff4753a1da78f6d$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ff4753a1da78f6d$var$ActionsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1BWxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4d2cd992b0acc82$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7Ob9A = parcelRequire("7Ob9A");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $d4d2cd992b0acc82$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $d4d2cd992b0acc82$export$2e2bcd8739ae039 = $d4d2cd992b0acc82$var$PageHeader;

});
parcelRegister("7Ob9A", function(module, exports) {
$parcel$export(module.exports, "OuterWrapper", () => $f896c1834f9739ce$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $f896c1834f9739ce$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $f896c1834f9739ce$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $f896c1834f9739ce$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $f896c1834f9739ce$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $f896c1834f9739ce$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $f896c1834f9739ce$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $f896c1834f9739ce$var$truncateStyles = null;
const $f896c1834f9739ce$var$outerStyles = null;
const $f896c1834f9739ce$var$titleStyles = null;
const $f896c1834f9739ce$var$titleWrapperStyles = null;
const $f896c1834f9739ce$var$titleWrapperTruncateStyles = null;
const $f896c1834f9739ce$var$titleContainerStyles = null;
const $f896c1834f9739ce$var$actionStyles = null;
const $f896c1834f9739ce$var$titleContainerTruncateStyles = null;
const $f896c1834f9739ce$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $hcewu.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $f896c1834f9739ce$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f896c1834f9739ce$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("i0t2M", function(module, exports) {
$parcel$export(module.exports, "default", () => $d774d2e7ba6299f2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $806LH = parcelRequire("806LH");
const $d774d2e7ba6299f2$var$styles = {
    productCard: "_2rko12b0 _1h6dmuej _1dqonqa1 _189ee4h9 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $d774d2e7ba6299f2$var$ProductCard = (props)=>{
    const { applicationType: applicationType, displayUrl: displayUrl, heading: heading } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $d774d2e7ba6299f2$var$styles.productCard,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, heading), props.statusLozenge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center"
    }, applicationType.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtle",
        size: "small"
    }, applicationType.name))));
};
var $d774d2e7ba6299f2$export$2e2bcd8739ae039 = $d774d2e7ba6299f2$var$ProductCard;

});

parcelRegister("a4pY2", function(module, exports) {
$parcel$export(module.exports, "TypeIdMap", () => $a3964edb777cd90b$export$7b493295b4541cf7);
$parcel$export(module.exports, "lookupType", () => $a3964edb777cd90b$export$dd5c4190ef79bf3f);
$parcel$export(module.exports, "lookupTypeByTypeId", () => $a3964edb777cd90b$export$2d290ec50c4200c5);
$parcel$export(module.exports, "lookupTypeFromV3Data", () => $a3964edb777cd90b$export$2e1f91665918e370);

var $eJOHy = parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $kcLaf = parcelRequire("kcLaf");
const $a3964edb777cd90b$export$7b493295b4541cf7 = {
    jira: {
        name: 'Jira',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.JiraIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Jira Cloud"
        }),
        category: 'cloud'
    },
    confluence: {
        name: 'Confluence',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ConfluenceIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Confluence Cloud"
        }),
        category: 'cloud'
    },
    'jira-dc': {
        name: 'Jira DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.JiraDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Jira DC"
        }),
        category: 'dc'
    },
    'confluence-dc': {
        name: 'Confluence DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ConfluenceDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Confluence DC"
        }),
        category: 'dc'
    },
    bitbucket: {
        name: 'Bitbucket DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.BitbucketDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Bitbucket DC"
        }),
        category: 'dc'
    },
    bamboo: {
        name: 'Bamboo',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.BambooIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Bamboo"
        }),
        category: 'dc'
    },
    generic: {
        name: 'External Application',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
            label: "External Application"
        }),
        category: 'generic'
    }
};
const $a3964edb777cd90b$export$dd5c4190ef79bf3f = (dcAwareTypeId)=>{
    return $a3964edb777cd90b$export$7b493295b4541cf7[dcAwareTypeId] || $a3964edb777cd90b$export$7b493295b4541cf7.generic;
};
const $a3964edb777cd90b$export$2d290ec50c4200c5 = (typeid, isDataCenter)=>{
    // Handle stash=bitbucket alias
    if (typeid === 'stash') return $a3964edb777cd90b$export$dd5c4190ef79bf3f('bitbucket');
    // Handle DC types
    if ((typeid === 'jira' || typeid === 'confluence') && isDataCenter) return $a3964edb777cd90b$export$dd5c4190ef79bf3f(`${typeid}-dc`);
    return $a3964edb777cd90b$export$dd5c4190ef79bf3f(typeid);
};
const $a3964edb777cd90b$export$2e1f91665918e370 = (link)=>{
    const type = link.type;
    // TODO: We can determine if it's DC, but how?
    // if (link.data.applicationVersion !== undefined) {
    // 	type += '-dc';
    // }
    return $a3964edb777cd90b$export$2d290ec50c4200c5(type, false);
};

});

parcelRegister("5k5J5", function(module, exports) {
$parcel$export(module.exports, "ErrorStatusSectionMessage", () => $8ff087ba427c5909$export$8edf5e699a4a50c7);

var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $esi81 = parcelRequire("esi81");
var $JQPCf = parcelRequire("JQPCf");

var $lRq8t = parcelRequire("lRq8t");

var $a4pY2 = parcelRequire("a4pY2");

var $9at1p = parcelRequire("9at1p");

var $7kBgh = parcelRequire("7kBgh");
const $8ff087ba427c5909$export$8edf5e699a4a50c7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const buildErrorContents = (0, $eJOHy.useCallback)(()=>{
        switch(props.err.type){
            case 'CONNECTION_REFUSED':
                return {
                    title: formatMessage((0, $9at1p.default).connectionRefusedTitle),
                    description: formatMessage((0, $9at1p.default).connectionRefusedDescription, {
                        rpcUrl: props.context.link.rpcUrl,
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks),
                        code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esi81.default), null, chunks)
                    }),
                    action: 'edit'
                };
            case 'UNKNOWN_HOST':
                return {
                    title: formatMessage((0, $9at1p.default).unknownHostTitle),
                    description: formatMessage((0, $9at1p.default).unknownHostDescription, {
                        rpcUrl: props.context.link.rpcUrl,
                        code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esi81.default), null, chunks)
                    }),
                    action: 'edit'
                };
            case 'SSL_UNTRUSTED':
                return {
                    title: formatMessage((0, $9at1p.default).sslUntrustedTitle),
                    description: formatMessage((0, $9at1p.default).sslUntrustedDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'SSL_HOSTNAME_UNMATCHED':
                return {
                    title: formatMessage((0, $9at1p.default).sslHostnameUnmatchedTitle),
                    description: formatMessage((0, $9at1p.default).sslHostnameUnmatchedDescription, {
                        applicationName: props.context.link.name,
                        rpcUrl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esi81.default), null, props.context.link.rpcUrl),
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'SSL_UNMATCHED':
                return {
                    title: formatMessage((0, $9at1p.default).sslUnmatchedTitle),
                    description: formatMessage((0, $9at1p.default).sslUnmatchedDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'OAUTH_PROBLEM':
                return {
                    title: formatMessage((0, $9at1p.default).oauthProblemTitle),
                    description: formatMessage((0, $9at1p.default).oauthProblemDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'OAUTH_TIMESTAMP_REFUSED':
                return {
                    title: formatMessage((0, $9at1p.default).oauthTimestampRefusedTitle),
                    description: formatMessage((0, $9at1p.default).oauthTimestampRefusedDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'OAUTH_SIGNATURE_INVALID':
                return {
                    title: formatMessage((0, $9at1p.default).oauthSignatureInvalidTitle),
                    description: formatMessage((0, $9at1p.default).oauthSignatureInvalidDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'UNEXPECTED_RESPONSE':
                return {
                    title: formatMessage((0, $9at1p.default).unexpectedResponseTitle),
                    description: formatMessage((0, $9at1p.default).unexpectedResponseDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'UNEXPECTED_RESPONSE_STATUS':
                return {
                    title: formatMessage((0, $9at1p.default).unexpectedResponseTitle),
                    description: formatMessage((0, $9at1p.default).unexpectedResponseDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'CREATION_FAILED':
                return {
                    title: formatMessage((0, $9at1p.default).creationFailedTitle),
                    description: formatMessage((0, $9at1p.default).creationFailedDescription)
                };
            case 'CONFIGURATION_INCOMPLETE':
                return {
                    title: formatMessage((0, $9at1p.default).configurationIncompleteTitle),
                    description: formatMessage((0, $9at1p.default).configurationIncompleteDescription)
                };
            case 'IN_PROGRESS':
                return {
                    title: formatMessage((0, $9at1p.default).inProgressTitle),
                    description: formatMessage((0, $9at1p.default).inProgressDescription)
                };
            case 'SUBMISSION_FAILED':
                return {
                    title: formatMessage((0, $9at1p.default).submissionFailedTitle),
                    description: formatMessage((0, $9at1p.default).submissionFailedDescription)
                };
            case 'CONFIGURATION_COMPLETE':
                return {
                    title: formatMessage((0, $9at1p.default).configurationCompleteTitle),
                    description: formatMessage((0, $9at1p.default).configurationCompleteDescription)
                };
            case 'AUTH_LEVEL_MISMATCH':
                return {
                    title: formatMessage((0, $9at1p.default).authLevelMismatchTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7kBgh.default), {
                        status: props.context
                    }),
                    action: 'edit'
                };
            case 'NO_REMOTE_APPLINK':
                return {
                    title: formatMessage((0, $9at1p.default).noRemoteApplinkTitle),
                    description: formatMessage((0, $9at1p.default).noRemoteApplinkDescription, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'INSUFFICIENT_REMOTE_PERMISSION':
            case 'REMOTE_VERSION_INCOMPATIBLE':
                return {
                    title: formatMessage((0, $9at1p.default).remoteVersionIncompatibleTitle),
                    description: formatMessage((0, $9at1p.default).remoteVersionIncompatibleDescription, {
                        applicationName: props.context.link.name,
                        // TODO: Try determine whether the link is DC or not (it doesn't strictly matter, as it'll still say "Confluence", etc)
                        applicationType: (0, $a4pY2.lookupTypeByTypeId)(props.context.link.type, false).name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    })
                };
            case 'NO_OUTGOING_AUTH':
                return {
                    title: formatMessage((0, $9at1p.default).noOutgoingAuthTitle),
                    description: formatMessage((0, $9at1p.default).noOutgoingAuthDescription)
                };
            case 'GENERIC_LINK':
                return {
                    title: formatMessage((0, $9at1p.default).genericLinkTitle),
                    description: formatMessage((0, $9at1p.default).genericLinkDescription)
                };
            case 'NON_ATLASSIAN':
                return {
                    title: formatMessage((0, $9at1p.default).nonAtlassianTitle),
                    description: formatMessage((0, $9at1p.default).nonAtlassianDescription)
                };
            case 'SYSTEM_LINK':
                return {
                    title: formatMessage((0, $9at1p.default).systemLinkTitle),
                    description: formatMessage((0, $9at1p.default).systemLinkDescription)
                };
            case 'AUTH_LEVEL_UNSUPPORTED':
                return {
                    title: formatMessage((0, $9at1p.default).authLevelUnsupportedTitle),
                    description: formatMessage((0, $9at1p.default).authLevelUnsupportedDescription),
                    action: 'edit'
                };
            case 'LEGACY_UPDATE':
                return {
                    title: formatMessage((0, $9at1p.default).legacyUpdateTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).legacyUpdateDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).legacyUpdateDescription2))),
                    action: 'update'
                };
            case 'LEGACY_REMOVAL':
                return {
                    title: formatMessage((0, $9at1p.default).legacyRemovalTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).legacyRemovalDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).legacyRemovalDescription2))),
                    action: 'update'
                };
            case 'MANUAL_LEGACY_UPDATE':
                return {
                    title: formatMessage((0, $9at1p.default).manualLegacyUpdateTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).manualLegacyUpdateDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).manualLegacyUpdateDescription2)))
                };
            case 'MANUAL_LEGACY_REMOVAL':
                return {
                    title: formatMessage((0, $9at1p.default).manualLegacyRemovalTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).manualLegacyRemovalDescription1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).manualLegacyRemovalDescription2, {
                        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                                as: "strong"
                            }, chunks)
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $9at1p.default).manualLegacyRemovalDescription3, {
                        applicationName: props.context.link.name,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.context.link.displayUrl,
                                target: "_blank"
                            }, chunks)
                    }))),
                    action: 'update'
                };
            case 'UNKNOWN':
            default:
                return {
                    title: formatMessage((0, $9at1p.default).unknownTitle),
                    description: formatMessage((0, $9at1p.default).unknownDescription, {
                        applicationName: props.context.link.name,
                        rpcUrl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esi81.default), null, props.context.link.rpcUrl)
                    }),
                    action: 'edit'
                };
        }
    }, [
        props.err,
        props.context,
        formatMessage
    ]);
    const buildActions = (0, $eJOHy.useCallback)(()=>{
        switch(buildErrorContents().action){
            case 'edit':
                // We don't show edit actions on the edit page
                // However when this class is extended to support popups on the list page, we'll show it there
                return [];
            case 'update':
                return [];
            default:
                return [];
        }
    }, [
        buildErrorContents
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        title: buildErrorContents().title,
        actions: buildActions()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, buildErrorContents().description), props.context.error && props.context.error.details && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $JQPCf.default), {
        text: props.context.error.details
    })));
};
var $8ff087ba427c5909$export$2e2bcd8739ae039 = $8ff087ba427c5909$export$8edf5e699a4a50c7;

});
parcelRegister("iHPvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});


var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("esi81", function(module, exports) {
$parcel$export(module.exports, "default", () => $a412e6cbdd328664$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");
const $a412e6cbdd328664$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $a412e6cbdd328664$var$Code = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $gt9Am.jsx)($a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $hcewu.default)([
            $a412e6cbdd328664$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $2E9Su.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($a412e6cbdd328664$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: replacedChildren
    });
}
function $a412e6cbdd328664$var$isReactElement(child) {
    return !!child.type;
}
$a412e6cbdd328664$var$Code.displayName = 'Code';
var $a412e6cbdd328664$export$2e2bcd8739ae039 = $a412e6cbdd328664$var$Code;

});
parcelRegister("hDNIq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ef15aa1302d4294$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $6JdWh = parcelRequire("6JdWh");
function $9ef15aa1302d4294$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        tag: $9ef15aa1302d4294$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $9ef15aa1302d4294$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("6JdWh", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $773f36c924fc369d$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6fs4r = parcelRequire("6fs4r");
const $773f36c924fc369d$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $773f36c924fc369d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $773f36c924fc369d$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("2E9Su", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb505789c157e144$export$2e2bcd8739ae039);
const $fb505789c157e144$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $fb505789c157e144$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($fb505789c157e144$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});


parcelRegister("JQPCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d29b310f5adcbb7$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $eGOwo = parcelRequire("eGOwo");

var $1wVTG = parcelRequire("1wVTG");

var $gvE0s = parcelRequire("gvE0s");

var $2qMvj = parcelRequire("2qMvj");

var $9LvmA = parcelRequire("9LvmA");
const $9d29b310f5adcbb7$var$getCodeBlockStyles = {
    codeFontFlagOn: "_11c81u0j",
    codeFontFlagOff: "_1wyb1crf _k48pi7a9 _ect41odn",
    root: "_2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1j08 _1vbw1j08 _1v9c1j08 _1srn17d7 _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gww7y _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $9d29b310f5adcbb7$var$CodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $eJOHy.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $gvE0s.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $eJOHy.useEffect)(()=>{
        const schedule = (0, $bRPNB.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $1wVTG.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eJOHy.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eJOHy.useMemo)(()=>(0, $2qMvj.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    // https://product-fabric.atlassian.net/browse/DSP-22927
    const useCodeFont = (0, $eGOwo.fg)('platform_dst_code-token');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LvmA.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hcewu.default)([
            useCodeFont ? $9d29b310f5adcbb7$var$getCodeBlockStyles.codeFontFlagOn : $9d29b310f5adcbb7$var$getCodeBlockStyles.codeFontFlagOff,
            $9d29b310f5adcbb7$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $9d29b310f5adcbb7$var$getCodeBlockStyles.shouldWrapLongLines : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $9d29b310f5adcbb7$var$getCodeBlockStyles.showLineNumbers : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $9d29b310f5adcbb7$export$2e2bcd8739ae039 = $9d29b310f5adcbb7$var$CodeBlock;

});
parcelRegister("1wVTG", function(module, exports) {
$parcel$export(module.exports, "useHighlightLines", () => $118a07406fdcc42b$export$84415a200bdf33ed);

var $eJOHy = parcelRequire("eJOHy");
const $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $118a07406fdcc42b$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $118a07406fdcc42b$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eJOHy.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eJOHy.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("gvE0s", function(module, exports) {
$parcel$export(module.exports, "getLineNumWidth", () => $505da49d0d7d5a0b$export$cb7aec0206b595d2);
const $505da49d0d7d5a0b$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("2qMvj", function(module, exports) {
$parcel$export(module.exports, "normalizeLanguage", () => $aca27a94c0d64a9d$export$f38728011c178796);

var $LFmXM = parcelRequire("LFmXM");

var $236Qa = parcelRequire("236Qa");
const $aca27a94c0d64a9d$export$f38728011c178796 = (0, $LFmXM.default)((language)=>{
    if (!language) return '';
    const match = (0, $236Qa.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("236Qa", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $32521280e8fb1b12$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $32521280e8fb1b12$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});


parcelRegister("9LvmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cdbe531236814ef$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $2Csjy = parcelRequire("2Csjy");
var $5cdbe531236814ef$export$2e2bcd8739ae039 = (0, $2Csjy.default);

});
parcelRegister("2Csjy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a371b7eb48e23c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9JmNq = parcelRequire("9JmNq");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $1a371b7eb48e23c4$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $9JmNq.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $1a371b7eb48e23c4$var$asyncGenerator = $1a371b7eb48e23c4$var$generator({
    loader: ()=>(parcelRequire("1WK8s")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $1a371b7eb48e23c4$export$2e2bcd8739ae039 = $1a371b7eb48e23c4$var$asyncGenerator;

});
parcelRegister("9JmNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb3e56997f5681d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $31Mrt = parcelRequire("31Mrt");

var $aRMho = parcelRequire("aRMho");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $bb3e56997f5681d6$var$Highlight = /*#__PURE__*/ (0, $eJOHy.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $31Mrt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $aRMho.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $bb3e56997f5681d6$export$2e2bcd8739ae039 = $bb3e56997f5681d6$var$Highlight;

});
parcelRegister("31Mrt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9006a9331ecad2$export$2e2bcd8739ae039);

var $iWzFr = parcelRequire("iWzFr");

var $8RUxU = parcelRequire("8RUxU");

var $26DGa = parcelRequire("26DGa");

var $f2iL7 = parcelRequire("f2iL7");
const $ad9006a9331ecad2$var$newLineRegex = /\n/g;
function $ad9006a9331ecad2$var$getNewLines(str) {
    return str.match($ad9006a9331ecad2$var$newLineRegex);
}
function $ad9006a9331ecad2$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $f2iL7.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iWzFr.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $26DGa.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $ad9006a9331ecad2$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $8RUxU.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $8RUxU.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iWzFr", function(module, exports) {
$parcel$export(module.exports, "default", () => $4195943504268cef$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");

var $cyPrZ = parcelRequire("cyPrZ");
function $4195943504268cef$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $8RUxU.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $cyPrZ.default)(lineNumber));
            return children;
        }
    };
}
var $4195943504268cef$export$2e2bcd8739ae039 = $4195943504268cef$var$createLineGenerator;

});
parcelRegister("8RUxU", function(module, exports) {
$parcel$export(module.exports, "default", () => $20548ef38714ae82$export$2e2bcd8739ae039);

var $cyPrZ = parcelRequire("cyPrZ");
function $20548ef38714ae82$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("cyPrZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d9e4c0cc14d81b$export$2e2bcd8739ae039);
function $03d9e4c0cc14d81b$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("26DGa", function(module, exports) {
$parcel$export(module.exports, "default", () => $380a054e11b3c43e$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");
function $380a054e11b3c43e$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $8RUxU.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $380a054e11b3c43e$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("f2iL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a951287c386786be$export$2e2bcd8739ae039);
function $a951287c386786be$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("aRMho", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ec570abb3fe649d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $JWUl7 = parcelRequire("JWUl7");
function $9ec570abb3fe649d$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $JWUl7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("JWUl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed639690821efdab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");

var $a4ixf = parcelRequire("a4ixf");
function $ed639690821efdab$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $ed639690821efdab$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $2E9Su.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $a4ixf.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $ed639690821efdab$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("a4ixf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ac4ebb91026fe6$export$2e2bcd8739ae039);

var $JWUl7 = parcelRequire("JWUl7");
function $e0ac4ebb91026fe6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $JWUl7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("1WK8s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5sFLQ").then(()=>parcelRequire('5eKjD'));

});




parcelRegister("9at1p", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb0c6a8ae12c9dc1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eb0c6a8ae12c9dc1$var$messages = (0, $7qGN1.defineMessages)({
    // Actions
    actionEdit: {
        "id": "applinks.administration.ui.common.status.action-edit",
        "defaultMessage": "Edit application link"
    },
    actionUpdate: {
        "id": "applinks.administration.ui.common.status.action-update",
        "defaultMessage": "Update application link"
    },
    // Status lozenges
    incompatibleStatus: {
        "id": "applinks.administration.ui.common.status.incompatible-status",
        "defaultMessage": "Status unavailable"
    },
    nonAtlassianStatus: {
        "id": "applinks.administration.ui.common.status.non-atlassian-status",
        "defaultMessage": "Non-Atlassian"
    },
    systemStatus: {
        "id": "applinks.administration.ui.common.status.system-status",
        "defaultMessage": "System"
    },
    networkErrorStatus: {
        "id": "applinks.administration.ui.common.status.network-error-status",
        "defaultMessage": "Network error"
    },
    creationFailedStatus: {
        "id": "applinks.administration.ui.common.status.creation-failed-status",
        "defaultMessage": "Creation failed"
    },
    configurationIncompleteStatus: {
        "id": "applinks.administration.ui.common.status.configuration-incomplete-status",
        "defaultMessage": "Configuration incomplete"
    },
    inProgressStatus: {
        "id": "applinks.administration.ui.common.status.in-progress-status",
        "defaultMessage": "In progress"
    },
    configurationComplete: {
        "id": "applinks.administration.ui.common.status.configuration-complete-status",
        "defaultMessage": "Configuration complete"
    },
    submissionFailed: {
        "id": "applinks.administration.ui.common.status.submission-failed-status",
        "defaultMessage": "Submission failed"
    },
    accessDeniedStatus: {
        "id": "applinks.administration.ui.common.status.access-denied-status",
        "defaultMessage": "Access denied"
    },
    configErrorStatus: {
        "id": "applinks.administration.ui.common.status.config-error-status",
        "defaultMessage": "Config error"
    },
    deprecatedStatus: {
        "id": "applinks.administration.ui.common.status.deprecated-status",
        "defaultMessage": "Deprecated"
    },
    disabledStatus: {
        "id": "applinks.administration.ui.common.status.disabled-status",
        "defaultMessage": "Disabled"
    },
    connectedStatus: {
        "id": "applinks.administration.ui.common.status.connected-status",
        "defaultMessage": "Connected"
    },
    notConnectedStatus: {
        "id": "applinks.administration.ui.common.status.not-connected-status",
        "defaultMessage": "Not Connected"
    },
    // Auth token missing
    authTokenRequired: {
        "id": "applinks.administration.ui.common.status.auth-token-required-title",
        "defaultMessage": "Authenticate to see status"
    },
    // Connection issues
    connectionRefusedTitle: {
        "id": "applinks.administration.ui.common.status.connection-refused-title",
        "defaultMessage": "The remote application is not responding"
    },
    connectionRefusedDescription: {
        "id": "applinks.administration.ui.common.status.connection-refused-description",
        "defaultMessage": "The connection to <code>{rpcUrl}</code> was refused. <link>{applicationName}</link> may be down or blocked by a firewall. Alternatively, the Application URL for the remote application may be incorrect or may have changed recently."
    },
    unknownHostTitle: {
        "id": "applinks.administration.ui.common.status.unknown-host-title",
        "defaultMessage": "Unable to reach the remote application"
    },
    unknownHostDescription: {
        "id": "applinks.administration.ui.common.status.unknown-host-description",
        "defaultMessage": "We couldn't resolve the hostname at <code>{rpcUrl}</code>. There may be a DNS configuration problem, or the Application URL for the remote application may be incorrect or may have changed recently."
    },
    oauthProblemTitle: {
        "id": "applinks.administration.ui.common.status.oauth-problem-title",
        "defaultMessage": "OAuth problem"
    },
    oauthProblemDescription: {
        "id": "applinks.administration.ui.common.status.oauth-problem-description",
        "defaultMessage": "There is an issue with the OAuth configuration of the connection to <link>{applicationName}</link>."
    },
    oauthTimestampRefusedTitle: {
        "id": "applinks.administration.ui.common.status.oauth-timestamp-refused-title",
        "defaultMessage": "The system clocks are not synchronized"
    },
    oauthTimestampRefusedDescription: {
        "id": "applinks.administration.ui.common.status.oauth-timestamp-refused-description",
        "defaultMessage": "This server has a different system time from <link>{applicationName}</link>, which prevents the applications from authenticating."
    },
    oauthSignatureInvalidTitle: {
        "id": "applinks.administration.ui.common.status.oauth-signature-invalid-title",
        "defaultMessage": "Invalid OAuth signature"
    },
    oauthSignatureInvalidDescription: {
        "id": "applinks.administration.ui.common.status.oauth-signature-invalid-description",
        "defaultMessage": "We couldn't connect to <link>{applicationName}</link>, possibly because that instance is behind a mis-configured proxy."
    },
    unexpectedResponseTitle: {
        "id": "applinks.administration.ui.common.status.unexpected-response-title",
        "defaultMessage": "Unexpected response"
    },
    unexpectedResponseDescription: {
        "id": "applinks.administration.ui.common.status.unexpected-response-description",
        "defaultMessage": "We received an unexpected response from <link>{applicationName}</link>. If the remote application is behind a proxy, check that the application is operational. Troubleshoot this for other possible causes."
    },
    creationFailedTitle: {
        "id": "applinks.administration.ui.common.status.creation-failed-status-title",
        "defaultMessage": "Creation failed"
    },
    creationFailedDescription: {
        "id": "applinks.administration.ui.common.status.creation-failed-status-description",
        "defaultMessage": "This application link failed to create an OAuth 2.0 client. Delete it and create a new one."
    },
    configurationIncompleteTitle: {
        "id": "applinks.administration.ui.common.status.configuration-incomplete-status-title",
        "defaultMessage": "Configuration incomplete"
    },
    configurationIncompleteDescription: {
        "id": "applinks.administration.ui.common.status.configuration-incomplete-status-description",
        "defaultMessage": "This application link is missing a remote client ID and remote client secret. Add these details to complete configuration."
    },
    inProgressTitle: {
        "id": "applinks.administration.ui.common.status.in-progress-status-title",
        "defaultMessage": "In progress"
    },
    inProgressDescription: {
        "id": "applinks.administration.ui.common.status.in-progress-status-description",
        "defaultMessage": "We're still configuring the application link."
    },
    submissionFailedTitle: {
        "id": "applinks.administration.ui.common.status.submission-failed-status-title",
        "defaultMessage": "Submission failed"
    },
    submissionFailedDescription: {
        "id": "applinks.administration.ui.common.status.submission-failed-status-description",
        "defaultMessage": "Resubmit this application link to complete configuration."
    },
    configurationCompleteTitle: {
        "id": "applinks.administration.ui.common.status.configuration-complete-status-title",
        "defaultMessage": "Configuration complete"
    },
    configurationCompleteDescription: {
        "id": "applinks.administration.ui.common.status.configuration-complete-status-description",
        "defaultMessage": "The configuration for your application link is complete. Try using it to confirm that everything works."
    },
    authLevelMismatchTitle: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-title",
        "defaultMessage": "OAuth mismatch"
    },
    authLevelMismatchIncoming: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-incoming",
        "defaultMessage": "incoming"
    },
    authLevelMismatchOutgoing: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-outgoing",
        "defaultMessage": "outgoing"
    },
    authTypeImpersonation: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-impersonation",
        "defaultMessage": "OAuth with impersonation"
    },
    authTypeDisabled: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-disabled",
        "defaultMessage": "Disabled"
    },
    authTypeUnknown: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-unknown",
        "defaultMessage": "Unknown"
    },
    authLevelMismatchUnknownDescription: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-unknown-description",
        "defaultMessage": "We couldn't detect the authentication method for this application link. Make sure both the local and remote connections use the same authentication type."
    },
    authLevelMismatchDisabledOauthDescription: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-disabled-oauth-description",
        "defaultMessage": "The local {direction} connection is disabled, however <link>{applicationName}</link> uses {remoteAuthType}."
    },
    authLevelMismatchOauthOauthDescription: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-oauth-oauth-description",
        "defaultMessage": "The local {direction} connection uses {localAuthType}, however <link>{applicationName}</link> uses {remoteAuthType}."
    },
    authLevelMismatchOauthDisabledDescription: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-oauth-disabled-description",
        "defaultMessage": "The local {direction} connection uses {localAuthType}, however it's disabled on <link>{applicationName}</link>."
    },
    authLevelMismatchSuggestDescription: {
        "id": "applinks.administration.ui.common.status.auth-level-mismatch-suggest-description",
        "defaultMessage": "You'll need to edit each connection to make sure the authentication methods are the same."
    },
    unknownTitle: {
        "id": "applinks.administration.ui.common.status.unknown-title",
        "defaultMessage": "Network error"
    },
    unknownDescription: {
        "id": "applinks.administration.ui.common.status.unknown-description",
        "defaultMessage": "We couldn't connect to {applicationName} at {rpcUrl}. This might have been caused by a network error or another configuration error."
    },
    authLevelUnsupportedTitle: {
        "id": "applinks.administration.ui.common.status.auth-level-unsupported-title",
        "defaultMessage": "Unsupported OAuth level"
    },
    authLevelUnsupportedDescription: {
        "id": "applinks.administration.ui.common.status.auth-level-unsupported-description",
        "defaultMessage": "The current OAuth configuration prevents integrations from working. You need to update your configuration to OAuth or OAuth with impersonation."
    },
    sslUntrustedTitle: {
        "id": "applinks.administration.ui.common.status.ssl-untrusted-title",
        "defaultMessage": "The remote certificate can't be trusted"
    },
    sslUntrustedDescription: {
        "id": "applinks.administration.ui.common.status.ssl-untrusted-description",
        "defaultMessage": "<link>{applicationName}</link> may be using a self-signed SSL certificate or a certificate that was issued by a certificate authority that isn't known locally."
    },
    sslHostnameUnmatchedTitle: {
        "id": "applinks.administration.ui.common.status.ssl-hostname-unmatched-title",
        "defaultMessage": "The remote certificate doesn't match the remote host name"
    },
    sslHostnameUnmatchedDescription: {
        "id": "applinks.administration.ui.common.status.ssl-hostname-unmatched-description",
        "defaultMessage": "The SSL certificate used by <link>{applicationName}</link> can't be trusted because the certificate's host name doesn't match the URL {rpcUrl}."
    },
    sslUnmatchedTitle: {
        "id": "applinks.administration.ui.common.status.ssl-unmatched-title",
        "defaultMessage": "Unable to verify remote certificate details"
    },
    sslUnmatchedDescription: {
        "id": "applinks.administration.ui.common.status.ssl-unmatched-description",
        "defaultMessage": "The SSL certificate used by <link>{applicationName}</link> can't be trusted because details inside the certificate can't be verified. Check that the remote certificate has the correct details."
    },
    systemLinkTitle: {
        "id": "applinks.administration.ui.common.status.system-link-title",
        "defaultMessage": "Internal System Link"
    },
    systemLinkDescription: {
        "id": "applinks.administration.ui.common.status.system-link-description",
        "defaultMessage": "This is an internal link created automatically by the system. System internal links are read-only and cannot be edited."
    },
    genericLinkTitle: {
        "id": "applinks.administration.ui.common.status.generic-link-title",
        "defaultMessage": "Link to external third party"
    },
    genericLinkDescription: {
        "id": "applinks.administration.ui.common.status.generic-link-description",
        "defaultMessage": "This is an application link to an external third party. We are unable to retrieve the status to third parties. If you are experiencing any problems with your connection ensure that your OAuth configuration is correct."
    },
    remoteVersionIncompatibleTitle: {
        "id": "applinks.administration.ui.common.status.remote-version-incompatible-title",
        "defaultMessage": "Unable to retrieve status"
    },
    remoteVersionIncompatibleDescription: {
        "id": "applinks.administration.ui.common.status.remote-version-incompatible-description",
        "defaultMessage": "We're unable to determine the status of this link, because the version of {applicationName} is a little too old. The link may actually be good. You can upgrade <link>{applicationName}</link> to the latest version of {applicationType} to get status and diagnostic capabilities."
    },
    nonAtlassianTitle: {
        "id": "applinks.administration.ui.common.status.non-atlassian-title",
        "defaultMessage": "Link to external third party"
    },
    nonAtlassianDescription: {
        "id": "applinks.administration.ui.common.status.non-atlassian-description",
        "defaultMessage": "This is an application link to an external third party. We are unable to retrieve the status to third parties, so if you are experiencing any problems with your connection reach out to the third party directly."
    },
    noRemoteApplinkTitle: {
        "id": "applinks.administration.ui.common.status.no-remote-applink-title",
        "defaultMessage": "No remote application link"
    },
    noRemoteApplinkDescription: {
        "id": "applinks.administration.ui.common.status.no-remote-applink-description",
        "defaultMessage": "We can't connect with <link>{applicationName}</link>  because a reciprocal application link is missing on that server. You'll need to delete and then re-create this application link."
    },
    noOutgoingAuthTitle: {
        "id": "applinks.administration.ui.common.status.no-outgoing-auth-title",
        "defaultMessage": "No outgoing authentication"
    },
    noOutgoingAuthDescription: {
        "id": "applinks.administration.ui.common.status.no-outgoing-auth-description",
        "defaultMessage": "We can't display the status for this application link, because outgoing authentication is disabled. You can enable outgoing authentication to see the status."
    },
    insufficientRemotePermissionTitle: {
        "id": "applinks.administration.ui.common.status.insufficient-remote-permission-title",
        "defaultMessage": "Access denied"
    },
    insufficientRemotePermission2LOi: {
        "id": "applinks.administration.ui.common.status.insufficient-remote-permission-2loi",
        "defaultMessage": "We couldn't retrieve the status from the remote application because your user account doesn't have admin privileges on {applicationName}."
    },
    insufficientRemotePermission2LOiExt: {
        "id": "applinks.administration.ui.common.status.insufficient-remote-permission-2loi-ext",
        "defaultMessage": "To see the status, ask for admin access for your account on <link>{applicationName}</link>."
    },
    insufficientRemotePermission3Lo: {
        "id": "applinks.administration.ui.common.status.insufficient-remote-permission-3lo",
        "defaultMessage": "We couldn't retrieve the status from the remote application because you don't have admin privileges on {applicationName}."
    },
    insufficientRemotePermission3LoExt: {
        "id": "applinks.administration.ui.common.status.insufficient-remote-permission-3lo-ext",
        "defaultMessage": "To see the status, log out of <link>{applicationName}</link> and then <link2>authenticate</link2> as an admin on {applicationName}."
    },
    legacyUpdateTitle: {
        "id": "applinks.administration.ui.common.status.legacy-update-title",
        "defaultMessage": "Deprecated authentication type"
    },
    legacyUpdateDescription1: {
        "id": "applinks.administration.ui.common.status.legacy-update-description-1",
        "defaultMessage": "This application link uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated."
    },
    legacyUpdateDescription2: {
        "id": "applinks.administration.ui.common.status.legacy-update-description-2",
        "defaultMessage": "You should update this link to use OAuth authentication, the industry standard."
    },
    legacyRemovalTitle: {
        "id": "applinks.administration.ui.common.status.legacy-removal-title",
        "defaultMessage": "Deprecated authentication type"
    },
    legacyRemovalDescription1: {
        "id": "applinks.administration.ui.common.status.legacy-removal-description-1",
        "defaultMessage": "As well as OAuth, this application link still uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated."
    },
    legacyRemovalDescription2: {
        "id": "applinks.administration.ui.common.status.legacy-removal-description-2",
        "defaultMessage": "You should update this link to use OAuth authentication, the industry standard."
    },
    manualLegacyUpdateTitle: {
        "id": "applinks.administration.ui.common.status.manual-legacy-update-title",
        "defaultMessage": "Deprecated authentication type"
    },
    manualLegacyUpdateDescription1: {
        "id": "applinks.administration.ui.common.status.manual-legacy-update-description-1",
        "defaultMessage": "This application link uses either the Trusted Applications or Basic Access authentication type, both of which are deprecated."
    },
    manualLegacyUpdateDescription2: {
        "id": "applinks.administration.ui.common.status.manual-legacy-update-description-2",
        "defaultMessage": "You should manually update this link to use OAuth authentication, the industry standard."
    },
    manualLegacyRemovalTitle: {
        "id": "applinks.administration.ui.common.status.manual-legacy-removal-title",
        "defaultMessage": "Deprecated authentication type"
    },
    manualLegacyRemovalDescription1: {
        "id": "applinks.administration.ui.common.status.manual-legacy-removal-description-1",
        "defaultMessage": "This application link uses a deprecated authentication type."
    },
    manualLegacyRemovalDescription2: {
        "id": "applinks.administration.ui.common.status.manual-legacy-removal-description-2",
        "defaultMessage": "You should click <bold>Update locally</bold> to move to OAuth authentication. Doing this will remove Trusted Applications authentication from this end of the link."
    },
    manualLegacyRemovalDescription3: {
        "id": "applinks.administration.ui.common.status.manual-legacy-removal-description-3",
        "defaultMessage": "You'll then need to manually remove Trusted Applications authentication from the <link>{applicationName}</link> end of the link."
    }
});
var $eb0c6a8ae12c9dc1$export$2e2bcd8739ae039 = $eb0c6a8ae12c9dc1$var$messages;

});

parcelRegister("7kBgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $41bd16eba23e9a09$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $lRq8t = parcelRequire("lRq8t");

var $bgrMr = parcelRequire("bgrMr");

var $9at1p = parcelRequire("9at1p");
const $41bd16eba23e9a09$var$PerDirectionDescription = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const buildDescriptionForMismatchState = (0, $eJOHy.useCallback)((direction)=>{
        const directionString = direction === 'incoming' ? formatMessage((0, $9at1p.default).authLevelMismatchIncoming) : formatMessage((0, $9at1p.default).authLevelMismatchOutgoing);
        switch(props.mismatchState){
            case 'disabled-oauth':
            case 'disabled-impersonation':
                {
                    const remoteAuthTypeString = props.mismatchState === 'disabled-oauth' ? formatMessage((0, $9at1p.default).authTypeDisabled) : formatMessage((0, $9at1p.default).authTypeImpersonation);
                    return formatMessage((0, $9at1p.default).authLevelMismatchDisabledOauthDescription, {
                        direction: directionString,
                        applicationName: props.name,
                        remoteAuthType: remoteAuthTypeString,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.displayUrl,
                                target: "_blank"
                            }, chunks)
                    });
                }
            case 'oauth-disabled':
            case 'impersonation-disabled':
                {
                    const localAuthTypeString = props.mismatchState === 'oauth-disabled' ? 'OAuth' // not translated, technical term
                     : formatMessage((0, $9at1p.default).authTypeImpersonation);
                    return formatMessage((0, $9at1p.default).authLevelMismatchOauthDisabledDescription, {
                        direction: directionString,
                        applicationName: props.name,
                        localAuthType: localAuthTypeString,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.displayUrl,
                                target: "_blank"
                            }, chunks)
                    });
                }
            case 'oauth-impersonation':
            case 'impersonation-oauth':
                {
                    const localAuthTypeString = props.mismatchState === 'oauth-impersonation' ? 'OAuth' // not translated, technical term
                     : formatMessage((0, $9at1p.default).authTypeImpersonation);
                    const remoteAuthTypeString = props.mismatchState === 'oauth-impersonation' ? formatMessage((0, $9at1p.default).authTypeImpersonation) : 'OAuth'; // not translated, technical term
                    return formatMessage((0, $9at1p.default).authLevelMismatchOauthOauthDescription, {
                        direction: directionString,
                        applicationName: props.name,
                        localAuthType: localAuthTypeString,
                        remoteAuthType: remoteAuthTypeString,
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                                href: props.displayUrl,
                                target: "_blank"
                            }, chunks)
                    });
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
        }
    }, [
        formatMessage,
        props.displayUrl,
        props.mismatchState,
        props.name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, buildDescriptionForMismatchState(props.direction));
};
const $41bd16eba23e9a09$var$determineMismatchState = (status, direction)=>{
    const local = (0, $bgrMr.getAuthLevel)(status.localAuthentication?.[direction]);
    const remote = (0, $bgrMr.getAuthLevel)(status.remoteAuthentication?.[direction]);
    if (local === (0, $bgrMr.AUTH_UNKNOWN) || remote === (0, $bgrMr.AUTH_UNKNOWN)) return 'unknown';
    if (local === (0, $bgrMr.AUTH_DISABLED) && remote === (0, $bgrMr.AUTH_OAUTH1)) return 'disabled-oauth';
    if (local === (0, $bgrMr.AUTH_DISABLED) && remote === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION)) return 'disabled-impersonation';
    if (local === (0, $bgrMr.AUTH_OAUTH1) && remote === (0, $bgrMr.AUTH_DISABLED)) return 'oauth-disabled';
    if (local === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION) && remote === (0, $bgrMr.AUTH_DISABLED)) return 'impersonation-disabled';
    if (local === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION) && remote === (0, $bgrMr.AUTH_DISABLED)) return 'impersonation-disabled';
    if (local === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION) && remote === (0, $bgrMr.AUTH_OAUTH1)) return 'impersonation-oauth';
    return 'no-mismatch';
};
const $41bd16eba23e9a09$export$9be1d088165ebfc0 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (props.incomingMismatch === 'unknown' || props.outgoingMismatch === 'unknown') return formatMessage((0, $9at1p.default).authLevelMismatchUnknownDescription);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41bd16eba23e9a09$var$PerDirectionDescription, {
        direction: "incoming",
        mismatchState: props.incomingMismatch,
        displayUrl: props.displayUrl,
        name: props.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41bd16eba23e9a09$var$PerDirectionDescription, {
        direction: "outgoing",
        mismatchState: props.outgoingMismatch,
        displayUrl: props.displayUrl,
        name: props.name
    }));
};
const $41bd16eba23e9a09$var$AuthLevelMismatchDescription = (props)=>{
    const incomingMismatch = $41bd16eba23e9a09$var$determineMismatchState(props.status, 'incoming');
    const outgoingMismatch = $41bd16eba23e9a09$var$determineMismatchState(props.status, 'outgoing');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41bd16eba23e9a09$export$9be1d088165ebfc0, {
        incomingMismatch: incomingMismatch,
        outgoingMismatch: outgoingMismatch,
        displayUrl: props.status.link.displayUrl,
        name: props.status.link.name
    });
};
var $41bd16eba23e9a09$export$2e2bcd8739ae039 = $41bd16eba23e9a09$var$AuthLevelMismatchDescription;

});
parcelRegister("bgrMr", function(module, exports) {
$parcel$export(module.exports, "AUTH_OAUTH1_IMPERSONATION", () => $447af97bc04f1ccb$export$ff126983aa810326);
$parcel$export(module.exports, "AUTH_OAUTH1", () => $447af97bc04f1ccb$export$6ddd0a1beee0fc1f);
$parcel$export(module.exports, "AUTH_DISABLED", () => $447af97bc04f1ccb$export$644a184fdd45756d);
$parcel$export(module.exports, "AUTH_UNKNOWN", () => $447af97bc04f1ccb$export$7ca14fced66a01c9);
$parcel$export(module.exports, "AUTH_OAUTH2", () => $447af97bc04f1ccb$export$c02e0077ab5a238d);
$parcel$export(module.exports, "getAuthLevel", () => $447af97bc04f1ccb$export$59daaa60b235e641);
const $447af97bc04f1ccb$export$ff126983aa810326 = 'oauthWithImpersonation';
const $447af97bc04f1ccb$export$6ddd0a1beee0fc1f = 'oauth';
const $447af97bc04f1ccb$export$644a184fdd45756d = 'disabled';
const $447af97bc04f1ccb$export$7ca14fced66a01c9 = 'unknown';
const $447af97bc04f1ccb$export$c02e0077ab5a238d = 'oauth2ThreeLo';
const $447af97bc04f1ccb$export$59daaa60b235e641 = (config)=>{
    if (!config) return $447af97bc04f1ccb$export$7ca14fced66a01c9;
    if (config.enabled && config.twoLoEnabled && config.twoLoImpersonationEnabled) return $447af97bc04f1ccb$export$ff126983aa810326;
    if (config.enabled && !config.twoLoImpersonationEnabled) return $447af97bc04f1ccb$export$6ddd0a1beee0fc1f;
    if (config.oAuth2ThreeLoEnabled) return $447af97bc04f1ccb$export$c02e0077ab5a238d;
    if (!config.enabled && !config.twoLoEnabled && !config.twoLoImpersonationEnabled && !config.oAuth2ThreeLoEnabled) return $447af97bc04f1ccb$export$644a184fdd45756d;
    return $447af97bc04f1ccb$export$7ca14fced66a01c9;
};

});



parcelRegister("Z7XR9", function(module, exports) {
$parcel$export(module.exports, "ERRORS", () => $211c917d43f0e753$export$4fd720569787ab6f);
const $211c917d43f0e753$export$4fd720569787ab6f = {
    // Network errors
    CONNECTION_REFUSED: {
        type: 'CONNECTION_REFUSED',
        category: 'NETWORK_ERROR'
    },
    UNKNOWN_HOST: {
        type: 'UNKNOWN_HOST',
        category: 'NETWORK_ERROR'
    },
    SSL_UNTRUSTED: {
        type: 'SSL_UNTRUSTED',
        category: 'NETWORK_ERROR'
    },
    SSL_HOSTNAME_UNMATCHED: {
        type: 'SSL_HOSTNAME_UNMATCHED',
        category: 'NETWORK_ERROR'
    },
    SSL_UNMATCHED: {
        type: 'SSL_UNMATCHED',
        category: 'NETWORK_ERROR'
    },
    OAUTH_PROBLEM: {
        type: 'OAUTH_PROBLEM',
        category: 'NETWORK_ERROR'
    },
    OAUTH_TIMESTAMP_REFUSED: {
        type: 'OAUTH_TIMESTAMP_REFUSED',
        category: 'NETWORK_ERROR'
    },
    OAUTH_SIGNATURE_INVALID: {
        type: 'OAUTH_SIGNATURE_INVALID',
        category: 'NETWORK_ERROR'
    },
    UNEXPECTED_RESPONSE: {
        type: 'UNEXPECTED_RESPONSE',
        category: 'NETWORK_ERROR'
    },
    UNEXPECTED_RESPONSE_STATUS: {
        type: 'UNEXPECTED_RESPONSE_STATUS',
        category: 'NETWORK_ERROR'
    },
    // Configuration state errors
    CREATION_FAILED: {
        type: 'CREATION_FAILED',
        category: 'CREATION_FAILED'
    },
    CONFIGURATION_INCOMPLETE: {
        type: 'CONFIGURATION_INCOMPLETE',
        category: 'CONFIGURATION_INCOMPLETE'
    },
    IN_PROGRESS: {
        type: 'IN_PROGRESS',
        category: 'IN_PROGRESS'
    },
    SUBMISSION_FAILED: {
        type: 'SUBMISSION_FAILED',
        category: 'SUBMISSION_FAILED'
    },
    CONFIGURATION_COMPLETE: {
        type: 'CONFIGURATION_COMPLETE',
        category: 'CONFIGURATION_COMPLETE'
    },
    // Configuration errors
    AUTH_LEVEL_MISMATCH: {
        type: 'AUTH_LEVEL_MISMATCH',
        category: 'CONFIG_ERROR'
    },
    NO_REMOTE_APPLINK: {
        type: 'NO_REMOTE_APPLINK',
        category: 'CONFIG_ERROR'
    },
    // Access errors
    LOCAL_AUTH_TOKEN_REQUIRED: {
        type: 'LOCAL_AUTH_TOKEN_REQUIRED',
        category: 'ACCESS_ERROR'
    },
    REMOTE_AUTH_TOKEN_REQUIRED: {
        type: 'REMOTE_AUTH_TOKEN_REQUIRED',
        category: 'ACCESS_ERROR'
    },
    INSUFFICIENT_REMOTE_PERMISSION: {
        type: 'INSUFFICIENT_REMOTE_PERMISSION',
        category: 'ACCESS_ERROR'
    },
    // Incompatibility errors
    REMOTE_VERSION_INCOMPATIBLE: {
        type: 'REMOTE_VERSION_INCOMPATIBLE',
        category: 'INCOMPATIBLE'
    },
    NO_OUTGOING_AUTH: {
        type: 'NO_OUTGOING_AUTH',
        category: 'INCOMPATIBLE'
    },
    // Non-Atlassian errors
    GENERIC_LINK: {
        type: 'GENERIC_LINK',
        category: 'NON_ATLASSIAN'
    },
    NON_ATLASSIAN: {
        type: 'NON_ATLASSIAN',
        category: 'NON_ATLASSIAN'
    },
    // System errors
    SYSTEM_LINK: {
        type: 'SYSTEM_LINK',
        category: 'SYSTEM'
    },
    // Deprecated functionality errors
    AUTH_LEVEL_UNSUPPORTED: {
        type: 'AUTH_LEVEL_UNSUPPORTED',
        category: 'DEPRECATED'
    },
    LEGACY_UPDATE: {
        type: 'LEGACY_UPDATE',
        category: 'DEPRECATED'
    },
    LEGACY_REMOVAL: {
        type: 'LEGACY_REMOVAL',
        category: 'DEPRECATED'
    },
    MANUAL_LEGACY_UPDATE: {
        type: 'MANUAL_LEGACY_UPDATE',
        category: 'DEPRECATED'
    },
    MANUAL_LEGACY_REMOVAL: {
        type: 'MANUAL_LEGACY_REMOVAL',
        category: 'DEPRECATED'
    },
    // Unknown errors
    UNKNOWN: {
        type: 'UNKNOWN',
        category: 'UNKNOWN'
    }
};

});

parcelRegister("6ZEHi", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", () => $331d339f4d7d5fe0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeV3", () => $331d339f4d7d5fe0$export$e8df9076d0ccd87c);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $7ep4S = parcelRequire("7ep4S");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lRq8t = parcelRequire("lRq8t");

var $9at1p = parcelRequire("9at1p");

var $Z7XR9 = parcelRequire("Z7XR9");
const $331d339f4d7d5fe0$export$f72db4ad1e9b3e6d = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (props.kind === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    });
    if (props.kind === 'working') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "success",
        isBold: true
    }, formatMessage((0, $9at1p.default).connectedStatus));
    if (props.kind === 'not-connected') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        isBold: true
    }, formatMessage((0, $9at1p.default).notConnectedStatus));
    if (props.kind === 'error') {
        const { err: err } = props;
        if (err.category === 'ACCESS_ERROR') {
            if (err.type === 'INSUFFICIENT_REMOTE_PERMISSION') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                appearance: "moved",
                isBold: true
            }, formatMessage((0, $9at1p.default).accessDeniedStatus));
            // Authenticated status API -> prompt user to do OAuth dance
            if (props.authorisationUri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: props.authorisationUri
            }, formatMessage((0, $9at1p.default).authTokenRequired));
            // Fallback for ACCESS_ERROR cases that don't match above conditions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                appearance: "removed",
                isBold: true
            }, formatMessage((0, $9at1p.default).accessDeniedStatus));
        }
        switch(err.type){
            case 'INCOMPATIBLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage((0, $9at1p.default).incompatibleStatus));
            case 'NON_ATLASSIAN':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage((0, $9at1p.default).nonAtlassianStatus));
            case 'SYSTEM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage((0, $9at1p.default).systemStatus));
            case 'NETWORK_ERROR':
            case 'UNKNOWN':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage((0, $9at1p.default).networkErrorStatus));
            case 'CREATION_FAILED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage((0, $9at1p.default).creationFailedStatus));
            case 'CONFIGURATION_INCOMPLETE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage((0, $9at1p.default).configurationIncompleteStatus));
            case 'IN_PROGRESS':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "moved",
                    isBold: true
                }, formatMessage((0, $9at1p.default).inProgressStatus));
            case 'CONFIGURATION_COMPLETE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "inprogress",
                    isBold: true
                }, formatMessage((0, $9at1p.default).configurationComplete));
            case 'SUBMISSION_FAILED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage((0, $9at1p.default).submissionFailed));
            case 'DEPRECATED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "inprogress",
                    isBold: true
                }, formatMessage((0, $9at1p.default).deprecatedStatus));
            case 'DISABLED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage((0, $9at1p.default).disabledStatus));
            case 'CONFIG_ERROR':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage((0, $9at1p.default).configErrorStatus));
        }
    }
};
const $331d339f4d7d5fe0$export$e8df9076d0ccd87c = (props)=>{
    const wrapWithV3Status = (0, $eJOHy.useCallback)(()=>{
        if (!props.status) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($331d339f4d7d5fe0$export$f72db4ad1e9b3e6d, {
            kind: "loading"
        });
        if (props.status.working) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($331d339f4d7d5fe0$export$f72db4ad1e9b3e6d, {
            kind: "working"
        });
        const err = props.status.error ?? (0, $Z7XR9.ERRORS).UNKNOWN;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($331d339f4d7d5fe0$export$f72db4ad1e9b3e6d, {
            kind: "error",
            err: err
        });
    }, [
        props.status
    ]);
    return wrapWithV3Status();
};

});

parcelRegister("gowAx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b05f4666dd7732b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5b05f4666dd7732b$var$messages = (0, $7qGN1.defineMessages)({
    applicationLinksTitle: {
        "id": "applinks.administration.ui.application-links-title",
        "defaultMessage": "Application links"
    },
    unknownErrorText: {
        "id": "applinks.administration.ui.unknown-error",
        "defaultMessage": "We encountered an unknown error."
    }
});
var $5b05f4666dd7732b$export$2e2bcd8739ae039 = $5b05f4666dd7732b$var$messages;

});

parcelRegister("3Ex3J", function(module, exports) {
$parcel$export(module.exports, "default", () => $4567d4548b1fb506$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4567d4548b1fb506$var$messages = (0, $7qGN1.defineMessages)({
    // Common
    linkDetailsSectionHeading: {
        "id": "applinks.administration.ui.edit.link-details-section-heading",
        "defaultMessage": "Link details"
    },
    applinkStatusLoadingText: {
        "id": "applinks.administration.ui.edit.applink-status-loading-text",
        "defaultMessage": "Loading application link status"
    },
    goToRemoteSiteLink: {
        "id": "applinks.administration.ui.edit.go-to-remote-site-link",
        "defaultMessage": "Go to {displayUrl}"
    },
    formCancelButtonText: {
        "id": "applinks.administration.ui.edit.form-cancel-button-text",
        "defaultMessage": "Cancel"
    },
    formSaveButtonText: {
        "id": "applinks.administration.ui.edit.form-save-button-text",
        "defaultMessage": "Save"
    },
    editMainTitle: {
        "id": "applinks.administration.ui.edit.main.title",
        "defaultMessage": "Edit application link"
    },
    seeAllApplinksButton: {
        "id": "applinks.administration.ui.edit.see-all-application-links-button",
        "defaultMessage": "See all application links"
    },
    applinkNotFoundHeader: {
        "id": "applinks.administration.ui.edit.applink-not-found-header",
        "defaultMessage": "Application link not found"
    },
    applinkNotFoundDescription: {
        "id": "applinks.administration.ui.edit.applink-not-found-description",
        "defaultMessage": "The application link you're trying to edit does not exist or has been deleted."
    },
    applinkNotEditableHeader: {
        "id": "applinks.administration.ui.edit.applink-not-editable-header",
        "defaultMessage": "Non-editable system link"
    },
    securedByMessage: {
        "id": "applinks.administration.ui.edit.secured-by-message",
        "defaultMessage": "Secured by {authMethod}"
    },
    productCardHeader: {
        "id": "applinks.administration.ui.edit.product-card-header",
        "defaultMessage": "Linked application"
    },
    errorFlagTitle: {
        "id": "applinks.administration.ui.edit.error-flag-title",
        "defaultMessage": "Failed to update application link"
    },
    // OAuth 1.0 Edit
    connectionsTitle: {
        "id": "applinks.administration.ui.edit.connections-section-header",
        "defaultMessage": "Connections"
    },
    arrowDisabledHoverText: {
        "id": "applinks.administration.ui.edit.arrow-disabled-alt-text",
        "defaultMessage": "Authentication is disabled"
    },
    arrowMatchHoverText: {
        "id": "applinks.administration.ui.edit.arrow-match-alt-text",
        "defaultMessage": "Authentication is enabled"
    },
    arrowMismatchHoverText: {
        "id": "applinks.administration.ui.edit.arrow-mismatch-alt-text",
        "defaultMessage": "Authentication is mismatched between local and remote"
    },
    authTableRowDirectionIncoming: {
        "id": "applinks.administration.ui.edit.direction-incoming",
        "defaultMessage": "Incoming"
    },
    authTableRowDirectionOutgoing: {
        "id": "applinks.administration.ui.edit.direction-outgoing",
        "defaultMessage": "Outgoing"
    },
    authTableColumnDirectionHeading: {
        "id": "applinks.administration.ui.edit.direction-heading",
        "defaultMessage": "Direction"
    },
    authTableColumnLocalAuthenticationHeading: {
        "id": "applinks.administration.ui.edit.local-authentication-heading",
        "defaultMessage": "Local authentication"
    },
    authTableColumnRemoteAuthenticationHeading: {
        "id": "applinks.administration.ui.edit.remote-authentication-heading",
        "defaultMessage": "Remote authentication"
    },
    impersonationRemovedTitle: {
        "id": "applinks.administration.ui.edit.impersonation-removed-title",
        "defaultMessage": "OAuth with impersonation is not supported"
    },
    impersonationRemovedDescription: {
        "id": "applinks.administration.ui.edit.impersonation-removed-description",
        "defaultMessage": "Support for OAuth with impersonation <link>has been removed</link>. Please select a different authentication method."
    },
    unsupportedAuthenticationType: {
        "id": "applinks.administration.ui.edit.unsupported-authentication-type",
        "defaultMessage": "Invalid authentication type \"{invalidAuthType}\" used. Please select a different authentication method."
    },
    // OAuth 2.0 Edit
    outgoingCredentialsButtonText: {
        "id": "applinks.administration.ui.edit.outgoing-credentials-button-text",
        "defaultMessage": "Update outgoing link credentials"
    },
    outgoingCredentialsModalTitle: {
        "id": "applinks.administration.ui.edit.outgoing-credentials-modal-title",
        "defaultMessage": "Update outgoing link credentials"
    },
    outgoingLinkTitle: {
        "id": "applinks.administration.ui.edit.outgoing-link.title",
        "defaultMessage": "Outgoing link"
    },
    outgoingLinkDescription: {
        "id": "applinks.administration.ui.edit.outgoing-link.description",
        "defaultMessage": "Find these details in the external application and enter them below. You may need to ask an admin of the external application for these details."
    },
    incomingLinkTitle: {
        "id": "applinks.administration.ui.edit.incoming-link.title",
        "defaultMessage": "Incoming link"
    },
    incomingLinkDescription: {
        "id": "applinks.administration.ui.edit.incoming-link.description",
        "defaultMessage": "Copy these details to the external application. If you're not an admin of the application, ask an existing admin to make the updates for you."
    },
    continueLinkingTitle: {
        "id": "applinks.administration.ui.edit.continue-linking.title",
        "defaultMessage": "Continue linking to the external application"
    },
    continueLinkingDescription: {
        "id": "applinks.administration.ui.edit.continue-linking.description",
        "defaultMessage": "In order to complete the link, enter the credentials for the incoming and outgoing links below."
    },
    oauth2ConfigLoadFailedTitle: {
        "id": "applinks.administration.ui.edit.oauth2-config-load-failed-title",
        "defaultMessage": "Failed to load the OAuth 2.0 configuration"
    },
    oauth2ConfigLoadFailedDescription: {
        "id": "applinks.administration.ui.edit.oauth2-config-load-failed-description",
        "defaultMessage": "We couldn't load the OAuth 2.0 configuration for this app. This may be because the target app is inaccessible."
    }
});
var $4567d4548b1fb506$export$2e2bcd8739ae039 = $4567d4548b1fb506$var$messages;

});

parcelRegister("eBoKt", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cf043cca0be813d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $3L3Os = parcelRequire("3L3Os");
var $eRpdx = parcelRequire("eRpdx");
var $bUGwX = parcelRequire("bUGwX");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");
var $5bY40 = parcelRequire("5bY40");

var $iHPvF = parcelRequire("iHPvF");

var $83DiZ = parcelRequire("83DiZ");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $eSnSE = parcelRequire("eSnSE");

var $8SMrZ = parcelRequire("8SMrZ");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $3Ex3J = parcelRequire("3Ex3J");

var $gowAx = parcelRequire("gowAx");

var $e3qJa = parcelRequire("e3qJa");
const $4cf043cca0be813d$var$styles = {
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _19pkpxbi",
    formSectionInner: "_19pkpxbi"
};
const $4cf043cca0be813d$var$ApplinksOAuth2EditPageContents = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getListPageUrl = (0, $eJOHy.useCallback)(()=>{
        if ((0, $4cTDP.fg)('applinks-933-experimental-list-page')) return 0, $d6B0e.APPLINKS_LIST_PAGE_URL;
        return 0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY;
    }, []);
    const onFormSubmit = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            const applinkUpdate = {
                id: props.applink.id,
                type: props.applink.type,
                system: props.applink.system,
                primary: props.applink.primary,
                isExtraAuthRequired: props.applink.isExtraAuthRequired,
                rpcUrl: props.applink.rpcUrl,
                // Only change these properties:
                name: data.displayName,
                displayUrl: data.displayUrl
            };
            await (0, $dk6v8.updateApplinkV3)(props.applink.id, applinkUpdate);
            if (props.oauth2ConfigInfo !== null) // Check at least one param is defined
            {
                if (data.applicationClientId || data.applicationClientSecret || data.redirectUrl) {
                    const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
                    const oauth2ConfigUpdate = {
                        remoteClientId: data.applicationClientId,
                        remoteClientSecret: data.applicationClientSecret,
                        remoteRedirectUrl: data.redirectUrl,
                        outboundScopes: scopes
                    };
                    await (0, $dk6v8.putOAuth2ConfigInfo)(props.applink.id, oauth2ConfigUpdate);
                }
            }
            push(getListPageUrl());
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined; // If you see this error:
            // - partially linked variant = outgoing credentials are inline
            // - normal variant = outgoing credentials are submitted via a separate modal (outgoing-credentials-modal)
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.oauth2.submitEditForm', `Failed to update OAuth 2.0 applink ${props.partiallyLinkedMode ? 'using partially linked variant' : 'using normal variant'} of the edit form`, maybeError);
            props.onDisplayError(maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText));
        }
    }, [
        formatMessage,
        getListPageUrl,
        props,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), {
            title: formatMessage((0, $3Ex3J.default).linkDetailsSectionHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.200",
            xcss: $4cf043cca0be813d$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayName), {
            name: "displayName",
            defaultName: props.applink.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayUrl), {
            name: "displayUrl",
            defaultUrl: props.applink.displayUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationUrl), {
            name: "rpcUrl",
            defaultUrl: props.applink.rpcUrl,
            disabled: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
            role: "presentation",
            className: (0, $hcewu.default)([
                $4cf043cca0be813d$var$styles.dividerStyle
            ])
        }), props.partiallyLinkedMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
            title: formatMessage((0, $3Ex3J.default).continueLinkingTitle)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $3Ex3J.default).continueLinkingDescription))), props.oauth2ConfigInfo !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e3qJa.default), {
            ...props,
            oauth2ConfigInfo: props.oauth2ConfigInfo,
            onRequestStatusRefresh: props.onRequestStatusRefresh
        }), !props.oauth2ConfigInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
            appearance: "error",
            title: formatMessage((0, $3Ex3J.default).oauth2ConfigLoadFailedTitle)
        }, formatMessage((0, $3Ex3J.default).oauth2ConfigLoadFailedDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRpdx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
            href: getListPageUrl(),
            appearance: "subtle"
        }, formatMessage((0, $3Ex3J.default).formCancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            testId: "applinks-administration.ui.edit.oauth2.submit-button",
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, formatMessage((0, $3Ex3J.default).formSaveButtonText))))))));
};
var $4cf043cca0be813d$export$2e2bcd8739ae039 = $4cf043cca0be813d$var$ApplinksOAuth2EditPageContents;

});
parcelRegister("8SMrZ", function(module, exports) {
$parcel$export(module.exports, "CopyableApplicationClientID", () => $ae50983c3d3fd402$export$933c655d375093bb);
$parcel$export(module.exports, "CopyableApplicationClientSecret", () => $ae50983c3d3fd402$export$eeaa05b78b5f2773);
$parcel$export(module.exports, "RemoteApplicationScopeMultiSelect", () => $ae50983c3d3fd402$export$e6ea1c895768a29c);
$parcel$export(module.exports, "ApplicationClientId", () => $ae50983c3d3fd402$export$c8399aae3a726af3);
$parcel$export(module.exports, "ApplicationClientSecret", () => $ae50983c3d3fd402$export$f137c4dc8b585189);
$parcel$export(module.exports, "RedirectUrl", () => $ae50983c3d3fd402$export$e0ad63dba68d8cca);
$parcel$export(module.exports, "DisplayName", () => $ae50983c3d3fd402$export$101fbca3a406e1fd);
$parcel$export(module.exports, "DisplayUrl", () => $ae50983c3d3fd402$export$b07e64a5c70fbd11);
$parcel$export(module.exports, "ApplicationUrl", () => $ae50983c3d3fd402$export$5c4f409b6c929d7a);

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $sY9BV = parcelRequire("sY9BV");

var $6UCkD = parcelRequire("6UCkD");

var $lRq8t = parcelRequire("lRq8t");

var $e7C36 = parcelRequire("e7C36");

var $d6B0e = parcelRequire("d6B0e");

var $bnyzI = parcelRequire("bnyzI");

var $kHyXk = parcelRequire("kHyXk");
const $ae50983c3d3fd402$export$933c655d375093bb = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: props.clientId,
        label: formatMessage((0, $kHyXk.default).clientIdLabel),
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.copyable-application-client-id",
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnyzI.default), {
                label: formatMessage((0, $kHyXk.default).clientIdLabel),
                value: props.clientId
            })
        }));
};
const $ae50983c3d3fd402$export$eeaa05b78b5f2773 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: props.clientSecret,
        label: formatMessage((0, $kHyXk.default).clientSecretLabel),
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.copyable-application-client-secret",
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnyzI.default), {
                label: formatMessage((0, $kHyXk.default).clientSecretLabel),
                value: props.clientSecret
            })
        }));
};
const $ae50983c3d3fd402$export$e6ea1c895768a29c = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        label: formatMessage((0, $kHyXk.default).remoteApplicationScopesLabel),
        defaultValue: props.defaultSelected,
        validate: (chosenScopes)=>(0, $e7C36.validateSupportedScopes)(chosenScopes ? chosenScopes.map((scope)=>scope.value) : [], props.supportedScopes),
        isRequired: true,
        "aria-required": true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UCkD.default), {
            testId: "applinks-administration.ui.common.fields.remote-application-scope-multi-select",
            placeholder: formatMessage((0, $kHyXk.default).remoteApplicationScopesPlaceholder),
            ...fieldProps,
            options: props.supportedScopes.map((scope)=>({
                    label: scope,
                    value: scope
                }))
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, error)));
};
const $ae50983c3d3fd402$export$c8399aae3a726af3 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        label: formatMessage((0, $kHyXk.default).clientIdLabel),
        isRequired: props.isRequired,
        "aria-required": props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.application-client-id",
            type: "password",
            placeholder: formatMessage((0, $kHyXk.default).clientIdLabel),
            ...fieldProps
        }));
};
const $ae50983c3d3fd402$export$f137c4dc8b585189 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        label: formatMessage((0, $kHyXk.default).clientSecretLabel),
        isRequired: props.isRequired,
        "aria-required": props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.application-client-secret",
            type: "password",
            placeholder: formatMessage((0, $kHyXk.default).clientSecretLabel),
            ...fieldProps
        }));
};
const $ae50983c3d3fd402$export$e0ad63dba68d8cca = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: props.defaultRedirectUrl,
        label: formatMessage((0, $kHyXk.default).redirectUrlLabel),
        validate: (redirectUrl)=>(0, $e7C36.validateURLField)(redirectUrl, true, true),
        isRequired: true,
        "aria-required": true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.redirect-url",
            placeholder: formatMessage((0, $kHyXk.default).redirectUrlLabel),
            ...fieldProps
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, error)));
};
const $ae50983c3d3fd402$export$101fbca3a406e1fd = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: props.defaultName,
        label: formatMessage((0, $kHyXk.default).displayNameLabel),
        isRequired: true,
        "aria-required": true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.display-name",
            placeholder: formatMessage((0, $kHyXk.default).displayNamePlaceholder),
            ...fieldProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, formatMessage((0, $kHyXk.default).displayNameHelperMessage))));
};
const $ae50983c3d3fd402$export$b07e64a5c70fbd11 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: props.defaultUrl,
        label: formatMessage((0, $kHyXk.default).displayUrlLabel),
        isRequired: true,
        "aria-required": true,
        validate: (defaultUrl)=>(0, $e7C36.validateURLField)(defaultUrl, true, false)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.display-url",
            placeholder: formatMessage((0, $kHyXk.default).displayUrlPlaceholder),
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, formatMessage((0, $kHyXk.default).displayUrlHelperMessage, {
            productName: (0, $d6B0e.THIS_PRODUCT_NAME_STRING)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, error)));
};
const $ae50983c3d3fd402$export$5c4f409b6c929d7a = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: props.defaultUrl,
        label: formatMessage((0, $kHyXk.default).applicationUrlLabel),
        isDisabled: props.disabled,
        isRequired: !props.disabled,
        "aria-required": !props.disabled,
        validate: (redirectUrl)=>(0, $e7C36.validateURLField)(redirectUrl, true, true)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            testId: "applinks-administration.ui.common.fields.application-url",
            placeholder: formatMessage((0, $kHyXk.default).applicationUrlPlaceholder),
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, formatMessage((0, $kHyXk.default).applicationUrlHelperMessage, {
            productName: (0, $d6B0e.THIS_PRODUCT_NAME_STRING)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, error)));
};

});
parcelRegister("6UCkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bb5dff77a1a2ff0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jzkyh = parcelRequire("jzkyh");

var $c4OV1 = parcelRequire("c4OV1");
const $3bb5dff77a1a2ff0$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eJOHy.useMemo)(()=>({
            ...components,
            Option: (0, $jzkyh.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $3bb5dff77a1a2ff0$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($3bb5dff77a1a2ff0$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bb5dff77a1a2ff0$export$2e2bcd8739ae039 = $3bb5dff77a1a2ff0$var$CheckboxSelect;

});
parcelRegister("jzkyh", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $c59673c02b42adcb$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $c59673c02b42adcb$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dwm7g = parcelRequire("dwm7g");

var $279SN = parcelRequire("279SN");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
const $c59673c02b42adcb$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112e126o",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $c59673c02b42adcb$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $c59673c02b42adcb$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c59673c02b42adcb$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $c59673c02b42adcb$var$baseIconStyles = null;
const $c59673c02b42adcb$var$baseOptionStyles = null;
const $c59673c02b42adcb$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $c59673c02b42adcb$var$optionStyles.default,
            isFocused && $c59673c02b42adcb$var$optionStyles.focused,
            isDisabled && $c59673c02b42adcb$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $c59673c02b42adcb$var$iconStyles.inherit : $c59673c02b42adcb$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $c59673c02b42adcb$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c59673c02b42adcb$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $c59673c02b42adcb$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($dwm7g))),
        ...props
    });
const $c59673c02b42adcb$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($279SN))),
        ...props
    });

});
parcelRegister("dwm7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7f6b5a4b54b43d$var$_react = $9d7f6b5a4b54b43d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9d7f6b5a4b54b43d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7f6b5a4b54b43d$var$CheckboxIcon = (props)=>/*#__PURE__*/ $9d7f6b5a4b54b43d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$9d7f6b5a4b54b43d$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $9d7f6b5a4b54b43d$var$_default = module.exports.default = $9d7f6b5a4b54b43d$var$CheckboxIcon;

});

parcelRegister("279SN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18a3e6b70b5fecb4$var$_react = $18a3e6b70b5fecb4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $18a3e6b70b5fecb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $18a3e6b70b5fecb4$var$RadioIcon = (props)=>/*#__PURE__*/ $18a3e6b70b5fecb4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$18a3e6b70b5fecb4$var$RadioIcon.displayName = 'RadioIcon';
var $18a3e6b70b5fecb4$var$_default = module.exports.default = $18a3e6b70b5fecb4$var$RadioIcon;

});



parcelRegister("e7C36", function(module, exports) {
$parcel$export(module.exports, "validateURLField", () => $ff55c6cd2437b378$export$2ad6818b3d68393f);
$parcel$export(module.exports, "validateSupportedScopes", () => $ff55c6cd2437b378$export$7abf746ed63ce29a);

var $8dH3d = parcelRequire("8dH3d");

var $eNS8S = parcelRequire("eNS8S");
const $ff55c6cd2437b378$export$7cc6bb943616cddf = [
    'http:',
    'https:'
];
const $ff55c6cd2437b378$export$2ad6818b3d68393f = (value, isRequired, checkScheme)=>{
    if (!value) return isRequired ? $ff55c6cd2437b378$export$af1e14e964849c8c.empty : undefined;
    const trimmedValue = value?.trim();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(trimmedValue) && isRequired) return $ff55c6cd2437b378$export$af1e14e964849c8c.empty;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(trimmedValue) && !(0, $eNS8S.isValidUrl)(value)) return $ff55c6cd2437b378$export$af1e14e964849c8c.urlInvalid;
    if (checkScheme && !$ff55c6cd2437b378$export$7cc6bb943616cddf.some((scheme)=>value.startsWith(scheme))) return $ff55c6cd2437b378$export$af1e14e964849c8c.urlSchemeInvalid;
    return undefined;
};
const $ff55c6cd2437b378$export$7abf746ed63ce29a = (chosenScopes, supportedScopes)=>{
    const invalidScopes = chosenScopes.filter((scope)=>!supportedScopes.includes(scope));
    if (invalidScopes.length > 0) return $ff55c6cd2437b378$export$af1e14e964849c8c.unsupportedScope;
    return undefined;
};
const $ff55c6cd2437b378$export$af1e14e964849c8c = {
    empty: 'This field is required.',
    urlInvalid: 'Enter a valid URL.',
    urlSchemeInvalid: 'The URL must start with http:// or https://.',
    authTypeInvalid: 'Select a valid authentication type.',
    impersonationNotAllowed: '2LO (impersonation) is deprecated. Please choose another authentication type.',
    unsupportedScope: 'One or more selected scopes are not supported.'
};

});
parcelRegister("eNS8S", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $ae6a7d95440d0325$export$bef94a5618bf18bf);
$parcel$export(module.exports, "default", () => $ae6a7d95440d0325$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $ae6a7d95440d0325$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $ae6a7d95440d0325$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $ae6a7d95440d0325$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $ae6a7d95440d0325$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $ae6a7d95440d0325$var$stricterURLRegex.test(string) || $ae6a7d95440d0325$var$protocolRegex.test(string);
    return $ae6a7d95440d0325$var$URLStandardRegex.test(string);
}
var $ae6a7d95440d0325$export$2e2bcd8739ae039 = $ae6a7d95440d0325$export$bef94a5618bf18bf;

});


parcelRegister("bnyzI", function(module, exports) {
$parcel$export(module.exports, "default", () => $251ef5110b5d7e4c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $k71qx = parcelRequire("k71qx");

var $lGr6J = parcelRequire("lGr6J");

var $gqEmK = parcelRequire("gqEmK");

var $lRq8t = parcelRequire("lRq8t");

var $j7FRf = parcelRequire("j7FRf");
const $251ef5110b5d7e4c$var$TOOLTIP_CONTENT_REFRESH_INTERVAL = 2500;
const $251ef5110b5d7e4c$var$CopyButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [linkCopied, setLinkCopied] = (0, $eJOHy.useState)(false);
    const [message, setMessage] = (0, $eJOHy.useState)(formatMessage((0, $j7FRf.default).copyTooltipHover, {
        itemToCopy: props.label
    }));
    const updateTooltip = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        message
    ]);
    const copyLink = (0, $eJOHy.useCallback)(async ()=>{
        if (typeof globalThis !== 'undefined' && globalThis.navigator?.clipboard) try {
            await globalThis.navigator.clipboard.writeText(props.value);
            setLinkCopied(true);
            setMessage(formatMessage((0, $j7FRf.default).copyTooltipFeedback));
            setTimeout(()=>{
                setLinkCopied(false);
                setMessage(formatMessage((0, $j7FRf.default).copyTooltipHover, {
                    itemToCopy: props.label
                }));
            }, $251ef5110b5d7e4c$var$TOOLTIP_CONTENT_REFRESH_INTERVAL);
        } catch (error) {
        // TODO: Handle error case where clipboard write fails
        }
    }, [
        formatMessage,
        props.label,
        props.value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return message;
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: linkCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))) : (0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))),
        label: formatMessage((0, $j7FRf.default).copyTooltipHover, {
            itemToCopy: props.label
        }),
        isTooltipDisabled: true,
        onClick: copyLink
    }));
};
var $251ef5110b5d7e4c$export$2e2bcd8739ae039 = $251ef5110b5d7e4c$var$CopyButton;

});
parcelRegister("j7FRf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e37b35f8323b87ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e37b35f8323b87ec$var$messages = (0, $7qGN1.defineMessages)({
    // Actions
    copyTooltipHover: {
        "id": "applinks.administration.ui.common.fields.copy-button.copy-tooltip-hover",
        "defaultMessage": "Copy {itemToCopy}"
    },
    copyTooltipFeedback: {
        "id": "applinks.administration.ui.common.fields.copy-button.copy-tooltip-feedback",
        "defaultMessage": "Copied"
    }
});
var $e37b35f8323b87ec$export$2e2bcd8739ae039 = $e37b35f8323b87ec$var$messages;

});


parcelRegister("kHyXk", function(module, exports) {
$parcel$export(module.exports, "default", () => $907ba696cdccccef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $907ba696cdccccef$var$messages = (0, $7qGN1.defineMessages)({
    clientIdLabel: {
        "id": "applinks.administration.ui.common.fields.client-id.label",
        "defaultMessage": "App client ID"
    },
    clientSecretLabel: {
        "id": "applinks.administration.ui.common.fields.client-secret.label",
        "defaultMessage": "App client secret"
    },
    remoteApplicationScopesLabel: {
        "id": "applinks.administration.ui.common.fields.remote-application-scopes.label",
        "defaultMessage": "Remote app scopes"
    },
    remoteApplicationScopesPlaceholder: {
        "id": "applinks.administration.ui.common.fields.remote-application-scopes.placeholder",
        "defaultMessage": "Use the same scopes as the remote app"
    },
    redirectUrlLabel: {
        "id": "applinks.administration.ui.common.fields.redirect-url.label",
        "defaultMessage": "Redirect URL"
    },
    displayNameLabel: {
        "id": "applinks.administration.ui.common.fields.display-name.label",
        "defaultMessage": "Display name"
    },
    displayNamePlaceholder: {
        "id": "applinks.administration.ui.common.fields.display-name.placeholder",
        "defaultMessage": "Name for the application link"
    },
    displayNameHelperMessage: {
        "id": "applinks.administration.ui.common.fields.display-name.helper-message",
        "defaultMessage": "Enter a unique name for the link, for example the name of your external app."
    },
    displayUrlLabel: {
        "id": "applinks.administration.ui.common.fields.display-url.label",
        "defaultMessage": "Display URL"
    },
    displayUrlPlaceholder: {
        "id": "applinks.administration.ui.common.fields.display-url.placeholder",
        "defaultMessage": "URL for the application link"
    },
    displayUrlHelperMessage: {
        "id": "applinks.administration.ui.common.fields.display-url.helper-message",
        "defaultMessage": "This is the URL that we'll display to users in  {productName}."
    },
    applicationUrlLabel: {
        "id": "applinks.administration.ui.common.fields.application-url.label",
        "defaultMessage": "Application URL"
    },
    applicationUrlPlaceholder: {
        "id": "applinks.administration.ui.common.fields.application-url.placeholder",
        "defaultMessage": "Application URL for the application link"
    },
    applicationUrlHelperMessage: {
        "id": "applinks.administration.ui.common.fields.application-url.helper-message",
        "defaultMessage": "This is the URL that {productName} will use to communicate with the external app."
    }
});
var $907ba696cdccccef$export$2e2bcd8739ae039 = $907ba696cdccccef$var$messages;

});


parcelRegister("e3qJa", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca3f78d88254702$export$2e2bcd8739ae039);
/* CredentialsForm.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $bUGwX = parcelRequire("bUGwX");

var $eJ9f5 = parcelRequire("eJ9f5");

var $gTr6H = parcelRequire("gTr6H");

var $lRq8t = parcelRequire("lRq8t");

var $aiiy5 = parcelRequire("aiiy5");

var $8SMrZ = parcelRequire("8SMrZ");

var $ffsuj = parcelRequire("ffsuj");

var $lOO86 = parcelRequire("lOO86");

var $3Ex3J = parcelRequire("3Ex3J");
const $8ca3f78d88254702$var$styles = {
    growField: "_16jlkb7n",
    formSectionInner: "_19pkpxbi"
};
const $8ca3f78d88254702$var$OutgoingCredentialsModalButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            applink: props.applink,
            onDisplayError: props.onDisplayError,
            onClose: props.onRequestStatusRefresh
        }), [
        props.applink,
        props.onDisplayError,
        props.onRequestStatusRefresh
    ]);
    return /*#__PURE__*/ $eJOHy.createElement((0, $aiiy5.ModalButtonTrigger), {
        testId: "applinks-administration.ui.edit.oauth2.credentials-form.outgoing-credentials-modal-button",
        name: "updateOutgoingLinkCredentials",
        entryPoint: (0, $lOO86.outgoingCredentialsModalEntryPoint),
        entryPointProps: entryPointProps,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H)))
    }, formatMessage((0, $3Ex3J.default).outgoingCredentialsButtonText));
};
const $8ca3f78d88254702$var$CredentialsForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $78OnL.default), null, /*#__PURE__*/ $eJOHy.createElement((0, $bUGwX.default), {
        title: formatMessage((0, $3Ex3J.default).incomingLinkTitle),
        description: formatMessage((0, $3Ex3J.default).incomingLinkDescription)
    }, /*#__PURE__*/ $eJOHy.createElement((0, $78OnL.default), {
        space: "space.200",
        xcss: $8ca3f78d88254702$var$styles.formSectionInner
    }, /*#__PURE__*/ $eJOHy.createElement((0, $6djmC.default), {
        space: "space.200"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $8ca3f78d88254702$var$styles.growField
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8SMrZ.CopyableApplicationClientID), {
        name: "copyableApplicationClientId",
        clientId: props.oauth2ConfigInfo.inboundOAuthClientId
    })), /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $8ca3f78d88254702$var$styles.growField
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8SMrZ.CopyableApplicationClientSecret), {
        name: "copyableApplicationClientSecret",
        clientSecret: props.oauth2ConfigInfo.inboundOAuthClientSecret
    }))))), /*#__PURE__*/ $eJOHy.createElement((0, $bUGwX.default), {
        title: formatMessage((0, $3Ex3J.default).outgoingLinkTitle),
        description: formatMessage((0, $3Ex3J.default).outgoingLinkDescription)
    }, /*#__PURE__*/ $eJOHy.createElement((0, $78OnL.default), {
        space: "space.200",
        xcss: $8ca3f78d88254702$var$styles.formSectionInner
    }, props.partiallyLinkedMode && /*#__PURE__*/ $eJOHy.createElement((0, $78OnL.default), {
        space: "space.200"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $6djmC.default), {
        space: "space.200"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $8ca3f78d88254702$var$styles.growField
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8SMrZ.ApplicationClientId), {
        name: "applicationClientId"
    })), /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $8ca3f78d88254702$var$styles.growField
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8SMrZ.ApplicationClientSecret), {
        name: "applicationClientSecret"
    })))), !props.oauth2ConfigInfo.isRemoteApplicationCloud && /*#__PURE__*/ $eJOHy.createElement((0, $8SMrZ.RedirectUrl), {
        name: "redirectUrl",
        defaultRedirectUrl: props.oauth2ConfigInfo?.inboundRedirectUrl || ''
    }), !props.oauth2ConfigInfo.isRemoteApplicationCloud && /*#__PURE__*/ $eJOHy.createElement((0, $8SMrZ.RemoteApplicationScopeMultiSelect), {
        name: "remoteApplicationSupportedScopes",
        supportedScopes: props.oauth2ConfigInfo.remoteApplicationSupportedScopes || [],
        defaultSelected: props.oauth2ConfigInfo.outboundScopes?.map((scope)=>({
                label: scope,
                value: scope
            })) || []
    }), !props.partiallyLinkedMode && /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), null, /*#__PURE__*/ $eJOHy.createElement($8ca3f78d88254702$var$OutgoingCredentialsModalButton, {
        applink: props.applink,
        onDisplayError: props.onDisplayError,
        onRequestStatusRefresh: props.onRequestStatusRefresh
    })), /*#__PURE__*/ $eJOHy.createElement((0, $eJ9f5.default), {
        href: (0, $ffsuj.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
        target: "_blank"
    }, formatMessage((0, $3Ex3J.default).goToRemoteSiteLink, {
        displayUrl: props.applink.displayUrl
    })))));
};
var $8ca3f78d88254702$export$2e2bcd8739ae039 = $8ca3f78d88254702$var$CredentialsForm;

});
parcelRegister("aiiy5", function(module, exports) {
$parcel$export(module.exports, "ModalButtonTrigger", () => $6f9eab7d1af23f4a$export$156b5756ed7a09ad);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $asoyU = parcelRequire("asoyU");
function $6f9eab7d1af23f4a$export$156b5756ed7a09ad({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, ...buttonProps }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asoyU.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                ref: ref,
                ...buttonProps,
                children: children
            })
    });
}

});

parcelRegister("ffsuj", function(module, exports) {
$parcel$export(module.exports, "STATUS_RECIPROCAL_SUCCESS", () => $a03bf89b29beef2f$export$657b6c684cdb0f25);
$parcel$export(module.exports, "STATUS_RECIPROCAL_INPROGRESS", () => $a03bf89b29beef2f$export$ebb855fc01c4dac8);
$parcel$export(module.exports, "updateStatusLog", () => $a03bf89b29beef2f$export$9f0778ce9e00d11);
$parcel$export(module.exports, "getApplinksAdminUrl", () => $a03bf89b29beef2f$export$78ab2fbb731a208e);
$parcel$export(module.exports, "getDefaultCreationState", () => $a03bf89b29beef2f$export$c97322013e85b0a3);
$parcel$export(module.exports, "generateApplinksCreationRedirectionUrl", () => $a03bf89b29beef2f$export$a227964e32a1613e);
$parcel$export(module.exports, "parseCreationStateFromUrl", () => $a03bf89b29beef2f$export$a3c0d7af5d0c8b3);
// The Applinks Status Log format
// We use this to interchange between the various products
// Refer to `AppLinks.Creation.generateApplinksCreationRedirectionUrl` in
// legacy frontend for more details

var $d6B0e = parcelRequire("d6B0e");
const $a03bf89b29beef2f$export$83a5ccd32faf0509 = 'completed.creation';
const $a03bf89b29beef2f$export$46ec94e31f2d2bee = 'failed.creation';
const $a03bf89b29beef2f$export$9c895fb851e899e2 = 'inprogress.creation';
const $a03bf89b29beef2f$export$4ef4887476a06719 = 'completed.creation.local';
const $a03bf89b29beef2f$export$657b6c684cdb0f25 = 'completed.creation.reciprocal';
const $a03bf89b29beef2f$export$ebb855fc01c4dac8 = 'inprogress.creation.reciprocal';
const $a03bf89b29beef2f$export$a5b9f0b29d12c743 = 'failed.creation.local';
const $a03bf89b29beef2f$export$151e8c78ee009a44 = 'failed.creation.reciprocal';
const $a03bf89b29beef2f$export$ce29b766ff657ea1 = 'failed.registerprovider.2loi';
const $a03bf89b29beef2f$export$a38352a15fd9f0ce = (entries)=>{
    return entries;
};
const $a03bf89b29beef2f$export$9f0778ce9e00d11 = (statusLog, newEntry)=>{
    return [
        ...statusLog,
        newEntry
    ];
};
const $a03bf89b29beef2f$export$78ab2fbb731a208e = (remoteBaseUrl, typeId)=>{
    const suffix = typeId === 'confluence' ? '/admin/listapplicationlinks.action' : (0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY);
    return remoteBaseUrl + suffix;
};
const $a03bf89b29beef2f$export$c97322013e85b0a3 = (startingUrl, startingTypeId, originalCreatedId)=>{
    return {
        applinkCreationStatusLog: $a03bf89b29beef2f$export$a38352a15fd9f0ce([
            {
                status: $a03bf89b29beef2f$export$9c895fb851e899e2
            },
            {
                status: $a03bf89b29beef2f$export$4ef4887476a06719
            },
            {
                status: $a03bf89b29beef2f$export$ebb855fc01c4dac8
            }
        ]),
        applinkOriginalCreatedId: originalCreatedId,
        sharedUserbase: false,
        applinkConfigInUserAuth: true,
        applinkConfigInServerAuth: true,
        applinkConfigInPreAuth: true,
        applinkConfigOutUserAuth: true,
        applinkConfigOutServerAuth: true,
        applinkConfigOutPreAuth: true,
        applinkStartingUrl: startingUrl,
        applinkStartingType: startingTypeId,
        creatingReciprocal: true
    };
};
const $a03bf89b29beef2f$var$generateUrl = (remoteUrl, parametersMap)=>{
    if (!parametersMap || Object.keys(parametersMap).length === 0) return remoteUrl;
    const params = Object.entries(parametersMap).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    return remoteUrl.includes('?') ? `${remoteUrl}&${params}` : `${remoteUrl}?${params}`;
};
const $a03bf89b29beef2f$export$a227964e32a1613e = (remoteBaseUrl, remoteTypeId, creationState)=>{
    // In the original applinks frontend, the status log was stored as a string. This means in the final URL,
    // the status log is double stringified. This is a hack to maintain compatibility with the legacy frontend.
    const parameterMap = Object.fromEntries(Object.entries(creationState).map(([key, value])=>{
        if (key === 'applinkCreationStatusLog') // Yes, I know it's awful
        return [
            key,
            JSON.stringify(JSON.stringify(creationState.applinkCreationStatusLog))
        ];
        return [
            key,
            JSON.stringify(value)
        ];
    }));
    return $a03bf89b29beef2f$var$generateUrl($a03bf89b29beef2f$export$78ab2fbb731a208e(remoteBaseUrl, remoteTypeId), parameterMap);
};
const $a03bf89b29beef2f$var$getAndDecode = (url, param)=>{
    const value = url.searchParams.get(param);
    if (value !== null) {
        const decodedFieldValue = decodeURIComponent(value);
        try {
            // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
            return value ? JSON.parse(decodedFieldValue) : null;
        } catch  {
            // If parsing fails, we return the decoded value as-is
            return decodedFieldValue;
        }
    }
    return undefined;
};
const $a03bf89b29beef2f$export$a3c0d7af5d0c8b3 = (url)=>{
    const applinkCreationStatusLog = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkCreationStatusLog');
    if (!applinkCreationStatusLog) return null; // No creation state found
    const applinkStartingUrl = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkStartingUrl');
    const applinkStartingType = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkStartingType');
    const applinkOriginalCreatedId = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkOriginalCreatedId');
    const sharedUserbase = $a03bf89b29beef2f$var$getAndDecode(url, 'sharedUserbase') === 'true';
    const applinkConfigInUserAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigInUserAuth') === 'true';
    const applinkConfigInServerAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigInServerAuth') === 'true';
    const applinkConfigInPreAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigInPreAuth') === 'true';
    const applinkConfigOutUserAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigOutUserAuth') === 'true';
    const applinkConfigOutServerAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigOutServerAuth') === 'true';
    const applinkConfigOutPreAuth = $a03bf89b29beef2f$var$getAndDecode(url, 'applinkConfigOutPreAuth') === 'true';
    const creatingReciprocal = $a03bf89b29beef2f$var$getAndDecode(url, 'creatingReciprocal') === 'true';
    const statusLog = JSON.parse(applinkCreationStatusLog);
    return {
        applinkCreationStatusLog: statusLog,
        applinkOriginalCreatedId: applinkOriginalCreatedId || '',
        sharedUserbase: sharedUserbase,
        applinkConfigInUserAuth: applinkConfigInUserAuth,
        applinkConfigInServerAuth: applinkConfigInServerAuth,
        applinkConfigInPreAuth: applinkConfigInPreAuth,
        applinkConfigOutUserAuth: applinkConfigOutUserAuth,
        applinkConfigOutServerAuth: applinkConfigOutServerAuth,
        applinkConfigOutPreAuth: applinkConfigOutPreAuth,
        applinkStartingUrl: applinkStartingUrl || '',
        applinkStartingType: applinkStartingType || '',
        creatingReciprocal: creatingReciprocal
    };
};

});

parcelRegister("lOO86", function(module, exports) {
$parcel$export(module.exports, "outgoingCredentialsModalEntryPoint", () => $a15ad521e0fc4c11$export$3db8bdfccb0f1ca5);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a15ad521e0fc4c11$export$3db8bdfccb0f1ca5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7JnAQ")), {
        moduleId: "c3d8b27f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7JnAQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dbkyD").then(()=>parcelRequire('1GfCc'));

});




parcelRegister("40lC8", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa35e4554f311350$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $3L3Os = parcelRequire("3L3Os");
var $6svxr = parcelRequire("6svxr");
var $eRpdx = parcelRequire("eRpdx");
var $bUGwX = parcelRequire("bUGwX");
var $cDJ0f = parcelRequire("cDJ0f");
var $byJNH = parcelRequire("byJNH");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");
var $5bY40 = parcelRequire("5bY40");

var $c4OV1 = parcelRequire("c4OV1");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $iHPvF = parcelRequire("iHPvF");

var $4cTDP = parcelRequire("4cTDP");

var $83DiZ = parcelRequire("83DiZ");

var $lRq8t = parcelRequire("lRq8t");

var $eSnSE = parcelRequire("eSnSE");

var $8SMrZ = parcelRequire("8SMrZ");

var $d6B0e = parcelRequire("d6B0e");

var $dk6v8 = parcelRequire("dk6v8");

var $a4pY2 = parcelRequire("a4pY2");

var $ffsuj = parcelRequire("ffsuj");

var $bgrMr = parcelRequire("bgrMr");

var $gowAx = parcelRequire("gowAx");

var $9at1p = parcelRequire("9at1p");

var $3Ex3J = parcelRequire("3Ex3J");

var $6OnPZ = parcelRequire("6OnPZ");
const $aa35e4554f311350$export$ff9fb46b9505cd2c = [
    (0, $bgrMr.AUTH_OAUTH1),
    (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION),
    (0, $bgrMr.AUTH_DISABLED)
];
const $aa35e4554f311350$var$styles = {
    growField: "_16jlkb7n",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _19pkpxbi",
    formSectionInner: "_19pkpxbi",
    fieldNegativeMargin: "_19pkx0bf",
    colDirection: "_1bsbx19p",
    colOutgoing: "_1bsbhwvj",
    colIncoming: "_1bsbhwvj"
};
const $aa35e4554f311350$export$dd490e8ff53d5bdc = (localAuthLevel, remoteAuthLevel)=>{
    if (!localAuthLevel || !remoteAuthLevel) return 'mismatch';
    if (localAuthLevel === remoteAuthLevel) {
        if (localAuthLevel === (0, $bgrMr.AUTH_DISABLED)) return 'disabled';
        return 'match';
    }
    return 'mismatch';
};
const $aa35e4554f311350$var$ApplinksConnectedArrow = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formatAltText = (0, $eJOHy.useCallback)(()=>{
        switch(props.state){
            case 'match':
                return formatMessage((0, $3Ex3J.default).arrowMatchHoverText);
            case 'mismatch':
                return formatMessage((0, $3Ex3J.default).arrowMismatchHoverText);
            case 'disabled':
            default:
                return formatMessage((0, $3Ex3J.default).arrowDisabledHoverText);
        }
    }, [
        formatMessage,
        props.state
    ]); // Render the appropriate arrow icon based on the connection state
    return props.isIncoming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatAltText()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        height: "16px",
        src: (0, $6OnPZ.Arrows).incoming[props.state],
        alt: formatAltText()
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatAltText()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        height: "16px",
        src: (0, $6OnPZ.Arrows).outgoing[props.state],
        alt: formatAltText()
    }));
};
const $aa35e4554f311350$var$buildLocalisedAuthTypes = (formatMessage, selectableOnly)=>{
    const oauthLabel = 'OAuth';
    const impersonationLabel = formatMessage((0, $9at1p.default).authTypeImpersonation);
    const disabledLabel = formatMessage((0, $9at1p.default).authTypeDisabled);
    const oauth2Label = 'OAuth 2.0';
    if (selectableOnly) return [
        {
            label: oauthLabel,
            value: (0, $bgrMr.AUTH_OAUTH1)
        },
        {
            label: disabledLabel,
            value: (0, $bgrMr.AUTH_DISABLED)
        }
    ];
    return [
        {
            label: oauthLabel,
            value: (0, $bgrMr.AUTH_OAUTH1)
        },
        {
            label: impersonationLabel,
            value: (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION)
        },
        {
            label: disabledLabel,
            value: (0, $bgrMr.AUTH_DISABLED)
        },
        {
            label: oauth2Label,
            value: (0, $bgrMr.AUTH_OAUTH2)
        }
    ];
};
const $aa35e4554f311350$var$LocalAuthDetails = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getAuthOptions = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$var$buildLocalisedAuthTypes(formatMessage, true);
    }, [
        formatMessage
    ]);
    const getDefaultOption = (0, $eJOHy.useCallback)(()=>{
        const options = $aa35e4554f311350$var$buildLocalisedAuthTypes(formatMessage);
        const authLevel = (0, $bgrMr.getAuthLevel)(props.defaultOAuthConfig);
        return options.find((option)=>option.value === authLevel) || options[0];
    }, [
        formatMessage,
        props.defaultOAuthConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $aa35e4554f311350$var$styles.growField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $aa35e4554f311350$var$styles.fieldNegativeMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: props.name,
        defaultValue: getDefaultOption()
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            testId: `applinks-administration.ui.edit.oauth1.local-auth-select.${props.isIncoming ? 'incoming' : 'outgoing'}`,
            ...fieldProps,
            inputId: props.name,
            options: getAuthOptions()
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$ApplinksConnectedArrow, {
        isIncoming: props.isIncoming,
        state: props.state
    }));
};
const $aa35e4554f311350$var$RemoteAuthDetails = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getAuthDescription = (0, $eJOHy.useCallback)(()=>{
        const options = $aa35e4554f311350$var$buildLocalisedAuthTypes(formatMessage);
        const authLevel = (0, $bgrMr.getAuthLevel)(props.oauthConfig);
        return options.find((option)=>option.value === authLevel);
    }, [
        formatMessage,
        props.oauthConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100"
    }, props.type.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        appearance: "subtle",
        href: props.url
    }, props.type.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, getAuthDescription()?.label ?? formatMessage((0, $9at1p.default).authTypeUnknown)));
};
const $aa35e4554f311350$var$ConfigureAuthTable = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $byJNH.useFormState)({
        values: true
    });
    const getApplinkType = (0, $eJOHy.useCallback)(()=>{
        return (0, $a4pY2.lookupTypeFromV3Data)(props.applink);
    }, [
        props.applink
    ]);
    const getOutgoingMatchState = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$export$dd490e8ff53d5bdc(formState?.values.outgoingAuth?.value ?? undefined, (0, $bgrMr.getAuthLevel)(props.remoteAuth?.incoming));
    }, [
        props.remoteAuth,
        formState?.values.outgoingAuth
    ]);
    const getIncomingMatchState = (0, $eJOHy.useCallback)(()=>{
        return $aa35e4554f311350$export$dd490e8ff53d5bdc(formState?.values.incomingAuth?.value ?? undefined, (0, $bgrMr.getAuthLevel)(props.remoteAuth?.outgoing));
    }, [
        props.remoteAuth,
        formState?.values.incomingAuth
    ]);
    const showOAuthImpersonationError = (0, $eJOHy.useCallback)(()=>{
        const isLocalAuthImpersonation = formState?.values.incomingAuth?.value === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION);
        const isRemoteAuthImpersonation = formState?.values.outgoingAuth?.value === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION);
        if (isLocalAuthImpersonation || isRemoteAuthImpersonation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
            title: formatMessage((0, $3Ex3J.default).impersonationRemovedTitle),
            appearance: "error"
        }, formatMessage((0, $3Ex3J.default).impersonationRemovedDescription, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                    href: "https://confluence.atlassian.com/jirakb/end-of-support-for-2loi-application-links-950806698.html",
                    target: "_blank"
                }, chunks)
        }));
        return null;
    }, [
        formState?.values.incomingAuth?.value,
        formState?.values.outgoingAuth?.value,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, showOAuthImpersonationError(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("colgroup", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("col", {
        className: (0, $hcewu.default)([
            $aa35e4554f311350$var$styles.colDirection
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("col", {
        className: (0, $hcewu.default)([
            $aa35e4554f311350$var$styles.colOutgoing
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("col", {
        className: (0, $hcewu.default)([
            $aa35e4554f311350$var$styles.colIncoming
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("th", null, formatMessage((0, $3Ex3J.default).authTableColumnDirectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("th", null, formatMessage((0, $3Ex3J.default).authTableColumnLocalAuthenticationHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("th", null, formatMessage((0, $3Ex3J.default).authTableColumnRemoteAuthenticationHeading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "outgoingAuth"
    }, formatMessage((0, $3Ex3J.default).authTableRowDirectionOutgoing))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$LocalAuthDetails, {
        isIncoming: false,
        state: getOutgoingMatchState(),
        name: "outgoingAuth",
        defaultOAuthConfig: props.localAuth?.outgoing
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$RemoteAuthDetails, {
        type: getApplinkType(),
        url: props.applink.displayUrl,
        oauthConfig: props.remoteAuth?.incoming
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "incomingAuth"
    }, formatMessage((0, $3Ex3J.default).authTableRowDirectionIncoming))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$LocalAuthDetails, {
        isIncoming: true,
        state: getIncomingMatchState(),
        name: "incomingAuth",
        defaultOAuthConfig: props.localAuth?.incoming
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$RemoteAuthDetails, {
        type: getApplinkType(),
        url: props.applink.displayUrl,
        oauthConfig: props.remoteAuth?.outgoing
    }))))));
};
const $aa35e4554f311350$var$buildOAuthConfigFromOption = (option)=>{
    if (option?.value === (0, $bgrMr.AUTH_OAUTH1)) return {
        enabled: true,
        twoLoEnabled: true,
        twoLoImpersonationEnabled: false,
        oAuth2ThreeLoEnabled: false
    };
    if (option?.value === (0, $bgrMr.AUTH_OAUTH1_IMPERSONATION)) return {
        enabled: true,
        twoLoEnabled: true,
        twoLoImpersonationEnabled: true,
        oAuth2ThreeLoEnabled: false
    };
    return {
        enabled: false,
        twoLoEnabled: false,
        twoLoImpersonationEnabled: false,
        oAuth2ThreeLoEnabled: false
    };
};
const $aa35e4554f311350$var$ApplinksOAuth1EditPageContents = (props)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getListPageUrl = (0, $eJOHy.useCallback)(()=>{
        if ((0, $4cTDP.fg)('applinks-933-experimental-list-page')) return 0, $d6B0e.APPLINKS_LIST_PAGE_URL;
        return 0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY;
    }, []);
    const onFormSubmit = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            const supportedAuthTypes = $aa35e4554f311350$var$buildLocalisedAuthTypes(formatMessage, true);
            const isOutgoingAuthSupported = supportedAuthTypes.some((type)=>type.value === data.outgoingAuth?.value);
            const isIncomingAuthSupported = supportedAuthTypes.some((type)=>type.value === data.incomingAuth?.value);
            if (!isOutgoingAuthSupported) throw new Error(formatMessage((0, $3Ex3J.default).unsupportedAuthenticationType, {
                invalidAuthType: data.outgoingAuth?.label
            }));
            if (!isIncomingAuthSupported) throw new Error(formatMessage((0, $3Ex3J.default).unsupportedAuthenticationType, {
                invalidAuthType: data.incomingAuth?.label
            }));
            const applinkUpdate = {
                id: props.applink.id,
                type: props.applink.type,
                system: props.applink.system,
                primary: props.applink.primary,
                isExtraAuthRequired: props.applink.isExtraAuthRequired,
                // Only change these properties:
                name: data.displayName,
                displayUrl: data.displayUrl,
                rpcUrl: data.rpcUrl
            };
            await (0, $dk6v8.updateApplinkV3)(props.applink.id, applinkUpdate);
            await (0, $dk6v8.putApplinkOAuth1Config)(props.applink.id, {
                outgoing: $aa35e4554f311350$var$buildOAuthConfigFromOption(data.outgoingAuth),
                incoming: $aa35e4554f311350$var$buildOAuthConfigFromOption(data.incomingAuth)
            });
            await push(getListPageUrl());
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.edit.oauth1.submitEditForm', 'Failed to update OAuth 1.0 applink', maybeError);
            props.onDisplayError(maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText));
        }
    }, [
        formatMessage,
        getListPageUrl,
        props,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: onFormSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), {
            title: formatMessage((0, $3Ex3J.default).linkDetailsSectionHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.200",
            xcss: $aa35e4554f311350$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayName), {
            name: "displayName",
            defaultName: props.applink.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.DisplayUrl), {
            name: "displayUrl",
            defaultUrl: props.applink.displayUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SMrZ.ApplicationUrl), {
            name: "rpcUrl",
            defaultUrl: props.applink.rpcUrl,
            disabled: false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
            role: "presentation",
            className: (0, $hcewu.default)([
                $aa35e4554f311350$var$styles.dividerStyle
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), {
            title: formatMessage((0, $3Ex3J.default).connectionsTitle)
        }, props.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            space: "space.200",
            xcss: $aa35e4554f311350$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa35e4554f311350$var$ConfigureAuthTable, {
            applink: props.applink,
            localAuth: props.status.localAuthentication,
            remoteAuth: props.status.remoteAuthentication
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: (0, $ffsuj.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
            target: "_blank"
        }, formatMessage((0, $3Ex3J.default).goToRemoteSiteLink, {
            displayUrl: props.applink.displayUrl
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.200",
            xcss: $aa35e4554f311350$var$styles.formSectionInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $3Ex3J.default).applinkStatusLoadingText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRpdx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
            href: getListPageUrl(),
            appearance: "subtle"
        }, formatMessage((0, $3Ex3J.default).formCancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            testId: "applinks-administration.ui.edit.oauth1.submit-button",
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, formatMessage((0, $3Ex3J.default).formSaveButtonText))))))));
};
var $aa35e4554f311350$export$2e2bcd8739ae039 = $aa35e4554f311350$var$ApplinksOAuth1EditPageContents;

});
parcelRegister("6OnPZ", function(module, exports) {
$parcel$export(module.exports, "Arrows", () => $a5d2b3bcc7e3278e$export$b6e350ab9915297a);

var $jIZVM = parcelRequire("jIZVM");

var $ibibY = parcelRequire("ibibY");

var $1gBp2 = parcelRequire("1gBp2");

var $fjVPw = parcelRequire("fjVPw");

var $iVDm5 = parcelRequire("iVDm5");

var $hRUo4 = parcelRequire("hRUo4");
const $a5d2b3bcc7e3278e$export$b6e350ab9915297a = {
    incoming: {
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($jIZVM))),
        match: (0, (/*@__PURE__*/$parcel$interopDefault($ibibY))),
        mismatch: (0, (/*@__PURE__*/$parcel$interopDefault($1gBp2)))
    },
    outgoing: {
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fjVPw))),
        match: (0, (/*@__PURE__*/$parcel$interopDefault($iVDm5))),
        mismatch: (0, (/*@__PURE__*/$parcel$interopDefault($hRUo4)))
    }
};

});
parcelRegister("jIZVM", function(module, exports) {
module.exports = new URL("arrow-left-disabled.e64b3d04.svg", import.meta.url).toString();

});

parcelRegister("ibibY", function(module, exports) {
module.exports = new URL("arrow-left-match.5ea6990b.svg", import.meta.url).toString();

});

parcelRegister("1gBp2", function(module, exports) {
module.exports = new URL("arrow-left-mismatch.14c5dc32.svg", import.meta.url).toString();

});

parcelRegister("fjVPw", function(module, exports) {
module.exports = new URL("arrow-right-disabled.4aa73a65.svg", import.meta.url).toString();

});

parcelRegister("iVDm5", function(module, exports) {
module.exports = new URL("arrow-right-match.0de9f50b.svg", import.meta.url).toString();

});

parcelRegister("hRUo4", function(module, exports) {
module.exports = new URL("arrow-right-mismatch.65202d42.svg", import.meta.url).toString();

});






parcelRegister("bEyFu", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationEditRoute", () => $899c82c3a21534e2$export$25e5ee53e818565e);
const $899c82c3a21534e2$export$25e5ee53e818565e = {
    name: 'global-settings-products-applinks-administration-edit',
    path: '/jira/settings/applinks/:applinkId/edit',
    exact: true
};

});


parcelRegister("jMKrp", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationListRouteEntry", () => $e5caaaa42a42c8ec$export$3303093eb593ff88);

var $b0JRA = parcelRequire("b0JRA");

var $gEhrq = parcelRequire("gEhrq");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");
const $e5caaaa42a42c8ec$export$3303093eb593ff88 = (0, $6xToB.createEntry)((0, $gEhrq.applinksAdministrationListRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-administration',
        component: (0, $bJscI.componentWithFG)('applinks-933-new-applinks-frontend', (0, $b0JRA.default), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4cTDP.fg)('applinks-933-new-applinks-frontend'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-applinks-entries/src/applinksAdministrationListRouteEntry.tsx',
                whichExportToUse: 'applinksAdministrationListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("b0JRA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a1ba1e1efbdc264$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cH6Qf = parcelRequire("cH6Qf");

var $4EKqI = parcelRequire("4EKqI");

var $aV23b = parcelRequire("aV23b");

var $8uaaE = parcelRequire("8uaaE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a1ba1e1efbdc264$var$ListPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "applinks-administration-list-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uaaE.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null)));
var $3a1ba1e1efbdc264$export$2e2bcd8739ae039 = $3a1ba1e1efbdc264$var$ListPage;

});
parcelRegister("8uaaE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a882bd91925c92c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jJaSe = parcelRequire("jJaSe");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $lliUE = parcelRequire("lliUE");
const $1a882bd91925c92c$export$c2248d8896966a26 = ()=>{
    const [applinks, setApplinks] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        (0, $dk6v8.fetchApplinks)().then((data)=>{
            setApplinks(data);
        }).catch((err)=>{
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.list.loadApplinks', 'Failed to load applinks for the list page', maybeError);
            setApplinks(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lliUE.default), {
        applinks: applinks
    });
};
var $1a882bd91925c92c$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($1a882bd91925c92c$export$c2248d8896966a26);

});
parcelRegister("lliUE", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc3a3da1813e1f6b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $95O7y = parcelRequire("95O7y");
var $83DiZ = parcelRequire("83DiZ");

var $dk6v8 = parcelRequire("dk6v8");

var $ffsuj = parcelRequire("ffsuj");

var $d6B0e = parcelRequire("d6B0e");

var $hZFsF = parcelRequire("hZFsF");

var $4oJke = parcelRequire("4oJke");

var $7tuB3 = parcelRequire("7tuB3");

var $cYu93 = parcelRequire("cYu93");
const $fc3a3da1813e1f6b$var$styles = {
    applinksPageContents: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $fc3a3da1813e1f6b$var$getOperationFromCreationState = (creationState)=>{
    if (!creationState) return 'operation-list-applinks';
    const statusLog = creationState.applinkCreationStatusLog;
    if (statusLog.filter((entry)=>entry.status === (0, $ffsuj.STATUS_RECIPROCAL_SUCCESS)).length > 0) return 'operation-oauth1-complete-link';
    if (statusLog.filter((entry)=>entry.status === (0, $ffsuj.STATUS_RECIPROCAL_INPROGRESS)).length > 0) return 'operation-oauth1-reciprocal';
    return 'operation-list-applinks';
};
const $fc3a3da1813e1f6b$var$PartialApplinksPageContents = ()=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [oauth2RemoteApplicationUrl, _] = (0, $95O7y.useQueryParam)('oauth2RemoteApplication');
    const [localApplinkManifest, setLocalApplinkManifest] = (0, $eJOHy.useState)(null);
    const [remoteApplinkManifest, setRemoteApplinkManifest] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (oauth2RemoteApplicationUrl) {
            (0, $dk6v8.fetchApplinkManifestForUrl)(oauth2RemoteApplicationUrl).then((remoteManifest)=>{
                setRemoteApplinkManifest(remoteManifest);
            });
            (0, $dk6v8.fetchThisManifest)().then((localManifest)=>{
                setLocalApplinkManifest(localManifest);
            });
        }
    }, [
        oauth2RemoteApplicationUrl
    ]);
    const redirectBackToLegacyListPage = (0, $eJOHy.useCallback)(()=>{
        push((0, $d6B0e.APPLINKS_LIST_PAGE_URL_LEGACY));
    }, [
        push
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!oauth2RemoteApplicationUrl) redirectBackToLegacyListPage();
    }, [
        oauth2RemoteApplicationUrl,
        redirectBackToLegacyListPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "applinks-administration-partial-page",
        teamName: "olympus",
        packageName: "applinksAdministrationPartialPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fc3a3da1813e1f6b$var$styles.applinksPageContents
    }, localApplinkManifest && remoteApplinkManifest && oauth2RemoteApplicationUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tuB3.CreateFlowDialog), {
        isOpen: true,
        onExit: redirectBackToLegacyListPage,
        startingStage: {
            kind: 'review',
            variant: 'OAUTH2.0',
            localManifest: localApplinkManifest,
            remoteManifest: remoteApplinkManifest,
            rpcUrl: oauth2RemoteApplicationUrl
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        interactionName: "load",
        label: "Loading"
    })));
};
const $fc3a3da1813e1f6b$var$FullApplinksPageContents = (props)=>{
    const [createLinkDrawerOpen, setCreateLinkDrawerOpen] = (0, $eJOHy.useState)(false);
    const [creationState] = (0, $eJOHy.useState)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        return (0, $ffsuj.parseCreationStateFromUrl)(url);
    });
    const [operation, setOperation] = (0, $eJOHy.useState)('operation-list-applinks');
    const [thisApplicationManifest, setThisApplicationManifest] = (0, $eJOHy.useState)(null);
    const [targetApplicationManifest, setTargetApplicationManifest] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const op = $fc3a3da1813e1f6b$var$getOperationFromCreationState(creationState);
        setOperation(op);
    }, [
        creationState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (creationState) {
            // We expect to always have an applinkStartingUrl in the creation state for reciprocal review
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
            if (operation === 'operation-oauth1-reciprocal' && creationState.applinkStartingUrl) {
                (0, $dk6v8.fetchApplinkManifestForUrl)(creationState.applinkStartingUrl).then((remoteManifest)=>{
                    setTargetApplicationManifest(remoteManifest);
                });
                (0, $dk6v8.fetchThisManifest)().then((localManifest)=>{
                    setThisApplicationManifest(localManifest);
                });
            }
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
            if (operation === 'operation-oauth1-complete-link') // eslint-disable-next-line react-you-might-not-need-an-effect/no-chain-state-updates
            setCreateLinkDrawerOpen(true);
        }
    }, [
        creationState,
        operation
    ]);
    const [filter, setFilter] = (0, $eJOHy.useState)(null);
    const [search, setSearch] = (0, $eJOHy.useState)('');
    const closeDrawer = ()=>{
        setCreateLinkDrawerOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "applinks-administration-list-page",
        teamName: "olympus",
        packageName: "applinksAdministrationListPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fc3a3da1813e1f6b$var$styles.applinksPageContents
    }, operation === 'operation-list-applinks' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4oJke.default), {
        onSearch: setSearch,
        onFilterChange: setFilter,
        onCreateLink: ()=>setCreateLinkDrawerOpen(true),
        filter: filter,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZFsF.default), {
        applinks: props.applinks,
        filter: filter,
        search: search
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tuB3.CreateFlowDialog), {
        isOpen: createLinkDrawerOpen,
        onExit: closeDrawer
    }))), operation === 'operation-oauth1-reciprocal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, (!thisApplicationManifest || !targetApplicationManifest) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        interactionName: "load",
        label: "Loading"
    }), thisApplicationManifest && targetApplicationManifest && creationState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYu93.default), {
        state: {
            kind: 'reciprocal-review',
            variant: 'OAUTH1.0',
            localManifest: thisApplicationManifest,
            remoteManifest: targetApplicationManifest,
            inboundCreationState: creationState,
            rpcUrl: targetApplicationManifest.url
        },
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: closeDrawer,
        // TODO: Handle error
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    })), operation === 'operation-oauth1-complete-link' && creationState?.applinkOriginalCreatedId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tuB3.CreateFlowDialog), {
        isOpen: createLinkDrawerOpen,
        onExit: closeDrawer,
        startingStage: {
            kind: 'confirmation',
            variant: 'OAUTH1.0',
            confirmationApplinkId: creationState?.applinkOriginalCreatedId
        }
    }))));
};
const $fc3a3da1813e1f6b$var$ApplinksPageContents = (props)=>{
    if ((0, $4cTDP.fg)('applinks-933-experimental-list-page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc3a3da1813e1f6b$var$FullApplinksPageContents, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc3a3da1813e1f6b$var$PartialApplinksPageContents, null);
};
var $fc3a3da1813e1f6b$export$2e2bcd8739ae039 = $fc3a3da1813e1f6b$var$ApplinksPageContents;

});
parcelRegister("hZFsF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8540b8ed37325dee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $aWndL = parcelRequire("aWndL");
var $bbUsH = parcelRequire("bbUsH");
var $6DZFN = parcelRequire("6DZFN");
var $g7LKe = parcelRequire("g7LKe");
var $jc89b = parcelRequire("jc89b");
var $d7Jct = parcelRequire("d7Jct");

var $NByNW = parcelRequire("NByNW");

var $2R0ne = parcelRequire("2R0ne");

var $Ay1uj = parcelRequire("Ay1uj");

var $kJsb4 = parcelRequire("kJsb4");

var $jdqdp = parcelRequire("jdqdp");

var $7saMl = parcelRequire("7saMl");
var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $7ep4S = parcelRequire("7ep4S");

var $806LH = parcelRequire("806LH");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $a4pY2 = parcelRequire("a4pY2");
const $8540b8ed37325dee$var$contentStyles = {
    status: "_bozgpxbi _y4tipxbi _1q51pxbi _85i5pxbi _p12fdgin _1ul9nklw",
    menu: "_p12fdgin _1ul9nklw"
};
const $8540b8ed37325dee$var$ApplicationLinkProduct = (props)=>{
    const typeDef = (0, $a4pY2.lookupTypeFromV3Data)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignBlock: "center",
        space: "space.100"
    }, typeDef.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, props.displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtle",
        size: "small"
    }, typeDef.name))));
};
const $8540b8ed37325dee$var$ApplicationLinkName = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, props.name);
};
const $8540b8ed37325dee$var$ApplicationLinkType = (props)=>{
    const appendLozenges = (isPrimary, isSystem, isExtraAuthRequired)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isPrimary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            key: "primary"
        }, "Primary"), isExtraAuthRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            key: "extra-auth"
        }, "Extra Auth"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignBlock: "center",
        space: "space.100"
    }, appendLozenges(props.primary, props.system, props.isExtraAuthRequired));
};
const $8540b8ed37325dee$var$LozengeWithContext = (props)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: props.appearance
    }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $8540b8ed37325dee$var$contentStyles.status
            }, props.content),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))),
                label: `Additional information about ${props.label} status`,
                appearance: "subtle",
                onClick: ()=>setIsOpen(!isOpen)
            })
    }));
};
const $8540b8ed37325dee$var$ApplicationLinkStatus = (props)=>{
    const [applinkStatus, setApplinkStatus] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // If the applink is a system link, we don't need to fetch its status
        if (props.system) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setApplinkStatus('system');
            return;
        }
        // TODO: Properly mock data
        (0, $dk6v8.fetchApplinkStatus)(props.id).then((status)=>{
            setApplinkStatus(status);
        }).catch((err)=>{
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.list.fetchApplinkStatus', `Failed to fetch applink status for the table row belonging to applink ${props.id}`, maybeError);
        });
    }, [
        props.id,
        props.system
    ]);
    // TODO: Pop-ups
    const createLozenge = (contents)=>{
        if (contents === 'system') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$LozengeWithContext, {
            appearance: "default",
            label: "System",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                size: "small"
            }, "Internal System Link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, "This is an internal link to a Cloud server, created automatically by the system. System internal links are read-only and cannot be edited."))
        });
        // First, check if the link is working
        if (contents.working) // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "success"
        }, "Connected");
        // Next, check if there is an error
        if (contents.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$LozengeWithContext, {
            appearance: "removed",
            label: "Config Error",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                size: "small"
            }, "Config Error"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, JSON.stringify(contents.error)))
        });
        // TODO: Others
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), null, "Unknown");
    };
    return applinkStatus ? createLozenge(applinkStatus) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null);
};
const $8540b8ed37325dee$var$onDeleteButtonClick = (applink)=>{
    (0, $dk6v8.deleteApplink)(applink.id);
};
const $8540b8ed37325dee$var$ApplicationLinkPopupMenuContent = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $8540b8ed37325dee$var$contentStyles.menu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: props.data.displayUrl + (0, $d6B0e.APPLINKS_LIST_PAGE_URL)
    }, "Go to remote")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        title: "Manage link",
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $d6B0e.APPLINKS_EDIT_PAGE_URL_FOR_ID)(props.data.id)
    }, "Edit"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: ()=>$8540b8ed37325dee$var$onDeleteButtonClick(props.data)
    }, "Delete"))));
};
const $8540b8ed37325dee$var$ApplicationLinkPopupMenu = (props)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkPopupMenuContent, {
                data: props.data
            }),
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...triggerProps,
                isSelected: isOpen,
                label: "Additional actions",
                onClick: ()=>{
                    setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW)))
            })
    });
};
const $8540b8ed37325dee$var$convertToArray = (applinks)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return applinks.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $8540b8ed37325dee$var$ApplinksTable = (props)=>{
    const applinkItems = props.applinks ? $8540b8ed37325dee$var$convertToArray(props.applinks) : undefined;
    const filteredApplinkItems = applinkItems?.filter((item)=>{
        let passesFilter = true;
        if (props.filter) passesFilter = item.content.type === props.filter;
        let passesSearch = true;
        if (props.search && props.search.length > 0) {
            const nameCondition = item.content.name.toLowerCase().includes(props.search.toLowerCase());
            const urlCondition = item.content.displayUrl.toLowerCase().includes(props.search.toLowerCase());
            passesSearch = nameCondition || urlCondition;
        }
        return passesFilter && passesSearch;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bbUsH.default), {
        label: "Application Links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g7LKe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "20%"
    }, "Name"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "40%"
    }, "Application"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "15%"
    }, "Link properties"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "15%"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "10%"
    }, "Actions")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d7Jct.default), {
        items: filteredApplinkItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jc89b.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkName, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkProduct, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkType, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkStatus, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8540b8ed37325dee$var$ApplicationLinkPopupMenu, {
                data: item.content
            })));
            return row;
        }
    }));
};
var $8540b8ed37325dee$export$2e2bcd8739ae039 = $8540b8ed37325dee$var$ApplinksTable;

});
parcelRegister("aWndL", function(module, exports) {
$parcel$export(module.exports, "default", () => $727f0221e6a5ee26$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bl7J3 = parcelRequire("bl7J3");

var $kyoiK = parcelRequire("kyoiK");

var $1MX01 = parcelRequire("1MX01");
const $727f0221e6a5ee26$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bl7J3.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 25px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyoiK.default), {
            isSingleLine: singleLine,
            children: children
        })
    });
const $727f0221e6a5ee26$var$Cell = (0, $1MX01.default)($727f0221e6a5ee26$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$727f0221e6a5ee26$export$2e2bcd8739ae039 = $727f0221e6a5ee26$var$Cell;

});
parcelRegister("bl7J3", function(module, exports) {
$parcel$export(module.exports, "default", () => $4df9499a77c4915d$export$2e2bcd8739ae039);
/* common-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4df9499a77c4915d$var$commonStyles = null;
/**
 * __Common cell__
 */ const $4df9499a77c4915d$var$CommonCell = ({ indent: indent, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "gridcell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1yt413wy _11c82smr _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syaz1fxt _ct361wug _1nmz1hna",
            className
        ]),
        ...props,
        style: {
            '--indent': indent,
            width: width
        }
    });
var $4df9499a77c4915d$export$2e2bcd8739ae039 = $4df9499a77c4915d$var$CommonCell;

});

parcelRegister("kyoiK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e14331f7adddd461$export$2e2bcd8739ae039);
/* overflow-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $e14331f7adddd461$var$overflowContainerStyles = null;
/**
 * __Overflow container__
 */ const $e14331f7adddd461$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
var $e14331f7adddd461$export$2e2bcd8739ae039 = $e14331f7adddd461$var$OverflowContainer;

});

parcelRegister("1MX01", function(module, exports) {
$parcel$export(module.exports, "default", () => $a05410bc0b4803d0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3aOWR = parcelRequire("3aOWR");
function $a05410bc0b4803d0$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $eJOHy.useContext)((0, $3aOWR.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $eJOHy.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("3aOWR", function(module, exports) {
$parcel$export(module.exports, "TableTreeContext", () => $c23d70ac0b4a1a7a$export$662c2d348d8b71af);

var $eJOHy = parcelRequire("eJOHy");
const $c23d70ac0b4a1a7a$export$662c2d348d8b71af = /*#__PURE__*/ (0, $eJOHy.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("bbUsH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db025bccbaa3430$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aWndL = parcelRequire("aWndL");

var $6DZFN = parcelRequire("6DZFN");

var $g7LKe = parcelRequire("g7LKe");

var $3aOWR = parcelRequire("3aOWR");

var $jc89b = parcelRequire("jc89b");

var $d7Jct = parcelRequire("d7Jct");
const $4db025bccbaa3430$var$emptyColumnWidths = [];
function $4db025bccbaa3430$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $4db025bccbaa3430$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $eJOHy.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $eJOHy.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $eJOHy.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g7LKe.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6DZFN.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aOWR.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d7Jct.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jc89b.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aWndL.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4db025bccbaa3430$export$2e2bcd8739ae039 = $4db025bccbaa3430$var$TableTree;

});
parcelRegister("6DZFN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e112ae7995fbe351$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bl7J3 = parcelRequire("bl7J3");

var $1MX01 = parcelRequire("1MX01");
const $e112ae7995fbe351$var$headerStyles = null;
const $e112ae7995fbe351$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bl7J3.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1n3s _k48pmoej"
        ]),
        children: children
    });
};
const $e112ae7995fbe351$var$Header = (0, $1MX01.default)($e112ae7995fbe351$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e112ae7995fbe351$export$2e2bcd8739ae039 = $e112ae7995fbe351$var$Header;

});

parcelRegister("g7LKe", function(module, exports) {
$parcel$export(module.exports, "default", () => $06bc79397bea7b5d$export$2e2bcd8739ae039);
/* headers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
/* eslint-disable @repo/internal/react/no-clone-element */ const $06bc79397bea7b5d$var$containerStyles = null;
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $06bc79397bea7b5d$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "row",
        className: (0, $hcewu.default)([
            "_179ruzq5 _1e0c1txw"
        ]),
        children: (0, $eJOHy.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $eJOHy.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
var $06bc79397bea7b5d$export$2e2bcd8739ae039 = $06bc79397bea7b5d$var$Headers;

});

parcelRegister("jc89b", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf8beb3348645bd$export$2e2bcd8739ae039);
/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $aNavI = parcelRequire("aNavI");

var $92O4O = parcelRequire("92O4O");

var $el72P = parcelRequire("el72P");
const $2bf8beb3348645bd$var$treeRowClickableStyles = null;
const $2bf8beb3348645bd$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $2bf8beb3348645bd$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $eJOHy.useState)(isDefaultExpanded || false);
    (0, $eJOHy.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded
    ]);
    const onExpand = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle(e);
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = (e)=>{
        e.stopPropagation();
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $2bf8beb3348645bd$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $92O4O.default), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $aNavI.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $el72P.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $hcewu.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2bf8beb3348645bd$export$2e2bcd8739ae039 = $2bf8beb3348645bd$var$Row;

});
parcelRegister("aNavI", function(module, exports) {
$parcel$export(module.exports, "default", () => $6956e04f75657d96$export$2e2bcd8739ae039);
function $6956e04f75657d96$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("92O4O", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cf799ea980e2a05$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $3Vuhz = parcelRequire("3Vuhz");

var $5lAAn = parcelRequire("5lAAn");

var $dB1eP = parcelRequire("dB1eP");

var $el72P = parcelRequire("el72P");
/**
 * Internal chevron component.
 */ const $6cf799ea980e2a05$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $3Vuhz.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $el72P.ChevronContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
                    ...iconProps,
                    size: "small"
                }),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
var $6cf799ea980e2a05$export$2e2bcd8739ae039 = $6cf799ea980e2a05$var$Chevron;

});
parcelRegister("el72P", function(module, exports) {
$parcel$export(module.exports, "TreeRowContainer", () => $3d27782ed3099f7a$export$802d2031792f9e4);
$parcel$export(module.exports, "ChevronContainer", () => $3d27782ed3099f7a$export$f25bd028f55b3d30);
$parcel$export(module.exports, "LoaderItemContainer", () => $3d27782ed3099f7a$export$94ae573de7227397);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3d27782ed3099f7a$var$treeRowContainerStyles = null;
const $3d27782ed3099f7a$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "row",
        ...props,
        className: (0, $hcewu.default)([
            "_179r17ba _1e0c1txw"
        ])
    });
const $3d27782ed3099f7a$var$commonCellElementStyles = null;
const $3d27782ed3099f7a$var$commonChevronContainerStyles = null;
const $3d27782ed3099f7a$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1pfhj39m"
        ])
    });
const $3d27782ed3099f7a$var$loadingItemContainerStyles = null;
const $3d27782ed3099f7a$var$paddingLeftStyles = null;
const $3d27782ed3099f7a$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });

});



parcelRegister("d7Jct", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd42495ce8992cb6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8EL9v = parcelRequire("8EL9v");
function $dd42495ce8992cb6$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8EL9v.default), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd42495ce8992cb6$export$2e2bcd8739ae039 = $dd42495ce8992cb6$var$Rows;

});
parcelRegister("8EL9v", function(module, exports) {
$parcel$export(module.exports, "default", () => $30023d54d6530c8a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7Lwkh = parcelRequire("7Lwkh");

var $2r8We = parcelRequire("2r8We");
function $30023d54d6530c8a$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $eJOHy.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2r8We.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Lwkh.default), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$30023d54d6530c8a$export$2e2bcd8739ae039 = $30023d54d6530c8a$var$Items;

});
parcelRegister("7Lwkh", function(module, exports) {
$parcel$export(module.exports, "default", () => $83353e3299386c98$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-clone-element */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aNavI = parcelRequire("aNavI");

var $8EL9v = parcelRequire("8EL9v");
/**
 * __Item__
 * Internal item component.
 */ function $83353e3299386c98$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $eJOHy.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                id: !!itemId ? (0, $aNavI.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8EL9v.default), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
var $83353e3299386c98$export$2e2bcd8739ae039 = $83353e3299386c98$var$Item;

});

parcelRegister("2r8We", function(module, exports) {
$parcel$export(module.exports, "default", () => $827b28a057ae9eef$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $bl7J3 = parcelRequire("bl7J3");

var $el72P = parcelRequire("el72P");
const $827b28a057ae9eef$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $eJOHy.useState)('loading');
    (0, $eJOHy.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $el72P.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bl7J3.default), {
            indent: `calc(${"var(--ds-space-300, 25px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $el72P.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$827b28a057ae9eef$export$2e2bcd8739ae039 = $827b28a057ae9eef$var$LoaderItem;

});





parcelRegister("4oJke", function(module, exports) {
$parcel$export(module.exports, "default", () => $19255e48ef2dd28d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $5CSKW = parcelRequire("5CSKW");

var $sY9BV = parcelRequire("sY9BV");

var $dt3aG = parcelRequire("dt3aG");

var $KDB2z = parcelRequire("KDB2z");

var $a03qM = parcelRequire("a03qM");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $eJ9f5 = parcelRequire("eJ9f5");

var $a4pY2 = parcelRequire("a4pY2");
const $19255e48ef2dd28d$var$styles = {
    searchBox: "_16jlidpf _1o9zidpf _i0dl1mjv"
};
const $19255e48ef2dd28d$var$ApplinksHeader = (props)=>{
    const createFilteredIconButton = ({ triggerRef: triggerRef, ...triggerProps })=>{
        if (props.filter) {
            const typeDef = (0, $a4pY2.lookupType)(props.filter);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))),
                isSelected: true,
                ref: triggerRef
            }, typeDef.name);
        }
        return(// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            ...triggerProps,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))),
            ref: triggerRef
        }, "All Apps"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "large"
    }, "Application Links"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: props.onCreateLink
    }, "Create link")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, "Application links let you integrate Jira with another Atlassian product or external application so they can exchange information, resources, and functionalities. What exactly is exchanged will depend on the applications you link.", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/"
    }, "Learn more about application links")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $19255e48ef2dd28d$var$styles.searchBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        placeholder: "Search application links",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
            label: "Search application links"
        }),
        onChange: (e)=>{
            props.onSearch(e.currentTarget.value);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: createFilteredIconButton,
        shouldRenderToParent: true
    }, props.filter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: "all",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
            label: "Clear filter"
        }),
        onClick: ()=>props.onFilterChange(null)
    }, "Clear selection")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        title: "Cloud"
    }, Object.entries((0, $a4pY2.TypeIdMap)).filter(([key])=>(0, $a4pY2.TypeIdMap)[key].category === 'cloud').map(([key, typeDef])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            key: key,
            elemBefore: typeDef.icon,
            onClick: ()=>props.onFilterChange(key)
        }, typeDef.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        title: "Data Center"
    }, Object.entries((0, $a4pY2.TypeIdMap)).filter(([key])=>(0, $a4pY2.TypeIdMap)[key].category === 'dc').map(([key, typeDef])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            key: key,
            elemBefore: typeDef.icon,
            onClick: ()=>props.onFilterChange(key)
        }, typeDef.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        title: "Miscellaneous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: "generic",
        elemBefore: (0, $a4pY2.TypeIdMap).generic.icon,
        onClick: ()=>props.onFilterChange('generic')
    }, (0, $a4pY2.TypeIdMap).generic.name))))));
};
var $19255e48ef2dd28d$export$2e2bcd8739ae039 = $19255e48ef2dd28d$var$ApplinksHeader;

});

parcelRegister("7tuB3", function(module, exports) {
$parcel$export(module.exports, "CreateFlowDialog", () => $e50c2ab5159790fc$export$79c286a92b7787f2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6K9yc = parcelRequire("6K9yc");
var $dSmxJ = parcelRequire("dSmxJ");

var $6djmC = parcelRequire("6djmC");

var $7ep4S = parcelRequire("7ep4S");

var $2pgjF = parcelRequire("2pgjF");

var $lRq8t = parcelRequire("lRq8t");

var $ekP6G = parcelRequire("ekP6G");

var $cYu93 = parcelRequire("cYu93");

var $1E9Rd = parcelRequire("1E9Rd");

var $3DmnW = parcelRequire("3DmnW");

var $4pa0Z = parcelRequire("4pa0Z");

var $22H8z = parcelRequire("22H8z");
const $e50c2ab5159790fc$var$DEFAULT_CREATE_STAGE = {
    kind: 'create'
};
const $e50c2ab5159790fc$var$StateMachine = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    switch(props.state.kind){
        case 'create':
        case 'manual-create':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ekP6G.default), {
                onError: props.onDisplayError,
                onSuccess: props.onStateChange,
                onCancel: props.onCancel
            });
        case 'review':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYu93.default), {
                state: props.state,
                onSuccess: props.onStateChange,
                onError: props.onDisplayError,
                onCancel: props.onCancel
            });
        case 'reciprocal-prompt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1E9Rd.default), {
                state: props.state
            });
        case 'connect':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4pa0Z.default), {
                state: props.state,
                onSuccess: props.onCancel,
                onError: props.onDisplayError,
                onCancel: props.onCancel
            });
        case 'confirmation':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DmnW.default), {
                state: props.state
            });
        case 'loading':
            props.state.promise.then((newState)=>{
                props.onStateChange(newState);
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    }
});
const $e50c2ab5159790fc$export$79c286a92b7787f2 = (props)=>{
    // Use the provided starting stage or default to the create stage
    const [flowState, setFlowState] = (0, $eJOHy.useState)(props.startingStage || $e50c2ab5159790fc$var$DEFAULT_CREATE_STAGE);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onCancel = ()=>{
        props.onExit();
        const defaultStage = props.startingStage || $e50c2ab5159790fc$var$DEFAULT_CREATE_STAGE;
        setFlowState(defaultStage);
    };
    const [errorFlags, setErrorFlags] = (0, $eJOHy.useState)([]);
    const addFlag = (0, $eJOHy.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K9yc.Drawer), {
        testId: "applinks-administration.ui.list.creation-flow-dialog.drawer",
        width: "full",
        onClose: ()=>onCancel(),
        onCloseComplete: props.onCloseComplete,
        isOpen: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSmxJ.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e50c2ab5159790fc$var$StateMachine, {
        state: flowState,
        onStateChange: setFlowState,
        onCancel: onCancel,
        onDisplayError: addFlag
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.ErrorFlag), {
            id: `flag-${idx}`,
            key: `flag-${idx}`,
            title: formatMessage((0, $22H8z.default).errorFlagTitle),
            description: err
        });
    })));
};

});
parcelRegister("ekP6G", function(module, exports) {
$parcel$export(module.exports, "default", () => $5333e4d79e61181d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $5toMF = parcelRequire("5toMF");
var $bUGwX = parcelRequire("bUGwX");
var $lP4Q7 = parcelRequire("lP4Q7");

var $sY9BV = parcelRequire("sY9BV");

var $a6tuu = parcelRequire("a6tuu");

var $lRq8t = parcelRequire("lRq8t");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $gowAx = parcelRequire("gowAx");

var $1IHCZ = parcelRequire("1IHCZ");

var $cjcvQ = parcelRequire("cjcvQ");
const $5333e4d79e61181d$var$styles = {
    fullContainer: "_4t3i1osq"
};
const $5333e4d79e61181d$var$linkTypeRadioOptions = [
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        name: 'linkType',
        value: 'OAUTH2.0',
        label: 'Atlassian product via OAuth 2.0'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        name: 'linkType',
        value: 'OAUTH1.0',
        label: 'Direct application link via OAuth 1.0'
    },
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    {
        name: 'linkType',
        value: 'TUNNEL',
        label: 'Existing application tunnel'
    }
];
const $5333e4d79e61181d$var$CreateSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onFormSubmit = async (data)=>{
        try {
            const remoteManifestPromise = (0, $dk6v8.fetchApplinkManifestForUrl)(data.remoteUrl);
            const localManifestPromise = (0, $dk6v8.fetchThisManifest)();
            const remoteManifest = await remoteManifestPromise;
            const localManifest = await localManifestPromise;
            // Check the remote application supports the selected variant type
            if (data.linkType === 'OAUTH2.0' && !remoteManifest.inboundAuthenticationTypes.includes((0, $d6B0e.APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK))) // TODO: Better error message - maybe a custom dialogue?
            throw new Error('The remote application does not support OAuth 2.0 authentication. Please select a different link type.');
            props.onSuccess({
                kind: 'review',
                variant: data.linkType,
                localManifest: localManifest,
                remoteManifest: remoteManifest,
                rpcUrl: data.remoteUrl
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            if (data.linkType === 'OAUTH1.0') props.onSuccess({
                kind: 'manual-create',
                variant: 'OAUTH1.0',
                error: maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText)
            });
            else {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.create.submitCreateForm', 'Failed to submit create form', maybeError);
                props.onError(maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText));
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: onFormSubmit,
        xcss: $5333e4d79e61181d$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1IHCZ.SubpageTemplate), {
            variant: null,
            kind: "create",
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), {
                label: "Form submit options"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, "Next")),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5toMF.default), {
                title: formatMessage((0, $cjcvQ.default).createHeaderText)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, `${formatMessage((0, $cjcvQ.default).applicationLinkInformationText)} `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/",
                target: "_blank"
            }, ' ', formatMessage((0, $cjcvQ.default).applicationLinkHowToLinkText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                size: "small"
            }, "Required fields are marked with an asterisk ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lP4Q7.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), {
                title: "Application link type"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                label: "Link type",
                name: "linkType",
                defaultValue: "OAUTH2.0",
                isRequired: true
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a6tuu.default), {
                    ...fieldProps,
                    options: $5333e4d79e61181d$var$linkTypeRadioOptions
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, "Check the application's documentation for supported link types")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bUGwX.default), {
                title: "External application details"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                "aria-required": true,
                name: "remoteUrl",
                label: "Application URL",
                isRequired: true
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                    autoComplete: "off",
                    placeholder: "https://example.atlassian.net",
                    ...fieldProps
                }), !error && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, "Enter the URL for the Atlassian product "), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, "You must enter a valid URL")))))
        })));
};
var $5333e4d79e61181d$export$2e2bcd8739ae039 = $5333e4d79e61181d$var$CreateSubpage;

});
parcelRegister("5toMF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fdcc349995b46d5$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $2fdcc349995b46d5$var$formHeaderContentStyles = null;
const $2fdcc349995b46d5$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $2fdcc349995b46d5$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
var $2fdcc349995b46d5$export$2e2bcd8739ae039 = $2fdcc349995b46d5$var$FormHeader;

});

parcelRegister("a6tuu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $de7bef9bf1f92e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $gPG64 = parcelRequire("gPG64");
const $de7bef9bf1f92e14$var$noOptions = [];
function $de7bef9bf1f92e14$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $de7bef9bf1f92e14$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $3Vuhz.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gl2vi.useId)();
    const [selectedValue, setSelectedValue] = (0, $eJOHy.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $gPG64.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("gPG64", function(module, exports) {
$parcel$export(module.exports, "default", () => $e69f9767f170f926$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");
const $e69f9767f170f926$var$packageName = "platform-pkg";
const $e69f9767f170f926$var$packageVersion = "0.0.0-use.local";
const $e69f9767f170f926$var$noop = (0, $3Vuhz.default);
const $e69f9767f170f926$var$labelPaddingStyles = null;
const $e69f9767f170f926$var$labelStyles = null;
const $e69f9767f170f926$var$radioStyles = null;
const $e69f9767f170f926$var$newRadioStyles = null;
const $e69f9767f170f926$var$InnerRadio = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $e69f9767f170f926$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $e69f9767f170f926$var$packageName,
        packageVersion: $e69f9767f170f926$var$packageVersion
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hcewu.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _2kbk1y1w _6cyr1y1w _n8t01y1w _1o5r1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1if1zcs9 _bl0ezcs9 _92nazcs9 _awurzcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _wml015t7 _tusm15t7 _1c6f15t7 _qftt15t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvjdfc _1bg41l7b _6tjkjdfc _awqn1l7b _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $eGOwo.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $e69f9767f170f926$var$Radio = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e69f9767f170f926$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $e69f9767f170f926$export$2e2bcd8739ae039 = $e69f9767f170f926$var$Radio;

});


parcelRegister("1IHCZ", function(module, exports) {
$parcel$export(module.exports, "SubpageTemplate", () => $170907c9642a1ce1$export$10a563abcf67156);
/* SubpageTemplate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $avQYn = parcelRequire("avQYn");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $aRF1Q = parcelRequire("aRF1Q");

var $6zhpo = parcelRequire("6zhpo");

var $lRq8t = parcelRequire("lRq8t");

var $22H8z = parcelRequire("22H8z");
const $170907c9642a1ce1$var$styles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _4t3i1osq",
    mainContentInner: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1c3h",
    mainContent: "_16jlkb7n _1o9zidpf _i0dl1wug _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
    footerContent: "_1o9zidpf",
    footerContentInner: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1c3h",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _19pkpxbi"
};
const $170907c9642a1ce1$var$UNKNOWN_STEP_ORDER = [
    'create',
    'unknown'
];
const $170907c9642a1ce1$var$OAUTH1_STEP_ORDER = [
    'create',
    'review',
    'reciprocal-prompt',
    'confirmation'
];
const $170907c9642a1ce1$var$OAUTH2_STEP_ORDER = [
    'create',
    'review',
    'connect'
];
const $170907c9642a1ce1$var$STEP_NAMES = {
    create: (0, $22H8z.default).createStepName,
    review: (0, $22H8z.default).reviewStepName,
    'reciprocal-prompt': (0, $22H8z.default).reciprocalPromptStepNameNonfinal,
    connect: (0, $22H8z.default).connectStepName,
    confirmation: (0, $22H8z.default).confirmationStepNameNonfinal,
    unknown: (0, $22H8z.default).unknownStepNameNonfinal
};
const $170907c9642a1ce1$var$determineStepPercentage = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 50; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 100;
    if (currentIndex === targetIndex) return 0;
    return 0;
};
const $170907c9642a1ce1$var$determineStepStatus = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 'current'; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 'disabled';
    if (currentIndex === targetIndex) return 'current';
    return 'unvisited';
};
const $170907c9642a1ce1$var$buildSteps = (step, sequence, formatMessage)=>{
    return sequence.map((s)=>({
            id: s,
            label: formatMessage($170907c9642a1ce1$var$STEP_NAMES[s]),
            percentageComplete: $170907c9642a1ce1$var$determineStepPercentage(step, s, sequence),
            status: $170907c9642a1ce1$var$determineStepStatus(step, s, sequence),
            href: '#'
        }));
};
const $170907c9642a1ce1$var$buildProgressTrackerItems = (step, variant, formatMessage)=>{
    if (variant === null) return $170907c9642a1ce1$var$buildSteps(step, $170907c9642a1ce1$var$UNKNOWN_STEP_ORDER, formatMessage);
    switch(variant){
        case 'OAUTH1.0':
            return $170907c9642a1ce1$var$buildSteps(step, $170907c9642a1ce1$var$OAUTH1_STEP_ORDER, formatMessage);
        case 'TUNNEL':
            return $170907c9642a1ce1$var$buildSteps(step, $170907c9642a1ce1$var$OAUTH1_STEP_ORDER, formatMessage);
        // Tunnel uses the same steps as OAUTH1.0
        case 'OAUTH2.0':
            return $170907c9642a1ce1$var$buildSteps(step, $170907c9642a1ce1$var$OAUTH2_STEP_ORDER, formatMessage);
        default:
            return [];
    }
};
const $170907c9642a1ce1$export$8b251419efc915eb = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getItems = (0, $eJOHy.useCallback)(()=>{
        return $170907c9642a1ce1$var$buildProgressTrackerItems(props.kind, props.variant, formatMessage);
    }, [
        formatMessage,
        props.kind,
        props.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avQYn.DrawerCloseButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRF1Q.default), {
        items: getItems(),
        spacing: "comfortable"
    }));
};
const $170907c9642a1ce1$export$a06f1c675e846f6f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $170907c9642a1ce1$var$styles.footerContentInner,
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "end",
        space: "space.050"
    }, props.buttons));
};
const $170907c9642a1ce1$export$10a563abcf67156 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $170907c9642a1ce1$var$styles.container,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($170907c9642a1ce1$export$8b251419efc915eb, {
        variant: props.variant,
        kind: props.kind
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
        role: "presentation",
        className: (0, $hcewu.default)([
            $170907c9642a1ce1$var$styles.dividerStyle
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $170907c9642a1ce1$var$styles.mainContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $170907c9642a1ce1$var$styles.mainContentInner
    }, props.content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $170907c9642a1ce1$var$styles.footerContent,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
        role: "presentation",
        className: (0, $hcewu.default)([
            $170907c9642a1ce1$var$styles.dividerStyle
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($170907c9642a1ce1$export$a06f1c675e846f6f, {
        buttons: props.buttons
    })));

});
parcelRegister("aRF1Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $673a88fb7ded6f73$export$2e2bcd8739ae039);
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dn13J = parcelRequire("dn13J");

var $bWzAa = parcelRequire("bWzAa");
const $673a88fb7ded6f73$var$containerStyles = null;
const $673a88fb7ded6f73$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $673a88fb7ded6f73$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line @atlassian/a11y/anchor-has-content
        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dn13J.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $eJOHy.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $eJOHy.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bWzAa.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $673a88fb7ded6f73$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
var $673a88fb7ded6f73$export$2e2bcd8739ae039 = $673a88fb7ded6f73$var$ProgressTracker;

});
parcelRegister("dn13J", function(module, exports) {
$parcel$export(module.exports, "default", () => $151739357ade899d$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lc0OY = parcelRequire("lc0OY");
const $151739357ade899d$var$styles = {
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _11c81kw7 _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Progress tracker link__
 */ const $151739357ade899d$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
        xcss: $151739357ade899d$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
var $151739357ade899d$export$2e2bcd8739ae039 = $151739357ade899d$var$Link;

});

parcelRegister("bWzAa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d74f7a11b9428b4$export$2e2bcd8739ae039);
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bmZ1f = parcelRequire("bmZ1f");

var $8IeH1 = parcelRequire("8IeH1");


var $63Z7a = parcelRequire("63Z7a");

var $358Lz = parcelRequire("358Lz");
const $2d74f7a11b9428b4$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $2d74f7a11b9428b4$var$textColor = {
    unvisited: "_syaz131l",
    current: "_syaz1e6v",
    visited: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
const $2d74f7a11b9428b4$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pmoej",
    visited: "_k48pmoej",
    disabled: "_k48pmoej"
};
const $2d74f7a11b9428b4$var$getMarkerColor = ({ status: status, percentageCompleted: percentageCompleted })=>{
    switch(status){
        case 'unvisited':
            return `var(--ds-icon-subtle, ${0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de})`;
        case 'current':
        case 'visited':
            return `var(--ds-icon-brand, ${0, $7bb4c1736002a04a$export$e62e8919cca44969})`;
        case 'disabled':
            if (percentageCompleted === 0) return `var(--ds-icon-disabled, ${0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de})`;
            // If the percentage completed is greater than 0, we show the brand colour, so that the marker (circle) blends in with the progress bar.
            // Otherwise, the grey marker would be visible within the progress bar.
            return `var(--ds-icon-brand, ${0, $7bb4c1736002a04a$export$e62e8919cca44969})`;
        default:
            return;
    }
};
const $2d74f7a11b9428b4$var$listItemStyles = null;
const $2d74f7a11b9428b4$var$titleStyles = null;
class $2d74f7a11b9428b4$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.nodeRefMarker = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.nodeRefBar = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.nodeRefTitle = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.onEntered = ()=>{
            this.setState({
                transitioning: false,
                oldMarkerColor: $2d74f7a11b9428b4$var$getMarkerColor({
                    status: this.props.item.status,
                    percentageCompleted: this.props.item.percentageComplete
                }),
                oldPercentageComplete: this.props.item.percentageComplete
            });
        };
        this.state = {
            transitioning: false,
            oldMarkerColor: $2d74f7a11b9428b4$var$getMarkerColor({
                status: this.props.item.status,
                percentageCompleted: this.props.item.percentageComplete
            }),
            oldPercentageComplete: 0
        };
    }
    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing,
            ['--ds--pt--mc']: this.state.oldMarkerColor,
            ['--ds--pt--bg']: $2d74f7a11b9428b4$var$getMarkerColor({
                status: item.status,
                percentageCompleted: item.percentageComplete
            }),
            listStyleType: 'none'
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $hcewu.default)([
                "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $2d74f7a11b9428b4$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefMarker,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $358Lz.default), {
                            testId: testId && `${testId}-marker`
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefBar,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $63Z7a.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmZ1f.default), {
                        appear: true,
                        in: this.state.transitioning,
                        onEntered: this.onEntered,
                        timeout: transitionDelay + transitionSpeed,
                        classNames: "fade",
                        nodeRef: this.nodeRefTitle,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            "data-testid": testId && `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_11c82smr _v564ph28 _1pfhv47k _y3gn1h6o _1t9yph28 _1ez2kb7n _1uuw17dr",
                                $2d74f7a11b9428b4$var$textColor[item.status],
                                $2d74f7a11b9428b4$var$fontWeight[item.status]
                            ]),
                            children: this.shouldShowLink() ? render.link({
                                item: item
                            }) : item.label
                        })
                    })
                ]
            })
        });
    }
}

});
parcelRegister("63Z7a", function(module, exports) {
$parcel$export(module.exports, "default", () => $52eaafb58d2c0228$export$2e2bcd8739ae039);
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $52eaafb58d2c0228$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $52eaafb58d2c0228$var$progressBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */ const $52eaafb58d2c0228$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$52eaafb58d2c0228$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $hcewu.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhkq17z _1einu2gc _5fbcu2gc _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
var $52eaafb58d2c0228$export$2e2bcd8739ae039 = $52eaafb58d2c0228$var$ProgressBar;

});

parcelRegister("358Lz", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbc8abdb1ba13d3d$export$2e2bcd8739ae039);
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dbc8abdb1ba13d3d$var$progressMarkerStyles = null;
/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */ const $dbc8abdb1ba13d3d$var$ProgressMarker = ({ testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rkou2gc _v5645rui _1bsbu2gc _4t3iu2gc _kqswstnw _bfhkr3ku _1e021ssb _t9ec157a _1lww1oqq _1uuw17dr _1ez2kb7n _1190pbrw _1ia8r3ku"
        ])
    });
var $dbc8abdb1ba13d3d$export$2e2bcd8739ae039 = $dbc8abdb1ba13d3d$var$ProgressMarker;

});



parcelRegister("22H8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $927b85622afeb92a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $927b85622afeb92a$var$messages = (0, $7qGN1.defineMessages)({
    // Step Names (TBD)
    createStepName: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-step-name-nonfinal",
        "defaultMessage": "Create link"
    },
    reviewStepName: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-step-name-nonfinal",
        "defaultMessage": "Review link"
    },
    reciprocalPromptStepNameNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.reciprocal-prompt-name-nonfinal",
        "defaultMessage": "Create reciprocal link"
    },
    connectStepName: {
        "id": "applinks.administration.ui.creation-flow-dialog.connect-step-name-nonfinal",
        "defaultMessage": "Enter credentials"
    },
    confirmationStepNameNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.confirmation-step-name-nonfinal",
        "defaultMessage": "Confirmation"
    },
    unknownStepNameNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.unknown-step-name-nonfinal",
        "defaultMessage": "Configure link"
    },
    // Common
    errorFlagTitle: {
        "id": "applinks.administration.ui.creation-flow-dialog.error-flag-title=",
        "defaultMessage": "Failed to configure application link"
    },
    unknownConnectionTypeError: {
        "id": "applinks.administration.ui.creation-flow-dialog.unknown-connection-type-error",
        "defaultMessage": "Unknown connection type selected."
    },
    localProductCardHeader: {
        "id": "applinks.administration.ui.creation-flow-dialog.local-product-card-header",
        "defaultMessage": "This application"
    },
    remoteProductCardHeader: {
        "id": "applinks.administration.ui.creation-flow-dialog.remote-product-card-header",
        "defaultMessage": "Remote application"
    },
    formCancelButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.form-cancel-button-text",
        "defaultMessage": "Cancel"
    },
    requiredFieldsText: {
        "id": "applinks.administration.ui.creation-flow-dialog.required-fields-text",
        "defaultMessage": "Required fields are marked with an asterisk"
    },
    // Review Stage
    reviewOAuth1HeaderNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-oauth-1-header-nonfinal",
        "defaultMessage": "Review OAuth 1.0 link"
    },
    reviewOAuth2Header: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-oauth-2-header",
        "defaultMessage": "Review OAuth 2.0 link"
    },
    reviewTunneledHeaderNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-tunneled-header-nonfinal",
        "defaultMessage": "Review tunneled link"
    },
    reviewIncomingLinkHeaderNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-incoming-link-header-nonfinal",
        "defaultMessage": "Review incoming link"
    },
    reviewOAuth1DescriptionNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-oauth-1-description-nonfinal",
        "defaultMessage": "Confirm the details of the application link you are creating. This will allow the remote <strong>{nameOfRemoteProduct}</strong> to access this {nameOfThisProduct} site. You will later be redirected to {nameOfRemoteProduct} to complete the other side of the link."
    },
    reviewOAuth2Description: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-oauth-2-description",
        "defaultMessage": "Confirm the details of the application link you're creating. In the next step, you'll exchange credentials to allow the remote <strong>{nameOfRemoteProduct}</strong> to communicate with this {nameOfThisProduct} site."
    },
    reviewOAuth1ReciprocalDescriptionNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal",
        "defaultMessage": "The remote <strong>{nameOfRemoteProduct}</strong> application has requested to create a link to this {nameOfThisProduct} site. Review the details below before completing the link. This will allow the remote {nameOfRemoteProduct} to access this site."
    },
    reviewFormCompleteLinkButtonNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-form-complete-link-button-nonfinal",
        "defaultMessage": "Complete link"
    },
    reviewFormCreateLinkButton: {
        "id": "applinks.administration.ui.creation-flow-dialog.review-form-create-link-button",
        "defaultMessage": "Create link"
    },
    // Connect (OAuth 2.0)
    connectHeader: {
        "id": "applinks.administration.ui.creation-flow-dialog.connect-header",
        "defaultMessage": "Connect to the application"
    },
    connectDescription: {
        "id": "applinks.administration.ui.creation-flow-dialog.connect-description",
        "defaultMessage": "Copy and paste the details below between this page and the settings page of the external application where you configure application links. This creates a secure connection."
    },
    connectContinueButton: {
        "id": "applinks.administration.ui.creation-flow-dialog.connect-continue-button",
        "defaultMessage": "Connect"
    },
    connectDoLaterButton: {
        "id": "applinks.administration.ui.creation-flow-dialog.connect-do-later-button",
        "defaultMessage": "Do this later"
    },
    // Create
    applicationLinkInformationTextNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.application-link-information-text-nonfinal",
        "defaultMessage": "An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira."
    },
    applicationLinkHowToLinkTextNonfinal: {
        "id": "appinks.administration.ui.creation-flow-dialog.application-link-how-to-text-nonfinal",
        "defaultMessage": "How to create an application link"
    },
    cancelButtonTextNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text-nonfinal",
        "defaultMessage": "Cancel"
    },
    createHeaderTextNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-header-text-nonfinal",
        "defaultMessage": "Create an application link"
    },
    completeButtonTextNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-form-button-text-nonfinal",
        "defaultMessage": "Create"
    },
    nextButtonTextNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.next-form-button-text-nonfinal",
        "defaultMessage": "Next"
    },
    reciprocalRedirectButtonTextNonfinal: {
        "id": "applinks.administration.ui.creation-flow-dialog.reciprocal-redirect-form-button-text-nonfinal",
        "defaultMessage": "Finish Setting Up"
    }
});
var $927b85622afeb92a$export$2e2bcd8739ae039 = $927b85622afeb92a$var$messages;

});


parcelRegister("cjcvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $79ec26d9852ca5f5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $79ec26d9852ca5f5$var$messages = (0, $7qGN1.defineMessages)({
    applicationLinkInformationText: {
        "id": "applinks.administration.ui.creation-flow-dialog.application-link-information-text",
        "defaultMessage": "An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira."
    },
    applicationLinkHowToLinkText: {
        "id": "appinks.administration.ui.creation-flow-dialog.application-link-how-to-text",
        "defaultMessage": "How to create an application link"
    },
    cancelButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text",
        "defaultMessage": "Cancel"
    },
    createHeaderText: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-header-text",
        "defaultMessage": "Create an application link"
    },
    completeButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.create-form-button-text",
        "defaultMessage": "Create"
    },
    nextButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.next-form-button-text",
        "defaultMessage": "Next"
    },
    reciprocalRedirectButtonText: {
        "id": "applinks.administration.ui.creation-flow-dialog.reciprocal-redirect-form-button-text",
        "defaultMessage": "Finish Setting Up"
    }
});
var $79ec26d9852ca5f5$export$2e2bcd8739ae039 = $79ec26d9852ca5f5$var$messages;

});


parcelRegister("cYu93", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0fcb53cb9c822c1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $5toMF = parcelRequire("5toMF");

var $cV8sz = parcelRequire("cV8sz");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $83DiZ = parcelRequire("83DiZ");

var $eSnSE = parcelRequire("eSnSE");

var $a4pY2 = parcelRequire("a4pY2");

var $i0t2M = parcelRequire("i0t2M");

var $dk6v8 = parcelRequire("dk6v8");

var $ffsuj = parcelRequire("ffsuj");

var $gowAx = parcelRequire("gowAx");

var $22H8z = parcelRequire("22H8z");

var $d6B0e = parcelRequire("d6B0e");

var $6ZEHi = parcelRequire("6ZEHi");

var $Z7XR9 = parcelRequire("Z7XR9");

var $1IHCZ = parcelRequire("1IHCZ");
const $b0fcb53cb9c822c1$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $b0fcb53cb9c822c1$var$ReviewSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const reciprocalMode = props.state.kind === 'reciprocal-review';
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const targetApplicationRpcUrl = props.state.rpcUrl; // TODO: Determine if the type is DC or Cloud
    const thisApplicationType = (0, $a4pY2.lookupTypeByTypeId)(thisApplicationManifest.typeId, false);
    const targetApplicationType = (0, $a4pY2.lookupTypeByTypeId)(targetApplicationManifest.typeId, false);
    const onFormSubmitOAuth1 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationRpcUrl,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: false
        };
        try {
            await (0, $dk6v8.putApplink)(applinkCreationEntity);
            if (props.state.kind === 'reciprocal-review' && props.state.inboundCreationState.applinkOriginalCreatedId) {
                // Configure OAuth
                await (0, $dk6v8.putApplinkOAuthOne3LOProvider)(targetApplicationManifest.id);
                await (0, $dk6v8.autoConfigureApplinkConsumer)(targetApplicationManifest.id);
                await (0, $dk6v8.putApplinkOAuthOne2LOProvider)(targetApplicationManifest.id); // Update status log
                const updatedApplinkCreationStatusLog = (0, $ffsuj.updateStatusLog)(props.state.inboundCreationState.applinkCreationStatusLog, {
                    status: (0, $ffsuj.STATUS_RECIPROCAL_SUCCESS)
                });
                const newCreationState = {
                    applinkCreationStatusLog: updatedApplinkCreationStatusLog,
                    applinkOriginalCreatedId: props.state.inboundCreationState.applinkOriginalCreatedId,
                    sharedUserbase: props.state.inboundCreationState.sharedUserbase,
                    applinkConfigInPreAuth: true,
                    applinkConfigInServerAuth: true,
                    applinkConfigInUserAuth: true,
                    applinkConfigOutPreAuth: true,
                    applinkConfigOutServerAuth: true,
                    applinkConfigOutUserAuth: true
                };
                const newRedirectionUrl = (0, $ffsuj.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, newCreationState);
                push(newRedirectionUrl);
                return;
            }
            props.onSuccess({
                kind: 'reciprocal-prompt',
                variant: props.state.variant,
                remoteManifest: targetApplicationManifest,
                localManifest: thisApplicationManifest
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.review.submitOAuth1ReviewForm', 'Failed to create an OAuth 1.0 link after reviewing', maybeError);
            props.onError(maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText));
            return err;
        }
    };
    const onFormSubmitOAuth2 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationRpcUrl,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: true
        };
        try {
            await (0, $dk6v8.createOAuth2Applink)(applinkCreationEntity);
            const oauth2ConfigInfo = await (0, $dk6v8.getOAuth2ConfigInfo)(targetApplicationManifest.id);
            const newlyCreatedApplink = await (0, $dk6v8.fetchApplink)(targetApplicationManifest.id);
            props.onSuccess({
                kind: 'connect',
                variant: props.state.variant,
                applink: newlyCreatedApplink,
                oauth2ConfigInfo: oauth2ConfigInfo
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.review.submitOAuth2ReviewForm', 'Failed to create an OAuth 2.0 link after reviewing', maybeError);
            props.onError(maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText));
            return err;
        }
    };
    const onFormSubmit = async ()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
            case 'TUNNEL':
                return onFormSubmitOAuth1();
            case 'OAUTH2.0':
                return onFormSubmitOAuth2();
            default:
                props.onError(formatMessage((0, $22H8z.default).unknownConnectionTypeError));
        }
    };
    const getVariantProperName = (0, $eJOHy.useCallback)(()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
                return formatMessage((0, $22H8z.default).reviewOAuth1HeaderNonfinal);
            case 'OAUTH2.0':
                return formatMessage((0, $22H8z.default).reviewOAuth2Header);
            case 'TUNNEL':
            default:
                return formatMessage((0, $22H8z.default).reviewTunneledHeaderNonfinal);
        }
    }, [
        formatMessage,
        props.state.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: onFormSubmit,
        xcss: $b0fcb53cb9c822c1$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1IHCZ.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage((0, $22H8z.default).formCancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.review.submit-button",
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, reciprocalMode ? formatMessage((0, $22H8z.default).reviewFormCompleteLinkButtonNonfinal) : formatMessage((0, $22H8z.default).reviewFormCreateLinkButton))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5toMF.default), {
                title: reciprocalMode ? formatMessage((0, $22H8z.default).reviewIncomingLinkHeaderNonfinal) : getVariantProperName()
            }, !reciprocalMode && (props.state.variant === 'OAUTH1.0' || props.state.variant === 'TUNNEL') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $22H8z.default).reviewOAuth1DescriptionNonfinal, {
                nameOfThisProduct: (0, $d6B0e.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong"
                    }, chunks)
            })), !reciprocalMode && props.state.variant === 'OAUTH2.0' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $22H8z.default).reviewOAuth2Description, {
                nameOfThisProduct: (0, $d6B0e.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong"
                    }, chunks)
            })), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $22H8z.default).reviewOAuth1ReciprocalDescriptionNonfinal, {
                nameOfThisProduct: (0, $d6B0e.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong"
                    }, chunks)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                xcss: $b0fcb53cb9c822c1$var$styles.linkDisplay,
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default), {
                applicationType: thisApplicationType,
                displayUrl: thisApplicationManifest.url,
                heading: formatMessage((0, $22H8z.default).localProductCardHeader)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                space: "space.100",
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                label: ""
            }), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ZEHi.StatusLozenge), {
                kind: "error",
                err: (0, $Z7XR9.ERRORS).CONFIGURATION_COMPLETE
            }), !reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ZEHi.StatusLozenge), {
                kind: "not-connected"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default), {
                applicationType: targetApplicationType,
                displayUrl: targetApplicationManifest.url,
                heading: formatMessage((0, $22H8z.default).remoteProductCardHeader)
            })))
        })));
};
var $b0fcb53cb9c822c1$export$2e2bcd8739ae039 = $b0fcb53cb9c822c1$var$ReviewSubpage;

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});


parcelRegister("1E9Rd", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e05c467f8218d74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");
var $5bY40 = parcelRequire("5bY40");

var $3L3Os = parcelRequire("3L3Os");
var $5toMF = parcelRequire("5toMF");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $a4pY2 = parcelRequire("a4pY2");

var $i0t2M = parcelRequire("i0t2M");

var $ffsuj = parcelRequire("ffsuj");

var $6ZEHi = parcelRequire("6ZEHi");

var $Z7XR9 = parcelRequire("Z7XR9");

var $1IHCZ = parcelRequire("1IHCZ");
const $0e05c467f8218d74$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $0e05c467f8218d74$var$ReciprocalPromptSubpage = (props)=>{
    (0, $lRq8t.default)();
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const targetCloudId = props.state.remoteManifest.id;
    const thisBaseUrl = thisApplicationManifest.url;
    const thisBaseTypeId = thisApplicationManifest.typeId;
    const creationState = (0, $ffsuj.getDefaultCreationState)(thisBaseUrl, thisBaseTypeId, targetCloudId);
    const reciprocalLinkUrl = (0, $ffsuj.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, creationState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        xcss: $0e05c467f8218d74$var$styles.fullContainer
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1IHCZ.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), {
                label: "Form submit options"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                appearance: "subtle"
            }, "Cancel"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
                href: reciprocalLinkUrl,
                appearance: "primary"
            }, `Continue on ${targetApplicationManifest.name}`)),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5toMF.default), {
                title: "Create reciprocal link"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, "A link from Jira to", ' ', targetApplicationManifest.name, " has been established. You will need to navigate to ", targetApplicationManifest.name, " to complete the link.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                xcss: $0e05c467f8218d74$var$styles.linkDisplay,
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default // TODO: Determine if the type is DC or Cloud
            ), {
                applicationType: (0, $a4pY2.lookupTypeByTypeId)(targetApplicationManifest.typeId, false),
                displayUrl: targetApplicationManifest.url,
                heading: "Application Link",
                statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ZEHi.StatusLozenge), {
                    kind: "error",
                    err: (0, $Z7XR9.ERRORS).CONFIGURATION_COMPLETE
                })
            })))
        })));
};
var $0e05c467f8218d74$export$2e2bcd8739ae039 = $0e05c467f8218d74$var$ReciprocalPromptSubpage;

});

parcelRegister("3DmnW", function(module, exports) {
$parcel$export(module.exports, "default", () => $b10a04daded43b37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $5toMF = parcelRequire("5toMF");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $a4pY2 = parcelRequire("a4pY2");

var $i0t2M = parcelRequire("i0t2M");

var $dk6v8 = parcelRequire("dk6v8");

var $d6B0e = parcelRequire("d6B0e");

var $6ZEHi = parcelRequire("6ZEHi");

var $1IHCZ = parcelRequire("1IHCZ");
const $b10a04daded43b37$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $b10a04daded43b37$var$ConfirmationSubpage = (props)=>{
    (0, $lRq8t.default)();
    const [status, setStatus] = (0, $eJOHy.useState)(null);
    const finaliseOAuth1Link = async (confirmationApplinkId)=>{
        await (0, $dk6v8.putApplinkOAuthOne3LOProvider)(confirmationApplinkId);
        await (0, $dk6v8.autoConfigureApplinkConsumer)(confirmationApplinkId);
        await (0, $dk6v8.putApplinkOAuthOne2LOProvider)(confirmationApplinkId);
        setStatus(await (0, $dk6v8.fetchApplinkStatus)(confirmationApplinkId));
    }; // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        // TODO: Enforce this using discriminated union types
        if (props.state.variant === 'OAUTH2.0') {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setStatus(null);
            return;
        }
        finaliseOAuth1Link(props.state.confirmationApplinkId);
    }, [
        props.state.confirmationApplinkId,
        props.state.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.href = (0, $d6B0e.APPLINKS_LIST_PAGE_URL);
        },
        xcss: $b10a04daded43b37$var$styles.fullContainer
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1IHCZ.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), {
                label: "Form submit options"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                type: "submit",
                appearance: "primary",
                isLoading: status === null
            }, "Done")),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5toMF.default), {
                title: "Confirmation"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, "The application link has been created.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                xcss: $b10a04daded43b37$var$styles.linkDisplay,
                space: "space.200"
            }, status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0t2M.default // TODO: Determine if the type is DC or Cloud
            ), {
                applicationType: (0, $a4pY2.lookupTypeByTypeId)(status.link.type, false),
                displayUrl: status.link.displayUrl,
                heading: "Application Link",
                statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ZEHi.StatusLozengeV3), {
                    status: status
                })
            }), status === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })))
        })));
};
var $b10a04daded43b37$export$2e2bcd8739ae039 = $b10a04daded43b37$var$ConfirmationSubpage;

});

parcelRegister("4pa0Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $de09409d970b1f91$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $5toMF = parcelRequire("5toMF");
var $lP4Q7 = parcelRequire("lP4Q7");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $eSnSE = parcelRequire("eSnSE");

var $dk6v8 = parcelRequire("dk6v8");

var $gowAx = parcelRequire("gowAx");

var $22H8z = parcelRequire("22H8z");

var $e3qJa = parcelRequire("e3qJa");

var $1IHCZ = parcelRequire("1IHCZ");
const $de09409d970b1f91$var$styles = {
    fullContainer: "_4t3i1osq"
};
const $de09409d970b1f91$var$ConnectSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onFormSubmit = async (data)=>{
        const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
        const oauth2Config = {
            remoteClientId: data.applicationClientId,
            remoteClientSecret: data.applicationClientSecret,
            remoteRedirectUrl: data.redirectUrl,
            outboundScopes: scopes
        };
        try {
            await (0, $dk6v8.putOAuth2ConfigInfo)(props.state.applink.id, oauth2Config);
            props.onSuccess(); // Success = close the drawer
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $eSnSE.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.connect.submitConnectForm', 'Failed to submit credentials form for newly created OAuth 2.0 applink', maybeError);
            props.onError(maybeError ? maybeError.message : formatMessage((0, $gowAx.default).unknownErrorText));
            return err;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: onFormSubmit,
        xcss: $de09409d970b1f91$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1IHCZ.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage((0, $22H8z.default).connectDoLaterButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.connect.submit-button",
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, formatMessage((0, $22H8z.default).connectContinueButton))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5toMF.default), {
                title: formatMessage((0, $22H8z.default).connectHeader)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $22H8z.default).connectDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                "aria-hidden": "true",
                size: "small"
            }, formatMessage((0, $22H8z.default).requiredFieldsText), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lP4Q7.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e3qJa.default), {
                applink: props.state.applink,
                oauth2ConfigInfo: props.state.oauth2ConfigInfo,
                onDisplayError: props.onError,
                onRequestStatusRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                partiallyLinkedMode: true
            }))
        })));
};
var $de09409d970b1f91$export$2e2bcd8739ae039 = $de09409d970b1f91$var$ConnectSubpage;

});





parcelRegister("gEhrq", function(module, exports) {
$parcel$export(module.exports, "applinksAdministrationListRoute", () => $d6c98621ea44512b$export$1eaebf5f3954a8b6);
const $d6c98621ea44512b$export$1eaebf5f3954a8b6 = {
    name: 'global-settings-products-applinks-administration-list',
    path: '/jira/settings/applinks',
    exact: true
};

});


parcelRegister("gK0o2", function(module, exports) {
$parcel$export(module.exports, "applinksExtraAuthHealthcheckRouteEntry", () => $bc4c6f2c1f49a0d6$export$cd4854d613a2c404);

var $dihHZ = parcelRequire("dihHZ");

var $9rz9P = parcelRequire("9rz9P");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");
const $bc4c6f2c1f49a0d6$export$cd4854d613a2c404 = (0, $6xToB.createEntry)((0, $9rz9P.applinksExtraAuthHealthcheckRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-extra-auth-healthcheck',
        component: (0, $bJscI.componentWithFG)('applinks-789-extra-auth-healthcheck-frontend', (0, $dihHZ.default), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4cTDP.fg)('applinks-789-extra-auth-healthcheck-frontend'),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-applinks-entries/src/applinksExtraAuthHealthcheckRouteEntry.tsx',
                whichExportToUse: 'applinksExtraAuthHealthcheckRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dihHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb99191b62c7837a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cH6Qf = parcelRequire("cH6Qf");

var $4EKqI = parcelRequire("4EKqI");

var $aV23b = parcelRequire("aV23b");

var $fPApF = parcelRequire("fPApF");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb99191b62c7837a$var$HealthcheckPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "applinks-extra-auth-healthcheck-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fPApF.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null)));
var $bb99191b62c7837a$export$2e2bcd8739ae039 = $bb99191b62c7837a$var$HealthcheckPage;

});
parcelRegister("fPApF", function(module, exports) {
$parcel$export(module.exports, "default", () => $109b26965435f333$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jJaSe = parcelRequire("jJaSe");

var $eSnSE = parcelRequire("eSnSE");

var $gDywu = parcelRequire("gDywu");


var $fsQ56 = parcelRequire("fsQ56");
const $109b26965435f333$export$7955d5fe058be414 = ()=>{
    const [healthcheck, setHealthcheck] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gDywu.getHealthcheck)().then((data)=>{
            setHealthcheck(data);
        }).catch((err)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $f326b3b1ea195b66$export$25a759e49d5049db), 'Failed to fetch healthcheck data', err);
            setHealthcheck(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsQ56.default), {
        healthcheck: healthcheck
    });
};
// eslint-disable-next-line camelcase
const $109b26965435f333$var$_default_1 = (0, $jJaSe.withRouter)($109b26965435f333$export$7955d5fe058be414);
var // eslint-disable-next-line camelcase
$109b26965435f333$export$2e2bcd8739ae039 = $109b26965435f333$var$_default_1;

});
parcelRegister("gDywu", function(module, exports) {
$parcel$export(module.exports, "getHealthcheck", () => $1b516a5040c58db6$export$47b0be97eea80dc5);

var $hgi0g = parcelRequire("hgi0g");
const $1b516a5040c58db6$export$47b0be97eea80dc5 = ()=>(0, $hgi0g.default)('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');

});

const $f326b3b1ea195b66$export$25a759e49d5049db = 'applinks.extra-auth.healthcheck';

parcelRegister("fsQ56", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b25364e5efde30$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $5vQ2T = parcelRequire("5vQ2T");

var $bZxkZ = parcelRequire("bZxkZ");

var $wZaoO = parcelRequire("wZaoO");
const $60b25364e5efde30$var$HealthcheckPageContents = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "applinks-extra-auth-healthcheck-page",
        teamName: "olympus",
        packageName: "applinksExtraAuthHealthcheckPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200",
        xcss: $60b25364e5efde30$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZaoO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZxkZ.default), {
        title: "Prerequisites",
        description: "Ensure that the following prerequisites are met before beginning the setup process.",
        healthcheckEntries: props.healthcheck?.healthcheckPreconditions ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZxkZ.default), {
        title: "OAuth 2.0 Provider Configuration",
        description: "Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created.",
        healthcheckEntries: props.healthcheck?.healthcheckEntries ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZxkZ.default), {
        title: "Applink Status",
        description: "Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below.",
        healthcheckEntries: props.healthcheck?.healthcheckStatuses ?? null
    })))));
};
var $60b25364e5efde30$export$2e2bcd8739ae039 = $60b25364e5efde30$var$HealthcheckPageContents;
const $60b25364e5efde30$var$styles = (0, $1DXK0.xcss)({
    padding: 'space.200'
});

});
parcelRegister("bZxkZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1da49bb1b171b749$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $aWndL = parcelRequire("aWndL");
var $bbUsH = parcelRequire("bbUsH");
var $6DZFN = parcelRequire("6DZFN");
var $g7LKe = parcelRequire("g7LKe");
var $jc89b = parcelRequire("jc89b");
var $d7Jct = parcelRequire("d7Jct");

var $3wl9L = parcelRequire("3wl9L");

var $a03qM = parcelRequire("a03qM");

var $aoeTu = parcelRequire("aoeTu");

var $806LH = parcelRequire("806LH");

var $1FZ85 = parcelRequire("1FZ85");
const $1da49bb1b171b749$var$HealthcheckIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.status.statusType === 'SUCCESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
        color: "var(--ds-icon-success, #22A06B)",
        label: "Success"
    }), props.status.statusType === 'FAILURE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unsuccessful"
    }), props.status.statusType === 'NOT_TRIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aoeTu))), {
        color: "var(--ds-icon, #44546F)",
        label: "Not Tried"
    }));
};
const $1da49bb1b171b749$var$getColorFromStatus = (status)=>{
    if (status.statusType === 'NOT_TRIED') return 'color.text.disabled';
    return 'color.text';
};
const $1da49bb1b171b749$var$HealthcheckTitle = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: $1da49bb1b171b749$var$getColorFromStatus(props.status)
    }, props.name);
};
const $1da49bb1b171b749$var$HealthcheckComment = (props)=>{
    const message = 'message' in props.status ? props.status.message : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: $1da49bb1b171b749$var$getColorFromStatus(props.status)
    }, message);
};
const $1da49bb1b171b749$var$convertToArray = (healthcheckEntries)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return healthcheckEntries.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $1da49bb1b171b749$var$HealthcheckTable = (props)=>{
    const healthcheckItems = props.healthcheckEntries ? $1da49bb1b171b749$var$convertToArray(props.healthcheckEntries) : undefined; // Loading state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium"
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bbUsH.default), {
        label: "Healthcheck Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g7LKe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "100px"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "50%"
    }, "Item"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DZFN.default), {
        width: "50%"
    }, "Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d7Jct.default), {
        items: healthcheckItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jc89b.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1da49bb1b171b749$var$HealthcheckIcon, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1da49bb1b171b749$var$HealthcheckTitle, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aWndL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1da49bb1b171b749$var$HealthcheckComment, content)));
            if (content.status.statusType === 'FAILURE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, row, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jc89b.default), {
                key: `${item.id}-suggested-action`,
                itemId: `${item.id}-suggested-action`,
                hasChildren: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $1da49bb1b171b749$var$suggestedActionCellStyles,
                role: "cell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1FZ85.default), {
                error: `Step "${content.name}" failed due to reason: "${content.status.message}".`,
                action: content.suggestedAction ?? null,
                link: content.suggestedActionLink ?? null
            }))));
            return row;
        }
    })));
};
var $1da49bb1b171b749$export$2e2bcd8739ae039 = $1da49bb1b171b749$var$HealthcheckTable;
const $1da49bb1b171b749$var$suggestedActionCellStyles = (0, $1DXK0.xcss)({
    width: '100%',
    padding: 'space.200'
});

});
parcelRegister("aoeTu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::967051479008b6df3057b7f835f26a9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7907b2e3dd80e4c4$var$_react = $7907b2e3dd80e4c4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7907b2e3dd80e4c4$var$_baseNew = $7907b2e3dd80e4c4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7907b2e3dd80e4c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7907b2e3dd80e4c4$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $7907b2e3dd80e4c4$var$_react.default.createElement($7907b2e3dd80e4c4$var$_baseNew.default, Object.assign({
        name: "TaskToDoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$7907b2e3dd80e4c4$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $7907b2e3dd80e4c4$var$_default = module.exports.default = $7907b2e3dd80e4c4$var$TaskToDoIcon;

});

parcelRegister("1FZ85", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b13c44b83e4c961$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");
const $4b13c44b83e4c961$var$HealthcheckSuggestedAction = (props)=>{
    const actions = props.link ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
            key: "action",
            href: props.link.link
        }, props.link.name)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        title: "Step Failed",
        appearance: "error",
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, props.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, props.action))));
};
var $4b13c44b83e4c961$export$2e2bcd8739ae039 = $4b13c44b83e4c961$var$HealthcheckSuggestedAction;

});
parcelRegister("akOEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6330b1bed100d78d$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6qaBj = parcelRequire("6qaBj");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");
const $6330b1bed100d78d$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6330b1bed100d78d$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $6330b1bed100d78d$var$styles.common,
                $6330b1bed100d78d$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $6qaBj.cx)($6330b1bed100d78d$var$styles.common, $6330b1bed100d78d$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            testId: testId,
            xcss: $6330b1bed100d78d$var$styles.common,
            children: children
        });
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
});
var $6330b1bed100d78d$export$2e2bcd8739ae039 = $6330b1bed100d78d$var$SectionMessageAction;

});



parcelRegister("wZaoO", function(module, exports) {
$parcel$export(module.exports, "default", () => $a11bdf88d94e006a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");
const $a11bdf88d94e006a$var$HealthcheckHeader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "large"
    }, "Extra Auth Healthcheck"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, "Status of Extra Authenticated Application Links for your Jira Cloud site.")));
};
var $a11bdf88d94e006a$export$2e2bcd8739ae039 = $a11bdf88d94e006a$var$HealthcheckHeader;

});




parcelRegister("9rz9P", function(module, exports) {
$parcel$export(module.exports, "applinksExtraAuthHealthcheckRoute", () => $eb57e7adbcd87ce1$export$c92684a6af97ae19);
const $eb57e7adbcd87ce1$export$c92684a6af97ae19 = {
    name: 'global-settings-products-applinks-extra-auth',
    path: '/jira/settings/applinks/extra-auth/healthcheck',
    exact: true
};

});


parcelRegister("7WGkO", function(module, exports) {
$parcel$export(module.exports, "appRequestsRouteEntry", () => $606a2f2e012366e7$export$423a1c80bb2f8b9a);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gC8Ke = parcelRequire("gC8Ke");

var $ixFkc = parcelRequire("ixFkc");
const $606a2f2e012366e7$export$423a1c80bb2f8b9a = (0, $6xToB.createEntry)((0, $gC8Ke.appRequestsRoute), ()=>({
        group: 'marketplace',
        component: (0, $ixFkc.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ixFkc.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-marketplace-entries/src/appRequestsRouteEntry.tsx',
                whichExportToUse: 'appRequestsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gKFn0", function(module, exports) {
$parcel$export(module.exports, "default", () => $09413d0f48517527$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $09413d0f48517527$var$LazyGlobalAppsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("hbC0m")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
const $09413d0f48517527$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09413d0f48517527$var$LazyGlobalAppsSettingsSidebar, null)));
$09413d0f48517527$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $09413d0f48517527$export$2e2bcd8739ae039 = $09413d0f48517527$var$GlobalAppsSettingsSidebar;

});
parcelRegister("hbC0m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ju8d5")
]).then(()=>parcelRequire('a6XIl'));

});


parcelRegister("gC8Ke", function(module, exports) {
$parcel$export(module.exports, "appRequestsRoute", () => $0810f4e967941125$export$df12e2a94e0a971b);
const $0810f4e967941125$export$df12e2a94e0a971b = {
    name: 'marketplace-app-requests',
    path: '/jira/marketplace/manage/app-requests'
};

});

parcelRegister("ixFkc", function(module, exports) {
$parcel$export(module.exports, "LazyMarketplace", () => $3b73073020c2fe89$export$5919da4c9ee4707e);
$parcel$export(module.exports, "MarketplaceComponent", () => $3b73073020c2fe89$export$f0d733b7012e9031);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3b73073020c2fe89$export$5919da4c9ee4707e = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ffGte"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $3b73073020c2fe89$export$f0d733b7012e9031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3b73073020c2fe89$export$5919da4c9ee4707e,
        pageId: "marketplace",
        shouldShowSpinner: true
    });

});
parcelRegister("2dJFW", function(module, exports) {
$parcel$export(module.exports, "markAsProductBundleReady", () => $ab9e756ab32e8c98$export$ff83c57004505abd);

var $lOI8W = parcelRequire("lOI8W");
const $ab9e756ab32e8c98$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $lOI8W.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("ffGte", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gs7IR")
]).then(()=>parcelRequire('fcjmy'));

});



parcelRegister("aPhVH", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", () => $0ea68876b7180483$export$f7d3667678a21360);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $c7U4n = parcelRequire("c7U4n");

var $j3sUb = parcelRequire("j3sUb");
const $0ea68876b7180483$export$f7d3667678a21360 = (0, $6xToB.createEntry)((0, $c7U4n.archivedIssuesRedirectRoute), ()=>({
        group: 'archive-issues',
        layout: (0, $ioHIu.genericProjectLayout),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archives-entries/src/archivedIssuesRedirectRouteEntry.tsx',
                whichExportToUse: 'archivedIssuesRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ioHIu", function(module, exports) {
$parcel$export(module.exports, "genericProjectLayout", () => $b45ef5b2a7af08eb$export$85dad8e9886563f6);

var $cEBDW = parcelRequire("cEBDW");

var $6dwgv = parcelRequire("6dwgv");

var $aQoXd = parcelRequire("aQoXd");

var $8FCAy = parcelRequire("8FCAy");

var $dkgBy = parcelRequire("dkgBy");
const $b45ef5b2a7af08eb$export$85dad8e9886563f6 = (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $cEBDW.coreProjectLayout), (0, $aQoXd.serviceProjectLayout), (0, $8FCAy.softwareProjectLayout), (0, $dkgBy.userBoardLayout));

});
parcelRegister("cEBDW", function(module, exports) {
$parcel$export(module.exports, "coreProjectLayout", () => $208365a70ac26c02$export$3c06ced9943ca671);

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");
const $208365a70ac26c02$export$3c06ced9943ca671 = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));

});

parcelRegister("8FCAy", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $2e2774c38c3e21fa$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $2e2774c38c3e21fa$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $2e2774c38c3e21fa$export$ab7e607e8441dc61);

var $FhXEJ = parcelRequire("FhXEJ");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2e2774c38c3e21fa$var$withAnySoftwareProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $FhXEJ.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("8R8if")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
$2e2774c38c3e21fa$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingCode = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kLVya")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aw5Vg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
$2e2774c38c3e21fa$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsCode = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aaPbu")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $2e2774c38c3e21fa$var$SoftWareOnboarding = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$Onboarding);
const $2e2774c38c3e21fa$var$SoftWareOnboardingCode = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$OnboardingCode);
const $2e2774c38c3e21fa$var$nonSettingsRightSidebars = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebars)
];
const $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebarsCode)
];
const $2e2774c38c3e21fa$var$sharedSoftwareProjectLayout = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {});
const $2e2774c38c3e21fa$export$3791efdd32024063 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$9a918616afa3328c = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$ada52b1309832862 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$6c1958653c44ba37 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$ab7e607e8441dc61 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("8R8if", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("22QMa")
]).then(()=>parcelRequire('jhc67'));

});

parcelRegister("kLVya", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("k3KUo")
]).then(()=>parcelRequire('fpUIa'));

});

parcelRegister("aw5Vg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bRZBc")
]).then(()=>parcelRequire('4mkSU'));

});

parcelRegister("aaPbu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("bXt8b")
]).then(()=>parcelRequire('8XVCp'));

});


parcelRegister("dkgBy", function(module, exports) {
$parcel$export(module.exports, "userBoardLayout", () => $cf45c653fc1d9878$export$7092b4ee86ae0b71);

var $6dwgv = parcelRequire("6dwgv");
const $cf45c653fc1d9878$export$7092b4ee86ae0b71 = (0, $6dwgv.createLayout)();

});


parcelRegister("gHEJe", function(module, exports) {
$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $7ef94f935654f247$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $7ef94f935654f247$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

const $7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("1t7yC")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("1t7yC")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
const $7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$export$16261c6a2217f29d = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar, null);
});
$7ef94f935654f247$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$7ef94f935654f247$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $7ef94f935654f247$export$2e2bcd8739ae039 = $7ef94f935654f247$var$SoftwareProjectSidebar;

});
parcelRegister("1t7yC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4yp4h")
]).then(()=>parcelRequire('9WRBf'));

});


parcelRegister("c7U4n", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesRedirectRoute", () => $53cb455bac15eae1$export$1bfee70ca366d995);
const $53cb455bac15eae1$export$1bfee70ca366d995 = {
    name: 'archived-issues-directory',
    path: '/jira/issues/archive',
    exact: true
};

});

parcelRegister("j3sUb", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesPageEntryPoint", () => $120f97aff115bbf0$export$e2fa7de87c15a81d);
$parcel$export(module.exports, "archivedIssuesWithoutHorizontalNavPageEntryPoint", () => $120f97aff115bbf0$export$c001d316b1f89101);
$parcel$export(module.exports, "getCommonProjectLayout", () => $120f97aff115bbf0$export$3dbe917a4c13b1e);

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $6dwgv = parcelRequire("6dwgv");

var $9n5I0 = parcelRequire("9n5I0");

var $5RW99 = parcelRequire("5RW99");

var $2cEzx = parcelRequire("2cEzx");
const $120f97aff115bbf0$export$e2fa7de87c15a81d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $2cEzx.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $120f97aff115bbf0$export$c001d316b1f89101 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $2cEzx.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $120f97aff115bbf0$export$3dbe917a4c13b1e = ()=>(0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout));

});
parcelRegister("9n5I0", function(module, exports) {
$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $c3ab5ab6b7a191f3$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2kG4d = parcelRequire("2kG4d");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

const $c3ab5ab6b7a191f3$export$e9ee9fa1097f370e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hjdUw")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true,
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        let boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (!boardId) {
            // If there is no boardId in the URL then we should check to see if it is provided as part of
            // the Connect app rapidView query param. This has been added to address JRACLOUD-94629
            const rapidViewBoard = query.rapidView ? query.rapidView : null;
            boardId = rapidViewBoard || boardId || null;
        }
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2kG4d.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("2kG4d", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2342b8045233cc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca6d73dad77687f7356638b9d469bc27>>
 * @relayHash 15afe768410f467f58512813804488cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a3abe148fa3378330c33399b2f78b01611b1b606d0218e858c383795a3ec93d

var $7KZsS = parcelRequire("7KZsS");

var $7ze1k = parcelRequire("7ze1k");

var $gpGBt = parcelRequire("gpGBt");
const $a2342b8045233cc3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5a3abe148fa3378330c33399b2f78b01611b1b606d0218e858c383795a3ec93d",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": (0, $7ze1k.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default)
        }
    }
};
var $a2342b8045233cc3$export$2e2bcd8739ae039 = $a2342b8045233cc3$var$node;

});
parcelRegister("7KZsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d80c26e7829d9791$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $d80c26e7829d9791$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("7ze1k", function(module, exports) {
$parcel$export(module.exports, "default", () => $938480f2a3a19bc1$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $938480f2a3a19bc1$var$JiraInviteButtonRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jfind-restore-invite-button-gate');
    }
};
var $938480f2a3a19bc1$export$2e2bcd8739ae039 = $938480f2a3a19bc1$var$JiraInviteButtonRelayProvider;

});

parcelRegister("gpGBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $12dde8e7615a22fe$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");
const $12dde8e7615a22fe$var$JiraTeamButtonTeamCountRelayProvider = {
    get () {
        return !(0, $4cTDP.fg)('team-bi-directional-container-connection-gate') || !(0, $cxKOj.expVal)('team-bi-directional-container-connection', 'isEnabled', false);
    }
};
var $12dde8e7615a22fe$export$2e2bcd8739ae039 = $12dde8e7615a22fe$var$JiraTeamButtonTeamCountRelayProvider;

});


parcelRegister("7Bvm5", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $adc6a95ef6681603$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $adc6a95ef6681603$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $adc6a95ef6681603$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $adc6a95ef6681603$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $adc6a95ef6681603$export$4653cda61a4943d6 = 75;
const $adc6a95ef6681603$export$d1b9ea3245b6a5de = 2;
const $adc6a95ef6681603$export$d07bba395c9390f1 = 36;
const $adc6a95ef6681603$export$29911ec08ab2ca2d = 5;
const $adc6a95ef6681603$export$b61e6f89a9db76de = 12;
const $adc6a95ef6681603$export$7fd2e391116c6ef5 = 9;
const $adc6a95ef6681603$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("hjdUw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira_amplitude_sr_phase_2', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("2W1LT")
]).then(()=>parcelRequire('5Uorw'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});




parcelRegister("2cEzx", function(module, exports) {
$parcel$export(module.exports, "archivedIssuesEntrypoint", () => $36d58d7b269574ee$export$3f35189530920ce3);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $36d58d7b269574ee$export$3f35189530920ce3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jZlR8")), {
        moduleId: "c61780dd",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jZlR8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d6Zdr").then(()=>parcelRequire('k7LtZ'));

});




parcelRegister("9JhPg", function(module, exports) {
$parcel$export(module.exports, "archivedPlansRouteEntry", () => $5664307c6970e86f$export$b9921058a8a65710);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bXBC1 = parcelRequire("bXBC1");

var $5nxGF = parcelRequire("5nxGF");
const $5664307c6970e86f$export$b9921058a8a65710 = (0, $6xToB.createEntry)((0, $bXBC1.archivedPlansRoute), ()=>({
        group: 'global-settings',
        component: (0, $5nxGF.ArchivedPlansDirectory),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5nxGF.LazyArchivedPlans)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-spa-entries/src/archivedPlansRouteEntry.tsx',
                whichExportToUse: 'archivedPlansRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fc9ma", function(module, exports) {
$parcel$export(module.exports, "default", () => $a97f84d2af4da2a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $a97f84d2af4da2a3$var$LazyGlobalProductsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("bNwM9")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
const $a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a97f84d2af4da2a3$var$LazyGlobalProductsSettingsSidebar, null)));
$a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a97f84d2af4da2a3$export$2e2bcd8739ae039 = $a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar;

});
parcelRegister("bNwM9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("3oeBN")
]).then(()=>parcelRequire('ixDlv'));

});


parcelRegister("bXBC1", function(module, exports) {
$parcel$export(module.exports, "archivedPlansRoute", () => $6b371cb941630836$export$29647353386ad146);
const $6b371cb941630836$export$29647353386ad146 = {
    name: 'archived-plans-directory',
    path: '/jira/plans/settings/archive',
    exact: true
};

});

parcelRegister("5nxGF", function(module, exports) {
$parcel$export(module.exports, "LazyArchivedPlans", () => $02692f9b8d9b7613$export$cf676f47aba10db8);
$parcel$export(module.exports, "ArchivedPlansDirectory", () => $02692f9b8d9b7613$export$ed59bbc59461c00f);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $02692f9b8d9b7613$export$cf676f47aba10db8 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7gogM")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $02692f9b8d9b7613$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $02692f9b8d9b7613$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("7gogM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("2w2jh")
]).then(()=>parcelRequire('2LlB2'));

});



parcelRegister("7y12x", function(module, exports) {
$parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", () => $b09f69ab5f5fe5f3$export$45e68d450757a753);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1jeQz = parcelRequire("1jeQz");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $b09f69ab5f5fe5f3$var$LazyArchivedDirectLink = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2oopw"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $b09f69ab5f5fe5f3$var$ArchivedProjectDirectLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b09f69ab5f5fe5f3$var$LazyArchivedDirectLink,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $b09f69ab5f5fe5f3$export$45e68d450757a753 = (0, $6xToB.createEntry)((0, $1jeQz.archivedProjectDirectLinkRoute), ()=>({
        group: 'redirects',
        component: $b09f69ab5f5fe5f3$var$ArchivedProjectDirectLink,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $b09f69ab5f5fe5f3$var$LazyArchivedDirectLink
        ],
        ufoName: 'project-archived',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archived-project-direct-link-entries/src/archivedProjectDirectLinkRouteEntry.tsx',
                whichExportToUse: 'archivedProjectDirectLinkRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1jeQz", function(module, exports) {
$parcel$export(module.exports, "archivedProjectDirectLinkRoute", () => $0e540b7438a85254$export$cd3fc26cf9f696e6);
const $0e540b7438a85254$export$cd3fc26cf9f696e6 = {
    name: 'archived-project-direct-link',
    path: '/jira/errors/project-archived',
    exact: true
};

});

parcelRegister("2oopw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jKxVf").then(()=>parcelRequire('arEu0'));

});


parcelRegister("54Mg6", function(module, exports) {
$parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", () => $f91c1016b40c2bbf$export$dc5f9e3c3931cc36);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $eD4cF = parcelRequire("eD4cF");

var $jx00M = parcelRequire("jx00M");
const $f91c1016b40c2bbf$export$dc5f9e3c3931cc36 = (0, $6xToB.createEntry)((0, $eD4cF.archivedProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        component: (0, $jx00M.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jx00M.LazyArchivedProjectsAdmin)
        ],
        ufoName: 'admin.archived-projects',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archived-projects-directory-entries/src/archivedProjectsDirectoryRouteEntry.tsx',
                whichExportToUse: 'archivedProjectsDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("vJYlr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b77bce2b95f32c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $5b77bce2b95f32c3$var$LazyGlobalProjectsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("fhHuz")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
const $5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b77bce2b95f32c3$var$LazyGlobalProjectsSettingsSidebar, null)));
$5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $5b77bce2b95f32c3$export$2e2bcd8739ae039 = $5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("fhHuz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iW52P").then(()=>parcelRequire('kdaCi'));

});


parcelRegister("eD4cF", function(module, exports) {
$parcel$export(module.exports, "archivedProjectsDirectoryRoute", () => $c170187e7bac8710$export$b60634d0fa43f719);
const $c170187e7bac8710$export$b60634d0fa43f719 = {
    name: 'archived-projects-directory',
    path: '/jira/settings/projects/archive',
    exact: true
};

});

parcelRegister("jx00M", function(module, exports) {
$parcel$export(module.exports, "LazyArchivedProjectsAdmin", () => $512b503a29fc1a7a$export$b220ffb582ee39aa);
$parcel$export(module.exports, "default", () => $512b503a29fc1a7a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $512b503a29fc1a7a$export$b220ffb582ee39aa = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("MRPGJ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
const $512b503a29fc1a7a$var$AsyncArchivedProjectsAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $512b503a29fc1a7a$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });
var $512b503a29fc1a7a$export$2e2bcd8739ae039 = $512b503a29fc1a7a$var$AsyncArchivedProjectsAdmin;

});
parcelRegister("MRPGJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("fliVL"),
    $ewTvA("jiQPW")
]).then(()=>parcelRequire('gXgjG'));

});



parcelRegister("kZGLD", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJsmRouteEntry", () => $5a448b11bd088eba$export$cdfe13bfc51ce940);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $5vGGb = parcelRequire("5vGGb");

var $aQoXd = parcelRequire("aQoXd");

var $j3sUb = parcelRequire("j3sUb");
const $5a448b11bd088eba$export$cdfe13bfc51ce940 = (0, $6xToB.createEntry)((0, $5vGGb.archivedWorkItemsJsmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectServicedeskRoute from issue-navigator
        layout: (0, $aQoXd.serviceProjectLayout),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesWithoutHorizontalNavPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archives-entries/src/archivedWorkItemsJsmRouteEntry.tsx',
                whichExportToUse: 'archivedWorkItemsJsmRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5vGGb", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJsmRoute", () => $2fc7bab5d1fd1b68$export$36e9c9de963d9a4f);
const $2fc7bab5d1fd1b68$export$36e9c9de963d9a4f = {
    name: 'servicedesk-archived-work-items',
    path: '/jira/servicedesk/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("5y94r", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswCompanyRouteEntry", () => $3f25b6f7d5466283$export$5555f344b15f5187);

var $hS1gr = parcelRequire("hS1gr");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $2pKcR = parcelRequire("2pKcR");

var $j3sUb = parcelRequire("j3sUb");
const $3f25b6f7d5466283$export$5555f344b15f5187 = (0, $6xToB.createEntry)((0, $2pKcR.archivedWorkItemsJswCompanyRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectClassicRoute from issue-navigator
        layout: (0, $j3sUb.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archives-entries/src/archivedWorkItemsJswCompanyRouteEntry.tsx',
                whichExportToUse: 'archivedWorkItemsJswCompanyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k6duF", function(module, exports) {
$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $919301427081454d$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $919301427081454d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

const $919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("3Eaha")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("3Eaha")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
const $919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
$919301427081454d$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$919301427081454d$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $919301427081454d$export$2e2bcd8739ae039 = $919301427081454d$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("3Eaha", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("1WCUI")
]).then(()=>parcelRequire('h8X2Q'));

});


parcelRegister("2pKcR", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswCompanyRoute", () => $d8bb6fa8c300a067$export$d370de0c0b8dc61b);
const $d8bb6fa8c300a067$export$d370de0c0b8dc61b = {
    name: 'software-archived-work-items-classic',
    path: '/jira/software/c/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("3cJRB", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswRouteEntry", () => $f71c77f19c231728$export$2686cd22a3691dbf);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $gHaIq = parcelRequire("gHaIq");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $j3sUb = parcelRequire("j3sUb");
const $f71c77f19c231728$export$2686cd22a3691dbf = (0, $6xToB.createEntry)((0, $gHaIq.archivedWorkItemsJswRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectSoftwareRoute from issue-navigator
        layout: (0, $6dwgv.createLayout)((0, $8FCAy.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archives-entries/src/archivedWorkItemsJswRouteEntry.tsx',
                whichExportToUse: 'archivedWorkItemsJswRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gHaIq", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJswRoute", () => $517c307f7699d330$export$356fe8859732c01b);
const $517c307f7699d330$export$356fe8859732c01b = {
    name: 'software-archived-work-items',
    path: '/jira/software/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("apVTf", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJwmRouteEntry", () => $e122004475a9740a$export$a243ee53747084d5);

var $hS1gr = parcelRequire("hS1gr");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $3belI = parcelRequire("3belI");

var $j3sUb = parcelRequire("j3sUb");
const $e122004475a9740a$export$a243ee53747084d5 = (0, $6xToB.createEntry)((0, $3belI.archivedWorkItemsJwmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectBusinessRoute from issue-navigator
        layout: (0, $j3sUb.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $j3sUb.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $kRv8K.getBusinessProjectResources)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-archives-entries/src/archivedWorkItemsJwmRouteEntry.tsx',
                whichExportToUse: 'archivedWorkItemsJwmRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hiOwQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c48a3c7fb40f9811$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $c48a3c7fb40f9811$var$LazyCoreProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("bUOXs")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $c48a3c7fb40f9811$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c48a3c7fb40f9811$var$LazyCoreProjectSidebar, null));
var $c48a3c7fb40f9811$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($c48a3c7fb40f9811$var$CoreProjectSidebar);

});
parcelRegister("bUOXs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("knnJv")
]).then(()=>parcelRequire('2ZlQu'));

});


parcelRegister("kRv8K", function(module, exports) {
$parcel$export(module.exports, "getBusinessProjectResources", () => $624d2da23216c44c$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $624d2da23216c44c$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $624d2da23216c44c$export$21c5527b459d56fe);

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $ebWJz = parcelRequire("ebWJz");

var $cV98p = parcelRequire("cV98p");

var $iXIhG = parcelRequire("iXIhG");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8tbnc = parcelRequire("8tbnc");

var $ho9E1 = parcelRequire("ho9E1");

var $1G20J = parcelRequire("1G20J");
const $624d2da23216c44c$export$20e8c2951e444b08 = ()=>[
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1G20J.projectThemeResource)
    ];
const $624d2da23216c44c$export$fcbe882e18ee4a35 = ()=>[
        ...$624d2da23216c44c$export$20e8c2951e444b08(),
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $ebWJz.fieldsResource)
    ];
const $624d2da23216c44c$export$46471673e66df5c1 = ()=>[
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $iXIhG.overviewDetailsResource),
        (0, $1G20J.projectThemeResource)
    ];
const $624d2da23216c44c$export$21c5527b459d56fe = ()=>[
        ...$624d2da23216c44c$export$46471673e66df5c1(),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $ebWJz.fieldsResource)
    ];

});
parcelRegister("ebWJz", function(module, exports) {
$parcel$export(module.exports, "fieldsResource", () => $f772abfaa17ccd63$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $f772abfaa17ccd63$export$c0cd85886917fe89);

var $cwZUV = parcelRequire("cwZUV");

var $942wy = parcelRequire("942wy");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $9bD5G = parcelRequire("9bD5G");

var $7cmPk = parcelRequire("7cmPk");
const $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $f772abfaa17ccd63$export$8bca6c1954ae9308 = (0, $l1VxS.createResource)({
    type: $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$c378ca4a0e2c9fec), $f772abfaa17ccd63$var$handleOverviewResponse, {
            overviewAri: (0, $cwZUV.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$4d41378da3f70f0f), $f772abfaa17ccd63$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $f772abfaa17ccd63$export$c0cd85886917fe89 = ()=>(0, $eJrcF.useResource)($f772abfaa17ccd63$export$8bca6c1954ae9308);

});
const $d414d4047a262b56$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $d414d4047a262b56$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("9bD5G", function(module, exports) {
$parcel$export(module.exports, "fetchFields", () => $d910ddfedea9b5ee$export$f3ddd735c360919);

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $d910ddfedea9b5ee$var$PAGE_SIZE = 100;
const $d910ddfedea9b5ee$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $d910ddfedea9b5ee$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("7cmPk", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $532ac776c238882e$export$3ceb62baab058c6b);
const $532ac776c238882e$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("cV98p", function(module, exports) {
$parcel$export(module.exports, "navigationResource", () => $e93bba7c11632d20$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $e93bba7c11632d20$export$c17011c09e042a31);

var $8dH3d = parcelRequire("8dH3d");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $exaWd = parcelRequire("exaWd");

const $e93bba7c11632d20$export$62940941ee574cdc = (0, $l1VxS.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectKey)) return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectId)) return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $3osLr.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $e93bba7c11632d20$export$c17011c09e042a31 = ()=>(0, $eJrcF.useResource)($e93bba7c11632d20$export$62940941ee574cdc);

});
const $facb8b07dec6e94a$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $facb8b07dec6e94a$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $facb8b07dec6e94a$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $facb8b07dec6e94a$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $facb8b07dec6e94a$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $facb8b07dec6e94a$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;
const $facb8b07dec6e94a$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;
const $facb8b07dec6e94a$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;

parcelRegister("exaWd", function(module, exports) {
$parcel$export(module.exports, "fetchNavigation", () => $5a91feaff3ce8435$export$1fc5fff73d9a570c);

var $942wy = parcelRequire("942wy");

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");


var $bUjBB = parcelRequire("bUjBB");
const $5a91feaff3ce8435$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $5a91feaff3ce8435$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $2affa696f349435b$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $942wy.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $bUjBB.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $5a91feaff3ce8435$var$EMPTY_RESPONSE;
};

});
const $2affa696f349435b$export$3349219a88ac77cd = 10;
const $2affa696f349435b$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("bUjBB", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $af6a29813efa9984$export$3ceb62baab058c6b);

var $1uv7v = parcelRequire("1uv7v");


var $9aOeZ = parcelRequire("9aOeZ");
const $af6a29813efa9984$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $af6a29813efa9984$var$PREMIUM = 'PREMIUM';
const $af6a29813efa9984$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $af6a29813efa9984$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $af6a29813efa9984$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name
    });
const $af6a29813efa9984$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $2affa696f349435b$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $af6a29813efa9984$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $9aOeZ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$af6a29813efa9984$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$af6a29813efa9984$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$af6a29813efa9984$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("9aOeZ", function(module, exports) {
$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $02fee4f3a61bd031$export$ddf2fc82885279d);
const $02fee4f3a61bd031$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $02fee4f3a61bd031$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $02fee4f3a61bd031$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("ebuR2", function(module, exports) {
$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a81e3a6968ecf224$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a81e3a6968ecf224$export$97def3841413167f);
/* eslint-disable camelcase */ 
var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $94I3A = parcelRequire("94I3A");
const $a81e3a6968ecf224$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a81e3a6968ecf224$export$ced53bf9d9551fef = (0, $l1VxS.createResource)({
    type: $a81e3a6968ecf224$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a81e3a6968ecf224$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $94I3A.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a81e3a6968ecf224$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($a81e3a6968ecf224$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("94I3A", function(module, exports) {
$parcel$export(module.exports, "fetchProjectDetails", () => $afb0ef71187f4894$export$78aa221476efa1c6);

var $3osLr = parcelRequire("3osLr");

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");


var $52UtB = parcelRequire("52UtB");
const $afb0ef71187f4894$var$EMPTY_VALUE = {};
const $afb0ef71187f4894$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $3833a2a8ead613b5$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $3osLr.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $52UtB.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $afb0ef71187f4894$var$EMPTY_VALUE;
};

});
const $3833a2a8ead613b5$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $3833a2a8ead613b5$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$3833a2a8ead613b5$var$PROJECT_FRAGMENT}
`;

parcelRegister("52UtB", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $e1a6d24fb0f7d7ff$export$3ceb62baab058c6b);
const $e1a6d24fb0f7d7ff$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $e1a6d24fb0f7d7ff$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $e1a6d24fb0f7d7ff$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $e1a6d24fb0f7d7ff$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("8tbnc", function(module, exports) {
$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $70398e7926820970$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $70398e7926820970$export$90749419e9042370);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $bGJcU = parcelRequire("bGJcU");
const $70398e7926820970$export$92c4069b5349d086 = (0, $l1VxS.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $bGJcU.fetchLicenseDetails)((0, $ba7d1bcdd3e5eca1$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity,
    isCritical: true
});
const $70398e7926820970$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $eJrcF.useResource)($70398e7926820970$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $ba7d1bcdd3e5eca1$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("bGJcU", function(module, exports) {
$parcel$export(module.exports, "fetchLicenseDetails", () => $ebc3c21a42e05a54$export$ec058a82eccb31e);

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $ebc3c21a42e05a54$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $ebc3c21a42e05a54$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $ebc3c21a42e05a54$var$EMPTY_RESPONSE;
};

});


parcelRegister("ho9E1", function(module, exports) {
$parcel$export(module.exports, "projectCreatePermissionsResource", () => $684d3b239b1e0d5f$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $684d3b239b1e0d5f$export$2bd0d3b374549a68);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $684d3b239b1e0d5f$var$getDataLoader = ()=>(parcelRequire("fGbmC"));
const $684d3b239b1e0d5f$export$f6c05eaea53ab4ae = (0, $l1VxS.createResource)({
    type: (0, $edca60a3af8f4bf8$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $684d3b239b1e0d5f$var$getDataLoader,
    maxAge: Infinity
});
const $684d3b239b1e0d5f$export$2bd0d3b374549a68 = ()=>(0, $eJrcF.useResource)($684d3b239b1e0d5f$export$f6c05eaea53ab4ae);

});
const $edca60a3af8f4bf8$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("fGbmC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aZk2z").then(()=>parcelRequire('jRDDZ'));

});



parcelRegister("3belI", function(module, exports) {
$parcel$export(module.exports, "archivedWorkItemsJwmRoute", () => $f4fce0a70da28628$export$1377e2cf39b3ae6a);
const $f4fce0a70da28628$export$1377e2cf39b3ae6a = {
    name: 'classic-business-archived-work-items',
    path: '/jira/core/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("2PFkC", function(module, exports) {
$parcel$export(module.exports, "arjCalendarEmbedRouteEntry", () => $91f0557b62d46e4c$export$309ed92381819b04);

var $eJOHy = parcelRequire("eJOHy");


var $k8mcw = parcelRequire("k8mcw");

var $g8uYY = parcelRequire("g8uYY");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $5rPHm = parcelRequire("5rPHm");

var $dsh9d = parcelRequire("dsh9d");

var $i9Kzd = parcelRequire("i9Kzd");
const $91f0557b62d46e4c$var$planCalendarEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $i9Kzd.calendarEntryPoint)
});
const $91f0557b62d46e4c$export$309ed92381819b04 = (0, $6xToB.createEntry)((0, $5rPHm.arjCalendarEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar-embed',
        skeleton: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dsh9d.CalendarSkeleton), null);
        },
        entryPoint () {
            (0, $k8mcw.setCapability)((0, $652f5f63189f3e2a$export$f999749ac7a2cd1));
            return $91f0557b62d46e4c$var$planCalendarEmbedRouteEntry;
        },
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f999749ac7a2cd1)
        },
        forPaint: [],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-embed-entries/src/arjCalendarEmbedRouteEntry.tsx',
                whichExportToUse: 'arjCalendarEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("4KrIc", function(module, exports) {
$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $ec1729c125d0f001$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $ec1729c125d0f001$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $ec1729c125d0f001$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $ec1729c125d0f001$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $ec1729c125d0f001$export$f5b159e1fb19e04e);

var $jPROM = parcelRequire("jPROM");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

var $aV23b = parcelRequire("aV23b");

var $7hVvO = parcelRequire("7hVvO");

const $ec1729c125d0f001$export$6ca262338f199e4b = (0, $l1VxS.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        /**
		 * resource getKey will be called whenever URL changes
		 */ return '';
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $ec1729c125d0f001$export$aec847b4ce72891 = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $3ugTQ.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $ec1729c125d0f001$export$7431e46c7ad56c3d = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
            component: 'router-resources.advanced-roadmaps-plan.initial-checks.get-data',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $3ugTQ.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $ec1729c125d0f001$export$bf0c5395c73cc255 = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
            component: 'router-resources.advanced-roadmaps-plan.report-initial-checks.get-data',
            message: 'Current user is not authenticated',
            name: 'AuthenticationError',
            skipSentry: true
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $3ugTQ.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $ec1729c125d0f001$export$f5b159e1fb19e04e = (0, $l1VxS.createResource)({
    type: (0, $467ecd9a8a47f90a$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $3ugTQ.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
const $467ecd9a8a47f90a$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $467ecd9a8a47f90a$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $467ecd9a8a47f90a$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $467ecd9a8a47f90a$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("5rPHm", function(module, exports) {
$parcel$export(module.exports, "arjCalendarEmbedRoute", () => $1780fc2d96c15a78$export$30779cab3c860456);
const $1780fc2d96c15a78$export$30779cab3c860456 = {
    name: 'software-plan-calendar-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};

});

parcelRegister("dsh9d", function(module, exports) {
$parcel$export(module.exports, "CalendarSkeleton", () => $a30845490434a605$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $a30845490434a605$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $a30845490434a605$export$504e7b05f3c54bf2);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $9jUqP = parcelRequire("9jUqP");

var $lo02j = parcelRequire("lo02j");

var $bYRoz = parcelRequire("bYRoz");
const $a30845490434a605$var$customCssStyles = null;
const $a30845490434a605$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9jUqP)))
    });
const $a30845490434a605$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lo02j)))
    });
const $a30845490434a605$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bYRoz))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9jUqP", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("lo02j", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("bYRoz", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("i9Kzd", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $1364aab682a9549d$export$19cf4b398f638dc6);

var $4cTDP = parcelRequire("4cTDP");

var $lpUQd = parcelRequire("lpUQd");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $1364aab682a9549d$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
const $1364aab682a9549d$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
function $1364aab682a9549d$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $1364aab682a9549d$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $1364aab682a9549d$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $1364aab682a9549d$var$getStorageValueFromScope(key) {
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $1364aab682a9549d$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $1364aab682a9549d$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $1364aab682a9549d$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $1364aab682a9549d$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $1364aab682a9549d$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $1364aab682a9549d$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $1364aab682a9549d$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $1364aab682a9549d$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $1364aab682a9549d$var$toCalendarWeekStart(weekStart) {
    switch(weekStart){
        case 'sunday':
            return 'sunday';
        case 'saturday':
            return 'saturday';
        default:
            return 'monday';
    }
}
function $1364aab682a9549d$var$toCalendarColorBy(colorBy) {
    switch(colorBy){
        case 'none':
            return 'none';
        case 'status':
            return 'status';
        default:
            return 'status';
    }
}
function $1364aab682a9549d$var$toCalendarViewRange(view) {
    switch(view){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $1364aab682a9549d$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $1364aab682a9549d$var$toMidnightUTCString(selectedDate),
        mode: $1364aab682a9549d$var$toViewMode(viewRange),
        weekStart: $1364aab682a9549d$var$toWeekStart(weekStartsOn),
        ...(0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $1364aab682a9549d$var$buildIssuesSearchInput(storageKey, filter, isEmbed) {
    return {
        additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $1364aab682a9549d$var$getStorageValueFromScope(storageKey)
    };
}
function $1364aab682a9549d$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $1364aab682a9549d$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $1364aab682a9549d$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $1364aab682a9549d$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $1364aab682a9549d$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy, viewRange) {
    if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy || viewRange) return {
        hideWeekends: hideWeekends === 'true' || undefined,
        hideSprints: hideSprints === 'true' || undefined,
        hideVersions: hideVersions === 'true' || undefined,
        hideIssues: hideIssues === 'true' || undefined,
        hideIssueKey: hideIssueKey === 'true' || undefined,
        weekStartsOn: $1364aab682a9549d$var$toCalendarWeekStart(weekStartsOnQueryParam),
        colorBy: $1364aab682a9549d$var$toCalendarColorBy(colorBy),
        viewRange: $1364aab682a9549d$var$toCalendarViewRange(viewRange)
    };
    return undefined;
}

const $1364aab682a9549d$export$19cf4b398f638dc6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jNEQu")), {
        moduleId: "53aec496",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $1364aab682a9549d$var$createScope(entryPointRouteParams);
        const scopeInput = $1364aab682a9549d$var$buildScopeInput(scope);
        const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam, viewRange: viewRangeParam } = context.query;
        const selectedDate = $1364aab682a9549d$var$toDate(date);
        const hasFilterQueryParam = Boolean(filter);
        const routeName = context.route.name;
        const settingsQueryParams = $1364aab682a9549d$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam, viewRangeParam);
        const isEmbed = routeName === $1364aab682a9549d$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED;
        const settings = (0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? $1364aab682a9549d$var$getViewSettings($1364aab682a9549d$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = settingsQueryParams?.viewRange ?? settings?.viewRange ?? 'month';
        const weekStartsOn = (0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday' : 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $1364aab682a9549d$var$getStorageKeyFromScope(context);
        const viewId = $1364aab682a9549d$var$buildViewId(scope);
        const filterQuery = $1364aab682a9549d$var$buildIssuesSearchInput(storageKey, filter, isEmbed);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $lpUQd.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $1364aab682a9549d$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 50,
                        issuesSearchInput: filterQuery,
                        unscheduledIssuesSearchInput: $1364aab682a9549d$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $1364aab682a9549d$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $1364aab682a9549d$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $1364aab682a9549d$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        pageLoadMoreEnabled: (0, $4cTDP.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4cTDP.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey,
                hasFilterQueryParam: hasFilterQueryParam,
                routeName: routeName,
                settingsQueryParams: settingsQueryParams,
                filterQuery: filterQuery.additionalFilterQuery,
                planId: String(context.match.params.planId)
            }
        };
    }
});

});
parcelRegister("lpUQd", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1db805a13398289$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f06f7f1ebf74ba5ce9f9a3159158b585>>
 * @relayHash abcecbee2d472915c1e43640f0e10568
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca3eefa1749696961d1abd1ad7ca8da2cfbb7e58d9a99457813f1b1322f2e2cd
const $a1db805a13398289$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ca3eefa1749696961d1abd1ad7ca8da2cfbb7e58d9a99457813f1b1322f2e2cd",
        "metadata": {},
        "name": "CalendarContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a1db805a13398289$export$2e2bcd8739ae039 = $a1db805a13398289$var$node;

});

parcelRegister("jNEQu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("d7aZW")),
    $ewTvA("eBZpe")
]).then(()=>parcelRequire('7wJ5d'));

});
parcelRegister("c5iyL", function(module, exports) {
"use strict";

var $5VrpE = parcelRequire("5VrpE");
module.exports = $5VrpE(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("5VrpE", function(module, exports) {
"use strict";
let $45078a36e59142a3$var$cachedBundles = {};
let $45078a36e59142a3$var$cachedPreloads = {};
let $45078a36e59142a3$var$cachedPrefetches = {};
function $45078a36e59142a3$var$getCache(type) {
    switch(type){
        case 'preload':
            return $45078a36e59142a3$var$cachedPreloads;
        case 'prefetch':
            return $45078a36e59142a3$var$cachedPrefetches;
        default:
            return $45078a36e59142a3$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $45078a36e59142a3$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("7lkHZ", function(module, exports) {
$parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", () => $2378ab8bb8366069$export$2506a377ba649c46);

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $5R5ZI = parcelRequire("5R5ZI");

var $g8uYY = parcelRequire("g8uYY");

var $3nt6g = parcelRequire("3nt6g");

var $j66XX = parcelRequire("j66XX");
const $2378ab8bb8366069$var$planDependenciesReportEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $3nt6g.planDependenciesReportEntryPoint)
});
const $2378ab8bb8366069$export$2506a377ba649c46 = (0, $6xToB.createEntry)((0, $5R5ZI.arjDependenciesEmbedRoute), ()=>({
        group: 'software',
        component: (0, $j66XX.PlanDependenciesReportEmbedPage),
        entryPoint: ()=>$2378ab8bb8366069$var$planDependenciesReportEmbedRouteEntry,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $j66XX.LazyPlanDependenciesReportEmbed)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-embed-entries/src/arjDependenciesEmbedRouteEntry.tsx',
                whichExportToUse: 'arjDependenciesEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5R5ZI", function(module, exports) {
$parcel$export(module.exports, "arjDependenciesEmbedRoute", () => $959c7b2a9e7b4aac$export$96aaf89753980215);
const $959c7b2a9e7b4aac$export$96aaf89753980215 = {
    name: 'software-plan-dependencies-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
};

});

parcelRegister("3nt6g", function(module, exports) {
$parcel$export(module.exports, "planDependenciesReportEntryPoint", () => $a2960b3abd5afd4a$export$e4ba4cc5a2304191);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a2960b3abd5afd4a$export$e4ba4cc5a2304191 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eJpwO")), {
        moduleId: "1a1a3500",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eJpwO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("5PRFh")),
    $ewTvA("32rAF")
]).then(()=>parcelRequire('16LzX'));

});


parcelRegister("j66XX", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSummaryEmbed", () => $15d5d2cd9dd1f407$export$b0feb6e650be3c8c);
$parcel$export(module.exports, "PlanSummaryEmbedPage", () => $15d5d2cd9dd1f407$export$a37f296d90476a73);
$parcel$export(module.exports, "LazyPlanDependenciesReportEmbed", () => $15d5d2cd9dd1f407$export$48681ab0b4246654);
$parcel$export(module.exports, "PlanDependenciesReportEmbedPage", () => $15d5d2cd9dd1f407$export$4ece7fb6c15037f9);
$parcel$export(module.exports, "LazyPlanIncrementEmbed", () => $15d5d2cd9dd1f407$export$51f2083dff1ee684);
$parcel$export(module.exports, "PlanIncrementEmbedPage", () => $15d5d2cd9dd1f407$export$a2ae011b90c17927);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $15d5d2cd9dd1f407$export$b0feb6e650be3c8c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5QPfy"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $15d5d2cd9dd1f407$export$a37f296d90476a73 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $15d5d2cd9dd1f407$export$b0feb6e650be3c8c,
        pageId: "plan-summary-embed-old",
        shouldShowSpinner: true
    });

const $15d5d2cd9dd1f407$export$48681ab0b4246654 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bJJn2"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
const $15d5d2cd9dd1f407$export$4ece7fb6c15037f9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $15d5d2cd9dd1f407$export$48681ab0b4246654,
        pageId: "plan-dependencies-report-embed-old",
        shouldShowSpinner: true
    });

const $15d5d2cd9dd1f407$export$51f2083dff1ee684 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("qXO6i"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $15d5d2cd9dd1f407$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $15d5d2cd9dd1f407$export$51f2083dff1ee684,
        pageId: "plan-increment-embed-old",
        shouldShowSpinner: true
    });

});
parcelRegister("5QPfy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("bD6QJ")),
    $ewTvA("fHpLQ")
]).then(()=>parcelRequire('9l7Vm'));

});

parcelRegister("bJJn2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("4nUBB")),
    $ewTvA("756Sk")
]).then(()=>parcelRequire('5SP4f'));

});

parcelRegister("qXO6i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("kNFvF"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("5OUWd")),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("htiDc")
]).then(()=>parcelRequire('6cTeO'));

});



parcelRegister("fxZdD", function(module, exports) {
$parcel$export(module.exports, "arjIncrementEmbedRouteEntry", () => $f68fda2c44f7fd57$export$3feed0b4da010c52);

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $krd26 = parcelRequire("krd26");

var $g8uYY = parcelRequire("g8uYY");

var $eDyDZ = parcelRequire("eDyDZ");

var $j66XX = parcelRequire("j66XX");
const $f68fda2c44f7fd57$var$planProgramEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $eDyDZ.planIncrementEntryPoint)
});
const $f68fda2c44f7fd57$export$3feed0b4da010c52 = (0, $6xToB.createEntry)((0, $krd26.arjIncrementEmbedRoute), ()=>({
        group: 'software',
        component: (0, $j66XX.PlanIncrementEmbedPage),
        entryPoint: ()=>$f68fda2c44f7fd57$var$planProgramEmbedRouteEntry,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $j66XX.LazyPlanIncrementEmbed)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-embed-entries/src/arjIncrementEmbedRouteEntry.tsx',
                whichExportToUse: 'arjIncrementEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("krd26", function(module, exports) {
$parcel$export(module.exports, "arjIncrementEmbedRoute", () => $841f36b364b459fb$export$88913ef2dfa37bc1);
const $841f36b364b459fb$export$88913ef2dfa37bc1 = {
    name: 'software-plan-increment-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};

});

parcelRegister("eDyDZ", function(module, exports) {
$parcel$export(module.exports, "planIncrementEntryPoint", () => $951d2e71208e83e4$export$72cc8a7d91a08ace);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $951d2e71208e83e4$export$72cc8a7d91a08ace = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3c3W8")), {
        moduleId: "6d0a9b0d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3c3W8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("kNFvF"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("98Ohz")),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2Acgg")
]).then(()=>parcelRequire('3L39g'));

});



parcelRegister("aCLGk", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", () => $26aabb4118899eb9$export$804f2d81dfbdd5c9);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $6U5mJ = parcelRequire("6U5mJ");

var $9NmsS = parcelRequire("9NmsS");

var $9T7WW = parcelRequire("9T7WW");

var $crpnS = parcelRequire("crpnS");

var $3A1Of = parcelRequire("3A1Of");
const $26aabb4118899eb9$export$804f2d81dfbdd5c9 = (0, $6xToB.createEntry)((0, $9T7WW.arjSettingsDependenciesLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3A1Of.redirectTo)('/jira/plans/settings/dependencies'),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $6U5mJ.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsDependencies)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-settings-entries/src/arjSettingsDependenciesLegacyRedirectRouteEntry.tsx',
                whichExportToUse: 'arjSettingsDependenciesLegacyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6U5mJ", function(module, exports) {
$parcel$export(module.exports, "issueLinkInformationResource", () => $dca48e61cf3706a8$export$8d8544ca08d98837);

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
const $dca48e61cf3706a8$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $dca48e61cf3706a8$var$url = '/rest/jpo/1.0/info/query';
const $dca48e61cf3706a8$var$fetchIssueLinkInformation = ()=>(0, $3ugTQ.performPostRequest)($dca48e61cf3706a8$var$url, {
        body: JSON.stringify($dca48e61cf3706a8$var$body)
    });
const $dca48e61cf3706a8$export$8d8544ca08d98837 = (0, $l1VxS.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$dca48e61cf3706a8$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("9T7WW", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRoute", () => $901796dcf2a308cf$export$f96bfb0a2b0ad0f4);
const $901796dcf2a308cf$export$f96bfb0a2b0ad0f4 = {
    name: 'arj-settings-dependencies-redirect',
    path: '/secure/PortfolioDependencySettings.jspa'
};

});

parcelRegister("crpnS", function(module, exports) {
$parcel$export(module.exports, "LazyArjSettingsDependencies", () => $e671e47effddf844$export$4fcc3c0f6e792efc);
$parcel$export(module.exports, "ArjSettingsDependencies", () => $e671e47effddf844$export$d6f045c7c1aaff50);
$parcel$export(module.exports, "LazyArjSettingsLoadingLimits", () => $e671e47effddf844$export$64761ea1912fdcd9);
$parcel$export(module.exports, "ArjSettingsLoadingLimits", () => $e671e47effddf844$export$7bb4c0f22b467385);
$parcel$export(module.exports, "LazyArjSettingsPermissions", () => $e671e47effddf844$export$edb4ae7e85c7908d);
$parcel$export(module.exports, "ArjSettingsPermissions", () => $e671e47effddf844$export$fa852ea42b98d3de);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e671e47effddf844$export$4fcc3c0f6e792efc = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ir7LJ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $e671e47effddf844$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e671e47effddf844$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });

const $e671e47effddf844$export$64761ea1912fdcd9 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1DbD0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $e671e47effddf844$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e671e47effddf844$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });

const $e671e47effddf844$export$edb4ae7e85c7908d = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("h7fdS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $e671e47effddf844$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e671e47effddf844$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("ir7LJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5WEe6").then(()=>parcelRequire('b4Lez'));

});

parcelRegister("1DbD0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("jvSpc")),
    $ewTvA("8tT3q")
]).then(()=>parcelRequire('azPLx'));

});

parcelRegister("h7fdS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iI0JV").then(()=>parcelRequire('7c5Kl'));

});


parcelRegister("3A1Of", function(module, exports) {
$parcel$export(module.exports, "redirectTo", () => $621b7d6c3aba0ef3$export$2d47ce6f15e624e5);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $621b7d6c3aba0ef3$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: redirectUrl
        });

});
parcelRegister("7fTjp", function(module, exports) {
$parcel$export(module.exports, "ScreenRedirect", () => $d4a25a2e90068241$export$fdd3e60cd227c2f7);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $d4a25a2e90068241$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $gCY1z.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $3lhVL.useSpaStateTransition)();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $kRgKj.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});



parcelRegister("eJqY3", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", () => $2dec85f6387d4de5$export$70386609aff5ba12);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $6U5mJ = parcelRequire("6U5mJ");

var $9NmsS = parcelRequire("9NmsS");

var $3pzsO = parcelRequire("3pzsO");

var $crpnS = parcelRequire("crpnS");
const $2dec85f6387d4de5$export$70386609aff5ba12 = (0, $6xToB.createEntry)((0, $3pzsO.arjSettingsDependenciesRoute), ()=>({
        group: 'software',
        component: (0, $crpnS.ArjSettingsDependencies),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $6U5mJ.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsDependencies)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-settings-entries/src/arjSettingsDependenciesRouteEntry.tsx',
                whichExportToUse: 'arjSettingsDependenciesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3pzsO", function(module, exports) {
$parcel$export(module.exports, "arjSettingsDependenciesRoute", () => $ea31bea6e2ac6c5c$export$ff9b90f9d680e34);
const $ea31bea6e2ac6c5c$export$ff9b90f9d680e34 = {
    name: 'arj-settings-dependencies',
    path: '/jira/plans/settings/dependencies'
};

});


parcelRegister("1lOAz", function(module, exports) {
$parcel$export(module.exports, "arjSettingsFinancialYearPageRouteEntry", () => $68e73400ed0dc409$export$b6bba25826e621b9);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $7MNDz = parcelRequire("7MNDz");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $l2CRW = parcelRequire("l2CRW");

var $dVS1R = parcelRequire("dVS1R");
const $68e73400ed0dc409$export$b6bba25826e621b9 = (0, $6xToB.createEntry)((0, $l2CRW.arjSettingsFinancialYearPageRoute), ()=>({
        group: 'software',
        component: (0, $dVS1R.ArjSettingsFinancialYear),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $7MNDz.arjSettingsFinancialYearResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dVS1R.LazyArjSettingsFinancialYear)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-spa-entries/src/arjSettingsFinancialYearPageRouteEntry.tsx',
                whichExportToUse: 'arjSettingsFinancialYearPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7MNDz", function(module, exports) {
$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $a2769854afa61743$export$da45020eede4a793);

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");

const $a2769854afa61743$export$da45020eede4a793 = (0, $l1VxS.createResource)({
    type: (0, $81ad417e9e376149$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $hgi0g.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $81ad417e9e376149$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("l2CRW", function(module, exports) {
$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $cf264a7b58719d56$export$7208300f00a36a5f);
const $cf264a7b58719d56$export$7208300f00a36a5f = {
    name: 'arj-settings-financial-year',
    path: '/jira/plans/settings/financial-year',
    exact: true
};

});

parcelRegister("dVS1R", function(module, exports) {
$parcel$export(module.exports, "LazyArjSettingsFinancialYear", () => $393ab146b792b775$export$dd67c2f01a58231e);
$parcel$export(module.exports, "ArjSettingsFinancialYear", () => $393ab146b792b775$export$785180185eba7ed9);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $393ab146b792b775$export$dd67c2f01a58231e = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dhzWy")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $393ab146b792b775$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $393ab146b792b775$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });

});
parcelRegister("dhzWy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g4MW9").then(()=>parcelRequire('hjnLm'));

});



parcelRegister("eOLN9", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", () => $5aa6ef318e96ca1f$export$9f80102c0f64ad9b);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $kAAs1 = parcelRequire("kAAs1");

var $crpnS = parcelRequire("crpnS");

var $3A1Of = parcelRequire("3A1Of");
const $5aa6ef318e96ca1f$export$9f80102c0f64ad9b = (0, $6xToB.createEntry)((0, $kAAs1.arjSettingsLoadingLimitsLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3A1Of.redirectTo)('/jira/plans/settings/loading-limits'),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsLoadingLimits)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-settings-entries/src/arjSettingsLoadingLimitsLegacyRedirectRouteEntry.tsx',
                whichExportToUse: 'arjSettingsLoadingLimitsLegacyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kAAs1", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRoute", () => $16fecf79f5f7a09d$export$7c71e235d628daf5);
const $16fecf79f5f7a09d$export$7c71e235d628daf5 = {
    name: 'arj-settings-loading-limits-redirect',
    path: '/secure/PortfolioLoadingLimits.jspa'
};

});


parcelRegister("2bnuQ", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", () => $d3e0a5fc9eb07ef4$export$6786257309f86d8c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $eaFxV = parcelRequire("eaFxV");

var $9NmsS = parcelRequire("9NmsS");

var $3daPY = parcelRequire("3daPY");

var $crpnS = parcelRequire("crpnS");
const $d3e0a5fc9eb07ef4$export$6786257309f86d8c = (0, $6xToB.createEntry)((0, $3daPY.arjSettingsLoadingLimitsRoute), ()=>({
        group: 'software',
        component: (0, $crpnS.ArjSettingsLoadingLimits),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $eaFxV.arjSettingsLoadingLimitsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsLoadingLimits)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-settings-entries/src/arjSettingsLoadingLimitsRouteEntry.tsx',
                whichExportToUse: 'arjSettingsLoadingLimitsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eaFxV", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $d4dcf0c9372d183c$export$c9e47fa9b57975f5);

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");

const $d4dcf0c9372d183c$export$c9e47fa9b57975f5 = (0, $l1VxS.createResource)({
    type: (0, $723e91a9d7fe9d70$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $hgi0g.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $723e91a9d7fe9d70$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("3daPY", function(module, exports) {
$parcel$export(module.exports, "arjSettingsLoadingLimitsRoute", () => $2d35630067e09e0f$export$f90dc3a45fadc1e2);
const $2d35630067e09e0f$export$f90dc3a45fadc1e2 = {
    name: 'arj-settings-loading-limits',
    path: '/jira/plans/settings/loading-limits'
};

});


parcelRegister("iDdAu", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", () => $2875028c5bfad390$export$4e97658a5cc15eaa);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9K0qt = parcelRequire("9K0qt");

var $9NmsS = parcelRequire("9NmsS");

var $jZJGn = parcelRequire("jZJGn");

var $crpnS = parcelRequire("crpnS");
const $2875028c5bfad390$export$4e97658a5cc15eaa = (0, $6xToB.createEntry)((0, $jZJGn.arjSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $crpnS.ArjSettingsPermissions),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $9K0qt.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-settings-entries/src/arjSettingsPermissionsRouteEntry.tsx',
                whichExportToUse: 'arjSettingsPermissionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9K0qt", function(module, exports) {
$parcel$export(module.exports, "grantedPermissionsResource", () => $9711889877d91aab$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $9711889877d91aab$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $9711889877d91aab$export$a09a91246a866817);

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
const $9711889877d91aab$var$fetchGrantedPermissions = ()=>(0, $3ugTQ.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $9711889877d91aab$var$fetchPermissionGroups = ()=>(0, $3ugTQ.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $9711889877d91aab$export$aa3daf3280e2a2d7 = (0, $l1VxS.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$9711889877d91aab$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $9711889877d91aab$export$950060d83722e3bd = (0, $l1VxS.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$9711889877d91aab$var$fetchPermissionGroups(),
    maxAge: 0
});
const $9711889877d91aab$export$a09a91246a866817 = ()=>[
        $9711889877d91aab$export$aa3daf3280e2a2d7,
        $9711889877d91aab$export$950060d83722e3bd
    ];

});

parcelRegister("jZJGn", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRoute", () => $134158516490e58d$export$4501213a8b1d3a10);
const $134158516490e58d$export$4501213a8b1d3a10 = {
    name: 'arj-settings-permissions',
    path: '/jira/plans/settings/permissions'
};

});


parcelRegister("3cedS", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", () => $79f26606e812159e$export$949c8177281fcc39);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9K0qt = parcelRequire("9K0qt");

var $9NmsS = parcelRequire("9NmsS");

var $5QuPH = parcelRequire("5QuPH");

var $crpnS = parcelRequire("crpnS");

var $3A1Of = parcelRequire("3A1Of");
const $79f26606e812159e$export$949c8177281fcc39 = (0, $6xToB.createEntry)((0, $5QuPH.arjSettingsPermissionsRouteLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3A1Of.redirectTo)('/jira/plans/settings/permissions'),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $9K0qt.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $crpnS.LazyArjSettingsPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-settings-entries/src/arjSettingsPermissionsRouteLegacyRedirectRouteEntry.tsx',
                whichExportToUse: 'arjSettingsPermissionsRouteLegacyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5QuPH", function(module, exports) {
$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRoute", () => $b6d4ff2fbeb5b061$export$24bf73f2d1dbf0db);
const $b6d4ff2fbeb5b061$export$24bf73f2d1dbf0db = {
    name: 'arj-settings-permissions-redirect',
    path: '/secure/PortfolioPermissions.jspa'
};

});


parcelRegister("cLZj8", function(module, exports) {
$parcel$export(module.exports, "arjSummaryEmbedRouteEntry", () => $cb1694a2fa4b6e92$export$bdc2c75e02c29d7);

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $jmv36 = parcelRequire("jmv36");

var $9NmsS = parcelRequire("9NmsS");

var $cxQGT = parcelRequire("cxQGT");

var $cJJhb = parcelRequire("cJJhb");

var $g8uYY = parcelRequire("g8uYY");

var $legH4 = parcelRequire("legH4");

var $j66XX = parcelRequire("j66XX");
const $cb1694a2fa4b6e92$var$planSummaryEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $legH4.planSummaryEntryPoint)
});
const $cb1694a2fa4b6e92$export$bdc2c75e02c29d7 = (0, $6xToB.createEntry)((0, $cJJhb.arjSummaryEmbedRoute), ()=>({
        group: 'software',
        component: (0, $j66XX.PlanSummaryEmbedPage),
        entryPoint: ()=>$cb1694a2fa4b6e92$var$planSummaryEmbedRouteEntry,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $jmv36.advancedRoadmapsSummaryDataResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $j66XX.LazyPlanSummaryEmbed)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-embed-entries/src/arjSummaryEmbedRouteEntry.tsx',
                whichExportToUse: 'arjSummaryEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jmv36", function(module, exports) {
$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $fa05b67d71bc9c34$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $fa05b67d71bc9c34$export$2dfe99460dae6bc6);

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");

var $fi0Y9 = parcelRequire("fi0Y9");

var $jqjE2 = parcelRequire("jqjE2");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $fa05b67d71bc9c34$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $fa05b67d71bc9c34$export$f9061628830b5175 = (0, $l1VxS.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $fa05b67d71bc9c34$export$2dfe99460dae6bc6(params, query, (0, $fi0Y9.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $fa05b67d71bc9c34$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    const dateRange = (0, $jqjE2.validateDateRange)((0, $jqjE2.parseDateRange)($fa05b67d71bc9c34$var$getQueryParams(query)));
    const data = await (0, $hgi0g.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...dateRange ? {
                dateRange: dateRange
            } : {}
        })
    });
    return dateRange ? {
        ...data,
        customDateRange: dateRange
    } : data;
};

});
parcelRegister("fi0Y9", function(module, exports) {
$parcel$export(module.exports, "CHART_TYPES", () => $a88f120904847c21$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $a88f120904847c21$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $a88f120904847c21$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $a88f120904847c21$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $a88f120904847c21$export$38e437924c2adbda);
const $a88f120904847c21$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $a88f120904847c21$export$79cf9c14f738d70b = [
    $a88f120904847c21$export$3251435144ca69e2.statusCategory,
    $a88f120904847c21$export$3251435144ca69e2.issueProgress,
    $a88f120904847c21$export$3251435144ca69e2.teamProgress,
    $a88f120904847c21$export$3251435144ca69e2.teamCapacity,
    $a88f120904847c21$export$3251435144ca69e2.blockers,
    $a88f120904847c21$export$3251435144ca69e2.highestPriority,
    $a88f120904847c21$export$3251435144ca69e2.unassignedIssues,
    $a88f120904847c21$export$3251435144ca69e2.overlappingBlockers,
    $a88f120904847c21$export$3251435144ca69e2.overdue
];
const $a88f120904847c21$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $a88f120904847c21$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $a88f120904847c21$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("jqjE2", function(module, exports) {
$parcel$export(module.exports, "parseDateRange", () => $475bbe0973adb452$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $475bbe0973adb452$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $1PBWh = parcelRequire("1PBWh");
const $475bbe0973adb452$export$637d8b0948b783c7 = {
    [(0, $1PBWh.DATE_UNITS).DAYS]: 3650,
    [(0, $1PBWh.DATE_UNITS).WEEKS]: 520,
    [(0, $1PBWh.DATE_UNITS).MONTHS]: 120
};
const $475bbe0973adb452$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $475bbe0973adb452$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $475bbe0973adb452$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $1PBWh.DATE_UNITS).DAYS:
        case (0, $1PBWh.DATE_UNITS).WEEKS:
        case (0, $1PBWh.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $475bbe0973adb452$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $475bbe0973adb452$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $475bbe0973adb452$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $475bbe0973adb452$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $475bbe0973adb452$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $475bbe0973adb452$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $475bbe0973adb452$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $475bbe0973adb452$export$c777dd44ece05114(toNowUnit)
    };
};
const $475bbe0973adb452$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $475bbe0973adb452$export$637d8b0948b783c7[unit];
};
const $475bbe0973adb452$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $475bbe0973adb452$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $475bbe0973adb452$export$68346777682e262(toNowUnitCount, toNowUnit) && $475bbe0973adb452$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $1PBWh.CUSTOM_TIME_RANGE_TYPES).FIXED && $475bbe0973adb452$export$1ba31c57b50b4374(fromDate) && $475bbe0973adb452$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("1PBWh", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $edf1e8c098472f89$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $edf1e8c098472f89$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $edf1e8c098472f89$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $edf1e8c098472f89$export$48808c686fe495c4);
const $edf1e8c098472f89$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $edf1e8c098472f89$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $edf1e8c098472f89$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $edf1e8c098472f89$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $edf1e8c098472f89$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});



parcelRegister("cJJhb", function(module, exports) {
$parcel$export(module.exports, "arjSummaryEmbedRoute", () => $45ec2c02f6f22edd$export$126053e8fb441b66);
const $45ec2c02f6f22edd$export$126053e8fb441b66 = {
    name: 'software-plan-summary-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};

});

parcelRegister("legH4", function(module, exports) {
$parcel$export(module.exports, "planSummaryEntryPoint", () => $fcc3180984f3fe8f$export$82d8368ec1a526b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $fcc3180984f3fe8f$export$82d8368ec1a526b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("5QPfy")), {
        moduleId: "c48db9c0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("Nhl2o", function(module, exports) {
$parcel$export(module.exports, "arjTimelineEmbedRouteEntry", () => $6174331bc6e649fa$export$a977d398db1904ff);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $cxQGT = parcelRequire("cxQGT");

var $7TB8U = parcelRequire("7TB8U");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $g8uYY = parcelRequire("g8uYY");

var $iyaX4 = parcelRequire("iyaX4");
const $6174331bc6e649fa$var$planTimelineEmbedRouteEntry = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $iyaX4.planTimelineEntryPoint)
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6174331bc6e649fa$var$LazyPlanTimelineEmbed = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4Jlwb"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
const $6174331bc6e649fa$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6174331bc6e649fa$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
const $6174331bc6e649fa$export$a977d398db1904ff = (0, $6xToB.createEntry)((0, $7TB8U.arjTimelineEmbedRoute), ()=>({
        group: 'software',
        component: $6174331bc6e649fa$var$PlanTimelineEmbedPage,
        entryPoint: ()=>$6174331bc6e649fa$var$planTimelineEmbedRouteEntry,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $cxQGT.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            $6174331bc6e649fa$var$LazyPlanTimelineEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-embed-entries/src/arjTimelineEmbedRouteEntry.tsx',
                whichExportToUse: 'arjTimelineEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7TB8U", function(module, exports) {
$parcel$export(module.exports, "arjTimelineEmbedRoute", () => $31f6879962c77809$export$aadc28402ef87b84);
const $31f6879962c77809$export$aadc28402ef87b84 = {
    name: 'software-advanced-roadmaps-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};

});

parcelRegister("iyaX4", function(module, exports) {
$parcel$export(module.exports, "planTimelineEntryPoint", () => $e41b801b53bdb78f$export$a36e3fca8afefb5b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e41b801b53bdb78f$export$a36e3fca8afefb5b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("q0x3o")), {
        moduleId: "0b69767e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("q0x3o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("cAb3k")),
    $ewTvA("fliVL"),
    $ewTvA("igMP1")
]).then(()=>parcelRequire('kXJSa'));

});


parcelRegister("4Jlwb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("ddgYy")),
    $ewTvA("fliVL"),
    $ewTvA("krAVq")
]).then(()=>parcelRequire('7q1Rr'));

});


parcelRegister("g0EQq", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewCreateRouteEntry", () => $f203d46a57fb9840$export$ee75957829357d5d);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $gHHjw = parcelRequire("gHHjw");

var $gy2Qg = parcelRequire("gy2Qg");

var $af0hI = parcelRequire("af0hI");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $f203d46a57fb9840$var$assetsAnalyticsDataViewCreatePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $af0hI.assetsAnalyticsDataViewCreateEntryPoint)
});
const $f203d46a57fb9840$export$ee75957829357d5d = (0, $6xToB.createEntry)((0, $gHHjw.assetsAnalyticsDataViewCreateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$f203d46a57fb9840$var$assetsAnalyticsDataViewCreatePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-create',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsAnalyticsDataViewCreateRouteEntry.tsx',
                whichExportToUse: 'assetsAnalyticsDataViewCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gHHjw", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewCreateRoute", () => $d003db8a9df3d9e2$export$4bdd2b973f5ff912);
const $d003db8a9df3d9e2$export$4bdd2b973f5ff912 = {
    name: 'assets-analytics-data-view-create',
    path: '/jira/assets/analytics/data-view/create',
    exact: true
};

});

parcelRegister("af0hI", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewCreateEntryPoint", () => $3a29ae1a3ba9e1c9$export$cfa228728b5a63f4);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3a29ae1a3ba9e1c9$export$cfa228728b5a63f4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jN4lF")).then((module)=>module.AssetsAnalyticsDataViewCreatePage), {
        moduleId: "539b781f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jN4lF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jAsfE").then(()=>parcelRequire('l8NK5'));

});


parcelRegister("1qTV8", function(module, exports) {
$parcel$export(module.exports, "LazyAssetsLayout", () => $81786c6b09cb2145$export$6d4ed5b3aae01b61);
$parcel$export(module.exports, "AssetsLayout", () => $81786c6b09cb2145$export$fc69c032e8242676);

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $bQWwW = parcelRequire("bQWwW");

var $2imLM = parcelRequire("2imLM");

var $bJscI = parcelRequire("bJscI");

const $81786c6b09cb2145$export$6d4ed5b3aae01b61 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jEayc")).then((module)=>module.AssetsLayout), {
    ssr: false,
    moduleId: "./src/packages/assets-app/layout/src/ui/index.tsx"
});
const $81786c6b09cb2145$export$aff80d98300cb5df = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "assets-layout-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($81786c6b09cb2145$export$6d4ed5b3aae01b61, null, children));
const $81786c6b09cb2145$export$90f990aee2a4a344 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "assets-layout-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "assets-layout-async"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($81786c6b09cb2145$export$6d4ed5b3aae01b61, null, children));
const $81786c6b09cb2145$export$fc69c032e8242676 = (0, $bJscI.componentWithFG)('add_ufo_hold_to_assets_schema_page', $81786c6b09cb2145$export$90f990aee2a4a344, $81786c6b09cb2145$export$aff80d98300cb5df);

});
parcelRegister("jEayc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4xc4u").then(()=>parcelRequire('8BU3q'));

});


parcelRegister("f1zun", function(module, exports) {
$parcel$export(module.exports, "getCmdbResources", () => $f314548d40a5fcb8$export$850433b0663023b8);
$parcel$export(module.exports, "getAssetsAppResources", () => $f314548d40a5fcb8$export$70fc9421fb71e080);

var $8ecGf = parcelRequire("8ecGf");

var $4cTDP = parcelRequire("4cTDP");

var $9NmsS = parcelRequire("9NmsS");

var $5L7qx = parcelRequire("5L7qx");

var $1PvPk = parcelRequire("1PvPk");

var $5MeEd = parcelRequire("5MeEd");

var $ePaI2 = parcelRequire("ePaI2");

var $cxQGT = parcelRequire("cxQGT");

var $lb6FK = parcelRequire("lb6FK");

var $4RTtS = parcelRequire("4RTtS");
function $f314548d40a5fcb8$export$850433b0663023b8() {
    return [
        ...(0, $9NmsS.getNavigationResources)(),
        ...(0, $1PvPk.getServicedeskPageContextResources)(),
        (0, $ePaI2.workspaceResource)
    ];
}
function $f314548d40a5fcb8$export$70fc9421fb71e080() {
    return [
        (0, $ePaI2.workspaceResource),
        (0, $cxQGT.themePreferenceResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('assets-announcement-banner-settings'), (0, $4RTtS.assetsNavigationSettingsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('assets-announcement-banner-settings'), (0, $4RTtS.assetsBannerSettingsResource)),
        (0, $lb6FK.rovoEntitlementResource),
        (0, $5MeEd.getConsentBannerUserPreferencesResource)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('show_announcement_banner_in_assets'), (0, $8ecGf.announcementBannerSettingsV4Resource))
    ];
}

});
parcelRegister("4RTtS", function(module, exports) {
$parcel$export(module.exports, "assetsNavigationSettingsResource", () => $53f3fee9f5775117$export$d72c30b62ce96bca);
$parcel$export(module.exports, "useAssetsNavigationSettingsResource", () => $53f3fee9f5775117$export$59c3c97d1f3b9d94);
$parcel$export(module.exports, "assetsBannerSettingsResource", () => $53f3fee9f5775117$export$a7ceab321c9806fd);
$parcel$export(module.exports, "useAssetsBannerSettingsResource", () => $53f3fee9f5775117$export$63ed762dfb6bd31c);

var $4cTDP = parcelRequire("4cTDP");

var $l1VxS = parcelRequire("l1VxS");
var $uCHeL = parcelRequire("uCHeL");
var $eJrcF = parcelRequire("eJrcF");

var $4hzWN = parcelRequire("4hzWN");

var $fpGxz = parcelRequire("fpGxz");

var $lStgW = parcelRequire("lStgW");
const $53f3fee9f5775117$export$d72c30b62ce96bca = (0, $l1VxS.createResource)({
    type: (0, $fpGxz.RESOURCE_ASSETS_NAVIGATION_SETTINGS),
    getKey: ()=>(0, $fpGxz.RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY),
    getData: async ()=>{
        if (!(0, $4cTDP.fg)('assets-announcement-banner-settings')) return 0, $fpGxz.emptyNavigationSettingsResponse;
        const navigationSettingsRequest = [
            {
                key: (0, $fpGxz.NAVIGATION_SETTINGS_KEYS).BG_COLOR
            },
            {
                key: (0, $fpGxz.NAVIGATION_SETTINGS_KEYS).HIGHLIGHT_COLOR
            }
        ];
        const { storeState: storeState } = (0, $uCHeL.getResourceStore)();
        const state = storeState.getState();
        try {
            const workspaceId = await (0, $lStgW.extractResourceStatePromise)(state.data);
            if (!workspaceId || typeof workspaceId !== 'string') return 0, $fpGxz.emptyNavigationSettingsResponse;
            const navigationSettings = await (0, $4hzWN.getAdminSettingsByKeys)(workspaceId, navigationSettingsRequest);
            return {
                backgroundColor: navigationSettings[(0, $fpGxz.NAVIGATION_SETTINGS_KEYS).BG_COLOR]?.value,
                highlightColor: navigationSettings[(0, $fpGxz.NAVIGATION_SETTINGS_KEYS).HIGHLIGHT_COLOR]?.value
            };
        } catch (error) {
            return 0, $fpGxz.emptyNavigationSettingsResponse;
        }
    },
    maxAge: (0, $fpGxz.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $53f3fee9f5775117$export$59c3c97d1f3b9d94 = ()=>{
    return (0, $eJrcF.useResource)($53f3fee9f5775117$export$d72c30b62ce96bca);
};
const $53f3fee9f5775117$export$a7ceab321c9806fd = (0, $l1VxS.createResource)({
    type: (0, $fpGxz.RESOURCE_ASSETS_BANNER_SETTINGS),
    getKey: ()=>(0, $fpGxz.RESOURCE_ASSETS_BANNER_SETTINGS_KEY),
    getData: async ()=>{
        if (!(0, $4cTDP.fg)('assets-announcement-banner-settings')) return 0, $fpGxz.emptyBannerSettingsResponse;
        const { storeState: storeState } = (0, $uCHeL.getResourceStore)();
        const state = storeState.getState();
        try {
            const workspaceId = await (0, $lStgW.extractResourceStatePromise)(state.data);
            if (!workspaceId || typeof workspaceId !== 'string') return 0, $fpGxz.emptyBannerSettingsResponse;
            const bannerSettings = await (0, $4hzWN.getBannerSettings)(workspaceId);
            return bannerSettings;
        } catch (error) {
            return 0, $fpGxz.emptyBannerSettingsResponse;
        }
    },
    maxAge: (0, $fpGxz.ASSETS_ADMIN_SETTINGS_MAX_AGE)
});
const $53f3fee9f5775117$export$63ed762dfb6bd31c = ()=>{
    return (0, $eJrcF.useResource)($53f3fee9f5775117$export$a7ceab321c9806fd);
};

});
parcelRegister("4hzWN", function(module, exports) {
$parcel$export(module.exports, "getAdminSettingsByKeys", () => $60f92d2211bdde6e$export$55fc3561374ab769);
$parcel$export(module.exports, "getBannerSettings", () => $60f92d2211bdde6e$export$3f3876609dfc8fe2);
$parcel$export(module.exports, "updateBannerSettings", () => $60f92d2211bdde6e$export$f1a5ab84b56daecd);
$parcel$export(module.exports, "updateNavigationSettings", () => $60f92d2211bdde6e$export$6a880189751ac5a3);

var $9pTd3 = parcelRequire("9pTd3");

var $eBhI6 = parcelRequire("eBhI6");

var $3ugTQ = parcelRequire("3ugTQ");

var $lStgW = parcelRequire("lStgW");

var $fpGxz = parcelRequire("fpGxz");
/**
 * SSR service name header for routing requests through the JSM CMDB Gateway
 */ const $60f92d2211bdde6e$var$SSR_SERVICE_NAME = 'jsm-cmdb-gateway';
/**
 * Merges default options (including SSR headers and credentials) with custom options
 * This ensures cookies are sent for SSR prefetching
 */ const $60f92d2211bdde6e$var$mergeOptionsWithDefaults = (url, options)=>{
    const defaultOptions = (0, $eBhI6.getDefaultOptions)(url);
    return {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers
        }
    };
};
const $60f92d2211bdde6e$export$55fc3561374ab769 = async (workspaceId, settingKeys)=>{
    const url = (0, $lStgW.getAdminSettingsUrl)(workspaceId);
    const mergedOptions = $60f92d2211bdde6e$var$mergeOptionsWithDefaults(url, {
        body: JSON.stringify(settingKeys),
        headers: {
            'x-ssr-service-name': $60f92d2211bdde6e$var$SSR_SERVICE_NAME,
            'atl-workspaceid': workspaceId
        }
    });
    try {
        const response = await (0, $3ugTQ.performPostRequest)(url, mergedOptions);
        return (0, $lStgW.transformAdminSettingsResponse)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403) return {};
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getAdminSettingsByKeys',
                packageName: 'jiraRouterResourcesAssetsAdminNavigationSettings',
                teamName: 'aurum'
            },
            error: error
        });
        throw error;
    }
};
const $60f92d2211bdde6e$export$3f3876609dfc8fe2 = async (workspaceId)=>{
    const url = (0, $lStgW.getBannerSettingsUrl)(workspaceId);
    const mergedOptions = $60f92d2211bdde6e$var$mergeOptionsWithDefaults(url, {
        headers: {
            'x-ssr-service-name': 'jsm-cmdb-gateway',
            'atl-workspaceid': workspaceId
        }
    });
    try {
        const response = await (0, $3ugTQ.performGetRequest)(url, mergedOptions);
        return (0, $lStgW.transformBannerSettings)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403 || error.statusCode === 404) return 0, $fpGxz.emptyBannerSettingsResponse;
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getBannerSettings',
                packageName: 'jiraRouterResourcesAssetsAdminBannerSettings',
                teamName: 'aurum'
            },
            error: error
        });
        throw error;
    }
};
const $60f92d2211bdde6e$export$f1a5ab84b56daecd = async (workspaceId, bannerId, bannerUpdates)=>{
    const url = `${(0, $lStgW.getBannerSettingsUrl)(workspaceId)}/${bannerId}`;
    try {
        const response = await (0, $3ugTQ.performPutRequest)(url, $60f92d2211bdde6e$var$mergeOptionsWithDefaults(url, {
            body: JSON.stringify((0, $lStgW.transformBannerSettings)(bannerUpdates))
        }));
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'updateBannerSettings',
                packageName: 'jiraRouterResourcesAssetsAdminBannerSettings',
                teamName: 'aurum'
            },
            error: error
        });
        throw error;
    }
};
const $60f92d2211bdde6e$export$6a880189751ac5a3 = async (workspaceId, navigationUpdates)=>{
    const url = (0, $lStgW.getAdminSettingsUrl)(workspaceId);
    try {
        const response = await (0, $3ugTQ.performPutRequest)(url, $60f92d2211bdde6e$var$mergeOptionsWithDefaults(url, {
            body: JSON.stringify(navigationUpdates)
        }));
        return response;
    } catch (error) {
        const err = error instanceof Error ? error : new Error(String(error));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'updateNavigationSettings',
                packageName: 'jiraRouterResourcesAssetsAdminNavigationSettings',
                teamName: 'aurum'
            },
            error: err
        });
        throw err;
    }
};

});
parcelRegister("lStgW", function(module, exports) {
$parcel$export(module.exports, "extractResourceStatePromise", () => $b7cc77ac67a88237$export$5e6c0b0c6c71e3a7);
$parcel$export(module.exports, "getAdminSettingsUrl", () => $b7cc77ac67a88237$export$13aeca3ca3499df1);
$parcel$export(module.exports, "getBannerSettingsUrl", () => $b7cc77ac67a88237$export$1e927bbb56fd29f2);
$parcel$export(module.exports, "transformAdminSettingsResponse", () => $b7cc77ac67a88237$export$c8db903c3984d79e);
$parcel$export(module.exports, "transformBannerSettings", () => $b7cc77ac67a88237$export$5221f0c585bc0e45);

var $fpGxz = parcelRequire("fpGxz");
function $b7cc77ac67a88237$export$5e6c0b0c6c71e3a7(resourceState) {
    return resourceState?.[0, $fpGxz.RESOURCE_TYPE_WORKSPACE_CONTEXT]?.state?.promise;
}
const $b7cc77ac67a88237$export$13aeca3ca3499df1 = (workspaceId)=>{
    return false ? '/api/v1/admin/settings' : `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/settings`;
};
const $b7cc77ac67a88237$export$1e927bbb56fd29f2 = (workspaceId)=>{
    return false ? '/api/v1/admin/banner-settings' : `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/admin/banner-settings`;
};
const $b7cc77ac67a88237$export$c8db903c3984d79e = (response)=>{
    return response.reduce((acc, setting)=>{
        acc[setting.key] = setting;
        return acc;
    }, {});
};
const $b7cc77ac67a88237$export$5221f0c585bc0e45 = (bannerSettings)=>{
    const { content: content, ...rest } = bannerSettings;
    const isContentString = content && typeof content === 'string';
    return {
        ...rest,
        content: isContentString ? JSON.parse(content) : JSON.stringify(content)
    };
};

});
parcelRegister("fpGxz", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS", () => $4d2df6cce256c6c7$export$858084c28938b25c);
$parcel$export(module.exports, "RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY", () => $4d2df6cce256c6c7$export$6c3a7ac5254a8135);
$parcel$export(module.exports, "RESOURCE_ASSETS_BANNER_SETTINGS", () => $4d2df6cce256c6c7$export$edf7b78eb8890aea);
$parcel$export(module.exports, "RESOURCE_ASSETS_BANNER_SETTINGS_KEY", () => $4d2df6cce256c6c7$export$9aedc6e738c8bf7f);
$parcel$export(module.exports, "DEFAULT_HIGHLIGHT_COLOR", () => $4d2df6cce256c6c7$export$4b15acc9c405c4bd);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $4d2df6cce256c6c7$export$617cdcc6afaae4f7);
$parcel$export(module.exports, "NAVIGATION_SETTINGS_KEYS", () => $4d2df6cce256c6c7$export$8a78e43025de1286);
$parcel$export(module.exports, "RESOURCE_TYPE_WORKSPACE_CONTEXT", () => $4d2df6cce256c6c7$export$3f183223d3598a56);
$parcel$export(module.exports, "ASSETS_ADMIN_SETTINGS_MAX_AGE", () => $4d2df6cce256c6c7$export$ce0c7383fedc84ce);
$parcel$export(module.exports, "emptyNavigationSettingsResponse", () => $4d2df6cce256c6c7$export$2175e487efc82f9);
$parcel$export(module.exports, "emptyBannerSettingsResponse", () => $4d2df6cce256c6c7$export$5b68b74d24ac7fdf);
const $4d2df6cce256c6c7$export$858084c28938b25c = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
const $4d2df6cce256c6c7$export$6c3a7ac5254a8135 = 'assets-navigation-settings';
const $4d2df6cce256c6c7$export$edf7b78eb8890aea = 'RESOURCE_ASSETS_BANNER_SETTINGS';
const $4d2df6cce256c6c7$export$9aedc6e738c8bf7f = 'assets-banner-settings';
const $4d2df6cce256c6c7$export$4b15acc9c405c4bd = '#0052CC';
const $4d2df6cce256c6c7$export$617cdcc6afaae4f7 = '#FFFFFF';
const $4d2df6cce256c6c7$export$8a78e43025de1286 = {
    BG_COLOR: 'assets.navigation.bgcolour',
    HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour'
};
const $4d2df6cce256c6c7$export$3f183223d3598a56 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $4d2df6cce256c6c7$export$ce0c7383fedc84ce = 900000;
const $4d2df6cce256c6c7$export$2175e487efc82f9 = {
    backgroundColor: '',
    highlightColor: ''
};
const $4d2df6cce256c6c7$export$5b68b74d24ac7fdf = {
    id: '',
    content: {
        version: 1,
        type: 'doc',
        content: []
    },
    isDismissable: false,
    isEnabled: false,
    hashId: '',
    visibility: '',
    bgColor: ''
};

});





parcelRegister("eG7NE", function(module, exports) {
$parcel$export(module.exports, "AssetsPageConfigContainer", () => $8334ac7022e551a5$export$68a74d1b39f069c5);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $2imLM = parcelRequire("2imLM");

const $8334ac7022e551a5$export$606469064c062fcd = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fXf8Z")).then((module)=>module.PageConfigContainer), {
    ssr: false,
    moduleId: "./src/packages/assets-app/page-config-container/src/ui/index.tsx"
});
const $8334ac7022e551a5$export$68a74d1b39f069c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "assets-page-config-container-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8334ac7022e551a5$export$606469064c062fcd, null, children));

});
parcelRegister("fXf8Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("87kVp").then(()=>parcelRequire('3chUb'));

});



parcelRegister("5NEJc", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsRouteEntry", () => $d6cc74fe3f45a176$export$3a6396cc5491db7c);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $k1uVB = parcelRequire("k1uVB");

var $gy2Qg = parcelRequire("gy2Qg");

var $9RD0X = parcelRequire("9RD0X");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $d6cc74fe3f45a176$var$assetsAnalyticsDataViewDetailsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9RD0X.assetsAnalyticsDataViewDetailsEntryPoint)
});
const $d6cc74fe3f45a176$export$3a6396cc5491db7c = (0, $6xToB.createEntry)((0, $k1uVB.assetsAnalyticsDataViewDetailsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$d6cc74fe3f45a176$var$assetsAnalyticsDataViewDetailsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-details',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsAnalyticsDataViewDetailsRouteEntry.tsx',
                whichExportToUse: 'assetsAnalyticsDataViewDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k1uVB", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsRoute", () => $fde8dd13847da101$export$745cfa051b349898);
const $fde8dd13847da101$export$745cfa051b349898 = {
    name: 'assets-analytics-data-view-details',
    path: '/jira/assets/analytics/data-view/:dataViewId',
    exact: true
};

});

parcelRegister("9RD0X", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewDetailsEntryPoint", () => $478f3aecb95ef964$export$2ef63d819083574a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $478f3aecb95ef964$export$2ef63d819083574a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7Ih5d")).then((module)=>module.AssetsAnalyticsDataViewDetailsPage), {
        moduleId: "3d6891cf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7Ih5d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kilYt").then(()=>parcelRequire('bi6bT'));

});



parcelRegister("9AeX2", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewListRouteEntry", () => $0186404d4be98625$export$7d8bada2dd6618e9);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9K4E7 = parcelRequire("9K4E7");

var $gy2Qg = parcelRequire("gy2Qg");

var $2c79B = parcelRequire("2c79B");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $0186404d4be98625$var$assetsAnalyticsDataViewListPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $2c79B.assetsAnalyticsDataViewListEntryPoint)
});
const $0186404d4be98625$export$7d8bada2dd6618e9 = (0, $6xToB.createEntry)((0, $9K4E7.assetsAnalyticsDataViewListRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$0186404d4be98625$var$assetsAnalyticsDataViewListPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-list',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsAnalyticsDataViewListRouteEntry.tsx',
                whichExportToUse: 'assetsAnalyticsDataViewListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9K4E7", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewListRoute", () => $a4982b3a2a3ab440$export$40ec17d60854071b);
const $a4982b3a2a3ab440$export$40ec17d60854071b = {
    name: 'assets-analytics-data-view-list',
    path: '/jira/assets/analytics/data-view',
    exact: true
};

});

parcelRegister("2c79B", function(module, exports) {
$parcel$export(module.exports, "assetsAnalyticsDataViewListEntryPoint", () => $dcfdab98db94a139$export$a5faca810df8b234);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $dcfdab98db94a139$export$a5faca810df8b234 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8BMvG")).then((module)=>module.AssetsAnalyticsDataViewListPage), {
        moduleId: "34d60c27",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8BMvG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("RUaGU").then(()=>parcelRequire('2To7f'));

});



parcelRegister("hjFNU", function(module, exports) {
$parcel$export(module.exports, "assetsConfigurationRouteEntry", () => $c30f6ede6164eca6$export$1c86de5db8ff2b58);

var $6xToB = parcelRequire("6xToB");

var $73yke = parcelRequire("73yke");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $j2mgX = parcelRequire("j2mgX");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $c30f6ede6164eca6$var$globalConfigurePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $j2mgX.assetsGlobalSettingsEntryPoint)
});
const $c30f6ede6164eca6$export$1c86de5db8ff2b58 = (0, $6xToB.createEntry)((0, $73yke.assetsConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        ufoName: 'servicedesk-cmdb-assets-configure',
        entryPoint: ()=>$c30f6ede6164eca6$var$globalConfigurePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsConfigurationRouteEntry.tsx',
                whichExportToUse: 'assetsConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("73yke", function(module, exports) {
$parcel$export(module.exports, "assetsConfigurationRoute", () => $85ba62486a8390d7$export$266d00c8001d32ab);
const $85ba62486a8390d7$export$266d00c8001d32ab = {
    name: 'assets-configure',
    path: '/jira/assets/configure/global'
};

});

parcelRegister("j2mgX", function(module, exports) {
$parcel$export(module.exports, "assetsGlobalSettingsEntryPoint", () => $a90979c8a78b4d9d$export$2b083e0274144f1b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a90979c8a78b4d9d$export$2b083e0274144f1b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1jmZA")), {
        moduleId: "b65d2969",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1jmZA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("4NlKx")
]).then(()=>parcelRequire('1chQi'));

});



parcelRegister("3w7LE", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsDetailRouteEntry", () => $ef2f36e17439be51$export$bb8a1d6ad210e221);

var $4qqF6 = parcelRequire("4qqF6");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $77DMF = parcelRequire("77DMF");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $gy2Qg = parcelRequire("gy2Qg");

var $g8uYY = parcelRequire("g8uYY");
const $ef2f36e17439be51$var$assetsDashboardsDetailsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $4qqF6.assetsDashboardsDetailsPageEntryPoint)
});
const $ef2f36e17439be51$export$bb8a1d6ad210e221 = (0, $6xToB.createEntry)((0, $77DMF.assetsDashboardsDetailRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$ef2f36e17439be51$var$assetsDashboardsDetailsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-dashboards-detail-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsDashboardsDetailRouteEntry.tsx',
                whichExportToUse: 'assetsDashboardsDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4qqF6", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsDetailsPageEntryPoint", () => $3356e31c2195bc88$export$54c6120b40e02f60);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3356e31c2195bc88$export$54c6120b40e02f60 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gZo9v")).then((module)=>module.AssetsDashboardsDetails), {
        moduleId: "3a175f89",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gZo9v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cmZCT").then(()=>parcelRequire('6G7Pc'));

});


parcelRegister("77DMF", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsDetailRoute", () => $fef3002e805086a5$export$59a78d0054623414);
const $fef3002e805086a5$export$59a78d0054623414 = {
    name: 'assets-dashboards-detail',
    path: '/jira/assets/dashboards/:templateId',
    exact: true
};

});


parcelRegister("eFriF", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsRouteEntry", () => $1ab095bc0876c7cf$export$f33c78609ae076c5);

var $lciTe = parcelRequire("lciTe");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $fs11T = parcelRequire("fs11T");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");
const $1ab095bc0876c7cf$var$assetsDashboardsListPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $lciTe.assetsDashboardsListEntryPoint)
});
const $1ab095bc0876c7cf$export$f33c78609ae076c5 = (0, $6xToB.createEntry)((0, $fs11T.assetsDashboardsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$1ab095bc0876c7cf$var$assetsDashboardsListPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-dashboards-list-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsDashboardsRouteEntry.tsx',
                whichExportToUse: 'assetsDashboardsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lciTe", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsListEntryPoint", () => $a38f38b3e24b71fc$export$92eba22de7f87140);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a38f38b3e24b71fc$export$92eba22de7f87140 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ihIrO")).then((module)=>module.AssetsDashboardsList), {
        moduleId: "6ddb21b0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ihIrO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4qJFV").then(()=>parcelRequire('jgSdJ'));

});


parcelRegister("fs11T", function(module, exports) {
$parcel$export(module.exports, "assetsDashboardsRoute", () => $18e5892b3e560448$export$b656a3df6d4d2e5d);
const $18e5892b3e560448$export$b656a3df6d4d2e5d = {
    name: 'assets-dashboards',
    path: '/jira/assets/dashboards',
    exact: true
};

});


parcelRegister("9enxs", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataSourceRouteEntry", () => $aba4a8890e7495e9$export$3ca446ebb8517896);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $3M6LE = parcelRequire("3M6LE");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $gxgQp = parcelRequire("gxgQp");
const $aba4a8890e7495e9$var$assetsDataManagerDataSourcePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $gxgQp.assetsDataManagerDataSourceEntryPoint)
});
const $aba4a8890e7495e9$export$3ca446ebb8517896 = (0, $6xToB.createEntry)((0, $3M6LE.assetsDataManagerDataSourceRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-data-source',
        pageId: ()=>'spa-apps/assets-data-manager-data-source',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? $aba4a8890e7495e9$var$assetsDataManagerDataSourcePageEntryPoint : undefined;
        },
        component: (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_DATA_SOURCE_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerDataSourceRouteEntry.tsx',
                whichExportToUse: 'assetsDataManagerDataSourceRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3M6LE", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataSourceRoute", () => $b98159378b020ea1$export$d046531151f2bc80);
const $b98159378b020ea1$export$d046531151f2bc80 = {
    name: 'assets-data-manager-data-source',
    path: '/jira/assets/data-manager/object-classes/data-source/:dataSourceId/:tab(configuration|data|activity)?',
    exact: true
};

});

parcelRegister("gxgQp", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerDataSourceEntryPoint", () => $641e26551df5e4e8$export$bd7cd6f2edc69e5c);

var $3KsPd = parcelRequire("3KsPd");

var $4RYvN = parcelRequire("4RYvN");

var $6fPdh = parcelRequire("6fPdh");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $641e26551df5e4e8$var$TABS = {
    activity: (0, $4RYvN.activityTabEntryPoint),
    configuration: (0, $3KsPd.configurationTabEntryPoint),
    data: (0, $6fPdh.dataTabEntryPoint)
};
const $641e26551df5e4e8$var$DEFAULT_TAB = 'configuration';
const $641e26551df5e4e8$var$isValidTab = (tab)=>typeof tab === 'string' && Object.keys($641e26551df5e4e8$var$TABS).includes(tab);

const $641e26551df5e4e8$export$bd7cd6f2edc69e5c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hGT9S")), {
        moduleId: "bcbb9c89",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: params } } })=>{
        const validTab = $641e26551df5e4e8$var$isValidTab(params?.tab) ? params.tab : $641e26551df5e4e8$var$DEFAULT_TAB;
        const extraProps = {
            jobId: params?.dataSourceId || ''
        };
        return {
            entryPoints: {
                [validTab]: {
                    entryPoint: $641e26551df5e4e8$var$TABS[validTab],
                    entryPointParams: {}
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("3KsPd", function(module, exports) {
$parcel$export(module.exports, "configurationTabEntryPoint", () => $4e27342556a4f81a$export$ec8b29e0134d3c80);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4e27342556a4f81a$export$ec8b29e0134d3c80 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("b0vQh")), {
        moduleId: "d587b5e6",
        moduleName: "ConfigurationPanel",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("b0vQh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hhU37").then(()=>parcelRequire('ejcQh'));

});


parcelRegister("4RYvN", function(module, exports) {
$parcel$export(module.exports, "activityTabEntryPoint", () => $055b10c96e643d07$export$1ce14f1f05d013dc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $055b10c96e643d07$export$1ce14f1f05d013dc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eyBaM")), {
        moduleId: "8f8064ae",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("eyBaM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hwLuK").then(()=>parcelRequire('8ehFz'));

});


parcelRegister("6fPdh", function(module, exports) {
$parcel$export(module.exports, "dataTabEntryPoint", () => $27844a7d253117b1$export$5b828465e64ab503);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $27844a7d253117b1$export$5b828465e64ab503 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lJbmx")), {
        moduleId: "824801bf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("lJbmx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8nmUr").then(()=>parcelRequire('4R9ta'));

});


parcelRegister("hGT9S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gkgbs").then(()=>parcelRequire('lewnL'));

});



parcelRegister("hMZzF", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerGettingStartedRouteEntry", () => $5897632d2e41489a$export$d9a1c48acd35cf03);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $7TdbO = parcelRequire("7TdbO");

var $g8uYY = parcelRequire("g8uYY");

var $kAJP5 = parcelRequire("kAJP5");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $5897632d2e41489a$var$assetsDataManagerGettingStartedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $kAJP5.assetsDataManagerGettingStartedEntryPoint)
});
const $5897632d2e41489a$export$d9a1c48acd35cf03 = (0, $6xToB.createEntry)((0, $7TdbO.assetsDataManagerGettingStartedRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-getting-started',
        ufoName: 'assets-data-manager-getting-started',
        pageId: ()=>'spa-apps/assets-data-manager-getting-started',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? $5897632d2e41489a$var$assetsDataManagerGettingStartedPageEntryPoint : undefined;
        },
        component: (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerGettingStartedRouteEntry.tsx',
                whichExportToUse: 'assetsDataManagerGettingStartedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7TdbO", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerGettingStartedRoute", () => $28768b4f8a84fec8$export$82de2af972f327f8);
const $28768b4f8a84fec8$export$82de2af972f327f8 = {
    name: 'assets-data-manager-getting-started',
    path: '/jira/assets/data-manager/getting-started',
    exact: true
};

});

parcelRegister("kAJP5", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerGettingStartedEntryPoint", () => $f1038a2d162bd607$export$4f270d89a19b2303);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $f1038a2d162bd607$export$4f270d89a19b2303 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lG9sW")), {
        moduleId: "69964d1d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lG9sW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3xS60").then(()=>parcelRequire('aO1kd'));

});



parcelRegister("jVidq", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesRouteEntry", () => $e679bfb714460f6b$export$21baed265eb8be15);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $8Wz9C = parcelRequire("8Wz9C");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $lIIas = parcelRequire("lIIas");
const $e679bfb714460f6b$var$assetsDataManagerObjectClassesPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $lIIas.assetsDataManagerObjectClassesEntryPoint)
});
const $e679bfb714460f6b$export$21baed265eb8be15 = (0, $6xToB.createEntry)((0, $8Wz9C.assetsDataManagerObjectClassesRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-object-classes',
        pageId: ()=>'spa-apps/assets-data-manager-object-classes',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? $e679bfb714460f6b$var$assetsDataManagerObjectClassesPageEntryPoint : undefined;
        },
        component: (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerObjectClassesRouteEntry.tsx',
                whichExportToUse: 'assetsDataManagerObjectClassesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8Wz9C", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesRoute", () => $0ba95430cf0e8191$export$efbc59a0b92a1a13);
const $0ba95430cf0e8191$export$efbc59a0b92a1a13 = {
    name: 'assets-data-manager-object-classes',
    path: '/jira/assets/data-manager/object-classes',
    exact: true
};

});

parcelRegister("lIIas", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassesEntryPoint", () => $1c1bed0ca14dbe32$export$c1881c035be68200);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1c1bed0ca14dbe32$export$c1881c035be68200 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jhuRt")), {
        moduleId: "1ab370bf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jhuRt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4dniO").then(()=>parcelRequire('idjoc'));

});



parcelRegister("c7xWN", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassViewRouteEntry", () => $036890fedb18aca5$export$f4973dfdf4833835);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $ll0DL = parcelRequire("ll0DL");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $3cnp7 = parcelRequire("3cnp7");
const $036890fedb18aca5$var$assetsDataManagerObjectClassViewPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $3cnp7.assetsDataManagerObjectClassViewEntryPoint)
});
const $036890fedb18aca5$export$f4973dfdf4833835 = (0, $6xToB.createEntry)((0, $ll0DL.assetsDataManagerObjectClassViewRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-object-class-view',
        pageId: ()=>'spa-apps/assets-data-manager-object-class-view',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? $036890fedb18aca5$var$assetsDataManagerObjectClassViewPageEntryPoint : undefined;
        },
        component: (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerObjectClassViewRouteEntry.tsx',
                whichExportToUse: 'assetsDataManagerObjectClassViewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ll0DL", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassViewRoute", () => $14649825280192a3$export$88a05b032620e348);
const $14649825280192a3$export$88a05b032620e348 = {
    name: 'assets-data-manager-object-class-view',
    path: '/jira/assets/data-manager/object-classes/view/:objectClassId',
    exact: true,
    query: [
        'tab'
    ]
};

});

parcelRegister("3cnp7", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectClassViewEntryPoint", () => $46d16f65bbfd7d8c$export$a02bbc7f46f6a7cc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $6b7zr = parcelRequire("6b7zr");

var $3vktg = parcelRequire("3vktg");

var $9yo7u = parcelRequire("9yo7u");

const $46d16f65bbfd7d8c$export$a02bbc7f46f6a7cc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kB3NJ")), {
        moduleId: "6716a723",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { query: query } })=>{
        const { tab: tab } = query;
        if (tab === 'saved-search') return {
            entryPoints: {
                savedSearchTabEntryPoint: {
                    entryPoint: (0, $6b7zr.savedSearchTabEntryPoint)
                }
            }
        };
        if (tab === 'tags') return {
            entryPoints: {
                tagsTabEntryPoint: {
                    entryPoint: (0, $3vktg.tagsTabEntryPoint)
                }
            }
        };
        // default to objects tab
        return {
            entryPoints: {
                objectsTabEntryPoint: {
                    entryPoint: (0, $9yo7u.objectsTabEntryPoint)
                }
            }
        };
    }
});

});
parcelRegister("6b7zr", function(module, exports) {
$parcel$export(module.exports, "savedSearchTabEntryPoint", () => $a08ad4c4b241d65a$export$892a185cebc12244);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a08ad4c4b241d65a$export$892a185cebc12244 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4hxQ5")), {
        moduleId: "ec46ba1c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("4hxQ5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iPSld").then(()=>parcelRequire('jOpec'));

});


parcelRegister("3vktg", function(module, exports) {
$parcel$export(module.exports, "tagsTabEntryPoint", () => $866793a24aa63e23$export$f5b804ece08cf9c8);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $866793a24aa63e23$export$f5b804ece08cf9c8 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8VuuS")), {
        moduleId: "23653f96",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("8VuuS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jo1k7").then(()=>parcelRequire('6P642'));

});


parcelRegister("9yo7u", function(module, exports) {
$parcel$export(module.exports, "objectsTabEntryPoint", () => $426598a5e7aac6e1$export$c56ef5bc8d8eca35);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $426598a5e7aac6e1$export$c56ef5bc8d8eca35 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jjOjq")), {
        moduleId: "3808433e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            extraProps: {}
        })
});

});
parcelRegister("jjOjq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5EnrL").then(()=>parcelRequire('gn51B'));

});


parcelRegister("kB3NJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b1YeA").then(()=>parcelRequire('2D4CV'));

});



parcelRegister("8WI0C", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectDetailViewRouteEntry", () => $81ad937ca98a0509$export$d85e06e8278936eb);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $hJ2oe = parcelRequire("hJ2oe");

var $g8uYY = parcelRequire("g8uYY");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $b6Sd9 = parcelRequire("b6Sd9");
const $81ad937ca98a0509$var$assetsDataManagerObjectDetailViewPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $b6Sd9.assetsDataManagerObjectDetailViewEntryPoint)
});
const $81ad937ca98a0509$export$d85e06e8278936eb = (0, $6xToB.createEntry)((0, $hJ2oe.assetsDataManagerObjectDetailViewRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        perfMetricKey: 'assets-data-manager-object-detail-view',
        pageId: ()=>'spa-apps/assets-data-manager-object-detail-view',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? $81ad937ca98a0509$var$assetsDataManagerObjectDetailViewPageEntryPoint : undefined;
        },
        component: (0, $4cTDP.fg)('assets_data_manager_jira_spa') ? undefined : (0, $9BJU1.default),
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_DETAIL_VIEW_PAGE),
                teamName: 'Aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerObjectDetailViewRouteEntry.tsx',
                whichExportToUse: 'assetsDataManagerObjectDetailViewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hJ2oe", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectDetailViewRoute", () => $a1a13b58c6a1b620$export$ddfe9d50019b3e76);
const $a1a13b58c6a1b620$export$ddfe9d50019b3e76 = {
    name: 'assets-data-manager-object-detail-view',
    path: '/jira/assets/data-manager/object-classes/view/:objectClassId/object/:objectId',
    exact: true
};

});

parcelRegister("b6Sd9", function(module, exports) {
$parcel$export(module.exports, "assetsDataManagerObjectDetailViewEntryPoint", () => $35ca0a021cee9a1a$export$84681f0edd85e05a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $35ca0a021cee9a1a$export$84681f0edd85e05a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hOZca")), {
        moduleId: "8f75be13",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hOZca", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iCaUz").then(()=>parcelRequire('dKfJw'));

});



parcelRegister("7w4wA", function(module, exports) {
$parcel$export(module.exports, "assetsForYouRouteEntry", () => $e63be586f9c9b22b$export$69f5cb89a22780e6);

var $6xToB = parcelRequire("6xToB");

var $dcK0k = parcelRequire("dcK0k");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $eshd5 = parcelRequire("eshd5");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $4cTDP = parcelRequire("4cTDP");
const $e63be586f9c9b22b$var$assetsForYouPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $eshd5.assetsForYouEntryPoint)
});
const $e63be586f9c9b22b$export$69f5cb89a22780e6 = (0, $6xToB.createEntry)((0, $dcK0k.assetsForYouRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>(0, $4cTDP.fg)('assets_for_you') ? $e63be586f9c9b22b$var$assetsForYouPageEntryPoint : undefined,
        pageId: ()=>'spa-apps/assets/for-you-page',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-for-you-page',
        ufoName: 'assets-app-for-you-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsForYouRouteEntry.tsx',
                whichExportToUse: 'assetsForYouRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dcK0k", function(module, exports) {
$parcel$export(module.exports, "assetsForYouRoute", () => $e1e03c2c9e83b071$export$ec149f15b6c7930d);
const $e1e03c2c9e83b071$export$ec149f15b6c7930d = {
    name: 'assets-for-you',
    path: '/jira/assets/for-you',
    exact: true
};

});

parcelRegister("eshd5", function(module, exports) {
$parcel$export(module.exports, "assetsForYouEntryPoint", () => $3572fde0d0e63afd$export$3c6977bd1cdb3ef);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3572fde0d0e63afd$export$3c6977bd1cdb3ef = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("74zZA")).then((module)=>module.AssetsForYouPageView), {
        moduleId: "07738182",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("74zZA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("csshn").then(()=>parcelRequire('ahYKy'));

});



parcelRegister("bGwGo", function(module, exports) {
$parcel$export(module.exports, "assetsObjectRouteEntry", () => $096a76917fab2176$export$17871a1fbc6e31db);

var $6xToB = parcelRequire("6xToB");

var $7PjwP = parcelRequire("7PjwP");

var $PgORA = parcelRequire("PgORA");

var $f1zun = parcelRequire("f1zun");

var $93pOA = parcelRequire("93pOA");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $096a76917fab2176$var$assetsObjectPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $93pOA.assetsObjectViewEntryPoint)
});
const $096a76917fab2176$export$17871a1fbc6e31db = (0, $6xToB.createEntry)((0, $PgORA.assetsObjectRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$096a76917fab2176$var$assetsObjectPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-v2',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            (0, $7PjwP.insightObjectResource)
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsObjectRouteEntry.tsx',
                whichExportToUse: 'assetsObjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7PjwP", function(module, exports) {
$parcel$export(module.exports, "insightObjectResource", () => $f3a1a368cc3b7c59$export$215464c8085c5e35);

var $l1VxS = parcelRequire("l1VxS");

var $8cp50 = parcelRequire("8cp50");
const $f3a1a368cc3b7c59$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $f3a1a368cc3b7c59$export$215464c8085c5e35 = (0, $l1VxS.createResource)({
    type: $f3a1a368cc3b7c59$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $8cp50.default,
    isBrowserOnly: true
});

});
parcelRegister("8cp50", function(module, exports) {
$parcel$export(module.exports, "default", () => $00665b5d70bca074$export$2e2bcd8739ae039);

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $51aj0 = parcelRequire("51aj0");

var $hgi0g = parcelRequire("hgi0g");

var $2vBmG = parcelRequire("2vBmG");

var $7hVvO = parcelRequire("7hVvO");

var $8rYjX = parcelRequire("8rYjX");

var $jopyG = parcelRequire("jopyG");

var $aV23b = parcelRequire("aV23b");
const $00665b5d70bca074$var$fetchInsightObjectDetails = async (routeDataContext, storeContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $jopyG.default)(routeDataContext, storeContext);
        if (workspaceId == null) return null;
        const data = await (0, $hgi0g.default)((0, $8rYjX.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $51aj0.fireCmdbErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
const $00665b5d70bca074$var$getData = async (routeDataContext, storeContext)=>{
    const { tenantContext: tenantContext } = storeContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
        component: 'spa.view.routes.servicedesk.cmdb-object.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    return $00665b5d70bca074$var$fetchInsightObjectDetails(routeDataContext, storeContext);
};
var $00665b5d70bca074$export$2e2bcd8739ae039 = $00665b5d70bca074$var$getData;

});
parcelRegister("2vBmG", function(module, exports) {
$parcel$export(module.exports, "appBundleReadyMark", () => $579400bfeaf912d5$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $579400bfeaf912d5$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $579400bfeaf912d5$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $579400bfeaf912d5$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $579400bfeaf912d5$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $579400bfeaf912d5$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $579400bfeaf912d5$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $579400bfeaf912d5$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $579400bfeaf912d5$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $579400bfeaf912d5$export$4eb8d44ddb14424a);


var $4VDpW = parcelRequire("4VDpW");
const $579400bfeaf912d5$export$7e50945a65dd40e = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$ff834eccc35b9089));
const $579400bfeaf912d5$export$17cbe723d23101d8 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$86b05e34d462ead8));
const $579400bfeaf912d5$export$887fadb22e7c7735 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$d6a604a7d9a390fb));
const $579400bfeaf912d5$export$bd099c0a906f4b3f = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$3ae43cc1782d058f));
const $579400bfeaf912d5$export$d23ef9e7633e30e7 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$363f6703ffa600be));
const $579400bfeaf912d5$export$319da6d901948a6d = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$e87b74567b79c8));
const $579400bfeaf912d5$export$f0b6622cdc5c7e4f = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$99fe642459a8b02));
const $579400bfeaf912d5$export$37e82663aa1e79a8 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$ab1f5705fc8e0571));
const $579400bfeaf912d5$export$21146514eacceb12 = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$8c3a9046da692c35));
const $579400bfeaf912d5$export$4eb8d44ddb14424a = (0, $4VDpW.getPrefixedMarkName)((0, $fcc2379b1f384e36$export$5aa497d1efdcc5bf));

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("8rYjX", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $51ae915a9d99dfd8$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $51ae915a9d99dfd8$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $51ae915a9d99dfd8$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $51ae915a9d99dfd8$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $51ae915a9d99dfd8$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $51ae915a9d99dfd8$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $51ae915a9d99dfd8$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $51ae915a9d99dfd8$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $51ae915a9d99dfd8$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $51ae915a9d99dfd8$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $51ae915a9d99dfd8$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $51ae915a9d99dfd8$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $51ae915a9d99dfd8$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $51ae915a9d99dfd8$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncGenerateUaDuplicatesReportUrl", () => $51ae915a9d99dfd8$export$54601fa587b1cebb);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $51ae915a9d99dfd8$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $51ae915a9d99dfd8$export$f4d68a6f0e3217b5);
$parcel$export(module.exports, "getCmdbAsyncCdmBundleInstantiationUrl", () => $51ae915a9d99dfd8$export$ae8f0647f4610496);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $51ae915a9d99dfd8$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $51ae915a9d99dfd8$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $b5RwB.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $51ae915a9d99dfd8$export$6ef8997552257871 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $51ae915a9d99dfd8$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $51ae915a9d99dfd8$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $51ae915a9d99dfd8$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $51ae915a9d99dfd8$export$9cdc19e8944d38cf = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/create`;
const $51ae915a9d99dfd8$export$bf9c534c2cd21829 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $51ae915a9d99dfd8$export$b35334340ee827fa = (workspaceId)=>`${$51ae915a9d99dfd8$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $51ae915a9d99dfd8$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$ee74f95a469c4433 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $51ae915a9d99dfd8$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$878b627ac685384e = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $51ae915a9d99dfd8$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$54601fa587b1cebb = (workspaceId, objectTypeAttributeId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}/generate-ua-duplicates-report`;
const $51ae915a9d99dfd8$export$b02201bcaeb75291 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $51ae915a9d99dfd8$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
const $51ae915a9d99dfd8$export$ae8f0647f4610496 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/bundle/instantiate/async`;

});



parcelRegister("PgORA", function(module, exports) {
$parcel$export(module.exports, "assetsObjectRoute", () => $8a8f114df4a73d0f$export$8f0b5215230b6dd1);
const $8a8f114df4a73d0f$export$8f0b5215230b6dd1 = {
    name: 'assets-object',
    path: '/jira/assets/object/:objectId'
};

});

parcelRegister("93pOA", function(module, exports) {
$parcel$export(module.exports, "assetsObjectViewEntryPoint", () => $d901c6c7d8ad50f2$export$4311ec530d21ec36);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d901c6c7d8ad50f2$export$4311ec530d21ec36 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1IkfC")), {
        moduleId: "5026c489",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1IkfC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("kweWm")
]).then(()=>parcelRequire('5JaU6'));

});



parcelRegister("dRVNt", function(module, exports) {
$parcel$export(module.exports, "assetsObjectTypeConfigurationRouteEntry", () => $0b4d5812291813b2$export$28b088de21f264eb);

var $6xToB = parcelRequire("6xToB");

var $gc68d = parcelRequire("gc68d");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $9NZbc = parcelRequire("9NZbc");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $0b4d5812291813b2$var$assetsObjectTypeSettingsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9NZbc.assetsObjectTypeSettingsEntryPoint)
});
const $0b4d5812291813b2$export$28b088de21f264eb = (0, $6xToB.createEntry)((0, $gc68d.assetsObjectTypeConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$0b4d5812291813b2$var$assetsObjectTypeSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure-object-type',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsObjectTypeConfigurationRouteEntry.tsx',
                whichExportToUse: 'assetsObjectTypeConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gc68d", function(module, exports) {
$parcel$export(module.exports, "assetsObjectTypeConfigurationRoute", () => $b4132ba2c48128c9$export$fe5957039840ffd3);
const $b4132ba2c48128c9$export$fe5957039840ffd3 = {
    name: 'assets-object-type-configuration',
    path: '/jira/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("9NZbc", function(module, exports) {
$parcel$export(module.exports, "assetsObjectTypeSettingsEntryPoint", () => $e08925e93db50e8b$export$fab2e471b162aafc);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $e08925e93db50e8b$export$fab2e471b162aafc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3Ng8O")), {
        moduleId: "b4d985ee",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3Ng8O", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("176N4").then(()=>parcelRequire('hKEgw'));

});



parcelRegister("9qNa5", function(module, exports) {
$parcel$export(module.exports, "assetsReportsRouteEntry", () => $9b33e3b8feb155b7$export$dabfe6668c5a0cc4);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $5ZtxG = parcelRequire("5ZtxG");

var $gy2Qg = parcelRequire("gy2Qg");

var $g28xe = parcelRequire("g28xe");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $f1zun = parcelRequire("f1zun");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $9b33e3b8feb155b7$var$assetsReportsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $g28xe.assetsReportsNav4HomeEntryPoint)
});
const $9b33e3b8feb155b7$export$dabfe6668c5a0cc4 = (0, $6xToB.createEntry)((0, $5ZtxG.assetsReportsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$9b33e3b8feb155b7$var$assetsReportsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsReportsRouteEntry.tsx',
                whichExportToUse: 'assetsReportsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5ZtxG", function(module, exports) {
$parcel$export(module.exports, "assetsReportsRoute", () => $22aae5a428d1761b$export$b123ccf7df3854f4);
const $22aae5a428d1761b$export$b123ccf7df3854f4 = {
    name: 'assets-reports-default-redirect',
    path: '/jira/assets/reports',
    exact: true
};

});

parcelRegister("g28xe", function(module, exports) {
$parcel$export(module.exports, "assetsReportsNav4HomeEntryPoint", () => $3a38341cab08552f$export$1a891b207b85b219);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3a38341cab08552f$export$1a891b207b85b219 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kRKAt")).then((module)=>module.AssetsReportsNav4HomePage), {
        moduleId: "cd1143ba",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kRKAt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1gTGZ").then(()=>parcelRequire('7O8th'));

});



parcelRegister("2MZpi", function(module, exports) {
$parcel$export(module.exports, "assetsReportsTemplateRouteEntry", () => $c8133c69269b45d5$export$c69d6dbd8091ce7b);

var $5RW99 = parcelRequire("5RW99");

var $5gQb9 = parcelRequire("5gQb9");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $hoXzm = parcelRequire("hoXzm");

var $gy2Qg = parcelRequire("gy2Qg");

var $c1dkq = parcelRequire("c1dkq");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $c8133c69269b45d5$export$c69d6dbd8091ce7b = (0, $6xToB.createEntry)((0, $hoXzm.assetsReportsTemplateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        component: (0, $c1dkq.AssetsReports),
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $5gQb9.default)
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsReportsTemplateRouteEntry.tsx',
                whichExportToUse: 'assetsReportsTemplateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5gQb9", function(module, exports) {
$parcel$export(module.exports, "default", () => $59ee3aba4039716b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $59ee3aba4039716b$export$2260a0528570f8da = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("77AnC")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
const $59ee3aba4039716b$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59ee3aba4039716b$export$2260a0528570f8da, null)));
$59ee3aba4039716b$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $59ee3aba4039716b$export$2e2bcd8739ae039 = $59ee3aba4039716b$var$AssetsReportsSidebar;

});
parcelRegister("77AnC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d7pvU").then(()=>parcelRequire('1znBb'));

});


parcelRegister("hoXzm", function(module, exports) {
$parcel$export(module.exports, "assetsReportsTemplateRoute", () => $f304f1ced63507b5$export$4255578ec14d83bb);
const $f304f1ced63507b5$export$4255578ec14d83bb = {
    name: 'assets-reports',
    path: '/jira/assets/reports/:templateId',
    exact: true
};

});

parcelRegister("c1dkq", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", () => $4f61b729325f7e0f$export$9f75cdfdfe8c8aaa);
$parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", () => $4f61b729325f7e0f$export$2534c3e9f8e70d0d);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", () => $4f61b729325f7e0f$export$dec85f15dd805ac4);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", () => $4f61b729325f7e0f$export$c56cfef9aa68df09);
$parcel$export(module.exports, "AssetsReports", () => $4f61b729325f7e0f$export$d45b40d40442434);
$parcel$export(module.exports, "AssetsReportsUnsubscribe", () => $4f61b729325f7e0f$export$541b39e6d5be07df);
$parcel$export(module.exports, "AssetsReportingDefaultRedirect", () => $4f61b729325f7e0f$export$4155da54bfeacf74);
$parcel$export(module.exports, "AssetsReportsNav4HomePage", () => $4f61b729325f7e0f$export$9d28551695f98cae);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4f61b729325f7e0f$export$9f75cdfdfe8c8aaa = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hRuQt")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $4f61b729325f7e0f$export$2534c3e9f8e70d0d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hRuQt")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $4f61b729325f7e0f$export$dec85f15dd805ac4 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("Hs4VU")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});

const $4f61b729325f7e0f$export$c56cfef9aa68df09 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hRuQt")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});
const $4f61b729325f7e0f$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $4f61b729325f7e0f$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $4f61b729325f7e0f$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
const $4f61b729325f7e0f$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4f61b729325f7e0f$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });

});
parcelRegister("hRuQt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("14Jl6")),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("03pUM")
]).then(()=>parcelRequire('a0KLt'));

});

parcelRegister("Hs4VU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("gZ8N5")),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("iVjaJ")
]).then(()=>parcelRequire('coSZV'));

});



parcelRegister("5JNuq", function(module, exports) {
$parcel$export(module.exports, "assetsReportsUnsubscribeRouteEntry", () => $f35349d255ba78de$export$25e4df4267166d6b);

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $1gL8D = parcelRequire("1gL8D");

var $gy2Qg = parcelRequire("gy2Qg");

var $eStGB = parcelRequire("eStGB");

var $g8uYY = parcelRequire("g8uYY");

var $f1zun = parcelRequire("f1zun");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $f35349d255ba78de$var$assetsReportsUnsubscribePageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $eStGB.assetsReportsUnsubscribeEntryPoint)
});
const $f35349d255ba78de$export$25e4df4267166d6b = (0, $6xToB.createEntry)((0, $1gL8D.assetsReportsUnsubscribeRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$f35349d255ba78de$var$assetsReportsUnsubscribePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsReportsUnsubscribeRouteEntry.tsx',
                whichExportToUse: 'assetsReportsUnsubscribeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1gL8D", function(module, exports) {
$parcel$export(module.exports, "assetsReportsUnsubscribeRoute", () => $a9678985ec3fd56a$export$2b543c10e2c9e843);
const $a9678985ec3fd56a$export$2b543c10e2c9e843 = {
    name: 'assets-reports-unsubscribe',
    path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});

parcelRegister("eStGB", function(module, exports) {
$parcel$export(module.exports, "assetsReportsUnsubscribeEntryPoint", () => $ce345f15dfec188a$export$d827c87e65bb6e47);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ce345f15dfec188a$export$d827c87e65bb6e47 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("Hs4VU")), {
        moduleId: "fe8b4981",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("1w4c6", function(module, exports) {
$parcel$export(module.exports, "assetsRouteEntry", () => $010b3f3a8e5db0b7$export$7069f3fb497264f1);

var $6xToB = parcelRequire("6xToB");

var $Ca4n2 = parcelRequire("Ca4n2");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $6rtcv = parcelRequire("6rtcv");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $drxiR = parcelRequire("drxiR");
const $010b3f3a8e5db0b7$var$assetsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6rtcv.landingPageEntryPoint)
});
const $010b3f3a8e5db0b7$export$7069f3fb497264f1 = (0, $6xToB.createEntry)((0, $Ca4n2.assetsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        // Use component for conditional redirect when feature gate is enabled
        component: (0, $bJscI.componentWithFG)('assets_for_you', (0, $drxiR.ConditionalAssetsPage), ()=>null),
        // Only use entryPoint when feature gate is disabled
        entryPoint: ()=>(0, $4cTDP.fg)('assets_for_you') ? undefined : $010b3f3a8e5db0b7$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        ufoName: 'assets-app-landing-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsRouteEntry.tsx',
                whichExportToUse: 'assetsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("Ca4n2", function(module, exports) {
$parcel$export(module.exports, "assetsRoute", () => $36c01e828318f2e7$export$70dab2ea29192797);
const $36c01e828318f2e7$export$70dab2ea29192797 = {
    name: 'assets',
    path: '/jira/assets',
    exact: true
};

});

parcelRegister("6rtcv", function(module, exports) {
$parcel$export(module.exports, "landingPageEntryPoint", () => $65704b3640e7730a$export$36d88a15c123c06);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $65704b3640e7730a$export$36d88a15c123c06 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("l14fz")), {
        moduleId: "60961f22",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l14fz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kmFdR").then(()=>parcelRequire('8KJda'));

});


parcelRegister("drxiR", function(module, exports) {
$parcel$export(module.exports, "ConditionalAssetsPage", () => $f920f12fc9de873f$export$a0f76a00c20afc20);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $7fTjp = parcelRequire("7fTjp");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2dJFW = parcelRequire("2dJFW");

const $f920f12fc9de873f$var$LazyAssetsLandingPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("l14fz"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
// This component will redirect users from /jira/assets to /jira/assets/for-you
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event
// We can remove this component once the feature is fully rolled out and frequency of the operational event is 0
const $f920f12fc9de873f$var$AssetsForYouRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/assets/for-you"
    });
const $f920f12fc9de873f$export$a0f76a00c20afc20 = ()=>{
    return (0, $4cTDP.fg)('assets_for_you') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f920f12fc9de873f$var$AssetsForYouRedirect, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f920f12fc9de873f$var$LazyAssetsLandingPage,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: false
    });
};

});


parcelRegister("bP5Jb", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaConfigurationRouteEntry", () => $6e3ee8fe9879bd63$export$6c9c29c3048f2e2c);

var $6xToB = parcelRequire("6xToB");

var $gBOsl = parcelRequire("gBOsl");

var $blice = parcelRequire("blice");

var $gy2Qg = parcelRequire("gy2Qg");

var $f1zun = parcelRequire("f1zun");

var $4pMHI = parcelRequire("4pMHI");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $6e3ee8fe9879bd63$var$assetsSchemaSettingsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $4pMHI.assetsSchemaSettingsEntryPoint)
});
const $6e3ee8fe9879bd63$export$6c9c29c3048f2e2c = (0, $6xToB.createEntry)((0, $blice.assetsSchemaConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$6e3ee8fe9879bd63$var$assetsSchemaSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
        resources: [
            ...(0, $f1zun.getAssetsAppResources)(),
            (0, $gBOsl.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsSchemaConfigurationRouteEntry.tsx',
                whichExportToUse: 'assetsSchemaConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gBOsl", function(module, exports) {
$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $169a2c7b3c726d2d$export$58d2462746e91c7d);

var $l1VxS = parcelRequire("l1VxS");

const $169a2c7b3c726d2d$var$getDataLoader = ()=>(parcelRequire("lJOAl"));
const $169a2c7b3c726d2d$export$58d2462746e91c7d = (0, $l1VxS.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $169a2c7b3c726d2d$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("lJOAl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iSUGd").then(()=>parcelRequire('9bIwZ'));

});


parcelRegister("blice", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaConfigurationRoute", () => $a970258c7f6548d8$export$f27e51e1e8d78f80);
const $a970258c7f6548d8$export$f27e51e1e8d78f80 = {
    name: 'assets-schema-configuration',
    path: '/jira/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("4pMHI", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaSettingsEntryPoint", () => $61720552b6a91e52$export$b012e15a5f6394fc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $61720552b6a91e52$export$b012e15a5f6394fc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("iCpq7")), {
        moduleId: "c93bb7f3",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iCpq7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9azxL").then(()=>parcelRequire('lTK0k'));

});



parcelRegister("d065h", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaRouteEntry", () => $05ce94c1d9ea5a81$export$92c5054123a75324);

var $6xToB = parcelRequire("6xToB");

var $cVSNO = parcelRequire("cVSNO");

var $f1zun = parcelRequire("f1zun");

var $ofVNb = parcelRequire("ofVNb");

var $abvGw = parcelRequire("abvGw");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $05ce94c1d9ea5a81$var$assetsSchemaPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $abvGw.assetsSchemaEntryPoint)
});
const $05ce94c1d9ea5a81$export$92c5054123a75324 = (0, $6xToB.createEntry)((0, $cVSNO.assetsSchemaRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        component: (0, $ofVNb.ObjectSchemaV2),
        entryPoint: ()=>$05ce94c1d9ea5a81$var$assetsSchemaPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsSchemaRouteEntry.tsx',
                whichExportToUse: 'assetsSchemaRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cVSNO", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaRoute", () => $6c4e152300a1e78b$export$9515b8d2f9c8b12d);
const $6c4e152300a1e78b$export$9515b8d2f9c8b12d = {
    name: 'assets-schema',
    path: '/jira/assets/object-schema/:objectSchemaId'
};

});

parcelRegister("ofVNb", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", () => $a2f819b490210785$export$1e50d5a65ac4f5fc);
$parcel$export(module.exports, "ObjectSchemaV2", () => $a2f819b490210785$export$f90a4f33c79fd86e);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a2f819b490210785$export$1e50d5a65ac4f5fc = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3Diil")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $a2f819b490210785$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a2f819b490210785$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $a2f819b490210785$export$2e2bcd8739ae039 = $a2f819b490210785$export$f90a4f33c79fd86e;

});
parcelRegister("3Diil", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("aBH2w")
]).then(()=>parcelRequire('8nrlS'));

});


parcelRegister("abvGw", function(module, exports) {
$parcel$export(module.exports, "assetsSchemaEntryPoint", () => $06b5a85ebf1ddb9e$export$bbb96f529694d699);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $06b5a85ebf1ddb9e$export$bbb96f529694d699 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3Diil")), {
        moduleId: "a9175d64",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("8LcdF", function(module, exports) {
$parcel$export(module.exports, "assetsSchemasRouteEntry", () => $cb09ecfebe2a8670$export$7b81f13129f1add7);

var $6xToB = parcelRequire("6xToB");

var $77E2B = parcelRequire("77E2B");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $6rtcv = parcelRequire("6rtcv");

var $1qTV8 = parcelRequire("1qTV8");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $cb09ecfebe2a8670$var$assetsPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6rtcv.landingPageEntryPoint)
});
const $cb09ecfebe2a8670$export$7b81f13129f1add7 = (0, $6xToB.createEntry)((0, $77E2B.assetsSchemasRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$cb09ecfebe2a8670$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app-schemas-page',
        ufoName: 'assets-app-schemas-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsSchemasRouteEntry.tsx',
                whichExportToUse: 'assetsSchemasRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("77E2B", function(module, exports) {
$parcel$export(module.exports, "assetsSchemasRoute", () => $01d0d66e17676356$export$326987eddbe389c4);
const $01d0d66e17676356$export$326987eddbe389c4 = {
    name: 'assets',
    path: '/jira/assets/schemas',
    exact: true
};

});


parcelRegister("7O1yF", function(module, exports) {
$parcel$export(module.exports, "assetsSearchRouteEntry", () => $b7f81eb0877e64fe$export$2a3cf8cc5b9b7e6);

var $6xToB = parcelRequire("6xToB");

var $f1zun = parcelRequire("f1zun");

var $g8uYY = parcelRequire("g8uYY");

var $1qTV8 = parcelRequire("1qTV8");

var $8LNzJ = parcelRequire("8LNzJ");

var $bb4Lw = parcelRequire("bb4Lw");

var $eG7NE = parcelRequire("eG7NE");

var $6OSA0 = parcelRequire("6OSA0");
const $b7f81eb0877e64fe$var$assetsSearchPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $bb4Lw.assetsSearchEntryPoint)
});
const $b7f81eb0877e64fe$export$2a3cf8cc5b9b7e6 = (0, $6xToB.createEntry)((0, $8LNzJ.assetsSearchRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $1qTV8.AssetsLayout),
        PageConfigContainerOverride: (0, $eG7NE.AssetsPageConfigContainer),
        skeleton: (0, $6OSA0.default),
        entryPoint: ()=>$b7f81eb0877e64fe$var$assetsSearchPageEntryPoint,
        resources: (0, $f1zun.getAssetsAppResources)(),
        forPaint: [
            (0, $1qTV8.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app.interact-with-search-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsSearchRouteEntry.tsx',
                whichExportToUse: 'assetsSearchRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8LNzJ", function(module, exports) {
$parcel$export(module.exports, "assetsSearchRoute", () => $75abc948211813a8$export$6d41f99fb1a055c0);
const $75abc948211813a8$export$6d41f99fb1a055c0 = {
    name: 'assets-search-results',
    path: '/jira/assets/search',
    exact: true
};

});

parcelRegister("bb4Lw", function(module, exports) {
$parcel$export(module.exports, "assetsSearchEntryPoint", () => $ab305c5e55ad49e0$export$5752b60b3fc851fc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ab305c5e55ad49e0$export$5752b60b3fc851fc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9BPue")).then((module)=>module.AssetsAppSearchEntrypointWrapper), {
        moduleId: "49468062",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9BPue", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVX56"),
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("fliVL"),
    $ewTvA("gsTnx")
]).then(()=>parcelRequire('hPrHe'));

});



parcelRegister("66eA2", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", () => $2ddc4acf7fd93cee$export$2a34d21ecf479c40);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $WCxDe = parcelRequire("WCxDe");

var $9NmsS = parcelRequire("9NmsS");

var $bcpTa = parcelRequire("bcpTa");

var $7fTjp = parcelRequire("7fTjp");

var $iMFdk = parcelRequire("iMFdk");

var $bNZC9 = parcelRequire("bNZC9");
const $2ddc4acf7fd93cee$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/boards"
    });
const $2ddc4acf7fd93cee$export$2a34d21ecf479c40 = (0, $6xToB.createEntry)((0, $bcpTa.boardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: $2ddc4acf7fd93cee$var$BoardsDirectoryRedirect,
        skeleton: (0, $iMFdk.BoardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $WCxDe.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bNZC9.LazyBoardsDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/boardsDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'boardsDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("WCxDe", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryResource", () => $92b2c38ae2ebdd5f$export$2646f173fa2c14f2);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");


const $92b2c38ae2ebdd5f$export$2646f173fa2c14f2 = (0, $l1VxS.createResource)({
    type: (0, $84af832620b9e84d$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dipb2")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
const $84af832620b9e84d$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("dipb2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dvoU9").then(()=>parcelRequire('77vyI'));

});


parcelRegister("bcpTa", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $9c89e26b7d535e6d$export$a4fba1ebd6ba91ee);
const $9c89e26b7d535e6d$export$a4fba1ebd6ba91ee = {
    name: 'boards-directory-redirect',
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("iMFdk", function(module, exports) {
$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $c389558f405e3cf8$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $c389558f405e3cf8$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $c389558f405e3cf8$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $c389558f405e3cf8$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $c389558f405e3cf8$export$6cd26a09efd6d158);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $8RbyT = parcelRequire("8RbyT");

var $2XU9u = parcelRequire("2XU9u");

var $eFfAb = parcelRequire("eFfAb");

var $eIh7c = parcelRequire("eIh7c");
const $c389558f405e3cf8$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8RbyT)))
    });
const $c389558f405e3cf8$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2XU9u)))
    });
const $c389558f405e3cf8$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eFfAb)))
    });
const $c389558f405e3cf8$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eIh7c)))
    });
const $c389558f405e3cf8$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eIh7c)))
    });

});
parcelRegister("8RbyT", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("2XU9u", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("eFfAb", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("eIh7c", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("bNZC9", function(module, exports) {
$parcel$export(module.exports, "LazyBoardsDirectory", () => $5c7a52e194de71ac$export$2826049ae45f4cd);

var $2dJFW = parcelRequire("2dJFW");

var $bQWwW = parcelRequire("bQWwW");

const $5c7a52e194de71ac$export$2826049ae45f4cd = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2WzhB"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});

});
parcelRegister("2WzhB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("cGigZ")
]).then(()=>parcelRequire('hWHpM'));

});



parcelRegister("5GAw8", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRouteEntry", () => $409266e41ca2b14f$export$e78b34c999194638);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $WCxDe = parcelRequire("WCxDe");

var $9NmsS = parcelRequire("9NmsS");

var $3Z5Oj = parcelRequire("3Z5Oj");

var $iMFdk = parcelRequire("iMFdk");

var $1F9cm = parcelRequire("1F9cm");

var $bNZC9 = parcelRequire("bNZC9");
const $409266e41ca2b14f$var$BoardsDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $bNZC9.LazyBoardsDirectory),
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $409266e41ca2b14f$export$e78b34c999194638 = (0, $6xToB.createEntry)((0, $3Z5Oj.boardsDirectoryRoute), ()=>({
        group: 'directories',
        component: $409266e41ca2b14f$var$BoardsDirectoryComponent,
        skeleton: (0, $iMFdk.BoardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $WCxDe.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bNZC9.LazyBoardsDirectory)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/boardsDirectoryRouteEntry.tsx',
                whichExportToUse: 'boardsDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3Z5Oj", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRoute", () => $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85);
const $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});


parcelRegister("amJJx", function(module, exports) {
$parcel$export(module.exports, "browseConversationsRouteEntry", () => $c6a61b8854894e5c$export$b81210c1c5fc2e86);

var $3MgfG = parcelRequire("3MgfG");

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $37gZV = parcelRequire("37gZV");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $1eu50 = parcelRequire("1eu50");

var $8PlcH = parcelRequire("8PlcH");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $c6a61b8854894e5c$var$browseConversationsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8PlcH.browseConversationsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $c6a61b8854894e5c$export$b81210c1c5fc2e86 = (0, $6xToB.createEntry)((0, $37gZV.browseConversationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $c6a61b8854894e5c$var$browseConversationsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $1eu50.VirtualAgentBrowseConversationsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/browseConversationsRouteEntry.tsx',
                whichExportToUse: 'browseConversationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3MgfG", function(module, exports) {
$parcel$export(module.exports, "userSegRedirectEntrypoint", () => $72de4643a6a365ca$export$6d4ea918c982d275);

var $bhnBu = parcelRequire("bhnBu");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $72de4643a6a365ca$var$fetchPolicy = 'store-or-network';

const $72de4643a6a365ca$export$6d4ea918c982d275 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eFV5W")), {
        moduleId: "15389eb1",
        moduleName: "UserSegmentationRedirectEntry",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                userSegQueryRef: {
                    parameters: (0, $bhnBu.default),
                    variables: {
                        accountId: tenantContext.atlassianAccountId || '',
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: $72de4643a6a365ca$var$fetchPolicy
                    }
                }
            }
        })
});

});
parcelRegister("bhnBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $db7724a775c38112$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916730509a2c791ccf785e4193581425>>
 * @relayHash d91677b6bdf2827b223e02fa48634538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134
const $db7724a775c38112$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134",
        "metadata": {},
        "name": "UserSegmentationRedirectEntryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $db7724a775c38112$export$2e2bcd8739ae039 = $db7724a775c38112$var$node;

});

parcelRegister("eFV5W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aEZEj").then(()=>parcelRequire('eYFK8'));

});


parcelRegister("1eu50", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", () => $a34e00a133ca52df$export$4a6267fad85ca589);
/* VirtualAgentBrowseConversationsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $13E7r = parcelRequire("13E7r");
const $a34e00a133ca52df$var$customStyles = null;
const $a34e00a133ca52df$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($13E7r))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("13E7r", function(module, exports) {
module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();

});


parcelRegister("8PlcH", function(module, exports) {
$parcel$export(module.exports, "browseConversationsEntryPoint", () => $00b0d2d801d17fa4$export$38549013d5d5a440);

var $aK5Yw = parcelRequire("aK5Yw");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $00b0d2d801d17fa4$var$DEFAULT_RANGE_DAYS = 14;

const $00b0d2d801d17fa4$export$38549013d5d5a440 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jljln")), {
        moduleId: "9b721325",
        moduleName: "VirtualAgentBrowseConversations",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $00b0d2d801d17fa4$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $aK5Yw.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("aK5Yw", function(module, exports) {
$parcel$export(module.exports, "default", () => $824be5945891cc80$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eab41df62e1fb5613068d83be1dcce03>>
 * @relayHash 13258b2e2cfc92532f20e242537aa342
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 25aaf89a7ec6a739ccf31f351080c89552b25f262f7a84c4c2696e29656f1b73

var $aSejq = parcelRequire("aSejq");

var $bXR9c = parcelRequire("bXR9c");
const $824be5945891cc80$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "25aaf89a7ec6a739ccf31f351080c89552b25f262f7a84c4c2696e29656f1b73",
        "metadata": {},
        "name": "VirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, $aSejq.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $824be5945891cc80$export$2e2bcd8739ae039 = $824be5945891cc80$var$node;

});
parcelRegister("aSejq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9ed2eeb6b0a8b13$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f9ed2eeb6b0a8b13$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('expose_channels_on_va_conversation_history');
    }
};

});


parcelRegister("jljln", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lUDpe").then(()=>parcelRequire('9loVs'));

});



parcelRegister("eijnk", function(module, exports) {
$parcel$export(module.exports, "browseIntentsRouteEntry", () => $d27b926fb5493a70$export$da5f3658bd3ecdde);

var $3MgfG = parcelRequire("3MgfG");

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $azX7D = parcelRequire("azX7D");

var $gy2Qg = parcelRequire("gy2Qg");

var $fYqi8 = parcelRequire("fYqi8");

var $75uzh = parcelRequire("75uzh");

var $g8uYY = parcelRequire("g8uYY");

var $exc6Q = parcelRequire("exc6Q");

var $cAYFR = parcelRequire("cAYFR");
const $d27b926fb5493a70$var$browseIntentsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $exc6Q.browseIntentsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $d27b926fb5493a70$export$da5f3658bd3ecdde = (0, $6xToB.createEntry)((0, $azX7D.browseIntentsRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $d27b926fb5493a70$var$browseIntentsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        layout: (0, $fYqi8.browseIntentsLayout),
        skeleton: (0, $75uzh.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/browseIntentsRouteEntry.tsx',
                whichExportToUse: 'browseIntentsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fYqi8", function(module, exports) {
$parcel$export(module.exports, "browseIntentsLayout", () => $85a78ec8023d6908$export$6659f41b213bad05);

var $FhXEJ = parcelRequire("FhXEJ");

var $6dwgv = parcelRequire("6dwgv");

var $aQoXd = parcelRequire("aQoXd");

var $jWaie = parcelRequire("jWaie");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $85a78ec8023d6908$var$withServiceProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $FhXEJ.SERVICE_DESK_PROJECT)
        }
    });
const $85a78ec8023d6908$export$6659f41b213bad05 = (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), {
    rightSidebars: [
        $85a78ec8023d6908$var$withServiceProjectContext((0, $jWaie.default))
    ]
});

});
parcelRegister("jWaie", function(module, exports) {
$parcel$export(module.exports, "default", () => $db3ad5812dfff7ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $dfP3D = parcelRequire("dfP3D");

var $2aY2d = parcelRequire("2aY2d");

var $dl0y0 = parcelRequire("dl0y0");

var $255VQ = parcelRequire("255VQ");

var $hdDJ2 = parcelRequire("hdDJ2");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");
const $db3ad5812dfff7ce$var$runtimeProps = {};
const $db3ad5812dfff7ce$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? '',
            isHideIntentDiscoveryWhenVaNotConfiguredEnabled: (0, $4cTDP.fg)('hide_intent_discovery_copy_when_va_not_configured')
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $dl0y0.virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdDJ2.VirtualAgentIntentTemplateSidebarSkeleton), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db3ad5812dfff7ce$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $255VQ.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $db3ad5812dfff7ce$var$runtimeProps
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $db3ad5812dfff7ce$var$SideBarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kl7udwz _1e0c1txw _2lx21bp4 _bfhk1bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $db3ad5812dfff7ce$export$2e2bcd8739ae039 = $db3ad5812dfff7ce$export$36ad24b9ac79bdc8;

});
parcelRegister("dl0y0", function(module, exports) {
$parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", () => $e518e2efada04cf5$export$2b1d9dc27ee42f8f);

var $g4gZ4 = parcelRequire("g4gZ4");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e518e2efada04cf5$export$2b1d9dc27ee42f8f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gPYw3")), {
        moduleId: "9deb663f",
        moduleName: "CreateIntentTemplatesSideBar",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key, isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $g4gZ4.default),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("g4gZ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c13b9f5c75ded05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<41c111e5ceffa68f598d059560399728>>
 * @relayHash 37691a2ea664ea608db989394f721e35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 407f5fad955448e52028e8ed34ed859ba18b22105591ba90774abd111cde418c
const $2c13b9f5c75ded05$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "407f5fad955448e52028e8ed34ed859ba18b22105591ba90774abd111cde418c",
        "metadata": {},
        "name": "CreateIntentTemplatesSideBarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2c13b9f5c75ded05$export$2e2bcd8739ae039 = $2c13b9f5c75ded05$var$node;

});

parcelRegister("gPYw3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("dzT3W")
]).then(()=>parcelRequire('17J6g'));

});


parcelRegister("255VQ", function(module, exports) {
$parcel$export(module.exports, "ErrorDisplay", () => $3c3edb9a3ff3249f$export$d56b0569bceb92ae);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $igCP5 = parcelRequire("igCP5");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $jHRC0 = parcelRequire("jHRC0");
const $3c3edb9a3ff3249f$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $jHRC0.default).errorDisplayHeading),
        description: formatMessage((0, $jHRC0.default).errorDisplayDescription),
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $igCP5.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $jHRC0.default).reloadNowButtonText))
    });
};

});
parcelRegister("aTJmy", function(module, exports) {
$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $484fdcae7d1a2fee$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3xT3U = parcelRequire("3xT3U");
function $484fdcae7d1a2fee$export$ebf64b9217c1b2a3(JiraIllustration = (0, $3xT3U.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $awdRS.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $awdRS.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $hcewu.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("3xT3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e8HDz")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aiB9q")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $aiB9q = parcelRequire("aiB9q");

var $e8HDz = parcelRequire("e8HDz");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e8HDz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aiB9q))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("aiB9q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("e8HDz", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("jHRC0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6adc0017fccf419$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a6adc0017fccf419$var$messages = (0, $7qGN1.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});
var $a6adc0017fccf419$export$2e2bcd8739ae039 = $a6adc0017fccf419$var$messages;

});


parcelRegister("hdDJ2", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", () => $8378e703b6d3ac08$export$fa68b26760d5b66f);
/* VirtualAgentIntentTemplateSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $bfKNZ = parcelRequire("bfKNZ");
const $8378e703b6d3ac08$var$customCssStyles = null;
const $8378e703b6d3ac08$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bfKNZ))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("bfKNZ", function(module, exports) {
module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();

});




parcelRegister("75uzh", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $e3402caca65ff257$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $e3402caca65ff257$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $e3402caca65ff257$export$538762e63d6466fe);
/* VirtualAgentStatisticsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $6I3hE = parcelRequire("6I3hE");

var $iTmCv = parcelRequire("iTmCv");

var $cIEgS = parcelRequire("cIEgS");
const $e3402caca65ff257$var$customCssStyles = null;
const $e3402caca65ff257$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I3hE))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $e3402caca65ff257$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iTmCv))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $e3402caca65ff257$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cIEgS))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("6I3hE", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("iTmCv", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("cIEgS", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("exc6Q", function(module, exports) {
$parcel$export(module.exports, "browseIntentsEntryPoint", () => $1366f9a5b90d6cc7$export$f19c213ae2d7940f);

var $OiJmQ = parcelRequire("OiJmQ");

var $hv5KC = parcelRequire("hv5KC");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $1366f9a5b90d6cc7$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $1366f9a5b90d6cc7$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $1366f9a5b90d6cc7$export$f19c213ae2d7940f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("WPoYJ")), {
        moduleId: "5e314bf0",
        moduleName: "VirtualAgentBrowseIntents",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $OiJmQ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                },
                statistics: {
                    parameters: (0, $hv5KC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $1366f9a5b90d6cc7$var$formatFetchDate(new Date(Date.now() - $1366f9a5b90d6cc7$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $1366f9a5b90d6cc7$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("OiJmQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $be72567222cdb810$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a711988cdce0999d5c96e56796cade9>>
 * @relayHash 2dd0683e5c8c8023476603b9c599eed0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9580ee86745fc1be5c2ccc60ce1457d3072d1458995c13fa9b1896f48d6c776

var $bXR9c = parcelRequire("bXR9c");
const $be72567222cdb810$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e9580ee86745fc1be5c2ccc60ce1457d3072d1458995c13fa9b1896f48d6c776",
        "metadata": {},
        "name": "VirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $be72567222cdb810$export$2e2bcd8739ae039 = $be72567222cdb810$var$node;

});

parcelRegister("hv5KC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2249288faa71b732$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0844ee98f111057cc57c406d2e0c4c0e>>
 * @relayHash 69a28931ecb1e9e645d5105ddb690178
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d559b64c93c76b82b8460753885ee0b3f0f99a9411c0244057f7e75351b2fad6

var $deqPA = parcelRequire("deqPA");
const $2249288faa71b732$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d559b64c93c76b82b8460753885ee0b3f0f99a9411c0244057f7e75351b2fad6",
        "metadata": {},
        "name": "VirtualAgentBrowseIntents788BadPatternQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, $deqPA.default)
        }
    }
};
var $2249288faa71b732$export$2e2bcd8739ae039 = $2249288faa71b732$var$node;

});
parcelRegister("deqPA", function(module, exports) {
$parcel$export(module.exports, "default", () => $15a465622d5a2647$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $15a465622d5a2647$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsm_va_enable_performance_page');
    }
};

});


parcelRegister("WPoYJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2IxWW").then(()=>parcelRequire('iM8xS'));

});



parcelRegister("fvYEf", function(module, exports) {
$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $31d805b679e7032b$export$e275b3ca0c6ccb5e);

var $gEIw2 = parcelRequire("gEIw2");

var $R5dK3 = parcelRequire("R5dK3");


var $7K5Ea = parcelRequire("7K5Ea");

var $grWOk = parcelRequire("grWOk");

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $dk4qA = parcelRequire("dk4qA");

var $lPVME = parcelRequire("lPVME");

var $9NmsS = parcelRequire("9NmsS");

var $cxQGT = parcelRequire("cxQGT");

var $fk6FR = parcelRequire("fk6FR");

var $ePaI2 = parcelRequire("ePaI2");

var $5nfTh = parcelRequire("5nfTh");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $W6cJS = parcelRequire("W6cJS");

var $jIhkm = parcelRequire("jIhkm");

var $dQc7D = parcelRequire("dQc7D");

var $1FbOO = parcelRequire("1FbOO");

var $38U18 = parcelRequire("38U18");
const $31d805b679e7032b$export$e275b3ca0c6ccb5e = (0, $6xToB.createEntry)((0, $fk6FR.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $38U18.IssueEmbedComponent),
        skeleton: (0, $R5dK3.IssueViewSkeleton),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getModernIssueTransitionResources)(),
            (0, $lPVME.issueGiraDataResource),
            (0, $dk4qA.issueViewRelayResource),
            (0, $ePaI2.workspaceResource),
            (0, $cxQGT.themePreferenceResource),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('magma-3869-jsm-issue-view-sla-panel-fixes'), (0, $W6cJS.getJsmIssueViewSlaPanelResource)()),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('clefairy-12-move-knowledge-base-to-ssr'), (0, $W6cJS.getJsmIssueViewRelatedArticlesResource)()),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $jIhkm.issueCollapsibleGroupDataResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ken-3458-jira-hide-empty-field-ssr-fix'), (0, $dQc7D.issueHideEmptyFieldsDataResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jiv-21223_issue_view_remote_data_query_earlier'), (0, $1FbOO.issueViewRemoteDataResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-3p-attachments'), (0, $gEIw2.thirdPartyConnectedDataSourceResource))
        ],
        forPaint: [
            (0, $38U18.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'browseIssueEmbedRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('jfp-magma-issue-view-embed-hydrate-root')
    }));

});
parcelRegister("gEIw2", function(module, exports) {
$parcel$export(module.exports, "thirdPartyConnectedDataSourceResource", () => $dc74d4fb707b5273$export$59d77c416f392aa8);

var $l1VxS = parcelRequire("l1VxS");

const $dc74d4fb707b5273$var$getDataLoader = ()=>(parcelRequire("hnMLz"));
const $dc74d4fb707b5273$export$59d77c416f392aa8 = (0, $l1VxS.createResource)({
    type: 'ISSUE_VIEW_THIRD_PARTY_CONNECTORS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $dc74d4fb707b5273$var$getDataLoader,
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("hnMLz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("12fs0").then(()=>parcelRequire('i0yfM'));

});


parcelRegister("R5dK3", function(module, exports) {
$parcel$export(module.exports, "IssueViewSkeleton", () => $f52809f20d23afc1$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $biWZb = parcelRequire("biWZb");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $2nmMZ = parcelRequire("2nmMZ");

var $8gkGI = parcelRequire("8gkGI");
const $f52809f20d23afc1$var$fullpageStyles = null;
const $f52809f20d23afc1$var$modalStyles = null;
const $f52809f20d23afc1$var$customSpacingStyles = null;
/**
 * Renders a placeholder for the Issue View that adapts its layout and styling to different contexts such as embedding or modal presentation, ensuring a consistent user experience during content loading.
 */ const $f52809f20d23afc1$var$IssueViewSkeletonWithRightStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $f52809f20d23afc1$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $f52809f20d23afc1$var$fullpageStyles : null,
        isModalView === true ? $f52809f20d23afc1$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2nmMZ))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $f52809f20d23afc1$var$IssueViewSkeletonWithLeftStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $f52809f20d23afc1$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $f52809f20d23afc1$var$fullpageStyles : null,
        isModalView === true ? $f52809f20d23afc1$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8gkGI))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $f52809f20d23afc1$export$49addbcdecb6e6ff = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('move_status_to_summary_ga', 'isEnabled', false), $f52809f20d23afc1$var$IssueViewSkeletonWithLeftStatus, $f52809f20d23afc1$var$IssueViewSkeletonWithRightStatus);

});
parcelRegister("biWZb", function(module, exports) {
$parcel$export(module.exports, "CompactModeContext", () => $b77d47f9e4eb67f9$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $b77d47f9e4eb67f9$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $b77d47f9e4eb67f9$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $8BpnG = parcelRequire("8BpnG");

var $gCY1z = parcelRequire("gCY1z");

var $coXKe = parcelRequire("coXKe");

var $cZpx8 = parcelRequire("cZpx8");
const $b77d47f9e4eb67f9$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $b77d47f9e4eb67f9$var$Provider, Consumer: $b77d47f9e4eb67f9$var$Consumer } = $b77d47f9e4eb67f9$export$37eeac5cc5245b18;
const $b77d47f9e4eb67f9$export$55a90a8e865a39b5 = 700;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$b77d47f9e4eb67f9$export$55a90a8e865a39b5}px)`;
const $b77d47f9e4eb67f9$export$ddd398a95f85cd75 = 850;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$b77d47f9e4eb67f9$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $b77d47f9e4eb67f9$var$useRouteKey() {
    const [routeState] = (0, $gCY1z.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $b77d47f9e4eb67f9$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $b77d47f9e4eb67f9$var$useRouteKey();
    (0, $cZpx8.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $cZpx8.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4);
        (0, $cZpx8.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $eJOHy.useState)(defaultState);
    const onChange = (0, $eJOHy.useCallback)((state)=>{
        (0, $cZpx8.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BpnG.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$Provider, {
        value: isCompact
    }, children));
};
const $b77d47f9e4eb67f9$export$20feb77b5b617e44 = $b77d47f9e4eb67f9$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77d47f9e4eb67f9$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $548198843509795c$export$ee15e0cd1efafcb4 = false;

parcelRegister("8BpnG", function(module, exports) {
$parcel$export(module.exports, "ContainerQueryObserver", () => $b45aeffccc0e4b84$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $EzBXZ = parcelRequire("EzBXZ");

var $4cTDP = parcelRequire("4cTDP");

const $b45aeffccc0e4b84$var$QueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
let $b45aeffccc0e4b84$var$currentIdSeed = 0;
function $b45aeffccc0e4b84$var$generateAttributeValue() {
    return `indicator-span-${$b45aeffccc0e4b84$var$currentIdSeed++}`;
}
function $b45aeffccc0e4b84$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eJOHy.useState)(defaultState);
    const handleQueryStatusChange = (0, $eJOHy.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$QueryContext.Provider, {
        value: active
    }, !(0, $4cTDP.fg)('jfp-magma-nav-and-issue-view-misc-hydration-fixes') && !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), (0, $4cTDP.fg)('jfp-magma-nav-and-issue-view-misc-hydration-fixes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    })), children);
}
function $b45aeffccc0e4b84$export$b66a67697973e01() {
    const currentState = (0, $eJOHy.useContext)($b45aeffccc0e4b84$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $b45aeffccc0e4b84$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eJOHy.useMemo)(()=>$b45aeffccc0e4b84$var$generateAttributeValue(), []);
    const spanRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    const currentState = $b45aeffccc0e4b84$export$b66a67697973e01();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45aeffccc0e4b84$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("coXKe", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $cxKOj = parcelRequire("cxKOj");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $1M2hR = parcelRequire("1M2hR");


var $bNexr = parcelRequire("bNexr");

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$var$Tabs = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $3b984a26137eed7b$var$defaultActiveTab = $3b984a26137eed7b$var$Tabs.Description;
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ]);
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $1M2hR.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = $3b984a26137eed7b$var$defaultActiveTab, ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Description),
            setWorkItemsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Integrations),
            setResourcesAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {
$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {
$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {
$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {
$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {
$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $6PplZ = parcelRequire("6PplZ");

var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2],
                [(0, $7f80bdb4337734ff$export$e10d4d251d909c59)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$e10d4d251d909c59]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $6PplZ.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("6PplZ", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $520d86b9433cc3c6$export$4027d961191df7c3);

var $eGOwo = parcelRequire("eGOwo");
function $520d86b9433cc3c6$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('ditto_uim_new_attributes_for_uim_use_submit') && fieldsChanges && lastProcessedChange?.changeId === changeId) {
        const fid = lastProcessedChange?.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("81O8J", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);

var $eGOwo = parcelRequire("eGOwo");
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if ((0, $eGOwo.fg)('ditto_uim_error_cb_screen_tabs')) screenTabsFromApp.forEach((tab)=>{
        if (!$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    // As part of an experiment (jiv-21227_dev_panel_collapsibility_exp) we are introducing collapsibility to the dev panel
    // However, we need to iterate on the backend change that would see the userPreference for our collapsed state of the dev panel
    // come through Relay/Agg.
    // This fetchUserPreferenceValue is a temporary measure to be able to run our initial experiment - if successful, we will remove the below and implement the backend change
    // Please don't use this for anything else except this experiment. Reach out to https://atlassian.enterprise.slack.com/archives/C093S7Q436E
    // Please see the JIRA ticket https://jplat.atlassian.net/browse/JIV-21315 for more details.
    const fetchValue = (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
                const serverValue = await (0, $etbP7.fetchUserPreferenceValue)(userPreferenceKey);
                if (serverValue !== null) {
                    const parsedValue = typeof serverValue === 'string' ? JSON.parse(serverValue) : serverValue;
                    setUserPreferenceValue(userPreferenceKey, parsedValue);
                    return parsedValue;
                }
            }
            return null;
        } catch (error) {
            return null;
        }
    }, [
        userPreferenceKey,
        setUserPreferenceValue
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue,
            fetchValue: fetchValue
        }), [
        setValue,
        deleteValue,
        fetchValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$var$store = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {
$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$var$getUserPreferenceValue = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$var$getUserPreferenceValue
};

});


parcelRegister("etbP7", function(module, exports) {
$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "fetchUserPreferenceValue", () => $a9cf1c440643deff$export$a3e5f8cedb0374ad);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");

var $cxKOj = parcelRequire("cxKOj");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a3e5f8cedb0374ad = async (userPreferenceKey)=>{
    try {
        if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
            const response = await (0, $keOPi.performIssueGetRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');
            return response;
        }
        return null;
    } catch (error) {
        // If the preference doesn't exist, return null
        return null;
    }
};
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});
parcelRegister("keOPi", function(module, exports) {
$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);
// Stryker disable all

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPostRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPutRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performDeleteRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performGetRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performGetRequest)(url, options);
};

});
parcelRegister("biGll", function(module, exports) {
$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $14RSn = parcelRequire("14RSn");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});




const $e8c5fe022e7e442a$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $e8c5fe022e7e442a$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $e8c5fe022e7e442a$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $e8c5fe022e7e442a$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $e8c5fe022e7e442a$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $e8c5fe022e7e442a$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $e8c5fe022e7e442a$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $e8c5fe022e7e442a$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("lpEwy", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
// this is a global state
const $e029db5d7fe89f63$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {
$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {
$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("cZpx8", function(module, exports) {
$parcel$export(module.exports, "getCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $ae6f6bc492f6f5be$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $ae6f6bc492f6f5be$var$cachedIsCompactValues = {};
let $ae6f6bc492f6f5be$var$previousRouteKey;
function $ae6f6bc492f6f5be$export$c47621d55d10906c(key) {
    return $ae6f6bc492f6f5be$var$cachedIsCompactValues[key];
}
function $ae6f6bc492f6f5be$export$568b2dd75c2027b4(isCompactValue, key) {
    $ae6f6bc492f6f5be$var$cachedIsCompactValues[key] = isCompactValue;
}
function $ae6f6bc492f6f5be$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $ae6f6bc492f6f5be$var$previousRouteKey) {
        $ae6f6bc492f6f5be$var$previousRouteKey = currentRouteKey;
        delete $ae6f6bc492f6f5be$var$cachedIsCompactValues[$ae6f6bc492f6f5be$var$previousRouteKey];
    }
}

});


parcelRegister("2nmMZ", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});

parcelRegister("8gkGI", function(module, exports) {
module.exports = new URL("issue-app-skeleton.exp.tpl.4aeaad6d.svg", import.meta.url).toString();

});


parcelRegister("grWOk", function(module, exports) {
$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $82d04be066b2aa57$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $82d04be066b2aa57$export$ad16a91905cefb0a);
const $82d04be066b2aa57$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $82d04be066b2aa57$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $82d04be066b2aa57$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $82d04be066b2aa57$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $82d04be066b2aa57$export$137d6d169f402a59 = [
    $82d04be066b2aa57$var$VENDOR_ASSET_REGEX,
    $82d04be066b2aa57$var$PARCEL_VENDOR_ASSET_REGEX
];
const $82d04be066b2aa57$export$ad16a91905cefb0a = [
    $82d04be066b2aa57$var$VENDOR_ASSET_REGEX,
    $82d04be066b2aa57$var$COMMON_ASSET_REGEX,
    $82d04be066b2aa57$var$PARCEL_VENDOR_ASSET_REGEX,
    $82d04be066b2aa57$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("dk4qA", function(module, exports) {
$parcel$export(module.exports, "issueViewRelayResource", () => $6bf3f1482f81a9c8$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $6bf3f1482f81a9c8$export$252bdba8c8e5f066);
// eslint-disable-next-line jira/import-whitelist

var $e0gCa = parcelRequire("e0gCa");

var $48lPN = parcelRequire("48lPN");

var $dNyY6 = parcelRequire("dNyY6");

var $fspIv = parcelRequire("fspIv");

var $9FYIg = parcelRequire("9FYIg");

var $fEInL = parcelRequire("fEInL");

var $eq3q8 = parcelRequire("eq3q8");

var $5L7qx = parcelRequire("5L7qx");


var $4cTDP = parcelRequire("4cTDP");

var $6NSKd = parcelRequire("6NSKd");
const $6bf3f1482f81a9c8$export$55131006e6699c0a = (0, $5L7qx.browserOnlyResourceWithCondition)(()=>{
    if (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4cTDP.fg)('issue-view-ssr-perf-m2');
    return true;
}, (0, $6NSKd.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        const siteAri = (0, $48lPN.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const projectKey = issueKey ? (0, $dNyY6.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey,
            siteAri: siteAri
        };
        if (issueKey && (0, $4cTDP.fg)('jfp-magma-mainissueaggquery-called-more-detector')) (0, $e0gCa.getAggOverfetchDetector)().setInitialIssueKey(issueKey);
        return {
            parameters: (0, $fEInL.default),
            variables: {
                ...queryVariables,
                ...(0, $fspIv.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $fspIv.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    onFetchComplete: (config)=>{
        if ((0, $4cTDP.fg)('jfp-magma-mainissueaggquery-called-more-detector')) {
            const issueKey = config?.variables?.issueKey;
            if (issueKey) (0, $e0gCa.getAggOverfetchDetector)().onRouterResourceFetchComplete(issueKey);
        }
    }
}));
const $6bf3f1482f81a9c8$export$252bdba8c8e5f066 = (options)=>(0, $9FYIg.useRelayResource)($6bf3f1482f81a9c8$export$55131006e6699c0a, options);

});
parcelRegister("e0gCa", function(module, exports) {
$parcel$export(module.exports, "getAggOverfetchDetector", () => $326f6a3fc6a3fa79$export$5a2305b7a74f6278);

var $9pTd3 = parcelRequire("9pTd3");

var $SvJbY = parcelRequire("SvJbY");
/**
 * This class helps detect if we are making more network requests than we expect for the mainIssueAggQuery query
 */ class $326f6a3fc6a3fa79$var$AggOverfetchDetector {
    /**
	 * This is used for when we initially load the page and don't make additional network requests - eg through ssr
	 * @param issueKey
	 * @param forceSSRFetchSuccess If provided, forces the ssrFetchSuccess value instead of checking the globalThis window variable. This is mainly used for testing
	 */ setInitialIssueKey(issueKey, forceSSRFetchSuccess) {
        if (!this.issueKey) {
            this.issueKey = issueKey;
            if (forceSSRFetchSuccess === undefined) {
                if (globalThis?.window?.SPA_STATE?.['ssr/render_status'] === 'success') this.ssrFetchSuccess = Boolean(globalThis?.window?.SPA_STATE?.['ssr/relay_fetch']?.mainIssueAggQuery);
            } else this.ssrFetchSuccess = forceSSRFetchSuccess;
        }
    }
    reset() {
        if (this.issueKey) this.previousIssueKeys.add(this.issueKey);
        this.issueKey = undefined;
        this.isDisabled = false;
        this.routerResourceFetched = false;
        this.relayFetches = 0;
        this.ssrFetchSuccess = false;
    }
    onRouterResourceFetchComplete(issueKey) {
        /**
		 * We can't correctly tell if we're fetching again if we're navigating to an issue we've previously seen
		 * eg, KAN-1 -> KAN-2 -> KAN-1
		 *
		 * I believe this is because the router resource will grab the data for the issue from the relay store since it already exists
		 * but we then make another fetch outside that to get the correct data
		 *
		 * We end up detecting it as multiple fetches but we only do 1 network request (from non router resource)
		 *
		 * So if we are fetching from router resource for an old issue key, the detector ignores it
		 */ if (this.previousIssueKeys.has(issueKey)) return;
        if (this.issueKey && this.issueKey !== issueKey) this.reset();
        this.issueKey = issueKey;
        if (this.isDisabled) return;
        this.routerResourceFetched = true;
        this.verifyNoOverfetch();
    }
    onRelayFetchComplete(issueKey) {
        if (this.issueKey && this.issueKey !== issueKey) this.reset();
        this.issueKey = issueKey;
        if (this.isDisabled) return;
        this.relayFetches += 1;
        this.verifyNoOverfetch();
    }
    verifyNoOverfetch() {
        if (this.isDisabled || this.hasSentAnalytics) return;
        const { routerResourceFetched: routerResourceFetched, relayFetches: standardFetches, ssrFetchSuccess: ssrFetchSuccess } = this;
        const totalFetches = (routerResourceFetched ? 1 : 0) + standardFetches + (ssrFetchSuccess ? 1 : 0);
        if (totalFetches > 1) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: new Error('AGG query overfetch detected'),
                meta: {
                    id: 'jiraIssueAggOverfetchDetector',
                    packageName: 'jiraIssueFetchOverfetchDetector',
                    teamName: 'Issue View - Kenji'
                },
                attributes: {
                    routerResourceFetched: routerResourceFetched,
                    standardFetches: standardFetches,
                    totalFetches: totalFetches,
                    ssrFetchSuccess: ssrFetchSuccess
                }
            });
            this.hasSentAnalytics = true;
        }
    }
    /**
	 * Disables the overfetch detector for a specific issue key.
	 * This is useful for when we know we will be calling mainIssueAggQuery again intentionally, eg for soft refresh after mutations
	 * @param issueKey The issue key to disable the detector for.
	 */ disableForIssueKey(issueKey) {
        if (this.issueKey === issueKey) this.isDisabled = true;
    }
    constructor(){
        this.previousIssueKeys = new Set();
        this.isDisabled = false;
        this.routerResourceFetched = false;
        this.relayFetches = 0;
        this.ssrFetchSuccess = false;
        this.hasSentAnalytics = false;
    }
}
let $326f6a3fc6a3fa79$var$aggOverfetchDetector = new $326f6a3fc6a3fa79$var$AggOverfetchDetector();
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $326f6a3fc6a3fa79$var$aggOverfetchDetector = new $326f6a3fc6a3fa79$var$AggOverfetchDetector();
});
const $326f6a3fc6a3fa79$export$5a2305b7a74f6278 = ()=>$326f6a3fc6a3fa79$var$aggOverfetchDetector;

});

parcelRegister("48lPN", function(module, exports) {
$parcel$export(module.exports, "JiraSiteAri", () => $3028d8a5865a8fff$export$6c0f81f222d09301);

var $jzuB4 = parcelRequire("jzuB4");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/site/manifest.ts
var $3028d8a5865a8fff$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jzuB4.JiraSiteAriResourceOwner),
    resourceType: (0, $jzuB4.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $3028d8a5865a8fff$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $3028d8a5865a8fff$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $3028d8a5865a8fff$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $3028d8a5865a8fff$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("jzuB4", function(module, exports) {
$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $e3f905208997f6cb$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $e3f905208997f6cb$export$886165a991f21644);
// src/jira/site/types.ts
var $e3f905208997f6cb$export$b7d590981b504412 = "jira", $e3f905208997f6cb$export$886165a991f21644 = "site";

});


parcelRegister("fspIv", function(module, exports) {
$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $4a9801c17543db4c$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $4a9801c17543db4c$export$5896c8dc13246fe2);
$parcel$export(module.exports, "getCommentQueriesFromURL", () => $4a9801c17543db4c$export$e2c3bddbfc195841);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $5KtrL = parcelRequire("5KtrL");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lBYgs = parcelRequire("lBYgs");


var $cblKs = parcelRequire("cblKs");

var $aFPNn = parcelRequire("aFPNn");

var $cDvK0 = parcelRequire("cDvK0");

var $aYncF = parcelRequire("aYncF");

var $hWeHP = parcelRequire("hWeHP");

var $fEInL = parcelRequire("fEInL");

var $fohjD = parcelRequire("fohjD");

var $d60Hm = parcelRequire("d60Hm");
const $4a9801c17543db4c$var$getMainIssueViewAggProvidedVariables = ()=>{
    const providerVariables = (0, $fEInL.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $4a9801c17543db4c$export$3dd406718c5846c6 = ()=>({
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        jsmSentimentCustomFieldFlag: true,
        issueViewDesignsPanelFlag: (0, $cxKOj.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        isFieldsByIdRemoved: (0, $4cTDP.fg)('dfo_remove_fields_by_id'),
        customFieldConfigurationFlag: (0, $4cTDP.fg)('issue_view_field_config_edit'),
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $4cTDP.fg)('jcs_master_flag'),
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        isProactiveCommentSummaryPreferenceEnabled: true,
        // eslint-disable-next-line jira/relay/no-hardcoded-agg-params
        dateFieldsMessageEnabled: true,
        isNavigationMetadataRemoved: (0, $4cTDP.fg)('dfo_remove_navigation_metadata'),
        issueViewCollapsibleSectionsFieldEnabled: (0, $4cTDP.fg)('collapsible-sections-in-issue-view-fg'),
        issueViewUserPreferredLayoutFieldEnabled: (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate'),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $cxKOj.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withDragHandler', 'noReordering') || (0, $cxKOj.expValEquals)('jira-work-item-reordering-fields-v2', 'reorderingBehaviour', 'withoutDragHandler', 'noReordering'),
        isPrioritiesRemoved: (0, $4cTDP.fg)('dfo_remove_priority_field_from_main_query'),
        issueViewRedactionExperience: (0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view'),
        issueViewCoverExperimentEnabled: (0, $4cTDP.fg)('cover_image_issue_view_experiment_kill_switch'),
        isPlaybooksEnabled: (0, $4cTDP.fg)('playbook_in_jsm_ga'),
        isPlaybooksEnabledForSpecificType: (0, $4cTDP.fg)('playbook_visibility_in_service_request'),
        isAutomationDiscoverabilityEnabled: (0, $4cTDP.fg)('automation_discoverability_in_jsm'),
        issueViewRovoDevAgentsPanelEnabled: // These conditions should be included in the conditions for RovodevAgentPanel in content-items-view.tsx
        (0, $4cTDP.fg)('devai-issue-view-main-migration') && (!!(0, $aYncF.getLicensedProducts)((0, $hWeHP.default)).devai || (0, $4cTDP.fg)('rovodev_entitlements_user_access_bypass')),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4cTDP.fg)('jiv_confluence_remote_link_critical_query'),
        linkedWorkItemsTableEnabled: (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate'),
        issueViewCommentAvatarFlag: (0, $4cTDP.fg)('relay-avatar-iv-llc-comments'),
        issueViewSlackSyncInfoEnabled: (0, $4cTDP.fg)('jira_issue_view_show_slack_sync_info'),
        issueViewNextBestActionsEnabled: (0, $4cTDP.fg)('jira_issue_next_best_actions_fg'),
        isConfigUrlDefer: (0, $4cTDP.fg)('config-url-defer-iv'),
        isDisableConfigUrlDefer: !(0, $4cTDP.fg)('config-url-defer-iv'),
        issueViewGoalsFieldWithShowAllGoalsFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('jira-preview-panel-goals-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel'),
        isSkipParentVisibility: (0, $4cTDP.fg)('remove-parent-visibility-dfo'),
        relayMigrationWebLinksFlag: (0, $4cTDP.fg)('relay-migration-web-links-fetch'),
        relayMigrationIssueFieldAttachments: (0, $4cTDP.fg)('relay_migration_issue_field_attachments'),
        relayMigrationChildrenIssuesSectionEnabled: (0, $4cTDP.fg)('relay_migration_children_issues_section'),
        isSkipIssueLinkTypes: (0, $4cTDP.fg)('remove-issue-link-types-dfo'),
        relayMigrationArchival: (0, $4cTDP.fg)('relay-migration-archival'),
        relayMigrationIssueComments: (0, $4cTDP.fg)('relay-migration-issue-comments'),
        issueViewAtlasProjectFieldEnabled: (0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control'),
        isConnectMultiSelectFieldOptionsRemoved: (0, $4cTDP.fg)('dfo_remove_connect_multi_select_field_options_agg'),
        isConnectSingleSelectFieldOptionsRemoved: (0, $4cTDP.fg)('dfo_remove_connect_single_select_field_options_agg'),
        preloadDevPanelInIssueViewEnabled: (0, $4cTDP.fg)('preload_dev_panel_in_issue_view'),
        shouldIncludeUserFlag: (0, $4cTDP.fg)('remove-user-rest-api'),
        isAssetsFieldAttributesLazyLoadingEnabled: (0, $4cTDP.fg)('assets-field-attributes-lazy-loading-enabled'),
        isAiAgentSessionsPanelEnabled: (0, $4cTDP.fg)('jira_assignable_agents_session_open_beta')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $4a9801c17543db4c$var$getURLFromWindow = ()=>new URL(window.location.href);
const $4a9801c17543db4c$export$5896c8dc13246fe2 = (issueKey, url = $4a9801c17543db4c$var$getURLFromWindow())=>({
        ...$4a9801c17543db4c$var$getMainIssueViewAggProvidedVariables(),
        ...$4a9801c17543db4c$export$3dd406718c5846c6(),
        ...$4a9801c17543db4c$export$e2c3bddbfc195841(url),
        ...$4a9801c17543db4c$var$getStorageBannerVariables(),
        ...$4a9801c17543db4c$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$4a9801c17543db4c$var$getForgeSpecificVariables(),
        ...$4a9801c17543db4c$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables(),
        ...$4a9801c17543db4c$var$getLinkedIssuesTableQueryVariables(issueKey),
        ...$4a9801c17543db4c$var$getStorageHardLimitVariables()
    });
const $4a9801c17543db4c$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
        return {
            isInTimelineOrCalendarView: pattern.test(pathname)
        };
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $4a9801c17543db4c$export$9f8034ef70f20a00 = ()=>{
    /**
	 * Default fields we're fetching in child issues:
	 * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
	 */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4cTDP.fg)('relay-migration-edit-worklog') && !(0, $4cTDP.fg)('jpx-93-unship-legacy-timetracking')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update')) childIssuesFieldIds.push('status');
    return childIssuesFieldIds;
};
const $4a9801c17543db4c$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        childIssuesFieldIds: $4a9801c17543db4c$export$9f8034ef70f20a00()
    });
const $4a9801c17543db4c$var$getLinkedIssuesTableQueryVariables = (issueKey)=>({
        linkedIssuesViewConfigInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        linkedIssuesFieldSetsInput: {
            viewInput: {
                namespace: 'LINKED_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        shouldIncludeRemoteIssues: false,
        isEditableSyncLoadedInIssueLinksTable: (0, $4cTDP.fg)('jira-issue-table-perf-enabled')
    });
const $4a9801c17543db4c$export$e2c3bddbfc195841 = (url)=>{
    const commentTargetId = (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url);
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $4a9801c17543db4c$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $aFPNn.default)((0, $hWeHP.default)).software === (0, $cblKs.FREE_EDITION),
        productKey: (0, $315aedf92e50a945$export$1346c9aa3cbb477d),
        changeOfferingOfferingName: 'standard'
    });
const $4a9801c17543db4c$var$getForgeSpecificVariables = ()=>{
    return {
        forgeTypes: [
            (0, $fohjD.ISSUE_ACTION_MODULE),
            (0, $fohjD.ISSUE_GLANCE_MODULE),
            (0, $fohjD.ISSUE_CONTEXT_MODULE),
            (0, $fohjD.ISSUE_PANEL_MODULE),
            (0, $fohjD.ISSUE_ACTIVITY_MODULE),
            (0, $fohjD.CUSTOM_FIELD_MODULE),
            (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE),
            (0, $fohjD.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $fohjD.UI_MODIFICATIONS_MODULE)
        ]
    };
};
const $4a9801c17543db4c$var$getStorageHardLimitVariables = ()=>{
    /* ======================================================================================== */ /* To fetch attachmentStorageUsed from JiraQuery, using applicationKey: JIRA_SOFTWARE is appropriate. */ /* The applicationKey is an enum that specifies the application context, and JIRA_SOFTWARE is commonly */ /* used for Jira Software-related queries. */ /* ======================================================================================== */ return {
        applicationKey: (0, $lBYgs.JIRA_SOFTWARE),
        issueViewAddAttachmentFlag: (0, $aFPNn.default)((0, $hWeHP.default)).software === (0, $cblKs.FREE_EDITION) && (0, $cDvK0.default)((0, $hWeHP.default)).software === (0, $5KtrL.LICENSE_STATE_ACTIVE) && (0, $4cTDP.fg)('jira-storage-hard-limit-gate')
    };
};

});
const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';
const $315aedf92e50a945$export$a310f85340477585 = 'assets';

parcelRegister("fEInL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c51291f3989646ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2632e81853ffe58512d4755c92ba0f8a>>
 * @relayHash 86697ef98675dd60dc4a1fd5e0b9d50e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3a8998c0949e1b0ecdb3981321d38e9593920813e87749566bffd889ffdf1ea5

var $3Bt2F = parcelRequire("3Bt2F");

var $ginDg = parcelRequire("ginDg");

var $cqxuo = parcelRequire("cqxuo");

var $8FjDB = parcelRequire("8FjDB");

var $gAaux = parcelRequire("gAaux");

var $l9xWO = parcelRequire("l9xWO");

var $3jVIX = parcelRequire("3jVIX");

var $kzMwF = parcelRequire("kzMwF");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $1NHqW = parcelRequire("1NHqW");

var $hRj2m = parcelRequire("hRj2m");

var $b5T0d = parcelRequire("b5T0d");

var $lq9ow = parcelRequire("lq9ow");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $5nHY8 = parcelRequire("5nHY8");

var $2HLoK = parcelRequire("2HLoK");

var $ePJhs = parcelRequire("ePJhs");

var $84Nve = parcelRequire("84Nve");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $jZUJm = parcelRequire("jZUJm");

var $gDQIG = parcelRequire("gDQIG");

var $jLDgo = parcelRequire("jLDgo");

var $2lw0M = parcelRequire("2lw0M");

var $84S8I = parcelRequire("84S8I");

var $8Qoc7 = parcelRequire("8Qoc7");

var $iOvkB = parcelRequire("iOvkB");

var $deyBS = parcelRequire("deyBS");

var $1kOgh = parcelRequire("1kOgh");

var $gODza = parcelRequire("gODza");

var $FU9UR = parcelRequire("FU9UR");

var $2INXH = parcelRequire("2INXH");

var $i3mIO = parcelRequire("i3mIO");

var $gVub6 = parcelRequire("gVub6");

var $8H46l = parcelRequire("8H46l");
const $c51291f3989646ef$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3a8998c0949e1b0ecdb3981321d38e9593920813e87749566bffd889ffdf1ea5",
        "metadata": {},
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingrelayprovider": (0, $2lw0M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $84Nve.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcimpedimentflagfragmentfetchrelayprovidertsx": (0, $kzMwF.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraenableclassificationorgdefaultfgrelayprovider": (0, $5nHY8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $2INXH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": (0, $8H46l.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud94147hot116492fixattachmentspreviewrelayprovider": (0, $84S8I.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmissueviewaffectedservicesrelayprovider": (0, $deyBS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $1NHqW.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsfieldwithshowallgoalsrelayprovider": (0, $l9xWO.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $8FjDB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": (0, $jLDgo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirarelaymigrationarchivalrelayprovider": (0, $jZUJm.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": (0, $gVub6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewlayoutepiccolorfgrelayprovider": (0, $b5T0d.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $i3mIO.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconfigurldeferivrelayprovider": (0, $gAaux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewprogresssummaryschemachangeenabledrelayprovider": (0, $lq9ow.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcnikedfousehaschildissuesrelayprovider": (0, $gODza.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider": (0, $1kOgh.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcboysenberryissueviewagentspanelrelayprovider": (0, $ginDg.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
        }
    }
};
var $c51291f3989646ef$export$2e2bcd8739ae039 = $c51291f3989646ef$var$node;

});
parcelRegister("3Bt2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ccffb2cac398396$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $2ccffb2cac398396$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control');
    }
};

});

parcelRegister("ginDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d37ef2772d46595$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $8d37ef2772d46595$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('bsnbry-rovodev-agents-panel');
    }
};

});

parcelRegister("cqxuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $5da2395408471532$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $5da2395408471532$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
    }
};

});

parcelRegister("8FjDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c331984c62f9b536$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $c331984c62f9b536$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("gAaux", function(module, exports) {
$parcel$export(module.exports, "default", () => $243b733deddf993e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $243b733deddf993e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('config-url-defer-iv');
    }
};

});

parcelRegister("l9xWO", function(module, exports) {
$parcel$export(module.exports, "default", () => $eba18a144261330b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eba18a144261330b$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('jira-preview-panel-goals-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel'));
    }
};

});

parcelRegister("3jVIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6816ae84318f26ea$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6816ae84318f26ea$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('goals_ssr_smart_card');
    }
};

});

parcelRegister("kzMwF", function(module, exports) {
$parcel$export(module.exports, "default", () => $63f48dff8172d8a9$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $63f48dff8172d8a9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('relay-migration-issue-flag-fetch');
    }
};

});

parcelRegister("l6otE", function(module, exports) {
$parcel$export(module.exports, "default", () => $bebaad44334d69bd$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $bebaad44334d69bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store');
    }
};

});

parcelRegister("ad5K7", function(module, exports) {
$parcel$export(module.exports, "default", () => $520683d36ddd8076$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $520683d36ddd8076$var$isIframePreviewPanelInSubtasksEnabled = {
    get () {
        return (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask');
    }
};
var $520683d36ddd8076$export$2e2bcd8739ae039 = $520683d36ddd8076$var$isIframePreviewPanelInSubtasksEnabled;

});

parcelRegister("hHOEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e662ece0a0353288$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $e662ece0a0353288$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("2Z4v6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f2f02804d9e4b9e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $3f2f02804d9e4b9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("1NHqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be344f95049c974$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $3be344f95049c974$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsc_inline_edit_fast_follow_field_types');
    }
};

});

parcelRegister("hRj2m", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c7ac58a937df639$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $1c7ac58a937df639$var$isFieldsByIdRemoved = {
    get () {
        return (0, $4cTDP.fg)('dfo_remove_fields_by_id');
    }
};
var $1c7ac58a937df639$export$2e2bcd8739ae039 = $1c7ac58a937df639$var$isFieldsByIdRemoved;

});

parcelRegister("b5T0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $61b9e36b23873cfb$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $61b9e36b23873cfb$var$isEpicColorFGEnabled = {
    get () {
        return (0, $4cTDP.fg)('issue-view-layout-epic-color-fg');
    }
};
var $61b9e36b23873cfb$export$2e2bcd8739ae039 = $61b9e36b23873cfb$var$isEpicColorFGEnabled;

});

parcelRegister("lq9ow", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a5ef45169b1c977$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6a5ef45169b1c977$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('dfo_consume_child_issues_progress_schema');
    }
};

});

parcelRegister("1PjiU", function(module, exports) {
$parcel$export(module.exports, "default", () => $181ad024341f9175$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $181ad024341f9175$var$JiraAiShowHumanSupervisorAvatarRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar');
    }
};
var $181ad024341f9175$export$2e2bcd8739ae039 = $181ad024341f9175$var$JiraAiShowHumanSupervisorAvatarRelayProvider;

});

parcelRegister("jvWSl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4854b286d089865$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $b4854b286d089865$var$isJiraConfluencePageContentEnabled = {
    get () {
        return (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout');
    }
};
var $b4854b286d089865$export$2e2bcd8739ae039 = $b4854b286d089865$var$isJiraConfluencePageContentEnabled;

});

parcelRegister("5nHY8", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d4f595332681c2$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $37d4f595332681c2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('enable_classification_org_default');
    }
};

});

parcelRegister("2HLoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abdea24f5875b44$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $1abdea24f5875b44$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_platform_issue_realtime_updates_used_in_nin');
    }
};

});

parcelRegister("ePJhs", function(module, exports) {
$parcel$export(module.exports, "default", () => $92292d3add361cda$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $92292d3add361cda$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("84Nve", function(module, exports) {
$parcel$export(module.exports, "default", () => $f606be28bbc6fb53$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f606be28bbc6fb53$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view');
    }
};

});

parcelRegister("j2Uha", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8e788cdda2153d8$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $c8e788cdda2153d8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_list_reduce_re_renders');
    }
};

});

parcelRegister("bU8Sj", function(module, exports) {
$parcel$export(module.exports, "default", () => $748aaaa6a5a84440$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $748aaaa6a5a84440$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('frontier-currency-field-d1');
    }
};

});

parcelRegister("g29oX", function(module, exports) {
$parcel$export(module.exports, "default", () => $608f5087ba39dcfa$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $608f5087ba39dcfa$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira-original-estimate-editable-fix');
    }
};

});

parcelRegister("jZUJm", function(module, exports) {
$parcel$export(module.exports, "default", () => $255fc0693787b215$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $255fc0693787b215$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('relay-migration-archival');
    }
};

});

parcelRegister("gDQIG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7655aa3d61c407f$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $d7655aa3d61c407f$var$isJiraTimelineAnalyticsHarmonizationEnabled = {
    get () {
        return (0, $4cTDP.fg)('jira_timeline_analytics_harmonization');
    }
};
var $d7655aa3d61c407f$export$2e2bcd8739ae039 = $d7655aa3d61c407f$var$isJiraTimelineAnalyticsHarmonizationEnabled;

});

parcelRegister("jLDgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $3da0c8b9d8cbd8d6$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $3da0c8b9d8cbd8d6$var$fixDisabledVotingOption = {
    get () {
        return (0, $4cTDP.fg)('jracloud-81233-fix-disabled-voting-option');
    }
};
var $3da0c8b9d8cbd8d6$export$2e2bcd8739ae039 = $3da0c8b9d8cbd8d6$var$fixDisabledVotingOption;

});

parcelRegister("2lw0M", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a8daab1b487e668$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $4a8daab1b487e668$var$fixDisabledVoting = {
    get () {
        return (0, $4cTDP.fg)('jracloud-81233-fix-disabled-voting');
    }
};
var $4a8daab1b487e668$export$2e2bcd8739ae039 = $4a8daab1b487e668$var$fixDisabledVoting;

});

parcelRegister("84S8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $3101d160e40b29c6$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $3101d160e40b29c6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jracloud-94147_hot-116492_fix_attachments_preview');
    }
};

});

parcelRegister("8Qoc7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef773c4214bbea2d$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $ef773c4214bbea2d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor');
    }
};

});

parcelRegister("iOvkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1076a5ec945e04c$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $f1076a5ec945e04c$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jira_list_merged_column_gate');
    }
};
var $f1076a5ec945e04c$export$2e2bcd8739ae039 = $f1076a5ec945e04c$var$JscMergedColumnRelayProvider;

});

parcelRegister("deyBS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e027e166288164b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $1e027e166288164b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('ssring_affected_services_in_issue_view');
    }
};

});

parcelRegister("1kOgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d3b9eead2d77881$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $2d3b9eead2d77881$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('magma-3191-render-chin-skeleton-in-ssr') && !(0, $4cTDP.fg)('nike_dfo_use_haschildissues_field');
    }
};

});

parcelRegister("gODza", function(module, exports) {
$parcel$export(module.exports, "default", () => $b325427826758166$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $b325427826758166$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('nike_dfo_use_haschildissues_field');
    }
};

});

parcelRegister("FU9UR", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb5963aea9bff0ee$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eb5963aea9bff0ee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('nin-strikethrough-resolution-update');
    }
};

});

parcelRegister("2INXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d39c348564f268c0$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $d39c348564f268c0$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $4cTDP.fg)('issue_view_field_config_edit');
    }
};
var $d39c348564f268c0$export$2e2bcd8739ae039 = $d39c348564f268c0$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("i3mIO", function(module, exports) {
$parcel$export(module.exports, "default", () => $04cfa17728d241ba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4cTDP = parcelRequire("4cTDP");
var $04cfa17728d241ba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("gVub6", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeea7592427e4f5e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eeea7592427e4f5e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('remove-issue-types-dfo');
    }
};

});

parcelRegister("8H46l", function(module, exports) {
$parcel$export(module.exports, "default", () => $86bbed3b3012e299$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $86bbed3b3012e299$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jpx-93-simplified-time-tracking');
    }
};

});


parcelRegister("d60Hm", function(module, exports) {
$parcel$export(module.exports, "COMMENTS", () => $795b06e1e9a5d895$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $795b06e1e9a5d895$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $795b06e1e9a5d895$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $795b06e1e9a5d895$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $795b06e1e9a5d895$export$87557f913748dcff);

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");
const $795b06e1e9a5d895$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $795b06e1e9a5d895$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $795b06e1e9a5d895$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $795b06e1e9a5d895$export$dca91ad250f6b082 = ()=>{
    (0, $gRw8I.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $795b06e1e9a5d895$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $795b06e1e9a5d895$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]];
};
const $795b06e1e9a5d895$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("eq3q8", function(module, exports) {
$parcel$export(module.exports, "getIssueKey", () => $f3a8bc7a8cf56aaa$export$4a030f6192bebe03);
const $f3a8bc7a8cf56aaa$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

parcelRegister("6NSKd", function(module, exports) {
$parcel$export(module.exports, "withResourceEarlyData", () => $551b7a7af70655c3$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $551b7a7af70655c3$export$2e279339bedcd427);

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $4cTDP = parcelRequire("4cTDP");

var $6uWhG = parcelRequire("6uWhG");

var $7zZ4w = parcelRequire("7zZ4w");

var $g1oKu = parcelRequire("g1oKu");

var $jjfy5 = parcelRequire("jjfy5");

var $l1VxS = parcelRequire("l1VxS");

var $jHI6h = parcelRequire("jHI6h");
const $551b7a7af70655c3$export$5664a170ac5a9781 = 5000;
const $551b7a7af70655c3$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $551b7a7af70655c3$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $551b7a7af70655c3$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false, onFetchComplete: onFetchComplete })=>(0, $l1VxS.createResource)({
        type: `${$551b7a7af70655c3$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, storeContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, storeContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            if ('kind' in preloadableRequest && preloadableRequest.kind === 'PreloadableConcreteRequest') {
                ({ params: params } = preloadableRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $37Ewn.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, storeContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $6uWhG.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, storeContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $6uWhG.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $jjfy5.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $6uWhG.setMark)(endMark);
                (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
                if ((0, $4cTDP.fg)('jfp-magma-mainissueaggquery-called-more-detector')) onFetchComplete?.({
                    parameters: parameters,
                    variables: variables,
                    options: options
                });
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $jHI6h.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $551b7a7af70655c3$export$2e279339bedcd427 = $551b7a7af70655c3$var$createRelayResourceImpl;

});


parcelRegister("lPVME", function(module, exports) {
$parcel$export(module.exports, "issueGiraDataResource", () => $f496a1a0a8f6865a$export$37badecd288c49f4);

var $eq3q8 = parcelRequire("eq3q8");

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");


var $4cTDP = parcelRequire("4cTDP");

var $6NSKd = parcelRequire("6NSKd");

var $hM5pD = parcelRequire("hM5pD");
const $f496a1a0a8f6865a$export$37badecd288c49f4 = (0, $5L7qx.browserOnlyResourceWithCondition)(()=>{
    if (0, $9790b8dfe6f31c81$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4cTDP.fg)('issue-view-ssr-perf-m2');
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $l1VxS.createResource)((0, $6NSKd.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $hM5pD.default)(...args),
    isBrowserOnly: true
})));

});
parcelRegister("hM5pD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e266f77fd89b5cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $2c68b = parcelRequire("2c68b");

var $7hVvO = parcelRequire("7hVvO");

var $eq3q8 = parcelRequire("eq3q8");
const $2e266f77fd89b5cf$var$getData = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $eq3q8.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const data = await (0, $2c68b.default)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};
var $2e266f77fd89b5cf$export$2e2bcd8739ae039 = $2e266f77fd89b5cf$var$getData;

});
parcelRegister("2c68b", function(module, exports) {
$parcel$export(module.exports, "default", () => $f746cf123483fdb3$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $4cTDP = parcelRequire("4cTDP");

var $hqYEY = parcelRequire("hqYEY");

var $dNyY6 = parcelRequire("dNyY6");

var $8DQlA = parcelRequire("8DQlA");

var $hWeHP = parcelRequire("hWeHP");

var $6rzJr = parcelRequire("6rzJr");
const $f746cf123483fdb3$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric = (0, $hqYEY.metrics).custom({
    key: $f746cf123483fdb3$var$ISSUE_GIRA_DATA
});
const $f746cf123483fdb3$var$getCloudId = (0, $LFmXM.default)(()=>(0, $4cTDP.fg)('forge-issue-panel-open-by-default') ? (0, $hWeHP.default)('ajs-cloud-id') : null);
const $f746cf123483fdb3$var$fetchIssueGiraData = async (issueKey)=>{
    const cloudId = $f746cf123483fdb3$var$getCloudId();
    const projectKey = (0, $dNyY6.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey,
        ...cloudId ? {
            cloudId: cloudId
        } : {}
    };
    const payload = {
        query: cloudId ? (0, $8DQlA.buildIssueQueryV2)() : (0, $8DQlA.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $8DQlA.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    const isInSample = (sampleRate = 100)=>Math.random() <= 1 / sampleRate;
    if (isInSample()) $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $6rzJr.getClient)('issue-fetch-service/src/services/issue-gira-data/index').query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $f746cf123483fdb3$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};
var $f746cf123483fdb3$export$2e2bcd8739ae039 = $f746cf123483fdb3$var$fetchIssueGiraData;

});
parcelRegister("8DQlA", function(module, exports) {
$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $2f4d1124325e51fb$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $2f4d1124325e51fb$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $2f4d1124325e51fb$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $2f4d1124325e51fb$export$222ae9aca08830f0);
$parcel$export(module.exports, "buildIssueQueryV2", () => $2f4d1124325e51fb$export$fd751aee2a193083);
$parcel$export(module.exports, "getGiraRequestOptions", () => $2f4d1124325e51fb$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $cTI7h = parcelRequire("cTI7h");

var $f8B5B = parcelRequire("f8B5B");

var $c6t82 = parcelRequire("c6t82");

var $lGt35 = parcelRequire("lGt35");

var $l6Jfp = parcelRequire("l6Jfp");

var $avnia = parcelRequire("avnia");

var $efm76 = parcelRequire("efm76");

var $cEdKD = parcelRequire("cEdKD");

var $g6Y30 = parcelRequire("g6Y30");

var $hif4C = parcelRequire("hif4C");

var $7JZFE = parcelRequire("7JZFE");

var $cvLHO = parcelRequire("cvLHO");
const $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING = '-created';
const $2f4d1124325e51fb$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $2f4d1124325e51fb$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2f4d1124325e51fb$var$getURLFromWindow = ()=>new URL(window.location.href);
const $2f4d1124325e51fb$var$viewIssueQuery = (url = $2f4d1124325e51fb$var$getURLFromWindow(), includeForgeQuery = true)=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $f8B5B.default)({
        maxResults: (0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cvLHO.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $lGt35.getEcosystemQuery)(includeForgeQuery)}
        ${(0, $c6t82.getContentPanelsQuery)()}
        ${(0, $lGt35.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $efm76.getContainersByTypeQuery)()}
        ${(0, $7JZFE.getRemoteLinksQuery)()}
    }
`;
const $2f4d1124325e51fb$var$getForgeQuery = ()=>`
    forge {
        workItemPanels(
            cloudId: $cloudId,
            context: {
                workItemIdOrKey: $issueKey
            }
        ) {
            moduleId
            pinnedTo
            instances {
                id
                pinnedTo
                collapsed
                added
            }
        }
    }
`;
const $2f4d1124325e51fb$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $2f4d1124325e51fb$var$getJiraQuery = (includeForgeQuery = false)=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    	${includeForgeQuery ? $2f4d1124325e51fb$var$getForgeQuery() : ''}
		}
`;
const $2f4d1124325e51fb$export$222ae9aca08830f0 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$2f4d1124325e51fb$var$getJiraQuery()}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$var$viewIssueQuery(url)}
        ${(0, $avnia.getJiraSettingsQuery)()}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }

`;
const $2f4d1124325e51fb$export$fd751aee2a193083 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String, $cloudId: ID)  {
        ${$2f4d1124325e51fb$var$getJiraQuery(/* includeForgeQuery */ true)}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$var$viewIssueQuery(url, /* includeForgeQuery */ false)}
        ${(0, $avnia.getJiraSettingsQuery)()}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }
`;
const $2f4d1124325e51fb$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $2f4d1124325e51fb$export$1780a132c0453fee,
        query: $2f4d1124325e51fb$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("cTI7h", function(module, exports) {
$parcel$export(module.exports, "appendOperationQuery", () => $237ed4c9607e5b1c$export$69694c3add0f6058);
const $237ed4c9607e5b1c$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("f8B5B", function(module, exports) {
$parcel$export(module.exports, "default", () => $53da8aef2f05bd3c$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
const $53da8aef2f05bd3c$var$createCommentsFragment = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};
var $53da8aef2f05bd3c$export$2e2bcd8739ae039 = $53da8aef2f05bd3c$var$createCommentsFragment;

});

parcelRegister("c6t82", function(module, exports) {
$parcel$export(module.exports, "getContentPanelsQuery", () => $4249a4b796c65712$export$e6f14eac549b679d);
const $4249a4b796c65712$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $4249a4b796c65712$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$export$e6f14eac549b679d = ()=>`
    ${$4249a4b796c65712$var$getContentPanelsConnectionQuery()}
    ${$4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("lGt35", function(module, exports) {
$parcel$export(module.exports, "getEcosystemQuery", () => $5d3bcfb4ca889012$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $5d3bcfb4ca889012$export$92c9a3dc7076af51);
const $5d3bcfb4ca889012$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $5d3bcfb4ca889012$export$edefef8c65e08bd2 = (includeForgeQuery = true)=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${includeForgeQuery ? $5d3bcfb4ca889012$var$getForgeQuery() : ''}
    }
`;
const $5d3bcfb4ca889012$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("l6Jfp", function(module, exports) {
$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $bba965161d9cb764$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $bba965161d9cb764$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $bba965161d9cb764$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $bba965161d9cb764$export$c46d621c29194aa4 = 5;
const $bba965161d9cb764$export$b2e398ce246f55b3 = 5;
const $bba965161d9cb764$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("avnia", function(module, exports) {
$parcel$export(module.exports, "getJiraSettingsQuery", () => $0d65d613f30838ca$export$191f50c0f86b85ec);
const $0d65d613f30838ca$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("efm76", function(module, exports) {
$parcel$export(module.exports, "getContainersByTypeQuery", () => $ce3bfce6001e529c$export$63131b2831854cc);

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");
const $ce3bfce6001e529c$var$getContainersByTypeQueryOld = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$var$getContainersByTypeQueryWithCustomerContext = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$export$63131b2831854cc = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_master_flag'), $ce3bfce6001e529c$var$getContainersByTypeQueryWithCustomerContext, $ce3bfce6001e529c$var$getContainersByTypeQueryOld);

});

parcelRegister("cEdKD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8daa13ccb825551d$export$2e2bcd8739ae039);

var $cGVqS = parcelRequire("cGVqS");
const $8daa13ccb825551d$var$createMediaContextFragment = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $cGVqS.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
var $8daa13ccb825551d$export$2e2bcd8739ae039 = $8daa13ccb825551d$var$createMediaContextFragment;

});
parcelRegister("cGVqS", function(module, exports) {
$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});


parcelRegister("g6Y30", function(module, exports) {
$parcel$export(module.exports, "default", () => $58c20a5fb285246a$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $58c20a5fb285246a$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
const $58c20a5fb285246a$var$createPermissionsFragment = ()=>`

    permissions(issueKey:$issueKey, keys:["${$58c20a5fb285246a$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;
var $58c20a5fb285246a$export$2e2bcd8739ae039 = $58c20a5fb285246a$var$createPermissionsFragment;

});

parcelRegister("hif4C", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ce89c5fc46ec8e1$export$2e2bcd8739ae039);
const $7ce89c5fc46ec8e1$var$createProjectFragment = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
var $7ce89c5fc46ec8e1$export$2e2bcd8739ae039 = $7ce89c5fc46ec8e1$var$createProjectFragment;

});

parcelRegister("7JZFE", function(module, exports) {
$parcel$export(module.exports, "getRemoteLinksQuery", () => $c94d2c74482f6654$export$6bbc6b72b0b57f25);

var $4cTDP = parcelRequire("4cTDP");
const $c94d2c74482f6654$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
		remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$export$6bbc6b72b0b57f25 = ()=>(0, $4cTDP.fg)('jiv_confluence_remote_link_critical_query') ? $c94d2c74482f6654$var$getRemoteLinksQueryNew() : $c94d2c74482f6654$var$getRemoteLinksQueryOld();

});

parcelRegister("cvLHO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b69391f765eb53b$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
const $5b69391f765eb53b$var$createWorklogsFragment = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.WORKLOG), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};
var $5b69391f765eb53b$export$2e2bcd8739ae039 = $5b69391f765eb53b$var$createWorklogsFragment;

});


parcelRegister("6rzJr", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $dc2f954dac87a9b3$export$6bb76d6eba7e258c);

var $4mEPL = parcelRequire("4mEPL");
const $dc2f954dac87a9b3$var$appendOperationQuery = (operation)=>operation ? `?operation=${operation}` : '';
const $dc2f954dac87a9b3$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${$dc2f954dac87a9b3$var$appendOperationQuery(operation)}`;
const $dc2f954dac87a9b3$var$makeFetchClient = (path)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $4mEPL.default)($dc2f954dac87a9b3$export$aefb19023b2eda55(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            }, path)
    });
let $dc2f954dac87a9b3$var$client;
const $dc2f954dac87a9b3$export$6bb76d6eba7e258c = (path)=>{
    if (!$dc2f954dac87a9b3$var$client) $dc2f954dac87a9b3$var$client = $dc2f954dac87a9b3$var$makeFetchClient(path);
    return $dc2f954dac87a9b3$var$client;
};

});




parcelRegister("fk6FR", function(module, exports) {
$parcel$export(module.exports, "browseIssueEmbedRoute", () => $973922f52e8ea894$export$240aeec71c480594);
const $973922f52e8ea894$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("5nfTh", function(module, exports) {
$parcel$export(module.exports, "aiContextPanelResource", () => $beffd628552f984a$export$8f6224974184ed8d);
$parcel$export(module.exports, "aiContextPanelResourceWithDependencies", () => $beffd628552f984a$export$70559c909620e4ed);
$parcel$export(module.exports, "getAIContextPanelResources", () => $beffd628552f984a$export$d5bd1af2f373eac4);

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");


var $iYKap = parcelRequire("iYKap");


var $dAIVP = parcelRequire("dAIVP");

var $2MCmQ = parcelRequire("2MCmQ");

var $iVFol = parcelRequire("iVFol");

var $3yIzr = parcelRequire("3yIzr");

var $fEqOu = parcelRequire("fEqOu");
const $beffd628552f984a$var$SUPPORTED_PRACTICES = new Set([
    (0, $61012e06080c144d$export$a364d86306d4a6d4),
    (0, $61012e06080c144d$export$31ffe79c2b019cf)
]);
const $beffd628552f984a$export$8f6224974184ed8d = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$57128ea4767a7885),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $iYKap.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4cTDP.fg)('jsm_issue_view_ai_context')) return null;
            const issueDetails = await (0, $3yIzr.getIssueDetails)(issueKey, cloudId, (0, $4cTDP.fg)('context_panel_state_in_issue_details'));
            const isAIEnabled = issueDetails.isAIEnabled;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            if (!isAIEnabled || !$beffd628552f984a$var$SUPPORTED_PRACTICES.has(practice)) return null;
            let isAIContextPanelDisabled;
            if ((0, $4cTDP.fg)('context_panel_state_in_issue_details')) isAIContextPanelDisabled = !issueDetails.isAiContextFeatureEnabled;
            else {
                const featureState = await (0, $fEqOu.getFeatureState)(routerDataContext, resourceStoreContext);
                isAIContextPanelDisabled = featureState?.['jsm-ai-context']?.status === (0, $61012e06080c144d$export$8cd212c10b4124d2);
            }
            if (isAIContextPanelDisabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $61012e06080c144d$export$a364d86306d4a6d4)) return (0, $2MCmQ.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $61012e06080c144d$export$31ffe79c2b019cf) && (0, $4cTDP.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $iVFol.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $beffd628552f984a$export$70559c909620e4ed = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$38f892c32d281e99),
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResourceWithDependencies-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (!(0, $iYKap.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4cTDP.fg)('jsm_issue_view_ai_context')) return null;
        let issueDetails = (0, $dAIVP.getDependencyData)(routerDataContext.dependencies, (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd));
        if (issueDetails instanceof Promise) issueDetails = await issueDetails;
        if (!issueDetails) return null;
        const { isAIEnabled: isAIEnabled, isAiContextFeatureEnabled: isAiContextFeatureEnabled } = issueDetails;
        issueId = issueDetails.issueId;
        projectId = issueDetails.projectId;
        practice = issueDetails.practice;
        if (!isAIEnabled || !$beffd628552f984a$var$SUPPORTED_PRACTICES.has(practice) || !isAiContextFeatureEnabled) return null;
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $61012e06080c144d$export$a364d86306d4a6d4)) return (0, $2MCmQ.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $61012e06080c144d$export$31ffe79c2b019cf) && (0, $4cTDP.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $iVFol.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    depends: [
        (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd)
    ],
    isBrowserOnly: true
});
const $beffd628552f984a$export$d5bd1af2f373eac4 = ()=>{
    return (0, $4cTDP.fg)('ssr_issue_details_for_suggestions_panel') ? [
        (0, $3yIzr.contextPanelIssueDetailsResource),
        $beffd628552f984a$export$70559c909620e4ed
    ] : [
        $beffd628552f984a$export$8f6224974184ed8d
    ];
};

});
const $61012e06080c144d$export$b45a36df7873757 = 'alerts';
const $61012e06080c144d$export$a7952c5a5c371ddd = 'oncall';
const $61012e06080c144d$export$de0bca182bc46c7f = 'services';
const $61012e06080c144d$export$ed849d1eb34423e5 = 'similarIssues';
const $61012e06080c144d$export$d4a1ed8524773042 = 'sentiment-analysis';
const $61012e06080c144d$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $61012e06080c144d$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $61012e06080c144d$export$cae2404f62c0f4d7 = 'change-management';
const $61012e06080c144d$export$31ffe79c2b019cf = 'incident-management';
const $61012e06080c144d$export$3a20074cc38cbf69 = 'problem-management';
const $61012e06080c144d$export$a364d86306d4a6d4 = 'service-request';
const $61012e06080c144d$export$71f1a79e03f525 = 'post-incident-review';
const $61012e06080c144d$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $61012e06080c144d$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $61012e06080c144d$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $61012e06080c144d$export$93b42272f76473c9 = 'jsm-views';
const $61012e06080c144d$export$1eb399d8c2d53748 = 'jsm-board';
const $61012e06080c144d$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $61012e06080c144d$export$c270aafb43a2f7bb = 'jsm-list';
const $61012e06080c144d$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $61012e06080c144d$export$34136c6420474672 = 'journey-builder';
const $61012e06080c144d$export$66ede2c1de447f8f = 'developer-escalation';
const $61012e06080c144d$export$1ee9c534405b9b35 = 'playbooks';
const $61012e06080c144d$export$ac0832132e8992d7 = 'automation-discoverability';
const $61012e06080c144d$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $61012e06080c144d$export$e927a5d1b72f0b68 = 'ENABLED';
const $61012e06080c144d$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("iYKap", function(module, exports) {
$parcel$export(module.exports, "checkLicense", () => $53e7d1c0d26ba27f$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $53e7d1c0d26ba27f$export$944be0b3bf2a6feb);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");
const $53e7d1c0d26ba27f$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $53e7d1c0d26ba27f$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$53e7d1c0d26ba27f$var$appPermissionMapper[type]]);
const $53e7d1c0d26ba27f$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $53e7d1c0d26ba27f$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

const $2ba002e1dfb362f8$export$3e1b459cf14e5bcd = 'CONTEXT_PANEL_ISSUE_DETAILS';
const $2ba002e1dfb362f8$export$57128ea4767a7885 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE';
const $2ba002e1dfb362f8$export$38f892c32d281e99 = 'AI-CONTEXT-PANEL-RESOURCE-TYPE-WITH-DEPENDENCIES';

parcelRegister("dAIVP", function(module, exports) {
$parcel$export(module.exports, "getDependencyData", () => $e40c6d169122cf74$export$c1f67084c4ca42af);

var $5j85B = parcelRequire("5j85B");
const $e40c6d169122cf74$export$c1f67084c4ca42af = (dependencies, key)=>{
    if (dependencies[key]?.loading || dependencies[key]?.error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5j85B.consumeDependency)(dependencies, key);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return dependencies[key]?.data;
};

});

parcelRegister("2MCmQ", function(module, exports) {
$parcel$export(module.exports, "getServiceSuggestionData", () => $4dfc8fc8b5116538$export$afab700af9f021de);

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $hH1YR = parcelRequire("hH1YR");

var $3oS2M = parcelRequire("3oS2M");
const $4dfc8fc8b5116538$export$d8192485ee52671b = (issueId)=>`/gateway/api/firebolt/1/context-panel/${issueId}`;
const $4dfc8fc8b5116538$export$afab700af9f021de = (issueId, cloudId)=>{
    if ((0, $4cTDP.fg)('context-panel-graphql-migration')) return (0, $3oS2M.getContextPanelSuggestions)(cloudId, issueId);
    const url = $4dfc8fc8b5116538$export$d8192485ee52671b(issueId);
    return (0, $3ugTQ.performGetRequest)(url).then((0, $hH1YR.transformData));
};

});
parcelRegister("hH1YR", function(module, exports) {
$parcel$export(module.exports, "transformContent", () => $e8ab789f25bfc4bf$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $e8ab789f25bfc4bf$export$5659c60045974de9);
$parcel$export(module.exports, "transformData", () => $e8ab789f25bfc4bf$export$3ceb62baab058c6b);
const $e8ab789f25bfc4bf$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $e8ab789f25bfc4bf$export$5659c60045974de9(content.title),
        description: $e8ab789f25bfc4bf$export$5659c60045974de9(content.description)
    };
};
const $e8ab789f25bfc4bf$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $e8ab789f25bfc4bf$export$5659c60045974de9(data.summary),
        reporterDetails: $e8ab789f25bfc4bf$export$5659c60045974de9(data.reporterDetails),
        nextSteps: $e8ab789f25bfc4bf$export$5659c60045974de9(data.nextSteps),
        suggestedEscalation: $e8ab789f25bfc4bf$export$5659c60045974de9(data.suggestedEscalation),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
                case 'comment':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $e8ab789f25bfc4bf$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $e8ab789f25bfc4bf$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});

parcelRegister("3oS2M", function(module, exports) {
$parcel$export(module.exports, "getContextPanelSuggestions", () => $adc9a15d05014044$export$715f8fbc08922943);

var $12ByG = parcelRequire("12ByG");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $jHI6h = parcelRequire("jHI6h");

var $8sZMk = parcelRequire("8sZMk");
const $adc9a15d05014044$var$OPERATION_NAME = 'graphqlContextPanelQuery';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
const $adc9a15d05014044$var$contextPanelQuery = (0, $12ByG.default);
const $adc9a15d05014044$export$715f8fbc08922943 = async (cloudId, issueId)=>{
    (0, $jHI6h.startCapturingTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
    const graphQLResponse = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), $adc9a15d05014044$var$contextPanelQuery, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $jHI6h.getTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
        return (0, $8sZMk.handleGraphQLresponse)(data, traceIds);
    }).catch((error)=>{
        const traceIds = (0, $jHI6h.getTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
        return (0, $8sZMk.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $jHI6h.stopCapturingTraceIds)($adc9a15d05014044$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("12ByG", function(module, exports) {
$parcel$export(module.exports, "default", () => $48e15bb162ea0470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c774a8911f438c14fb2c108dc7261b2>>
 * @relayHash 20aa1db3e5dcec5d6322da71b2d44a0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55a6eaf60c07b634226859504fbc2afe9f4b2d83ce39697f662c523cfaea5460
const $48e15bb162ea0470$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "nextSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "kind": "ScalarField",
                "name": "suggestedEscalation"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "fieldName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "currentValue"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "55a6eaf60c07b634226859504fbc2afe9f4b2d83ce39697f662c523cfaea5460",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$48e15bb162ea0470$var$node.hash = "566ae9d1c90b40e64ca9be90435ac041";
var $48e15bb162ea0470$export$2e2bcd8739ae039 = $48e15bb162ea0470$var$node;

});

parcelRegister("8sZMk", function(module, exports) {
$parcel$export(module.exports, "handleGraphQLresponse", () => $c54e4deedc3837c9$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $c54e4deedc3837c9$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $hr3bU = parcelRequire("hr3bU");

var $hH1YR = parcelRequire("hH1YR");
const $c54e4deedc3837c9$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $hH1YR.parseAdf)(data?.summary),
        reporterDetails: (0, $hH1YR.parseAdf)(data?.reporterDetails),
        nextSteps: (0, $hH1YR.parseAdf)(data?.nextSteps),
        suggestedEscalation: (0, $hH1YR.parseAdf)(data?.suggestedEscalation),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $hH1YR.transformContent)(action?.content)
            })) : []
    };
};
const $c54e4deedc3837c9$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $c54e4deedc3837c9$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $hr3bU.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $hr3bU.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $c54e4deedc3837c9$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $hr3bU.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});
parcelRegister("hr3bU", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $c3479ad131081be1$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $c3479ad131081be1$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $c3479ad131081be1$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $c3479ad131081be1$export$26e841bcf1aeb894 extends $c3479ad131081be1$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $c3479ad131081be1$export$895e385291c3b753 extends $c3479ad131081be1$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});




parcelRegister("iVFol", function(module, exports) {
$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $7e9ce5a2037a7c93$export$32b63803a24bceaa);

var $hgi0g = parcelRequire("hgi0g");

var $1L12E = parcelRequire("1L12E");
const $7e9ce5a2037a7c93$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $7e9ce5a2037a7c93$export$32b63803a24bceaa = (reqParams)=>{
    const url = $7e9ce5a2037a7c93$export$db19de3f154d9918(reqParams);
    return (0, $hgi0g.default)(url, {
        method: 'GET'
    }).then((0, $1L12E.transformResponseV2));
};

});
parcelRegister("1L12E", function(module, exports) {
$parcel$export(module.exports, "transformResponseV2", () => $c4785b8184d8dce8$export$deb8fcf4bacae588);
// Resource doesn't allow imports of getEmptyADF();
const $c4785b8184d8dce8$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $c4785b8184d8dce8$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $c4785b8184d8dce8$var$EMPTY_DOCUMENT;
    }
};
const $c4785b8184d8dce8$var$transformContent = (content)=>{
    return {
        title: $c4785b8184d8dce8$var$parseToADF(content.title),
        description: $c4785b8184d8dce8$var$parseToADF(content.description)
    };
};
const $c4785b8184d8dce8$var$transformMultipleSectionContent = (content)=>{
    return {
        title: $c4785b8184d8dce8$var$parseToADF(content.title),
        description: $c4785b8184d8dce8$var$parseToADF(content.description),
        descriptionList: content.descriptionList ? content.descriptionList.map((suggestion)=>({
                id: suggestion.id,
                description: $c4785b8184d8dce8$var$parseToADF(suggestion.description)
            })) : []
    };
};
const $c4785b8184d8dce8$var$exhaustiveCheck = (_)=>null;
const $c4785b8184d8dce8$export$deb8fcf4bacae588 = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $c4785b8184d8dce8$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'MAJOR_INCIDENT':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'PRIORITY':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'RESPONDERS':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $c4785b8184d8dce8$var$transformContent(action.content)
                    };
                case 'ASSIGNEE':
                    return {
                        ...action,
                        context: action.context,
                        content: $c4785b8184d8dce8$var$transformMultipleSectionContent(action.content)
                    };
                default:
                    return $c4785b8184d8dce8$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("3yIzr", function(module, exports) {
$parcel$export(module.exports, "getIssueDetails", () => $5e5098c8e0f24a39$export$da0733c355d205d6);
$parcel$export(module.exports, "contextPanelIssueDetailsResource", () => $5e5098c8e0f24a39$export$626ce3b2cb7fb94e);

var $NEgSm = parcelRequire("NEgSm");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $hqYEY = parcelRequire("hqYEY");

var $l1VxS = parcelRequire("l1VxS");

var $iYKap = parcelRequire("iYKap");

const $5e5098c8e0f24a39$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $5e5098c8e0f24a39$var$issueDetailsAggMetric = (0, $hqYEY.metrics).custom({
    key: $5e5098c8e0f24a39$var$ISSUE_DETAILS_AGG_METRIC
});
const $5e5098c8e0f24a39$export$da0733c355d205d6 = async (issueKey, cloudId, includeContextPanelState = false)=>{
    $5e5098c8e0f24a39$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $NEgSm.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeContextPanelState: includeContextPanelState
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $5e5098c8e0f24a39$var$issueDetailsAggMetric.stop();
        return data;
    }).catch(()=>{
        $5e5098c8e0f24a39$var$issueDetailsAggMetric.cancel();
        return null; // only returning null instead of throwing error since it polluted overall SSR success rate
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined,
        ...includeContextPanelState && {
            isAiContextFeatureEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAiContextFeatureEnabled ?? undefined
        }
    };
};
const $5e5098c8e0f24a39$export$626ce3b2cb7fb94e = (0, $l1VxS.createResource)({
    type: (0, $2ba002e1dfb362f8$export$3e1b459cf14e5bcd),
    getKey: ({ match: match, query: query })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        return `contextPanelIssueDetailsResource-${issueKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const issueKey = match.params.issueKey || query.selectedIssue || '';
        const cloudId = tenantContext.cloudId;
        if (!(0, $iYKap.checkLicense)(tenantContext, 'servicedesk')) return null;
        if (!issueKey) /* only returning null instead of throwing error since it polluted overall SSR success rate */ /* until a better is implemented */ return null;
        return $5e5098c8e0f24a39$export$da0733c355d205d6(issueKey, cloudId, true);
    },
    maxAge: 3600000
});

});
parcelRegister("NEgSm", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c8621b016dd1263$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97b1ac959a33600e23b69a5ece8a9862>>
 * @relayHash f0aba673194e9058619abb300a99e877
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74
const $1c8621b016dd1263$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeContextPanelState"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "condition": "includeContextPanelState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAiContextFeatureEnabled"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74",
            "metadata": {},
            "name": "issueDetailsForAIContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1c8621b016dd1263$var$node.hash = "31378fdb45b287b152e0f480c90e621a";
var $1c8621b016dd1263$export$2e2bcd8739ae039 = $1c8621b016dd1263$var$node;

});


parcelRegister("fEqOu", function(module, exports) {
$parcel$export(module.exports, "getFeatureState", () => $06021a236a151e25$export$c8c54cead17ad7fa);
// eslint-disable-next-line jira/import-whitelist

var $hqYEY = parcelRequire("hqYEY");

var $dYpVn = parcelRequire("dYpVn");
const $06021a236a151e25$var$FEATURE_STATE_METRIC = 'context-panel-feature-states';
const $06021a236a151e25$var$featureStateMetric = (0, $hqYEY.metrics).custom({
    key: $06021a236a151e25$var$FEATURE_STATE_METRIC
});
const $06021a236a151e25$export$c8c54cead17ad7fa = (routerDataContext, resourceStoreContext)=>{
    $06021a236a151e25$var$featureStateMetric.start();
    return (0, $dYpVn.featuresResource)(routerDataContext, resourceStoreContext)?.then((data)=>{
        $06021a236a151e25$var$featureStateMetric.stop();
        return data;
    }).catch((e)=>{
        $06021a236a151e25$var$featureStateMetric.cancel();
        throw e;
    });
};

});
parcelRegister("dYpVn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "transformRestData", () => $f8375032ce4d6cb2$export$40da6ae06b8b332e);
$parcel$export(module.exports, "featuresResource", () => $f8375032ce4d6cb2$export$16f81cc9da2c6c47);
$parcel$export(module.exports, "default", () => $f8375032ce4d6cb2$export$2e2bcd8739ae039);

var $9Dhvc = parcelRequire("9Dhvc");

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $2vBmG = parcelRequire("2vBmG");

var $7hVvO = parcelRequire("7hVvO");

var $bBtQo = parcelRequire("bBtQo");

var $aV23b = parcelRequire("aV23b");
const $f8375032ce4d6cb2$export$40da6ae06b8b332e = (data)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.reduce((acc, { feature: feature, status: status, editable: editable })=>Object.assign(acc, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [feature]: {
                status: status,
                editable: editable
            }
        }), {});
const $f8375032ce4d6cb2$var$getFeatures = async (projectKey)=>{
    try {
        const data = await (0, $hgi0g.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/features`);
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        return $f8375032ce4d6cb2$export$40da6ae06b8b332e(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraServicedeskPracticeFeaturesResource', error);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskPracticeFeaturesResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $f8375032ce4d6cb2$export$16f81cc9da2c6c47 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { params: params } = match;
    if (!(0, $aV23b.checkAuthentication)(tenantContext)) throw (0, $7hVvO.createResourceError)({
        component: 'spa.view.routes.servicedesk.features.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // projectKey from url path or issueKey
    const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $f8375032ce4d6cb2$var$getFeatures(projectKey);
};
var $f8375032ce4d6cb2$export$2e2bcd8739ae039 = $f8375032ce4d6cb2$export$16f81cc9da2c6c47;

});



parcelRegister("6zEUu", function(module, exports) {
$parcel$export(module.exports, "projectGlobalComponentsResource", () => $dea084457308c93c$export$d2cb7067a31cf873);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3Is9n = parcelRequire("3Is9n");
const $dea084457308c93c$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $dea084457308c93c$export$d2cb7067a31cf873 = (0, $l1VxS.createResource)({
    type: $dea084457308c93c$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $3Is9n.getData)(...args)
});

});
parcelRegister("3Is9n", function(module, exports) {
$parcel$export(module.exports, "getData", () => $c5448ba1b9fac404$export$7a171f172be0782e);

var $bBtQo = parcelRequire("bBtQo");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $c5448ba1b9fac404$export$7a171f172be0782e = async (matchedRoute, _storeContext)=>{
    const projectIdOrKey = (0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $c5448ba1b9fac404$export$1db3503600a1638e(projectIdOrKey);
};
const $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $c5448ba1b9fac404$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $c5448ba1b9fac404$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $c5448ba1b9fac404$var$getProjectId = async (projectKey)=>{
    const project = await (0, $3ugTQ.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $c5448ba1b9fac404$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$c5448ba1b9fac404$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $c5448ba1b9fac404$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $c5448ba1b9fac404$var$url(projectId, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $c5448ba1b9fac404$var$url(projectKey, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $3ugTQ.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("W6cJS", function(module, exports) {
$parcel$export(module.exports, "getJsmIssueViewSlaPanelResource", () => $00f5fc4bffd7e9ed$export$31e044b40ecfc470);
$parcel$export(module.exports, "useJsmIssueViewSlaPanelResource", () => $00f5fc4bffd7e9ed$export$cc90b63080792845);
$parcel$export(module.exports, "getJsmIssueViewRelatedArticlesResource", () => $00f5fc4bffd7e9ed$export$ae254d90098bb89b);
$parcel$export(module.exports, "useJsmIssueViewRelatedArticlesResource", () => $00f5fc4bffd7e9ed$export$916df522dc3042e5);

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $eq3q8 = parcelRequire("eq3q8");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");


var $5j85B = parcelRequire("5j85B");
const $00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource = (0, $l1VxS.createResource)({
    type: 'JSM_ISSUE_VIEW_SLA_PANEL_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey && (0, $4cTDP.fg)('update_key_of_sla_panel_resource')) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    getData: async ({ match: match }, { tenantContext: tenantContext })=>{
        // ServiceDesk access check is only enforced when jsm-issue-view-sla-panel-high-load-protection fg is enabled,
        // allowing us to restrict access during high load scenarios
        if (!tenantContext.appEditions.serviceDesk && (0, $4cTDP.fg)('jsm-issue-view-sla-panel-high-load-protection')) return null;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey) return null;
        try {
            const url = `/rest/servicedesk/1/servicedesk/sla/issue/${issueKey}`;
            const response = await (0, $hgi0g.default)(url, {
                method: 'GET'
            });
            if (!response.errors) return response;
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error(String(error)),
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    id: 'jsmIssueViewSlaPanelResource',
                    packageName: 'jiraRouterResourcesJsmIssueView',
                    teamName: 'jsd-shield'
                }
            });
        }
        return null;
    }
});
const $00f5fc4bffd7e9ed$export$31e044b40ecfc470 = ()=>$00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource;
const $00f5fc4bffd7e9ed$export$cc90b63080792845 = ()=>{
    return (0, $eJrcF.useResource)($00f5fc4bffd7e9ed$var$jsmIssueViewSlaPanelResource);
};
const $00f5fc4bffd7e9ed$var$jsmIssueViewRelatedArticlesResource = (0, $l1VxS.createResource)({
    type: 'JSM_ISSUE_VIEW_RELATED_ARTICLES_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey && (0, $4cTDP.fg)('update_key_of_sla_panel_resource')) {
            if (query && query.selectedIssue) return query.selectedIssue || '';
        }
        return issueKey || '';
    },
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ],
    getData: async ({ match: match, dependencies: dependencies }, { tenantContext: tenantContext })=>{
        if (!tenantContext.appEditions.serviceDesk) return null;
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        if (!issueKey) return null;
        const consumedDependency = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        if (consumedDependency) {
            const { projectType: projectType } = consumedDependency;
            if (projectType !== 'service_desk') return null;
        }
        if (false) {
            const serverUrl = `/api/issue/${issueKey}/articles`;
            return (0, $hgi0g.default)(serverUrl, {
                method: 'GET',
                headers: {
                    'x-ssr-service-name': 'jsd-apollo',
                    'atl-cloudid': tenantContext.cloudId
                }
            });
        }
        const clientUrl = `/gateway/api/jsd-apollo-stargate/sharded/workspace/${tenantContext.activationId}/api/issue/${issueKey}/articles`;
        return (0, $hgi0g.default)(clientUrl, {
            method: 'GET'
        });
    }
});
const $00f5fc4bffd7e9ed$export$ae254d90098bb89b = ()=>$00f5fc4bffd7e9ed$var$jsmIssueViewRelatedArticlesResource;
const $00f5fc4bffd7e9ed$export$916df522dc3042e5 = ()=>{
    return (0, $eJrcF.useResource)($00f5fc4bffd7e9ed$var$jsmIssueViewRelatedArticlesResource);
};

});

parcelRegister("dQc7D", function(module, exports) {
$parcel$export(module.exports, "issueHideEmptyFieldsDataResource", () => $834a2ef505a079d2$export$a4e9191e8975382d);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3ugTQ = parcelRequire("3ugTQ");
const $834a2ef505a079d2$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $bBtQo.getProjectKey)(match, query);
    return `issue.hide-empty-fields.${projectKey}`;
};
const $834a2ef505a079d2$export$a4e9191e8975382d = (0, $l1VxS.createResource)({
    type: 'ISSUE_HIDE_EMPTY_FIELDS_DATA',
    getKey: $834a2ef505a079d2$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $834a2ef505a079d2$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        return (0, $3ugTQ.performGetRequest)(requestUrl);
    },
    isBrowserOnly: false
});

});

parcelRegister("1FbOO", function(module, exports) {
$parcel$export(module.exports, "issueViewRemoteDataResource", () => $67ef7d8a234ffdb4$export$6942f0cc7b5c5ffd);

var $eq3q8 = parcelRequire("eq3q8");

var $l1VxS = parcelRequire("l1VxS");

var $8BIkE = parcelRequire("8BIkE");
const $67ef7d8a234ffdb4$export$6942f0cc7b5c5ffd = (0, $l1VxS.createResource)({
    type: 'ISSUE_VIEW_REMOTE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $eq3q8.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $8BIkE.default)(...args),
    isBrowserOnly: true
});

});
parcelRegister("8BIkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c25e27746856939e$export$2e2bcd8739ae039);

var $eq3q8 = parcelRequire("eq3q8");

var $8myMV = parcelRequire("8myMV");
const $c25e27746856939e$var$getData = async ({ match: match }, _storeContext)=>{
    const issueKey = (0, $eq3q8.getIssueKey)(match);
    if (!issueKey) return null;
    (0, $8myMV.prefetchedRemoteDataManager).prefetch(issueKey);
    return null;
};
var $c25e27746856939e$export$2e2bcd8739ae039 = $c25e27746856939e$var$getData;

});
parcelRegister("8myMV", function(module, exports) {
$parcel$export(module.exports, "prefetchedRemoteDataManager", () => $dfaa457b025a39dd$export$1d81e79fc6260e6d);

var $04Hi3 = parcelRequire("04Hi3");
class $dfaa457b025a39dd$export$b5a5c1dfc61a5193 {
    prefetch(issueKey) {
        const promise = (0, $04Hi3.fetchIssueViewRemoteData)(issueKey);
        this.cache.set(issueKey, promise);
    }
    getOrFetch(issueKey) {
        if (this.cache.has(issueKey)) return this.cache.get(issueKey);
        const promise = (0, $04Hi3.fetchIssueViewRemoteData)(issueKey);
        this.cache.set(issueKey, promise);
        return promise;
    }
    consume(issueKey) {
        const promise = this.getOrFetch(issueKey);
        this.cache.delete(issueKey);
        return promise;
    }
    constructor(){
        this.cache = new Map();
    }
}
const $dfaa457b025a39dd$export$1d81e79fc6260e6d = new $dfaa457b025a39dd$export$b5a5c1dfc61a5193();

});
parcelRegister("04Hi3", function(module, exports) {
$parcel$export(module.exports, "fetchIssueViewRemoteData", () => $5f7d44e5c1171476$export$35db3378e2f116e4);

var $gyozf = parcelRequire("gyozf");

var $fVpjy = parcelRequire("fVpjy");
const $5f7d44e5c1171476$export$35db3378e2f116e4 = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $gyozf.getIssueRemoteDataQuery)(),
        variables: variables,
        operationName: (0, $gyozf.ISSUE_VIEW_REMOTE_DATA_QUERY)
    };
    const response = await (0, $fVpjy.getClient)().query(payload);
    return response;
};

});
parcelRegister("gyozf", function(module, exports) {
$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $42c1056ef10067ff$export$1a164444721ce2fb);
$parcel$export(module.exports, "ISSUE_VIEW_REMOTE_DATA_QUERY", () => $42c1056ef10067ff$export$2761e7caa26df533);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $42c1056ef10067ff$export$65f9808f978ee25);

var $4cTDP = parcelRequire("4cTDP");
const $42c1056ef10067ff$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $42c1056ef10067ff$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $42c1056ef10067ff$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$42c1056ef10067ff$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $42c1056ef10067ff$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$42c1056ef10067ff$var$getConfluencePagesQueryFragment()}
`;
const $42c1056ef10067ff$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $42c1056ef10067ff$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $42c1056ef10067ff$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$42c1056ef10067ff$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $42c1056ef10067ff$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$42c1056ef10067ff$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$42c1056ef10067ff$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $42c1056ef10067ff$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $42c1056ef10067ff$var$getRemoteDataQueryFragmentOld = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$42c1056ef10067ff$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$42c1056ef10067ff$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$42c1056ef10067ff$export$761fd517f0dda983()}
        ${(0, $4cTDP.fg)('jiv-21221_iv_remote_links_new_field') ? '' : $42c1056ef10067ff$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $42c1056ef10067ff$var$getRemoteDataQueryFragmentNew = ()=>`
	issueId
	remoteLinks {
		isLinkingEnabled
		${$42c1056ef10067ff$export$761fd517f0dda983()}
        ${(0, $4cTDP.fg)('jiv-21221_iv_remote_links_new_field') ? '' : $42c1056ef10067ff$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $42c1056ef10067ff$var$getRemoteDataQueryFragment = ()=>(0, $4cTDP.fg)('jiv_confluence_remote_link_critical_query') ? $42c1056ef10067ff$var$getRemoteDataQueryFragmentNew() : $42c1056ef10067ff$var$getRemoteDataQueryFragmentOld();
const $42c1056ef10067ff$var$getRemoteIssueLinksFragment = ()=>`
	remoteIssueLinks {
		edges {
			node {
				id
				globalId
				title
				relationship
				href
				content {
					__typename
					... on RemoteJiraIssueLinkResultSuccess {
						issueId
						key
						summary
						statusId
						statusName
						statusCategoryId
						isResolved
						issueTypeName
						issueTypeIconUrl
						priorityName
						priorityIconUrl
						assigneeDisplayName
						assigneeAvatarUrl
					}
					... on RemoteJiraIssueLinkResultError {
						errorType
						repairLink
					}
				}
			}
		}
	}
`;
const $42c1056ef10067ff$export$1a164444721ce2fb = ()=>'_remote_data';
const $42c1056ef10067ff$export$2761e7caa26df533 = 'issueViewRemoteDataQuery';
const $42c1056ef10067ff$export$65f9808f978ee25 = ()=>`
    query ${$42c1056ef10067ff$export$2761e7caa26df533}($issueKey: String!) {
        ${$42c1056ef10067ff$var$VIEW_ISSUE_ALIAS}${$42c1056ef10067ff$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$42c1056ef10067ff$var$getRemoteDataQueryFragment()}
			${(0, $4cTDP.fg)('jiv-21221_iv_remote_links_new_field') ? $42c1056ef10067ff$var$getRemoteIssueLinksFragment() : ''}
        }
    }
`;

});

parcelRegister("fVpjy", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $ef8531d5e19bae40$export$6bb76d6eba7e258c);

var $hgi0g = parcelRequire("hgi0g");

var $8DQlA = parcelRequire("8DQlA");
const $ef8531d5e19bae40$var$makeFetchClient = ()=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $hgi0g.default)((0, $8DQlA.getGiraUrl)(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $ef8531d5e19bae40$var$client;
const $ef8531d5e19bae40$export$6bb76d6eba7e258c = ()=>{
    if (!$ef8531d5e19bae40$var$client) $ef8531d5e19bae40$var$client = $ef8531d5e19bae40$var$makeFetchClient();
    return $ef8531d5e19bae40$var$client;
};

});





parcelRegister("38U18", function(module, exports) {
$parcel$export(module.exports, "LazyIssuePage", () => $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $d4115a80200ae1b5$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $d4115a80200ae1b5$export$ef02bcc0eb1d9ded);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $Xckw8 = parcelRequire("Xckw8");

var $bNexr = parcelRequire("bNexr");

var $2aY2d = parcelRequire("2aY2d");

var $kGR8U = parcelRequire("kGR8U");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");
var $2FqDG = parcelRequire("2FqDG");

const $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a = (0, $bQWwW.lazyForPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("CDLPO"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $d4115a80200ae1b5$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d4115a80200ae1b5$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $d4115a80200ae1b5$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const projectKey = (0, $bNexr.useProjectKey)(issueKey || '');
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Xckw8.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4115a80200ae1b5$export$c1a868ace2f38803, null));
};

});
parcelRegister("kGR8U", function(module, exports) {
$parcel$export(module.exports, "markAsBentoBundleReady", () => $393e398983932379$export$d9ff0b3329728986);

var $75yrv = parcelRequire("75yrv");

var $lOI8W = parcelRequire("lOI8W");
let $393e398983932379$var$reportedBentoBundleReady = false;
const $393e398983932379$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($393e398983932379$var$reportedBentoBundleReady) return;
        $393e398983932379$var$reportedBentoBundleReady = true;
        (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $75yrv.JS_EVAL_START))) {
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("CDLPO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("j53wu")
]).then(()=>parcelRequire('5IVSD'));

});



parcelRegister("kNuDg", function(module, exports) {
$parcel$export(module.exports, "browseIssueRouteEntry", () => $11c6470f77b6dcac$export$cef770e7c16cfcc);

var $gEIw2 = parcelRequire("gEIw2");

var $gjPI6 = parcelRequire("gjPI6");

var $3MgfG = parcelRequire("3MgfG");

var $R5dK3 = parcelRequire("R5dK3");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $4cTDP = parcelRequire("4cTDP");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");


var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4VIcO = parcelRequire("4VIcO");

var $dk4qA = parcelRequire("dk4qA");

var $lPVME = parcelRequire("lPVME");

var $9NmsS = parcelRequire("9NmsS");

var $5N1SB = parcelRequire("5N1SB");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $esUDP = parcelRequire("esUDP");

var $iBSnt = parcelRequire("iBSnt");

var $ePaI2 = parcelRequire("ePaI2");

var $5nfTh = parcelRequire("5nfTh");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $W6cJS = parcelRequire("W6cJS");

var $5fjzQ = parcelRequire("5fjzQ");

var $5DQfo = parcelRequire("5DQfo");

var $g8uYY = parcelRequire("g8uYY");

var $gg7cq = parcelRequire("gg7cq");

var $jIhkm = parcelRequire("jIhkm");

var $dQc7D = parcelRequire("dQc7D");

var $1FbOO = parcelRequire("1FbOO");

var $38U18 = parcelRequire("38U18");
const $11c6470f77b6dcac$var$resourcesOld = ()=>[
        ...(0, $9NmsS.getNavigationResources)({
            isUsingSidebarEntrypoint: (0, $4cTDP.fg)('move-issue-view-to-entrypoint')
        }),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dZRaT.projectContextResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $5N1SB.getOfferingCatalogueFeaturesResource)(),
        (0, $lPVME.issueGiraDataResource),
        (0, $dk4qA.issueViewRelayResource),
        (0, $aGQ56.queuesNavigationItems),
        (0, $ePaI2.workspaceResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        ...(0, $5nfTh.getAIContextPanelResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-twc-spotlight-tour-ssr'), (0, $5fjzQ.postOfficeJiraIssueViewTwcSpotlightTourResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('support-getting-customization-using-issue-key'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jiv-21223_issue_view_remote_data_query_earlier'), (0, $1FbOO.issueViewRemoteDataResource))
    ];
// jfp-magma-3491-reorder-issue-view-route-resources - These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const $11c6470f77b6dcac$var$resourcesNew = ()=>[
        (0, $dk4qA.issueViewRelayResource),
        (0, $lPVME.issueGiraDataResource),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        ...(0, $9NmsS.getNavigationResources)({
            isUsingSidebarEntrypoint: (0, $4cTDP.fg)('move-issue-view-to-entrypoint')
        }),
        (0, $dZRaT.projectContextResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        ...(0, $5N1SB.getOfferingCatalogueFeaturesResource)(),
        (0, $aGQ56.queuesNavigationItems),
        (0, $ePaI2.workspaceResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        ...(0, $5nfTh.getAIContextPanelResources)(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('magma-3869-jsm-issue-view-sla-panel-fixes'), (0, $W6cJS.getJsmIssueViewSlaPanelResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('clefairy-12-move-knowledge-base-to-ssr'), (0, $W6cJS.getJsmIssueViewRelatedArticlesResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $jIhkm.issueCollapsibleGroupDataResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ken-3458-jira-hide-empty-field-ssr-fix'), (0, $dQc7D.issueHideEmptyFieldsDataResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-twc-spotlight-tour-ssr'), (0, $5fjzQ.postOfficeJiraIssueViewTwcSpotlightTourResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('support-getting-customization-using-issue-key'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jiv-21223_issue_view_remote_data_query_earlier'), (0, $1FbOO.issueViewRemoteDataResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-3p-attachments'), (0, $gEIw2.thirdPartyConnectedDataSourceResource))
    ];
const $11c6470f77b6dcac$var$entrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gg7cq.issueViewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $11c6470f77b6dcac$export$cef770e7c16cfcc = (0, $6xToB.createEntry)((0, $iBSnt.browseIssueRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        isHydrateRootEnabled: (0, $4cTDP.fg)('jfp-magma-issue-view-full-page-hydrate-root'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $4cTDP.fg)('move-issue-view-to-entrypoint') ? undefined : (0, $38U18.IssueComponent),
        skeleton: (0, $R5dK3.IssueViewSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.fullPageIssuePreloadLayout)),
        navigation: {
            sidebar: (0, $aDtWM.genericProjectSidebars),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $4cTDP.fg)('move-issue-view-to-entrypoint') ? (0, $5RW99.SIDEBAR_ID).CONTENT : undefined,
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: (0, $4cTDP.fg)('jfp-magma-3491-reorder-issue-view-route-resources') ? $11c6470f77b6dcac$var$resourcesNew() : $11c6470f77b6dcac$var$resourcesOld(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $38U18.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
                whichExportToUse: 'browseIssueRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json',
            circuitBreakerConfig: (0, $gjPI6.getIssueCircuitBreaker)()
        },
        supportsPreviewPanel: true,
        entryPoint: (0, $4cTDP.fg)('move-issue-view-to-entrypoint') ? ()=>$11c6470f77b6dcac$var$entrypoint : undefined,
        entryPointOptions: (0, $4cTDP.fg)('jfp-magma-concurrent-entrypoint-router-metric-fix') ? {
            isSSRPlaceholderEnabled: true
        } : undefined
    }));

});
parcelRegister("gjPI6", function(module, exports) {
$parcel$export(module.exports, "getIssueCircuitBreaker", () => $8c97ff53c8b2531a$export$96348e7c42d52e4a);

var $cxKOj = parcelRequire("cxKOj");

var $7oY9g = parcelRequire("7oY9g");
function $8c97ff53c8b2531a$export$96348e7c42d52e4a() {
    return {
        isSetCookieEnabled: true,
        isMonitoringEnabled: true,
        isBailoutEnabled: !(0, $7oY9g.default)('issue-view-cookie-cb'),
        cookieKey: 'iss',
        windowSize: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'windowSize', 5),
        threshold: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'threshold', 0.3),
        keepOpenCount: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'keepOpenCount', 50),
        halfOpenForCount: (0, $cxKOj.expVal)('jfp-magma-ssr-cookie-cb-optimisation', 'halfOpenForCount', 5)
    };
}

});

parcelRegister("lixcc", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $7fe0cfb4720033ae$export$c5a39ebd1638fa7);

var $bBIDB = parcelRequire("bBIDB");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $bBtQo = parcelRequire("bBtQo");

const $7fe0cfb4720033ae$export$c5a39ebd1638fa7 = (0, $3Bzqe.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("iIXZF"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "4c2c284d",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    // Result matches the generics of the async component's EntryPointProps
    // except for TComponentProps which is derived from `root`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded, isOverviewsExpanded: isOverviewsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        let projectKey = '';
        if (context.match.params?.projectKey) projectKey = context.match.params.projectKey;
        else if (context.match.params?.issueKey && (0, $4cTDP.fg)('move-issue-view-to-entrypoint')) projectKey = (0, $bBtQo.getProjectKey)(context.match, context.query);
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $bBIDB.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        isOverviewsExpanded: isOverviewsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`,
                        isAnonymous: tenantContext.isAnonymous
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});

parcelRegister("iIsIs", function(module, exports) {
$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $5a7a9947a97daa9e$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $5a7a9947a97daa9e$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $5a7a9947a97daa9e$export$682dcbf7cc80ba11);

var $6dwgv = parcelRequire("6dwgv");

var $kGR8U = parcelRequire("kGR8U");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");
var $fKdol = parcelRequire("fKdol");

var $1VofM = parcelRequire("1VofM");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$LazyIssuePage = (0, $bQWwW.lazyAfterPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)((parcelRequire("CDLPO"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$AsyncIssueAppComponent = (0, $bQWwW.lazyAfterPaint)(()=>(0, $kGR8U.markAsBentoBundleReady)((parcelRequire("5pAUa"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$IssueModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kwulP")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a7a9947a97daa9e$var$IssueModalContents = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("ccyGQ")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-view.tsx"
});
const $5a7a9947a97daa9e$var$imports = {
    fullPage: ()=>$5a7a9947a97daa9e$var$LazyIssuePage.preload(),
    embedded: ()=>$5a7a9947a97daa9e$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $5a7a9947a97daa9e$var$IssueModal.preload();
            $5a7a9947a97daa9e$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $5a7a9947a97daa9e$var$AsyncIssueAppComponent.preload();
    }
};

const $5a7a9947a97daa9e$var$PrefetchCBBResourcesComponent = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("aoTjy")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $5a7a9947a97daa9e$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $5a7a9947a97daa9e$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $5a7a9947a97daa9e$var$useParamsSelector = (0, $kfvK2.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $5a7a9947a97daa9e$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $fKdol.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $1VofM.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($5a7a9947a97daa9e$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $5a7a9947a97daa9e$var$FullPageIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('fullPage', $5a7a9947a97daa9e$var$imports.fullPage);
$5a7a9947a97daa9e$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $5a7a9947a97daa9e$export$98e337c40eb151da = (0, $6dwgv.createLayout)({
    globalComponents: [
        $5a7a9947a97daa9e$var$FullPageIssuePreloadComponent,
        $5a7a9947a97daa9e$var$PrefetchCBBResourcesComponent
    ]
});
const $5a7a9947a97daa9e$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('embedded', $5a7a9947a97daa9e$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $6dwgv.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $5a7a9947a97daa9e$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $5a7a9947a97daa9e$var$IssuePreloadComponentBuilder('pageLoad', ()=>$5a7a9947a97daa9e$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $6dwgv.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("1VofM", function(module, exports) {
$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $7af7e490b4f39bb6$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $7af7e490b4f39bb6$var$serverIssuePreloadIdentifier = '';
const $7af7e490b4f39bb6$export$d2077b3b0eac1c19 = (identifier)=>{
    $7af7e490b4f39bb6$var$serverIssuePreloadIdentifier = identifier;
};
const $7af7e490b4f39bb6$export$f55e6973062dc859 = ()=>$7af7e490b4f39bb6$var$serverIssuePreloadIdentifier;

});

parcelRegister("5pAUa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lDuOD")
]).then(()=>parcelRequire('kq6nk'));

});

parcelRegister("kwulP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("77kn1")
]).then(()=>parcelRequire('igA3X'));

});

parcelRegister("ccyGQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kL3jN")
]).then(()=>parcelRequire('hSwWh'));

});

parcelRegister("aoTjy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ajKPE").then(()=>parcelRequire('3Eb0P'));

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $aa97a50ba70be130$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $aa97a50ba70be130$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("aDtWM", function(module, exports) {
$parcel$export(module.exports, "genericProjectSidebars", () => $2441c7e576639e68$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $2441c7e576639e68$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $2441c7e576639e68$export$844d342b575ead35);

var $7zL9d = parcelRequire("7zL9d");

var $hiOwQ = parcelRequire("hiOwQ");

var $gKFn0 = parcelRequire("gKFn0");

var $2nHUF = parcelRequire("2nHUF");

var $gHEJe = parcelRequire("gHEJe");

var $1f2LE = parcelRequire("1f2LE");

var $k6duF = parcelRequire("k6duF");

var $3V6se = parcelRequire("3V6se");
const $2441c7e576639e68$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $hiOwQ.default),
    (0, $gHEJe.default),
    (0, $1f2LE.default),
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$c04daf123cec1f1e = [
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$844d342b575ead35 = [
    ...$2441c7e576639e68$export$d88d2d25355bc89a,
    (0, $7zL9d.default),
    (0, $gKFn0.default),
    (0, $2nHUF.default)
];

});
parcelRegister("7zL9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5ca43a7cc265a55$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $d5ca43a7cc265a55$var$LazyConnectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("drZbH")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
const $d5ca43a7cc265a55$var$ConnectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5ca43a7cc265a55$var$LazyConnectSidebar, null)));
$d5ca43a7cc265a55$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $d5ca43a7cc265a55$export$2e2bcd8739ae039 = $d5ca43a7cc265a55$var$ConnectSidebar;

});
parcelRegister("drZbH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dPMOS").then(()=>parcelRequire('9zsf7'));

});


parcelRegister("3V6se", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3a532df6c151ee1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $a3a532df6c151ee1$var$LazyUserSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("iZKOz")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
const $a3a532df6c151ee1$var$UserSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3a532df6c151ee1$var$LazyUserSidebar, null)));
$a3a532df6c151ee1$var$UserSidebar.displayName = 'UserSidebar';
var $a3a532df6c151ee1$export$2e2bcd8739ae039 = $a3a532df6c151ee1$var$UserSidebar;

});
parcelRegister("iZKOz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("8aAWx")
]).then(()=>parcelRequire('2uIzr'));

});



parcelRegister("5N1SB", function(module, exports) {
$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $5c6a39299c71dc02$export$d08a9fee651d30b2);

var $l1VxS = parcelRequire("l1VxS");


const $5c6a39299c71dc02$var$getDataLoader = ()=>(parcelRequire("7NR9p"));
const $5c6a39299c71dc02$export$ec991c565cf31550 = (0, $l1VxS.createResource)({
    type: (0, $b9e6117892e37693$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $5c6a39299c71dc02$var$getDataLoader,
    maxAge: 1800000
});
const $5c6a39299c71dc02$export$d08a9fee651d30b2 = ()=>[];

});
const $b9e6117892e37693$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("7NR9p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lRIym").then(()=>parcelRequire('AFoLQ'));

});


parcelRegister("iBSnt", function(module, exports) {
$parcel$export(module.exports, "browseIssueRoute", () => $c940aca0110ccf9d$export$2c9c7e50a88e588b);
const $c940aca0110ccf9d$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});

parcelRegister("gg7cq", function(module, exports) {
$parcel$export(module.exports, "issueViewEntryPoint", () => $1de729576f8b4bee$export$c9f081604fc01386);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $1de729576f8b4bee$export$c9f081604fc01386 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("exCPM")), {
        moduleId: "babc18a5",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("exCPM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("kNFvF"),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("kmTsB")
]).then(()=>parcelRequire('c3cIq'));

});



parcelRegister("XhYcm", function(module, exports) {
$parcel$export(module.exports, "browseProjectRedirectRouteEntry", () => $95c7eb7b4bd8a104$export$f9891419b34ab305);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $d3wpJ = parcelRequire("d3wpJ");

var $hoV2u = parcelRequire("hoV2u");
const $95c7eb7b4bd8a104$export$f9891419b34ab305 = (0, $6xToB.createEntry)((0, $d3wpJ.browseProjectRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $aGQ56.queuesNavigationItems),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-browse-project-entries/src/browseProjectRedirectRouteEntry.tsx',
                whichExportToUse: 'browseProjectRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hoV2u", function(module, exports) {
$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $40ea509ff5827a8e$export$86041af020f4c959);

var $eJOHy = parcelRequire("eJOHy");

var $gRw5p = parcelRequire("gRw5p");
const $40ea509ff5827a8e$export$86041af020f4c959 = ()=>// @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRw5p.default), null);

});
parcelRegister("gRw5p", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff232445e6bd88e3$export$2e2bcd8739ae039);

var $jJaSe = parcelRequire("jJaSe");

var $ddFsg = parcelRequire("ddFsg");
var $ff232445e6bd88e3$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)((0, $ddFsg.default));

});
parcelRegister("ddFsg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f73f830b21aa26d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $b5RwB = parcelRequire("b5RwB");

var $dLR8J = parcelRequire("dLR8J");

var $75yrv = parcelRequire("75yrv");

var $662Y6 = parcelRequire("662Y6");

var $aYncF = parcelRequire("aYncF");

var $eSnSE = parcelRequire("eSnSE");

var $hgi0g = parcelRequire("hgi0g");

var $4cTDP = parcelRequire("4cTDP");


var $jwGf7 = parcelRequire("jwGf7");
const $0f73f830b21aa26d$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $0f73f830b21aa26d$var$allowListedSearchParams = [
    (0, $4b966049ad0c2037$export$29d3926e3d72cfb),
    (0, $4b966049ad0c2037$export$b3233b76460c1e7c)
];
const $0f73f830b21aa26d$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/${(0, $4cTDP.fg)('jira_list_nin_merge') ? 'list' : 'issues'}/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $jwGf7.getNow)() - startTime,
        destination: destination
    });
};
const $0f73f830b21aa26d$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$0f73f830b21aa26d$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $4b966049ad0c2037$export$29d3926e3d72cfb))));
const $0f73f830b21aa26d$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $0f73f830b21aa26d$export$bf8d1fdc3b47a835 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $662Y6.default)((0, $75yrv.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $jwGf7.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), 'queryString', {
            duration: (0, $jwGf7.getNow)() - startTime
        });
        if (projectKey) (0, $hgi0g.default)($0f73f830b21aa26d$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $jwGf7.getNow)();
            let searchQueryParams = '';
            const searchQuery = $0f73f830b21aa26d$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $0f73f830b21aa26d$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $jwGf7.getNow)();
            if ((0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $0f73f830b21aa26d$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $4b966049ad0c2037$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $0f73f830b21aa26d$export$2e2bcd8739ae039 = $0f73f830b21aa26d$export$bf8d1fdc3b47a835;

});
const $4b966049ad0c2037$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $4b966049ad0c2037$export$29d3926e3d72cfb = 'search';
const $4b966049ad0c2037$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("jwGf7", function(module, exports) {
$parcel$export(module.exports, "getNow", () => $9dd4f64bbee985ad$export$3991332aae1fc754);
const $9dd4f64bbee985ad$export$3991332aae1fc754 = ()=>Date.now();

});





parcelRegister("4OGAK", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsRouteEntry", () => $7a43dbcf0e5e3085$export$6a572c5bc9ffe9da);

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3EnHO = parcelRequire("3EnHO");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $eISG1 = parcelRequire("eISG1");

var $eVtuK = parcelRequire("eVtuK");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $7a43dbcf0e5e3085$var$browseStandardFlowsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eVtuK.browseStandardFlowsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $7a43dbcf0e5e3085$export$6a572c5bc9ffe9da = (0, $6xToB.createEntry)((0, $3EnHO.browseStandardFlowsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $7a43dbcf0e5e3085$var$browseStandardFlowsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $eISG1.VirtualAgentBrowseStandardFlowsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/browseStandardFlowsRouteEntry.tsx',
                whichExportToUse: 'browseStandardFlowsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eISG1", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", () => $66ba91899626e548$export$c2bd83dd149452bd);
/* VirtualAgentBrowseStandardFlowsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $9QY3M = parcelRequire("9QY3M");
const $66ba91899626e548$var$customCssStyles = null;
const $66ba91899626e548$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9QY3M))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("9QY3M", function(module, exports) {
module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();

});


parcelRegister("eVtuK", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsEntryPoint", () => $ad83053115311bde$export$f7de8593c7455f1);

var $gvWdq = parcelRequire("gvWdq");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ad83053115311bde$export$f7de8593c7455f1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9Gs2s")), {
        moduleId: "33e26da4",
        moduleName: "VirtualAgentBrowseStandardFlows",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $gvWdq.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("gvWdq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d90c979622e506c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6db52fd104d7da7ffa3b910542d9d2da>>
 * @relayHash 4ba16a2c2f890e419fe37c98bdbcae4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50d97b2346bbe48db70feade386d140eeb43d66cda98dde0df5e5cea9b0d7bbd

var $bXR9c = parcelRequire("bXR9c");
const $d90c979622e506c1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50d97b2346bbe48db70feade386d140eeb43d66cda98dde0df5e5cea9b0d7bbd",
        "metadata": {},
        "name": "VirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $d90c979622e506c1$export$2e2bcd8739ae039 = $d90c979622e506c1$var$node;

});

parcelRegister("9Gs2s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lRoZt").then(()=>parcelRequire('a1RAT'));

});



parcelRegister("5wrsY", function(module, exports) {
$parcel$export(module.exports, "classicBusinessOverviewCalendarRouteEntry", () => $fb28cd738dfd724d$export$93f05037a457ce22);

var $gYW18 = parcelRequire("gYW18");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $eOm20 = parcelRequire("eOm20");

var $g8uYY = parcelRequire("g8uYY");

var $79780 = parcelRequire("79780");
const $fb28cd738dfd724d$var$overviewCalendarPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $79780.overviewCalendarEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $fb28cd738dfd724d$export$93f05037a457ce22 = (0, $6xToB.createEntry)((0, $eOm20.classicBusinessOverviewCalendarRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        entryPoint: ()=>$fb28cd738dfd724d$var$overviewCalendarPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessOverviewCalendarRouteEntry.tsx',
                whichExportToUse: 'classicBusinessOverviewCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kNM5Y", function(module, exports) {
$parcel$export(module.exports, "ThemedLazySkeleton", () => $ec1b330c87eff4aa$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $5W8uM = parcelRequire("5W8uM");
const $ec1b330c87eff4aa$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec1b330c87eff4aa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5W8uM.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec1b330c87eff4aa$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5W8uM", function(module, exports) {
$parcel$export(module.exports, "ThemedSpinner", () => $c8343f1bb6fa5b40$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $c8343f1bb6fa5b40$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8343f1bb6fa5b40$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large",
        ...props,
        testId: "project-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8343f1bb6fa5b40$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1xjgvy9e",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eOm20", function(module, exports) {
$parcel$export(module.exports, "classicBusinessOverviewCalendarRoute", () => $ef2c059f9016923a$export$61383e5418d2ffe3);
const $ef2c059f9016923a$export$61383e5418d2ffe3 = {
    name: 'classic-business-overview-calendar',
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};

});

parcelRegister("79780", function(module, exports) {
$parcel$export(module.exports, "overviewCalendarEntrypoint", () => $39dc7de5f53ab200$export$b7094a9bdb66fbad);

var $hu2rE = parcelRequire("hu2rE");

var $1XFDQ = parcelRequire("1XFDQ");

var $3Bzqe = parcelRequire("3Bzqe");

const $39dc7de5f53ab200$export$b7094a9bdb66fbad = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("kQEk9")), {
        moduleId: "a9cf6a8e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewCalendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1XFDQ.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("1XFDQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $80276688aa16f701$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c59e3d9fe824c793d8469a9e8be7dc1e>>
 * @relayHash c97066ea9133e252df98e2a71427ae7f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2fb876a7e3dc7853483baab5b740175f5f9ee911bca5bb40564c8664dd6cf30
const $80276688aa16f701$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d2fb876a7e3dc7853483baab5b740175f5f9ee911bca5bb40564c8664dd6cf30",
        "metadata": {},
        "name": "src_jiraBusinessOverviewCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $80276688aa16f701$export$2e2bcd8739ae039 = $80276688aa16f701$var$node;

});

parcelRegister("kQEk9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5QVH4").then(()=>parcelRequire('dlAu1'));

});



parcelRegister("e2Odp", function(module, exports) {
$parcel$export(module.exports, "classicBusinessOverviewSummaryRouteEntry", () => $3bece96b55464b81$export$f8fd32e123428b9a);

var $gYW18 = parcelRequire("gYW18");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $2OYGO = parcelRequire("2OYGO");

var $g8uYY = parcelRequire("g8uYY");

var $aRMaG = parcelRequire("aRMaG");
const $3bece96b55464b81$var$overviewSummaryPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aRMaG.overviewSummaryEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $3bece96b55464b81$export$f8fd32e123428b9a = (0, $6xToB.createEntry)((0, $2OYGO.classicBusinessOverviewSummaryRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        entryPoint: ()=>$3bece96b55464b81$var$overviewSummaryPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessOverviewSummaryRouteEntry.tsx',
                whichExportToUse: 'classicBusinessOverviewSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2OYGO", function(module, exports) {
$parcel$export(module.exports, "classicBusinessOverviewSummaryRoute", () => $117c4ec1004ed79c$export$4a86e6b12ce49af9);
const $117c4ec1004ed79c$export$4a86e6b12ce49af9 = {
    name: 'classic-business-overview-summary',
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};

});

parcelRegister("aRMaG", function(module, exports) {
$parcel$export(module.exports, "overviewSummaryEntrypoint", () => $e51790e51bf8df9e$export$3793bbcc33b62692);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $e51790e51bf8df9e$export$3793bbcc33b62692 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("gbFzj")), {
        moduleId: "5d9f07b1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gbFzj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1vgvL").then(()=>parcelRequire('3Ehcx'));

});



parcelRegister("djb2Z", function(module, exports) {
$parcel$export(module.exports, "classicBusinessOverviewTimelineRouteEntry", () => $7c693fbc4b9d58b9$export$9d9d562e489097b3);

var $gYW18 = parcelRequire("gYW18");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $2LUyM = parcelRequire("2LUyM");

var $g8uYY = parcelRequire("g8uYY");

var $42uQ3 = parcelRequire("42uQ3");
const $7c693fbc4b9d58b9$var$overviewTimelinePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $42uQ3.overviewTimelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $7c693fbc4b9d58b9$export$9d9d562e489097b3 = (0, $6xToB.createEntry)((0, $2LUyM.classicBusinessOverviewTimelineRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        entryPoint: ()=>$7c693fbc4b9d58b9$var$overviewTimelinePageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessOverviewTimelineRouteEntry.tsx',
                whichExportToUse: 'classicBusinessOverviewTimelineRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2LUyM", function(module, exports) {
$parcel$export(module.exports, "classicBusinessOverviewTimelineRoute", () => $175c945c42633bbd$export$13f0c823ff3059c2);
const $175c945c42633bbd$export$13f0c823ff3059c2 = {
    name: 'classic-business-overview-timeline',
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};

});

parcelRegister("42uQ3", function(module, exports) {
$parcel$export(module.exports, "overviewTimelineEntrypoint", () => $4bb940a33304beb0$export$d00505893f9d5d11);

var $hu2rE = parcelRequire("hu2rE");

var $1LpQp = parcelRequire("1LpQp");

var $3Bzqe = parcelRequire("3Bzqe");

const $4bb940a33304beb0$export$d00505893f9d5d11 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("57uac")), {
        moduleId: "ae6650bb",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1LpQp.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("1LpQp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d79ea349716da08d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb4ae6aae065c938f532a846255332dc>>
 * @relayHash 007933a1073bb512097f0e95cf95622d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807
const $d79ea349716da08d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807",
        "metadata": {},
        "name": "src_jiraBusinessOverviewTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d79ea349716da08d$export$2e2bcd8739ae039 = $d79ea349716da08d$var$node;

});

parcelRegister("57uac", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gfs7N")
]).then(()=>parcelRequire('bqTTp'));

});



parcelRegister("5xUFr", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRouteEntry", () => $01226d0edbbe6b2a$export$99ff9a6f448db95c);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $fXAjm = parcelRequire("fXAjm");

var $kWsG7 = parcelRequire("kWsG7");
const $01226d0edbbe6b2a$export$99ff9a6f448db95c = (0, $6xToB.createEntry)((0, $fXAjm.classicBusinessProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-business',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        component: (0, $kWsG7.default),
        forPaint: [
            (0, $kWsG7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/classicBusinessProformaIssueFormsDirectEmbedRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProformaIssueFormsDirectEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fXAjm", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRoute", () => $27fe20fca7f8a858$export$92c0120052644a60);
const $27fe20fca7f8a858$export$92c0120052644a60 = {
    name: 'classic-business-proforma-issue-forms-direct-embed',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("kWsG7", function(module, exports) {
$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $96411853c866acc6$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $96411853c866acc6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $96411853c866acc6$export$22681210aaeb910f = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eEKFl")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
const $96411853c866acc6$var$AsyncProformaIssueFormsDirectEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $96411853c866acc6$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });
var $96411853c866acc6$export$2e2bcd8739ae039 = $96411853c866acc6$var$AsyncProformaIssueFormsDirectEmbed;

});
parcelRegister("eEKFl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4h6Er").then(()=>parcelRequire('3oO3p'));

});



parcelRegister("45FXR", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRouteEntry", () => $84dab78aea9489c9$export$8aa48763ac761f64);

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $7Ypiw = parcelRequire("7Ypiw");

var $d017r = parcelRequire("d017r");
const $84dab78aea9489c9$export$8aa48763ac761f64 = (0, $6xToB.createEntry)((0, $7Ypiw.classicBusinessProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-business',
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $d017r.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/classicBusinessProformaIssueFormsDirectRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProformaIssueFormsDirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7Ypiw", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRoute", () => $6a9b89485b8d2901$export$97a413d49241d03b);
const $6a9b89485b8d2901$export$97a413d49241d03b = {
    name: 'classic-business-proforma-issue-forms-direct',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("d017r", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $fbe6c0c8c54a20c4$export$dc0bb5719ae7aab4);

var $cZ31R = parcelRequire("cZ31R");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $fbe6c0c8c54a20c4$export$dc0bb5719ae7aab4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cZ31R.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("cZ31R", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsDirectEntryPoint", () => $0a4aa1cdbbc0e1e2$export$2a51bba458da5928);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $0a4aa1cdbbc0e1e2$export$2a51bba458da5928 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("annSp")), {
        moduleId: "3047b51f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("annSp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dQaGo").then(()=>parcelRequire('fyq5j'));

});




parcelRegister("d5FsU", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectApprovalsRouteEntry", () => $97c9869878e57b7f$export$563b4fef899fe540);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $iOObx = parcelRequire("iOObx");

var $8cU7c = parcelRequire("8cU7c");
const $97c9869878e57b7f$export$563b4fef899fe540 = (0, $6xToB.createEntry)((0, $iOObx.classicBusinessProjectApprovalsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.approvals-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $8cU7c.approvalsPageEntryPoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectApprovalsRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectApprovalsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9eXLI", function(module, exports) {
$parcel$export(module.exports, "businessProjectLayout", () => $a75bb44e672a49d0$export$dfb0c3e0348f4429);

var $FhXEJ = parcelRequire("FhXEJ");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a75bb44e672a49d0$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kVMQd")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a75bb44e672a49d0$var$withAnyBusinessProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $FhXEJ.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a75bb44e672a49d0$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1P2R1")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $a75bb44e672a49d0$var$BusinessOnboarding = $a75bb44e672a49d0$var$withAnyBusinessProjectContext($a75bb44e672a49d0$var$Onboarding);
const $a75bb44e672a49d0$var$nonSettingsRightSidebars = [
    $a75bb44e672a49d0$var$withAnyBusinessProjectContext($a75bb44e672a49d0$var$RightSidebars)
];
const $a75bb44e672a49d0$var$sharedBusinessProjectLayout = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));
const $a75bb44e672a49d0$export$dfb0c3e0348f4429 = (0, $6dwgv.composeLayouts)($a75bb44e672a49d0$var$sharedBusinessProjectLayout, {
    rightSidebars: $a75bb44e672a49d0$var$nonSettingsRightSidebars,
    globalComponents: [
        $a75bb44e672a49d0$var$BusinessOnboarding
    ]
});

});
parcelRegister("kVMQd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c8IeZ").then(()=>parcelRequire('kLLtw'));

});

parcelRegister("1P2R1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aquCq").then(()=>parcelRequire('5w7vf'));

});


parcelRegister("iOObx", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", () => $ed0e8d46d045ddef$export$3109a183a442a02d);
const $ed0e8d46d045ddef$export$3109a183a442a02d = {
    name: 'classic-business-approvals',
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};

});

parcelRegister("8cU7c", function(module, exports) {
$parcel$export(module.exports, "approvalsPageEntryPoint", () => $5963acd66baa2380$export$52c40d37705be5fa);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1EVxe = parcelRequire("1EVxe");

var $9n5I0 = parcelRequire("9n5I0");
const $5963acd66baa2380$export$52c40d37705be5fa = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1EVxe.approvalsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1EVxe", function(module, exports) {
$parcel$export(module.exports, "approvalsEntryPoint", () => $85218c7331be8151$export$25d4a03de93a440e);

var $k56g6 = parcelRequire("k56g6");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $85218c7331be8151$export$25d4a03de93a440e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bGVpL")), {
        moduleId: "6a9ba200",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $k56g6.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("k56g6", function(module, exports) {
$parcel$export(module.exports, "default", () => $f89f660ffc3727a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6e2d903d7a5160ec3c02b7156848e4>>
 * @relayHash 2cc1b2be473185de0346970d79002539
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d
const $f89f660ffc3727a4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f89f660ffc3727a4$export$2e2bcd8739ae039 = $f89f660ffc3727a4$var$node;

});

parcelRegister("bGVpL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dJuok").then(()=>parcelRequire('jLqzd'));

});




parcelRegister("7kn5P", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormBuilderRouteEntry", () => $772001a4b0ae12c3$export$9eb15893d080e73b);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $egjvs = parcelRequire("egjvs");

var $7OdQF = parcelRequire("7OdQF");
const $772001a4b0ae12c3$export$9eb15893d080e73b = (0, $6xToB.createEntry)((0, $egjvs.classicBusinessProjectFormBuilderRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $7OdQF.formBuilderPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormBuilderRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectFormBuilderRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("egjvs", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", () => $795ebdbfaac46826$export$5f684808e671de5);
const $795ebdbfaac46826$export$5f684808e671de5 = {
    name: 'classic-business-form-builder',
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("7OdQF", function(module, exports) {
$parcel$export(module.exports, "formBuilderPageEntrypoint", () => $558f9be903d7366a$export$e0f4bcb9440be5eb);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $72lHW = parcelRequire("72lHW");

var $9n5I0 = parcelRequire("9n5I0");
const $558f9be903d7366a$export$e0f4bcb9440be5eb = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $72lHW.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("72lHW", function(module, exports) {
$parcel$export(module.exports, "formBuilderEntrypoint", () => $7dc7812464505771$export$6d3c9fa7232f412c);

var $lPQ1p = parcelRequire("lPQ1p");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7dc7812464505771$export$6d3c9fa7232f412c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("j04xZ")), {
        moduleId: "86254720",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lPQ1p.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("lPQ1p", function(module, exports) {
$parcel$export(module.exports, "default", () => $de92a6254e122590$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4e5285cf738fae5658c117e04609239>>
 * @relayHash d97c7a633d846788784b53e47412dba2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5
const $de92a6254e122590$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5",
        "metadata": {},
        "name": "src_jiraBusinessFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $de92a6254e122590$export$2e2bcd8739ae039 = $de92a6254e122590$var$node;

});

parcelRegister("j04xZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bkNxq").then(()=>parcelRequire('fuuku'));

});




parcelRegister("gjSfP", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormRouteEntry", () => $50806d420907d462$export$4798edf139084d2e);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $60Tyc = parcelRequire("60Tyc");

var $6Kytx = parcelRequire("6Kytx");
const $50806d420907d462$export$4798edf139084d2e = (0, $6xToB.createEntry)((0, $60Tyc.classicBusinessProjectFormRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-directory-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $6Kytx.formPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectFormRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("60Tyc", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormRoute", () => $13307bc2c963621c$export$e98776bdf96c88ac);
const $13307bc2c963621c$export$e98776bdf96c88ac = {
    name: 'classic-business-form',
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("6Kytx", function(module, exports) {
$parcel$export(module.exports, "formPageEntrypoint", () => $bab61c24a59d2af5$export$ebaf30a031a61671);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bjASA = parcelRequire("bjASA");

var $9n5I0 = parcelRequire("9n5I0");
const $bab61c24a59d2af5$export$ebaf30a031a61671 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bjASA.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("bjASA", function(module, exports) {
$parcel$export(module.exports, "formEntrypoint", () => $130bb9c1c43479e6$export$b931eb60522f687a);

var $c4u59 = parcelRequire("c4u59");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $130bb9c1c43479e6$export$b931eb60522f687a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("btjrK")), {
        moduleId: "77eafb5a",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $c4u59.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("c4u59", function(module, exports) {
$parcel$export(module.exports, "default", () => $6add814bcfcd5ee1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f62e7b05d75adf93c826705d7992eb93>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b
const $6add814bcfcd5ee1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
        "metadata": {},
        "name": "src_jiraBusinessFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6add814bcfcd5ee1$export$2e2bcd8739ae039 = $6add814bcfcd5ee1$var$node;

});

parcelRegister("btjrK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lyYgq").then(()=>parcelRequire('5jeMe'));

});




parcelRegister("7aHwj", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRouteEntry", () => $86e3e3c8becfd242$export$c2f698be6eedea1a);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $53Dto = parcelRequire("53Dto");

var $iDG9N = parcelRequire("iDG9N");
const $86e3e3c8becfd242$export$c2f698be6eedea1a = (0, $6xToB.createEntry)((0, $53Dto.classicBusinessProjectFormSubmitEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-embed-view',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $iDG9N.formSubmitEmbedPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormSubmitEmbedRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectFormSubmitEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("53Dto", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", () => $2ea26d09f435f720$export$7e8fd15fdfa29385);
const $2ea26d09f435f720$export$7e8fd15fdfa29385 = {
    name: 'classic-business-form-submit-embed',
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("iDG9N", function(module, exports) {
$parcel$export(module.exports, "formSubmitEmbedPageEntrypoint", () => $4c19060df61babf6$export$93f08d580854f4a7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bHYrQ = parcelRequire("bHYrQ");

var $9n5I0 = parcelRequire("9n5I0");
const $4c19060df61babf6$export$93f08d580854f4a7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bHYrQ.formSubmitEmbedEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bHYrQ", function(module, exports) {
$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $e947ff29e30a76d3$export$4c748d8ca82fc24);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $e947ff29e30a76d3$export$4c748d8ca82fc24 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hqnQH")), {
        moduleId: "20838510",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hqnQH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kh3N2").then(()=>parcelRequire('g1kwn'));

});




parcelRegister("hULAZ", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRouteEntry", () => $fc17e73a43fddbd9$export$69d2365670c516de);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $i6nt0 = parcelRequire("i6nt0");

var $cxKOj = parcelRequire("cxKOj");

var $kSeQy = parcelRequire("kSeQy");

var $cxQGT = parcelRequire("cxQGT");

var $7TTbh = parcelRequire("7TTbh");
const $fc17e73a43fddbd9$export$69d2365670c516de = (0, $6xToB.createEntry)((0, $i6nt0.classicBusinessProjectFormSubmitPublicRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-public-view',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        // This public route should not include
        // DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
        // remove all usages of projectKey.
        entryPoint: ()=>(0, $cxKOj.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $7TTbh.formSubmitPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormSubmitPublicRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectFormSubmitPublicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("i6nt0", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRoute", () => $a76d25dcffedf4b2$export$865063615075df54);
const $a76d25dcffedf4b2$export$865063615075df54 = {
    name: 'classic-business-form-submit-public',
    path: '/jira/core/form/:formUuid',
    exact: true
};

});

parcelRegister("kSeQy", function(module, exports) {
$parcel$export(module.exports, "notFoundPageEntrypoint", () => $cb15b80ff801a631$export$eb748b014da0ac9a);
// eslint-disable-next-line jira/import/file-extension-required

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8sJsy = parcelRequire("8sJsy");
const $cb15b80ff801a631$export$eb748b014da0ac9a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8sJsy.notFoundEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HOME
});

});
parcelRegister("8sJsy", function(module, exports) {
$parcel$export(module.exports, "notFoundEntrypoint", () => $8ba65e49059e1a00$export$7fdee4826a30b643);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $8ba65e49059e1a00$export$7fdee4826a30b643 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3xPh7")), {
        moduleId: "4e8af128",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("7TTbh", function(module, exports) {
$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $79cfcf554dce6749$export$26755d0805847061);

var $g8uYY = parcelRequire("g8uYY");

var $aiuBl = parcelRequire("aiuBl");
const $79cfcf554dce6749$export$26755d0805847061 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $aiuBl.formSubmitPublicEntrypoint)
});

});
parcelRegister("aiuBl", function(module, exports) {
$parcel$export(module.exports, "formSubmitPublicEntrypoint", () => $43158b9e29901a2d$export$345530940ab03dbd);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $43158b9e29901a2d$export$345530940ab03dbd = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("i7bQH")), {
        moduleId: "d418c43d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i7bQH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1K0CS").then(()=>parcelRequire('8JOz7'));

});




parcelRegister("8WHEn", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitRouteEntry", () => $e3062b13f5c4ec14$export$bd59a50eb595d1d5);

var $hS1gr = parcelRequire("hS1gr");

var $7K5Ea = parcelRequire("7K5Ea");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $ebtn8 = parcelRequire("ebtn8");

var $f1dLp = parcelRequire("f1dLp");
const $e3062b13f5c4ec14$export$bd59a50eb595d1d5 = (0, $6xToB.createEntry)((0, $ebtn8.classicBusinessProjectFormSubmitRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-view',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $f1dLp.formSubmitPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormSubmitRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectFormSubmitRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ebtn8", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", () => $f2b1b6e109621185$export$3cd93ff55b29f07f);
const $f2b1b6e109621185$export$3cd93ff55b29f07f = {
    name: 'classic-business-form-submit',
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("f1dLp", function(module, exports) {
$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $385bcb6f7896c37e$export$26755d0805847061);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5te9m = parcelRequire("5te9m");
const $385bcb6f7896c37e$export$26755d0805847061 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5te9m.formSubmitEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("5te9m", function(module, exports) {
$parcel$export(module.exports, "formSubmitEntrypoint", () => $4fd3364aa5cb94f8$export$d33b8db02e0a0cb5);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $4fd3364aa5cb94f8$export$d33b8db02e0a0cb5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2lqq5")), {
        moduleId: "1cf8636b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2lqq5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Z0Ia").then(()=>parcelRequire('1Hqud'));

});




parcelRegister("6BJfU", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectPagesRouteEntry", () => $74648e4549871877$export$7a55e12f93813823);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8peAk = parcelRequire("8peAk");

var $85ovz = parcelRequire("85ovz");
const $74648e4549871877$export$7a55e12f93813823 = (0, $6xToB.createEntry)((0, $8peAk.classicBusinessProjectPagesRoute), ()=>({
        group: 'classic-business',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource)
        ],
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        ufoName: 'jwm.jwm-pages',
        entryPoint: ()=>(0, $85ovz.pagesPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectPagesRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectPagesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8peAk", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectPagesRoute", () => $b0c7ef728c8097cb$export$573cc697c2d33124);
const $b0c7ef728c8097cb$export$573cc697c2d33124 = {
    name: 'project-pages',
    path: '/jira/core/projects/:projectKey/pages'
};

});

parcelRegister("85ovz", function(module, exports) {
$parcel$export(module.exports, "pagesPageEntrypoint", () => $662e5e2ed89db107$export$4ce394de88f5b54a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $GG9qq = parcelRequire("GG9qq");

var $9n5I0 = parcelRequire("9n5I0");
const $662e5e2ed89db107$export$4ce394de88f5b54a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $GG9qq.pagesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("GG9qq", function(module, exports) {
$parcel$export(module.exports, "pagesEntrypoint", () => $aa73c40e6977a190$export$49834d404673808c);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $aa73c40e6977a190$export$49834d404673808c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("62hBp")), {
        moduleId: "671532d1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("62hBp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iaIlg").then(()=>parcelRequire('el8fJ'));

});




parcelRegister("a7Dk4", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectShortcutRouteEntry", () => $ae7b8140c354f3c9$export$22248cc626626132);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $kpeaX = parcelRequire("kpeaX");

var $1dclZ = parcelRequire("1dclZ");
const $ae7b8140c354f3c9$export$22248cc626626132 = (0, $6xToB.createEntry)((0, $kpeaX.classicBusinessProjectShortcutRoute), ()=>({
        group: 'classic-business',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $1dclZ.shortcutsPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectShortcutRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectShortcutRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kpeaX", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectShortcutRoute", () => $ea7011af4881196b$export$2dd4e8a37d8ac978);
const $ea7011af4881196b$export$2dd4e8a37d8ac978 = {
    name: 'classic-business-shortcut',
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};

});

parcelRegister("1dclZ", function(module, exports) {
$parcel$export(module.exports, "shortcutsPageEntrypoint", () => $0f7792905aa1bcd2$export$57a2f1af23fcbb8b);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hLAWj = parcelRequire("hLAWj");

var $9n5I0 = parcelRequire("9n5I0");
const $0f7792905aa1bcd2$export$57a2f1af23fcbb8b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $hLAWj.shortcutsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("hLAWj", function(module, exports) {
$parcel$export(module.exports, "shortcutsEntrypoint", () => $74cc8127d1f5bbb4$export$212fd76838eeb6ad);

var $78bHS = parcelRequire("78bHS");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $74cc8127d1f5bbb4$export$212fd76838eeb6ad = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("kGoH8")), {
        moduleId: "736f6fc2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                shortcutsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $78bHS.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("78bHS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e447bfa04dd0b5f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<571227a0b71f1eebd07db7bde4b71b10>>
 * @relayHash f251714abaead8d7f256f75b2cbcdd4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e
const $e447bfa04dd0b5f8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e",
        "metadata": {},
        "name": "src_jiraBusinessShortcutsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e447bfa04dd0b5f8$export$2e2bcd8739ae039 = $e447bfa04dd0b5f8$var$node;

});

parcelRegister("kGoH8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("kag6n")
]).then(()=>parcelRequire('fydRE'));

});




parcelRegister("eAKSk", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRouteEntry", () => $321698f850da12b4$export$e23e06ae81848c38);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $bk9g2 = parcelRequire("bk9g2");

var $lqm4V = parcelRequire("lqm4V");
const $321698f850da12b4$export$e23e06ae81848c38 = (0, $6xToB.createEntry)((0, $bk9g2.classicBusinessProjectViewNotFoundRoute), ()=>({
        group: 'classic-business',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>(0, $lqm4V.projectViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectViewNotFoundRouteEntry.tsx',
                whichExportToUse: 'classicBusinessProjectViewNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bk9g2", function(module, exports) {
$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRoute", () => $66cd44e5d2928867$export$1194a530fb12fc37);
const $66cd44e5d2928867$export$1194a530fb12fc37 = {
    name: 'classic-business-view-not-found',
    path: '/jira/core/projects/:projectKey/not-found',
    exact: true
};

});

parcelRegister("lqm4V", function(module, exports) {
$parcel$export(module.exports, "projectViewNotFoundPageEntrypoint", () => $af9a408b7801e7b6$export$31e63eef3cc009c6);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $g35Sw = parcelRequire("g35Sw");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

const $af9a408b7801e7b6$var$main = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("5HTaj")), {
        moduleId: "24c3dcc7",
        moduleName: "ProjectViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $g35Sw.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});
const $af9a408b7801e7b6$export$31e63eef3cc009c6 = (0, $g8uYY.createPageEntryPoint)({
    main: $af9a408b7801e7b6$var$main,
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("g35Sw", function(module, exports) {
$parcel$export(module.exports, "default", () => $228f8bc43c71d769$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9a08656b81123b3a899ed443afd14f3>>
 * @relayHash 4f9cc1b4eefda38b80dcbc5247f75776
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9
const $228f8bc43c71d769$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9",
        "metadata": {},
        "name": "ProjectViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $228f8bc43c71d769$export$2e2bcd8739ae039 = $228f8bc43c71d769$var$node;

});

parcelRegister("5HTaj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3EMmo").then(()=>parcelRequire('jPybt'));

});



parcelRegister("j9RxE", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", () => $a4b052d9a9bf10aa$export$5b0670f37204a43d);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8tbnc = parcelRequire("8tbnc");

var $bTfc4 = parcelRequire("bTfc4");

var $QIRn1 = parcelRequire("QIRn1");

var $7OZa1 = parcelRequire("7OZa1");
const $a4b052d9a9bf10aa$export$5b0670f37204a43d = (0, $6xToB.createEntry)((0, $QIRn1.classicProjectSettingsDataClassificationsRoute), ()=>({
        group: 'project-settings-classic',
        component: (0, $7OZa1.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7OZa1.LazyDataClassificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-project-settings-data-classifications-entries/src/classicProjectSettingsDataClassificationsRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsDataClassificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("QIRn1", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $ee169d7e1ab17d73$export$952eefa1907e877a);
const $ee169d7e1ab17d73$export$952eefa1907e877a = {
    name: 'project-settings-classic-data-classifications',
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("7OZa1", function(module, exports) {
$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $233771e23fdb4e35$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $233771e23fdb4e35$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $233771e23fdb4e35$export$b8abcf8aa8f4df56 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8kyMO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $233771e23fdb4e35$var$AsyncDataClassificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $233771e23fdb4e35$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
var $233771e23fdb4e35$export$2e2bcd8739ae039 = $233771e23fdb4e35$var$AsyncDataClassificationsSettings;

});
parcelRegister("8kyMO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5nnaS").then(()=>parcelRequire('g5gWI'));

});



parcelRegister("cprgG", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDetailsRouteEntry", () => $84946a88159b0a32$export$9391a147c94081db);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $dbqPj = parcelRequire("dbqPj");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $g8uYY = parcelRequire("g8uYY");

var $1OM5U = parcelRequire("1OM5U");

var $4cTDP = parcelRequire("4cTDP");

var $kFQUu = parcelRequire("kFQUu");

var $5L7qx = parcelRequire("5L7qx");

var $g6q5m = parcelRequire("g6q5m");

var $fLSSb = parcelRequire("fLSSb");
const $84946a88159b0a32$var$projectSettingsDetailsPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1OM5U.projectDetailsPageEntrypoint)
});
const $84946a88159b0a32$export$9391a147c94081db = (0, $6xToB.createEntry)((0, $dbqPj.classicProjectSettingsDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $fLSSb.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $8FCAy.softwareProjectLayout),
        entryPoint: ()=>(0, $4cTDP.fg)('jira_project_details_settings_refresh') ? $84946a88159b0a32$var$projectSettingsDetailsPageEntrypoint : undefined,
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira_project_details_settings_refresh'), (0, $kFQUu.softwareOnboardingGetStartedIntegrationsStatusResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira_project_details_settings_refresh'), (0, $g6q5m.fetchUserTraitsResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fLSSb.LazyDetailsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsDetailsRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dbqPj", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsDetailsRoute", () => $288d8d62d5e9a3bd$export$37e0dbac44df25b9);
const $288d8d62d5e9a3bd$export$37e0dbac44df25b9 = {
    name: 'classic-software-details',
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("bmwpE", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $5db067f2e0655363$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $5db067f2e0655363$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $5db067f2e0655363$export$ec1cdd0c8335373c);
/* ProjectSettingsFeaturesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $hfsEZ = parcelRequire("hfsEZ");

var $2LV88 = parcelRequire("2LV88");

var $4aEz6 = parcelRequire("4aEz6");
const $5db067f2e0655363$var$customCssStyles = null;
const $5db067f2e0655363$var$listOnlyStyles = null;
const $5db067f2e0655363$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hfsEZ))),
        className: (0, $hcewu.default)([
            "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $5db067f2e0655363$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2LV88))),
        className: (0, $hcewu.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $5db067f2e0655363$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4aEz6))),
        className: (0, $hcewu.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("hfsEZ", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("2LV88", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("4aEz6", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});


parcelRegister("1OM5U", function(module, exports) {
$parcel$export(module.exports, "projectDetailsPageEntrypoint", () => $63474afeee22f9d1$export$a2703bbcf53fcb99);

var $7Caml = parcelRequire("7Caml");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $63474afeee22f9d1$export$a2703bbcf53fcb99 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ewy3Y")), {
        moduleId: "a2fee103",
        moduleName: "ProjectDetailsPage",
        priority: "interaction"
    }),
    // @TODO: fix once https://product-fabric.atlassian.net/browse/AFB-1544 is resolved
    // @ts-expect-error TS2345 - TypeScript can't properly infer nested entrypoints type, levelUpSettingsEntryPoint is inferred as 'never'
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {},
            entryPoints: {
                preloadedLevelUpSettingsEntryPoint: {
                    entryPoint: (0, $7Caml.levelUpSettingsEntryPoint),
                    entryPointParams: {
                        context: context,
                        tenantContext: tenantContext
                    }
                }
            },
            extraProps: {}
        })
});

});
parcelRegister("7Caml", function(module, exports) {
$parcel$export(module.exports, "levelUpSettingsEntryPoint", () => $0604b455d6628a53$export$9a089574259dc560);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $li6kK = parcelRequire("li6kK");

const $0604b455d6628a53$export$9a089574259dc560 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lxsf3")), {
        moduleId: "f034c293",
        moduleName: "LevelUpSettings",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key missing');
        return {
            queries: {
                levelUpSettingsData: {
                    parameters: $li6kK.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            },
            extraProps: {}
        };
    }
});

});
parcelRegister("li6kK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2a3ad395fca68dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62e8fba85206a08dac9ca8aa183e86fe>>
 * @relayHash d2bbf68684b92b2347afe2f0881877ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 09f92630e485923f6df517190e2dc48c050f35d914ca1d4cf53bf24f11d362b3
const $b2a3ad395fca68dd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteAri"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "created"
    }, v4 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LevelUpSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "jira_projectByIdOrKey",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "AutomationsSection"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ConfigurationSection_project"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira_projectByIdOrKey"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v6 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ConfigurationSection_codeInJira"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ConfigurationSection_jira"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurationSection_github"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LevelUpSettingsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "appId",
                                            "value": "bitbucket"
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigStateConnection",
                                            "kind": "LinkedField",
                                            "name": "config",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "siteAri"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "providerTypes",
                                    "value": [
                                        "DEV_INFO"
                                    ]
                                }
                            ],
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "args": v6 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraConfigStateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "config",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraConfigState",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "09f92630e485923f6df517190e2dc48c050f35d914ca1d4cf53bf24f11d362b3",
            "metadata": {},
            "name": "LevelUpSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b2a3ad395fca68dd$var$node.hash = "32aa38b9e2ca377c100b4f77f623a631";
var $b2a3ad395fca68dd$export$2e2bcd8739ae039 = $b2a3ad395fca68dd$var$node;

});

parcelRegister("lxsf3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9cbXp").then(()=>parcelRequire('84LIP'));

});


parcelRegister("ewy3Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("jMBPc")
]).then(()=>parcelRequire('btEbP'));

});


parcelRegister("kFQUu", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingGetStartedIntegrationsStatusResource", () => $c608bf27860e57f3$export$7998050969c75bc0);

var $l1VxS = parcelRequire("l1VxS");

var $3ugTQ = parcelRequire("3ugTQ");

var $9pTd3 = parcelRequire("9pTd3");

var $bBtQo = parcelRequire("bBtQo");
// Match on part of the ID that is consistent between prod and staging
const $c608bf27860e57f3$var$SLACK_PROJECT_PAGE_ID_PARTIAL = 'com.atlassian.plugins.atlassian-connect-plugin:jira-slack-integration';
const $c608bf27860e57f3$var$TEAMS_PROJECT_PAGE_ID_PARTIAL = 'com.atlassian.plugins.atlassian-connect-plugin:msteams';
const $c608bf27860e57f3$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $c608bf27860e57f3$var$fetchIntegrationEnabledStatuses = async (projectKeyOrId)=>{
    try {
        // Using this until as a proxy until there is a more direct endpoint
        const addons = await (0, $3ugTQ.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=settings`);
        if (!addons || !addons.length) return {
            slackIntegrationEnabled: false,
            teamsIntegrationEnabled: false
        };
        return {
            slackIntegrationEnabled: addons.some((i)=>i.id.includes($c608bf27860e57f3$var$SLACK_PROJECT_PAGE_ID_PARTIAL)),
            teamsIntegrationEnabled: addons.some((i)=>i.id.includes($c608bf27860e57f3$var$TEAMS_PROJECT_PAGE_ID_PARTIAL))
        };
    } catch (err) {
        const normalizedError = err instanceof Error ? err : new Error(JSON.stringify(err));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'levelUpSettings.resourceError',
                packageName: 'jiraProjectSettingsLevelUp',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'fetchIntegrationEnabledStatuses'
            },
            error: normalizedError
        });
        throw normalizedError;
    }
};
const $c608bf27860e57f3$var$fetchProjectConnectedStatuses = async (projectKeyOrId)=>{
    try {
        // Using this until as a proxy until there is a more direct endpoint
        const addons = await (0, $3ugTQ.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=home`);
        if (!addons || !addons.length) return {
            slackProjectConnected: false,
            teamsProjectConnected: false
        };
        return {
            slackProjectConnected: addons.some((i)=>i.id.includes($c608bf27860e57f3$var$SLACK_PROJECT_PAGE_ID_PARTIAL)),
            teamsProjectConnected: addons.some((i)=>i.id.includes($c608bf27860e57f3$var$TEAMS_PROJECT_PAGE_ID_PARTIAL))
        };
    } catch (err) {
        const normalizedError = err instanceof Error ? err : new Error(JSON.stringify(err));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'levelUpSettings.resourceError',
                packageName: 'jiraProjectSettingsLevelUp',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'fetchProjectConnectedStatuses'
            },
            error: normalizedError
        });
        throw normalizedError;
    }
};
const $c608bf27860e57f3$var$fetchSlackIsLoggedIn = async (cloudId)=>{
    if (!cloudId) return false;
    try {
        const response = await (0, $3ugTQ.performGetRequest)(`/gateway/api/slack/jira/userinfo?cloudId=${cloudId}`);
        return Boolean(response.connected);
    } catch (err) {
        const normalizedError = err instanceof Error ? err : new Error(JSON.stringify(err));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'levelUpSettings.resourceError',
                packageName: 'jiraProjectSettingsLevelUp',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'fetchSlackIsLoggedIn'
            },
            error: normalizedError
        });
        throw normalizedError;
    }
};
const $c608bf27860e57f3$export$7998050969c75bc0 = (0, $l1VxS.createResource)({
    type: 'JSW_ONBOARDING_GET_STARTED_INTEGRATIONS_STATUS_RESOURCE',
    getKey: ({ match: match, query: query })=>$c608bf27860e57f3$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const projectKeyOrId = $c608bf27860e57f3$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const [slackHasLoggedIn, { slackProjectConnected: slackProjectConnected, teamsProjectConnected: teamsProjectConnected }, { slackIntegrationEnabled: slackIntegrationEnabled, teamsIntegrationEnabled: teamsIntegrationEnabled }] = await Promise.all([
            $c608bf27860e57f3$var$fetchSlackIsLoggedIn(cloudId),
            $c608bf27860e57f3$var$fetchProjectConnectedStatuses(projectKeyOrId),
            $c608bf27860e57f3$var$fetchIntegrationEnabledStatuses(projectKeyOrId)
        ]);
        return {
            slackProjectConnected: slackProjectConnected,
            teamsProjectConnected: teamsProjectConnected,
            slackHasLoggedIn: slackHasLoggedIn,
            slackIntegrationEnabled: slackIntegrationEnabled,
            teamsIntegrationEnabled: teamsIntegrationEnabled
        };
    },
    maxAge: Number.MAX_SAFE_INTEGER,
    // For now, skip SSR for this resource since /gateway/api/slack/jira/userinfo is not available on SSR
    isBrowserOnly: true
});

});

parcelRegister("g6q5m", function(module, exports) {
$parcel$export(module.exports, "fetchUserTraitsResource", () => $f8aafaa91b9afb01$export$d5198d02e9089545);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

var $58aj6 = parcelRequire("58aj6");


const $f8aafaa91b9afb01$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous || !tenantContext.atlassianAccountId) return null;
        const accountId = tenantContext.atlassianAccountId;
        const ssrUrl = `/api/v3/personalization/user/${accountId}`;
        // Use the regular path locally https://atlassian.slack.com/archives/C017Y3EPAQ4/p1760402009102299?thread_ts=1760399382.225529&cid=C017Y3EPAQ4
        const shouldUseSsrUrl = false && !(globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false);
        const response = shouldUseSsrUrl ? (await (0, $3ugTQ.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $58aj6.fetchUserPersonalization)({
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $2b1dbd68e99b477f$export$7f111648ca05f056),
                packageName: (0, $fad1ccf34996459e$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $f8aafaa91b9afb01$export$d5198d02e9089545 = (0, $l1VxS.createResource)({
    type: (0, $2b1dbd68e99b477f$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2b1dbd68e99b477f$export$7e7d7930e22ba39f),
    getData: $f8aafaa91b9afb01$var$getData,
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});

});
parcelRegister("58aj6", function(module, exports) {
$parcel$export(module.exports, "fetchUserPersonalization", () => $c2086ee19c7780e8$export$358e702c7c492276);

var $hgi0g = parcelRequire("hgi0g");
const $c2086ee19c7780e8$var$getPersonalizationUserTraitsUrl = (userId)=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
const $c2086ee19c7780e8$export$358e702c7c492276 = async ({ userId: userId })=>{
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $hgi0g.default)($c2086ee19c7780e8$var$getPersonalizationUserTraitsUrl(userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};

});

const $fad1ccf34996459e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesPersonalization';

const $2b1dbd68e99b477f$export$6f0555de4f60e84e = 'RESOURCE_TYPE_FETCH_USER_TRAITS';
const $2b1dbd68e99b477f$export$7e7d7930e22ba39f = 'fetch-user-traits-resource-key';
const $2b1dbd68e99b477f$export$7f111648ca05f056 = 'useResource.fetchUserTraits';


parcelRegister("fLSSb", function(module, exports) {
$parcel$export(module.exports, "LazyDetailsSettings", () => $1cf3200158e533c3$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $1cf3200158e533c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1cf3200158e533c3$export$6f16b5efddd5c646 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4esLz"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $1cf3200158e533c3$var$AsyncDetailsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1cf3200158e533c3$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
var $1cf3200158e533c3$export$2e2bcd8739ae039 = $1cf3200158e533c3$var$AsyncDetailsSettings;

});
parcelRegister("4esLz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("8KXv2")
]).then(()=>parcelRequire('iBX4i'));

});



parcelRegister("aGmFb", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsFeaturesRouteEntry", () => $897e1c0d50761d04$export$b623393adc25556a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $aPSxl = parcelRequire("aPSxl");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $jjUOC = parcelRequire("jjUOC");
const $897e1c0d50761d04$export$b623393adc25556a = (0, $6xToB.createEntry)((0, $aPSxl.classicProjectSettingsFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'classic-features-page',
        component: (0, $jjUOC.ClassicFeaturesPage),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jjUOC.LazySoftwareClassicFeatures)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsFeaturesRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsFeaturesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aPSxl", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", () => $e7a94da5cb04526c$export$d4bf23ba6f4199d7);
const $e7a94da5cb04526c$export$d4bf23ba6f4199d7 = {
    name: 'classic-software-features',
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("jjUOC", function(module, exports) {
$parcel$export(module.exports, "LazySoftwareClassicFeatures", () => $396c4b5eb8790ea0$export$79fe16f960f3d89f);
$parcel$export(module.exports, "ClassicFeaturesPage", () => $396c4b5eb8790ea0$export$8e6f565615e921dd);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $396c4b5eb8790ea0$export$79fe16f960f3d89f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2sCVs"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $396c4b5eb8790ea0$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $396c4b5eb8790ea0$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });

});
parcelRegister("2sCVs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kQ4bh").then(()=>parcelRequire('6At3v'));

});



parcelRegister("7x2TW", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", () => $3feaf0637df9894c$export$47b3bdf88a7d176b);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $2WuSE = parcelRequire("2WuSE");

var $9X074 = parcelRequire("9X074");
const $3feaf0637df9894c$export$47b3bdf88a7d176b = (0, $6xToB.createEntry)((0, $2WuSE.classicProjectSettingsIssueLayoutRoute), ()=>({
        group: 'project-settings-classic',
        ufoName: 'project-settings.issue-type.jsw-cmp',
        component: (0, $9X074.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9X074.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-project-settings-issue-layout-entries/src/classicProjectSettingsIssueLayoutRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsIssueLayoutRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2WuSE", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", () => $a0ecf27044ced88c$export$c593179674352d0);
const $a0ecf27044ced88c$export$c593179674352d0 = {
    name: 'project-settings-classic-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};

});

parcelRegister("9X074", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSettings", () => $3566656dc44068ff$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $3566656dc44068ff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3566656dc44068ff$export$36dcfb52d47cb93a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j5ufr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $3566656dc44068ff$var$AsyncIssueTypeSettings = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3566656dc44068ff$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
var $3566656dc44068ff$export$2e2bcd8739ae039 = $3566656dc44068ff$var$AsyncIssueTypeSettings;

});
parcelRegister("j5ufr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8fhwO").then(()=>parcelRequire('5pMQO'));

});



parcelRegister("d6OfK", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsOpsgenieRouteEntry", () => $74e5b93c67733130$export$17e7416abefe91dc);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $6wqnM = parcelRequire("6wqnM");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $jLc1n = parcelRequire("jLc1n");
const $74e5b93c67733130$export$17e7416abefe91dc = (0, $6xToB.createEntry)((0, $6wqnM.classicProjectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $jLc1n.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jLc1n.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsOpsgenieRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsOpsgenieRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6qDrV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62983c7b7a7f090$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
/**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ const $d62983c7b7a7f090$var$componentWithCondition = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};
var $d62983c7b7a7f090$export$2e2bcd8739ae039 = $d62983c7b7a7f090$var$componentWithCondition;

});

parcelRegister("6wqnM", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", () => $c26b8de24a202a54$export$4e4a4b8762b611);
const $c26b8de24a202a54$export$4e4a4b8762b611 = {
    name: 'classic-software-link-opsgenie',
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};

});

parcelRegister("jLc1n", function(module, exports) {
$parcel$export(module.exports, "LazyLinkOpsgeniePage", () => $bc2c672bce6647e8$export$ca5dba69148b337);
$parcel$export(module.exports, "default", () => $bc2c672bce6647e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $bc2c672bce6647e8$export$ca5dba69148b337 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("i6xea")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
const $bc2c672bce6647e8$var$AsyncLinkOpsgeniePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bc2c672bce6647e8$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });
var $bc2c672bce6647e8$export$2e2bcd8739ae039 = $bc2c672bce6647e8$var$AsyncLinkOpsgeniePage;

});
parcelRegister("i6xea", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("baN47").then(()=>parcelRequire('3GUgg'));

});



parcelRegister("4vMYX", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $5275a62984855e6a$export$cdc4e64211a34457);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bGYpj = parcelRequire("bGYpj");

var $8FCAy = parcelRequire("8FCAy");

var $6qzZB = parcelRequire("6qzZB");
const $5275a62984855e6a$export$cdc4e64211a34457 = (0, $6xToB.createEntry)((0, $bGYpj.classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $6qzZB.SoftwareNotificationsIssueLogs),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6qzZB.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $6qzZB.emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bGYpj", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", () => $5df01b9dd763cc69$export$5e2e0a895d6a14bd);
const $5df01b9dd763cc69$export$5e2e0a895d6a14bd = {
    name: 'classic-software-notifications-issue-logs',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};

});

parcelRegister("6qzZB", function(module, exports) {
$parcel$export(module.exports, "emailNotificationsLogEntryPointPage", () => $36163c389e27445f$export$cd8964bea0e3c2);
$parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", () => $36163c389e27445f$export$6960a46ebd209756);
$parcel$export(module.exports, "SoftwareNotificationsIssueLogs", () => $36163c389e27445f$export$4b75df09cc5b4e8e);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9BdgC = parcelRequire("9BdgC");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");
const $36163c389e27445f$export$cd8964bea0e3c2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9BdgC.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

const $36163c389e27445f$export$6960a46ebd209756 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("748mp"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $36163c389e27445f$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $36163c389e27445f$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });

});
parcelRegister("9BdgC", function(module, exports) {
$parcel$export(module.exports, "notificationsIssueLogsEntryPoint", () => $3f0806f07fcc5770$export$97bbdefcbe0571ac);

var $f5p5r = parcelRequire("f5p5r");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3f0806f07fcc5770$export$97bbdefcbe0571ac = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("748mp")), {
        moduleId: "b2136a4d",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $f5p5r.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});

});
parcelRegister("f5p5r", function(module, exports) {
$parcel$export(module.exports, "default", () => $5801358f68a398b3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd4746523c651e56ecee740aa726ab3c>>
 * @relayHash f9849ca62d92d5dccd989e12e1008a35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5ee7e920ef5738fb298d664d9c2c5ee8763d21ceced2b7bc2516078b63fe195
const $5801358f68a398b3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5ee7e920ef5738fb298d664d9c2c5ee8763d21ceced2b7bc2516078b63fe195",
        "metadata": {},
        "name": "NotificationLogsPageUiQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5801358f68a398b3$export$2e2bcd8739ae039 = $5801358f68a398b3$var$node;

});

parcelRegister("748mp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j9v9C").then(()=>parcelRequire('9n6Sp'));

});




parcelRegister("13I6Z", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRouteEntry", () => $4e71602b781b7558$export$e730b13555ff0c60);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4vq3o = parcelRequire("4vq3o");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $flSSv = parcelRequire("flSSv");
const $4e71602b781b7558$export$e730b13555ff0c60 = (0, $6xToB.createEntry)((0, $4vq3o.classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $flSSv.default),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flSSv.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsSoftwareProformaEditFormsRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsSoftwareProformaEditFormsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4vq3o", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", () => $cad0ee66b8925436$export$811ace4fee984f0e);
const $cad0ee66b8925436$export$811ace4fee984f0e = {
    name: 'project-settings-software-proforma-edit-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("5JAAk", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_PRODUCT", () => $6e6276c28e4f3f5a$export$2954328f6207617a);
$parcel$export(module.exports, "getSettingsNavigationResources", () => $6e6276c28e4f3f5a$export$586756e5c0542a50);
$parcel$export(module.exports, "RedirectForSettings", () => $6e6276c28e4f3f5a$export$fb15a6ba8980fdac);
$parcel$export(module.exports, "RedirectForSettingsForClassicProject", () => $6e6276c28e4f3f5a$export$f9befa0a4925b36d);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $dSkLG = parcelRequire("dSkLG");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2mHfh = parcelRequire("2mHfh");
const $6e6276c28e4f3f5a$export$2954328f6207617a = 'software';
const $6e6276c28e4f3f5a$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $6e6276c28e4f3f5a$export$586756e5c0542a50 = ()=>{
    return [
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $6e6276c28e4f3f5a$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data, loading: loading } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    // Wait for nav data to be available before deciding where to redirect on cold loads
    if (loading || !data) return null;
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
    // the next three if branches do not make a lot of sense for TMP as you always a project admin in TMP
    // however a wrong link is generated by the nav4 navbar for CMP projects which matches to this redirect logic
    // ex: "/jira/software/projects/JSWCMP1/settings"
    // instead it should be "/jira/software/c/projects/JSWCMP1/settings"
    // which matches to CMP redirect logic defined in RedirectForSettingsForClassicProject
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4cTDP.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $6e6276c28e4f3f5a$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data, loading: loading } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    // Wait for nav data to be available before deciding where to redirect on cold loads
    if ((loading || !data) && (0, $4cTDP.fg)('vmc-52-settings-redirect-wait-till-data-received')) return null;
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4cTDP.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};

});

parcelRegister("flSSv", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $4dbaf5b5533067a8$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $4dbaf5b5533067a8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4dbaf5b5533067a8$export$a7d63246a10aedd = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("87BMN")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $4dbaf5b5533067a8$var$AsyncProjectSettingsProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4dbaf5b5533067a8$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
var $4dbaf5b5533067a8$export$2e2bcd8739ae039 = $4dbaf5b5533067a8$var$AsyncProjectSettingsProformaJiraFormBuilder;

});
parcelRegister("87BMN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("7Me5p")
]).then(()=>parcelRequire('97MV1'));

});



parcelRegister("5IMFp", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRouteEntry", () => $413816a91070f678$export$5e67ac6f50ae37e1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $diIio = parcelRequire("diIio");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $7BRGK = parcelRequire("7BRGK");
const $413816a91070f678$export$5e67ac6f50ae37e1 = (0, $6xToB.createEntry)((0, $diIio.classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $7BRGK.default),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7BRGK.LazyProjectSettingsProformaProjectForms)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsSoftwareProformaFormsRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsSoftwareProformaFormsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("diIio", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", () => $656b6cf425098207$export$2313ca001d58ab27);
const $656b6cf425098207$export$2313ca001d58ab27 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("7BRGK", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $e36263420d65374a$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $e36263420d65374a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e36263420d65374a$export$38414b624a749cec = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hZVDr")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $e36263420d65374a$var$AsyncProjectSettingsProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e36263420d65374a$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
var $e36263420d65374a$export$2e2bcd8739ae039 = $e36263420d65374a$var$AsyncProjectSettingsProformaProjectForms;

});
parcelRegister("hZVDr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6n8IC").then(()=>parcelRequire('rxPon'));

});



parcelRegister("eCSHY", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRouteEntry", () => $20b7059ced23805e$export$3c7d008bbb14e2b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $gDWl0 = parcelRequire("gDWl0");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");
const $20b7059ced23805e$export$3c7d008bbb14e2b = (0, $6xToB.createEntry)((0, $gDWl0.classicProjectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5JAAk.RedirectForSettingsForClassicProject),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsSoftwareRedirectRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsSoftwareRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gDWl0", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", () => $57cb4e8682dd4709$export$99b695c2b8299b5a);
const $57cb4e8682dd4709$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'classic-software-redirect',
    path: '/jira/software/c/projects/:projectKey/settings'
};

});


parcelRegister("k7BXo", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsToolchainRouteEntry", () => $31f3e2198111a83e$export$1fe479c54f4d7684);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $aaqFB = parcelRequire("aaqFB");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $davWM = parcelRequire("davWM");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $1a7Aj = parcelRequire("1a7Aj");
const $31f3e2198111a83e$export$1fe479c54f4d7684 = (0, $6xToB.createEntry)((0, $davWM.classicProjectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $1a7Aj.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $aaqFB.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1a7Aj.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsToolchainRouteEntry.tsx',
                whichExportToUse: 'classicProjectSettingsToolchainRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aaqFB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsToolchainResource", () => $5f2850140c25c0a6$export$182dfe2bc7c28567);

var $g7vn5 = parcelRequire("g7vn5");

var $9FYIg = parcelRequire("9FYIg");
const $5f2850140c25c0a6$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $5f2850140c25c0a6$export$182dfe2bc7c28567 = (0, $9FYIg.createRelayResource)({
    type: $5f2850140c25c0a6$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $g7vn5.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("g7vn5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ab2949d2a92eb13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74566bd99807f69e434cfa02aa55b2a9>>
 * @relayHash 48253c273e6aab42de7754c1092fc3a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 09eb5c309b93132e17ec19c3a5fdc9e09d9d2320daa0d37c40ac6a46dc998281
const $1ab2949d2a92eb13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ToolchainLayoutQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ToolchainLayoutQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "09eb5c309b93132e17ec19c3a5fdc9e09d9d2320daa0d37c40ac6a46dc998281",
            "metadata": {},
            "name": "ToolchainLayoutQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1ab2949d2a92eb13$var$node.hash = "810499e5c2abc370d3d44631b8958e5f";
var $1ab2949d2a92eb13$export$2e2bcd8739ae039 = $1ab2949d2a92eb13$var$node;

});


parcelRegister("davWM", function(module, exports) {
$parcel$export(module.exports, "classicProjectSettingsToolchainRoute", () => $d1412cf050e832f7$export$7dbc23deac9553d4);
const $d1412cf050e832f7$export$7dbc23deac9553d4 = {
    name: 'project-settings-software-toolchain-company-managed',
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};

});

parcelRegister("1a7Aj", function(module, exports) {
$parcel$export(module.exports, "LazyDevOpsConnectionsSettings", () => $7c2ae585b9382004$export$9d468faf674a5201);
$parcel$export(module.exports, "default", () => $7c2ae585b9382004$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7c2ae585b9382004$export$9d468faf674a5201 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dSHqy")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
const $7c2ae585b9382004$var$AsyncDevOpsConnectionsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7c2ae585b9382004$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });
var $7c2ae585b9382004$export$2e2bcd8739ae039 = $7c2ae585b9382004$var$AsyncDevOpsConnectionsSettings;

});
parcelRegister("dSHqy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c5Sw3").then(()=>parcelRequire('d9zBr'));

});



parcelRegister("5ClpU", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogEmbedRouteEntry", () => $10987dab9fcab7e7$export$1a7368427cd23b33);

var $6xToB = parcelRequire("6xToB");

var $iGqPy = parcelRequire("iGqPy");

var $kbZYB = parcelRequire("kbZYB");

var $7K5Ea = parcelRequire("7K5Ea");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $4cTDP = parcelRequire("4cTDP");

var $dcS0z = parcelRequire("dcS0z");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $fbgOh = parcelRequire("fbgOh");

var $5L7qx = parcelRequire("5L7qx");

var $27Owl = parcelRequire("27Owl");

var $cxQGT = parcelRequire("cxQGT");

var $eJe5A = parcelRequire("eJe5A");

var $grWOk = parcelRequire("grWOk");

var $9NmsS = parcelRequire("9NmsS");

var $e1vE6 = parcelRequire("e1vE6");

var $kX24C = parcelRequire("kX24C");

var $daiGg = parcelRequire("daiGg");
const $10987dab9fcab7e7$export$1a7368427cd23b33 = (0, $6xToB.createEntry)((0, $iGqPy.classicSoftwareBacklogEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog-embed',
        component: (0, $kbZYB.RapidBoardSpaPage),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $alzbz.getUIFBacklogDataResource)(true),
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $e1vE6.aiEntitlementResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('backlog-preload-epics-lite'), (0, $dcS0z.epicsLiteResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kX24C.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $daiGg.classicBacklogCapability)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-backlog-entries/src/classicSoftwareBacklogEmbedRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBacklogEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iGqPy", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $56e657b647700c56$export$e6776ef8123b7136);
const $56e657b647700c56$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});

parcelRegister("kbZYB", function(module, exports) {
$parcel$export(module.exports, "UIFBoardSpa", () => $6177a7a3c7ca9e0e$export$2164de18d39af313);
$parcel$export(module.exports, "RapidBoardSpaPage", () => $6177a7a3c7ca9e0e$export$4ceb6cf2934825b2);
$parcel$export(module.exports, "LazyRapidBoard", () => $6177a7a3c7ca9e0e$export$9de09057ba255cc4);
$parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", () => $6177a7a3c7ca9e0e$export$bcb5bb6438a46dcb);
$parcel$export(module.exports, "LazyRapidBoardDataApiResource", () => $6177a7a3c7ca9e0e$export$d4640ceb9bdd4b4);
$parcel$export(module.exports, "LazyRapidBoardConfigApiResource", () => $6177a7a3c7ca9e0e$export$c96c36c0cbfb2c16);
$parcel$export(module.exports, "LazyRapidBoardResource", () => $6177a7a3c7ca9e0e$export$2ad64ed8eb98d9e);
$parcel$export(module.exports, "LazyRapidBoardApps", () => $6177a7a3c7ca9e0e$export$4a8825f3e310b97);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $6177a7a3c7ca9e0e$export$2164de18d39af313 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iclWv")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $6177a7a3c7ca9e0e$export$bcc6315cf211edab = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6bmnz")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

const $6177a7a3c7ca9e0e$export$a1c59527bd5131cc = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gt89m")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/src/index.tsx"
});
const $6177a7a3c7ca9e0e$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board',
        'rapidboard-backlog-embed'
    ].includes(route.name) && query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6177a7a3c7ca9e0e$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $6177a7a3c7ca9e0e$export$9de09057ba255cc4 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9H3OA")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index-old.tsx"
});

const $6177a7a3c7ca9e0e$export$bcb5bb6438a46dcb = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jmMYb")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$d4640ceb9bdd4b4 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("nKbCn")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$c96c36c0cbfb2c16 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9w1h2")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$2ad64ed8eb98d9e = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("12d8R")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $6177a7a3c7ca9e0e$export$4a8825f3e310b97 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("bLve9")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});

});
parcelRegister("iclWv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("kNFvF"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("1yyys")),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3hzCJ")
]).then(()=>parcelRequire('gwyFe'));

});

parcelRegister("6bmnz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("8TsKJ")
]).then(()=>parcelRequire('2fxgQ'));

});

parcelRegister("gt89m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iJ5yk").then(()=>parcelRequire('htWDI'));

});

parcelRegister("9H3OA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dhY7N").then(()=>parcelRequire('Xu9Uw'));

});

parcelRegister("9w1h2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5audb").then(()=>parcelRequire('c6bSy'));

});

parcelRegister("bLve9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("azZqs").then(()=>parcelRequire('6pPz6'));

});


parcelRegister("dcS0z", function(module, exports) {
$parcel$export(module.exports, "epicsLiteResource", () => $0d69173553f5ec07$export$39abb8be14c2a1c5);

var $l1VxS = parcelRequire("l1VxS");

const $0d69173553f5ec07$export$39abb8be14c2a1c5 = (0, $l1VxS.createResource)({
    type: 'EPICS_LITE_PRELOAD',
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("kA79M")),
    maxAge: 0
});

});
parcelRegister("kA79M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i0QFt").then(()=>parcelRequire('jrXKs'));

});


parcelRegister("eJe5A", function(module, exports) {
$parcel$export(module.exports, "LazyIssueApp", () => $80c8b01e8332d190$export$8c70dcc4643464f8);

var $bQWwW = parcelRequire("bQWwW");

const $80c8b01e8332d190$export$8c70dcc4643464f8 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("5pAUa")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});

parcelRegister("e1vE6", function(module, exports) {
$parcel$export(module.exports, "aiEntitlementResource", () => $ca4f246a1c036ca7$export$1d7e36ec4890154f);
$parcel$export(module.exports, "useAiEntitlementResource", () => $ca4f246a1c036ca7$export$58958385d85a6e72);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $9RxtF = parcelRequire("9RxtF");
const $ca4f246a1c036ca7$var$RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';
const $ca4f246a1c036ca7$export$1d7e36ec4890154f = (0, $l1VxS.createResource)({
    type: $ca4f246a1c036ca7$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getKey: ()=>$ca4f246a1c036ca7$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getData: ()=>(0, $9RxtF.fetchAiEnablement)(),
    maxAge: 3600000
});
const $ca4f246a1c036ca7$export$58958385d85a6e72 = ()=>(0, $eJrcF.useResource)($ca4f246a1c036ca7$export$1d7e36ec4890154f);

});
parcelRegister("9RxtF", function(module, exports) {
$parcel$export(module.exports, "fetchAiEnablement", () => $8e5fdc23f4bbfb78$export$ad4105850d0ce824);

var $hgi0g = parcelRequire("hgi0g");
const $8e5fdc23f4bbfb78$var$JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
const $8e5fdc23f4bbfb78$export$ad4105850d0ce824 = async ()=>{
    // We could check for other jira products / confluence when we need to
    // Not doing that right now as it adds complexity & we need software only now
    // See `@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled`
    const entitlementData = {
        isAiEnabledForJiraSoftware: null
    };
    try {
        const response = await (0, $hgi0g.default)($8e5fdc23f4bbfb78$var$JIRA_SOFTWARE_AI_ENABLED_URL, {
            method: 'GET'
        });
        entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
    } catch (_) {
        entitlementData.isAiEnabledForJiraSoftware = null;
    }
    return entitlementData;
};

});


parcelRegister("kX24C", function(module, exports) {
$parcel$export(module.exports, "LazyBacklogPage", () => $c5d16d03120ed3fe$export$edb4b8cf67d7d767);

var $bQWwW = parcelRequire("bQWwW");

var $2dJFW = parcelRequire("2dJFW");

const $c5d16d03120ed3fe$export$edb4b8cf67d7d767 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6bmnz"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

});

parcelRegister("daiGg", function(module, exports) {
$parcel$export(module.exports, "classicBacklogCapability", () => $db679226da4cfc54$export$10a7bb102137d92b);

const $db679226da4cfc54$export$10a7bb102137d92b = !false ? (0, $652f5f63189f3e2a$export$571692eec8a399e1) : (0, $652f5f63189f3e2a$export$93104dc4eba58ba4);

});


parcelRegister("74BfF", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogRouteEntry", () => $0e6a74a0ef9edaac$export$568101ebd359b606);

var $6xToB = parcelRequire("6xToB");

var $aqgqG = parcelRequire("aqgqG");

var $kbZYB = parcelRequire("kbZYB");

var $9ZjGp = parcelRequire("9ZjGp");

var $4cTDP = parcelRequire("4cTDP");

var $6dwgv = parcelRequire("6dwgv");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $alzbz = parcelRequire("alzbz");

var $dcS0z = parcelRequire("dcS0z");

var $fbgOh = parcelRequire("fbgOh");

var $27Owl = parcelRequire("27Owl");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $grWOk = parcelRequire("grWOk");

var $k6duF = parcelRequire("k6duF");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $e1vE6 = parcelRequire("e1vE6");

var $5vHl0 = parcelRequire("5vHl0");

var $daiGg = parcelRequire("daiGg");

var $kX24C = parcelRequire("kX24C");
const $0e6a74a0ef9edaac$export$568101ebd359b606 = (0, $6xToB.createEntry)((0, $aqgqG.classicSoftwareBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.pageLoadIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ], 'SIDEBAR')),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getUIFBacklogDataResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $e1vE6.aiEntitlementResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('backlog-preload-epics-lite'), (0, $dcS0z.epicsLiteResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kX24C.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $daiGg.classicBacklogCapability)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'backlog-and-board',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-backlog-entries/src/classicSoftwareBacklogRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBacklogRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-backlog.json'
        },
        entryPoint: ()=>(0, $5vHl0.classicBacklogPageEntryPoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('cmp-backlog-hydrate-root')
    }));

});
parcelRegister("aqgqG", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBacklogRoute", () => $94985eb032cc2771$export$9bfa3c0dded1688f);
const $94985eb032cc2771$export$9bfa3c0dded1688f = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("9ZjGp", function(module, exports) {
$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $0d166db2984aa878$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6umqd = parcelRequire("6umqd");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $9RE4U = parcelRequire("9RE4U");

var $jPwoC = parcelRequire("jPwoC");
const $0d166db2984aa878$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jPwoC)))
    });
const $0d166db2984aa878$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d166db2984aa878$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jPwoC)))
    }));
const $0d166db2984aa878$var$BacklogSkeleton = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $0d166db2984aa878$export$88189b56881f213e, $0d166db2984aa878$export$433c2e8574f2e911);
const $0d166db2984aa878$export$33cd465913cf178f = ()=>{
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    let ssrPlaceholderProp = {};
    if (!isPageHydrating) ssrPlaceholderProp = false ? {
        'data-ssr-placeholder': 'software-backlog-skeleton'
    } : {
        'data-ssr-placeholder-replace': 'software-backlog-skeleton'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", ssrPlaceholderProp, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d166db2984aa878$var$BacklogSkeleton, null));
};
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0d166db2984aa878$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jPwoC", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("5vHl0", function(module, exports) {
$parcel$export(module.exports, "classicBacklogPageEntryPoint", () => $6a9c26c550c58f20$export$e07cd4fec395c8db);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cw1BI = parcelRequire("cw1BI");

var $5DQfo = parcelRequire("5DQfo");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $9n5I0 = parcelRequire("9n5I0");
const $6a9c26c550c58f20$export$e07cd4fec395c8db = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cw1BI.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("cw1BI", function(module, exports) {
$parcel$export(module.exports, "nextGenBacklogEntryPoint", () => $832138e73fefe1ea$export$377b23d5a7dc4052);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $k6sY0 = parcelRequire("k6sY0");

var $496yH = parcelRequire("496yH");

const $832138e73fefe1ea$export$377b23d5a7dc4052 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("g5OHe")), {
        moduleId: "ba92b399",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const routeName = context.route.name;
        if (routeName !== 'rapidboard-backlog' || // Commenting out these two routes as we get an error from Relay if we try to
        // load the query on these routes. We should revisit this when we have proper
        // user testing on these routes.
        // routeName !== 'rapidboard-user-backlog' &&
        // routeName !== 'rapidboard-backlog-embed'
        !(0, $4cTDP.fg)('backlog_relay_data_resource')) return {};
        const viewId = (0, $496yH.JiraViewAri).create({
            activationId: tenantContext.activationId,
            siteId: tenantContext.cloudId,
            scopeId: `${context.match.params.boardId}/backlog`,
            scopeType: 'board'
        }).toString();
        return {
            queries: {
                backlogDataQuery: {
                    parameters: $k6sY0.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${tenantContext.cloudId}:board/${context.match.params.boardId}`,
                        input: {
                            jiraBacklogViewQueryInput: {
                                viewId: viewId
                            }
                        },
                        includeBacklogView: (0, $4cTDP.fg)('backlog_include_view_setting_query_into_backlogagg')
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("k6sY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $edcc1ff992769b5d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6461e6c6d836d7dca72d5aad10e6461>>
 * @relayHash 4a8a9e049dcad9843b5d59376e53ceb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6eb7271950c55c9701a8edde14106467de0061f5e932aabdb753ee6d78aa112f
const $edcc1ff992769b5d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6eb7271950c55c9701a8edde14106467de0061f5e932aabdb753ee6d78aa112f",
        "metadata": {},
        "name": "BacklogAggAppDataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $edcc1ff992769b5d$export$2e2bcd8739ae039 = $edcc1ff992769b5d$var$node;

});

parcelRegister("496yH", function(module, exports) {
$parcel$export(module.exports, "JiraViewAri", () => $304d171cb4c80fb0$export$259cce321cdbcc);

var $l6thc = parcelRequire("l6thc");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/view/manifest.ts
var $304d171cb4c80fb0$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $l6thc.JiraViewAriResourceOwner),
    resourceType: (0, $l6thc.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board)/,
        // eslint-disable-line no-useless-escape
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $304d171cb4c80fb0$export$259cce321cdbcc = class _JiraViewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $304d171cb4c80fb0$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $304d171cb4c80fb0$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $304d171cb4c80fb0$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("l6thc", function(module, exports) {
$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $f5d0de35c3dbae2a$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $f5d0de35c3dbae2a$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $f5d0de35c3dbae2a$export$c63cbf12e88f62b6 = "jira", $f5d0de35c3dbae2a$export$4b456bf9436bd47e = "view";

});


parcelRegister("g5OHe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("gElov")
]).then(()=>parcelRequire('a1Gcb'));

});




parcelRegister("2r2Qz", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", () => $29322ff28d980cef$export$b5558b683e9c45a4);

var $lopBx = parcelRequire("lopBx");

var $eJe5A = parcelRequire("eJe5A");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $b8mPY = parcelRequire("b8mPY");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $fzFPm = parcelRequire("fzFPm");

var $kbZYB = parcelRequire("kbZYB");

var $6dwgv = parcelRequire("6dwgv");

var $hkqTc = parcelRequire("hkqTc");
const $29322ff28d980cef$export$b5558b683e9c45a4 = (0, $6xToB.createEntry)((0, $fzFPm.classicSoftwareBoardEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board-embed',
        component: (0, $kbZYB.RapidBoardSpaPage),
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() && !(0, $lopBx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $cxQGT.themePreferenceResource),
            (0, $hHbzj.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kbZYB.UIFBoardSpa)
        ],
        meta: {
            capability: (0, $hkqTc.classicBoardCapability)
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardEmbedRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("b8mPY", function(module, exports) {
$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $c69fbe24c063fd77$export$5d472f7d515300ca);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");

const $c69fbe24c063fd77$export$5d472f7d515300ca = (0, $l1VxS.createResource)({
    type: (0, $040daa3db0be3503$export$6f0555de4f60e84e),
    getKey: ()=>(0, $040daa3db0be3503$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $3ugTQ.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $040daa3db0be3503$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, we auto enroll them and set the initial value to true.
					 */ return {
                hasUserOptedIn: true
            };
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: (0, $040daa3db0be3503$export$7f111648ca05f056),
                    packageName: (0, $040daa3db0be3503$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
			 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $040daa3db0be3503$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $040daa3db0be3503$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $040daa3db0be3503$export$b94951a11282ae6a = 'next-best-task-feature';
const $040daa3db0be3503$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $040daa3db0be3503$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';


parcelRegister("fzFPm", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $134627f3bb568c9c$export$122afcef7dfd252);
const $134627f3bb568c9c$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("hkqTc", function(module, exports) {
$parcel$export(module.exports, "classicBoardCapability", () => $7376c20eb73bee8d$export$a6d9a03b76d2193b);

const $7376c20eb73bee8d$export$a6d9a03b76d2193b = !false ? (0, $652f5f63189f3e2a$export$664edf77d4c76110) : (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c);

});


parcelRegister("cyLCh", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardRouteEntry", () => $56e241b7ecaa2cf7$export$f2cd114cf8ab53aa);

var $lopBx = parcelRequire("lopBx");

var $kHlOR = parcelRequire("kHlOR");

var $grWOk = parcelRequire("grWOk");

var $4cTDP = parcelRequire("4cTDP");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $b8mPY = parcelRequire("b8mPY");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $k7VE6 = parcelRequire("k7VE6");

var $kbZYB = parcelRequire("kbZYB");

var $c5gcy = parcelRequire("c5gcy");

var $fwrw4 = parcelRequire("fwrw4");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $8vmEP = parcelRequire("8vmEP");

var $cxKOj = parcelRequire("cxKOj");

var $hkqTc = parcelRequire("hkqTc");

var $fBkBS = parcelRequire("fBkBS");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $56e241b7ecaa2cf7$var$getLayout = ()=>{
    let viewMode = 'DEFAULT';
    if ((0, $fwrw4.isLocalStorageAvailable)()) viewMode = (0, $c5gcy.getViewModeFromLocalStorage)();
    return (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.pageLoadIssuePreloadLayoutBuilder)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ], viewMode));
};
const $56e241b7ecaa2cf7$var$isColoredLabelsMilestone2ExperimentEnabled = ()=>{
    return (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) !== false;
};
const $56e241b7ecaa2cf7$export$f2cd114cf8ab53aa = (0, $6xToB.createEntry)((0, $k7VE6.classicSoftwareBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: $56e241b7ecaa2cf7$var$getLayout(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() || (0, $4cTDP.fg)('enable_ssr_for_cmp_board'), (0, $c0h8V.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() && !(0, $lopBx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBoardModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource)),
            (0, $5L7qx.resourceWithCondition2)($56e241b7ecaa2cf7$var$isColoredLabelsMilestone2ExperimentEnabled, (0, $8vmEP.coloredLabelsResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.UIFBoardSpa)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        meta: {
            capability: (0, $hkqTc.classicBoardCapability)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'backlog-and-board',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-board.json'
        },
        entryPoint: ()=>(0, $fBkBS.classicBoardPageEntryPoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('cmp-board-hydrate-root')
    }));

});
parcelRegister("zNGiI", function(module, exports) {
$parcel$export(module.exports, "ClassicBoardSkeleton", () => $1dcd14fbb9b67592$export$631611c5fdf027d5);
/* ClassicBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $FfFVd = parcelRequire("FfFVd");
const $1dcd14fbb9b67592$var$customCssStyles = null;
const $1dcd14fbb9b67592$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($FfFVd))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("FfFVd", function(module, exports) {
module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();

});


parcelRegister("8vmEP", function(module, exports) {
$parcel$export(module.exports, "coloredLabelsResource", () => $67b5fd6cf53e55fe$export$f0ad3e030e2810cd);

var $9FYIg = parcelRequire("9FYIg");

var $9pTd3 = parcelRequire("9pTd3");

var $gfurL = parcelRequire("gfurL");

const $67b5fd6cf53e55fe$export$f0ad3e030e2810cd = (0, $9FYIg.createRelayResource)({
    type: (0, $c4cbf185d67d5f99$export$23ce323aea9a6251),
    getQuery: ({ query: query, match: match }, { tenantContext: tenantContext })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        let boardAriId = null;
        try {
            boardAriId = boardId ? `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}` : '';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'getBoardAriId',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            parameters: (0, $gfurL.default),
            variables: {
                boardId: boardAriId || ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    },
    isBrowserOnly: true
});

});
parcelRegister("gfurL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8636672e9306f825$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9fd26d8ea440c3315d30fdcc98a3091>>
 * @relayHash f1a1e7f4f3391d9025cda1e1a967eac2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6cc55bf7b732ac37d40318c8c8e923f5e4fb306144d2d271a0d55c3f0909b71
const $8636672e9306f825$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "colorKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "labelsInBoard",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "labelsInBoard",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabel",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a6cc55bf7b732ac37d40318c8c8e923f5e4fb306144d2d271a0d55c3f0909b71",
            "metadata": {},
            "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8636672e9306f825$var$node.hash = "ae1319e8a8b2f29c250f16107724930b";
var $8636672e9306f825$export$2e2bcd8739ae039 = $8636672e9306f825$var$node;

});

const $c4cbf185d67d5f99$export$23ce323aea9a6251 = 'COLORED_LABELS_RELAY';


parcelRegister("fBkBS", function(module, exports) {
$parcel$export(module.exports, "classicBoardPageEntryPoint", () => $ecc79b0d6607dd5f$export$b7ca8af848cd7993);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $iJnZt = parcelRequire("iJnZt");

var $5DQfo = parcelRequire("5DQfo");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $9n5I0 = parcelRequire("9n5I0");
const $ecc79b0d6607dd5f$export$b7ca8af848cd7993 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iJnZt.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("iJnZt", function(module, exports) {
$parcel$export(module.exports, "nextGenBoardEntryPoint", () => $644517290b990a06$export$bb3c6f02a735f848);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $644517290b990a06$export$bb3c6f02a735f848 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("iclWv")), {
        moduleId: "5be6be56",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("gUidc", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry", () => $caeffc5f86b73edb$export$9bcdab5e8a786007);

var $9UxDS = parcelRequire("9UxDS");

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $abOZT = parcelRequire("abOZT");

var $kbZYB = parcelRequire("kbZYB");

var $9ZjGp = parcelRequire("9ZjGp");

var $hS1gr = parcelRequire("hS1gr");

var $8BTxL = parcelRequire("8BTxL");
const $caeffc5f86b73edb$export$9bcdab5e8a786007 = (0, $6xToB.createEntry)((0, $abOZT.classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $8BTxL.InsightsSettingsRedirect),
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $9UxDS.issueHierarchyPageResource),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps),
            (0, $kbZYB.LazyRapidBoardDataApiResource),
            (0, $kbZYB.LazyRapidBoardConfigApiResource),
            (0, $kbZYB.LazyRapidBoardWrmBundleResource),
            (0, $kbZYB.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-settings-insights-entries/src/classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9UxDS", function(module, exports) {
$parcel$export(module.exports, "issueHierarchyPageResource", () => $fc870df98e3d93d1$export$98d50a2e19509817);

var $9FYIg = parcelRequire("9FYIg");

var $foMzt = parcelRequire("foMzt");
const $fc870df98e3d93d1$export$98d50a2e19509817 = (0, $9FYIg.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $foMzt.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("foMzt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f00e2dfa42683692$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7478b7f6f49ae8da025e636dd01fc6ad>>
 * @relayHash a7fc4e9c382896a4769627413accc3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a641f91a8624f90047b210e0dc40067db21c90ddcca76f463db856927c1088
const $f00e2dfa42683692$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueHierarchyViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveButtonSaveButton"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveDialog"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueHierarchyViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9a641f91a8624f90047b210e0dc40067db21c90ddcca76f463db856927c1088",
            "metadata": {},
            "name": "IssueHierarchyViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f00e2dfa42683692$var$node.hash = "01d8ce6b2a99e8bb6f021090db170c86";
var $f00e2dfa42683692$export$2e2bcd8739ae039 = $f00e2dfa42683692$var$node;

});


parcelRegister("b4jBr", function(module, exports) {
$parcel$export(module.exports, "horizontalNavJiraResource", () => $0bd7097ca3e78874$export$faeb8c89315e20da);

var $9FYIg = parcelRequire("9FYIg");

var $byeh6 = parcelRequire("byeh6");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $hBje1 = parcelRequire("hBje1");
const $0bd7097ca3e78874$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $byeh6.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $0bd7097ca3e78874$var$horizontalNavJiraResourceActual = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $0bd7097ca3e78874$export$71eec30d9db46a56
}));
const $0bd7097ca3e78874$export$faeb8c89315e20da = $0bd7097ca3e78874$var$horizontalNavJiraResourceActual;

});
parcelRegister("byeh6", function(module, exports) {
$parcel$export(module.exports, "default", () => $82bde2de23c60ccc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b55d539d862e81d98d36743cbc75d57>>
 * @relayHash 15afe768410f467f58512813804488cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a3abe148fa3378330c33399b2f78b01611b1b606d0218e858c383795a3ec93d

var $7KZsS = parcelRequire("7KZsS");

var $7ze1k = parcelRequire("7ze1k");

var $gpGBt = parcelRequire("gpGBt");

var $37Ewn = parcelRequire("37Ewn");
const $82bde2de23c60ccc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v9 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                            "kind": "LinkedField",
                                            "name": "teamsConnected",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "created"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5a3abe148fa3378330c33399b2f78b01611b1b606d0218e858c383795a3ec93d",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": (0, $7ze1k.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default)
            }
        }
    };
}();
$82bde2de23c60ccc$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $37Ewn.PreloadableQueryRegistry).set($82bde2de23c60ccc$var$node.params.id, $82bde2de23c60ccc$var$node);
var $82bde2de23c60ccc$export$2e2bcd8739ae039 = $82bde2de23c60ccc$var$node;

});


parcelRegister("abOZT", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute", () => $16779a343a56a3a6$export$e43f33a0c1ae830c);
const $16779a343a56a3a6$export$e43f33a0c1ae830c = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};

});

parcelRegister("8BTxL", function(module, exports) {
$parcel$export(module.exports, "InsightsSettingsRedirect", () => $b26a9d577c1c9bb4$export$f7bc2c5799e41684);

var $70SHW = parcelRequire("70SHW");

var $95O7y = parcelRequire("95O7y");
const $b26a9d577c1c9bb4$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $70SHW.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $95O7y.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};

});
parcelRegister("70SHW", function(module, exports) {
$parcel$export(module.exports, "useSelectedConfigTab", () => $490a4f1d12f4798a$export$9b386f1a3e61b385);

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
const $490a4f1d12f4798a$export$9b386f1a3e61b385 = ()=>{
    const storageProvider = (0, $3hRxq.createLocalStorageProvider)('', false);
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>{
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) return storageProvider.get(SELECTED_CONFIG_TAB_KEY) || '';
        return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    };
    const setSelectedConfigTab = (newConfigTab)=>{
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) storageProvider.set(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        else localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    };
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});



parcelRegister("6p8i9", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry", () => $262090c926929379$export$d4cb7b5fe9faae5e);

var $9UxDS = parcelRequire("9UxDS");

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cfP4L = parcelRequire("cfP4L");

var $kbZYB = parcelRequire("kbZYB");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");

var $8BTxL = parcelRequire("8BTxL");
const $262090c926929379$export$d4cb7b5fe9faae5e = (0, $6xToB.createEntry)((0, $cfP4L.classicSoftwareBoardSettingsInsightsRapidboardBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-board-insights',
        component: (0, $8BTxL.InsightsSettingsRedirect),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $9UxDS.issueHierarchyPageResource),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps),
            (0, $kbZYB.LazyRapidBoardDataApiResource),
            (0, $kbZYB.LazyRapidBoardConfigApiResource),
            (0, $kbZYB.LazyRapidBoardWrmBundleResource),
            (0, $kbZYB.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-settings-insights-entries/src/classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cfP4L", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRoute", () => $9044012524759fbc$export$8c2f936709b987ac);
const $9044012524759fbc$export$8c2f936709b987ac = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};

});


parcelRegister("4RXNm", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsRouteEntry", () => $166a16e46d70e618$export$4e7891e9bba3f679);

var $lopBx = parcelRequire("lopBx");

var $6xToB = parcelRequire("6xToB");

var $zNGiI = parcelRequire("zNGiI");

var $7Oedg = parcelRequire("7Oedg");

var $ioHIu = parcelRequire("ioHIu");

var $dZRaT = parcelRequire("dZRaT");

var $9NmsS = parcelRequire("9NmsS");

var $alzbz = parcelRequire("alzbz");

var $27Owl = parcelRequire("27Owl");

var $bTfc4 = parcelRequire("bTfc4");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $fbgOh = parcelRequire("fbgOh");

var $5L7qx = parcelRequire("5L7qx");

var $c0h8V = parcelRequire("c0h8V");

var $b8mPY = parcelRequire("b8mPY");


var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $a4jDB = parcelRequire("a4jDB");
const $166a16e46d70e618$export$4e7891e9bba3f679 = (0, $6xToB.createEntry)((0, $7Oedg.classicSoftwareBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $a4jDB.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            sidebarId: (0, $5RW99.SIDEBAR_ID).BOARD_SETTINGS
        },
        layout: (0, $ioHIu.genericProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $alzbz.shouldLoadUIFBoardResources)() && !(0, $lopBx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $hHbzj.forgeBoardModuleResource)
        ],
        meta: {
            // Inline this statement instead of creating a (circular) dependency by importing
            // { classicBoardCapability } from '@atlassian/jira-router-routes-software-classic-board-entries/src/common/constants.tsx';
            capability: !false ? (0, $652f5f63189f3e2a$export$664edf77d4c76110) : (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c)
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-settings-entries/src/classicSoftwareBoardSettingsRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7Oedg", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardSettingsRoute", () => $7a77c8b2ca1d391d$export$c055a8844d0d2f5e);
const $7a77c8b2ca1d391d$export$c055a8844d0d2f5e = {
    name: 'rapidboard-board-settings',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});

parcelRegister("a4jDB", function(module, exports) {
$parcel$export(module.exports, "boardSettingsPageEntryPoint", () => $3c13d43de97673c8$export$e92abb48a4e0c94d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3kyC0 = parcelRequire("3kyC0");

var $5n4TZ = parcelRequire("5n4TZ");
const $3c13d43de97673c8$export$e92abb48a4e0c94d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5n4TZ.classicBoardSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $3kyC0.nav4SidebarSettingsBoardEntryPoint)
    }
});

});
parcelRegister("3kyC0", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarSettingsBoardEntryPoint", () => $5566f1bf3e63509d$export$f4cb88eb97cbdc30);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $5566f1bf3e63509d$export$f4cb88eb97cbdc30 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("auTU5")), {
        moduleId: "98fd14bc",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("auTU5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hJJuC").then(()=>parcelRequire('7TH4E'));

});


parcelRegister("5n4TZ", function(module, exports) {
$parcel$export(module.exports, "classicBoardSettingsEntryPoint", () => $f00ba1a8670b9f3b$export$fd11e3f2f113ef67);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $f00ba1a8670b9f3b$export$fd11e3f2f113ef67 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jOpeW")).then(({ BoardSettingsSwitcher: BoardSettingsSwitcher })=>BoardSettingsSwitcher), {
        moduleId: "59af2752",
        moduleName: "BoardSettingsSwitcher",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("jOpeW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7a5Ei").then(()=>parcelRequire('cO2Fz'));

});




parcelRegister("94WeZ", function(module, exports) {
$parcel$export(module.exports, "cmpVelocityRouteEntry", () => $27f17dfe76c3b690$export$93315233fc25c1b4);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8FCAy = parcelRequire("8FCAy");

var $8JxCQ = parcelRequire("8JxCQ");

var $8iZ3C = parcelRequire("8iZ3C");

var $awzH2 = parcelRequire("awzH2");
const $27f17dfe76c3b690$export$93315233fc25c1b4 = (0, $6xToB.createEntry)((0, $8JxCQ.cmpVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report-cmp',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $8iZ3C.velocityReportPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/cmpVelocityRouteEntry.tsx',
                whichExportToUse: 'cmpVelocityRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8JxCQ", function(module, exports) {
$parcel$export(module.exports, "cmpVelocityRoute", () => $79d60745a93d6fbc$export$1dfb0bd517ec7a8b);
const $79d60745a93d6fbc$export$1dfb0bd517ec7a8b = {
    name: 'software-reports-velocity-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("8iZ3C", function(module, exports) {
$parcel$export(module.exports, "velocityReportPageEntrypoint", () => $bc6ce3c629e61c0b$export$571ee01f62e186c8);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5C8tx = parcelRequire("5C8tx");
const $bc6ce3c629e61c0b$export$571ee01f62e186c8 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5C8tx.velocityReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("5C8tx", function(module, exports) {
$parcel$export(module.exports, "velocityReportEntrypoint", () => $258417ee791ad89b$export$6f6bc731b8a9d27);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $258417ee791ad89b$export$6f6bc731b8a9d27 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eGlal")), {
        moduleId: "3ce1c0b2",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eGlal", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("83W1e").then(()=>parcelRequire('b1t6C'));

});



parcelRegister("awzH2", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $bfe7e156cd647afe$export$8cb713295e6b7204);
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $bfe7e156cd647afe$export$f234446c23dc22a);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $bfe7e156cd647afe$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $bfe7e156cd647afe$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("ho3Tv", function(module, exports) {
$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $cc95b3bd57d16e20$export$5910307042ab3f6f);

var $2at4v = parcelRequire("2at4v");

var $l1VxS = parcelRequire("l1VxS");

var $9kIEH = parcelRequire("9kIEH");
const $cc95b3bd57d16e20$export$5910307042ab3f6f = (0, $l1VxS.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $9kIEH.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("9kIEH", function(module, exports) {
$parcel$export(module.exports, "fetchJSWReports", () => $0b71b3b31d605b16$export$a93a577d6971da2c);

var $3ugTQ = parcelRequire("3ugTQ");
const $0b71b3b31d605b16$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $3ugTQ.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("hlh4g", function(module, exports) {
$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $a69e62c33f4a6228$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $a69e62c33f4a6228$export$e9adc6103e9ed514);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $a69e62c33f4a6228$export$96cb0eae1b3413f4 = (0, $l1VxS.createResource)({
    type: (0, $271f8eaa42077abf$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("8NSRJ")),
    maxAge: 60000
});
const $a69e62c33f4a6228$export$e9adc6103e9ed514 = ()=>(0, $eJrcF.useResource)($a69e62c33f4a6228$export$96cb0eae1b3413f4);

});
const $271f8eaa42077abf$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $271f8eaa42077abf$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $271f8eaa42077abf$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("8NSRJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kaWHz").then(()=>parcelRequire('19vLN'));

});




parcelRegister("81S4s", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholderGroupsRouteEntry", () => $f85b738690fadb0a$export$f0dd910016653be3);

var $6xToB = parcelRequire("6xToB");

var $lrHlh = parcelRequire("lrHlh");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $5aUnj = parcelRequire("5aUnj");

var $hLwPy = parcelRequire("hLwPy");
const $f85b738690fadb0a$export$f0dd910016653be3 = (0, $6xToB.createEntry)((0, $lrHlh.communicationsStakeholderGroupsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $1f2LE.default)
        },
        skeleton: (0, $5aUnj.StakeholdersSkeleton),
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_stakeholder_management_platform') ? (0, $hLwPy.stakeholderGroupsPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStakeholderGroupsRouteEntry.tsx',
                whichExportToUse: 'communicationsStakeholderGroupsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lrHlh", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholderGroupsRoute", () => $63809c299c37f3a3$export$87043fcbf23f0119);
const $63809c299c37f3a3$export$87043fcbf23f0119 = {
    name: 'communications-stakeholder-groups',
    path: '/jira/communications/stakeholder-groups'
};

});

parcelRegister("5aUnj", function(module, exports) {
$parcel$export(module.exports, "StakeholdersSkeleton", () => $6b156284147a5ea6$export$9315c1a342c9fb32);
/* StakeholdersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6umqd = parcelRequire("6umqd");

var $7MItw = parcelRequire("7MItw");
const $6b156284147a5ea6$var$customCssStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order
const $6b156284147a5ea6$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $6b156284147a5ea6$export$9315c1a342c9fb32 = ()=>/*#__PURE__*/ $eJOHy.createElement($6b156284147a5ea6$var$Wrapper, null, /*#__PURE__*/ $eJOHy.createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7MItw))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    }));

});
parcelRegister("7MItw", function(module, exports) {
module.exports = new URL("stakeholders-skeleton.tpl.a7968e44.svg", import.meta.url).toString();

});


parcelRegister("hLwPy", function(module, exports) {
$parcel$export(module.exports, "stakeholderGroupsPageEntryPoint", () => $4d63f3b57632a9ba$export$838bd3c623ceac0);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4RIkD = parcelRequire("4RIkD");

var $bZXJd = parcelRequire("bZXJd");
const $4d63f3b57632a9ba$export$838bd3c623ceac0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bZXJd.communicationsStakeholderGroupsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $4RIkD.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("4RIkD", function(module, exports) {
$parcel$export(module.exports, "communicationsHorizontalNavEntrypoint", () => $3aacff5720a5fdfd$export$6862ea61ceda83f3);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $3aacff5720a5fdfd$export$6862ea61ceda83f3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("17O30")).then((module)=>module.HorizontalCommunicationsNav), {
        moduleId: "a456392a",
        moduleName: "HorizontalCommunicationsNav",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("17O30", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("adk1M").then(()=>parcelRequire('iofEW'));

});


parcelRegister("bZXJd", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholderGroupsEntrypoint", () => $2fb7d9e63b82e621$export$df18143715531ee1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $kyXQq = parcelRequire("kyXQq");

const $2fb7d9e63b82e621$export$df18143715531ee1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kGkYT")).then((module)=>module.StakeholderGroupsPage), {
        moduleId: "90ba51b1",
        moduleName: "StakeholderGroupsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {
            queries: {
                StakeholderGroupsPageQuery: {
                    parameters: (0, $kyXQq.default),
                    variables: {
                        first: 30
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("kyXQq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4542accea2f192c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c2bf0d0fcce689bfe74cda4ac04fc8c>>
 * @relayHash ec86b94bacd89c4d545c608256e2ce31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d385ee8659c1c15ce72a6945d4db5f703bb500913381ae8718823896ba7da93
const $4542accea2f192c1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StakeholderGroupsPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "StakeholderGroupPageContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StakeholderGroupsPageQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersConnection",
                    "kind": "LinkedField",
                    "name": "stakeholderComms_getStakeholderGroupsWithStakeholders",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "StakeholderCommsStakeholderGroupsAndStakeholders",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "StakeholderCommsStakeholderGroup",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "services"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "StakeholderCommsStakeholder",
                                            "kind": "LinkedField",
                                            "name": "stakeholders",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "avatar"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "aaid"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "StakeholderCommsNotificationPreference",
                                                    "kind": "LinkedField",
                                                    "name": "notificationPreference",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "emailId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ownerName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ownerAvatar"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "error"
                        },
                        {
                            "concreteType": "StakeholderCommsPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "handle": "connection",
                    "key": "StakeholderGroupTableLayout_stakeholderComms_getStakeholderGroupsWithStakeholders",
                    "kind": "LinkedHandle",
                    "name": "stakeholderComms_getStakeholderGroupsWithStakeholders"
                }
            ]
        },
        "params": {
            "id": "0d385ee8659c1c15ce72a6945d4db5f703bb500913381ae8718823896ba7da93",
            "metadata": {},
            "name": "StakeholderGroupsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4542accea2f192c1$var$node.hash = "ce93b94ed54a7afc00ff594c131c3334";
var $4542accea2f192c1$export$2e2bcd8739ae039 = $4542accea2f192c1$var$node;

});

parcelRegister("kGkYT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("54Ij5").then(()=>parcelRequire('fxoyS'));

});




parcelRegister("cGZ5m", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholdersRouteEntry", () => $beb1dd341221ad4f$export$c12bfa7616ac8400);

var $6xToB = parcelRequire("6xToB");

var $kizvV = parcelRequire("kizvV");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $5aUnj = parcelRequire("5aUnj");

var $ecyHK = parcelRequire("ecyHK");
const $beb1dd341221ad4f$export$c12bfa7616ac8400 = (0, $6xToB.createEntry)((0, $kizvV.communicationsStakeholdersRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $1f2LE.default)
        },
        skeleton: (0, $5aUnj.StakeholdersSkeleton),
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_stakeholder_management_platform') ? (0, $ecyHK.stakeholdersPageEntrypoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStakeholdersRouteEntry.tsx',
                whichExportToUse: 'communicationsStakeholdersRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kizvV", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholdersRoute", () => $ef1758a83ffe54af$export$9933513623f14d7f);
const $ef1758a83ffe54af$export$9933513623f14d7f = {
    name: 'communications-stakeholders',
    path: '/jira/communications/stakeholders'
};

});

parcelRegister("ecyHK", function(module, exports) {
$parcel$export(module.exports, "stakeholdersPageEntrypoint", () => $0cd85c16b7b4715f$export$24a5b3c3e5dd381e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4RIkD = parcelRequire("4RIkD");

var $iZq2f = parcelRequire("iZq2f");
const $0cd85c16b7b4715f$export$24a5b3c3e5dd381e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iZq2f.communicationsStakeholdersEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $4RIkD.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("iZq2f", function(module, exports) {
$parcel$export(module.exports, "communicationsStakeholdersEntrypoint", () => $24e9dba2481b9faf$export$2be0008a269b55af);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

var $aHX4e = parcelRequire("aHX4e");

const $24e9dba2481b9faf$export$2be0008a269b55af = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("eYOBM")).then((module)=>module.StakeholdersPage)), {
        moduleId: "52ac92a7",
        moduleName: "StakeholdersPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>{
        const filter = context.query.filter ? JSON.parse(context.query.filter) : null;
        const search = context.query.search ? {
            searchField: 'EMAIL_ID',
            searchValue: context.query.search
        } : null;
        return {
            queries: {
                StakeholdersPageQuery: {
                    parameters: (0, $aHX4e.default),
                    variables: {
                        filter: filter,
                        search: search,
                        first: 30
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("inQqC", function(module, exports) {
$parcel$export(module.exports, "clientSideOnly", () => $82b73592f648e5cd$export$7fda87e5e6d5a8d1);
const $82b73592f648e5cd$export$7fda87e5e6d5a8d1 = (x)=>x;

});

parcelRegister("aHX4e", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22bd5af09c4ac88$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<097c2c42a07ff2223cf935224cc0e17b>>
 * @relayHash dc02cba68b5b8d3e8f25932a9ba1fc85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba7a53e347f31a50b1c077c6ca77355786e1f50c5a176fba9eb0abdc12772654
const $f22bd5af09c4ac88$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "search"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "search",
            "variableName": "search"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StakeholdersPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "StakeholderPageContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StakeholdersPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "StakeholderCommsStakeholderConnection",
                    "kind": "LinkedField",
                    "name": "stakeholderComms_listStakeholders",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "StakeholderCommsStakeholderEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "StakeholderCommsStakeholder",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "aaid"
                                        },
                                        {
                                            "concreteType": "StakeholderCommsNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "notificationPreference",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "emailId"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "concreteType": "StakeholderCommsGroups",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "avatar"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "error"
                        },
                        {
                            "concreteType": "StakeholderCommsPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "filter",
                        "search"
                    ],
                    "handle": "connection",
                    "key": "StakeholderTableLayout_stakeholderComms_listStakeholders",
                    "kind": "LinkedHandle",
                    "name": "stakeholderComms_listStakeholders"
                }
            ]
        },
        "params": {
            "id": "ba7a53e347f31a50b1c077c6ca77355786e1f50c5a176fba9eb0abdc12772654",
            "metadata": {},
            "name": "StakeholdersPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f22bd5af09c4ac88$var$node.hash = "5d2fcc256d3d69fa8469975de7d26375";
var $f22bd5af09c4ac88$export$2e2bcd8739ae039 = $f22bd5af09c4ac88$var$node;

});

parcelRegister("eYOBM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kNg9U").then(()=>parcelRequire('krf2j'));

});




parcelRegister("lw6zb", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageConfigurationRouteEntry", () => $e904dc3a038da7c9$export$76b5cdb407565d67);

var $6xToB = parcelRequire("6xToB");

var $1d9BE = parcelRequire("1d9BE");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $8OTKt = parcelRequire("8OTKt");
const $e904dc3a038da7c9$export$76b5cdb407565d67 = (0, $6xToB.createEntry)((0, $1d9BE.communicationsStatusPageConfigurationRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_status_page_manage_platform') ? (0, $8OTKt.StatusPageConfigurationPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPageConfigurationRouteEntry.tsx',
                whichExportToUse: 'communicationsStatusPageConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1d9BE", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageConfigurationRoute", () => $2f8cacff0ccd5970$export$3e17d1189cad068e);
const $2f8cacff0ccd5970$export$3e17d1189cad068e = {
    name: 'communications-status-page-configuration',
    path: '/jira/communications/status-page/configuration/:pageId'
};

});

parcelRegister("8OTKt", function(module, exports) {
$parcel$export(module.exports, "StatusPageConfigurationPageEntryPoint", () => $3af5028757ceda57$export$60200b364291da35);

var $9zsp5 = parcelRequire("9zsp5");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6smQA = parcelRequire("6smQA");
const $3af5028757ceda57$export$60200b364291da35 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9zsp5.communicationsStatusPageConfigurationsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
    horizontalNavigation: (0, $6smQA.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("9zsp5", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageConfigurationsEntrypoint", () => $b66e58143a698cfa$export$2594f377bc858add);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

const $b66e58143a698cfa$export$2594f377bc858add = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("e4g81")).then((module)=>module.StatusPageConfigurationPage)), {
        moduleId: "128898db",
        moduleName: "StatusPageConfigurationPage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("e4g81", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("akl5K").then(()=>parcelRequire('aDQEH'));

});


parcelRegister("6smQA", function(module, exports) {
$parcel$export(module.exports, "horizontalStatusPageNavEntrypoint", () => $d11d36242a5f5f14$export$6940d30dce6de17b);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $d11d36242a5f5f14$export$6940d30dce6de17b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("187LS")).then((module)=>module.HorizontalStatusPageNav), {
        moduleId: "eb087ca7",
        moduleName: "HorizontalStatusPageNav",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("187LS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6D8ri").then(()=>parcelRequire('jXUXW'));

});




parcelRegister("h6dkb", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageCreateRouteEntry", () => $29d21c39797fa717$export$82c596f9b720f384);

var $6xToB = parcelRequire("6xToB");

var $fUKCS = parcelRequire("fUKCS");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $cgOnH = parcelRequire("cgOnH");
const $29d21c39797fa717$export$82c596f9b720f384 = (0, $6xToB.createEntry)((0, $fUKCS.communicationsStatusPageCreateRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_status_page_manage_platform') ? (0, $cgOnH.StatusPageCreatePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPageCreateRouteEntry.tsx',
                whichExportToUse: 'communicationsStatusPageCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fUKCS", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageCreateRoute", () => $cada66a11a97df2a$export$624f9ad34b2a53d8);
const $cada66a11a97df2a$export$624f9ad34b2a53d8 = {
    name: 'communications-status-page-create',
    path: '/jira/communications/status-page/create'
};

});

parcelRegister("cgOnH", function(module, exports) {
$parcel$export(module.exports, "StatusPageCreatePageEntryPoint", () => $f282569b4fe70606$export$110452142f595ae9);

var $4Elmv = parcelRequire("4Elmv");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6smQA = parcelRequire("6smQA");
const $f282569b4fe70606$export$110452142f595ae9 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4Elmv.communicationsStatusPageCreateEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
    horizontalNavigation: (0, $6smQA.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("4Elmv", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageCreateEntrypoint", () => $17e14fed1e795d51$export$d01ad4841fb1a7a);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

const $17e14fed1e795d51$export$d01ad4841fb1a7a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("jpPoS")).then((module)=>module.StatusPageCreatePage)), {
        moduleId: "70c7f721",
        moduleName: "StatusPageCreatePage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("jpPoS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g0vXa").then(()=>parcelRequire('emtky'));

});




parcelRegister("V63Fz", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageDetailsRouteEntry", () => $a8fd0f9628fd45f0$export$7ec231a670ad3d90);

var $6xToB = parcelRequire("6xToB");

var $2Hcxp = parcelRequire("2Hcxp");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $6cnXR = parcelRequire("6cnXR");
const $a8fd0f9628fd45f0$export$7ec231a670ad3d90 = (0, $6xToB.createEntry)((0, $2Hcxp.communicationsStatusPageDetailsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_status_page_manage_platform') ? (0, $6cnXR.StatusPageDetailsPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPageDetailsRouteEntry.tsx',
                whichExportToUse: 'communicationsStatusPageDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2Hcxp", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageDetailsRoute", () => $042bfa5dd13ad2b9$export$e6ce3e0e6a11a357);
const $042bfa5dd13ad2b9$export$e6ce3e0e6a11a357 = {
    name: 'communications-status-page-details',
    path: '/jira/communications/status-page/:pageId'
};

});

parcelRegister("6cnXR", function(module, exports) {
$parcel$export(module.exports, "StatusPageDetailsPageEntryPoint", () => $a512c532625f51b9$export$f50ecd5b433f8302);

var $dV5xI = parcelRequire("dV5xI");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6smQA = parcelRequire("6smQA");
const $a512c532625f51b9$export$f50ecd5b433f8302 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dV5xI.communicationsStatusPageDetailsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
    horizontalNavigation: (0, $6smQA.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("dV5xI", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageDetailsEntrypoint", () => $d2044ec1bae991d6$export$4bb0d7c5c07a6d39);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

const $d2044ec1bae991d6$export$4bb0d7c5c07a6d39 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("dbiZM")).then((module)=>module.StatusPageDetailsPage)), {
        moduleId: "958b26bb",
        moduleName: "StatusPageDetailsPage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("dbiZM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lUh4r").then(()=>parcelRequire('hgGNe'));

});




parcelRegister("ktWm2", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageManageRouteEntry", () => $05ea8ba538f010bd$export$2018afeaa0d2e5e9);

var $6xToB = parcelRequire("6xToB");

var $66DLj = parcelRequire("66DLj");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $aGhZ2 = parcelRequire("aGhZ2");
const $05ea8ba538f010bd$export$2018afeaa0d2e5e9 = (0, $6xToB.createEntry)((0, $66DLj.communicationsStatusPageManageRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_status_page_manage_platform') ? (0, $aGhZ2.statusPageManagePageEntrypoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPageManageRouteEntry.tsx',
                whichExportToUse: 'communicationsStatusPageManageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("66DLj", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageManageRoute", () => $688936f446285aaa$export$4e9ecbae53e3a486);
const $688936f446285aaa$export$4e9ecbae53e3a486 = {
    name: 'communications-status-page-manage',
    path: '/jira/communications/status-page-manage'
};

});

parcelRegister("aGhZ2", function(module, exports) {
$parcel$export(module.exports, "statusPageManagePageEntrypoint", () => $aea5c01323f64f1e$export$6590fa324a0d7052);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6smQA = parcelRequire("6smQA");

var $cg0JU = parcelRequire("cg0JU");
const $aea5c01323f64f1e$export$6590fa324a0d7052 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cg0JU.communicationsStatusPageManageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
    horizontalNavigation: (0, $6smQA.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("cg0JU", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageManageEntrypoint", () => $ad08531ce31f281a$export$226a26a49f2a5540);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

const $ad08531ce31f281a$export$226a26a49f2a5540 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("2bx6k")).then((module)=>module.StatusPageManagePage)), {
        moduleId: "680e5e24",
        moduleName: "StatusPageManagePage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        // No GraphQL preloading needed for this route
        return {};
    }
});

});
parcelRegister("2bx6k", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gcDrK").then(()=>parcelRequire('lbWy3'));

});




parcelRegister("jru5K", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageRouteEntry", () => $e64320bb7045ebe0$export$88a2753691734b92);

var $6xToB = parcelRequire("6xToB");

var $4Z1ku = parcelRequire("4Z1ku");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $9NmsS = parcelRequire("9NmsS");

var $1J5Hu = parcelRequire("1J5Hu");
const $e64320bb7045ebe0$export$88a2753691734b92 = (0, $6xToB.createEntry)((0, $4Z1ku.communicationsStatusPageRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
            sidebar: (0, $1f2LE.default)
        },
        entryPoint: ()=>{
            return (0, $4cTDP.fg)('communications_status_page_manage_platform') ? (0, $1J5Hu.StatusPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPageRouteEntry.tsx',
                whichExportToUse: 'communicationsStatusPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4Z1ku", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageRoute", () => $a19d12602b0b6e78$export$db69791340a78355);
const $a19d12602b0b6e78$export$db69791340a78355 = {
    name: 'communications-status-page',
    path: '/jira/communications/status-page'
};

});

parcelRegister("1J5Hu", function(module, exports) {
$parcel$export(module.exports, "StatusPageEntryPoint", () => $dccab75ec4092a4c$export$b2ae424106b2e3d7);

var $9ODlY = parcelRequire("9ODlY");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6smQA = parcelRequire("6smQA");
const $dccab75ec4092a4c$export$b2ae424106b2e3d7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9ODlY.communicationsStatusPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).STATUS_PAGE_MANAGE,
    horizontalNavigation: (0, $6smQA.horizontalStatusPageNavEntrypoint)
});

});
parcelRegister("9ODlY", function(module, exports) {
$parcel$export(module.exports, "communicationsStatusPageEntrypoint", () => $b3cb312631fbf0ae$export$6af3925e2dcbafc5);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

const $b3cb312631fbf0ae$export$6af3925e2dcbafc5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("1P8lc")).then((module)=>module.StatusPage)), {
        moduleId: "40d27b0f",
        moduleName: "StatusPage",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("1P8lc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("zuP1l").then(()=>parcelRequire('cxLwp'));

});




parcelRegister("2BDh0", function(module, exports) {
$parcel$export(module.exports, "compassProductSettingsRouteEntry", () => $8ed7619b22cea546$export$703b5090da478c9c);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $k5Vpa = parcelRequire("k5Vpa");

var $9NmsS = parcelRequire("9NmsS");

var $6iLpr = parcelRequire("6iLpr");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8ed7619b22cea546$var$LazyCompassProductSettingsPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gaQ8v"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $8ed7619b22cea546$var$CompassProductSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8ed7619b22cea546$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $8ed7619b22cea546$export$703b5090da478c9c = (0, $6xToB.createEntry)((0, $6iLpr.compassProductSettingsRoute), ()=>({
        group: 'global-settings',
        component: $8ed7619b22cea546$var$CompassProductSettingsComponent,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $k5Vpa.compassProductSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $8ed7619b22cea546$var$LazyCompassProductSettingsPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-compass-product-settings-entries/src/compassProductSettingsRouteEntry.tsx',
                whichExportToUse: 'compassProductSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k5Vpa", function(module, exports) {
$parcel$export(module.exports, "compassProductSettingsResource", () => $1b5e4a9067cd1ba4$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $1b5e4a9067cd1ba4$export$6cbcbd11d26ae36f);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $1b5e4a9067cd1ba4$export$d18ff068d6c25455 = (0, $l1VxS.createResource)({
    type: (0, $1eb4dd82f40cf71c$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $3ugTQ.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $1eb4dd82f40cf71c$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $1b5e4a9067cd1ba4$export$6cbcbd11d26ae36f = ()=>(0, $eJrcF.useResource)($1b5e4a9067cd1ba4$export$d18ff068d6c25455);

});
const $1eb4dd82f40cf71c$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $1eb4dd82f40cf71c$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("6iLpr", function(module, exports) {
$parcel$export(module.exports, "compassProductSettingsRoute", () => $ab7fd4c32714bac4$export$48d633ce1d0d2a0e);
const $ab7fd4c32714bac4$export$48d633ce1d0d2a0e = {
    name: 'compass-product-settings',
    path: '/jira/settings/products/compass',
    exact: true
};

});

parcelRegister("gaQ8v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b4YM8").then(()=>parcelRequire('4x7m1'));

});


parcelRegister("c7HRO", function(module, exports) {
$parcel$export(module.exports, "connectGeneralInvalidRouteEntry", () => $cd4f636d38699abe$export$d8088cb4e7cc7efd);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $5OsiD = parcelRequire("5OsiD");

var $d8BiX = parcelRequire("d8BiX");

var $36JSs = parcelRequire("36JSs");
const $cd4f636d38699abe$export$d8088cb4e7cc7efd = (0, $6xToB.createEntry)((0, $5OsiD.connectGeneralInvalidRoute), ()=>({
        group: 'connect',
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        component: (0, $36JSs.default),
        resources: (0, $d8BiX.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $36JSs.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-connect-entries/src/connectGeneralInvalidRouteEntry.tsx',
                whichExportToUse: 'connectGeneralInvalidRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5OsiD", function(module, exports) {
$parcel$export(module.exports, "connectGeneralInvalidRoute", () => $5b26b56fa24b53a8$export$486ffffd0a2797a5);

var $63tRy = parcelRequire("63tRy");
const $5b26b56fa24b53a8$export$486ffffd0a2797a5 = {
    name: 'connect-general-invalid',
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    query: (0, $63tRy.CONNECT_GENERAL_QUERY_PARAMS)
};

});
parcelRegister("63tRy", function(module, exports) {
$parcel$export(module.exports, "CONNECT_GENERAL_QUERY_PARAMS", () => $5b21dced9378a948$export$2fdb05fdbf78d595);
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $5b21dced9378a948$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json',
    'project.key?',
    'project.id?'
];

});


parcelRegister("d8BiX", function(module, exports) {
$parcel$export(module.exports, "getGeneralConnectRouteResources", () => $1175208f01dda0de$export$2c86c2f79b80cf77);
$parcel$export(module.exports, "getProjectConnectRouteDefaultResources", () => $1175208f01dda0de$export$4c06110e7d14ab3c);

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $kRv8K = parcelRequire("kRv8K");

var $7FIkD = parcelRequire("7FIkD");

var $b41XS = parcelRequire("b41XS");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");
const $1175208f01dda0de$export$2c86c2f79b80cf77 = ()=>[
        ...(0, $kRv8K.getBusinessProjectResources)(),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $enHI7.navigationSidebarGlobalResource),
        ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $7FIkD.connectGeneralResources),
        (0, $4VIcO.getConsolidationStateResource)()
    ];
const $1175208f01dda0de$export$4c06110e7d14ab3c = ()=>[
        ...(0, $kRv8K.getBusinessProjectResources)(),
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $b41XS.connectProjectResources)
    ];

});
parcelRegister("b41XS", function(module, exports) {
$parcel$export(module.exports, "connectProjectResources", () => $bbf230b3d3c324b1$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $fnx9L = parcelRequire("fnx9L");

var $9pJMP = parcelRequire("9pJMP");

var $l1VxS = parcelRequire("l1VxS");


const $bbf230b3d3c324b1$export$7d2d082a4b91a6c7 = (0, $l1VxS.createResource)({
    type: (0, $f71270049d49ef4d$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $fnx9L.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $9pJMP.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("9Qxqb"))
});

});
parcelRegister("fnx9L", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $c9fc058b98a5f055$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $c9fc058b98a5f055$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $c9fc058b98a5f055$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $c9fc058b98a5f055$export$752ef5ab3d7ab15f);

var $eSnSE = parcelRequire("eSnSE");

var $aEyM4 = parcelRequire("aEyM4");

var $imXGf = parcelRequire("imXGf");
const $c9fc058b98a5f055$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: true
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $eSnSE.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c9fc058b98a5f055$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $c9fc058b98a5f055$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $c9fc058b98a5f055$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $c9fc058b98a5f055$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $imXGf.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $aEyM4.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $c9fc058b98a5f055$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $c9fc058b98a5f055$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $c9fc058b98a5f055$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $c9fc058b98a5f055$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("aEyM4", function(module, exports) {
$parcel$export(module.exports, "extractData", () => $f0de9883562e19b9$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $f0de9883562e19b9$export$67db9e2d1b6ed865);
const $f0de9883562e19b9$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $f0de9883562e19b9$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $f71270049d49ef4d$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("9Qxqb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kTkfd").then(()=>parcelRequire('e68Yk'));

});



parcelRegister("36JSs", function(module, exports) {
$parcel$export(module.exports, "LazyGeneralConnect", () => $d6d3c040ac0d88f6$export$c33275abe6c1e577);
$parcel$export(module.exports, "default", () => $d6d3c040ac0d88f6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d6d3c040ac0d88f6$export$c33275abe6c1e577 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fndaj"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
const $d6d3c040ac0d88f6$var$AsyncGeneralConnect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d6d3c040ac0d88f6$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });
var $d6d3c040ac0d88f6$export$2e2bcd8739ae039 = $d6d3c040ac0d88f6$var$AsyncGeneralConnect;

});
parcelRegister("fndaj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1dl4M").then(()=>parcelRequire('dx7Jv'));

});



parcelRegister("2wLap", function(module, exports) {
$parcel$export(module.exports, "connectGeneralRouteEntry", () => $646d2275bae5d744$export$46273ee39bcd958b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $dO60j = parcelRequire("dO60j");

var $d8BiX = parcelRequire("d8BiX");

var $36JSs = parcelRequire("36JSs");
const $646d2275bae5d744$export$46273ee39bcd958b = (0, $6xToB.createEntry)((0, $dO60j.connectGeneralRoute), ()=>({
        group: 'connect',
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        component: (0, $36JSs.default),
        resources: (0, $d8BiX.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $36JSs.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-connect-entries/src/connectGeneralRouteEntry.tsx',
                whichExportToUse: 'connectGeneralRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dO60j", function(module, exports) {
$parcel$export(module.exports, "connectGeneralRoute", () => $78c09d42272238f6$export$1fda4850b6314ff0);

var $63tRy = parcelRequire("63tRy");
const $78c09d42272238f6$export$1fda4850b6314ff0 = {
    name: 'connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: (0, $63tRy.CONNECT_GENERAL_QUERY_PARAMS)
};

});


parcelRegister("3arhy", function(module, exports) {
$parcel$export(module.exports, "connectGeneralServiceDeskProjectRouteEntry", () => $503cb0345c3432e1$export$487a360459ad1bea);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $1PvPk = parcelRequire("1PvPk");

var $6Jf2i = parcelRequire("6Jf2i");

var $d8BiX = parcelRequire("d8BiX");

var $36JSs = parcelRequire("36JSs");
const $503cb0345c3432e1$export$487a360459ad1bea = (0, $6xToB.createEntry)((0, $6Jf2i.connectGeneralServiceDeskProjectRoute), ()=>({
        group: 'connect',
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        component: (0, $36JSs.default),
        resources: [
            ...(0, $d8BiX.getGeneralConnectRouteResources)(),
            ...(0, $1PvPk.getServiceDeskNavigationSingleResources)()
        ],
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $36JSs.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-connect-entries/src/connectGeneralServiceDeskProjectRouteEntry.tsx',
                whichExportToUse: 'connectGeneralServiceDeskProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6Jf2i", function(module, exports) {
$parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", () => $e6b03c0e2f966895$export$e8a58aee75961b55);
const $e6b03c0e2f966895$export$e8a58aee75961b55 = {
    name: 'connect-general-service-desk-project',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?',
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};

});


parcelRegister("9IZNs", function(module, exports) {
$parcel$export(module.exports, "connectProjectRouteEntry", () => $26e8e25e2b17ced9$export$96bdc57a01f2ee48);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $fbmQ3 = parcelRequire("fbmQ3");

var $d8BiX = parcelRequire("d8BiX");

var $dzuEl = parcelRequire("dzuEl");
const $26e8e25e2b17ced9$export$96bdc57a01f2ee48 = (0, $6xToB.createEntry)((0, $fbmQ3.connectProjectRoute), ()=>({
        group: 'connect',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        layout: (0, $ioHIu.genericProjectLayout),
        ufoName: 'jira-connect',
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...(0, $d8BiX.getProjectConnectRouteDefaultResources)(),
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $dzuEl.connectProjectsPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-connect-entries/src/connectProjectRouteEntry.tsx',
                whichExportToUse: 'connectProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fbmQ3", function(module, exports) {
$parcel$export(module.exports, "connectProjectRoute", () => $f44764dedad36013$export$27e7531864dfb704);

var $avJUJ = parcelRequire("avJUJ");
const $f44764dedad36013$export$27e7531864dfb704 = {
    name: 'connect-project',
    path: '/projects/:projectKey',
    query: (0, $avJUJ.CONNECT_PROJECT_QUERY_PARAMS)
};

});
parcelRegister("avJUJ", function(module, exports) {
$parcel$export(module.exports, "CONNECT_PROJECT_QUERY_PARAMS", () => $fa83517b6772ae47$export$9bb839aee83bf4d8);
const $fa83517b6772ae47$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];

});


parcelRegister("dzuEl", function(module, exports) {
$parcel$export(module.exports, "connectProjectsPageEntrypoint", () => $d72dd44cf681dc01$export$d7105af2aa9527d0);
$parcel$export(module.exports, "connectProjectsWithoutHorizontalNavPageEntrypoint", () => $d72dd44cf681dc01$export$8df81c5e9c00a7b4);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fBNI3 = parcelRequire("fBNI3");

var $9n5I0 = parcelRequire("9n5I0");
const $d72dd44cf681dc01$export$d7105af2aa9527d0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $fBNI3.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $d72dd44cf681dc01$export$8df81c5e9c00a7b4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $fBNI3.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("fBNI3", function(module, exports) {
$parcel$export(module.exports, "connectProjectsEntrypoint", () => $66846dd8f8b71f04$export$4ff832a017f5175c);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $66846dd8f8b71f04$export$4ff832a017f5175c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4Ljz4")), {
        moduleId: "2203c501",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                query: context.query
            }
        })
});

});
parcelRegister("4Ljz4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5hSjH").then(()=>parcelRequire('aqLmU'));

});




parcelRegister("1YKQh", function(module, exports) {
$parcel$export(module.exports, "createProjectRouteEntry", () => $7843f5d9f7ac1782$export$28887e2da22c839a);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $UpqWg = parcelRequire("UpqWg");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7843f5d9f7ac1782$var$LazyCreateProject = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fR4fF")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $7843f5d9f7ac1782$var$CreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7843f5d9f7ac1782$var$LazyCreateProject,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $7843f5d9f7ac1782$export$28887e2da22c839a = (0, $6xToB.createEntry)((0, $UpqWg.createProjectRoute), ()=>({
        group: 'components',
        component: $7843f5d9f7ac1782$var$CreateProject,
        layout: (0, $ioHIu.genericProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $7843f5d9f7ac1782$var$LazyCreateProject
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-create-project-entries/src/createProjectRouteEntry.tsx',
                whichExportToUse: 'createProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("UpqWg", function(module, exports) {
$parcel$export(module.exports, "createProjectRoute", () => $7eb1157664ce6def$export$5ce9108542315ac8);
const $7eb1157664ce6def$export$5ce9108542315ac8 = {
    name: 'create-project',
    path: '/jira/create-project',
    exact: true
};

});

parcelRegister("fR4fF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9skoV").then(()=>parcelRequire('7v6Xe'));

});


parcelRegister("2vkb8", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomerDetailsRouteEntry", () => $7cc8183b6f1cb078$export$9dfe67e6e721ca6d);

var $8GPyy = parcelRequire("8GPyy");

var $bPYMA = parcelRequire("bPYMA");

var $f56jI = parcelRequire("f56jI");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $g8uYY = parcelRequire("g8uYY");

var $3UyX6 = parcelRequire("3UyX6");

var $izOHw = parcelRequire("izOHw");
const $7cc8183b6f1cb078$var$customerServiceCustomerDetailsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8GPyy.customerServiceCustomerDetailsEntryPoint)
});
const $7cc8183b6f1cb078$export$9dfe67e6e721ca6d = (0, $6xToB.createEntry)((0, $f56jI.customerServiceCustomerDetailsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.customer-details',
        layout: (0, $7h3uc.globalLayout),
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('berry-6285-customers-l1') ? $7cc8183b6f1cb078$var$customerServiceCustomerDetailsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $3UyX6.CustomerDetailsPageQueryResource),
            (0, $izOHw.EntitlementsQueryResource),
            (0, $bPYMA.l1CustomersProjectProviderResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceCustomerDetailsRouteEntry.tsx',
                whichExportToUse: 'customerServiceCustomerDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8GPyy", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomerDetailsEntryPoint", () => $fe2c3aeb478bebb2$export$2e8cd0a95d30d16e);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $fe2c3aeb478bebb2$export$2e8cd0a95d30d16e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("it7D8")), {
        moduleId: "65bef27b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("it7D8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("ew0lk")
]).then(()=>parcelRequire('5Hm6Q'));

});


parcelRegister("bPYMA", function(module, exports) {
$parcel$export(module.exports, "l1CustomersProjectProviderResource", () => $c8dede7d70833347$export$5859972994597afe);

var $l1VxS = parcelRequire("l1VxS");

var $a9bFI = parcelRequire("a9bFI");
const $c8dede7d70833347$var$RESOURCE_TYPE_CSM_BASE_URL = 'L1_CUSTOMERS_PROJECT';
const $c8dede7d70833347$export$5859972994597afe = (0, $l1VxS.createResource)({
    type: $c8dede7d70833347$var$RESOURCE_TYPE_CSM_BASE_URL,
    getKey: ()=>'l1-customers-project',
    getData: async ()=>(0, $a9bFI.default)(),
    maxAge: 3600000
});

});
parcelRegister("a9bFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $54fc46ebb550eac1$export$2e2bcd8739ae039);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $4cTDP = parcelRequire("4cTDP");
const $54fc46ebb550eac1$var$getData = async ()=>{
    try {
        const v2projects = '/rest/api/2/project/search?maxResults=100&typeKey=customer_service&expand=permissions';
        // we check for browse access, which means user must be part of the project.
        // jira admin can Administer projects without being part of the actual project.
        // see https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-projects/#api-rest-api-3-project-search-get
        const v3projects = '/rest/api/3/project/search?expand=permissions&typeKey=customer_service&action=browse&maxResults=100&startAt=0';
        const data = await (0, $hgi0g.default)((0, $4cTDP.fg)('berry-6701-avoid-404-for-jiraadmin') ? v3projects : v2projects);
        const projectWhereAdmin = data?.values?.find((project)=>project.permissions.canEdit);
        // includes collaborator
        // collaborator will get 403 on customers and organizations list pages
        const projectWhereUser = data?.values?.find((project)=>!project.permissions.canEdit);
        return projectWhereAdmin || projectWhereUser || null;
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'l1CustomersProjectProvider',
                packageName: 'jiraRouterResourcesCustomerServiceL1CustomersProjectProvider',
                teamName: 'Boysenberry'
            },
            error: error instanceof Error ? error : undefined
        });
        throw error;
    }
};
var $54fc46ebb550eac1$export$2e2bcd8739ae039 = $54fc46ebb550eac1$var$getData;

});


parcelRegister("f56jI", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomerDetailsRoute", () => $90a12269398fb8cd$export$465a65a04726e2e6);
const $90a12269398fb8cd$export$465a65a04726e2e6 = {
    name: 'customer-service-customer-details',
    path: '/jira/customer-service/customers/:customerId',
    exact: true
};

});

parcelRegister("3UyX6", function(module, exports) {
$parcel$export(module.exports, "CustomerDetailsPageQueryResource", () => $e999423d71180dc7$export$b7c13e8503a1c9ab);

var $9FYIg = parcelRequire("9FYIg");

var $eAUPZ = parcelRequire("eAUPZ");
const $e999423d71180dc7$export$b7c13e8503a1c9ab = (0, $9FYIg.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eAUPZ.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eAUPZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $81fbff6a8fa795ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afd78c9c5f1446250b8a255671317ce3>>
 * @relayHash 6159df47506c760bc9d3bcb347c7de4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ba454c25ab6b2a91a8f66bf3811c0d9d12e24802b9f7ba7700b299fc78694f7
const $81fbff6a8fa795ed$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1ba454c25ab6b2a91a8f66bf3811c0d9d12e24802b9f7ba7700b299fc78694f7",
        "metadata": {},
        "name": "CustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $81fbff6a8fa795ed$export$2e2bcd8739ae039 = $81fbff6a8fa795ed$var$node;

});


parcelRegister("izOHw", function(module, exports) {
$parcel$export(module.exports, "EntitlementsQueryResource", () => $ddae7ed79786dcfb$export$c38ff8a452b9917d);

var $9FYIg = parcelRequire("9FYIg");

var $eAxCD = parcelRequire("eAxCD");
const $ddae7ed79786dcfb$export$c38ff8a452b9917d = (0, $9FYIg.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eAxCD.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eAxCD", function(module, exports) {
$parcel$export(module.exports, "default", () => $56209bad74e32a0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<474799fbeeeff1a6beda325ddd613334>>
 * @relayHash 95a37fafea41f7393615020271b944eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3de52a71d40720a4d9254d54021b84be0832bdb2474555266267ce6bc5edfe19
const $56209bad74e32a0f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EntitlementsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "Entitlement"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ThrowOnQueryError"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EntitlementsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3de52a71d40720a4d9254d54021b84be0832bdb2474555266267ce6bc5edfe19",
            "metadata": {},
            "name": "EntitlementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$56209bad74e32a0f$var$node.hash = "174c0b19de4219e635e33aa462e987e4";
var $56209bad74e32a0f$export$2e2bcd8739ae039 = $56209bad74e32a0f$var$node;

});



parcelRegister("ek1TG", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersRouteEntry", () => $568e65a7ff0ddf71$export$18c1302b859e0b5f);

var $6ZHUi = parcelRequire("6ZHUi");

var $bPYMA = parcelRequire("bPYMA");

var $jwPAS = parcelRequire("jwPAS");

var $cMc4W = parcelRequire("cMc4W");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $6JB46 = parcelRequire("6JB46");

var $g8uYY = parcelRequire("g8uYY");
const $568e65a7ff0ddf71$var$customerServiceCustomersPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6JB46.customerServiceCustomersEntryPoint)
});
const $568e65a7ff0ddf71$export$18c1302b859e0b5f = (0, $6xToB.createEntry)((0, $cMc4W.customerServiceCustomersRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.customers',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            horizontal: (0, $6ZHUi.AsyncCustomersNav)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('berry-6285-customers-l1') ? $568e65a7ff0ddf71$var$customerServiceCustomersPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bPYMA.l1CustomersProjectProviderResource),
            (0, $jwPAS.csmCustomerContextTenantMigratedStatusResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceCustomersRouteEntry.tsx',
                whichExportToUse: 'customerServiceCustomersRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6ZHUi", function(module, exports) {
$parcel$export(module.exports, "AsyncCustomersNav", () => $be4ceb789c665f7d$export$a96bad1d85441048);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $be4ceb789c665f7d$var$LazyCustomersNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9qpil")).then(({ CustomersHorizontalNav: CustomersHorizontalNav })=>CustomersHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-csm/customers/src/ui/index.tsx"
});
const $be4ceb789c665f7d$export$a96bad1d85441048 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-csm-customers-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($be4ceb789c665f7d$var$LazyCustomersNav, null));

});
parcelRegister("9qpil", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2vtcj").then(()=>parcelRequire('hbVwU'));

});


parcelRegister("jwPAS", function(module, exports) {
$parcel$export(module.exports, "csmCustomerContextTenantMigratedStatusResource", () => $40ec96d3d128887c$export$f89a4294229b7a16);

var $l1VxS = parcelRequire("l1VxS");

var $ezxcJ = parcelRequire("ezxcJ");
const $40ec96d3d128887c$export$f89a4294229b7a16 = (0, $l1VxS.createResource)({
    type: 'CSM_CUSTOMER_CONTEXT_TENANT_MIGRATED_STATUS',
    getKey: ()=>'csm-customer-context-tenant-migrated-status',
    getData: async ()=>(0, $ezxcJ.default)(),
    maxAge: 86400000,
    isBrowserOnly: true
});

});
parcelRegister("ezxcJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $abd6d7b12ddea1ed$export$2e2bcd8739ae039);

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $hgi0g = parcelRequire("hgi0g");
const $abd6d7b12ddea1ed$var$getData = async ()=>{
    try {
        if (!(0, $4cTDP.fg)('csm-barista-customer-context-rearch')) return false;
        const data = await (0, $hgi0g.default)('/gateway/api/jsm/csm/api/v1/migration/customer-context/storage-architecture/status');
        return data.isMigratedToNewStorageArch;
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'csmCustomerContextTenantMigratedStatusResource',
                packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmMigratedTenantStatus',
                teamName: 'Boysenberry'
            },
            error: error instanceof Error ? error : undefined
        });
        throw error;
    }
};
var $abd6d7b12ddea1ed$export$2e2bcd8739ae039 = $abd6d7b12ddea1ed$var$getData;

});


parcelRegister("6JB46", function(module, exports) {
$parcel$export(module.exports, "customerServiceCustomersEntryPoint", () => $c12a23b6c46ff813$export$f9e86fb3be37e94);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $c12a23b6c46ff813$export$f9e86fb3be37e94 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("ii1ve")), {
        moduleId: "ab08f703",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ii1ve", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("fFopZ")
]).then(()=>parcelRequire('kSakt'));

});



parcelRegister("5vEtc", function(module, exports) {
$parcel$export(module.exports, "customerServiceEscalationsRouteEntry", () => $215db75612ea2329$export$36a7c374f4474cc1);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lLLpQ = parcelRequire("lLLpQ");

var $hc29r = parcelRequire("hc29r");

var $lgUu3 = parcelRequire("lgUu3");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $215db75612ea2329$var$LazyServicedeskCustomerServiceEscalations = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ki3Sm"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $215db75612ea2329$var$ServicedeskCustomerServiceEscalations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $215db75612ea2329$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $215db75612ea2329$export$36a7c374f4474cc1 = (0, $6xToB.createEntry)((0, $lgUu3.customerServiceEscalationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $lLLpQ.componentFilterResource),
            (0, $hc29r.priorityFilterResource)
        ],
        component: $215db75612ea2329$var$ServicedeskCustomerServiceEscalations,
        perfMetricKey: 'jsm-customer-service-escalations-component-load',
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $215db75612ea2329$var$LazyServicedeskCustomerServiceEscalations
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                teamName: 'boysenberry'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-customer-service-escalations-entries/src/customerServiceEscalationsRouteEntry.tsx',
                whichExportToUse: 'customerServiceEscalationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lLLpQ", function(module, exports) {
$parcel$export(module.exports, "componentFilterResource", () => $2c16adcd153f09f9$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $2c16adcd153f09f9$export$e13868d6ab2288af);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $2c16adcd153f09f9$var$getDataLoader = ()=>(parcelRequire("kVaU3"));
const $2c16adcd153f09f9$export$306e389909032632 = (0, $l1VxS.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $2c16adcd153f09f9$var$getDataLoader
});
const $2c16adcd153f09f9$export$e13868d6ab2288af = ()=>(0, $eJrcF.useResource)($2c16adcd153f09f9$export$306e389909032632);

});
parcelRegister("kVaU3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gHmLE").then(()=>parcelRequire('xl1rO'));

});


parcelRegister("hc29r", function(module, exports) {
$parcel$export(module.exports, "priorityFilterResource", () => $32c1ef26ebfd7598$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $32c1ef26ebfd7598$export$3654f46b6bb12558);

var $4cTDP = parcelRequire("4cTDP");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $32c1ef26ebfd7598$var$getDataLoader = ()=>(parcelRequire("fP82U"));
const $32c1ef26ebfd7598$export$ca03c5f9fc44703e = (0, $l1VxS.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $32c1ef26ebfd7598$var$getDataLoader
});
const $32c1ef26ebfd7598$export$3654f46b6bb12558 = ()=>(0, $eJrcF.useResource)((0, $4cTDP.fg)('jcs_master_flag') ? $32c1ef26ebfd7598$export$ca03c5f9fc44703e : (0, $l1VxS.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
        getDataLoader: $32c1ef26ebfd7598$var$getDataLoader
    }));

});
parcelRegister("fP82U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1xv02").then(()=>parcelRequire('3WEzz'));

});


parcelRegister("lgUu3", function(module, exports) {
$parcel$export(module.exports, "customerServiceEscalationsRoute", () => $35e9854d0e3aa940$export$51e84b36f828d9ff);
const $35e9854d0e3aa940$export$51e84b36f828d9ff = {
    name: 'servicedesk-customer-service-escalations',
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("ki3Sm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g38XK").then(()=>parcelRequire('fnE71'));

});


parcelRegister("bHvbN", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedRouteEntry", () => $0569a1e9a9e1fbde$export$bf3ebc0c2cf4cbf4);

var $5RW99 = parcelRequire("5RW99");

var $9pJMP = parcelRequire("9pJMP");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $9BJU1 = parcelRequire("9BJU1");

var $aQoXd = parcelRequire("aQoXd");

var $ipDV0 = parcelRequire("ipDV0");

var $6kIK7 = parcelRequire("6kIK7");

var $lqiKv = parcelRequire("lqiKv");
const $0569a1e9a9e1fbde$export$bf3ebc0c2cf4cbf4 = (0, $6xToB.createEntry)((0, $ipDV0.customerServiceGetStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        perfMetricKey: 'customer-service-get-started-page-load',
        skeleton: (0, $6kIK7.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $kEdwd.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return 0, $lqiKv.customerServiceGetStartedPageEntryPoint;
        },
        component: (0, $9BJU1.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-customer-service-get-started-entries/src/customerServiceGetStartedRouteEntry.tsx',
                whichExportToUse: 'customerServiceGetStartedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kEdwd", function(module, exports) {
$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $4c371e8026b56fdb$export$191ce50629f40dbe);

var $l1VxS = parcelRequire("l1VxS");


const $4c371e8026b56fdb$var$getDataLoader = ()=>(parcelRequire("3JXsi"));
const $4c371e8026b56fdb$export$191ce50629f40dbe = (0, $l1VxS.createResource)({
    type: (0, $67a24649971d090c$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $4c371e8026b56fdb$var$getDataLoader
});

});
const $67a24649971d090c$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("3JXsi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("02e3i")
]).then(()=>parcelRequire('5KjQk'));

});


parcelRegister("ipDV0", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedRoute", () => $fc436167040e4e33$export$a29b57a3840da142);
const $fc436167040e4e33$export$a29b57a3840da142 = {
    name: 'customer-service-get-started',
    path: '/jira/servicedesk/projects/:projectKey/get-started',
    exact: true
};

});

parcelRegister("6kIK7", function(module, exports) {
$parcel$export(module.exports, "GettingStartedPageSkeleton", () => $5ae52f2a4a0f090c$export$525669daa9599ec);
/* GettingStartedPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $5oakB = parcelRequire("5oakB");
const $5ae52f2a4a0f090c$var$customCssStyles = null;
const $5ae52f2a4a0f090c$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5oakB))),
        className: (0, $hcewu.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });

});
parcelRegister("5oakB", function(module, exports) {
module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();

});


parcelRegister("lqiKv", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedPageEntryPoint", () => $f5c3b6ed7aadb696$export$fdc75e6cf24026f5);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hDAcB = parcelRequire("hDAcB");
const $f5c3b6ed7aadb696$export$fdc75e6cf24026f5 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $hDAcB.customerServiceGetStartedEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("hDAcB", function(module, exports) {
$parcel$export(module.exports, "customerServiceGetStartedEntryPoint", () => $c199224914f1915f$export$16f9ae4ef5a48d4a);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $c199224914f1915f$export$16f9ae4ef5a48d4a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hPPqq")), {
        moduleId: "63fb9144",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hPPqq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dIHvK").then(()=>parcelRequire('lS6bs'));

});




parcelRegister("7NfJj", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationDetailsRouteEntry", () => $4b420598a1540247$export$90042424f0ac9f60);

var $joeAz = parcelRequire("joeAz");

var $bPYMA = parcelRequire("bPYMA");

var $csr9W = parcelRequire("csr9W");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $g8uYY = parcelRequire("g8uYY");

var $2rGHH = parcelRequire("2rGHH");

var $2rHmc = parcelRequire("2rHmc");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");
const $4b420598a1540247$var$customerServiceOrganizationDetailsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $joeAz.customerServiceOrganizationDetailsEntryPoint)
});
const $4b420598a1540247$export$90042424f0ac9f60 = (0, $6xToB.createEntry)((0, $csr9W.customerServiceOrganizationDetailsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.organization-details',
        layout: (0, $7h3uc.globalLayout),
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('berry-6285-customers-l1') ? $4b420598a1540247$var$customerServiceOrganizationDetailsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $2rHmc.OrganizationDetailsPageQueryResource),
            (0, $2rGHH.EntitlementsEntitlementsQueryResource),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $czabB.jsmEmailDomainsListResource),
            (0, $bPYMA.l1CustomersProjectProviderResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceOrganizationDetailsRouteEntry.tsx',
                whichExportToUse: 'customerServiceOrganizationDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("joeAz", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationDetailsEntryPoint", () => $e15ba9f5091b00a5$export$b6d7904aa0b4dcb4);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $e15ba9f5091b00a5$export$b6d7904aa0b4dcb4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("dUmkJ")), {
        moduleId: "e88b79c5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dUmkJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("byFyU")
]).then(()=>parcelRequire('dXEk5'));

});


parcelRegister("csr9W", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationDetailsRoute", () => $99104bcfdd7ff0a9$export$b10e04667ad3ac02);
const $99104bcfdd7ff0a9$export$b10e04667ad3ac02 = {
    name: 'customer-service-organization-details',
    path: '/jira/customer-service/organizations/:organizationId',
    exact: true
};

});

parcelRegister("2rGHH", function(module, exports) {
$parcel$export(module.exports, "EntitlementsEntitlementsQueryResource", () => $ae75c6ccde1e8f8c$export$c1f7620990c1e585);

var $9FYIg = parcelRequire("9FYIg");

var $1TaB3 = parcelRequire("1TaB3");
const $ae75c6ccde1e8f8c$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $ae75c6ccde1e8f8c$export$c1f7620990c1e585 = (0, $9FYIg.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $1TaB3.default),
            variables: {
                organizationId: $ae75c6ccde1e8f8c$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("1TaB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec834e63ad847344$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1adf14eeb6917670d862e93fec193b5>>
 * @relayHash 3ed6a55d6b39a49ae6a95619ef16ff61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bd6ba9d1b06f3a5def83dee2e069e4810b9ca9e72e61e29df2d401cce168033
const $ec834e63ad847344$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EntitlementsEntitlementsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "Entitlement"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ThrowOnQueryError"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EntitlementsEntitlementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bd6ba9d1b06f3a5def83dee2e069e4810b9ca9e72e61e29df2d401cce168033",
            "metadata": {},
            "name": "EntitlementsEntitlementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ec834e63ad847344$var$node.hash = "7e7f56cea0bdd6489b3ab7f1512e9b84";
var $ec834e63ad847344$export$2e2bcd8739ae039 = $ec834e63ad847344$var$node;

});


parcelRegister("2rHmc", function(module, exports) {
$parcel$export(module.exports, "OrganizationDetailsPageQueryResource", () => $152b3c5382e2edd1$export$3ed29674f0cc8f97);

var $9FYIg = parcelRequire("9FYIg");

var $kQ3ch = parcelRequire("kQ3ch");
const $152b3c5382e2edd1$var$getCustomerServiceOrganizationAri = (organizationId, activationId)=>{
    return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};
const $152b3c5382e2edd1$export$3ed29674f0cc8f97 = (0, $9FYIg.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kQ3ch.default),
            variables: {
                organizationId: $152b3c5382e2edd1$var$getCustomerServiceOrganizationAri(String(match.params.organizationId), tenantContext.activationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("kQ3ch", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0d95078ed32eb93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f5a3e1d892b524b75c7a7408b7fd4f8>>
 * @relayHash 564337dbab683def385b386089972b3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0195a556cc8d68c6c38988b8e91ce0aa490d450932095e5a91f0fd9c51c8ad27
const $d0d95078ed32eb93$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "CustomDetailsSidebar"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ThrowOnQueryError"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0195a556cc8d68c6c38988b8e91ce0aa490d450932095e5a91f0fd9c51c8ad27",
            "metadata": {},
            "name": "OrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d0d95078ed32eb93$var$node.hash = "cca85a63efa4d2afa7aa698035d4c639";
var $d0d95078ed32eb93$export$2e2bcd8739ae039 = $d0d95078ed32eb93$var$node;

});


parcelRegister("czabB", function(module, exports) {
$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $f31fe5e5165a82b6$export$8e956348e5d47a3c);

var $l1VxS = parcelRequire("l1VxS");


const $f31fe5e5165a82b6$export$8e956348e5d47a3c = (0, $l1VxS.createResource)({
    type: (0, $e0c2d30570ac08fb$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("bNO8r"))
});

});
const $e0c2d30570ac08fb$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("bNO8r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8DxN8").then(()=>parcelRequire('1hCRG'));

});


parcelRegister("3OsCM", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $3653d199bce0332c$export$ccda79811a15bf5);

var $l1VxS = parcelRequire("l1VxS");


const $3653d199bce0332c$export$ccda79811a15bf5 = (0, $l1VxS.createResource)({
    type: (0, $db3054255b7b598f$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5VMDN"))
});

});
const $db3054255b7b598f$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("5VMDN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ehBKN").then(()=>parcelRequire('28dfS'));

});



parcelRegister("iCaX0", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationsRouteEntry", () => $c0c30555e989eef9$export$9d68d24d39463f80);

var $kyqHl = parcelRequire("kyqHl");

var $6ZHUi = parcelRequire("6ZHUi");

var $bPYMA = parcelRequire("bPYMA");

var $jwPAS = parcelRequire("jwPAS");

var $hh4zd = parcelRequire("hh4zd");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $g8uYY = parcelRequire("g8uYY");
const $c0c30555e989eef9$var$customerServiceOrganizationsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $kyqHl.customerServiceOrganizationsEntryPoint)
});
const $c0c30555e989eef9$export$9d68d24d39463f80 = (0, $6xToB.createEntry)((0, $hh4zd.customerServiceOrganizationsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.organizations',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            horizontal: (0, $6ZHUi.AsyncCustomersNav)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('berry-6285-customers-l1') ? $c0c30555e989eef9$var$customerServiceOrganizationsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bPYMA.l1CustomersProjectProviderResource),
            (0, $jwPAS.csmCustomerContextTenantMigratedStatusResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceOrganizationsRouteEntry.tsx',
                whichExportToUse: 'customerServiceOrganizationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kyqHl", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationsEntryPoint", () => $4db0d637233455a3$export$e076da0b42b3d61b);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $4db0d637233455a3$export$e076da0b42b3d61b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("dqqws")), {
        moduleId: "86c67190",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dqqws", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("eMKup")
]).then(()=>parcelRequire('hqpaf'));

});


parcelRegister("hh4zd", function(module, exports) {
$parcel$export(module.exports, "customerServiceOrganizationsRoute", () => $487fe050452beaf9$export$8b935f85541f706d);
const $487fe050452beaf9$export$8b935f85541f706d = {
    name: 'customer-service-organizations',
    path: '/jira/customer-service/organizations',
    exact: true
};

});


parcelRegister("36fLu", function(module, exports) {
$parcel$export(module.exports, "customerServiceProductsRouteEntry", () => $290e529a29cd3bb7$export$8e015e39dbc90d0b);

var $kk3ZI = parcelRequire("kk3ZI");

var $6ZHUi = parcelRequire("6ZHUi");

var $bPYMA = parcelRequire("bPYMA");

var $jwPAS = parcelRequire("jwPAS");

var $bU6mZ = parcelRequire("bU6mZ");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $g8uYY = parcelRequire("g8uYY");
const $290e529a29cd3bb7$var$customerServiceProductsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $kk3ZI.customerServiceProductsEntryPoint)
});
const $290e529a29cd3bb7$export$8e015e39dbc90d0b = (0, $6xToB.createEntry)((0, $bU6mZ.customerServiceProductsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.products',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            horizontal: (0, $6ZHUi.AsyncCustomersNav)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('berry-6285-customers-l1') ? $290e529a29cd3bb7$var$customerServiceProductsPageEntryPoint : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bPYMA.l1CustomersProjectProviderResource),
            (0, $jwPAS.csmCustomerContextTenantMigratedStatusResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceProductsRouteEntry.tsx',
                whichExportToUse: 'customerServiceProductsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kk3ZI", function(module, exports) {
$parcel$export(module.exports, "customerServiceProductsEntryPoint", () => $e582dd6732245e1c$export$cbe982d0d183808b);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $5yu2R = parcelRequire("5yu2R");
const $e582dd6732245e1c$var$PRODUCTS_PAGE_SIZE = 50;

const $e582dd6732245e1c$export$cbe982d0d183808b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("etTjU")), {
        moduleId: "54f8a565",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>({
            queries: {
                ProductsAppQuery: {
                    parameters: $5yu2R.default,
                    variables: {
                        cloudId: cloudId,
                        first: $e582dd6732245e1c$var$PRODUCTS_PAGE_SIZE
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("5yu2R", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbe57c2cf528fb69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<698ce2a98471a87410710c3c7c10230d>>
 * @relayHash 2f2525f72b335b5d911e7fb1e6f7b2df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6
const $cbe57c2cf528fb69$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6",
        "metadata": {},
        "name": "ProductsAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $cbe57c2cf528fb69$export$2e2bcd8739ae039 = $cbe57c2cf528fb69$var$node;

});

parcelRegister("etTjU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f2eMo").then(()=>parcelRequire('6Ea8e'));

});


parcelRegister("bU6mZ", function(module, exports) {
$parcel$export(module.exports, "customerServiceProductsRoute", () => $7fbd6b45b786ccc0$export$73e241aabf4c9c58);
const $7fbd6b45b786ccc0$export$73e241aabf4c9c58 = {
    name: 'customer-service-products',
    path: '/jira/customer-service/products',
    exact: true
};

});


parcelRegister("e54wO", function(module, exports) {
$parcel$export(module.exports, "customIssueRouteEntry", () => $d90cf6b802c1c59b$export$3813414450b75758);

var $kHlOR = parcelRequire("kHlOR");

var $4cTDP = parcelRequire("4cTDP");

var $2ZjY0 = parcelRequire("2ZjY0");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $iWhpv = parcelRequire("iWhpv");

var $2Qpxd = parcelRequire("2Qpxd");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $bwzwd = parcelRequire("bwzwd");

var $9U6YG = parcelRequire("9U6YG");
const $d90cf6b802c1c59b$export$3813414450b75758 = (0, $6xToB.createEntry)((0, $2Qpxd.customIssueRoute), ()=>({
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            // Keep this consistent with the one in customQueueRouteEntry.tsx, so it won't rerender the queue agent view component
            // when navigating between queues and issues.
            // Rereder could cause problem:
            // 1. Issue view will lose issue navigator component
            // 2. When navigating back to queue, the queue will lose the scroll position.
            horizontal: (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9U6YG.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            ...(0, $1PvPk.getTriageButtonPermissionResource)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $iWhpv.servicedeskIsItsmProjectResource),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $bwzwd.CustomQueueRouteComponent),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwzwd.LazyServicedeskQueuesAgentAndIssueView)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customIssueRouteEntry.tsx',
                whichExportToUse: 'customIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2ZjY0", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalNavQueue", () => $3d69ac55b6dae45f$export$5f20c7610c638983);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2imLM = parcelRequire("2imLM");

var $6zXPf = parcelRequire("6zXPf");

var $iX5t3 = parcelRequire("iX5t3");

var $8LnTF = parcelRequire("8LnTF");

var $2Qpxd = parcelRequire("2Qpxd");

var $hih5V = parcelRequire("hih5V");

var $2FqDG = parcelRequire("2FqDG");

var $26mRz = parcelRequire("26mRz");
const $3d69ac55b6dae45f$export$5f20c7610c638983 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    const isIssueView = route.name === (0, $2Qpxd.customIssueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name && issueKey;
    const content = !isIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-nav-queue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iX5t3.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26mRz.LazyHorizontalNavQueue), null));
    return (0, $6zXPf.getWillShowNav4)() ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3d69ac55b6dae45f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3d69ac55b6dae45f$var$styles
    }, content));
};
const $3d69ac55b6dae45f$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $3d69ac55b6dae45f$var$styles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("2Qpxd", function(module, exports) {
$parcel$export(module.exports, "customIssueRoute", () => $7ca5d0c219b8e601$export$2c4bc3091ab58cd0);
const $7ca5d0c219b8e601$export$2c4bc3091ab58cd0 = {
    name: 'servicedesk-queues-custom-issue-detail',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("26mRz", function(module, exports) {
$parcel$export(module.exports, "LazyHorizontalNavQueue", () => $672fa091873772f6$export$d5abd8e11ee6080b);

var $bQWwW = parcelRequire("bQWwW");

const $672fa091873772f6$export$d5abd8e11ee6080b = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("j3NQ5")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/queue/src/ui/HorizontalNavQueue.tsx"
});

});
parcelRegister("j3NQ5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("5m29h")
]).then(()=>parcelRequire('8VQU1'));

});



parcelRegister("ieQb1", function(module, exports) {
$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $f809acc9341aa882$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $f809acc9341aa882$export$d8ba398930f2f5f);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $6XhAO = parcelRequire("6XhAO");

const $f809acc9341aa882$export$647de7516d081bd8 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("6ZPli")),
    maxAge: Number.MAX_VALUE
});
const $f809acc9341aa882$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($f809acc9341aa882$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("6ZPli", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8kjXz").then(()=>parcelRequire('ieUfL'));

});


parcelRegister("bwzwd", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesAgentAndIssueView", () => $3fd45bf9eaf5b481$export$6f01bfb6fc18a06e);
$parcel$export(module.exports, "CustomQueueRouteComponent", () => $3fd45bf9eaf5b481$export$59d555419fbaa611);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

var $2dJFW = parcelRequire("2dJFW");

const $3fd45bf9eaf5b481$export$6f01bfb6fc18a06e = (0, $bQWwW.lazyForPaint)(()=>{
    return (0, $2dJFW.markAsProductBundleReady)((parcelRequire("hOl6H")));
}, {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $3fd45bf9eaf5b481$var$LazyServicedeskQueuesAgentAndIssueViewWithSsrError = ()=>{
    if (false && !(0, $4cTDP.fg)('enable_view_queues_content_ssr')) {
        const error = new Error('Skip content SSR for queues view');
        // @ts-expect-error exclude those errors from SSR reporting
        error.skipSsr = true;
        throw error;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3fd45bf9eaf5b481$export$6f01bfb6fc18a06e, null);
};
const $3fd45bf9eaf5b481$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3fd45bf9eaf5b481$var$LazyServicedeskQueuesAgentAndIssueViewWithSsrError,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: !(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')
    });
};

});
parcelRegister("hOl6H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8vSKt")
]).then(()=>parcelRequire('86K1L'));

});


parcelRegister("9U6YG", function(module, exports) {
$parcel$export(module.exports, "QueueLoadingSkeleton", () => $e75f46c99d6bd30b$export$d20068523efc567f);

var $eJOHy = parcelRequire("eJOHy");

var $lRxpy = parcelRequire("lRxpy");

var $6OSA0 = parcelRequire("6OSA0");

var $4cTDP = parcelRequire("4cTDP");

var $6zXPf = parcelRequire("6zXPf");
const $e75f46c99d6bd30b$export$d20068523efc567f = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && !(0, $4cTDP.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null));
};

});
parcelRegister("lRxpy", function(module, exports) {
$parcel$export(module.exports, "useStylingPatch", () => $b29a0528b0d1edc9$export$ed35078f707ec860);
$parcel$export(module.exports, "QueueNav3StylingPatchContainer", () => $b29a0528b0d1edc9$export$9cbbe53228ab978f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6zXPf = parcelRequire("6zXPf");

var $4cTDP = parcelRequire("4cTDP");

var $hih5V = parcelRequire("hih5V");

var $2FqDG = parcelRequire("2FqDG");

var $7MMy7 = parcelRequire("7MMy7");

var $8LnTF = parcelRequire("8LnTF");

var $ezY2M = parcelRequire("ezY2M");

var $iuwL5 = parcelRequire("iuwL5");

var $3z9R8 = parcelRequire("3z9R8");

var $aoMKL = parcelRequire("aoMKL");

var $2Qpxd = parcelRequire("2Qpxd");

var $9RE4U = parcelRequire("9RE4U");
const $b29a0528b0d1edc9$var$SEGMENT_KEY = 'queues-agent-view-top-layout-nav3';
const $b29a0528b0d1edc9$export$ed35078f707ec860 = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const [issueKey] = (0, $2FqDG.usePathParam)('issueKey');
    if (!(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')) return {
        shouldUseStylingPatch: false,
        isNav3QueueIssueViewRoute: false
    };
    const isNav3QueueRouteOld = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $7MMy7.customQueueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name && !issueKey);
    const isNav3QueueRouteNew = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $7MMy7.customQueueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name || // Only the Nav3 Queue content and Nav3 Category Queue content are wrapped with QueueNav3StylingPatchContainer.
    // The routes where we should doing this wrapping are queue route, category queue route and issue view route
    // The reason why we are also need to wrap the Queue content on issue view route is because we want to avoid re-rendering.
    // ----------------------------------------------------------------------------------------------------------
    // Inside the QueueNav3StylingPatchContainer (below), we will avoid putting the height on issue view route (because of this scroll problem).
    // This will not trigger the re-rendering because the DOM structure isn’t changed.
    route.name === (0, $2Qpxd.customIssueRoute).name);
    // customIssueRoute is issue view route for custom queue
    // while customPracticeQueueRoute contains route for both practice queue agent view and practice queue issue view, we need to check issueKey to determine if it's issue view route
    const isNav3QueueIssueViewRoute = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $2Qpxd.customIssueRoute).name || route.name === (0, $8LnTF.customPracticeQueueRoute).name && !!issueKey);
    const isNav3QueueRoute = (0, $4cTDP.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? isNav3QueueRouteNew : isNav3QueueRouteOld;
    const isNav3BoardRoute = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $iuwL5.customQueueBoardRoute).name || route.name === (0, $ezY2M.customPracticeQueueBoardRoute).name);
    const isNav3CalendarRoute = !(0, $6zXPf.getWillShowNav4)() && (route.name === (0, $3z9R8.customQueueCalendarRoute).name || route.name === (0, $aoMKL.customPracticeQueueCalendarRoute).name);
    return {
        shouldUseStylingPatch: isNav3QueueRoute || isNav3BoardRoute || isNav3CalendarRoute,
        isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute
    };
};
const $b29a0528b0d1edc9$export$9cbbe53228ab978f = ({ children: children })=>{
    const { shouldUseStylingPatch: shouldUseStylingPatch, isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute } = $b29a0528b0d1edc9$export$ed35078f707ec860();
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    if (shouldUseStylingPatch || !(0, $4cTDP.fg)('jsm_fix_queue_issue_view_navigate_back_state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-vc": (0, $4cTDP.fg)('jsm_view_inside_queue_ssr_metric') ? `${$b29a0528b0d1edc9$var$SEGMENT_KEY}${false && !isPageHydrating ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && !isPageHydrating && (0, $4cTDP.fg)('jsm_view_inside_queue_ssr_metric') ? $b29a0528b0d1edc9$var$SEGMENT_KEY : undefined,
        "data-ssr-placeholder-replace": false || isPageHydrating || !(0, $4cTDP.fg)('jsm_view_inside_queue_ssr_metric') ? undefined : $b29a0528b0d1edc9$var$SEGMENT_KEY,
        "data-testid": "horizontal-nav-queue.controllers.styling-patch.queue-nav-3-styling-patch-container",
        className: (0, $hcewu.default)([
            !isNav3QueueIssueViewRoute && "_ca0q1h05 _vchhusvi _1e0c1txw _2lx21bp4 _4t3i1osq"
        ])
    }, children);
    return children;
};
const $b29a0528b0d1edc9$var$nav3PaddingStyles = null;

});
parcelRegister("ezY2M", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueBoardRoute", () => $b21aec2e594727c2$export$47ae519519dbd803);
const $b21aec2e594727c2$export$47ae519519dbd803 = {
    name: 'servicedesk-queues-practice-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("iuwL5", function(module, exports) {
$parcel$export(module.exports, "customQueueBoardRoute", () => $60482c0d1d8abd43$export$5407961894c40126);
const $60482c0d1d8abd43$export$5407961894c40126 = {
    name: 'servicedesk-queues-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("3z9R8", function(module, exports) {
$parcel$export(module.exports, "customQueueCalendarRoute", () => $947a5826d96b9330$export$82a97d9fba2cfa9a);
const $947a5826d96b9330$export$82a97d9fba2cfa9a = {
    name: 'servicedesk-queues-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
    exact: true
};

});

parcelRegister("aoMKL", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueCalendarRoute", () => $a639ed70e298b726$export$5a0e47b0abcf7c2f);
const $a639ed70e298b726$export$5a0e47b0abcf7c2f = {
    name: 'servicedesk-queues-practice-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
    exact: true
};

});




parcelRegister("ft8RF", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueBoardRouteEntry", () => $1546556f2a4387de$export$7b0b0691f8b766cf);

var $kHlOR = parcelRequire("kHlOR");

var $4cTDP = parcelRequire("4cTDP");

var $26mRz = parcelRequire("26mRz");

var $2ZjY0 = parcelRequire("2ZjY0");

var $5RW99 = parcelRequire("5RW99");

var $hZn8E = parcelRequire("hZn8E");

var $6zXPf = parcelRequire("6zXPf");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $9BJU1 = parcelRequire("9BJU1");

var $ezY2M = parcelRequire("ezY2M");

var $aQoXd = parcelRequire("aQoXd");

var $kD31z = parcelRequire("kD31z");
const $1546556f2a4387de$export$7b0b0691f8b766cf = (0, $6xToB.createEntry)((0, $ezY2M.customPracticeQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $kD31z.boardPageEntryPoint) : (0, $kD31z.boardPageNav3EntryPoint);
            return undefined;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        skeleton: (0, $kD31z.BoardSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customPracticeQueueBoardRouteEntry.tsx',
                whichExportToUse: 'customPracticeQueueBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hZn8E", function(module, exports) {
$parcel$export(module.exports, "horizontalNavQueueResource", () => $1ea991232f726ef5$export$896712202052ca56);

var $9FYIg = parcelRequire("9FYIg");

var $2KVNq = parcelRequire("2KVNq");

var $2BUDW = parcelRequire("2BUDW");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $hBje1 = parcelRequire("hBje1");
const $1ea991232f726ef5$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const queueId = match.params.queueId;
    let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const queueAri = queueId ? (0, $2BUDW.JiraServicedeskQueueAri).create({
        siteId: cloudId,
        queueId: queueId || '',
        activationId: activationId
    }).toString() : '';
    const containerNavigationInput = queueAri ? {
        scopeId: queueAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: $2KVNq.default,
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            containerNavigationInput: containerNavigationInput,
            first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $1ea991232f726ef5$export$896712202052ca56 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_QUEUE_QUERY',
    getQuery: $1ea991232f726ef5$export$71eec30d9db46a56
}));

});
parcelRegister("2KVNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $006e919579626eae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c8059f14a3201b31e0652bd91e511bc>>
 * @relayHash ad9b22c18ca56c0cec6bb77e087f1a60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2
const $006e919579626eae$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2",
        "metadata": {},
        "name": "HorizontalNavQueueInnerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $006e919579626eae$export$2e2bcd8739ae039 = $006e919579626eae$var$node;

});


parcelRegister("kD31z", function(module, exports) {
$parcel$export(module.exports, "boardPageNav3EntryPoint", () => $c83d93be51937897$export$ae25ae5278cbd6a1);
$parcel$export(module.exports, "boardPageEntryPoint", () => $c83d93be51937897$export$552f44bed039f041);
$parcel$export(module.exports, "BoardSkeleton", () => $c83d93be51937897$export$325f821722dfa572);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

var $3PvPr = parcelRequire("3PvPr");

var $eIyjT = parcelRequire("eIyjT");

var $zNGiI = parcelRequire("zNGiI");

var $lRxpy = parcelRequire("lRxpy");

var $6zXPf = parcelRequire("6zXPf");
const $c83d93be51937897$export$ae25ae5278cbd6a1 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eIyjT.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c83d93be51937897$export$552f44bed039f041 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eIyjT.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $3PvPr.horizontalNavQueueEntrypoint)
});
const $c83d93be51937897$export$325f821722dfa572 = ()=>(0, $6zXPf.getWillShowNav4)() && !(0, $4cTDP.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $zNGiI.ClassicBoardSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $zNGiI.ClassicBoardSkeleton), null));

});
parcelRegister("3PvPr", function(module, exports) {
$parcel$export(module.exports, "horizontalNavQueueEntrypoint", () => $add8ea01289a3169$export$df9ea493099a3cc4);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2KVNq = parcelRequire("2KVNq");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $2BUDW = parcelRequire("2BUDW");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

const $add8ea01289a3169$export$df9ea493099a3cc4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("deyE6")), {
        moduleId: "664171c5",
        moduleName: "HorizontalNavQueueInner",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        projectId = projectId ?? '';
        const projectIdOrKey = projectId || projectKey;
        const queueAri = queueId ? (0, $2BUDW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const containerNavigationInput = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQueueQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2KVNq.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        containerNavigationInput: containerNavigationInput,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("deyE6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("b56AA")
]).then(()=>parcelRequire('25hyE'));

});


parcelRegister("eIyjT", function(module, exports) {
$parcel$export(module.exports, "boardEntryPoint", () => $f7d7b76d75ec55cb$export$937ca5a4cdc1a12e);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $f7d7b76d75ec55cb$export$937ca5a4cdc1a12e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("5U96y")), {
        moduleId: "286ebff8",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5U96y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("kNFvF"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("gZxHV")),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2J0Df")
]).then(()=>parcelRequire('aMLZ1'));

});




parcelRegister("bwD6U", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueCalendarRouteEntry", () => $77aa9aca48804f59$export$8e8d88d3af02e6f7);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $aoMKL = parcelRequire("aoMKL");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $4VIcO = parcelRequire("4VIcO");

var $c0h8V = parcelRequire("c0h8V");

var $5FSZM = parcelRequire("5FSZM");

var $hZn8E = parcelRequire("hZn8E");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $lgaNk = parcelRequire("lgaNk");
const $77aa9aca48804f59$export$8e8d88d3af02e6f7 = (0, $6xToB.createEntry)((0, $aoMKL.customPracticeQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $lgaNk.calendarPageEntryPoint) : (0, $lgaNk.calendarPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $lgaNk.CalendarSkeleton),
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customPracticeQueueCalendarRouteEntry.tsx',
                whichExportToUse: 'customPracticeQueueCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lgaNk", function(module, exports) {
$parcel$export(module.exports, "calendarPageNav3EntryPoint", () => $659b52ad76340769$export$4dc8c8e2c977ed01);
$parcel$export(module.exports, "calendarPageEntryPoint", () => $659b52ad76340769$export$eda0c2fb67f7d7e7);
$parcel$export(module.exports, "CalendarSkeleton", () => $659b52ad76340769$export$ebc7c47cc535837e);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

var $4mfV8 = parcelRequire("4mfV8");

var $3PvPr = parcelRequire("3PvPr");

var $lRxpy = parcelRequire("lRxpy");

var $F9BvL = parcelRequire("F9BvL");

var $6zXPf = parcelRequire("6zXPf");
const $659b52ad76340769$export$4dc8c8e2c977ed01 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4mfV8.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $659b52ad76340769$export$eda0c2fb67f7d7e7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4mfV8.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $3PvPr.horizontalNavQueueEntrypoint)
});
const $659b52ad76340769$export$ebc7c47cc535837e = ()=>(0, $6zXPf.getWillShowNav4)() && !(0, $4cTDP.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $F9BvL.ClassicCalendarSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $F9BvL.ClassicCalendarSkeleton), null));

});
parcelRegister("4mfV8", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $392a2ed62bbe99be$export$19cf4b398f638dc6);

var $4cTDP = parcelRequire("4cTDP");

var $lpUQd = parcelRequire("lpUQd");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
// This is the key used to store the calendar filters in the local storage
const $392a2ed62bbe99be$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $392a2ed62bbe99be$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
/**
 * Default Day Starts At Time in Calendar View Settings
 */ const $392a2ed62bbe99be$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
function $392a2ed62bbe99be$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $392a2ed62bbe99be$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $392a2ed62bbe99be$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $392a2ed62bbe99be$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $392a2ed62bbe99be$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: (0, $4cTDP.fg)('fix_jsm_calendar_scope_issue') ? [] : [
            String(context.match.params.projectKey)
        ],
        viewId: viewId
    };
}
function $392a2ed62bbe99be$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $392a2ed62bbe99be$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $392a2ed62bbe99be$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $392a2ed62bbe99be$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $392a2ed62bbe99be$var$toMidnightUTCString(selectedDate),
        mode: $392a2ed62bbe99be$var$toViewMode(viewRange),
        weekStart: $392a2ed62bbe99be$var$toWeekStart(weekStartsOn),
        ...(0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $392a2ed62bbe99be$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $392a2ed62bbe99be$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $392a2ed62bbe99be$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
    return '';
}
function $392a2ed62bbe99be$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $392a2ed62bbe99be$var$getStorageValue(storageKey) || ''
    };
}
function $392a2ed62bbe99be$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $392a2ed62bbe99be$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $392a2ed62bbe99be$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $392a2ed62bbe99be$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $392a2ed62bbe99be$export$19cf4b398f638dc6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("50gbV")), {
        moduleId: "7a55ad65",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $392a2ed62bbe99be$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = $392a2ed62bbe99be$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const scope = $392a2ed62bbe99be$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = $392a2ed62bbe99be$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $392a2ed62bbe99be$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        });
        const storageKeyForViewSettings = $392a2ed62bbe99be$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $392a2ed62bbe99be$var$VIEW_SETTINGS_STORAGE_KEY
        });
        const defaultViewRange = 'month';
        const storedConfig = $392a2ed62bbe99be$var$getStorageValue(storageKeyForViewSettings);
        const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
            viewRange: defaultViewRange,
            weekStartsOn: null,
            dayStartsAt: $392a2ed62bbe99be$var$DEFAULT_DAY_STARTS_AT,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false,
            colorBy: 'status'
        };
        const viewRange = viewSettingsConfig.viewRange ?? 'month';
        const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorBy = viewSettingsConfig.colorBy ?? 'status';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = $392a2ed62bbe99be$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $lpUQd.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $392a2ed62bbe99be$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $392a2ed62bbe99be$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $392a2ed62bbe99be$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $392a2ed62bbe99be$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $392a2ed62bbe99be$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        viewId: viewId,
                        skipFieldConfig: false,
                        pageLoadMoreEnabled: (0, $4cTDP.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4cTDP.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                dayStartsAt: viewSettingsConfig.dayStartsAt,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                colorBy: colorBy
            }
        };
    }
});

});
parcelRegister("50gbV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6TmB4").then(()=>parcelRequire('ly6Vc'));

});


parcelRegister("F9BvL", function(module, exports) {
$parcel$export(module.exports, "ClassicCalendarSkeleton", () => $76106232d0ffc3fb$export$49d3670908a8d8fe);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $HcYdQ = parcelRequire("HcYdQ");
const $76106232d0ffc3fb$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HcYdQ)))
    });

});
parcelRegister("HcYdQ", function(module, exports) {
module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();

});




parcelRegister("frNhT", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueRouteEntry", () => $49f9483b7c8aab0e$export$b43128c9b5db2a5e);

var $kHlOR = parcelRequire("kHlOR");

var $4cTDP = parcelRequire("4cTDP");

var $26mRz = parcelRequire("26mRz");

var $2ZjY0 = parcelRequire("2ZjY0");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hZn8E = parcelRequire("hZn8E");

var $i67QL = parcelRequire("i67QL");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $e30vg = parcelRequire("e30vg");

var $5L7qx = parcelRequire("5L7qx");

var $8LnTF = parcelRequire("8LnTF");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $6I8xu = parcelRequire("6I8xu");

var $bwzwd = parcelRequire("bwzwd");

var $9U6YG = parcelRequire("9U6YG");
const $49f9483b7c8aab0e$export$b43128c9b5db2a5e = (0, $6xToB.createEntry)((0, $8LnTF.customPracticeQueueRoute), ()=>({
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $bwzwd.CustomQueueRouteComponent),
        isHydrateRootEnabled: false,
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        skeleton: (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9U6YG.QueueLoadingSkeleton) : undefined,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            ...(0, $1PvPk.getTriageButtonPermissionResource)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $hZn8E.horizontalNavQueueResource)),
            ...(0, $1PvPk.getIssueViewResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('queues_jql_builder_hydration_query'), (0, $e30vg.queuesJqlBuilderHydrationQueryRelayResource))
        ],
        afterPaint: (0, $4cTDP.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? [
            (0, $eJe5A.LazyIssueApp),
            (0, $26mRz.LazyHorizontalNavQueue)
        ] : [
            (0, $eJe5A.LazyIssueApp),
            (0, $6I8xu.AsyncBulkActionToolbarLazy),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwzwd.LazyServicedeskQueuesAgentAndIssueView),
            (0, $i67QL.LazyForPaintServicedeskSidebar)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'jira-service-management',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customPracticeQueueRouteEntry.tsx',
                whichExportToUse: 'customPracticeQueueRouteEntry'
            },
            manifestName: 'jira-spa-jira-service-management.json',
            enabled: true
        }
    }));

});
parcelRegister("e30vg", function(module, exports) {
$parcel$export(module.exports, "queuesJqlBuilderHydrationQueryRelayResource", () => $2690d9e5a2424cee$export$222b1728cc9334ea);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");

var $3w0Dj = parcelRequire("3w0Dj");

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");
const $2690d9e5a2424cee$export$8d46a2efdf233f05 = 'queues-jql-builder-hydration-relay';
const $2690d9e5a2424cee$export$222b1728cc9334ea = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${$2690d9e5a2424cee$export$8d46a2efdf233f05}`,
    getKey: ()=>$2690d9e5a2424cee$export$8d46a2efdf233f05,
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $3w0Dj.default), {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: false,
            jql: '',
            filterAri: '',
            viewContext: null,
            input: {
                jql: ''
            },
            isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
        }, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null && (0, $jjfy5.QueryPromisesMap).get(queryReference.id)) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("3w0Dj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce1d0959192768f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5c77cbf7b99305f1107223511d2df8e>>
 * @relayHash 272c213df6b547b7dbc897ac9a46b41c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b3d13de30733668c0c47d689dc01a8178cfb463b102989d04df3e8b4c631f10
const $ce1d0959192768f4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isFilter"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPlanReleaseFeatureToggleEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v12 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v13 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v17 = [
        v15 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v16 /*: any*/ 
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ], v18 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = [
        v15 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v19 /*: any*/ 
            ]
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v26 = [
        v15 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v16 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v12 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v24 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v24 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useHydrationQueryLoaderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JQLBuilderUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "JQLEditorUIWithErrorBoundary"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "QuerySupportedContainerOld"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValuesUtils"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v14 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useHydrationQueryLoaderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v20 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v14 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v18 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3b3d13de30733668c0c47d689dc01a8178cfb463b102989d04df3e8b4c631f10",
            "metadata": {},
            "name": "useHydrationQueryLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ce1d0959192768f4$var$node.hash = "0275d35c12602c6ecd64ce8d4e362f29";
var $ce1d0959192768f4$export$2e2bcd8739ae039 = $ce1d0959192768f4$var$node;

});


parcelRegister("6I8xu", function(module, exports) {
$parcel$export(module.exports, "AsyncBulkActionToolbarLazy", () => $7f54d336d3737fd1$export$f0945fba2003d80a);
$parcel$export(module.exports, "AsyncBulkActionToolbar", () => $7f54d336d3737fd1$export$d53c287f3c6193b2);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $jjS5D = parcelRequire("jjS5D");

var $8IeH1 = parcelRequire("8IeH1");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");
// Match the height of the toolbar
const $7f54d336d3737fd1$var$HEIGHT = 24;

const $7f54d336d3737fd1$export$f0945fba2003d80a = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1PmBe")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/bulk-actions-toolbar/src/index.tsx"
});
const $7f54d336d3737fd1$export$d53c287f3c6193b2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira-servicedesk.bulk-actions.toolbar",
        packageName: "atlassian/jira-servicedesk-bulk-actions-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "servicedesk-bulk-actions-toolbar",
        fallback: (0, $4cTDP.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $7f54d336d3737fd1$var$styles.skeletonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            height: `${$7f54d336d3737fd1$var$HEIGHT}px`,
            width: "60vw",
            isShimmering: true
        })) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f54d336d3737fd1$export$f0945fba2003d80a, props)));
const $7f54d336d3737fd1$var$styles = {
    skeletonContainer: "_1bsbauwl _bfhkvuon _19bvu2gc"
};

});
parcelRegister("1PmBe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kifIe")
]).then(()=>parcelRequire('8cYfx'));

});



parcelRegister("iZ2AQ", function(module, exports) {
$parcel$export(module.exports, "customQueueBoardRouteEntry", () => $3b1fd5b4a83cdc1a$export$f94102e9d0a3b113);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $iuwL5 = parcelRequire("iuwL5");

var $aQoXd = parcelRequire("aQoXd");

var $4cTDP = parcelRequire("4cTDP");

var $4VIcO = parcelRequire("4VIcO");

var $alzbz = parcelRequire("alzbz");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $hZn8E = parcelRequire("hZn8E");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $kD31z = parcelRequire("kD31z");
const $3b1fd5b4a83cdc1a$export$f94102e9d0a3b113 = (0, $6xToB.createEntry)((0, $iuwL5.customQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $kD31z.boardPageEntryPoint) : (0, $kD31z.boardPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $kD31z.BoardSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        afterPaint: [
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customQueueBoardRouteEntry.tsx',
                whichExportToUse: 'customQueueBoardRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("2d55w", function(module, exports) {
$parcel$export(module.exports, "customQueueCalendarRouteEntry", () => $ab22129773969ec2$export$a6aaa9129c24f852);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $1PvPk = parcelRequire("1PvPk");

var $3z9R8 = parcelRequire("3z9R8");

var $aQoXd = parcelRequire("aQoXd");

var $4VIcO = parcelRequire("4VIcO");

var $c0h8V = parcelRequire("c0h8V");

var $5FSZM = parcelRequire("5FSZM");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $hZn8E = parcelRequire("hZn8E");

var $6zXPf = parcelRequire("6zXPf");

var $2ZjY0 = parcelRequire("2ZjY0");

var $26mRz = parcelRequire("26mRz");

var $lgaNk = parcelRequire("lgaNk");
const $ab22129773969ec2$export$a6aaa9129c24f852 = (0, $6xToB.createEntry)((0, $3z9R8.customQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $6zXPf.getWillShowNav4)() ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $6zXPf.getWillShowNav4)() ? (0, $lgaNk.calendarPageEntryPoint) : (0, $lgaNk.calendarPageNav3EntryPoint);
            return undefined;
        },
        afterPaint: [
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        skeleton: (0, $lgaNk.CalendarSkeleton),
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), (0, $hZn8E.horizontalNavQueueResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customQueueCalendarRouteEntry.tsx',
                whichExportToUse: 'customQueueCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("3bo4c", function(module, exports) {
$parcel$export(module.exports, "customQueueRouteEntry", () => $35090fd6a231bcdf$export$54a295e04e6cea33);

var $kHlOR = parcelRequire("kHlOR");

var $4cTDP = parcelRequire("4cTDP");

var $26mRz = parcelRequire("26mRz");

var $2ZjY0 = parcelRequire("2ZjY0");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hZn8E = parcelRequire("hZn8E");

var $i67QL = parcelRequire("i67QL");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $e30vg = parcelRequire("e30vg");

var $iWhpv = parcelRequire("iWhpv");

var $5L7qx = parcelRequire("5L7qx");

var $7MMy7 = parcelRequire("7MMy7");

var $aQoXd = parcelRequire("aQoXd");

var $6I8xu = parcelRequire("6I8xu");

var $bwzwd = parcelRequire("bwzwd");

var $9U6YG = parcelRequire("9U6YG");
const $35090fd6a231bcdf$export$54a295e04e6cea33 = (0, $6xToB.createEntry)((0, $7MMy7.customQueueRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        preloadOptions: {
            earlyChunks: (0, $4cTDP.fg)('queues-earlyscripts') ? [
                'queues-prefetch-early-entry'
            ] : []
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $2ZjY0.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $9U6YG.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            ...(0, $1PvPk.getTriageButtonPermissionResource)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $iWhpv.servicedeskIsItsmProjectResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $hZn8E.horizontalNavQueueResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('queues_jql_builder_hydration_query'), (0, $e30vg.queuesJqlBuilderHydrationQueryRelayResource))
        ],
        afterPaint: (0, $4cTDP.fg)('jsm_remove_queue_bulk_action_bar_from_preloading') ? [
            (0, $eJe5A.LazyIssueApp),
            (0, $26mRz.LazyHorizontalNavQueue)
        ] : [
            (0, $eJe5A.LazyIssueApp),
            (0, $6I8xu.AsyncBulkActionToolbarLazy),
            (0, $26mRz.LazyHorizontalNavQueue)
        ],
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $bwzwd.CustomQueueRouteComponent),
        isHydrateRootEnabled: false,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwzwd.LazyServicedeskQueuesAgentAndIssueView),
            (0, $i67QL.LazyForPaintServicedeskSidebar)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'jira-service-management',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queue-entries/src/customQueueRouteEntry.tsx',
                whichExportToUse: 'customQueueRouteEntry'
            },
            manifestName: 'jira-spa-jira-service-management.json',
            enabled: true
        }
    }));

});

parcelRegister("kINnF", function(module, exports) {
$parcel$export(module.exports, "dashboardEditRouteEntry", () => $ff2b2f103cf40f8e$export$9b0fdfd6a51a17de);

var $7IYIF = parcelRequire("7IYIF");


var $grWOk = parcelRequire("grWOk");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $jlaZM = parcelRequire("jlaZM");

var $9NmsS = parcelRequire("9NmsS");

var $2Ga0d = parcelRequire("2Ga0d");

var $hUpHQ = parcelRequire("hUpHQ");

var $8vUDE = parcelRequire("8vUDE");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $en43l = parcelRequire("en43l");
const $ff2b2f103cf40f8e$export$9b0fdfd6a51a17de = (0, $6xToB.createEntry)((0, $2Ga0d.dashboardEditRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ff2b2f103cf40f8e$var$pageEntryPoint,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $7IYIF.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)(),
            (0, $jlaZM.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $en43l.LazyForPaintBackgroundScripts),
            (0, $en43l.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/dashboardEditRouteEntry.tsx',
                whichExportToUse: 'dashboardEditRouteEntry'
            },
            enabled: true
        }
    }));
// Page entrypoint, referred to above...
const $ff2b2f103cf40f8e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8vUDE.dashboardEditEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("7IYIF", function(module, exports) {
$parcel$export(module.exports, "dashboardBackgroundScriptsLayout", () => $15dcb686237ae24b$export$f0a12e66953aa38a);

var $6dwgv = parcelRequire("6dwgv");

var $3O07j = parcelRequire("3O07j");
const $15dcb686237ae24b$export$f0a12e66953aa38a = (0, $6dwgv.createLayout)({
    globalComponents: [
        (0, $3O07j.DashboardBackgroundScripts)
    ]
});

});
parcelRegister("3O07j", function(module, exports) {
$parcel$export(module.exports, "DashboardBackgroundScripts", () => $caf28a7036a34af8$export$4095842bb2e8d712);

var $gMQDC = parcelRequire("gMQDC");

var $bJscI = parcelRequire("bJscI");
const $caf28a7036a34af8$export$4095842bb2e8d712 = (0, $bJscI.componentWithFG)('jira_dashboards_optimise_atf_gadgets_loading', (0, $gMQDC.LazyForPaintBackgroundScripts), (0, $gMQDC.LazyAfterPaintBackgroundScripts));
$caf28a7036a34af8$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';

});
parcelRegister("gMQDC", function(module, exports) {
$parcel$export(module.exports, "LazyAfterPaintBackgroundScripts", () => $aac4aec64484ba5b$export$d4768112536c9dc9);
$parcel$export(module.exports, "LazyForPaintBackgroundScripts", () => $aac4aec64484ba5b$export$b5c9ccba15f81486);

var $bQWwW = parcelRequire("bQWwW");

const $aac4aec64484ba5b$export$d4768112536c9dc9 = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("iz3Hw")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

const $aac4aec64484ba5b$export$b5c9ccba15f81486 = (0, $bQWwW.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("iz3Hw")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

});
parcelRegister("iz3Hw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dZ3IW").then(()=>parcelRequire('1NtAt'));

});




parcelRegister("jlaZM", function(module, exports) {
$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $eddd06b4219d924c$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $eddd06b4219d924c$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $eddd06b4219d924c$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $eddd06b4219d924c$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $eddd06b4219d924c$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $eddd06b4219d924c$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $eddd06b4219d924c$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $eddd06b4219d924c$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $eddd06b4219d924c$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $eddd06b4219d924c$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $eddd06b4219d924c$export$75ca1b431898fd09);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $5KBwc = parcelRequire("5KBwc");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $E0qsj = parcelRequire("E0qsj");

var $hElUD = parcelRequire("hElUD");


var $3qYSS = parcelRequire("3qYSS");

var $lQtHx = parcelRequire("lQtHx");

var $8Fsa4 = parcelRequire("8Fsa4");

var $rbj9K = parcelRequire("rbj9K");

var $fxH8d = parcelRequire("fxH8d");
const $eddd06b4219d924c$export$2853c0e656e89346 = (0, $l1VxS.createResource)({
    type: (0, $fd22ea3140eeb833$export$ca03ff6cc792cc16),
    getKey: $hElUD.getKey,
    getData: (0, $lQtHx.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $eddd06b4219d924c$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $eddd06b4219d924c$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $eddd06b4219d924c$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (0, $eJOHy.useCallback)((getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]), [
        resourceResponse
    ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $eddd06b4219d924c$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $eddd06b4219d924c$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $eddd06b4219d924c$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $eddd06b4219d924c$export$6a46406b05d8d13c = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$2853c0e656e89346);
const $eddd06b4219d924c$export$ef3fa55626812fa4 = (0, $E0qsj.createDependentResource)({
    type: (0, $fd22ea3140eeb833$export$e239393fd4e2bc85),
    getKey: $hElUD.getKey,
    depends: [
        (0, $fd22ea3140eeb833$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $E0qsj.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $fxH8d.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $E0qsj.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $3qYSS.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $eddd06b4219d924c$export$efe0eb9a44e08d38 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$ef3fa55626812fa4);
const $eddd06b4219d924c$export$39804ce8cc42cd04 = (0, $E0qsj.createDependentResource)({
    type: (0, $fd22ea3140eeb833$export$9e5db01432b13b67),
    getKey: $hElUD.getKey,
    depends: [
        (0, $fd22ea3140eeb833$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $E0qsj.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $fxH8d.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $E0qsj.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $rbj9K.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $eddd06b4219d924c$export$31b430e01a1caab5 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$39804ce8cc42cd04);
const $eddd06b4219d924c$export$4e0719e53da01e93 = (0, $l1VxS.createResource)({
    type: (0, $fd22ea3140eeb833$export$bce41807cc929d0f),
    getKey: $hElUD.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.DASHBOARD_GADGET_MODULE),
                (0, $fohjD.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $fohjD.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $fohjD.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $eddd06b4219d924c$export$36c9632be21fbb06 = (0, $l1VxS.createResource)({
    type: (0, $fd22ea3140eeb833$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $8Fsa4.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $eddd06b4219d924c$export$27f4c12e781b4572 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$36c9632be21fbb06);
const $eddd06b4219d924c$export$75ca1b431898fd09 = ()=>(0, $eJrcF.useResource)($eddd06b4219d924c$export$4e0719e53da01e93);

});
parcelRegister("E0qsj", function(module, exports) {
$parcel$export(module.exports, "withEitherDataOrError", () => $4baea0a192bade5c$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $4baea0a192bade5c$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $4baea0a192bade5c$export$36d5102d613df7c6);

var $l1VxS = parcelRequire("l1VxS");
var $dSu1v = parcelRequire("dSu1v");
const $4baea0a192bade5c$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $4baea0a192bade5c$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $dSu1v.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $4baea0a192bade5c$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $4baea0a192bade5c$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $l1VxS.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $4baea0a192bade5c$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$4baea0a192bade5c$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $4baea0a192bade5c$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("hElUD", function(module, exports) {
$parcel$export(module.exports, "getKey", () => $13f3de97d34e3670$export$a47fb462a08de82f);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");
const $13f3de97d34e3670$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $iluXv.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("iluXv", function(module, exports) {
$parcel$export(module.exports, "GADGET_DISPLAY", () => $0a37d7d1a1d083ba$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $0a37d7d1a1d083ba$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $0a37d7d1a1d083ba$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $0a37d7d1a1d083ba$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $0a37d7d1a1d083ba$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $0a37d7d1a1d083ba$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $0a37d7d1a1d083ba$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $0a37d7d1a1d083ba$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $0a37d7d1a1d083ba$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $0a37d7d1a1d083ba$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $0a37d7d1a1d083ba$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $0a37d7d1a1d083ba$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $0a37d7d1a1d083ba$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $0a37d7d1a1d083ba$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $0a37d7d1a1d083ba$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $0a37d7d1a1d083ba$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $0a37d7d1a1d083ba$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $0a37d7d1a1d083ba$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $0a37d7d1a1d083ba$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $0a37d7d1a1d083ba$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $0a37d7d1a1d083ba$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $0a37d7d1a1d083ba$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $0a37d7d1a1d083ba$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $0a37d7d1a1d083ba$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $0a37d7d1a1d083ba$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $0a37d7d1a1d083ba$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $0a37d7d1a1d083ba$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $0a37d7d1a1d083ba$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $0a37d7d1a1d083ba$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $0a37d7d1a1d083ba$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $0a37d7d1a1d083ba$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $0a37d7d1a1d083ba$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $0a37d7d1a1d083ba$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $0a37d7d1a1d083ba$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $0a37d7d1a1d083ba$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $0a37d7d1a1d083ba$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $0a37d7d1a1d083ba$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $0a37d7d1a1d083ba$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $0a37d7d1a1d083ba$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $0a37d7d1a1d083ba$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $0a37d7d1a1d083ba$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $0a37d7d1a1d083ba$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $0a37d7d1a1d083ba$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $0a37d7d1a1d083ba$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $0a37d7d1a1d083ba$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $0a37d7d1a1d083ba$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $0a37d7d1a1d083ba$export$f07dac7b8de3bda);


var $agYa8 = parcelRequire("agYa8");
const $0a37d7d1a1d083ba$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $0a37d7d1a1d083ba$export$86eaa19ea940a4f5 = 'maximized';
const $0a37d7d1a1d083ba$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $0a37d7d1a1d083ba$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $0a37d7d1a1d083ba$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $0a37d7d1a1d083ba$export$50eac80bcbebc737 = '10000';
const $0a37d7d1a1d083ba$export$e11ffd0409aa6522 = 80;
const $0a37d7d1a1d083ba$export$4d708f4c16ae3a73 = 16;
const $0a37d7d1a1d083ba$export$7cc65d02ca2e18ec = 'dashboard';
const $0a37d7d1a1d083ba$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $0a37d7d1a1d083ba$export$e281465c09f561d4 = 'dashboard-data';
const $0a37d7d1a1d083ba$export$46dd0168a7875b47 = 160;
const $0a37d7d1a1d083ba$var$COLOR_BLUE = '#2684ff';
const $0a37d7d1a1d083ba$var$COLOR_RED = '#ff5630';
const $0a37d7d1a1d083ba$var$COLOR_YELLOW = '#ffab00';
const $0a37d7d1a1d083ba$var$COLOR_GREEN = '#36b37e';
const $0a37d7d1a1d083ba$var$COLOR_TEAL = '#00b8d9';
const $0a37d7d1a1d083ba$var$COLOR_PURPLE = '#6554c0';
const $0a37d7d1a1d083ba$var$COLOR_GRAY = '#97a0af';
const $0a37d7d1a1d083ba$var$COLOR_WHITE = '#ffffff';
const $0a37d7d1a1d083ba$export$1468aefba37090f9 = {
    color1: $0a37d7d1a1d083ba$var$COLOR_BLUE,
    color2: $0a37d7d1a1d083ba$var$COLOR_RED,
    color3: $0a37d7d1a1d083ba$var$COLOR_YELLOW,
    color4: $0a37d7d1a1d083ba$var$COLOR_GREEN,
    color5: $0a37d7d1a1d083ba$var$COLOR_TEAL,
    color6: $0a37d7d1a1d083ba$var$COLOR_PURPLE,
    color7: $0a37d7d1a1d083ba$var$COLOR_GRAY,
    color8: $0a37d7d1a1d083ba$var$COLOR_WHITE
};
const $0a37d7d1a1d083ba$export$5d9e688e192a63ae = {
    [$0a37d7d1a1d083ba$var$COLOR_BLUE]: (0, $agYa8.default).blue,
    [$0a37d7d1a1d083ba$var$COLOR_RED]: (0, $agYa8.default).red,
    [$0a37d7d1a1d083ba$var$COLOR_YELLOW]: (0, $agYa8.default).yellow,
    [$0a37d7d1a1d083ba$var$COLOR_GREEN]: (0, $agYa8.default).green,
    [$0a37d7d1a1d083ba$var$COLOR_TEAL]: (0, $agYa8.default).teal,
    [$0a37d7d1a1d083ba$var$COLOR_PURPLE]: (0, $agYa8.default).purple,
    [$0a37d7d1a1d083ba$var$COLOR_GRAY]: (0, $agYa8.default).gray,
    [$0a37d7d1a1d083ba$var$COLOR_WHITE]: (0, $agYa8.default).white
};
const $0a37d7d1a1d083ba$export$6906a4beef307ac4 = {
    color1: (0, $7bb4c1736002a04a$exports).N10,
    color2: (0, $7bb4c1736002a04a$exports).N10,
    color3: (0, $7bb4c1736002a04a$exports).N500,
    color4: (0, $7bb4c1736002a04a$exports).N10,
    color5: (0, $7bb4c1736002a04a$exports).N500,
    color6: (0, $7bb4c1736002a04a$exports).N10,
    color7: (0, $7bb4c1736002a04a$exports).N10,
    color8: (0, $7bb4c1736002a04a$exports).N500
};
const $0a37d7d1a1d083ba$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $0a37d7d1a1d083ba$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $0a37d7d1a1d083ba$export$b0234a47b1a4a515 = 350;
const $0a37d7d1a1d083ba$export$9674cd14c20d1c89 = 250;
const $0a37d7d1a1d083ba$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $0a37d7d1a1d083ba$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $0a37d7d1a1d083ba$export$4f74f1f13671c49d = 'delete-dashboard';
const $0a37d7d1a1d083ba$export$3853fce65645c557 = 'copy-dashboard';
const $0a37d7d1a1d083ba$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $0a37d7d1a1d083ba$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $0a37d7d1a1d083ba$export$efbab4efa7252143 = 'create-dashboard';
const $0a37d7d1a1d083ba$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $0a37d7d1a1d083ba$export$f0e105144716a420 = 'view-dashboard-readonly';
const $0a37d7d1a1d083ba$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $0a37d7d1a1d083ba$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $0a37d7d1a1d083ba$export$3b17b4f7f722b1ae = 'add-gadget';
const $0a37d7d1a1d083ba$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $0a37d7d1a1d083ba$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $0a37d7d1a1d083ba$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $0a37d7d1a1d083ba$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $0a37d7d1a1d083ba$export$7254246f25b4cbc8 = 'change-layout';
const $0a37d7d1a1d083ba$export$40c4d345e57fce2d = 'delete-gadget';
const $0a37d7d1a1d083ba$export$43fb10a4d8374f1a = 'view-react-gadget';
const $0a37d7d1a1d083ba$export$2f961c74af6d8735 = 'dashboardView';
const $0a37d7d1a1d083ba$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $0a37d7d1a1d083ba$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $0a37d7d1a1d083ba$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $0a37d7d1a1d083ba$export$eba1a497984af3ae = 'systemDashboardEdit';
const $0a37d7d1a1d083ba$export$3578044b625436f9 = 'copyDashboard';
const $0a37d7d1a1d083ba$export$48bb59a846d62ea0 = 'automaticRefresh';
const $0a37d7d1a1d083ba$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $0a37d7d1a1d083ba$export$fabf79b25b44377f = 'duplicateGadget';
const $0a37d7d1a1d083ba$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $0a37d7d1a1d083ba$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $0a37d7d1a1d083ba$export$ada294d471e7dfc3 = 1000;
const $0a37d7d1a1d083ba$export$f4280aaeba4d1d08 = 30000;
const $0a37d7d1a1d083ba$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $0a37d7d1a1d083ba$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $0a37d7d1a1d083ba$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});
parcelRegister("agYa8", function(module, exports) {
$parcel$export(module.exports, "default", () => $70eb3035b95f7a2b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $70eb3035b95f7a2b$var$messages = (0, $7qGN1.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});
var $70eb3035b95f7a2b$export$2e2bcd8739ae039 = $70eb3035b95f7a2b$var$messages;

});



const $fd22ea3140eeb833$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $fd22ea3140eeb833$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $fd22ea3140eeb833$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $fd22ea3140eeb833$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $fd22ea3140eeb833$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';

parcelRegister("3qYSS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dacccd1f2016ac0$export$2e2bcd8739ae039);

var $a8PVz = parcelRequire("a8PVz");

var $E0qsj = parcelRequire("E0qsj");

var $ljFr2 = parcelRequire("ljFr2");
const $2dacccd1f2016ac0$var$getAMDModulesData = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $E0qsj.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $ljFr2.loadAmdModules)((0, $a8PVz.asyncWrmRequire), moduleNames) ? (0, $ljFr2.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };
var $2dacccd1f2016ac0$export$2e2bcd8739ae039 = $2dacccd1f2016ac0$var$getAMDModulesData;

});
parcelRegister("ljFr2", function(module, exports) {
$parcel$export(module.exports, "loadAmdModules", () => $0ebb29f40170e1c7$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $0ebb29f40170e1c7$export$d74eab33af9baaea);

var $eSnSE = parcelRequire("eSnSE");

var $iluXv = parcelRequire("iluXv");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $0ebb29f40170e1c7$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $0ebb29f40170e1c7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$0ebb29f40170e1c7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $0ebb29f40170e1c7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $iluXv.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $0ebb29f40170e1c7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $0ebb29f40170e1c7$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $iluXv.CONNECT_ITEM_AMD_MODULE) ? $0ebb29f40170e1c7$var$ConnectDashboardItem : $0ebb29f40170e1c7$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $eSnSE.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$0ebb29f40170e1c7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $eSnSE.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("lQtHx", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe7193624272bdef$export$2e2bcd8739ae039);

var $7DwRl = parcelRequire("7DwRl");

var $eSnSE = parcelRequire("eSnSE");

var $7rykd = parcelRequire("7rykd");

var $l1whs = parcelRequire("l1whs");

var $dnNPa = parcelRequire("dnNPa");

var $i6ThV = parcelRequire("i6ThV");

var $hElUD = parcelRequire("hElUD");

var $fxH8d = parcelRequire("fxH8d");
const $fe7193624272bdef$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $fxH8d.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $l1whs.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $i6ThV.default)(wrmBundleDescriptor) : null,
            (0, $dnNPa.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
const $fe7193624272bdef$var$getConfigAndWRMData = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    try {
        const { route: route, query: query } = context;
        const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $7rykd.getDashboardsConfig)(query.dashboardId) : [
            await (0, $7rykd.default)((0, $hElUD.getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, $7DwRl.mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $fe7193624272bdef$var$generateScriptTagAndPreloadedModuleNames(configs);
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.get-config-and-wrm-data', `Failed to get dashboard configuration and wrm data: route=[${context.route.name}], query=[${JSON.stringify(context.query)}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
var $fe7193624272bdef$export$2e2bcd8739ae039 = $fe7193624272bdef$var$getConfigAndWRMData;

});
parcelRegister("7DwRl", function(module, exports) {
$parcel$export(module.exports, "mapToReactGadgets", () => $70e6ea57c1c19022$export$c90615c5eb218d50);

var $4cTDP = parcelRequire("4cTDP");
const $70e6ea57c1c19022$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $4cTDP.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $4cTDP.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $4cTDP.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $4cTDP.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $4cTDP.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("7rykd", function(module, exports) {
$parcel$export(module.exports, "getDashboardsConfig", () => $db5ea9750860430f$export$1264b6af3adf5084);
$parcel$export(module.exports, "default", () => $db5ea9750860430f$export$2e2bcd8739ae039);

var $hgi0g = parcelRequire("hgi0g");

var $eSnSE = parcelRequire("eSnSE");
const $db5ea9750860430f$var$getDashboardConfig = async (id)=>{
    try {
        return (0, $hgi0g.default)(`/rest/dashboards/1.0/${id}.json`);
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config json with id=[${id}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
const $db5ea9750860430f$export$1264b6af3adf5084 = async (idsCsv)=>{
    try {
        return (0, $hgi0g.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config with ids=[${idsCsv}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
var $db5ea9750860430f$export$2e2bcd8739ae039 = $db5ea9750860430f$var$getDashboardConfig;

});

parcelRegister("l1whs", function(module, exports) {
$parcel$export(module.exports, "default", () => $28a7b496d07a93d7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");

var $hgi0g = parcelRequire("hgi0g");

var $eSnSE = parcelRequire("eSnSE");
const $28a7b496d07a93d7$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $28a7b496d07a93d7$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
const $28a7b496d07a93d7$var$fetchWrmBundleDescriptor = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $iluXv.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$28a7b496d07a93d7$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $28a7b496d07a93d7$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    try {
        return (0, $hgi0g.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    } catch (error) {
        (0, $eSnSE.default).unsafeErrorWithCustomerData('spa-apps.dashboard.wrm-bundle-descriptor', `Failed to fetch wrm bundle with contexts [${contextsToRequire.join(',')}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
var $28a7b496d07a93d7$export$2e2bcd8739ae039 = $28a7b496d07a93d7$var$fetchWrmBundleDescriptor;

});

parcelRegister("dnNPa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a5f13865e07cedd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");

var $dI81q = parcelRequire("dI81q");
const $3a5f13865e07cedd$var$generatePreloadLinkTags = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $dI81q.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $iluXv.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $iluXv.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};
var $3a5f13865e07cedd$export$2e2bcd8739ae039 = $3a5f13865e07cedd$var$generatePreloadLinkTags;

});
parcelRegister("dI81q", function(module, exports) {
$parcel$export(module.exports, "getPrefetches", () => $3131787f134a9e3e$export$3144db3718ad5e57);

var $cA5jK = parcelRequire("cA5jK");
const $3131787f134a9e3e$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $cA5jK.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("cA5jK", function(module, exports) {
$parcel$export(module.exports, "getPrefetchDict", () => $249224b7a18d3fb6$export$244cea94cab19e07);

var $4cTDP = parcelRequire("4cTDP");

var $dJT4y = parcelRequire("dJT4y");

var $ehfMg = parcelRequire("ehfMg");

var $9bbm9 = parcelRequire("9bbm9");
const $249224b7a18d3fb6$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $ehfMg.getActivityStreamPrefetchLink),
            priority: (0, $dJT4y.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $9bbm9.getFilterResultsPrefetchLink),
            priority: (0, $dJT4y.LOADING_PRIORITY).LOW,
            enabled: !(0, $4cTDP.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("dJT4y", function(module, exports) {
$parcel$export(module.exports, "LOADING_PRIORITY", () => $23c62257b27bbbf0$export$cb9b1f2232733c1b);
const $23c62257b27bbbf0$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("ehfMg", function(module, exports) {
$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $76ab8a67f710df71$export$360928f5bf059a9e);

var $b5RwB = parcelRequire("b5RwB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76ab8a67f710df71$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $76ab8a67f710df71$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $76ab8a67f710df71$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $76ab8a67f710df71$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $76ab8a67f710df71$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $76ab8a67f710df71$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $76ab8a67f710df71$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $76ab8a67f710df71$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $76ab8a67f710df71$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(params).replace(/%20/g, '+');
};
const $76ab8a67f710df71$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $76ab8a67f710df71$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $76ab8a67f710df71$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$76ab8a67f710df71$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("9bbm9", function(module, exports) {
$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $f18556a61bfce23a$export$947cd90004054337);

var $b5RwB = parcelRequire("b5RwB");
const $f18556a61bfce23a$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $f18556a61bfce23a$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$f18556a61bfce23a$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("i6ThV", function(module, exports) {
$parcel$export(module.exports, "default", () => $53883be98866e9a2$export$2e2bcd8739ae039);
const $53883be98866e9a2$var$generateScriptTags = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};
var $53883be98866e9a2$export$2e2bcd8739ae039 = $53883be98866e9a2$var$generateScriptTags;

});

parcelRegister("fxH8d", function(module, exports) {
$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $327bd7a3fadeaf27$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $327bd7a3fadeaf27$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $iluXv = parcelRequire("iluXv");

var $8MjsA = parcelRequire("8MjsA");
const $327bd7a3fadeaf27$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $iluXv.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $327bd7a3fadeaf27$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $8MjsA.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("8MjsA", function(module, exports) {
$parcel$export(module.exports, "isReactKey", () => $52b83e6aaadc4f03$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $52b83e6aaadc4f03$export$2e2bcd8739ae039);

var $17XsP = parcelRequire("17XsP");

var $4A8Tm = parcelRequire("4A8Tm");

var $8ospY = parcelRequire("8ospY");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $52b83e6aaadc4f03$var$GADGETS_DEFINITION = {
    [(0, $8ospY.REACT_KEY).FILTER_RESULTS]: (0, $4A8Tm.FILTER_RESULTS_DEFINITION),
    [(0, $8ospY.REACT_KEY).ASSIGNED_TO_ME]: (0, $4A8Tm.ASSIGNED_TO_ME_DEFINITION),
    [(0, $8ospY.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $4A8Tm.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $8ospY.REACT_KEY).VOTED_ISSUES]: (0, $4A8Tm.VOTED_ISSUES_DEFINITION),
    [(0, $8ospY.REACT_KEY).WATCHED_ISSUES]: (0, $4A8Tm.WATCHED_ISSUES_DEFINITION),
    [(0, $8ospY.REACT_KEY).CUSTOM_REPORT]: (0, $17XsP.default)
};
function $52b83e6aaadc4f03$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $8ospY.REACT_KEY)).includes(key));
}
var $52b83e6aaadc4f03$export$2e2bcd8739ae039 = $52b83e6aaadc4f03$var$GADGETS_DEFINITION;

});
parcelRegister("17XsP", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ba03e9ae9cfb516$export$2e2bcd8739ae039);

var $lwRcY = parcelRequire("lwRcY");

var $2qfPu = parcelRequire("2qfPu");

var $hLUwd = parcelRequire("hLUwd");
const $5ba03e9ae9cfb516$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $2qfPu.LazyCustomReportGadgetView),
    componentEdit: (0, $lwRcY.LazyCustomReportGadgetEdit),
    getInitialState: $hLUwd.default,
    preload: $2qfPu.preload
};
var $5ba03e9ae9cfb516$export$2e2bcd8739ae039 = $5ba03e9ae9cfb516$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("lwRcY", function(module, exports) {
$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $9c98ae885e285cdb$export$475e4a6fb8f40116);

var $bQWwW = parcelRequire("bQWwW");

const $9c98ae885e285cdb$export$475e4a6fb8f40116 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3n2Ey")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("3n2Ey", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9YvvC").then(()=>parcelRequire('1lUBb'));

});


parcelRegister("2qfPu", function(module, exports) {
$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $9dbbbd3c17549925$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $9dbbbd3c17549925$export$513ccb98c53b8039);

var $bQWwW = parcelRequire("bQWwW");

const $9dbbbd3c17549925$export$27df795d4f3ff173 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("buy9G")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $9dbbbd3c17549925$export$513ccb98c53b8039 } = $9dbbbd3c17549925$export$27df795d4f3ff173;

});
parcelRegister("buy9G", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9LqSU").then(()=>parcelRequire('TOAHd'));

});


parcelRegister("hLUwd", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6705b5a7e1c76b7$export$2e2bcd8739ae039);
const $f6705b5a7e1c76b7$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $f6705b5a7e1c76b7$export$2e2bcd8739ae039 = $f6705b5a7e1c76b7$var$getInitialState;

});


parcelRegister("4A8Tm", function(module, exports) {
$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $6dcd4e956050d432$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $6dcd4e956050d432$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $6dcd4e956050d432$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $6dcd4e956050d432$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $6dcd4e956050d432$export$5109728db227eae);

var $eJOHy = parcelRequire("eJOHy");

var $3MbRU = parcelRequire("3MbRU");

var $8G0iN = parcelRequire("8G0iN");

var $ixr5d = parcelRequire("ixr5d");

var $92GBg = parcelRequire("92GBg");

var $bz1Gz = parcelRequire("bz1Gz");

var $gVMtN = parcelRequire("gVMtN");

var $i222u = parcelRequire("i222u");
const $6dcd4e956050d432$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $6dcd4e956050d432$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $6dcd4e956050d432$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $6dcd4e956050d432$export$3581891d04da6bb8 = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $8G0iN.FilterResultsGadgetEdit),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$FILTER_RESULTS_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $6dcd4e956050d432$export$652d5a9cc2c18d2e = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $3MbRU.AssignedToMeGadgetEdit), $6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $6dcd4e956050d432$export$54b46348d1ed5d22 = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $ixr5d.IssuesInProgressGadgetEdit), $6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $6dcd4e956050d432$export$ea96ce30d34ce354 = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$VOTED_ISSUES_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $bz1Gz.VotedIssuesGadgetEdit), $6dcd4e956050d432$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$VOTED_ISSUES_CONFIG),
    preload: (0, $92GBg.preload)
};
const $6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $6dcd4e956050d432$export$5109728db227eae = {
    componentView: $6dcd4e956050d432$var$componentViewWithAdditionalState((0, $92GBg.IssueTableGadgetView), $6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $6dcd4e956050d432$var$componentEditWithAdditionalState((0, $gVMtN.WatchedIssuesGadgetEdit), $6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $i222u.default)($6dcd4e956050d432$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $92GBg.preload)
};

});
parcelRegister("3MbRU", function(module, exports) {
$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $0df2d23261b9fc3e$export$3ae3568d16dc8f35);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $kSxjd = parcelRequire("kSxjd");

var $bQWwW = parcelRequire("bQWwW");

const $0df2d23261b9fc3e$var$LazyAssignedToMeGadgetEdit = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eW6Ey")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $0df2d23261b9fc3e$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0df2d23261b9fc3e$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $0df2d23261b9fc3e$export$513ccb98c53b8039 } = $0df2d23261b9fc3e$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("kSxjd", function(module, exports) {
$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $9975e76ceee590cb$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $HOzY3 = parcelRequire("HOzY3");
const $9975e76ceee590cb$var$customCssStyles = null;
const $9975e76ceee590cb$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $9975e76ceee590cb$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HOzY3))),
        containerStyles: {
            height: $9975e76ceee590cb$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("HOzY3", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("eW6Ey", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("cXDWU")
]).then(()=>parcelRequire('hizmQ'));

});


parcelRegister("8G0iN", function(module, exports) {
$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $58603643e09663c6$export$6dfceca003c43832);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $kSxjd = parcelRequire("kSxjd");

var $bQWwW = parcelRequire("bQWwW");

const $58603643e09663c6$var$LazyFilterResultsGadgetEdit = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lfsKL")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $58603643e09663c6$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58603643e09663c6$var$LazyFilterResultsGadgetEdit, props));
const { preload: $58603643e09663c6$export$513ccb98c53b8039 } = $58603643e09663c6$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("lfsKL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("8dVVn")
]).then(()=>parcelRequire('390xr'));

});


parcelRegister("ixr5d", function(module, exports) {
$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $8a793479fb83e9e0$export$199fec410a0f70a2);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $kSxjd = parcelRequire("kSxjd");

var $bQWwW = parcelRequire("bQWwW");

const $8a793479fb83e9e0$var$LazyIssuesInProgressGadgetEdit = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6kDR7")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $8a793479fb83e9e0$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8a793479fb83e9e0$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $8a793479fb83e9e0$export$513ccb98c53b8039 } = $8a793479fb83e9e0$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("6kDR7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("8o7mc")
]).then(()=>parcelRequire('5tlcN'));

});


parcelRegister("92GBg", function(module, exports) {
$parcel$export(module.exports, "IssueTableGadgetView", () => $2546d43c174a6acb$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $2546d43c174a6acb$export$513ccb98c53b8039);

var $eJOHy = parcelRequire("eJOHy");

var $iluXv = parcelRequire("iluXv");

var $2imLM = parcelRequire("2imLM");

var $KWlg0 = parcelRequire("KWlg0");

var $bQWwW = parcelRequire("bQWwW");

const $2546d43c174a6acb$var$LazyIssueTableGadgetView = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("8mO6k")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $2546d43c174a6acb$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $KWlg0.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $iluXv.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2546d43c174a6acb$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $2546d43c174a6acb$export$513ccb98c53b8039 } = $2546d43c174a6acb$var$LazyIssueTableGadgetView;

});
parcelRegister("KWlg0", function(module, exports) {
$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $20813c86b16240ff$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $7qheL = parcelRequire("7qheL");
const $20813c86b16240ff$var$customCssStyles = null;
const $20813c86b16240ff$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7qheL))),
        containerStyles: {
            height: height
        },
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("7qheL", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("8mO6k", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("jyc0E")
]).then(()=>parcelRequire('d3SdG'));

});


parcelRegister("bz1Gz", function(module, exports) {
$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $3d37a81833c717c2$export$7650b85a7a54914);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $kSxjd = parcelRequire("kSxjd");

var $bQWwW = parcelRequire("bQWwW");

const $3d37a81833c717c2$var$LazyVotedIssuesGadgetEdit = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iX0nz")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $3d37a81833c717c2$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d37a81833c717c2$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $3d37a81833c717c2$export$513ccb98c53b8039 } = $3d37a81833c717c2$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("iX0nz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("hDQAN")
]).then(()=>parcelRequire('ln0ip'));

});


parcelRegister("gVMtN", function(module, exports) {
$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $db913fcb8ad1a43f$export$a53864bd0bf8a85f);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $kSxjd = parcelRequire("kSxjd");

var $bQWwW = parcelRequire("bQWwW");

const $db913fcb8ad1a43f$var$LazyWatchedIssuesGadgetEdit = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hBYOl")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $db913fcb8ad1a43f$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSxjd.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db913fcb8ad1a43f$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $db913fcb8ad1a43f$export$513ccb98c53b8039 } = $db913fcb8ad1a43f$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("hBYOl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("j3M2Y")
]).then(()=>parcelRequire('9y8Vg'));

});


parcelRegister("i222u", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab080f0d58cec23$export$2e2bcd8739ae039);

var $27LST = parcelRequire("27LST");

var $7XzWK = parcelRequire("7XzWK");

var $3UXIi = parcelRequire("3UXIi");

var $gKL7K = parcelRequire("gKL7K");
const $cab080f0d58cec23$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $gKL7K.transformToValidUserPrefs)((0, $27LST.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $3UXIi.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $7XzWK.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $cab080f0d58cec23$export$2e2bcd8739ae039 = $cab080f0d58cec23$var$createGetInitialState;

});
parcelRegister("27LST", function(module, exports) {
$parcel$export(module.exports, "getUserPreferences", () => $04f8c794fd7da3f4$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $04f8c794fd7da3f4$export$ebdfc6c2778ef8e2);

var $hgi0g = parcelRequire("hgi0g");
const $04f8c794fd7da3f4$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $04f8c794fd7da3f4$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $04f8c794fd7da3f4$export$ae3f5fa351e2f57a = (action)=>(0, $hgi0g.default)(action);
const $04f8c794fd7da3f4$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $04f8c794fd7da3f4$var$isBooleanString(value) ? $04f8c794fd7da3f4$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("7XzWK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef5374988d31870f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<952f004d359130b5c2f3a6160446f1dd>>
 * @relayHash a3bc2063b488cf9a77a6027a18f07dd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cdd49d0220e209f96a8b47e0e9f5faec09c7de9614ecafb0d55e707809d03193

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $8Qoc7 = parcelRequire("8Qoc7");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $ef5374988d31870f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v15 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v16 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v20 = {
        "kind": "ScalarField",
        "name": "type"
    }, v21 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v23 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "value"
    }, v25 = [
        v24 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v27 = {
        "kind": "ClientExtension",
        "selections": [
            v26 /*: any*/ 
        ]
    }, v28 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v29 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v30 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v31 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "text"
    }, v33 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v10 /*: any*/ 
        ]
    }, v34 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v36 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v37 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v38 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v39 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v40 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v41 = {
        "kind": "ClientExtension",
        "selections": [
            v19 /*: any*/ 
        ]
    }, v42 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v43 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v44 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            v10 /*: any*/ 
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "href"
    }, v46 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v47 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v48 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "IssueTableView"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraStatusField",
                                                    "kind": "LinkedField",
                                                    "name": "statusField",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canBeExported"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 500
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        v23 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v25 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v25 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v28 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "date"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v32 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v15 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v28 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v33 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v32 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                v32 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                                        v36 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                                        v13 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v23 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v10 /*: any*/ ,
                                                                                                                                                                v15 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v36 /*: any*/ ,
                                                                                                                                v13 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v16 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v10 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v14 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "relationName"
                                                                                                                        },
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v22 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        v40 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v40 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v41 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v9 /*: any*/ ,
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v27 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v29 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v28 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "versionId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v28 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v27 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v28 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v45 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v45 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v27 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        v41 /*: any*/ 
                                    ]
                                },
                                v46 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v47 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v47 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v47 /*: any*/ 
                                        }
                                    ]
                                },
                                v41 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetIds",
                                    "variableName": "fieldSetIds"
                                }
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "aliases"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "canBeConfigured"
                                                                                },
                                                                                v23 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v48 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ ,
                                v41 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cdd49d0220e209f96a8b47e0e9f5faec09c7de9614ecafb0d55e707809d03193",
            "metadata": {},
            "name": "IssueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$ef5374988d31870f$var$node.hash = "78397a7dc374c0a1e5d3b2c5219bdd18";
var $ef5374988d31870f$export$2e2bcd8739ae039 = $ef5374988d31870f$var$node;

});

parcelRegister("3UXIi", function(module, exports) {
$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $3a2f2bb16b1da3c2$export$700e212b8b5c678f);

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $26oP8 = parcelRequire("26oP8");
async function $3a2f2bb16b1da3c2$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $26oP8.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("26oP8", function(module, exports) {
$parcel$export(module.exports, "transformToVariables", () => $89cb822fe50e27eb$export$a5cefa50115212b3);

var $4NoAT = parcelRequire("4NoAT");

var $8jOO7 = parcelRequire("8jOO7");

var $aPVW5 = parcelRequire("aPVW5");

var $4uCZb = parcelRequire("4uCZb");



const $89cb822fe50e27eb$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $4NoAT.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: {
            fieldSetIds: columnNames
        },
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("9dg6M")),
        (parcelRequire("9AQRm")),
        (parcelRequire("jWgJk"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $4uCZb.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $aPVW5.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("8jOO7", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $235707a6a613803b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $235707a6a613803b$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $235707a6a613803b$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $235707a6a613803b$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $235707a6a613803b$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $235707a6a613803b$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $235707a6a613803b$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $235707a6a613803b$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $235707a6a613803b$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $235707a6a613803b$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $235707a6a613803b$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $235707a6a613803b$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $235707a6a613803b$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $235707a6a613803b$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $235707a6a613803b$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $235707a6a613803b$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $235707a6a613803b$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $235707a6a613803b$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $235707a6a613803b$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "COLUMN_ID_TIMELINE", () => $235707a6a613803b$export$244401c8eb936efd);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $235707a6a613803b$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $235707a6a613803b$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $235707a6a613803b$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $235707a6a613803b$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $235707a6a613803b$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $235707a6a613803b$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $235707a6a613803b$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $235707a6a613803b$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $235707a6a613803b$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $235707a6a613803b$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $235707a6a613803b$export$54fb99171fb48426);
$parcel$export(module.exports, "MINIMUM_MERGED_CELL_COLUMN_WIDTH", () => $235707a6a613803b$export$787e40d1c5baf821);
$parcel$export(module.exports, "MINIMUM_MERGED_CELL_COLUMN_WIDTH_TIMELINE", () => $235707a6a613803b$export$62288d0140c46137);
$parcel$export(module.exports, "COLUMN_WIDTH_ASSIGNEE", () => $235707a6a613803b$export$49f5d64369d40b04);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $235707a6a613803b$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $235707a6a613803b$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $235707a6a613803b$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $235707a6a613803b$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $235707a6a613803b$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $235707a6a613803b$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $235707a6a613803b$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $235707a6a613803b$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $235707a6a613803b$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $235707a6a613803b$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $235707a6a613803b$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $235707a6a613803b$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $235707a6a613803b$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $235707a6a613803b$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $235707a6a613803b$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $235707a6a613803b$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $235707a6a613803b$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $235707a6a613803b$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $235707a6a613803b$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $235707a6a613803b$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $235707a6a613803b$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $235707a6a613803b$export$118b06a03e2c672f);
$parcel$export(module.exports, "INSTRUCTION_BLOCKED", () => $235707a6a613803b$export$71b8539e20744dab);
$parcel$export(module.exports, "COMBINE", () => $235707a6a613803b$export$a259161040977848);
$parcel$export(module.exports, "REORDER_BEFORE", () => $235707a6a613803b$export$15f7f11d631a78c1);
$parcel$export(module.exports, "REORDER_AFTER", () => $235707a6a613803b$export$3a8d6fe24ed2320f);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $235707a6a613803b$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $235707a6a613803b$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $235707a6a613803b$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $235707a6a613803b$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $235707a6a613803b$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $235707a6a613803b$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $235707a6a613803b$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $235707a6a613803b$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $235707a6a613803b$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $235707a6a613803b$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $235707a6a613803b$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $235707a6a613803b$export$d3c0241ce8ae9a73);
$parcel$export(module.exports, "DUPLICATE_FIELD_EDIT_WIDTH", () => $235707a6a613803b$export$de4b89eec2f02226);
$parcel$export(module.exports, "GRID_NAVIGATION_ONBOARDING_TRIGGERS", () => $235707a6a613803b$export$61885878ee8ed2ff);
$parcel$export(module.exports, "KEYBOARD_SHORTCUTS_HELP_ARTICLE_ID", () => $235707a6a613803b$export$6fb1d4dbf61e0523);
$parcel$export(module.exports, "Z_INDEX_STICKY_COLUMN", () => $235707a6a613803b$export$52078a2fcd02af21);
$parcel$export(module.exports, "SMALL_TABLE_WIDTH", () => $235707a6a613803b$export$f3c2ffd039fcc10c);
$parcel$export(module.exports, "SMALL_SCREEN_WIDTH", () => $235707a6a613803b$export$1c20094c5869d61e);
$parcel$export(module.exports, "EXTRA_SPACE_PER_LEVEL", () => $235707a6a613803b$export$107c825dc66c95b7);
$parcel$export(module.exports, "FIXED_POSITION_COLUMN_TYPES", () => $235707a6a613803b$export$a77fc985659ff0d1);

var $j8Km1 = parcelRequire("j8Km1");
const $235707a6a613803b$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $235707a6a613803b$export$d57b6b390e78d90f = 'empanada';
const $235707a6a613803b$export$88956207daf9a17e = 'ASC';
const $235707a6a613803b$export$bc14f97913aaf2a = 'DESC';
const $235707a6a613803b$export$9c424bf3e8ffe64e = 'NONE';
const $235707a6a613803b$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $235707a6a613803b$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $235707a6a613803b$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $235707a6a613803b$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $235707a6a613803b$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $235707a6a613803b$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $235707a6a613803b$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $235707a6a613803b$export$e2bd4c1faded7921 = '1px';
const $235707a6a613803b$export$cdb7fd9d999c7168 = 40;
const $235707a6a613803b$export$88e6c5bab2ff80e8 = 40;
const $235707a6a613803b$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $235707a6a613803b$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $235707a6a613803b$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $235707a6a613803b$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $235707a6a613803b$export$244401c8eb936efd = 'timeline';
const $235707a6a613803b$export$3dbdc5c16825be4d = [
    $235707a6a613803b$export$c3266da279aa6b84,
    $235707a6a613803b$export$de4c02b525d877fa,
    $235707a6a613803b$export$66b2a4a5f67468ac,
    (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)
];
const $235707a6a613803b$export$a1c171a82c45d53f = 24;
const $235707a6a613803b$export$43ff8c492b8a2e1b = 24;
const $235707a6a613803b$export$9c5dd6078b37aac2 = 16;
const $235707a6a613803b$export$a8273d7d48e89fce = 24;
const $235707a6a613803b$export$7ec4af037f372df4 = 500;
const $235707a6a613803b$export$d2372dfbd4e91a11 = 50;
const $235707a6a613803b$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $235707a6a613803b$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $235707a6a613803b$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $235707a6a613803b$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $235707a6a613803b$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $235707a6a613803b$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $235707a6a613803b$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $235707a6a613803b$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $235707a6a613803b$export$7c3f559e2ca95fa = 170;
const $235707a6a613803b$export$e1a42c2fefb5af25 = 999;
const $235707a6a613803b$export$54fb99171fb48426 = 80;
const $235707a6a613803b$export$a194aa0e243a27f9 = 156;
const $235707a6a613803b$export$87a3548b97ce2540 = 136;
const $235707a6a613803b$export$d182a35496b19fb4 = 112;
const $235707a6a613803b$export$4fd6711c21931f5b = 116;
const $235707a6a613803b$export$9b72110b9a7c0a39 = 102;
const $235707a6a613803b$export$54c15048528650a8 = 84;
const $235707a6a613803b$export$7ed05c26fe24a805 = 200;
const $235707a6a613803b$export$787e40d1c5baf821 = 180;
const $235707a6a613803b$export$62288d0140c46137 = 240;
const $235707a6a613803b$export$49f5d64369d40b04 = 204;
const $235707a6a613803b$export$bfe09a9186b98f8f = 400;
const $235707a6a613803b$export$f2540f34b796306d = 300;
const $235707a6a613803b$export$954afb0fcf5a326 = 450;
const $235707a6a613803b$export$93758649595b2d58 = 'reorder';
const $235707a6a613803b$export$cad8c6a0b6e78898 = 'resize';
const $235707a6a613803b$export$5252387dc65db584 = -16;
const $235707a6a613803b$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $235707a6a613803b$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $235707a6a613803b$export$4e8abe16cd1126dd = 'rowReorder';
const $235707a6a613803b$export$6c0a5a77457ca62 = 'COMPACT';
const $235707a6a613803b$export$119d8ab9a5bc4b2 = 'FULL';
const $235707a6a613803b$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $235707a6a613803b$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $235707a6a613803b$export$e03155205bf92428 = 'loadChildItems';
const $235707a6a613803b$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $235707a6a613803b$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $235707a6a613803b$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $235707a6a613803b$export$70f80a241e016093 = 'createIssue';
const $235707a6a613803b$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $235707a6a613803b$export$5eb61e3ff74a4f58 = 'make-child';
const $235707a6a613803b$export$9213b5774112217f = 'reorder-above';
const $235707a6a613803b$export$118b06a03e2c672f = 'reorder-below';
const $235707a6a613803b$export$71b8539e20744dab = 'instruction-blocked';
const $235707a6a613803b$export$a259161040977848 = 'combine';
const $235707a6a613803b$export$15f7f11d631a78c1 = 'reorder-before';
const $235707a6a613803b$export$3a8d6fe24ed2320f = 'reorder-after';
const $235707a6a613803b$export$5b388ccfa29be01 = -1;
const $235707a6a613803b$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $235707a6a613803b$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $235707a6a613803b$export$139bffb2a576e8c0 = 2;
const $235707a6a613803b$export$3b696b0ac06c2cc4 = 1;
const $235707a6a613803b$export$6ba5aaedfd1b5319 = 2000;
const $235707a6a613803b$export$1bc2edb2aa5e8282 = 'a_to_z';
const $235707a6a613803b$export$c7b524b6c48f8273 = 'z_to_a';
const $235707a6a613803b$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $235707a6a613803b$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $235707a6a613803b$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $235707a6a613803b$export$d3c0241ce8ae9a73 = 'newest_to_oldest';
const $235707a6a613803b$export$de4b89eec2f02226 = 270;
const $235707a6a613803b$export$61885878ee8ed2ff = {
    MORE_SHORTCUTS_CLICKED: 'jira-grid-navigation-onboarding-more-shortcuts-clicked',
    OK_CLICKED: 'jira-grid-navigation-onboarding-ok-clicked'
};
const $235707a6a613803b$export$6fb1d4dbf61e0523 = '6yfW2wFuTcluCiX8ghrxWj';
const $235707a6a613803b$export$52078a2fcd02af21 = 7;
const $235707a6a613803b$export$8de1f7a70e87463c = 8;
const $235707a6a613803b$export$f3c2ffd039fcc10c = 960;
const $235707a6a613803b$export$1c20094c5869d61e = 1024;
const $235707a6a613803b$export$107c825dc66c95b7 = 4;
const $235707a6a613803b$export$a77fc985659ff0d1 = [
    $235707a6a613803b$export$244401c8eb936efd,
    $235707a6a613803b$export$de4c02b525d877fa
];

});
parcelRegister("j8Km1", function(module, exports) {
$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $e5b9ff271db028f7$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $e5b9ff271db028f7$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $e5b9ff271db028f7$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $e5b9ff271db028f7$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_TYPES", () => $e5b9ff271db028f7$export$72f66561203b705c);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $e5b9ff271db028f7$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $e5b9ff271db028f7$export$6aa1d347deb86ef3);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $e5b9ff271db028f7$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $e5b9ff271db028f7$export$39ec48f092f3ea90);
const $e5b9ff271db028f7$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    TIMELINE: 'timeline',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
    ATLAS_PROJECT: 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project'
};
const $e5b9ff271db028f7$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $e5b9ff271db028f7$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $e5b9ff271db028f7$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $e5b9ff271db028f7$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $e5b9ff271db028f7$export$72f66561203b705c = [
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.ISSUE_KEY,
    $e5b9ff271db028f7$export$bbc2e8c301f97f97.SUMMARY
];
const $e5b9ff271db028f7$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $e5b9ff271db028f7$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)
const $e5b9ff271db028f7$export$fae6afe554014a45 = 'NIN_PROJECT';
const $e5b9ff271db028f7$export$39ec48f092f3ea90 = 'NIN_GLOBAL';

});


parcelRegister("aPVW5", function(module, exports) {
$parcel$export(module.exports, "getAliasesForField", () => $41cc5c59baaab770$export$94d69942fbe58a01);
const $41cc5c59baaab770$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("4uCZb", function(module, exports) {
$parcel$export(module.exports, "getJqlTermForField", () => $b8f199beaa022d8a$export$ef4e8b2c9bc7bd4d);

var $1S1Tf = parcelRequire("1S1Tf");
const $b8f199beaa022d8a$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $1S1Tf.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("1S1Tf", function(module, exports) {
$parcel$export(module.exports, "convertFieldToJqlTerm", () => $deb668ce7f0a6895$export$29f734dc2c61ea9d);
const $deb668ce7f0a6895$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("9dg6M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h9R5C").then(()=>parcelRequire('imx7a'));

});

parcelRegister("9AQRm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jLbI9").then(()=>parcelRequire('boEdP'));

});

parcelRegister("jWgJk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iSmBG").then(()=>parcelRequire('3qoCN'));

});



parcelRegister("gKL7K", function(module, exports) {
$parcel$export(module.exports, "transformToValidUserPrefs", () => $de3749d4733e362d$export$e9345b021afd3cc3);

var $db9hy = parcelRequire("db9hy");

var $8knHl = parcelRequire("8knHl");

var $f1gVB = parcelRequire("f1gVB");
const $de3749d4733e362d$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $db9hy.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $8knHl.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $f1gVB.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("db9hy", function(module, exports) {
$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $c43676d5930696ed$export$6e5cdc232ebb20cf);

var $iluXv = parcelRequire("iluXv");

const $c43676d5930696ed$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $aa603a4a6cc3d43b$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $aa603a4a6cc3d43b$export$952287cc7aef3a4c), (0, $aa603a4a6cc3d43b$export$a3d4af30107c4f4d))) : (0, $iluXv.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $aa603a4a6cc3d43b$export$dd03181e30c7d559 = 5;
const $aa603a4a6cc3d43b$export$a3d4af30107c4f4d = '|';
const $aa603a4a6cc3d43b$export$952287cc7aef3a4c = '%7C';


parcelRegister("8knHl", function(module, exports) {
$parcel$export(module.exports, "getSortFieldAndDirection", () => $1d645544a8ea064c$export$e535bb2dfaa4d10b);
const $1d645544a8ea064c$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("f1gVB", function(module, exports) {
$parcel$export(module.exports, "isFilterId", () => $e93567f8e731246c$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $e93567f8e731246c$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("8ospY", function(module, exports) {
$parcel$export(module.exports, "REACT_KEY", () => $c0263edac7754048$export$e0e89108956f58f6);
// React gadget keys
const $c0263edac7754048$export$c8ae0b83405368ed = 'react/filter-results';
const $c0263edac7754048$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $c0263edac7754048$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $c0263edac7754048$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $c0263edac7754048$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $c0263edac7754048$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $c0263edac7754048$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $c0263edac7754048$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $c0263edac7754048$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $c0263edac7754048$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $c0263edac7754048$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $c0263edac7754048$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $c0263edac7754048$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("8Fsa4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ca618da80c61e6e$export$2e2bcd8739ae039);

var $3ugTQ = parcelRequire("3ugTQ");
const $4ca618da80c61e6e$var$getGadgetDirectoryData = async ()=>(0, $3ugTQ.performGetRequest)('/rest/config/1.0/directoryitems.json');
var $4ca618da80c61e6e$export$2e2bcd8739ae039 = $4ca618da80c61e6e$var$getGadgetDirectoryData;

});

parcelRegister("rbj9K", function(module, exports) {
$parcel$export(module.exports, "default", () => $21b334fde51b6ff0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $j5TCC = parcelRequire("j5TCC");

var $8MjsA = parcelRequire("8MjsA");

var $E0qsj = parcelRequire("E0qsj");

var $4lxlN = parcelRequire("4lxlN");
const $21b334fde51b6ff0$var$getReactGadgetsData = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, storeContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $E0qsj.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $8MjsA.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $j5TCC.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $4lxlN.loadReactGadgets)(gadgetsToLoad, storeContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };
var $21b334fde51b6ff0$export$2e2bcd8739ae039 = $21b334fde51b6ff0$var$getReactGadgetsData;

});
parcelRegister("j5TCC", function(module, exports) {
$parcel$export(module.exports, "isGadgetConfigured", () => $651ae8a0bb1abfd0$export$b625fae487818738);
const $651ae8a0bb1abfd0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("4lxlN", function(module, exports) {
$parcel$export(module.exports, "loadReactGadgets", () => $1fcf9ef6c7245c9e$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $8MjsA = parcelRequire("8MjsA");
const $1fcf9ef6c7245c9e$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $8MjsA.default)[reactKey].preload();
    });
const $1fcf9ef6c7245c9e$export$7e1a3455761184a2 = async (gadgets, storeContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $1fcf9ef6c7245c9e$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8MjsA.default)[reactKey]?.getInitialState(storeContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("2Ga0d", function(module, exports) {
$parcel$export(module.exports, "dashboardEditRoute", () => $b352cea7b082c6d1$export$b6e00d2cd7369fbd);
const $b352cea7b082c6d1$export$b6e00d2cd7369fbd = {
    name: 'dashboard-edit',
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("8vUDE", function(module, exports) {
$parcel$export(module.exports, "dashboardEditEntryPoint", () => $a622e7f542388744$export$eb39305ec6fcebf1);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $a622e7f542388744$export$eb39305ec6fcebf1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bI1lv")), {
        moduleId: "4d5a5b34",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("bI1lv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4kIDm").then(()=>parcelRequire('jmgZu'));

});


parcelRegister("en43l", function(module, exports) {
$parcel$export(module.exports, "dashboardResources", () => $04dfe95f5bd72bdf$export$50d95db618f58349);
$parcel$export(module.exports, "LazyDashboardView", () => $04dfe95f5bd72bdf$export$c3bf98706b62de2b);
$parcel$export(module.exports, "LazyDashboardViewEmbed", () => $04dfe95f5bd72bdf$export$94d85118d282a15);
$parcel$export(module.exports, "LazySystemDashboardEdit", () => $04dfe95f5bd72bdf$export$c8d59d34c3e8f345);
$parcel$export(module.exports, "LazyForPaintBackgroundScripts", () => $04dfe95f5bd72bdf$export$b5c9ccba15f81486);
$parcel$export(module.exports, "LazyForPaintConnectJsApi", () => $04dfe95f5bd72bdf$export$aba403674a33dc61);
$parcel$export(module.exports, "DashboardViewEmbedPage", () => $04dfe95f5bd72bdf$export$86d9f777f9d4e312);
$parcel$export(module.exports, "SystemDashboardEditPage", () => $04dfe95f5bd72bdf$export$dcd19a888f8c85c);

var $eJOHy = parcelRequire("eJOHy");

var $jlaZM = parcelRequire("jlaZM");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");
const $04dfe95f5bd72bdf$export$50d95db618f58349 = ()=>[
        (0, $jlaZM.dashboardConfigAndWRMResource),
        (0, $jlaZM.dashboardAMDModulesResource),
        (0, $jlaZM.dashboardReactGadgetsResource),
        (0, $jlaZM.dashboardForgeResource)
    ];

const $04dfe95f5bd72bdf$export$c3bf98706b62de2b = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3Bkiu"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $04dfe95f5bd72bdf$export$94d85118d282a15 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kWayz"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $04dfe95f5bd72bdf$export$c8d59d34c3e8f345 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bSKkK"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});

const $04dfe95f5bd72bdf$export$b5c9ccba15f81486 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iz3Hw")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

const $04dfe95f5bd72bdf$export$aba403674a33dc61 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("5sBPb")), {
    ssr: false,
    moduleId: "./src/packages/connect/src/loader.tsx"
});
const $04dfe95f5bd72bdf$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $04dfe95f5bd72bdf$export$94d85118d282a15,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $04dfe95f5bd72bdf$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $04dfe95f5bd72bdf$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });

});
parcelRegister("3Bkiu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("rY6Jk").then(()=>parcelRequire('8Xpvo'));

});

parcelRegister("kWayz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iuMRi").then(()=>parcelRequire('4NPdN'));

});

parcelRegister("bSKkK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("55otQ").then(()=>parcelRequire('eM952'));

});

parcelRegister("5sBPb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kwvFG").then(()=>parcelRequire('jh0iZ'));

});



parcelRegister("fkKo1", function(module, exports) {
$parcel$export(module.exports, "dashboardRouteEntry", () => $3859dd2e475cb8d5$export$9fbbaafb58999ac3);

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $1RKJf = parcelRequire("1RKJf");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9aj7y = parcelRequire("9aj7y");

var $doZ3p = parcelRequire("doZ3p");

var $en43l = parcelRequire("en43l");
const $3859dd2e475cb8d5$export$9fbbaafb58999ac3 = (0, $6xToB.createEntry)((0, $9aj7y.dashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $doZ3p.DashboardRedirect),
        layout: (0, $1RKJf.homepageLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $en43l.LazyDashboardView)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/dashboardRouteEntry.tsx',
                whichExportToUse: 'dashboardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1RKJf", function(module, exports) {
$parcel$export(module.exports, "homepageLayout", () => $e8887a1c3d0e1d20$export$5b7fb151d60504c);

var $fz8gQ = parcelRequire("fz8gQ");

var $7h3uc = parcelRequire("7h3uc");

var $6dwgv = parcelRequire("6dwgv");
const $e8887a1c3d0e1d20$export$5b7fb151d60504c = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $fz8gQ.AsyncTransitionHomeRenderer),
        (0, $fz8gQ.AsyncWelcomeModalRenderer)
    ]
});

});
parcelRegister("fz8gQ", function(module, exports) {
$parcel$export(module.exports, "AsyncTransitionHomeRenderer", () => $7101fec8869f42fd$export$cb38f5a820347580);
$parcel$export(module.exports, "AsyncWelcomeModalRenderer", () => $7101fec8869f42fd$export$9cda67d6c86d7b98);
$parcel$export(module.exports, "eocChangeboardingLayout", () => $7101fec8869f42fd$export$b8fa7ac7019001bb);

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

const $7101fec8869f42fd$export$cb38f5a820347580 = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("i5JQ4")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
});
$7101fec8869f42fd$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $7101fec8869f42fd$export$9cda67d6c86d7b98 = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("l5tQv")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
});
$7101fec8869f42fd$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';

const $7101fec8869f42fd$export$913f5a2340406083 = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1Z8WU")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$7101fec8869f42fd$export$913f5a2340406083.displayName = 'MigrationHubRightSidebar';

const $7101fec8869f42fd$export$6d7715b12d3ad17b = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("18isC")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$7101fec8869f42fd$export$6d7715b12d3ad17b.displayName = 'MigrationHubOnboarding';
const $7101fec8869f42fd$export$b8fa7ac7019001bb = (0, $6dwgv.createLayout)({
    get globalComponents () {
        return [
            $7101fec8869f42fd$export$cb38f5a820347580,
            $7101fec8869f42fd$export$9cda67d6c86d7b98,
            $7101fec8869f42fd$export$6d7715b12d3ad17b
        ];
    },
    rightSidebars: [
        $7101fec8869f42fd$export$913f5a2340406083
    ]
});

});
parcelRegister("i5JQ4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3PTqF").then(()=>parcelRequire('N7rTt'));

});

parcelRegister("l5tQv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kcqiz").then(()=>parcelRequire('6y9Ty'));

});

parcelRegister("1Z8WU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jG1nH").then(()=>parcelRequire('9HF0e'));

});

parcelRegister("18isC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4RTC0").then(()=>parcelRequire('9XKDI'));

});



parcelRegister("9aj7y", function(module, exports) {
$parcel$export(module.exports, "dashboardRoute", () => $27e86cdbb90113ab$export$3bf0ecb39349b6ef);
const $27e86cdbb90113ab$export$3bf0ecb39349b6ef = {
    name: 'dashboard',
    path: '/secure/Dashboard.jspa'
};

});

parcelRegister("doZ3p", function(module, exports) {
$parcel$export(module.exports, "DashboardRedirect", () => $03c8cbf0c62ac2eb$export$da833ddcffcc38ba);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $7fTjp = parcelRequire("7fTjp");

var $02kpm = parcelRequire("02kpm");
var $gCY1z = parcelRequire("gCY1z");
const $03c8cbf0c62ac2eb$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $gCY1z.useRouter)();
    const { path: path } = (0, $hih5V.useRouteByName)('dashboard-view') ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $02kpm.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};

});


parcelRegister("4BD3h", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", () => $15a393c2e4817283$export$8dae8091f8e43b97);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9l1y1 = parcelRequire("9l1y1");

var $9NmsS = parcelRequire("9NmsS");

var $41bNV = parcelRequire("41bNV");

var $7fTjp = parcelRequire("7fTjp");

var $iMFdk = parcelRequire("iMFdk");

var $fRaUi = parcelRequire("fRaUi");
const $15a393c2e4817283$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/dashboards"
    });
const $15a393c2e4817283$export$8dae8091f8e43b97 = (0, $6xToB.createEntry)((0, $41bNV.dashboardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $9l1y1.dashboardsDirectoryResource)
        ],
        component: !false ? $15a393c2e4817283$var$DashboardsDirectoryRedirect : (0, $fRaUi.DashboardsDirectoryComponent),
        skeleton: (0, $iMFdk.DashboardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fRaUi.LazyDashboardsDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/dashboardsDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'dashboardsDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9l1y1", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryResource", () => $20253ccc3882e5b9$export$1cf6c7815471c2a2);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");
const $20253ccc3882e5b9$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $20253ccc3882e5b9$export$1cf6c7815471c2a2 = (0, $l1VxS.createResource)({
    type: $20253ccc3882e5b9$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("lyNff")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
parcelRegister("lyNff", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9hhnU").then(()=>parcelRequire('6qyMq'));

});


parcelRegister("41bNV", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $f4dfd28f92ee4173$export$b96f6fb3c35a6fe5);
const $f4dfd28f92ee4173$export$b96f6fb3c35a6fe5 = {
    name: 'dashboards-directory-secure',
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("fRaUi", function(module, exports) {
$parcel$export(module.exports, "LazyDashboardsDirectory", () => $da5c1fc915e72d55$export$f2f3fd22cd37e121);
$parcel$export(module.exports, "DashboardsDirectoryComponent", () => $da5c1fc915e72d55$export$1cc6cc01050e1215);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $da5c1fc915e72d55$export$f2f3fd22cd37e121 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2ww7P"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $da5c1fc915e72d55$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $da5c1fc915e72d55$export$f2f3fd22cd37e121,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("2ww7P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("c3vgN")
]).then(()=>parcelRequire('8iNv0'));

});



parcelRegister("czPgr", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $3569b78ccc33f692$export$748e329bd0c282a);

var $3MgfG = parcelRequire("3MgfG");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9l1y1 = parcelRequire("9l1y1");

var $9NmsS = parcelRequire("9NmsS");

var $fuV6j = parcelRequire("fuV6j");

var $iMFdk = parcelRequire("iMFdk");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $hUpHQ = parcelRequire("hUpHQ");

var $lqtcb = parcelRequire("lqtcb");
const $3569b78ccc33f692$export$748e329bd0c282a = (0, $6xToB.createEntry)((0, $fuV6j.dashboardsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint: ()=>$3569b78ccc33f692$var$pageEntryPoint,
        skeleton: (0, $iMFdk.DashboardsDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $9l1y1.dashboardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/dashboardsDirectoryRouteEntry.tsx',
                whichExportToUse: 'dashboardsDirectoryRouteEntry'
            },
            enabled: true
        }
    }));
// Page entrypoint, referred to above...
const $3569b78ccc33f692$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lqtcb.dashboardDirectoryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
            }
        }
    },
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("lqtcb", function(module, exports) {
$parcel$export(module.exports, "dashboardDirectoryEntryPoint", () => $7d994a9615f2c1db$export$3325d832741ebeb3);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $7d994a9615f2c1db$export$3325d832741ebeb3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2ww7P")), {
        moduleId: "933882c8",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("7Zjtg", function(module, exports) {
$parcel$export(module.exports, "dashboardViewEmbedRouteEntry", () => $3bc9683c1ed0874b$export$73a377380ff671af);

var $3O07j = parcelRequire("3O07j");


var $grWOk = parcelRequire("grWOk");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $cxQGT = parcelRequire("cxQGT");

var $1LonB = parcelRequire("1LonB");

var $en43l = parcelRequire("en43l");
const $3bc9683c1ed0874b$export$73a377380ff671af = (0, $6xToB.createEntry)((0, $1LonB.dashboardViewEmbedRoute), ()=>({
        group: 'dashboard',
        component: (0, $en43l.DashboardViewEmbedPage),
        layout: (0, $6dwgv.createLayout)({
            globalComponents: [
                (0, $3O07j.DashboardBackgroundScripts)
            ],
            isChromeless: true
        }),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $en43l.LazyDashboardViewEmbed),
            (0, $en43l.LazyForPaintBackgroundScripts),
            (0, $en43l.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/dashboardViewEmbedRouteEntry.tsx',
                whichExportToUse: 'dashboardViewEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1LonB", function(module, exports) {
$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $9eb7d3f85958508e$export$258b5e3f294617d2);
const $9eb7d3f85958508e$export$258b5e3f294617d2 = {
    name: 'dashboard-view-embed',
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};

});


parcelRegister("1Jz0d", function(module, exports) {
$parcel$export(module.exports, "dashboardViewRouteEntry", () => $4f211a4e781d6bbf$export$18226b6422149926);

var $3MgfG = parcelRequire("3MgfG");

var $7IYIF = parcelRequire("7IYIF");


var $grWOk = parcelRequire("grWOk");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $kmQWD = parcelRequire("kmQWD");

var $7EJL7 = parcelRequire("7EJL7");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $hUpHQ = parcelRequire("hUpHQ");

var $en43l = parcelRequire("en43l");
const $4f211a4e781d6bbf$export$18226b6422149926 = (0, $6xToB.createEntry)((0, $kmQWD.dashboardViewRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$4f211a4e781d6bbf$var$pageEntryPoint,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $7IYIF.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $en43l.LazyForPaintBackgroundScripts),
            (0, $en43l.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        ufoName: 'dashboard',
        supportsPreviewPanel: true,
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/dashboardViewRouteEntry.tsx',
                whichExportToUse: 'dashboardViewRouteEntry'
            },
            enabled: true
        }
    }));
const $4f211a4e781d6bbf$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7EJL7.dashboardViewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $hUpHQ.nav4DashboardsContentEntryPoint)
            }
        }
    },
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("kmQWD", function(module, exports) {
$parcel$export(module.exports, "dashboardViewRoute", () => $d44c47ccc7ce6a45$export$24f1b2ff97b9d3e6);
const $d44c47ccc7ce6a45$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("7EJL7", function(module, exports) {
$parcel$export(module.exports, "dashboardViewEntryPoint", () => $21c1d7e9bf95e874$export$acd33fbfe610d0e6);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $21c1d7e9bf95e874$export$acd33fbfe610d0e6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3Bkiu")), {
        moduleId: "2821e152",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("kJhhx", function(module, exports) {
$parcel$export(module.exports, "dashboardWallboardRouteEntry", () => $b76beb67f2413d0e$export$6009dd8e88f1a7de);

var $3O07j = parcelRequire("3O07j");


var $grWOk = parcelRequire("grWOk");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $cxQGT = parcelRequire("cxQGT");

var $7L9Wn = parcelRequire("7L9Wn");

var $g8uYY = parcelRequire("g8uYY");

var $8giOv = parcelRequire("8giOv");

var $en43l = parcelRequire("en43l");
const $b76beb67f2413d0e$export$6009dd8e88f1a7de = (0, $6xToB.createEntry)((0, $7L9Wn.dashboardWallboardRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$b76beb67f2413d0e$var$dashboardWallboardPageEntryPoint,
        layout: (0, $6dwgv.createLayout)({
            globalComponents: [
                (0, $3O07j.DashboardBackgroundScripts)
            ],
            // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
            isChromeless: true
        }),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $en43l.LazyForPaintBackgroundScripts),
            (0, $en43l.LazyForPaintConnectJsApi)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/dashboardWallboardRouteEntry.tsx',
                whichExportToUse: 'dashboardWallboardRouteEntry'
            },
            enabled: true
        }
    }));
const $b76beb67f2413d0e$var$dashboardWallboardPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $8giOv.dashboardWallboardEntryPoint)
});

});
parcelRegister("7L9Wn", function(module, exports) {
$parcel$export(module.exports, "dashboardWallboardRoute", () => $fdfaa2dfb7f3b9a4$export$eaa33c953ab9ca63);
const $fdfaa2dfb7f3b9a4$export$eaa33c953ab9ca63 = {
    name: 'dashboard-wallboard',
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};

});

parcelRegister("8giOv", function(module, exports) {
$parcel$export(module.exports, "dashboardWallboardEntryPoint", () => $88c6d758580a5f43$export$99f21964c00b61ef);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $88c6d758580a5f43$export$99f21964c00b61ef = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("1mjmR")), {
        moduleId: "b10917db",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("1mjmR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9I1It").then(()=>parcelRequire('i04af'));

});



parcelRegister("5Ufi9", function(module, exports) {
$parcel$export(module.exports, "devopsConnectedProjectRouteEntry", () => $ef2048fddb43ff08$export$ae258fb8ec2c1f86);

var $kHlOR = parcelRequire("kHlOR");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $agnyK = parcelRequire("agnyK");

var $6ZXtj = parcelRequire("6ZXtj");
const $ef2048fddb43ff08$export$ae258fb8ec2c1f86 = (0, $6xToB.createEntry)((0, $agnyK.devopsConnectedProjectRoute), ()=>({
        group: 'devops',
        ufoName: 'devops.connected-project',
        component: (0, $6ZXtj.default),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6ZXtj.LazyDevopsConnectedProject)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-devops-connected-project-entries/src/devopsConnectedProjectRouteEntry.tsx',
                whichExportToUse: 'devopsConnectedProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("agnyK", function(module, exports) {
$parcel$export(module.exports, "devopsConnectedProjectRoute", () => $4dcba4b6da22a793$export$91257312631802bc);
const $4dcba4b6da22a793$export$91257312631802bc = {
    name: 'devops-connected-project',
    path: '/jira/devops/connected-project'
};

});

parcelRegister("6ZXtj", function(module, exports) {
$parcel$export(module.exports, "LazyDevopsConnectedProject", () => $fa420428cf303180$export$dcd3d20b0038b35c);
$parcel$export(module.exports, "default", () => $fa420428cf303180$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fa420428cf303180$export$dcd3d20b0038b35c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8Q4EQ"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
const $fa420428cf303180$var$AsyncDevopsConnectedProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fa420428cf303180$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });
var $fa420428cf303180$export$2e2bcd8739ae039 = $fa420428cf303180$var$AsyncDevopsConnectedProject;

});
parcelRegister("8Q4EQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ggpBz").then(()=>parcelRequire('WpfYQ'));

});



parcelRegister("l8WGY", function(module, exports) {
$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRouteEntry", () => $188a9bf64694b85c$export$6ff00ce079beb0ed);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $kdVPH = parcelRequire("kdVPH");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $188a9bf64694b85c$var$LazyDigestsNotificationsPersonalSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3y531"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/digests-notifications/src/index.tsx"
});
const $188a9bf64694b85c$var$DigestsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $188a9bf64694b85c$var$LazyDigestsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $188a9bf64694b85c$export$6ff00ce079beb0ed = (0, $6xToB.createEntry)((0, $kdVPH.digestsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $188a9bf64694b85c$var$DigestsNotificationsPersonalSettingsComponent,
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $188a9bf64694b85c$var$LazyDigestsNotificationsPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-personal-settings-entries/src/digestsNotificationsPersonalSettingsRouteEntry.tsx',
                whichExportToUse: 'digestsNotificationsPersonalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eaZMD", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa192dcf2dceb161$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $aa192dcf2dceb161$var$LazyPersonalSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("5ZJVu")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $aa192dcf2dceb161$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa192dcf2dceb161$var$LazyPersonalSettingsSidebar, null));
var $aa192dcf2dceb161$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($aa192dcf2dceb161$var$PersonalSettingsSidebar);

});
parcelRegister("5ZJVu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aOUf8").then(()=>parcelRequire('7MdHb'));

});


parcelRegister("kdVPH", function(module, exports) {
$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRoute", () => $1833a171e9ff0806$export$36b31d006b9456a1);
const $1833a171e9ff0806$export$36b31d006b9456a1 = {
    name: 'personal-settings-digests',
    path: '/jira/settings/personal/digests'
};

});

parcelRegister("3y531", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gKB7z").then(()=>parcelRequire('4948p'));

});


parcelRegister("d29rL", function(module, exports) {
$parcel$export(module.exports, "emailNotificationsLogAccessRouteEntry", () => $2521abd1a1635c49$export$4d57b993ce36e7b2);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $aNm4v = parcelRequire("aNm4v");

var $6WhGP = parcelRequire("6WhGP");

var $7A34I = parcelRequire("7A34I");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $5fjzQ = parcelRequire("5fjzQ");
const $2521abd1a1635c49$var$emailNotificationsLogEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7A34I.notificationLogsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

const $2521abd1a1635c49$var$LazyNotificationLogsType = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("k1zJF"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $2521abd1a1635c49$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2521abd1a1635c49$var$LazyNotificationLogsType,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $2521abd1a1635c49$export$4d57b993ce36e7b2 = (0, $6xToB.createEntry)((0, $6WhGP.emailNotificationsLogAccessRoute), ()=>({
        group: 'global-settings',
        component: $2521abd1a1635c49$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aNm4v.systemConfigurationGeneralResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $2521abd1a1635c49$var$LazyNotificationLogsType
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return $2521abd1a1635c49$var$emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-email-notifications-log-entries/src/emailNotificationsLogAccessRouteEntry.tsx',
                whichExportToUse: 'emailNotificationsLogAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aNm4v", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $f0148833c09ef3ca$export$b622f7400bfafd0d);

var $l1VxS = parcelRequire("l1VxS");


const $f0148833c09ef3ca$export$b622f7400bfafd0d = (0, $l1VxS.createResource)({
    type: (0, $839d13d40d1761ff$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("935tw"))
});

});
const $839d13d40d1761ff$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("935tw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("36Jaa").then(()=>parcelRequire('aQoI6'));

});


parcelRegister("6WhGP", function(module, exports) {
$parcel$export(module.exports, "emailNotificationsLogAccessRoute", () => $2e31e685eac5cd0f$export$aed294a4a292b909);
const $2e31e685eac5cd0f$export$aed294a4a292b909 = {
    name: 'global-admin-helper-email-notifications-log',
    path: '/jira/settings/system/notification-logs',
    exact: true
};

});

parcelRegister("7A34I", function(module, exports) {
$parcel$export(module.exports, "notificationLogsEntryPoint", () => $9928e86358963954$export$818d841e00bb3749);

var $9gPWR = parcelRequire("9gPWR");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $9928e86358963954$export$818d841e00bb3749 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("k1zJF")), {
        moduleId: "d533cc53",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9gPWR.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("9gPWR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ceba3706714a72a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91dd011830f6a2a7f0d9e67684f8f067>>
 * @relayHash c3e1d2f1050f72df266cf46d38850c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d
const $0ceba3706714a72a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d",
        "metadata": {},
        "name": "NotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0ceba3706714a72a$export$2e2bcd8739ae039 = $0ceba3706714a72a$var$node;

});

parcelRegister("k1zJF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7QqkI").then(()=>parcelRequire('cppNo'));

});



parcelRegister("47SW5", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingCreateRouteEntry", () => $0a350a8f2e007f4e$export$92f4b6644eb6cb88);

var $7ZjlZ = parcelRequire("7ZjlZ");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $f5GYg = parcelRequire("f5GYg");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $jXwOY = parcelRequire("jXwOY");

var $4dPst = parcelRequire("4dPst");

var $91lt4 = parcelRequire("91lt4");
const $0a350a8f2e007f4e$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $0a350a8f2e007f4e$export$92f4b6644eb6cb88 = (0, $6xToB.createEntry)((0, $f5GYg.eocAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        slot: (0, $4dPst.AlertIssueSyncCreate),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $7ZjlZ.resources).configuredSyncsResource,
            (0, $7ZjlZ.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$0a350a8f2e007f4e$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-alert-issue-syncing-entries/src/eocAlertIssueSyncingCreateRouteEntry.tsx',
                whichExportToUse: 'eocAlertIssueSyncingCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7ZjlZ", function(module, exports) {
$parcel$export(module.exports, "resources", () => $a997ae4208b41ad8$export$bc99aaabaf7b70a7);

var $iocUY = parcelRequire("iocUY");

var $7afWl = parcelRequire("7afWl");

var $dII2N = parcelRequire("dII2N");

var $7ICrz = parcelRequire("7ICrz");
const $a997ae4208b41ad8$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $iocUY.configuredSyncsResource,
    userAccessRightsResource: $7ICrz.userAccessRightsResource,
    getTeamResource: $dII2N.getTeamResource,
    isCurrentSiteSyncEnabledResource: $7afWl.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("iocUY", function(module, exports) {
$parcel$export(module.exports, "configuredSyncsResource", () => $8e74da7557da1224$export$333c290f4a1ec41c);

var $l1VxS = parcelRequire("l1VxS");

var $4Eutj = parcelRequire("4Eutj");

var $4PVQ4 = parcelRequire("4PVQ4");
const $8e74da7557da1224$export$333c290f4a1ec41c = (0, $l1VxS.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $4Eutj.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $4PVQ4.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("4Eutj", function(module, exports) {
$parcel$export(module.exports, "UrlHelper", () => $5f71d599b80fad39$export$bacbc496e850c0a4);
const $5f71d599b80fad39$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("4PVQ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff14f49694299347$export$2e2bcd8739ae039);

var $9ppkU = parcelRequire("9ppkU");

var $4Eutj = parcelRequire("4Eutj");

const $ff14f49694299347$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $fd190858557c7049$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $9ppkU.eocFetch)((0, $4Eutj.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $fd190858557c7049$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $fd190858557c7049$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $ff14f49694299347$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $9ppkU.eocFetch)((0, $4Eutj.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $ff14f49694299347$var$deleteSync = async (syncId, syncType, teamId)=>(0, $9ppkU.eocFetch)((0, $4Eutj.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $ff14f49694299347$export$2e2bcd8739ae039 = {
    getSyncs: $ff14f49694299347$var$getSyncs,
    patchSync: $ff14f49694299347$var$patchSync,
    deleteSync: $ff14f49694299347$var$deleteSync
};

});
const $fd190858557c7049$export$31ecae7225aecec6 = 20;



parcelRegister("7afWl", function(module, exports) {
$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $48acc3b13ff39049$export$94465df791bf80);

var $l1VxS = parcelRequire("l1VxS");

var $hqXR3 = parcelRequire("hqXR3");
const $48acc3b13ff39049$export$94465df791bf80 = (0, $l1VxS.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $hqXR3.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("hqXR3", function(module, exports) {
$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $2b4facdfeaabae78$export$93fc09e39edf63d0);

var $9ppkU = parcelRequire("9ppkU");
const $2b4facdfeaabae78$export$93fc09e39edf63d0 = ()=>(0, $9ppkU.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("dII2N", function(module, exports) {
$parcel$export(module.exports, "getTeamResource", () => $c1081b98bb9af23f$export$50271c9e7f21f10e);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $2AWD5 = parcelRequire("2AWD5");
const $c1081b98bb9af23f$export$50271c9e7f21f10e = (0, $l1VxS.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $2AWD5.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("2AWD5", function(module, exports) {
$parcel$export(module.exports, "getTeam", () => $526601fceb7bcd70$export$491fe77f22ab2b51);

var $9ppkU = parcelRequire("9ppkU");
const $526601fceb7bcd70$export$491fe77f22ab2b51 = (teamId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("7ICrz", function(module, exports) {
$parcel$export(module.exports, "userAccessRightsResource", () => $017454bf883f4cc5$export$69ddc7cc64ae9a02);

var $l1VxS = parcelRequire("l1VxS");

var $ejjho = parcelRequire("ejjho");
const $017454bf883f4cc5$export$69ddc7cc64ae9a02 = (0, $l1VxS.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $ejjho.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("ejjho", function(module, exports) {
$parcel$export(module.exports, "getUserRights", () => $4a0e89525d0f9ba1$export$84e2ed279bc4e64e);

var $9ppkU = parcelRequire("9ppkU");

var $4Eutj = parcelRequire("4Eutj");
const $4a0e89525d0f9ba1$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $9ppkU.eocFetch)((0, $4Eutj.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("f5GYg", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", () => $fd5513f4a6b1d432$export$f271eef5f9ec6602);
const $fd5513f4a6b1d432$export$f271eef5f9ec6602 = {
    name: 'eoc-alert-issue-syncing-create',
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};

});

parcelRegister("17wyZ", function(module, exports) {
$parcel$export(module.exports, "LazyHorizontalOperationsConfigurationNav", () => $9602bbd162c7b35f$export$aea682543f08e131);
$parcel$export(module.exports, "AsyncHorizontalOperationsConfigurationNav", () => $9602bbd162c7b35f$export$1f7a0efe3746ea0d);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $9602bbd162c7b35f$export$aea682543f08e131 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("8m8LC")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations-configuration/src/ui/index.tsx"
});
const $9602bbd162c7b35f$export$1f7a0efe3746ea0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-operations-configurations-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncHorizontalOperationsConfigurationNav",
        packageName: "jiraOperationsConfigurationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9602bbd162c7b35f$export$aea682543f08e131, null)));

});
parcelRegister("8m8LC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCyS0").then(()=>parcelRequire('d9nVP'));

});


parcelRegister("jXwOY", function(module, exports) {
$parcel$export(module.exports, "AlertIssueSync", () => $171cde3cecf9f5e8$export$5a4922ba79d730f4);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $91lt4 = parcelRequire("91lt4");
const $171cde3cecf9f5e8$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $91lt4.LazyAlertIssueSync),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});
parcelRegister("91lt4", function(module, exports) {
$parcel$export(module.exports, "LazyAlertIssueSync", () => $fbbc03211b5cc15e$export$dbbcce89c7be1e71);
$parcel$export(module.exports, "LazyAlertIssueSyncCreate", () => $fbbc03211b5cc15e$export$ff3e9ed7471eebce);
$parcel$export(module.exports, "LazyAlertIssueSyncDetail", () => $fbbc03211b5cc15e$export$75137a2a583918e2);

var $bQWwW = parcelRequire("bQWwW");

const $fbbc03211b5cc15e$export$dbbcce89c7be1e71 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9yrV5")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $fbbc03211b5cc15e$export$ff3e9ed7471eebce = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9yrV5")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $fbbc03211b5cc15e$export$75137a2a583918e2 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9yrV5")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

});
parcelRegister("9yrV5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Acsm").then(()=>parcelRequire('6dsY7'));

});



parcelRegister("4dPst", function(module, exports) {
$parcel$export(module.exports, "AlertIssueSyncCreate", () => $0359aa9666dfd98a$export$a26f24c49385cf3a);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $91lt4 = parcelRequire("91lt4");
const $0359aa9666dfd98a$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $91lt4.LazyAlertIssueSyncCreate),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("jP5bP", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingDetailRouteEntry", () => $340f4a7b0a748fb9$export$7e604b22ae6e7c1e);

var $7ZjlZ = parcelRequire("7ZjlZ");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $78a75 = parcelRequire("78a75");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $jXwOY = parcelRequire("jXwOY");

var $gne1j = parcelRequire("gne1j");

var $91lt4 = parcelRequire("91lt4");
const $340f4a7b0a748fb9$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $340f4a7b0a748fb9$export$7e604b22ae6e7c1e = (0, $6xToB.createEntry)((0, $78a75.eocAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        slot: (0, $gne1j.AlertIssueSyncDetail),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $7ZjlZ.resources).configuredSyncsResource,
            (0, $7ZjlZ.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$340f4a7b0a748fb9$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-alert-issue-syncing-entries/src/eocAlertIssueSyncingDetailRouteEntry.tsx',
                whichExportToUse: 'eocAlertIssueSyncingDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("78a75", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", () => $e453ebe087689708$export$f1b4093ef603b98d);
const $e453ebe087689708$export$f1b4093ef603b98d = {
    name: 'eoc-alert-issue-syncing-detail',
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};

});

parcelRegister("gne1j", function(module, exports) {
$parcel$export(module.exports, "AlertIssueSyncDetail", () => $8ddb0455f3defe71$export$c21f2a7e1aa801a7);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $91lt4 = parcelRequire("91lt4");
const $8ddb0455f3defe71$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $91lt4.LazyAlertIssueSyncDetail),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("lmaBn", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingRouteEntry", () => $e7669f2f70889228$export$c63d0942ec0f93c);

var $7ZjlZ = parcelRequire("7ZjlZ");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $83tUc = parcelRequire("83tUc");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $91lt4 = parcelRequire("91lt4");

var $jXwOY = parcelRequire("jXwOY");
const $e7669f2f70889228$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e7669f2f70889228$export$c63d0942ec0f93c = (0, $6xToB.createEntry)((0, $83tUc.eocAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        slot: null,
        basePath: '/jira/settings/products/ops',
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $7ZjlZ.resources).configuredSyncsResource,
            (0, $7ZjlZ.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$e7669f2f70889228$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-alert-issue-syncing-entries/src/eocAlertIssueSyncingRouteEntry.tsx',
                whichExportToUse: 'eocAlertIssueSyncingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iRfwO", function(module, exports) {
$parcel$export(module.exports, "opsSettingsLayout", () => $89e42e11d77f40df$export$96d5e7da242cacf9);
$parcel$export(module.exports, "opsMigrationHubLayout", () => $89e42e11d77f40df$export$d4e92309ebd00b0f);
$parcel$export(module.exports, "opsNotificationsLayout", () => $89e42e11d77f40df$export$5714bc9520dbc6cf);

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

var $yRJUA = parcelRequire("yRJUA");

var $7h3uc = parcelRequire("7h3uc");

const $89e42e11d77f40df$export$f61c80ac3b95bc7d = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1Z8WU")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$89e42e11d77f40df$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

const $89e42e11d77f40df$export$70238cd3868b67c9 = (0, $bJscI.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("18isC")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$89e42e11d77f40df$export$70238cd3868b67c9.displayName = 'Onboarding';
const $89e42e11d77f40df$export$96d5e7da242cacf9 = (0, $6dwgv.composeLayouts)((0, $yRJUA.globalSettingsLayout), {
    get globalComponents () {
        return [
            $89e42e11d77f40df$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $89e42e11d77f40df$export$f61c80ac3b95bc7d
    ]
});
const $89e42e11d77f40df$export$d4e92309ebd00b0f = (0, $6dwgv.createLayout)({
    get globalComponents () {
        return [
            $89e42e11d77f40df$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $89e42e11d77f40df$export$f61c80ac3b95bc7d
    ]
});
const $89e42e11d77f40df$export$5714bc9520dbc6cf = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    get globalComponents () {
        return [
            $89e42e11d77f40df$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $89e42e11d77f40df$export$f61c80ac3b95bc7d
    ]
});

});

parcelRegister("83tUc", function(module, exports) {
$parcel$export(module.exports, "eocAlertIssueSyncingRoute", () => $a0ff879417ff8c9b$export$73d6a0dc298aae15);
const $a0ff879417ff8c9b$export$73d6a0dc298aae15 = {
    name: 'eoc-alert-issue-syncing',
    path: '/jira/settings/products/ops/syncs',
    exact: true
};

});


parcelRegister("6egyA", function(module, exports) {
$parcel$export(module.exports, "eocApiKeyManagementRouteEntry", () => $0807834eb69697da$export$e18a6be3d2ffad71);

var $bGcKu = parcelRequire("bGcKu");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $j7rf7 = parcelRequire("j7rf7");

var $4cTDP = parcelRequire("4cTDP");

var $6zXPf = parcelRequire("6zXPf");

var $fXF6E = parcelRequire("fXF6E");

var $vd3SG = parcelRequire("vd3SG");
const $0807834eb69697da$var$getNavigationSpecifications = ()=>{
    return (0, $6zXPf.getWillShowNav4)() && (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $0807834eb69697da$export$e18a6be3d2ffad71 = (0, $6xToB.createEntry)((0, $j7rf7.eocApiKeyManagementRoute), ()=>({
        group: 'eoc',
        component: (0, $vd3SG.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$0807834eb69697da$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $bGcKu.resources)()
        ],
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $vd3SG.LazyApiKeyManagement)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $vd3SG.LazyApiKeyManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-api-key-management-entries/src/eocApiKeyManagementRouteEntry.tsx',
                whichExportToUse: 'eocApiKeyManagementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bGcKu", function(module, exports) {
$parcel$export(module.exports, "apiKeysResource", () => $c9afd51ff0a01b8b$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $c9afd51ff0a01b8b$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");
parcelRequire("1DrRY");
var $igkn1 = parcelRequire("igkn1");

var $93Z36 = parcelRequire("93Z36");
const $c9afd51ff0a01b8b$export$a98d5421eda11f29 = (0, $l1VxS.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $igkn1.eocUserResource).type]?.promise;
        return (0, $93Z36.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $igkn1.eocUserResource).type
    ]
});
const $c9afd51ff0a01b8b$export$bc99aaabaf7b70a7 = ()=>[
        (0, $igkn1.eocUserResource),
        $c9afd51ff0a01b8b$export$a98d5421eda11f29
    ];

});
parcelRegister("1DrRY", function(module, exports) {
$parcel$export(module.exports, "eocCommonResources", () => $fe69cddeae506bb2$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("igkn1")).eocUserResource);

var $igkn1 = parcelRequire("igkn1");
const $fe69cddeae506bb2$export$8977bbbf2f7167d2 = ()=>[
        (0, $igkn1.eocUserResource)
    ];

});
parcelRegister("igkn1", function(module, exports) {
$parcel$export(module.exports, "eocUserResource", () => $313db6663794c5a4$export$3a08a0bdeef86956);

var $l1VxS = parcelRequire("l1VxS");

var $9nrPW = parcelRequire("9nrPW");
const $313db6663794c5a4$export$3a08a0bdeef86956 = (0, $l1VxS.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $9nrPW.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("9nrPW", function(module, exports) {
$parcel$export(module.exports, "fetchJsmUserInfo", () => $f7f256c17993c162$export$7d750310098b5a7);

var $9ppkU = parcelRequire("9ppkU");
var $fR4Ty = parcelRequire("fR4Ty");
const $f7f256c17993c162$var$JSM_BASE_URL = '/rest/api/3/myself';
const $f7f256c17993c162$export$7d750310098b5a7 = ()=>{
    return (0, $9ppkU.eocFetch)($f7f256c17993c162$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $fR4Ty.jsmErrorTransformer)
    });
};

});



parcelRegister("93Z36", function(module, exports) {
$parcel$export(module.exports, "fetchKeys", () => $001afe773e5f79f5$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $001afe773e5f79f5$export$d2f8649a375a4113);

var $9ppkU = parcelRequire("9ppkU");
const $001afe773e5f79f5$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $9ppkU.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $001afe773e5f79f5$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $9ppkU.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("j7rf7", function(module, exports) {
$parcel$export(module.exports, "eocApiKeyManagementRoute", () => $37320d71e199c893$export$84985159d5695f4d);
const $37320d71e199c893$export$84985159d5695f4d = {
    name: 'eoc-api-key-management',
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};

});

parcelRegister("vd3SG", function(module, exports) {
$parcel$export(module.exports, "LazyApiKeyManagement", () => $591f70ea6542176a$export$6ae4b26c31b1b0d2);
$parcel$export(module.exports, "default", () => $591f70ea6542176a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $591f70ea6542176a$export$6ae4b26c31b1b0d2 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9PHwz")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
const $591f70ea6542176a$var$AsyncApiKeyManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $591f70ea6542176a$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });
var $591f70ea6542176a$export$2e2bcd8739ae039 = $591f70ea6542176a$var$AsyncApiKeyManagement;

});
parcelRegister("9PHwz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("feh32").then(()=>parcelRequire('fP0nh'));

});



parcelRegister("5JjgV", function(module, exports) {
$parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", () => $80b7eb9e24c3f73b$export$c51a4ee3e3f1b270);

var $eUzkS = parcelRequire("eUzkS");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $hCdSq = parcelRequire("hCdSq");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $9fAJx = parcelRequire("9fAJx");
const $80b7eb9e24c3f73b$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $80b7eb9e24c3f73b$export$c51a4ee3e3f1b270 = (0, $6xToB.createEntry)((0, $hCdSq.eocAssignCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $9fAJx.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$80b7eb9e24c3f73b$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $eUzkS.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9fAJx.LazyAssignCustomRoles)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9fAJx.LazyAssignCustomRoles)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-assign-custom-roles-entries/src/eocAssignCustomRolesRouteEntry.tsx',
                whichExportToUse: 'eocAssignCustomRolesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eUzkS", function(module, exports) {
$parcel$export(module.exports, "rolesResource", () => $d8a59ebf93b1648b$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $d8a59ebf93b1648b$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $9xKfL = parcelRequire("9xKfL");
const $d8a59ebf93b1648b$export$52e29d5915d5f674 = (0, $l1VxS.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $9xKfL.getRolesEndpoint),
    isBrowserOnly: true
});
const $d8a59ebf93b1648b$export$bc99aaabaf7b70a7 = ()=>[
        $d8a59ebf93b1648b$export$52e29d5915d5f674
    ];

});
parcelRegister("9xKfL", function(module, exports) {
$parcel$export(module.exports, "getUsersEndpoint", () => $7dd3b8deb6c34466$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $7dd3b8deb6c34466$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $7dd3b8deb6c34466$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $7dd3b8deb6c34466$export$a0b296dc0259976f);

var $9ppkU = parcelRequire("9ppkU");

var $1xlYu = parcelRequire("1xlYu");
const $7dd3b8deb6c34466$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $1xlYu.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $9ppkU.eocFetch)(url);
};
const $7dd3b8deb6c34466$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $9ppkU.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $7dd3b8deb6c34466$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $9ppkU.eocFetch)('/v1/users/roles');
};
const $7dd3b8deb6c34466$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("1xlYu", function(module, exports) {
$parcel$export(module.exports, "URLBuilder", () => $f587f0fea93ecea3$export$61d2e8db329a11f8);
class $f587f0fea93ecea3$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("hCdSq", function(module, exports) {
$parcel$export(module.exports, "eocAssignCustomRolesRoute", () => $b8461b7b2865c5e2$export$79c37191a61ac94b);
const $b8461b7b2865c5e2$export$79c37191a61ac94b = {
    name: 'eoc-assign-custom-roles',
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};

});

parcelRegister("9fAJx", function(module, exports) {
$parcel$export(module.exports, "LazyAssignCustomRoles", () => $5bfcff16018399de$export$fb6bafef9453a357);
$parcel$export(module.exports, "default", () => $5bfcff16018399de$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $5bfcff16018399de$export$fb6bafef9453a357 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cbB7S")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
const $5bfcff16018399de$var$AsyncAssignCustomRoles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5bfcff16018399de$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });
var $5bfcff16018399de$export$2e2bcd8739ae039 = $5bfcff16018399de$var$AsyncAssignCustomRoles;

});
parcelRegister("cbB7S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6FmR0").then(()=>parcelRequire('2y4Ff'));

});



parcelRegister("gTM9q", function(module, exports) {
$parcel$export(module.exports, "eocAutomationsRouteEntry", () => $7b4c9d28536c2bf9$export$6ff606556e19e12);

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $bWlm7 = parcelRequire("bWlm7");

var $3RwpL = parcelRequire("3RwpL");
const $7b4c9d28536c2bf9$export$6ff606556e19e12 = (0, $6xToB.createEntry)((0, $bWlm7.eocAutomationsRoute), ()=>({
        group: 'eoc',
        component: (0, $3RwpL.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3RwpL.LazyOpsTeamAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-automations-entries/src/eocAutomationsRouteEntry.tsx',
                whichExportToUse: 'eocAutomationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bWlm7", function(module, exports) {
$parcel$export(module.exports, "eocAutomationsRoute", () => $559682becc30910d$export$4a84eb4d8d37c9d4);
const $559682becc30910d$export$4a84eb4d8d37c9d4 = {
    name: 'eoc-automations',
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};

});

parcelRegister("3RwpL", function(module, exports) {
$parcel$export(module.exports, "LazyOpsTeamAutomation", () => $0c73ca548832a597$export$903a0a44cc0933c5);
$parcel$export(module.exports, "default", () => $0c73ca548832a597$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $0c73ca548832a597$export$903a0a44cc0933c5 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cZEGH")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
const $0c73ca548832a597$var$AsyncOpsTeamAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0c73ca548832a597$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });
var $0c73ca548832a597$export$2e2bcd8739ae039 = $0c73ca548832a597$var$AsyncOpsTeamAutomation;

});
parcelRegister("cZEGH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aQa7o").then(()=>parcelRequire('3EYJt'));

});



parcelRegister("bJd2N", function(module, exports) {
$parcel$export(module.exports, "eocCustomRolesRouteEntry", () => $27f8adf98042f45f$export$9c9bab95d425eb6f);

var $gWsiK = parcelRequire("gWsiK");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $hObAB = parcelRequire("hObAB");

var $4cTDP = parcelRequire("4cTDP");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $fXF6E = parcelRequire("fXF6E");

var $doKHc = parcelRequire("doKHc");
const $27f8adf98042f45f$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $27f8adf98042f45f$export$9c9bab95d425eb6f = (0, $6xToB.createEntry)((0, $hObAB.eocCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $doKHc.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$27f8adf98042f45f$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $gWsiK.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $doKHc.LazyCustomRoles)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $doKHc.LazyCustomRoles)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-custom-roles-entries/src/eocCustomRolesRouteEntry.tsx',
                whichExportToUse: 'eocCustomRolesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gWsiK", function(module, exports) {
$parcel$export(module.exports, "customRolesResource", () => $672e0d2b3d60b5f7$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $672e0d2b3d60b5f7$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $lpO35 = parcelRequire("lpO35");
const $672e0d2b3d60b5f7$export$7140716a1b1b8e7a = (0, $l1VxS.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $lpO35.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $672e0d2b3d60b5f7$export$bc99aaabaf7b70a7 = ()=>[
        $672e0d2b3d60b5f7$export$7140716a1b1b8e7a
    ];

});
parcelRegister("lpO35", function(module, exports) {
$parcel$export(module.exports, "getPermissionsEndpoint", () => $491b2e8650a5fdbf$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $491b2e8650a5fdbf$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $491b2e8650a5fdbf$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $491b2e8650a5fdbf$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $491b2e8650a5fdbf$export$3619edac53aa59fd);

var $9ppkU = parcelRequire("9ppkU");
const $491b2e8650a5fdbf$export$f97b589720c51ce1 = ()=>(0, $9ppkU.eocFetch)(`/v1/users/permissions`);
const $491b2e8650a5fdbf$export$5a7187e04c844900 = (newCustomRole)=>(0, $9ppkU.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $491b2e8650a5fdbf$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $9ppkU.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $491b2e8650a5fdbf$export$e12995ccad013f65 = (id)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $491b2e8650a5fdbf$export$3619edac53aa59fd = ()=>(0, $9ppkU.eocFetch)(`/v1/users/roles`);

});


parcelRegister("hObAB", function(module, exports) {
$parcel$export(module.exports, "eocCustomRolesRoute", () => $9fd95fd7b4578d26$export$3213a7325ca9911);
const $9fd95fd7b4578d26$export$3213a7325ca9911 = {
    name: 'eoc-custom-roles',
    path: '/jira/settings/products/ops/roles',
    exact: true
};

});

parcelRegister("doKHc", function(module, exports) {
$parcel$export(module.exports, "LazyCustomRoles", () => $dd207319cda3505c$export$78ed54710f55f948);
$parcel$export(module.exports, "default", () => $dd207319cda3505c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $dd207319cda3505c$export$78ed54710f55f948 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3D25W")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
const $dd207319cda3505c$var$AsyncCustomRoles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $dd207319cda3505c$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });
var $dd207319cda3505c$export$2e2bcd8739ae039 = $dd207319cda3505c$var$AsyncCustomRoles;

});
parcelRegister("3D25W", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("76okG").then(()=>parcelRequire('9Qguw'));

});



parcelRegister("2Q9dT", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRedirectRouteEntry", () => $c7e7856940511d22$export$4fc438c20edc8a6f);

var $3dkey = parcelRequire("3dkey");

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $2p5Lf = parcelRequire("2p5Lf");

var $jhbvD = parcelRequire("jhbvD");
const $c7e7856940511d22$export$4fc438c20edc8a6f = (0, $6xToB.createEntry)((0, $2p5Lf.eocGlobalAlertListRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $jhbvD.AlertListComponent),
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $3dkey.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jhbvD.LazyAlertList),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-global-alerts-entries/src/eocGlobalAlertListRedirectRouteEntry.tsx',
                whichExportToUse: 'eocGlobalAlertListRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3dkey", function(module, exports) {
$parcel$export(module.exports, "resources", () => $27ffdecbbb7f4aa3$export$bc99aaabaf7b70a7);

var $1cKle = parcelRequire("1cKle");

var $1DrRY = parcelRequire("1DrRY");

var $dOQqF = parcelRequire("dOQqF");

var $8Z3ze = parcelRequire("8Z3ze");

var $1rj7Z = parcelRequire("1rj7Z");
const $27ffdecbbb7f4aa3$export$bc99aaabaf7b70a7 = ()=>[
        (0, $1rj7Z.uiPreferencesResource),
        (0, $8Z3ze.savedSearchesResource),
        (0, $dOQqF.compressionRatioResource),
        (0, $1cKle.alertGroupingStateResource),
        ...(0, $1DrRY.eocCommonResources)()
    ];

});
parcelRegister("1cKle", function(module, exports) {
$parcel$export(module.exports, "alertGroupingStateResource", () => $1acade67ad7ca69b$export$722cc8285202ce44);

var $l1VxS = parcelRequire("l1VxS");

var $e5Myg = parcelRequire("e5Myg");
const $1acade67ad7ca69b$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $1acade67ad7ca69b$export$722cc8285202ce44 = (0, $l1VxS.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $e5Myg.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $1acade67ad7ca69b$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("e5Myg", function(module, exports) {
$parcel$export(module.exports, "getGroupFeatureStatus", () => $57e4590e5c8568cb$export$48deee62d9dfb365);

var $aWSdN = parcelRequire("aWSdN");

var $fhWef = parcelRequire("fhWef");

var $9ppkU = parcelRequire("9ppkU");
const $57e4590e5c8568cb$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $fhWef.URLBuilder)((0, $aWSdN.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $9ppkU.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("aWSdN", function(module, exports) {
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $e5aaefd8928fa6bd$export$81c70e0016508593);

var $fR4Ty = parcelRequire("fR4Ty");
const $e5aaefd8928fa6bd$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});

parcelRegister("fhWef", function(module, exports) {
$parcel$export(module.exports, "URLBuilder", () => $3309fdecaf47b5c6$export$61d2e8db329a11f8);
class $3309fdecaf47b5c6$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("dOQqF", function(module, exports) {
$parcel$export(module.exports, "compressionRatioResource", () => $d446b87ab91b6cda$export$8c912e73f758af2);

var $l1VxS = parcelRequire("l1VxS");

var $eGOwo = parcelRequire("eGOwo");

var $cHouZ = parcelRequire("cHouZ");
const $d446b87ab91b6cda$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $d446b87ab91b6cda$export$8c912e73f758af2 = (0, $l1VxS.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        // When unified-view-revamp is enabled, return null instead of making the API call
        if ((0, $eGOwo.fg)('unified-view-revamp')) return null;
        try {
            const response = await (0, $cHouZ.getCompressionRatio)();
            return response;
        } catch (e) {
            return $d446b87ab91b6cda$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("cHouZ", function(module, exports) {
$parcel$export(module.exports, "getCompressionRatio", () => $24e4ecb87827e22d$export$4991457f359db4f7);

var $9ppkU = parcelRequire("9ppkU");

var $aZHG3 = parcelRequire("aZHG3");
const $24e4ecb87827e22d$export$4991457f359db4f7 = ()=>{
    return (0, $9ppkU.eocFetch)((0, $aZHG3.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("8Z3ze", function(module, exports) {
$parcel$export(module.exports, "savedSearchesResource", () => $1a0d77c8439bdb15$export$d915b849e6dd786b);

var $l1VxS = parcelRequire("l1VxS");

var $9KL5d = parcelRequire("9KL5d");
const $1a0d77c8439bdb15$export$d915b849e6dd786b = (0, $l1VxS.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $9KL5d.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});

parcelRegister("1rj7Z", function(module, exports) {
$parcel$export(module.exports, "uiPreferencesResource", () => $feebfa846b971a80$export$4e143f0fe4b2e025);

var $l1VxS = parcelRequire("l1VxS");

var $98zPG = parcelRequire("98zPG");
const $feebfa846b971a80$export$4e143f0fe4b2e025 = (0, $l1VxS.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $98zPG.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("98zPG", function(module, exports) {
$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $53577c3b4b3131a2$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $53577c3b4b3131a2$export$4990793476d8f783);

var $9ppkU = parcelRequire("9ppkU");
const $53577c3b4b3131a2$export$afa4854419ed2fc8 = ()=>{
    return (0, $9ppkU.eocFetch)('/v1/alerts/ui-preferences');
};
const $53577c3b4b3131a2$export$4990793476d8f783 = (data)=>{
    return (0, $9ppkU.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});



parcelRegister("7TRTJ", function(module, exports) {
$parcel$export(module.exports, "LazyGlobalAlertsSidebar", () => $caf22840305bd6a5$export$674fd99c08c90491);
$parcel$export(module.exports, "AsyncSidebarEocGlobalAlerts", () => $caf22840305bd6a5$export$a1c034c1031e8711);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $bQWwW = parcelRequire("bQWwW");

const $caf22840305bd6a5$export$674fd99c08c90491 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4sVSg")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $caf22840305bd6a5$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($caf22840305bd6a5$export$674fd99c08c90491, null));

});
parcelRegister("4sVSg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kE76g")
]).then(()=>parcelRequire('6Ya0u'));

});


parcelRegister("2p5Lf", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRedirectRoute", () => $ff44028307d04ba8$export$491d479dc37383e9);
const $ff44028307d04ba8$export$491d479dc37383e9 = {
    name: 'eoc-global-alerts-redirect',
    path: '/jira/ops',
    exact: true
};

});

parcelRegister("jhbvD", function(module, exports) {
$parcel$export(module.exports, "LazyAlertList", () => $7290c43ada9de388$export$f4aafff31d950b6c);
$parcel$export(module.exports, "AlertListComponent", () => $7290c43ada9de388$export$9333bfa567c9c31);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7290c43ada9de388$export$f4aafff31d950b6c = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kSyqr")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $7290c43ada9de388$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7290c43ada9de388$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});
parcelRegister("kSyqr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("1uNFv")
]).then(()=>parcelRequire('nPAxe'));

});



parcelRegister("hr8RB", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertListRouteEntry", () => $3a3e13783354d482$export$851a659e50436cff);

var $3dkey = parcelRequire("3dkey");

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $jn07M = parcelRequire("jn07M");

var $jhbvD = parcelRequire("jhbvD");
const $3a3e13783354d482$export$851a659e50436cff = (0, $6xToB.createEntry)((0, $jn07M.eocGlobalAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $jhbvD.AlertListComponent),
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $3dkey.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jhbvD.LazyAlertList),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-global-alerts-entries/src/eocGlobalAlertListRouteEntry.tsx',
                whichExportToUse: 'eocGlobalAlertListRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("haVHi", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertsDetailRouteEntry", () => $446e77773c8ea48d$export$bcb93d8198d511b9);

var $8T8NA = parcelRequire("8T8NA");

var $3dkey = parcelRequire("3dkey");

var $i1cBv = parcelRequire("i1cBv");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $jibdU = parcelRequire("jibdU");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $jhbvD = parcelRequire("jhbvD");
const $446e77773c8ea48d$export$bcb93d8198d511b9 = (0, $6xToB.createEntry)((0, $jibdU.eocGlobalAlertsDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jhbvD.AlertListComponent),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $3dkey.resources)(),
            ...(0, $8T8NA.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('automation_discoverability_in_jsm'), (0, $i1cBv.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jhbvD.LazyAlertList),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-global-alerts-entries/src/eocGlobalAlertsDetailRouteEntry.tsx',
                whichExportToUse: 'eocGlobalAlertsDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8T8NA", function(module, exports) {
$parcel$export(module.exports, "alertDetailResource", () => $33cced6bde85e287$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $33cced6bde85e287$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $33cced6bde85e287$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $33cced6bde85e287$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $33cced6bde85e287$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $eaj78 = parcelRequire("eaj78");

var $1YX1S = parcelRequire("1YX1S");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $1DrRY = parcelRequire("1DrRY");

var $cy3Z3 = parcelRequire("cy3Z3");

var $er8Il = parcelRequire("er8Il");
const $33cced6bde85e287$var$ALERT_DETAIL_RESOURCE_TYPE = 'alertDetailResource';
const $33cced6bde85e287$export$f918335771807ac4 = (0, $l1VxS.createResource)({
    type: $33cced6bde85e287$var$ALERT_DETAIL_RESOURCE_TYPE,
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $cyz90.assert)(!!alertId, new (0, $gLoFN.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $er8Il.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $33cced6bde85e287$export$f9c57ab4d5f63686 = (0, $l1VxS.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $er8Il.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $33cced6bde85e287$export$a5515392cb45b9f8 = (0, $l1VxS.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $cyz90.assert)(!!alertId, new (0, $gLoFN.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(alertId)) {
            const { id: id } = await (0, $cy3Z3.consumeDependency)(dependencies, $33cced6bde85e287$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $er8Il.getEntityRelationTypesEndpoint)(id);
        }
        return (0, $er8Il.getEntityRelationTypesEndpoint)(alertId);
    },
    depends: [
        $33cced6bde85e287$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $33cced6bde85e287$export$c3b70747662e5932 = (0, $l1VxS.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $cyz90.assert)(!!alertId, new (0, $gLoFN.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(alertId)) {
            const { id: id } = await (0, $cy3Z3.consumeDependency)(dependencies, $33cced6bde85e287$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $er8Il.getResponderStatesEndpoint)(id);
        }
        return (0, $er8Il.getResponderStatesEndpoint)(alertId);
    },
    depends: [
        $33cced6bde85e287$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $33cced6bde85e287$export$bc99aaabaf7b70a7 = ()=>[
        $33cced6bde85e287$export$f918335771807ac4,
        $33cced6bde85e287$export$f9c57ab4d5f63686,
        $33cced6bde85e287$export$c3b70747662e5932,
        $33cced6bde85e287$export$a5515392cb45b9f8,
        (0, $1YX1S.relatedAlertGroupResource),
        ...(0, $1DrRY.eocCommonResources)()
    ];

});
parcelRegister("eaj78", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5Ovjr = parcelRequire("5Ovjr");
var $a500d3812b6eabd3$require$Buffer = $5Ovjr.Buffer;
var $a500d3812b6eabd3$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $a500d3812b6eabd3$var$_byteToHex = [];
for(var $a500d3812b6eabd3$var$i = 0; $a500d3812b6eabd3$var$i < 256; $a500d3812b6eabd3$var$i++)$a500d3812b6eabd3$var$_byteToHex[$a500d3812b6eabd3$var$i] = ($a500d3812b6eabd3$var$i + 0x100).toString(16).substr(1);
function $a500d3812b6eabd3$var$unparse(buf, offset) {
    var i = offset || 0, bth = $a500d3812b6eabd3$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($a500d3812b6eabd3$require$Buffer.isBuffer(uuid)) parsedUuid = $a500d3812b6eabd3$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$a500d3812b6eabd3$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $a500d3812b6eabd3$var$extractVersion(parsedUuid);
    else if ($a500d3812b6eabd3$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $a500d3812b6eabd3$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("1YX1S", function(module, exports) {
$parcel$export(module.exports, "relatedAlertGroupResource", () => $7b7ca11b320f5638$export$35df14c9f0cfb113);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $fmirN = parcelRequire("fmirN");
const $7b7ca11b320f5638$export$35df14c9f0cfb113 = (0, $l1VxS.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $cyz90.assert)(!!alertId, new (0, $gLoFN.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $fmirN.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("fmirN", function(module, exports) {
$parcel$export(module.exports, "getRelatedAlertGroup", () => $9dbba1738bca9585$export$665e34f20aad273a);

var $9ppkU = parcelRequire("9ppkU");

var $bIc5E = parcelRequire("bIc5E");
const $9dbba1738bca9585$export$665e34f20aad273a = (alertId)=>(0, $9ppkU.eocFetch)((0, $bIc5E.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("bIc5E", function(module, exports) {
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $acd93d06c2e8e90d$export$81c70e0016508593);

var $fR4Ty = parcelRequire("fR4Ty");
const $acd93d06c2e8e90d$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("cy3Z3", function(module, exports) {
$parcel$export(module.exports, "consumeDependency", () => $d2d7d8e9e19d4a5a$export$a973ef9e17a326f);
async function $d2d7d8e9e19d4a5a$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("er8Il", function(module, exports) {
$parcel$export(module.exports, "getAlertDetail", () => $f647f3b621aa2a99$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $f647f3b621aa2a99$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $f647f3b621aa2a99$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $f647f3b621aa2a99$export$8f96130abdd7549d);

var $9ppkU = parcelRequire("9ppkU");
const $f647f3b621aa2a99$export$436b6d88c1865c54 = (alertId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/${alertId}`);
const $f647f3b621aa2a99$export$97200f7e7a7d1479 = ()=>(0, $9ppkU.eocFetch)(`/v1/alerts/logs/types`);
const $f647f3b621aa2a99$export$498d1a9ea659d430 = (alertId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $f647f3b621aa2a99$export$8f96130abdd7549d = (alertId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("i1cBv", function(module, exports) {
$parcel$export(module.exports, "getAutomationDiscoveryDismissResource", () => $78a06afdcb26f495$export$3e9b930ef3c80543);

var $l1VxS = parcelRequire("l1VxS");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $aQFRz = parcelRequire("aQFRz");
const $78a06afdcb26f495$var$PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';
const $78a06afdcb26f495$export$3e9b930ef3c80543 = (0, $l1VxS.createResource)({
    type: 'getAutomationDiscoveryDismiss',
    getKey: ()=>'getAutomationDiscoveryDismiss',
    getData: async ()=>{
        try {
            const res = await (0, $3ugTQ.performGetRequest)(`/rest/api/3/mypreferences?key=${$78a06afdcb26f495$var$PROPERTY_KEY}`);
            return res;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $aQFRz.NOT_FOUND)) return null;
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getDismissData',
                    teamName: 'ITOps Phantom',
                    packageName: 'jiraEocAutomationDiscovery'
                }
            });
            throw error;
        }
    },
    maxAge: 300000
});

});

parcelRegister("jibdU", function(module, exports) {
$parcel$export(module.exports, "eocGlobalAlertsDetailRoute", () => $a56b027b36a6ba01$export$d87948ea641004e2);
const $a56b027b36a6ba01$export$d87948ea641004e2 = {
    name: 'eoc-global-alert-detail',
    path: '/jira/ops/alerts/:id',
    exact: true
};

});


parcelRegister("gCQuB", function(module, exports) {
$parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", () => $aa5067eb6d4b9bab$export$66928ab349190059);

var $3dkey = parcelRequire("3dkey");

var $8vvFn = parcelRequire("8vvFn");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $7TRTJ = parcelRequire("7TRTJ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $kPioY = parcelRequire("kPioY");

var $9HKZp = parcelRequire("9HKZp");
const $aa5067eb6d4b9bab$export$66928ab349190059 = (0, $6xToB.createEntry)((0, $kPioY.eocGlobalGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $9HKZp.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $8vvFn.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $3dkey.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            sidebar: (0, $7TRTJ.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9HKZp.LazyGroupDetail),
            (0, $7TRTJ.LazyGlobalAlertsSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-group-detail-entries/src/eocGlobalGroupDetailRouteEntry.tsx',
                whichExportToUse: 'eocGlobalGroupDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8vvFn", function(module, exports) {
$parcel$export(module.exports, "groupHeaderResource", () => $47cf05f6055feeb0$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $47cf05f6055feeb0$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $47cf05f6055feeb0$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $9ACQM = parcelRequire("9ACQM");
const $47cf05f6055feeb0$export$e6ba56f6b67069c8 = (0, $l1VxS.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $cyz90.assert)(!!groupId, new (0, $gLoFN.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $9ACQM.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $47cf05f6055feeb0$export$94675faef1d4568b = (0, $l1VxS.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $cyz90.assert)(!!groupId, new (0, $gLoFN.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $9ACQM.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $47cf05f6055feeb0$export$bc99aaabaf7b70a7 = ()=>[
        $47cf05f6055feeb0$export$e6ba56f6b67069c8,
        $47cf05f6055feeb0$export$94675faef1d4568b
    ];

});
parcelRegister("9ACQM", function(module, exports) {
$parcel$export(module.exports, "getHeaderDetails", () => $5b7315fc327c8731$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $5b7315fc327c8731$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $5b7315fc327c8731$export$bd5bdebdb6d9abb);

var $9ppkU = parcelRequire("9ppkU");

var $68DQk = parcelRequire("68DQk");
const $5b7315fc327c8731$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $9ppkU.eocFetch)((0, $68DQk.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $5b7315fc327c8731$export$34bb7a15a54039a5 = (groupId)=>(0, $9ppkU.eocFetch)((0, $68DQk.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $5b7315fc327c8731$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $9ppkU.eocFetch)((0, $68DQk.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });

});
parcelRegister("68DQk", function(module, exports) {
$parcel$export(module.exports, "withAIOpsPrefix", () => $0777b11e7e521a69$export$5ad74397753c99a2);
$parcel$export(module.exports, "formatTimezone", () => $0777b11e7e521a69$export$26da7aa151b6684c);

var $gjGnq = parcelRequire("gjGnq");

var $d6a6O = parcelRequire("d6a6O");

var $fR4Ty = parcelRequire("fR4Ty");
const $0777b11e7e521a69$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
function $0777b11e7e521a69$export$9e555a50010549c1(timezone) {
    const splittedTz = timezone.split('/');
    // EST || EST5EDT
    if (splittedTz.length === 0) return splittedTz;
    // Europe/Amsterdam || Europe/Isle_of_Man || America/North_Dakota/New_Salem
    if (splittedTz.length > 0) {
        const areaName = splittedTz[splittedTz.length - 1];
        return areaName.replace(/_/g, ' ');
    }
    return timezone;
}
function $0777b11e7e521a69$export$26da7aa151b6684c(timezone) {
    const timeZone = timezone ?? (0, $d6a6O.guessUserTimeZone)();
    return (0, $gjGnq.default)(new Date(), timeZone, `z '${$0777b11e7e521a69$export$9e555a50010549c1(timeZone)}'`);
}

});
parcelRegister("gjGnq", function(module, exports) {
$parcel$export(module.exports, "default", () => $be0f4adbdc875f32$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $1aCDc = parcelRequire("1aCDc");

var $jC2UU = parcelRequire("jC2UU");
function $be0f4adbdc875f32$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $1aCDc.default)((0, $jC2UU.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("1aCDc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0da4b10041d75650$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $eWlwI = parcelRequire("eWlwI");

var $eHqVS = parcelRequire("eHqVS");
var $0da4b10041d75650$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $0da4b10041d75650$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($0da4b10041d75650$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $eHqVS.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $eWlwI.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("eWlwI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae072e319643c075$export$2e2bcd8739ae039);

var $2Somw = parcelRequire("2Somw");

var $my48x = parcelRequire("my48x");
var $ae072e319643c075$var$MILLISECONDS_IN_MINUTE = 60000;
var $ae072e319643c075$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $ae072e319643c075$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $ae072e319643c075$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $ae072e319643c075$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $ae072e319643c075$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $ae072e319643c075$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $ae072e319643c075$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $ae072e319643c075$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $ae072e319643c075$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $ae072e319643c075$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $ae072e319643c075$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $ae072e319643c075$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $2Somw.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $2Somw.default)('long', date, options);
        }
    }
};
function $ae072e319643c075$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $my48x.default)(timeZone, originalDate, true) / $ae072e319643c075$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $ae072e319643c075$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $ae072e319643c075$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $ae072e319643c075$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $ae072e319643c075$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $ae072e319643c075$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $ae072e319643c075$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $ae072e319643c075$var$formatTimezone(offset, dirtyDelimeter);
}
function $ae072e319643c075$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $ae072e319643c075$var$addLeadingZeros(minutes, 2);
}
var $ae072e319643c075$export$2e2bcd8739ae039 = $ae072e319643c075$var$formatters;

});
parcelRegister("2Somw", function(module, exports) {
$parcel$export(module.exports, "default", () => $218385beb55d0862$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $218385beb55d0862$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $218385beb55d0862$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $218385beb55d0862$var$partsTimeZone(dtf, date) : $218385beb55d0862$var$hackyTimeZone(dtf, date);
}
function $218385beb55d0862$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $218385beb55d0862$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $218385beb55d0862$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("my48x", function(module, exports) {
$parcel$export(module.exports, "default", () => $043c7aee502371fb$export$2e2bcd8739ae039);

var $03FXz = parcelRequire("03FXz");

var $jmm2b = parcelRequire("jmm2b");
var $043c7aee502371fb$var$MILLISECONDS_IN_HOUR = 3600000;
var $043c7aee502371fb$var$MILLISECONDS_IN_MINUTE = 60000;
var $043c7aee502371fb$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $043c7aee502371fb$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $043c7aee502371fb$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $043c7aee502371fb$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$043c7aee502371fb$var$validateTimezone(hours)) return NaN;
        return -(hours * $043c7aee502371fb$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $043c7aee502371fb$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$043c7aee502371fb$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $043c7aee502371fb$var$MILLISECONDS_IN_HOUR + minutes * $043c7aee502371fb$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($043c7aee502371fb$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $043c7aee502371fb$var$toUtcDate(date);
        var offset = $043c7aee502371fb$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $043c7aee502371fb$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $043c7aee502371fb$var$toUtcDate(date) {
    return (0, $jmm2b.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $043c7aee502371fb$var$calcOffset(date, timezoneString) {
    var tokens = (0, $03FXz.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $jmm2b.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $043c7aee502371fb$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $043c7aee502371fb$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $043c7aee502371fb$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $043c7aee502371fb$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $043c7aee502371fb$var$validIANATimezoneCache = {};
function $043c7aee502371fb$var$isValidTimezoneIANAString(timeZoneString) {
    if ($043c7aee502371fb$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $043c7aee502371fb$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("03FXz", function(module, exports) {
$parcel$export(module.exports, "default", () => $00b0d44964a94c88$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $00b0d44964a94c88$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $00b0d44964a94c88$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $00b0d44964a94c88$var$partsOffset(dtf, date) : $00b0d44964a94c88$var$hackyOffset(dtf, date);
}
var $00b0d44964a94c88$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $00b0d44964a94c88$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $00b0d44964a94c88$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $00b0d44964a94c88$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $00b0d44964a94c88$var$dtfCache = {};
function $00b0d44964a94c88$var$getDateTimeFormat(timeZone) {
    if (!$00b0d44964a94c88$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $00b0d44964a94c88$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $00b0d44964a94c88$var$dtfCache[timeZone];
}

});

parcelRegister("jmm2b", function(module, exports) {
$parcel$export(module.exports, "default", () => $e18129ee931ab169$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $e18129ee931ab169$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("eHqVS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab39f910b01e6404$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $my48x = parcelRequire("my48x");

var $a2bdU = parcelRequire("a2bdU");
var $ab39f910b01e6404$var$MILLISECONDS_IN_HOUR = 3600000;
var $ab39f910b01e6404$var$MILLISECONDS_IN_MINUTE = 60000;
var $ab39f910b01e6404$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $ab39f910b01e6404$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $a2bdU.default)
};
function $ab39f910b01e6404$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $ab39f910b01e6404$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $ab39f910b01e6404$var$splitDateString(argument);
    var parseYearResult = $ab39f910b01e6404$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $ab39f910b01e6404$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $ab39f910b01e6404$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $my48x.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $ab39f910b01e6404$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $ab39f910b01e6404$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $ab39f910b01e6404$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $ab39f910b01e6404$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $ab39f910b01e6404$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $ab39f910b01e6404$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $ab39f910b01e6404$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $ab39f910b01e6404$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $ab39f910b01e6404$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $ab39f910b01e6404$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $ab39f910b01e6404$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$ab39f910b01e6404$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $ab39f910b01e6404$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$ab39f910b01e6404$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $ab39f910b01e6404$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$ab39f910b01e6404$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $ab39f910b01e6404$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$ab39f910b01e6404$var$validateWeekDate(year, week)) return new Date(NaN);
        return $ab39f910b01e6404$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $ab39f910b01e6404$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$ab39f910b01e6404$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $ab39f910b01e6404$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $ab39f910b01e6404$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $ab39f910b01e6404$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$ab39f910b01e6404$var$validateTime(hours)) return NaN;
        return hours % 24 * $ab39f910b01e6404$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $ab39f910b01e6404$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$ab39f910b01e6404$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $ab39f910b01e6404$var$MILLISECONDS_IN_HOUR + minutes * $ab39f910b01e6404$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $ab39f910b01e6404$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$ab39f910b01e6404$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $ab39f910b01e6404$var$MILLISECONDS_IN_HOUR + minutes * $ab39f910b01e6404$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $ab39f910b01e6404$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $ab39f910b01e6404$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $ab39f910b01e6404$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $ab39f910b01e6404$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $ab39f910b01e6404$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $ab39f910b01e6404$var$isLeapYearIndex(year);
        if (isLeapYear && date > $ab39f910b01e6404$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $ab39f910b01e6404$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $ab39f910b01e6404$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $ab39f910b01e6404$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $ab39f910b01e6404$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $ab39f910b01e6404$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("a2bdU", function(module, exports) {
$parcel$export(module.exports, "default", () => $74e2cc047c3aa537$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $74e2cc047c3aa537$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $74e2cc047c3aa537$export$2e2bcd8739ae039 = $74e2cc047c3aa537$var$tzPattern;

});



parcelRegister("jC2UU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e473d42f04fd1bc2$export$2e2bcd8739ae039);

var $my48x = parcelRequire("my48x");

var $eHqVS = parcelRequire("eHqVS");
function $e473d42f04fd1bc2$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $eHqVS.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $my48x.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("d6a6O", function(module, exports) {
$parcel$export(module.exports, "guessUserTimeZone", () => $f2a0999258b7e14f$export$6fd096fe0456f5b);
$parcel$export(module.exports, "formatDate", () => $f2a0999258b7e14f$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getDefaultTimes", () => $f2a0999258b7e14f$export$951e947e785c998d);

var $gSdBV = parcelRequire("gSdBV");
function $f2a0999258b7e14f$export$6fd096fe0456f5b() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $f2a0999258b7e14f$export$3ae94a2503e890a1(date, timezone = $f2a0999258b7e14f$export$6fd096fe0456f5b(), format = 'PP p') {
    return (0, $gSdBV.default)(new Date(date), timezone, format);
}
const $f2a0999258b7e14f$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};

});
parcelRegister("gSdBV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c48c3f4990f92ec9$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $hifPr = parcelRequire("hifPr");

var $kmTx7 = parcelRequire("kmTx7");
function $c48c3f4990f92ec9$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $hifPr.default)((0, $kmTx7.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("hifPr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c970655b9aa044da$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $6lXMa = parcelRequire("6lXMa");

var $eT6gb = parcelRequire("eT6gb");
var $c970655b9aa044da$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $c970655b9aa044da$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($c970655b9aa044da$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $eT6gb.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $6lXMa.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("6lXMa", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a03128289e77c11$export$2e2bcd8739ae039);

var $jrRuo = parcelRequire("jrRuo");

var $32TIT = parcelRequire("32TIT");
var $4a03128289e77c11$var$MILLISECONDS_IN_MINUTE = 60000;
var $4a03128289e77c11$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $4a03128289e77c11$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4a03128289e77c11$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $4a03128289e77c11$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4a03128289e77c11$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $4a03128289e77c11$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4a03128289e77c11$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $4a03128289e77c11$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4a03128289e77c11$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $4a03128289e77c11$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4a03128289e77c11$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4a03128289e77c11$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $jrRuo.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $jrRuo.default)('long', date, options);
        }
    }
};
function $4a03128289e77c11$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $32TIT.default)(timeZone, originalDate, true) / $4a03128289e77c11$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $4a03128289e77c11$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $4a03128289e77c11$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $4a03128289e77c11$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $4a03128289e77c11$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $4a03128289e77c11$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $4a03128289e77c11$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $4a03128289e77c11$var$formatTimezone(offset, dirtyDelimeter);
}
function $4a03128289e77c11$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $4a03128289e77c11$var$addLeadingZeros(minutes, 2);
}
var $4a03128289e77c11$export$2e2bcd8739ae039 = $4a03128289e77c11$var$formatters;

});
parcelRegister("jrRuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e28a07c79392ce6f$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $e28a07c79392ce6f$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $e28a07c79392ce6f$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $e28a07c79392ce6f$var$partsTimeZone(dtf, date) : $e28a07c79392ce6f$var$hackyTimeZone(dtf, date);
}
function $e28a07c79392ce6f$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $e28a07c79392ce6f$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $e28a07c79392ce6f$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("32TIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $237cc870761492ed$export$2e2bcd8739ae039);

var $hSnhm = parcelRequire("hSnhm");

var $csABj = parcelRequire("csABj");
var $237cc870761492ed$var$MILLISECONDS_IN_HOUR = 3600000;
var $237cc870761492ed$var$MILLISECONDS_IN_MINUTE = 60000;
var $237cc870761492ed$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $237cc870761492ed$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $237cc870761492ed$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $237cc870761492ed$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$237cc870761492ed$var$validateTimezone(hours)) return NaN;
        return -(hours * $237cc870761492ed$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $237cc870761492ed$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$237cc870761492ed$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $237cc870761492ed$var$MILLISECONDS_IN_HOUR + minutes * $237cc870761492ed$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($237cc870761492ed$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $237cc870761492ed$var$toUtcDate(date);
        var offset = $237cc870761492ed$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $237cc870761492ed$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $237cc870761492ed$var$toUtcDate(date) {
    return (0, $csABj.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $237cc870761492ed$var$calcOffset(date, timezoneString) {
    var tokens = (0, $hSnhm.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $csABj.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $237cc870761492ed$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $237cc870761492ed$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $237cc870761492ed$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $237cc870761492ed$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $237cc870761492ed$var$validIANATimezoneCache = {};
function $237cc870761492ed$var$isValidTimezoneIANAString(timeZoneString) {
    if ($237cc870761492ed$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $237cc870761492ed$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("hSnhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $d039898aa7223e12$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $d039898aa7223e12$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $d039898aa7223e12$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $d039898aa7223e12$var$partsOffset(dtf, date) : $d039898aa7223e12$var$hackyOffset(dtf, date);
}
var $d039898aa7223e12$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $d039898aa7223e12$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $d039898aa7223e12$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $d039898aa7223e12$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $d039898aa7223e12$var$dtfCache = {};
function $d039898aa7223e12$var$getDateTimeFormat(timeZone) {
    if (!$d039898aa7223e12$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $d039898aa7223e12$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $d039898aa7223e12$var$dtfCache[timeZone];
}

});

parcelRegister("csABj", function(module, exports) {
$parcel$export(module.exports, "default", () => $91247db2b8e73a0e$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $91247db2b8e73a0e$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("eT6gb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad6b0ee0e6a83a9b$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $32TIT = parcelRequire("32TIT");

var $g6NNx = parcelRequire("g6NNx");
var $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_HOUR = 3600000;
var $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_MINUTE = 60000;
var $ad6b0ee0e6a83a9b$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $ad6b0ee0e6a83a9b$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $g6NNx.default)
};
function $ad6b0ee0e6a83a9b$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $ad6b0ee0e6a83a9b$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $ad6b0ee0e6a83a9b$var$splitDateString(argument);
    var parseYearResult = $ad6b0ee0e6a83a9b$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $ad6b0ee0e6a83a9b$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $ad6b0ee0e6a83a9b$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $32TIT.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $ad6b0ee0e6a83a9b$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $ad6b0ee0e6a83a9b$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $ad6b0ee0e6a83a9b$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $ad6b0ee0e6a83a9b$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $ad6b0ee0e6a83a9b$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $ad6b0ee0e6a83a9b$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $ad6b0ee0e6a83a9b$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $ad6b0ee0e6a83a9b$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $ad6b0ee0e6a83a9b$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $ad6b0ee0e6a83a9b$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $ad6b0ee0e6a83a9b$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$ad6b0ee0e6a83a9b$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $ad6b0ee0e6a83a9b$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$ad6b0ee0e6a83a9b$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $ad6b0ee0e6a83a9b$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$ad6b0ee0e6a83a9b$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $ad6b0ee0e6a83a9b$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$ad6b0ee0e6a83a9b$var$validateWeekDate(year, week)) return new Date(NaN);
        return $ad6b0ee0e6a83a9b$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $ad6b0ee0e6a83a9b$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$ad6b0ee0e6a83a9b$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $ad6b0ee0e6a83a9b$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $ad6b0ee0e6a83a9b$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $ad6b0ee0e6a83a9b$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$ad6b0ee0e6a83a9b$var$validateTime(hours)) return NaN;
        return hours % 24 * $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $ad6b0ee0e6a83a9b$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$ad6b0ee0e6a83a9b$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_HOUR + minutes * $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $ad6b0ee0e6a83a9b$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$ad6b0ee0e6a83a9b$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_HOUR + minutes * $ad6b0ee0e6a83a9b$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $ad6b0ee0e6a83a9b$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $ad6b0ee0e6a83a9b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $ad6b0ee0e6a83a9b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $ad6b0ee0e6a83a9b$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $ad6b0ee0e6a83a9b$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $ad6b0ee0e6a83a9b$var$isLeapYearIndex(year);
        if (isLeapYear && date > $ad6b0ee0e6a83a9b$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $ad6b0ee0e6a83a9b$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $ad6b0ee0e6a83a9b$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $ad6b0ee0e6a83a9b$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $ad6b0ee0e6a83a9b$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $ad6b0ee0e6a83a9b$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("g6NNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $bba3d5bc433bef7d$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $bba3d5bc433bef7d$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $bba3d5bc433bef7d$export$2e2bcd8739ae039 = $bba3d5bc433bef7d$var$tzPattern;

});



parcelRegister("kmTx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed40f0798fda62aa$export$2e2bcd8739ae039);

var $32TIT = parcelRequire("32TIT");

var $eT6gb = parcelRequire("eT6gb");
function $ed40f0798fda62aa$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $eT6gb.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $32TIT.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("kPioY", function(module, exports) {
$parcel$export(module.exports, "eocGlobalGroupDetailRoute", () => $04b87b53684bbda2$export$e6569aff8dfd4c1d);
const $04b87b53684bbda2$export$e6569aff8dfd4c1d = {
    name: 'eoc-global-group-detail',
    path: '/jira/ops/group-detail/:id',
    exact: true
};

});

parcelRegister("9HKZp", function(module, exports) {
$parcel$export(module.exports, "LazyGroupDetail", () => $121ff44230386a5e$export$8d4b3992eb19d436);
$parcel$export(module.exports, "default", () => $121ff44230386a5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $121ff44230386a5e$export$8d4b3992eb19d436 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("41WW5")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
const $121ff44230386a5e$var$AsyncGroupDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $121ff44230386a5e$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });
var $121ff44230386a5e$export$2e2bcd8739ae039 = $121ff44230386a5e$var$AsyncGroupDetail;

});
parcelRegister("41WW5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("9Mbel")
]).then(()=>parcelRequire('gZ67m'));

});



parcelRegister("4gFBe", function(module, exports) {
$parcel$export(module.exports, "eocGlobalHeartbeatsRouteEntry", () => $ac43bac0557723f4$export$2d7875aa465a7757);

var $2QRQR = parcelRequire("2QRQR");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $31fc3 = parcelRequire("31fc3");

var $iRfwO = parcelRequire("iRfwO");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $igs1s = parcelRequire("igs1s");
const $ac43bac0557723f4$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ac43bac0557723f4$export$2d7875aa465a7757 = (0, $6xToB.createEntry)((0, $31fc3.eocGlobalHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $igs1s.HeartbeatsComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $2QRQR.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$ac43bac0557723f4$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igs1s.LazyHeartbeats)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igs1s.LazyHeartbeats)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-heartbeats-entries/src/eocGlobalHeartbeatsRouteEntry.tsx',
                whichExportToUse: 'eocGlobalHeartbeatsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2QRQR", function(module, exports) {
$parcel$export(module.exports, "heartbeatsResource", () => $728a141480a15680$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $728a141480a15680$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $728a141480a15680$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $kpQnq = parcelRequire("kpQnq");
const $728a141480a15680$export$dd38e2aa5cfda9c9 = (0, $l1VxS.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $kpQnq.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $728a141480a15680$export$b5d9a0bcdfa848ce = (0, $l1VxS.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $kpQnq.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $728a141480a15680$export$bc99aaabaf7b70a7 = ()=>[
        $728a141480a15680$export$dd38e2aa5cfda9c9,
        $728a141480a15680$export$b5d9a0bcdfa848ce
    ];

});
parcelRegister("kpQnq", function(module, exports) {
$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $2f2205d8d2102d69$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $2f2205d8d2102d69$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $2f2205d8d2102d69$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $2f2205d8d2102d69$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $2f2205d8d2102d69$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $2f2205d8d2102d69$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $2f2205d8d2102d69$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $2f2205d8d2102d69$export$38097aade6a3b234);

var $9ppkU = parcelRequire("9ppkU");

var $8D2rp = parcelRequire("8D2rp");
const $2f2205d8d2102d69$export$c322dad372dcb08b = (teamId)=>(0, $9ppkU.eocFetch)((0, $8D2rp.generateBaseUrl)(teamId), {
        method: 'GET'
    });
const $2f2205d8d2102d69$export$676f6aee59f124b0 = (heartbeatName, teamId)=>(0, $9ppkU.eocFetch)(`${(0, $8D2rp.generateBaseUrl)(teamId)}/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $2f2205d8d2102d69$export$891ea85cc6973b32 = (heartbeat, teamId)=>(0, $9ppkU.eocFetch)((0, $8D2rp.generateBaseUrl)(teamId), {
        method: 'POST',
        body: heartbeat
    });
const $2f2205d8d2102d69$export$7311481b59e02e06 = (heartbeat, teamId)=>(0, $9ppkU.eocFetch)((0, $8D2rp.generateBaseUrl)(teamId), {
        method: 'PUT',
        body: heartbeat
    });
const $2f2205d8d2102d69$export$5df993f1c74d7e8e = (enable, name, teamId)=>(0, $9ppkU.eocFetch)(`${(0, $8D2rp.generateBaseUrl)(teamId)}/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $2f2205d8d2102d69$export$716e365975fc2cd1 = (name, teamId)=>(0, $9ppkU.eocFetch)(`${(0, $8D2rp.generateBaseUrl)(teamId)}?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $2f2205d8d2102d69$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $9ppkU.eocFetch)(`${(0, $8D2rp.generateBaseUrl)(teamId)}/rights`);
};
const $2f2205d8d2102d69$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $9ppkU.eocFetch)(`${(0, $8D2rp.generateBaseUrl)(teamId)}/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});
parcelRegister("8D2rp", function(module, exports) {
$parcel$export(module.exports, "getMaxAvailableEpoch", () => $b7245413b7b4d017$export$1eaa8fc6df8a5dac);
$parcel$export(module.exports, "generateBaseUrl", () => $b7245413b7b4d017$export$25e86c63685d7e40);

var $d8nud = parcelRequire("d8nud");
const $b7245413b7b4d017$export$1eaa8fc6df8a5dac = ()=>{
    const today = new Date();
    const futureDate = new Date();
    futureDate.setFullYear(today.getFullYear() * (0, $d8nud.MAX_INTERVAL_TIME_YEARS));
    const epochTime = futureDate.getTime();
    return epochTime;
};
const $b7245413b7b4d017$export$25e86c63685d7e40 = (teamId)=>{
    return teamId ? `/v1/teams/${teamId}/heartbeats` : '/v1/heartbeats';
};

});
parcelRegister("d8nud", function(module, exports) {
$parcel$export(module.exports, "MAX_INTERVAL_TIME_YEARS", () => $1efb179a53aeac5d$export$c3f9ae43b3ab397c);
$parcel$export(module.exports, "MIN_DATE_SHOWN_EPOCH", () => $1efb179a53aeac5d$export$f081f690fcb957ce);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $1efb179a53aeac5d$export$a7c923252528b255);
const $1efb179a53aeac5d$export$c3f9ae43b3ab397c = 5;
const $1efb179a53aeac5d$export$f081f690fcb957ce = 946677600;
const $1efb179a53aeac5d$export$a7c923252528b255 = {
    actions: 'eoc-heartbeats_actions'
};

});




parcelRegister("31fc3", function(module, exports) {
$parcel$export(module.exports, "eocGlobalHeartbeatsRoute", () => $73a1034ba3855894$export$48568054c59facbb);
const $73a1034ba3855894$export$48568054c59facbb = {
    name: 'eoc-global-heartbeats',
    path: '/jira/settings/products/ops/heartbeats',
    exact: true
};

});

parcelRegister("igs1s", function(module, exports) {
$parcel$export(module.exports, "LazyHeartbeats", () => $10bfd1aa77151542$export$93c9586b023b5aa3);
$parcel$export(module.exports, "HeartbeatsComponent", () => $10bfd1aa77151542$export$43c2d87bd51ba6ac);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $10bfd1aa77151542$export$93c9586b023b5aa3 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("630UX")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $10bfd1aa77151542$export$43c2d87bd51ba6ac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $10bfd1aa77151542$export$93c9586b023b5aa3,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });

});
parcelRegister("630UX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dP2Uj").then(()=>parcelRequire('ee1yi'));

});



parcelRegister("dCYpv", function(module, exports) {
$parcel$export(module.exports, "eocGlobalMaintenanceRouteEntry", () => $89b01b8fb5fbf786$export$ce2a5648c28a5b48);

var $4Xdtk = parcelRequire("4Xdtk");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $6PfIm = parcelRequire("6PfIm");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $kMVdl = parcelRequire("kMVdl");
const $89b01b8fb5fbf786$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $89b01b8fb5fbf786$export$ce2a5648c28a5b48 = (0, $6xToB.createEntry)((0, $6PfIm.eocGlobalMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $kMVdl.MaintenanceComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4Xdtk.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$89b01b8fb5fbf786$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kMVdl.LazyMaintenance)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kMVdl.LazyMaintenance)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-maintenance-entries/src/eocGlobalMaintenanceRouteEntry.tsx',
                whichExportToUse: 'eocGlobalMaintenanceRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4Xdtk", function(module, exports) {
$parcel$export(module.exports, "maintenanceResource", () => $d07232cca55e5735$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $d07232cca55e5735$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $d07232cca55e5735$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $1DrRY = parcelRequire("1DrRY");

var $8w2tD = parcelRequire("8w2tD");
const $d07232cca55e5735$export$5486c78261efb2c3 = (0, $l1VxS.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $8w2tD.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $d07232cca55e5735$export$e4c92d8948e3625 = (0, $l1VxS.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $8w2tD.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $d07232cca55e5735$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $1DrRY.eocCommonResources)(),
        $d07232cca55e5735$export$5486c78261efb2c3,
        $d07232cca55e5735$export$e4c92d8948e3625
    ];

});
parcelRegister("8w2tD", function(module, exports) {
$parcel$export(module.exports, "getMaintenance", () => $c4c24689253f9b6f$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $c4c24689253f9b6f$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $c4c24689253f9b6f$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $c4c24689253f9b6f$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $c4c24689253f9b6f$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $c4c24689253f9b6f$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $c4c24689253f9b6f$export$fa55cd063e1b15c2);

var $9ppkU = parcelRequire("9ppkU");
const $c4c24689253f9b6f$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $c4c24689253f9b6f$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $9ppkU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $c4c24689253f9b6f$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $9ppkU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $c4c24689253f9b6f$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $9ppkU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $c4c24689253f9b6f$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $c4c24689253f9b6f$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $9ppkU.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $c4c24689253f9b6f$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $9ppkU.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("6PfIm", function(module, exports) {
$parcel$export(module.exports, "eocGlobalMaintenanceRoute", () => $f8bec2b534fc57c5$export$e0665f23a759e78f);
const $f8bec2b534fc57c5$export$e0665f23a759e78f = {
    name: 'eoc-global-maintenance',
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};

});

parcelRegister("kMVdl", function(module, exports) {
$parcel$export(module.exports, "LazyMaintenance", () => $71650970c1af5b00$export$c5c7dc53d976edee);
$parcel$export(module.exports, "MaintenanceComponent", () => $71650970c1af5b00$export$76d7c25f72022339);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $71650970c1af5b00$export$c5c7dc53d976edee = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("bB2LL")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $71650970c1af5b00$export$76d7c25f72022339 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $71650970c1af5b00$export$c5c7dc53d976edee,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });

});
parcelRegister("bB2LL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("5ePFE")
]).then(()=>parcelRequire('8L6ZW'));

});



parcelRegister("ezywV", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsHomePageNav4RouteEntry", () => $f2c1ac7f91e1614d$export$193586b163d4afae);

var $3LXmM = parcelRequire("3LXmM");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $63eGz = parcelRequire("63eGz");

var $iRfwO = parcelRequire("iRfwO");

var $98AOo = parcelRequire("98AOo");
const $f2c1ac7f91e1614d$export$193586b163d4afae = (0, $6xToB.createEntry)((0, $63eGz.eocGlobalReportsHomePageNav4Route), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReportsRedirect),
        layout: (0, $iRfwO.opsMigrationHubLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $3LXmM.resources)(),
            (0, $3LXmM.opsReportsPermissionResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReportsRedirect),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-reports-entries/src/eocGlobalReportsHomePageNav4RouteEntry.tsx',
                whichExportToUse: 'eocGlobalReportsHomePageNav4RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3LXmM", function(module, exports) {
$parcel$export(module.exports, "opsReportsResource", () => $f70a5f90a366fd6e$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $f70a5f90a366fd6e$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $f70a5f90a366fd6e$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $3ggZP = parcelRequire("3ggZP");

var $dwYvE = parcelRequire("dwYvE");
const $f70a5f90a366fd6e$export$8498311fc7a4ab48 = (0, $l1VxS.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $dwYvE.getReportSettings)();
        const api = (0, $dwYvE.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $f70a5f90a366fd6e$export$c432f280d76e2acf = (0, $l1VxS.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $3ggZP.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!isTeamDashboard || !!teamId, new (0, $gLoFN.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $dwYvE.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $f70a5f90a366fd6e$export$bc99aaabaf7b70a7 = ()=>[
        $f70a5f90a366fd6e$export$8498311fc7a4ab48,
        $f70a5f90a366fd6e$export$c432f280d76e2acf
    ];

});
parcelRegister("3ggZP", function(module, exports) {
$parcel$export(module.exports, "withReportingPrefix", () => $1d7a0fafd45271ca$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $1d7a0fafd45271ca$export$f923ac475871fcad);

var $fR4Ty = parcelRequire("fR4Ty");
function $1d7a0fafd45271ca$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $1d7a0fafd45271ca$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("dwYvE", function(module, exports) {
$parcel$export(module.exports, "getDashboards", () => $c562021e0ff554fe$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $c562021e0ff554fe$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $c562021e0ff554fe$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $c562021e0ff554fe$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $c562021e0ff554fe$export$fb46892f83504a42);

var $9ppkU = parcelRequire("9ppkU");

var $3ggZP = parcelRequire("3ggZP");

var $cyQ8y = parcelRequire("cyQ8y");
const $c562021e0ff554fe$export$8e4b6d6c4fec08f3 = ()=>(0, $9ppkU.eocFetch)((0, $3ggZP.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $cyQ8y.opsReportsErrorTransformer
    });
const $c562021e0ff554fe$export$e69121e90ce0231b = ()=>(0, $9ppkU.eocFetch)((0, $3ggZP.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $cyQ8y.opsReportsErrorTransformer
    });
const $c562021e0ff554fe$export$9114b8a872caf5d8 = ()=>(0, $9ppkU.eocFetch)((0, $3ggZP.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $cyQ8y.opsReportsErrorTransformer
    });
const $c562021e0ff554fe$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $9ppkU.eocFetch)((0, $3ggZP.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $cyQ8y.opsReportsErrorTransformer
    });
};
const $c562021e0ff554fe$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $9ppkU.eocFetch)((0, $3ggZP.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $cyQ8y.opsReportsErrorTransformer
    });
};
const $c562021e0ff554fe$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $9ppkU.eocFetch)((0, $3ggZP.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $cyQ8y.opsReportsErrorTransformer
    });
};

});
parcelRegister("cyQ8y", function(module, exports) {
$parcel$export(module.exports, "opsReportsErrorTransformer", () => $4d65c32aef2a6601$export$b170750bd4489531);

var $1boDC = parcelRequire("1boDC");
const $4d65c32aef2a6601$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $4d65c32aef2a6601$export$b170750bd4489531 = (e)=>{
    if ((0, $1boDC.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $4d65c32aef2a6601$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $1boDC.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $1boDC.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("63eGz", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsHomePageNav4Route", () => $7d3c0d02265ceb21$export$e7c62a288f7d3a11);
const $7d3c0d02265ceb21$export$e7c62a288f7d3a11 = {
    name: 'eoc-global-reports',
    path: '/jira/ops/reports',
    exact: true
};

});

parcelRegister("98AOo", function(module, exports) {
$parcel$export(module.exports, "LazyOpsReports", () => $869a8a1e2d67bce3$export$2404f0e35deca592);
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $869a8a1e2d67bce3$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $869a8a1e2d67bce3$export$66850ec5549adba6);
$parcel$export(module.exports, "LazyOpsReportsUnsubscribe", () => $869a8a1e2d67bce3$export$5fd77c3bbfb22cbd);
$parcel$export(module.exports, "OpsReportsRedirect", () => $869a8a1e2d67bce3$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $869a8a1e2d67bce3$export$648ddf2d1f8b1c3f);
$parcel$export(module.exports, "OpsReports", () => $869a8a1e2d67bce3$export$87e6a54b4f5dc91e);
$parcel$export(module.exports, "OpsReportsUnsubscribe", () => $869a8a1e2d67bce3$export$7f366d77015c286f);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $869a8a1e2d67bce3$export$2404f0e35deca592 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $869a8a1e2d67bce3$export$d33ea1a773b744e = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $869a8a1e2d67bce3$export$66850ec5549adba6 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $869a8a1e2d67bce3$export$5fd77c3bbfb22cbd = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $869a8a1e2d67bce3$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $869a8a1e2d67bce3$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $869a8a1e2d67bce3$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $869a8a1e2d67bce3$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $869a8a1e2d67bce3$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });

});
parcelRegister("2glcC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("eVJpD")),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("9toJd")
]).then(()=>parcelRequire('cImxM'));

});



parcelRegister("iXFOs", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsNav4RouteEntry", () => $9c0ed43579def0b8$export$90a73fe101848dd);

var $3LXmM = parcelRequire("3LXmM");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $72EwM = parcelRequire("72EwM");

var $98AOo = parcelRequire("98AOo");
const $9c0ed43579def0b8$export$90a73fe101848dd = (0, $6xToB.createEntry)((0, $72EwM.eocGlobalReportsNav4Route), ()=>({
        group: 'eoc',
        component: (0, $98AOo.GlobalOpsReports),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $3LXmM.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyGlobalOpsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-reports-entries/src/eocGlobalReportsNav4RouteEntry.tsx',
                whichExportToUse: 'eocGlobalReportsNav4RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("72EwM", function(module, exports) {
$parcel$export(module.exports, "eocGlobalReportsNav4Route", () => $9c498525c08cccd4$export$2344cc35fd2eff4e);
const $9c498525c08cccd4$export$2344cc35fd2eff4e = {
    name: 'eoc-global-report-dashboard',
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("dqsu7", function(module, exports) {
$parcel$export(module.exports, "eocHeartbeatsRouteEntry", () => $496d13b3d3b8550b$export$2c2d6115c4280a08);

var $2QRQR = parcelRequire("2QRQR");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $3oIRx = parcelRequire("3oIRx");

var $igs1s = parcelRequire("igs1s");
const $496d13b3d3b8550b$export$2c2d6115c4280a08 = (0, $6xToB.createEntry)((0, $3oIRx.eocHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $igs1s.HeartbeatsComponent),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $2QRQR.resources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igs1s.LazyHeartbeats),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-heartbeats-entries/src/eocHeartbeatsRouteEntry.tsx',
                whichExportToUse: 'eocHeartbeatsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3oIRx", function(module, exports) {
$parcel$export(module.exports, "eocHeartbeatsRoute", () => $d17cfa5e832430e2$export$71bd833dcb7bd1e9);
const $d17cfa5e832430e2$export$71bd833dcb7bd1e9 = {
    name: 'eoc-heartbeats',
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};

});


parcelRegister("j3oaw", function(module, exports) {
$parcel$export(module.exports, "eocMaintenanceRouteEntry", () => $a17211bb7828b802$export$e9c59d0d6bfec8a3);

var $4Xdtk = parcelRequire("4Xdtk");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $3qe4A = parcelRequire("3qe4A");

var $kMVdl = parcelRequire("kMVdl");
const $a17211bb7828b802$export$e9c59d0d6bfec8a3 = (0, $6xToB.createEntry)((0, $3qe4A.eocMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $kMVdl.MaintenanceComponent),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $4Xdtk.resources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kMVdl.LazyMaintenance),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-maintenance-entries/src/eocMaintenanceRouteEntry.tsx',
                whichExportToUse: 'eocMaintenanceRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3qe4A", function(module, exports) {
$parcel$export(module.exports, "eocMaintenanceRoute", () => $3579c3313c5d4bfc$export$7523f600b27b1b54);
const $3579c3313c5d4bfc$export$7523f600b27b1b54 = {
    name: 'eoc-maintenance',
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};

});


parcelRegister("atZb5", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRedirectRouteEntry", () => $8757cbc08785af76$export$c5c49f69c4fe1ea6);

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $5AUdw = parcelRequire("5AUdw");

var $7rCqf = parcelRequire("7rCqf");
const $8757cbc08785af76$export$c5c49f69c4fe1ea6 = (0, $6xToB.createEntry)((0, $5AUdw.eocOnCallRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $7rCqf.OnCallRedirect),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-on-call-entries/src/eocOnCallRedirectRouteEntry.tsx',
                whichExportToUse: 'eocOnCallRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5AUdw", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRedirectRoute", () => $706d9c14d0500529$export$d725ece0e087d522);
const $706d9c14d0500529$export$d725ece0e087d522 = {
    name: 'eoc-on-call-redirect',
    path: '/jira/ops/teams/:teamId',
    exact: true
};

});

parcelRegister("7rCqf", function(module, exports) {
$parcel$export(module.exports, "OnCallRedirect", () => $74dda56f1dc0d5b5$export$659b7ce11c160b32);
$parcel$export(module.exports, "LazyOnCall", () => $74dda56f1dc0d5b5$export$772095aa22362f73);
$parcel$export(module.exports, "default", () => $74dda56f1dc0d5b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $74dda56f1dc0d5b5$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $gCY1z.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: redirectionUrl
    });
};

const $74dda56f1dc0d5b5$export$772095aa22362f73 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1t8lu")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
const $74dda56f1dc0d5b5$var$AsyncOnCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $74dda56f1dc0d5b5$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });
var $74dda56f1dc0d5b5$export$2e2bcd8739ae039 = $74dda56f1dc0d5b5$var$AsyncOnCall;

});
parcelRegister("1t8lu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2Y3CR")
]).then(()=>parcelRequire('1cQxv'));

});



parcelRegister("bcSH6", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRouteEntry", () => $a5f720dfbef0d05b$export$ac245212b12db871);

var $cJFeX = parcelRequire("cJFeX");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $k6osT = parcelRequire("k6osT");

var $7rCqf = parcelRequire("7rCqf");
const $a5f720dfbef0d05b$export$ac245212b12db871 = (0, $6xToB.createEntry)((0, $k6osT.eocOnCallRoute), ()=>({
        group: 'eoc',
        component: (0, $7rCqf.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $cJFeX.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7rCqf.LazyOnCall),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-on-call-entries/src/eocOnCallRouteEntry.tsx',
                whichExportToUse: 'eocOnCallRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cJFeX", function(module, exports) {
$parcel$export(module.exports, "getTeamResource", () => $ce2629bc23da46df$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $ce2629bc23da46df$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $6ulma = parcelRequire("6ulma");

var $8eS93 = parcelRequire("8eS93");

var $eU56b = parcelRequire("eU56b");
const $ce2629bc23da46df$export$50271c9e7f21f10e = (0, $l1VxS.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $eU56b.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $ce2629bc23da46df$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $8eS93.resources),
        (0, $6ulma.routingRulesResource),
        $ce2629bc23da46df$export$50271c9e7f21f10e
    ];

});
parcelRegister("6ulma", function(module, exports) {
$parcel$export(module.exports, "routingRulesResource", () => $63c5d9c85ee0c934$export$7f38c73dca88500e);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $c5E9u = parcelRequire("c5E9u");
const $63c5d9c85ee0c934$export$7f38c73dca88500e = (0, $l1VxS.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $c5E9u.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("c5E9u", function(module, exports) {
$parcel$export(module.exports, "getRoutingRules", () => $277ca1efce6c4950$export$425c24c86196521);

var $9ppkU = parcelRequire("9ppkU");
const $277ca1efce6c4950$export$425c24c86196521 = (teamId)=>(0, $9ppkU.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("8eS93", function(module, exports) {
$parcel$export(module.exports, "getSchedulesResource", () => $6175b8d022dffa1b$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $6175b8d022dffa1b$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $6175b8d022dffa1b$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $6175b8d022dffa1b$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $6175b8d022dffa1b$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $1DrRY = parcelRequire("1DrRY");

var $ls7PN = parcelRequire("ls7PN");

var $6izVK = parcelRequire("6izVK");

var $9Nz3j = parcelRequire("9Nz3j");

var $gfR0K = parcelRequire("gfR0K");

var $5YWAW = parcelRequire("5YWAW");

var $lqDlp = parcelRequire("lqDlp");
const $6175b8d022dffa1b$export$6b2b3e2a53cc13e2 = (0, $l1VxS.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $gfR0K.endpoints).getScheduleList((0, $6izVK.getTeamIdFromContext)(routerExtendedContext))
});
const $6175b8d022dffa1b$export$5c6454d866055bdd = (0, $l1VxS.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $5YWAW.endpoints).getUiPreferences((0, $6izVK.getTeamIdFromContext)(routerExtendedContext))
});
const $6175b8d022dffa1b$export$9d9ecb8586783931 = (0, $l1VxS.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $lqDlp.endpoints).getScheduleRights((0, $6izVK.getTeamIdFromContext)(routerExtendedContext))
});
const $6175b8d022dffa1b$export$90251855f07c54b4 = (0, $l1VxS.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $9Nz3j.endpoints).getScheduleTimeTemplates()
});
const $6175b8d022dffa1b$export$bc99aaabaf7b70a7 = [
    $6175b8d022dffa1b$export$6b2b3e2a53cc13e2,
    $6175b8d022dffa1b$export$5c6454d866055bdd,
    $6175b8d022dffa1b$export$9d9ecb8586783931,
    $6175b8d022dffa1b$export$90251855f07c54b4,
    ...(0, $ls7PN.resources),
    ...(0, $1DrRY.eocCommonResources)()
];

});
parcelRegister("ls7PN", function(module, exports) {
$parcel$export(module.exports, "getTimezonesResource", () => $c044116db410948b$export$7524ea9fda8149c6);
$parcel$export(module.exports, "getTimeTemplatesResource", () => $c044116db410948b$export$f045bbf39b81240d);
$parcel$export(module.exports, "resources", () => $c044116db410948b$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $kO41a = parcelRequire("kO41a");
const $c044116db410948b$export$7524ea9fda8149c6 = (0, $l1VxS.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $kO41a.endpoints).getTimezones()
});
const $c044116db410948b$export$f045bbf39b81240d = (0, $l1VxS.createResource)({
    type: 'getEocTimeTemplatesResource',
    getKey: ()=>'getEocTimeTemplatesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $kO41a.endpoints).getTimeTemplates()
});
const $c044116db410948b$export$bc99aaabaf7b70a7 = [
    $c044116db410948b$export$7524ea9fda8149c6
];

});
parcelRegister("kO41a", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $49740e49a212856e$export$3a2536d80ecc00e7);

var $9ppkU = parcelRequire("9ppkU");

var $gdLbX = parcelRequire("gdLbX");
const $49740e49a212856e$var$getTimezones = async ()=>{
    const response = await (0, $9ppkU.eocFetch)((0, $gdLbX.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $49740e49a212856e$var$getTimeTemplates = ()=>{
    return (0, $9ppkU.eocFetch)((0, $gdLbX.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $49740e49a212856e$export$3a2536d80ecc00e7 = {
    getTimezones: $49740e49a212856e$var$getTimezones,
    getTimeTemplates: $49740e49a212856e$var$getTimeTemplates
};

});
parcelRegister("gdLbX", function(module, exports) {
$parcel$export(module.exports, "urls", () => $61667b223087f3bd$export$bcae9ba627f604b6);
const $61667b223087f3bd$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            },
            suggested: {
                url: ()=>'/v1/alerts/responders/suggested'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        user: {
            webCalendarUrl: {
                url: ()=>`/v1/schedules/user/web-calendar-url`
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    users: {
        contacts: {
            primary: {
                url: ()=>'/v1/users/contact/primary'
            }
        }
    }
});

});



parcelRegister("6izVK", function(module, exports) {
$parcel$export(module.exports, "getTeamIdFromContext", () => $14de5df5d0733d87$export$3ea727bebc3792bb);

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $dXYGD = parcelRequire("dXYGD");
const $14de5df5d0733d87$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $dXYGD.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $cyz90.assert)(!(0, $dXYGD.isEmpty)(teamId), new (0, $gLoFN.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("dXYGD", function(module, exports) {
$parcel$export(module.exports, "getSafe", () => $3f765621fb4d8de0$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $3f765621fb4d8de0$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $3f765621fb4d8de0$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $3f765621fb4d8de0$export$5fc068d42db64a99);

var $fDDjN = parcelRequire("fDDjN");
const $3f765621fb4d8de0$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $3f765621fb4d8de0$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $3f765621fb4d8de0$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $3f765621fb4d8de0$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $fDDjN.messages).nameSpaceValidationError);
        };

});
parcelRegister("fDDjN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $658a5d196a8a6422$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $658a5d196a8a6422$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be before the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be after the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("9Nz3j", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $dbce6ee3e49f4a22$export$3a2536d80ecc00e7);

var $9ppkU = parcelRequire("9ppkU");

var $59FUt = parcelRequire("59FUt");
const $dbce6ee3e49f4a22$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $dbce6ee3e49f4a22$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $dbce6ee3e49f4a22$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $dbce6ee3e49f4a22$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $dbce6ee3e49f4a22$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $dbce6ee3e49f4a22$var$getScheduleTimeTemplates = ()=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $dbce6ee3e49f4a22$export$3a2536d80ecc00e7 = {
    deleteRotation: $dbce6ee3e49f4a22$var$deleteRotation,
    getRotation: $dbce6ee3e49f4a22$var$getRotation,
    orderRotation: $dbce6ee3e49f4a22$var$orderRotation,
    addRotation: $dbce6ee3e49f4a22$var$addRotation,
    editRotation: $dbce6ee3e49f4a22$var$editRotation,
    getScheduleTimeTemplates: $dbce6ee3e49f4a22$var$getScheduleTimeTemplates
};

});
parcelRegister("59FUt", function(module, exports) {
$parcel$export(module.exports, "urls", () => $479006eeda46628c$export$bcae9ba627f604b6);
const $479006eeda46628c$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
});

});


parcelRegister("gfR0K", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $57020f8c3cd68933$export$3a2536d80ecc00e7);

var $9ppkU = parcelRequire("9ppkU");

var $59FUt = parcelRequire("59FUt");
const $57020f8c3cd68933$var$getScheduleList = (teamId)=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $57020f8c3cd68933$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $57020f8c3cd68933$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $57020f8c3cd68933$export$3a2536d80ecc00e7 = {
    deleteSchedule: $57020f8c3cd68933$var$deleteSchedule,
    getScheduleList: $57020f8c3cd68933$var$getScheduleList,
    updateSchedule: $57020f8c3cd68933$var$updateSchedule
};

});

parcelRegister("5YWAW", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $65de8bf9751f1be2$export$3a2536d80ecc00e7);

var $9ppkU = parcelRequire("9ppkU");

var $59FUt = parcelRequire("59FUt");
const $65de8bf9751f1be2$var$getUiPreferences = (teamId)=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $65de8bf9751f1be2$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $65de8bf9751f1be2$export$3a2536d80ecc00e7 = {
    getUiPreferences: $65de8bf9751f1be2$var$getUiPreferences,
    updateUiPreferences: $65de8bf9751f1be2$var$updateUiPreferences
};

});

parcelRegister("lqDlp", function(module, exports) {
$parcel$export(module.exports, "endpoints", () => $12d58e6ebb0b9942$export$3a2536d80ecc00e7);

var $9ppkU = parcelRequire("9ppkU");

var $59FUt = parcelRequire("59FUt");
const $12d58e6ebb0b9942$var$getScheduleRights = (teamId)=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $12d58e6ebb0b9942$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $12d58e6ebb0b9942$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $9ppkU.eocFetch)((0, $59FUt.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $12d58e6ebb0b9942$export$3a2536d80ecc00e7 = {
    createSchedule: $12d58e6ebb0b9942$var$createSchedule,
    getScheduleRights: $12d58e6ebb0b9942$var$getScheduleRights,
    cloneSchedule: $12d58e6ebb0b9942$var$cloneSchedule
};

});


parcelRegister("eU56b", function(module, exports) {
$parcel$export(module.exports, "getTeam", () => $f564665abd0f245d$export$491fe77f22ab2b51);

var $9ppkU = parcelRequire("9ppkU");
const $f564665abd0f245d$export$491fe77f22ab2b51 = (teamId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("k6osT", function(module, exports) {
$parcel$export(module.exports, "eocOnCallRoute", () => $744fb1975a9af96a$export$5eaa466ae8a4d7d3);
const $744fb1975a9af96a$export$5eaa466ae8a4d7d3 = {
    name: 'eoc-on-call',
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};

});


parcelRegister("L6NLT", function(module, exports) {
$parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", () => $f412e52bc0639fdf$export$842d7c81068bb64e);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $GnSwp = parcelRequire("GnSwp");

var $6xToB = parcelRequire("6xToB");

var $70evk = parcelRequire("70evk");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $fKceA = parcelRequire("fKceA");

var $1DrRY = parcelRequire("1DrRY");

var $9i0Bn = parcelRequire("9i0Bn");
const $f412e52bc0639fdf$export$842d7c81068bb64e = (0, $6xToB.createEntry)((0, $fKceA.eocOverviewAllTeamsRoute), ()=>({
        group: 'eoc',
        component: (0, $9i0Bn.EocOverviewAllTeamsComponent),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $70evk.getTeamsResource),
            ...(0, $1DrRY.eocCommonResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $GnSwp.LazyHorizontalOperationsOverviewNav),
            (0, $9i0Bn.LazyOverviewAllTeamsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-overview-entries/src/eocOverviewAllTeamsRouteEntry.tsx',
                whichExportToUse: 'eocOverviewAllTeamsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("70evk", function(module, exports) {
$parcel$export(module.exports, "getTeamsResource", () => $36ea1c80197b97be$export$27d854bd39923fc7);
// eslint-disable-next-line jira/import-whitelist

var $dyg8o = parcelRequire("dyg8o");
var $4XAzi = parcelRequire("4XAzi");

var $4cTDP = parcelRequire("4cTDP");

var $l1VxS = parcelRequire("l1VxS");

var $dI30d = parcelRequire("dI30d");

const $36ea1c80197b97be$export$27d854bd39923fc7 = (0, $l1VxS.createResource)({
    type: (0, $4XAzi.getTeamsResource).type,
    getKey: (0, $4XAzi.getTeamsResource).getKey,
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734]?.promise;
        const isOpsAdmin = (0, $dI30d.checkIsOpsAdmin)(tenantInfo);
        const shouldSeeAllTeams = (0, $4cTDP.fg)('operations-tenant-info-endpoint-update') ? isSiteAdmin || isAdmin || isOpsAdmin : isSiteAdmin || isAdmin;
        return (0, $dyg8o.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true,
                includeTeamExternalDetails: true
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0,
    depends: [
        (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
    ]
});

});
parcelRegister("dyg8o", function(module, exports) {
$parcel$export(module.exports, "getTeams", () => $68b8c03c214f93e6$export$5a622455e94bac3);

var $9ppkU = parcelRequire("9ppkU");
const $68b8c03c214f93e6$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (queryParams.includeTeamExternalDetails) params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
    if (url) return (0, $9ppkU.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $9ppkU.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

});

parcelRegister("4XAzi", function(module, exports) {
$parcel$export(module.exports, "getTeamsResource", () => $0b707f995bcfab2c$export$27d854bd39923fc7);

var $l1VxS = parcelRequire("l1VxS");

var $dyg8o = parcelRequire("dyg8o");
const $0b707f995bcfab2c$export$27d854bd39923fc7 = (0, $l1VxS.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});

});

const $f8747ec2695de8a7$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("fKceA", function(module, exports) {
$parcel$export(module.exports, "eocOverviewAllTeamsRoute", () => $5d5a2485f47a86ad$export$dbe53627482b9f0f);
const $5d5a2485f47a86ad$export$dbe53627482b9f0f = {
    name: 'eoc-overview-all-teams',
    path: '/jira/ops/overview/teams',
    exact: true
};

});

parcelRegister("9i0Bn", function(module, exports) {
$parcel$export(module.exports, "LazyOverviewPage", () => $80a5b5dee0a7d5b5$export$c7c96cc8d6e9a8f1);
$parcel$export(module.exports, "LazyOverviewAllTeamsPage", () => $80a5b5dee0a7d5b5$export$9a22ecad8322834e);
$parcel$export(module.exports, "EocOverviewComponent", () => $80a5b5dee0a7d5b5$export$b22309f0ee469d5c);
$parcel$export(module.exports, "EocOverviewAllTeamsComponent", () => $80a5b5dee0a7d5b5$export$2713003ebbdbb975);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $80a5b5dee0a7d5b5$export$c7c96cc8d6e9a8f1 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("bgMpL")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

const $80a5b5dee0a7d5b5$export$9a22ecad8322834e = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1QXcc")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $80a5b5dee0a7d5b5$export$b22309f0ee469d5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $80a5b5dee0a7d5b5$export$c7c96cc8d6e9a8f1,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
const $80a5b5dee0a7d5b5$export$2713003ebbdbb975 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $80a5b5dee0a7d5b5$export$9a22ecad8322834e,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });

});
parcelRegister("bgMpL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e3txk").then(()=>parcelRequire('AkBvw'));

});

parcelRegister("1QXcc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jN3ry").then(()=>parcelRequire('d8lGf'));

});



parcelRegister("d1pTa", function(module, exports) {
$parcel$export(module.exports, "eocOverviewRouteEntry", () => $a903633f689b80a7$export$f1a859c727c30be4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $GnSwp = parcelRequire("GnSwp");

var $6xToB = parcelRequire("6xToB");

var $70evk = parcelRequire("70evk");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $88DS7 = parcelRequire("88DS7");

var $iRfwO = parcelRequire("iRfwO");

var $1DrRY = parcelRequire("1DrRY");

var $9i0Bn = parcelRequire("9i0Bn");
const $a903633f689b80a7$export$f1a859c727c30be4 = (0, $6xToB.createEntry)((0, $88DS7.eocOverviewRoute), ()=>({
        group: 'eoc',
        component: (0, $9i0Bn.EocOverviewComponent),
        layout: (0, $iRfwO.opsMigrationHubLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $70evk.getTeamsResource),
            ...(0, $1DrRY.eocCommonResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME,
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $GnSwp.LazyHorizontalOperationsOverviewNav),
            (0, $9i0Bn.LazyOverviewPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-overview-entries/src/eocOverviewRouteEntry.tsx',
                whichExportToUse: 'eocOverviewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("88DS7", function(module, exports) {
$parcel$export(module.exports, "eocOverviewRoute", () => $7d3f8efb155cd058$export$cb929d46451a5c12);
const $7d3f8efb155cd058$export$cb929d46451a5c12 = {
    name: 'eoc-overview',
    path: '/jira/ops/overview',
    exact: true
};

});


parcelRegister("42xEn", function(module, exports) {
$parcel$export(module.exports, "eocPermissionsRouteEntry", () => $dce501faa7419f5e$export$c2ced436a30c60dc);

var $6orRg = parcelRequire("6orRg");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $5Wzun = parcelRequire("5Wzun");

var $a6Kdh = parcelRequire("a6Kdh");
const $dce501faa7419f5e$export$c2ced436a30c60dc = (0, $6xToB.createEntry)((0, $5Wzun.eocPermissionsRoute), ()=>({
        group: 'eoc',
        component: (0, $a6Kdh.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // pageAccessResource should be defined before memberRolesResources since they depend on it
            (0, $6orRg.pageAccessResource),
            ...(0, $6orRg.resources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a6Kdh.LazyMemberRoles),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-permissions-entries/src/eocPermissionsRouteEntry.tsx',
                whichExportToUse: 'eocPermissionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6orRg", function(module, exports) {
$parcel$export(module.exports, "pageAccessResource", () => $ca6420fc7edcf484$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $ca6420fc7edcf484$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $ca6420fc7edcf484$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $ca6420fc7edcf484$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $ca6420fc7edcf484$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $eGOwo = parcelRequire("eGOwo");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $jOg6y = parcelRequire("jOg6y");
const $ca6420fc7edcf484$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $ca6420fc7edcf484$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$ca6420fc7edcf484$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$ca6420fc7edcf484$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $ca6420fc7edcf484$var$getMembersPaginated = async (teamId)=>{
    let hasNextPage = true;
    let endCursor = '';
    let members = [];
    while(hasNextPage && endCursor !== null){
        const gqlResponse = await (0, $jOg6y.getMembers)(teamId, endCursor);
        endCursor = gqlResponse.data.team?.teamV2?.members.pageInfo.endCursor ?? '';
        hasNextPage = gqlResponse.data.team?.teamV2?.members.pageInfo.hasNextPage ?? false;
        const newMembers = gqlResponse.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member);
        if (newMembers) members = [
            ...members,
            ...newMembers
        ];
    }
    return members;
};
const $ca6420fc7edcf484$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $ca6420fc7edcf484$export$b0d36f8262140e35 = (0, $l1VxS.createResource)({
    type: $ca6420fc7edcf484$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $jOg6y.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $ca6420fc7edcf484$export$5c4885c1f1a535b = (0, $l1VxS.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $ca6420fc7edcf484$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage && !(0, $eGOwo.fg)('ops_member_roles_page_access_detailed_rights_2')) return null;
        let members;
        if ((0, $eGOwo.fg)('member-roles-graphql-paginaton')) members = await $ca6420fc7edcf484$var$getMembersPaginated(teamId);
        else {
            const gqlResponse = await (0, $jOg6y.getMembersOld)(teamId);
            members = gqlResponse?.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member) || [];
        }
        const memberRoleResponse = await (0, $jOg6y.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        });
        const teamMembers = members.map((user)=>{
            const userWithRole = memberRoleResponse.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
            return {
                ...user,
                role: userWithRole?.roleId || 'user',
                jsmLicense: userWithRole?.jsmLicense || false,
                jiraAdmin: userWithRole?.jiraAdmin || false,
                invitationStatus: 'member'
            };
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (!membersWithoutJSMLicense.length) return teamMembers;
        const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
        try {
            const { embeddedValue: embeddedValue } = await (0, $jOg6y.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            });
            return teamMembers.map((user)=>{
                const userWithInvitationStatus = embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                return {
                    ...user,
                    invitationStatus: $ca6420fc7edcf484$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                };
            });
        } catch  {
            return teamMembers;
        }
    },
    isBrowserOnly: true,
    // TODO remove dependency on cleanup ops_member_roles_page_access_detailed_rights_2
    depends: [
        $ca6420fc7edcf484$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $ca6420fc7edcf484$export$50271c9e7f21f10e = (0, $l1VxS.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $jOg6y.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $ca6420fc7edcf484$export$ed1eb48699cf7893 = (0, $l1VxS.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $cyz90.assert)(!!teamId, new (0, $gLoFN.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $ca6420fc7edcf484$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage && !(0, $eGOwo.fg)('ops_member_roles_page_access_detailed_rights_2')) return null;
        return (0, $jOg6y.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    // TODO remove dependency on cleanup ops_member_roles_page_access_detailed_rights_2
    depends: [
        $ca6420fc7edcf484$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $ca6420fc7edcf484$export$bc99aaabaf7b70a7 = ()=>[
        $ca6420fc7edcf484$export$5c4885c1f1a535b,
        $ca6420fc7edcf484$export$50271c9e7f21f10e,
        $ca6420fc7edcf484$export$ed1eb48699cf7893
    ];

});
parcelRegister("jOg6y", function(module, exports) {
$parcel$export(module.exports, "getMembersOld", () => $71c72fac9ed66e90$export$dc7a9fe3089fc26e);
$parcel$export(module.exports, "getMembers", () => $71c72fac9ed66e90$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $71c72fac9ed66e90$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $71c72fac9ed66e90$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $71c72fac9ed66e90$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $71c72fac9ed66e90$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $71c72fac9ed66e90$export$ebfa293eb1ef42f5);

var $eGOwo = parcelRequire("eGOwo");

var $9ppkU = parcelRequire("9ppkU");
var $fR4Ty = parcelRequire("fR4Ty");
const $71c72fac9ed66e90$var$operationName = 'memberRolesTeamMembersQuery';
const $71c72fac9ed66e90$var$getMembersParams = (after)=>{
    const firstParam = (0, $eGOwo.fg)('platform_increase_limit_of_members_query') ? 'first: 300' : 'first: 100';
    const afterParam = after ? `, after: "${after}"` : '';
    return `(${firstParam}${afterParam})`;
};
const $71c72fac9ed66e90$export$dc7a9fe3089fc26e = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, $eGOwo.fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
    return (0, $9ppkU.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $71c72fac9ed66e90$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $71c72fac9ed66e90$export$f4931e6f9feb30c5 = (teamId, after)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $fR4Ty.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${$71c72fac9ed66e90$var$getMembersParams(after)}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
					pageInfo {
						endCursor
						hasNextPage
					}
				}
			}
		}
	}
	`;
    return (0, $9ppkU.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $71c72fac9ed66e90$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $71c72fac9ed66e90$export$95d4c4e762437fdd = (teamId)=>(0, $9ppkU.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $71c72fac9ed66e90$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $9ppkU.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $71c72fac9ed66e90$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $9ppkU.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $71c72fac9ed66e90$export$491fe77f22ab2b51 = (teamId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $71c72fac9ed66e90$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $9ppkU.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("5Wzun", function(module, exports) {
$parcel$export(module.exports, "eocPermissionsRoute", () => $f55ad163e13bf5d3$export$8e6afd724de3be6e);
const $f55ad163e13bf5d3$export$8e6afd724de3be6e = {
    name: 'eoc-permissions',
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};

});

parcelRegister("a6Kdh", function(module, exports) {
$parcel$export(module.exports, "LazyMemberRoles", () => $04e7a8ade7ba428a$export$27b4fb95241ab47);
$parcel$export(module.exports, "default", () => $04e7a8ade7ba428a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $04e7a8ade7ba428a$export$27b4fb95241ab47 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6Ghrv")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
const $04e7a8ade7ba428a$var$AsyncMemberRoles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $04e7a8ade7ba428a$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });
var $04e7a8ade7ba428a$export$2e2bcd8739ae039 = $04e7a8ade7ba428a$var$AsyncMemberRoles;

});
parcelRegister("6Ghrv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5AlTx").then(()=>parcelRequire('3EgOL'));

});



parcelRegister("6y1qE", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRedirectRouteEntry", () => $38270fe969ef3f07$export$c5606e8eeca32c0f);

var $3LXmM = parcelRequire("3LXmM");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $fP5hi = parcelRequire("fP5hi");

var $98AOo = parcelRequire("98AOo");
const $38270fe969ef3f07$export$c5606e8eeca32c0f = (0, $6xToB.createEntry)((0, $fP5hi.eocReportsTeamRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReportsRedirect),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $3LXmM.resources)(),
            (0, $3LXmM.opsReportsPermissionResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReportsRedirect),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-reports-entries/src/eocReportsTeamRedirectRouteEntry.tsx',
                whichExportToUse: 'eocReportsTeamRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fP5hi", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRedirectRoute", () => $d768d698dfe73ff3$export$26b0a544e6502d55);
const $d768d698dfe73ff3$export$26b0a544e6502d55 = {
    name: 'eoc-reports',
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};

});


parcelRegister("5UUbR", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRouteEntry", () => $d31e1f1a1195128c$export$cd1c1a81e516fec5);

var $3LXmM = parcelRequire("3LXmM");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $hhkDv = parcelRequire("hhkDv");

var $98AOo = parcelRequire("98AOo");
const $d31e1f1a1195128c$export$cd1c1a81e516fec5 = (0, $6xToB.createEntry)((0, $hhkDv.eocReportsTeamRoute), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReports),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $3LXmM.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReports),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-reports-entries/src/eocReportsTeamRouteEntry.tsx',
                whichExportToUse: 'eocReportsTeamRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hhkDv", function(module, exports) {
$parcel$export(module.exports, "eocReportsTeamRoute", () => $18d6d825e2e93cf9$export$c9e0796615c034f3);
const $18d6d825e2e93cf9$export$c9e0796615c034f3 = {
    name: 'eoc-reports-team',
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};

});


parcelRegister("djdJN", function(module, exports) {
$parcel$export(module.exports, "eocReportsUnsubscribeRouteEntry", () => $66afa995de4f4abf$export$6e8d112a548528b5);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $46YLy = parcelRequire("46YLy");

var $98AOo = parcelRequire("98AOo");
const $66afa995de4f4abf$export$6e8d112a548528b5 = (0, $6xToB.createEntry)((0, $46YLy.eocReportsUnsubscribeRoute), ()=>({
        group: 'eoc',
        component: (0, $98AOo.OpsReportsUnsubscribe),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $98AOo.LazyOpsReportsUnsubscribe)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-reports-entries/src/eocReportsUnsubscribeRouteEntry.tsx',
                whichExportToUse: 'eocReportsUnsubscribeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("46YLy", function(module, exports) {
$parcel$export(module.exports, "eocReportsUnsubscribeRoute", () => $5285f5ca5480918e$export$72cde899ee974e6e);
const $5285f5ca5480918e$export$72cde899ee974e6e = {
    name: 'eoc-reports-unsubscribe',
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("5ylat", function(module, exports) {
$parcel$export(module.exports, "eocScheduleGlobalRouteEntry", () => $5ab3dfa90913e3a9$export$831e8756cdaae4ba);

var $eJOHy = parcelRequire("eJOHy");

var $99bks = parcelRequire("99bks");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $753hq = parcelRequire("753hq");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jJKus")).then((m)=>m.ScheduleGlobalPage), {
    moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
});
const $5ab3dfa90913e3a9$var$EocScheduleGlobalComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage,
        pageId: "async-jira-eoc-schedule-global",
        shouldShowSpinner: false
    });
const $5ab3dfa90913e3a9$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $5ab3dfa90913e3a9$export$831e8756cdaae4ba = (0, $6xToB.createEntry)((0, $753hq.eocScheduleGlobalRoute), ()=>({
        group: 'eoc',
        component: $5ab3dfa90913e3a9$var$EocScheduleGlobalComponent,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $99bks.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$5ab3dfa90913e3a9$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            $5ab3dfa90913e3a9$var$LazyScheduleGlobalPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-schedule-global-entries/src/eocScheduleGlobalRouteEntry.tsx',
                whichExportToUse: 'eocScheduleGlobalRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("99bks", function(module, exports) {
$parcel$export(module.exports, "resources", () => $a94fee5d3eff1691$export$bc99aaabaf7b70a7);

var $1DrRY = parcelRequire("1DrRY");

var $ls7PN = parcelRequire("ls7PN");
const $a94fee5d3eff1691$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ls7PN.getTimezonesResource),
        (0, $ls7PN.getTimeTemplatesResource),
        ...(0, $1DrRY.eocCommonResources)()
    ];

});

parcelRegister("753hq", function(module, exports) {
$parcel$export(module.exports, "eocScheduleGlobalRoute", () => $c461ff52ffca1a86$export$10454dc485142eb6);
const $c461ff52ffca1a86$export$10454dc485142eb6 = {
    name: 'eoc-schedules',
    path: '/jira/settings/products/ops/schedules',
    exact: true
};

});

parcelRegister("jJKus", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kKbft").then(()=>parcelRequire('hYna3'));

});


parcelRegister("dEChv", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertDetailRouteEntry", () => $b793d39d728adba9$export$94aaa7006da9d63a);

var $8T8NA = parcelRequire("8T8NA");

var $3dkey = parcelRequire("3dkey");

var $dEcKp = parcelRequire("dEcKp");

var $i1cBv = parcelRequire("i1cBv");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $igYXn = parcelRequire("igYXn");

var $fy9vy = parcelRequire("fy9vy");
const $b793d39d728adba9$export$94aaa7006da9d63a = (0, $6xToB.createEntry)((0, $igYXn.eocTeamAlertDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $fy9vy.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $3dkey.resources)(),
            ...(0, $8T8NA.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('automation_discoverability_in_jsm'), (0, $i1cBv.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fy9vy.LazyAlertList),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-team-alerts-entries/src/eocTeamAlertDetailRouteEntry.tsx',
                whichExportToUse: 'eocTeamAlertDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fy9vy", function(module, exports) {
$parcel$export(module.exports, "LazyAlertList", () => $bdc84cdc67c7a25d$export$f4aafff31d950b6c);
$parcel$export(module.exports, "default", () => $bdc84cdc67c7a25d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $bdc84cdc67c7a25d$export$f4aafff31d950b6c = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kSyqr")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $bdc84cdc67c7a25d$var$AsyncAlertList = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bdc84cdc67c7a25d$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });
var $bdc84cdc67c7a25d$export$2e2bcd8739ae039 = $bdc84cdc67c7a25d$var$AsyncAlertList;

});


parcelRegister("7YInD", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRouteEntry", () => $c4f6beb549f8d6f1$export$8c07dc381591dc69);

var $7ZjlZ = parcelRequire("7ZjlZ");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $4Mrbh = parcelRequire("4Mrbh");

var $jXwOY = parcelRequire("jXwOY");

var $4dPst = parcelRequire("4dPst");

var $91lt4 = parcelRequire("91lt4");
const $c4f6beb549f8d6f1$export$8c07dc381591dc69 = (0, $6xToB.createEntry)((0, $4Mrbh.eocTeamAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $4dPst.AlertIssueSyncCreate),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $7ZjlZ.resources).configuredSyncsResource,
            (0, $7ZjlZ.resources).userAccessRightsResource,
            (0, $7ZjlZ.resources).getTeamResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-alert-issue-syncing-entries/src/eocTeamAlertIssueSyncingCreateRouteEntry.tsx',
                whichExportToUse: 'eocTeamAlertIssueSyncingCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4Mrbh", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", () => $a39de729ea392ca3$export$915ef1948fe4650a);
const $a39de729ea392ca3$export$915ef1948fe4650a = {
    name: 'eoc-team-alert-issue-syncing-create',
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};

});


parcelRegister("kXXTW", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRouteEntry", () => $2210068f8b76d0d7$export$6298ff494c460e75);

var $7ZjlZ = parcelRequire("7ZjlZ");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $jhI29 = parcelRequire("jhI29");

var $gne1j = parcelRequire("gne1j");

var $jXwOY = parcelRequire("jXwOY");

var $91lt4 = parcelRequire("91lt4");
const $2210068f8b76d0d7$export$6298ff494c460e75 = (0, $6xToB.createEntry)((0, $jhI29.eocTeamAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $gne1j.AlertIssueSyncDetail),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $7ZjlZ.resources).configuredSyncsResource,
            (0, $7ZjlZ.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-alert-issue-syncing-entries/src/eocTeamAlertIssueSyncingDetailRouteEntry.tsx',
                whichExportToUse: 'eocTeamAlertIssueSyncingDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jhI29", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", () => $6698d14394398285$export$e91535fc2137c3b);
const $6698d14394398285$export$e91535fc2137c3b = {
    name: 'eoc-team-alert-issue-syncing-detail',
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};

});


parcelRegister("6aBHI", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingRouteEntry", () => $23265ba2582c9139$export$be342a3401146aae);

var $7ZjlZ = parcelRequire("7ZjlZ");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $flCKw = parcelRequire("flCKw");

var $jXwOY = parcelRequire("jXwOY");

var $91lt4 = parcelRequire("91lt4");
const $23265ba2582c9139$export$be342a3401146aae = (0, $6xToB.createEntry)((0, $flCKw.eocTeamAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jXwOY.AlertIssueSync),
        layout: (0, $igwPu.opsTeamLayout),
        slot: null,
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $7ZjlZ.resources).configuredSyncsResource,
            (0, $7ZjlZ.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $91lt4.LazyAlertIssueSync),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-alert-issue-syncing-entries/src/eocTeamAlertIssueSyncingRouteEntry.tsx',
                whichExportToUse: 'eocTeamAlertIssueSyncingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("flCKw", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", () => $7345549d10c755cc$export$37ea7624561cbb89);
const $7345549d10c755cc$export$37ea7624561cbb89 = {
    name: 'eoc-team-alert-issue-syncing',
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};

});


parcelRegister("85n74", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertListRouteEntry", () => $6796c399b3b3aaae$export$de37dab3b3ed8e5c);

var $3dkey = parcelRequire("3dkey");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $ghsHL = parcelRequire("ghsHL");

var $fy9vy = parcelRequire("fy9vy");
const $6796c399b3b3aaae$export$de37dab3b3ed8e5c = (0, $6xToB.createEntry)((0, $ghsHL.eocTeamAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $fy9vy.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $3dkey.resources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fy9vy.LazyAlertList),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-team-alerts-entries/src/eocTeamAlertListRouteEntry.tsx',
                whichExportToUse: 'eocTeamAlertListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ghsHL", function(module, exports) {
$parcel$export(module.exports, "eocTeamAlertListRoute", () => $edadd18ba8feba76$export$94efd60f23d97aa5);
const $edadd18ba8feba76$export$94efd60f23d97aa5 = {
    name: 'eoc-team-alerts',
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};

});


parcelRegister("ekFnU", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", () => $a004d162c1e0c610$export$d2ce6f09ef8aa840);

var $cVewO = parcelRequire("cVewO");

var $yRJUA = parcelRequire("yRJUA");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $7RTxG = parcelRequire("7RTxG");

var $9lzBd = parcelRequire("9lzBd");
const $a004d162c1e0c610$export$d2ce6f09ef8aa840 = (0, $6xToB.createEntry)((0, $7RTxG.eocTeamCustomerLogsDownloadRoute), ()=>({
        group: 'eoc',
        component: (0, $9lzBd.CustomerLogsDownloadPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $cVewO.downloadResources)()
        ],
        forPaint: [
            (0, $9lzBd.LazyCustomerLogsDownLoad)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-team-customer-logs-entries/src/eocTeamCustomerLogsDownloadRouteEntry.tsx',
                whichExportToUse: 'eocTeamCustomerLogsDownloadRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cVewO", function(module, exports) {
$parcel$export(module.exports, "resources", () => $ae9f84ac8adbd263$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "downloadResources", () => $ae9f84ac8adbd263$export$8571305c82629fe4);

var $1DrRY = parcelRequire("1DrRY");

var $eqlqO = parcelRequire("eqlqO");

var $aO3EN = parcelRequire("aO3EN");

var $ftbsW = parcelRequire("ftbsW");
const $ae9f84ac8adbd263$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ftbsW.uiSettingsResource),
        (0, $aO3EN.logsResource),
        ...(0, $1DrRY.eocCommonResources)()
    ];
const $ae9f84ac8adbd263$export$8571305c82629fe4 = ()=>[
        (0, $eqlqO.downloadAuditLogsResource),
        ...(0, $1DrRY.eocCommonResources)()
    ];

});
parcelRegister("eqlqO", function(module, exports) {
$parcel$export(module.exports, "downloadAuditLogsResource", () => $695a847bf4883972$export$304da75014b88b78);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $kFRqd = parcelRequire("kFRqd");
const $695a847bf4883972$export$304da75014b88b78 = (0, $l1VxS.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $cyz90.assert)(!!uniqueKey, new (0, $gLoFN.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $kFRqd.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("kFRqd", function(module, exports) {
$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $bae6fc967d76a943$export$c8df7e5942ba1d96);

var $9ppkU = parcelRequire("9ppkU");
const $bae6fc967d76a943$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $9ppkU.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("aO3EN", function(module, exports) {
$parcel$export(module.exports, "logsResource", () => $05571d603392aa4d$export$fd88b4310d3f52ff);

var $l1VxS = parcelRequire("l1VxS");

var $lmbIE = parcelRequire("lmbIE");
const $05571d603392aa4d$export$fd88b4310d3f52ff = (0, $l1VxS.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $lmbIE.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("lmbIE", function(module, exports) {
$parcel$export(module.exports, "fetchLogs", () => $cacca3b5c26f005f$export$b9fcc8145a518db4);

var $9ppkU = parcelRequire("9ppkU");

var $53R2f = parcelRequire("53R2f");
const $cacca3b5c26f005f$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $53R2f.generateLogParams)(params);
    return (0, $9ppkU.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $53R2f.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("53R2f", function(module, exports) {
$parcel$export(module.exports, "isValidTimePeriodFormat", () => $ce7fc0233ff93cce$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $ce7fc0233ff93cce$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $ce7fc0233ff93cce$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $ce7fc0233ff93cce$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $ce7fc0233ff93cce$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $ce7fc0233ff93cce$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $ce7fc0233ff93cce$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $ce7fc0233ff93cce$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $ce7fc0233ff93cce$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $ce7fc0233ff93cce$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $ce7fc0233ff93cce$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $ce7fc0233ff93cce$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $ce7fc0233ff93cce$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $ce7fc0233ff93cce$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $ce7fc0233ff93cce$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $ce7fc0233ff93cce$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $ce7fc0233ff93cce$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $ce7fc0233ff93cce$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $ce7fc0233ff93cce$export$9a858fe3837c0be0);
$parcel$export(module.exports, "isObject", () => $ce7fc0233ff93cce$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectNotEmpty", () => $ce7fc0233ff93cce$export$ef1babdfa24b430e);
$parcel$export(module.exports, "isObjectEmpty", () => $ce7fc0233ff93cce$export$23cfe696632d10f4);
$parcel$export(module.exports, "checkSourceExpandedSection", () => $ce7fc0233ff93cce$export$994e710d733916ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1dGnw = parcelRequire("1dGnw");

var $fTjQo = parcelRequire("fTjQo");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $8XZn3 = parcelRequire("8XZn3");

var $8dH3d = parcelRequire("8dH3d");

var $jPROM = parcelRequire("jPROM");

var $3cMgR = parcelRequire("3cMgR");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $4N6zu = parcelRequire("4N6zu");

var $hopx4 = parcelRequire("hopx4");

var $d5Qw5 = parcelRequire("d5Qw5");

var $bdiDk = parcelRequire("bdiDk");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $ce7fc0233ff93cce$var$isNumeric = (value)=>/^\d+$/.test(value);
const $ce7fc0233ff93cce$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $ce7fc0233ff93cce$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $hopx4.RANGE_OPTIONS).includes(timeUnit);
};
const $ce7fc0233ff93cce$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $bdiDk.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $bdiDk.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $dBLX0.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $dBLX0.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $bdiDk.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $ce7fc0233ff93cce$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $dBLX0.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $dBLX0.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $ce7fc0233ff93cce$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
};
const $ce7fc0233ff93cce$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $ce7fc0233ff93cce$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $ce7fc0233ff93cce$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$ce7fc0233ff93cce$export$792d5c0a6d15a15e(query, value));
};
const $ce7fc0233ff93cce$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $ce7fc0233ff93cce$export$422789958d8174dd = (unit)=>(0, $hopx4.RANGE_OPTIONS).includes(unit);
const $ce7fc0233ff93cce$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $ce7fc0233ff93cce$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $ce7fc0233ff93cce$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $8XZn3.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $ce7fc0233ff93cce$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$ce7fc0233ff93cce$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $ce7fc0233ff93cce$export$42dac873831f0e2(urlParams);
};
const $ce7fc0233ff93cce$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $1dGnw.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $ce7fc0233ff93cce$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $kQ82p.default)(startDate);
    const parsedEndDate = (0, $kQ82p.default)(endDate);
    const timeDifference = $ce7fc0233ff93cce$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $ce7fc0233ff93cce$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $ce7fc0233ff93cce$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $d5Qw5.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $ce7fc0233ff93cce$export$ae02811946c03a4b((0, $fTjQo.default)(startDateIntValue), (0, $fTjQo.default)(endDateIntValue));
    const params = $ce7fc0233ff93cce$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $cyz90.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(endTimestampParams), new (0, $gLoFN.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $ce7fc0233ff93cce$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(parsedRaw);
};
const $ce7fc0233ff93cce$export$130612b33e678a37 = ()=>{
    const params = $ce7fc0233ff93cce$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $cyz90.assert)(!!startDate && !!endDate, new (0, $gLoFN.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $4N6zu.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $ce7fc0233ff93cce$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $d5Qw5.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $ce7fc0233ff93cce$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $ce7fc0233ff93cce$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: textContent
    }, key);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $ce7fc0233ff93cce$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: children
            }, key);
        case 'I':
            return /*#__PURE__*/ (0, $gt9Am.jsx)("i", {
                children: children
            }, key);
        case 'STRONG':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                weight: "bold",
                children: children
            }, key);
        case 'EM':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                as: "em",
                children: children
            }, key);
        case 'CODE':
            // eslint-disable-next-line @atlaskit/design-system/no-html-code
            return /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
                children: children
            }, key);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children[0]
    }, key);
    if (children.length) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        children: children
    }, key);
    return null;
}
const $ce7fc0233ff93cce$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};
function $ce7fc0233ff93cce$export$a6cdc56e425d0d0a(val) {
    return typeof val === 'object' && val !== null;
}
function $ce7fc0233ff93cce$export$ef1babdfa24b430e(object) {
    return !$ce7fc0233ff93cce$export$23cfe696632d10f4(object);
}
function $ce7fc0233ff93cce$export$23cfe696632d10f4(object) {
    return Object.keys(object).length === 0;
}
const $ce7fc0233ff93cce$export$994e710d733916ea = (src)=>Object.values(src).some((value)=>$ce7fc0233ff93cce$export$a6cdc56e425d0d0a(value));

});
parcelRegister("4N6zu", function(module, exports) {
$parcel$export(module.exports, "TimeRadioOptions", () => $e35cb3f43feee5bf$export$ff1338756af30600);
var $e35cb3f43feee5bf$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("hopx4", function(module, exports) {
$parcel$export(module.exports, "RANGE_OPTIONS", () => $df67feb608eb4e62$export$a0f3448347834e6b);
const $df67feb608eb4e62$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("d5Qw5", function(module, exports) {
$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $c02b33f44cf94379$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $c02b33f44cf94379$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $c02b33f44cf94379$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $c02b33f44cf94379$export$1220f90483bde21);
const $c02b33f44cf94379$export$4b254bc84a71033a = 'size';
const $c02b33f44cf94379$export$753f41e31eccb6d7 = 1000000;
const $c02b33f44cf94379$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $c02b33f44cf94379$export$1220f90483bde21 = 250;

});

parcelRegister("bdiDk", function(module, exports) {
$parcel$export(module.exports, "default", () => $49577b6c188cd3b9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $49577b6c188cd3b9$var$messages = (0, $7qGN1.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $49577b6c188cd3b9$export$2e2bcd8739ae039 = $49577b6c188cd3b9$var$messages;

});




parcelRegister("ftbsW", function(module, exports) {
$parcel$export(module.exports, "uiSettingsResource", () => $66c2c4c7e1cd391d$export$f2b33518cf31cd40);

var $l1VxS = parcelRequire("l1VxS");

var $7S9UD = parcelRequire("7S9UD");
const $66c2c4c7e1cd391d$export$f2b33518cf31cd40 = (0, $l1VxS.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $7S9UD.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("7S9UD", function(module, exports) {
$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $0a0613cdda0ef4e5$export$ea2f12bcbdce2020);

var $9ppkU = parcelRequire("9ppkU");
const $0a0613cdda0ef4e5$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $9ppkU.eocFetch)('/v1/logs');
};

});



parcelRegister("7RTxG", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", () => $9cb3689751fd3d67$export$678856ccddc0bc05);
const $9cb3689751fd3d67$export$678856ccddc0bc05 = {
    name: 'eoc-team-customer-logs-download',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};

});

parcelRegister("9lzBd", function(module, exports) {
$parcel$export(module.exports, "LazyCustomerLogs", () => $74267c97f7a69873$export$6e30e25faf4f6dce);
$parcel$export(module.exports, "LazyCustomerLogsDownLoad", () => $74267c97f7a69873$export$898c7cb3b28a6104);
$parcel$export(module.exports, "default", () => $74267c97f7a69873$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomerLogsDownloadPage", () => $74267c97f7a69873$export$a5786cf859b7b457);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $74267c97f7a69873$export$6e30e25faf4f6dce = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3sIml")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $74267c97f7a69873$export$898c7cb3b28a6104 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3sIml")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
const $74267c97f7a69873$var$AsyncCustomerLogsDownLoad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $74267c97f7a69873$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
var $74267c97f7a69873$export$2e2bcd8739ae039 = $74267c97f7a69873$var$AsyncCustomerLogsDownLoad;
const $74267c97f7a69873$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $74267c97f7a69873$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });

});
parcelRegister("3sIml", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cIBeW").then(()=>parcelRequire('57oKS'));

});



parcelRegister("3s5Pk", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", () => $30927a52d25dd1e8$export$42ca979ec2919b23);

var $cVewO = parcelRequire("cVewO");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $iTOe5 = parcelRequire("iTOe5");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $9lzBd = parcelRequire("9lzBd");
const $30927a52d25dd1e8$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $30927a52d25dd1e8$export$42ca979ec2919b23 = (0, $6xToB.createEntry)((0, $iTOe5.eocTeamCustomerLogsRoute), ()=>({
        group: 'eoc',
        component: (0, $9lzBd.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$30927a52d25dd1e8$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $cVewO.resources)()
        ],
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9lzBd.LazyCustomerLogs)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9lzBd.LazyCustomerLogs)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-team-customer-logs-entries/src/eocTeamCustomerLogsRouteEntry.tsx',
                whichExportToUse: 'eocTeamCustomerLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iTOe5", function(module, exports) {
$parcel$export(module.exports, "eocTeamCustomerLogsRoute", () => $b8938549b62bad8e$export$4b517044f5f7830d);
const $b8938549b62bad8e$export$4b517044f5f7830d = {
    name: 'eoc-team-customer-logs',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};

});


parcelRegister("Vlf4X", function(module, exports) {
$parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", () => $3d2511d7ed26a782$export$2b25520e20820251);

var $3dkey = parcelRequire("3dkey");

var $8vvFn = parcelRequire("8vvFn");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $bQuVG = parcelRequire("bQuVG");

var $9HKZp = parcelRequire("9HKZp");
const $3d2511d7ed26a782$export$2b25520e20820251 = (0, $6xToB.createEntry)((0, $bQuVG.eocTeamGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $9HKZp.default),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $8vvFn.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $3dkey.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9HKZp.LazyGroupDetail),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-group-detail-entries/src/eocTeamGroupDetailRouteEntry.tsx',
                whichExportToUse: 'eocTeamGroupDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bQuVG", function(module, exports) {
$parcel$export(module.exports, "eocTeamGroupDetailRoute", () => $1e8ac7f8b70f6a94$export$aa8cf61e94739f21);
const $1e8ac7f8b70f6a94$export$aa8cf61e94739f21 = {
    name: 'eoc-team-group-detail',
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};

});


parcelRegister("7JuWl", function(module, exports) {
$parcel$export(module.exports, "eocUserNotificationsRouteEntry", () => $030ef2384ba5b682$export$15b42089d01e5917);

var $k3OCS = parcelRequire("k3OCS");

var $j3mZ1 = parcelRequire("j3mZ1");

var $6wCSD = parcelRequire("6wCSD");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gPROq = parcelRequire("gPROq");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $8fcHh = parcelRequire("8fcHh");
const $030ef2384ba5b682$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $030ef2384ba5b682$export$15b42089d01e5917 = (0, $6xToB.createEntry)((0, $gPROq.eocUserNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $8fcHh.default),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$030ef2384ba5b682$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $k3OCS.createContactsResource)(),
            (0, $6wCSD.createNotificationPreferencesResource)(),
            (0, $j3mZ1.createMuteResource)(),
            (0, $j3mZ1.createQuietHoursResource)(),
            (0, $6wCSD.createForwardingRulesResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8fcHh.LazyUserNotifications)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8fcHh.LazyUserNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-user-notifications-entries/src/eocUserNotificationsRouteEntry.tsx',
                whichExportToUse: 'eocUserNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k3OCS", function(module, exports) {
$parcel$export(module.exports, "createContactsResource", () => $b385f86b02e2a47f$export$b9ca444b0be3df97);
$parcel$export(module.exports, "contactsResource", () => $b385f86b02e2a47f$export$54a06d876c95357d);

var $l1VxS = parcelRequire("l1VxS");

var $eGOwo = parcelRequire("eGOwo");

var $5g8ED = parcelRequire("5g8ED");
const $b385f86b02e2a47f$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = (0, $eGOwo.fg)('jsm_admin_access_user_notification_settings') ? match.params?.targetAccountId : undefined;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $5g8ED.getContacts)(targetAccountId);
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $b385f86b02e2a47f$export$54a06d876c95357d = $b385f86b02e2a47f$export$b9ca444b0be3df97();

});
parcelRegister("5g8ED", function(module, exports) {
$parcel$export(module.exports, "getContacts", () => $f97f41cfcf544d0f$export$70ff9d70e43e8f10);
$parcel$export(module.exports, "addContactEndpoint", () => $f97f41cfcf544d0f$export$bd596455bda1cd66);
$parcel$export(module.exports, "orderContactEndpoint", () => $f97f41cfcf544d0f$export$77f16e7683ad08d6);
$parcel$export(module.exports, "updateContactStatusEndpoint", () => $f97f41cfcf544d0f$export$d50cab05338f8080);
$parcel$export(module.exports, "updateContactVisibleEndpoint", () => $f97f41cfcf544d0f$export$9c70861fcae2d721);
$parcel$export(module.exports, "setContactPrimaryEndpoint", () => $f97f41cfcf544d0f$export$2b151c91a5abc2aa);
$parcel$export(module.exports, "deleteContactEndpoint", () => $f97f41cfcf544d0f$export$59eb3ff38e4cd944);
$parcel$export(module.exports, "editContactEndpoint", () => $f97f41cfcf544d0f$export$3f8035f77e3aeb9d);
$parcel$export(module.exports, "sendVerificationCodeEndpoint", () => $f97f41cfcf544d0f$export$74e1bdc56dc32826);
$parcel$export(module.exports, "checkVerificationCodeEndpoint", () => $f97f41cfcf544d0f$export$fbe80b8d857094de);

var $9ppkU = parcelRequire("9ppkU");

var $c9SEt = parcelRequire("c9SEt");
const $f97f41cfcf544d0f$export$70ff9d70e43e8f10 = (targetAccountId)=>(0, $9ppkU.eocFetch)(`/v1/users/contact${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`);
const $f97f41cfcf544d0f$export$bd596455bda1cd66 = (newAddress, method, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            address: newAddress,
            method: method.toLowerCase()
        }
    });
};
const $f97f41cfcf544d0f$export$77f16e7683ad08d6 = (contactId, after, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/order${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            after: after
        }
    });
};
const $f97f41cfcf544d0f$export$d50cab05338f8080 = (status)=>{
    return status ? $f97f41cfcf544d0f$var$enableContactEndpoint : $f97f41cfcf544d0f$var$disableContactEndpoint;
};
const $f97f41cfcf544d0f$var$enableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/state/enabled${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f97f41cfcf544d0f$var$disableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/state/disabled${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f97f41cfcf544d0f$export$9c70861fcae2d721 = (visible)=>{
    return visible ? $f97f41cfcf544d0f$var$setContactVisibleEndpoint : $f97f41cfcf544d0f$var$setContactHiddenEndpoint;
};
const $f97f41cfcf544d0f$var$setContactVisibleEndpoint = (contactId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/state/visible`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f97f41cfcf544d0f$var$setContactHiddenEndpoint = (contactId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/state/hidden`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f97f41cfcf544d0f$export$2b151c91a5abc2aa = (contactId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/state/primary`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $f97f41cfcf544d0f$export$59eb3ff38e4cd944 = (contactId, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'DELETE',
        body: {
            contactId: contactId
        },
        responseType: 'headers'
    });
};
const $f97f41cfcf544d0f$export$3f8035f77e3aeb9d = (contactId, newAddress, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            address: newAddress
        }
    });
};
const $f97f41cfcf544d0f$export$74e1bdc56dc32826 = (phoneNumber, method, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/verification${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            method: method.toLowerCase()
        }
    });
};
const $f97f41cfcf544d0f$export$fbe80b8d857094de = (phoneNumber, code, targetAccountId)=>{
    return (0, $9ppkU.eocFetch)(`/v1/users/contact/verification/check${(0, $c9SEt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            code: code
        },
        responseType: 'headers'
    });
};

});
parcelRegister("c9SEt", function(module, exports) {
$parcel$export(module.exports, "calculateRemainingMinutesAndSeconds", () => $a9aceb9bdc17ae0e$export$d3f650aeadf07bf8);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $a9aceb9bdc17ae0e$export$f538d5c43127966b);

var $eGOwo = parcelRequire("eGOwo");
const $a9aceb9bdc17ae0e$export$d3f650aeadf07bf8 = (countDown)=>{
    const minutes = Math.floor(countDown % 3600000 / 60000);
    const seconds = Math.floor(countDown % 60000 / 1000);
    return [
        minutes < 0 ? 0 : minutes,
        seconds < 0 ? 0 : seconds
    ];
};
const $a9aceb9bdc17ae0e$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $eGOwo.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("j3mZ1", function(module, exports) {
$parcel$export(module.exports, "createMuteResource", () => $08054a2cecb8b583$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $08054a2cecb8b583$export$efc5e8690061f9cc);
$parcel$export(module.exports, "muteResource", () => $08054a2cecb8b583$export$3c4c16a7c2620c29);
$parcel$export(module.exports, "quietHoursResource", () => $08054a2cecb8b583$export$9b33012bd34cc225);

var $l1VxS = parcelRequire("l1VxS");

var $6fRIY = parcelRequire("6fRIY");
const $08054a2cecb8b583$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $6fRIY.getMuteDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $08054a2cecb8b583$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $6fRIY.getQuietHoursDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $08054a2cecb8b583$export$3c4c16a7c2620c29 = $08054a2cecb8b583$export$c849cfac68bc6e80();
const $08054a2cecb8b583$export$9b33012bd34cc225 = $08054a2cecb8b583$export$efc5e8690061f9cc();

});
parcelRegister("6fRIY", function(module, exports) {
$parcel$export(module.exports, "getMuteDetail", () => $93033c301415b936$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $93033c301415b936$export$44a94c74f358d02f);

var $9ppkU = parcelRequire("9ppkU");

var $4g2xq = parcelRequire("4g2xq");
const $93033c301415b936$export$80a4e62998a806a6 = (targetAccountId)=>(0, $9ppkU.eocFetch)(`/v1/users/notifications/mute${(0, $4g2xq.getTargetAccountIdSuffix)(targetAccountId)}`);
const $93033c301415b936$export$44a94c74f358d02f = (targetAccountId)=>(0, $9ppkU.eocFetch)(`/v1/users/quiet-hours/details${(0, $4g2xq.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("4g2xq", function(module, exports) {
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $e8edfcb54c817a73$export$f538d5c43127966b);

var $eGOwo = parcelRequire("eGOwo");
const $e8edfcb54c817a73$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $eGOwo.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("6wCSD", function(module, exports) {
$parcel$export(module.exports, "createNotificationPreferencesResource", () => $ded28323179ffcf7$export$731980bd233a4797);
$parcel$export(module.exports, "createForwardingRulesResource", () => $ded28323179ffcf7$export$5314dca65b4e5888);

var $l1VxS = parcelRequire("l1VxS");
parcelRequire("1DrRY");
var $igkn1 = parcelRequire("igkn1");

var $8jtrb = parcelRequire("8jtrb");
const $ded28323179ffcf7$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $8jtrb.getNotificationPreferences)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $ded28323179ffcf7$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $8jtrb.getForwardingRules)(targetAccountId).then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("8jtrb", function(module, exports) {
$parcel$export(module.exports, "getNotificationPreferences", () => $da085016638bd13b$export$60e139c3026f21bc);
$parcel$export(module.exports, "getForwardingRules", () => $da085016638bd13b$export$2161af98e3d645a5);

var $9ppkU = parcelRequire("9ppkU");

var $8v8SQ = parcelRequire("8v8SQ");
const $da085016638bd13b$export$60e139c3026f21bc = (targetAccountId)=>(0, $9ppkU.eocFetch)(`/v1/users/notification-preferences${(0, $8v8SQ.getTargetAccountIdSuffix)(targetAccountId)}`);
const $da085016638bd13b$export$2161af98e3d645a5 = (targetAccountId)=>(0, $9ppkU.eocFetch)(`/v1/alerts/notifications/forwarding-rules${(0, $8v8SQ.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("8v8SQ", function(module, exports) {
$parcel$export(module.exports, "getOperationName", () => $be2eae25e11c9efd$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getMatchType", () => $be2eae25e11c9efd$export$a8ea0fb63186ef7e);
$parcel$export(module.exports, "formatRestriction", () => $be2eae25e11c9efd$export$99bcc87a197977ea);
$parcel$export(module.exports, "getAvailableRuleTypeOptions", () => $be2eae25e11c9efd$export$c5259662f509f23f);
$parcel$export(module.exports, "getDefaultTimeOptions", () => $be2eae25e11c9efd$export$318d0e67e244d7ff);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $be2eae25e11c9efd$export$f538d5c43127966b);

var $8RQlO = parcelRequire("8RQlO");

var $57raR = parcelRequire("57raR");

var $jD788 = parcelRequire("jD788");

var $5IPrF = parcelRequire("5IPrF");

var $eGOwo = parcelRequire("eGOwo");

var $gGPuG = parcelRequire("gGPuG");

var $gQQgB = parcelRequire("gQQgB");

var $bf3P8 = parcelRequire("bf3P8");
const $be2eae25e11c9efd$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $gGPuG.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $be2eae25e11c9efd$export$a8ea0fb63186ef7e = (conditionMatchType)=>{
    switch(conditionMatchType){
        case 1:
            return 'match-any-condition';
        case 2:
            return 'match-all-conditions';
        default:
            return 'match-all';
    }
};
const $be2eae25e11c9efd$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $5IPrF.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $57raR.default)((0, $8RQlO.default)(firstDOW, i), 'EEEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $be2eae25e11c9efd$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $be2eae25e11c9efd$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $57raR.default)((0, $jD788.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $57raR.default)((0, $jD788.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};
const $be2eae25e11c9efd$export$c5259662f509f23f = (formatMessage)=>{
    return Object.keys((0, $gQQgB.AVAILABLE_RULE_TYPES)).filter((v)=>isNaN(Number(v))).map((key)=>({
            label: formatMessage((0, $bf3P8.default)[key]),
            value: key
        }));
};
const $be2eae25e11c9efd$export$318d0e67e244d7ff = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $be2eae25e11c9efd$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $eGOwo.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});
parcelRegister("gGPuG", function(module, exports) {
$parcel$export(module.exports, "DATE_FORMAT", () => $a7fa58040a097a03$export$45c85543ba71221d);
$parcel$export(module.exports, "TIME_FORMAT", () => $a7fa58040a097a03$export$c4e1e4e065ff5bd8);
$parcel$export(module.exports, "DATETIME_FORMAT", () => $a7fa58040a097a03$export$ae1dc8cbcf481d8e);
$parcel$export(module.exports, "OPERATIONS", () => $a7fa58040a097a03$export$98ff4de2f070152d);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $a7fa58040a097a03$export$a7c923252528b255);
$parcel$export(module.exports, "defaultTimes", () => $a7fa58040a097a03$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "supportArticles", () => $a7fa58040a097a03$export$f4b848c2437238f9);

var $gQQgB = parcelRequire("gQQgB");
const $a7fa58040a097a03$export$45c85543ba71221d = 'dd/MM/yyyy';
const $a7fa58040a097a03$export$c4e1e4e065ff5bd8 = 'h:mm aaa';
const $a7fa58040a097a03$export$ae1dc8cbcf481d8e = `${$a7fa58040a097a03$export$45c85543ba71221d}; ${$a7fa58040a097a03$export$c4e1e4e065ff5bd8}`;
const $a7fa58040a097a03$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $gQQgB.OperationIds).Matches,
        name: (0, $gQQgB.Operation).Matches
    },
    {
        order: 1,
        id: (0, $gQQgB.OperationIds).Equals,
        name: (0, $gQQgB.Operation).Equals
    },
    {
        order: 2,
        id: (0, $gQQgB.OperationIds).Contains,
        name: (0, $gQQgB.Operation).Contains
    },
    {
        order: 3,
        id: (0, $gQQgB.OperationIds).StartsWith,
        name: (0, $gQQgB.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $gQQgB.OperationIds).EndsWith,
        name: (0, $gQQgB.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $gQQgB.OperationIds).ContainsKey,
        name: (0, $gQQgB.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $gQQgB.OperationIds).ContainsValue,
        name: (0, $gQQgB.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $gQQgB.OperationIds).GreaterThan,
        name: (0, $gQQgB.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $gQQgB.OperationIds).LessThan,
        name: (0, $gQQgB.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $gQQgB.OperationIds).IsEmpty,
        name: (0, $gQQgB.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $gQQgB.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $gQQgB.Operation).EqualsIgnoreWhitespace
    }
];
const $a7fa58040a097a03$export$a7c923252528b255 = {
    dndTitle: 'eoc-notifications_dnd_title',
    rulesTitle: 'eoc-notifications_rules_title',
    forwardingRulesTitle: 'eoc-notifications_forwarding_rules_title'
};
const $a7fa58040a097a03$export$b42ffb9f09b1861b = [
    ...Array(24).keys()
].map((time)=>{
    let newTime = time.toString();
    if (newTime.length === 1) newTime = `0${time}`;
    return [
        `${newTime}:00`,
        `${newTime}:30`
    ];
}).flatMap((time)=>time);
const $a7fa58040a097a03$export$f4b848c2437238f9 = {
    setUpRoleBasedNotifications: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-role-based-notifications/',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/112066569/Set+up+role-based+notifications/'
    },
    setUpSmsAndVoice: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-sms-and-voice-notifications/#Contact-information',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404235/Set+up+SMS+and+voice+notifications#Contact-information'
    },
    setUpNotificationPreferences: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-notification-preferences',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11469955/Set+up+notification+preferences'
    },
    notificationForwardingRules: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/add-notification-forwarding-rules',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404196/Add+notification+forwarding+rules'
    }
};

});
parcelRegister("gQQgB", function(module, exports) {
$parcel$export(module.exports, "AVAILABLE_RULE_TYPES", () => $1283784fa0e6a90b$export$a4958d8d5a6aee21);
$parcel$export(module.exports, "OperationIds", () => $1283784fa0e6a90b$export$9e369e35ea3634d7);
$parcel$export(module.exports, "ReverseOperations", () => $1283784fa0e6a90b$export$e722854e5571abe4);
$parcel$export(module.exports, "MatchConditionType", () => $1283784fa0e6a90b$export$dab128282aa7aeee);
$parcel$export(module.exports, "Operation", () => $1283784fa0e6a90b$export$ab5aad00225c5662);
var $1283784fa0e6a90b$export$a4958d8d5a6aee21 = /*#__PURE__*/ function(AVAILABLE_RULE_TYPES) {
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["New Alert"] = 0] = "New Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule Start"] = 3] = "Schedule Start";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule End"] = 7] = "Schedule End";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Incoming Call Routing"] = 8] = "Incoming Call Routing";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Acknowledged Alert"] = 1] = "Acknowledged Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Closed Alert"] = 2] = "Closed Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Assigned Alert"] = 5] = "Assigned Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Add Note"] = 6] = "Add Note";
    return AVAILABLE_RULE_TYPES;
}({});
var $1283784fa0e6a90b$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $1283784fa0e6a90b$export$e722854e5571abe4 = /*#__PURE__*/ function(ReverseOperations) {
    ReverseOperations[ReverseOperations["matches"] = 0] = "matches";
    ReverseOperations[ReverseOperations["contains"] = 1] = "contains";
    ReverseOperations[ReverseOperations["starts-with"] = 3] = "starts-with";
    ReverseOperations[ReverseOperations["ends-with"] = 4] = "ends-with";
    ReverseOperations[ReverseOperations["equals"] = 5] = "equals";
    ReverseOperations[ReverseOperations["contains-key"] = 6] = "contains-key";
    ReverseOperations[ReverseOperations["contains-value"] = 7] = "contains-value";
    ReverseOperations[ReverseOperations["greater-than"] = 8] = "greater-than";
    ReverseOperations[ReverseOperations["less-than"] = 9] = "less-than";
    ReverseOperations[ReverseOperations["is-empty"] = 10] = "is-empty";
    ReverseOperations[ReverseOperations["equals-ignore-whitespace"] = 11] = "equals-ignore-whitespace";
    return ReverseOperations;
}({});
var $1283784fa0e6a90b$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});
var $1283784fa0e6a90b$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});

});


parcelRegister("bf3P8", function(module, exports) {
$parcel$export(module.exports, "default", () => $44d6500a8a81e79a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $44d6500a8a81e79a$var$messages = (0, $7qGN1.defineMessages)({
    addIcon: {
        id: 'eoc.notifications.rules.add-icon.no-translate',
        defaultMessage: 'Add rule',
        description: 'Button label to indicate it is used for adding a new notification rule.'
    },
    'New Alert': {
        id: 'eoc.notifications.ui.notifications.new-alert.no-translate',
        defaultMessage: 'New alert',
        description: 'The title of new alert notifications'
    },
    'Schedule Start': {
        id: 'eoc.notifications.ui.notifications.schedule-start.no-translate',
        defaultMessage: 'Schedule start',
        description: 'The title of schedule start notifications'
    },
    'Schedule End': {
        id: 'eoc.notifications.ui.notifications.schedule-end.no-translate',
        defaultMessage: 'Schedule end',
        description: 'The title of schedule end notifications'
    },
    'Acknowledged Alert': {
        id: 'eoc.notifications.ui.notifications.acknowledged-alert.no-translate',
        defaultMessage: 'Acknowledged alert',
        description: 'The title of acknowledged alert notifications'
    },
    'Closed Alert': {
        id: 'eoc.notifications.ui.notifications.closed-alert.no-translate',
        defaultMessage: 'Closed alert',
        description: 'The title of closed alert notifications'
    },
    'Assigned Alert': {
        id: 'eoc.notifications.ui.notifications.assigned-alert.no-translate',
        defaultMessage: 'Assigned alert',
        description: 'The title of assigned alert notifications'
    },
    'Add Note': {
        id: 'eoc.notifications.ui.notifications.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'The title of add note notifications'
    },
    'Incoming Call Routing': {
        id: 'eoc.notifications.ui.notifications.incoming-call-routing.no-translate',
        defaultMessage: 'Incoming Call Routing',
        description: 'The title of incoming call rounting notifications'
    },
    addButtonTooltip: {
        id: 'eoc.notifications.common.ui.notification-section.add-button-tooltip.non-final',
        defaultMessage: "A role-based notification is in effect, so adding more rules isn\u2019t possible.",
        description: 'The message to be shown when user tries to add a rule but there is a role-based notification'
    }
});
var $44d6500a8a81e79a$export$2e2bcd8739ae039 = $44d6500a8a81e79a$var$messages;

});




parcelRegister("gPROq", function(module, exports) {
$parcel$export(module.exports, "eocUserNotificationsRoute", () => $64a2dff356011922$export$f7a15352c90f8063);
const $64a2dff356011922$export$f7a15352c90f8063 = {
    name: 'eoc-user-notifications',
    path: '/jira/settings/products/ops/role-assignment/notifications/:targetAccountId',
    exact: true
};

});

parcelRegister("8fcHh", function(module, exports) {
$parcel$export(module.exports, "LazyUserNotifications", () => $cdd80e4e0e1de913$export$a510b3cfe09fad0d);
$parcel$export(module.exports, "default", () => $cdd80e4e0e1de913$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $cdd80e4e0e1de913$export$a510b3cfe09fad0d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lrfJ9")), {
    ssr: false,
    moduleId: "./src/packages/eoc/user-notifications/src/index.tsx"
});
const $cdd80e4e0e1de913$var$LazyUserNotificationsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cdd80e4e0e1de913$export$a510b3cfe09fad0d,
        pageId: "async-eoc-user-notifications",
        shouldShowSpinner: false
    });
var $cdd80e4e0e1de913$export$2e2bcd8739ae039 = $cdd80e4e0e1de913$var$LazyUserNotificationsPage;

});
parcelRegister("lrfJ9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("huyF8")
]).then(()=>parcelRequire('jE64o'));

});



parcelRegister("4kc5Q", function(module, exports) {
$parcel$export(module.exports, "errorsNotFoundRouteEntry", () => $88e7ccc882e07762$export$c4c012a49b465e94);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $hTP13 = parcelRequire("hTP13");
const $88e7ccc882e07762$export$c4c012a49b465e94 = (0, $6xToB.createEntry)((0, $hTP13.errorsNotFoundRoute), ()=>({
        group: 'errors',
        component: (0, $9BJU1.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9BJU1.LazyNotFoundErrorPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-errors-not-found-entries/src/errorsNotFoundRouteEntry.tsx',
                whichExportToUse: 'errorsNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hTP13", function(module, exports) {
$parcel$export(module.exports, "errorsNotFoundRoute", () => $11ca6d2fc3955dd4$export$465fa01c0f3a0551);
const $11ca6d2fc3955dd4$export$465fa01c0f3a0551 = {
    name: 'errors-not-found',
    path: '/jira/:projectType(software|servicedesk|core)'
};

});


parcelRegister("ksM4d", function(module, exports) {
$parcel$export(module.exports, "externalImportRouteEntry", () => $405b65f4bf032022$export$d55ce647d8216437);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dB6ZO = parcelRequire("dB6ZO");

var $5fjzQ = parcelRequire("5fjzQ");

var $fSjll = parcelRequire("fSjll");
const $405b65f4bf032022$export$d55ce647d8216437 = (0, $6xToB.createEntry)((0, $dB6ZO.externalImportRoute), ()=>({
        group: 'global-settings',
        component: (0, $fSjll.default),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-external-import-entries/src/externalImportRouteEntry.tsx',
                whichExportToUse: 'externalImportRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dB6ZO", function(module, exports) {
$parcel$export(module.exports, "externalImportRoute", () => $235145e3e8943ed5$export$17c79100fc4c65a1);
const $235145e3e8943ed5$export$17c79100fc4c65a1 = {
    name: 'external-import',
    path: '/jira/settings/system/external-import'
};

});

parcelRegister("fSjll", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3d2125bcfbad4a4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d3d2125bcfbad4a4$var$LazyExternalImport = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kg9kW")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
const $d3d2125bcfbad4a4$var$AsyncExternalImport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d3d2125bcfbad4a4$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });
var $d3d2125bcfbad4a4$export$2e2bcd8739ae039 = $d3d2125bcfbad4a4$var$AsyncExternalImport;

});
parcelRegister("kg9kW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3yAl4"),
    $ewTvA("21Nd9")
]).then(()=>parcelRequire('daUrk'));

});



parcelRegister("czFX6", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", () => $f769615681996eec$export$41fb3f2a3e68c7c3);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $jBMV2 = parcelRequire("jBMV2");

var $9NmsS = parcelRequire("9NmsS");

var $2mMik = parcelRequire("2mMik");

var $iMFdk = parcelRequire("iMFdk");

var $alJZi = parcelRequire("alJZi");
const $f769615681996eec$export$41fb3f2a3e68c7c3 = (0, $6xToB.createEntry)((0, $2mMik.filtersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $jBMV2.filtersDirectoryResource)
        ],
        component: !false ? (0, $alJZi.FiltersDirectoryRedirect) : (0, $alJZi.FiltersDirectoryComponent),
        skeleton: (0, $iMFdk.FiltersDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $alJZi.LazyFiltersDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/filtersDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'filtersDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jBMV2", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryResource", () => $f1677d54c5a99941$export$53f99086c62225b6);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");


const $f1677d54c5a99941$export$53f99086c62225b6 = (0, $l1VxS.createResource)({
    type: (0, $7a54c23c1a218244$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1a9jk")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
const $7a54c23c1a218244$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("1a9jk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("edTcR").then(()=>parcelRequire('1hTxv'));

});


parcelRegister("2mMik", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $b7c4dec64890edd4$export$f4f86e1ddc30a625);
const $b7c4dec64890edd4$export$f4f86e1ddc30a625 = {
    name: 'filters-directory-redirect',
    path: '/ManageFilters.jspa'
};

});

parcelRegister("alJZi", function(module, exports) {
$parcel$export(module.exports, "FiltersDirectoryRedirect", () => $d2566f6145a43912$export$c56e739d3bb1fe19);
$parcel$export(module.exports, "LazyFiltersDirectory", () => $d2566f6145a43912$export$cc133cd5c6f1b69d);
$parcel$export(module.exports, "FiltersDirectoryComponent", () => $d2566f6145a43912$export$e5d735e83dacb7c7);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");
const $d2566f6145a43912$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/filters"
    });

const $d2566f6145a43912$export$cc133cd5c6f1b69d = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lpKj1"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $d2566f6145a43912$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d2566f6145a43912$export$cc133cd5c6f1b69d,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("lpKj1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("5GJST")
]).then(()=>parcelRequire('8vvws'));

});



parcelRegister("keKPA", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRouteEntry", () => $5b102addf0af494c$export$ca77bc660994f51f);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $jBMV2 = parcelRequire("jBMV2");

var $9NmsS = parcelRequire("9NmsS");

var $bxSuo = parcelRequire("bxSuo");

var $iMFdk = parcelRequire("iMFdk");

var $alJZi = parcelRequire("alJZi");
const $5b102addf0af494c$export$ca77bc660994f51f = (0, $6xToB.createEntry)((0, $bxSuo.filtersDirectoryRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $jBMV2.filtersDirectoryResource)
        ],
        component: (0, $alJZi.FiltersDirectoryComponent),
        skeleton: (0, $iMFdk.FiltersDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $alJZi.LazyFiltersDirectory)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/filtersDirectoryRouteEntry.tsx',
                whichExportToUse: 'filtersDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("437TO", function(module, exports) {
$parcel$export(module.exports, "findAppsRouteEntry", () => $5c14761a914993f2$export$422f564c9c56a4f8);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $63mGD = parcelRequire("63mGD");

var $ixFkc = parcelRequire("ixFkc");
const $5c14761a914993f2$export$422f564c9c56a4f8 = (0, $6xToB.createEntry)((0, $63mGD.findAppsRoute), ()=>({
        group: 'marketplace',
        component: (0, $ixFkc.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ixFkc.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-marketplace-entries/src/findAppsRouteEntry.tsx',
                whichExportToUse: 'findAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("63mGD", function(module, exports) {
$parcel$export(module.exports, "findAppsRoute", () => $6ffd6d796f0895d5$export$e264ef643451c60a);
const $6ffd6d796f0895d5$export$e264ef643451c60a = {
    name: 'marketplace-index',
    path: '/jira/marketplace'
};

});


parcelRegister("6HVt9", function(module, exports) {
$parcel$export(module.exports, "forgeAdminRouteEntry", () => $c768b8f60c08a6f3$export$9e57f00c65d37e11);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dJrIK = parcelRequire("dJrIK");

var $bwe90 = parcelRequire("bwe90");
const $c768b8f60c08a6f3$export$9e57f00c65d37e11 = (0, $6xToB.createEntry)((0, $dJrIK.forgeAdminRoute), ()=>({
        component: (0, $bwe90.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwe90.LazyForgeAdminPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeAdminRouteEntry.tsx',
                whichExportToUse: 'forgeAdminRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dJrIK", function(module, exports) {
$parcel$export(module.exports, "forgeAdminRoute", () => $86cbf649ecb40238$export$157f97e6454c2a9f);
const $86cbf649ecb40238$export$157f97e6454c2a9f = {
    name: 'forge-spa-admin',
    path: '/jira/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bwe90", function(module, exports) {
$parcel$export(module.exports, "LazyForgeAdminPage", () => $fdaa0f262cc8cd3b$export$66ee65dcd4a6458d);
$parcel$export(module.exports, "default", () => $fdaa0f262cc8cd3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fdaa0f262cc8cd3b$export$66ee65dcd4a6458d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1jo9T")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $fdaa0f262cc8cd3b$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fdaa0f262cc8cd3b$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $fdaa0f262cc8cd3b$export$2e2bcd8739ae039 = $fdaa0f262cc8cd3b$export$c9e5f500ef472147;

});
parcelRegister("1jo9T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("brrrb").then(()=>parcelRequire('fKvyc'));

});



parcelRegister("7RQxY", function(module, exports) {
$parcel$export(module.exports, "forgeAdminSettingsRouteEntry", () => $18283900414ceb01$export$ea8439aa1b4afbb2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jWLr7 = parcelRequire("jWLr7");

var $bwe90 = parcelRequire("bwe90");
const $18283900414ceb01$export$ea8439aa1b4afbb2 = (0, $6xToB.createEntry)((0, $jWLr7.forgeAdminSettingsRoute), ()=>({
        component: (0, $bwe90.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwe90.LazyForgeAdminPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeAdminSettingsRouteEntry.tsx',
                whichExportToUse: 'forgeAdminSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jWLr7", function(module, exports) {
$parcel$export(module.exports, "forgeAdminSettingsRoute", () => $fbbfaf5995f770ab$export$392534a80a0b9b11);
const $fbbfaf5995f770ab$export$392534a80a0b9b11 = {
    name: 'forge-spa-admin-settings',
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};

});


parcelRegister("5ZQVr", function(module, exports) {
$parcel$export(module.exports, "forgeFieldContextualConfigurationRouteEntry", () => $28fbac4ae560480e$export$425186ecf36e93c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $gZbmE = parcelRequire("gZbmE");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6aUfx = parcelRequire("6aUfx");

var $kf1MW = parcelRequire("kf1MW");
const $28fbac4ae560480e$export$425186ecf36e93c = (0, $6xToB.createEntry)((0, $6aUfx.forgeFieldContextualConfigurationRoute), ()=>({
        component: (0, $kf1MW.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $hHbzj.forgeCustomFieldTypeResource),
            (0, $gZbmE.fieldContextConfigPageResource),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kf1MW.LazyForgeFieldContextConfigPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeFieldContextualConfigurationRouteEntry.tsx',
                whichExportToUse: 'forgeFieldContextualConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8XpuN", function(module, exports) {
$parcel$export(module.exports, "default", () => $69f3a4d32478eb00$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $69f3a4d32478eb00$var$LazyGlobalIssuesSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("4XOQF")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
const $69f3a4d32478eb00$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69f3a4d32478eb00$var$LazyGlobalIssuesSettingsSidebar, null)));
var $69f3a4d32478eb00$export$2e2bcd8739ae039 = $69f3a4d32478eb00$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("4XOQF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("4r1UM")
]).then(()=>parcelRequire('jlQix'));

});


parcelRegister("gZbmE", function(module, exports) {
$parcel$export(module.exports, "fieldContextConfigPageResource", () => $daea4e0f7e27674b$export$686a607053a18611);

var $l1VxS = parcelRequire("l1VxS");


const $daea4e0f7e27674b$export$686a607053a18611 = (0, $l1VxS.createResource)({
    type: (0, $cf50a866b7d0e879$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("5Idj5")),
    maxAge: 5000
});

});
const $cf50a866b7d0e879$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("5Idj5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8haKM").then(()=>parcelRequire('khZod'));

});


parcelRegister("6aUfx", function(module, exports) {
$parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", () => $a35ead35515b7f91$export$2ee4468dd8e9636f);
const $a35ead35515b7f91$export$2ee4468dd8e9636f = {
    name: 'forge-spa-field-context-config',
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};

});

parcelRegister("kf1MW", function(module, exports) {
$parcel$export(module.exports, "LazyForgeFieldContextConfigPage", () => $8e1e953397428d8f$export$c53e206c7fd6fb76);
$parcel$export(module.exports, "default", () => $8e1e953397428d8f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8e1e953397428d8f$export$c53e206c7fd6fb76 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jnMUR")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $8e1e953397428d8f$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8e1e953397428d8f$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $8e1e953397428d8f$export$2e2bcd8739ae039 = $8e1e953397428d8f$export$50bd0baee0b2f946;

});
parcelRegister("jnMUR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1JgW0").then(()=>parcelRequire('6Tbkh'));

});



parcelRegister("1PFei", function(module, exports) {
$parcel$export(module.exports, "forgeGlobalRouteEntry", () => $0b2b5957b5ab469d$export$68b00eede5bc25e6);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $fzU9D = parcelRequire("fzU9D");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $fXVLW = parcelRequire("fXVLW");

var $fkt3o = parcelRequire("fkt3o");
const $0b2b5957b5ab469d$export$68b00eede5bc25e6 = (0, $6xToB.createEntry)((0, $fXVLW.forgeGlobalRoute), ()=>({
        component: (0, $fkt3o.default),
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $fzU9D.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fkt3o.LazyForgeGlobalPage)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeGlobalRouteEntry.tsx',
                whichExportToUse: 'forgeGlobalRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fzU9D", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf0326ad75688b34$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $bf0326ad75688b34$var$LazyForPaintForgeGlobalPageSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("hbt11")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
const $bf0326ad75688b34$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf0326ad75688b34$var$LazyForPaintForgeGlobalPageSidebar, null)));
$bf0326ad75688b34$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $bf0326ad75688b34$export$2e2bcd8739ae039 = $bf0326ad75688b34$var$ForgeGlobalPageSidebar;

});
parcelRegister("hbt11", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kMGo6").then(()=>parcelRequire('46KFl'));

});


parcelRegister("fXVLW", function(module, exports) {
$parcel$export(module.exports, "forgeGlobalRoute", () => $d37f9dc9fdd24009$export$4146dba061d1c72d);
const $d37f9dc9fdd24009$export$4146dba061d1c72d = {
    name: 'forge-spa-global',
    path: '/jira/apps/:appId/:envId/:route?'
};

});

parcelRegister("fkt3o", function(module, exports) {
$parcel$export(module.exports, "LazyForgeGlobalPage", () => $42640cb09091dc2b$export$332293feb5cffd72);
$parcel$export(module.exports, "default", () => $42640cb09091dc2b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $42640cb09091dc2b$export$332293feb5cffd72 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jW5pd")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $42640cb09091dc2b$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $42640cb09091dc2b$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $42640cb09091dc2b$export$2e2bcd8739ae039 = $42640cb09091dc2b$export$4c36a7b018e5e5cc;

});
parcelRegister("jW5pd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5xERA").then(()=>parcelRequire('1J3S4'));

});



parcelRegister("11NnB", function(module, exports) {
$parcel$export(module.exports, "forgePersonalSettingsRouteEntry", () => $644ab9063c66de4e$export$bcf4a0e471a2493d);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2e4qA = parcelRequire("2e4qA");

var $azbTY = parcelRequire("azbTY");
const $644ab9063c66de4e$export$bcf4a0e471a2493d = (0, $6xToB.createEntry)((0, $2e4qA.forgePersonalSettingsRoute), ()=>({
        component: (0, $azbTY.default),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $azbTY.LazyForgePersonalSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgePersonalSettingsRouteEntry.tsx',
                whichExportToUse: 'forgePersonalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2e4qA", function(module, exports) {
$parcel$export(module.exports, "forgePersonalSettingsRoute", () => $9d2b8bb79f84d5f0$export$8cf022892f01dc88);
const $9d2b8bb79f84d5f0$export$8cf022892f01dc88 = {
    name: 'forge-spa-personal-settings',
    path: '/jira/settings/personal/apps/:appId/:envId/:route?'
};

});

parcelRegister("azbTY", function(module, exports) {
$parcel$export(module.exports, "LazyForgePersonalSettingsPage", () => $3a0226e7a1a791e6$export$984c6340ff981792);
$parcel$export(module.exports, "default", () => $3a0226e7a1a791e6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3a0226e7a1a791e6$export$984c6340ff981792 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1jvrs")), {
    moduleId: "./src/packages/spa-apps/forge/personal-settings/src/index.tsx"
});
const $3a0226e7a1a791e6$export$fb659fde7fa91075 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3a0226e7a1a791e6$export$984c6340ff981792,
        pageId: "forge-spa-personal-settings",
        shouldShowSpinner: true
    });
var $3a0226e7a1a791e6$export$2e2bcd8739ae039 = $3a0226e7a1a791e6$export$fb659fde7fa91075;

});
parcelRegister("1jvrs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kFFBo").then(()=>parcelRequire('cJxZP'));

});



parcelRegister("gRPtE", function(module, exports) {
$parcel$export(module.exports, "forgeProjectRouteEntry", () => $390fd685a1011595$export$1ed77617605af86d);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $bTfc4 = parcelRequire("bTfc4");

var $1tU1R = parcelRequire("1tU1R");

var $jDBnR = parcelRequire("jDBnR");
const $390fd685a1011595$export$1ed77617605af86d = (0, $6xToB.createEntry)((0, $1tU1R.forgeProjectRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $jDBnR.forgeProjectPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeProjectRouteEntry.tsx',
                whichExportToUse: 'forgeProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1tU1R", function(module, exports) {
$parcel$export(module.exports, "forgeProjectRoute", () => $a297ebf60add814e$export$998d01fc8f4c3224);
const $a297ebf60add814e$export$998d01fc8f4c3224 = {
    name: 'forge-spa-project',
    path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("jDBnR", function(module, exports) {
$parcel$export(module.exports, "forgeProjectPageEntrypoint", () => $59eba036dbc12336$export$74e6ff15060a7efe);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9OhlI = parcelRequire("9OhlI");

var $9n5I0 = parcelRequire("9n5I0");
const $59eba036dbc12336$export$74e6ff15060a7efe = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9OhlI.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9OhlI", function(module, exports) {
$parcel$export(module.exports, "forgeProjectEntrypoint", () => $eccabc7b5ea24861$export$109bb60f5ed960e9);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $eccabc7b5ea24861$export$109bb60f5ed960e9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hcLIp")), {
        moduleId: "a42399f5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                match: context.match
            }
        })
});

});
parcelRegister("hcLIp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aArcw").then(()=>parcelRequire('eDZUG'));

});




parcelRegister("4xmZV", function(module, exports) {
$parcel$export(module.exports, "forgeProjectServicedeskRouteEntry", () => $a4349ddee4ad74de$export$6732bea56e68d0b4);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $bTfc4 = parcelRequire("bTfc4");

var $34SPF = parcelRequire("34SPF");

var $89EYK = parcelRequire("89EYK");
const $a4349ddee4ad74de$export$6732bea56e68d0b4 = (0, $6xToB.createEntry)((0, $34SPF.forgeProjectServicedeskRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $89EYK.forgeProjectServicedeskPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeProjectServicedeskRouteEntry.tsx',
                whichExportToUse: 'forgeProjectServicedeskRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("34SPF", function(module, exports) {
$parcel$export(module.exports, "forgeProjectServicedeskRoute", () => $fcae3112c20bfc77$export$8b83928f9f21e11);
const $fcae3112c20bfc77$export$8b83928f9f21e11 = {
    name: 'forge-spa-project-servicedesk',
    path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("89EYK", function(module, exports) {
$parcel$export(module.exports, "forgeProjectServicedeskPageEntrypoint", () => $f2f8c0e8c5c9b8ab$export$eae71fd9c3e0166a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9OhlI = parcelRequire("9OhlI");
const $f2f8c0e8c5c9b8ab$export$eae71fd9c3e0166a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9OhlI.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("bv6P6", function(module, exports) {
$parcel$export(module.exports, "forgeServicedeskQueueRouteEntry", () => $17a924e571fb638f$export$1486fc4f85c1237);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dpkla = parcelRequire("dpkla");

var $aQoXd = parcelRequire("aQoXd");

var $034mL = parcelRequire("034mL");
const $17a924e571fb638f$export$1486fc4f85c1237 = (0, $6xToB.createEntry)((0, $dpkla.forgeServicedeskQueueRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $034mL.forgeServiceDeskQueuePageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-forge-entries/src/forgeServicedeskQueueRouteEntry.tsx',
                whichExportToUse: 'forgeServicedeskQueueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dpkla", function(module, exports) {
$parcel$export(module.exports, "forgeServicedeskQueueRoute", () => $6fe3936aea0f5c85$export$b77275b989ab42a6);
const $6fe3936aea0f5c85$export$b77275b989ab42a6 = {
    name: 'forge-spa-servicedesk-queue',
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};

});

parcelRegister("034mL", function(module, exports) {
$parcel$export(module.exports, "forgeServiceDeskQueuePageEntrypoint", () => $2985510ba8e89b49$export$e50db2ee9d53508e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bkUuj = parcelRequire("bkUuj");
const $2985510ba8e89b49$export$e50db2ee9d53508e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bkUuj.forgeServiceDeskEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("bkUuj", function(module, exports) {
$parcel$export(module.exports, "forgeServiceDeskEntrypoint", () => $54fbdd32032aa554$export$5f56161124a4cb21);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $54fbdd32032aa554$export$5f56161124a4cb21 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("6soqZ")), {
        moduleId: "70dc4c33",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6soqZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ckY9W").then(()=>parcelRequire('f9hBa'));

});




parcelRegister("lGtFG", function(module, exports) {
$parcel$export(module.exports, "generalPersonalSettingsRouteEntry", () => $87150ee752e36ecd$export$e8b7e9281fc3db35);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $4wyu4 = parcelRequire("4wyu4");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2hhQE = parcelRequire("2hhQE");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $87150ee752e36ecd$var$LazyGeneralPersonalSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ewOnS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});
const $87150ee752e36ecd$var$GeneralPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $87150ee752e36ecd$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $87150ee752e36ecd$export$e8b7e9281fc3db35 = (0, $6xToB.createEntry)((0, $4wyu4.generalPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $87150ee752e36ecd$var$GeneralPersonalSettingsComponent,
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $2hhQE.getLabsResources)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $87150ee752e36ecd$var$LazyGeneralPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-personal-settings-entries/src/generalPersonalSettingsRouteEntry.tsx',
                whichExportToUse: 'generalPersonalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4wyu4", function(module, exports) {
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $15328041019aaf7d$export$7a6c9715a86f906b);
const $15328041019aaf7d$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("2hhQE", function(module, exports) {
$parcel$export(module.exports, "getLabsResources", () => $cf2fc41aa5d1a754$export$18345571aa12a367);

var $lopBx = parcelRequire("lopBx");

var $5zQIb = parcelRequire("5zQIb");

var $b8mPY = parcelRequire("b8mPY");

var $5L7qx = parcelRequire("5L7qx");
const $cf2fc41aa5d1a754$export$18345571aa12a367 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $lopBx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource))
    ];

});

parcelRegister("ewOnS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1KVRQ").then(()=>parcelRequire('1QmuW'));

});


parcelRegister("ilnMG", function(module, exports) {
$parcel$export(module.exports, "globalEscalationsRouteEntry", () => $62f604aabcc4e3aa$export$adde4536d8e5f94c);

var $eJOHy = parcelRequire("eJOHy");

var $grioT = parcelRequire("grioT");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9m8pQ = parcelRequire("9m8pQ");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $62f604aabcc4e3aa$var$LazyGlobalEscalations = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("i27wp")).then((module)=>module.GlobalEscalationsPage), {
    moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
});
const $62f604aabcc4e3aa$var$GlobalEscalationsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $62f604aabcc4e3aa$var$LazyGlobalEscalations,
        pageId: "async-jira-eoc-global-escalations",
        shouldShowSpinner: false
    });
const $62f604aabcc4e3aa$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $62f604aabcc4e3aa$export$adde4536d8e5f94c = (0, $6xToB.createEntry)((0, $9m8pQ.globalEscalationsRoute), ()=>({
        group: 'eoc',
        component: $62f604aabcc4e3aa$var$GlobalEscalationsComponent,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $grioT.globalEscalationsListInfoResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$62f604aabcc4e3aa$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            $62f604aabcc4e3aa$var$LazyGlobalEscalations
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            $62f604aabcc4e3aa$var$LazyGlobalEscalations
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-global-escalations-entries/src/globalEscalationsRouteEntry.tsx',
                whichExportToUse: 'globalEscalationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("grioT", function(module, exports) {
$parcel$export(module.exports, "globalEscalationsListInfoResource", () => $f14831e2d768789a$export$bffddc002dadaf3a);

var $l1VxS = parcelRequire("l1VxS");

var $cNK5F = parcelRequire("cNK5F");
const $f14831e2d768789a$export$bffddc002dadaf3a = (0, $l1VxS.createResource)({
    type: 'globalEscalationsListInfoResource',
    getKey: ()=>'globalEscalationsListInfoResource',
    getData: (0, $cNK5F.getListInfo),
    isBrowserOnly: true
});

});
parcelRegister("cNK5F", function(module, exports) {
$parcel$export(module.exports, "getEscalations", () => $40fba732f73ba804$export$300727380b60aeb4);
$parcel$export(module.exports, "getListInfo", () => $40fba732f73ba804$export$bdc8fe7d9cd263b);

var $9ppkU = parcelRequire("9ppkU");
const $40fba732f73ba804$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
    const [, filtersString] = queryKey;
    const filters = JSON.parse(filtersString);
    const params = new URLSearchParams({
        ...filters,
        lastEvaluatedToken: lastEvaluatedToken
    });
    return (0, $9ppkU.eocFetch)(`/v1/escalations/search?${params.toString()}`);
};
const $40fba732f73ba804$export$bdc8fe7d9cd263b = ()=>{
    return (0, $9ppkU.eocFetch)('/v1/escalations/list-info');
};

});


parcelRegister("9m8pQ", function(module, exports) {
$parcel$export(module.exports, "globalEscalationsRoute", () => $1d1c75ae70e67e71$export$9ed12f6fa845edfb);
const $1d1c75ae70e67e71$export$9ed12f6fa845edfb = {
    name: 'eoc-global-escalations',
    path: '/jira/settings/products/ops/escalation-policies',
    exact: true
};

});

parcelRegister("i27wp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("5whKV")
]).then(()=>parcelRequire('8KP6j'));

});


parcelRegister("3baNr", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallDetailRouteEntry", () => $f08f7ccd78bddc66$export$39f40714591c98c0);

var $eJOHy = parcelRequire("eJOHy");

var $4vIoS = parcelRequire("4vIoS");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $7ZvEb = parcelRequire("7ZvEb");

var $1F9cm = parcelRequire("1F9cm");

var $3BFKs = parcelRequire("3BFKs");
const $f08f7ccd78bddc66$var$IncomingCallDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $3BFKs.LazyIncomingCallDetail),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $f08f7ccd78bddc66$export$39f40714591c98c0 = (0, $6xToB.createEntry)((0, $7ZvEb.globalIncomingCallDetailRoute), ()=>({
        group: 'eoc',
        component: $f08f7ccd78bddc66$var$IncomingCallDetail,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4vIoS.detailResources)()
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3BFKs.LazyIncomingCall)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-incoming-call-entries/src/globalIncomingCallDetailRouteEntry.tsx',
                whichExportToUse: 'globalIncomingCallDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4vIoS", function(module, exports) {
$parcel$export(module.exports, "listResources", () => $4cc3e6fe27145912$export$c83d9fd41123ab31);
$parcel$export(module.exports, "detailResources", () => $4cc3e6fe27145912$export$63630293105c0f4e);

var $7JaiF = parcelRequire("7JaiF");

var $bTMTe = parcelRequire("bTMTe");
const $4cc3e6fe27145912$export$c83d9fd41123ab31 = ()=>[
        (0, $bTMTe.listResource)
    ];
const $4cc3e6fe27145912$export$63630293105c0f4e = ()=>[
        (0, $7JaiF.detailResource)
    ];

});
parcelRegister("7JaiF", function(module, exports) {
$parcel$export(module.exports, "detailResource", () => $e1bbfc105f91d976$export$13d78d45f8054f1e);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $eQBzT = parcelRequire("eQBzT");
const $e1bbfc105f91d976$export$13d78d45f8054f1e = (0, $l1VxS.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $cyz90.assert)(!!id, new (0, $gLoFN.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $eQBzT.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("eQBzT", function(module, exports) {
$parcel$export(module.exports, "getDetail", () => $0e2ad87105332092$export$d6c3faeb2ce9d297);

var $9ppkU = parcelRequire("9ppkU");

var $7ihlh = parcelRequire("7ihlh");
const $0e2ad87105332092$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $7ihlh.urls).incomingCall.detail.url(id)}`;
    return (0, $9ppkU.eocFetch)(endpoint);
};

});
parcelRegister("7ihlh", function(module, exports) {
$parcel$export(module.exports, "urls", () => $6af025ffe300d74c$export$bcae9ba627f604b6);
const $6af025ffe300d74c$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$6af025ffe300d74c$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("bTMTe", function(module, exports) {
$parcel$export(module.exports, "listResource", () => $68cd7c04a27eac85$export$5ee018e9baf9d633);

var $b7Y7n = parcelRequire("b7Y7n");

var $5xmjd = parcelRequire("5xmjd");
const $68cd7c04a27eac85$export$5ee018e9baf9d633 = (0, $b7Y7n.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $5xmjd.getList),
    isBrowserOnly: true
});

});
parcelRegister("b7Y7n", function(module, exports) {
$parcel$export(module.exports, "createPaginatedResource", () => $8a00587ec3366992$export$561b032e4d26d1e8);

var $l1VxS = parcelRequire("l1VxS");
const $8a00587ec3366992$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $l1VxS.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("5xmjd", function(module, exports) {
$parcel$export(module.exports, "getList", () => $fd4335dee3adb1c6$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $fd4335dee3adb1c6$export$cdae09ff00c893b2);

var $9ppkU = parcelRequire("9ppkU");

var $7ihlh = parcelRequire("7ihlh");
const $fd4335dee3adb1c6$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $7ihlh.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $9ppkU.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $fd4335dee3adb1c6$export$cdae09ff00c893b2 = (params)=>{
    return (0, $9ppkU.eocFetch)((0, $7ihlh.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});



parcelRegister("7ZvEb", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallDetailRoute", () => $54aa78d434702576$export$10f19333da6ac52c);
const $54aa78d434702576$export$10f19333da6ac52c = {
    name: 'eoc-incoming-call-detail',
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};

});

parcelRegister("3BFKs", function(module, exports) {
$parcel$export(module.exports, "LazyIncomingCall", () => $e5362cebd43bef8f$export$d76e6607b7e88a7b);
$parcel$export(module.exports, "LazyIncomingCallDetail", () => $e5362cebd43bef8f$export$1c56f2b1fdd5d724);

var $bQWwW = parcelRequire("bQWwW");

const $e5362cebd43bef8f$export$d76e6607b7e88a7b = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1O6bQ")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $e5362cebd43bef8f$export$1c56f2b1fdd5d724 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1O6bQ")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

});
parcelRegister("1O6bQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("djEoP").then(()=>parcelRequire('d2zX5'));

});



parcelRegister("fuBQx", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallRouteEntry", () => $f970485e84ffcf64$export$bf8ccc758901febd);

var $eJOHy = parcelRequire("eJOHy");

var $4vIoS = parcelRequire("4vIoS");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $95K6m = parcelRequire("95K6m");

var $1F9cm = parcelRequire("1F9cm");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $3BFKs = parcelRequire("3BFKs");
const $f970485e84ffcf64$var$IncomingCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $3BFKs.LazyIncomingCall),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $f970485e84ffcf64$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $f970485e84ffcf64$export$bf8ccc758901febd = (0, $6xToB.createEntry)((0, $95K6m.globalIncomingCallRoute), ()=>({
        group: 'eoc',
        component: $f970485e84ffcf64$var$IncomingCall,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4vIoS.listResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$f970485e84ffcf64$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3BFKs.LazyIncomingCall)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3BFKs.LazyIncomingCall)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-incoming-call-entries/src/globalIncomingCallRouteEntry.tsx',
                whichExportToUse: 'globalIncomingCallRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("95K6m", function(module, exports) {
$parcel$export(module.exports, "globalIncomingCallRoute", () => $b6754300df67400a$export$8dd2e8adca05d8a3);
const $b6754300df67400a$export$8dd2e8adca05d8a3 = {
    name: 'eoc-incoming-call',
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};

});


parcelRegister("4Bcd1", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationCreateRouteEntry", () => $4da23ddd245f4fa9$export$62eef9a2917f041f);

var $37Rs8 = parcelRequire("37Rs8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $8ivmo = parcelRequire("8ivmo");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $9bIMK = parcelRequire("9bIMK");

var $cbgXG = parcelRequire("cbgXG");

var $h5q0o = parcelRequire("h5q0o");
const $4da23ddd245f4fa9$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4da23ddd245f4fa9$export$62eef9a2917f041f = (0, $6xToB.createEntry)((0, $8ivmo.globalIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $cbgXG.IntegrationCreate),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).integrationListResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$4da23ddd245f4fa9$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/globalIntegrationCreateRouteEntry.tsx',
                whichExportToUse: 'globalIntegrationCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("37Rs8", function(module, exports) {
$parcel$export(module.exports, "resources", () => $8b880bd82f844688$export$bc99aaabaf7b70a7);

var $jcpAh = parcelRequire("jcpAh");

var $49UFU = parcelRequire("49UFU");

var $iO6RH = parcelRequire("iO6RH");
const $8b880bd82f844688$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $jcpAh.configuredIntegrationsResource,
    integrationListResource: $49UFU.integrationListResource,
    userAccessRightsResource: $iO6RH.userAccessRightsResource
};

});
parcelRegister("jcpAh", function(module, exports) {
$parcel$export(module.exports, "configuredIntegrationsResource", () => $df641a9e145a587a$export$4136019b80be5917);

var $l1VxS = parcelRequire("l1VxS");

var $7AcIz = parcelRequire("7AcIz");

var $9V1cD = parcelRequire("9V1cD");

const $df641a9e145a587a$export$4136019b80be5917 = (0, $l1VxS.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $7AcIz.UrlHelper)((0, $9ebb23cba40c3de9$export$bc7daa294a7c75e4), {
            [(0, $9ebb23cba40c3de9$export$d26137cf824a9e53)]: page,
            [(0, $9ebb23cba40c3de9$export$299579ccbdd63cbc)]: keyword,
            [(0, $9ebb23cba40c3de9$export$d7415cfdee4bffc8)]: group,
            [(0, $9ebb23cba40c3de9$export$ce2c93e90dda8613)]: status,
            [(0, $9ebb23cba40c3de9$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $9V1cD.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("7AcIz", function(module, exports) {
$parcel$export(module.exports, "UrlHelper", () => $5480290b917d149a$export$bacbc496e850c0a4);
const $5480290b917d149a$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("9V1cD", function(module, exports) {
$parcel$export(module.exports, "default", () => $05da73a9d0d0038b$export$2e2bcd8739ae039);

var $9ppkU = parcelRequire("9ppkU");

var $7AcIz = parcelRequire("7AcIz");

const $05da73a9d0d0038b$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $cfe107ae3df37211$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $9ppkU.eocFetch)((0, $7AcIz.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $cfe107ae3df37211$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $cfe107ae3df37211$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $05da73a9d0d0038b$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $9ppkU.eocFetch)((0, $7AcIz.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $05da73a9d0d0038b$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $9ppkU.eocFetch)((0, $7AcIz.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $05da73a9d0d0038b$export$2e2bcd8739ae039 = {
    getIntegrations: $05da73a9d0d0038b$var$getIntegrations,
    patchIntegration: $05da73a9d0d0038b$var$patchIntegration,
    deleteIntegration: $05da73a9d0d0038b$var$deleteIntegration
};

});
const $cfe107ae3df37211$export$31ecae7225aecec6 = 20;


const $9ebb23cba40c3de9$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $9ebb23cba40c3de9$export$d26137cf824a9e53 = 'page';
const $9ebb23cba40c3de9$export$299579ccbdd63cbc = 'keyword';
const $9ebb23cba40c3de9$export$d7415cfdee4bffc8 = 'group';
const $9ebb23cba40c3de9$export$ce2c93e90dda8613 = 'status';
const $9ebb23cba40c3de9$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("49UFU", function(module, exports) {
$parcel$export(module.exports, "integrationListResource", () => $c05ffd5a5a92a9fb$export$f60a40a11a6e0ee4);

var $l1VxS = parcelRequire("l1VxS");

var $3paoK = parcelRequire("3paoK");
const $c05ffd5a5a92a9fb$export$f60a40a11a6e0ee4 = (0, $l1VxS.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $3paoK.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("3paoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $54ae5d53a585a068$export$2e2bcd8739ae039);

var $9ppkU = parcelRequire("9ppkU");

var $7AcIz = parcelRequire("7AcIz");
const $54ae5d53a585a068$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $9ppkU.eocFetch)((0, $7AcIz.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $54ae5d53a585a068$var$getIntegrationTypes = (integrationType, teamId)=>(0, $9ppkU.eocFetch)((0, $7AcIz.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $54ae5d53a585a068$export$2e2bcd8739ae039 = {
    getIntegrationList: $54ae5d53a585a068$var$getIntegrationList,
    getIntegrationTypes: $54ae5d53a585a068$var$getIntegrationTypes
};

});


parcelRegister("iO6RH", function(module, exports) {
$parcel$export(module.exports, "userAccessRightsResource", () => $488006a535435e84$export$69ddc7cc64ae9a02);

var $l1VxS = parcelRequire("l1VxS");

var $9sgEF = parcelRequire("9sgEF");
const $488006a535435e84$export$69ddc7cc64ae9a02 = (0, $l1VxS.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $9sgEF.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("9sgEF", function(module, exports) {
$parcel$export(module.exports, "getUserRights", () => $625b8becc3d45949$export$84e2ed279bc4e64e);

var $9ppkU = parcelRequire("9ppkU");

var $7AcIz = parcelRequire("7AcIz");
const $625b8becc3d45949$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $9ppkU.eocFetch)((0, $7AcIz.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("8ivmo", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationCreateRoute", () => $36d368c7f57a8f21$export$bb272d36e3c3b7c1);
const $36d368c7f57a8f21$export$bb272d36e3c3b7c1 = {
    name: 'eoc-integration-create',
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};

});

parcelRegister("9bIMK", function(module, exports) {
$parcel$export(module.exports, "IntegrationAutomation", () => $a6465774f50a1840$export$434c3e2269913ac0);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $a6465774f50a1840$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationAutomation),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("h5q0o", function(module, exports) {
$parcel$export(module.exports, "LazyIntegrationAutomation", () => $4f1e56f6e7b802ad$export$68c40afda0287b61);
$parcel$export(module.exports, "LazyIntegrationDetail", () => $4f1e56f6e7b802ad$export$fd7f60e3df94c902);
$parcel$export(module.exports, "LazyIntegrationCreate", () => $4f1e56f6e7b802ad$export$aa9358ade7cb53ee);
$parcel$export(module.exports, "LazyIntegrationList", () => $4f1e56f6e7b802ad$export$993132b847f26efa);
$parcel$export(module.exports, "LazyIntegrationLog", () => $4f1e56f6e7b802ad$export$b02ef932401d95fc);

var $bQWwW = parcelRequire("bQWwW");

const $4f1e56f6e7b802ad$export$68c40afda0287b61 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("adyIf")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$fd7f60e3df94c902 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("adyIf")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$aa9358ade7cb53ee = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("adyIf")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$993132b847f26efa = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("adyIf")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $4f1e56f6e7b802ad$export$b02ef932401d95fc = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("adyIf")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

});
parcelRegister("adyIf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7dNJ4")
]).then(()=>parcelRequire('9rMVR'));

});



parcelRegister("cbgXG", function(module, exports) {
$parcel$export(module.exports, "IntegrationCreate", () => $e010794379d58299$export$5cb14595364f02c);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $e010794379d58299$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationCreate),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("flxCZ", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationDetailRouteEntry", () => $cfffd9007dcf9897$export$b66abbccbf93e9ad);

var $37Rs8 = parcelRequire("37Rs8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $8KL6m = parcelRequire("8KL6m");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $9bIMK = parcelRequire("9bIMK");

var $6M51H = parcelRequire("6M51H");

var $h5q0o = parcelRequire("h5q0o");
const $cfffd9007dcf9897$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $cfffd9007dcf9897$export$b66abbccbf93e9ad = (0, $6xToB.createEntry)((0, $8KL6m.globalIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $6M51H.IntegrationDetail),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$cfffd9007dcf9897$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/globalIntegrationDetailRouteEntry.tsx',
                whichExportToUse: 'globalIntegrationDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8KL6m", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationDetailRoute", () => $0687adc34b378b13$export$f826f15073eda98);
const $0687adc34b378b13$export$f826f15073eda98 = {
    name: 'eoc-integration-detail',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};

});

parcelRegister("6M51H", function(module, exports) {
$parcel$export(module.exports, "IntegrationDetail", () => $98be509013c42a08$export$8bb99f196e0be5b6);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $98be509013c42a08$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationDetail),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("k85NS", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationListRouteEntry", () => $abda72d2df4cfe5b$export$790602da39f8af00);

var $37Rs8 = parcelRequire("37Rs8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $idgsu = parcelRequire("idgsu");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $9bIMK = parcelRequire("9bIMK");

var $juImm = parcelRequire("juImm");

var $h5q0o = parcelRequire("h5q0o");
const $abda72d2df4cfe5b$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $abda72d2df4cfe5b$export$790602da39f8af00 = (0, $6xToB.createEntry)((0, $idgsu.globalIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $juImm.IntegrationList),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $37Rs8.resources).integrationListResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$abda72d2df4cfe5b$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/globalIntegrationListRouteEntry.tsx',
                whichExportToUse: 'globalIntegrationListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("idgsu", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationListRoute", () => $6aa01fe5cb8c3f87$export$270e16f240db883b);
const $6aa01fe5cb8c3f87$export$270e16f240db883b = {
    name: 'eoc-integration-list',
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};

});

parcelRegister("juImm", function(module, exports) {
$parcel$export(module.exports, "IntegrationList", () => $b07b6a309061e362$export$955768269b79c203);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $b07b6a309061e362$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationList),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("dyOQA", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationLogRouteEntry", () => $4cc5676159504c32$export$d30f51d0f351bd8a);

var $cVewO = parcelRequire("cVewO");

var $37Rs8 = parcelRequire("37Rs8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $lRIbV = parcelRequire("lRIbV");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $9bIMK = parcelRequire("9bIMK");

var $1MNgS = parcelRequire("1MNgS");

var $h5q0o = parcelRequire("h5q0o");
const $4cc5676159504c32$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4cc5676159504c32$export$d30f51d0f351bd8a = (0, $6xToB.createEntry)((0, $lRIbV.globalIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $1MNgS.IntegrationLog),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $cVewO.resources)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$4cc5676159504c32$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/globalIntegrationLogRouteEntry.tsx',
                whichExportToUse: 'globalIntegrationLogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lRIbV", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationLogRoute", () => $9c657a70c1412117$export$71884dc820e415fc);
const $9c657a70c1412117$export$71884dc820e415fc = {
    name: 'eoc-integration-log',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};

});

parcelRegister("1MNgS", function(module, exports) {
$parcel$export(module.exports, "IntegrationLog", () => $afbe360ff0e1c88d$export$b545b4a4c4cee016);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $h5q0o = parcelRequire("h5q0o");
const $afbe360ff0e1c88d$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $h5q0o.LazyIntegrationLog),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("898Bv", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationsRouteEntry", () => $65d7c81351596706$export$6e5cd6656076550f);

var $37Rs8 = parcelRequire("37Rs8");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $3xUgf = parcelRequire("3xUgf");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $h5q0o = parcelRequire("h5q0o");

var $9bIMK = parcelRequire("9bIMK");
const $65d7c81351596706$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $65d7c81351596706$export$6e5cd6656076550f = (0, $6xToB.createEntry)((0, $3xUgf.globalIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: null,
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$65d7c81351596706$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/globalIntegrationsRouteEntry.tsx',
                whichExportToUse: 'globalIntegrationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3xUgf", function(module, exports) {
$parcel$export(module.exports, "globalIntegrationsRoute", () => $09d9f5f57c193d36$export$e196ff2390a1ec56);
const $09d9f5f57c193d36$export$e196ff2390a1ec56 = {
    name: 'eoc-integrations',
    path: '/jira/settings/products/ops/integrations',
    exact: true
};

});


parcelRegister("2Z13m", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRouteEntry", () => $b78af05281889852$export$30f8c1a53605b10b);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $hbb1g = parcelRequire("hbb1g");

var $eznTg = parcelRequire("eznTg");


var $klAnQ = parcelRequire("klAnQ");

var $gAL0c = parcelRequire("gAL0c");

var $d4NVH = parcelRequire("d4NVH");

var $dq5jm = parcelRequire("dq5jm");

var $fYGKn = parcelRequire("fYGKn");
const $b78af05281889852$export$30f8c1a53605b10b = (0, $6xToB.createEntry)((0, $hbb1g.globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        component: (0, $dq5jm.default),
        skeleton: (0, $eznTg.GlobalIssueNavigatorSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fYGKn.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $klAnQ.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $gAL0c.getCommonGlobalResources)()
        ],
        layout: (0, $7h3uc.globalLayout),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/globalIssueNavigatorBrowseIssueRedirectRouteEntry.tsx',
                whichExportToUse: 'globalIssueNavigatorBrowseIssueRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hbb1g", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $a85677dacaa6e27c$export$34695dccebecc6bc);
const $a85677dacaa6e27c$export$34695dccebecc6bc = {
    name: 'global-issue-navigator-browse-issue-redirect',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("eznTg", function(module, exports) {
$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $9e9b8f436d40863b$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $idrOX = parcelRequire("idrOX");
const $9e9b8f436d40863b$var$customCssStyles = null;
const $9e9b8f436d40863b$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($idrOX))),
        className: (0, $hcewu.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("idrOX", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("klAnQ", function(module, exports) {
$parcel$export(module.exports, "getCommonGlobalNavigation", () => $2aaf8d60fbd6872f$export$2f31f4f387017d83);

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");
const $2aaf8d60fbd6872f$export$2f31f4f387017d83 = ()=>({
        menuId: (0, $5RW99.MENU_ID).FILTERS,
        sidebar: (0, $ftFEp.AsyncForPaintSidebarFiltersGlobal)
    });

});
parcelRegister("ftFEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $159719ac782bc91d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $159719ac782bc91d$export$7655c90db6341aa6);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

// Legacy GIN Sidebar
const $159719ac782bc91d$var$LazySidebarFiltersLegacy = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("8CAVd")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
const $159719ac782bc91d$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazySidebarFiltersLegacy, null)));
var $159719ac782bc91d$export$2e2bcd8739ae039 = $159719ac782bc91d$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $159719ac782bc91d$var$LazyAfterPaintSidebarFiltersGlobal = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("dJWms")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $159719ac782bc91d$var$LazyForPaintSidebarFiltersGlobal = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("dJWms")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $159719ac782bc91d$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $159719ac782bc91d$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("8CAVd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lfhFX")
]).then(()=>parcelRequire('6C8aj'));

});

parcelRegister("dJWms", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dn0w6")
]).then(()=>parcelRequire('6ItgB'));

});



parcelRegister("gAL0c", function(module, exports) {
$parcel$export(module.exports, "getCommonGlobalResources", () => $588d871c56f845a6$export$343e92405307cf8d);

var $4cTDP = parcelRequire("4cTDP");

var $dSkEC = parcelRequire("dSkEC");

var $8k1uC = parcelRequire("8k1uC");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $5L7qx = parcelRequire("5L7qx");

var $5nfTh = parcelRequire("5nfTh");
const $588d871c56f845a6$var$getAIContextPanelResourcesWithCondition = ()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025') ? [] : (0, $5nfTh.getAIContextPanelResources)();
const $588d871c56f845a6$export$343e92405307cf8d = ()=>[
        (0, $8k1uC.issueNavigatorRelayResource),
        (0, $8k1uC.issueNavigatorFilterRelayResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('nin_request_hydrate_query_earlier') && !(0, $4cTDP.fg)('render_jql_builder_in_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResourceBrowserOnly)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('render_jql_builder_in_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResource)),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $5L7qx.resourceWithCondition2)(// not used, removing
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $enHI7.navigationSidebarGlobalResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('nin_remove_global_scope_enrolment'), (0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource)),
        ...$588d871c56f845a6$var$getAIContextPanelResourcesWithCondition()
    ];

});
parcelRegister("dSkEC", function(module, exports) {
$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $d4b13795e146c70f$export$3f6390b4131d761b);

var $l1VxS = parcelRequire("l1VxS");

const $d4b13795e146c70f$var$getDataLoader = ()=>(parcelRequire("1XAnt"));
const $d4b13795e146c70f$export$3f6390b4131d761b = (0, $l1VxS.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $d4b13795e146c70f$var$getDataLoader
});

});
parcelRegister("1XAnt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7th2q").then(()=>parcelRequire('2Dq8O'));

});


parcelRegister("8k1uC", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorRelayResource", () => $ed0a4483fb669c9c$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $ed0a4483fb669c9c$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $ed0a4483fb669c9c$export$967ef0cfbd1cc946);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResourceBrowserOnly", () => $ed0a4483fb669c9c$export$2c98f9cf5d4c493e);
$parcel$export(module.exports, "issueNavigatorFilterRefinementRelayResource", () => $ed0a4483fb669c9c$export$b963a9a8713e35f3);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $4NoAT = parcelRequire("4NoAT");

var $cxKOj = parcelRequire("cxKOj");

var $82cqT = parcelRequire("82cqT");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $awWeA = parcelRequire("awWeA");

var $8oKDI = parcelRequire("8oKDI");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");

var $3w0Dj = parcelRequire("3w0Dj");

var $4mFQO = parcelRequire("4mFQO");

var $93W2w = parcelRequire("93W2w");

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");

var $9S9Cb = parcelRequire("9S9Cb");

var $kjRvu = parcelRequire("kjRvu");

var $2HIMw = parcelRequire("2HIMw");

var $lzktc = parcelRequire("lzktc");
const $ed0a4483fb669c9c$export$b4096f516fb93159 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ({ match: { params: { projectKey: projectKey } }, query: { filter: filter } })=>{
        if (projectKey) return `issue-navigator-relay-${projectKey}`;
        if (!(0, $4cTDP.fg)('nin_prevent_route_refresh_on_filter_change')) {
            const filterId = Boolean(filter) && (0, $82cqT.isFilterId)(filter) ? filter : null;
            if (filterId) return `issue-navigator-relay-${filterId}`;
        }
        return 'issue-navigator-relay';
    },
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter, groupBy: groupBy, hideDone: hideDone } = (0, $lzktc.getParams)(routerContext);
        const issueSearchInput = (0, $4cTDP.fg)('jira_nin_last_used_jql') ? (0, $lzktc.getIssueSearchInput)(defaultJql, jqlParam, filter, projectKey) : (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $iRahl.getMaxIssuesPerPage)();
        const chromelessRoute = (0, $lzktc.isChromelessRoute)(routerContext);
        let viewId;
        let shouldQueryConditionalFormatting = Boolean(projectKey);
        let isIFCEnabled = Boolean(projectKey);
        const filterId = Boolean(filter) && (0, $82cqT.isCustomFilter)(filter) ? filter : null;
        if (chromelessRoute) {
            // Disable conditional formatting for chromeless (i.e. embed) routes when saved views is disabled
            shouldQueryConditionalFormatting = (0, $4cTDP.fg)('saved_list_view_technical_changes');
            // Disable IFC for chromeless (i.e. embed) routes
            isIFCEnabled = false;
            // Explicitly load list view for chromeless (i.e. embed) routes
            viewId = filterId ? (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
        }
        let staticViewInput;
        if (projectKey === undefined || projectKey === null) staticViewInput = {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        };
        else if (hideDone != null) staticViewInput = {
            isHideDoneEnabled: hideDone
        };
        const viewConfigInput = staticViewInput ? {
            staticViewInput: staticViewInput
        } : {
            viewInput: {
                namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE)
            }
        };
        let viewQueryInput;
        if ((0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support')) {
            const itemIdSlug = routerContext.match.params.navigationItemId;
            const itemId = itemIdSlug ? `list/${itemIdSlug}` : 'list';
            viewQueryInput = projectKey == null ? {
                viewAri: (0, $9S9Cb.createViewAri)({
                    activationId: tenantContext.activationId,
                    cloudId: tenantContext.cloudId
                })
            } : {
                projectKeyAndItemIdQuery: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    itemId: itemId
                }
            };
        }
        let operationScope;
        if (isIFCEnabled && (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) operationScope = (0, $awWeA.getOperationScope)(projectKey);
        else if (projectKey) operationScope = (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $iRahl.NIN_GLOBAL_OPERATION_SCOPE);
        const scope = {
            operationScope: operationScope
        };
        // Behavioural change from IFC. Previously we omitted the project key in embed view - which
        // means default global field sets would be loaded. Now we load field sets configured to the
        // project in both project and embed routes
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) scope.projectKey = projectKey ?? null;
        else if (isIFCEnabled && (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) scope.projectKey = projectKey;
        let fieldSetsScope = null;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) fieldSetsScope = {
            operationScope: operationScope,
            projectKey: projectKey ?? null
        };
        else if (isIFCEnabled && (0, $cxKOj.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false)) fieldSetsScope = {
            operationScope: operationScope,
            projectKey: projectKey
        };
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: issueSearchInput,
            namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: {
                viewInput: {
                    namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
                    filterId: filterId,
                    viewId: viewId
                }
            },
            after: null,
            options: {
                issueKey: issueKey
            },
            filterId: filterId,
            amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && (0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
            ...(0, $4cTDP.fg)('jsc_nin_operation_scope_fe') && {
                scope: scope
            },
            ...((0, $cxKOj.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) || (0, $4cTDP.fg)('jsc_hide_done_view_config_fix')) && {
                viewConfigInput: viewConfigInput
            },
            staticViewInput: staticViewInput,
            ...((0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support')) && {
                viewQueryInput: viewQueryInput,
                settings: {
                    groupBy: groupBy,
                    hideDone: hideDone,
                    jql: jqlParam
                }
            },
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $iRahl.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey),
            shouldQueryConditionalFormatting: shouldQueryConditionalFormatting && (0, $4cTDP.fg)('jira_list_conditional_formatting'),
            shouldQueryConditionalFormattingFromSavedView: // eslint-disable-next-line jira/ff/no-preconditioning
            shouldQueryConditionalFormatting && (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $4cTDP.fg)('saved_list_view_technical_changes'),
            groupBy: groupBy ?? null,
            fieldSetsScope: fieldSetsScope,
            viewId: viewId
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $93W2w.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$44ca3a0b25f38d83 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $lzktc.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $82cqT.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $4mFQO.default), variables, options);
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$967ef0cfbd1cc946 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $lzktc.getParams)(routerContext);
        const isProjectNIN = Boolean(projectKey);
        if (isProjectNIN && (0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) return null;
        let variables;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) {
            const hydrateJqlInput = (0, $lzktc.getHydrateJqlInput)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId,
                defaultJql: defaultJql,
                jqlParam: jqlParam,
                filter: filter,
                projectKey: projectKey
            });
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: false,
                jql: '',
                filterAri: '',
                viewContext: null,
                input: hydrateJqlInput,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        } else {
            const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, $4NoAT.JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                viewContext: null,
                input: null,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        }
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $3w0Dj.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $ed0a4483fb669c9c$export$2c98f9cf5d4c493e = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}_BROWSER_ONLY`,
    getKey: ()=>'issue-navigator-hydration-relay-browser-only',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $lzktc.getParams)(routerContext);
        let variables;
        if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) {
            const hydrateJqlInput = (0, $lzktc.getHydrateJqlInput)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId,
                defaultJql: defaultJql,
                jqlParam: jqlParam,
                filter: filter,
                projectKey: projectKey
            });
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                // Remove argument and query variable on jira_nin_last_used_jql cleanup
                isFilter: false,
                // Remove argument and query variable on jira_nin_last_used_jql cleanup
                jql: '',
                // Remove argument and query variable on jira_nin_last_used_jql cleanup
                filterAri: '',
                viewContext: null,
                input: hydrateJqlInput,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        } else {
            const jqlOrFilterId = (0, $lzktc.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, $4NoAT.JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                viewContext: null,
                input: null,
                isPlanReleaseFeatureToggleEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle')
            };
        }
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $3w0Dj.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});
const $ed0a4483fb669c9c$export$b963a9a8713e35f3 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $2HIMw.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-refinement-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey } = (0, $lzktc.getParams)(routerContext);
        const isProjectNIN = Boolean(projectKey);
        if (!isProjectNIN || !(0, $cxKOj.expVal)('list_lovability_improving_filters_exp', 'isEnabled', false)) return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            isFilterRefinementEnabled: true
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $kjRvu.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("82cqT", function(module, exports) {
$parcel$export(module.exports, "isCustomFilter", () => $210cb11189693860$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $210cb11189693860$export$23be85030bd58047);
const $210cb11189693860$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $210cb11189693860$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $210cb11189693860$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("iRahl", function(module, exports) {
$parcel$export(module.exports, "sortDirections", () => $44bd204fdd3c598a$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $44bd204fdd3c598a$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $44bd204fdd3c598a$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $44bd204fdd3c598a$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $44bd204fdd3c598a$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $44bd204fdd3c598a$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $44bd204fdd3c598a$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $44bd204fdd3c598a$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $44bd204fdd3c598a$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $44bd204fdd3c598a$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $44bd204fdd3c598a$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $44bd204fdd3c598a$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $44bd204fdd3c598a$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $44bd204fdd3c598a$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $44bd204fdd3c598a$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $44bd204fdd3c598a$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $44bd204fdd3c598a$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $44bd204fdd3c598a$export$524ae4278a57eea2);
$parcel$export(module.exports, "LIST_VIEW_ID", () => $44bd204fdd3c598a$export$af225181779390f4);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $44bd204fdd3c598a$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $44bd204fdd3c598a$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $44bd204fdd3c598a$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $44bd204fdd3c598a$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $44bd204fdd3c598a$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $44bd204fdd3c598a$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $44bd204fdd3c598a$export$6c35abbca3056365);
$parcel$export(module.exports, "ALL_COLUMNS_ID", () => $44bd204fdd3c598a$export$eb85a4c9b5d9ce7b);
$parcel$export(module.exports, "supportedOrderFields", () => $44bd204fdd3c598a$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $44bd204fdd3c598a$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $44bd204fdd3c598a$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $44bd204fdd3c598a$export$2627fa464eafde69);

var $8jOO7 = parcelRequire("8jOO7");
const $44bd204fdd3c598a$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $44bd204fdd3c598a$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $44bd204fdd3c598a$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $44bd204fdd3c598a$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $44bd204fdd3c598a$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $44bd204fdd3c598a$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $44bd204fdd3c598a$export$393cb330f31d305c = $44bd204fdd3c598a$export$2bd49f8f262d7cbb.created;
const $44bd204fdd3c598a$export$8ea18fa9e35fdf25 = $44bd204fdd3c598a$export$73034536b9adc928.DESC;
const $44bd204fdd3c598a$export$500b5c379b5c7f2e = 'list_default';
const $44bd204fdd3c598a$export$f88f58d1a4b2078b = 50;
const $44bd204fdd3c598a$export$8c67ad1f64ab5a9c = ()=>$44bd204fdd3c598a$export$f88f58d1a4b2078b;
const $44bd204fdd3c598a$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $44bd204fdd3c598a$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $44bd204fdd3c598a$export$d57b6b390e78d90f = 'empanada';
const $44bd204fdd3c598a$export$52919046b94109dc = 'showPinIssueList';
const $44bd204fdd3c598a$export$88890124f795113d = 'groupedList';
const $44bd204fdd3c598a$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $44bd204fdd3c598a$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $44bd204fdd3c598a$export$af225181779390f4 = 'list_default';
const $44bd204fdd3c598a$export$608eeb3a32afef02 = (0, $8jOO7.MAX_COLUMNS);
const $44bd204fdd3c598a$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $44bd204fdd3c598a$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $44bd204fdd3c598a$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $44bd204fdd3c598a$export$fae6afe554014a45 = 'NIN_PROJECT';
const $44bd204fdd3c598a$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $44bd204fdd3c598a$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $44bd204fdd3c598a$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $44bd204fdd3c598a$export$6c35abbca3056365 = 'IssueNavigator';
const $44bd204fdd3c598a$export$eb85a4c9b5d9ce7b = 'all-columns';
const $44bd204fdd3c598a$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $44bd204fdd3c598a$export$eaadab3243bf458 = (alias)=>Object.keys($44bd204fdd3c598a$export$3630aa1c4c69277f).find((key)=>$44bd204fdd3c598a$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $44bd204fdd3c598a$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $44bd204fdd3c598a$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});

parcelRegister("eibCx", function(module, exports) {
$parcel$export(module.exports, "createRememoizeSelector", () => $0e7c4003c6219e66$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $0e7c4003c6219e66$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $0e7c4003c6219e66$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $0e7c4003c6219e66$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $0e7c4003c6219e66$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $0e7c4003c6219e66$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $0e7c4003c6219e66$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $0e7c4003c6219e66$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $0e7c4003c6219e66$export$1dde85fc919cd8db);

var $ahm5r = parcelRequire("ahm5r");

var $iRahl = parcelRequire("iRahl");
const $0e7c4003c6219e66$export$982d75deeca693ef = (0, $ahm5r.createSelectorCreator)((0, $ahm5r.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $0e7c4003c6219e66$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $0e7c4003c6219e66$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $0e7c4003c6219e66$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($0e7c4003c6219e66$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $0e7c4003c6219e66$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $0e7c4003c6219e66$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $iRahl.views).detail : (0, $iRahl.views).list;
const $0e7c4003c6219e66$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $iRahl.views).detail ? 'detail' : 'list_default';
const $0e7c4003c6219e66$export$5786a571e562003d = (viewMode)=>viewMode === (0, $iRahl.views).detail ? 'DETAIL' : 'LIST';
function $0e7c4003c6219e66$export$70573498ee17fe1d(value) {
    return value != null;
}
const $0e7c4003c6219e66$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($0e7c4003c6219e66$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $0e7c4003c6219e66$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $0e7c4003c6219e66$export$6ce707b3eccb341d = (view)=>view === (0, $iRahl.views).detail ? 'detail' : 'list_default';
const $0e7c4003c6219e66$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $iRahl.views).detail : (0, $iRahl.views).list;
const $0e7c4003c6219e66$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $0e7c4003c6219e66$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("awWeA", function(module, exports) {
$parcel$export(module.exports, "getOperationScope", () => $5af88e3fbe2eb6ab$export$93ef6e0525bce59d);

var $j8Km1 = parcelRequire("j8Km1");
const $5af88e3fbe2eb6ab$export$93ef6e0525bce59d = (projectKey)=>{
    let operationScope;
    if (projectKey != null) operationScope = (0, $j8Km1.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $j8Km1.NIN_GLOBAL_OPERATION_SCOPE);
    return operationScope;
};

});

parcelRegister("4mFQO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad68114cb1dd8f51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<210c03b356af3558094d2187351cd5c9>>
 * @relayHash 9f8f716e33f0a3f70ec04be69edc8a8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 358acf927b5804a881bf1d24cc18e315f32b18ad94e0f7c7dcf94aa639b52072
const $ad68114cb1dd8f51$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "358acf927b5804a881bf1d24cc18e315f32b18ad94e0f7c7dcf94aa639b52072",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ad68114cb1dd8f51$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $ad68114cb1dd8f51$export$2e2bcd8739ae039 = $ad68114cb1dd8f51$var$node;

});

parcelRegister("93W2w", function(module, exports) {
$parcel$export(module.exports, "default", () => $04e26ee18435d3dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b08258fcbdce20e284587919dc1d2e7>>
 * @relayHash 21dd2c9160a58fb277b6b5042130fb03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6fe877ade3ed566e7498595109b445ca3f016d85482f82641ba173a78549c3fb

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $dexoz = parcelRequire("dexoz");

var $3jVIX = parcelRequire("3jVIX");

var $4GS9O = parcelRequire("4GS9O");

var $l6otE = parcelRequire("l6otE");

var $lcRgI = parcelRequire("lcRgI");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $axWOK = parcelRequire("axWOK");

var $2Z4v6 = parcelRequire("2Z4v6");

var $alrjx = parcelRequire("alrjx");

var $eylLg = parcelRequire("eylLg");

var $86KXU = parcelRequire("86KXU");

var $iiQfx = parcelRequire("iiQfx");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $hA9n6 = parcelRequire("hA9n6");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $8Qoc7 = parcelRequire("8Qoc7");

var $cqnj8 = parcelRequire("cqnj8");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $04e26ee18435d3dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormatting"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryConditionalFormattingFromSavedView"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v27 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormatting"
    }, v28 = {
        "kind": "Variable",
        "name": "isSavedViewConditionalFormattingEnabled",
        "variableName": "shouldQueryConditionalFormattingFromSavedView"
    }, v29 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v30 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v31 = [
        v30 /*: any*/ 
    ], v32 = [
        v30 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v34 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v35 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v36 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v37 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v38 = {
        "kind": "ScalarField",
        "name": "message"
    }, v39 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v37 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v38 /*: any*/ 
    ], v40 = {
        "kind": "ScalarField",
        "name": "id"
    }, v41 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v42 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v41 /*: any*/ 
    ], v43 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v45 = {
        "kind": "ScalarField",
        "name": "savedViewId"
    }, v46 = {
        "args": [
            v36 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v47 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v48 = [
        v47 /*: any*/ ,
        v34 /*: any*/ ,
        v36 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v49 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v50 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v49 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v52 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v53 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v54 = {
        "kind": "ClientExtension",
        "selections": [
            v53 /*: any*/ 
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v56 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v57 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v58 = {
        "kind": "ScalarField",
        "name": "type"
    }, v59 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v60 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v61 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "aliases"
            }
        ]
    }, v62 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v63 = {
        "kind": "ScalarField",
        "name": "value"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "alias": "singleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            v63 /*: any*/ 
        ],
        "type": "JiraFormattingSingleValueOperand"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "alias": "multipleValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            },
            {
                "kind": "ScalarField",
                "name": "values"
            }
        ],
        "type": "JiraFormattingMultipleValueOperand"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "alias": "noValueOperator",
                "kind": "ScalarField",
                "name": "operator"
            }
        ],
        "type": "JiraFormattingNoValueOperand"
    }, v67 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v64 /*: any*/ ,
            v65 /*: any*/ ,
            v66 /*: any*/ 
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v69 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v70 = [
        {
            "concreteType": "JiraFormattingRuleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraFormattingRule",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v67 /*: any*/ ,
                        v68 /*: any*/ ,
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                                v40 /*: any*/ ,
                                v69 /*: any*/ 
                            ]
                        },
                        v40 /*: any*/ 
                    ]
                }
            ]
        }
    ], v71 = {
        "kind": "ScalarField",
        "name": "name"
    }, v72 = [
        v69 /*: any*/ ,
        v40 /*: any*/ 
    ], v73 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "formattingColor",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v74 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v75 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v76 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v77 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v78 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v79 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v80 = {
        "kind": "Variable",
        "name": "saveJQLToUserHistory",
        "variableName": "saveJQLToUserHistory"
    }, v81 = [
        v74 /*: any*/ ,
        v75 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v34 /*: any*/ ,
        v78 /*: any*/ ,
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v82 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v83 = {
        "kind": "ScalarField",
        "name": "key"
    }, v84 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v85 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v86 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v85 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            },
            v40 /*: any*/ 
        ]
    }, v87 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v88 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v89 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v88 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v90 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v89 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v91 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v90 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v92 = [
        v71 /*: any*/ 
    ], v93 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": v92 /*: any*/ 
                    }
                ]
            }
        ]
    }, v94 = {
        "kind": "ClientExtension",
        "selections": [
            v53 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v95 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v96 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v97 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v40 /*: any*/ ,
            v83 /*: any*/ ,
            v84 /*: any*/ ,
            v86 /*: any*/ ,
            v87 /*: any*/ ,
            v91 /*: any*/ ,
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v95 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v96 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v92 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v98 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v99 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v71 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v101 = [
        v63 /*: any*/ ,
        v40 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v102 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v103 = {
        "kind": "ClientExtension",
        "selections": [
            v102 /*: any*/ 
        ]
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v101 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v101 /*: any*/ 
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v105 = [
        v38 /*: any*/ 
    ], v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": v105 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v107 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v108 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v109 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v108 /*: any*/ ,
                                    v109 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v111 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v71 /*: any*/ ,
            v111 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v113 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v83 /*: any*/ ,
                    v95 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v116 = {
        "kind": "ScalarField",
        "name": "text"
    }, v117 = {
        "kind": "InlineFragment",
        "selections": [
            v116 /*: any*/ ,
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v118 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v88 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v89 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v120 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v121 = [
        v71 /*: any*/ ,
        v120 /*: any*/ 
    ], v122 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v121 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v96 /*: any*/ ,
                    v71 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v124 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v125 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v126 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v127 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v88 /*: any*/ 
        ]
    }, v128 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v83 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v120 /*: any*/ ,
                            v40 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v124 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            },
                            v40 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v116 /*: any*/ ,
                            v40 /*: any*/ 
                        ]
                    },
                    v40 /*: any*/ ,
                    v84 /*: any*/ ,
                    v125 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "project",
                                            "summary",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    v40 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            v116 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v40 /*: any*/ ,
                                                                    v126 /*: any*/ ,
                                                                    v71 /*: any*/ ,
                                                                    v124 /*: any*/ ,
                                                                    v85 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v40 /*: any*/ ,
                                                                    v127 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    v49 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v126 /*: any*/ ,
                                            v85 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraSingleLineTextField",
                                "kind": "LinkedField",
                                "name": "summaryField",
                                "plural": false,
                                "selections": [
                                    v49 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v90 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraParentIssueField"
    }, v129 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v130 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v129 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v131 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v83 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraResolutionField"
    }, v133 = [
        v40 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v71 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v134 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v133 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v71 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v135 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v136 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v137 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v138 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v71 /*: any*/ ,
                    v135 /*: any*/ ,
                    v136 /*: any*/ ,
                    v40 /*: any*/ ,
                    v137 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "appType"
                                    }
                                ]
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            v111 /*: any*/ ,
            v103 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v140 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v124 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v141 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v125 /*: any*/ ,
                                            v83 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v37 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v89 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v40 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    v87 /*: any*/ 
                                                ]
                                            },
                                            v40 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v40 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v142 = {
        "kind": "ScalarField",
        "name": "number"
    }, v143 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v142 /*: any*/ ,
            v71 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraNumberFieldFormatConfig",
                        "kind": "LinkedField",
                        "name": "formatConfig",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "formatStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formatUnit"
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v144 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v57 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v145 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v146 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v147 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    v120 /*: any*/ ,
                    v40 /*: any*/ ,
                    v146 /*: any*/ 
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v148 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v63 /*: any*/ ,
                                    v146 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v149 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v63 /*: any*/ 
        ]
    }, v150 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v37 /*: any*/ ,
                                    v137 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v135 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v136 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v151 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v152 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v153 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v154 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v152 /*: any*/ ,
                                    v153 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v58 /*: any*/ ,
                                    v103 /*: any*/ 
                                ]
                            },
                            v40 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            }
        ]
    }, v155 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v152 /*: any*/ ,
                                    v153 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v58 /*: any*/ 
                                ]
                            },
                            v40 /*: any*/ 
                        ]
                    },
                    v103 /*: any*/ 
                ],
                "type": "JiraOriginalTimeEstimateField"
            }
        ]
    }, v156 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v40 /*: any*/ ,
                    v108 /*: any*/ 
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v157 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v158 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v108 /*: any*/ ,
                                    v109 /*: any*/ ,
                                    v157 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v159 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            v40 /*: any*/ 
        ]
    }, v160 = {
        "kind": "ScalarField",
        "name": "status"
    }, v161 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            v159 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v83 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            v71 /*: any*/ ,
                                            v160 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v53 /*: any*/ ,
                    v102 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v162 = {
        "kind": "ScalarField",
        "name": "privateProject"
    }, v163 = {
        "kind": "ScalarField",
        "name": "hasPermission"
    }, v164 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v71 /*: any*/ ,
                    v159 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isLinkEditable"
                    },
                    {
                        "concreteType": "JiraTownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            {
                                "alias": "atlasProjectName",
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "alias": "atlasProjectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            v162 /*: any*/ ,
                            v163 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "isWorkspaceActive"
                            }
                        ]
                    },
                    v103 /*: any*/ 
                ],
                "type": "JiraTownsquareProjectField"
            }
        ]
    }, v165 = {
        "kind": "ScalarField",
        "name": "href"
    }, v166 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "args": v107 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v165 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v165 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v57 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v103 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v167 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v168 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v167 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v103 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v169 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraFlag",
                "kind": "LinkedField",
                "name": "flag",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isFlagged"
                    }
                ]
            }
        ],
        "type": "JiraFlagField"
    }, v170 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v171 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v172 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v173 = [
        v37 /*: any*/ ,
        v40 /*: any*/ 
    ], v174 = {
        "args": v98 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v58 /*: any*/ ,
                            v43 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    v57 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v40 /*: any*/ ,
                                                    v37 /*: any*/ ,
                                                    v49 /*: any*/ ,
                                                    v58 /*: any*/ ,
                                                    v99 /*: any*/ ,
                                                    v100 /*: any*/ ,
                                                    v104 /*: any*/ ,
                                                    v106 /*: any*/ ,
                                                    v110 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v113 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v115 /*: any*/ ,
                                                    v117 /*: any*/ ,
                                                    v118 /*: any*/ ,
                                                    v119 /*: any*/ ,
                                                    v122 /*: any*/ ,
                                                    v123 /*: any*/ ,
                                                    v128 /*: any*/ ,
                                                    v130 /*: any*/ ,
                                                    v131 /*: any*/ ,
                                                    v132 /*: any*/ ,
                                                    v134 /*: any*/ ,
                                                    v138 /*: any*/ ,
                                                    v139 /*: any*/ ,
                                                    v140 /*: any*/ ,
                                                    v141 /*: any*/ ,
                                                    v143 /*: any*/ ,
                                                    v144 /*: any*/ ,
                                                    v145 /*: any*/ ,
                                                    v147 /*: any*/ ,
                                                    v148 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v71 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v149 /*: any*/ ,
                                                                            v54 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v103 /*: any*/ 
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    v150 /*: any*/ ,
                                                    v151 /*: any*/ ,
                                                    v154 /*: any*/ ,
                                                    v155 /*: any*/ ,
                                                    v156 /*: any*/ ,
                                                    v158 /*: any*/ ,
                                                    v161 /*: any*/ ,
                                                    v164 /*: any*/ ,
                                                    v166 /*: any*/ ,
                                                    v168 /*: any*/ ,
                                                    v169 /*: any*/ ,
                                                    v170 /*: any*/ ,
                                                    v54 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v54 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "shouldQueryConditionalFormatting",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v107 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "componentId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v171 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v172 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "version",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v157 /*: any*/ ,
                                                                            v40 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v126 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValue",
                                                                        "plural": false,
                                                                        "selections": v173 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSelectableValueEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v173 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v175 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v176 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v177 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v175 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v176 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v178 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v179 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v180 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v181 = [
        v179 /*: any*/ ,
        v82 /*: any*/ ,
        v180 /*: any*/ 
    ], v182 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v181 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v181 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v82 /*: any*/ ,
                    v179 /*: any*/ ,
                    v180 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v183 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v184 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v38 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": v105 /*: any*/ ,
                "type": "JiraServerError"
            }
        ]
    }, v185 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v186 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v95 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v187 = {
        "args": v81 /*: any*/ ,
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v82 /*: any*/ ,
                    v97 /*: any*/ ,
                    v37 /*: any*/ ,
                    v174 /*: any*/ ,
                    v54 /*: any*/ 
                ]
            },
            v177 /*: any*/ ,
            v178 /*: any*/ ,
            v182 /*: any*/ ,
            v183 /*: any*/ ,
            v184 /*: any*/ ,
            v44 /*: any*/ ,
            v185 /*: any*/ ,
            v54 /*: any*/ ,
            v186 /*: any*/ 
        ]
    }, v188 = [
        "scope"
    ], v189 = [
        "issueSearchInput"
    ], v190 = [
        v74 /*: any*/ ,
        v75 /*: any*/ ,
        v77 /*: any*/ ,
        v47 /*: any*/ ,
        v34 /*: any*/ ,
        v78 /*: any*/ ,
        v80 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v191 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v192 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v60 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v171 /*: any*/ ,
                            v71 /*: any*/ ,
                            v129 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v40 /*: any*/ ,
                            v137 /*: any*/ ,
                            v71 /*: any*/ ,
                            v135 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v71 /*: any*/ ,
                            v127 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ ,
                    v89 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v142 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v146 /*: any*/ ,
                            v63 /*: any*/ ,
                            v120 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v133 /*: any*/ 
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": v121 /*: any*/ 
                    }
                ],
                "type": "JiraJqlLabelFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v167 /*: any*/ ,
                            v71 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGroupFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v157 /*: any*/ ,
                            v71 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ],
                "type": "JiraJqlVersionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v59 /*: any*/ ,
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v160 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            },
                            v40 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlGoalsFieldValue"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    v40 /*: any*/ ,
                                    v83 /*: any*/ ,
                                    v162 /*: any*/ ,
                                    v163 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlTownsquareProjectFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": true,
                        "selections": [
                            v71 /*: any*/ ,
                            v96 /*: any*/ ,
                            v40 /*: any*/ ,
                            v126 /*: any*/ ,
                            v85 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlIssueTypeFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v59 /*: any*/ ,
                    {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "resolution",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            v71 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraJqlResolutionFieldValue"
            }
        ]
    }, v193 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v194 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v195 = [
        v76 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v41 /*: any*/ ,
        v36 /*: any*/ ,
        v194 /*: any*/ 
    ], v196 = {
        "args": v190 /*: any*/ ,
        "concreteType": "JiraSpreadsheetGroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v82 /*: any*/ ,
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v40 /*: any*/ ,
                            v44 /*: any*/ ,
                            v49 /*: any*/ ,
                            v191 /*: any*/ ,
                            v43 /*: any*/ ,
                            v192 /*: any*/ ,
                            v193 /*: any*/ 
                        ]
                    },
                    v37 /*: any*/ 
                ]
            },
            v177 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "groupByField"
            },
            v44 /*: any*/ ,
            {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": v39 /*: any*/ 
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            {
                                "args": v195 /*: any*/ ,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v37 /*: any*/ ,
                                            v82 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    v40 /*: any*/ ,
                                                    v84 /*: any*/ ,
                                                    v83 /*: any*/ ,
                                                    v86 /*: any*/ ,
                                                    v87 /*: any*/ ,
                                                    v91 /*: any*/ ,
                                                    v93 /*: any*/ ,
                                                    v94 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "args": v98 /*: any*/ ,
                                                "concreteType": "JiraIssueFieldSetConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldSets",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldSetEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldSet",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v58 /*: any*/ ,
                                                                    v43 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fields",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v57 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v40 /*: any*/ ,
                                                                                            v37 /*: any*/ ,
                                                                                            v49 /*: any*/ ,
                                                                                            v58 /*: any*/ ,
                                                                                            v99 /*: any*/ ,
                                                                                            v100 /*: any*/ ,
                                                                                            v104 /*: any*/ ,
                                                                                            v106 /*: any*/ ,
                                                                                            v110 /*: any*/ ,
                                                                                            v112 /*: any*/ ,
                                                                                            v113 /*: any*/ ,
                                                                                            v114 /*: any*/ ,
                                                                                            v115 /*: any*/ ,
                                                                                            v117 /*: any*/ ,
                                                                                            v118 /*: any*/ ,
                                                                                            v119 /*: any*/ ,
                                                                                            v122 /*: any*/ ,
                                                                                            v123 /*: any*/ ,
                                                                                            v128 /*: any*/ ,
                                                                                            v130 /*: any*/ ,
                                                                                            v131 /*: any*/ ,
                                                                                            v132 /*: any*/ ,
                                                                                            v134 /*: any*/ ,
                                                                                            v138 /*: any*/ ,
                                                                                            v139 /*: any*/ ,
                                                                                            v140 /*: any*/ ,
                                                                                            v141 /*: any*/ ,
                                                                                            v143 /*: any*/ ,
                                                                                            v144 /*: any*/ ,
                                                                                            v145 /*: any*/ ,
                                                                                            v147 /*: any*/ ,
                                                                                            v148 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v71 /*: any*/ ,
                                                                                                    {
                                                                                                        "concreteType": "JiraOptionConnection",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "selectedOptions",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "edges",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v149 /*: any*/ 
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v103 /*: any*/ 
                                                                                                ],
                                                                                                "type": "JiraCheckboxesField"
                                                                                            },
                                                                                            v150 /*: any*/ ,
                                                                                            v151 /*: any*/ ,
                                                                                            v154 /*: any*/ ,
                                                                                            v155 /*: any*/ ,
                                                                                            v156 /*: any*/ ,
                                                                                            v158 /*: any*/ ,
                                                                                            v161 /*: any*/ ,
                                                                                            v164 /*: any*/ ,
                                                                                            v166 /*: any*/ ,
                                                                                            v168 /*: any*/ ,
                                                                                            v169 /*: any*/ ,
                                                                                            v170 /*: any*/ ,
                                                                                            v54 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldSets(first:500)"
                                            },
                                            v54 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            v175 /*: any*/ ,
                                            v176 /*: any*/ 
                                        ]
                                    },
                                    v183 /*: any*/ ,
                                    v185 /*: any*/ ,
                                    v54 /*: any*/ 
                                ]
                            },
                            {
                                "args": v195 /*: any*/ ,
                                "filters": [
                                    "viewConfigInput",
                                    "fieldSetsInput",
                                    "scope",
                                    "settings"
                                ],
                                "handle": "connection",
                                "key": "firstGroupSection_nativeIssueTable__issues",
                                "kind": "LinkedHandle",
                                "name": "issues"
                            },
                            v44 /*: any*/ ,
                            v49 /*: any*/ ,
                            v191 /*: any*/ ,
                            v43 /*: any*/ ,
                            v192 /*: any*/ ,
                            v193 /*: any*/ 
                        ]
                    }
                ]
            },
            v54 /*: any*/ 
        ]
    }, v197 = [
        v74 /*: any*/ ,
        v75 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v34 /*: any*/ ,
        v78 /*: any*/ ,
        v79 /*: any*/ ,
        v80 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v194 /*: any*/ 
    ], v198 = {
        "args": v197 /*: any*/ ,
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    v82 /*: any*/ ,
                    v97 /*: any*/ ,
                    v37 /*: any*/ ,
                    v174 /*: any*/ ,
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "filterByProjectKeys.0",
                                                "variableName": "projectKey"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "filterByProjectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            },
                            {
                                "args": [
                                    v29 /*: any*/ 
                                ],
                                "kind": "ScalarField",
                                "name": "canHaveChildIssues"
                            }
                        ]
                    },
                    v54 /*: any*/ 
                ]
            },
            v177 /*: any*/ ,
            v178 /*: any*/ ,
            v182 /*: any*/ ,
            v183 /*: any*/ ,
            v184 /*: any*/ ,
            v44 /*: any*/ ,
            v185 /*: any*/ ,
            v54 /*: any*/ ,
            v186 /*: any*/ 
        ]
    }, v199 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v30 /*: any*/ 
    ], v200 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v29 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v31 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_issueNavigator_IssueNavigatorUI_project"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueSearch_issueNavigatorProject"
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "kind": "FragmentSpread",
                                                            "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ConditionalFormattingSidebarContainer_project"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v12 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v25 /*: any*/ ,
                v14 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v15 /*: any*/ ,
                v22 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v10 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v17 /*: any*/ ,
                v9 /*: any*/ ,
                v21 /*: any*/ ,
                v6 /*: any*/ ,
                v26 /*: any*/ ,
                v18 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v30 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v34 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewQueryInput",
                                    "variableName": "viewQueryInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v37 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v39 /*: any*/ 
                                },
                                v40 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v42 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isFrozen"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v44 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPublishViewConfig"
                                                },
                                                v45 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v48 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v54 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v45 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v48 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v55 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        v41 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v42 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v57 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v59 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v61 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v49 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v54 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v46 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v48 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v52 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v50 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraFormattingRuleConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "conditionalFormattingRules",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v70 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v54 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "args": v48 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v71 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ],
                                            "type": "JiraView",
                                            "abstractKey": "__isJiraView"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v48 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        v62 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v45 /*: any*/ ,
                                                {
                                                    "args": v33 /*: any*/ ,
                                                    "concreteType": "JiraFormattingRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "conditionalFormattingRules",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRuleEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRule",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "expression",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                v65 /*: any*/ ,
                                                                                v64 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ ,
                                                                        v68 /*: any*/ 
                                                                    ]
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v54 /*: any*/ 
                                                    ],
                                                    "storageKey": "conditionalFormattingRules(first:20)"
                                                },
                                                v54 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v187 /*: any*/ ,
                                                {
                                                    "args": v81 /*: any*/ ,
                                                    "filters": v188 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v187 /*: any*/ ,
                                                {
                                                    "args": v81 /*: any*/ ,
                                                    "filters": v189 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v196 /*: any*/ ,
                                                {
                                                    "args": v190 /*: any*/ ,
                                                    "filters": v188 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v196 /*: any*/ ,
                                                {
                                                    "args": v190 /*: any*/ ,
                                                    "filters": v189 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v198 /*: any*/ ,
                                                {
                                                    "args": v197 /*: any*/ ,
                                                    "filters": v188 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorJiraListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v198 /*: any*/ ,
                                                {
                                                    "args": v197 /*: any*/ ,
                                                    "filters": v189 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        },
                        {
                            "args": v31 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                v54 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                }
                            ]
                        },
                        {
                            "args": v199 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v199 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v37 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v31 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldWithAliases",
                                    "kind": "LinkedField",
                                    "name": "rankField",
                                    "plural": false,
                                    "selections": [
                                        v49 /*: any*/ ,
                                        v60 /*: any*/ ,
                                        v61 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v83 /*: any*/ ,
                                        v172 /*: any*/ ,
                                        {
                                            "alias": "createIssues",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "CREATE_ISSUES"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": v200 /*: any*/ ,
                                            "storageKey": "action(type:\"CREATE_ISSUES\")"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        v40 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "editIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v200 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraFormattingRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "conditionalFormattingRules",
                                                            "plural": false,
                                                            "selections": v70 /*: any*/ ,
                                                            "storageKey": "conditionalFormattingRules(first:20)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryConditionalFormattingFromSavedView",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "condition": "shouldQueryConditionalFormatting",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraFormattingRuleConnection",
                                                            "kind": "LinkedField",
                                                            "name": "conditionalFormattingRules",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFormattingRuleEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFormattingRule",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v68 /*: any*/ ,
                                                                                v67 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "conditionalFormattingRules(first:20)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v92 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6fe877ade3ed566e7498595109b445ca3f016d85482f82641ba173a78549c3fb",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider": (0, $hA9n6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $iiQfx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": (0, $lcRgI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $eylLg.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $cqnj8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $alrjx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcfrontierformulafieldd1relayprovider": (0, $dexoz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": (0, $axWOK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingormergesupportenabledrelayprovider": (0, $86KXU.default)
            }
        }
    };
}();
$04e26ee18435d3dd$var$node.hash = "e08a14af4b25b6ce0f995ff259a909bf";
var $04e26ee18435d3dd$export$2e2bcd8739ae039 = $04e26ee18435d3dd$var$node;

});
parcelRegister("dexoz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1454966b1f1ab0d9$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $1454966b1f1ab0d9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('frontier-formula-field-d1');
    }
};

});

parcelRegister("4GS9O", function(module, exports) {
$parcel$export(module.exports, "default", () => $00c181c86ac97317$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $00c181c86ac97317$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('group_by_projects');
    }
};

});

parcelRegister("lcRgI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5044a43d32ddc421$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $5044a43d32ddc421$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('issue_table_frozen_columns');
    }
};

});

parcelRegister("axWOK", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a374daabff4b4a$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $17a374daabff4b4a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_paid_list_nin_merge_onboarding_modal');
    }
};

});

parcelRegister("alrjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5866ee686638771$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f5866ee686638771$export$2e2bcd8739ae039 = {
    get () {
        // eslint-disable-next-line jira/ff/no-preconditioning
        return (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $4cTDP.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("eylLg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5026bc93a9dbae2$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $f5026bc93a9dbae2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('saved_list_view', 'isEnabled', false);
    }
};

});

parcelRegister("86KXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6138f9d02c978367$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6138f9d02c978367$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('saved_list_view_technical_changes') || (0, $4cTDP.fg)('saved_list_view_merge_support');
    }
};

});

parcelRegister("iiQfx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2f41d418b65dd3d$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $f2f41d418b65dd3d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("kmr3r", function(module, exports) {
$parcel$export(module.exports, "default", () => $828374d45db0f539$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $828374d45db0f539$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("hA9n6", function(module, exports) {
$parcel$export(module.exports, "default", () => $66bdfe38c73f6115$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $66bdfe38c73f6115$var$lastUsedJql = {
    get () {
        return (0, $4cTDP.fg)('jira_nin_last_used_jql');
    }
};
var $66bdfe38c73f6115$export$2e2bcd8739ae039 = $66bdfe38c73f6115$var$lastUsedJql;

});

parcelRegister("cqnj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dc2689c4189780e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $0dc2689c4189780e$var$JscIssueRankingRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jsc_list_reranking_gate');
    }
};
var $0dc2689c4189780e$export$2e2bcd8739ae039 = $0dc2689c4189780e$var$JscIssueRankingRelayProvider;

});


parcelRegister("9S9Cb", function(module, exports) {
$parcel$export(module.exports, "createViewAri", () => $6c29cdb9d8abd803$export$8e9e81ca81fb9409);

var $496yH = parcelRequire("496yH");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $kfvK2 = parcelRequire("kfvK2");
const $6c29cdb9d8abd803$var$useNavigationItemId = (0, $kfvK2.createRouterSelector)((state)=>state.match?.params?.navigationItemId);
const $6c29cdb9d8abd803$export$8e9e81ca81fb9409 = ({ activationId: activationId, cloudId: cloudId, layout: layout, projectId: projectId, viewItemId: viewItemId })=>{
    const layoutPart = layout ? `/layout/${layout}` : '';
    if (projectId) {
        const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';
        return (0, $496yH.JiraViewAri).create({
            activationId: activationId,
            scopeId: `${projectId}/list${viewItemIdPart}${layoutPart}`,
            scopeType: 'project',
            siteId: cloudId
        }).toString();
    }
    return (0, $496yH.JiraViewAri).create({
        activationId: activationId,
        scopeId: `issue-navigator${layoutPart}`,
        scopeType: 'global',
        siteId: cloudId
    }).toString();
};
const $6c29cdb9d8abd803$export$b6b78fb187396ce9 = ({ layout: layout, projectId: projectId })=>{
    const activationId = (0, $f2sjT.useActivationId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const viewItemId = $6c29cdb9d8abd803$var$useNavigationItemId();
    return $6c29cdb9d8abd803$export$8e9e81ca81fb9409({
        activationId: activationId,
        cloudId: cloudId,
        layout: layout,
        projectId: projectId,
        viewItemId: viewItemId
    });
};

});

parcelRegister("kjRvu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc3470762a0a247$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f8e6bff17c97922d5fdccd4453b1ac4>>
 * @relayHash 00de152e369f714ec9b678e593c3a3b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eac3ae0c1af4c562b2f8c4ef87c13e9380d10a9063b7f3c57dfc05d73706bb4a
const $7fc3470762a0a247$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilterRefinementEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isFilterRefinementEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "FragmentSpread",
                                    "name": "FilterRefinement"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isFilterRefinementEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 100
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "jqlTerm",
                                                    "value": "assignee"
                                                }
                                            ],
                                            "concreteType": "JiraJqlFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldValues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlFieldValueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "id"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlUserFieldValue"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldValues(first:100,jqlTerm:\"assignee\")"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eac3ae0c1af4c562b2f8c4ef87c13e9380d10a9063b7f3c57dfc05d73706bb4a",
            "metadata": {},
            "name": "JQLBuilderWithAIFilterRefinementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7fc3470762a0a247$var$node.hash = "0143d483589ea0ca8646e9717dc2ce36";
var $7fc3470762a0a247$export$2e2bcd8739ae039 = $7fc3470762a0a247$var$node;

});

parcelRegister("2HIMw", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $bdc751863d77333a$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $bdc751863d77333a$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $bdc751863d77333a$export$1b65799bbeba8a33);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY", () => $bdc751863d77333a$export$2609791ed67e6247);
$parcel$export(module.exports, "defaultOrderFields", () => $bdc751863d77333a$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $bdc751863d77333a$export$73034536b9adc928);
const $bdc751863d77333a$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $bdc751863d77333a$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $bdc751863d77333a$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $bdc751863d77333a$export$2609791ed67e6247 = 'ISSUE_NAVIGATOR_FILTER_REFINEMENT_RELAY';
const $bdc751863d77333a$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $bdc751863d77333a$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("lzktc", function(module, exports) {
$parcel$export(module.exports, "getDefaultJqlGin", () => $cc65a5b5e9f5208f$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $cc65a5b5e9f5208f$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $cc65a5b5e9f5208f$export$b968a035fc2aa57b);
$parcel$export(module.exports, "getIssueSearchInput", () => $cc65a5b5e9f5208f$export$7d76295e85a90b29);
$parcel$export(module.exports, "getHydrateJqlInput", () => $cc65a5b5e9f5208f$export$248650a7f669b084);
$parcel$export(module.exports, "isChromelessRoute", () => $cc65a5b5e9f5208f$export$cc6019019381b4fd);
/* eslint-disable jira/import-whitelist */ 
var $82cqT = parcelRequire("82cqT");

var $2QZBX = parcelRequire("2QZBX");

var $hLPih = parcelRequire("hLPih");

var $iRahl = parcelRequire("iRahl");

var $4NoAT = parcelRequire("4NoAT");

var $2HIMw = parcelRequire("2HIMw");
const $cc65a5b5e9f5208f$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $2HIMw.defaultOrderFields).created} ${(0, $2HIMw.sortDirections).DESC}`;
const $cc65a5b5e9f5208f$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey } = params;
    const { filter: filter, jql: jql, selectedIssue: selectedIssue, groupBy: groupBy, hideDone: hideDone } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $hLPih.getDefaultJql)((0, $2QZBX.toProjectKey)(projectKey)) : $cc65a5b5e9f5208f$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: selectedIssue,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql,
        groupBy: groupBy,
        hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined
    };
};
const $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull = (jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $82cqT.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $hLPih.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    return null;
};
const $cc65a5b5e9f5208f$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? {
        jql: defaultJql
    };
};
const $cc65a5b5e9f5208f$export$7d76295e85a90b29 = (defaultJql, jqlParam, filter, projectKey)=>{
    // When in project scope fallback to searching by last used JQL, otherwise fallback to default JQL.
    const fallback = projectKey ? {
        searchWithLastUsedJql: true
    } : {
        jql: defaultJql
    };
    // Fallback if neither JQL or valid filter parameters have been provided.
    return $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? fallback;
};
const $cc65a5b5e9f5208f$export$248650a7f669b084 = ({ activationId: activationId, cloudId: cloudId, defaultJql: defaultJql, jqlParam: jqlParam, filter: filter, projectKey: projectKey })=>{
    // When in project scope fallback to searching by last used JQL, otherwise fallback to default JQL.
    const fallback = projectKey ? {
        lastUsedJqlForIssueNavigator: {
            list: {
                operationScope: (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE),
                projectKey: projectKey
            }
        }
    } : {
        jql: defaultJql
    };
    // Fallback if neither JQL or valid filter parameters have been provided.
    const result = $cc65a5b5e9f5208f$var$getJqlOrFilterIdOrNull(jqlParam, filter, projectKey) ?? fallback;
    // Hydration API expects filterId in ARI format
    if ('filterId' in result) return {
        filterId: (0, $4NoAT.JiraFilterAri).create({
            siteId: cloudId,
            filterId: result.filterId,
            activationId: activationId
        }).toString()
    };
    return result;
};
const $cc65a5b5e9f5208f$export$cc6019019381b4fd = ({ route: route })=>{
    return route.layout?.isChromeless ?? false;
};

});
parcelRegister("hLPih", function(module, exports) {
$parcel$export(module.exports, "isFilterKey", () => $c803067837d15823$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $c803067837d15823$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $c803067837d15823$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $c803067837d15823$export$821d4141d135e0d0);

var $b5RwB = parcelRequire("b5RwB");

var $iRahl = parcelRequire("iRahl");

var $64ivx = parcelRequire("64ivx");
const $c803067837d15823$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $64ivx.Filters);
const $c803067837d15823$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$c803067837d15823$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $iRahl.DEFAULT_ORDER_FIELD);
    const direction = (0, $iRahl.DEFAULT_SORT_DIRECTION);
    switch((0, $64ivx.Filters)[filter]){
        case (0, $64ivx.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $64ivx.StatusCategoryValues).TO_DO}, ${(0, $64ivx.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $64ivx.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $64ivx.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $64ivx.StatusCategoryValues).TO_DO}, ${(0, $64ivx.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $64ivx.StatusCategoryValues).DONE}`);
            break;
        case (0, $64ivx.Filters).recentlyviewed:
            order = (0, $iRahl.defaultOrderFields).lastviewed;
            break;
        case (0, $64ivx.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).updatedrecently:
            order = (0, $iRahl.defaultOrderFields).updated;
            break;
        case (0, $64ivx.Filters).allissues:
            order = (0, $iRahl.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $c803067837d15823$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $iRahl.DEFAULT_ORDER_FIELD} ${0, $iRahl.DEFAULT_SORT_DIRECTION}`;
const $c803067837d15823$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $b5RwB.parse)(search),
        ...match && match.params
    });
const $c803067837d15823$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("64ivx", function(module, exports) {
$parcel$export(module.exports, "Filters", () => $c7fcd0af44be8211$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $c7fcd0af44be8211$export$72d6e2acce8f36fd);
const $c7fcd0af44be8211$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $c7fcd0af44be8211$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});





parcelRegister("d4NVH", function(module, exports) {
$parcel$export(module.exports, "getRouteReporting", () => $3aaa8bb9c2bc5949$export$1300cb25a03c28fe);
const $3aaa8bb9c2bc5949$export$1300cb25a03c28fe = ()=>({
        id: 'issue-navigator',
        packageName: 'issueNavigator',
        teamName: 'empanada'
    });

});

parcelRegister("dq5jm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9029fb076dae25f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
const $e9029fb076dae25f$var$GinBrowseIssuesRedirect = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};
var $e9029fb076dae25f$export$2e2bcd8739ae039 = $e9029fb076dae25f$var$GinBrowseIssuesRedirect;

});

parcelRegister("fYGKn", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorGinRedirectPageEntryPoint", () => $f8b6617ed5804749$export$f0e4197c4e8c99ac);
$parcel$export(module.exports, "globalIssueNavigatorPageEntryPoint", () => $f8b6617ed5804749$export$b1fc7a6fa07a8b5c);
$parcel$export(module.exports, "issueNavigatorPageEntryPoint", () => $f8b6617ed5804749$export$b75ca1c5551bc52f);
$parcel$export(module.exports, "issueNavigatorPageEntryPointWithNested", () => $f8b6617ed5804749$export$6f6d14ffd6415d3f);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPoint", () => $f8b6617ed5804749$export$ebe022658b1c5d7a);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPoint", () => $f8b6617ed5804749$export$a90e8f2ed95763c3);
$parcel$export(module.exports, "issueNavigatorEmbedPageEntryPoint", () => $f8b6617ed5804749$export$650aa18210eea5a8);
$parcel$export(module.exports, "LazyGlobalIssueNavigator", () => $f8b6617ed5804749$export$8ff267588532c2ce);

var $3MgfG = parcelRequire("3MgfG");

var $bQWwW = parcelRequire("bQWwW");

var $j3LTu = parcelRequire("j3LTu");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $4ZT9l = parcelRequire("4ZT9l");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");

var $eaAW8 = parcelRequire("eaAW8");

var $aDQ9G = parcelRequire("aDQ9G");

var $efo1i = parcelRequire("efo1i");
const $f8b6617ed5804749$export$f0e4197c4e8c99ac = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aDQ9G.globalIssueNavigatorGinRedirectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $f8b6617ed5804749$export$b1fc7a6fa07a8b5c = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eaAW8.globalIssueNavigatorEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS
});
const $f8b6617ed5804749$export$b75ca1c5551bc52f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j3LTu.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $f8b6617ed5804749$export$6f6d14ffd6415d3f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j3LTu.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $f8b6617ed5804749$export$ebe022658b1c5d7a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j3LTu.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f8b6617ed5804749$export$a90e8f2ed95763c3 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $efo1i.issueNavigatorPinRedirectEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f8b6617ed5804749$export$650aa18210eea5a8 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $4ZT9l.issueNavigatorEmbedEntrypoint)
});

const $f8b6617ed5804749$export$8ff267588532c2ce = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7at6T")), {
    moduleId: "./src/packages/spa-apps/issue-navigator/global-issue-navigator/src/index.tsx"
});

});
parcelRegister("j3LTu", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorEntrypoint", () => $4cef8257e9e53d42$export$4ec136b0c737540b);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $gvzJT = parcelRequire("gvzJT");

var $4cTDP = parcelRequire("4cTDP");

var $4G2FD = parcelRequire("4G2FD");

const $4cef8257e9e53d42$export$4ec136b0c737540b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eESJn")), {
        moduleId: "7afd1266",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.query?.selectedIssue;
        let preloadProps = {};
        // exclude nativeIssueTableEntryPoint and jqlBuilderWithAiEntryPoint from preloading on the issue route
        if (!issueKey) preloadProps = {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...(0, $4cTDP.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                    jqlBuilderWithAiEntryPoint: {
                        entryPoint: (0, $4G2FD.jqlBuilderWithAiEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
        return preloadProps;
    }
});

});
parcelRegister("gvzJT", function(module, exports) {
$parcel$export(module.exports, "nativeIssueTableEntryPoint", () => $80cad17c8d3185b4$export$df35b18d762f614);

var $3Bzqe = parcelRequire("3Bzqe");

var $hu2rE = parcelRequire("hu2rE");

const $80cad17c8d3185b4$export$df35b18d762f614 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8ID8C")).then((module)=>module.NativeIssueTableEntryPoint), {
        moduleId: "d4cb6264",
        moduleName: "NativeIssueTableWithSelectedIssuesProvider",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8ID8C", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("jr04i")
]).then(()=>parcelRequire('3CqQm'));

});


parcelRegister("4G2FD", function(module, exports) {
$parcel$export(module.exports, "jqlBuilderWithAiEntryPoint", () => $fd934fe77cb1c7d8$export$43f8e092231523ab);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $fd934fe77cb1c7d8$export$43f8e092231523ab = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("fHcRZ")).then((module)=>module.JQLBuilderWithAIEntryPoint), {
        moduleId: "ba3f75c6",
        moduleName: "JQLBuilderWithAI",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: false
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fHcRZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iuOzF").then(()=>parcelRequire('3rNQG'));

});


parcelRegister("eESJn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('initialise_virtualiser_state_from_relay_store', function() {
        return Promise.all([
            $ewTvA("h9R5C")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2VWwz")
        ]);
    }),
    $ewTvA("d9fW6")
]).then(()=>parcelRequire('irimY'));

});


parcelRegister("4ZT9l", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorEmbedEntrypoint", () => $8f24b95b321d46e3$export$407d940f927eac56);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $gvzJT = parcelRequire("gvzJT");

const $8f24b95b321d46e3$export$407d940f927eac56 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2rIOm")), {
        moduleId: "9aa91f84",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("2rIOm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('initialise_virtualiser_state_from_relay_store', function() {
        return Promise.all([
            $ewTvA("h9R5C")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2VWwz")
        ]);
    }),
    $ewTvA("dDaHd")
]).then(()=>parcelRequire('78wo9'));

});


parcelRegister("eaAW8", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorEntryPoint", () => $ce5c836c382687ef$export$79ac0647e40ae809);

var $gvzJT = parcelRequire("gvzJT");

var $4cTDP = parcelRequire("4cTDP");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4G2FD = parcelRequire("4G2FD");

const $ce5c836c382687ef$export$79ac0647e40ae809 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("7at6T")), {
        moduleId: "c478d9ce",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        if (!(0, $4cTDP.fg)('nin_remove_global_scope_enrolment')) return {};
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        return {
            entryPoints: {
                ...!issueKey ? {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    },
                    ...(0, $4cTDP.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                        jqlBuilderWithAiEntryPoint: {
                            entryPoint: (0, $4G2FD.jqlBuilderWithAiEntryPoint),
                            entryPointParams: entryPointParams
                        }
                    } : {}
                } : {}
            }
        };
    }
});

});
parcelRegister("7at6T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('initialise_virtualiser_state_from_relay_store', function() {
        return Promise.all([
            $ewTvA("h9R5C")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2VWwz")
        ]);
    }),
    $ewTvA("1BOU4")
]).then(()=>parcelRequire('2vRh2'));

});


parcelRegister("aDQ9G", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorGinRedirectEntrypoint", () => $64b31bdc90c786b5$export$3185a5139b079ec0);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $eaAW8 = parcelRequire("eaAW8");

var $gvzJT = parcelRequire("gvzJT");

var $4cTDP = parcelRequire("4cTDP");

var $4G2FD = parcelRequire("4G2FD");

const $64b31bdc90c786b5$export$3185a5139b079ec0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jj2BY")), {
        moduleId: "e648b5f0",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        return {
            entryPoints: {
                globalIssueNavigatorEntryPoint: {
                    entryPoint: (0, $eaAW8.globalIssueNavigatorEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...!issueKey ? {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $gvzJT.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    },
                    ...(0, $4cTDP.fg)('jql_builder_basic_ssr_stability_fixes') ? {
                        jqlBuilderWithAiEntryPoint: {
                            entryPoint: (0, $4G2FD.jqlBuilderWithAiEntryPoint),
                            entryPointParams: entryPointParams
                        }
                    } : {}
                } : {}
            }
        };
    }
});

});
parcelRegister("jj2BY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2jC6U").then(()=>parcelRequire('3xzAj'));

});


parcelRegister("efo1i", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorPinRedirectEntrypoint", () => $ed4ca92ea727ad31$export$cc17cd3f65b3828f);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $ed4ca92ea727ad31$export$cc17cd3f65b3828f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("l27JC")), {
        moduleId: "8d4a4d33",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: false
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l27JC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cHuTU").then(()=>parcelRequire('jLUA6'));

});




parcelRegister("cZnHb", function(module, exports) {
$parcel$export(module.exports, "globalMailSettingsRouteEntry", () => $2142508b82594168$export$5e1236665a530df4);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $75uKm = parcelRequire("75uKm");

var $ZL6Qq = parcelRequire("ZL6Qq");

var $eGZWT = parcelRequire("eGZWT");
const $2142508b82594168$export$5e1236665a530df4 = (0, $6xToB.createEntry)((0, $75uKm.globalMailSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.global-mail-settings',
        component: (0, $6qDrV.default)(()=>true, (0, $eGZWT.default), (0, $ZL6Qq.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $eGZWT.LazyGlobalMailSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-global-mail-settings-entries/src/globalMailSettingsRouteEntry.tsx',
                whichExportToUse: 'globalMailSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("75uKm", function(module, exports) {
$parcel$export(module.exports, "globalMailSettingsRoute", () => $48a2ae2426d7fdf5$export$e69b84daf70501b3);
const $48a2ae2426d7fdf5$export$e69b84daf70501b3 = {
    name: 'global-mail-settings',
    path: '/secure/admin/global-mail-settings',
    exact: true
};

});

parcelRegister("ZL6Qq", function(module, exports) {
$parcel$export(module.exports, "default", () => $18c7af094da371c2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7Z2hn = parcelRequire("7Z2hn");
/** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
const $18c7af094da371c2$var$RedirectToLegacyRoutingWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z2hn.default), null);
var $18c7af094da371c2$export$2e2bcd8739ae039 = $18c7af094da371c2$var$RedirectToLegacyRoutingWrapper;

});
parcelRegister("7Z2hn", function(module, exports) {
$parcel$export(module.exports, "default", () => $058bd651131efa09$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $2fNLP = parcelRequire("2fNLP");

var $eSnSE = parcelRequire("eSnSE");

var $jchga = parcelRequire("jchga");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $jJaSe = parcelRequire("jJaSe");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");

var $6JCFc = parcelRequire("6JCFc");
const $058bd651131efa09$var$THRESHOLD = 30000;
const $058bd651131efa09$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
const $058bd651131efa09$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
class $058bd651131efa09$export$836fe1ef2cfde075 extends (0, $eJOHy.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $gRw8I.di)(sessionStorage, $058bd651131efa09$var$sessionStorageProvider, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? Number($058bd651131efa09$var$sessionStorageProvider.get(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.set(redirectPathname, Date.now().toString()) : sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $058bd651131efa09$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $2fNLP.default)(window.location.href, (0, $hWeHP.default));
            const scope = $058bd651131efa09$var$getScopeType(scopeData);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $6JCFc.errorFlag)());
            (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
            return;
        } else (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $058bd651131efa09$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$058bd651131efa09$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)((0, $jchga.default)((0, $4J0ad.default)()($058bd651131efa09$export$836fe1ef2cfde075)));

});
parcelRegister("2fNLP", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $87bb57fd652d51da$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $87bb57fd652d51da$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $jkKE1 = parcelRequire("jkKE1");

var $8L5FN = parcelRequire("8L5FN");

var $6zxj7 = parcelRequire("6zxj7");

var $kgGWj = parcelRequire("kgGWj");
const $87bb57fd652d51da$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $87bb57fd652d51da$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $87bb57fd652d51da$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $87bb57fd652d51da$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $87bb57fd652d51da$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $87bb57fd652d51da$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $87bb57fd652d51da$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $8L5FN.default).some((regex)=>regex.test(url)) || (0, $6zxj7.default).some((regex)=>regex.test(url));
const $87bb57fd652d51da$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $87bb57fd652d51da$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $kgGWj.default).some((route)=>url.match(route)) || $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $87bb57fd652d51da$var$getProjectPageType = (getMeta, url)=>{
    if ($87bb57fd652d51da$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
const $87bb57fd652d51da$var$getScopeData = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $87bb57fd652d51da$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $87bb57fd652d51da$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $87bb57fd652d51da$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $87bb57fd652d51da$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $87bb57fd652d51da$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $jkKE1.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};
var $87bb57fd652d51da$export$2e2bcd8739ae039 = $87bb57fd652d51da$var$getScopeData;

});
parcelRegister("8L5FN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9991dc7a3b0c4326$export$2e2bcd8739ae039);
const $9991dc7a3b0c4326$var$connectRoutes = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];
var $9991dc7a3b0c4326$export$2e2bcd8739ae039 = $9991dc7a3b0c4326$var$connectRoutes;

});

parcelRegister("6zxj7", function(module, exports) {
$parcel$export(module.exports, "default", () => $85420e92e692d947$export$2e2bcd8739ae039);
const $85420e92e692d947$var$projectSettingsConnectRoutes = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];
var $85420e92e692d947$export$2e2bcd8739ae039 = $85420e92e692d947$var$projectSettingsConnectRoutes;

});

parcelRegister("kgGWj", function(module, exports) {
$parcel$export(module.exports, "default", () => $270dbf4ef727859d$export$2e2bcd8739ae039);

var $6zxj7 = parcelRequire("6zxj7");
const $270dbf4ef727859d$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
const $270dbf4ef727859d$var$projectSettingsRoutes = [
    ...$270dbf4ef727859d$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $6zxj7.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];
var $270dbf4ef727859d$export$2e2bcd8739ae039 = $270dbf4ef727859d$var$projectSettingsRoutes;

});


parcelRegister("6JCFc", function(module, exports) {
$parcel$export(module.exports, "errorFlag", () => $c0c08f8506304cea$export$b9a7f1ebeaa76953);

var $7uOn8 = parcelRequire("7uOn8");
const $c0c08f8506304cea$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $7uOn8.messages).title,
        description: (0, $7uOn8.messages).description,
        messageId: 'spa-apps-common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $7uOn8.messages).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});
parcelRegister("7uOn8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4dbc780177456e55$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4dbc780177456e55$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});

});




parcelRegister("eGZWT", function(module, exports) {
$parcel$export(module.exports, "LazyGlobalMailSettings", () => $045882abf78a8f88$export$a133d90b2004a90e);
$parcel$export(module.exports, "default", () => $045882abf78a8f88$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $045882abf78a8f88$export$a133d90b2004a90e = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4A6Et"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
const $045882abf78a8f88$var$AsyncGlobalMailSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $045882abf78a8f88$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });
var $045882abf78a8f88$export$2e2bcd8739ae039 = $045882abf78a8f88$var$AsyncGlobalMailSettings;

});
parcelRegister("4A6Et", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ag0E9").then(()=>parcelRequire('79ZX9'));

});



parcelRegister("ExJeP", function(module, exports) {
$parcel$export(module.exports, "globalPoliciesRouteEntry", () => $ae77252a608218ce$export$2ee2f43d380cc210);

var $8rb87 = parcelRequire("8rb87");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $iRfwO = parcelRequire("iRfwO");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1LKbD = parcelRequire("1LKbD");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $fIZNm = parcelRequire("fIZNm");
const $ae77252a608218ce$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ae77252a608218ce$export$2ee2f43d380cc210 = (0, $6xToB.createEntry)((0, $1LKbD.globalPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $fIZNm.AlertPoliciesComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $8rb87.resources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$ae77252a608218ce$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fIZNm.LazyAlertPolicies)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fIZNm.LazyAlertPolicies)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-policies-entries/src/globalPoliciesRouteEntry.tsx',
                whichExportToUse: 'globalPoliciesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1LKbD", function(module, exports) {
$parcel$export(module.exports, "globalPoliciesRoute", () => $b6a7ef9496c2a629$export$4eb24a8e860a3df7);
const $b6a7ef9496c2a629$export$4eb24a8e860a3df7 = {
    name: 'eoc-policies',
    path: '/jira/settings/products/ops/policies',
    exact: true
};

});


parcelRegister("5CWoo", function(module, exports) {
$parcel$export(module.exports, "globalSettingsContactAdministratorRouteEntry", () => $c47af52924d3b837$export$d213125be8246eea);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $c7iMO = parcelRequire("c7iMO");

var $j37Rv = parcelRequire("j37Rv");
const $c47af52924d3b837$export$d213125be8246eea = (0, $6xToB.createEntry)((0, $c7iMO.globalSettingsContactAdministratorRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.contact-administrator',
        component: (0, $j37Rv.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $j37Rv.LazyContactAdministratorPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-contact-administrator-entries/src/globalSettingsContactAdministratorRouteEntry.tsx',
                whichExportToUse: 'globalSettingsContactAdministratorRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("c7iMO", function(module, exports) {
$parcel$export(module.exports, "globalSettingsContactAdministratorRoute", () => $c6110c9eb362d553$export$146910ddc36bf151);
const $c6110c9eb362d553$export$146910ddc36bf151 = {
    name: 'global-settings-contact-administrator',
    path: '/jira/contact-administrator'
};

});

parcelRegister("j37Rv", function(module, exports) {
$parcel$export(module.exports, "LazyContactAdministratorPage", () => $1c7e31900a7f65b9$export$bf75747a931b9a2b);
$parcel$export(module.exports, "default", () => $1c7e31900a7f65b9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1c7e31900a7f65b9$export$bf75747a931b9a2b = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1p4NY"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/ContactAdministratorPage.tsx"
});
const $1c7e31900a7f65b9$var$AsyncContactAdministratorPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1c7e31900a7f65b9$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });
var $1c7e31900a7f65b9$export$2e2bcd8739ae039 = $1c7e31900a7f65b9$var$AsyncContactAdministratorPage;

});
parcelRegister("1p4NY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1oxe3").then(()=>parcelRequire('2fcAX'));

});



parcelRegister("fBUuA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $ec60de6547af3189$export$d83c2e469d070766);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $2dhyd = parcelRequire("2dhyd");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6ez9p = parcelRequire("6ez9p");

var $5fjzQ = parcelRequire("5fjzQ");

var $bCdza = parcelRequire("bCdza");
const $ec60de6547af3189$export$d83c2e469d070766 = (0, $6xToB.createEntry)((0, $6ez9p.globalSettingsCustomFieldsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.custom-fields-directory',
        component: (0, $bCdza.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $2dhyd.customFieldsDirectoryResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bCdza.LazyCustomFieldsDirectoryAdmin)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-global-settings-custom-fields-entries/src/globalSettingsCustomFieldsRouteEntry.tsx',
                whichExportToUse: 'globalSettingsCustomFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2dhyd", function(module, exports) {
$parcel$export(module.exports, "customFieldsDirectoryResource", () => $513a9bcccb9aa19f$export$3d783f106e15b01a);

var $l1VxS = parcelRequire("l1VxS");


const $513a9bcccb9aa19f$export$3d783f106e15b01a = (0, $l1VxS.createResource)({
    type: (0, $32ac74db0fe7b93d$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("iPuI5"))
});

});
const $32ac74db0fe7b93d$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("iPuI5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2wfqp").then(()=>parcelRequire('8gyyU'));

});


parcelRegister("6ez9p", function(module, exports) {
$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $31dc00f4aa9ce38a$export$45e7d93edcc9507f);
const $31dc00f4aa9ce38a$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};

});

parcelRegister("bCdza", function(module, exports) {
$parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", () => $6150103a26efb44c$export$55a5c16f39a046af);
$parcel$export(module.exports, "default", () => $6150103a26efb44c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $6150103a26efb44c$export$55a5c16f39a046af = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cGR75"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
const $6150103a26efb44c$var$AsyncCustomFieldsDirectoryAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6150103a26efb44c$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });
var $6150103a26efb44c$export$2e2bcd8739ae039 = $6150103a26efb44c$var$AsyncCustomFieldsDirectoryAdmin;

});
parcelRegister("cGR75", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("fliVL"),
    $ewTvA("hV6C1")
]).then(()=>parcelRequire('10sHA'));

});



parcelRegister("3WFhy", function(module, exports) {
$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRouteEntry", () => $67ed067875824d69$export$25dca167915e813c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $1RvYH = parcelRequire("1RvYH");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $b2icQ = parcelRequire("b2icQ");

var $3Kw2I = parcelRequire("3Kw2I");
const $67ed067875824d69$export$25dca167915e813c = (0, $6xToB.createEntry)((0, $b2icQ.globalSettingsEditPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $3Kw2I.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $1RvYH.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3Kw2I.LazyEditPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'gordian'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-permission-schemes-entries/src/globalSettingsEditPermissionSchemesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsEditPermissionSchemesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1RvYH", function(module, exports) {
$parcel$export(module.exports, "editPermissionSchemePageResource", () => $0d614a165a29d166$export$2b6bb2f543863b53);

var $9FYIg = parcelRequire("9FYIg");

var $8njch = parcelRequire("8njch");
const $0d614a165a29d166$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $0d614a165a29d166$export$2b6bb2f543863b53 = (0, $9FYIg.createRelayResource)({
    type: $0d614a165a29d166$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $8njch.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("8njch", function(module, exports) {
$parcel$export(module.exports, "default", () => $a055bae4b70a9780$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf9dd52bff7eb700bc199213f93ee422>>
 * @relayHash 68742a61b838212a798006d6e9c7143f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9dd26f13d3fb1b9e1841f3a7c158f1280d92df4a0e3f0e04a02484bf36dbae88

var $i6iR0 = parcelRequire("i6iR0");
const $a055bae4b70a9780$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "usageType"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "avatarUrl"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9dd26f13d3fb1b9e1841f3a7c158f1280d92df4a0e3f0e04a02484bf36dbae88",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider": (0, $i6iR0.default)
            }
        }
    };
}();
$a055bae4b70a9780$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $a055bae4b70a9780$export$2e2bcd8739ae039 = $a055bae4b70a9780$var$node;

});
parcelRegister("i6iR0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d84dfe0856968003$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $d84dfe0856968003$var$JiraProjectPermissionSupportTeamsRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('support_teams_in_jira_project_permission');
    }
};
var $d84dfe0856968003$export$2e2bcd8739ae039 = $d84dfe0856968003$var$JiraProjectPermissionSupportTeamsRelayProvider;

});



parcelRegister("b2icQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", () => $a857ecd9bcf82c5b$export$d57f448badd0561f);
const $a857ecd9bcf82c5b$export$d57f448badd0561f = {
    name: 'global-settings-issues-edit-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};

});

parcelRegister("3Kw2I", function(module, exports) {
$parcel$export(module.exports, "LazyEditPermissionSchemePage", () => $92a617ea3198921b$export$4549705b02900c32);
$parcel$export(module.exports, "default", () => $92a617ea3198921b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $92a617ea3198921b$export$4549705b02900c32 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hDaZw"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
const $92a617ea3198921b$var$AsyncEditPermissionSchemePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $92a617ea3198921b$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });
var $92a617ea3198921b$export$2e2bcd8739ae039 = $92a617ea3198921b$var$AsyncEditPermissionSchemePage;

});
parcelRegister("hDaZw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cF192").then(()=>parcelRequire('iYTly'));

});



parcelRegister("7T8Ox", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFormDataConnectionsRouteEntry", () => $d873a89f38ef5899$export$d975ee3e4df0b4d2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $8x7Ns = parcelRequire("8x7Ns");

var $7zSPZ = parcelRequire("7zSPZ");

var $g8uYY = parcelRequire("g8uYY");

var $3dKrj = parcelRequire("3dKrj");
const $d873a89f38ef5899$var$jiraAdminProformaDataConnectionsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7zSPZ.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $d873a89f38ef5899$export$d975ee3e4df0b4d2 = (0, $6xToB.createEntry)((0, $8x7Ns.globalSettingsFormDataConnectionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $3dKrj.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3dKrj.LazyProformaJiraDataConnectionsPage)
        ],
        entryPoint () {
            return $d873a89f38ef5899$var$jiraAdminProformaDataConnectionsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-proforma-entries/src/globalSettingsFormDataConnectionsRouteEntry.tsx',
                whichExportToUse: 'globalSettingsFormDataConnectionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8x7Ns", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", () => $5e42bfd1789c4d6a$export$6633247975d81f28);
const $5e42bfd1789c4d6a$export$6633247975d81f28 = {
    name: 'global-settings-issues-form-data-connections',
    path: '/jira/settings/forms/data-connections'
};

});

parcelRegister("7zSPZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bc6056a355a5f25$export$2e2bcd8739ae039);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $2bc6056a355a5f25$var$JiraAdminProformaDataConnectionsEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("5JKj2")), {
        moduleId: "606040fa",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});
var $2bc6056a355a5f25$export$2e2bcd8739ae039 = $2bc6056a355a5f25$var$JiraAdminProformaDataConnectionsEntryPoint;

});
parcelRegister("5JKj2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eZCIf").then(()=>parcelRequire('8gBj2'));

});


parcelRegister("3dKrj", function(module, exports) {
$parcel$export(module.exports, "LazyProformaJiraDataConnectionsPage", () => $0b2318210149c244$export$a81885366284dc75);
$parcel$export(module.exports, "default", () => $0b2318210149c244$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $0b2318210149c244$export$a81885366284dc75 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("62XAH"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
const $0b2318210149c244$var$AsyncProformaJiraDataConnectionsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0b2318210149c244$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });
var $0b2318210149c244$export$2e2bcd8739ae039 = $0b2318210149c244$var$AsyncProformaJiraDataConnectionsPage;

});
parcelRegister("62XAH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j5PkU").then(()=>parcelRequire('1NXaV'));

});



parcelRegister("8H8bx", function(module, exports) {
$parcel$export(module.exports, "globalSettingsGlobalPermissionsRouteEntry", () => $e2bffd4a31205864$export$34203273711b537f);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $iwxpQ = parcelRequire("iwxpQ");

var $g8uYY = parcelRequire("g8uYY");

var $3djv9 = parcelRequire("3djv9");

var $4cTDP = parcelRequire("4cTDP");
const $e2bffd4a31205864$export$34203273711b537f = (0, $6xToB.createEntry)((0, $iwxpQ.globalSettingsGlobalPermissionsRoute), ()=>({
        entryPoint () {
            return (0, $4cTDP.fg)('olympus-global-permissions-fe-modernisation') ? (0, $g8uYY.createPageEntryPoint)({
                main: (0, $3djv9.globalPermissionsEntryPoint),
                topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
            }) : undefined;
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-global-permissions-entries/src/globalSettingsGlobalPermissionsRouteEntry.tsx',
                whichExportToUse: 'globalSettingsGlobalPermissionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iwxpQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", () => $b4c73b5e103a0249$export$236ce89eb737f752);
const $b4c73b5e103a0249$export$236ce89eb737f752 = {
    name: 'global-settings-global-permissions',
    path: '/secure/admin/global-permissions'
};

});

parcelRegister("3djv9", function(module, exports) {
$parcel$export(module.exports, "globalPermissionsEntryPoint", () => $d5127e8829f7f317$export$78f97c5f11781a19);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $1HQsX = parcelRequire("1HQsX");

const $d5127e8829f7f317$export$78f97c5f11781a19 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("BMXyG")), {
        moduleId: "1c80d413",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>({
            queries: {
                main_globalPermissionsAndGrantsQuery: {
                    parameters: $1HQsX.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("1HQsX", function(module, exports) {
$parcel$export(module.exports, "default", () => $93b4393eacfca3c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6bc0203eca174d19e93136aaa69effb5>>
 * @relayHash 82bc2ef57083f105c3a75af0d16ccbb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74ec5247503ef80b21ba3b3cd1d14d9a5bd5e08ee3493586655d4540aac64f4e
const $93b4393eacfca3c3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "main_globalPermissions_GlobalPermissionsTable_globalPermissionGrantsListRef"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionModal_globalPermissions_GrantPermissionDialog"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "74ec5247503ef80b21ba3b3cd1d14d9a5bd5e08ee3493586655d4540aac64f4e",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$93b4393eacfca3c3$var$node.hash = "e6a6814f30a2905d884e00d0e46d4977";
var $93b4393eacfca3c3$export$2e2bcd8739ae039 = $93b4393eacfca3c3$var$node;

});

parcelRegister("BMXyG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cWJo9").then(()=>parcelRequire('e1fke'));

});



parcelRegister("bI8Dj", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemeRouteEntry", () => $6bbc1555fcf02ec3$export$7d7f30b10ed32027);

var $gOSUj = parcelRequire("gOSUj");

var $6xToB = parcelRequire("6xToB");

var $5Hv7B = parcelRequire("5Hv7B");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $cxKOj = parcelRequire("cxKOj");

var $8XpuN = parcelRequire("8XpuN");

var $9NmsS = parcelRequire("9NmsS");

var $enHI7 = parcelRequire("enHI7");

var $5fjzQ = parcelRequire("5fjzQ");

var $g8uYY = parcelRequire("g8uYY");
const $6bbc1555fcf02ec3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gOSUj.globalAdminFieldSchemeEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $6bbc1555fcf02ec3$export$7d7f30b10ed32027 = (0, $6xToB.createEntry)((0, $5Hv7B.globalSettingsIssueFieldSchemeRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-scheme',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $cxKOj.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $cxKOj.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false)) return undefined;
            return $6bbc1555fcf02ec3$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldScheme',
                id: 'globalSettingsIssueFieldScheme',
                teamName: 'Yamato'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-field-schemes-entries/src/globalSettingsIssueFieldSchemeRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueFieldSchemeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gOSUj", function(module, exports) {
$parcel$export(module.exports, "globalAdminFieldSchemeEntryPoint", () => $a0174655b2f0f21c$export$db849352675d81cc);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $jvFHA = parcelRequire("jvFHA");

var $4cTDP = parcelRequire("4cTDP");

var $hN4a6 = parcelRequire("hN4a6");

const $a0174655b2f0f21c$export$db849352675d81cc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gXGC1")), {
        moduleId: "d7333f59",
        moduleName: "FieldSchemeApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>({
            queries: {
                fieldSchemePageQuery: {
                    parameters: (0, $hN4a6.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        schemeId: (0, $4cTDP.fg)('efa_cmp_-_beta_fields_management_features') ? match.params?.schemeId || '' : '',
                        input: {
                            schemeId: match.params?.schemeId || ''
                        },
                        fieldSchemeAri: match.params?.schemeId ? (0, $jvFHA.JiraFieldSchemeAri).create({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            fieldSchemeId: match.params.schemeId
                        }).toString() : ''
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            },
            extraProps: {
                schemeId: match.params?.schemeId || ''
            }
        })
});

});
parcelRegister("jvFHA", function(module, exports) {
$parcel$export(module.exports, "JiraFieldSchemeAri", () => $e34142bbe390fbd4$export$5e44b06409c4e697);

var $k0RMs = parcelRequire("k0RMs");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/field-scheme/manifest.ts
var $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $k0RMs.JiraFieldSchemeAriResourceOwner),
    resourceType: (0, $k0RMs.JiraFieldSchemeAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldSchemeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldSchemeId: /[0-9]+/
    }
};
// src/jira/field-scheme/index.ts
var $e34142bbe390fbd4$export$5e44b06409c4e697 = class _JiraFieldSchemeAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldSchemeId = opts.resourceIdSegmentValues.fieldSchemeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldSchemeId() {
        return this._fieldSchemeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.qualifier,
            platformQualifier: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.resourceOwner,
            resourceType: $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldSchemeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldSchemeId: opts.fieldSchemeId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts);
        return new _JiraFieldSchemeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $e34142bbe390fbd4$var$jiraFieldSchemeAriStaticOpts);
        return new _JiraFieldSchemeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldSchemeId: this.fieldSchemeId
        };
    }
};

});
parcelRegister("k0RMs", function(module, exports) {
$parcel$export(module.exports, "JiraFieldSchemeAriResourceOwner", () => $e91d866f96fb107a$export$8f6ad5e411df9d8);
$parcel$export(module.exports, "JiraFieldSchemeAriResourceType", () => $e91d866f96fb107a$export$6d39bf538961beb4);
// src/jira/field-scheme/types.ts
var $e91d866f96fb107a$export$8f6ad5e411df9d8 = "jira", $e91d866f96fb107a$export$6d39bf538961beb4 = "field-scheme";

});


parcelRegister("hN4a6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f268d54db540699$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3675ab32fd0e509b7f3a23138ed02cd0>>
 * @relayHash 7c35b7c705a2189ec4fdce9b4cc05ca1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12e91db1db4da369d1aa41539383967aae8b59276836b358878b45e80d1c5de3

var $7QMA7 = parcelRequire("7QMA7");

var $iegKI = parcelRequire("iegKI");

var $37Ewn = parcelRequire("37Ewn");
const $4f268d54db540699$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSchemeAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v4 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v5 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "fieldSchemeAri"
        }
    ], v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        },
        v4 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "description"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FieldSchemePageQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "AssociatedFieldsTable"
                },
                {
                    "alias": "fieldSchemeNode",
                    "args": v6 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PageHeaderGroup"
                                }
                            ],
                            "type": "JiraFieldScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "FieldSchemePageQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldSchemeAssociatedFields",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldSchemeAssociatedField",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFieldLocked"
                                        },
                                        {
                                            "concreteType": "JiraIssueFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldSchemeOperations",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSchemeOperations",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldConfig",
                                                    "kind": "LinkedField",
                                                    "name": "fieldConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                v5 /*: any*/ 
                                                            ],
                                                            "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                                                            "kind": "LinkedField",
                                                            "name": "descriptionCustomisations",
                                                            "plural": true,
                                                            "selections": [
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isHighlighted"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldSchemeAssociatedFields"
                },
                {
                    "alias": "fieldSchemeNode",
                    "args": v6 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "schemeId"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectsCount"
                                }
                            ],
                            "type": "JiraFieldScheme"
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "12e91db1db4da369d1aa41539383967aae8b59276836b358878b45e80d1c5de3",
            "metadata": {},
            "name": "FieldSchemePageQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider": (0, $iegKI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider": (0, $7QMA7.default)
            }
        }
    };
}();
$4f268d54db540699$var$node.hash = "da5ebcd1436b86b03226a915f9febb20";
(0, $37Ewn.PreloadableQueryRegistry).set($4f268d54db540699$var$node.params.id, $4f268d54db540699$var$node);
var $4f268d54db540699$export$2e2bcd8739ae039 = $4f268d54db540699$var$node;

});
parcelRegister("7QMA7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6423d738b8a7d28a$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6423d738b8a7d28a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('efa_cmp_-_beta_fields_management_features');
    }
};

});

parcelRegister("iegKI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a61efff598c948b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $7a61efff598c948b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('efa_cmp_-_eap_fast_follow_field_scheme_operations');
    }
};

});


parcelRegister("gXGC1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jU99q").then(()=>parcelRequire('2EEnO'));

});


parcelRegister("5Hv7B", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemeRoute", () => $2f2f824f35a1894a$export$4fa4d1ddd1b89f8e);
const $2f2f824f35a1894a$export$4fa4d1ddd1b89f8e = {
    name: 'global-settings-issues-field-scheme',
    path: '/jira/settings/issues/field-schemes/:schemeId',
    exact: true
};

});


parcelRegister("4cnHJ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesConfigRouteEntry", () => $f3ec35f184053727$export$dc59f583c700b3f9);

var $eJOHy = parcelRequire("eJOHy");

var $krv4o = parcelRequire("krv4o");

var $6xToB = parcelRequire("6xToB");

var $eKVJl = parcelRequire("eKVJl");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $cxKOj = parcelRequire("cxKOj");

var $9NmsS = parcelRequire("9NmsS");

var $enHI7 = parcelRequire("enHI7");

var $5fjzQ = parcelRequire("5fjzQ");

var $g8uYY = parcelRequire("g8uYY");

var $7Gdao = parcelRequire("7Gdao");
const $f3ec35f184053727$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $krv4o.globalAdminFieldSchemesEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $f3ec35f184053727$export$dc59f583c700b3f9 = (0, $6xToB.createEntry)((0, $eKVJl.globalSettingsIssueFieldSchemesConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-schemes',
        layout: (0, $yRJUA.globalSettingsLayout),
        skeleton: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Gdao.FieldSchemesSkeleton), null);
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $cxKOj.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $cxKOj.expValEquals)('jira_efa_for_cmp_m2_experiment', 'isEnabled', true, false)) return undefined;
            return $f3ec35f184053727$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldSchemes',
                id: 'globalSettingsIssueFieldSchemes',
                teamName: 'Yamato'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-field-schemes-entries/src/globalSettingsIssueFieldSchemesConfigRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueFieldSchemesConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("krv4o", function(module, exports) {
$parcel$export(module.exports, "globalAdminFieldSchemesEntryPoint", () => $308e5ccaf71ed4b7$export$7f6007a9ef27a05a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $c47Z4 = parcelRequire("c47Z4");

const $308e5ccaf71ed4b7$export$7f6007a9ef27a05a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hse6h")), {
        moduleId: "b162d4e3",
        moduleName: "FieldSchemesApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                pageQueryRef: {
                    parameters: (0, $c47Z4.default),
                    variables: {
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("c47Z4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc76d5c13c36939f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d65bc9855a9672d7fd743f95b3366c18>>
 * @relayHash cec6ffb355a5b2cc196fb8b55fa54ecc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7739a46bbf06695acfa71b74b99e7d85fe083d19c17db079e2f464295d9d962f

var $37Ewn = parcelRequire("37Ewn");
const $bc76d5c13c36939f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FieldSchemesAppQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FieldSchemesPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FieldSchemesAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraFieldSchemesConnection",
                    "kind": "LinkedField",
                    "name": "jira_fieldSchemes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraFieldSchemesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraFieldScheme",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "schemeId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldsCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectsCount"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "fieldSchemesTable_adminPagesFieldSchemes_jira_fieldSchemes",
                    "kind": "LinkedHandle",
                    "name": "jira_fieldSchemes"
                }
            ]
        },
        "params": {
            "id": "7739a46bbf06695acfa71b74b99e7d85fe083d19c17db079e2f464295d9d962f",
            "metadata": {},
            "name": "FieldSchemesAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bc76d5c13c36939f$var$node.hash = "5d849fa3dc746f78acf5e0a8b2791820";
(0, $37Ewn.PreloadableQueryRegistry).set($bc76d5c13c36939f$var$node.params.id, $bc76d5c13c36939f$var$node);
var $bc76d5c13c36939f$export$2e2bcd8739ae039 = $bc76d5c13c36939f$var$node;

});

parcelRegister("hse6h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cridM").then(()=>parcelRequire('flVrS'));

});


parcelRegister("eKVJl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesConfigRoute", () => $02c18caf632c9e77$export$9c41d0c6d3034d6a);
const $02c18caf632c9e77$export$9c41d0c6d3034d6a = {
    name: 'global-settings-issues-field-schemes',
    path: '/jira/settings/issues/field-schemes',
    exact: true
};

});

parcelRegister("7Gdao", function(module, exports) {
$parcel$export(module.exports, "FieldSchemesSkeleton", () => $3a9cdb21f2ed4208$export$7e38a517468c73e2);
/* FieldSchemesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $44Lmf = parcelRequire("44Lmf");
const $3a9cdb21f2ed4208$export$7e38a517468c73e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($44Lmf)))
    });

});
parcelRegister("44Lmf", function(module, exports) {
module.exports = new URL("field-schemes-app-skeleton.tpl.0f9ec3c8.svg", import.meta.url).toString();

});



parcelRegister("g6DXA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRouteEntry", () => $6fe289a5c8346640$export$d76b41f577aeeba5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gNr7h = parcelRequire("gNr7h");

var $5fjzQ = parcelRequire("5fjzQ");

var $dakbt = parcelRequire("dakbt");
const $6fe289a5c8346640$export$d76b41f577aeeba5 = (0, $6xToB.createEntry)((0, $gNr7h.globalSettingsIssueFieldSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $dakbt.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dakbt.LazyScreenSchemesPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-screens-entries/src/globalSettingsIssueFieldSchemesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueFieldSchemesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gNr7h", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", () => $67e9e57c0011a18b$export$3c5a0cf6ecc1bdf1);
const $67e9e57c0011a18b$export$3c5a0cf6ecc1bdf1 = {
    name: 'global-settings-issues-field-schemes-view',
    path: '/jira/settings/issues/screen-schemes'
};

});

parcelRegister("dakbt", function(module, exports) {
$parcel$export(module.exports, "LazyScreenSchemesPage", () => $fde5fd2e5864e1ea$export$342ae41503f611f1);
$parcel$export(module.exports, "default", () => $fde5fd2e5864e1ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fde5fd2e5864e1ea$export$342ae41503f611f1 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("0wf4P"))), {
    moduleId: "./src/packages/admin-pages/screen-schemes-page/src/ScreenSchemesPage.tsx"
});
const $fde5fd2e5864e1ea$var$AsyncScreenSchemesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fde5fd2e5864e1ea$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });
var $fde5fd2e5864e1ea$export$2e2bcd8739ae039 = $fde5fd2e5864e1ea$var$AsyncScreenSchemesPage;

});
parcelRegister("0wf4P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lLinc").then(()=>parcelRequire('gOEPf'));

});



parcelRegister("tNfGA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldScreensRouteEntry", () => $8b6063e622d9269c$export$ea08b1064c32ddb2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jtpSO = parcelRequire("jtpSO");

var $5fjzQ = parcelRequire("5fjzQ");

var $iSul8 = parcelRequire("iSul8");
const $8b6063e622d9269c$export$ea08b1064c32ddb2 = (0, $6xToB.createEntry)((0, $jtpSO.globalSettingsIssueFieldScreensRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screens',
        component: (0, $iSul8.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iSul8.LazyScreensPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-screens-entries/src/globalSettingsIssueFieldScreensRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueFieldScreensRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jtpSO", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", () => $8315e11698b1e326$export$197fd5d0ee709ca4);
const $8315e11698b1e326$export$197fd5d0ee709ca4 = {
    name: 'global-settings-issues-field-screens',
    path: '/jira/settings/issues/screens'
};

});

parcelRegister("iSul8", function(module, exports) {
$parcel$export(module.exports, "LazyScreensPage", () => $4697a3feba66eb2e$export$f4e6d546d7f2894c);
$parcel$export(module.exports, "default", () => $4697a3feba66eb2e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4697a3feba66eb2e$export$f4e6d546d7f2894c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("d5utZ"))), {
    moduleId: "./src/packages/admin-pages/screens-page/src/ScreensPage.tsx"
});
const $4697a3feba66eb2e$var$AsyncScreensPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4697a3feba66eb2e$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });
var $4697a3feba66eb2e$export$2e2bcd8739ae039 = $4697a3feba66eb2e$var$AsyncScreensPage;

});
parcelRegister("d5utZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fgKjC").then(()=>parcelRequire('1JPa1'));

});



parcelRegister("4szwi", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntry", () => $5996c7f300dc44ce$export$b0811d27c1832ea1);

var $bFq8y = parcelRequire("bFq8y");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dwx3R = parcelRequire("dwx3R");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");

var $cxKOj = parcelRequire("cxKOj");
const $5996c7f300dc44ce$var$globalSettingsIssueFieldsManagementEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bFq8y.globalSettingsIssueFieldsManagementRouteEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $5996c7f300dc44ce$export$b0811d27c1832ea1 = (0, $6xToB.createEntry)((0, $dwx3R.globalSettingsIssueFieldsManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.fields',
        component: (0, $9BJU1.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $cxKOj.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint () {
            if ((0, $cxKOj.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false)) return $5996c7f300dc44ce$var$globalSettingsIssueFieldsManagementEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-fields-entries/src/globalSettingsIssueFieldsManagementRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueFieldsManagementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bFq8y", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntryPoint", () => $491ee30ab2427cbf$export$b2a8ea978923a786);
// entrypoint.tsx

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $3IzLt = parcelRequire("3IzLt");

var $cxKOj = parcelRequire("cxKOj");

var $eNf3J = parcelRequire("eNf3J");
// Backwards compatibility with old URL params
const $491ee30ab2427cbf$var$CustomFieldStatus = {
    TRASHED: 'trashed',
    ACTIVE: 'active'
};

const $491ee30ab2427cbf$export$b2a8ea978923a786 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("03mIY")), {
        moduleId: "9c77ca70",
        moduleName: "GlobalSettingsAdminPagesFields",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId, isAdmin: isAdmin }, context: { query: query } })=>{
        const sidebarId = query.sidebarId?.toUpperCase();
        const sidebarView = query.sidebarView?.toLowerCase();
        const fieldId = query.fieldId;
        const initialTab = query.customFieldStatus?.toLowerCase() === $491ee30ab2427cbf$var$CustomFieldStatus.TRASHED ? 'deleted' : 'active';
        const preloadFieldNodeId = fieldId ? (()=>{
            try {
                return (0, $3IzLt.JiraFieldConfigurationAri).create({
                    fieldConfigurationId: fieldId,
                    activationId: activationId,
                    siteId: cloudId
                }).toString();
            } catch (error) {
                return '';
            }
        })() : '';
        const fieldScope = (0, $cxKOj.expValEquals)('centralised-fields-show-edit-tmp-exp', 'isEnabled', true, false) ? 'ALL' : 'GLOBAL';
        return {
            queries: {
                globalFields: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $eNf3J.default,
                    variables: {
                        cloudId: cloudId,
                        isAdmin: isAdmin,
                        includeIsForge: (0, $4cTDP.fg)('modify_forge_field_type_display_name') || false,
                        preloadFieldNodeId: preloadFieldNodeId,
                        shouldPreloadField: !!preloadFieldNodeId,
                        includeInstalledByAppName: (0, $4cTDP.fg)('cfm_add_app_name') || false,
                        includeAnalyticsUpgradeShowTmp: (0, $4cTDP.fg)('admin-pages-fields-analytics-upgrade-show-tmp') || false,
                        fieldScope: fieldScope
                    }
                }
            },
            extraProps: {
                initialTab: initialTab,
                sidebarId: sidebarId,
                sidebarView: sidebarView,
                isAdmin: isAdmin,
                fieldNodeId: preloadFieldNodeId
            }
        };
    }
});

});
parcelRegister("3IzLt", function(module, exports) {
$parcel$export(module.exports, "JiraFieldConfigurationAri", () => $2b513944fd8cc80b$export$a3e5f46252df758f);

var $4o1Os = parcelRequire("4o1Os");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/field-configuration/manifest.ts
var $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4o1Os.JiraFieldConfigurationAriResourceOwner),
    resourceType: (0, $4o1Os.JiraFieldConfigurationAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldConfigurationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldConfigurationId: /[a-zA-Z]+(_[0-9]+)?/
    }
};
// src/jira/field-configuration/index.ts
var $2b513944fd8cc80b$export$a3e5f46252df758f = class _JiraFieldConfigurationAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldConfigurationId = opts.resourceIdSegmentValues.fieldConfigurationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldConfigurationId() {
        return this._fieldConfigurationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts.qualifier,
            platformQualifier: $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts.resourceOwner,
            resourceType: $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldConfigurationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldConfigurationId: opts.fieldConfigurationId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts);
        return new _JiraFieldConfigurationAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2b513944fd8cc80b$var$jiraFieldConfigurationAriStaticOpts);
        return new _JiraFieldConfigurationAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldConfigurationId: this.fieldConfigurationId
        };
    }
};

});
parcelRegister("4o1Os", function(module, exports) {
$parcel$export(module.exports, "JiraFieldConfigurationAriResourceOwner", () => $331acf52468505b3$export$b0ece3f43f00d97a);
$parcel$export(module.exports, "JiraFieldConfigurationAriResourceType", () => $331acf52468505b3$export$f045a5ec770d79b7);
// src/jira/field-configuration/types.ts
var $331acf52468505b3$export$b0ece3f43f00d97a = "jira", $331acf52468505b3$export$f045a5ec770d79b7 = "field-configuration";

});


parcelRegister("eNf3J", function(module, exports) {
$parcel$export(module.exports, "default", () => $762d8170a9b40fc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<915ccfdb9827d09de26f82508c5f645f>>
 * @relayHash 2bdfda8629ba5a2d466e6b228eac05f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84853bbd61f0143a528d0dd13ec13ee60706a3d15a2cac4b13e1aa281a49740d
const $762d8170a9b40fc1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "84853bbd61f0143a528d0dd13ec13ee60706a3d15a2cac4b13e1aa281a49740d",
        "metadata": {},
        "name": "FieldsPageViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $762d8170a9b40fc1$export$2e2bcd8739ae039 = $762d8170a9b40fc1$var$node;

});

parcelRegister("03mIY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("1ZGwi")
]).then(()=>parcelRequire('aX5Qn'));

});


parcelRegister("dwx3R", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRoute", () => $bb3d1e7348ae7593$export$6e571c84819449f5);
const $bb3d1e7348ae7593$export$6e571c84819449f5 = {
    name: 'global-settings-issues-fields-management-view',
    path: '/jira/settings/issues/fields'
};

});


parcelRegister("f7XdL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRouteEntry", () => $c891a70b2c398d64$export$ce3302d254f9c0b4);

var $eJOHy = parcelRequire("eJOHy");

var $9UxDS = parcelRequire("9UxDS");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gL0pr = parcelRequire("gL0pr");

var $7fTjp = parcelRequire("7fTjp");

var $iOCyz = parcelRequire("iOCyz");
const $c891a70b2c398d64$export$ce3302d254f9c0b4 = (0, $6xToB.createEntry)((0, $gL0pr.globalSettingsIssueHierarchyRedirectRoute), ()=>({
        group: 'global-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $9UxDS.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iOCyz.LazyIssueHierarchyDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-issue-types-entries/src/globalSettingsIssueHierarchyRedirectRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueHierarchyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gL0pr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $845130a82495e6e3$export$6236a41e09bb858a);
const $845130a82495e6e3$export$6236a41e09bb858a = {
    name: 'global-settings-issues-hierarchy-redirect',
    path: '/secure/PortfolioHierarchy.jspa'
};

});

parcelRegister("iOCyz", function(module, exports) {
$parcel$export(module.exports, "LazyIssueHierarchyDirectory", () => $817cd99bb93ca89e$export$1ff7255ab4f7a2dd);
$parcel$export(module.exports, "default", () => $817cd99bb93ca89e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $817cd99bb93ca89e$export$1ff7255ab4f7a2dd = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5XnON"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
const $817cd99bb93ca89e$var$AsyncIssueHierarchyDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $817cd99bb93ca89e$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });
var $817cd99bb93ca89e$export$2e2bcd8739ae039 = $817cd99bb93ca89e$var$AsyncIssueHierarchyDirectory;

});
parcelRegister("5XnON", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jTMXJ").then(()=>parcelRequire('7BQsk'));

});



parcelRegister("goUY1", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRouteEntry", () => $e8f24026c3471cba$export$119e5b48edcee4ff);

var $9UxDS = parcelRequire("9UxDS");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $kFp0r = parcelRequire("kFp0r");

var $5fjzQ = parcelRequire("5fjzQ");

var $iOCyz = parcelRequire("iOCyz");
const $e8f24026c3471cba$export$119e5b48edcee4ff = (0, $6xToB.createEntry)((0, $kFp0r.globalSettingsIssueHierarchyRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $iOCyz.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $9UxDS.issueHierarchyPageResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iOCyz.LazyIssueHierarchyDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-issue-types-entries/src/globalSettingsIssueHierarchyRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueHierarchyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kFp0r", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $e6c6cf3d092abfdf$export$2c220ed11ae62e14);
const $e6c6cf3d092abfdf$export$2c220ed11ae62e14 = {
    name: 'global-settings-issues-hierarchy-view',
    path: '/jira/settings/issues/issue-hierarchy'
};

});


parcelRegister("cpLuR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $254ce9d765bbe306$export$5519b86c9ea602e1);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jbTNU = parcelRequire("jbTNU");

var $8zfV8 = parcelRequire("8zfV8");
const $254ce9d765bbe306$export$5519b86c9ea602e1 = (0, $6xToB.createEntry)((0, $jbTNU.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        component: (0, $8zfV8.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8zfV8.LazyExplicitFieldsProjectListPromise)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-global-settings-issues-explicit-field-association-entries/src/globalSettingsIssuesExplicitFieldAssociationRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssuesExplicitFieldAssociationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jbTNU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $1855163d6f79197b$export$4f2c2d125c2b811a);
const $1855163d6f79197b$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("8zfV8", function(module, exports) {
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $fb333efc50c60ea2$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $fb333efc50c60ea2$export$e81c180c4f4833e);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $1F9cm = parcelRequire("1F9cm");

const $fb333efc50c60ea2$export$7b11685155ada84d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3xPh7")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
const $fb333efc50c60ea2$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fb333efc50c60ea2$export$7b11685155ada84d,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});


parcelRegister("5KbgO", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRouteEntry", () => $d84cdb0f414aa0e8$export$ecfeb067cb61f7f7);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9bTfr = parcelRequire("9bTfr");

var $5fjzQ = parcelRequire("5fjzQ");

var $4b89B = parcelRequire("4b89B");
const $d84cdb0f414aa0e8$export$ecfeb067cb61f7f7 = (0, $6xToB.createEntry)((0, $9bTfr.globalSettingsIssuesNewIssueSearchRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $4b89B.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4b89B.LazyNewIssueSearchTransition)
        ],
        canTransitionIn: ()=>true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-new-issue-features-entries/src/globalSettingsIssuesNewIssueSearchRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssuesNewIssueSearchRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9bTfr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", () => $10a8d73ad8a06398$export$774dc60e785b8ae8);
const $10a8d73ad8a06398$export$774dc60e785b8ae8 = {
    name: 'global-settings-issues-new-issue-search',
    path: '/jira/settings/issues/new-issue-search-transition'
};

});

parcelRegister("4b89B", function(module, exports) {
$parcel$export(module.exports, "LazyNewIssueSearchTransition", () => $41cdd0dc39a15f49$export$aa5e318abd957ad);
$parcel$export(module.exports, "default", () => $41cdd0dc39a15f49$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $41cdd0dc39a15f49$export$aa5e318abd957ad = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3WIry"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
const $41cdd0dc39a15f49$var$AsyncNewIssueSearchTransition = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $41cdd0dc39a15f49$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });
var $41cdd0dc39a15f49$export$2e2bcd8739ae039 = $41cdd0dc39a15f49$var$AsyncNewIssueSearchTransition;

});
parcelRegister("3WIry", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k8xPd").then(()=>parcelRequire('iB9F0'));

});



parcelRegister("d3qbB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $690814e47b18fedb$export$63a56a096ab0d260);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $kHlOR = parcelRequire("kHlOR");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dhkml = parcelRequire("dhkml");

var $5fjzQ = parcelRequire("5fjzQ");

var $1DhCr = parcelRequire("1DhCr");
const $690814e47b18fedb$export$63a56a096ab0d260 = (0, $6xToB.createEntry)((0, $dhkml.globalSettingsIssuesPrioritiesRoute), ()=>({
        group: 'global-settings',
        component: (0, $1DhCr.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1DhCr.LazyPrioritiesPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-priorities-entries/src/globalSettingsIssuesPrioritiesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssuesPrioritiesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dhkml", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $bca045faab5c8bda$export$518516cdf6b7cd83);
const $bca045faab5c8bda$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("1DhCr", function(module, exports) {
$parcel$export(module.exports, "LazyPrioritiesPage", () => $2d85bab79423bf6e$export$2b5843205130631c);
$parcel$export(module.exports, "default", () => $2d85bab79423bf6e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $2d85bab79423bf6e$export$2b5843205130631c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("g4SCA"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/PrioritiesPageWrapper.tsx"
});
const $2d85bab79423bf6e$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2d85bab79423bf6e$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $2d85bab79423bf6e$export$2e2bcd8739ae039 = $2d85bab79423bf6e$var$PrioritiesPage;

});
parcelRegister("g4SCA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8UB5T").then(()=>parcelRequire('aGJF2'));

});



parcelRegister("kLk7C", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRouteEntry", () => $75a2806a58bbbdbf$export$a5ac2a64ed09e754);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fKd3N = parcelRequire("fKd3N");

var $5fjzQ = parcelRequire("5fjzQ");

var $9Bh0G = parcelRequire("9Bh0G");
const $75a2806a58bbbdbf$export$a5ac2a64ed09e754 = (0, $6xToB.createEntry)((0, $fKd3N.globalSettingsIssuesPrioritySchemesRoute), ()=>({
        group: 'global-settings',
        component: (0, $9Bh0G.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $9Bh0G.LazyPrioritySchemes)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-priorities-entries/src/globalSettingsIssuesPrioritySchemesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssuesPrioritySchemesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fKd3N", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $406083e41b689f52$export$185af30f53271c10);
const $406083e41b689f52$export$185af30f53271c10 = {
    name: 'global-settings-issues-priority-schemes',
    path: '/jira/settings/issues/priority-schemes'
};

});

parcelRegister("9Bh0G", function(module, exports) {
$parcel$export(module.exports, "LazyPrioritySchemes", () => $023d8f15f5c6ff64$export$20bb8a3b40a3add4);
$parcel$export(module.exports, "default", () => $023d8f15f5c6ff64$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $023d8f15f5c6ff64$export$20bb8a3b40a3add4 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dPlCf"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/PrioritySchemesPage.tsx"
});
const $023d8f15f5c6ff64$var$AsyncPrioritySchemes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $023d8f15f5c6ff64$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });
var $023d8f15f5c6ff64$export$2e2bcd8739ae039 = $023d8f15f5c6ff64$var$AsyncPrioritySchemes;

});
parcelRegister("dPlCf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("45Stc").then(()=>parcelRequire('27Ap3'));

});



parcelRegister("fcC3H", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesRouteEntry", () => $7a35b209d240cbf4$export$680243b058188dc0);

var $aQd2d = parcelRequire("aQd2d");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $EEl9K = parcelRequire("EEl9K");

var $5fjzQ = parcelRequire("5fjzQ");

var $2Gm1W = parcelRequire("2Gm1W");
const $7a35b209d240cbf4$export$680243b058188dc0 = (0, $6xToB.createEntry)((0, $EEl9K.globalSettingsIssueTypesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $2Gm1W.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aQd2d.issueTypesResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $2Gm1W.LazyIssueTypesDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-issue-types-entries/src/globalSettingsIssueTypesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueTypesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aQd2d", function(module, exports) {
$parcel$export(module.exports, "issueTypesResource", () => $db7011dca5aa2f45$export$614e9d897c1ef917);

var $b5RwB = parcelRequire("b5RwB");

var $l1VxS = parcelRequire("l1VxS");

var $11cuC = parcelRequire("11cuC");
const $db7011dca5aa2f45$export$614e9d897c1ef917 = (0, $l1VxS.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $11cuC.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query))
});

});
parcelRegister("11cuC", function(module, exports) {
$parcel$export(module.exports, "getIssueTypes", () => $4c8a2ad35242b006$export$4cf4b24b88599615);

var $b5RwB = parcelRequire("b5RwB");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");


var $al9Id = parcelRequire("al9Id");
const $4c8a2ad35242b006$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $al9Id.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify((0, $al9Id.toApiUrlTransformer)(filter));
    try {
        return await (0, $hgi0g.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $5b2eb79f9ecca7ca$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $5b2eb79f9ecca7ca$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("al9Id", function(module, exports) {
$parcel$export(module.exports, "toUrlTransformer", () => $fbd20387fd24466c$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $fbd20387fd24466c$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $fbd20387fd24466c$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $fbd20387fd24466c$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $fbd20387fd24466c$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $fbd20387fd24466c$export$fb15afa686993f11);

var $6GoxC = parcelRequire("6GoxC");

var $b5RwB = parcelRequire("b5RwB");

var $fFyRs = parcelRequire("fFyRs");

var $6A6fV = parcelRequire("6A6fV");

var $cZUUD = parcelRequire("cZUUD");
const $fbd20387fd24466c$var$HIERARCHY_LEVEL = 'hierarchy-level';
const $fbd20387fd24466c$var$NAME = 'name';
const $fbd20387fd24466c$var$sortDirectionMap = {
    asc: 'ASC',
    desc: 'DESC'
};
const $fbd20387fd24466c$var$sortFieldMap = {
    [$fbd20387fd24466c$var$NAME.toLowerCase()]: $fbd20387fd24466c$var$NAME,
    [$fbd20387fd24466c$var$HIERARCHY_LEVEL.toLowerCase()]: $fbd20387fd24466c$var$HIERARCHY_LEVEL
};
const $fbd20387fd24466c$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $6A6fV.fieldToParam)(filter.sortDirection),
        sortField: (0, $6A6fV.fieldToParam)(filter.sortField),
        searchFilter: (0, $6A6fV.trimSearchFilter)(filter.searchFilter)
    } : {};
const $fbd20387fd24466c$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $fFyRs.number).parse(params.page))) || undefined,
        searchFilter: (0, $6A6fV.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $6A6fV.fieldFromParam)($fbd20387fd24466c$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $6A6fV.fieldFromParam)($fbd20387fd24466c$var$sortFieldMap, params.sortField)
    });
const $fbd20387fd24466c$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $fbd20387fd24466c$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? $fbd20387fd24466c$var$NAME : $fbd20387fd24466c$var$HIERARCHY_LEVEL;
};
const $fbd20387fd24466c$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? 'ASC' : 'DESC';
};
const $fbd20387fd24466c$var$apiSortByMap = {
    ASC: '',
    DESC: '-'
};
const $fbd20387fd24466c$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($6GoxC)))({}, filter, (0, $cZUUD.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $cZUUD.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $cZUUD.MAX_RESULTS),
        query: (0, $6A6fV.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$fbd20387fd24466c$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
parcelRegister("6GoxC", function(module, exports) {

var $l76qh = parcelRequire("l76qh");

var $2wri1 = parcelRequire("2wri1");

var $eA1it = parcelRequire("eA1it");

var $bIi70 = parcelRequire("bIi70");
/** Used for built-in method references. */ var $4dd9b3b5c88f0b8c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4dd9b3b5c88f0b8c$var$hasOwnProperty = $4dd9b3b5c88f0b8c$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $4dd9b3b5c88f0b8c$var$defaults = $l76qh(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $eA1it(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $bIi70(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $2wri1(value, $4dd9b3b5c88f0b8c$var$objectProto[key]) && !$4dd9b3b5c88f0b8c$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $4dd9b3b5c88f0b8c$var$defaults;

});

parcelRegister("fFyRs", function(module, exports) {
$parcel$export(module.exports, "string", () => $009f1d63c21941f0$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $009f1d63c21941f0$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $009f1d63c21941f0$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $009f1d63c21941f0$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $009f1d63c21941f0$export$98e628dec113755e);

var $d7YnM = parcelRequire("d7YnM");
const $009f1d63c21941f0$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($d7YnM))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($d7YnM)))
};
const $009f1d63c21941f0$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $009f1d63c21941f0$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $009f1d63c21941f0$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $009f1d63c21941f0$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("6A6fV", function(module, exports) {
$parcel$export(module.exports, "fieldToParam", () => $b86f8fee9308eaa4$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $b86f8fee9308eaa4$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $b86f8fee9308eaa4$export$ed1722f41c23aaaf);
const $b86f8fee9308eaa4$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $b86f8fee9308eaa4$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $b86f8fee9308eaa4$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("cZUUD", function(module, exports) {
$parcel$export(module.exports, "MAX_RESULTS", () => $bbbf2a5f5cb326df$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $bbbf2a5f5cb326df$export$6deee0e4f2fb784e);
const $bbbf2a5f5cb326df$var$HIERARCHY_LEVEL = 'hierarchy-level';
const $bbbf2a5f5cb326df$export$f6b2881bc1090cea = 15;
const $bbbf2a5f5cb326df$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: 'DESC',
    sortField: $bbbf2a5f5cb326df$var$HIERARCHY_LEVEL
};

});




parcelRegister("EEl9K", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $a015bf0c6e96bc46$export$7358263a3bbb38b1);
const $a015bf0c6e96bc46$export$7358263a3bbb38b1 = {
    name: 'global-settings-issues-types-view',
    path: '/jira/settings/issues/issue-types'
};

});

parcelRegister("2Gm1W", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypesDirectory", () => $13a10676821889fb$export$661e1bf38bb82270);
$parcel$export(module.exports, "default", () => $13a10676821889fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $13a10676821889fb$export$661e1bf38bb82270 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aOpKv"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
const $13a10676821889fb$var$AsyncIssueTypesDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $13a10676821889fb$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });
var $13a10676821889fb$export$2e2bcd8739ae039 = $13a10676821889fb$var$AsyncIssueTypesDirectory;

});
parcelRegister("aOpKv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kzDMQ").then(()=>parcelRequire('drGkM'));

});



parcelRegister("4CAXG", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRouteEntry", () => $ef13d4b0e87cf5f0$export$8f940be66a7e7324);

var $7KhbP = parcelRequire("7KhbP");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gMZln = parcelRequire("gMZln");

var $5fjzQ = parcelRequire("5fjzQ");

var $31U0M = parcelRequire("31U0M");
const $ef13d4b0e87cf5f0$export$8f940be66a7e7324 = (0, $6xToB.createEntry)((0, $gMZln.globalSettingsIssueTypesSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $31U0M.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $7KhbP.default),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $31U0M.LazyIssueTypeSchemesDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-issue-types-entries/src/globalSettingsIssueTypesSchemesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueTypesSchemesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7KhbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7fb0dc4fd3f8bd4$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $l1VxS = parcelRequire("l1VxS");

var $favct = parcelRequire("favct");
const $a7fb0dc4fd3f8bd4$var$ISSUE_TYPE_SCHEME_TABLE_TYPE = 'ISSUE_TYPE_SCHEME_TABLE';
const $a7fb0dc4fd3f8bd4$var$ISSUE_TYPE_SCHEME_TABLE_KEY = 'ISSUE_TYPE_SCHEME_TABLE_KEY';
const $a7fb0dc4fd3f8bd4$var$issueTypeSchemeResource = (0, $l1VxS.createResource)({
    type: $a7fb0dc4fd3f8bd4$var$ISSUE_TYPE_SCHEME_TABLE_TYPE,
    getKey: ({ query: query })=>`${$a7fb0dc4fd3f8bd4$var$ISSUE_TYPE_SCHEME_TABLE_KEY}-${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $favct.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query))
});
var $a7fb0dc4fd3f8bd4$export$2e2bcd8739ae039 = $a7fb0dc4fd3f8bd4$var$issueTypeSchemeResource;

});
parcelRegister("favct", function(module, exports) {
$parcel$export(module.exports, "getIssueTypeSchemes", () => $c1c878dbf2c1f305$export$2844cac611eecaa7);

var $b5RwB = parcelRequire("b5RwB");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $ahzaM = parcelRequire("ahzaM");
const $c1c878dbf2c1f305$var$PACKAGE_NAME = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $c1c878dbf2c1f305$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $ahzaM.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify((0, $ahzaM.toApiUrlTransformer)(filter));
    try {
        return await (0, $3ugTQ.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: $c1c878dbf2c1f305$var$PACKAGE_NAME,
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("ahzaM", function(module, exports) {
$parcel$export(module.exports, "toUrlTransformer", () => $748ee56e020c8ae7$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $748ee56e020c8ae7$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $748ee56e020c8ae7$export$fb15afa686993f11);

var $6GoxC = parcelRequire("6GoxC");

var $fFyRs = parcelRequire("fFyRs");

var $icuCB = parcelRequire("icuCB");

var $cdbDA = parcelRequire("cdbDA");
const $748ee56e020c8ae7$var$MAX_RESULTS = 10;
const $748ee56e020c8ae7$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $748ee56e020c8ae7$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $fFyRs.number).parse(pageNumber)) ? (0, $icuCB.defaultIssueTypeSchemesFilter).pageNumber : (0, $fFyRs.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $icuCB.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $748ee56e020c8ae7$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($6GoxC)))({}, filter, (0, $icuCB.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: $748ee56e020c8ae7$var$MAX_RESULTS,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * $748ee56e020c8ae7$var$MAX_RESULTS,
        orderBy: fullFilter.orderBy,
        queryString: (0, $cdbDA.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("icuCB", function(module, exports) {
$parcel$export(module.exports, "ORDER", () => $62eb6a03ec9c0e94$export$11e75bce9f7ea886);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $62eb6a03ec9c0e94$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $62eb6a03ec9c0e94$export$81a0343467d0e9a9);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $62eb6a03ec9c0e94$export$9ac56b2484c2d4e9);
// analytics constants
const $62eb6a03ec9c0e94$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $62eb6a03ec9c0e94$var$MAX_RESULTS = 10;
const $62eb6a03ec9c0e94$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $62eb6a03ec9c0e94$var$MAX_RESULTS,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: 'DESC'
};
const $62eb6a03ec9c0e94$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $62eb6a03ec9c0e94$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("cdbDA", function(module, exports) {
$parcel$export(module.exports, "trimSearchFilter", () => $63c78c9897094687$export$ed1722f41c23aaaf);
const $63c78c9897094687$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});




parcelRegister("gMZln", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $a2980d6044f25ee6$export$2aba97aa663f43b3);
const $a2980d6044f25ee6$export$2aba97aa663f43b3 = {
    name: 'global-settings-issues-types-schemes-manage',
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("31U0M", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", () => $c8bade2c565be10b$export$611728a54ba37830);
$parcel$export(module.exports, "default", () => $c8bade2c565be10b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c8bade2c565be10b$export$611728a54ba37830 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fJ60j"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
const $c8bade2c565be10b$var$AsyncIssueTypeSchemesDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c8bade2c565be10b$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });
var $c8bade2c565be10b$export$2e2bcd8739ae039 = $c8bade2c565be10b$var$AsyncIssueTypeSchemesDirectory;

});
parcelRegister("fJ60j", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cpX7N").then(()=>parcelRequire('2yAmG'));

});



parcelRegister("kZ7rD", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRouteEntry", () => $519cb5832694145f$export$e2c2c1569887e684);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $cnps2 = parcelRequire("cnps2");

var $5fjzQ = parcelRequire("5fjzQ");

var $35xnd = parcelRequire("35xnd");
const $519cb5832694145f$export$e2c2c1569887e684 = (0, $6xToB.createEntry)((0, $cnps2.globalSettingsIssueTypesScreenSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $35xnd.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $35xnd.LazyIssueTypeScreenSchemesPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-screens-entries/src/globalSettingsIssueTypesScreenSchemesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueTypesScreenSchemesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cnps2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", () => $59a0d82495c94fa6$export$df93a4addc359237);
const $59a0d82495c94fa6$export$df93a4addc359237 = {
    name: 'global-settings-issues-types-screen-schemes-view',
    path: '/jira/settings/issues/issue-type-screen-schemes'
};

});

parcelRegister("35xnd", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", () => $1b60da8c0eeefdc3$export$350edfb57b335a57);
$parcel$export(module.exports, "default", () => $1b60da8c0eeefdc3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1b60da8c0eeefdc3$export$350edfb57b335a57 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dPRna"))), {
    moduleId: "./src/packages/admin-pages/issue-type-screen-schemes-page/src/IssueTypeScreenSchemesPage.tsx"
});
const $1b60da8c0eeefdc3$var$AsyncIssueTypeScreenSchemesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1b60da8c0eeefdc3$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });
var $1b60da8c0eeefdc3$export$2e2bcd8739ae039 = $1b60da8c0eeefdc3$var$AsyncIssueTypeScreenSchemesPage;

});
parcelRegister("dPRna", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eXNo2").then(()=>parcelRequire('4Q4Sb'));

});



parcelRegister("dChQF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflow1RouteEntry", () => $ac67cbf255a22335$export$55e4c1d21a9b75e6);

var $2CTqs = parcelRequire("2CTqs");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fQQ9b = parcelRequire("fQQ9b");

var $5fjzQ = parcelRequire("5fjzQ");

var $du7XD = parcelRequire("du7XD");
const $ac67cbf255a22335$export$55e4c1d21a9b75e6 = (0, $6xToB.createEntry)((0, $fQQ9b.globalSettingsIssueWorkflow1Route), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $du7XD.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $2CTqs.default),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $du7XD.LazyListWorkflows)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-workflows-entries/src/globalSettingsIssueWorkflow1RouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueWorkflow1RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2CTqs", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2e40f5b4c7141ba$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $l1VxS = parcelRequire("l1VxS");

var $gkDaM = parcelRequire("gkDaM");
const $c2e40f5b4c7141ba$var$WORKFLOWS_TABLE_TYPE = 'WORKFLOWS_TABLE';
const $c2e40f5b4c7141ba$var$WORKFLOWS_TABLE_KEY = 'WORKFLOWS_TABLE_KEY';
const $c2e40f5b4c7141ba$var$workFlowsResource = (0, $l1VxS.createResource)({
    type: $c2e40f5b4c7141ba$var$WORKFLOWS_TABLE_TYPE,
    getKey: ({ query: query })=>`${$c2e40f5b4c7141ba$var$WORKFLOWS_TABLE_KEY}-${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $gkDaM.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query))
});
var $c2e40f5b4c7141ba$export$2e2bcd8739ae039 = $c2e40f5b4c7141ba$var$workFlowsResource;

});
parcelRegister("gkDaM", function(module, exports) {
$parcel$export(module.exports, "getListWorkFlows", () => $bd6791a619f977c2$export$952f5d693c3c0d4e);

var $b5RwB = parcelRequire("b5RwB");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $iA3xE = parcelRequire("iA3xE");

var $8ow7L = parcelRequire("8ow7L");
const $bd6791a619f977c2$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $8ow7L.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify((0, $8ow7L.toApiUrlTransformer)(filter));
    try {
        return await (0, $3ugTQ.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $iA3xE.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("iA3xE", function(module, exports) {
$parcel$export(module.exports, "APP_NAME", () => $f01c2193315fcfdc$export$5b6c28c7dca07ad7);
$parcel$export(module.exports, "TEAM_NAME", () => $f01c2193315fcfdc$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SOURCE_NAME", () => $f01c2193315fcfdc$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $f01c2193315fcfdc$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $f01c2193315fcfdc$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $f01c2193315fcfdc$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $f01c2193315fcfdc$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $f01c2193315fcfdc$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $f01c2193315fcfdc$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $f01c2193315fcfdc$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $f01c2193315fcfdc$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $f01c2193315fcfdc$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $f01c2193315fcfdc$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $f01c2193315fcfdc$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $f01c2193315fcfdc$export$a3f6840410eb0571);
const $f01c2193315fcfdc$export$5b6c28c7dca07ad7 = 'jira';
const $f01c2193315fcfdc$export$d57b6b390e78d90f = 'helix';
const $f01c2193315fcfdc$export$a3821bc63538b210 = 'listWorkflows';
const $f01c2193315fcfdc$export$a69699c3acbd94ca = 'workflowName';
const $f01c2193315fcfdc$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $f01c2193315fcfdc$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $f01c2193315fcfdc$export$81c9aaf617cb2f01 = 'workflowScheme';
const $f01c2193315fcfdc$export$615f1d8b29794ae = 'jira';
const $f01c2193315fcfdc$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $f01c2193315fcfdc$export$5716e8bcb003888d = 10;
const $f01c2193315fcfdc$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $f01c2193315fcfdc$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: 'ASC',
    isActive: true
};
const $f01c2193315fcfdc$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $f01c2193315fcfdc$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $f01c2193315fcfdc$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $f01c2193315fcfdc$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("8ow7L", function(module, exports) {
$parcel$export(module.exports, "toUrlTransformer", () => $634531c0df767227$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $634531c0df767227$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $634531c0df767227$export$fb15afa686993f11);

var $fFyRs = parcelRequire("fFyRs");

var $iA3xE = parcelRequire("iA3xE");

var $gcBRP = parcelRequire("gcBRP");
const $634531c0df767227$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $634531c0df767227$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $fFyRs.number).parse(pageNumber)) ? (0, $iA3xE.defaultListWorkFlowsFilter).pageNumber : (0, $fFyRs.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $fFyRs.number).parse(pageSize)) ? (0, $iA3xE.defaultListWorkFlowsFilter).pageSize : (0, $fFyRs.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $iA3xE.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $iA3xE.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $634531c0df767227$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $iA3xE.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $iA3xE.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $gcBRP.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("gcBRP", function(module, exports) {
$parcel$export(module.exports, "trimSearchFilter", () => $2cc214d06d353218$export$ed1722f41c23aaaf);
const $2cc214d06d353218$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});




parcelRegister("fQQ9b", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", () => $b90ccaaf01661e08$export$f8f2a617a2f4d53);
const $b90ccaaf01661e08$export$f8f2a617a2f4d53 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/jira/settings/issues/workflows'
};

});

parcelRegister("du7XD", function(module, exports) {
$parcel$export(module.exports, "LazyListWorkflows", () => $8182e561fb9b3513$export$4c64b4f1ecf22fc8);
$parcel$export(module.exports, "default", () => $8182e561fb9b3513$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8182e561fb9b3513$export$4c64b4f1ecf22fc8 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("61wqj"))), {
    moduleId: "./src/packages/admin-pages/list-workflows/src/ListWorkflows.tsx"
});
const $8182e561fb9b3513$var$AsyncListWorkflows = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8182e561fb9b3513$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });
var $8182e561fb9b3513$export$2e2bcd8739ae039 = $8182e561fb9b3513$var$AsyncListWorkflows;

});
parcelRegister("61wqj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hnfnt").then(()=>parcelRequire('al4ZP'));

});



parcelRegister("67YRM", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRouteEntry", () => $aa12078081d7bc2e$export$d2b3121978e344e);

var $94ry1 = parcelRequire("94ry1");

var $1pIK1 = parcelRequire("1pIK1");

var $kHlOR = parcelRequire("kHlOR");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $7K5Ea = parcelRequire("7K5Ea");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $h6n7A = parcelRequire("h6n7A");

var $5fjzQ = parcelRequire("5fjzQ");

var $6OSA0 = parcelRequire("6OSA0");

var $cxKOj = parcelRequire("cxKOj");

var $kL8k5 = parcelRequire("kL8k5");

var $jS1hO = parcelRequire("jS1hO");

var $cxQGT = parcelRequire("cxQGT");

var $cgXAH = parcelRequire("cgXAH");

var $lb6FK = parcelRequire("lb6FK");

var $4cTDP = parcelRequire("4cTDP");

var $iRrJM = parcelRequire("iRrJM");
const $aa12078081d7bc2e$var$globalSettingsIssueWorkflowEditEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $94ry1.editWorkflowEntryPoint)
});
const $aa12078081d7bc2e$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $cgXAH.workflowBuilderProvisioningResource)
    ];
const $aa12078081d7bc2e$var$getWorkflowUserPreferencesResources = ()=>{
    return (0, $4cTDP.fg)('hix-7520-wfe-user-preferences-resource') ? [
        (0, $1pIK1.workflowUserPreferencesResource)
    ] : [];
};
const $aa12078081d7bc2e$export$d2b3121978e344e = (0, $6xToB.createEntry)((0, $h6n7A.globalSettingsIssueWorkflowEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.edit-workflow',
        entryPoint: ()=>(0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? $aa12078081d7bc2e$var$globalSettingsIssueWorkflowEditEntryPoint : undefined,
        skeleton: (0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? (0, $6OSA0.default) : undefined,
        component: (0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : (0, $iRrJM.default),
        layout: (0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $yRJUA.globalSettingsLayout),
        navigation: (0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: (0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? [
            (0, $kL8k5.workflowCapabilitiesResource),
            (0, $jS1hO.workflowDocumentResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $lb6FK.rovoEntitlementResource),
            ...$aa12078081d7bc2e$var$getWorkflowBuilderProvisioningResources(),
            ...$aa12078081d7bc2e$var$getWorkflowUserPreferencesResources()
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            ...$aa12078081d7bc2e$var$getWorkflowBuilderProvisioningResources(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: (0, $cxKOj.expValEquals)('hix-6586_wfe_no_nav_or_sidebar_route', 'isEnabled', true, false) ? undefined : [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iRrJM.LazyEditWorkflow)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-workflows-entries/src/globalSettingsIssueWorkflowEditRouteEntry.tsx',
                whichExportToUse: 'globalSettingsIssueWorkflowEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("94ry1", function(module, exports) {
$parcel$export(module.exports, "editWorkflowEntryPoint", () => $65b824ae9d379424$export$8173c14a99f6a4bb);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $65b824ae9d379424$export$8173c14a99f6a4bb = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fMlvh")).then((module)=>module.EditWorkflow), {
        moduleId: "9f739006",
        moduleName: "EditWorkflow",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fMlvh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("gMZXG")
]).then(()=>parcelRequire('k9sQt'));

});


parcelRegister("1pIK1", function(module, exports) {
$parcel$export(module.exports, "workflowUserPreferencesResource", () => $35be22a5a4c42ebb$export$dcc0e7a13dca73a4);
$parcel$export(module.exports, "useWorkflowUserPreference", () => $35be22a5a4c42ebb$export$63db1f00a6f1699b);
$parcel$export(module.exports, "useWorkflowUserPreferencesInitialiser", () => $35be22a5a4c42ebb$export$a568f6667d8c2696);
$parcel$export(module.exports, "useCollapseTransitionLabelsPreferenceFromResource", () => $35be22a5a4c42ebb$export$31ee5a83bc933bf);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");


var $3a1bk = parcelRequire("3a1bk");

var $hNTYb = parcelRequire("hNTYb");
const $35be22a5a4c42ebb$var$workflowUserPreferenceKeys = [
    (0, $178730fddc67d086$export$deefa5c1f10c69a0),
    (0, $178730fddc67d086$export$1e110a15789b066c),
    (0, $178730fddc67d086$export$a08cbe94405fa92),
    (0, $178730fddc67d086$export$2ed404c7f997572a)
];
const $35be22a5a4c42ebb$export$dcc0e7a13dca73a4 = (0, $l1VxS.createResource)({
    type: (0, $178730fddc67d086$export$952d335c91f3dcbc),
    getKey: ()=>(0, $178730fddc67d086$export$952d335c91f3dcbc),
    getData: ()=>(0, $3a1bk.getUserPreferences)([
            ...$35be22a5a4c42ebb$var$workflowUserPreferenceKeys
        ]),
    maxAge: 1000,
    isBrowserOnly: true
});
const $35be22a5a4c42ebb$export$63db1f00a6f1699b = (key, options)=>(0, $hNTYb.useUserPreference)($35be22a5a4c42ebb$export$dcc0e7a13dca73a4, key, options);
const $35be22a5a4c42ebb$export$a568f6667d8c2696 = ()=>(0, $hNTYb.useUserPreferencesInitialiser)($35be22a5a4c42ebb$export$dcc0e7a13dca73a4);
const $35be22a5a4c42ebb$export$31ee5a83bc933bf = ()=>{
    const { value: value, setValue: setValue } = $35be22a5a4c42ebb$export$63db1f00a6f1699b((0, $178730fddc67d086$export$2ed404c7f997572a));
    const areTransitionLabelsCollapsed = !value ? true : value === 'true';
    const setTransitionLabelsCollapsed = (0, $eJOHy.useCallback)((collapsed)=>{
        setValue(collapsed.toString());
    }, [
        setValue
    ]);
    return {
        value: areTransitionLabelsCollapsed,
        setValue: setTransitionLabelsCollapsed
    };
};

});
const $178730fddc67d086$export$952d335c91f3dcbc = 'ADMIN_WORKFLOW_USER_PREFERENCES';
const $178730fddc67d086$export$2ed404c7f997572a = 'jira.user.workflow.editor.collapsed.transitions';
const $178730fddc67d086$export$a08cbe94405fa92 = 'jira.user.workflow.editor.list-view';
const $178730fddc67d086$export$deefa5c1f10c69a0 = 'jira.user.workflow.editor.global.scope.enrolment';
const $178730fddc67d086$export$1e110a15789b066c = 'jira.user.workflow.editor.changeboarding-dismissed';

parcelRegister("3a1bk", function(module, exports) {
$parcel$export(module.exports, "getUserPreferences", () => $0d14015163c1a6ae$export$ae3f5fa351e2f57a);

var $3ugTQ = parcelRequire("3ugTQ");

var $9pTd3 = parcelRequire("9pTd3");
const $0d14015163c1a6ae$export$165e2fbe12123208 = (keys)=>`
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [${keys.map((key)=>`"${key}"`).join(', ')}])
}
`;
const $0d14015163c1a6ae$export$ae3f5fa351e2f57a = async (keys)=>{
    try {
        const apiResult = await (0, $3ugTQ.performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $0d14015163c1a6ae$export$165e2fbe12123208(keys)
            })
        });
        return apiResult.data.myPreferences;
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: 'getUserPreferences',
                packageName: 'jiraAdminPagesWorkflowsUserPreferences',
                teamName: 'Helix'
            }
        });
        throw error;
    }
};

});

parcelRegister("hNTYb", function(module, exports) {
$parcel$export(module.exports, "useUserPreference", () => $2f2e2c231add37d0$export$67772f4a901db59b);
$parcel$export(module.exports, "useUserPreferencesInitialiser", () => $2f2e2c231add37d0$export$2b48814b5b24efde);

var $eJrcF = parcelRequire("eJrcF");

var $6TwEE = parcelRequire("6TwEE");
const $2f2e2c231add37d0$export$67772f4a901db59b = (resource, key, options)=>{
    const { data: data, update: update, error: error, loading: loading } = (0, $eJrcF.useResource)(resource);
    const value = data?.[key];
    const setValue = (newValue)=>{
        const formattedNewValue = options?.skipValueFormatting ? newValue : $2f2e2c231add37d0$var$encodeValueObject(newValue);
        update((d)=>({
                ...d,
                [key]: formattedNewValue
            }));
        (0, $6TwEE.setUserPreference)(key, formattedNewValue);
    };
    try {
        const formattedValue = options?.skipValueFormatting ? value : $2f2e2c231add37d0$var$decodeValueObject(value);
        return {
            value: formattedValue,
            setValue: setValue,
            error: error,
            loading: loading
        };
    } catch (formattingError) {
        return {
            value: undefined,
            setValue: setValue,
            error: formattingError instanceof Error ? formattingError : error,
            loading: loading
        };
    }
};
const $2f2e2c231add37d0$export$2b48814b5b24efde = (resource)=>{
    const { refresh: refresh, loading: loading, error: error, data: data } = (0, $eJrcF.useResource)(resource);
    const initialise = ()=>{
        if (data === null && error === null && !loading) refresh();
    };
    return {
        initialise: initialise
    };
};
const $2f2e2c231add37d0$var$decodeValueObject = (value)=>{
    if (!value) return value;
    return JSON.parse(value)?.value;
};
const $2f2e2c231add37d0$var$encodeValueObject = (value)=>{
    return JSON.stringify({
        value: value
    });
};

});
parcelRegister("6TwEE", function(module, exports) {
$parcel$export(module.exports, "setUserPreference", () => $daecbeb4ac6e2f5f$export$b2da77ffcb5ccb19);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $daecbeb4ac6e2f5f$export$615e3c066435ee7d = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $daecbeb4ac6e2f5f$export$b2da77ffcb5ccb19 = async (key, value)=>{
    try {
        const result = await (0, $3ugTQ.performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $daecbeb4ac6e2f5f$export$615e3c066435ee7d,
                variables: {
                    input: {
                        key: key,
                        value: value
                    }
                }
            })
        });
        if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${key}`, {
            cause: result.errors?.[0]
        });
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: 'setUserPreference',
                packageName: 'jiraAdminPagesWorkflowsUserPreferences',
                teamName: 'Helix'
            }
        });
        throw error;
    }
};

});



parcelRegister("h6n7A", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", () => $f345e45d74df8c40$export$9d533f08a4447cc);
const $f345e45d74df8c40$export$9d533f08a4447cc = {
    name: 'global-settings-issues-workflow-edit',
    path: '/jira/settings/issues/workflows/:workflowId'
};

});

parcelRegister("kL8k5", function(module, exports) {
$parcel$export(module.exports, "workflowCapabilitiesResource", () => $03a4d75ef373c866$export$752f9619231646c7);
$parcel$export(module.exports, "useWorkflowCapabilities", () => $03a4d75ef373c866$export$861a32391dc35e21);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $j5idT = parcelRequire("j5idT");
const $03a4d75ef373c866$export$e683a752d2185432 = 'ADMIN_WORKFLOW_CAPABILITIES';
const $03a4d75ef373c866$export$752f9619231646c7 = (0, $l1VxS.createResource)({
    type: $03a4d75ef373c866$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId } = matchedRoute.match.params;
        return `${$03a4d75ef373c866$export$e683a752d2185432}_${workflowId}`;
    },
    getData: (0, $j5idT.fetchWorkflowCapabilities),
    maxAge: 1000,
    isBrowserOnly: true
});
const $03a4d75ef373c866$export$861a32391dc35e21 = ()=>(0, $eJrcF.useResource)($03a4d75ef373c866$export$752f9619231646c7);

});
parcelRegister("j5idT", function(module, exports) {
$parcel$export(module.exports, "fetchWorkflowCapabilities", () => $330d675fff983670$export$51e1638cbea98309);

var $f262R = parcelRequire("f262R");

var $6uWhG = parcelRequire("6uWhG");

var $2vBmG = parcelRequire("2vBmG");

var $7hVvO = parcelRequire("7hVvO");
const $330d675fff983670$export$51e1638cbea98309 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    if (isAnonymous || !match.params.workflowId) {
        const message = !match.params.workflowId ? 'Workflow ID is not defined.' : "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        // better way to monitor perf?
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiStartMark));
        const workflowCapabilities = await (0, $f262R.getWorkflowCapabilities)(cloudId, {
            workflowId: match.params.workflowId
        });
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        return workflowCapabilities;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-capabilities.getData',
            message: 'An error was thrown while prefetching workflow capabilities data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("f262R", function(module, exports) {
$parcel$export(module.exports, "getWorkflowCapabilities", () => $a66ce0141d6086db$export$334f82027882d665);

var $e0I8k = parcelRequire("e0I8k");

var $hgi0g = parcelRequire("hgi0g");

var $eSnSE = parcelRequire("eSnSE");
const $a66ce0141d6086db$var$getApiPrefix = ()=>'gateway/api/jira/project-configuration';
const $a66ce0141d6086db$export$a5b7a8c3b1c6e775 = (cloudId, params)=>`/${$a66ce0141d6086db$var$getApiPrefix()}/query/${cloudId}/workflow/capabilities?${(0, $e0I8k.stringify)(params)}`;
const $a66ce0141d6086db$export$334f82027882d665 = (cloudId, options)=>(0, $hgi0g.default)($a66ce0141d6086db$export$a5b7a8c3b1c6e775(cloudId, options), {
        method: 'GET'
    }).catch((e)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('getWorkflowAvailableCapabilities', e);
        throw e;
    });

});
parcelRegister("e0I8k", function(module, exports) {
$parcel$export(module.exports, "decode", () => $a3334cc298c2f94d$export$2f872c0f2117be69, (v) => $a3334cc298c2f94d$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $a3334cc298c2f94d$export$98e6a39c04603d36, (v) => $a3334cc298c2f94d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $a3334cc298c2f94d$export$c564cdbbe6da493, (v) => $a3334cc298c2f94d$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $a3334cc298c2f94d$export$fac44ee5b035f737, (v) => $a3334cc298c2f94d$export$fac44ee5b035f737 = v);
var $a3334cc298c2f94d$export$2f872c0f2117be69;
var $a3334cc298c2f94d$export$98e6a39c04603d36;
var $a3334cc298c2f94d$export$c564cdbbe6da493;
var $a3334cc298c2f94d$export$fac44ee5b035f737;
'use strict';

$a3334cc298c2f94d$export$2f872c0f2117be69 = $a3334cc298c2f94d$export$98e6a39c04603d36 = (parcelRequire("dsfwg"));

$a3334cc298c2f94d$export$c564cdbbe6da493 = $a3334cc298c2f94d$export$fac44ee5b035f737 = (parcelRequire("6vVY0"));

});
parcelRegister("dsfwg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $9cb9edb7aa9a3001$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$9cb9edb7aa9a3001$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($9cb9edb7aa9a3001$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $9cb9edb7aa9a3001$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("6vVY0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4be29a4f00cc422b$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $4be29a4f00cc422b$var$map($4be29a4f00cc422b$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(k)) + eq;
        if ($4be29a4f00cc422b$var$isArray(obj[k])) return $4be29a4f00cc422b$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(name)) + eq + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj));
};
var $4be29a4f00cc422b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $4be29a4f00cc422b$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $4be29a4f00cc422b$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});





parcelRegister("jS1hO", function(module, exports) {
$parcel$export(module.exports, "workflowDocumentResource", () => $aaa717bc04429990$export$b63b10ddc49fa54f);
$parcel$export(module.exports, "useWorkflowDocument", () => $aaa717bc04429990$export$1ed79b881a7cb8b1);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $6y5nr = parcelRequire("6y5nr");
const $aaa717bc04429990$export$e683a752d2185432 = 'ADMIN_WORKFLOW_DOCUMENT';
const $aaa717bc04429990$export$b63b10ddc49fa54f = (0, $l1VxS.createResource)({
    type: $aaa717bc04429990$export$e683a752d2185432,
    getKey: (matchedRoute)=>{
        const { workflowId: workflowId } = matchedRoute.match.params;
        return `${$aaa717bc04429990$export$e683a752d2185432}_${workflowId}`;
    },
    getData: async (routerContext, customContext)=>(0, $6y5nr.fetchWorkflowDocument)(routerContext, customContext, false),
    maxAge: 1000,
    isBrowserOnly: true
});
const $aaa717bc04429990$export$1ed79b881a7cb8b1 = ()=>(0, $eJrcF.useResource)($aaa717bc04429990$export$b63b10ddc49fa54f);

});
parcelRegister("6y5nr", function(module, exports) {
$parcel$export(module.exports, "fetchWorkflowDocument", () => $d9338ef756608254$export$f9f333ad2a8d394b);

var $3rw8H = parcelRequire("3rw8H");

var $6uWhG = parcelRequire("6uWhG");

var $2vBmG = parcelRequire("2vBmG");

var $7hVvO = parcelRequire("7hVvO");
const $d9338ef756608254$export$f9f333ad2a8d394b = async ({ match: match }, { tenantContext: tenantContext }, isProjectScoped)=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    if (isAnonymous || !match.params.workflowId) {
        const message = !match.params.workflowId ? 'Workflow ID is not defined.' : "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiStartMark));
        const workflowDocument = await (0, $3rw8H.getWorkflow)(cloudId, {
            workflowId: match.params.workflowId
        }, {
            checkForDrafts: !isProjectScoped
        });
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        return workflowDocument;
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-document.getData',
            message: 'An error was thrown while prefetching workflow document data',
            name: 'ResourceError'
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        error);
    }
};

});
parcelRegister("3rw8H", function(module, exports) {
$parcel$export(module.exports, "getWorkflow", () => $4a9ad9da58c775d1$export$f927248b35ee72a7);

var $jPROM = parcelRequire("jPROM");

var $3ugTQ = parcelRequire("3ugTQ");
const $4a9ad9da58c775d1$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $4a9ad9da58c775d1$export$a5b7a8c3b1c6e775 = (cloudId)=>`/${$4a9ad9da58c775d1$export$c1b7f62a96ae605b()}/query/${cloudId}/3/workflow`;
const $4a9ad9da58c775d1$export$f927248b35ee72a7 = (cloudId, workflowIdentifier, config)=>{
    const url = $4a9ad9da58c775d1$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (config?.checkForDrafts) payload.checkForDrafts = true;
    return (0, $3ugTQ.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
};

});



parcelRegister("cgXAH", function(module, exports) {
$parcel$export(module.exports, "workflowBuilderProvisioningResource", () => $d68e76e129f66428$export$5dd78fb4d8e7d884);
$parcel$export(module.exports, "useWorkflowBuilderProvisioning", () => $d68e76e129f66428$export$31f614b597ebcd64);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $2N4qm = parcelRequire("2N4qm");
const $d68e76e129f66428$export$e683a752d2185432 = 'ADMIN_WORKFLOW_BUILDER_PROVISIONING';
const $d68e76e129f66428$export$5dd78fb4d8e7d884 = (0, $l1VxS.createResource)({
    type: $d68e76e129f66428$export$e683a752d2185432,
    getKey: ()=>$d68e76e129f66428$export$e683a752d2185432,
    getData: (0, $2N4qm.fetchWorkflowBuilderProvisioning),
    maxAge: 1000,
    isBrowserOnly: true
});
const $d68e76e129f66428$export$31f614b597ebcd64 = ()=>(0, $eJrcF.useResource)($d68e76e129f66428$export$5dd78fb4d8e7d884);

});
parcelRegister("2N4qm", function(module, exports) {
$parcel$export(module.exports, "fetchWorkflowBuilderProvisioning", () => $74812f0dabc22b8e$export$cd22f6e9979f476b);

var $7hVvO = parcelRequire("7hVvO");

var $6uWhG = parcelRequire("6uWhG");

var $2vBmG = parcelRequire("2vBmG");

var $3ugTQ = parcelRequire("3ugTQ");
const $74812f0dabc22b8e$export$cd22f6e9979f476b = async ({ match: _match }, { tenantContext: tenantContext })=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = tenantContext;
    if (isAnonymous) {
        const message = "Workflows can't be edited in anonymous mode.";
        throw new Error(message);
    }
    try {
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiStartMark));
        await (0, $3ugTQ.performPostRequest)('/gateway/api/assist/v1/agent/provisioning/ootb/jira_workflow_builder_agent', {
            headers: {
                'X-Product': 'jira',
                'X-Experience-Id': 'ai-mate',
                'Atl-Cloudid': cloudId
            }
        });
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        // If the request is successful, we return true as this means that the workflow builder was already provisioned or has just succesfully been provisioned
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.admin-pages.workflows.workflow-builder-provisioning.getData',
            message: 'An error was thrown while prefetching workflow builder provisioning',
            name: 'ResourceError'
        }, error);
    }
};

});


parcelRegister("iRrJM", function(module, exports) {
$parcel$export(module.exports, "LazyEditWorkflow", () => $c5567d5a04080bc2$export$cb79ebb337a95317);
$parcel$export(module.exports, "default", () => $c5567d5a04080bc2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c5567d5a04080bc2$export$cb79ebb337a95317 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fMlvh"))), {
    moduleId: "./src/packages/admin-pages/edit-workflow/src/EditWorkflow.tsx"
});
const $c5567d5a04080bc2$var$AsyncEditWorkflow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c5567d5a04080bc2$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });
var $c5567d5a04080bc2$export$2e2bcd8739ae039 = $c5567d5a04080bc2$var$AsyncEditWorkflow;

});


parcelRegister("bWzV9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRouteEntry", () => $fdb3f390a6a0e4ed$export$49998c6229ab8099);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bisZi = parcelRequire("bisZi");

var $ludcG = parcelRequire("ludcG");
const $fdb3f390a6a0e4ed$export$49998c6229ab8099 = (0, $6xToB.createEntry)((0, $bisZi.globalSettingsLegacyFieldLayoutRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        component: (0, $ludcG.LazyLegacyFieldLayoutPage),
        forPaint: [
            (0, $ludcG.LazyLegacyFieldLayoutPromise)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-legacy-field-layout-entries/src/globalSettingsLegacyFieldLayoutRouteEntry.tsx',
                whichExportToUse: 'globalSettingsLegacyFieldLayoutRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bisZi", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRoute", () => $8faa06314f4ceadf$export$82fa992cdfa20fb5);
const $8faa06314f4ceadf$export$82fa992cdfa20fb5 = {
    name: 'global-settings-issues-legacy-field-layout',
    path: '/jira/settings/issues/field-configuration/:fieldLayoutId'
};

});

parcelRegister("ludcG", function(module, exports) {
$parcel$export(module.exports, "LazyLegacyFieldLayoutPromise", () => $086204577f90cc0d$export$8b5ab888f8df499);
$parcel$export(module.exports, "LazyLegacyFieldLayoutPage", () => $086204577f90cc0d$export$676ecf497a280cfa);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $086204577f90cc0d$export$8b5ab888f8df499 = (0, $bQWwW.lazyForPaint)(()=>{
    return (0, $2dJFW.markAsProductBundleReady)((parcelRequire("5Efku")).then((bundle)=>bundle.LegacyFieldLayoutApp));
}, {
    moduleId: "./src/packages/admin-pages/legacy-field-layout/src/LegacyFieldLayoutApp.tsx"
});
const $086204577f90cc0d$export$676ecf497a280cfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $086204577f90cc0d$export$8b5ab888f8df499,
        pageId: "jira-admin-pages-legacy-field-layout",
        shouldShowSpinner: true
    });

});
parcelRegister("5Efku", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2pex6").then(()=>parcelRequire('9wqJG'));

});



parcelRegister("aieAu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRouteEntry", () => $29e6ae5f90f5f894$export$b98ced4649f55b1c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $d0oBd = parcelRequire("d0oBd");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");

var $lXTH9 = parcelRequire("lXTH9");
const $29e6ae5f90f5f894$export$b98ced4649f55b1c = (0, $6xToB.createEntry)((0, $d0oBd.globalSettingsOptimizeFieldConfigurationSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $bJscI.componentWithFG)('field_streamlining_ui', (0, $lXTH9.OptimizeFieldConfigurationSchemePage), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $4cTDP.fg)('field_streamlining_ui'),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lXTH9.LazyOptimizeFieldConfigurationSchemePagePage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-fields-entries/src/globalSettingsOptimizeFieldConfigurationSchemeRouteEntry.tsx',
                whichExportToUse: 'globalSettingsOptimizeFieldConfigurationSchemeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("d0oBd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRoute", () => $814cf952bcc75cda$export$3da73e59758744eb);
const $814cf952bcc75cda$export$3da73e59758744eb = {
    name: 'global-settings-optimize-field-configuration-scheme-view',
    path: '/jira/settings/issues/field-configuration-schemes/:fieldConfigurationSchemeId/optimize'
};

});

parcelRegister("lXTH9", function(module, exports) {
$parcel$export(module.exports, "LazyOptimizeFieldConfigurationSchemePagePage", () => $06f25e3f3eca09e7$export$bd8509501da10c3);
$parcel$export(module.exports, "OptimizeFieldConfigurationSchemePage", () => $06f25e3f3eca09e7$export$7cd55863572c1f3a);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $06f25e3f3eca09e7$export$bd8509501da10c3 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("glEHO"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-field-configuration-scheme-page/src/index.tsx"
});
const $06f25e3f3eca09e7$export$7cd55863572c1f3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $06f25e3f3eca09e7$export$bd8509501da10c3,
        pageId: "jira-admin-pages-optimize-field-configuration-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("glEHO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k3xxV").then(()=>parcelRequire('cEOMi'));

});



parcelRegister("hEWb7", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRouteEntry", () => $d8a4f7bf8e198653$export$bae97ca0b9dd2ea2);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fekcl = parcelRequire("fekcl");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $9BJU1 = parcelRequire("9BJU1");

var $5fjzQ = parcelRequire("5fjzQ");

var $iDRnR = parcelRequire("iDRnR");
const $d8a4f7bf8e198653$export$bae97ca0b9dd2ea2 = (0, $6xToB.createEntry)((0, $fekcl.globalSettingsOptimizeWorkTypeSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $bJscI.componentWithFG)('optimize_issue_type_scheme_page', (0, $iDRnR.OptimizeWorkTypeSchemePage), (0, $9BJU1.default)),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        canTransitionIn: ()=>(0, $4cTDP.fg)('optimize_issue_type_scheme_page'),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iDRnR.LazyOptimizeWorkTypeSchemePagePage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-fields-entries/src/globalSettingsOptimizeWorkTypeSchemeRouteEntry.tsx',
                whichExportToUse: 'globalSettingsOptimizeWorkTypeSchemeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fekcl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRoute", () => $efcb9b38d5c14047$export$c0e227e20c671f81);
const $efcb9b38d5c14047$export$c0e227e20c671f81 = {
    name: 'global-settings-optimize-work-type-scheme-view',
    path: '/jira/settings/issues/issue-type-schemes/:workTypeSchemeId/optimize'
};

});

parcelRegister("iDRnR", function(module, exports) {
$parcel$export(module.exports, "LazyOptimizeWorkTypeSchemePagePage", () => $03d92ca6caf8d71b$export$267fd3967a05d273);
$parcel$export(module.exports, "OptimizeWorkTypeSchemePage", () => $03d92ca6caf8d71b$export$ba894e00aa169b3b);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $03d92ca6caf8d71b$export$267fd3967a05d273 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ceTCa"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-work-type-scheme-page/src/index.tsx"
});
const $03d92ca6caf8d71b$export$ba894e00aa169b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $03d92ca6caf8d71b$export$267fd3967a05d273,
        pageId: "jira-admin-pages-optimize-work-type-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("ceTCa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7r7DH").then(()=>parcelRequire('in4So'));

});



parcelRegister("dVpvh", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldCleanupRouteEntry", () => $6b5162eeb56a9068$export$2861e75e48fa039f);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $cOL7T = parcelRequire("cOL7T");

var $leTLb = parcelRequire("leTLb");
const $6b5162eeb56a9068$export$2861e75e48fa039f = (0, $6xToB.createEntry)((0, $cOL7T.globalSettingsPerformanceCustomFieldCleanupRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $leTLb.customFieldCleanupMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceCustomFieldCleanupRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceCustomFieldCleanupRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cOL7T", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldCleanupRoute", () => $943e20c180cc897c$export$cb147997a6f0639a);
const $943e20c180cc897c$export$cb147997a6f0639a = {
    name: 'global-settings-performance-custom-field-cleanup',
    path: '/jira/settings/system/performance/metrics/customfield/cleanup'
};

});

parcelRegister("leTLb", function(module, exports) {
$parcel$export(module.exports, "customFieldCleanupMetricDetailEntryPoint", () => $5e58eff6c33d0db6$export$47780c76bc3a7e1e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $gbpNq = parcelRequire("gbpNq");

const $5e58eff6c33d0db6$export$47780c76bc3a7e1e = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("d4bYC")), {
            moduleId: "e0a8c357",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("d4bYC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dBlMg").then(()=>parcelRequire('9H0ZF'));

});



parcelRegister("iLf1F", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldProjectLimitRouteEntry", () => $b7656d74ec0e9808$export$e86e8247db1f29bb);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $gqJO6 = parcelRequire("gqJO6");

var $9NmsS = parcelRequire("9NmsS");

var $hxJkg = parcelRequire("hxJkg");

var $3AyZ6 = parcelRequire("3AyZ6");
const $b7656d74ec0e9808$export$e86e8247db1f29bb = (0, $6xToB.createEntry)((0, $hxJkg.globalSettingsPerformanceCustomFieldProjectLimitRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $3AyZ6.customFieldProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $gqJO6.fieldsProjectsLimitsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceCustomFieldProjectLimitRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceCustomFieldProjectLimitRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gqJO6", function(module, exports) {
$parcel$export(module.exports, "fieldsProjectsLimitsResource", () => $82ad06ef690a2967$export$c3fe56fd6a83a952);

var $l1VxS = parcelRequire("l1VxS");
const $82ad06ef690a2967$var$RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS = 'FIELDS_PROJECTS_LIMITS';

const $82ad06ef690a2967$export$c3fe56fd6a83a952 = (0, $l1VxS.createResource)({
    type: $82ad06ef690a2967$var$RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS,
    getKey: ()=>'fieldsProjectsLimits',
    getDataLoader: ()=>(parcelRequire("iFU7J"))
});

});
parcelRegister("iFU7J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aDWmt").then(()=>parcelRequire('2vAnn'));

});


parcelRegister("hxJkg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldProjectLimitRoute", () => $f21837c6155b33f4$export$9449246286770320);
const $f21837c6155b33f4$export$9449246286770320 = {
    name: 'global-settings-performance-custom-field-project-limit',
    path: '/jira/settings/system/performance/metrics/customfield/projectlimit'
};

});

parcelRegister("3AyZ6", function(module, exports) {
$parcel$export(module.exports, "customFieldProjectLimitMetricDetailEntryPoint", () => $766ea365c40ef396$export$a2234cc105eb9aa9);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $gbpNq = parcelRequire("gbpNq");

const $766ea365c40ef396$export$a2234cc105eb9aa9 = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fbWBc")), {
            moduleId: "43601b8e",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("fbWBc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4sTYn").then(()=>parcelRequire('bTqVl'));

});



parcelRegister("2zDjc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRouteEntry", () => $726ab017cdee397f$export$8cc68908e4ed5a16);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $ec3NN = parcelRequire("ec3NN");

var $96vQW = parcelRequire("96vQW");
const $726ab017cdee397f$export$8cc68908e4ed5a16 = (0, $6xToB.createEntry)((0, $ec3NN.globalSettingsPerformanceCustomFieldRoute), ()=>({
        group: 'global-settings',
        component: (0, $96vQW.CustomFieldMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96vQW.LazyCustomFieldDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceCustomFieldRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceCustomFieldRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ec3NN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", () => $5379f2145d09883a$export$198b0dea5bcb104d);
const $5379f2145d09883a$export$198b0dea5bcb104d = {
    name: 'global-settings-performance-custom-field',
    path: '/jira/settings/system/performance/metrics/customfield'
};

});

parcelRegister("96vQW", function(module, exports) {
$parcel$export(module.exports, "LazyCustomFieldDetail", () => $33c7f88cb2f8be50$export$d323aa888b5be0c2);
$parcel$export(module.exports, "CustomFieldMetricDetail", () => $33c7f88cb2f8be50$export$446bf9be075b3cb);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $33c7f88cb2f8be50$export$d323aa888b5be0c2 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2RFIE"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $33c7f88cb2f8be50$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $33c7f88cb2f8be50$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });

});
parcelRegister("2RFIE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("5GTY9")
]).then(()=>parcelRequire('8nmH7'));

});



parcelRegister("izkie", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceDashboardRouteEntry", () => $029ab139634557a1$export$6abc49117edae2db);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $3IC5k = parcelRequire("3IC5k");

var $7fM8i = parcelRequire("7fM8i");
const $029ab139634557a1$export$6abc49117edae2db = (0, $6xToB.createEntry)((0, $3IC5k.globalSettingsPerformanceDashboardRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $7fM8i.PerformanceMonitorDashboardEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceDashboardRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceDashboardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3IC5k", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceDashboardRoute", () => $2aa340897ffde746$export$5cb922a7b379216b);
const $2aa340897ffde746$export$5cb922a7b379216b = {
    name: 'global-settings-performance-dashboard',
    path: '/jira/settings/system/performance/dashboard'
};

});

parcelRegister("7fM8i", function(module, exports) {
$parcel$export(module.exports, "PerformanceMonitorDashboardEntryPoint", () => $852ee6796935ce0f$export$220d2ee62020fcad);

var $kVEY1 = parcelRequire("kVEY1");

var $iLblh = parcelRequire("iLblh");

var $exEd9 = parcelRequire("exEd9");

var $bdHSb = parcelRequire("bdHSb");

var $g8uYY = parcelRequire("g8uYY");

var $gbpNq = parcelRequire("gbpNq");

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

const $852ee6796935ce0f$export$220d2ee62020fcad = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("5GU3D")), {
            moduleId: "14df36f4",
            priority: "interaction"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>{
            const now = new Date();
            const endDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
            const startDate = new Date(endDate.getTime() - 604800000);
            return {
                queries: {
                    boardPerformanceQuery: {
                        parameters: (0, $kVEY1.default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            startDate: startDate,
                            endDate: endDate,
                            filters: [
                                {
                                    boardFilter: {
                                        keyword: '',
                                        performanceStatus: [
                                            'SLOW',
                                            'MODERATE',
                                            'FAST'
                                        ]
                                    }
                                }
                            ],
                            after: ''
                        },
                        fetchPolicy: 'store-or-network'
                    },
                    performanceNetworkQuery: {
                        parameters: (0, $iLblh.default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            startDate: startDate,
                            endDate: endDate,
                            granularity: 'DAY'
                        },
                        fetchPolicy: 'store-or-network'
                    },
                    performanceLimitsAndCleanupQuery: {
                        parameters: (0, $exEd9.default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            schemaMigrationEnabled: (0, $4cTDP.fg)('site_optimiser_schema_migration'),
                            projectLevelReportingEnabled: (0, $4cTDP.fg)('slt1-682-fe-project-level-reporting-so')
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    },
                    performanceOverviewQuery: {
                        parameters: (0, $bdHSb.default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            startDate: startDate,
                            endDate: endDate,
                            granularity: 'DAY'
                        },
                        fetchPolicy: 'store-or-network'
                    }
                }
            };
        }
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("kVEY1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2b8ab39ffd51f53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11812e88fc9b1f067f3bf1e96f37b98a>>
 * @relayHash 3e105ba686a3c7e413dfa0d3b76a857f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9f03be7c278eb49be8080be8946d8663b0cffe9208a3205ce9ef65215ab6565
const $f2b8ab39ffd51f53$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v7 = {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
    }, v8 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v9 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v10 = {
        "kind": "Literal",
        "name": "dimensions",
        "value": [
            {
                "name": "jira_board_id"
            }
        ]
    }, v11 = {
        "type": "COUNT"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "Literal",
        "name": "first",
        "value": 25
    }, v14 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardPerformanceTabsQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BoardPerformanceTabSummary"
                },
                {
                    "args": [
                        v9 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BoardPerformanceTabTable"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BoardPerformanceTabsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "boardPerformanceSummary",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": {
                                                "type": "AVG"
                                            },
                                            "alias": "loadTime",
                                            "name": "ttvc90",
                                            "summarize": true
                                        },
                                        {
                                            "aggregation": v11 /*: any*/ ,
                                            "alias": "views",
                                            "name": "*",
                                            "summarize": true
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraCFOBoardPerfStats",
                                                    "kind": "LinkedField",
                                                    "name": "boardPerfStats",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slowBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moderateBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fastBoardsCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slowBoardThreshold"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fastBoardThreshold"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCFOBoardPerformanceMetricSummary"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "after",
                                            "value": ""
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ 
                                    ],
                                    "storageKey": "data(after:\"\",first:25)"
                                }
                            ]
                        },
                        {
                            "alias": "boardPerformanceTableValues",
                            "args": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": v11 /*: any*/ ,
                                            "alias": "views",
                                            "name": "*"
                                        },
                                        {
                                            "aggregation": {
                                                "type": "PERCENTILE",
                                                "value": 0.5
                                            },
                                            "alias": "loadTime",
                                            "name": "ttvc90"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "args": [
                                        v9 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ],
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFODataRowEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraCFOMetric",
                                                            "kind": "LinkedField",
                                                            "name": "metrics",
                                                            "plural": true,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardName"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "boardCreator",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "perfStatus"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "projectKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optimizationSuggestion"
                                                                }
                                                            ],
                                                            "type": "JiraCFOBoardPerformanceDataRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e9f03be7c278eb49be8080be8946d8663b0cffe9208a3205ce9ef65215ab6565",
            "metadata": {},
            "name": "BoardPerformanceTabsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f2b8ab39ffd51f53$var$node.hash = "306a79f31bf6a2bceda3f37cbfbdfbad";
var $f2b8ab39ffd51f53$export$2e2bcd8739ae039 = $f2b8ab39ffd51f53$var$node;

});

parcelRegister("iLblh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e49ff159e94d4c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d07db648a581c8ccdd28b700e1d8f915>>
 * @relayHash 1c57182c48cac0e1935dff63eed52f97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91ee270ba8a4a23aed34b9104b68a8d1847e24d7ecd5d2bb5ea88f0bed1ee6bf
const $1e49ff159e94d4c1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": "network_downlink",
        "kind": "LocalArgument",
        "name": "dimension"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v3 = {
        "defaultValue": "DAY",
        "kind": "LocalArgument",
        "name": "granularity"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v7 = {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
    }, v8 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v9 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "COUNT_DISTINCT"
                },
                "name": "account_id"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "concreteType": "JiraCFODimension",
        "kind": "LinkedField",
        "name": "dimensions",
        "plural": true,
        "selections": v11 /*: any*/ 
    }, v13 = {
        "concreteType": "JiraCFOMetric",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": true,
        "selections": v11 /*: any*/ 
    }, v14 = [
        v10 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "timestamp"
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PerformanceNetworkViewQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PerformanceNetworkUserCharts"
                },
                {
                    "args": [
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "dimension",
                            "variableName": "dimension"
                        },
                        v6 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PerformanceMonitoringHorizontalBarChart"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PerformanceNetworkViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "cores",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "cpus"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "speed",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "network_downlink"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "protocol",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "http_protocol"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "os",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "os"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "browsers",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "dimensions",
                                    "value": [
                                        {
                                            "name": "browser_name"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "alias": "ttvcAnalytics",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "name",
                                                    "variableName": "dimension"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "dimensions.0"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "dimensions"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "metrics",
                                    "value": [
                                        {
                                            "aggregation": {
                                                "type": "PERCENTILE",
                                                "value": 0.5
                                            },
                                            "name": "ttvc90"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraCFODataRowConnection",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCFODataRowEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "91ee270ba8a4a23aed34b9104b68a8d1847e24d7ecd5d2bb5ea88f0bed1ee6bf",
            "metadata": {},
            "name": "PerformanceNetworkViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e49ff159e94d4c1$var$node.hash = "6203650689cd6f017f015501d7de4fcf";
var $1e49ff159e94d4c1$export$2e2bcd8739ae039 = $1e49ff159e94d4c1$var$node;

});

parcelRegister("exEd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6645434157c11d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<206bf7af8c425b058241173b3c3cf5ab>>
 * @relayHash 84e0a7d195cc73930afb4bb61a11b442
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26de4c70f96cd11db74eeabfc49857db789bc16577caa734831f8a9dbc38b6f2
const $1b6645434157c11d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectLevelReportingEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemaMigrationEnabled"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "projectLevelReportingEnabled",
            "variableName": "projectLevelReportingEnabled"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "currentValue"
    }, v7 = {
        "kind": "ScalarField",
        "name": "warningValue"
    }, v8 = {
        "kind": "ScalarField",
        "name": "thresholdValue"
    }, v9 = {
        "kind": "ScalarField",
        "name": "cleanupValue"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "projectsOverLimit"
    }, v12 = {
        "kind": "ScalarField",
        "name": "projectsReachingLimit"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = [
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PerformanceOverviewMainQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnection",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetrics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "OverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetrics"
                                    }
                                ]
                            },
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetricsV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "OverviewPage843BadPattern"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetricsV2"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PerformanceOverviewMainQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResourceUsageMetric",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraResourceUsageMetric",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "projectLevelReportingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v14 /*: any*/ ,
                                                            "type": "JiraWorkTypeUsageMetric"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v14 /*: any*/ ,
                                                            "type": "JiraCustomFieldUsageMetric"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "26de4c70f96cd11db74eeabfc49857db789bc16577caa734831f8a9dbc38b6f2",
            "metadata": {},
            "name": "PerformanceOverviewMainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1b6645434157c11d$var$node.hash = "4854cf1c4446dc0d62ce69d578fa8abf";
var $1b6645434157c11d$export$2e2bcd8739ae039 = $1b6645434157c11d$var$node;

});

parcelRegister("bdHSb", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cef8905f19749e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62fc369d42ec070a61c652692f0bb0c9>>
 * @relayHash de43fc40c6c0bdd613280a9303c24cc4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fce0f412405d21d978570411ea8828a9701fb56fbdea5bce13e567153b8a2c3

var $9dtMx = parcelRequire("9dtMx");
const $5cef8905f19749e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endDate"
    }, v2 = {
        "defaultValue": "DAY",
        "kind": "LocalArgument",
        "name": "granularity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startDate"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
    }, v6 = {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
    }, v7 = {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
    }, v8 = [
        v4 /*: any*/ 
    ], v9 = {
        "kind": "Literal",
        "name": "dimensions",
        "value": []
    }, v10 = {
        "kind": "Literal",
        "name": "metrics",
        "value": [
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.75
                },
                "alias": "p75",
                "name": "ttvc90"
            },
            {
                "aggregation": {
                    "type": "PERCENTILE",
                    "value": 0.5
                },
                "alias": "p50",
                "name": "ttvc90",
                "summarize": true
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = [
        v11 /*: any*/ ,
        {
            "concreteType": "JiraCFODataRowConnection",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "timestamp"
                                },
                                {
                                    "concreteType": "JiraCFOMetric",
                                    "kind": "LinkedField",
                                    "name": "metrics",
                                    "plural": true,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "name": "summary",
            "plural": false,
            "selections": [
                v11 /*: any*/ ,
                {
                    "concreteType": "JiraCFOMetricComparison",
                    "kind": "LinkedField",
                    "name": "periodComparison",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "currentPeriod",
                            "plural": false,
                            "selections": v12 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "change"
                        }
                    ]
                }
            ]
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "projectsOverLimit"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PerformanceOverviewQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PerformanceOverviewCharts"
                },
                {
                    "args": v8 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "PerformanceOverviewRecommendations"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "PerformanceOverviewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allExperiences",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "alias": "boards",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filters",
                                    "value": [
                                        {
                                            "dimensionFilter": {
                                                "name": "experience",
                                                "operator": "IN",
                                                "values": [
                                                    "Classic Board",
                                                    "Nextgen Board"
                                                ]
                                            }
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "alias": "workItems",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "name",
                                                            "value": "experience"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "operator",
                                                            "value": "IN"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "values",
                                                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "dimensionFilter"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filters.0"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "filters"
                                },
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "alias": "backlogs",
                            "args": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filters",
                                    "value": [
                                        {
                                            "dimensionFilter": {
                                                "name": "experience",
                                                "operator": "IN",
                                                "values": [
                                                    "Classic Backlog",
                                                    "Nextgen Backlog"
                                                ]
                                            }
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "cfoAnalytics",
                            "plural": false,
                            "selections": v13 /*: any*/ 
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                            "kind": "LinkedField",
                            "name": "resourceUsageMetricsV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unusedCustomFieldsCount"
                                                }
                                            ],
                                            "type": "JiraCustomFieldUsageMetric"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraWorkTypeUsageMetric"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fce0f412405d21d978570411ea8828a9701fb56fbdea5bce13e567153b8a2c3",
            "metadata": {},
            "name": "PerformanceOverviewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider": (0, $9dtMx.default)
            }
        }
    };
}();
$5cef8905f19749e2$var$node.hash = "881c8d46154125448c6f0461f1adf8cd";
var $5cef8905f19749e2$export$2e2bcd8739ae039 = $5cef8905f19749e2$var$node;

});
parcelRegister("9dtMx", function(module, exports) {
$parcel$export(module.exports, "default", () => $09f3de08bda9c00e$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $09f3de08bda9c00e$export$2e2bcd8739ae039 = {
    get () {
        // eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
        return (0, $cxKOj.expVal)('ttvc_dimensions_issue_view', 'value', [
            'Embedded Issue View',
            'Full Issue View'
        ]);
    }
};

});


parcelRegister("5GU3D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iphUq").then(()=>parcelRequire('7i1h4'));

});



parcelRegister("9Isj0", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRouteEntry", () => $5cbcd9a80ebdf6e8$export$6f8a930d1f2f4103);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $hIpQN = parcelRequire("hIpQN");

var $Uskeg = parcelRequire("Uskeg");
const $5cbcd9a80ebdf6e8$export$6f8a930d1f2f4103 = (0, $6xToB.createEntry)((0, $hIpQN.globalSettingsPerformanceIssueArchivalRoute), ()=>({
        group: 'global-settings',
        component: (0, $Uskeg.IssueMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $Uskeg.LazyIssueDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceIssueArchivalRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceIssueArchivalRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hIpQN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", () => $f293e219049e69c5$export$a615b79ae9fb06e5);
const $f293e219049e69c5$export$a615b79ae9fb06e5 = {
    name: 'global-settings-performance-issue',
    path: '/jira/settings/system/performance/metrics/issue'
};

});

parcelRegister("Uskeg", function(module, exports) {
$parcel$export(module.exports, "LazyIssueDetail", () => $fdf43b91f1ac3288$export$e44cbefb7c57e031);
$parcel$export(module.exports, "IssueMetricDetail", () => $fdf43b91f1ac3288$export$30b22d5292fcd86f);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fdf43b91f1ac3288$export$e44cbefb7c57e031 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6vplB"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $fdf43b91f1ac3288$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fdf43b91f1ac3288$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("6vplB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("4DsoW")
]).then(()=>parcelRequire('4CgFO'));

});



parcelRegister("bs2w3", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRouteEntry", () => $0767927744640a15$export$4b547a5bd165bd83);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jnVux = parcelRequire("jnVux");

var $8WrNo = parcelRequire("8WrNo");
const $0767927744640a15$export$4b547a5bd165bd83 = (0, $6xToB.createEntry)((0, $jnVux.globalSettingsPerformanceMetricDetailRoute), ()=>({
        group: 'global-settings',
        component: (0, $8WrNo.RedirectToExactMetricRoutes),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceMetricDetailRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceMetricDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jnVux", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", () => $620a245b2f6d3335$export$d4f7a24791f8b506);
const $620a245b2f6d3335$export$d4f7a24791f8b506 = {
    name: 'global-settings-performance-metric-detail',
    path: '/jira/settings/system/performance/metric/:metricKey'
};

});

parcelRegister("8WrNo", function(module, exports) {
$parcel$export(module.exports, "RedirectToExactMetricRoutes", () => $6e9f017b39f8449a$export$dda90f06f8afe9ec);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $kRgKj = parcelRequire("kRgKj");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
const $6e9f017b39f8449a$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};

});


parcelRegister("jlE2b", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceOverviewRouteEntry", () => $b8b84d76ead7eb10$export$6f957aade53e2c17);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bcaR6 = parcelRequire("bcaR6");

var $5NKAA = parcelRequire("5NKAA");

var $bCewD = parcelRequire("bCewD");
const $b8b84d76ead7eb10$export$6f957aade53e2c17 = (0, $6xToB.createEntry)((0, $5NKAA.globalSettingsPerformanceOverviewRoute), ()=>({
        group: 'global-settings',
        component: (0, $bCewD.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $bcaR6.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bCewD.LazyOverview)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceOverviewRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceOverviewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bcaR6", function(module, exports) {
$parcel$export(module.exports, "metricsOverviewPageResource", () => $3d664a9d2cc556cb$export$ac0b4ef4ec4987ae);

var $exEd9 = parcelRequire("exEd9");

var $4cTDP = parcelRequire("4cTDP");

var $9FYIg = parcelRequire("9FYIg");
const $3d664a9d2cc556cb$export$ac0b4ef4ec4987ae = (0, $9FYIg.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $exEd9.default),
            variables: {
                cloudId: tenantContext.cloudId,
                schemaMigrationEnabled: (0, $4cTDP.fg)('site_optimiser_schema_migration'),
                projectLevelReportingEnabled: (0, $4cTDP.fg)('slt1-682-fe-project-level-reporting-so')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});

parcelRegister("5NKAA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", () => $dbfadb11fc0e9b18$export$677fc3a2086479d2);
const $dbfadb11fc0e9b18$export$677fc3a2086479d2 = {
    name: 'global-settings-performance-overview',
    path: '/jira/settings/system/performance/overview'
};

});

parcelRegister("bCewD", function(module, exports) {
$parcel$export(module.exports, "LazyOverview", () => $21f93b1c5953002f$export$17b4d4eaede5f445);
$parcel$export(module.exports, "default", () => $21f93b1c5953002f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $21f93b1c5953002f$export$17b4d4eaede5f445 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("77hoc"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
const $21f93b1c5953002f$var$AsyncOverview = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $21f93b1c5953002f$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });
var $21f93b1c5953002f$export$2e2bcd8739ae039 = $21f93b1c5953002f$var$AsyncOverview;

});
parcelRegister("77hoc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bH0RB").then(()=>parcelRequire('5ExgM'));

});



parcelRegister("kDttK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRouteEntry", () => $6da04e599b811bf3$export$7048705fd224d040);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $lirjv = parcelRequire("lirjv");

var $3fsKo = parcelRequire("3fsKo");
const $6da04e599b811bf3$export$7048705fd224d040 = (0, $6xToB.createEntry)((0, $lirjv.globalSettingsPerformanceProjectCleanupRoute), ()=>({
        group: 'global-settings',
        component: (0, $3fsKo.ProjectCleanupMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3fsKo.LazyProjectCleanupDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceProjectCleanupRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceProjectCleanupRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lirjv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", () => $d316f80a5a0f24b2$export$c0d3487a9dc79ff3);
const $d316f80a5a0f24b2$export$c0d3487a9dc79ff3 = {
    name: 'global-settings-performance-project-cleanup',
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};

});

parcelRegister("3fsKo", function(module, exports) {
$parcel$export(module.exports, "LazyProjectCleanupDetail", () => $cd9ca891c314ff85$export$a02cb3bfa11d0dc0);
$parcel$export(module.exports, "ProjectCleanupMetricDetail", () => $cd9ca891c314ff85$export$2adb5abd6651c182);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $cd9ca891c314ff85$export$a02cb3bfa11d0dc0 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aGjhs"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $cd9ca891c314ff85$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd9ca891c314ff85$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });

});
parcelRegister("aGjhs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("jukJv")
]).then(()=>parcelRequire('fGjAz'));

});



parcelRegister("20DnI", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRouteEntry", () => $99e48c57c4fb50f0$export$a37cab737d8b474a);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dQs2a = parcelRequire("dQs2a");

var $fa9c1 = parcelRequire("fa9c1");
const $99e48c57c4fb50f0$export$a37cab737d8b474a = (0, $6xToB.createEntry)((0, $dQs2a.globalSettingsPerformanceProjectRoleActorRoute), ()=>({
        group: 'global-settings',
        component: (0, $fa9c1.ProjectRoleActorMetricDetail),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fa9c1.LazyProjectRoleActorDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceProjectRoleActorRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceProjectRoleActorRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dQs2a", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", () => $dee84a18d9ab2ffa$export$c81695f590e65a42);
const $dee84a18d9ab2ffa$export$c81695f590e65a42 = {
    name: 'global-settings-performance-project-role-actor',
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};

});

parcelRegister("fa9c1", function(module, exports) {
$parcel$export(module.exports, "LazyProjectRoleActorDetail", () => $809fa5df770221f0$export$41ecfa31d3d81e1c);
$parcel$export(module.exports, "ProjectRoleActorMetricDetail", () => $809fa5df770221f0$export$3c58376b89706313);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $809fa5df770221f0$export$41ecfa31d3d81e1c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1Cak2"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $809fa5df770221f0$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $809fa5df770221f0$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });

});
parcelRegister("1Cak2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("dWA5j")
]).then(()=>parcelRequire('9zKIx'));

});



parcelRegister("81vTA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeProjectLimitRouteEntry", () => $698075abb119f507$export$965a17cb3e65a2e5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $bkhk6 = parcelRequire("bkhk6");

var $icUQP = parcelRequire("icUQP");

var $gH15Q = parcelRequire("gH15Q");
const $698075abb119f507$export$965a17cb3e65a2e5 = (0, $6xToB.createEntry)((0, $bkhk6.globalSettingsPerformanceWorkTypeProjectLimitRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $gH15Q.workTypeProjectLimitMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $icUQP.workTypeProjectsLimitsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceWorkTypeProjectLimitRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceWorkTypeProjectLimitRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bkhk6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeProjectLimitRoute", () => $d0b82d9272a49d17$export$1931d6cf70f5bde7);
const $d0b82d9272a49d17$export$1931d6cf70f5bde7 = {
    name: 'global-settings-performance-work-type-project-limit',
    path: '/jira/settings/system/performance/metrics/worktype/projectlimit'
};

});

parcelRegister("icUQP", function(module, exports) {
$parcel$export(module.exports, "workTypeProjectsLimitsResource", () => $402413fb3711d27c$export$2ec7f3178377ec2c);

var $l1VxS = parcelRequire("l1VxS");
const $402413fb3711d27c$var$RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS = 'WORK_TYPE_PROJECTS_LIMITS';

const $402413fb3711d27c$export$2ec7f3178377ec2c = (0, $l1VxS.createResource)({
    type: $402413fb3711d27c$var$RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS,
    getKey: ()=>'workTypeProjectsLimits',
    getDataLoader: ()=>(parcelRequire("8kFDG"))
});

});
parcelRegister("8kFDG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3MwXk").then(()=>parcelRequire('aoDXB'));

});


parcelRegister("gH15Q", function(module, exports) {
$parcel$export(module.exports, "workTypeProjectLimitMetricDetailEntryPoint", () => $b5a5ae6ea29de9bc$export$f497120022a11a8d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $gbpNq = parcelRequire("gbpNq");

const $b5a5ae6ea29de9bc$export$f497120022a11a8d = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lWbZK")), {
            moduleId: "478492f0",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("lWbZK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kM1cW").then(()=>parcelRequire('2ws0G'));

});



parcelRegister("f0p1P", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeRouteEntry", () => $b2f47f947ec65a73$export$92421240ff4c94e5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $1kjON = parcelRequire("1kjON");

var $1wNA2 = parcelRequire("1wNA2");
const $b2f47f947ec65a73$export$92421240ff4c94e5 = (0, $6xToB.createEntry)((0, $1kjON.globalSettingsPerformanceWorkTypeRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return 0, $1wNA2.workTypeMetricDetailEntryPoint;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceWorkTypeRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPerformanceWorkTypeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1kjON", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPerformanceWorkTypeRoute", () => $af42797de3d7f2e9$export$6e2ae2fc0cb46e28);
const $af42797de3d7f2e9$export$6e2ae2fc0cb46e28 = {
    name: 'global-settings-performance-work-type',
    path: '/jira/settings/system/performance/metrics/worktype'
};

});

parcelRegister("1wNA2", function(module, exports) {
$parcel$export(module.exports, "workTypeMetricDetailEntryPoint", () => $d12b05cdcf22bda6$export$a9f578d6187315f8);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $gbpNq = parcelRequire("gbpNq");

const $d12b05cdcf22bda6$export$a9f578d6187315f8 = (0, $g8uYY.createPageEntryPoint)({
    main: {
        root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cAxWs")), {
            moduleId: "0d2267fc",
            priority: "interaction"
        }),
        getPreloadProps: ()=>({})
    },
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("cAxWs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("02EjQ")
]).then(()=>parcelRequire('j3YP6'));

});



parcelRegister("1yaIP", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPermissionSchemesRouteEntry", () => $4845417ac4f7292e$export$85d07cd59d004b5b);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $4PYLV = parcelRequire("4PYLV");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jEcOI = parcelRequire("jEcOI");

var $bVzQe = parcelRequire("bVzQe");
const $4845417ac4f7292e$export$85d07cd59d004b5b = (0, $6xToB.createEntry)((0, $jEcOI.globalSettingsPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $bVzQe.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $4PYLV.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bVzQe.LazyPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'gordian'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-permission-schemes-entries/src/globalSettingsPermissionSchemesRouteEntry.tsx',
                whichExportToUse: 'globalSettingsPermissionSchemesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4PYLV", function(module, exports) {
$parcel$export(module.exports, "permissionSchemePageResource", () => $c3bdd4d86bf4a1d4$export$58d9013f694fc9d0);

var $9FYIg = parcelRequire("9FYIg");

var $15MPj = parcelRequire("15MPj");
const $c3bdd4d86bf4a1d4$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $c3bdd4d86bf4a1d4$export$58d9013f694fc9d0 = (0, $9FYIg.createRelayResource)({
    type: $c3bdd4d86bf4a1d4$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $15MPj.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("15MPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $aad813eafe39647c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $aad813eafe39647c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$aad813eafe39647c$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $aad813eafe39647c$export$2e2bcd8739ae039 = $aad813eafe39647c$var$node;

});


parcelRegister("jEcOI", function(module, exports) {
$parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", () => $2d85bd50d3c083df$export$ceade8e040291782);
const $2d85bd50d3c083df$export$ceade8e040291782 = {
    name: 'global-settings-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};

});

parcelRegister("bVzQe", function(module, exports) {
$parcel$export(module.exports, "LazyPermissionSchemePage", () => $149f3a31b76919ac$export$f7fcf8304eb17dda);
$parcel$export(module.exports, "default", () => $149f3a31b76919ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $149f3a31b76919ac$export$f7fcf8304eb17dda = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j2KBe"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
const $149f3a31b76919ac$var$AsyncPermissionSchemePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $149f3a31b76919ac$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });
var $149f3a31b76919ac$export$2e2bcd8739ae039 = $149f3a31b76919ac$var$AsyncPermissionSchemePage;

});
parcelRegister("j2KBe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cUlxg").then(()=>parcelRequire('44Ret'));

});



parcelRegister("bksGt", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemBulkMailRouteEntry", () => $358c5488ab53b7fe$export$f1e14d1857713e35);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $6K4yM = parcelRequire("6K4yM");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9gC8Q = parcelRequire("9gC8Q");

var $2lbA8 = parcelRequire("2lbA8");
const $358c5488ab53b7fe$export$f1e14d1857713e35 = (0, $6xToB.createEntry)((0, $9gC8Q.globalSettingsSystemBulkMailRoute), ()=>({
        group: 'global-settings',
        component: (0, $2lbA8.default),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $6K4yM.SidebarGlobalSettingsSystem)
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $2lbA8.LazyBulkEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-outgoing-mail-entries/src/globalSettingsSystemBulkMailRouteEntry.tsx',
                whichExportToUse: 'globalSettingsSystemBulkMailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6K4yM", function(module, exports) {
$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $3f83fc002f25ad5f$export$52af3150b9f64726);

var $eJOHy = parcelRequire("eJOHy");

var $1IRel = parcelRequire("1IRel");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $lwUCf = parcelRequire("lwUCf");
const $3f83fc002f25ad5f$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q9Ns.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lwUCf.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Q9Ns.SidebarReady), {
        id: (0, $1IRel.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("1IRel", function(module, exports) {
$parcel$export(module.exports, "SIDEBAR_ID", () => $65c620124257314a$export$adf978edbdfaf080);
const $65c620124257314a$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("lwUCf", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $515a7afc1067af50$export$d9b273488cd8ce6f);

var $eJOHy = parcelRequire("eJOHy");

var $kZ3QZ = parcelRequire("kZ3QZ");
var $jcciq = parcelRequire("jcciq");
var $j5l4H = parcelRequire("j5l4H");
var $6seod = parcelRequire("6seod");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $8kc2T = parcelRequire("8kc2T");

var $jsesb = parcelRequire("jsesb");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $dPngI = parcelRequire("dPngI");

var $hih5V = parcelRequire("hih5V");

var $12LC2 = parcelRequire("12LC2");

var $4nlI9 = parcelRequire("4nlI9");

var $jNN5t = parcelRequire("jNN5t");

var $984NX = parcelRequire("984NX");

var $biIRA = parcelRequire("biIRA");

var $cQl3U = parcelRequire("cQl3U");

var $013X4 = parcelRequire("013X4");

var $kgYBH = parcelRequire("kgYBH");

var $km8c0 = parcelRequire("km8c0");

var $gg4FC = parcelRequire("gg4FC");

var $8mGF5 = parcelRequire("8mGF5");

var $e54td = parcelRequire("e54td");

var $1hRnr = parcelRequire("1hRnr");
const $515a7afc1067af50$var$calculateStack = (route)=>{
    const routeName = route && route.name;
    if ([
        'global-settings-performance-metric-detail',
        'global-settings-performance-overview',
        'global-settings-performance-dashboard',
        'global-settings-performance-project-cleanup',
        'global-settings-performance-project-role-actor',
        'global-settings-performance-custom-field',
        'global-settings-performance-work-type',
        'global-settings-performance-issue'
    ].includes(routeName)) return [
        (0, $12LC2.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $515a7afc1067af50$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const route = (0, $hih5V.useCurrentRoute)();
    const { data: connectItems } = (0, $4nlI9.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $eJOHy.useState)($515a7afc1067af50$var$calculateStack(route));
    (0, $eJOHy.useEffect)(()=>{
        setStack($515a7afc1067af50$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $1hRnr.isGeneralConfigurationSelected)
    }, formatMessage((0, $kgYBH.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $kgYBH.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mGF5.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km8c0.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kgYBH.default).issueCollectorsIssueTermRefresh : (0, $kgYBH.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biIRA.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e54td.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cQl3U.ImportExportSection), null), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $013X4.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNN5t.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gg4FC.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $984NX.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPngI.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $kgYBH.default).systemGroup)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsesb.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5l4H.default), {
        label: formatMessage((0, $kgYBH.default).globalSettingsSystemSidebarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kZ3QZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kc2T.TitleHeader), null, formatMessage((0, $kgYBH.default).systemGroup))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jcciq.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent)));
};

});
parcelRegister("kZ3QZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9cd08b1f79b2e52$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $c9cd08b1f79b2e52$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c9cd08b1f79b2e52$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $c9cd08b1f79b2e52$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $c9cd08b1f79b2e52$export$2e2bcd8739ae039 = $c9cd08b1f79b2e52$var$NavigationHeader;

});

parcelRegister("jcciq", function(module, exports) {
$parcel$export(module.exports, "ROOT_ID", () => $bed75de04f6c5b44$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $bed75de04f6c5b44$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");

var $eGOwo = parcelRequire("eGOwo");

var $fV1cq = parcelRequire("fV1cq");

var $eOsRG = parcelRequire("eOsRG");

var $iIZJ5 = parcelRequire("iIZJ5");

var $2eOKX = parcelRequire("2eOKX");

var $gkgS5 = parcelRequire("gkgS5");
const $bed75de04f6c5b44$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $bed75de04f6c5b44$var$nestableNavigationContentStyles = null;
const $bed75de04f6c5b44$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $bed75de04f6c5b44$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $eJOHy.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $eJOHy.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $bed75de04f6c5b44$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $eJOHy.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $eJOHy.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $eJOHy.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $eGOwo.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fV1cq.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $iIZJ5.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $eJOHy.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $eJOHy.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $eJOHy.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $bed75de04f6c5b44$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gkgS5.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ...motion,
                            className: (0, $hcewu.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2eOKX.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eOsRG.default), {
                                    title: "",
                                    id: $bed75de04f6c5b44$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $bed75de04f6c5b44$export$2e2bcd8739ae039 = $bed75de04f6c5b44$var$NestableNavigationContent;

});
parcelRegister("fV1cq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8afd681eb2485e3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJCX7 = parcelRequire("aJCX7");


var $lOpB3 = parcelRequire("lOpB3");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $d8afd681eb2485e3$var$GoBackItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aJCX7))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $eJOHy.useState)(false);
    const onClickHandler = (0, $eJOHy.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOpB3.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $d8afd681eb2485e3$export$2e2bcd8739ae039 = $d8afd681eb2485e3$var$GoBackItem;

});
parcelRegister("aJCX7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14166727518fb35f8b6d88aee12f245c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d0c52868d3bbdb8$var$_react = $7d0c52868d3bbdb8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7d0c52868d3bbdb8$var$_arrowLeft = $7d0c52868d3bbdb8$var$_interopRequireDefault((parcelRequire("aqu01")));

var $7d0c52868d3bbdb8$var$_arrowLeftCircle = $7d0c52868d3bbdb8$var$_interopRequireDefault((parcelRequire("ebhGv")));
function $7d0c52868d3bbdb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d0c52868d3bbdb8$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $7d0c52868d3bbdb8$var$_react.default.createElement($7d0c52868d3bbdb8$var$_arrowLeft.default, Object.assign({
        name: "ArrowLeftIcon",
        LEGACY_fallbackIcon: $7d0c52868d3bbdb8$var$_arrowLeftCircle.default
    }, props));
$7d0c52868d3bbdb8$var$ArrowLeftIcon.displayName = 'ArrowLeftIconMigration';
var $7d0c52868d3bbdb8$var$_default = module.exports.default = $7d0c52868d3bbdb8$var$ArrowLeftIcon;

});
parcelRegister("ebhGv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a52fcf907d8b67b3$var$_react = $a52fcf907d8b67b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a52fcf907d8b67b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a52fcf907d8b67b3$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $a52fcf907d8b67b3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props));
$a52fcf907d8b67b3$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $a52fcf907d8b67b3$var$_default = module.exports.default = $a52fcf907d8b67b3$var$ArrowLeftCircleIcon;

});


parcelRegister("lOpB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $aef0022280e1b0e9$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7saMl = parcelRequire("7saMl");

var $2eOKX = parcelRequire("2eOKX");
const $aef0022280e1b0e9$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $aef0022280e1b0e9$var$ButtonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $aef0022280e1b0e9$var$styles.root,
            props.isSelected && $aef0022280e1b0e9$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $aef0022280e1b0e9$export$2e2bcd8739ae039 = $aef0022280e1b0e9$var$ButtonItem;

});


parcelRegister("eOsRG", function(module, exports) {
$parcel$export(module.exports, "default", () => $31cdf6c97a90d3e9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3qZZA = parcelRequire("3qZZA");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");


var $lOpB3 = parcelRequire("lOpB3");
var $4vQlI = parcelRequire("4vQlI");
var $8NVZT = parcelRequire("8NVZT");

var $jcciq = parcelRequire("jcciq");

var $2eOKX = parcelRequire("2eOKX");

var $iIZJ5 = parcelRequire("iIZJ5");
const $31cdf6c97a90d3e9$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $31cdf6c97a90d3e9$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $2eOKX.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $eJOHy.useState)(false);
    const parentItemRef = (0, $eJOHy.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $eGOwo.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $eJOHy.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $iIZJ5.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $eJOHy.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2eOKX.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8NVZT.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $jcciq.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $31cdf6c97a90d3e9$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "data-right-arrow": true,
                    xcss: $31cdf6c97a90d3e9$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3qZZA))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vQlI.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $31cdf6c97a90d3e9$var$styles.nestingItem,
            isDisabled && $31cdf6c97a90d3e9$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOpB3.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $31cdf6c97a90d3e9$var$styles.nestingItem,
            isDisabled && $31cdf6c97a90d3e9$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $31cdf6c97a90d3e9$export$2e2bcd8739ae039 = $31cdf6c97a90d3e9$var$NestingItem;

});
parcelRegister("3qZZA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c6e834f7127447f187253f462afe4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2803e32c3ab3bcb7$var$_react = $2803e32c3ab3bcb7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2803e32c3ab3bcb7$var$_arrowRight = $2803e32c3ab3bcb7$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $2803e32c3ab3bcb7$var$_arrowRightCircle = $2803e32c3ab3bcb7$var$_interopRequireDefault((parcelRequire("9YAbA")));
function $2803e32c3ab3bcb7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2803e32c3ab3bcb7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2803e32c3ab3bcb7$var$_react.default.createElement($2803e32c3ab3bcb7$var$_arrowRight.default, Object.assign({
        name: "ArrowRightIcon",
        LEGACY_fallbackIcon: $2803e32c3ab3bcb7$var$_arrowRightCircle.default
    }, props));
$2803e32c3ab3bcb7$var$ArrowRightIcon.displayName = 'ArrowRightIconMigration';
var $2803e32c3ab3bcb7$var$_default = module.exports.default = $2803e32c3ab3bcb7$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("9YAbA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7435c96ecc9ed077$var$_react = $7435c96ecc9ed077$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7435c96ecc9ed077$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7435c96ecc9ed077$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7435c96ecc9ed077$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props));
$7435c96ecc9ed077$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7435c96ecc9ed077$var$_default = module.exports.default = $7435c96ecc9ed077$var$ArrowRightCircleIcon;

});


parcelRegister("4vQlI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8450fbee69ab3a89$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1PYwQ = parcelRequire("1PYwQ");

var $2eOKX = parcelRequire("2eOKX");
const $8450fbee69ab3a89$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $8450fbee69ab3a89$var$CustomItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1PYwQ.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $8450fbee69ab3a89$var$styles.root,
            props.isSelected && $8450fbee69ab3a89$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $8450fbee69ab3a89$export$2e2bcd8739ae039 = $8450fbee69ab3a89$var$CustomItem;

});

parcelRegister("8NVZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $81e34849b6770769$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9RjqB = parcelRequire("9RjqB");

var $2eOKX = parcelRequire("2eOKX");
const $81e34849b6770769$var$outerContainerCSS = null;
const $81e34849b6770769$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjlb4i _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $81e34849b6770769$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $81e34849b6770769$var$NavigationContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    const scrollbar = (0, $9RjqB.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjlb4i _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $hcewu.default)([
                $81e34849b6770769$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $81e34849b6770769$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $81e34849b6770769$var$containerCSS.basic,
                    showTopScrollIndicator && $81e34849b6770769$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $81e34849b6770769$export$2e2bcd8739ae039 = $81e34849b6770769$var$NavigationContent;

});
parcelRegister("9RjqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $956c679486dfb22d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $956c679486dfb22d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $eJOHy.useState)(0);
    const elementRef = (0, $eJOHy.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("iIZJ5", function(module, exports) {
$parcel$export(module.exports, "useChildIds", () => $94c16a439874c22d$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $94c16a439874c22d$export$ea18c2b5f0e24612);

var $eJOHy = parcelRequire("eJOHy");

var $jcciq = parcelRequire("jcciq");
const $94c16a439874c22d$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $eJOHy.useRef)(new Set());
    (0, $eJOHy.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $jcciq.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $94c16a439874c22d$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $eJOHy.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("gkgS5", function(module, exports) {
$parcel$export(module.exports, "NestingMotion", () => $a5b530baab8af272$export$9e743a8c2a6b450e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8UpxG = parcelRequire("8UpxG");
const $a5b530baab8af272$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8UpxG.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("j5l4H", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b63b6885c6159ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dQDjy = parcelRequire("dQDjy");
const $9b63b6885c6159ab$var$sidebarMinWidth = '240px';
const $9b63b6885c6159ab$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $9b63b6885c6159ab$var$SideNavigation = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQDjy.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $9b63b6885c6159ab$export$2e2bcd8739ae039 = $9b63b6885c6159ab$var$SideNavigation;

});

parcelRegister("dysoB", function(module, exports) {
$parcel$export(module.exports, "MenuItem", () => $af143be694f933c4$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Q6BV = parcelRequire("3Q6BV");

var $4vQlI = parcelRequire("4vQlI");

var $c9uTK = parcelRequire("c9uTK");
var $gCY1z = parcelRequire("gCY1z");

var $8KWr1 = parcelRequire("8KWr1");

var $fZmSO = parcelRequire("fZmSO");
const $af143be694f933c4$var$cssVarPrefix = '--sidebar-menu-item';
const $af143be694f933c4$var$bgColorCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color`;
const $af143be694f933c4$var$bgColorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color-hover`;
const $af143be694f933c4$var$bgColorActiveCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color-active`;
const $af143be694f933c4$var$colorCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color`;
const $af143be694f933c4$var$colorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color-hover`;
const $af143be694f933c4$var$colorActiveCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color-active`;
const $af143be694f933c4$var$boxShadowCssVar = `${$af143be694f933c4$var$cssVarPrefix}-box-shadow`;
const $af143be694f933c4$var$iconSecondaryColorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-icon-secondary-color-hover`;
const $af143be694f933c4$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $af143be694f933c4$var$WrapperComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $eJOHy.createElement((0, $c9uTK.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $eJOHy.createElement($af143be694f933c4$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $af143be694f933c4$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $fZmSO.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $gCY1z.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $8KWr1.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $af143be694f933c4$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$af143be694f933c4$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$af143be694f933c4$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$af143be694f933c4$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$af143be694f933c4$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$af143be694f933c4$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$af143be694f933c4$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$af143be694f933c4$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$af143be694f933c4$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $hcewu.default)([
            (0, $hcewu.default)([
                $af143be694f933c4$var$styles.root
            ]),
            isSelected && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $4vQlI.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            $af143be694f933c4$var$styles.root,
            isSelected && $af143be694f933c4$var$styles.selected,
            itemTheme?.color?.default && $af143be694f933c4$var$styles.themeColorDefault,
            itemTheme?.background?.default && $af143be694f933c4$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $af143be694f933c4$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $af143be694f933c4$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $af143be694f933c4$var$styles.themeColorHover,
            itemTheme?.color?.active && $af143be694f933c4$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $af143be694f933c4$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af143be694f933c4$var$ButtonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8KWr1", function(module, exports) {
$parcel$export(module.exports, "SidebarThemeProvider", () => $76cb412fcc597faf$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $76cb412fcc597faf$export$b1a81b4626bc52c3);

var $eJOHy = parcelRequire("eJOHy");
const $76cb412fcc597faf$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $76cb412fcc597faf$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76cb412fcc597faf$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $76cb412fcc597faf$export$b1a81b4626bc52c3 = ()=>(0, $eJOHy.useContext)($76cb412fcc597faf$var$ThemeContext);

});

parcelRegister("fZmSO", function(module, exports) {
$parcel$export(module.exports, "useOnClick", () => $95214767aefcba5f$export$a81c45382e7253ac);

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $95214767aefcba5f$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("8kc2T", function(module, exports) {
$parcel$export(module.exports, "TitleHeader", () => $5d3eb52abe585b54$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1H6cR = parcelRequire("1H6cR");
const $5d3eb52abe585b54$var$overrideStyles = null;
const $5d3eb52abe585b54$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1H6cR.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $hcewu.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("1H6cR", function(module, exports) {
$parcel$export(module.exports, "CustomHeader", () => $c6612ad9800f1aa6$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4vQlI = parcelRequire("4vQlI");

var $8KWr1 = parcelRequire("8KWr1");
const $c6612ad9800f1aa6$var$bgColorCssVar = '--header-bg-color';
const $c6612ad9800f1aa6$var$textColorCssVar = '--header-text-color';
const $c6612ad9800f1aa6$var$containerStyles = null;
const $c6612ad9800f1aa6$var$bgColorThemeStyles = null;
const $c6612ad9800f1aa6$var$colorThemeStyles = null;
const $c6612ad9800f1aa6$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$c6612ad9800f1aa6$var$bgColorCssVar]: item?.background?.default,
            [$c6612ad9800f1aa6$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $c6612ad9800f1aa6$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $4vQlI.default), {
        ...rest,
        component: $c6612ad9800f1aa6$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("dPngI", function(module, exports) {
$parcel$export(module.exports, "ConnectMenu", () => $f2c616a9ef8ca18f$export$19d0925d424b864a);

var $eJOHy = parcelRequire("eJOHy");

var $2FyzM = parcelRequire("2FyzM");

var $2L5WL = parcelRequire("2L5WL");
const $f2c616a9ef8ca18f$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $2FyzM.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2L5WL.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("2FyzM", function(module, exports) {
$parcel$export(module.exports, "useFilteredItems", () => $834772dde15fdd1a$export$79762159776e61da);

var $eJOHy = parcelRequire("eJOHy");

var $eES78 = parcelRequire("eES78");
const $834772dde15fdd1a$export$79762159776e61da = (items, shouldFilter = true)=>(0, $eJOHy.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $eES78.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("2L5WL", function(module, exports) {
$parcel$export(module.exports, "ConnectItem", () => $02c32db1d359d9d3$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kcLaf = parcelRequire("kcLaf");

var $diNYL = parcelRequire("diNYL");

var $9YRcI = parcelRequire("9YRcI");

var $eAeIg = parcelRequire("eAeIg");

var $jUPZ1 = parcelRequire("jUPZ1");

var $cGvTS = parcelRequire("cGvTS");

var $dysoB = parcelRequire("dysoB");

var $7wb6T = parcelRequire("7wb6T");

var $8kc2T = parcelRequire("8kc2T");

var $gkhxF = parcelRequire("gkhxF");

var $8xDPn = parcelRequire("8xDPn");
const $02c32db1d359d9d3$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jUPZ1.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $cGvTS.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $eJOHy.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $9YRcI.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $eAeIg.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02c32db1d359d9d3$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $eJOHy.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $cGvTS.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $9YRcI.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $eAeIg.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02c32db1d359d9d3$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkhxF.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7wb6T.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kc2T.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02c32db1d359d9d3$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $8xDPn.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c32db1d359d9d3$var$ConnectIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eAeIg", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $35882f1170e3dcfb$export$93509ff9a62ee022);

var $5Qndl = parcelRequire("5Qndl");
const $35882f1170e3dcfb$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $5Qndl.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("7wb6T", function(module, exports) {
$parcel$export(module.exports, "NavigationHeaderWrapper", () => $6bae686b85f6a717$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $6bae686b85f6a717$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $6bae686b85f6a717$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $6bae686b85f6a717$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $6bae686b85f6a717$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $6bae686b85f6a717$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $6bae686b85f6a717$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NavigationHeaderWrapperContainer, null, props.children);
const $6bae686b85f6a717$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $6bae686b85f6a717$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $6bae686b85f6a717$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $6bae686b85f6a717$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$ExpandableProjectContainer, null, props.children);
const $6bae686b85f6a717$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bae686b85f6a717$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bae686b85f6a717$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $awdRS.default)(__cmplp.nestedAppOpen ? 'auto' : '100%')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv12b0 _83u612b0 _1ern12b0 _rjkj12b0",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2u196n _1n80196n _di7g196n _1loz196n" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_fbie05": (0, $awdRS.default)(__cmplp.nestedMenuOpen ? 0 : 60, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_yugv12b0 _83u612b0 _1ern12b0 _rjkj12b0",
            __cmplp.submenuActive ? "_4t3igmb1" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91ejb _19iy1ejb _t6kl1ejb _shi31ejb" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp14h2 _l9o614h2 _f6zi14h2",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $6bae686b85f6a717$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gkhxF", function(module, exports) {
$parcel$export(module.exports, "NestingMenuItem", () => $fac5addee1b29ecd$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aqu01 = parcelRequire("aqu01");

var $eOsRG = parcelRequire("eOsRG");

var $dysGT = parcelRequire("dysGT");

var $dysoB = parcelRequire("dysoB");

var $8KWr1 = parcelRequire("8KWr1");

var $762yz = parcelRequire("762yz");
const $fac5addee1b29ecd$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $fac5addee1b29ecd$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $fac5addee1b29ecd$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $eJOHy.createElement("a", props, props.children);
const $fac5addee1b29ecd$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $eJOHy.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $eJOHy.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $eJOHy.createElement(WrapperComponent, null, /*#__PURE__*/ $eJOHy.createElement((0, $dysoB.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqu01))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $762yz.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$fac5addee1b29ecd$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $hcewu.default)([
                iconSecondaryColor && $fac5addee1b29ecd$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $eJOHy.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $eJOHy.createElement((0, $eOsRG.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $fac5addee1b29ecd$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $hcewu.default)([
                $fac5addee1b29ecd$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $eJOHy.createElement((0, $dysGT.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $eJOHy.createElement((0, $dysoB.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});



parcelRegister("12LC2", function(module, exports) {
$parcel$export(module.exports, "SECTION_ID", () => $edeae68033ab1128$export$501955bd67991a25);
const $edeae68033ab1128$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("4nlI9", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $f7718e8cb9fac139$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $f7718e8cb9fac139$export$f601efaceb0636f4);

var $eJOHy = parcelRequire("eJOHy");

var $dGS6y = parcelRequire("dGS6y");

var $jkijI = parcelRequire("jkijI");

var $8mNJo = parcelRequire("8mNJo");

var $koAZ4 = parcelRequire("koAZ4");

var $35kfd = parcelRequire("35kfd");
const $f7718e8cb9fac139$export$4a39035bacc4ed76 = (0, $jkijI.withThrowOnError)(()=>{
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const { data: data, loading: loading, error: error } = (0, $dGS6y.useNavigationGlobalResource)();
    // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $koAZ4.useTenantContext)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $35kfd.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $f7718e8cb9fac139$export$f601efaceb0636f4 = (0, $jkijI.withThrowOnError)((0, $8mNJo.useGlobalSettingsSystemConnectItems));

});
parcelRegister("dGS6y", function(module, exports) {
$parcel$export(module.exports, "useNavigationGlobalResource", () => $5ff6e79cef908460$export$1e1c317ed5b99faa);

var $eJOHy = parcelRequire("eJOHy");

var $enHI7 = parcelRequire("enHI7");

var $eJrcF = parcelRequire("eJrcF");
const $5ff6e79cef908460$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $enHI7.navigationSidebarGlobalResource));
    const response = (0, $eJOHy.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("jkijI", function(module, exports) {
$parcel$export(module.exports, "withThrowOnError", () => $8b058de70bdadedd$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gRw8I = parcelRequire("gRw8I");
const $8b058de70bdadedd$var$isDataEmpty = (data)=>data == null;
function $8b058de70bdadedd$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gRw8I.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $8b058de70bdadedd$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("8mNJo", function(module, exports) {
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $786134a7d6f046e9$export$f601efaceb0636f4);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dGS6y = parcelRequire("dGS6y");

var $gCY1z = parcelRequire("gCY1z");

var $3uU3k = parcelRequire("3uU3k");

var $e4GDd = parcelRequire("e4GDd");

var $7Q6ai = parcelRequire("7Q6ai");
// use memoised functions per hook to avoid re-computation between same hooks
const $786134a7d6f046e9$var$getItemsMemo = (0, $LFmXM.default)((d)=>(0, $e4GDd.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $7Q6ai.transformLink)).filter(Boolean));
const $786134a7d6f046e9$var$findItemAndStackMemo = (0, $LFmXM.default)((0, $3uU3k.findItemAndStack));
const $786134a7d6f046e9$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $dGS6y.useNavigationGlobalResource)();
    const items = (0, $eJOHy.useMemo)(()=>data && $786134a7d6f046e9$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eJOHy.useMemo)(()=>route && items && $786134a7d6f046e9$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("3uU3k", function(module, exports) {
$parcel$export(module.exports, "findItemAndStack", () => $0c85a801882a0f1a$export$751e2e6237002565);

var $cSmYj = parcelRequire("cSmYj");

var $artR0 = parcelRequire("artR0");
// JSPA-1062 remove qs items that might not always be there
const $0c85a801882a0f1a$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $0c85a801882a0f1a$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $0c85a801882a0f1a$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $artR0.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $0c85a801882a0f1a$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $0c85a801882a0f1a$var$splitRelevantQs(itemQs);
        const sameQuery = $0c85a801882a0f1a$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $0c85a801882a0f1a$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("e4GDd", function(module, exports) {
$parcel$export(module.exports, "getLinks", () => $f7606ddd2919ecd5$export$8054dcb2b42da45c);

var $5MqBz = parcelRequire("5MqBz");

var $9BLJ5 = parcelRequire("9BLJ5");
const $f7606ddd2919ecd5$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $5MqBz.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $9BLJ5.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $9BLJ5.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $9BLJ5.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("5MqBz", function(module, exports) {
$parcel$export(module.exports, "hasItemInSidebar", () => $6acdf3cbbe313a21$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $6acdf3cbbe313a21$export$9b7e0e4dd8bfade8);
const $6acdf3cbbe313a21$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $6acdf3cbbe313a21$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $6acdf3cbbe313a21$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $6acdf3cbbe313a21$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $6acdf3cbbe313a21$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($6acdf3cbbe313a21$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $6acdf3cbbe313a21$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $6acdf3cbbe313a21$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $6acdf3cbbe313a21$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $6acdf3cbbe313a21$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("9BLJ5", function(module, exports) {
$parcel$export(module.exports, "connectPrefix", () => $37513bb0a469b460$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $37513bb0a469b460$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $37513bb0a469b460$export$b1c2c1fc5d10280);

var $eES78 = parcelRequire("eES78");
const $37513bb0a469b460$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $37513bb0a469b460$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $37513bb0a469b460$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $37513bb0a469b460$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $37513bb0a469b460$export$b1c2c1fc5d10280 = [
    $37513bb0a469b460$var$legacyAddonPanelLinkId,
    (0, $eES78.REPORTS_IDS).REPORTS_ADDONS,
    $37513bb0a469b460$var$jsdQueuesConnectSection
];

});


parcelRegister("7Q6ai", function(module, exports) {
$parcel$export(module.exports, "transformLink", () => $70bed4bda6f79222$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $70bed4bda6f79222$export$27267b6b6650eaa5);
const $70bed4bda6f79222$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($70bed4bda6f79222$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $70bed4bda6f79222$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($70bed4bda6f79222$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("35kfd", function(module, exports) {
$parcel$export(module.exports, "extractData", () => $986afa50afdb72df$export$9df5fa0a366163d2);

var $5MqBz = parcelRequire("5MqBz");
const $986afa50afdb72df$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $5MqBz.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $5MqBz.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $5MqBz.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $5MqBz.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $5MqBz.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $5MqBz.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $5MqBz.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $5MqBz.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $5MqBz.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $5MqBz.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("jNN5t", function(module, exports) {
$parcel$export(module.exports, "AdminHelperSection", () => $284ed6edcc1285b8$export$4855b2d78f0d666a);

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");

var $guChT = parcelRequire("guChT");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $jDVls = parcelRequire("jDVls");
const $284ed6edcc1285b8$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $284ed6edcc1285b8$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $jDVls.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $jDVls.default).permissionHelper)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: $284ed6edcc1285b8$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $284ed6edcc1285b8$var$emailNotificationsLogContainerStyles
    }, formatMessage((0, $jDVls.default).adminEmailAuditNotificationsLog))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
        engagementId: $284ed6edcc1285b8$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $284ed6edcc1285b8$var$emailNotificationsLogContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("jDVls", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca6b4330674f0b26$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ca6b4330674f0b26$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    adminEmailAuditNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
        "defaultMessage": "Admin email audit"
    }
});

});


parcelRegister("984NX", function(module, exports) {
$parcel$export(module.exports, "AdvancedSection", () => $31c218580cdf3392$export$32bea920eaad7efb);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $53NWI = parcelRequire("53NWI");
const $31c218580cdf3392$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $53NWI.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).webhooks)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $53NWI.default).lexorankManagement)));
};

});
parcelRegister("53NWI", function(module, exports) {
$parcel$export(module.exports, "default", () => $09c752d73d743455$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $09c752d73d743455$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("biIRA", function(module, exports) {
$parcel$export(module.exports, "AutomationSection", () => $25640454f6bfc0ee$export$5fa01e4d25d8e6ec);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $5GHeW = parcelRequire("5GHeW");
const $25640454f6bfc0ee$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $5GHeW.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            'global-automation'
        ]
    }, formatMessage((0, $5GHeW.default).globalAutomation)));
};

});
parcelRegister("5GHeW", function(module, exports) {
$parcel$export(module.exports, "default", () => $acf7c280d3e158e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $acf7c280d3e158e4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("cQl3U", function(module, exports) {
$parcel$export(module.exports, "ImportExportSection", () => $b91ddb39621dbc16$export$2e4cb1dc5b398447);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $FhXEJ = parcelRequire("FhXEJ");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $koAZ4 = parcelRequire("koAZ4");

var $4nlI9 = parcelRequire("4nlI9");

var $jmET1 = parcelRequire("jmET1");
const $b91ddb39621dbc16$export$2e4cb1dc5b398447 = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { licensedProducts: licensedProducts } = (0, $koAZ4.useTenantContext)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    const hasSupportedLicense = licensedProducts[(0, $FhXEJ.projectTypeToCanonicalId)((0, $FhXEJ.SOFTWARE_PROJECT))] || licensedProducts[(0, $FhXEJ.projectTypeToCanonicalId)((0, $FhXEJ.CORE_PROJECT))];
    const showNewExternalImport = hasSupportedLicense;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $jmET1.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $jmET1.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $jmET1.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $8xDPn.matchUrlExact)()
    }, formatMessage((0, $jmET1.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $8xDPn.matchUrlExact)()
    }, formatMessage((0, $jmET1.default).importJiraServer)));
};

});
parcelRegister("jmET1", function(module, exports) {
$parcel$export(module.exports, "default", () => $80a0b82ad0592101$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $80a0b82ad0592101$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});


parcelRegister("013X4", function(module, exports) {
$parcel$export(module.exports, "MailSection", () => $6d5aa7476d5021b7$export$6e0cda39522c0aa7);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $dtZZt = parcelRequire("dtZZt");

var $5v2Rk = parcelRequire("5v2Rk");
const $6d5aa7476d5021b7$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $dtZZt.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $dtZZt.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $dtZZt.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $5v2Rk.isIncomingMailSelected)
    }, formatMessage((0, $dtZZt.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $dtZZt.default).sendEmail)));
};

});
parcelRegister("dtZZt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed6dc523930ca679$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ed6dc523930ca679$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("5v2Rk", function(module, exports) {
$parcel$export(module.exports, "isIncomingMailSelected", () => $8a4849689084cd66$export$3f53f72603975cb0);

var $8xDPn = parcelRequire("8xDPn");
const $8a4849689084cd66$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $8a4849689084cd66$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $8a4849689084cd66$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("kgYBH", function(module, exports) {
$parcel$export(module.exports, "default", () => $fab742a91d22043b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fab742a91d22043b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System settings"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    globalSettingsSystemSidebarLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
        "defaultMessage": "Sidebar"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    }
});

});

parcelRegister("km8c0", function(module, exports) {
$parcel$export(module.exports, "SecuritySection", () => $2de52b30b3079886$export$4f16aec1633bed7d);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $7EtzP = parcelRequire("7EtzP");

var $8EV7W = parcelRequire("8EV7W");
const $2de52b30b3079886$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $7EtzP.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $8EV7W.isProjectRolesSelected)
    }, formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $7EtzP.default).projectRolesGalaxia : (0, $7EtzP.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $7EtzP.default).globalPermissions)));
};

});
parcelRegister("7EtzP", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdb8303b45d710f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fdb8303b45d710f6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    },
    projectRolesGalaxia: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles-galaxia",
        "defaultMessage": "Space roles"
    }
});

});

parcelRegister("8EV7W", function(module, exports) {
$parcel$export(module.exports, "isProjectRolesSelected", () => $ff731d2affade8a4$export$ca9501e7fedfce90);

var $8xDPn = parcelRequire("8xDPn");
const $ff731d2affade8a4$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $ff731d2affade8a4$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $ff731d2affade8a4$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("gg4FC", function(module, exports) {
$parcel$export(module.exports, "SharedSection", () => $05fba404380a8e8d$export$230e518497f06fdc);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $8c9sn = parcelRequire("8c9sn");
const $05fba404380a8e8d$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $8c9sn.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $8c9sn.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $8c9sn.default).dashboards)));
};

});
parcelRegister("8c9sn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0f4d97db1c45217$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a0f4d97db1c45217$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("8mGF5", function(module, exports) {
$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $cf60a611cf5d4781$export$dad01649916e6a2d);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $bxtyM = parcelRequire("bxtyM");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $4nlI9 = parcelRequire("4nlI9");

var $3jVDS = parcelRequire("3jVDS");

var $3NDiG = parcelRequire("3NDiG");

var $4cBUk = parcelRequire("4cBUk");
const $cf60a611cf5d4781$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $bxtyM.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $3jVDS.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $4cBUk.isViewAuditingSelected)
    }, formatMessage((0, $3jVDS.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $3jVDS.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NDiG.PerformanceMenuItem), null));
};

});
parcelRegister("bxtyM", function(module, exports) {
$parcel$export(module.exports, "useSiteOptimizerCheck", () => $8a287a8fe16adf8c$export$7df80afc329cd61);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $3ugTQ = parcelRequire("3ugTQ");
const $8a287a8fe16adf8c$export$e9921a980669184 = ()=>(0, $3ugTQ.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $8a287a8fe16adf8c$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $4cTDP.fg)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $8a287a8fe16adf8c$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("3jVDS", function(module, exports) {
$parcel$export(module.exports, "default", () => $52beb7cb400b52c2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $52beb7cb400b52c2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("3NDiG", function(module, exports) {
$parcel$export(module.exports, "PerformanceMenuItem", () => $6fc2f116c407bd92$export$b4e98631ff0b3fb5);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $lRq8t = parcelRequire("lRq8t");

var $gkhxF = parcelRequire("gkhxF");

var $gp9Js = parcelRequire("gp9Js");

var $kRgKj = parcelRequire("kRgKj");

var $iC2Fk = parcelRequire("iC2Fk");

var $e6YEs = parcelRequire("e6YEs");

var $12LC2 = parcelRequire("12LC2");

var $fuICN = parcelRequire("fuICN");

var $fKDY2 = parcelRequire("fKDY2");

var $3nYWL = parcelRequire("3nYWL");
const $6fc2f116c407bd92$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $e6YEs.useAccountId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $eJOHy.useState)(false);
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $fuICN.default).itemBack)
    };
    const fetchSpotlightState = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $3nYWL.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkhxF.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, formatMessage((0, $fuICN.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage((0, $fuICN.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $12LC2.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKDY2.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $fuICN.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $fuICN.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $fuICN.default).spotlightBody))));
};

});
parcelRegister("fuICN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1499884aa597ea7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d1499884aa597ea7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("fKDY2", function(module, exports) {
$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $ba767faeb08b2c25$export$442d4ccb0d25fc50);

var $eJOHy = parcelRequire("eJOHy");

var $97M9u = parcelRequire("97M9u");

var $4JSOn = parcelRequire("4JSOn");

var $diNYL = parcelRequire("diNYL");

var $guChT = parcelRequire("guChT");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $8kc2T = parcelRequire("8kc2T");

var $8xDPn = parcelRequire("8xDPn");

var $dGzlS = parcelRequire("dGzlS");

var $967Ue = parcelRequire("967Ue");
const $ba767faeb08b2c25$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $4JSOn.getAllVisibleMetrics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kc2T.TitleHeader), null, formatMessage((0, $dGzlS.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $8xDPn.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $dGzlS.default).overview)), (0, $4cTDP.fg)('enable_cfo_dashboard') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'performance-dashboard'
        },
        selectedOn: (0, $8xDPn.matchUrlPathname)(),
        href: `${basePerformanceUrl}/dashboard`
    }, formatMessage((0, $dGzlS.default).dashboard))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $dGzlS.default).allReports)
    }, allVisibleMetrics.map((metric)=>{
        if (metric.key === (0, $97M9u.PROJECT_CLEANUP_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: "project-cleanup-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: (0, $967Ue.PROJECT_CLEANUP_SPOTLIGHT_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $8xDPn.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $967Ue.ProjectCleanupSpotlight), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $8xDPn.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name));
    })));
};

});
parcelRegister("97M9u", function(module, exports) {
$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $6be6c1ed25642b4a$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "projectCleanupConstants", () => $6be6c1ed25642b4a$export$a67febcdb988ec8a);

var $7qGN1 = parcelRequire("7qGN1");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $6be6c1ed25642b4a$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $6be6c1ed25642b4a$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $6be6c1ed25642b4a$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $6be6c1ed25642b4a$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $6be6c1ed25642b4a$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $6be6c1ed25642b4a$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
const $6be6c1ed25642b4a$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $6be6c1ed25642b4a$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
const $6be6c1ed25642b4a$var$messages = (0, $7qGN1.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
        "defaultMessage": "See how we identify these projects."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Projects over time"
    },
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});
const $6be6c1ed25642b4a$export$4e9bf1d386c2f0c = 'projectcleanup';
const $6be6c1ed25642b4a$export$a67febcdb988ec8a = {
    key: $6be6c1ed25642b4a$export$4e9bf1d386c2f0c,
    visible: true,
    name: $6be6c1ed25642b4a$var$messages.nameNonFinal,
    description: $6be6c1ed25642b4a$var$messages.descriptionNonFinal,
    tabLabels: [
        $6be6c1ed25642b4a$var$messages.analysisNonFinal,
        $6be6c1ed25642b4a$var$messages.activityLogNonFinal
    ],
    warningMessage: $6be6c1ed25642b4a$var$messages.warningNonFinal,
    exceededMessage: $6be6c1ed25642b4a$var$messages.exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: $6be6c1ed25642b4a$var$messages.currentValueLabel,
    cleanupValueLabel: $6be6c1ed25642b4a$var$messages.cleanupValueLabel,
    graphHeader: $6be6c1ed25642b4a$var$messages.graphHeader,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
    recommendationUrlText: $6be6c1ed25642b4a$var$messages.recommendationUrlText
};

});

parcelRegister("4JSOn", function(module, exports) {
$parcel$export(module.exports, "getAllVisibleMetrics", () => $ed6d3fb6f0437e6f$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $ed6d3fb6f0437e6f$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $ed6d3fb6f0437e6f$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $ed6d3fb6f0437e6f$export$cbadc5a7223772a8);
$parcel$export(module.exports, "TooltipMap", () => $ed6d3fb6f0437e6f$export$9bd9f2d76c500145);
$parcel$export(module.exports, "getUrl", () => $ed6d3fb6f0437e6f$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "sortMetrics", () => $ed6d3fb6f0437e6f$export$4d417651bd525c45);

var $1AT9S = parcelRequire("1AT9S");

var $1VPxe = parcelRequire("1VPxe");

var $lnhoM = parcelRequire("lnhoM");

var $97M9u = parcelRequire("97M9u");

var $dejTV = parcelRequire("dejTV");

var $7ah8V = parcelRequire("7ah8V");

var $auF4B = parcelRequire("auF4B");
class $ed6d3fb6f0437e6f$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $ed6d3fb6f0437e6f$var$mitigationEnabled(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $ed6d3fb6f0437e6f$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $ed6d3fb6f0437e6f$var$REGISTRY = new $ed6d3fb6f0437e6f$export$9419457073a1750((0, $auF4B.METRICS));
const $ed6d3fb6f0437e6f$export$ed0dc1178a679c67 = $ed6d3fb6f0437e6f$var$REGISTRY.getMetric.bind($ed6d3fb6f0437e6f$var$REGISTRY);
const $ed6d3fb6f0437e6f$export$e6140fda06493d18 = $ed6d3fb6f0437e6f$var$REGISTRY.getAllVisibleMetrics.bind($ed6d3fb6f0437e6f$var$REGISTRY);
const $ed6d3fb6f0437e6f$export$1f2abf3e170d35d2 = $ed6d3fb6f0437e6f$var$REGISTRY.getAllVisibleMetricsKeys.bind($ed6d3fb6f0437e6f$var$REGISTRY);
const $ed6d3fb6f0437e6f$var$mitigationEnabled = (metricKey)=>{
    switch(metricKey){
        case 0, $97M9u.PROJECT_CLEANUP_KEY:
        case 0, $dejTV.PROJECT_ROLE_ACTOR_KEY:
        case 0, $1VPxe.CUSTOM_FIELDS_KEY:
        case 0, $lnhoM.ISSUE_KEY:
        case 0, $7ah8V.WORK_TYPES_KEY:
            return true;
        default:
            return false;
    }
};
const $ed6d3fb6f0437e6f$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};
const $ed6d3fb6f0437e6f$export$9bd9f2d76c500145 = {
    [(0, $1VPxe.CUSTOM_FIELDS_KEY)]: (0, $1AT9S.CustomFieldsTooltip)
};
const $ed6d3fb6f0437e6f$export$94df0e59ebebf4a7 = (metric)=>`metrics/${metric.key}`;
const $ed6d3fb6f0437e6f$export$4d417651bd525c45 = (a, b)=>{
    if ('name' in a && 'name' in b && a.name?.defaultMessage && b.name?.defaultMessage) return a.name.defaultMessage.localeCompare(b.name.defaultMessage);
    return 0;
};

});
parcelRegister("1AT9S", function(module, exports) {
$parcel$export(module.exports, "CustomFieldsTooltip", () => $f91edec8649c5a93$export$9a2f1f96cf156e26);

var $3TZ4e = parcelRequire("3TZ4e");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");
var $7AseU = parcelRequire("7AseU");

var $lRq8t = parcelRequire("lRq8t");

var $essTM = parcelRequire("essTM");
const $f91edec8649c5a93$var$CustomTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...rest }, ref)=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $7AseU.default), {
        ...rest,
        ref: ref,
        className: (0, $hcewu.default)([
            $f91edec8649c5a93$var$styles.tooltipStyles
        ])
    }, children);
});
const $f91edec8649c5a93$export$9a2f1f96cf156e26 = ({ children: children, dataRef: dataRef, metricState: metricState })=>{
    const { resourceUsageMetricV2: metricUsageData } = (0, $j4oe4.useFragment)((0, $3TZ4e.default), dataRef);
    if (metricUsageData === null || metricUsageData === undefined) return null;
    const customFieldsCount = {
        globalScopedCustomFieldsCount: metricUsageData.globalScopedCustomFieldsCount,
        projectScopedCustomFieldsCount: metricUsageData.projectScopedCustomFieldsCount
    };
    const customFieldsCountLabels = {
        globalScopedCustomFieldsCountLabel: (0, $essTM.default).globalScopedCustomFieldsCountLabel,
        projectScopedCustomFieldsCountLabel: (0, $essTM.default).projectScopedCustomFieldsCountLabel,
        globalScopedCustomFieldsCountAriaLabel: (0, $essTM.default).globalScopedCustomFieldsCountAriaLabel,
        projectScopedCustomFieldsCountArialLabel: (0, $essTM.default).projectScopedCustomFieldsCountAriaLabel
    };
    return /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: /*#__PURE__*/ $eJOHy.createElement($f91edec8649c5a93$var$CustomFieldsTooltipContent, {
            customFieldsCount: customFieldsCount,
            customFieldsCountLabels: customFieldsCountLabels,
            metricState: metricState
        }),
        component: $f91edec8649c5a93$var$CustomTooltip
    }, children);
};
const $f91edec8649c5a93$var$CustomFieldsTooltipContent = ({ customFieldsCount: customFieldsCount, customFieldsCountLabels: customFieldsCountLabels, metricState: metricState })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $lRq8t.default)();
    const { globalScopedCustomFieldsCount: globalScopedCustomFieldsCount, projectScopedCustomFieldsCount: projectScopedCustomFieldsCount } = customFieldsCount;
    const { globalScopedCustomFieldsCountLabel: globalScopedCustomFieldsCountLabel, projectScopedCustomFieldsCountLabel: projectScopedCustomFieldsCountLabel, globalScopedCustomFieldsCountAriaLabel: globalScopedCustomFieldsCountAriaLabel, projectScopedCustomFieldsCountArialLabel: projectScopedCustomFieldsCountArialLabel } = customFieldsCountLabels;
    return /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $f91edec8649c5a93$var$styles.numbersContainer
    }, globalScopedCustomFieldsCount != null && globalScopedCustomFieldsCountLabel && /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $f91edec8649c5a93$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": globalScopedCustomFieldsCountAriaLabel ? formatMessage(globalScopedCustomFieldsCountAriaLabel, {
            number: formatNumber(globalScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)(metricState === 'none' && $f91edec8649c5a93$var$styles.successNumber, metricState === 'warning' && $f91edec8649c5a93$var$styles.warningNumber, metricState === 'exceeded' && $f91edec8649c5a93$var$styles.errorNumber, $f91edec8649c5a93$var$styles.fontWeightStyles),
        "aria-describedby": "global-scoped-custom-fields-count-desc"
    }, formatNumber(globalScopedCustomFieldsCount)), /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $f91edec8649c5a93$var$styles.textContainer
    }, /*#__PURE__*/ $eJOHy.createElement("small", {
        id: "global-scoped-custom-fields-count-desc"
    }, formatMessage(globalScopedCustomFieldsCountLabel)))), projectScopedCustomFieldsCount != null && projectScopedCustomFieldsCountLabel && /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $f91edec8649c5a93$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": projectScopedCustomFieldsCountArialLabel ? formatMessage(projectScopedCustomFieldsCountArialLabel, {
            number: formatNumber(projectScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)(metricState === 'none' && $f91edec8649c5a93$var$styles.successNumber, metricState === 'warning' && $f91edec8649c5a93$var$styles.warningNumber, metricState === 'exceeded' && $f91edec8649c5a93$var$styles.errorNumber, $f91edec8649c5a93$var$styles.fontWeightStyles),
        "aria-describedby": "project-scoped-custom-fields-count-desc"
    }, formatNumber(projectScopedCustomFieldsCount)), /*#__PURE__*/ $eJOHy.createElement((0, $8IeH1.default), {
        xcss: $f91edec8649c5a93$var$styles.textContainer
    }, /*#__PURE__*/ $eJOHy.createElement("small", {
        id: "project-scoped-custom-fields-count-desc"
    }, formatMessage(projectScopedCustomFieldsCountLabel)))));
};
const $f91edec8649c5a93$var$styles = {
    numbersContainer: "_1e0c1txw _y3gn1h6o _1bsb1mjv _1bah1yb4 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
    numberContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    successNumber: "_11c8nf1z _syazaqb7",
    warningNumber: "_11c8nf1z _syaz1q28",
    errorNumber: "_11c8nf1z _syaz9lu1",
    fontWeightStyles: "_k48p1pd9",
    textContainer: "_p12f1lit",
    tooltipStyles: "_2rko12b0 _bfhk1j9a _syaz15cr _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qszucj"
};

});
parcelRegister("3TZ4e", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c293c022d546ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53f9681513f47eef225087ff5b4a6d22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $44c293c022d546ae$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "metricKey"
        }
    ],
    "kind": "Fragment",
    "name": "CustomFieldsTooltip",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "metricKey",
                    "variableName": "metricKey"
                }
            ],
            "kind": "LinkedField",
            "name": "resourceUsageMetricV2",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "globalScopedCustomFieldsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectScopedCustomFieldsCount"
                        }
                    ],
                    "type": "JiraCustomFieldUsageMetric"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$44c293c022d546ae$var$node.hash = "42a9b9edb6fb9283ff37d663fa3ce970";
var $44c293c022d546ae$export$2e2bcd8739ae039 = $44c293c022d546ae$var$node;

});

parcelRegister("essTM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c87d9df241cdfa9d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c87d9df241cdfa9d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    descriptionV2: {
        "id": "admin-pages__performance.common.assets.custom-fields.description-v-2",
        "defaultMessage": "Monitor custom field usage across projects. Each project can have up to {entityLimit} custom fields per scheme track usage to stay within this threshold and prevent performance degradation or configuration blocks."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-label",
        "defaultMessage": "CMP custom fields count"
    },
    projectScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-label",
        "defaultMessage": "TMP custom fields count"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {global scoped custom field} other {global scoped custom fields}}"
    },
    projectScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {project scoped custom field} other {global scoped custom fields}}"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "See how we identify these fields."
    },
    recommendationUrlTextV2: {
        "id": "admin-pages__performance.common.assets.custom-fields.recommendation-url-text-v-2",
        "defaultMessage": "Learn how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1-issue-term-refresh",
        "defaultMessage": "Custom fields can make searching (JQL and boards) and creating work items slow."
    }
});

});


parcelRegister("1VPxe", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $39c4e274f4d58fc8$export$d214286a7039b004);
$parcel$export(module.exports, "customFieldsConstants", () => $39c4e274f4d58fc8$export$9e7ee8c9ecad1392);

var $essTM = parcelRequire("essTM");
const $39c4e274f4d58fc8$export$d214286a7039b004 = 'customField';
const $39c4e274f4d58fc8$export$9e7ee8c9ecad1392 = {
    key: $39c4e274f4d58fc8$export$d214286a7039b004,
    visible: true,
    name: (0, $essTM.default).name,
    description: (0, $essTM.default).description,
    descriptionV2: (0, $essTM.default).descriptionV2,
    tabLabels: [
        (0, $essTM.default).chart,
        (0, $essTM.default).reviewAndAnalyze
    ],
    warningMessage: (0, $essTM.default).warning,
    exceededMessage: (0, $essTM.default).exceeded,
    risks: [
        (0, $essTM.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $essTM.default).currentValueLabel,
    currentValueAriaLabel: (0, $essTM.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $essTM.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $essTM.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $essTM.default).recommendationUrlText,
    recommendationUrlTextV2: (0, $essTM.default).recommendationUrlTextV2,
    graphHeader: (0, $essTM.default).graphHeader,
    showTooltip: true
};

});

parcelRegister("lnhoM", function(module, exports) {
$parcel$export(module.exports, "ISSUE_KEY", () => $587a262258db0fe2$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $587a262258db0fe2$export$76a449e52fa0e1e8);

var $7qGN1 = parcelRequire("7qGN1");
const $587a262258db0fe2$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    nameV2: {
        "id": "admin-pages__performance.common.assets.issue.name-v-2",
        "defaultMessage": "Work items"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    }
});
const $587a262258db0fe2$export$5daa28d10e23592 = 'issue';
const $587a262258db0fe2$export$76a449e52fa0e1e8 = {
    key: $587a262258db0fe2$export$5daa28d10e23592,
    visible: true,
    name: $587a262258db0fe2$var$messages.name,
    nameV2: $587a262258db0fe2$var$messages.nameV2,
    description: $587a262258db0fe2$var$messages.description,
    tabLabels: [
        $587a262258db0fe2$var$messages.reviewAndAnalyze,
        $587a262258db0fe2$var$messages.activityLog
    ],
    warningMessage: $587a262258db0fe2$var$messages.warning,
    exceededMessage: $587a262258db0fe2$var$messages.exceeded,
    risks: [
        $587a262258db0fe2$var$messages.risk1
    ],
    mitigations: [
        $587a262258db0fe2$var$messages.mitigation1,
        $587a262258db0fe2$var$messages.mitigation2,
        $587a262258db0fe2$var$messages.mitigation3
    ],
    currentValueLabel: $587a262258db0fe2$var$messages.currentValueLabel,
    currentValueAriaLabel: $587a262258db0fe2$var$messages.currentValueAriaLabel,
    thresholdValueLabel: $587a262258db0fe2$var$messages.thresholdValueLabel,
    thresholdValueAriaLabel: $587a262258db0fe2$var$messages.thresholdValueAriaLabel,
    graphHeader: $587a262258db0fe2$var$messages.graphHeader
};

});

parcelRegister("dejTV", function(module, exports) {
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $57a454eaf51b9dc1$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "projectRoleActorConstants", () => $57a454eaf51b9dc1$export$a709dfa86ca7ef50);

var $7qGN1 = parcelRequire("7qGN1");
const $57a454eaf51b9dc1$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});
const $57a454eaf51b9dc1$export$a570ca3f6cc5e280 = 'projectroleactor';
const $57a454eaf51b9dc1$export$a709dfa86ca7ef50 = {
    key: $57a454eaf51b9dc1$export$a570ca3f6cc5e280,
    visible: true,
    name: $57a454eaf51b9dc1$var$messages.name,
    description: $57a454eaf51b9dc1$var$messages.description,
    tabLabels: [
        $57a454eaf51b9dc1$var$messages.analysis,
        $57a454eaf51b9dc1$var$messages.activityLog
    ],
    warningMessage: $57a454eaf51b9dc1$var$messages.warning,
    exceededMessage: $57a454eaf51b9dc1$var$messages.exceeded,
    risks: [
        $57a454eaf51b9dc1$var$messages.risk1
    ],
    mitigations: [
        $57a454eaf51b9dc1$var$messages.mitigation1,
        $57a454eaf51b9dc1$var$messages.mitigation2,
        $57a454eaf51b9dc1$var$messages.mitigation3
    ],
    currentValueLabel: $57a454eaf51b9dc1$var$messages.currentValueLabel,
    currentValueAriaLabel: $57a454eaf51b9dc1$var$messages.currentValueAriaLabel,
    thresholdValueLabel: $57a454eaf51b9dc1$var$messages.thresholdValueLabel,
    thresholdValueAriaLabel: $57a454eaf51b9dc1$var$messages.thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: $57a454eaf51b9dc1$var$messages.recommendationUrlText,
    graphHeader: $57a454eaf51b9dc1$var$messages.graphHeader
};

});

parcelRegister("7ah8V", function(module, exports) {
$parcel$export(module.exports, "WORK_TYPES_KEY", () => $a454de7c301fada4$export$c171a00037afe9fe);
$parcel$export(module.exports, "workTypesConstants", () => $a454de7c301fada4$export$fd2841ae78d63fa4);

var $7qGN1 = parcelRequire("7qGN1");
const $a454de7c301fada4$var$messages = (0, $7qGN1.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.name-non-final",
        "defaultMessage": "Work types"
    },
    descriptionNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.description-non-final",
        "defaultMessage": "Monitor work types usage across projects. Each project can have up to {entityLimit} work types within a work type scheme. Monitor usage to stay within this threshold and maintain site performance and stability."
    },
    chartNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.chart-non-final",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyzeNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.review-and-analyze-non-final",
        "defaultMessage": "Analysis"
    },
    warningNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.warning-non-final",
        "defaultMessage": "The number of work types is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.exceeded-non-final",
        "defaultMessage": "There are more work types than our recommended threshold."
    },
    risk1NonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.risk-1-non-final",
        "defaultMessage": "Work types can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1NonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.mitigation-1-non-final",
        "defaultMessage": "Edit the context for the work type to make it visible only for specific projects."
    },
    mitigation2NonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.mitigation-2-non-final",
        "defaultMessage": "Limit the number of work types across all projects and use the same work type in multiple projects."
    },
    currentValueLabelNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.current-value-label-non-final",
        "defaultMessage": "Work types in your site"
    },
    thresholdValueLabelNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.threshold-value-label-non-final",
        "defaultMessage": "Recommended maximum number of work types"
    },
    currentValueAriaLabelNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.current-value-aria-label-non-final",
        "defaultMessage": "{number} work types in your site"
    },
    thresholdValueAriaLabelNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.threshold-value-aria-label-non-final",
        "defaultMessage": "{number} recommended maximum number of work types"
    },
    recommendationUrlTextNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.recommendation-url-text-non-final",
        "defaultMessage": "See how we identify these work types."
    },
    graphHeaderNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.graph-header-non-final",
        "defaultMessage": "Work types over time"
    },
    risk1IssueTermRefreshNonFinal: {
        "id": "admin-pages__performance.common.assets.work-types.risk-1-issue-term-refresh-non-final",
        "defaultMessage": "Work types can make searching (JQL and boards) and creating work items slow."
    }
});
const $a454de7c301fada4$export$c171a00037afe9fe = 'worktype';
const $a454de7c301fada4$export$fd2841ae78d63fa4 = {
    key: $a454de7c301fada4$export$c171a00037afe9fe,
    visible: true,
    name: $a454de7c301fada4$var$messages.nameNonFinal,
    description: $a454de7c301fada4$var$messages.descriptionNonFinal,
    tabLabels: [
        $a454de7c301fada4$var$messages.chartNonFinal,
        $a454de7c301fada4$var$messages.reviewAndAnalyzeNonFinal
    ],
    warningMessage: $a454de7c301fada4$var$messages.warningNonFinal,
    exceededMessage: $a454de7c301fada4$var$messages.exceededNonFinal,
    risks: [
        $a454de7c301fada4$var$messages.risk1NonFinal
    ],
    mitigations: [],
    currentValueLabel: $a454de7c301fada4$var$messages.currentValueLabelNonFinal,
    currentValueAriaLabel: $a454de7c301fada4$var$messages.currentValueAriaLabelNonFinal,
    thresholdValueLabel: $a454de7c301fada4$var$messages.thresholdValueLabelNonFinal,
    thresholdValueAriaLabel: $a454de7c301fada4$var$messages.thresholdValueAriaLabelNonFinal,
    recommendationUrl: '',
    recommendationUrlText: $a454de7c301fada4$var$messages.recommendationUrlTextNonFinal,
    graphHeader: $a454de7c301fada4$var$messages.graphHeaderNonFinal
};

});

parcelRegister("auF4B", function(module, exports) {
$parcel$export(module.exports, "METRICS", () => $33e162af1cce479a$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "SEARCH_SCHEME_STATS", () => $33e162af1cce479a$export$54209a8d2b29d234);
$parcel$export(module.exports, "REVIEW_AND_OPTIMIZE", () => $33e162af1cce479a$export$d0ec79ebaec8d930);
$parcel$export(module.exports, "REVIEW_AND_CLEANUP", () => $33e162af1cce479a$export$5f0512763ef3545a);
$parcel$export(module.exports, "OPTIMIZE_SCHEME", () => $33e162af1cce479a$export$4bdba8e46a779fae);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $33e162af1cce479a$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $33e162af1cce479a$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $33e162af1cce479a$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $33e162af1cce479a$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $33e162af1cce479a$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $33e162af1cce479a$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $33e162af1cce479a$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $33e162af1cce479a$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $33e162af1cce479a$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $33e162af1cce479a$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $33e162af1cce479a$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $33e162af1cce479a$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $33e162af1cce479a$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $33e162af1cce479a$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $33e162af1cce479a$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $33e162af1cce479a$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $33e162af1cce479a$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $33e162af1cce479a$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $33e162af1cce479a$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $33e162af1cce479a$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $33e162af1cce479a$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $33e162af1cce479a$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $33e162af1cce479a$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $33e162af1cce479a$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $33e162af1cce479a$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $33e162af1cce479a$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $33e162af1cce479a$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $33e162af1cce479a$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $33e162af1cce479a$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $33e162af1cce479a$export$efdb93c7210090d1);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", () => $33e162af1cce479a$export$6c650be5c2b4774f);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", () => $33e162af1cce479a$export$6493dd0e190d3f58);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", () => $33e162af1cce479a$export$422673ba1cec4aed);
$parcel$export(module.exports, "PROJECT_CLEAN_UP", () => $33e162af1cce479a$export$3a7186fc63c9e188);
$parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", () => $33e162af1cce479a$export$8e0b8859a3cbd9e6);
$parcel$export(module.exports, "ACTION_TRASH", () => $33e162af1cce479a$export$342d8b9804e407c7);
$parcel$export(module.exports, "ACTION_ARCHIVE", () => $33e162af1cce479a$export$b685f2109baf2b4f);
$parcel$export(module.exports, "ACTION_UNARCHIVE", () => $33e162af1cce479a$export$3ac60b381ed426ca);
$parcel$export(module.exports, "PAGE_SIZE", () => $33e162af1cce479a$export$8ec3d08588d2eeda);

var $1VPxe = parcelRequire("1VPxe");

var $lnhoM = parcelRequire("lnhoM");

var $97M9u = parcelRequire("97M9u");

var $dejTV = parcelRequire("dejTV");

var $7ah8V = parcelRequire("7ah8V");
const $33e162af1cce479a$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $1VPxe.customFieldsConstants),
    (0, $7ah8V.workTypesConstants),
    (0, $lnhoM.ISSUE),
    (0, $dejTV.projectRoleActorConstants),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $97M9u.projectCleanupConstants)
];
const $33e162af1cce479a$export$54209a8d2b29d234 = 'searchSchemeStats';
const $33e162af1cce479a$export$d0ec79ebaec8d930 = 'reviewAndOptimize';
const $33e162af1cce479a$export$5f0512763ef3545a = 'reviewAndCleanup';
const $33e162af1cce479a$export$4bdba8e46a779fae = 'optimizeScheme';
const $33e162af1cce479a$export$769b1a9477352cf9 = 'runAnalysis';
const $33e162af1cce479a$export$e7e31b14c32e055a = 'deleteRecommendations';
const $33e162af1cce479a$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $33e162af1cce479a$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $33e162af1cce479a$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $33e162af1cce479a$export$d358fc12daa9f606 = 'psiTab';
const $33e162af1cce479a$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $33e162af1cce479a$export$71794f4d197278dc = 'mitigationMetricCard';
const $33e162af1cce479a$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $33e162af1cce479a$export$d6761557c91eea50 = {
    metric: (0, $dejTV.PROJECT_ROLE_ACTOR_KEY)
};
const $33e162af1cce479a$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $33e162af1cce479a$export$70525d18051240f4 = 'restoreIssueArchival';
const $33e162af1cce479a$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $33e162af1cce479a$export$108288df7758f60c = 'restoreIssueTryAgain';
const $33e162af1cce479a$export$972d5a8da0d9f4c3 = 'viewIssues';
const $33e162af1cce479a$export$b920363d50bcf753 = 'stopIssueArchival';
const $33e162af1cce479a$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $33e162af1cce479a$export$5c2df36fdd8476f7 = 'jqlSearch';
const $33e162af1cce479a$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $33e162af1cce479a$export$c62a52f3f7d80ec3 = {
    metric: (0, $lnhoM.ISSUE_KEY)
};
const $33e162af1cce479a$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $33e162af1cce479a$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $33e162af1cce479a$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $33e162af1cce479a$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $33e162af1cce479a$export$33989f74b6ba0674 = {
    metric: (0, $1VPxe.customFieldsConstants).key
};
const $33e162af1cce479a$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $33e162af1cce479a$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $33e162af1cce479a$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $33e162af1cce479a$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $33e162af1cce479a$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
const $33e162af1cce479a$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
const $33e162af1cce479a$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
const $33e162af1cce479a$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
const $33e162af1cce479a$export$3a7186fc63c9e188 = 'projectCleanUp';
const $33e162af1cce479a$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
const $33e162af1cce479a$export$342d8b9804e407c7 = 'TRASH';
const $33e162af1cce479a$export$b685f2109baf2b4f = 'ARCHIVE';
const $33e162af1cce479a$export$3ac60b381ed426ca = 'UNARCHIVE';
const $33e162af1cce479a$export$8ec3d08588d2eeda = 25;

});


parcelRegister("dGzlS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bde9993f72fbcea$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6bde9993f72fbcea$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    },
    dashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.dashboard",
        "defaultMessage": "Dashboard"
    }
});

});

parcelRegister("967Ue", function(module, exports) {
$parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", () => $504137348dac6364$export$4150c6a7c9be0102);
$parcel$export(module.exports, "ProjectCleanupSpotlight", () => $504137348dac6364$export$6dc8afd0c00f9525);

var $eJOHy = parcelRequire("eJOHy");

var $d2s5v = parcelRequire("d2s5v");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $drA6C = parcelRequire("drA6C");

var $5x1EH = parcelRequire("5x1EH");
const $504137348dac6364$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
const $504137348dac6364$export$6dc8afd0c00f9525 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $drA6C.useProjectCleanupSpotlight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isProjectCleanupSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                text: formatMessage((0, $5x1EH.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5x1EH.default).spotlightHeadingGalaxia : (0, $5x1EH.default).spotlightHeading),
        target: $504137348dac6364$export$4150c6a7c9be0102,
        key: $504137348dac6364$export$4150c6a7c9be0102,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $5x1EH.default).spotlightDescriptionGalaxia : (0, $5x1EH.default).spotlightDescription)));
});

});
parcelRegister("drA6C", function(module, exports) {
$parcel$export(module.exports, "useProjectCleanupSpotlight", () => $37bbb63fa043a950$export$780bcf6e3ebf2d12);

var $eJOHy = parcelRequire("eJOHy");

var $lu2We = parcelRequire("lu2We");

var $e6YEs = parcelRequire("e6YEs");
// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const $37bbb63fa043a950$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
const $37bbb63fa043a950$export$780bcf6e3ebf2d12 = ()=>{
    const accountId = (0, $e6YEs.useAccountId)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $eJOHy.useState)(false);
    const getHasSeenProjectCleanupSpotlight = async (id)=>{
        const response = await (0, $lu2We.getUserProperty)({
            accountId: id,
            propertyKey: $37bbb63fa043a950$var$PROPERTY_KEY,
            defaultValue: false
        });
        // If they have not seen the spotlight, return true and mark as shown
        if (!response.value) {
            await (0, $lu2We.setUserProperty)({
                accountId: id,
                propertyKey: $37bbb63fa043a950$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
    const fetchSpotlightState = (0, $eJOHy.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenProjectCleanupSpotlight(accountId);
            setIsProjectCleanupSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return [
        isProjectCleanupSpotlightActive,
        setIsProjectCleanupSpotlightActive
    ];
};

});

parcelRegister("5x1EH", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf24a9d402c283f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cf24a9d402c283f0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
        "defaultMessage": "Clean out unused projects"
    },
    spotlightDescription: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
        "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
        "defaultMessage": "Ok"
    },
    spotlightHeadingGalaxia: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading-galaxia",
        "defaultMessage": "Clean out unused spaces"
    },
    spotlightDescriptionGalaxia: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description-galaxia",
        "defaultMessage": "Quickly remove inactive or empty spaces to improve your site\u2019s performance."
    }
});

});



parcelRegister("3nYWL", function(module, exports) {
$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $90d873808e331528$export$3ed4e8541d8ba40);

var $lu2We = parcelRequire("lu2We");
const $90d873808e331528$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $90d873808e331528$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $lu2We.getUserProperty)({
        accountId: accountId,
        propertyKey: $90d873808e331528$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $lu2We.setUserProperty)({
            accountId: accountId,
            propertyKey: $90d873808e331528$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});


parcelRegister("4cBUk", function(module, exports) {
$parcel$export(module.exports, "isViewAuditingSelected", () => $0ec5eaa9039b7bc4$export$6da8ca04904513f9);

var $8xDPn = parcelRequire("8xDPn");
const $0ec5eaa9039b7bc4$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $0ec5eaa9039b7bc4$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $0ec5eaa9039b7bc4$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("e54td", function(module, exports) {
$parcel$export(module.exports, "UserInterfaceSection", () => $f1c13eb897db8fdd$export$c4128359313d3f58);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");

var $lRq8t = parcelRequire("lRq8t");

var $dysoB = parcelRequire("dysoB");

var $gp9Js = parcelRequire("gp9Js");

var $8xDPn = parcelRequire("8xDPn");

var $kAwwe = parcelRequire("kAwwe");

var $4nlI9 = parcelRequire("4nlI9");

var $bp1wP = parcelRequire("bp1wP");
const $f1c13eb897db8fdd$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $kAwwe.useIsAdmin)();
    const { data: features } = (0, $4nlI9.useFeatures)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const navigationPath = (0, $eJOHy.useMemo)(()=>(0, $gp9Js.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $bp1wP.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $8xDPn.matchUrlPathname)()
    }, formatMessage((0, $bp1wP.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            'global-settings-system-ui-announcement-banner'
        ]
    }, formatMessage((0, $bp1wP.default).announcementBanner)));
};

});
parcelRegister("bp1wP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a2698a46d5bfed1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4a2698a46d5bfed1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("1hRnr", function(module, exports) {
$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $3b9adf410e2cf34e$export$ba31cfa97c56eefd);

var $8xDPn = parcelRequire("8xDPn");
const $3b9adf410e2cf34e$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $3b9adf410e2cf34e$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $8xDPn.matchUrlExact)()(currentLocation, itemLocation) || $3b9adf410e2cf34e$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("9gC8Q", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", () => $35065d871a511d9b$export$2b269dcf51f5a4d3);
const $35065d871a511d9b$export$2b269dcf51f5a4d3 = {
    name: 'global-settings-system-bulk-mail',
    path: '/jira/settings/system/send-email'
};

});

parcelRegister("2lbA8", function(module, exports) {
$parcel$export(module.exports, "LazyBulkEmail", () => $0897ce069002a905$export$416f8039fbf50bea);
$parcel$export(module.exports, "default", () => $0897ce069002a905$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $0897ce069002a905$export$416f8039fbf50bea = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("l8YR3"))), {
    moduleId: "./src/packages/admin-pages/bulk-email-page/src/BulkEmailPage.tsx"
});
const $0897ce069002a905$var$AsyncBulkEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0897ce069002a905$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });
var $0897ce069002a905$export$2e2bcd8739ae039 = $0897ce069002a905$var$AsyncBulkEmail;

});
parcelRegister("l8YR3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cPA85").then(()=>parcelRequire('fguF3'));

});



parcelRegister("WOvcu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRouteEntry", () => $2e98342e95de1283$export$416d225883781012);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $7lDtC = parcelRequire("7lDtC");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $5fjzQ = parcelRequire("5fjzQ");

const $2e98342e95de1283$var$LazyAnnouncementBanner = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gOov3"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-announcement-banner/src/index.tsx"
});
const $2e98342e95de1283$var$AnnouncementBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2e98342e95de1283$var$LazyAnnouncementBanner,
        pageId: "admin-pages-system-announcement-banner",
        shouldShowSpinner: true
    });
const $2e98342e95de1283$export$416d225883781012 = (0, $6xToB.createEntry)((0, $7lDtC.globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $2e98342e95de1283$var$AnnouncementBanner,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $2e98342e95de1283$var$LazyAnnouncementBanner
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-system-entries/src/globalSettingsSystemUiAnnouncementBannerRouteEntry.tsx',
                whichExportToUse: 'globalSettingsSystemUiAnnouncementBannerRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7lDtC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", () => $b10d9c8d87ba9100$export$20631ff3b13dafc0);
const $b10d9c8d87ba9100$export$20631ff3b13dafc0 = {
    name: 'global-settings-system-ui-announcement-banner',
    path: '/jira/settings/system/ui/announcement-banner'
};

});

parcelRegister("gOov3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("k1mcH")
]).then(()=>parcelRequire('enqPa'));

});


parcelRegister("kTUT3", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAgentStudioRouteEntry", () => $d2c2d3de713052bf$export$5328c10e46075e4d);

var $kHlOR = parcelRequire("kHlOR");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $grWOk = parcelRequire("grWOk");

var $6xToB = parcelRequire("6xToB");

var $CsWXk = parcelRequire("CsWXk");

var $drLri = parcelRequire("drLri");

var $jmvbS = parcelRequire("jmvbS");

var $ioWDK = parcelRequire("ioWDK");
const $d2c2d3de713052bf$export$5328c10e46075e4d = (0, $6xToB.createEntry)((0, $CsWXk.helpCenterSettingsAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio',
        // For either return undefined scenario, it will fallback to the component config below
        entryPoint () {
            return 0, $jmvbS.csmAgentOverviewPageEntryPoint;
        },
        component: (0, $jmvbS.AgentStudioOverviewPage),
        skeleton: (0, $drLri.AgentOverviewPageSkeleton),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $ioWDK.agentStudioNavigation),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jmvbS.LazyAgentStudioOverviewPage)
        ],
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsAgentStudioRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsAgentStudioRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("CsWXk", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAgentStudioRoute", () => $5328927e5e2ee980$export$b8b0efb16984db50);
const $5328927e5e2ee980$export$b8b0efb16984db50 = {
    name: 'helpcenter-settings-agent-studio',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});

parcelRegister("drLri", function(module, exports) {
$parcel$export(module.exports, "AgentOverviewPageSkeleton", () => $88fa7fecc6e36fe0$export$afcefc88e1a5cac8);
/* AgentOverviewPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6umqd = parcelRequire("6umqd");

var $6qwKW = parcelRequire("6qwKW");
const $88fa7fecc6e36fe0$var$customCssStyles = null;
const $88fa7fecc6e36fe0$export$afcefc88e1a5cac8 = ()=>/*#__PURE__*/ $eJOHy.createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6qwKW))),
        className: (0, $hcewu.default)([
            "_2zz11tcg _slt81tcg"
        ])
    });

});
parcelRegister("6qwKW", function(module, exports) {
module.exports = new URL("agent-overview-page-skeleton.tpl.5523a7de.svg", import.meta.url).toString();

});


parcelRegister("jmvbS", function(module, exports) {
$parcel$export(module.exports, "LazyAgentStudioOverviewPage", () => $cd99f40b75230879$export$5fa375047554c75c);
$parcel$export(module.exports, "AgentStudioOverviewPage", () => $cd99f40b75230879$export$3c32337b9e9c89e5);
$parcel$export(module.exports, "csmAgentOverviewPageEntryPoint", () => $cd99f40b75230879$export$64672a53ea64d95b);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $f1kLD = parcelRequire("f1kLD");

const $cd99f40b75230879$export$5fa375047554c75c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3boQ8")).then((module)=>module.AgentOverview)), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/overview/AgentOverviewInternals.tsx"
});
const $cd99f40b75230879$export$3c32337b9e9c89e5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cd99f40b75230879$export$5fa375047554c75c,
        pageId: "help-center-settings-agent-studio-overview",
        shouldShowSpinner: true
    });
const $cd99f40b75230879$export$64672a53ea64d95b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $f1kLD.csmAgentOverviewEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("f1kLD", function(module, exports) {
$parcel$export(module.exports, "csmAgentOverviewEntryPoint", () => $58a98793ef05d0d8$export$50a5fd926c9d7bb4);

var $4cTDP = parcelRequire("4cTDP");

var $3C4yu = parcelRequire("3C4yu");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $58a98793ef05d0d8$export$50a5fd926c9d7bb4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3boQ8")).then((module)=>module.AgentOverview), {
        moduleId: "1870cd5f",
        moduleName: "AgentOverviewInternals",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $3C4yu.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`,
                        isVersioningEnabled: (0, $4cTDP.fg)('csm_ai_agent_versioning')
                    }
                }
            }
        })
});

});
parcelRegister("3C4yu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1029ada9f524798$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f918ddd4e76977f49be6dad13b59d09>>
 * @relayHash d3e613cd519244eff8a4a90302d91068
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8f8b7b407e2eea2b5d3ad37de8e3668ccf3ab2f9368581d1c0d4eff1685b179
const $c1029ada9f524798$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVersioningEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "versionType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentOverviewInternalsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "condition": "isVersioningEnabled",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "agentCard_AtlassianCsmAgentOverview"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isVersioningEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "agents",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v4 /*: any*/ ,
                                                            "concreteType": "CsmAiAgentVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "versions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CsmAiAgentVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v5 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "csmAi_getAiHubByHelpCenterAri.agents.versions.nodes"
                                                                }
                                                            ],
                                                            "storageKey": "versions(first:2)"
                                                        }
                                                    ],
                                                    "type": "CsmAiMultiVersionAgent"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentOverviewInternalsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "condition": "isVersioningEnabled",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "CsmAiAgent"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isVersioningEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "agents",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCsmAiMultiVersionAgentResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "agentId"
                                                        },
                                                        {
                                                            "args": v4 /*: any*/ ,
                                                            "concreteType": "CsmAiAgentVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "versions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CsmAiAgentVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "versionNumber"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "agentIdentityConfig",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        v3 /*: any*/ 
                                                                                    ],
                                                                                    "type": "CsmAiAgentIdentity"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "versions(first:2)"
                                                        }
                                                    ],
                                                    "type": "CsmAiMultiVersionAgent"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e8f8b7b407e2eea2b5d3ad37de8e3668ccf3ab2f9368581d1c0d4eff1685b179",
            "metadata": {},
            "name": "AgentOverviewInternalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c1029ada9f524798$var$node.hash = "2535d14a88dbf30c4d01d277dcd1497a";
var $c1029ada9f524798$export$2e2bcd8739ae039 = $c1029ada9f524798$var$node;

});

parcelRegister("3boQ8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("4u6EB")),
    $ewTvA("fliVL"),
    $ewTvA("1hHw9")
]).then(()=>parcelRequire('hhPU6'));

});



parcelRegister("ioWDK", function(module, exports) {
$parcel$export(module.exports, "navigation", () => $6332fb700a1a107a$export$428e7c787d57587d);
$parcel$export(module.exports, "agentStudioNavigation", () => $6332fb700a1a107a$export$c198b13d4a0b8cea);

var $5RW99 = parcelRequire("5RW99");

var $dUMft = parcelRequire("dUMft");
const $6332fb700a1a107a$export$428e7c787d57587d = {
    sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $dUMft.default)
};
const $6332fb700a1a107a$export$c198b13d4a0b8cea = {
    sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $dUMft.default)
};

});
parcelRegister("dUMft", function(module, exports) {
$parcel$export(module.exports, "default", () => $56210a9ed64c7b2d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $56210a9ed64c7b2d$export$ea77f88c1b841127 = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("p0AJG")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
});
const $56210a9ed64c7b2d$var$HelpCenterSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56210a9ed64c7b2d$export$ea77f88c1b841127, null)));
$56210a9ed64c7b2d$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
var $56210a9ed64c7b2d$export$2e2bcd8739ae039 = $56210a9ed64c7b2d$var$HelpCenterSettingsSidebar;

});
parcelRegister("p0AJG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9k4Cl").then(()=>parcelRequire('kNZGg'));

});




parcelRegister("cHL3P", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsRouteEntry", () => $6c409a0ed730b565$export$13d5cfdc3231d970);

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $9WgdA = parcelRequire("9WgdA");

var $7tVpB = parcelRequire("7tVpB");
const $6c409a0ed730b565$export$13d5cfdc3231d970 = (0, $6xToB.createEntry)((0, $9WgdA.helpCenterSettingsAnalyticsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.analytics',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return 0, $7tVpB.helpCenterSettingsAnalyticsRoutePageEntryPoint;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsAnalyticsRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsAnalyticsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9WgdA", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoute", () => $8a2496471cbe6288$export$1487d4661960397f);
const $8a2496471cbe6288$export$1487d4661960397f = {
    exact: true,
    name: 'customer-service-helpcenter-analytics',
    path: '/jira/helpcenter/analytics'
};

});

parcelRegister("7tVpB", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoutePageEntryPoint", () => $0282c14db2b50045$export$cb0b3a882806ef6e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $176gs = parcelRequire("176gs");
const $0282c14db2b50045$export$cb0b3a882806ef6e = (0, $g8uYY.createPageEntryPoint)({
    main: $176gs.helpCenterSettingsAnalyticsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("176gs", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsAnalyticsAppEntryPoint", () => $a93f80fd61957fa1$export$fa405dadb950b4a6);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a93f80fd61957fa1$export$fa405dadb950b4a6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("aibKy")), {
        moduleId: "19032ae8",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("aibKy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("c3ugT")),
    $ewTvA("fliVL"),
    $ewTvA("igBk9")
]).then(()=>parcelRequire('f4Ym1'));

});




parcelRegister("fSwF2", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesRouteEntry", () => $557a37e34b1dceed$export$dcf98310ab461eb0);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $5df3d = parcelRequire("5df3d");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $jbd9a = parcelRequire("jbd9a");
const $557a37e34b1dceed$export$dcf98310ab461eb0 = (0, $6xToB.createEntry)((0, $5df3d.helpCenterSettingsArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $jbd9a.helpCenterSettingArticlesAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsArticlesRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsArticlesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5df3d", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesRoute", () => $b6c69d3e551bf1b0$export$6445613754b0db30);
const $b6c69d3e551bf1b0$export$6445613754b0db30 = {
    name: 'helpcenter-settings-articles',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});

parcelRegister("jbd9a", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingArticlesAppPageEntryPoint", () => $859703d541edd309$export$5f683051fd990adb);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5Tx3j = parcelRequire("5Tx3j");
const $859703d541edd309$export$5f683051fd990adb = (0, $g8uYY.createPageEntryPoint)({
    main: $5Tx3j.HelpCenterSettingsArticlesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("5Tx3j", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsArticlesAppEntryPoint", () => $ab13940cb2c3ceca$export$ba888b162abf6368);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $ab13940cb2c3ceca$export$ba888b162abf6368 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("liLbL")), {
        moduleId: "8c0e0839",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("liLbL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lIgXL").then(()=>parcelRequire('aOmEt'));

});




parcelRegister("4VbNK", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRouteEntry", () => $50eb33ded365fa9b$export$d14f4c2b666bbb54);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $4oz3c = parcelRequire("4oz3c");

var $aQoXd = parcelRequire("aQoXd");

var $gB1vz = parcelRequire("gB1vz");

var $ioWDK = parcelRequire("ioWDK");

var $3Npex = parcelRequire("3Npex");
const $50eb33ded365fa9b$export$d14f4c2b666bbb54 = (0, $6xToB.createEntry)((0, $4oz3c.helpCenterSettingsArticlesViewArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles-view-article',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $3Npex.helpCenterSettingViewArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $gB1vz.csmBaseUrlResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsArticlesViewArticleRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsArticlesViewArticleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4oz3c", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRoute", () => $57f64524b25ffba6$export$c5c6fbcb1f26b87b);
const $57f64524b25ffba6$export$c5c6fbcb1f26b87b = {
    name: 'helpcenter-settings-articles-view-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
    exact: true
};

});

parcelRegister("gB1vz", function(module, exports) {
$parcel$export(module.exports, "csmBaseUrlResource", () => $cb524b1574df2a64$export$9c5392bbc049a926);

var $l1VxS = parcelRequire("l1VxS");

var $j3nNi = parcelRequire("j3nNi");
const $cb524b1574df2a64$var$RESOURCE_TYPE_CSM_BASE_URL = 'CSM_SUPPORT_SITE_BASE_URL';
const $cb524b1574df2a64$export$9c5392bbc049a926 = (0, $l1VxS.createResource)({
    type: $cb524b1574df2a64$var$RESOURCE_TYPE_CSM_BASE_URL,
    getKey: ()=>'csm-support-site-base-url',
    getData: async ()=>(0, $j3nNi.default)(),
    maxAge: 0
});

});
parcelRegister("j3nNi", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d8b05153c9fcdfb$export$2e2bcd8739ae039);

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");
const $1d8b05153c9fcdfb$var$getData = async ()=>{
    try {
        const data = await (0, $hgi0g.default)('/rest/api/latest/serverInfo');
        return data.displayUrlCSMHelpSeeker?.replace(/^https?:\/\//, '');
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'csmBaseUrlResource',
                packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmBaseUrl',
                teamName: 'boysenberry'
            },
            error: error instanceof Error ? error : undefined
        });
        throw error;
    }
};
var $1d8b05153c9fcdfb$export$2e2bcd8739ae039 = $1d8b05153c9fcdfb$var$getData;

});


parcelRegister("3Npex", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingViewArticleAppPageEntryPoint", () => $94dcbb3f1f3e9d5d$export$7f08ea9d5c2912ad);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bIezk = parcelRequire("bIezk");
const $94dcbb3f1f3e9d5d$export$7f08ea9d5c2912ad = (0, $g8uYY.createPageEntryPoint)({
    main: $bIezk.HelpCenterSettingsArticlesViewArticleAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("bIezk", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsArticlesViewArticleAppEntryPoint", () => $02c8add95f28b39d$export$31df33b35c5b2ee);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $02c8add95f28b39d$export$31df33b35c5b2ee = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("aRXLf")), {
        moduleId: "6cb514e3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("aRXLf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3nfxN").then(()=>parcelRequire('840FM'));

});




parcelRegister("25Xvp", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsBrandingRouteEntry", () => $cc12446ed59acf26$export$5ee7fbd23c469c7);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $hk17k = parcelRequire("hk17k");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $gwjJa = parcelRequire("gwjJa");
const $cc12446ed59acf26$export$5ee7fbd23c469c7 = (0, $6xToB.createEntry)((0, $hk17k.helpCenterSettingsBrandingRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.branding',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            if ((0, $4cTDP.fg)('jcs-global-branding')) return 0, $gwjJa.helpCenterSettingBrandingAppPageEntryPoint;
            return undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsBrandingRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsBrandingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hk17k", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsBrandingRoute", () => $e97eefade00572d4$export$f70734f5d2d3d52b);
const $e97eefade00572d4$export$f70734f5d2d3d52b = {
    exact: true,
    name: 'helpcenter-settings-branding',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/branding'
};

});

parcelRegister("gwjJa", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingBrandingAppPageEntryPoint", () => $114b94b4bc86d507$export$bb128cb1d0aaba4d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3OGRB = parcelRequire("3OGRB");
const $114b94b4bc86d507$export$bb128cb1d0aaba4d = (0, $g8uYY.createPageEntryPoint)({
    main: $3OGRB.helpCenterSettingBrandingAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("3OGRB", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingBrandingAppEntryPoint", () => $44063b95641e944b$export$f1525531cb4c9a9c);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $9j9Vs = parcelRequire("9j9Vs");

const $44063b95641e944b$export$f1525531cb4c9a9c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cZM76")), {
        moduleId: "b3034233",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                GlobalBrandingQuery: {
                    parameters: $9j9Vs.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("9j9Vs", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a1e96dc8eed886c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5d1537f4a6ae328bb5b882fbaa6147ae>>
 * @relayHash 0c12372d999250c67d6beec02276832c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b171b801c0aa34ef9d708065ce3aad67c1a07cbc0a224a9b9e860aa8f8f8779
const $9a1e96dc8eed886c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5b171b801c0aa34ef9d708065ce3aad67c1a07cbc0a224a9b9e860aa8f8f8779",
        "metadata": {},
        "name": "GlobalBrandingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9a1e96dc8eed886c$export$2e2bcd8739ae039 = $9a1e96dc8eed886c$var$node;

});

parcelRegister("cZM76", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cJJJA").then(()=>parcelRequire('dILzZ'));

});




parcelRegister("5uVut", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCreateArticleRouteEntry", () => $9e10006556bee2fa$export$882f07b6a7d364c7);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $gJf7C = parcelRequire("gJf7C");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $cbGjT = parcelRequire("cbGjT");
const $9e10006556bee2fa$export$882f07b6a7d364c7 = (0, $6xToB.createEntry)((0, $gJf7C.helpCenterSettingsCreateArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.create-article',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $cbGjT.helpCenterSettingCreateArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsCreateArticleRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsCreateArticleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gJf7C", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCreateArticleRoute", () => $4f742c01382a8940$export$6f4350070b3391d2);
const $4f742c01382a8940$export$6f4350070b3391d2 = {
    name: 'helpcenter-settings-create-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("cbGjT", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingCreateArticleAppPageEntryPoint", () => $a09176e2db3393ef$export$2dedebb94d500afa);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jgINI = parcelRequire("jgINI");
const $a09176e2db3393ef$export$2dedebb94d500afa = (0, $g8uYY.createPageEntryPoint)({
    main: $jgINI.HelpCenterSettingsCreateArticleAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("jgINI", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsCreateArticleAppEntryPoint", () => $eaa75240b4e3aff6$export$dd82613d258b9120);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $eaa75240b4e3aff6$export$dd82613d258b9120 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2u6Sp")), {
        moduleId: "d6a89104",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("2u6Sp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gpbn0").then(()=>parcelRequire('kXVNP'));

});




parcelRegister("qU7hK", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRouteEntry", () => $9a54a2dc61f74cd4$export$5cfeb28cf3c43d24);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $28JNJ = parcelRequire("28JNJ");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $74TzF = parcelRequire("74TzF");
const $9a54a2dc61f74cd4$export$5cfeb28cf3c43d24 = (0, $6xToB.createEntry)((0, $28JNJ.helpCenterSettingsCustomerAccessRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $74TzF.HelpCenterSettingsCustomerAccess), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $74TzF.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsCustomerAccessRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsCustomerAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("28JNJ", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRoute", () => $242a38aec89abe47$export$5adf9b8f07e4dd7b);
const $242a38aec89abe47$export$5adf9b8f07e4dd7b = {
    name: 'helpcenter-settings-customer-access',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access'
};

});

parcelRegister("74TzF", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerAccess", () => $d81328931cc8aa2e$export$2c331ddbdb6fb4ef);
$parcel$export(module.exports, "HelpCenterSettingsCustomerAccess", () => $d81328931cc8aa2e$export$ab643bb246877df);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d81328931cc8aa2e$export$2c331ddbdb6fb4ef = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fdGJY"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-access/src/index.tsx"
});
const $d81328931cc8aa2e$export$ab643bb246877df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d81328931cc8aa2e$export$2c331ddbdb6fb4ef,
        pageId: "help-center-settings-customer-access",
        shouldShowSpinner: true
    });

});
parcelRegister("fdGJY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c2yoy").then(()=>parcelRequire('dSNBY'));

});



parcelRegister("9cLPB", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", () => $897f6369f1c33670$export$4e4f38417d267cf6);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $gqslx = parcelRequire("gqslx");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $4V1Wf = parcelRequire("4V1Wf");
const $897f6369f1c33670$export$4e4f38417d267cf6 = (0, $6xToB.createEntry)((0, $gqslx.helpCenterSettingsCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $4V1Wf.HelpCenterSettingsCustomerNotifications), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4V1Wf.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsCustomerNotificationsRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsCustomerNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gqslx", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", () => $019b89d0278cff0b$export$88fcb9acf40a0827);
const $019b89d0278cff0b$export$88fcb9acf40a0827 = {
    name: 'helpcenter-settings-customer-notifications',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications'
};

});

parcelRegister("4V1Wf", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", () => $8f1848ef04965ad8$export$b2b6550dec008a98);
$parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", () => $8f1848ef04965ad8$export$2f2f18f57014444a);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8f1848ef04965ad8$export$b2b6550dec008a98 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("iZR2s"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
});
const $8f1848ef04965ad8$export$2f2f18f57014444a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8f1848ef04965ad8$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("iZR2s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lASPk").then(()=>parcelRequire('cYXPO'));

});



parcelRegister("cVu4s", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsDetailsRouteEntry", () => $8c22f9998b0d4d13$export$a9c03c3c37251dd3);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $5oeMa = parcelRequire("5oeMa");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $dCgv3 = parcelRequire("dCgv3");
const $8c22f9998b0d4d13$export$a9c03c3c37251dd3 = (0, $6xToB.createEntry)((0, $5oeMa.helpCenterSettingsDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.details',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $dCgv3.helpCenterSettingDetailsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsDetailsRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5oeMa", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $9a5a76848176565b$export$f54c1546ddea019b);
const $9a5a76848176565b$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("dCgv3", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingDetailsAppPageEntryPoint", () => $0acfa6394b0a8124$export$c52cb026d0dc8ed7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jsgdZ = parcelRequire("jsgdZ");
const $0acfa6394b0a8124$export$c52cb026d0dc8ed7 = (0, $g8uYY.createPageEntryPoint)({
    main: $jsgdZ.helpCenterSettingDetailsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("jsgdZ", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingDetailsAppEntryPoint", () => $f9ee001ee56e248f$export$519ec4ef3722cb47);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $bnjmB = parcelRequire("bnjmB");

const $f9ee001ee56e248f$export$519ec4ef3722cb47 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4Yt0a")), {
        moduleId: "e9a696a2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $bnjmB.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("bnjmB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2349b495c6e906c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9102907891884f4cf549e6386bc2cd0a>>
 * @relayHash 00440bbe51c0e32bdc5d206bddc550e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9be00f2b4dd73c26321f514b801a60fb1db78572af8b4419e03240610932204
const $2349b495c6e906c0$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e9be00f2b4dd73c26321f514b801a60fb1db78572af8b4419e03240610932204",
        "metadata": {},
        "name": "ServiceHubDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2349b495c6e906c0$export$2e2bcd8739ae039 = $2349b495c6e906c0$var$node;

});

parcelRegister("4Yt0a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("clL3C").then(()=>parcelRequire('1QTjA'));

});




parcelRegister("dceq5", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", () => $affc413bf6d59e8f$export$f95717dac47e4db3);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $dN1NV = parcelRequire("dN1NV");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $4R3qR = parcelRequire("4R3qR");
const $affc413bf6d59e8f$export$f95717dac47e4db3 = (0, $6xToB.createEntry)((0, $dN1NV.helpCenterSettingsEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $4R3qR.HelpCenterSettingsEmail), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4R3qR.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsEmailRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsEmailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dN1NV", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsEmailRoute", () => $3389fac66e445ee2$export$4515288a48c62087);
const $3389fac66e445ee2$export$4515288a48c62087 = {
    name: 'helpcenter-settings-email',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("4R3qR", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterSettingsEmail", () => $766a31f54d9e1d55$export$e090cd3a62343249);
$parcel$export(module.exports, "HelpCenterSettingsEmail", () => $766a31f54d9e1d55$export$962f20e752738967);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $766a31f54d9e1d55$export$e090cd3a62343249 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eAk3z")), {
    moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
});
const $766a31f54d9e1d55$export$962f20e752738967 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $766a31f54d9e1d55$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });

});
parcelRegister("eAk3z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5qqwM").then(()=>parcelRequire('dBf4A'));

});



parcelRegister("i1SxF", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", () => $05db6725367511ce$export$1750cfcab794a07d);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $7c7ou = parcelRequire("7c7ou");

var $9BJU1 = parcelRequire("9BJU1");

var $iQx3C = parcelRequire("iQx3C");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $4XDZT = parcelRequire("4XDZT");
const $05db6725367511ce$export$1750cfcab794a07d = (0, $6xToB.createEntry)((0, $iQx3C.helpCenterSettingsFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.form-edit',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $4XDZT.helpCenterSettingFormEditAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $7c7ou.formEditJirafieldsResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsFormEditRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsFormEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7c7ou", function(module, exports) {
$parcel$export(module.exports, "formEditJirafieldsResource", () => $eba93f6a60ca6f09$export$ca58e1498fd1ff3e);
$parcel$export(module.exports, "useFormEditJirafields", () => $eba93f6a60ca6f09$export$8a76fadb956ce203);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $eba93f6a60ca6f09$var$getDataLoader = ()=>(parcelRequire("4yjSZ"));
const $eba93f6a60ca6f09$export$ca58e1498fd1ff3e = (0, $l1VxS.createResource)({
    type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $eba93f6a60ca6f09$var$getDataLoader,
    isBrowserOnly: true
});
const $eba93f6a60ca6f09$export$8a76fadb956ce203 = ()=>(0, $eJrcF.useResource)($eba93f6a60ca6f09$export$ca58e1498fd1ff3e);

});
parcelRegister("4yjSZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("DSq8B").then(()=>parcelRequire('lCM2t'));

});


parcelRegister("iQx3C", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormEditRoute", () => $a9812b10d82d7ebc$export$31bd3e10c42460dc);
const $a9812b10d82d7ebc$export$31bd3e10c42460dc = {
    exact: true,
    name: 'helpcenter-settings-form-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId'
};

});

parcelRegister("4XDZT", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", () => $8b232d5f3c0f4591$export$2792cba2387cbc5c);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cDcwY = parcelRequire("cDcwY");
const $8b232d5f3c0f4591$export$2792cba2387cbc5c = (0, $g8uYY.createPageEntryPoint)({
    main: $cDcwY.helpCenterSettingFormEditAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("cDcwY", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", () => $c91eceae72db5a99$export$262512d610e494f8);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $eIhgJ = parcelRequire("eIhgJ");

const $c91eceae72db5a99$export$262512d610e494f8 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jpqpc")), {
        moduleId: "d82eb4d8",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, formId: formId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                FormEditQuery: {
                    parameters: $eIhgJ.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("eIhgJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $aff49fd7f08133d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ecc5d7624a9455c6f99b32a9dd3c5387>>
 * @relayHash 2160bae9d990bef0424cf6790fd9bb6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea5c5b7e6b6b1e0cd31820216482408491694394fecec525769b007f9686cd0a
const $aff49fd7f08133d3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ea5c5b7e6b6b1e0cd31820216482408491694394fecec525769b007f9686cd0a",
        "metadata": {},
        "name": "FormEditQuery",
        "operationKind": "query",
        "text": null
    }
};
var $aff49fd7f08133d3$export$2e2bcd8739ae039 = $aff49fd7f08133d3$var$node;

});

parcelRegister("jpqpc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jyfmA").then(()=>parcelRequire('dZrxI'));

});




parcelRegister("64vgo", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", () => $ed2e4fada4dfb854$export$9a67aaae787c9f40);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $fDEjZ = parcelRequire("fDEjZ");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $3wgAy = parcelRequire("3wgAy");
const $ed2e4fada4dfb854$export$9a67aaae787c9f40 = (0, $6xToB.createEntry)((0, $fDEjZ.helpCenterSettingsFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.forms',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $3wgAy.helpCenterSettingFormsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsFormsRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsFormsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fDEjZ", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsFormsRoute", () => $283bcbedda55f023$export$45b14c3ed47b2b3a);
const $283bcbedda55f023$export$45b14c3ed47b2b3a = {
    exact: true,
    name: 'helpcenter-settings-forms',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms'
};

});

parcelRegister("3wgAy", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", () => $91ee78b052c924d7$export$b50d944f3be2457f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $bBJjz = parcelRequire("bBJjz");
const $91ee78b052c924d7$export$b50d944f3be2457f = (0, $g8uYY.createPageEntryPoint)({
    main: $bBJjz.helpCenterSettingFormsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("bBJjz", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", () => $492dafc7f32d9aee$export$ce8253ab16579f12);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $dFAaH = parcelRequire("dFAaH");

const $492dafc7f32d9aee$export$ce8253ab16579f12 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("flaFT")), {
        moduleId: "c7a4dbb9",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                FormsQuery: {
                    parameters: $dFAaH.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("dFAaH", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd742fbc205fd66c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6df0628f36cb4b1f256847a152bb891>>
 * @relayHash 891edaf6e87e299a147c6e9c32e3d7ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf33084190f671d57d5417699ce10b46fdcb269408000caf2a15c2f7353fc69a
const $dd742fbc205fd66c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bf33084190f671d57d5417699ce10b46fdcb269408000caf2a15c2f7353fc69a",
        "metadata": {},
        "name": "FormsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $dd742fbc205fd66c$export$2e2bcd8739ae039 = $dd742fbc205fd66c$var$node;

});

parcelRegister("flaFT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("isXId").then(()=>parcelRequire('29qD5'));

});




parcelRegister("9hXyI", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsKbRouteEntry", () => $7dcf48ed5e4a68ed$export$caf568619a621961);

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $by3fT = parcelRequire("by3fT");

var $aQoXd = parcelRequire("aQoXd");

var $ioWDK = parcelRequire("ioWDK");

var $3JHTH = parcelRequire("3JHTH");
const $7dcf48ed5e4a68ed$export$caf568619a621961 = (0, $6xToB.createEntry)((0, $by3fT.helpCenterSettingsKbRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.kb',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $bJscI.componentWithFG)('jcs_master_flag', (0, $3JHTH.HelpCenterSettingsKnowledgeBase), (0, $9BJU1.default)),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3JHTH.LazyHelpCenterSettingsKnowledgeBase)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsKbRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsKbRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("by3fT", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsKbRoute", () => $e03ffc91b212b4d9$export$8a784299dc7faaff);
const $e03ffc91b212b4d9$export$8a784299dc7faaff = {
    name: 'helpcenter-settings-kb',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/kb',
    exact: true
};

});

parcelRegister("3JHTH", function(module, exports) {
$parcel$export(module.exports, "LazyHelpCenterSettingsKnowledgeBase", () => $e9cce4da843200c7$export$92983043c677b1b1);
$parcel$export(module.exports, "HelpCenterSettingsKnowledgeBase", () => $e9cce4da843200c7$export$c1d58cf9dc0a2ed3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e9cce4da843200c7$export$92983043c677b1b1 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7pCDn"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
});
const $e9cce4da843200c7$export$c1d58cf9dc0a2ed3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e9cce4da843200c7$export$92983043c677b1b1,
        pageId: "help-center-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("7pCDn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("IZf4J").then(()=>parcelRequire('kQUup'));

});



parcelRegister("1PXic", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsNotFoundRouteEntry", () => $a753187a83d5ad3a$export$2dced3f6d0a4894);

var $6xToB = parcelRequire("6xToB");

var $l0KDT = parcelRequire("l0KDT");

var $jJNU7 = parcelRequire("jJNU7");
const $a753187a83d5ad3a$export$2dced3f6d0a4894 = (0, $6xToB.createEntry)((0, $l0KDT.helpCenterSettingsNotFoundRoute), ()=>({
        group: 'customer-service',
        component: (0, $jJNU7.NotFound),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsNotFoundRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("l0KDT", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsNotFoundRoute", () => $23763a2d6fc2020c$export$b6bc9dd96e9608e7);
const $23763a2d6fc2020c$export$b6bc9dd96e9608e7 = {
    exact: false,
    name: 'customer-service-not-found',
    path: '/jira/helpcenter/:any'
};

});

parcelRegister("jJNU7", function(module, exports) {
$parcel$export(module.exports, "NotFound", () => $a847820c6bf7f1cc$export$271f9f08425019c7);

var $eJOHy = parcelRequire("eJOHy");

var $dMpy6 = parcelRequire("dMpy6");

var $kfvK2 = parcelRequire("kfvK2");

var $9pTd3 = parcelRequire("9pTd3");
const $a847820c6bf7f1cc$var$useLocation = (0, $kfvK2.createRouterSelector)(({ location: location })=>location.pathname);
const $a847820c6bf7f1cc$export$271f9f08425019c7 = ()=>{
    const pathname = $a847820c6bf7f1cc$var$useLocation();
    (0, $eJOHy.useEffect)(()=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'serviceHubPageNotFound',
                packageName: 'jiraServicedeskCustomerServiceServiceHubs',
                teamName: 'boysenberry'
            },
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                pathname: pathname
            }
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null);
};

});


parcelRegister("pX4Kl", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsRouteEntry", () => $9d65972d70e54b01$export$4afd756ea4d2cf7e);

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $gB1vz = parcelRequire("gB1vz");

var $9BJU1 = parcelRequire("9BJU1");

var $7SF7y = parcelRequire("7SF7y");

var $gPOXv = parcelRequire("gPOXv");
const $9d65972d70e54b01$export$4afd756ea4d2cf7e = (0, $6xToB.createEntry)((0, $7SF7y.helpCenterSettingsServiceHubsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.service-hubs',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? (0, $gPOXv.helpCenterSettingsServiceHubsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $gB1vz.csmBaseUrlResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsServiceHubsRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsServiceHubsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7SF7y", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoute", () => $5b040b4d0e410c37$export$16970f28ba5bfb66);
const $5b040b4d0e410c37$export$16970f28ba5bfb66 = {
    exact: true,
    name: 'customer-service-helpcenter',
    path: '/jira/helpcenter'
};

});

parcelRegister("gPOXv", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoutePageEntryPoint", () => $1e4457e3235fe1d5$export$3c1cef4845013f95);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fUQgH = parcelRequire("fUQgH");
const $1e4457e3235fe1d5$export$3c1cef4845013f95 = (0, $g8uYY.createPageEntryPoint)({
    main: $fUQgH.helpCenterSettingsServiceHubsAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("fUQgH", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsServiceHubsAppEntryPoint", () => $4245f6963e24ff54$export$68ab0caf884fe346);

var $dXCV2 = parcelRequire("dXCV2");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $4245f6963e24ff54$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const $4245f6963e24ff54$var$SORT_ORDER = 'CREATED_DATE_DESCENDING';

const $4245f6963e24ff54$export$68ab0caf884fe346 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jcJrX")).then((module)=>module.HelpCenterSettingServiceHubsAppWithJCSLicenseCheck), {
        moduleId: "c447b568",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                serviceHubsQuery: {
                    parameters: $dXCV2.default,
                    variables: {
                        cloudId: cloudId,
                        workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
                        SORT_ORDER: $4245f6963e24ff54$var$SORT_ORDER,
                        NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $4245f6963e24ff54$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("dXCV2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f9fe01898b82b11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<484fa77f161b641690181de080f853af>>
 * @relayHash 1ce8acea6682da39223e50d1097bbd01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5bbf63e1af0eaf86bd47dbfb9b0f08cfb653355c87498b03039cbc350713b1ed
const $7f9fe01898b82b11$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5bbf63e1af0eaf86bd47dbfb9b0f08cfb653355c87498b03039cbc350713b1ed",
        "metadata": {},
        "name": "ServiceHubsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7f9fe01898b82b11$export$2e2bcd8739ae039 = $7f9fe01898b82b11$var$node;

});

parcelRegister("jcJrX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7fBe0").then(()=>parcelRequire('bgS4M'));

});




parcelRegister("7lW5H", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRouteEntry", () => $669a0e265b7bff0e$export$eb728930eecb0b42);

var $4cTDP = parcelRequire("4cTDP");

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $kgDPH = parcelRequire("kgDPH");

var $cu1g7 = parcelRequire("cu1g7");

var $be9GB = parcelRequire("be9GB");

var $dUMft = parcelRequire("dUMft");

var $5RW99 = parcelRequire("5RW99");

var $b9dJE = parcelRequire("b9dJE");

var $gB1vz = parcelRequire("gB1vz");

var $a8qDQ = parcelRequire("a8qDQ");
const $669a0e265b7bff0e$export$eb728930eecb0b42 = (0, $6xToB.createEntry)((0, $be9GB.helpCenterSettingsSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.overview',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $dUMft.default),
            horizontal: (0, $4cTDP.fg)('csm_contact_us_rte') ? undefined : (0, $b9dJE.AsyncSupportWebsiteNav)
        },
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('jcs_master_flag')) return undefined;
            return (0, $4cTDP.fg)('csm_contact_us_rte') ? (0, $a8qDQ.HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation) : (0, $a8qDQ.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint);
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            (0, $kgDPH.serviceDeskContextResource),
            (0, $cu1g7.serviceDeskAnalyticsContextResource),
            (0, $gB1vz.csmBaseUrlResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsSupportWebsiteOverviewRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsSupportWebsiteOverviewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("be9GB", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRoute", () => $6103956352967918$export$64e95782b19caeac);
const $6103956352967918$export$64e95782b19caeac = {
    name: 'helpcenter-settings-support-website-details-overview',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});

parcelRegister("b9dJE", function(module, exports) {
$parcel$export(module.exports, "AsyncSupportWebsiteNav", () => $ee27107460aa32df$export$8887f9c4b5829b78);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $ee27107460aa32df$var$LazySupportWebsiteNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("h11nQ")).then(({ SupportWebsiteNavOld: SupportWebsiteNavOld })=>SupportWebsiteNavOld), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-csm/support-website/src/ui/index.tsx"
});
const $ee27107460aa32df$export$8887f9c4b5829b78 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-csm-support-site-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ee27107460aa32df$var$LazySupportWebsiteNav, null));

});
parcelRegister("h11nQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cgQIg").then(()=>parcelRequire('7Hi0z'));

});


parcelRegister("a8qDQ", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $b1808f85d92b32ca$export$780fd78388c1f1d1);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation", () => $b1808f85d92b32ca$export$23f7867fc61415d6);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $lXSXs = parcelRequire("lXSXs");

var $469qC = parcelRequire("469qC");
const $b1808f85d92b32ca$export$780fd78388c1f1d1 = (0, $g8uYY.createPageEntryPoint)({
    main: $lXSXs.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $b1808f85d92b32ca$export$23f7867fc61415d6 = (0, $g8uYY.createPageEntryPoint)({
    main: $lXSXs.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $469qC.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("lXSXs", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $d9ead258d20a7a85$export$780fd78388c1f1d1);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $c2Puf = parcelRequire("c2Puf");

const $d9ead258d20a7a85$export$780fd78388c1f1d1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("fKWLB")), {
        moduleId: "d27a8c99",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $c2Puf.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("c2Puf", function(module, exports) {
$parcel$export(module.exports, "default", () => $96e22ddd80d7b6d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<303c78ea65766e95fe6e49ee8299a1d5>>
 * @relayHash 3915650f8eb2fa0cca35772da0cd370c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92859d529606502deea4be34ba0966f6b4fc84c5666c803fd73b800c66b33c06
const $96e22ddd80d7b6d9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "92859d529606502deea4be34ba0966f6b4fc84c5666c803fd73b800c66b33c06",
        "metadata": {},
        "name": "SupportWebsiteOverviewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $96e22ddd80d7b6d9$export$2e2bcd8739ae039 = $96e22ddd80d7b6d9$var$node;

});

parcelRegister("fKWLB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aoPmK").then(()=>parcelRequire('7XuGk'));

});


parcelRegister("469qC", function(module, exports) {
$parcel$export(module.exports, "horizontalNavigationCsmSupportWebsiteEntryPoint", () => $6d564a6bea220942$export$2ba426f18e0d22f5);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $dk48T = parcelRequire("dk48T");

const $6d564a6bea220942$export$2ba426f18e0d22f5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("gHX32")), {
        moduleId: "843b3f72",
        moduleName: "SupportWebsiteNavEntryPoint",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                SupportWebsiteNavEntryPointQuery: {
                    parameters: $dk48T.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("dk48T", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ed6febfa1357542$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c964fdc4db048aa27656ed4d3cedc32>>
 * @relayHash c7d5e8e948efa0a5f4521d77275a114a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID df21ac0704295fb549bc8443e0370ead496e2d268178d86e9d1a286329b37b9d
const $0ed6febfa1357542$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "df21ac0704295fb549bc8443e0370ead496e2d268178d86e9d1a286329b37b9d",
        "metadata": {},
        "name": "SupportWebsiteNavEntryPointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0ed6febfa1357542$export$2e2bcd8739ae039 = $0ed6febfa1357542$var$node;

});

parcelRegister("gHX32", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kB72I").then(()=>parcelRequire('iSxaX'));

});




parcelRegister("7RzXN", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRouteEntry", () => $15b18cf58fe79f1d$export$5077ff1d96b93d83);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $fhK2S = parcelRequire("fhK2S");

var $dUMft = parcelRequire("dUMft");

var $5RW99 = parcelRequire("5RW99");

var $b9dJE = parcelRequire("b9dJE");

var $4cTDP = parcelRequire("4cTDP");

var $4uXiB = parcelRequire("4uXiB");
const $15b18cf58fe79f1d$export$5077ff1d96b93d83 = (0, $6xToB.createEntry)((0, $fhK2S.helpCenterSettingsSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.pages',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $dUMft.default),
            horizontal: (0, $4cTDP.fg)('csm_contact_us_rte') ? undefined : (0, $b9dJE.AsyncSupportWebsiteNav)
        },
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('jcs_master_flag')) return undefined;
            return (0, $4cTDP.fg)('csm_contact_us_rte') ? (0, $4uXiB.HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation) : (0, $4uXiB.HelpCenterSettingsSupportWebsitePagesAppEntryPoint);
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsSupportWebsitePagesRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsSupportWebsitePagesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fhK2S", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRoute", () => $cf061a366125027d$export$a6eefe359f3d3ade);
const $cf061a366125027d$export$a6eefe359f3d3ade = {
    name: 'helpcenter-settings-support-website-details-pages',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});

parcelRegister("4uXiB", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $df1b05e0083ad85c$export$7d51b2b14ae8000f);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation", () => $df1b05e0083ad85c$export$e27663b14f44038e);

var $g8uYY = parcelRequire("g8uYY");

var $469qC = parcelRequire("469qC");

var $5RW99 = parcelRequire("5RW99");

var $ISPIA = parcelRequire("ISPIA");
const $df1b05e0083ad85c$export$7d51b2b14ae8000f = (0, $g8uYY.createPageEntryPoint)({
    main: $ISPIA.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $df1b05e0083ad85c$export$e27663b14f44038e = (0, $g8uYY.createPageEntryPoint)({
    main: $ISPIA.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $469qC.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("ISPIA", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $a4abb3745ae9a7f4$export$7d51b2b14ae8000f);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $1aN31 = parcelRequire("1aN31");

const $a4abb3745ae9a7f4$export$7d51b2b14ae8000f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("9TqXQ")), {
        moduleId: "c9581695",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                customPagesQuery: {
                    parameters: $1aN31.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        NUMBER_OF_PAGES_INITIAL_FETCH: 300
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("1aN31", function(module, exports) {
$parcel$export(module.exports, "default", () => $29c8f3d4b808c9e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e4008cf1a810da5a69af68580d2d27c>>
 * @relayHash f13961bf02127962900ef43b1b0957b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0381d6bd7bbe5617a5660feab9ea1ef587bd4c9822f831ab5b078936b0bd4726
const $29c8f3d4b808c9e5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0381d6bd7bbe5617a5660feab9ea1ef587bd4c9822f831ab5b078936b0bd4726",
        "metadata": {
            "connection": [
                {
                    "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "helpCenter",
                        "helpCenterPages"
                    ]
                }
            ]
        },
        "name": "SupportWebsitePagesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $29c8f3d4b808c9e5$export$2e2bcd8739ae039 = $29c8f3d4b808c9e5$var$node;

});

parcelRegister("9TqXQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1uhRX").then(()=>parcelRequire('3HAKZ'));

});




parcelRegister("8M7gQ", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRouteEntry", () => $5d298e21be96f4b1$export$59cfd0dfcd1b4311);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $8BXqW = parcelRequire("8BXqW");

var $5RW99 = parcelRequire("5RW99");

var $dUMft = parcelRequire("dUMft");

var $b9dJE = parcelRequire("b9dJE");

var $4cTDP = parcelRequire("4cTDP");

var $3cDvy = parcelRequire("3cDvy");
const $5d298e21be96f4b1$export$59cfd0dfcd1b4311 = (0, $6xToB.createEntry)((0, $8BXqW.helpCenterSettingsSupportWebsiteRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $dUMft.default),
            horizontal: (0, $4cTDP.fg)('csm_contact_us_rte') ? undefined : (0, $b9dJE.AsyncSupportWebsiteNav)
        },
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('jcs_master_flag')) return undefined;
            return (0, $4cTDP.fg)('csm_contact_us_rte') ? (0, $3cDvy.HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation) : (0, $3cDvy.HelpCenterSettingsSupportWebsiteEntryPoint);
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsSupportWebsiteRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsSupportWebsiteRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8BXqW", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRoute", () => $b72b0aa9579f37a6$export$c59ea9b870a0e809);
const $b72b0aa9579f37a6$export$c59ea9b870a0e809 = {
    name: 'helpcenter-settings-support-website-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website',
    exact: true
};

});

parcelRegister("3cDvy", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPoint", () => $37e8019dbe2c1863$export$91f75c485220b109);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation", () => $37e8019dbe2c1863$export$4811316770750d89);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $5iiP9 = parcelRequire("5iiP9");

var $469qC = parcelRequire("469qC");
const $37e8019dbe2c1863$export$91f75c485220b109 = (0, $g8uYY.createPageEntryPoint)({
    main: $5iiP9.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});
const $37e8019dbe2c1863$export$4811316770750d89 = (0, $g8uYY.createPageEntryPoint)({
    main: $5iiP9.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $469qC.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("5iiP9", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteAppEntryPoint", () => $580dca05e836ac74$export$43c72a7c514122ed);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $580dca05e836ac74$export$43c72a7c514122ed = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4iEIC")), {
        moduleId: "6e5d67aa",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("4iEIC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3s72Y").then(()=>parcelRequire('k5jfD'));

});




parcelRegister("1kuHh", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationCustomizeRouteEntry", () => $7b1f53a91ad425e2$export$e2d2cfd4c910d192);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $dq0ox = parcelRequire("dq0ox");

var $4cTDP = parcelRequire("4cTDP");

var $aGKVW = parcelRequire("aGKVW");

var $ioWDK = parcelRequire("ioWDK");
const $7b1f53a91ad425e2$export$e2d2cfd4c910d192 = (0, $6xToB.createEntry)((0, $dq0ox.helpCenterSettingsWidgetConfigurationCustomizeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration.customize',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('csm_agent_config_widget_configuration_embed_page') || !(0, $4cTDP.fg)('csm_agent_config_widget_configuration_tab_routes')) return undefined;
            return 0, $aGKVW.HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsWidgetConfigurationCustomizeRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsWidgetConfigurationCustomizeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dq0ox", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationCustomizeRoute", () => $2ce88de579e5e3c8$export$f737005f37c63b01);
const $2ce88de579e5e3c8$export$f737005f37c63b01 = {
    name: 'helpcenter-settings-widget-configuration-customize',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/widget-configuration/customize',
    exact: true
};

});

parcelRegister("aGKVW", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint", () => $54515e7b0c8a436f$export$797b58b534648b3f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $crXh2 = parcelRequire("crXh2");
const $54515e7b0c8a436f$export$797b58b534648b3f = (0, $g8uYY.createPageEntryPoint)({
    main: $crXh2.customizeEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("crXh2", function(module, exports) {
$parcel$export(module.exports, "customizeEntryPoint", () => $2939f473eefdcb15$export$7213ac69dc745c32);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $8HUND = parcelRequire("8HUND");

const $2939f473eefdcb15$export$7213ac69dc745c32 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("1XBkP")), {
        moduleId: "c66234ba",
        moduleName: "HelpCenterSettingsWidgetConfigurationCustomizeApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                page: {
                    parameters: (0, $8HUND.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("8HUND", function(module, exports) {
$parcel$export(module.exports, "default", () => $0979d2ba7e6d4a81$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c2a09b56c897eb2c341f8fbfab9e6fbd>>
 * @relayHash 9fa2541c008cfde5e59182c11104b868
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2e628eaa65c571e8c942d1651916f03f44a145df51266f25664aff3ebf5f62e

var $37Ewn = parcelRequire("37Ewn");
const $0979d2ba7e6d4a81$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EMBED"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "allowedDomains"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAnonymousAccessEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "position"
                                                },
                                                {
                                                    "concreteType": "CsmAiWidgetBrandingTheme",
                                                    "kind": "LinkedField",
                                                    "name": "theme",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorVibeVariant"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "radius"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "space"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "chatColor"
                                                        },
                                                        {
                                                            "concreteType": "CsmAiWidgetBrandingAttribution",
                                                            "kind": "LinkedField",
                                                            "name": "attribution",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                },
                                v5 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f2e628eaa65c571e8c942d1651916f03f44a145df51266f25664aff3ebf5f62e",
            "metadata": {},
            "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0979d2ba7e6d4a81$var$node.hash = "fce85ed7be1408ea5c40096af1177f12";
(0, $37Ewn.PreloadableQueryRegistry).set($0979d2ba7e6d4a81$var$node.params.id, $0979d2ba7e6d4a81$var$node);
var $0979d2ba7e6d4a81$export$2e2bcd8739ae039 = $0979d2ba7e6d4a81$var$node;

});

parcelRegister("1XBkP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4qL5x").then(()=>parcelRequire('jjqbH'));

});




parcelRegister("amP5i", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationInstallRouteEntry", () => $500dfcb7018bbbc3$export$59a8db5e8e5313cc);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $b1OEb = parcelRequire("b1OEb");

var $4cTDP = parcelRequire("4cTDP");

var $b6tzp = parcelRequire("b6tzp");

var $ioWDK = parcelRequire("ioWDK");
const $500dfcb7018bbbc3$export$59a8db5e8e5313cc = (0, $6xToB.createEntry)((0, $b1OEb.helpCenterSettingsWidgetConfigurationInstallRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration.install',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('csm_agent_config_widget_configuration_embed_page') || !(0, $4cTDP.fg)('csm_agent_config_widget_configuration_tab_routes')) return undefined;
            return 0, $b6tzp.HelpCenterSettingsWidgetConfigurationInstallEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsWidgetConfigurationInstallRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsWidgetConfigurationInstallRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("b1OEb", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationInstallRoute", () => $5c242c5bfb55f4f3$export$3f21158408d69752);
const $5c242c5bfb55f4f3$export$3f21158408d69752 = {
    name: 'helpcenter-settings-widget-configuration-install',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/widget-configuration/install',
    exact: true
};

});

parcelRegister("b6tzp", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationInstallEntryPoint", () => $b2a394663ca291df$export$f1b91dfa549d7f2d);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $lw1UQ = parcelRequire("lw1UQ");
const $b2a394663ca291df$export$f1b91dfa549d7f2d = (0, $g8uYY.createPageEntryPoint)({
    main: $lw1UQ.installEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("lw1UQ", function(module, exports) {
$parcel$export(module.exports, "installEntryPoint", () => $dd17d973c6a85dd2$export$a67eb9bb1b8e25ec);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $dMgUh = parcelRequire("dMgUh");

const $dd17d973c6a85dd2$export$a67eb9bb1b8e25ec = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("cNK79")), {
        moduleId: "2fe5f13d",
        moduleName: "HelpCenterSettingsWidgetConfigurationInstallApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                page: {
                    parameters: (0, $dMgUh.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("dMgUh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1baf48ee19aee713$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<86d1372fb510993435ca5e79a1de74d0>>
 * @relayHash f4bb23c9a35362b105b2f16ff48e7563
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c55b182af4c22c379cae60904670d35dfd93f91d0fb752d66a4a61e795515588

var $37Ewn = parcelRequire("37Ewn");
const $1baf48ee19aee713$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EMBED"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "allowedDomains"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAnonymousAccessEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "position"
                                                },
                                                {
                                                    "concreteType": "CsmAiWidgetBrandingTheme",
                                                    "kind": "LinkedField",
                                                    "name": "theme",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorVibeVariant"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "radius"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "space"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "chatColor"
                                                        },
                                                        {
                                                            "concreteType": "CsmAiWidgetBrandingAttribution",
                                                            "kind": "LinkedField",
                                                            "name": "attribution",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                },
                                v5 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c55b182af4c22c379cae60904670d35dfd93f91d0fb752d66a4a61e795515588",
            "metadata": {},
            "name": "HelpCenterSettingsWidgetConfigurationInstallAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1baf48ee19aee713$var$node.hash = "9e27728c78af0b70941f3a0f02ab93cf";
(0, $37Ewn.PreloadableQueryRegistry).set($1baf48ee19aee713$var$node.params.id, $1baf48ee19aee713$var$node);
var $1baf48ee19aee713$export$2e2bcd8739ae039 = $1baf48ee19aee713$var$node;

});

parcelRegister("cNK79", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ivXc").then(()=>parcelRequire('fxrUq'));

});




parcelRegister("4AyGF", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationRouteEntry", () => $858d2da35e031de3$export$c31c9a710ba499e8);

var $aQoXd = parcelRequire("aQoXd");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $dHjtl = parcelRequire("dHjtl");

var $4cTDP = parcelRequire("4cTDP");

var $b5xUw = parcelRequire("b5xUw");

var $ioWDK = parcelRequire("ioWDK");
const $858d2da35e031de3$export$c31c9a710ba499e8 = (0, $6xToB.createEntry)((0, $dHjtl.helpCenterSettingsWidgetConfigurationRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.widget-configuration',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: $ioWDK.navigation,
        component: (0, $9BJU1.default),
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('csm_agent_config_widget_configuration_embed_page')) return undefined;
            return 0, $b5xUw.HelpCenterSettingsWidgetConfigurationEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsWidgetConfigurationRouteEntry.tsx',
                whichExportToUse: 'helpCenterSettingsWidgetConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dHjtl", function(module, exports) {
$parcel$export(module.exports, "helpCenterSettingsWidgetConfigurationRoute", () => $25574dce869a712f$export$5383ecd0996d74ed);
const $25574dce869a712f$export$5383ecd0996d74ed = {
    name: 'helpcenter-settings-widget-configuration',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/widget-configuration',
    exact: true
};

});

parcelRegister("b5xUw", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationEntryPoint", () => $fdbb2bb303d289a0$export$8b1b69a280b85325);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $iEk8Z = parcelRequire("iEk8Z");
const $fdbb2bb303d289a0$export$8b1b69a280b85325 = (0, $g8uYY.createPageEntryPoint)({
    main: $iEk8Z.HelpCenterSettingsWidgetConfigurationAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("iEk8Z", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsWidgetConfigurationAppEntryPoint", () => $db3f43a887661996$export$5b62ed117b99ac21);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $8d3cS = parcelRequire("8d3cS");

const $db3f43a887661996$export$5b62ed117b99ac21 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4dqoP")), {
        moduleId: "93c4204c",
        moduleName: "HelpCenterSettingsWidgetConfigurationApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                page: {
                    parameters: (0, $8d3cS.default),
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("8d3cS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f29f8befe1a34ebd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ceeb6f5e4b427372ff065770f4ebe4b2>>
 * @relayHash 836dbddf7a5a4130431fe57d1668810f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f584889675147c92a8c6b21b35e30385eed398c535f053812cf5ddcab0e1181

var $37Ewn = parcelRequire("37Ewn");
const $f29f8befe1a34ebd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EMBED"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsWidgetConfigurationAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsWidgetConfigurationAppQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "widgets",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "allowedDomains"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAnonymousAccessEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "position"
                                                },
                                                {
                                                    "concreteType": "CsmAiWidgetBrandingTheme",
                                                    "kind": "LinkedField",
                                                    "name": "theme",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorVibeVariant"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "radius"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "space"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "chatColor"
                                                        },
                                                        {
                                                            "concreteType": "CsmAiWidgetBrandingAttribution",
                                                            "kind": "LinkedField",
                                                            "name": "attribution",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiWidgetConfig"
                                        }
                                    ],
                                    "storageKey": "widgets(type:\"EMBED\")"
                                },
                                v5 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8f584889675147c92a8c6b21b35e30385eed398c535f053812cf5ddcab0e1181",
            "metadata": {},
            "name": "HelpCenterSettingsWidgetConfigurationAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f29f8befe1a34ebd$var$node.hash = "5f26abeb786a2413d66be942121861de";
(0, $37Ewn.PreloadableQueryRegistry).set($f29f8befe1a34ebd$var$node.params.id, $f29f8befe1a34ebd$var$node);
var $f29f8befe1a34ebd$export$2e2bcd8739ae039 = $f29f8befe1a34ebd$var$node;

});

parcelRegister("4dqoP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("058PH").then(()=>parcelRequire('aoN9y'));

});




parcelRegister("MBVfl", function(module, exports) {
$parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", () => $7b89ea521d9a7722$export$2740cfaa979353b9);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $h7Tbo = parcelRequire("h7Tbo");

var $8ULju = parcelRequire("8ULju");
const $7b89ea521d9a7722$export$2740cfaa979353b9 = (0, $6xToB.createEntry)((0, $h7Tbo.homeOnboardingRedirectRoute), ()=>({
        group: 'home',
        component: (0, $8ULju.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-home-onboarding-redirect-entries/src/homeOnboardingRedirectRouteEntry.tsx',
                whichExportToUse: 'homeOnboardingRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("h7Tbo", function(module, exports) {
$parcel$export(module.exports, "homeOnboardingRedirectRoute", () => $69b4b747cd814a8d$export$2eaffde3ad991b33);
const $69b4b747cd814a8d$export$2eaffde3ad991b33 = {
    name: 'home-onboarding-redirect',
    path: '/jira/your-work-onboarding',
    exact: true
};

});

parcelRegister("8ULju", function(module, exports) {
$parcel$export(module.exports, "default", () => $e94200604f01264f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eS29z = parcelRequire("eS29z");

var $83DiZ = parcelRequire("83DiZ");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $e94200604f01264f$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $83DiZ.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $e94200604f01264f$export$2e2bcd8739ae039 = $e94200604f01264f$var$JiraHomeOnboardingRedirect;

});


parcelRegister("4w8EY", function(module, exports) {
$parcel$export(module.exports, "homeRedirectRouteEntry", () => $09b5e322c4bfffbf$export$5379c026da4201e6);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $6r5jO = parcelRequire("6r5jO");

var $3LdAk = parcelRequire("3LdAk");
const $09b5e322c4bfffbf$export$5379c026da4201e6 = (0, $6xToB.createEntry)((0, $6r5jO.homeRedirectRoute), ()=>({
        group: 'home',
        component: (0, $3LdAk.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-home-redirect-entries/src/homeRedirectRouteEntry.tsx',
                whichExportToUse: 'homeRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6r5jO", function(module, exports) {
$parcel$export(module.exports, "homeRedirectRoute", () => $af81b3277e6bf3b6$export$f7a252c9d61f8f94);
const $af81b3277e6bf3b6$export$f7a252c9d61f8f94 = {
    name: 'home-redirect',
    path: '/jira',
    exact: true
};

});

parcelRegister("3LdAk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eaf4ee054cb26e2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lGrwR = parcelRequire("lGrwR");
const $4eaf4ee054cb26e2$var$JiraBaseRedirectWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGrwR.default), null);
var $4eaf4ee054cb26e2$export$2e2bcd8739ae039 = $4eaf4ee054cb26e2$var$JiraBaseRedirectWrapper;

});
parcelRegister("lGrwR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4da6a8cf5da911a7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");

var $aUy7d = parcelRequire("aUy7d");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");

const $4da6a8cf5da911a7$var$JiraBaseRedirectWrapper = ()=>{
    (0, $gRw8I.di)(window);
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $aUy7d.userHomepageResource));
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && data == null) (0, $eSnSE.default).safeInfoWithoutCustomerData((0, $1c4d6835d61579b2$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: data.homepagePreference
    });
};
var $4da6a8cf5da911a7$export$2e2bcd8739ae039 = $4da6a8cf5da911a7$var$JiraBaseRedirectWrapper;

});
const $1c4d6835d61579b2$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';




parcelRegister("eYdQw", function(module, exports) {
$parcel$export(module.exports, "issueCreateEmbedRouteEntry", () => $52f852bd8c3d84bd$export$abd0bbe95839baf7);

var $eJOHy = parcelRequire("eJOHy");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $cxQGT = parcelRequire("cxQGT");

var $aiWTC = parcelRequire("aiWTC");

var $aV23b = parcelRequire("aV23b");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");
const $52f852bd8c3d84bd$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $52f852bd8c3d84bd$var$LazyIssueCreateEmbed = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3SsWf")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $52f852bd8c3d84bd$var$IssueCreateEmbedLazy = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $52f852bd8c3d84bd$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $52f852bd8c3d84bd$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $52f852bd8c3d84bd$var$LazyIssueCreateEmbed,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $52f852bd8c3d84bd$export$abd0bbe95839baf7 = (0, $6xToB.createEntry)((0, $aiWTC.issueCreateEmbedRoute), ()=>({
        group: 'issue',
        component: $52f852bd8c3d84bd$var$IssueCreateEmbedLazy,
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            $52f852bd8c3d84bd$var$LazyIssueCreateEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-create-embed-entries/src/issueCreateEmbedRouteEntry.tsx',
                whichExportToUse: 'issueCreateEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aiWTC", function(module, exports) {
$parcel$export(module.exports, "issueCreateEmbedRoute", () => $7edf4a90e0aef5e3$export$c155f4de16b62110);
const $7edf4a90e0aef5e3$export$c155f4de16b62110 = {
    name: 'issue-create-embed',
    path: '/jira/issues/create/embed'
};

});

parcelRegister("3SsWf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("jRTO0")
]).then(()=>parcelRequire('fTNst'));

});


parcelRegister("lOn6l", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", () => $533b9b9374a389f0$export$8925c79a030fdfe8);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $j26UA = parcelRequire("j26UA");

var $eznTg = parcelRequire("eznTg");


var $4cTDP = parcelRequire("4cTDP");

var $klAnQ = parcelRequire("klAnQ");

var $gAL0c = parcelRequire("gAL0c");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $533b9b9374a389f0$export$8925c79a030fdfe8 = (0, $6xToB.createEntry)((0, $j26UA.issueNavigatorGlobalJiraRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $eznTg.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $klAnQ.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $gAL0c.getCommonGlobalResources)()
        ],
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>(0, $4cTDP.fg)('nin_remove_global_scope_enrolment') ? (0, $fYGKn.globalIssueNavigatorPageEntryPoint) : (0, $fYGKn.globalIssueNavigatorGinRedirectPageEntryPoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalJiraRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorGlobalJiraRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("j26UA", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalJiraRoute", () => $07713bbd3066130c$export$286b1d26dcbbce9e);
const $07713bbd3066130c$export$286b1d26dcbbce9e = {
    name: 'global-issue-navigator',
    path: '/jira/issues/:issueKey?'
};

});


parcelRegister("37pqk", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", () => $be43171d4eefaba4$export$3e58fe44312b4093);

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $47bQc = parcelRequire("47bQc");

var $eznTg = parcelRequire("eznTg");


var $klAnQ = parcelRequire("klAnQ");

var $gAL0c = parcelRequire("gAL0c");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $be43171d4eefaba4$export$3e58fe44312b4093 = (0, $6xToB.createEntry)((0, $47bQc.issueNavigatorGlobalRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $eznTg.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $klAnQ.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $gAL0c.getCommonGlobalResources)()
        ],
        layout: (0, $7h3uc.globalLayout),
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorGlobalRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4cTDP.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $4cTDP.fg)('nin_remove_global_scope_enrolment') ? (0, $fYGKn.globalIssueNavigatorPageEntryPoint) : (0, $fYGKn.globalIssueNavigatorGinRedirectPageEntryPoint),
        supportsPreviewPanel: true
    }));

});
parcelRegister("47bQc", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $c1bfc0f1ce07a50f$export$928d3577bbe9e124);
const $c1bfc0f1ce07a50f$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    path: '/issues'
};

});


parcelRegister("gymKR", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessCustomEmbedRouteEntry", () => $6462e9329c8c7527$export$ca299eb1d1e6d3a9);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $bZGp2 = parcelRequire("bZGp2");


var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $3vSNg = parcelRequire("3vSNg");
const $6462e9329c8c7527$export$ca299eb1d1e6d3a9 = (0, $6xToB.createEntry)((0, $bZGp2.issueNavigatorProjectBusinessCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectBusinessCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectBusinessCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bZGp2", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessCustomEmbedRoute", () => $67ae605c2a0d7d1e$export$7c9a6e2f3d99aa24);
const $67ae605c2a0d7d1e$export$7c9a6e2f3d99aa24 = {
    name: 'issue-navigator-core-custom-embed',
    path: '/jira/core/projects/:projectKey/issues/:navigationItemId/embed'
};

});

parcelRegister("hFWLB", function(module, exports) {
$parcel$export(module.exports, "EmbedIssueNavigatorSkeleton", () => $fd170ea0a62770da$export$1b1eaa2e48fda507);
/* embed-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $aP8X0 = parcelRequire("aP8X0");
const $fd170ea0a62770da$var$customCssStyles = null;
const $fd170ea0a62770da$export$1b1eaa2e48fda507 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aP8X0))),
        className: (0, $hcewu.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("aP8X0", function(module, exports) {
module.exports = new URL("embed-issue-navigator-skeleton.tpl.616c25ab.svg", import.meta.url).toString();

});


parcelRegister("bQFhw", function(module, exports) {
$parcel$export(module.exports, "getCommonProjectResources", () => $e4f9b2fa1dd4e1a6$export$6236a7417086ea8d);

var $4cTDP = parcelRequire("4cTDP");

var $hHbzj = parcelRequire("hHbzj");

var $3IBHH = parcelRequire("3IBHH");

var $70taY = parcelRequire("70taY");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $dSkEC = parcelRequire("dSkEC");

var $8k1uC = parcelRequire("8k1uC");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5L7qx = parcelRequire("5L7qx");

var $5nfTh = parcelRequire("5nfTh");

var $ebuR2 = parcelRequire("ebuR2");

var $1G20J = parcelRequire("1G20J");
const $e4f9b2fa1dd4e1a6$var$getAIContextPanelResourcesWithCondition = ()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025') ? [] : (0, $5nfTh.getAIContextPanelResources)();
const $e4f9b2fa1dd4e1a6$export$6236a7417086ea8d = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        (0, $8k1uC.issueNavigatorRelayResource),
        (0, $8k1uC.issueNavigatorFilterRelayResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('nin_request_hydrate_query_earlier') && !(0, $4cTDP.fg)('render_jql_builder_in_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResourceBrowserOnly)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('render_jql_builder_in_ssr'), (0, $8k1uC.issueNavigatorHydrationRelayResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('list_lovability_improving_filters'), (0, $8k1uC.issueNavigatorFilterRefinementRelayResource)),
        ...(0, $9NmsS.getNavigationResources)({
            isUsingSidebarEntrypoint: isUsingSidebarEntrypoint
        }),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $5L7qx.resourceWithCondition2)(// not used, removing
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $bTfc4.incidentExperimentTraitResource)),
        (0, $dZRaT.projectContextResource),
        (0, $5L7qx.resourceWithCondition2)(// moving to JSM NIN only
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $hHbzj.forgeProjectModuleResource)),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $5L7qx.resourceWithCondition2)(// moving to JSM NIN only
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $5L7qx.resourceWithCondition2)(// not used, removing
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)),
        (0, $1G20J.projectThemeResource),
        (0, $5L7qx.resourceWithCondition2)(// not used, removing
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $70taY.sidebarProjectIssuesResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('nin_remove_global_scope_enrolment'), (0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource)),
        (0, $5L7qx.resourceWithCondition2)(// moving to JSM NIN only
        ()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $3IBHH.staticSidebarDefaultPINFiltersResource)),
        ...$e4f9b2fa1dd4e1a6$var$getAIContextPanelResourcesWithCondition()
    ];

});
parcelRegister("3IBHH", function(module, exports) {
$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $af6bf790275ff943$export$d3efe54a881807bf);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $an7p8 = parcelRequire("an7p8");
const $af6bf790275ff943$export$d3efe54a881807bf = (0, $l1VxS.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $an7p8.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("an7p8", function(module, exports) {
$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $9e0f6cb12be550b3$export$268c1bcb44a0ddd3);

var $3ugTQ = parcelRequire("3ugTQ");
const $9e0f6cb12be550b3$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $9e0f6cb12be550b3$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $3ugTQ.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $9e0f6cb12be550b3$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("70taY", function(module, exports) {
$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $415ca39887aadfd5$export$be31dd7adcfd2297);

var $9FYIg = parcelRequire("9FYIg");

var $f1wKi = parcelRequire("f1wKi");

var $hBje1 = parcelRequire("hBje1");
const $415ca39887aadfd5$export$be31dd7adcfd2297 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $f1wKi.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("f1wKi", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ea569d4f79be67a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<29244e55aeda3be3a09f4d04a01a93c5>>
 * @relayHash 6240104d9cc8180a1271850d545e109d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc2981cd7068a3ac5f6a5abbeb82ec6d1f129908254097112a0825df9b4c4295

var $5Jxq3 = parcelRequire("5Jxq3");
const $7ea569d4f79be67a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StarredFiltersContainerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "StarredFiltersList"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "StarredFiltersContainerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bc2981cd7068a3ac5f6a5abbeb82ec6d1f129908254097112a0825df9b4c4295",
            "metadata": {},
            "name": "StarredFiltersContainerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $5Jxq3.default)
            }
        }
    };
}();
$7ea569d4f79be67a$var$node.hash = "5638ded0435361762f065c662e4cb3fc";
var $7ea569d4f79be67a$export$2e2bcd8739ae039 = $7ea569d4f79be67a$var$node;

});
parcelRegister("5Jxq3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a554ab6a3a2d497f$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $a554ab6a3a2d497f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('add_limit_to_nav3_starred_filter_sidebar');
    }
};

});




parcelRegister("3vSNg", function(module, exports) {
$parcel$export(module.exports, "ListRedirect", () => $e8f0b820c130cddc$export$c011d20faedb87c3);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $kfvK2 = parcelRequire("kfvK2");
const $e8f0b820c130cddc$var$useMatchUrl = (0, $kfvK2.createRouterSelector)((state)=>state.match.url);
const $e8f0b820c130cddc$export$c011d20faedb87c3 = ()=>{
    const matchUrl = $e8f0b820c130cddc$var$useMatchUrl();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: matchUrl.replace('issues', 'list')
    });
};

});


parcelRegister("dJkii", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRouteEntry", () => $a8f2e4ff4bb50b03$export$2b29f9b6033583e1);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $950ia = parcelRequire("950ia");


var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $3vSNg = parcelRequire("3vSNg");
const $a8f2e4ff4bb50b03$export$2b29f9b6033583e1 = (0, $6xToB.createEntry)((0, $950ia.issueNavigatorProjectBusinessEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectBusinessEmbedRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectBusinessEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("950ia", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRoute", () => $072d8c6f0ad6b8ae$export$a59f4bdf8be89f93);
const $072d8c6f0ad6b8ae$export$a59f4bdf8be89f93 = {
    name: 'issue-navigator-core-embed',
    path: '/jira/core/projects/:projectKey/issues/embed'
};

});


parcelRegister("7M3Qw", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", () => $de31742aff49379c$export$ce258b07e4b7eb8c);

var $hS1gr = parcelRequire("hS1gr");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $2CudY = parcelRequire("2CudY");

var $gwH93 = parcelRequire("gwH93");


var $4cTDP = parcelRequire("4cTDP");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $3vSNg = parcelRequire("3vSNg");
const $de31742aff49379c$export$ce258b07e4b7eb8c = (0, $6xToB.createEntry)((0, $2CudY.issueNavigatorProjectBusinessRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectBusinessRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectBusinessRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root')
    }));

});
parcelRegister("2CudY", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectBusinessRoute", () => $45f2e5a21d68291e$export$3219766aa1a42d18);
const $45f2e5a21d68291e$export$3219766aa1a42d18 = {
    name: 'issue-navigator-core',
    path: '/jira/core/projects/:projectKey/issues/:navigationItemId?'
};

});

parcelRegister("gwH93", function(module, exports) {
$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $6692fc7a1d956e32$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $c9K8H = parcelRequire("c9K8H");
const $6692fc7a1d956e32$var$customCssStyles = null;
const $6692fc7a1d956e32$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c9K8H))),
        className: (0, $hcewu.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("c9K8H", function(module, exports) {
module.exports = new URL("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg", import.meta.url).toString();

});



parcelRegister("kSzi3", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicCustomEmbedRouteEntry", () => $20ece720ea215a17$export$26b088a9b796b7a4);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $5ClYN = parcelRequire("5ClYN");

var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");


var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");

var $3vSNg = parcelRequire("3vSNg");
const $20ece720ea215a17$export$26b088a9b796b7a4 = (0, $6xToB.createEntry)((0, $5ClYN.issueNavigatorProjectClassicCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root'),
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5ClYN", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicCustomEmbedRoute", () => $a4758a21ea467aab$export$67a527991a5dd89b);
const $a4758a21ea467aab$export$67a527991a5dd89b = {
    name: 'issue-navigator-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId/embed'
};

});


parcelRegister("eIWvD", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRouteEntry", () => $0134eb36ace1ef06$export$e77148aa19091842);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $83CdI = parcelRequire("83CdI");

var $hFWLB = parcelRequire("hFWLB");

var $7K5Ea = parcelRequire("7K5Ea");


var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");

var $3vSNg = parcelRequire("3vSNg");
const $0134eb36ace1ef06$export$e77148aa19091842 = (0, $6xToB.createEntry)((0, $83CdI.issueNavigatorProjectClassicEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root'),
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicEmbedRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("83CdI", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRoute", () => $5ed3aaf68de71c16$export$1062bd8aa98d7bd1);
const $5ed3aaf68de71c16$export$1062bd8aa98d7bd1 = {
    name: 'issue-navigator-classic-embed',
    path: '/jira/software/c/projects/:projectKey/issues/embed'
};

});


parcelRegister("5HdwO", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", () => $1c4accc0e340e2b1$export$88d5f4117ce3d0fb);

var $4cTDP = parcelRequire("4cTDP");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $fswMK = parcelRequire("fswMK");

var $gwH93 = parcelRequire("gwH93");

var $hS1gr = parcelRequire("hS1gr");


var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $3vSNg = parcelRequire("3vSNg");
const $1c4accc0e340e2b1$export$88d5f4117ce3d0fb = (0, $6xToB.createEntry)((0, $fswMK.issueNavigatorProjectClassicRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)({
                isUsingSidebarEntrypoint: true
            })
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4cTDP.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorPageEntryPointWithNested),
        supportsPreviewPanel: true
    }));

});
parcelRegister("fswMK", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectClassicRoute", () => $02e6762aec3aaac6$export$8e7b74b6169d59ca);
const $02e6762aec3aaac6$export$8e7b74b6169d59ca = {
    name: 'issue-navigator-classic',
    path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId?'
};

});


parcelRegister("9kaa4", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectListServicedeskRouteEntry", () => $c25cb749c6b5e510$export$1e29ccb817b061b2);

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $aGQ56 = parcelRequire("aGQ56");

var $gr3Ie = parcelRequire("gr3Ie");

var $aQoXd = parcelRequire("aQoXd");

var $gwH93 = parcelRequire("gwH93");


var $esUDP = parcelRequire("esUDP");

var $5L7qx = parcelRequire("5L7qx");

var $hHbzj = parcelRequire("hHbzj");

var $3IBHH = parcelRequire("3IBHH");

var $6zZVV = parcelRequire("6zZVV");

var $5nfTh = parcelRequire("5nfTh");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $c25cb749c6b5e510$var$getAIContextPanelResourcesWithCondition = ()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025') ? (0, $5nfTh.getAIContextPanelResources)() : [];
const $c25cb749c6b5e510$export$1e29ccb817b061b2 = (0, $6xToB.createEntry)((0, $gr3Ie.issueNavigatorProjectListServicedeskRoute), ()=>({
        ufoName: 'jsm-list-nin',
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.ForPaintServicedeskSidebar)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $aGQ56.queuesNavigationItems),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $4VIcO.getConsolidationStateResource)()),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('more_for_nav_4_level_3'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $hHbzj.forgeProjectModuleResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $3IBHH.staticSidebarDefaultPINFiltersResource)),
            ...$c25cb749c6b5e510$var$getAIContextPanelResourcesWithCondition()
        ],
        layout: (0, $aQoXd.serviceProjectLayout),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectListServicedeskRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectListServicedeskRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        entryPoint: ()=>(0, $fYGKn.issueNavigatorWithoutHorizontalNavPageEntryPoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root')
    }));

});
parcelRegister("gr3Ie", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectListServicedeskRoute", () => $1c67afca82f07a57$export$ae79eb2d016347ad);
const $1c67afca82f07a57$export$ae79eb2d016347ad = {
    name: 'servicedesk-list',
    path: '/jira/servicedesk/projects/:projectKey/list/:navigationItemId?'
};

});


parcelRegister("7lqd9", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", () => $eaeddc79e63a2b6a$export$b779296ccb8ca1a8);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $aGQ56 = parcelRequire("aGQ56");

var $byfv5 = parcelRequire("byfv5");

var $aQoXd = parcelRequire("aQoXd");

var $gwH93 = parcelRequire("gwH93");


var $4cTDP = parcelRequire("4cTDP");

var $esUDP = parcelRequire("esUDP");

var $5L7qx = parcelRequire("5L7qx");

var $hHbzj = parcelRequire("hHbzj");

var $3IBHH = parcelRequire("3IBHH");

var $6zZVV = parcelRequire("6zZVV");

var $5nfTh = parcelRequire("5nfTh");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $3vSNg = parcelRequire("3vSNg");
const $eaeddc79e63a2b6a$var$getAIContextPanelResourcesWithCondition = ()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025') ? (0, $5nfTh.getAIContextPanelResources)() : [];
const $eaeddc79e63a2b6a$export$b779296ccb8ca1a8 = (0, $6xToB.createEntry)((0, $byfv5.issueNavigatorProjectServicedeskRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.ForPaintServicedeskSidebar)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $aGQ56.queuesNavigationItems),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $4VIcO.getConsolidationStateResource)()),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('more_for_nav_4_level_3'), (0, $esUDP.jsmProjectMenuContentSidebarResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $hHbzj.forgeProjectModuleResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $3IBHH.staticSidebarDefaultPINFiltersResource)),
            ...$eaeddc79e63a2b6a$var$getAIContextPanelResourcesWithCondition()
        ],
        layout: (0, $aQoXd.serviceProjectLayout),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectServicedeskRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectServicedeskRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorWithoutHorizontalNavPageEntryPoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root')
    }));

});
parcelRegister("byfv5", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectServicedeskRoute", () => $b2697b842d9d2a49$export$e3495d64f36ba27c);
const $b2697b842d9d2a49$export$e3495d64f36ba27c = {
    name: 'servicedesk-issues',
    path: '/jira/servicedesk/projects/:projectKey/issues/:navigationItemId?'
};

});


parcelRegister("bxEah", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareCustomEmbedRouteEntry", () => $d017c9a55a396236$export$128e557bdc64663e);

var $6xToB = parcelRequire("6xToB");

var $5pk1v = parcelRequire("5pk1v");

var $7K5Ea = parcelRequire("7K5Ea");

var $4VIcO = parcelRequire("4VIcO");

var $hFWLB = parcelRequire("hFWLB");


var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");

var $3vSNg = parcelRequire("3vSNg");
const $d017c9a55a396236$export$128e557bdc64663e = (0, $6xToB.createEntry)((0, $5pk1v.issueNavigatorProjectSoftwareCustomEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $4VIcO.getConsolidationStateResource)())
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectSoftwareCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5pk1v", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareCustomEmbedRoute", () => $41e03a10d9a3d551$export$efddc86081bba5fc);
const $41e03a10d9a3d551$export$efddc86081bba5fc = {
    name: 'software-issue-navigator-custom-embed',
    path: '/jira/software/projects/:projectKey/issues/:navigationItemId/embed'
};

});


parcelRegister("ytX2z", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRouteEntry", () => $badedcd1e5c2c1b7$export$e87ead168f851b66);

var $6xToB = parcelRequire("6xToB");

var $4eenS = parcelRequire("4eenS");

var $7K5Ea = parcelRequire("7K5Ea");

var $4VIcO = parcelRequire("4VIcO");

var $hFWLB = parcelRequire("hFWLB");


var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $d4NVH = parcelRequire("d4NVH");

var $3vSNg = parcelRequire("3vSNg");
const $badedcd1e5c2c1b7$export$e87ead168f851b66 = (0, $6xToB.createEntry)((0, $4eenS.issueNavigatorProjectSoftwareEmbedRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $hFWLB.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $4VIcO.getConsolidationStateResource)())
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareEmbedRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectSoftwareEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4eenS", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRoute", () => $d598abe98648a3a5$export$ab4385f7ae539901);
const $d598abe98648a3a5$export$ab4385f7ae539901 = {
    name: 'software-issue-navigator-embed',
    path: '/jira/software/projects/:projectKey/issues/embed'
};

});


parcelRegister("5rr5U", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", () => $2626c3312716833c$export$2a50f64378877c9d);

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $enVQb = parcelRequire("enVQb");

var $gwH93 = parcelRequire("gwH93");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");


var $4cTDP = parcelRequire("4cTDP");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $3vSNg = parcelRequire("3vSNg");
const $2626c3312716833c$export$2a50f64378877c9d = (0, $6xToB.createEntry)((0, $enVQb.issueNavigatorProjectSoftwareRoute), ()=>({
        group: 'issue-navigator',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.ForPaintSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $8FCAy.softwareProjectLayoutNoOnboarding)),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectSoftwareRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        component: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $3vSNg.ListRedirect) : undefined,
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : (0, $fYGKn.issueNavigatorPageEntryPoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root')
    }));

});
parcelRegister("enVQb", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorProjectSoftwareRoute", () => $d376270ff6ff844f$export$b8bd410115307d80);
const $d376270ff6ff844f$export$b8bd410115307d80 = {
    name: 'software-issue-navigator',
    path: '/jira/software/projects/:projectKey/issues/:navigationItemId?'
};

});


parcelRegister("fFeTt", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAttachmentsRouteEntry", () => $05292bd8a56c1695$export$62c45d8ff658b6c2);

var $3MgfG = parcelRequire("3MgfG");

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jpDOj = parcelRequire("jpDOj");

var $jkM5n = parcelRequire("jkM5n");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");
const $05292bd8a56c1695$var$attachmentsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jkM5n.attachmentsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $05292bd8a56c1695$export$62c45d8ff658b6c2 = (0, $6xToB.createEntry)((0, $jpDOj.jiraBusinessAttachmentsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.attachments-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>$05292bd8a56c1695$var$attachmentsPageEntryPoint,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-attachments-entries/src/jiraBusinessAttachmentsRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessAttachmentsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jpDOj", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessAttachmentsRoute", () => $de1305201950e721$export$81237c0b791e592e);
const $de1305201950e721$export$81237c0b791e592e = {
    name: 'classic-business-attachments',
    path: '/jira/core/projects/:projectKey/attachments'
};

});

parcelRegister("jkM5n", function(module, exports) {
$parcel$export(module.exports, "attachmentsEntryPoint", () => $c2b712895055eec8$export$d94bafd9d893ec98);

var $4b7aq = parcelRequire("4b7aq");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $c2b712895055eec8$export$d94bafd9d893ec98 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eHjbR")), {
        moduleId: "26a1d436",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $4b7aq.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        projectKeys: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("4b7aq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c848784960304ed5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4054d3c2cb7c4a4c50cc7ffc255f51b>>
 * @relayHash 176740e0030484c495af762dfe4e4fed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eca7cf9c000bf43a7e44ad71c7f514d42218e2cc89475fb724f0827fd0a81048
const $c848784960304ed5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "eca7cf9c000bf43a7e44ad71c7f514d42218e2cc89475fb724f0827fd0a81048",
        "metadata": {},
        "name": "src_jiraBusinessAttachmentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c848784960304ed5$export$2e2bcd8739ae039 = $c848784960304ed5$var$node;

});

parcelRegister("eHjbR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9WBx4").then(()=>parcelRequire('eZOQw'));

});



parcelRegister("9onbT", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRouteEntry", () => $6a30df79afe8bf4d$export$4622ad4c7294f3a7);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $9Jo4w = parcelRequire("9Jo4w");

var $cxKOj = parcelRequire("cxKOj");

var $kRv8K = parcelRequire("kRv8K");

var $kmsn1 = parcelRequire("kmsn1");

var $aPuyg = parcelRequire("aPuyg");

var $bAZBO = parcelRequire("bAZBO");
const $6a30df79afe8bf4d$export$4622ad4c7294f3a7 = (0, $6xToB.createEntry)((0, $kmsn1.jiraBusinessBoardCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            (0, $9Jo4w.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $cxKOj.expValEquals)('board_harmonisation_m2', 'enabled', true, false) ? (0, $aPuyg.boardEmbedPageEntryPoint) : (0, $bAZBO.boardEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-board-entries/src/jiraBusinessBoardCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessBoardCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9Jo4w", function(module, exports) {
$parcel$export(module.exports, "useWorkflowIssues", () => $4f8c50521aed954a$export$86b7de71bf71360d);
$parcel$export(module.exports, "workflowIssuesResource", () => $4f8c50521aed954a$export$49027035af709702);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $5L7qx = parcelRequire("5L7qx");

var $cxKOj = parcelRequire("cxKOj");

var $9MB0h = parcelRequire("9MB0h");
const $4f8c50521aed954a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const $4f8c50521aed954a$var$resource = (0, $l1VxS.createResource)({
    type: $4f8c50521aed954a$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$4f8c50521aed954a$var$RESOURCE_TYPE_KEY}_${projectKey}_${matchedRoute.match?.params?.itemId ?? 'default'}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("9MB0h"))),
    getData: (0, $9MB0h.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $4f8c50521aed954a$export$86b7de71bf71360d = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $eJrcF.useResource)($4f8c50521aed954a$export$49027035af709702);
const $4f8c50521aed954a$export$49027035af709702 = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $cxKOj.expValEquals)('board_harmonisation_m2', 'enabled', true, false), $4f8c50521aed954a$var$resource);

});
parcelRegister("9MB0h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fcafc61247208ca2$export$2e2bcd8739ae039);

var $d04mc = parcelRequire("d04mc");

var $6uWhG = parcelRequire("6uWhG");

var $14RSn = parcelRequire("14RSn");

var $2vBmG = parcelRequire("2vBmG");

var $7hVvO = parcelRequire("7hVvO");
const $fcafc61247208ca2$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $fcafc61247208ca2$var$getEarlyPreload() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $d04mc.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $14RSn.default)(response.error.status);
            }
            return {
                workflows: response.workflows,
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $fcafc61247208ca2$var$fetchData({ projectKey: projectKey, itemId: itemId }) {
    const earlyPreload = $fcafc61247208ca2$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $d04mc.fetchWorkflowIssues)({
        projectKey: projectKey,
        itemId: itemId
    });
}
async function $fcafc61247208ca2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $fcafc61247208ca2$var$EMPTY_DATA;
    try {
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiStartMark));
        const workflows = await $fcafc61247208ca2$var$fetchData({
            projectKey: match.params.projectKey ?? '',
            itemId: match.params.itemId ?? undefined
        });
        (0, $6uWhG.setMark)((0, $2vBmG.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $7hVvO.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("d04mc", function(module, exports) {
$parcel$export(module.exports, "Unchanged", () => $a872adfb90aa89a1$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $a872adfb90aa89a1$export$17e2e8212d93f58d);

var $gRw8I = parcelRequire("gRw8I");


var $kDz4Q = parcelRequire("kDz4Q");

var $14RSn = parcelRequire("14RSn");

var $eBhI6 = parcelRequire("eBhI6");
class $a872adfb90aa89a1$export$eccd6db33b8f6a89 extends Error {
}
const $a872adfb90aa89a1$export$17e2e8212d93f58d = async ({ projectKey: projectKey, itemId: itemId, ifChangedSince: ifChangedSince })=>{
    (0, $gRw8I.di)(fetch);
    try {
        (0, $kDz4Q.markViewMetric)('jwm-board', (0, $7ae6358d133c6fe3$export$23e322eb7c526958));
        let url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true&operation=LegacyBoardIssuesByWorkflow`;
        if (itemId) url += `&viewItemId=${itemId}`;
        const defaultOptions = (0, $eBhI6.getDefaultOptions)(url);
        const response = await fetch(url, {
            ...defaultOptions,
            headers: {
                ...defaultOptions.headers,
                ...ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            }
        });
        if (!response.ok) {
            if (response.status === 304) throw new $a872adfb90aa89a1$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $14RSn.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        return {
            workflows: workflows.data,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $kDz4Q.markViewMetric)('jwm-board', (0, $7ae6358d133c6fe3$export$83ca21a50372ea3b));
    }
};

});
const $7ae6358d133c6fe3$export$747aad128920134d = 3000;
const $7ae6358d133c6fe3$export$e4f8d353742c04ac = 4000;
const $7ae6358d133c6fe3$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $7ae6358d133c6fe3$export$23e322eb7c526958 = 'REQUEST_START';
const $7ae6358d133c6fe3$export$83ca21a50372ea3b = 'REQUEST_END';
const $7ae6358d133c6fe3$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $7ae6358d133c6fe3$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $7ae6358d133c6fe3$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $7ae6358d133c6fe3$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $7ae6358d133c6fe3$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $7ae6358d133c6fe3$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("kDz4Q", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $14d6e286f06274f1$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $14d6e286f06274f1$export$8d15b4fb25f90514);

var $hqYEY = parcelRequire("hqYEY");

const $14d6e286f06274f1$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $7ae6358d133c6fe3$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $7ae6358d133c6fe3$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $7ae6358d133c6fe3$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $7ae6358d133c6fe3$export$e4f8d353742c04ac)
        }
    }
};
const $14d6e286f06274f1$var$timings = [
    {
        key: (0, $7ae6358d133c6fe3$export$540ffd289e5e0562),
        startMark: (0, $7ae6358d133c6fe3$export$23e322eb7c526958),
        endMark: (0, $7ae6358d133c6fe3$export$83ca21a50372ea3b)
    },
    {
        key: (0, $7ae6358d133c6fe3$export$821ca6ff41f300ec),
        startMark: (0, $7ae6358d133c6fe3$export$7b887ee35f2b465e),
        endMark: (0, $7ae6358d133c6fe3$export$ac953882305d6102)
    },
    {
        key: (0, $7ae6358d133c6fe3$export$7f7f60b5526c5ee3),
        startMark: (0, $7ae6358d133c6fe3$export$b78f0bbf209e5f4),
        endMark: (0, $7ae6358d133c6fe3$export$88ea1e280513690f)
    }
];
const $14d6e286f06274f1$export$2878bf482e539059 = {
    'approvals-view': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    summary: (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'summary-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    list: (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'list-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'software-form-submit-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jsw.form-submit-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'software-list': (0, $hqYEY.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'software-list-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    timeline: (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'timeline-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    calendar: (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'calendar-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    form: (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-submit': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-submit-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-submit-public': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.form-submit-public-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'form-directory': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    board: (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'jwm-board': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'jwm-board-embed': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    'jwm-pages': (0, $hqYEY.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $hqYEY.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $14d6e286f06274f1$var$slo,
        timings: $14d6e286f06274f1$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $14d6e286f06274f1$var$startedMarks = {};
const $14d6e286f06274f1$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($14d6e286f06274f1$var$startedMarks[markKey]) return;
    $14d6e286f06274f1$var$startedMarks[markKey] = true;
    const metric = $14d6e286f06274f1$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});




parcelRegister("kmsn1", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRoute", () => $1cdf4356b463bbfc$export$7d977a74e9d9d32b);
const $1cdf4356b463bbfc$export$7d977a74e9d9d32b = {
    name: 'classic-business-board-custom-embed',
    path: '/jira/core/projects/:projectKey/board/:itemId/embed',
    exact: true
};

});

parcelRegister("aPuyg", function(module, exports) {
$parcel$export(module.exports, "boardEmbedPageEntryPoint", () => $fd4c933209b704fe$export$5046daadb8899791);

var $g8uYY = parcelRequire("g8uYY");

var $52zK0 = parcelRequire("52zK0");
const $fd4c933209b704fe$export$5046daadb8899791 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $52zK0.boardEntryPoint)
});

});
parcelRegister("52zK0", function(module, exports) {
$parcel$export(module.exports, "boardEntryPoint", () => $8014e42aebbca137$export$937ca5a4cdc1a12e);

var $2QbdU = parcelRequire("2QbdU");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $c2mZk = parcelRequire("c2mZk");

const $8014e42aebbca137$export$937ca5a4cdc1a12e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cM0AB")), {
        moduleId: "1efc4fed",
        moduleName: "JiraBoard",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        if (projectKey == null) throw new Error('Project key missing');
        const settings = (0, $c2mZk.getBoardQueryParams)(context);
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2QbdU.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: settings
                        },
                        viewQueryInput: {
                            projectKeyAndItemQuery: {
                                cloudId: cloudId,
                                projectKey: projectKey,
                                itemId: itemId
                            }
                        },
                        settings: settings
                    }
                }
            }
        };
    }
});

});
parcelRegister("2QbdU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce3fc64d02b47d31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8f1e0247dad05a3264cc2906fbe2e69>>
 * @relayHash 8b8c38c7a22dce7456580a037f4b2a62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d77d6176b659359d2321c3d2a388ede962ae07219ab1f053817592810c44263a
const $ce3fc64d02b47d31$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d77d6176b659359d2321c3d2a388ede962ae07219ab1f053817592810c44263a",
        "metadata": {},
        "name": "JiraBoardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ce3fc64d02b47d31$export$2e2bcd8739ae039 = $ce3fc64d02b47d31$var$node;

});

parcelRegister("c2mZk", function(module, exports) {
$parcel$export(module.exports, "getBoardQueryParams", () => $e5c8b2f70b78da0f$export$99a929f88d893f90);

var $48ais = parcelRequire("48ais");
const $e5c8b2f70b78da0f$export$99a929f88d893f90 = (routerContext)=>{
    let filter;
    let text;
    let groupBy;
    // if in a client environment, check whether the router url matches the current window pathname
    // if it does, use the filter and groupBy from the current window location instead of the router query
    // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
    const currentLocation = typeof window !== 'undefined' ? window.location : null;
    if (currentLocation != null && (routerContext == null || currentLocation.pathname === routerContext?.match.url)) {
        const urlSearchParams = new URLSearchParams(currentLocation.search);
        filter = urlSearchParams.get('filter') ?? undefined;
        text = urlSearchParams.get('text') ?? undefined;
        groupBy = urlSearchParams.get('groupBy') ?? undefined;
    } else if (routerContext) {
        filter = routerContext.query?.filter;
        text = routerContext.query?.text;
        groupBy = routerContext.query?.groupBy;
    }
    const filterJql = (0, $48ais.combineFilterJqlWithSearchText)(filter, text);
    return {
        filterJql: filterJql,
        groupBy: groupBy
    };
};

});
parcelRegister("48ais", function(module, exports) {
$parcel$export(module.exports, "combineFilterJqlWithSearchText", () => $d07c6829b6e4213c$export$2800caf55ef1091e);
$parcel$export(module.exports, "extractSearchTextFromJql", () => $d07c6829b6e4213c$export$4e9fc17d0b0d17b);
const $d07c6829b6e4213c$var$issueKeyRegex = /^([A-Z][A-Z0-9_]+-)?\d+$/i;
const $d07c6829b6e4213c$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $d07c6829b6e4213c$var$searchTextRegex = /\(summary ~ '(?<searchText>.+?)' OR description ~ '.+?'/;
const $d07c6829b6e4213c$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $d07c6829b6e4213c$var$getSearchTextJQL = (text)=>{
    if (text == null) return undefined;
    if (text.trim() === '') return '';
    let search = $d07c6829b6e4213c$var$sanitize(text);
    if ($d07c6829b6e4213c$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key ~ '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$d07c6829b6e4213c$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $d07c6829b6e4213c$export$2800caf55ef1091e = (filterJql, searchText)=>{
    const textSearchJql = $d07c6829b6e4213c$var$getSearchTextJQL(searchText);
    if (filterJql && textSearchJql) return `${filterJql} AND ${textSearchJql}`;
    if (filterJql && textSearchJql == null) return filterJql;
    if (textSearchJql && filterJql == null) return textSearchJql;
    return filterJql || textSearchJql;
};
const $d07c6829b6e4213c$export$4e9fc17d0b0d17b = (jql)=>{
    const match = jql.match($d07c6829b6e4213c$var$searchTextRegex);
    if (match) {
        let searchText = match.groups?.searchText || '';
        // remove any trailing wildcard from the extracted search text
        searchText = searchText.replace(/\*$/, '');
        // the filter JQL is everything before the matched search text JQL
        // so we split the original JQL at the start index of the match
        let filterJql = jql.slice(0, match.index).trim();
        // remove any trailing AND from the filter JQL
        filterJql = filterJql.replace(/AND\s*$/i, '').trim();
        return [
            filterJql,
            searchText
        ];
    }
    return [
        jql,
        ''
    ];
};

});


parcelRegister("cM0AB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("8K2aW")
]).then(()=>parcelRequire('3IEiO'));

});



parcelRegister("bAZBO", function(module, exports) {
$parcel$export(module.exports, "boardEmbedPageEntryPoint", () => $92c5de105924e1af$export$5046daadb8899791);

var $g8uYY = parcelRequire("g8uYY");

var $1U42Z = parcelRequire("1U42Z");
const $92c5de105924e1af$export$5046daadb8899791 = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $1U42Z.boardEmbedEntryPoint)
});

});
parcelRegister("1U42Z", function(module, exports) {
$parcel$export(module.exports, "boardEmbedEntryPoint", () => $497ac14d88f3339b$export$416ba69e2e054935);

var $1iGaq = parcelRequire("1iGaq");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $497ac14d88f3339b$export$416ba69e2e054935 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bD45Z")), {
        moduleId: "c853cc44",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1iGaq.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("1iGaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a466da213b440cfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fcd9bf6451370124008fb551585d407b>>
 * @relayHash 92fa38aacec5efa4adc1ae885e93167d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f6b45ca1fe09166bd676c00295349a1ebb1ae58b8e5903a218eec379adb781d9

var $f1blX = parcelRequire("f1blX");
const $a466da213b440cfc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f6b45ca1fe09166bd676c00295349a1ebb1ae58b8e5903a218eec379adb781d9",
        "metadata": {},
        "name": "src_jiraBusinessBoardEmbedQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $f1blX.default)
        }
    }
};
var $a466da213b440cfc$export$2e2bcd8739ae039 = $a466da213b440cfc$var$node;

});
parcelRegister("f1blX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4868550c9dfba19$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
const $a4868550c9dfba19$var$MergeBoardWorkflowsRelayProvider = {
    get () {
        return (0, $cxKOj.expVal)('merge_board_workflows', 'enabled', false);
    }
};
var $a4868550c9dfba19$export$2e2bcd8739ae039 = $a4868550c9dfba19$var$MergeBoardWorkflowsRelayProvider;

});


parcelRegister("bD45Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("dWC9u")
]).then(()=>parcelRequire('e9FEZ'));

});




parcelRegister("i6owk", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardEmbedRouteEntry", () => $d1a30f2f12e306b4$export$7a97e5e258f37b2a);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $cxKOj = parcelRequire("cxKOj");

var $6xToB = parcelRequire("6xToB");

var $9Jo4w = parcelRequire("9Jo4w");

var $kRv8K = parcelRequire("kRv8K");

var $jOTca = parcelRequire("jOTca");

var $aPuyg = parcelRequire("aPuyg");

var $bAZBO = parcelRequire("bAZBO");
const $d1a30f2f12e306b4$export$7a97e5e258f37b2a = (0, $6xToB.createEntry)((0, $jOTca.jiraBusinessBoardEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            (0, $9Jo4w.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $cxKOj.expValEquals)('board_harmonisation_m2', 'enabled', true, false) ? (0, $aPuyg.boardEmbedPageEntryPoint) : (0, $bAZBO.boardEmbedPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-board-entries/src/jiraBusinessBoardEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessBoardEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jOTca", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardEmbedRoute", () => $ee31414ab6a65efa$export$bd75a810572fe27d);
const $ee31414ab6a65efa$export$bd75a810572fe27d = {
    name: 'classic-business-board-embed',
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};

});


parcelRegister("6tmSj", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardRouteEntry", () => $f032cb8874fad627$export$c7fe0dd4417407a0);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $cxKOj = parcelRequire("cxKOj");

var $9Jo4w = parcelRequire("9Jo4w");

var $kRv8K = parcelRequire("kRv8K");

var $kkG73 = parcelRequire("kkG73");

var $kGRp3 = parcelRequire("kGRp3");

var $8QUNR = parcelRequire("8QUNR");
const $f032cb8874fad627$export$c7fe0dd4417407a0 = (0, $6xToB.createEntry)((0, $kkG73.jiraBusinessBoardRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board',
        layout: (0, $6dwgv.composeLayouts)((0, $9eXLI.businessProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            (0, $9Jo4w.workflowIssuesResource)
        ],
        preloadOptions: {
            earlyChunks: (0, $cxKOj.expValEquals)('board_harmonisation_m2', 'enabled', true, false) ? [] : [
                'business-board-early-entry'
            ]
        },
        entryPoint: ()=>(0, $cxKOj.expValEquals)('board_harmonisation_m2', 'enabled', true, false) ? (0, $kGRp3.boardPageEntryPoint) : (0, $8QUNR.boardPageEntryPoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-board-entries/src/jiraBusinessBoardRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kkG73", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessBoardRoute", () => $10e4ad517f14f730$export$14a5cbbd7e1e2dc2);
const $10e4ad517f14f730$export$14a5cbbd7e1e2dc2 = {
    name: 'classic-business-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board/:itemId?'
};

});

parcelRegister("kGRp3", function(module, exports) {
$parcel$export(module.exports, "boardPageEntryPoint", () => $15f03116e411a663$export$552f44bed039f041);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $52zK0 = parcelRequire("52zK0");

var $9n5I0 = parcelRequire("9n5I0");
const $15f03116e411a663$export$552f44bed039f041 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $52zK0.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});

parcelRegister("8QUNR", function(module, exports) {
$parcel$export(module.exports, "boardPageEntryPoint", () => $6fdbf2ac74ec6e3b$export$552f44bed039f041);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cbl4g = parcelRequire("cbl4g");

var $9n5I0 = parcelRequire("9n5I0");
const $6fdbf2ac74ec6e3b$export$552f44bed039f041 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cbl4g.boardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("cbl4g", function(module, exports) {
$parcel$export(module.exports, "boardEntryPoint", () => $59cd06a0e4aee0da$export$937ca5a4cdc1a12e);

var $inMIk = parcelRequire("inMIk");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $59cd06a0e4aee0da$export$937ca5a4cdc1a12e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("b8UIl")), {
        moduleId: "8dcbcc62",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $inMIk.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("inMIk", function(module, exports) {
$parcel$export(module.exports, "default", () => $add593b4d7bfa958$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f5461ab4b36715040a705f261a42375>>
 * @relayHash a798cac7daee4cded7a00457dbc16bb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e32d863524848bcda8b90da23cea2bf9847e1c64f917f4ebe321728f8efde594

var $f1blX = parcelRequire("f1blX");
const $add593b4d7bfa958$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e32d863524848bcda8b90da23cea2bf9847e1c64f917f4ebe321728f8efde594",
        "metadata": {},
        "name": "src_jiraBusinessBoardQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $f1blX.default)
        }
    }
};
var $add593b4d7bfa958$export$2e2bcd8739ae039 = $add593b4d7bfa958$var$node;

});

parcelRegister("b8UIl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("1Yl0r")
]).then(()=>parcelRequire('9toZG'));

});




parcelRegister("2KqMs", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarCustomEmbedRouteEntry", () => $abb092c651899b6f$export$2971062de35b0b9e);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $dKroe = parcelRequire("dKroe");

var $g8uYY = parcelRequire("g8uYY");

var $cxQGT = parcelRequire("cxQGT");

var $aJSoj = parcelRequire("aJSoj");
const $abb092c651899b6f$var$calendarEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $aJSoj.calendarEntryPoint)
});
const $abb092c651899b6f$export$2971062de35b0b9e = (0, $6xToB.createEntry)((0, $dKroe.jiraBusinessCalendarCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $abb092c651899b6f$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-calendar-entries/src/jiraBusinessCalendarCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessCalendarCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dKroe", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarCustomEmbedRoute", () => $f23b84d56ba648dd$export$9cee00d5c4aee198);
const $f23b84d56ba648dd$export$9cee00d5c4aee198 = {
    name: 'classic-business-calendar-custom-embed',
    path: '/jira/core/projects/:projectKey/calendar/:itemId/embed',
    exact: true
};

});

parcelRegister("aJSoj", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $752335b943997526$export$19cf4b398f638dc6);

var $4cTDP = parcelRequire("4cTDP");

var $caGAp = parcelRequire("caGAp");

var $lpUQd = parcelRequire("lpUQd");

var $cxKOj = parcelRequire("cxKOj");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $752335b943997526$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
function $752335b943997526$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $752335b943997526$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
function $752335b943997526$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $752335b943997526$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $752335b943997526$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $752335b943997526$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $752335b943997526$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $752335b943997526$var$toViewRange(mode) {
    switch(mode){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $752335b943997526$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $752335b943997526$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $752335b943997526$var$toMidnightUTCString(selectedDate),
        mode: $752335b943997526$var$toViewMode(viewRange),
        weekStart: $752335b943997526$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
/** Extracted from business/shared/simpleSearch */ function $752335b943997526$var$jqlSearchText(text) {
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
    const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
}
function $752335b943997526$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
    if (!(0, $4cTDP.fg)('jira_calendar_load_more_pagination')) return {
        additionalFilterQuery: ''
    };
    const hideDoneItemsQuery = "StatusCategory != 'Complete'";
    const search = $752335b943997526$var$jqlSearchText(text);
    return {
        additionalFilterQuery: $752335b943997526$var$and([
            search,
            filter,
            ...hideDoneItems ? [
                hideDoneItemsQuery
            ] : []
        ])
    };
}
function $752335b943997526$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $752335b943997526$export$19cf4b398f638dc6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("9TBSc")), {
        moduleId: "7ed75dc0",
        moduleName: "JiraBusinessCalendarEntrypoint",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        const scope = $752335b943997526$var$createScope(entryPointRouteParams);
        const { date: date, filter: filter, hideDone: hideDone, text: text, viewRange: viewRangeQueryParam } = context.query;
        const selectedDate = $752335b943997526$var$toDate(date);
        const settings = (0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? $752335b943997526$var$getViewSettings($752335b943997526$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = (0, $4cTDP.fg)('jira_calendar_day_grid_week_view') ? $752335b943997526$var$toViewRange(viewRangeQueryParam ?? settings?.viewRange ?? 'month') : 'month';
        const hideDoneItems = hideDone && (0, $4cTDP.fg)('calendar-hide-done-query-param') ? true : settings?.hideDoneItems ?? false;
        const weekStartsOn = (0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $caGAp.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $lpUQd.default),
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $752335b943997526$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $752335b943997526$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: $752335b943997526$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                        unscheduledIssuesSearchInput: $752335b943997526$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        viewId: null,
                        pageLoadMoreEnabled: (0, $4cTDP.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        includeRecurrenceIndicator: true,
                        pageLoadMoreEnabledViewSettings: (0, $4cTDP.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false,
                        hasSavedViewCapability: (0, $cxKOj.expValEquals)('atlas-96240_saved_views_calendar', 'enabled', true, false)
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                hasRecurrenceItemIndicator: true
            }
        };
    }
});

});
parcelRegister("caGAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ace6f66ce5e90dc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfe1a063f9c3dee53e0ce29c41b55e19>>
 * @relayHash 4904f7cdc8e6a902778256166e661f7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03584fde98790a7e63f8ca85b13f2405c35faeb9ebc3dd7e7bd6286ce6193785
const $ace6f66ce5e90dc5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "03584fde98790a7e63f8ca85b13f2405c35faeb9ebc3dd7e7bd6286ce6193785",
        "metadata": {},
        "name": "JiraBusinessCalendarEntrypointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ace6f66ce5e90dc5$export$2e2bcd8739ae039 = $ace6f66ce5e90dc5$var$node;

});

parcelRegister("9TBSc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gSbWh").then(()=>parcelRequire('AFwEY'));

});



parcelRegister("5ZNYc", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarEmbedRouteEntry", () => $ea2e7d70e18d88e4$export$d75a7b48d8838f92);

var $7K5Ea = parcelRequire("7K5Ea");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $hRRyN = parcelRequire("hRRyN");

var $g8uYY = parcelRequire("g8uYY");

var $aJSoj = parcelRequire("aJSoj");
const $ea2e7d70e18d88e4$var$calendarEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $aJSoj.calendarEntryPoint)
});
const $ea2e7d70e18d88e4$export$d75a7b48d8838f92 = (0, $6xToB.createEntry)((0, $hRRyN.jiraBusinessCalendarEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $ea2e7d70e18d88e4$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: (0, $kRv8K.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-calendar-entries/src/jiraBusinessCalendarEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessCalendarEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hRRyN", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarEmbedRoute", () => $fdebf02151d3a6e5$export$71a801c267234959);
const $fdebf02151d3a6e5$export$71a801c267234959 = {
    name: 'classic-business-calendar-embed',
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};

});


parcelRegister("hPiSX", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarRouteEntry", () => $9cffa112dd43b0a5$export$b8f4785659c5349e);

var $3MgfG = parcelRequire("3MgfG");

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $lxEqj = parcelRequire("lxEqj");

var $g8uYY = parcelRequire("g8uYY");

var $aJSoj = parcelRequire("aJSoj");

var $9n5I0 = parcelRequire("9n5I0");
const $9cffa112dd43b0a5$var$calendarPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aJSoj.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $9cffa112dd43b0a5$export$b8f4785659c5349e = (0, $6xToB.createEntry)((0, $lxEqj.jiraBusinessCalendarRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-view',
        entryPoint () {
            return $9cffa112dd43b0a5$var$calendarPageEntrypoint;
        },
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-calendar-entries/src/jiraBusinessCalendarRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lxEqj", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessCalendarRoute", () => $f6caa0a33eb55e2b$export$3f1924073260dde6);
const $f6caa0a33eb55e2b$export$3f1924073260dde6 = {
    name: 'classic-business-calendar',
    path: '/jira/core/projects/:projectKey/calendar/:itemId?',
    exact: true
};

});


parcelRegister("5JYqa", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListCustomEmbedRouteEntry", () => $e0655816f8b3f8da$export$e48bc622b980eb9a);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $4cTDP = parcelRequire("4cTDP");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $d5Xmj = parcelRequire("d5Xmj");

var $6NcRg = parcelRequire("6NcRg");


var $d4NVH = parcelRequire("d4NVH");

var $hFWLB = parcelRequire("hFWLB");

var $fYGKn = parcelRequire("fYGKn");

var $bQFhw = parcelRequire("bQFhw");
const $e0655816f8b3f8da$var$listEmbedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6NcRg.listEmbedEntryPoint)
});
const $e0655816f8b3f8da$export$e48bc622b980eb9a = (0, $6xToB.createEntry)((0, $d5Xmj.jiraBusinessListCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'jwm-list-custom-nin-embed' : 'jwm.list-embed-view',
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorEmbedPageEntryPoint;
            return $e0655816f8b3f8da$var$listEmbedPageEntryPoint;
        },
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : (0, $kRv8K.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-list-entries/src/jiraBusinessListCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessListCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("d5Xmj", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListCustomEmbedRoute", () => $6d5399012f5ad5e4$export$3bcc972f482cc0bd);
const $6d5399012f5ad5e4$export$3bcc972f482cc0bd = {
    name: 'classic-business-list-custom-embed',
    path: '/jira/core/projects/:projectKey/list/:navigationItemId/embed',
    exact: true
};

});

parcelRegister("6NcRg", function(module, exports) {
$parcel$export(module.exports, "listEmbedEntryPoint", () => $e6c67193850e83b5$export$519bb55e1612f243);

var $37SCz = parcelRequire("37SCz");

var $48vAp = parcelRequire("48vAp");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $e6c67193850e83b5$var$FORMAT_RULES_FIRST = 20;

const $e6c67193850e83b5$export$519bb55e1612f243 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("fzNox")), {
        moduleId: "ace40bcc",
        moduleName: "JiraBusinessListEmbedApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $48vAp.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $37SCz.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $e6c67193850e83b5$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("37SCz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ce7b38b1433a5bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eeb3f5f0c7e4c5f597cdccf0d16f309b>>
 * @relayHash 675361bd8a0cbf4e577c3d4a64e58d93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09
const $5ce7b38b1433a5bf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09",
        "metadata": {},
        "name": "FormatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5ce7b38b1433a5bf$export$2e2bcd8739ae039 = $5ce7b38b1433a5bf$var$node;

});

parcelRegister("48vAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $7da5afaaadac0bf6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d03265939ab3d7411c3822a37aadeac6>>
 * @relayHash 1cb886365bb9c572de10198d6edd0748
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 065351ad3c4d218094c1e7f4071ae68aec98e6836ef7d2bc2e31a0b0382734e8
const $7da5afaaadac0bf6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "065351ad3c4d218094c1e7f4071ae68aec98e6836ef7d2bc2e31a0b0382734e8",
        "metadata": {},
        "name": "JiraBusinessListEmbedAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7da5afaaadac0bf6$export$2e2bcd8739ae039 = $7da5afaaadac0bf6$var$node;

});

parcelRegister("fzNox", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6aUfU").then(()=>parcelRequire('it8QE'));

});



parcelRegister("ljCsD", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListEmbedRouteEntry", () => $6a1767c82c2ebe4f$export$a6737d9a8c0f9d4f);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $4cTDP = parcelRequire("4cTDP");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jkZuG = parcelRequire("jkZuG");

var $6NcRg = parcelRequire("6NcRg");


var $d4NVH = parcelRequire("d4NVH");

var $hFWLB = parcelRequire("hFWLB");

var $fYGKn = parcelRequire("fYGKn");

var $bQFhw = parcelRequire("bQFhw");
const $6a1767c82c2ebe4f$var$listEmbedPageEntryPoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6NcRg.listEmbedEntryPoint)
});
const $6a1767c82c2ebe4f$export$a6737d9a8c0f9d4f = (0, $6xToB.createEntry)((0, $jkZuG.jiraBusinessListEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'jwm-list-nin-embed' : 'jwm.list-embed-view',
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorEmbedPageEntryPoint;
            return $6a1767c82c2ebe4f$var$listEmbedPageEntryPoint;
        },
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : (0, $kRv8K.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-list-entries/src/jiraBusinessListEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessListEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jkZuG", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListEmbedRoute", () => $9878e458870df13b$export$40306068630dfc2);
const $9878e458870df13b$export$40306068630dfc2 = {
    name: 'classic-business-list-embed',
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};

});


parcelRegister("lIqxK", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListRouteEntry", () => $47af72d9ac0051e7$export$9ef24aa950399eaf);

var $3MgfG = parcelRequire("3MgfG");

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $maEn8 = parcelRequire("maEn8");

var $iUCDP = parcelRequire("iUCDP");

var $9n5I0 = parcelRequire("9n5I0");

var $4cTDP = parcelRequire("4cTDP");


var $gwH93 = parcelRequire("gwH93");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");

var $bQFhw = parcelRequire("bQFhw");
const $47af72d9ac0051e7$var$listPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iUCDP.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $47af72d9ac0051e7$export$9ef24aa950399eaf = (0, $6xToB.createEntry)((0, $maEn8.jiraBusinessListRoute), ()=>({
        group: 'classic-business',
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'jwm-list-nin' : 'jwm.list-view',
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $gwH93.ProjectIssueNavigatorSkeleton) : (0, $kNM5Y.ThemedLazySkeleton),
        entryPoint: ()=>(0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $fYGKn.issueNavigatorPageEntryPoint) : $47af72d9ac0051e7$var$listPageEntryPoint,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : (0, $kRv8K.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-list-entries/src/jiraBusinessListRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessListRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $4cTDP.fg)('nin-full-page-hydrate-root') : false
    }));

});
parcelRegister("maEn8", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessListRoute", () => $ccb2ae16fec1261e$export$ea171f7670960cff);
const $ccb2ae16fec1261e$export$ea171f7670960cff = {
    name: 'classic-business-list',
    path: '/jira/core/projects/:projectKey/list/:navigationItemId?',
    exact: true
};

});

parcelRegister("iUCDP", function(module, exports) {
$parcel$export(module.exports, "listEntryPoint", () => $565b926a73689f90$export$6be4f10150ff6073);

var $37SCz = parcelRequire("37SCz");

var $3uTg1 = parcelRequire("3uTg1");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $565b926a73689f90$var$FORMAT_RULES_FIRST = 20;

const $565b926a73689f90$export$6be4f10150ff6073 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("l0OlZ")), {
        moduleId: "8948df69",
        moduleName: "JiraBusinessListApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3uTg1.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $37SCz.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $565b926a73689f90$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("3uTg1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ffd2ba602806b47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba779ef6b812cede154959a2e0f9172b>>
 * @relayHash 566ec581d7b46097a17ae532ccf2c747
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f596b0f9584438b830afd4ec08afdf07c7a8023da440d893cd0bf35b6e0f2caa
const $4ffd2ba602806b47$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f596b0f9584438b830afd4ec08afdf07c7a8023da440d893cd0bf35b6e0f2caa",
        "metadata": {},
        "name": "JiraBusinessListAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4ffd2ba602806b47$export$2e2bcd8739ae039 = $4ffd2ba602806b47$var$node;

});

parcelRegister("l0OlZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f3U59").then(()=>parcelRequire('fIQox'));

});



parcelRegister("2Q6z2", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessOverviewRedirectRouteEntry", () => $2b4aa3d4305a47d5$export$3aa9116f715693e1);

var $kHlOR = parcelRequire("kHlOR");

var $gYW18 = parcelRequire("gYW18");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $27BUY = parcelRequire("27BUY");

var $kpZMy = parcelRequire("kpZMy");
const $2b4aa3d4305a47d5$export$3aa9116f715693e1 = (0, $6xToB.createEntry)((0, $27BUY.jiraBusinessOverviewRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $kpZMy.default),
        layout: (0, $9eXLI.businessProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $gYW18.AsyncHorizontalOverviewNav)
        },
        resources: (0, $kRv8K.getOverviewViewResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-redirect-entries/src/jiraBusinessOverviewRedirectRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessOverviewRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("27BUY", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $f757b15bc23ad42c$export$5ab0e07528c31349);
const $f757b15bc23ad42c$export$5ab0e07528c31349 = {
    name: 'classic-business-overview-redirect',
    path: '/jira/core/overviews/:overviewId',
    exact: true
};

});

parcelRegister("kpZMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ab828ee58da7410$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $2FqDG = parcelRequire("2FqDG");
const $0ab828ee58da7410$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $2FqDG.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $0ab828ee58da7410$export$2e2bcd8739ae039 = $0ab828ee58da7410$var$OverviewRedirect;

});


parcelRegister("c0nCS", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", () => $184f703c83207ef4$export$766e305da4c78de5);

var $kHlOR = parcelRequire("kHlOR");

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $1xlYL = parcelRequire("1xlYL");

var $hoV2u = parcelRequire("hoV2u");
const $184f703c83207ef4$export$766e305da4c78de5 = (0, $6xToB.createEntry)((0, $1xlYL.jiraBusinessProjectRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $9eXLI.businessProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-redirect-entries/src/jiraBusinessProjectRedirectRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessProjectRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("1U37F", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessReportsOverviewRouteEntry", () => $2dbc28f707f1b70a$export$2cde310731fa9055);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $2T0cn = parcelRequire("2T0cn");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $lvjEc = parcelRequire("lvjEc");
const $2dbc28f707f1b70a$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $2dbc28f707f1b70a$export$2cde310731fa9055 = (0, $6xToB.createEntry)((0, $2T0cn.jiraBusinessReportsOverviewRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-overview',
        entryPoint () {
            return $2dbc28f707f1b70a$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-reports-entries/src/jiraBusinessReportsOverviewRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessReportsOverviewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2T0cn", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessReportsOverviewRoute", () => $d42d8f4ced936b9c$export$5881ca008f82b9d8);
const $d42d8f4ced936b9c$export$5881ca008f82b9d8 = {
    name: 'classic-business-reports-overview',
    path: '/jira/core/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("lvjEc", function(module, exports) {
$parcel$export(module.exports, "reportsOverviewPageEntryPoint", () => $6dda353dfc5c9434$export$9dfa968d9e20b359);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $7LwBf = parcelRequire("7LwBf");

var $4cTDP = parcelRequire("4cTDP");

const $6dda353dfc5c9434$export$9dfa968d9e20b359 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bg6IS")).then((mod)=>mod.ReportsOverviewPage), {
        moduleId: "b8514977",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
        const projectKey = context.match.params.projectKey ? String(context.match.params.projectKey) : null;
        const isBoardContext = !!boardId;
        const isProjectContext = !!projectKey;
        const cloudId = tenantContext.cloudId;
        return {
            queries: {
                reportsOverviewPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7LwBf.default,
                    variables: {
                        boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
                        projectKey: !isBoardContext && isProjectContext ? projectKey : '',
                        cloudId: cloudId,
                        isBoardContext: isBoardContext,
                        isMigrateTMPReportsOverviewEnabled: (0, $4cTDP.fg)('uxissue_545_migrate_tmp_reports_overview_page')
                    }
                }
            }
        };
    }
});

});
parcelRegister("7LwBf", function(module, exports) {
$parcel$export(module.exports, "default", () => $236fe7b79542d01c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e39573fc901b2f3156bc9fa49e7618c5>>
 * @relayHash 312509cf7e8f094ab955bd36ba4a696c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcd3ceda0cefadd2528f9083f937b5d035dc8acc69d37b619095d620aefe7741
const $236fe7b79542d01c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isBoardContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isMigrateTMPReportsOverviewEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "concreteType": "JiraReportCategoryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraReportCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "concreteType": "JiraReportConnection",
                        "kind": "LinkedField",
                        "name": "reports",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraReportConnectionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraReport",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "imageUrl"
                                            },
                                            {
                                                "condition": "isMigrateTMPReportsOverviewEnabled",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isNotApplicableReason"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isNotApplicableDesc"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            },
                                            v10 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v10 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "reportCategories_reportsOverviewPage"
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jira_projectByIdOrKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira_projectByIdOrKey.projectType"
                                    },
                                    v7 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira_projectByIdOrKey"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraReportCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "reportCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReportCategoryConnection",
                                                    "kind": "LinkedField",
                                                    "name": "reportCategories",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v10 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bcd3ceda0cefadd2528f9083f937b5d035dc8acc69d37b619095d620aefe7741",
            "metadata": {},
            "name": "srcReportsOverviewPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$236fe7b79542d01c$var$node.hash = "b69379ed19aa80a3eda2dc5fab58cbe9";
var $236fe7b79542d01c$export$2e2bcd8739ae039 = $236fe7b79542d01c$var$node;

});

parcelRegister("bg6IS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1b2Xc").then(()=>parcelRequire('b5voN'));

});



parcelRegister("3ZA2n", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryEmbedRouteEntry", () => $fb888a6e77e9fdf9$export$2c37f93832ff9919);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jDHf0 = parcelRequire("jDHf0");

var $aGXnR = parcelRequire("aGXnR");

var $7lao1 = parcelRequire("7lao1");

var $4cTDP = parcelRequire("4cTDP");
const $fb888a6e77e9fdf9$var$summaryEmbedBusimessPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7lao1.summaryBusinessEmbedEntrypoint)
});
const $fb888a6e77e9fdf9$var$getSummaryPageResource = ()=>{
    return [
        ...(0, $4cTDP.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $jDHf0.activityFeedResource)
        ]
    ];
};
const $fb888a6e77e9fdf9$export$2c37f93832ff9919 = (0, $6xToB.createEntry)((0, $aGXnR.jiraBusinessSummaryEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            ...$fb888a6e77e9fdf9$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            return $fb888a6e77e9fdf9$var$summaryEmbedBusimessPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-summary-entries/src/jiraBusinessSummaryEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessSummaryEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jDHf0", function(module, exports) {
$parcel$export(module.exports, "activityFeedResource", () => $e8f412e2783ab0c0$export$928ea152e5c5de54);

var $eOsKQ = parcelRequire("eOsKQ");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");
const $e8f412e2783ab0c0$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $e8f412e2783ab0c0$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $e8f412e2783ab0c0$export$928ea152e5c5de54 = (0, $l1VxS.createResource)({
    type: $e8f412e2783ab0c0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$e8f412e2783ab0c0$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $e8f412e2783ab0c0$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $eOsKQ.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $e8f412e2783ab0c0$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $eJrcF.useResource)($e8f412e2783ab0c0$export$928ea152e5c5de54);

});
parcelRegister("eOsKQ", function(module, exports) {
$parcel$export(module.exports, "fetchActivityFeed", () => $e8e2785d375e41cc$export$967c92ed76f908b6);

var $gRw8I = parcelRequire("gRw8I");

var $14RSn = parcelRequire("14RSn");

var $jrKJw = parcelRequire("jrKJw");
const $e8e2785d375e41cc$var$PAGE_SIZE = 10;
const $e8e2785d375e41cc$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $e8e2785d375e41cc$var$STREAM_PROVIDERS = 'thirdparty issues';
const $e8e2785d375e41cc$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $gRw8I.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $e8e2785d375e41cc$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $e8e2785d375e41cc$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $e8e2785d375e41cc$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $14RSn.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $jrKJw.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("jrKJw", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $2673472aead14945$export$3ceb62baab058c6b);
const $2673472aead14945$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("aGXnR", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryEmbedRoute", () => $d71cd7db20d0c836$export$d4aa7e677d381961);
const $d71cd7db20d0c836$export$d4aa7e677d381961 = {
    name: 'classic-business-summary-embed',
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};

});

parcelRegister("7lao1", function(module, exports) {
$parcel$export(module.exports, "summaryBusinessEmbedEntrypoint", () => $5ece2cbaafb216d6$export$a027511631595373);

var $dSEJJ = parcelRequire("dSEJJ");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $5ece2cbaafb216d6$export$a027511631595373 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("1Gg0J")), {
        moduleId: "bfeee3c2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dSEJJ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("dSEJJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5c9f1f77e701cc7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2161716a6a9ddd596df65d397a277cb5>>
 * @relayHash 4f557a85d513d521d9088e7217fed3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763
const $f5c9f1f77e701cc7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763",
        "metadata": {},
        "name": "src_jiraSummaryBusinessEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f5c9f1f77e701cc7$export$2e2bcd8739ae039 = $f5c9f1f77e701cc7$var$node;

});

parcelRegister("1Gg0J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("4tVqv")
]).then(()=>parcelRequire('ib7sZ'));

});



parcelRegister("ghxYA", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryRouteEntry", () => $d82905b20b85bd68$export$66365c0c5e8430d2);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $jDHf0 = parcelRequire("jDHf0");

var $xoHZX = parcelRequire("xoHZX");

var $5fwSH = parcelRequire("5fwSH");

var $9n5I0 = parcelRequire("9n5I0");

var $4cTDP = parcelRequire("4cTDP");
const $d82905b20b85bd68$var$summaryBusinessPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5fwSH.summaryBusinessEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $d82905b20b85bd68$var$getSummaryPageResource = ()=>{
    return [
        ...(0, $4cTDP.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $jDHf0.activityFeedResource)
        ]
    ];
};
const $d82905b20b85bd68$export$66365c0c5e8430d2 = (0, $6xToB.createEntry)((0, $xoHZX.jiraBusinessSummaryRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $kRv8K.getProjectViewResources)(),
            ...$d82905b20b85bd68$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            return $d82905b20b85bd68$var$summaryBusinessPageEntrypoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-summary-entries/src/jiraBusinessSummaryRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("xoHZX", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessSummaryRoute", () => $f98c60dd3a974656$export$ad0ce411d14c71d7);
const $f98c60dd3a974656$export$ad0ce411d14c71d7 = {
    name: 'classic-business-summary',
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};

});

parcelRegister("5fwSH", function(module, exports) {
$parcel$export(module.exports, "summaryBusinessEntrypoint", () => $ea4dc8c9f01f8047$export$1655de4ea7d4bb73);

var $fN78K = parcelRequire("fN78K");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $ea4dc8c9f01f8047$export$1655de4ea7d4bb73 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("15B4i")), {
        moduleId: "e788cf2e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $fN78K.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("fN78K", function(module, exports) {
$parcel$export(module.exports, "default", () => $17b42e5297ed2898$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e999f38de92db02cb900ff3e39b1c9b5>>
 * @relayHash e1db5ab6de3c01b21716a8934a36cc9b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055
const $17b42e5297ed2898$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055",
        "metadata": {},
        "name": "src_jiraSummaryBusinessQuery",
        "operationKind": "query",
        "text": null
    }
};
var $17b42e5297ed2898$export$2e2bcd8739ae039 = $17b42e5297ed2898$var$node;

});

parcelRegister("15B4i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("dsYRV")
]).then(()=>parcelRequire('j9j0S'));

});



parcelRegister("bMvJs", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineEmbedRouteEntry", () => $0294bda49e4b203b$export$ef65a62ced1a9df1);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $4cTDP = parcelRequire("4cTDP");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $3f2WR = parcelRequire("3f2WR");

var $egdw2 = parcelRequire("egdw2");

var $6mHOv = parcelRequire("6mHOv");
const $0294bda49e4b203b$var$timelineEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6mHOv.timelineEntrypoint)
});
const $0294bda49e4b203b$var$legacyimelineEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $egdw2.timelineEmbedEntrypoint)
});
const $0294bda49e4b203b$export$ef65a62ced1a9df1 = (0, $6xToB.createEntry)((0, $3f2WR.jiraBusinessTimelineEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $7K5Ea.chromelessLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('jira_harmonised_business_timeline_embed') && (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_merged_column_gate') && (0, $4cTDP.fg)('jira_timeline_disable_child_inline_editing') ? $0294bda49e4b203b$var$timelineEmbedPageEntrypoint : $0294bda49e4b203b$var$legacyimelineEmbedPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-timeline-entries/src/jiraBusinessTimelineEmbedRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessTimelineEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3f2WR", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineEmbedRoute", () => $03a3fd655997b506$export$d85fbccfa0ba559a);
const $03a3fd655997b506$export$d85fbccfa0ba559a = {
    name: 'classic-business-timeline-embed',
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};

});

parcelRegister("egdw2", function(module, exports) {
$parcel$export(module.exports, "timelineEmbedEntrypoint", () => $d861558f24426713$export$12a9d017aa53985f);

var $bpttI = parcelRequire("bpttI");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $d861558f24426713$export$12a9d017aa53985f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("9TAZa")), {
        moduleId: "88bc99ab",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bpttI.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("bpttI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1628df2ccefacae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c25e21ec05fd2b676e0b39f50f317308>>
 * @relayHash aaa779177ef49e606102f9e257279c2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c
const $f1628df2ccefacae$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c",
        "metadata": {},
        "name": "src_jiraBusinessTimelineEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f1628df2ccefacae$export$2e2bcd8739ae039 = $f1628df2ccefacae$var$node;

});

parcelRegister("9TAZa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("st495")
]).then(()=>parcelRequire('fDHwb'));

});


parcelRegister("6mHOv", function(module, exports) {
$parcel$export(module.exports, "timelineEntrypoint", () => $f5be1f5b0393c2c3$export$7586afa83216512a);

var $4cTDP = parcelRequire("4cTDP");

var $P5lF7 = parcelRequire("P5lF7");

var $fCagM = parcelRequire("fCagM");

var $3hRxq = parcelRequire("3hRxq");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $cxKOj = parcelRequire("cxKOj");
const $f5be1f5b0393c2c3$var$store = typeof window !== 'undefined' ? (0, $3hRxq.createLocalStorageProvider)('jwm-view-preferences') : undefined;
const $f5be1f5b0393c2c3$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $f5be1f5b0393c2c3$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $f5be1f5b0393c2c3$var$getSearchTextJql = (text)=>{
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const issueKeyRegex = new RegExp('^([A-Z][A-Z0-9_]+-\\d+)$');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $f5be1f5b0393c2c3$var$buildJql = (filter = '', text = '', projectKey = '')=>{
    const search = $f5be1f5b0393c2c3$var$getSearchTextJql(text);
    const project = $f5be1f5b0393c2c3$var$getProjectJql(projectKey);
    return `${$f5be1f5b0393c2c3$var$and([
        search,
        filter,
        project
    ])} ORDER BY rank ASC`;
};
// should be equivalent to the getToday function in jira/src/packages/software/roadmap/utils/src/utils/dates.tsx
const $f5be1f5b0393c2c3$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};
const $f5be1f5b0393c2c3$var$parseQueryParamValue = (str)=>{
    try {
        return str ? JSON.parse(str) : undefined;
    } catch (e) {
    // Do nothing - ignore invalid values
    }
};
const $f5be1f5b0393c2c3$var$toStaticViewInput = (settings)=>{
    return {
        isGroupingEnabled: !!settings.groupBy,
        isHideDoneEnabled: settings.hideDone,
        isHierarchyEnabled: settings.hierarchyEnabled
    };
};
const $f5be1f5b0393c2c3$var$getFilterPreference = (entityId, preferenceId = 'filter')=>{
    if (entityId === undefined) return '';
    const key = `${entityId}_timeline_${preferenceId}`;
    return $f5be1f5b0393c2c3$var$store?.get(key);
};
const $f5be1f5b0393c2c3$var$getHideDonePreference = (entityId, preferenceId = 'hideDone')=>{
    if (entityId === undefined) return undefined;
    const key = `${entityId}_timeline_${preferenceId}`;
    const value = $f5be1f5b0393c2c3$var$store?.get(key);
    // We only save the value in local storage if it's true, so we can ignore
    // anything else
    return value === 'true' || undefined;
};
const $f5be1f5b0393c2c3$var$getProjectId = (projectKey)=>{
    const key = 'timeline_project-mapping-preference';
    const projectMapping = $f5be1f5b0393c2c3$var$store?.get(key) ?? {};
    const projectId = projectMapping[projectKey];
    return projectId?.toString() ?? '';
};

const $f5be1f5b0393c2c3$export$7586afa83216512a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("fmUI5")), {
        moduleId: "ea9f2eb3",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const namespace = 'TIMELINE';
        const projectKey = context.match.params.projectKey;
        const { filter: queryFilter, hideDone: hideDone, text: text } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const projectId = $f5be1f5b0393c2c3$var$getProjectId(projectKey);
        const storageFilter = $f5be1f5b0393c2c3$var$getFilterPreference(projectId);
        const filter = queryFilter || storageFilter;
        const storageHideDone = (0, $4cTDP.fg)('jira_timeline_move_preferences_into_local_storage') ? $f5be1f5b0393c2c3$var$getHideDonePreference(projectId) : undefined;
        const prevFieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'timeline'
        ];
        // TODO hardcoded fieldsetIds will be replaced with fieldSets from BE
        const newFieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'assignee',
            'status',
            'timeline'
        ];
        const fieldSetIds = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? newFieldSetIds : prevFieldSetIds;
        const scope = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? {
            operationScope: 'TIMELINE_PROJECT',
            projectKey: projectKey
        } : undefined;
        const jql = $f5be1f5b0393c2c3$var$buildJql(filter, text, projectKey);
        const settings = {
            groupBy: null,
            hideDone: $f5be1f5b0393c2c3$var$parseQueryParamValue(hideDone) ?? storageHideDone,
            hierarchyEnabled: true,
            jql: jql
        };
        // JiraIssueSearchSettings will replace JiraIssueSearchStaticViewInput
        // as part of the saved views project, so we'll use it as the source of
        // truth
        const staticViewInput = $f5be1f5b0393c2c3$var$toStaticViewInput(settings);
        return {
            extraProps: {
                today: $f5be1f5b0393c2c3$var$getToday(),
                isTimelineHarmonisationM2Enabled: (0, $cxKOj.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false)
            },
            queries: {
                businessTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $P5lF7.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $fCagM.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: {
                            fieldSetIds: fieldSetIds
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: {
                            jql: jql
                        },
                        namespace: namespace,
                        projectKey: projectKey,
                        settings: settings,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: true,
                        scope: scope,
                        staticViewInput: staticViewInput,
                        viewConfigInput: {
                            staticViewInput: staticViewInput
                        },
                        viewQueryInput: {
                            projectKeyAndItemIdQuery: {
                                cloudId: cloudId,
                                projectKey: projectKey,
                                itemId: 'timeline'
                            }
                        },
                        viewId: (0, $4cTDP.fg)('jira_timeline_graphql_view_type') ? 'timeline_default' : 'list_default',
                        isInlineEditingEnabled: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')
                    }
                }
            }
        };
    }
});

});
parcelRegister("P5lF7", function(module, exports) {
$parcel$export(module.exports, "default", () => $80bbd0ac55c726fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<951467f217b7b80c29447f75caa0a085>>
 * @relayHash abf98366ae34ffd1f8b11a9f6e296e42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe89a0048379d250f0d0d63fea37ec5e51eabf66a8cd926fb797e653f452a422
const $80bbd0ac55c726fa$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fe89a0048379d250f0d0d63fea37ec5e51eabf66a8cd926fb797e653f452a422",
        "metadata": {},
        "name": "src_jiraHarmonisedBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $80bbd0ac55c726fa$export$2e2bcd8739ae039 = $80bbd0ac55c726fa$var$node;

});

parcelRegister("fCagM", function(module, exports) {
$parcel$export(module.exports, "default", () => $223f6fc754a85a37$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d842622ad70507a1e32fa5bddbbb886>>
 * @relayHash b3e243b4a4a41c2ccc368319c0f0ebba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 509a1972c905568430b8fb9f0cd6c273b9a3a78c9c93e576dfba284c1f34a2b8

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $alrjx = parcelRequire("alrjx");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $b455s = parcelRequire("b455s");

var $8q9Kv = parcelRequire("8q9Kv");

var $8Qoc7 = parcelRequire("8Qoc7");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");

var $aNXuv = parcelRequire("aNXuv");
const $223f6fc754a85a37$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "509a1972c905568430b8fb9f0cd6c273b9a3a78c9c93e576dfba284c1f34a2b8",
        "metadata": {},
        "name": "src_timelineQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrctimelinestickyassigneestatuscolumnrelayprovider": (0, $aNXuv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $alrjx.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinegraphqlviewtyperelayprovider": (0, $b455s.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinejpdroadmaprecommendationrelayprovider": (0, $8q9Kv.default)
        }
    }
};
var $223f6fc754a85a37$export$2e2bcd8739ae039 = $223f6fc754a85a37$var$node;

});
parcelRegister("b455s", function(module, exports) {
$parcel$export(module.exports, "default", () => $422f591df180b26b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $422f591df180b26b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira_timeline_graphql_view_type');
    }
};

});

parcelRegister("8q9Kv", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa893845a295b359$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $fa893845a295b359$var$JiraTimelineJpdRoadmapRecommendationRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jira_timeline_jpd_roadmap_recommendation');
    }
};
var $fa893845a295b359$export$2e2bcd8739ae039 = $fa893845a295b359$var$JiraTimelineJpdRoadmapRecommendationRelayProvider;

});

parcelRegister("aNXuv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4feb3cd20955d967$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $4feb3cd20955d967$var$TimelineStickyAssigneeStatusColumnRelayProvider = {
    get () {
        return (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns');
    }
};
var $4feb3cd20955d967$export$2e2bcd8739ae039 = $4feb3cd20955d967$var$TimelineStickyAssigneeStatusColumnRelayProvider;

});


parcelRegister("fmUI5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("lNPLy")
]).then(()=>parcelRequire('6Lijq'));

});



parcelRegister("ffcU3", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineRouteEntry", () => $03a43808b6d91c8a$export$5725375da49b5772);

var $hS1gr = parcelRequire("hS1gr");

var $9eXLI = parcelRequire("9eXLI");

var $g8uYY = parcelRequire("g8uYY");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $hiOwQ = parcelRequire("hiOwQ");

var $kNM5Y = parcelRequire("kNM5Y");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9jvLx = parcelRequire("9jvLx");

var $1J9Ft = parcelRequire("1J9Ft");

var $6mHOv = parcelRequire("6mHOv");

var $9n5I0 = parcelRequire("9n5I0");
const $03a43808b6d91c8a$var$timelinePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6mHOv.timelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $03a43808b6d91c8a$var$legacyTimelinePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1J9Ft.timelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $03a43808b6d91c8a$export$5725375da49b5772 = (0, $6xToB.createEntry)((0, $9jvLx.jiraBusinessTimelineRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-view',
        layout: (0, $9eXLI.businessProjectLayout),
        skeleton: (0, $kNM5Y.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira)
        },
        resources: (0, $kRv8K.getProjectViewResources)(),
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') && (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_merged_column_gate') && (0, $4cTDP.fg)('jira_timeline_disable_child_inline_editing') && (0, $cxKOj.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $03a43808b6d91c8a$var$timelinePageEntrypoint : $03a43808b6d91c8a$var$legacyTimelinePageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-business-timeline-entries/src/jiraBusinessTimelineRouteEntry.tsx',
                whichExportToUse: 'jiraBusinessTimelineRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9jvLx", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessTimelineRoute", () => $22d0d54ffe950fa8$export$4c71cfbf61bf0bf3);
const $22d0d54ffe950fa8$export$4c71cfbf61bf0bf3 = {
    name: 'classic-business-timeline',
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};

});

parcelRegister("1J9Ft", function(module, exports) {
$parcel$export(module.exports, "timelineEntrypoint", () => $bdeab538ab55ab83$export$7586afa83216512a);

var $f5Ive = parcelRequire("f5Ive");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $bdeab538ab55ab83$export$7586afa83216512a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("7KQq5")), {
        moduleId: "cac371d1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $f5Ive.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("f5Ive", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5bec15de29074ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec0d5db49437667573ca835bd84e9756>>
 * @relayHash 841436c7487840af84c959f83e5a4493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1
const $d5bec15de29074ce$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1",
        "metadata": {},
        "name": "src_jiraBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d5bec15de29074ce$export$2e2bcd8739ae039 = $d5bec15de29074ce$var$node;

});

parcelRegister("7KQq5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("dSZ60")
]).then(()=>parcelRequire('bsJdy'));

});



parcelRegister("eWBMh", function(module, exports) {
$parcel$export(module.exports, "jiraHomeRouteEntry", () => $1c1cfc9939ff8808$export$578dcb61ac3cb57a);

var $eJOHy = parcelRequire("eJOHy");

var $hIzUD = parcelRequire("hIzUD");

var $dDHhl = parcelRequire("dDHhl");

var $kHlOR = parcelRequire("kHlOR");

var $dI30d = parcelRequire("dI30d");

var $4cTDP = parcelRequire("4cTDP");

var $4ZkZK = parcelRequire("4ZkZK");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");


var $4VIcO = parcelRequire("4VIcO");

var $iDAU4 = parcelRequire("iDAU4");

var $80Ye8 = parcelRequire("80Ye8");

var $9NmsS = parcelRequire("9NmsS");

var $iIQmy = parcelRequire("iIQmy");

var $5fjzQ = parcelRequire("5fjzQ");

var $5L7qx = parcelRequire("5L7qx");

var $5gjY4 = parcelRequire("5gjY4");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $cxKOj = parcelRequire("cxKOj");

var $2emAF = parcelRequire("2emAF");

var $giQoM = parcelRequire("giQoM");

var $jnds2 = parcelRequire("jnds2");
const $1c1cfc9939ff8808$var$conditionalPostOfficeJiraYourWorkResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5fjzQ.postOfficeJiraYourWorkResource));
const $1c1cfc9939ff8808$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $cxKOj.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $80Ye8.jiraHomeWorkSuggestionsIsDeveloperResource));

const $1c1cfc9939ff8808$var$LazyJiraHomePage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5oURf"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $1c1cfc9939ff8808$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dI30d.checkShouldUseJSM)(data);
};
const $1c1cfc9939ff8808$var$JiraHomeComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1c1cfc9939ff8808$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $1c1cfc9939ff8808$export$578dcb61ac3cb57a = (0, $6xToB.createEntry)((0, $iIQmy.jiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: $1c1cfc9939ff8808$var$JiraHomeComponent,
        skeleton: (0, $5gjY4.YourWorkSkeleton),
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $iDAU4.jiraHomeResourceWithCache),
            (0, $4ZkZK.jiraHomePageRightSidePanelResource),
            $1c1cfc9939ff8808$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $hIzUD.widgetResources).map((resourceCreator)=>resourceCreator($1c1cfc9939ff8808$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ])),
            ...(0, $dDHhl.widgetResources).map((resourceCreator)=>resourceCreator($1c1cfc9939ff8808$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ])),
            $1c1cfc9939ff8808$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource,
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_portal_widget'), (0, $giQoM.fetchSiteUserTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_portal_widget'), (0, $2emAF.fetchSiteTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_portal_widget'), (0, $jnds2.widgetDismissedStateResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $1c1cfc9939ff8808$var$LazyJiraHomePage
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-jira-home-entries/src/jiraHomeRouteEntry.tsx',
                whichExportToUse: 'jiraHomeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hIzUD", function(module, exports) {
$parcel$export(module.exports, "myTeamsResource", () => $da18702ccc6f80a4$export$602f373f7fdaccc1);
$parcel$export(module.exports, "statusResource", () => $da18702ccc6f80a4$export$8f57164cc67fb360);
$parcel$export(module.exports, "userTimelineResource", () => $da18702ccc6f80a4$export$35b906dc2329cdc6);
$parcel$export(module.exports, "schedulesResource", () => $da18702ccc6f80a4$export$f9574b51fbc36dc3);
$parcel$export(module.exports, "resources", () => $da18702ccc6f80a4$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $da18702ccc6f80a4$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("fNzE7")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("bPF5G")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("gXKS0")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("8MqR1")).createSchedulesResource);
parcelRequire("1DrRY");
var $igkn1 = parcelRequire("igkn1");

var $fNzE7 = parcelRequire("fNzE7");

var $bZqCz = parcelRequire("bZqCz");

var $8MqR1 = parcelRequire("8MqR1");

var $bPF5G = parcelRequire("bPF5G");

var $gXKS0 = parcelRequire("gXKS0");
const $da18702ccc6f80a4$export$602f373f7fdaccc1 = (0, $fNzE7.createMyTeamsResource)();
const $da18702ccc6f80a4$export$f363fac02afee7a4 = (0, $bZqCz.createOpsTeamsResource)();
const $da18702ccc6f80a4$export$8f57164cc67fb360 = (0, $bPF5G.createStatusResource)();
const $da18702ccc6f80a4$export$35b906dc2329cdc6 = (0, $gXKS0.createUserTimelineResource)();
const $da18702ccc6f80a4$export$f9574b51fbc36dc3 = (0, $8MqR1.createSchedulesResource)();
const $da18702ccc6f80a4$export$bc99aaabaf7b70a7 = [
    (0, $igkn1.eocUserResource),
    (0, $fNzE7.createMyTeamsResource)(),
    (0, $bPF5G.createStatusResource)(),
    (0, $bZqCz.createOpsTeamsResource)()
];
const $da18702ccc6f80a4$export$bce3244764eac6e6 = [
    ()=>(0, $igkn1.eocUserResource),
    (callback, depends)=>(0, $fNzE7.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $bPF5G.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $gXKS0.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $8MqR1.createSchedulesResource)(callback, depends)
];

});
parcelRegister("fNzE7", function(module, exports) {
$parcel$export(module.exports, "createMyTeamsResource", () => $27d1bed64c4a852a$export$bf86fb90d0661bcb);

var $l1VxS = parcelRequire("l1VxS");

var $l7fr8 = parcelRequire("l7fr8");
const $27d1bed64c4a852a$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $l7fr8.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("l7fr8", function(module, exports) {
$parcel$export(module.exports, "getMyTeamsEndpoint", () => $a743bbcc3a499c14$export$abe46da7d1f191a7);

var $9ppkU = parcelRequire("9ppkU");
const $a743bbcc3a499c14$export$abe46da7d1f191a7 = ()=>{
    return (0, $9ppkU.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("bZqCz", function(module, exports) {
$parcel$export(module.exports, "createOpsTeamsResource", () => $9597b9396d955383$export$99505a9d792f516c);

var $l1VxS = parcelRequire("l1VxS");

var $cgtgq = parcelRequire("cgtgq");
const $9597b9396d955383$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $cgtgq.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("cgtgq", function(module, exports) {
$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $d69342811ba99db1$export$7498ba30158c16cd);

var $9ppkU = parcelRequire("9ppkU");

var $1wXtI = parcelRequire("1wXtI");
const $d69342811ba99db1$export$7498ba30158c16cd = ()=>{
    return (0, $9ppkU.eocFetch)((0, $1wXtI.urls).teams.url());
};

});
parcelRegister("1wXtI", function(module, exports) {
$parcel$export(module.exports, "urls", () => $f83e5758ad24c7a0$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $f83e5758ad24c7a0$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $f83e5758ad24c7a0$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $f83e5758ad24c7a0$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $f83e5758ad24c7a0$export$d05bbb1ada0e07c4);
const $f83e5758ad24c7a0$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$f83e5758ad24c7a0$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $f83e5758ad24c7a0$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $f83e5758ad24c7a0$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $f83e5758ad24c7a0$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $f83e5758ad24c7a0$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("8MqR1", function(module, exports) {
$parcel$export(module.exports, "createSchedulesResource", () => $48431536849515bc$export$b5e65ca3f82b01c5);

var $l1VxS = parcelRequire("l1VxS");

var $erLz4 = parcelRequire("erLz4");
const $48431536849515bc$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $erLz4.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("erLz4", function(module, exports) {
$parcel$export(module.exports, "getSchedulesEndpoint", () => $7756e0afe9378e26$export$e8e940098db1b988);

var $9ppkU = parcelRequire("9ppkU");

var $1wXtI = parcelRequire("1wXtI");
const $7756e0afe9378e26$export$e8e940098db1b988 = ()=>{
    return (0, $9ppkU.eocFetch)(`${(0, $1wXtI.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("bPF5G", function(module, exports) {
$parcel$export(module.exports, "createStatusResource", () => $06498c370640148c$export$3d1c353e2693418c);

var $l1VxS = parcelRequire("l1VxS");

var $beG7g = parcelRequire("beG7g");

var $k79bM = parcelRequire("k79bM");
const $06498c370640148c$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $beG7g.getStatus)().then((0, $k79bM.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("beG7g", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $d8d98580f4214220$export$b70265791d2079d4);

var $9ppkU = parcelRequire("9ppkU");

var $1wXtI = parcelRequire("1wXtI");
const $d8d98580f4214220$export$b70265791d2079d4 = ()=>{
    return (0, $9ppkU.eocFetch)((0, $1wXtI.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("k79bM", function(module, exports) {
$parcel$export(module.exports, "transformStatusResponse", () => $12b283f686fbb217$export$44a749c89534e42c);
const $12b283f686fbb217$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("gXKS0", function(module, exports) {
$parcel$export(module.exports, "createUserTimelineResource", () => $078329fce3500a03$export$a479dcc35c33def1);

var $l1VxS = parcelRequire("l1VxS");
parcelRequire("1DrRY");
var $igkn1 = parcelRequire("igkn1");

var $cNbpA = parcelRequire("cNbpA");
const $078329fce3500a03$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $igkn1.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $cNbpA.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $igkn1.eocUserResource).type
        ]
    });

});
parcelRegister("cNbpA", function(module, exports) {
$parcel$export(module.exports, "getWidgetTimeline", () => $fbbd4357cd64a13c$export$bd80cae08a85b1f0);

var $ioECs = parcelRequire("ioECs");

var $9ppkU = parcelRequire("9ppkU");

var $1wXtI = parcelRequire("1wXtI");

var $fSHjN = parcelRequire("fSHjN");
const $fbbd4357cd64a13c$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $ioECs.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $9ppkU.eocFetch)(`${(0, $1wXtI.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $fSHjN.transformUserTimelineResponse));
};

});
parcelRegister("ioECs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d649fa0c728912ec$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $aou2D = parcelRequire("aou2D");

var $3uXsS = parcelRequire("3uXsS");
function $d649fa0c728912ec$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $aou2D.default)((0, $3uXsS.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("aou2D", function(module, exports) {
$parcel$export(module.exports, "default", () => $791372e79ec638ee$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $uteoc = parcelRequire("uteoc");

var $jnhYt = parcelRequire("jnhYt");
var $791372e79ec638ee$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $791372e79ec638ee$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($791372e79ec638ee$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $jnhYt.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $uteoc.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("uteoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $05b97a241eaaa004$export$2e2bcd8739ae039);

var $i6fVn = parcelRequire("i6fVn");

var $4rKo8 = parcelRequire("4rKo8");
var $05b97a241eaaa004$var$MILLISECONDS_IN_MINUTE = 60000;
var $05b97a241eaaa004$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $05b97a241eaaa004$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $05b97a241eaaa004$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $05b97a241eaaa004$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $05b97a241eaaa004$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $05b97a241eaaa004$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $05b97a241eaaa004$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $05b97a241eaaa004$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $05b97a241eaaa004$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $05b97a241eaaa004$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $05b97a241eaaa004$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $05b97a241eaaa004$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $i6fVn.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $i6fVn.default)('long', date, options);
        }
    }
};
function $05b97a241eaaa004$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $4rKo8.default)(timeZone, originalDate, true) / $05b97a241eaaa004$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $05b97a241eaaa004$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $05b97a241eaaa004$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $05b97a241eaaa004$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $05b97a241eaaa004$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $05b97a241eaaa004$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $05b97a241eaaa004$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $05b97a241eaaa004$var$formatTimezone(offset, dirtyDelimeter);
}
function $05b97a241eaaa004$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $05b97a241eaaa004$var$addLeadingZeros(minutes, 2);
}
var $05b97a241eaaa004$export$2e2bcd8739ae039 = $05b97a241eaaa004$var$formatters;

});
parcelRegister("i6fVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2d523ca7e835ddf$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $d2d523ca7e835ddf$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $d2d523ca7e835ddf$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $d2d523ca7e835ddf$var$partsTimeZone(dtf, date) : $d2d523ca7e835ddf$var$hackyTimeZone(dtf, date);
}
function $d2d523ca7e835ddf$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $d2d523ca7e835ddf$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $d2d523ca7e835ddf$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("4rKo8", function(module, exports) {
$parcel$export(module.exports, "default", () => $33cdaac6266836a2$export$2e2bcd8739ae039);

var $5GkHY = parcelRequire("5GkHY");

var $gZi9F = parcelRequire("gZi9F");
var $33cdaac6266836a2$var$MILLISECONDS_IN_HOUR = 3600000;
var $33cdaac6266836a2$var$MILLISECONDS_IN_MINUTE = 60000;
var $33cdaac6266836a2$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $33cdaac6266836a2$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $33cdaac6266836a2$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $33cdaac6266836a2$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$33cdaac6266836a2$var$validateTimezone(hours)) return NaN;
        return -(hours * $33cdaac6266836a2$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $33cdaac6266836a2$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$33cdaac6266836a2$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $33cdaac6266836a2$var$MILLISECONDS_IN_HOUR + minutes * $33cdaac6266836a2$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($33cdaac6266836a2$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $33cdaac6266836a2$var$toUtcDate(date);
        var offset = $33cdaac6266836a2$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $33cdaac6266836a2$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $33cdaac6266836a2$var$toUtcDate(date) {
    return (0, $gZi9F.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $33cdaac6266836a2$var$calcOffset(date, timezoneString) {
    var tokens = (0, $5GkHY.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $gZi9F.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $33cdaac6266836a2$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $33cdaac6266836a2$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $33cdaac6266836a2$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $33cdaac6266836a2$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $33cdaac6266836a2$var$validIANATimezoneCache = {};
function $33cdaac6266836a2$var$isValidTimezoneIANAString(timeZoneString) {
    if ($33cdaac6266836a2$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $33cdaac6266836a2$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("5GkHY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4230f03a0bfe831c$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $4230f03a0bfe831c$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $4230f03a0bfe831c$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $4230f03a0bfe831c$var$partsOffset(dtf, date) : $4230f03a0bfe831c$var$hackyOffset(dtf, date);
}
var $4230f03a0bfe831c$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $4230f03a0bfe831c$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $4230f03a0bfe831c$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $4230f03a0bfe831c$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $4230f03a0bfe831c$var$dtfCache = {};
function $4230f03a0bfe831c$var$getDateTimeFormat(timeZone) {
    if (!$4230f03a0bfe831c$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $4230f03a0bfe831c$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $4230f03a0bfe831c$var$dtfCache[timeZone];
}

});

parcelRegister("gZi9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5e06d0cb3c61622$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c5e06d0cb3c61622$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("jnhYt", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1ae1baa898b3b98$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $4rKo8 = parcelRequire("4rKo8");

var $iScBt = parcelRequire("iScBt");
var $e1ae1baa898b3b98$var$MILLISECONDS_IN_HOUR = 3600000;
var $e1ae1baa898b3b98$var$MILLISECONDS_IN_MINUTE = 60000;
var $e1ae1baa898b3b98$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $e1ae1baa898b3b98$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $iScBt.default)
};
function $e1ae1baa898b3b98$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $e1ae1baa898b3b98$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e1ae1baa898b3b98$var$splitDateString(argument);
    var parseYearResult = $e1ae1baa898b3b98$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $e1ae1baa898b3b98$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $e1ae1baa898b3b98$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $4rKo8.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $e1ae1baa898b3b98$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $e1ae1baa898b3b98$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $e1ae1baa898b3b98$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $e1ae1baa898b3b98$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e1ae1baa898b3b98$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $e1ae1baa898b3b98$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $e1ae1baa898b3b98$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $e1ae1baa898b3b98$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $e1ae1baa898b3b98$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $e1ae1baa898b3b98$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $e1ae1baa898b3b98$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$e1ae1baa898b3b98$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $e1ae1baa898b3b98$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$e1ae1baa898b3b98$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $e1ae1baa898b3b98$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$e1ae1baa898b3b98$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $e1ae1baa898b3b98$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$e1ae1baa898b3b98$var$validateWeekDate(year, week)) return new Date(NaN);
        return $e1ae1baa898b3b98$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $e1ae1baa898b3b98$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$e1ae1baa898b3b98$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e1ae1baa898b3b98$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $e1ae1baa898b3b98$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $e1ae1baa898b3b98$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$e1ae1baa898b3b98$var$validateTime(hours)) return NaN;
        return hours % 24 * $e1ae1baa898b3b98$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $e1ae1baa898b3b98$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$e1ae1baa898b3b98$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $e1ae1baa898b3b98$var$MILLISECONDS_IN_HOUR + minutes * $e1ae1baa898b3b98$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $e1ae1baa898b3b98$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$e1ae1baa898b3b98$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $e1ae1baa898b3b98$var$MILLISECONDS_IN_HOUR + minutes * $e1ae1baa898b3b98$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $e1ae1baa898b3b98$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $e1ae1baa898b3b98$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e1ae1baa898b3b98$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e1ae1baa898b3b98$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e1ae1baa898b3b98$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $e1ae1baa898b3b98$var$isLeapYearIndex(year);
        if (isLeapYear && date > $e1ae1baa898b3b98$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $e1ae1baa898b3b98$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $e1ae1baa898b3b98$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $e1ae1baa898b3b98$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $e1ae1baa898b3b98$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $e1ae1baa898b3b98$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("iScBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbd70be5f33a71bc$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $dbd70be5f33a71bc$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $dbd70be5f33a71bc$export$2e2bcd8739ae039 = $dbd70be5f33a71bc$var$tzPattern;

});



parcelRegister("3uXsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $28c24ced2e8dec3c$export$2e2bcd8739ae039);

var $4rKo8 = parcelRequire("4rKo8");

var $jnhYt = parcelRequire("jnhYt");
function $28c24ced2e8dec3c$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $jnhYt.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $4rKo8.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("fSHjN", function(module, exports) {
$parcel$export(module.exports, "transformUserTimelineResponse", () => $9b70168c53f99576$export$78049913b79774a2);

var $dpcZD = parcelRequire("dpcZD");
const $9b70168c53f99576$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $dpcZD.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("dpcZD", function(module, exports) {
$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $409fce60734bc558$export$9b0bac75f135bd57);
const $409fce60734bc558$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($409fce60734bc558$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $409fce60734bc558$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("dDHhl", function(module, exports) {
$parcel$export(module.exports, "openAlertsResource", () => $5d501a575f007e75$export$fb6d91a24bfaa074);
$parcel$export(module.exports, "ackedAlertsResource", () => $5d501a575f007e75$export$3917a9639b1be557);
$parcel$export(module.exports, "snoozedAlertsResource", () => $5d501a575f007e75$export$f62d237df457042d);
$parcel$export(module.exports, "widgetResources", () => $5d501a575f007e75$export$bce3244764eac6e6);

var $l1VxS = parcelRequire("l1VxS");

var $8sDwk = parcelRequire("8sDwk");

var $2njib = parcelRequire("2njib");
const $5d501a575f007e75$export$e5eb8aade1d4272a = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'openAlertsResource',
        getKey: ()=>'openAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $2njib.fetchAlerts)({
                searchParams: {
                    query: (0, $8sDwk.PredefinedQueries).MY_OPEN_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $5d501a575f007e75$export$66760ff81022525f = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'ackedAlertsResource',
        getKey: ()=>'ackedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $2njib.fetchAlerts)({
                searchParams: {
                    query: (0, $8sDwk.PredefinedQueries).MY_ACKED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $5d501a575f007e75$export$73c7fe1d8124595f = (checkConsolidationOnRouteDependency, depends)=>(0, $l1VxS.createResource)({
        type: 'snoozedAlertsResource',
        getKey: ()=>'snoozedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $2njib.fetchAlerts)({
                searchParams: {
                    query: (0, $8sDwk.PredefinedQueries).MY_SNOOZED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $5d501a575f007e75$export$fb6d91a24bfaa074 = $5d501a575f007e75$export$e5eb8aade1d4272a();
const $5d501a575f007e75$export$3917a9639b1be557 = $5d501a575f007e75$export$66760ff81022525f();
const $5d501a575f007e75$export$f62d237df457042d = $5d501a575f007e75$export$73c7fe1d8124595f();
const $5d501a575f007e75$export$bce3244764eac6e6 = [
    (callback, depends)=>$5d501a575f007e75$export$e5eb8aade1d4272a(callback, depends),
    (callback, depends)=>$5d501a575f007e75$export$66760ff81022525f(callback, depends),
    (callback, depends)=>$5d501a575f007e75$export$73c7fe1d8124595f(callback, depends)
];

});
parcelRegister("8sDwk", function(module, exports) {
$parcel$export(module.exports, "PredefinedQueries", () => $02dac0f05969c429$export$ed6721f2880ce367);
$parcel$export(module.exports, "GLOBAL_ALERTS_ROUTE_NAME", () => $02dac0f05969c429$export$ba93b3de87c980dc);
$parcel$export(module.exports, "GLOBAL_ALERT_DETAIL_ROUTE_NAME", () => $02dac0f05969c429$export$1881423041ad1b5c);
const $02dac0f05969c429$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $02dac0f05969c429$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $02dac0f05969c429$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$02dac0f05969c429$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$02dac0f05969c429$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$02dac0f05969c429$var$ONLY_MY_SELECTOR_QUERY}`
};
const $02dac0f05969c429$export$d4c72bab9d6cc13a = {};
const $02dac0f05969c429$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $02dac0f05969c429$export$ba93b3de87c980dc = 'eoc-global-alerts';
const $02dac0f05969c429$export$1881423041ad1b5c = 'eoc-global-alert-detail';

});

parcelRegister("2njib", function(module, exports) {
$parcel$export(module.exports, "fetchAlerts", () => $4935f520bcbd925a$export$f7b1e2075b3da718);

var $9ppkU = parcelRequire("9ppkU");
const $4935f520bcbd925a$export$f7b1e2075b3da718 = async ({ searchParams: searchParams })=>{
    const params = new URLSearchParams(searchParams ?? {});
    return (0, $9ppkU.eocFetch)(`/v1/alerts/?${params.toString()}`);
};

});


parcelRegister("4ZkZK", function(module, exports) {
$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $30acd9ad5acbc104$export$9cba342d9ec5384d);

var $9FYIg = parcelRequire("9FYIg");

var $gpj3Y = parcelRequire("gpj3Y");

var $48BUe = parcelRequire("48BUe");
const $30acd9ad5acbc104$var$isBroadcastWidgetEnabled = ()=>false;
const $30acd9ad5acbc104$export$9cba342d9ec5384d = (0, $9FYIg.createRelayResource)({
    type: (0, $48BUe.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gpj3Y.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $30acd9ad5acbc104$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("gpj3Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $f731a952a6e56719$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $f731a952a6e56719$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f731a952a6e56719$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $f731a952a6e56719$export$2e2bcd8739ae039 = $f731a952a6e56719$var$node;

});

parcelRegister("48BUe", function(module, exports) {
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $fc975c81b3f341b9$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $fc975c81b3f341b9$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $fc975c81b3f341b9$export$6c783d91630ece21);
const $fc975c81b3f341b9$export$750459958906793 = 392;
const $fc975c81b3f341b9$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $fc975c81b3f341b9$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("iDAU4", function(module, exports) {
$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $4e5b6a1d41336340$export$1da15dc2d924240c);

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");

var $cxKOj = parcelRequire("cxKOj");



const $4e5b6a1d41336340$export$1da15dc2d924240c = (0, $5L7qx.resourceWithCondition2)(()=>(0, $cxKOj.expValEquals)('recommended_projects_for_you_page', 'cohort', 'test', 'control'), (0, $l1VxS.createResource)({
    type: (0, $ee6e0cf9d15433cc$export$2424d848f6fd66f6),
    getKey: ()=>'jira-home-2',
    getDataLoader: ()=>(parcelRequire("fHN4F")),
    maxAge: Infinity
}), (0, $l1VxS.createResource)({
    type: (0, $ee6e0cf9d15433cc$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("cm8PP")),
    maxAge: Infinity
}));

});
const $ee6e0cf9d15433cc$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';
const $ee6e0cf9d15433cc$export$2424d848f6fd66f6 = 'JIRA_HOME_PROJECT_REC_EXPERIMENT';

parcelRegister("fHN4F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("36M5Z").then(()=>parcelRequire('5kAX9'));

});

parcelRegister("cm8PP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ccobK").then(()=>parcelRequire('gu7eh'));

});


parcelRegister("80Ye8", function(module, exports) {
$parcel$export(module.exports, "jiraHomeWorkSuggestionsIsDeveloperResource", () => $8684b2f33815fbda$export$420b5969a526b86f);

var $5KtrL = parcelRequire("5KtrL");

var $9FYIg = parcelRequire("9FYIg");

var $clsnW = parcelRequire("clsnW");

var $aYncF = parcelRequire("aYncF");
const $8684b2f33815fbda$export$420b5969a526b86f = (0, $9FYIg.createRelayResource)({
    type: 'JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $clsnW.default),
            variables: {
                cloudId: tenantContext.cloudId,
                isSoftwareLicensed: tenantContext.licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SOFTWARE] && tenantContext.licenseStates?.software === (0, $5KtrL.LICENSE_STATE_ACTIVE)
            }
        })
});

});
parcelRegister("clsnW", function(module, exports) {
$parcel$export(module.exports, "default", () => $24b25cf36aed9e27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9af3482c29caafe3c266b9a94e6bf614>>
 * @relayHash 33a398085fffc1c8c240023b01b17ecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1
const $24b25cf36aed9e27$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSoftwareLicensed"
        }
    ], v1 = [
        {
            "condition": "isSoftwareLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "WorkSuggestionsUserProfile",
                            "kind": "LinkedField",
                            "name": "userProfileByCloudId",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "persona"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1",
            "metadata": {},
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$24b25cf36aed9e27$var$node.hash = "2ffc84c440c4cba253c916b64a96af89";
var $24b25cf36aed9e27$export$2e2bcd8739ae039 = $24b25cf36aed9e27$var$node;

});


parcelRegister("5gjY4", function(module, exports) {
$parcel$export(module.exports, "YourWorkSkeleton", () => $61046b34651c6bad$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $61046b34651c6bad$export$31cebe1052db844);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $lqRy3 = parcelRequire("lqRy3");

var $l3laI = parcelRequire("l3laI");
const $61046b34651c6bad$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lqRy3)))
    });
const $61046b34651c6bad$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l3laI))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("lqRy3", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("l3laI", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("jnds2", function(module, exports) {
$parcel$export(module.exports, "widgetDismissedStateResource", () => $57ae939029132df2$export$451c4a4a781aa514);
$parcel$export(module.exports, "useServiceDeskPortalWidgetResource", () => $57ae939029132df2$export$d3aa387095a4c8ad);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");


const $57ae939029132df2$var$getDataLoader = ()=>(parcelRequire("TkKwb"));
const $57ae939029132df2$export$451c4a4a781aa514 = (0, $l1VxS.createResource)({
    type: (0, $3f53320209c907af$export$5a807784695ecdeb),
    getKey: ()=>(0, $3f53320209c907af$export$5a807784695ecdeb),
    getDataLoader: $57ae939029132df2$var$getDataLoader,
    maxAge: Infinity
});
const $57ae939029132df2$export$d3aa387095a4c8ad = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $eJrcF.useResource)($57ae939029132df2$export$451c4a4a781aa514);
    const loadingRef = (0, $eJOHy.useRef)(false);
    const errorRef = (0, $eJOHy.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eJOHy.useCallback)(()=>{
        update(()=>({
                widgetIsDismissed: true
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useServiceDeskPortalWidgetResource',
                        packageName: 'jiraRouterResourcesServicedeskPortalWidgetResources',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $3f53320209c907af$export$f9c8733e3a81c54c), 'true').catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'useServiceDeskPortalWidgetResource',
                        packageName: 'jiraRouterResourcesServicedeskPortalWidgetResources',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            widgetIsDismissed: true,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            widgetIsDismissed: data.widgetIsDismissed,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
const $3f53320209c907af$export$5a807784695ecdeb = 'SERVICEDESK_PORTAL_WIDGET_DISMISSED';
const $3f53320209c907af$export$f9c8733e3a81c54c = 'eoc-jsm-servicedesk-portal-widget';

parcelRegister("TkKwb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aONrf").then(()=>parcelRequire('4CdMl'));

});


parcelRegister("5oURf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kJ2W9").then(()=>parcelRequire('4Ov3V'));

});


parcelRegister("7lsw4", function(module, exports) {
$parcel$export(module.exports, "jiraSearchRouteEntry", () => $5bebce03f6f0e3a4$export$76b74d5744e69817);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $gpMOv = parcelRequire("gpMOv");

var $8VHZr = parcelRequire("8VHZr");

var $4c8NG = parcelRequire("4c8NG");
const $5bebce03f6f0e3a4$export$76b74d5744e69817 = (0, $6xToB.createEntry)((0, $gpMOv.jiraSearchRoute), ()=>({
        group: 'redirects',
        component: (0, $8VHZr.JiraSearchRedirect),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4c8NG.jiraSearchResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-jira-search-entries/src/jiraSearchRouteEntry.tsx',
                whichExportToUse: 'jiraSearchRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gpMOv", function(module, exports) {
$parcel$export(module.exports, "jiraSearchRoute", () => $6d1ee70e507e9079$export$a3a93dcf611b611a);
const $6d1ee70e507e9079$export$a3a93dcf611b611a = {
    name: 'jira-search',
    path: '/jira/search',
    exact: true
};

});

parcelRegister("8VHZr", function(module, exports) {
$parcel$export(module.exports, "JiraSearchRedirect", () => $1bb7117a1a55913a$export$ee180957879b33ac);

var $eJOHy = parcelRequire("eJOHy");

var $R5dK3 = parcelRequire("R5dK3");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");

var $gjgo6 = parcelRequire("gjgo6");

var $4c8NG = parcelRequire("4c8NG");
const $1bb7117a1a55913a$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $4c8NG.jiraSearchResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $R5dK3.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjgo6.QuickSearchToGlobalIssueNavigatorRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: data.url,
        push: false
    });
};

});
parcelRegister("gjgo6", function(module, exports) {
$parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", () => $6420f1489837c0e8$export$968c2900ae111000);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dSkEC = parcelRequire("dSkEC");

var $2mHfh = parcelRequire("2mHfh");
var $95O7y = parcelRequire("95O7y");
var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");
const $6420f1489837c0e8$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $kRgKj.fireScreenAnalytics), useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useCurrentRoute: // eslint-disable-next-line react-hooks/react-compiler
useCurrentRoute = (0, $hih5V.useCurrentRoute), useQueryParam: // eslint-disable-next-line react-hooks/react-compiler
useQueryParam = (0, $95O7y.useQueryParam) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const route = useCurrentRoute();
    // eslint-disable-next-line react-hooks/react-compiler
    const [searchString] = useQueryParam('searchString');
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { data: isNinEnabled } = (0, $eJrcF.useResource)((0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource));
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $eJOHy.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if (isNinEnabled || (0, $4cTDP.fg)('nin_remove_global_scope_enrolment')) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: redirectUrl
    });
};
const $6420f1489837c0e8$var$JiraGlobalIssueNavigatorRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6420f1489837c0e8$export$968c2900ae111000, null);
var $6420f1489837c0e8$export$2e2bcd8739ae039 = $6420f1489837c0e8$var$JiraGlobalIssueNavigatorRedirect;

});

parcelRegister("4c8NG", function(module, exports) {
$parcel$export(module.exports, "jiraSearchResource", () => $959381ff378a0f18$export$d23832be0ebf8a93);

var $b5RwB = parcelRequire("b5RwB");

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");
const $959381ff378a0f18$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $959381ff378a0f18$export$d23832be0ebf8a93 = (0, $l1VxS.createResource)({
    type: $959381ff378a0f18$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            searchString: query.searchString
        });
        return (0, $hgi0g.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});

});



parcelRegister("bMj4d", function(module, exports) {
$parcel$export(module.exports, "jsmBoardRouteEntry", () => $c964b22851bcfd9e$export$44cb11fe4ca053f8);

var $kHlOR = parcelRequire("kHlOR");

var $iWUAX = parcelRequire("iWUAX");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $eWDmv = parcelRequire("eWDmv");

var $aQoXd = parcelRequire("aQoXd");

var $zNGiI = parcelRequire("zNGiI");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $cTGji = parcelRequire("cTGji");
const $c964b22851bcfd9e$export$44cb11fe4ca053f8 = (0, $6xToB.createEntry)((0, $eWDmv.jsmBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cTGji.ServicedeskBoard),
        layout: (0, $aQoXd.serviceProjectLayout),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cTGji.LazyServicedeskBoard),
            (0, $cTGji.LazyBoardSettings)
        ],
        perfMetricKey: 'servicedesk-boards-load',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $iWUAX.AsyncViewsNav)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-board-entries/src/jsmBoardRouteEntry.tsx',
                whichExportToUse: 'jsmBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iWUAX", function(module, exports) {
$parcel$export(module.exports, "AsyncViewsNav", () => $4f80d54e53f9117f$export$b43adc74b6a33bde);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $4f80d54e53f9117f$var$LazyViewsNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6tx8m")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
});
const $4f80d54e53f9117f$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f80d54e53f9117f$var$LazyViewsNav, null));

});
parcelRegister("6tx8m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("29uZk").then(()=>parcelRequire('3mJDw'));

});


parcelRegister("cTGji", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskBoard", () => $76da0f6e46c42f64$export$bb5ed4e7838cf30c);
$parcel$export(module.exports, "LazyBoardSettings", () => $76da0f6e46c42f64$export$45bb2963a11a5163);
$parcel$export(module.exports, "ServicedeskBoard", () => $76da0f6e46c42f64$export$f058c0d1561d67f3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $76da0f6e46c42f64$export$bb5ed4e7838cf30c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5U96y"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $76da0f6e46c42f64$export$45bb2963a11a5163 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lKblg")).then((module)=>module.ServicedeskBoardSettingsAppLayout)), {
    moduleId: "./src/packages/spa-apps/servicedesk/board-settings/src/ui/index.tsx"
});
const $76da0f6e46c42f64$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== 'servicedesk-boards') return null;
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $76da0f6e46c42f64$export$45bb2963a11a5163,
        pageId: "spa-apps/servicedesk/boards/board-settings",
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $76da0f6e46c42f64$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};

});
parcelRegister("lKblg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ce7WX").then(()=>parcelRequire('hm3w3'));

});



parcelRegister("6XPJ5", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubAllArticlesRouteEntry", () => $3c9d062c74dc59e1$export$5b55251966102ec);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $05dAZ = parcelRequire("05dAZ");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $efTLg = parcelRequire("efTLg");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");

var $fIdiR = parcelRequire("fIdiR");

var $8PNlM = parcelRequire("8PNlM");

var $bUl48 = parcelRequire("bUl48");

var $37mqV = parcelRequire("37mqV");
const $3c9d062c74dc59e1$export$5b55251966102ec = (0, $6xToB.createEntry)((0, $05dAZ.knowledgeHubAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bUl48.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bUl48.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubAllArticlesRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubAllArticlesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5qNZF", function(module, exports) {
$parcel$export(module.exports, "AsyncKbNav", () => $0f2e13b1c45ccae3$export$223f755b7799fe02);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $h47gY = parcelRequire("h47gY");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

const $0f2e13b1c45ccae3$var$LazyKbNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("grslL")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});

const $0f2e13b1c45ccae3$var$LazyKbNavWithUseResource = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("grslL")).then(({ KnowledgeBaseNavWithUseResource: KnowledgeBaseNavWithUseResource })=>KnowledgeBaseNavWithUseResource), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $0f2e13b1c45ccae3$export$223f755b7799fe02 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "horizontal-jsm-kb-nav",
        packageName: "jira-horizontal-nav-jsm-knowledge-base"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-jsm-kb-nav"
    }, (0, $4cTDP.fg)('jsm-kb-articles-functional') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0f2e13b1c45ccae3$var$LazyKbNavWithUseResource, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0f2e13b1c45ccae3$var$LazyKbNav, null)));
};

});
parcelRegister("grslL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9K58V").then(()=>parcelRequire('194dz'));

});


parcelRegister("05dAZ", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $408453b4b18d1ed3$export$20e57a83f181da7b);
const $408453b4b18d1ed3$export$20e57a83f181da7b = {
    name: 'knowledge-hub-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};

});

parcelRegister("efTLg", function(module, exports) {
$parcel$export(module.exports, "kbTopicsResource", () => $e1d4170f92b1d08e$export$21fb94425a1f9352);

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");

var $5j85B = parcelRequire("5j85B");

var $8PNlM = parcelRequire("8PNlM");
const $e1d4170f92b1d08e$var$isTopicSuggestionAllowed = (appEditions)=>{
    return appEditions.serviceDesk === 'PREMIUM_EDITION';
};
const $e1d4170f92b1d08e$export$21fb94425a1f9352 = (0, $l1VxS.createResource)({
    type: 'KB_TOPIC',
    depends: [
        (0, $8PNlM.projectIdResource).type
    ],
    getKey: ({ match: match })=>{
        return match.params.projectKey ? `kb-topic-${match.params.projectKey}` : 'kb-topic';
    },
    getData: async (dataContext, { tenantContext: { activationId: activationId, appEditions: appEditions } })=>{
        const { match: { params: params } } = dataContext;
        if (!$e1d4170f92b1d08e$var$isTopicSuggestionAllowed(appEditions)) return {
            topicSuggestionAllowed: false
        };
        if ((0, $4cTDP.fg)('jsm-kb-articles-functional')) {
            // Use shared project ID resource - fetch project ID and AI enablement in parallel
            const [projectData, aiEnablementResponse] = await Promise.all([
                (0, $5j85B.consumeDependency)(dataContext.dependencies, (0, $8PNlM.projectIdResource).type),
                (0, $hgi0g.default)('/rest/api/1/aiconfig/ai-enabled/jira-servicedesk', {
                    method: 'GET'
                })
            ]);
            if (!projectData?.id) return {
                topics: [],
                isFiltered: true,
                aiEnabled: false,
                topicSuggestionAllowed: true
            };
            // if ai enablement is enabled, fetch kb topics
            if (aiEnablementResponse.isEnabled) {
                const response = await (0, $hgi0g.default)(`/gateway/api/jsd-apollo-stargate/sharded/workspace/${activationId}/api/project/${projectData.id}/kb-topics`);
                return {
                    topics: response.topics,
                    aiEnabled: true,
                    topicSuggestionAllowed: true
                };
            }
            return {
                topics: [],
                aiEnabled: false,
                topicSuggestionAllowed: true
            };
        }
        // fetch project response and ai enablement response in parallel
        const [projectResponse, aiEnablementResponse] = await Promise.all([
            (0, $hgi0g.default)(`/rest/api/2/project/${params.projectKey}`),
            (0, $hgi0g.default)('/rest/api/1/aiconfig/ai-enabled/jira-servicedesk', {
                method: 'GET'
            })
        ]);
        // if ai enablement is enabled, fetch kb topics
        if (aiEnablementResponse.isEnabled) {
            const response = await (0, $hgi0g.default)(`/gateway/api/jsd-apollo-stargate/sharded/workspace/${activationId}/api/project/${projectResponse.id}/kb-topics`);
            return {
                topics: response.topics,
                aiEnabled: true,
                topicSuggestionAllowed: true
            };
        }
        return {
            topics: [],
            aiEnabled: false,
            topicSuggestionAllowed: true
        };
    },
    isBrowserOnly: true,
    maxAge: 1800000
});

});
parcelRegister("8PNlM", function(module, exports) {
$parcel$export(module.exports, "projectIdResource", () => $081d7dd285ebcd46$export$8ab33580af181f4);

var $l1VxS = parcelRequire("l1VxS");

var $3ugTQ = parcelRequire("3ugTQ");
const $081d7dd285ebcd46$export$8ab33580af181f4 = (0, $l1VxS.createResource)({
    type: 'PROJECT_ID',
    getKey: (routerContext)=>{
        const projectKey = routerContext.match.params.projectKey;
        return `project-id-${projectKey}`;
    },
    getData: async (routerContext)=>{
        const projectKey = routerContext.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        const project = await (0, $3ugTQ.performGetRequest)(`/rest/api/2/project/${projectKey}`);
        return project;
    },
    maxAge: 3600000
});

});


parcelRegister("fIdiR", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesKBTypeCheckerResource", () => $e37abaca7d05469d$export$151f5babb301c251);

var $j4oe4 = parcelRequire("j4oe4");

var $l1VxS = parcelRequire("l1VxS");

var $7zZ4w = parcelRequire("7zZ4w");

var $d1Ttr = parcelRequire("d1Ttr");

var $5j85B = parcelRequire("5j85B");

var $4cTDP = parcelRequire("4cTDP");

var $8PNlM = parcelRequire("8PNlM");
const $e37abaca7d05469d$export$151f5babb301c251 = (0, $l1VxS.createResource)({
    type: 'KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES_KB_TYPE_CHECKER',
    depends: [
        (0, $8PNlM.projectIdResource).type
    ],
    getKey: (routerContext)=>{
        const projectKey = routerContext.match.params.projectKey;
        return `knowledge-hub-kb-type-checker-${projectKey}`;
    },
    getData: async (dataContext, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        const projectKey = dataContext.match.params.projectKey;
        // Use shared project ID resource
        const { dependencies: dependencies } = dataContext;
        const projectData = await (0, $5j85B.consumeDependency)(dependencies, (0, $8PNlM.projectIdResource).type);
        if (!projectData?.id) throw new Error(`Failed to get project ID for project key: ${projectKey}`);
        // Construct container using projectId
        const container = `ari:cloud:jira:${cloudId}:project/${projectData.id}`;
        // Use loadQuery to create the preloaded query and return it
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $d1Ttr.default), {
            cloudId: cloudId,
            container: container,
            isAgentKbEnabled: (0, $4cTDP.fg)('enable_jsm_agent_kb')
        });
        return queryReference;
    },
    isBrowserOnly: true
});

});
parcelRegister("d1Ttr", function(module, exports) {
$parcel$export(module.exports, "default", () => $124f17f4428c810e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06d85713555b3e4c5e75ecb86af72ad2>>
 * @relayHash eb102bdaa211563303c83d89ef60bf26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 975b56d264a64cb33e0b46e61fcd7414a9f0d26c1024de322dde7ffe79ca736e
const $124f17f4428c810e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "container"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAgentKbEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "container",
            "variableName": "container"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "sourceType"
    }, v5 = {
        "condition": "isAgentKbEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceVisibility"
            }
        ]
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "linkedSourceTypes"
            }
        ],
        "type": "KnowledgeBaseLinkedSourceTypes"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "KnowledgeBaseQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeBase",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "KnowledgeBaseSourceEdge",
                                                "kind": "LinkedField",
                                                "name": "edge",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeBaseSource",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "knowledgeBase.knowledgeBase.edge"
                                        }
                                    ],
                                    "type": "KnowledgeBaseSources"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "knowledgeBase_getLinkedSourceTypes",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "KnowledgeBaseQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeBase",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "knowledgeBase",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeBaseSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeBaseSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeBaseSources"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "knowledgeBase_getLinkedSourceTypes",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "975b56d264a64cb33e0b46e61fcd7414a9f0d26c1024de322dde7ffe79ca736e",
            "metadata": {},
            "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$124f17f4428c810e$var$node.hash = "dc3e88c81c8f019e8d183c5b195482e6";
var $124f17f4428c810e$export$2e2bcd8739ae039 = $124f17f4428c810e$var$node;

});


parcelRegister("bUl48", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", () => $96082a4fa3505fd8$export$c73ba7e80a805fb2);
$parcel$export(module.exports, "default", () => $96082a4fa3505fd8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $96082a4fa3505fd8$export$c73ba7e80a805fb2 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9S3z8"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
const $96082a4fa3505fd8$var$AsyncServicedeskKnowledgeHubBrowseAllArticles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $96082a4fa3505fd8$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });
var $96082a4fa3505fd8$export$2e2bcd8739ae039 = $96082a4fa3505fd8$var$AsyncServicedeskKnowledgeHubBrowseAllArticles;

});
parcelRegister("9S3z8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("3TPNO")
]).then(()=>parcelRequire('1Tm7l'));

});


parcelRegister("37mqV", function(module, exports) {
$parcel$export(module.exports, "getKnowledgeHubResources", () => $b3d665e906aaec17$export$5421e48e728c449f);

var $85Ze9 = parcelRequire("85Ze9");

var $1PvPk = parcelRequire("1PvPk");
const $b3d665e906aaec17$export$5421e48e728c449f = ()=>[
        ...(0, $1PvPk.getServicedeskPageContextResources)(),
        (0, $85Ze9.kbConfluenceContextResource)
    ];

});


parcelRegister("1fi5O", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRouteEntry", () => $2fa427d97734a071$export$513e093ef937dc06);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $4SJN8 = parcelRequire("4SJN8");

var $aQoXd = parcelRequire("aQoXd");

var $37mqV = parcelRequire("37mqV");

var $4LjGe = parcelRequire("4LjGe");
const $2fa427d97734a071$export$513e093ef937dc06 = (0, $6xToB.createEntry)((0, $4SJN8.knowledgeHubArticleEmbedEditorRoute), ()=>({
        group: 'servicedesk',
        component: (0, $4LjGe.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4LjGe.LazyServiceDeskKnowledgeArticleEmbedEditor)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubArticleEmbedEditorRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubArticleEmbedEditorRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4SJN8", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $638ec66a6480ede7$export$bd512c426b095693);
const $638ec66a6480ede7$export$bd512c426b095693 = {
    name: 'kb-article-embed-editor',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("4LjGe", function(module, exports) {
$parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", () => $f8957981e861612d$export$35c6d2a033ef4c42);
$parcel$export(module.exports, "default", () => $f8957981e861612d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f8957981e861612d$export$35c6d2a033ef4c42 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("icNrU"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
const $f8957981e861612d$var$AsyncServiceDeskKnowledgeArticleEmbedEditor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f8957981e861612d$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });
var $f8957981e861612d$export$2e2bcd8739ae039 = $f8957981e861612d$var$AsyncServiceDeskKnowledgeArticleEmbedEditor;

});
parcelRegister("icNrU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("adbVD").then(()=>parcelRequire('fbaeV'));

});



parcelRegister("3DoQq", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleInCategoryRouteEntry", () => $d986e9ce17378918$export$a67199ebb12b0f7f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cR5N0 = parcelRequire("cR5N0");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $1m9Vx = parcelRequire("1m9Vx");
const $d986e9ce17378918$export$a67199ebb12b0f7f = (0, $6xToB.createEntry)((0, $cR5N0.knowledgeHubArticleInCategoryRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $1m9Vx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1m9Vx.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubArticleInCategoryRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubArticleInCategoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cR5N0", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $415cc4cad3a2ca3c$export$3afe8482ce820835);
const $415cc4cad3a2ca3c$export$3afe8482ce820835 = {
    name: 'knowledge-hub-article-in-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};

});

parcelRegister("1m9Vx", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", () => $18518def2687a56c$export$efd0ec49853aa81);
$parcel$export(module.exports, "default", () => $18518def2687a56c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $18518def2687a56c$export$efd0ec49853aa81 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7x9tw"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
const $18518def2687a56c$var$AsyncServicedeskKnowledgeHubViewArticle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $18518def2687a56c$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });
var $18518def2687a56c$export$2e2bcd8739ae039 = $18518def2687a56c$var$AsyncServicedeskKnowledgeHubViewArticle;

});
parcelRegister("7x9tw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2QSk7").then(()=>parcelRequire('i2c2s'));

});



parcelRegister("dpAnL", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRouteEntry", () => $3af272ff53192dcc$export$de40c949b963d9e);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $bxbQK = parcelRequire("bxbQK");

var $5L7qx = parcelRequire("5L7qx");

var $2Y5nj = parcelRequire("2Y5nj");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $lopBx = parcelRequire("lopBx");

var $efTLg = parcelRequire("efTLg");

var $4cTDP = parcelRequire("4cTDP");

var $fIdiR = parcelRequire("fIdiR");

var $8PNlM = parcelRequire("8PNlM");

var $37mqV = parcelRequire("37mqV");

var $bUl48 = parcelRequire("bUl48");
const $3af272ff53192dcc$export$de40c949b963d9e = (0, $6xToB.createEntry)((0, $2Y5nj.knowledgeHubBrowseAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bUl48.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $lopBx.isFedRamp)(), (0, $bxbQK.virtualAgentKnowledgebaseTouchpointResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bUl48.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubBrowseAllArticlesRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubBrowseAllArticlesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bxbQK", function(module, exports) {
$parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", () => $3afa3392dccb83a7$export$1b798e6122168cca);

var $4cTDP = parcelRequire("4cTDP");

var $9FYIg = parcelRequire("9FYIg");

var $ihZyh = parcelRequire("ihZyh");
const $3afa3392dccb83a7$export$1b798e6122168cca = (0, $9FYIg.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ihZyh.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4cTDP.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("ihZyh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e664231cf64e3b1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c48abcc6b496304054e100d2e441e9b>>
 * @relayHash cf384c20d02578de5057af63fc8ffcd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dec10e76f05bd66b0bce134e788f44487f264e251120bb3271f6f78d1bec90e
const $e664231cf64e3b1b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7dec10e76f05bd66b0bce134e788f44487f264e251120bb3271f6f78d1bec90e",
        "metadata": {},
        "name": "VirtualServiceAgentCtaCardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e664231cf64e3b1b$export$2e2bcd8739ae039 = $e664231cf64e3b1b$var$node;

});


parcelRegister("2Y5nj", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $6f80f34f95941411$export$c8e99e3434791c0e);
const $6f80f34f95941411$export$c8e99e3434791c0e = {
    name: 'knowledge-hub-browse-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};

});


parcelRegister("20wcj", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRouteEntry", () => $823f90a908b238fe$export$dd6c99863524ee59);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $1nDFe = parcelRequire("1nDFe");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");

var $efTLg = parcelRequire("efTLg");

var $8PNlM = parcelRequire("8PNlM");

var $fIdiR = parcelRequire("fIdiR");

var $7P9Bo = parcelRequire("7P9Bo");

var $37mqV = parcelRequire("37mqV");
const $823f90a908b238fe$export$dd6c99863524ee59 = (0, $6xToB.createEntry)((0, $1nDFe.knowledgeHubBrowseAllCategoriesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7P9Bo.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7P9Bo.LazyServicedeskKnowledgeHubBrowseAllCategories)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubBrowseAllCategoriesRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubBrowseAllCategoriesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1nDFe", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $58bbd9d370d8b140$export$256f841794b3f077);
const $58bbd9d370d8b140$export$256f841794b3f077 = {
    name: 'knowledge-hub-browse-all-categories',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};

});

parcelRegister("7P9Bo", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", () => $984449bb49cd7f6f$export$a488cba75f18ade8);
$parcel$export(module.exports, "default", () => $984449bb49cd7f6f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $984449bb49cd7f6f$export$a488cba75f18ade8 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2npP6"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
const $984449bb49cd7f6f$var$AsyncServicedeskKnowledgeHubBrowseAllCategories = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $984449bb49cd7f6f$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });
var $984449bb49cd7f6f$export$2e2bcd8739ae039 = $984449bb49cd7f6f$var$AsyncServicedeskKnowledgeHubBrowseAllCategories;

});
parcelRegister("2npP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d765r").then(()=>parcelRequire('6MBBj'));

});



parcelRegister("1lGts", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRouteEntry", () => $f8027d8fdd2a398c$export$abb9cdffbf5c943b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2mUb7 = parcelRequire("2mUb7");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $1m9Vx = parcelRequire("1m9Vx");
const $f8027d8fdd2a398c$export$abb9cdffbf5c943b = (0, $6xToB.createEntry)((0, $2mUb7.knowledgeHubBrowseViewArticleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $1m9Vx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1m9Vx.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubBrowseViewArticleRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubBrowseViewArticleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2mUb7", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $cd209d2926c2a236$export$ef8a9ec2979d1b10);
const $cd209d2926c2a236$export$ef8a9ec2979d1b10 = {
    name: 'knowledge-hub-browse-view-article',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};

});


parcelRegister("j3R4j", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryPageRouteEntry", () => $3ae5894492816ecf$export$464b24032c2aeb02);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $j3xLT = parcelRequire("j3xLT");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $el48G = parcelRequire("el48G");
const $3ae5894492816ecf$export$464b24032c2aeb02 = (0, $6xToB.createEntry)((0, $j3xLT.knowledgeHubCategoryPageRoute), ()=>({
        group: 'servicedesk',
        component: (0, $el48G.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $el48G.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_CATEGORY,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubCategoryPageRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubCategoryPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("j3xLT", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $80f8d129ae4f90b7$export$79fb48a07e43639a);
const $80f8d129ae4f90b7$export$79fb48a07e43639a = {
    name: 'knowledge-hub-category-page',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};

});

parcelRegister("el48G", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", () => $fd62694248c955e3$export$c01a896b8d33aa9c);
$parcel$export(module.exports, "default", () => $fd62694248c955e3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fd62694248c955e3$export$c01a896b8d33aa9c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("b0MJ5"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
const $fd62694248c955e3$var$AsyncServicedeskKnowledgeHubCategory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fd62694248c955e3$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });
var $fd62694248c955e3$export$2e2bcd8739ae039 = $fd62694248c955e3$var$AsyncServicedeskKnowledgeHubCategory;

});
parcelRegister("b0MJ5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Uf0K").then(()=>parcelRequire('ifsVi'));

});



parcelRegister("gG5r4", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryRouteEntry", () => $3785c68628c9a716$export$416d7b87b4f3205e);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5kJg8 = parcelRequire("5kJg8");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $37mqV = parcelRequire("37mqV");

var $el48G = parcelRequire("el48G");
const $3785c68628c9a716$export$416d7b87b4f3205e = (0, $6xToB.createEntry)((0, $5kJg8.knowledgeHubCategoryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.knowledge.category',
        component: (0, $el48G.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $el48G.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_CATEGORY,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubCategoryRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubCategoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5kJg8", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $513d9221090385c4$export$69ed5b0214ea6ee5);
const $513d9221090385c4$export$69ed5b0214ea6ee5 = {
    name: 'knowledge-hub-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};

});


parcelRegister("jYWZX", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubDraftsRouteEntry", () => $3de8811eda552379$export$4da743c0d13c2cfc);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ibB6D = parcelRequire("ibB6D");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");

var $efTLg = parcelRequire("efTLg");

var $8PNlM = parcelRequire("8PNlM");

var $fIdiR = parcelRequire("fIdiR");

var $lGEBz = parcelRequire("lGEBz");

var $37mqV = parcelRequire("37mqV");
const $3de8811eda552379$export$4da743c0d13c2cfc = (0, $6xToB.createEntry)((0, $ibB6D.knowledgeHubDraftsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $lGEBz.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lGEBz.LazyServicedeskKnowledgeHubDrafts)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_DRAFTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubDraftsRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubDraftsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ibB6D", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $20dedff9bf24275c$export$670f3b59aa55b7ae);
const $20dedff9bf24275c$export$670f3b59aa55b7ae = {
    name: 'knowledge-hub-drafts',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};

});

parcelRegister("lGEBz", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", () => $9dd32b6f3082a02e$export$53decb9d1eb60aed);
$parcel$export(module.exports, "default", () => $9dd32b6f3082a02e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9dd32b6f3082a02e$export$53decb9d1eb60aed = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9mz8y"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
const $9dd32b6f3082a02e$var$AsyncServicedeskKnowledgeHubDrafts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9dd32b6f3082a02e$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });
var $9dd32b6f3082a02e$export$2e2bcd8739ae039 = $9dd32b6f3082a02e$var$AsyncServicedeskKnowledgeHubDrafts;

});
parcelRegister("9mz8y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("fVG9a")
]).then(()=>parcelRequire('by822'));

});



parcelRegister("21gXe", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubLandingRouteEntry", () => $af48c865d50803a3$export$671687d85e096e5b);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $1cRFu = parcelRequire("1cRFu");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $8PNlM = parcelRequire("8PNlM");

var $efTLg = parcelRequire("efTLg");

var $fIdiR = parcelRequire("fIdiR");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $37mqV = parcelRequire("37mqV");

var $7KQFQ = parcelRequire("7KQFQ");
const $af48c865d50803a3$export$671687d85e096e5b = (0, $6xToB.createEntry)((0, $1cRFu.knowledgeHubLandingRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7KQFQ.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7KQFQ.LazyServicedeskKnowledgeHubLanding)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_LANDING,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubLandingRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubLandingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1cRFu", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $852afc9ee2401a27$export$239eaf6a202e0f54);
const $852afc9ee2401a27$export$239eaf6a202e0f54 = {
    name: 'knowledge-hub-landing',
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};

});

parcelRegister("7KQFQ", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", () => $60cb10bb5d52f412$export$f1266a588cfc310b);
$parcel$export(module.exports, "default", () => $60cb10bb5d52f412$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $60cb10bb5d52f412$export$f1266a588cfc310b = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1lNOe")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
const $60cb10bb5d52f412$var$AsyncServicedeskKnowledgeHubLanding = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $60cb10bb5d52f412$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });
var $60cb10bb5d52f412$export$2e2bcd8739ae039 = $60cb10bb5d52f412$var$AsyncServicedeskKnowledgeHubLanding;

});
parcelRegister("1lNOe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("arF5W").then(()=>parcelRequire('96cJs'));

});



parcelRegister("5jjQ1", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSearchRouteEntry", () => $9b7f4a9d389ea822$export$49337a3cc2431ae5);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $bvETR = parcelRequire("bvETR");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $8PNlM = parcelRequire("8PNlM");

var $efTLg = parcelRequire("efTLg");

var $fIdiR = parcelRequire("fIdiR");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");

var $37mqV = parcelRequire("37mqV");

var $1m9Vx = parcelRequire("1m9Vx");
const $9b7f4a9d389ea822$export$49337a3cc2431ae5 = (0, $6xToB.createEntry)((0, $bvETR.knowledgeHubSearchRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1m9Vx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1m9Vx.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubSearchRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubSearchRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bvETR", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $e3ab93bfd33327ab$export$a47c36fb081b544d);
const $e3ab93bfd33327ab$export$a47c36fb081b544d = {
    name: 'knowledge-hub-search',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};

});


parcelRegister("1MGof", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSetupRouteEntry", () => $c084a6049e6be4fd$export$b220f8194ee7c231);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jexDQ = parcelRequire("jexDQ");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $8PNlM = parcelRequire("8PNlM");

var $5L7qx = parcelRequire("5L7qx");

var $efTLg = parcelRequire("efTLg");

var $fIdiR = parcelRequire("fIdiR");

var $4cTDP = parcelRequire("4cTDP");

var $37mqV = parcelRequire("37mqV");

var $8Yxet = parcelRequire("8Yxet");

var $hekHg = parcelRequire("hekHg");
const $c084a6049e6be4fd$export$b220f8194ee7c231 = (0, $6xToB.createEntry)((0, $jexDQ.knowledgeHubSetupRoute), ()=>({
        group: 'servicedesk',
        component: (0, $8Yxet.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $hekHg.getKBExperimentResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8Yxet.LazyServicedeskKnowledgeHubSetup)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_SETUP,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubSetupRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubSetupRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jexDQ", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $7a69d7ec5c386457$export$f20770545704547d);
const $7a69d7ec5c386457$export$f20770545704547d = {
    name: 'knowledge-hub-setup',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("8Yxet", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", () => $19aed36a1390b002$export$6c08040d2dc71e43);
$parcel$export(module.exports, "default", () => $19aed36a1390b002$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $19aed36a1390b002$export$6c08040d2dc71e43 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iHSz0")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
const $19aed36a1390b002$var$AsyncServicedeskKnowledgeHubSetup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $19aed36a1390b002$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });
var $19aed36a1390b002$export$2e2bcd8739ae039 = $19aed36a1390b002$var$AsyncServicedeskKnowledgeHubSetup;

});
parcelRegister("iHSz0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gE7hn").then(()=>parcelRequire('c5DUK'));

});


parcelRegister("hekHg", function(module, exports) {
$parcel$export(module.exports, "getKBExperimentResources", () => $a668c63e1a85d076$export$1f44ba1db527c265);

var $6W5Du = parcelRequire("6W5Du");

var $3CmqB = parcelRequire("3CmqB");

var $ghndx = parcelRequire("ghndx");

var $f53Rx = parcelRequire("f53Rx");

var $hDp7i = parcelRequire("hDp7i");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");
const $a668c63e1a85d076$export$1f44ba1db527c265 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_kb_activation_experiment'), (0, $6W5Du.servicedeskKnowledgeBaseAppLinksResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_kb_activation_experiment'), (0, $3CmqB.servicedeskKnowledgeBaseKbTopicsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_kb_activation_experiment'), (0, $ghndx.servicedeskKnowledgeBaseAiDraftGenerateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_kb_activation_experiment'), (0, $f53Rx.servicedeskKnowledgeBaseFetchProjectIssuesResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_kb_activation_experiment'), (0, $hDp7i.servicedeskKnowledgeBaseThirdpartyConnectorsResource))
    ];

});
parcelRegister("6W5Du", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseAppLinksResource", () => $8e23c281a3a38cd3$export$44d5f7a53fb5c262);

var $l1VxS = parcelRequire("l1VxS");

const $8e23c281a3a38cd3$var$getDataLoader = ()=>(parcelRequire("dSl3E"));
const $8e23c281a3a38cd3$export$44d5f7a53fb5c262 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_APP_LINKS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $8e23c281a3a38cd3$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("dSl3E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6BHMm").then(()=>parcelRequire('ee5d3'));

});


parcelRegister("3CmqB", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseKbTopicsResource", () => $208b9effd5cc1bd5$export$f4625a4a319130bd);

var $l1VxS = parcelRequire("l1VxS");

const $208b9effd5cc1bd5$var$getDataLoader = ()=>(parcelRequire("3gZoQ"));
const $208b9effd5cc1bd5$export$f4625a4a319130bd = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_KB_TOPICS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $208b9effd5cc1bd5$var$getDataLoader,
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("3gZoQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gbPQG").then(()=>parcelRequire('9gjfb'));

});


parcelRegister("ghndx", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseAiDraftGenerateResource", () => $e6e02146737897a5$export$1359a8300fe0f193);

var $l1VxS = parcelRequire("l1VxS");

const $e6e02146737897a5$var$getDataLoader = ()=>(parcelRequire("co6Wf"));
const $e6e02146737897a5$export$1359a8300fe0f193 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_AI_DRAFT_GENERATE',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $e6e02146737897a5$var$getDataLoader,
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("co6Wf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("47nUw").then(()=>parcelRequire('6EvpZ'));

});


parcelRegister("f53Rx", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseFetchProjectIssuesResource", () => $6d872489598b2ed8$export$916781e82d6715a6);
// project = "TO" AND created >= "-28d" ORDER BY created DESC

var $l1VxS = parcelRequire("l1VxS");

const $6d872489598b2ed8$var$getDataLoader = ()=>(parcelRequire("bWKnc"));
const $6d872489598b2ed8$export$916781e82d6715a6 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_FETCH_PROJECT_ISSUES',
    getKey: ({ match: match })=>match.query.projectKey || '',
    getDataLoader: $6d872489598b2ed8$var$getDataLoader
});

});
parcelRegister("bWKnc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iWTwf").then(()=>parcelRequire('byCzz'));

});


parcelRegister("hDp7i", function(module, exports) {
$parcel$export(module.exports, "servicedeskKnowledgeBaseThirdpartyConnectorsResource", () => $f10934996cdd0bb3$export$98d85998fe3f25c6);

var $l1VxS = parcelRequire("l1VxS");

const $f10934996cdd0bb3$var$getDataLoader = ()=>(parcelRequire("5D35i"));
const $f10934996cdd0bb3$export$98d85998fe3f25c6 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_KNOWLEDGE_BASE_THIRDPARTY_CONNECTORS',
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $f10934996cdd0bb3$var$getDataLoader,
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("5D35i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iGdgf").then(()=>parcelRequire('3tsG4'));

});




parcelRegister("i5Fsz", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRouteEntry", () => $1c4b63b80aea78f0$export$6a7974939bde7d37);

var $kHlOR = parcelRequire("kHlOR");

var $5qNZF = parcelRequire("5qNZF");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $23Ngf = parcelRequire("23Ngf");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $5L7qx = parcelRequire("5L7qx");

var $4cTDP = parcelRequire("4cTDP");

var $efTLg = parcelRequire("efTLg");

var $8PNlM = parcelRequire("8PNlM");

var $fIdiR = parcelRequire("fIdiR");

var $0WCVc = parcelRequire("0WCVc");

var $37mqV = parcelRequire("37mqV");
const $1c4b63b80aea78f0$export$6a7974939bde7d37 = (0, $6xToB.createEntry)((0, $23Ngf.knowledgeHubSuggestedArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $4cTDP.fg)('jsm-kb-articles-functional') ? (0, $0WCVc.ServiceDeskKnowledgeHubSuggestedArticlesWithResource) : (0, $0WCVc.ServiceDeskKnowledgeHubSuggestedArticles),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $5qNZF.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $37mqV.getKnowledgeHubResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $8PNlM.projectIdResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $efTLg.kbTopicsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm-kb-articles-functional'), (0, $fIdiR.knowledgeHubBrowseAllArticlesKBTypeCheckerResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $0WCVc.LazyServicedeskKnowledgeHubSuggestedArticles)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-knowledge-hub-entries/src/knowledgeHubSuggestedArticlesRouteEntry.tsx',
                whichExportToUse: 'knowledgeHubSuggestedArticlesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("23Ngf", function(module, exports) {
$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $8622f25f0723b25a$export$54edf5cef1c6b21b);
const $8622f25f0723b25a$export$54edf5cef1c6b21b = {
    name: 'knowledge-hub-suggested-topics',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};

});

parcelRegister("0WCVc", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", () => $f74daa10b19a4a9a$export$aee7d96c2ee4c388);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", () => $f74daa10b19a4a9a$export$ee4623542ebd573e);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticlesWithResource", () => $f74daa10b19a4a9a$export$dce81affa4bfe4c6);

var $eJOHy = parcelRequire("eJOHy");

var $3XuP5 = parcelRequire("3XuP5");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $1BZ8a = parcelRequire("1BZ8a");

var $bQWwW = parcelRequire("bQWwW");

var $eJrcF = parcelRequire("eJrcF");

var $efTLg = parcelRequire("efTLg");

var $623to = parcelRequire("623to");

var $9OCJd = parcelRequire("9OCJd");

var $ftN6c = parcelRequire("ftN6c");

const $f74daa10b19a4a9a$export$aee7d96c2ee4c388 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3kVLX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $f74daa10b19a4a9a$export$ee4623542ebd573e = ()=>{
    const { data: isAdminHubAIEnabled, loading: isAdminHubAIEnabledLoading, error: isAdminHubAIEnabledError, fetchAIEnablement: fetchAIEnablement } = (0, $3XuP5.default)('jira-servicedesk');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $9OCJd.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const { projectId: projectId } = projectContext || {};
    const activationId = tenantContext?.activationId || '';
    const [{ error: topicsError, loading: isTopicsLoading }, { fetchSuggestedTopics: fetchSuggestedTopics }] = (0, $623to.useSuggestedTopics)();
    const appEditions = (0, $1BZ8a.useAppEditions)();
    const isTopicSuggestionAllowed = (0, $eJOHy.useCallback)(()=>{
        return appEditions.serviceDesk === 'PREMIUM_EDITION';
    }, [
        appEditions.serviceDesk
    ]);
    const showSuggestedTopics = isTopicSuggestionAllowed() && !isAdminHubAIEnabledLoading && !isAdminHubAIEnabledError && isAdminHubAIEnabled && !isTopicsLoading && !topicsError;
    (0, $eJOHy.useEffect)(()=>{
        projectId && isTopicSuggestionAllowed() && isAdminHubAIEnabled && fetchSuggestedTopics(projectId, createAnalyticsEvent({}), activationId);
    }, [
        activationId,
        createAnalyticsEvent,
        fetchSuggestedTopics,
        isTopicSuggestionAllowed,
        projectId,
        isAdminHubAIEnabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        isTopicSuggestionAllowed() && fetchAIEnablement();
    }, [
        fetchAIEnablement,
        isTopicSuggestionAllowed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f74daa10b19a4a9a$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};
const $f74daa10b19a4a9a$export$dce81affa4bfe4c6 = ()=>{
    const { data: isAdminHubAIEnabled, loading: isAdminHubAIEnabledLoading, error: isAdminHubAIEnabledError, fetchAIEnablement: fetchAIEnablement } = (0, $3XuP5.default)('jira-servicedesk');
    const { data: topicsData, error: topicsError, loading: isTopicsLoading } = (0, $eJrcF.useResource)((0, $efTLg.kbTopicsResource));
    const showSuggestedTopics = topicsData?.topicSuggestionAllowed && !isAdminHubAIEnabledLoading && !isAdminHubAIEnabledError && isAdminHubAIEnabled && !isTopicsLoading && !topicsError;
    (0, $eJOHy.useEffect)(()=>{
        topicsData?.topicSuggestionAllowed && fetchAIEnablement();
    }, [
        fetchAIEnablement,
        topicsData?.topicSuggestionAllowed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f74daa10b19a4a9a$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};

});
parcelRegister("3XuP5", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f11b08ae1f3711e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lsOEE = parcelRequire("lsOEE");
const $8f11b08ae1f3711e$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $lsOEE.fetchAiEnablement)(jiraProduct, version);
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $9pTd3.fireErrorAnalytics)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $8f11b08ae1f3711e$export$2e2bcd8739ae039 = $8f11b08ae1f3711e$var$useIsAdminHubAIEnabled;

});
parcelRegister("lsOEE", function(module, exports) {
$parcel$export(module.exports, "fetchAiEnablement", () => $dc8dcfb6f4d0d2bd$export$ad4105850d0ce824);

var $hgi0g = parcelRequire("hgi0g");
const $dc8dcfb6f4d0d2bd$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $dc8dcfb6f4d0d2bd$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $dc8dcfb6f4d0d2bd$export$2171a423b572256a(jiraProduct, version);
    return (0, $hgi0g.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("623to", function(module, exports) {
$parcel$export(module.exports, "KnowledgeHubSuggestedTopicsContainer", () => $625ec04ef595cb38$export$545055c3c05f3a42);
$parcel$export(module.exports, "useSuggestedTopics", () => $625ec04ef595cb38$export$2328a37d3e371b67);
$parcel$export(module.exports, "usePageNumber", () => $625ec04ef595cb38$export$1571508029b597f4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $6a5ZI = parcelRequire("6a5ZI");

var $lTEl5 = parcelRequire("lTEl5");
const $625ec04ef595cb38$var$initialState = {
    topics: {
        data: [],
        loading: false,
        error: null
    },
    page: 1
};
const $625ec04ef595cb38$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: $625ec04ef595cb38$var$initialState,
    actions: $6a5ZI.actions,
    name: 'KnowledgeHubSuggestedTopicsStore'
});
const $625ec04ef595cb38$export$545055c3c05f3a42 = (0, $6E16M.createContainer)($625ec04ef595cb38$export$6f57813fe9f31bf9, {
    displayName: 'KnowledgeHubSuggestedTopicsContainer'
});
const $625ec04ef595cb38$export$2328a37d3e371b67 = (0, $iJq0l.createHook)($625ec04ef595cb38$export$6f57813fe9f31bf9, {
    selector: (0, $lTEl5.getSuggestedTopics)
});
const $625ec04ef595cb38$export$1571508029b597f4 = (0, $iJq0l.createHook)($625ec04ef595cb38$export$6f57813fe9f31bf9, {
    selector: (0, $lTEl5.getPageNumber)
});

});
parcelRegister("6a5ZI", function(module, exports) {
$parcel$export(module.exports, "actions", () => $8eceddbb21145051$export$e324594224ef24da);

var $la6yl = parcelRequire("la6yl");

var $2uSLP = parcelRequire("2uSLP");

var $c5ubp = parcelRequire("c5ubp");

var $abdL3 = parcelRequire("abdL3");

var $9mb2d = parcelRequire("9mb2d");
const $8eceddbb21145051$export$e324594224ef24da = {
    fetchSuggestedTopics: $2uSLP.fetchSuggestedTopics,
    setPagination: $c5ubp.setPagination,
    dismissTopic: $la6yl.dismissTopic,
    fetchAiDraftPreviewContent: $abdL3.fetchAiDraftPreviewContent,
    triggerArticleGenerationForTopics: $9mb2d.triggerArticleGenerationForTopics
};

});
parcelRegister("la6yl", function(module, exports) {
$parcel$export(module.exports, "dismissTopic", () => $d8ec5fc28789fcf1$export$8c9ab121673c8912);

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $kRgKj = parcelRequire("kRgKj");

var $dTXJ8 = parcelRequire("dTXJ8");

var $fItk5 = parcelRequire("fItk5");

var $eNOs6 = parcelRequire("eNOs6");


var $dAJjM = parcelRequire("dAJjM");

var $k9Ozr = parcelRequire("k9Ozr");
const $d8ec5fc28789fcf1$export$8c9ab121673c8912 = (topicId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, locale: locale, activationId: activationId } = props;
        const currentTopics = getState().topics.data;
        // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
        const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
        const formatMessage = (0, $dTXJ8.createFormatMessage)(locale);
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            projectId && await (0, $eNOs6.deleteTopic)(projectId, topicId, activationId);
            const updatedTopics = (0, $dAJjM.removeTopic)(currentTopics, topicId);
            const page = (0, $fItk5.getPageOnDelete)(getState().page, updatedTopics.length, (0, $350544268fbe82cc$export$5631491ed07b4a08));
            setState({
                ...getState(),
                topics: {
                    data: updatedTopics,
                    loading: false,
                    error: null
                },
                page: page
            });
            showFlag({
                type: 'success',
                title: formatMessage((0, $k9Ozr.default).dismissTopicSuccessTitle),
                isAutoDismiss: true,
                messageId: 'servicedesk-knowledge-performance.controllers.store.actions.dismiss-topic.show-flag.success',
                messageType: 'transactional'
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'dismissTopic succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: false,
                    error: error
                }
            });
            showFlag({
                type: 'error',
                title: formatMessage((0, $k9Ozr.default).dismissTopicErrorTitle),
                description: formatMessage((0, $k9Ozr.default).dismissTopicErrorDescription),
                isAutoDismiss: true,
                messageId: 'servicedesk-knowledge-performance.controllers.store.actions.dismiss-topic.show-flag.error',
                messageType: 'transactional'
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'dismissTopic',
                    packageName: (0, $350544268fbe82cc$export$b8b9d90f9e5bd72b),
                    teamName: (0, $350544268fbe82cc$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("dTXJ8", function(module, exports) {
$parcel$export(module.exports, "createFormatMessage", () => $8560faf7e85baa6c$export$5eaf6c4755708cf2);
/// <reference types="node" />
// correctly type "require"

var $5PQOA = parcelRequire("5PQOA");

var $jUlfz = parcelRequire("jUlfz");

var $gfYxH = parcelRequire("gfYxH");

const $8560faf7e85baa6c$export$5eaf6c4755708cf2 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((locale)=>{
    // TODO: providing locale to IntlProvider is nothing to do with translation. We can completely remove language, not providing any locale
    // TODO: React-intl just reads whatever given to messages object, regardless of locale. REMOVE THIS
    // IntlProvider cannot deal with locale w/ country code. Needs language-only.
    const language = (0, $jUlfz.default)(locale);
    // disable flow for unresolved externals module
    // disable eslint for both unresolved module
    // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
    const messages = (parcelRequire("hXmA9"));
    const intl = (0, $gfYxH.getIntl)({
        locale: language,
        messages: messages
    });
    return intl.formatMessage;
});

});
parcelRegister("jUlfz", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeca643311ab3b45$export$2e2bcd8739ae039);
// en_US => en
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
//
// After the feature flag(https://app.launchdarkly.com/jira/staging/features/use.bcp47.locale.format/targeting) is cleaned-up, this will be removed.
// The reason why it is deprecated is that we are providing locale to ReactIntlProvider as a locale prop after applying
// this function. This is wrong because we are passing only language part ignoring the region variance.
// The consequence is react-intl's format functions such as formatDate will format date into MM-DD-YYYY, instead of DD-MM-YYYY
// in case of en-gb. The similar things could happen in any other language variances.
// On 2. Feb. 2021, it is confirmed that this function is only used to provide locale for IntlProvider component
// Under the feature flag, it is replaced with getBCPLocale function that replaces _ to - to be BCP47 web standard locale format
//
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
const $eeca643311ab3b45$var$getLanguageFromLocale = (locale)=>locale ? locale.substring(0, locale.indexOf('_')) : '';
var $eeca643311ab3b45$export$2e2bcd8739ae039 = $eeca643311ab3b45$var$getLanguageFromLocale;

});

parcelRegister("gfYxH", function(module, exports) {
$parcel$export(module.exports, "getIntl", () => $7e0882b3a42f1fb4$export$51771ec7613ad564);

var $4nehu = parcelRequire("4nehu");
var $99KvW = parcelRequire("99KvW");
const $7e0882b3a42f1fb4$var$cache = (0, $99KvW.createIntlCache)();
const $7e0882b3a42f1fb4$export$51771ec7613ad564 = (config)=>(0, $4nehu.createIntl)(config, $7e0882b3a42f1fb4$var$cache);

});


parcelRegister("fItk5", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalyticsEvents", () => $5341bfc5e562edd3$export$b84e314c48e09c44);
$parcel$export(module.exports, "getPageOnDelete", () => $5341bfc5e562edd3$export$99689dbe56145ad5);
$parcel$export(module.exports, "fireCustomErrorAnalytics", () => $5341bfc5e562edd3$export$3d13cbe76aeaf5e8);
$parcel$export(module.exports, "getViewArticleUrl", () => $5341bfc5e562edd3$export$4b1de73aa951498c);
$parcel$export(module.exports, "getJcsViewArticleUrl", () => $5341bfc5e562edd3$export$adfe9025f8369589);
$parcel$export(module.exports, "getAllDraftsUrl", () => $5341bfc5e562edd3$export$939c0821a1193768);
$parcel$export(module.exports, "getAllArticlesUrl", () => $5341bfc5e562edd3$export$240e98bbb8304c52);
$parcel$export(module.exports, "getAllJcsArticlesUrl", () => $5341bfc5e562edd3$export$35dca3e17444a3e5);
$parcel$export(module.exports, "getFlag", () => $5341bfc5e562edd3$export$a19b74191e00c5e);
$parcel$export(module.exports, "getCommonFlagData", () => $5341bfc5e562edd3$export$f44d45dc3db56277);
$parcel$export(module.exports, "filterSupportedBillingPeriod", () => $5341bfc5e562edd3$export$9f13ed259dc4b1bf);
$parcel$export(module.exports, "formatTrialEndDate", () => $5341bfc5e562edd3$export$da56c66ce2766e02);

var $9pTd3 = parcelRequire("9pTd3");

var $14RSn = parcelRequire("14RSn");

var $kRgKj = parcelRequire("kRgKj");


var $4Gnc4 = parcelRequire("4Gnc4");

var $2SGES = parcelRequire("2SGES");
const $5341bfc5e562edd3$var$TEAM_NAME = 'jsm-nebula';
const $5341bfc5e562edd3$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $5341bfc5e562edd3$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $5341bfc5e562edd3$export$53ee51427129200c = (statusCode)=>$5341bfc5e562edd3$export$1a5a4674dd906e7e(statusCode) || $5341bfc5e562edd3$export$d31fd506ce75fa65(statusCode);
const $5341bfc5e562edd3$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    if (error && typeof error.statusCode === 'number') {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
        const { statusCode: statusCode } = error;
        const lowPriorityError = statusCode >= 400 && statusCode < 500;
        const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
        const transformedError = error instanceof (0, $14RSn.default) ? error : new (0, $14RSn.default)(statusCode);
        const errorObj = {
            error: transformedError,
            meta: {
                id: errorMetaId,
                packageName: packageName,
                teamName: $5341bfc5e562edd3$var$TEAM_NAME
            },
            skipSentry: true,
            ...attributes && {
                attributes: attributes
            }
        };
        (0, $9pTd3.fireErrorAnalytics)(errorObj);
    } else (0, $9pTd3.fireErrorAnalytics)({
        // Note there should not be a case of circular object for error , if there is it will be handled by fireErrorAnalytics
        error: error instanceof Error ? error : new Error(JSON.stringify(error)),
        meta: {
            id: `${id}__JS_ERROR`,
            packageName: packageName,
            teamName: $5341bfc5e562edd3$var$TEAM_NAME
        },
        ...attributes && {
            attributes: attributes
        }
    });
};
const $5341bfc5e562edd3$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
    const lastPage = Math.ceil(updateDataSize / perPage);
    return currentPage > lastPage ? lastPage : currentPage;
};
const $5341bfc5e562edd3$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
    if (error && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    typeof error.statusCode === 'number' && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    !$5341bfc5e562edd3$export$53ee51427129200c(error.statusCode)) event && (0, $kRgKj.fireOperationalAnalytics)(event, id);
    $5341bfc5e562edd3$export$b84e314c48e09c44(error, id, packageName, attributes);
};
const $5341bfc5e562edd3$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
const $5341bfc5e562edd3$export$adfe9025f8369589 = (projectKey, contentId, spaceKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles/${contentId}?spaceKey=${spaceKey}`;
const $5341bfc5e562edd3$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
const $5341bfc5e562edd3$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
const $5341bfc5e562edd3$export$35dca3e17444a3e5 = (projectKey, helpCenterId)=>`/jira/helpcenter/projects/${projectKey}/settings/${helpCenterId}/articles`;
const $5341bfc5e562edd3$export$a19b74191e00c5e = (title, description, flagType)=>({
        title: title,
        description: description,
        id: (0, $4Gnc4.generateNanoId)(),
        flagType: flagType
    });
const $5341bfc5e562edd3$export$a6125e21263de883 = (state)=>{
    const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
    const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
    const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
    const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
    const isArticleDeleted = Boolean(articleId && deleted);
    return {
        isDraftPublished: isDraftPublished,
        isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
        isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
        isArticleDeleted: isArticleDeleted
    };
};
const $5341bfc5e562edd3$export$f44d45dc3db56277 = (state, messages)=>{
    let flag = {
        id: '',
        title: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        description: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        type: (0, $929a8fd32a4edb1e$export$f215947b3d76a6b7)
    };
    const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
    // if confluence get content api fails
    if (showConfluenceCreatePageError) {
        flag = {
            id: 'draftErrorFlag',
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            title: messages.confluenceCreatePageFailureTitle,
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            description: messages.confluenceCreatePageFailureDescription,
            type: (0, $929a8fd32a4edb1e$export$f215947b3d76a6b7)
        };
        return flag;
    }
    const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $5341bfc5e562edd3$export$a6125e21263de883(state);
    // case when new article is published --> Article View
    if (isDraftPublished) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $929a8fd32a4edb1e$export$516433e8a6db7503)
    };
    // case when draft is saved with unpublished changes --> Browse All Articles Page
    if (isDraftSavedWithUnpublishedChanges) flag = {
        id: 'draftSavedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'string | MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessSavedFlagDescription || '',
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $929a8fd32a4edb1e$export$516433e8a6db7503)
    };
    // case when older article is saved with unpublished changes --> Article View
    if (isArticleSavedWithUnpublishedChanges) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleSuccessSavedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $929a8fd32a4edb1e$export$516433e8a6db7503)
    };
    // case when article is deleted --> Browse All Articles Page
    if (isArticleDeleted) flag = {
        id: 'articleDeletedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleDeletedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleDeletedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $929a8fd32a4edb1e$export$516433e8a6db7503)
    };
    return flag;
};
const $5341bfc5e562edd3$export$9f13ed259dc4b1bf = (billingPeriod)=>{
    if (billingPeriod === (0, $2SGES.MONTHLY_BILLED)) return 0, $2SGES.MONTHLY_BILLED;
    if (billingPeriod === (0, $2SGES.ANNUALLY_BILLED)) return 0, $2SGES.ANNUALLY_BILLED;
    return 0, $2SGES.INACTIVE;
};
const $5341bfc5e562edd3$export$da56c66ce2766e02 = (trialEndDate)=>{
    if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
    return null;
};

});
const $929a8fd32a4edb1e$export$516433e8a6db7503 = 'SUCCESS';
const $929a8fd32a4edb1e$export$a0a5e05447abb018 = 'WARNING';
const $929a8fd32a4edb1e$export$f215947b3d76a6b7 = 'ERROR';
const $929a8fd32a4edb1e$export$21bdd502a5302e06 = 'INFO';

parcelRegister("4Gnc4", function(module, exports) {
$parcel$export(module.exports, "generateNanoId", () => $9d2a3ceffd593460$export$a4f5444a5996c185);

var $isIkh = parcelRequire("isIkh");
const $9d2a3ceffd593460$export$a4f5444a5996c185 = ()=>(0, $isIkh.nanoid)(12);
const $9d2a3ceffd593460$export$e73c8bd0f20705a = ()=>(0, $isIkh.nanoid)();

});
parcelRegister("isIkh", function(module, exports) {
$parcel$export(module.exports, "nanoid", () => $d70d39bde9358ce1$export$ac4959f4f1338dfc);
/* @ts-self-types="./index.d.ts" */ 
let $d70d39bde9358ce1$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $d70d39bde9358ce1$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length >= size) return id;
            }
        }
    };
};
let $d70d39bde9358ce1$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$d70d39bde9358ce1$export$a5cee9e955a615e5(alphabet, size | 0, $d70d39bde9358ce1$export$4385e60b38654f68);
let $d70d39bde9358ce1$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $b8927c65666bbc7e$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};

});
const $b8927c65666bbc7e$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';



parcelRegister("2SGES", function(module, exports) {
$parcel$export(module.exports, "NCS", () => $f75514d32e999430$export$d42203c46ecda0b5);
$parcel$export(module.exports, "PARENT_PRODUCT", () => $f75514d32e999430$export$f6fc4a5779d5dc2c);
$parcel$export(module.exports, "USER_ID_TYPE", () => $f75514d32e999430$export$a40257481ddef37e);
$parcel$export(module.exports, "TEAM_NAME", () => $f75514d32e999430$export$d57b6b390e78d90f);
$parcel$export(module.exports, "MONTHLY_BILLED", () => $f75514d32e999430$export$85314a8fbb8155e1);
$parcel$export(module.exports, "ANNUALLY_BILLED", () => $f75514d32e999430$export$d1eb58f682ad65ad);
$parcel$export(module.exports, "INACTIVE", () => $f75514d32e999430$export$1635bbf8efc1cbc4);
$parcel$export(module.exports, "NATIVE_CONFLUENCE", () => $f75514d32e999430$export$1b63ba606d8ecfaa);
$parcel$export(module.exports, "SERVER_CONFLUENCE", () => $f75514d32e999430$export$ce410195c34d61ac);
$parcel$export(module.exports, "CROSS_SITE_CONFLUENCE", () => $f75514d32e999430$export$2a7e16e321f5b7a0);
$parcel$export(module.exports, "SHAREPOINT", () => $f75514d32e999430$export$bc7192bfce222457);
$parcel$export(module.exports, "GOOGLE_DRIVE", () => $f75514d32e999430$export$a9b78a3a2613c33a);
$parcel$export(module.exports, "GOOGLE_DRIVE_CONNECTOR", () => $f75514d32e999430$export$ff6b6c90dea66f24);
$parcel$export(module.exports, "SHAREPOINT_CONNECTOR", () => $f75514d32e999430$export$58e1cd824c9d9f35);
$parcel$export(module.exports, "INTERNAL_VISIBILITY", () => $f75514d32e999430$export$5581bfec82a3629d);
$parcel$export(module.exports, "EXTERNAL_VISIBILITY", () => $f75514d32e999430$export$94a3b08b4e0442dd);
$parcel$export(module.exports, "GoogleDriveAri", () => $f75514d32e999430$export$1d6d386752f38c08);
$parcel$export(module.exports, "SharePointAri", () => $f75514d32e999430$export$45909285cd85fe3d);

var $8oKDI = parcelRequire("8oKDI");
const $f75514d32e999430$export$d42203c46ecda0b5 = 'ncs';
const $f75514d32e999430$export$f6fc4a5779d5dc2c = 'JSM';
const $f75514d32e999430$export$a40257481ddef37e = 'atlassianAccount';
const $f75514d32e999430$export$d57b6b390e78d90f = 'jsm-nebula';
const $f75514d32e999430$export$85314a8fbb8155e1 = 'MONTHLY';
const $f75514d32e999430$export$d1eb58f682ad65ad = 'ANNUAL';
const $f75514d32e999430$export$1635bbf8efc1cbc4 = 'INACTIVE';
const $f75514d32e999430$export$1b63ba606d8ecfaa = 'NATIVE_CONFLUENCE';
const $f75514d32e999430$export$ce410195c34d61ac = 'SERVER_CONFLUENCE';
const $f75514d32e999430$export$2a7e16e321f5b7a0 = 'CROSS_SITE_CONFLUENCE';
const $f75514d32e999430$export$bc7192bfce222457 = 'SHAREPOINT';
const $f75514d32e999430$export$a9b78a3a2613c33a = 'GOOGLE_DRIVE';
const $f75514d32e999430$export$ff6b6c90dea66f24 = 'google-drive-connector';
const $f75514d32e999430$export$58e1cd824c9d9f35 = 'sharepoint-connector';
const $f75514d32e999430$export$5581bfec82a3629d = 'INTERNAL';
const $f75514d32e999430$export$94a3b08b4e0442dd = 'EXTERNAL';
const $f75514d32e999430$export$1d6d386752f38c08 = (0, $8oKDI.createAri)({
    resourceOwner: 'platform',
    resourceType: 'integration',
    resourceId: 'google'
});
const $f75514d32e999430$export$45909285cd85fe3d = (0, $8oKDI.createAri)({
    resourceOwner: 'platform',
    resourceType: 'integration',
    resourceId: 'microsoft'
});

});


parcelRegister("eNOs6", function(module, exports) {
$parcel$export(module.exports, "deleteTopic", () => $dad0232098306480$export$abca5685670e035c);

var $3ugTQ = parcelRequire("3ugTQ");
const $dad0232098306480$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $dad0232098306480$export$abca5685670e035c = (projectId, topicId, activationId)=>{
    return (0, $3ugTQ.performDeleteRequest)(`${$dad0232098306480$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}`);
};

});

const $350544268fbe82cc$export$d57b6b390e78d90f = 'jsm-nebula';
const $350544268fbe82cc$export$5631491ed07b4a08 = 10;
const $350544268fbe82cc$export$b8b9d90f9e5bd72b = '@atlassian/jira-servicedesk-knowledge-performance';

parcelRegister("dAJjM", function(module, exports) {
$parcel$export(module.exports, "removeTopic", () => $709aefd8fb94d875$export$fcbc6597dc84c9da);
const $709aefd8fb94d875$export$fcbc6597dc84c9da = (topics, topicId)=>topics.filter((topic)=>topic.topicId !== topicId);

});

parcelRegister("k9Ozr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bb8d3e0c6128e0f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6bb8d3e0c6128e0f$var$messages = (0, $7qGN1.defineMessages)({
    dismissTopicSuccessTitle: {
        "id": "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-success-title",
        "defaultMessage": "Removed the suggested topic"
    },
    dismissTopicErrorTitle: {
        "id": "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-title",
        "defaultMessage": "We couldn\u2019t remove the topic"
    },
    dismissTopicErrorDescription: {
        "id": "servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-description",
        "defaultMessage": "Something went wrong. Try again or refresh the page"
    }
});
var $6bb8d3e0c6128e0f$export$2e2bcd8739ae039 = $6bb8d3e0c6128e0f$var$messages;

});


parcelRegister("2uSLP", function(module, exports) {
$parcel$export(module.exports, "fetchSuggestedTopics", () => $279fb4ff2824c8fd$export$c5eac5039f8d8a0);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");


var $GylTF = parcelRequire("GylTF");
const $279fb4ff2824c8fd$export$c5eac5039f8d8a0 = (projectId, analyticsEvent, activationId)=>async ({ getState: getState, setState: setState })=>{
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    loading: true,
                    error: null
                }
            });
            const response = await (0, $GylTF.fetchSuggestedTopics)(projectId, activationId);
            setState({
                ...getState(),
                topics: {
                    data: response.topics,
                    loading: false,
                    error: null
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'fetchTopics succeeded', {
                projectId: projectId,
                noOfTopics: response.topics.length,
                isFiltered: response.isFiltered
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $350544268fbe82cc$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    data: [],
                    loading: false,
                    error: error
                }
            });
        }
    };

});
parcelRegister("GylTF", function(module, exports) {
$parcel$export(module.exports, "fetchSuggestedTopics", () => $f99ec0ef2ab8c71f$export$c5eac5039f8d8a0);

var $3ugTQ = parcelRequire("3ugTQ");
const $f99ec0ef2ab8c71f$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $f99ec0ef2ab8c71f$var$getSuggestedTopicsUrl = (projectId, activationId)=>`${$f99ec0ef2ab8c71f$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics`;
const $f99ec0ef2ab8c71f$export$c5eac5039f8d8a0 = (projectId, activationId)=>{
    const url = $f99ec0ef2ab8c71f$var$getSuggestedTopicsUrl(projectId, activationId);
    return (0, $3ugTQ.performGetRequest)(url);
};

});


parcelRegister("c5ubp", function(module, exports) {
$parcel$export(module.exports, "setPagination", () => $13aa94ebe087aba1$export$347aea62317e2398);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $13aa94ebe087aba1$export$347aea62317e2398 = (currentPage)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            page: currentPage
        });
    };

});

parcelRegister("abdL3", function(module, exports) {
$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $39303bfeb5d09c5d$export$518af6df5154b1b1);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");

var $2SGES = parcelRequire("2SGES");

var $aHFlp = parcelRequire("aHFlp");
const $39303bfeb5d09c5d$export$518af6df5154b1b1 = (topicId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId } = props;
        try {
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: null,
                                loading: true,
                                error: null
                            }
                        } : topic)
                }
            });
            const response = projectId && await (0, $aHFlp.fetchAiDraftPreviewContent)(projectId, activationId, topicId) || null;
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: response && response?.content || null,
                                loading: false,
                                error: null
                            }
                        } : topic)
                }
            });
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiDraftPreviewContent succeeded', {
                projectId: projectId,
                topicId: topicId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'fetchAiDraftPreviewContent',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $2SGES.TEAM_NAME)
                },
                error: error
            });
            setState({
                ...getState(),
                topics: {
                    ...getState().topics,
                    data: getState().topics.data.map((topic)=>topic.topicId === topicId ? {
                            ...topic,
                            aiDraftPreview: {
                                data: null,
                                loading: false,
                                error: error
                            }
                        } : topic)
                }
            });
        }
    };

});
parcelRegister("aHFlp", function(module, exports) {
$parcel$export(module.exports, "fetchAiDraftPreviewContent", () => $f6b3d55bf8415e3a$export$518af6df5154b1b1);

var $3ugTQ = parcelRequire("3ugTQ");
const $f6b3d55bf8415e3a$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $f6b3d55bf8415e3a$var$getAiDraftPreviewContentUrl = (projectId, activationId, topicId, contentFormat)=>`${$f6b3d55bf8415e3a$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}/draft-article?contentFormat=${contentFormat}`;
const $f6b3d55bf8415e3a$export$518af6df5154b1b1 = (projectId, activationId, topicId)=>{
    const contentFormat = 'text/adf';
    const url = $f6b3d55bf8415e3a$var$getAiDraftPreviewContentUrl(projectId, activationId, topicId, contentFormat);
    return (0, $3ugTQ.performGetRequest)(url);
};

});


parcelRegister("9mb2d", function(module, exports) {
$parcel$export(module.exports, "triggerArticleGenerationForTopics", () => $96ab0c26c3d6c8a9$export$7bd57fc6c7a6dd3d);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");


var $eHQcs = parcelRequire("eHQcs");
const $96ab0c26c3d6c8a9$export$7bd57fc6c7a6dd3d = (projectId, analyticsEvent, activationId)=>async ()=>{
        try {
            await (0, $eHQcs.fetchArticleGenerationForTopics)(projectId, activationId);
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'triggerArticleGenerationForTopics succeeded', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'triggerArticleGenerationForTopics',
                    packageName: 'jiraServicedeskKnowledgePerformance',
                    teamName: (0, $350544268fbe82cc$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("eHQcs", function(module, exports) {
$parcel$export(module.exports, "fetchArticleGenerationForTopics", () => $1b1c0ada2fb79c0a$export$5d2d7bed782963e7);

var $3ugTQ = parcelRequire("3ugTQ");
const $1b1c0ada2fb79c0a$var$APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $1b1c0ada2fb79c0a$export$fd5c5783cdaa5a5f = (projectId, activationId)=>`${$1b1c0ada2fb79c0a$var$APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics/draft-article/generate`;
const $1b1c0ada2fb79c0a$export$5d2d7bed782963e7 = (projectId, activationId)=>{
    const url = $1b1c0ada2fb79c0a$export$fd5c5783cdaa5a5f(projectId, activationId);
    return (0, $3ugTQ.performPostRequest)(url);
};

});



parcelRegister("lTEl5", function(module, exports) {
$parcel$export(module.exports, "getSuggestedTopics", () => $4a1d871f39fa4c7d$export$d95ddf26dc427cbd);
$parcel$export(module.exports, "getPageNumber", () => $4a1d871f39fa4c7d$export$c173ad1c1111eb41);
const $4a1d871f39fa4c7d$export$d95ddf26dc427cbd = (state)=>state.topics;
const $4a1d871f39fa4c7d$export$c173ad1c1111eb41 = (state)=>state.page;

});


parcelRegister("9OCJd", function(module, exports) {
$parcel$export(module.exports, "usePageContext", () => $0f1ed288f228d066$export$9c25024bdfe755f7);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");

var $koAZ4 = parcelRequire("koAZ4");

var $5tgJD = parcelRequire("5tgJD");
const $0f1ed288f228d066$var$getProjectContextResource = ()=>(0, $dZRaT.projectContextResourceWithCache);
const $0f1ed288f228d066$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $bo7Z6.useResourceWithCustomRouterContext)($0f1ed288f228d066$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $5tgJD.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eJOHy.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("5tgJD", function(module, exports) {
$parcel$export(module.exports, "useServiceDeskContext", () => $c0c57c7bdd281961$export$712ead87353ac687);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $bNexr = parcelRequire("bNexr");

var $bo7Z6 = parcelRequire("bo7Z6");

var $kgDPH = parcelRequire("kgDPH");
const $c0c57c7bdd281961$var$getServiceDeskContextResource = ()=>(0, $kgDPH.serviceDeskContextResource);
const $c0c57c7bdd281961$export$712ead87353ac687 = (projectKey, customContext, options)=>{
    let projectType;
    if ((0, $4cTDP.fg)('jpx-197-servicedeskcontext-check-project-type')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    projectType = (0, $bNexr.useProjectType)(projectKey ?? '');
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $bo7Z6.useResourceWithCustomRouterContext)($c0c57c7bdd281961$var$getServiceDeskContextResource(), customContext, (0, $4cTDP.fg)('handle_context_panel_issue_navigator_path') ? options : undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (!false) {
            if ((0, $4cTDP.fg)('jpx-197-servicedeskcontext-check-project-type')) // Only refresh cache if project type is SERVICE_DESK_PROJECT
            {
                if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT)) refreshCache();
            } else // Legacy behavior - always refresh cache
            refreshCache();
        }
    }, [
        projectKey,
        refreshCache,
        projectType
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("3kVLX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lRZLY").then(()=>parcelRequire('7CCUS'));

});



parcelRegister("3mrXC", function(module, exports) {
$parcel$export(module.exports, "landingPageRouteEntry", () => $1a2af95fa31b4152$export$8ccc5b384e778bac);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $loMl1 = parcelRequire("loMl1");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $5u2wi = parcelRequire("5u2wi");

var $g8uYY = parcelRequire("g8uYY");

var $dbEUp = parcelRequire("dbEUp");
const $1a2af95fa31b4152$var$landingPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dbEUp.landingEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $1a2af95fa31b4152$export$8ccc5b384e778bac = (0, $6xToB.createEntry)((0, $loMl1.landingPageRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return $1a2af95fa31b4152$var$landingPageEntryPoint;
        },
        skeleton: (0, $5u2wi.VirtualAgentLandingSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/landingPageRouteEntry.tsx',
                whichExportToUse: 'landingPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5u2wi", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentLandingSkeleton", () => $0e929a439af87fe6$export$f4b71d7b732df8a7);
/* VirtualAgentLandingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $bL0I8 = parcelRequire("bL0I8");
const $0e929a439af87fe6$var$customStyles = null;
const $0e929a439af87fe6$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bL0I8))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("bL0I8", function(module, exports) {
module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();

});


parcelRegister("dbEUp", function(module, exports) {
$parcel$export(module.exports, "landingEntryPoint", () => $f1bb2f35aa113c41$export$ad927ca7512a3a01);

var $6h0mL = parcelRequire("6h0mL");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $f1bb2f35aa113c41$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $f1bb2f35aa113c41$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $f1bb2f35aa113c41$export$ad927ca7512a3a01 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1kIL7")), {
        moduleId: "d74ef564",
        moduleName: "VirtualAgentLandingPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $6h0mL.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $f1bb2f35aa113c41$var$formatFetchDate(new Date(Date.now() - $f1bb2f35aa113c41$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $f1bb2f35aa113c41$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("6h0mL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3290f06c7451663e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<536513fe58ab8601284e081693cde16e>>
 * @relayHash ba12a427359e5d16e520af1be52586a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6c874d932e50c5f6b0294ae03b5f50be90d3d6e819ce609deb39d0ce1144c457

var $bXR9c = parcelRequire("bXR9c");

var $fUVPs = parcelRequire("fUVPs");

var $Ic6R7 = parcelRequire("Ic6R7");
const $3290f06c7451663e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6c874d932e50c5f6b0294ae03b5f50be90d3d6e819ce609deb39d0ce1144c457",
        "metadata": {},
        "name": "VirtualAgentLandingPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $Ic6R7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": (0, $fUVPs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $3290f06c7451663e$export$2e2bcd8739ae039 = $3290f06c7451663e$var$node;

});
parcelRegister("fUVPs", function(module, exports) {
$parcel$export(module.exports, "default", () => $582c441c33965029$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $582c441c33965029$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('show-next-steps-on-vsa-performance-page');
    }
};

});

parcelRegister("Ic6R7", function(module, exports) {
$parcel$export(module.exports, "default", () => $06934404485a86b2$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $06934404485a86b2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsm_va_status_header');
    }
};

});


parcelRegister("1kIL7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cLLdV").then(()=>parcelRequire('7Ne5e'));

});



parcelRegister("4SqLF", function(module, exports) {
$parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", () => $187cf9cb456facdd$export$e9cfdb950d40e917);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $lnaMp = parcelRequire("lnaMp");

var $eyNFj = parcelRequire("eyNFj");

var $iIcBn = parcelRequire("iIcBn");
const $187cf9cb456facdd$export$e9cfdb950d40e917 = (0, $6xToB.createEntry)((0, $lnaMp.legacyPlanPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $eyNFj.RedirectLegacyPlanPage),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4KrIc.advancedRoadmapsScenarioIdResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/legacyPlanPageRedirectRouteEntry.tsx',
                whichExportToUse: 'legacyPlanPageRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lnaMp", function(module, exports) {
$parcel$export(module.exports, "legacyPlanPageRedirectRoute", () => $6d8f475adb205152$export$1e324bd9675918a8);
const $6d8f475adb205152$export$1e324bd9675918a8 = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioPlanView.jspa'
};

});

parcelRegister("eyNFj", function(module, exports) {
$parcel$export(module.exports, "RedirectLegacyPlanPage", () => $0629fc505d245fd6$export$c3e4fda2290a52bf);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioIdLoadQuery", () => $0629fc505d245fd6$export$e57364775e9e9634);

var $49XDD = parcelRequire("49XDD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6OSA0 = parcelRequire("6OSA0");

var $4KrIc = parcelRequire("4KrIc");

var $7fTjp = parcelRequire("7fTjp");

var $1K1Ep = parcelRequire("1K1Ep");

var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");

var $49XDD = parcelRequire("49XDD");

var $koAZ4 = parcelRequire("koAZ4");
const $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $0629fc505d245fd6$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $4KrIc.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0629fc505d245fd6$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$b2194d886d9f3b64 = ({ queryRef: queryRef, planId: planId })=>{
    const gqlData = (0, $j4oe4.usePreloadedQuery)((0, $49XDD.default), queryRef);
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource));
    const defaultTabUrl = gqlData?.jira?.planById?.defaultNavigationItem?.url;
    if (defaultTabUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: defaultTabUrl,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
    // Fallback if can not get defaultTabUrl
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1K1Ep.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $0629fc505d245fd6$var$PERSIST_SEARCH_PARAMS
    });
};
const $0629fc505d245fd6$export$e57364775e9e9634 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { cloudId: cloudId, activationId: activationId } = (0, $koAZ4.useTenantContext)();
    const [queryRef, loadQuery, disposeQuery] = (0, $j4oe4.useQueryLoader)((0, $49XDD.default));
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery;
    }, [
        loadQuery,
        disposeQuery,
        cloudId,
        activationId,
        planId
    ]);
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0629fc505d245fd6$export$b2194d886d9f3b64, {
        queryRef: queryRef,
        planId: planId
    }) : null;
};

});
parcelRegister("49XDD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2445e06a4117db1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<513d91abcf431d67cd831934eb3cdd81>>
 * @relayHash c7ba33b8e7695997c7bbf9e29b42c7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe
const $e2445e06a4117db1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "JiraNavigationItem",
        "abstractKey": "__isJiraNavigationItem"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.planById.defaultNavigationItem"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe",
            "metadata": {},
            "name": "planNoScenarioQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e2445e06a4117db1$var$node.hash = "7791279196ac8025a83cda3fc2b29b08";
var $e2445e06a4117db1$export$2e2bcd8739ae039 = $e2445e06a4117db1$var$node;

});

parcelRegister("1K1Ep", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", () => $2e8e9348b642d506$export$42f84e610f279c31);

var $eJOHy = parcelRequire("eJOHy");

var $5ya7R = parcelRequire("5ya7R");


var $lHJi1 = parcelRequire("lHJi1");

var $ghcyi = parcelRequire("ghcyi");

var $khPJj = parcelRequire("khPJj");

var $2rgTV = parcelRequire("2rgTV");
const $2e8e9348b642d506$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, react-hooks/react-compiler
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $9bc9fcc35360d1f1$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ya7R.RedirectToLoginPage), null);
        case 0, $9bc9fcc35360d1f1$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHJi1.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $9bc9fcc35360d1f1$export$4589763db20bfd7f:
        case 0, $9bc9fcc35360d1f1$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khPJj.AsyncNotFoundErrorPage), {
                entity: (0, $9bc9fcc35360d1f1$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $9bc9fcc35360d1f1$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khPJj.AsyncNotFoundErrorPage), {
                entity: (0, $9bc9fcc35360d1f1$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $9bc9fcc35360d1f1$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ghcyi.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $9bc9fcc35360d1f1$export$1f988ace3cbe8975:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rgTV.AsyncLazyGenericErrorPage), null);
        default:
            return null;
    }
};

});
const $9bc9fcc35360d1f1$export$aa64437890e7b596 = 'permission-violation';
const $9bc9fcc35360d1f1$export$3fe2400c9d24940d = 'license-violation';
const $9bc9fcc35360d1f1$export$4589763db20bfd7f = 'plan-not-found';
const $9bc9fcc35360d1f1$export$6519152a5f0e081 = 'scenario-not-found';
const $9bc9fcc35360d1f1$export$7e6358a0c21dff8c = 'report-not-found';
const $9bc9fcc35360d1f1$export$6128dc888243fa0a = 'no-plan-permission';
const $9bc9fcc35360d1f1$export$1f988ace3cbe8975 = 'GENERIC';
const $9bc9fcc35360d1f1$export$c303e491e026ebc6 = 'PLAN';
const $9bc9fcc35360d1f1$export$9b928fc5e710e864 = 'SCENARIO';
const $9bc9fcc35360d1f1$export$b8b9d90f9e5bd72b = 'jiraSpaAppsAdvancedRoadmaps';
const $9bc9fcc35360d1f1$export$d57b6b390e78d90f = 'advanced-roadmaps';

parcelRegister("lHJi1", function(module, exports) {
$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $6e303ef7d2bed99c$export$f5d9764f07badc4d);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $6e303ef7d2bed99c$var$LazyLicenseViolationErrorPage = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("h45M8")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $6e303ef7d2bed99c$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e303ef7d2bed99c$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("h45M8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gf4mF").then(()=>parcelRequire('9GdMy'));

});


parcelRegister("ghcyi", function(module, exports) {
$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $87ae74d289795cd2$export$e595d2c5dfcb1d5a);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $87ae74d289795cd2$var$LazyNoPlanPermissionErrorPage = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("5WCgH")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $87ae74d289795cd2$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87ae74d289795cd2$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("5WCgH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4KF6S").then(()=>parcelRequire('hPioD'));

});


parcelRegister("khPJj", function(module, exports) {
$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $79f9e794c70fc463$export$8f6c907860218fdc);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $79f9e794c70fc463$var$LazyNotFoundErrorPage = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kGxmh")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $79f9e794c70fc463$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79f9e794c70fc463$var$LazyNotFoundErrorPage, props));

});
parcelRegister("kGxmh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iNh8a").then(()=>parcelRequire('5y4bu'));

});


parcelRegister("2rgTV", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyGenericErrorPage", () => $dbfe5cf5b0eacf76$export$8e4963c137216f8f);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $dbfe5cf5b0eacf76$var$LazyGenericErrorPage = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("5aZms")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/generic/index.tsx"
});
const $dbfe5cf5b0eacf76$export$8e4963c137216f8f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-arj-generic-error-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dbfe5cf5b0eacf76$var$LazyGenericErrorPage, null));

});
parcelRegister("5aZms", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bJ9de").then(()=>parcelRequire('g7lF5'));

});




parcelRegister("iIcBn", function(module, exports) {
$parcel$export(module.exports, "LazyPlanTimeline", () => $ea65241c1b4edd2f$export$bf48e5f1529ddaeb);
$parcel$export(module.exports, "default", () => $ea65241c1b4edd2f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ea65241c1b4edd2f$export$bf48e5f1529ddaeb = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4Jlwb"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
const $ea65241c1b4edd2f$var$AsyncPlanTimeline = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ea65241c1b4edd2f$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });
var $ea65241c1b4edd2f$export$2e2bcd8739ae039 = $ea65241c1b4edd2f$var$AsyncPlanTimeline;

});


parcelRegister("bRYwY", function(module, exports) {
$parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", () => $4d144feb6a840f18$export$c2a4c5c6576a704c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $4vL7T = parcelRequire("4vL7T");

var $cWxb0 = parcelRequire("cWxb0");

var $iIcBn = parcelRequire("iIcBn");
const $4d144feb6a840f18$export$c2a4c5c6576a704c = (0, $6xToB.createEntry)((0, $4vL7T.legacyPlanReportPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $cWxb0.default),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/legacyPlanReportPageRedirectRouteEntry.tsx',
                whichExportToUse: 'legacyPlanReportPageRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4vL7T", function(module, exports) {
$parcel$export(module.exports, "legacyPlanReportPageRedirectRoute", () => $1d4e7026354226c0$export$7747547e845a016c);
const $1d4e7026354226c0$export$7747547e845a016c = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioReportView.jspa'
};

});

parcelRegister("cWxb0", function(module, exports) {
$parcel$export(module.exports, "default", () => $464f19e6e477337c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
const $464f19e6e477337c$var$RedirectLegacyReportPage = ()=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};
var $464f19e6e477337c$export$2e2bcd8739ae039 = $464f19e6e477337c$var$RedirectLegacyReportPage;

});


parcelRegister("C784O", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $ab28d2b73a7a7822$export$836428e7b33b6c6c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $98adr = parcelRequire("98adr");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");
const $ab28d2b73a7a7822$export$836428e7b33b6c6c = (0, $6xToB.createEntry)((0, $98adr.legacyProjectReleasesNoteConfigRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $bMm2d.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/legacyProjectReleasesNoteConfigRouteEntry.tsx',
                whichExportToUse: 'legacyProjectReleasesNoteConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("98adr", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $0c04158b743c13bc$export$a9509017cabb1e30);
const $0c04158b743c13bc$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});

parcelRegister("bMm2d", function(module, exports) {
$parcel$export(module.exports, "BoardSettingsRedirectToCSM", () => $c91395048a6a2e4b$export$ccce5315da25c53e);
$parcel$export(module.exports, "RoadmapSettingsRedirectToTimelineSettings", () => $c91395048a6a2e4b$export$eaa324972a212c18);
$parcel$export(module.exports, "SpaReleaseNoteRedirectToVersionDetails", () => $c91395048a6a2e4b$export$52fa4fd8ca9baab5);
$parcel$export(module.exports, "LegacyFrontendReleaseNoteRedirect", () => $c91395048a6a2e4b$export$dee47264404d89a0);
$parcel$export(module.exports, "getUFOName", () => $c91395048a6a2e4b$export$759ec9adbd19c936);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $7UxjA = parcelRequire("7UxjA");

var $2mHfh = parcelRequire("2mHfh");
const $c91395048a6a2e4b$export$ccce5315da25c53e = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $c91395048a6a2e4b$export$eaa324972a212c18 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $c91395048a6a2e4b$export$52fa4fd8ca9baab5 = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $7UxjA.useProjectKeyByProjectResource)();
    if (loading === false && error) return null;
    if (loading) return null;
    if (!versionId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`,
            hash: '',
            search: ''
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $c91395048a6a2e4b$export$dee47264404d89a0 = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $c91395048a6a2e4b$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $c91395048a6a2e4b$export$759ec9adbd19c936 = (name)=>$c91395048a6a2e4b$var$ufoNamesMap[name] || name;

});
parcelRegister("7UxjA", function(module, exports) {
$parcel$export(module.exports, "useProjectKeyByProjectResource", () => $e8cc67911de41710$export$899fd1c46031ece8);

var $9pTd3 = parcelRequire("9pTd3");

var $eJrcF = parcelRequire("eJrcF");

var $dZRaT = parcelRequire("dZRaT");
const $e8cc67911de41710$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};

});



parcelRegister("6hSMD", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $d3f4428503596633$export$781dd53d465d270d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $7YSdU = parcelRequire("7YSdU");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");
const $d3f4428503596633$export$781dd53d465d270d = (0, $6xToB.createEntry)((0, $7YSdU.legacyProjectReleasesNoteRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $bMm2d.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/legacyProjectReleasesNoteRouteEntry.tsx',
                whichExportToUse: 'legacyProjectReleasesNoteRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7YSdU", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $99e8f8dd4db60f2d$export$6ef734887b6da0c8);
const $99e8f8dd4db60f2d$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("bWZUz", function(module, exports) {
$parcel$export(module.exports, "legacyRapidBoardRouteEntry", () => $78370a65b7fbd64d$export$4a5b9e48e40676ad);

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $f7JE2 = parcelRequire("f7JE2");

var $kbZYB = parcelRequire("kbZYB");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");
const $78370a65b7fbd64d$export$4a5b9e48e40676ad = (0, $6xToB.createEntry)((0, $f7JE2.legacyRapidBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-rapid-board-entries/src/legacyRapidBoardRouteEntry.tsx',
                whichExportToUse: 'legacyRapidBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("f7JE2", function(module, exports) {
$parcel$export(module.exports, "legacyRapidBoardRoute", () => $dea8f890c4b8c242$export$2bc0c59cefa2bd5e);
const $dea8f890c4b8c242$export$2bc0c59cefa2bd5e = {
    name: 'rapidboard-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ],
    __unsafeOrder: -1
};

});


parcelRegister("ihfrS", function(module, exports) {
$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $e033d289cffb5bf4$export$27f123cb9320355);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $bSgdP = parcelRequire("bSgdP");

var $7Z2hn = parcelRequire("7Z2hn");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $e033d289cffb5bf4$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z2hn.default), null);
const $e033d289cffb5bf4$export$27f123cb9320355 = (0, $6xToB.createEntry)((0, $bSgdP.legacyRedirectRoute), ()=>({
        component: $e033d289cffb5bf4$var$RedirectComponent,
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-legacy-redirect-entries/src/legacyRedirectRouteEntry.tsx',
                whichExportToUse: 'legacyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bSgdP", function(module, exports) {
$parcel$export(module.exports, "legacyRedirectRoute", () => $7bcdedfe9f3abeaa$export$176ff76c3ba7c4ce);
const $7bcdedfe9f3abeaa$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});


parcelRegister("kMe3w", function(module, exports) {
$parcel$export(module.exports, "listRouteEntry", () => $a937d5a79902b10c$export$4425668b2cd90292);

var $3MgfG = parcelRequire("3MgfG");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $gwH93 = parcelRequire("gwH93");

var $94VAY = parcelRequire("94VAY");

var $aQoXd = parcelRequire("aQoXd");

var $g8uYY = parcelRequire("g8uYY");

var $c5Vjm = parcelRequire("c5Vjm");

var $5FSZM = parcelRequire("5FSZM");

var $1PvPk = parcelRequire("1PvPk");

var $dZRaT = parcelRequire("dZRaT");

var $4VIcO = parcelRequire("4VIcO");

var $qJGcC = parcelRequire("qJGcC");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $cxKOj = parcelRequire("cxKOj");
const $a937d5a79902b10c$var$entryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c5Vjm.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $qJGcC.horizontalNavViewEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $a937d5a79902b10c$export$4425668b2cd90292 = (0, $6xToB.createEntry)((0, $94VAY.listRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9BJU1.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        entryPoint: ()=>{
            if (!(0, $cxKOj.expValEquals)('jsm_multi_project_list_view_milestone_1', 'isEnabled', true, false)) return undefined;
            return $a937d5a79902b10c$var$entryPoint;
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $5L7qx.resourceWithCondition2)(()=>!false && (0, $cxKOj.expValEquals)('jsm_multi_project_list_view_milestone_1', 'isEnabled', true, false), (0, $c0h8V.uifBoardResource))
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-list-entries/src/listRouteEntry.tsx',
                whichExportToUse: 'listRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("94VAY", function(module, exports) {
$parcel$export(module.exports, "listRoute", () => $b1e843f6fd0b635c$export$5cf62dc131f4fd3d);
const $b1e843f6fd0b635c$export$5cf62dc131f4fd3d = {
    name: 'servicedesk-list',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/list',
    exact: true
};

});

parcelRegister("c5Vjm", function(module, exports) {
$parcel$export(module.exports, "listEntryPoint", () => $dc5aa59c51159067$export$6be4f10150ff6073);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $82Jne = parcelRequire("82Jne");

var $4cTDP = parcelRequire("4cTDP");

const $dc5aa59c51159067$export$6be4f10150ff6073 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("b5A40")), {
        moduleId: "0fd85406",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const boardAri = `ari:cloud:jira-software:${cloudId}:board/${boardId}`;
        const projectKey = match.params.projectKey ?? '';
        const issueSearchInput = {
            customInput: {
                jiraSoftwareInput: {
                    jiraEntityId: boardAri,
                    additionalJql: ''
                }
            }
        };
        const fieldSetsInput = (0, $4cTDP.fg)('jsm_list_minor_bug_fixes_and_analytic_event') ? {
            viewInput: {
                namespace: 'JSM_ISSUE_NAVIGATOR',
                viewId: 'list_default',
                filterId: null
            }
        } : {
            viewInput: {
                namespace: 'JSM_ISSUE_NAVIGATOR',
                filterId: null
            }
        };
        const defaultProps = {
            first: 50,
            last: null,
            before: null,
            after: null,
            options: {
                issueKey: null
            },
            viewConfigInput: {
                staticViewInput: {
                    isHierarchyEnabled: false,
                    isGroupingEnabled: false,
                    isHideDoneEnabled: false
                }
            },
            filterId: null,
            namespace: 'JSM_ISSUE_NAVIGATOR',
            amountOfColumns: 500,
            groupBy: null,
            viewQueryInput: null,
            shouldQueryHasChildren: false,
            fieldSetsInput: fieldSetsInput,
            scope: {
                operationScope: 'NIN_PROJECT',
                projectKey: projectKey
            },
            fieldSetsScope: {
                operationScope: 'NIN_PROJECT',
                projectKey: projectKey
            },
            boardId: boardAri,
            viewId: 'list_default'
        };
        return {
            queries: {
                jsmListDataQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $82Jne.default,
                    variables: {
                        cloudId: cloudId,
                        issueSearchInput: issueSearchInput,
                        projectKey: projectKey,
                        ...defaultProps
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                projectKey: projectKey,
                issueSearchInput: issueSearchInput,
                defaultProps: defaultProps
            }
        };
    }
});

});
parcelRegister("82Jne", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b214ed8feacdf69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e3fda6bf1ff9e3fd4c1d3d82aff1aab>>
 * @relayHash c1313d18bc45d929c76ae9ba82a2ddb7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0a3acdbf62683f8ed70db16ba87059d3d4d63b71329ca57efceb5620db28c0ee

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $8Qoc7 = parcelRequire("8Qoc7");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $6b214ed8feacdf69$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0a3acdbf62683f8ed70db16ba87059d3d4d63b71329ca57efceb5620db28c0ee",
        "metadata": {},
        "name": "ListQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
        }
    }
};
var $6b214ed8feacdf69$export$2e2bcd8739ae039 = $6b214ed8feacdf69$var$node;

});

parcelRegister("b5A40", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("gIDuL")
]).then(()=>parcelRequire('5g6Tr'));

});


parcelRegister("qJGcC", function(module, exports) {
$parcel$export(module.exports, "horizontalNavViewEntrypoint", () => $1d234487fc217b81$export$47416ecfbb1a428a);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $1d234487fc217b81$export$47416ecfbb1a428a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("6tx8m")), {
        moduleId: "73476d22",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("id9nd", function(module, exports) {
$parcel$export(module.exports, "loginEmbedRouteEntry", () => $e2bffff88fa509ad$export$faa46f8c5e1f06d3);

var $eJOHy = parcelRequire("eJOHy");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dJ4f6 = parcelRequire("dJ4f6");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e2bffff88fa509ad$var$LazyLoginEmbed = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("ehDUJ")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $e2bffff88fa509ad$var$LoginEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e2bffff88fa509ad$var$LazyLoginEmbed,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $e2bffff88fa509ad$export$faa46f8c5e1f06d3 = (0, $6xToB.createEntry)((0, $dJ4f6.loginEmbedRoute), ()=>({
        group: 'errors',
        component: $e2bffff88fa509ad$var$LoginEmbed,
        layout: (0, $7K5Ea.chromelessLayout),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-login-embed-entries/src/loginEmbedRouteEntry.tsx',
                whichExportToUse: 'loginEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dJ4f6", function(module, exports) {
$parcel$export(module.exports, "loginEmbedRoute", () => $77eb0ed0591acbf9$export$9efae7a8e8e69866);
const $77eb0ed0591acbf9$export$9efae7a8e8e69866 = {
    name: 'login-embed',
    path: '/jira-login/embed'
};

});

parcelRegister("ehDUJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b8qk9").then(()=>parcelRequire('3ANMU'));

});


parcelRegister("7K8ER", function(module, exports) {
$parcel$export(module.exports, "manageProjectsDirectoryRouteEntry", () => $f8f2552c542728ef$export$d5b1a46987369ee4);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1Gd8G = parcelRequire("1Gd8G");

var $iMFdk = parcelRequire("iMFdk");

var $1F9cm = parcelRequire("1F9cm");

var $9MwFx = parcelRequire("9MwFx");

var $4qnr5 = parcelRequire("4qnr5");

var $5TrFe = parcelRequire("5TrFe");
const $f8f2552c542728ef$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4qnr5.LazyProjectsDirectory), {
        isAdminProjectDirectoryRoute: true
    });
const $f8f2552c542728ef$var$ProjectsDirectoryManageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f8f2552c542728ef$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $f8f2552c542728ef$export$d5b1a46987369ee4 = (0, $6xToB.createEntry)((0, $1Gd8G.manageProjectsDirectoryRoute), ()=>({
        group: 'directories',
        component: $f8f2552c542728ef$var$ProjectsDirectoryManageComponent,
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9MwFx.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ],
        ufoName: 'projects-directory-v3-manage',
        entryPoint () {
            return 0, $5TrFe.ProjectsDirectoryPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/manageProjectsDirectoryRouteEntry.tsx',
                whichExportToUse: 'manageProjectsDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1Gd8G", function(module, exports) {
$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $22077b66f868a2f0$export$281a4490a0f8fb4c);
const $22077b66f868a2f0$export$281a4490a0f8fb4c = {
    name: 'projects-directory-manage',
    path: '/jira/settings/projects/manage'
};

});

parcelRegister("9MwFx", function(module, exports) {
$parcel$export(module.exports, "adminProjectDirectoryResources", () => $6d80d73586b75892$export$1b29db6307155621);

var $enHI7 = parcelRequire("enHI7");

var $i9ujx = parcelRequire("i9ujx");
const $6d80d73586b75892$export$1b29db6307155621 = ()=>[
        (0, $enHI7.navigationSidebarGlobalResource),
        (0, $i9ujx.projectsDirectoryPageResource)
    ];

});
parcelRegister("i9ujx", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryPageResource", () => $f8e474e7e2c6d5a7$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $2YWby = parcelRequire("2YWby");

var $g1iDH = parcelRequire("g1iDH");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");

var $j1cyW = parcelRequire("j1cyW");

var $l1VxS = parcelRequire("l1VxS");

var $cxKOj = parcelRequire("cxKOj");

const $f8e474e7e2c6d5a7$export$aabb201a7f7100c5 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $9392429483f8560c$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $j1cyW.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $g1iDH.mapQueryToFilter)((0, $2YWby.filterInitialState), {
                cloudId: cloudId,
                query: (0, $g1iDH.sanitizeLegacyQuery)(query),
                aliases: (0, $2YWby.filterAliasMap)
            }),
            first: query?.page ? (0, $2YWby.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $2YWby.DEFAULT_LIMIT),
            last: (0, $2YWby.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === 'projects-directory-manage',
            isAnonymous: isAnonymous,
            isRecommendationsEnabled: (0, $cxKOj.expValEquals)('project_directory_relevancy_sorting_recommend', 'isEnabled', true, false)
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("2YWby", function(module, exports) {
$parcel$export(module.exports, "TableColumns", () => $53c967357c262cd2$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $53c967357c262cd2$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $53c967357c262cd2$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $53c967357c262cd2$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $53c967357c262cd2$export$fcb7b3e474e67781);
$parcel$export(module.exports, "filterInitialStateSortExp", () => $53c967357c262cd2$export$5e60406711efc54e);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $53c967357c262cd2$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $53c967357c262cd2$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $53c967357c262cd2$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $5W62K = parcelRequire("5W62K");
const $53c967357c262cd2$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $53c967357c262cd2$export$f9e740ef44a4c43a = [
    $53c967357c262cd2$export$b0e68791ad9c52df.Favourites,
    $53c967357c262cd2$export$b0e68791ad9c52df.Key,
    $53c967357c262cd2$export$b0e68791ad9c52df.Name,
    $53c967357c262cd2$export$b0e68791ad9c52df.Lead,
    $53c967357c262cd2$export$b0e68791ad9c52df.Category,
    $53c967357c262cd2$export$b0e68791ad9c52df.LastIssueUpdate
];
const $53c967357c262cd2$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $5W62K.DefaultFilterFields)
};
const $53c967357c262cd2$export$5bc0ad9873e5cd89 = {
    contains: $53c967357c262cd2$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $53c967357c262cd2$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $53c967357c262cd2$export$fcb7b3e474e67781 = {
    [$53c967357c262cd2$export$e38c2fbdcbc20613.Keyword]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectType]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.SortKey]: $53c967357c262cd2$export$b0e68791ad9c52df.Name,
    [$53c967357c262cd2$export$e38c2fbdcbc20613.Page]: '1'
};
const $53c967357c262cd2$export$5e60406711efc54e = {
    [$53c967357c262cd2$export$e38c2fbdcbc20613.Keyword]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectType]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.SortOrder]: 'DESC',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.SortKey]: 'recommendation',
    [$53c967357c262cd2$export$e38c2fbdcbc20613.Page]: '1'
};
const $53c967357c262cd2$export$ebc5ec3267fbcf57 = 25;
const $53c967357c262cd2$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $53c967357c262cd2$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("5W62K", function(module, exports) {
$parcel$export(module.exports, "DefaultFilterFields", () => $197bcec067979fbc$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $197bcec067979fbc$export$ef79d9c1dcb09f8f);

var $b5RwB = parcelRequire("b5RwB");

var $9pTd3 = parcelRequire("9pTd3");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $197bcec067979fbc$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $197bcec067979fbc$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$197bcec067979fbc$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $GtRbT.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $iJq0l.createHook)(Store);
    const useScopedFilter = (0, $iJq0l.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $6E16M.createContainer)(Store, {
        onInit: ()=>({ setState: setState }, { isAdminSettingsContext: isAdminSettingsContext })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery,
                        isAdminSettingsContext: isAdminSettingsContext
                    }));
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'keystone'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState }, { isAdminSettingsContext: isAdminSettingsContext })=>setState(getInitialState({
                    routeQuery: {},
                    isAdminSettingsContext: isAdminSettingsContext
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("g1iDH", function(module, exports) {
$parcel$export(module.exports, "sanitizeLegacyQuery", () => $2e20bdcb5aff1187$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $2e20bdcb5aff1187$export$2274cd5f35844a96);

var $4cTDP = parcelRequire("4cTDP");

var $gtr2v = parcelRequire("gtr2v");

var $cLuhM = parcelRequire("cLuhM");

var $FhXEJ = parcelRequire("FhXEJ");

var $j8Fdp = parcelRequire("j8Fdp");

var $8oKDI = parcelRequire("8oKDI");

var $2YWby = parcelRequire("2YWby");
const $2e20bdcb5aff1187$var$LEGACY_ALL_VALUE = 'all';
const $2e20bdcb5aff1187$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $2e20bdcb5aff1187$var$LEGACY_ALL_VALUE ? (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $2e20bdcb5aff1187$var$LEGACY_ALL_VALUE ? (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $2e20bdcb5aff1187$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $2YWby.FilterFields).Keyword]: keyword, [(0, $2YWby.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $2YWby.FilterFields).ProjectType]: types, [(0, $2YWby.FilterFields).SortOrder]: sortOrder, [(0, $2YWby.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $j8Fdp.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4cTDP.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $gtr2v.AnyAri).check(projectCategoryId) : (0, $8oKDI.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4cTDP.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $cLuhM.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && (0, $2YWby.SortableColumns).includes(sortKey) ? sortKey : (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $2YWby.filterInitialState)[(0, $2YWby.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $FhXEJ.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("cLuhM", function(module, exports) {
$parcel$export(module.exports, "JiraProjectCategoryAri", () => $94b15df57c4ec450$export$da484aad24207e3d);

var $2Q5Wf = parcelRequire("2Q5Wf");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project-category/manifest.ts
var $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $2Q5Wf.JiraProjectCategoryAriResourceOwner),
    resourceType: (0, $2Q5Wf.JiraProjectCategoryAriResourceType),
    resourceIdSlug: "{projectCategoryId}",
    resourceIdSegmentFormats: {
        projectCategoryId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/project-category/index.ts
var $94b15df57c4ec450$export$da484aad24207e3d = class _JiraProjectCategoryAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectCategoryId = opts.resourceIdSegmentValues.projectCategoryId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectCategoryId() {
        return this._projectCategoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.qualifier,
            platformQualifier: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.resourceOwner,
            resourceType: $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts.resourceType,
            resourceId: `${opts.projectCategoryId}`,
            resourceIdSegmentValues: {
                projectCategoryId: opts.projectCategoryId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $94b15df57c4ec450$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectCategoryId: this.projectCategoryId
        };
    }
};

});
parcelRegister("2Q5Wf", function(module, exports) {
$parcel$export(module.exports, "JiraProjectCategoryAriResourceOwner", () => $21150b6225c297d5$export$b4df372413a623f1);
$parcel$export(module.exports, "JiraProjectCategoryAriResourceType", () => $21150b6225c297d5$export$51b6f2a645c9e23a);
// src/jira/project-category/types.ts
var $21150b6225c297d5$export$b4df372413a623f1 = "jira", $21150b6225c297d5$export$51b6f2a645c9e23a = "project-category";

});


parcelRegister("j8Fdp", function(module, exports) {
$parcel$export(module.exports, "matchAliases", () => $660773f2835b6ff4$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $660773f2835b6ff4$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $660773f2835b6ff4$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $660773f2835b6ff4$export$17e142fa55464467);

var $2IQEX = parcelRequire("2IQEX");

var $8V8so = parcelRequire("8V8so");
const $660773f2835b6ff4$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $660773f2835b6ff4$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(data, (_, key)=>invertedAliases[key] || key);
};
const $660773f2835b6ff4$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $660773f2835b6ff4$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $660773f2835b6ff4$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("2IQEX", function(module, exports) {

var $9hKkF = parcelRequire("9hKkF");

var $h3TKx = parcelRequire("h3TKx");

var $d7YnM = parcelRequire("d7YnM");
/** Used for built-in method references. */ var $1fb889f558f23ac4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1fb889f558f23ac4$var$nativeObjectToString = $1fb889f558f23ac4$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $1fb889f558f23ac4$var$invert = $h3TKx(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $1fb889f558f23ac4$var$nativeObjectToString.call(value);
    result[value] = key;
}, $9hKkF($d7YnM));
module.exports = $1fb889f558f23ac4$var$invert;

});
parcelRegister("h3TKx", function(module, exports) {

var $8uipj = parcelRequire("8uipj");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $c6bdf63192b21f8e$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $8uipj(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $c6bdf63192b21f8e$var$createInverter;

});
parcelRegister("8uipj", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $62df67589f85c449$var$baseInverter(object, setter, iteratee, accumulator) {
    $75Jcs(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $62df67589f85c449$var$baseInverter;

});



parcelRegister("8V8so", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $67ea34f606cb6857$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $67ea34f606cb6857$var$mapKeys;

});



parcelRegister("j1cyW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8472ae39bb0113ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32996a9a2a05cf4fd9a00cbf71efa063>>
 * @relayHash 1cf5e269ea7ab21dd29830f41cc30471
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484

var $jhhgp = parcelRequire("jhhgp");

var $37Ewn = parcelRequire("37Ewn");
const $8472ae39bb0113ac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRecommendationsEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = {
        "alias": "canBrowseProjects",
        "args": [
            v8 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v10 = [
        {
            "kind": "Literal",
            "name": "activityField",
            "value": "UPDATED"
        },
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "days",
            "value": 180
        },
        {
            "kind": "Literal",
            "name": "limit",
            "value": 4
        }
    ], v11 = [
        v8 /*: any*/ 
    ], v12 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v21 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectDirectoryLayoutQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "Header"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "RefinementBar"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ProjectsList130BadPattern"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "EmptyView"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "NoPermissionViews"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "condition": "isRecommendationsEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectRecommendationConnection",
                                    "kind": "LinkedField",
                                    "name": "recommendProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "RecommendationsList"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ProjectDirectoryLayoutQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        v9 /*: any*/ ,
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectListRightPanelState"
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "sidebarExperimentTemplates",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "experimentKey",
                                            "value": "sidebarExperiment"
                                        }
                                    ],
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isRecommendationsEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectRecommendationConnection",
                                    "kind": "LinkedField",
                                    "name": "recommendProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectRecommendationEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectRecommendation",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "recommendationType"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "inviter",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraInviterActivityRecommendation"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484",
            "metadata": {},
            "name": "ProjectDirectoryLayoutQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default)
            }
        }
    };
}();
$8472ae39bb0113ac$var$node.hash = "81b049589e01537904d5dc6d16cc10b8";
(0, $37Ewn.PreloadableQueryRegistry).set($8472ae39bb0113ac$var$node.params.id, $8472ae39bb0113ac$var$node);
var $8472ae39bb0113ac$export$2e2bcd8739ae039 = $8472ae39bb0113ac$var$node;

});

const $9392429483f8560c$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';



parcelRegister("4qnr5", function(module, exports) {
$parcel$export(module.exports, "LazyProjectsDirectory", () => $b25739e0d466197b$export$f9ee24127b8e4a7f);

var $2dJFW = parcelRequire("2dJFW");

var $bQWwW = parcelRequire("bQWwW");

const $b25739e0d466197b$export$f9ee24127b8e4a7f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dhl7r"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});

});
parcelRegister("dhl7r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("3T2XJ")
]).then(()=>parcelRequire('afSyV'));

});


parcelRegister("5TrFe", function(module, exports) {
$parcel$export(module.exports, "ProjectsDirectoryPageEntryPoint", () => $c4ec07c725b3a5c2$export$f4985310f86f98fc);

var $g8uYY = parcelRequire("g8uYY");

var $2Gh1T = parcelRequire("2Gh1T");

var $5RW99 = parcelRequire("5RW99");

var $4EA1U = parcelRequire("4EA1U");

var $9waEc = parcelRequire("9waEc");
const $c4ec07c725b3a5c2$export$f4985310f86f98fc = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4EA1U.projectsDirectoryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    rightSidebar: (0, $2Gh1T.RecommendationsInProjectListEntryPoint),
    rightSidebarFallback: (0, $9waEc.ProjectListSidebarSkeleton)
});

});
parcelRegister("2Gh1T", function(module, exports) {
$parcel$export(module.exports, "RecommendationsInProjectListEntryPoint", () => $264c69dab599d479$export$8baad7954c0e6b8c);

var $1GcZ0 = parcelRequire("1GcZ0");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

const $264c69dab599d479$export$8baad7954c0e6b8c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("7uHKo")), {
        moduleId: "3a12ca77",
        priority: "userVisible"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps,
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $1GcZ0.default,
                    variables: {
                        cloudId: extraProps.tenantContext.cloudId,
                        isAnonymous: extraProps.tenantContext.isAnonymous,
                        isAllowingEndUsersToAccessCustomTemplates: (0, $4cTDP.fg)('allow_end_users_to_access_custom_templates')
                    }
                }
            }
        })
});

});
parcelRegister("1GcZ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6882e399275810aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5a932507584148c7318fad8cc2050fb>>
 * @relayHash dbb4fc405135e8a7a440f4a278aa8a4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51
const $6882e399275810aa$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51",
        "metadata": {},
        "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6882e399275810aa$export$2e2bcd8739ae039 = $6882e399275810aa$var$node;

});

parcelRegister("7uHKo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8brer").then(()=>parcelRequire('i5FAK'));

});


parcelRegister("4EA1U", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryEntryPoint", () => $65dfc8578404e2bf$export$80225215a10b2688);

var $4cTDP = parcelRequire("4cTDP");

var $gtr2v = parcelRequire("gtr2v");

var $cLuhM = parcelRequire("cLuhM");

var $8oKDI = parcelRequire("8oKDI");

var $kgraC = parcelRequire("kgraC");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $cxKOj = parcelRequire("cxKOj");
const $65dfc8578404e2bf$var$DEFAULT_LIMIT = 25;
const $65dfc8578404e2bf$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $65dfc8578404e2bf$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $65dfc8578404e2bf$var$TableColumns = /*#__PURE__*/ function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
    return TableColumns;
}($65dfc8578404e2bf$var$TableColumns || {});
const $65dfc8578404e2bf$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $65dfc8578404e2bf$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$65dfc8578404e2bf$var$DefaultFilterFields
};
const $65dfc8578404e2bf$var$filterAliasMap = {
    contains: $65dfc8578404e2bf$var$FilterFields.Keyword,
    selectedProjectType: $65dfc8578404e2bf$var$FilterFields.ProjectType,
    selectedCategory: $65dfc8578404e2bf$var$FilterFields.ProjectCategoryId
};
const $65dfc8578404e2bf$var$filterInitialState = {
    [$65dfc8578404e2bf$var$FilterFields.Keyword]: '',
    [$65dfc8578404e2bf$var$FilterFields.ProjectType]: '',
    [$65dfc8578404e2bf$var$FilterFields.ProjectCategoryId]: '',
    [$65dfc8578404e2bf$var$FilterFields.SortOrder]: 'ASC',
    [$65dfc8578404e2bf$var$FilterFields.SortKey]: "name",
    [$65dfc8578404e2bf$var$FilterFields.Page]: '1'
};
const $65dfc8578404e2bf$var$LEGACY_ALL_VALUE = 'all';
const $65dfc8578404e2bf$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $65dfc8578404e2bf$var$LEGACY_ALL_VALUE ? $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $65dfc8578404e2bf$var$LEGACY_ALL_VALUE ? $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $65dfc8578404e2bf$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $65dfc8578404e2bf$var$CORE_PROJECT = 'business';
const $65dfc8578404e2bf$var$SOFTWARE_PROJECT = 'software';
const $65dfc8578404e2bf$var$SERVICE_DESK_PROJECT = 'service_desk';
const $65dfc8578404e2bf$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $65dfc8578404e2bf$var$PROJECT_TYPES = [
    $65dfc8578404e2bf$var$CORE_PROJECT,
    $65dfc8578404e2bf$var$SOFTWARE_PROJECT,
    $65dfc8578404e2bf$var$SERVICE_DESK_PROJECT,
    $65dfc8578404e2bf$var$PRODUCT_DISCOVERY_PROJECT
];
const $65dfc8578404e2bf$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$65dfc8578404e2bf$var$FilterFields.Keyword]: keyword, [$65dfc8578404e2bf$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$65dfc8578404e2bf$var$FilterFields.ProjectType]: types, [$65dfc8578404e2bf$var$FilterFields.SortOrder]: sortOrder, [$65dfc8578404e2bf$var$FilterFields.SortKey]: sortKey } = aliases && query ? $65dfc8578404e2bf$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4cTDP.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $gtr2v.AnyAri).check(projectCategoryId) : (0, $8oKDI.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4cTDP.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $cLuhM.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $65dfc8578404e2bf$var$SortableColumns.includes(sortKey) ? sortKey : $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $65dfc8578404e2bf$var$filterInitialState[$65dfc8578404e2bf$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$65dfc8578404e2bf$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $65dfc8578404e2bf$export$80225215a10b2688 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("gBfDZ")), {
        moduleId: "b77224b3",
        priority: "userVisible"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $65dfc8578404e2bf$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $kgraC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $65dfc8578404e2bf$var$mapQueryToFilter($65dfc8578404e2bf$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $65dfc8578404e2bf$var$sanitizeLegacyQuery(query),
                            aliases: $65dfc8578404e2bf$var$filterAliasMap
                        }),
                        first: query?.page ? $65dfc8578404e2bf$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $65dfc8578404e2bf$var$DEFAULT_LIMIT,
                        last: $65dfc8578404e2bf$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $65dfc8578404e2bf$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous,
                        isRecommendationsEnabled: (0, $cxKOj.expValEquals)('project_directory_relevancy_sorting_recommend', 'isEnabled', true, false)
                    }
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("kgraC", function(module, exports) {
$parcel$export(module.exports, "default", () => $15e9304b56ba2c06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad3a313f762c4605692fda99cb12a006>>
 * @relayHash 1cf5e269ea7ab21dd29830f41cc30471
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484

var $jhhgp = parcelRequire("jhhgp");
const $15e9304b56ba2c06$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484",
        "metadata": {},
        "name": "ProjectDirectoryLayoutQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default)
        }
    }
};
var $15e9304b56ba2c06$export$2e2bcd8739ae039 = $15e9304b56ba2c06$var$node;

});

parcelRegister("gBfDZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("jZxab")
]).then(()=>parcelRequire('1bh7m'));

});


parcelRegister("9waEc", function(module, exports) {
$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $84327a5516097b11$export$808c25bcc6102427);
/* ProjectListSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $4eXBu = parcelRequire("4eXBu");
const $84327a5516097b11$var$customCssStyles = null;
const $84327a5516097b11$var$sidebarCssStyles = null;
const $84327a5516097b11$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_4t3i1osq _1bsb1gwv _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _t6vde4h9 _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4eXBu))),
        className: (0, $hcewu.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("4eXBu", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});




parcelRegister("hefqI", function(module, exports) {
$parcel$export(module.exports, "mergeTeamsRouteEntry", () => $91be28aacb28d211$export$ca943a326e5fc7f);

var $7mF43 = parcelRequire("7mF43");

var $dgKsy = parcelRequire("dgKsy");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fXF6E = parcelRequire("fXF6E");

var $dIyBX = parcelRequire("dIyBX");

var $4cTDP = parcelRequire("4cTDP");

var $kSeQy = parcelRequire("kSeQy");

var $9BJU1 = parcelRequire("9BJU1");

var $g8uYY = parcelRequire("g8uYY");
const $91be28aacb28d211$var$mergeTeamsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dIyBX.mergeTeamsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $91be28aacb28d211$export$ca943a326e5fc7f = (0, $6xToB.createEntry)((0, $dgKsy.mergeTeamsRoute), ()=>({
        group: 'eoc',
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>{
            if (!(0, $4cTDP.fg)('enable_jsm_operation_team_merge')) return 0, $kSeQy.notFoundPageEntrypoint;
            return $91be28aacb28d211$var$mergeTeamsPageEntryPoint;
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION,
            sidebar: (0, $fXF6E.default)
        },
        pageId: 'eoc-merge-teams',
        meta: {
            reporting: {
                id: 'eoc.merge-teams',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('eoc-merge-teams'),
                teamName: 'Alexstrasza'
            }
        },
        component: (0, $9BJU1.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-merge-teams-entries/src/mergeTeamsRouteEntry.tsx',
                whichExportToUse: 'mergeTeamsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dgKsy", function(module, exports) {
$parcel$export(module.exports, "mergeTeamsRoute", () => $39dc57f88bf9b7b3$export$bce6d6357998d903);
const $39dc57f88bf9b7b3$export$bce6d6357998d903 = {
    name: 'eoc-merge-teams',
    path: '/jira/settings/products/ops/merge-teams',
    exact: true
};

});

parcelRegister("dIyBX", function(module, exports) {
$parcel$export(module.exports, "mergeTeamsEntryPoint", () => $3c2b6c4e5140c6e0$export$4b7e3ec02acf92fe);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $3c2b6c4e5140c6e0$export$4b7e3ec02acf92fe = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("lXSr3")), {
        moduleId: "974c5c0a",
        moduleName: "MergeTeams",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lXSr3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("w6Uy8").then(()=>parcelRequire('gLFT8'));

});



parcelRegister("bIDIn", function(module, exports) {
$parcel$export(module.exports, "newRovoSearchRouteEntry", () => $316a3a3609d5a1b2$export$33531d48a743e2a6);

var $eJOHy = parcelRequire("eJOHy");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $6nUEc = parcelRequire("6nUEc");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $316a3a3609d5a1b2$var$LazyRovoSearchPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("f1eus"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $316a3a3609d5a1b2$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $316a3a3609d5a1b2$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $316a3a3609d5a1b2$export$33531d48a743e2a6 = (0, $6xToB.createEntry)((0, $6nUEc.newRovoSearchRoute), ()=>({
        group: 'search',
        ufoName: 'search-page',
        component: $316a3a3609d5a1b2$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            $316a3a3609d5a1b2$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-rovo-search-entries/src/newRovoSearchRouteEntry.tsx',
                whichExportToUse: 'newRovoSearchRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6nUEc", function(module, exports) {
$parcel$export(module.exports, "newRovoSearchRoute", () => $4ec5a31945e81951$export$595a3e6b7223948e);
const $4ec5a31945e81951$export$595a3e6b7223948e = {
    name: 'jira-rovo-search-new',
    path: '/jira/rovo-search',
    exact: true
};

});

parcelRegister("f1eus", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVX56"),
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("fliVL"),
    $ewTvA("hPjL9")
]).then(()=>parcelRequire('eG7sb'));

});


parcelRegister("iaJjO", function(module, exports) {
$parcel$export(module.exports, "notificationLogsRouteEntry", () => $aacecaf172ec0466$export$20ab3a955246df95);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jodhV = parcelRequire("jodhV");

var $aQoXd = parcelRequire("aQoXd");

var $j74Q1 = parcelRequire("j74Q1");
const $aacecaf172ec0466$export$20ab3a955246df95 = (0, $6xToB.createEntry)((0, $jodhV.notificationLogsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $j74Q1.NotificationLogs),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $j74Q1.LazyNotificationLogs)
        ],
        perfMetricKey: 'jsm-notification-logs-component-load',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-notification-logs-entries/src/notificationLogsRouteEntry.tsx',
                whichExportToUse: 'notificationLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jodhV", function(module, exports) {
$parcel$export(module.exports, "notificationLogsRoute", () => $f77455bc7881df50$export$c947c80f138bc137);
const $f77455bc7881df50$export$c947c80f138bc137 = {
    name: 'notification-logs',
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("j74Q1", function(module, exports) {
$parcel$export(module.exports, "LazyNotificationLogs", () => $7f59ff5068e2430a$export$69cba5247233f8bc);
$parcel$export(module.exports, "NotificationLogs", () => $7f59ff5068e2430a$export$1139895a5af7252e);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7f59ff5068e2430a$export$69cba5247233f8bc = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j6jVA"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $7f59ff5068e2430a$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7f59ff5068e2430a$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });

});
parcelRegister("j6jVA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("49weW").then(()=>parcelRequire('dAq4f'));

});



parcelRegister("flrMb", function(module, exports) {
$parcel$export(module.exports, "notificationsPersonalSettingsRouteEntry", () => $eb4c0f4709229790$export$640c1b3b96c9032e);

var $eJOHy = parcelRequire("eJOHy");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $bxWdr = parcelRequire("bxWdr");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $53QWl = parcelRequire("53QWl");

var $7fTjp = parcelRequire("7fTjp");

var $eb6BR = parcelRequire("eb6BR");

var $72GuB = parcelRequire("72GuB");
const $eb4c0f4709229790$var$personalSettingsNotificationsEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $72GuB.personalSettingsNotificationsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).NOTIFICATIONS
});
const $eb4c0f4709229790$export$640c1b3b96c9032e = (0, $6xToB.createEntry)((0, $53QWl.notificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        skeleton: (0, $eb6BR.PersonalSettingsNotificationsAppSkeleton),
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: (0, $bxWdr.getNotificationsPersonalSettingsPath)()
            }),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        pageId: 'personal-settings-notifications',
        entryPoint () {
            return $eb4c0f4709229790$var$personalSettingsNotificationsEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-personal-settings-entries/src/notificationsPersonalSettingsRouteEntry.tsx',
                whichExportToUse: 'notificationsPersonalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bxWdr", function(module, exports) {
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $07c184ad65442c98$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $07c184ad65442c98$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $07c184ad65442c98$export$1a7321c4210a3049);
const $07c184ad65442c98$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $07c184ad65442c98$export$a974f4af282a75ba = '/jira/settings/personal';
const $07c184ad65442c98$export$693b70d1bcef8627 = `${$07c184ad65442c98$export$a974f4af282a75ba}/general`;
const $07c184ad65442c98$export$21946ea4c58fd4c9 = `${$07c184ad65442c98$export$a974f4af282a75ba}/notifications`;
const $07c184ad65442c98$export$cff16c3a6aa7a3a9 = `${$07c184ad65442c98$export$a974f4af282a75ba}/digests`;
const $07c184ad65442c98$export$1fffbb6055aa320a = `${$07c184ad65442c98$export$a974f4af282a75ba}/apps`;
const $07c184ad65442c98$export$2321c59d517801c8 = `${$07c184ad65442c98$export$a974f4af282a75ba}/alert-notifications`;
function $07c184ad65442c98$export$db9e3ccc1e5e3317() {
    return $07c184ad65442c98$export$693b70d1bcef8627;
}
function $07c184ad65442c98$export$88a45ae8c4b1c664() {
    return $07c184ad65442c98$export$2321c59d517801c8;
}
function $07c184ad65442c98$export$64a672523a583594() {
    return $07c184ad65442c98$export$21946ea4c58fd4c9;
}
function $07c184ad65442c98$export$1a7321c4210a3049() {
    return $07c184ad65442c98$export$1fffbb6055aa320a;
}

});

parcelRegister("53QWl", function(module, exports) {
$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $0c0a4761dab0c29b$export$55ab09b9d6beb8be);
const $0c0a4761dab0c29b$export$55ab09b9d6beb8be = {
    name: 'personal-settings-notifications',
    path: '/jira/settings/personal/notifications'
};

});

parcelRegister("eb6BR", function(module, exports) {
$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $131ead9e22be457b$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $131ead9e22be457b$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $131ead9e22be457b$export$8cb773cb6fc17338);
/* PersonalSettingsNotificationsAppSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6umqd = parcelRequire("6umqd");

var $16Hv8 = parcelRequire("16Hv8");

var $jNS7j = parcelRequire("jNS7j");

var $7nBQE = parcelRequire("7nBQE");

var $8BZNC = parcelRequire("8BZNC");
const $131ead9e22be457b$var$maxWidthCssStyles = null;
const $131ead9e22be457b$var$customCssStyles = null;
const $131ead9e22be457b$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7nBQE))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f8stt"
        ])
    });
const $131ead9e22be457b$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($131ead9e22be457b$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($16Hv8))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    }));
const $131ead9e22be457b$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($131ead9e22be457b$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jNS7j))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    }));
const $131ead9e22be457b$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($131ead9e22be457b$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BZNC))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $131ead9e22be457b$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("16Hv8", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("jNS7j", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("7nBQE", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("8BZNC", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});


parcelRegister("72GuB", function(module, exports) {
$parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", () => $611e3debee5346a6$export$44d710abd316d1f1);

var $cluCZ = parcelRequire("cluCZ");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $611e3debee5346a6$export$44d710abd316d1f1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("kGj3F")), {
        moduleId: "fe0c927e",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $cluCZ.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("cluCZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b45afeef9d23fd2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d90926d53427ea9177e55cce84d06f94>>
 * @relayHash 8df6ed3ca3de7f1679849a93c0559b51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de2ef332b28ff532d0a9a01b358aa15741c014c8b93ee581d3f727e11c8cab94

var $f3FK6 = parcelRequire("f3FK6");
const $b45afeef9d23fd2b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "de2ef332b28ff532d0a9a01b358aa15741c014c8b93ee581d3f727e11c8cab94",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $f3FK6.default)
            }
        }
    };
}();
$b45afeef9d23fd2b$var$node.hash = "b001322577b49b90b0c0e44082f4b2b8";
var $b45afeef9d23fd2b$export$2e2bcd8739ae039 = $b45afeef9d23fd2b$var$node;

});
parcelRegister("f3FK6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a267137a7d680f8d$export$2e2bcd8739ae039);
var $a267137a7d680f8d$export$2e2bcd8739ae039 = {
    get () {
        return true;
    }
};

});


parcelRegister("kGj3F", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7nT3z").then(()=>parcelRequire('3f2BD'));

});



parcelRegister("10xT1", function(module, exports) {
$parcel$export(module.exports, "oldJiraHomeRouteEntry", () => $d8ae084afb2a1124$export$a9f6f4dd735b1a50);

var $hIzUD = parcelRequire("hIzUD");

var $dDHhl = parcelRequire("dDHhl");

var $kHlOR = parcelRequire("kHlOR");

var $dI30d = parcelRequire("dI30d");

var $4cTDP = parcelRequire("4cTDP");

var $4ZkZK = parcelRequire("4ZkZK");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");


var $4VIcO = parcelRequire("4VIcO");

var $iDAU4 = parcelRequire("iDAU4");

var $80Ye8 = parcelRequire("80Ye8");

var $9NmsS = parcelRequire("9NmsS");

var $fs2Be = parcelRequire("fs2Be");

var $5fjzQ = parcelRequire("5fjzQ");

var $5L7qx = parcelRequire("5L7qx");

var $5gjY4 = parcelRequire("5gjY4");

var $cxKOj = parcelRequire("cxKOj");

var $2emAF = parcelRequire("2emAF");

var $giQoM = parcelRequire("giQoM");

var $jnds2 = parcelRequire("jnds2");

var $bzIap = parcelRequire("bzIap");
const $d8ae084afb2a1124$var$conditionalPostOfficeJiraYourWorkResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5fjzQ.postOfficeJiraYourWorkResource));
const $d8ae084afb2a1124$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $5L7qx.resourceWithCondition2)(()=>(0, $cxKOj.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $80Ye8.jiraHomeWorkSuggestionsIsDeveloperResource));
const $d8ae084afb2a1124$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dI30d.checkShouldUseJSM)(data);
};
const $d8ae084afb2a1124$export$a9f6f4dd735b1a50 = (0, $6xToB.createEntry)((0, $fs2Be.oldJiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: (0, $bzIap.ConditionalJiraHome),
        skeleton: (0, $5gjY4.YourWorkSkeleton),
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).HOME
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $iDAU4.jiraHomeResourceWithCache),
            (0, $4ZkZK.jiraHomePageRightSidePanelResource),
            $d8ae084afb2a1124$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $hIzUD.widgetResources).map((resourceCreator)=>resourceCreator($d8ae084afb2a1124$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ])),
            ...(0, $dDHhl.widgetResources).map((resourceCreator)=>resourceCreator($d8ae084afb2a1124$var$checkConsolidationOnRouteDependency, [
                    (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
                ])),
            $d8ae084afb2a1124$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource,
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_portal_widget'), (0, $giQoM.fetchSiteUserTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_portal_widget'), (0, $2emAF.fetchSiteTraitsResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jsm_portal_widget'), (0, $jnds2.widgetDismissedStateResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bzIap.LazyJiraHomePage)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-jira-home-entries/src/oldJiraHomeRouteEntry.tsx',
                whichExportToUse: 'oldJiraHomeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bzIap", function(module, exports) {
$parcel$export(module.exports, "LazyJiraHomePage", () => $a07f43cc0d67a23c$export$72fc07b51a2e705d);
$parcel$export(module.exports, "ConditionalJiraHome", () => $a07f43cc0d67a23c$export$27e85db2fde321c7);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $1F9cm = parcelRequire("1F9cm");

var $2dJFW = parcelRequire("2dJFW");

var $bQWwW = parcelRequire("bQWwW");

var $7fTjp = parcelRequire("7fTjp");

const $a07f43cc0d67a23c$export$72fc07b51a2e705d = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5oURf"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
// This component will redirect users from /jira/your-work to /jira/for-you.
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event.
// We can remove this component once the frequency of the operational event is 0.
const $a07f43cc0d67a23c$var$YourWorkRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/for-you"
    });
const $a07f43cc0d67a23c$export$27e85db2fde321c7 = ()=>{
    return (0, $4cTDP.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a07f43cc0d67a23c$var$YourWorkRedirect, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a07f43cc0d67a23c$export$72fc07b51a2e705d,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
};

});


parcelRegister("5oAgu", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRedirectRouteEntry", () => $9aab4de5c0b54ba6$export$75f0bcae97d54ba0);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $kPEES = parcelRequire("kPEES");

var $c6XPK = parcelRequire("c6XPK");
const $9aab4de5c0b54ba6$export$75f0bcae97d54ba0 = (0, $6xToB.createEntry)((0, $kPEES.opsgenieScheduleRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $c6XPK.OpsgenieScheduleRedirect) : (0, $c6XPK.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c6XPK.LazyOpsGenieSchedule)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-opsgenie-schedule-entries/src/opsgenieScheduleRedirectRouteEntry.tsx',
                whichExportToUse: 'opsgenieScheduleRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kPEES", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRedirectRoute", () => $9a227644729c3a18$export$5d29dbb36868dff4);
const $9a227644729c3a18$export$5d29dbb36868dff4 = {
    name: 'opsgenie-schedule-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};

});

parcelRegister("c6XPK", function(module, exports) {
$parcel$export(module.exports, "LazyOpsGenieSchedule", () => $5f4a9676e544329c$export$3a9c3ff70731bdd6);
$parcel$export(module.exports, "OpsgenieScheduleRedirect", () => $5f4a9676e544329c$export$6ffd640c3062d976);
$parcel$export(module.exports, "default", () => $5f4a9676e544329c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $hOUP7 = parcelRequire("hOUP7");

const $5f4a9676e544329c$export$3a9c3ff70731bdd6 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eECUW"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $5f4a9676e544329c$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOUP7.RedirectToProjectType), {
        page: "/on-call-schedule"
    });
const $5f4a9676e544329c$var$AsyncOpsGenieSchedule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5f4a9676e544329c$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });
var $5f4a9676e544329c$export$2e2bcd8739ae039 = $5f4a9676e544329c$var$AsyncOpsGenieSchedule;

});
parcelRegister("hOUP7", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $b00624fae0377dae$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $b00624fae0377dae$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $kRgKj.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $3lhVL.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $FhXEJ.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $FhXEJ.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("eECUW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ftSMY").then(()=>parcelRequire('7DSXR'));

});



parcelRegister("k5e75", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRouteEntry", () => $07eff9f31f86dece$export$f128c1c4a1f0d631);

var $7mF43 = parcelRequire("7mF43");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $6lnLI = parcelRequire("6lnLI");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $c6XPK = parcelRequire("c6XPK");
const $07eff9f31f86dece$export$f128c1c4a1f0d631 = (0, $6xToB.createEntry)((0, $6lnLI.opsgenieScheduleRoute), ()=>({
        group: 'components',
        ufoName: 'project-opsgenie-schedule',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $c6XPK.default)),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ],
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c6XPK.LazyOpsGenieSchedule)
        ],
        meta: {
            reporting: {
                id: 'opsgenie-schedule',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('opsgenie-schedule'),
                teamName: 'fusion-solaris'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-opsgenie-schedule-entries/src/opsgenieScheduleRouteEntry.tsx',
                whichExportToUse: 'opsgenieScheduleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6lnLI", function(module, exports) {
$parcel$export(module.exports, "opsgenieScheduleRoute", () => $e3f20b049973159c$export$534a7ac096cb1da2);
const $e3f20b049973159c$export$534a7ac096cb1da2 = {
    name: 'opsgenie-schedule',
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};

});


parcelRegister("leBbj", function(module, exports) {
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRouteEntry", () => $1f71e65410b21a76$export$407513e3bdb49efe);

var $eJOHy = parcelRequire("eJOHy");

var $k3OCS = parcelRequire("k3OCS");

var $j3mZ1 = parcelRequire("j3mZ1");

var $6wCSD = parcelRequire("6wCSD");parcelRequire("1DrRY");
var $igkn1 = parcelRequire("igkn1");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $eaZMD = parcelRequire("eaZMD");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $cTPJz = parcelRequire("cTPJz");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $iRfwO = parcelRequire("iRfwO");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f71e65410b21a76$var$LazyOpsNotificationsPersonalSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2BKLB"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $1f71e65410b21a76$var$OpsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f71e65410b21a76$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $1f71e65410b21a76$export$407513e3bdb49efe = (0, $6xToB.createEntry)((0, $cTPJz.opsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $1f71e65410b21a76$var$OpsNotificationsPersonalSettingsComponent,
        layout: (0, $iRfwO.opsNotificationsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE,
            sidebar: (0, $eaZMD.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $k3OCS.createContactsResource)(),
            (0, $6wCSD.createNotificationPreferencesResource)(),
            (0, $igkn1.eocUserResource),
            (0, $j3mZ1.createMuteResource)(),
            (0, $j3mZ1.createQuietHoursResource)(),
            (0, $6wCSD.createForwardingRulesResource)(),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $1f71e65410b21a76$var$LazyOpsNotificationsPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-personal-settings-entries/src/opsNotificationsPersonalSettingsRouteEntry.tsx',
                whichExportToUse: 'opsNotificationsPersonalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cTPJz", function(module, exports) {
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $518284761c100d08$export$68ebdd4eccb7b383);
const $518284761c100d08$export$68ebdd4eccb7b383 = {
    name: 'personal-settings-ops-notifications',
    path: '/jira/settings/personal/alert-notifications'
};

});

parcelRegister("2BKLB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gFb32")
]).then(()=>parcelRequire('goaXA'));

});


parcelRegister("jlwtU", function(module, exports) {
$parcel$export(module.exports, "peopleProfilesRouteEntry", () => $c87b6188b9371f43$export$219b6cc00b2f91a0);

var $3MgfG = parcelRequire("3MgfG");

var $cxKOj = parcelRequire("cxKOj");

var $7h3uc = parcelRequire("7h3uc");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $eYvz3 = parcelRequire("eYvz3");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $eR19P = parcelRequire("eR19P");

var $aQoXd = parcelRequire("aQoXd");

var $7c6fJ = parcelRequire("7c6fJ");
const $c87b6188b9371f43$var$peopleProfilesPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $7c6fJ.peopleProfilesEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PEOPLE,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $c87b6188b9371f43$export$219b6cc00b2f91a0 = (0, $6xToB.createEntry)((0, $eR19P.peopleProfilesRoute), ()=>({
        group: 'people-profiles',
        layout: (0, $eYvz3.layoutWithCondition)(()=>(0, $cxKOj.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $aQoXd.rightSidebarsLayout), (0, $7h3uc.globalLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'people-profiles',
        entryPoint: ()=>$c87b6188b9371f43$var$peopleProfilesPageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-people-profiles-entries/src/peopleProfilesRouteEntry.tsx',
                whichExportToUse: 'peopleProfilesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eYvz3", function(module, exports) {
$parcel$export(module.exports, "layoutWithCondition", () => $169a9523cff11418$export$c5db53e93ba35c0f);
const $169a9523cff11418$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});

parcelRegister("eR19P", function(module, exports) {
$parcel$export(module.exports, "peopleProfilesRoute", () => $48616684057e2867$export$1338132568be849);
const $48616684057e2867$export$1338132568be849 = {
    name: 'people-index',
    path: '/jira/people/:subPath?'
};

});

parcelRegister("7c6fJ", function(module, exports) {
$parcel$export(module.exports, "peopleProfilesEntrypoint", () => $f72e7f8385be0ad5$export$26daeb77c71acf79);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $f72e7f8385be0ad5$export$26daeb77c71acf79 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("knNff")), {
        moduleId: "871dfc54",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("knNff", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVX56"),
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("fliVL"),
    $ewTvA("3FR8F")
]).then(()=>parcelRequire('4I8rL'));

});



parcelRegister("3yeCC", function(module, exports) {
$parcel$export(module.exports, "performanceRouteEntry", () => $8bb4e40fdd7ce358$export$3f75a1735cbe5a04);

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gjR2w = parcelRequire("gjR2w");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $g8uYY = parcelRequire("g8uYY");

var $9ycIa = parcelRequire("9ycIa");

var $cAYFR = parcelRequire("cAYFR");
const $8bb4e40fdd7ce358$var$performancePageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9ycIa.performanceEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $8bb4e40fdd7ce358$export$3f75a1735cbe5a04 = (0, $6xToB.createEntry)((0, $gjR2w.performanceRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $8bb4e40fdd7ce358$var$performancePageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/performanceRouteEntry.tsx',
                whichExportToUse: 'performanceRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gjR2w", function(module, exports) {
$parcel$export(module.exports, "performanceRoute", () => $5ba6af24b39eb448$export$d867623f05adedb3);
const $5ba6af24b39eb448$export$d867623f05adedb3 = {
    name: 'project-settings-servicedesk-virtualagent-performance',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
};

});

parcelRegister("9ycIa", function(module, exports) {
$parcel$export(module.exports, "performanceEntryPoint", () => $3d4f3159d5c93a35$export$52b48527e9315b46);

var $6FG7b = parcelRequire("6FG7b");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $3d4f3159d5c93a35$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $3d4f3159d5c93a35$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $3d4f3159d5c93a35$export$52b48527e9315b46 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7p7KR")), {
        moduleId: "64afc14e",
        moduleName: "VirtualAgentPerformance",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $6FG7b.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: $3d4f3159d5c93a35$var$formatFetchDate(new Date(Date.now() - $3d4f3159d5c93a35$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $3d4f3159d5c93a35$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("6FG7b", function(module, exports) {
$parcel$export(module.exports, "default", () => $dec3927758d8cd0c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36906fae269f267c44c365aaca246518>>
 * @relayHash 389af168eb0543cdf47ad388e5fca725
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c904a3e08be2badecee1d367fc8c81c57b3bad9c725d082c699aa71f3a2477bb

var $bXR9c = parcelRequire("bXR9c");

var $fUVPs = parcelRequire("fUVPs");

var $Ic6R7 = parcelRequire("Ic6R7");
const $dec3927758d8cd0c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c904a3e08be2badecee1d367fc8c81c57b3bad9c725d082c699aa71f3a2477bb",
        "metadata": {},
        "name": "VirtualAgentPerformanceQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $Ic6R7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": (0, $fUVPs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $dec3927758d8cd0c$export$2e2bcd8739ae039 = $dec3927758d8cd0c$var$node;

});

parcelRegister("7p7KR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9IX5A").then(()=>parcelRequire('fkf6J'));

});



parcelRegister("4FBBR", function(module, exports) {
$parcel$export(module.exports, "personalSettingsRouteEntry", () => $6cc27bb4c73249de$export$89646e32fa7698db);

var $eJOHy = parcelRequire("eJOHy");

var $k3OCS = parcelRequire("k3OCS");

var $j3mZ1 = parcelRequire("j3mZ1");

var $6wCSD = parcelRequire("6wCSD");parcelRequire("1DrRY");
var $igkn1 = parcelRequire("igkn1");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $bxWdr = parcelRequire("bxWdr");

var $6xToB = parcelRequire("6xToB");


var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $9Ocri = parcelRequire("9Ocri");

var $7fTjp = parcelRequire("7fTjp");

var $2dJFW = parcelRequire("2dJFW");

var $bQWwW = parcelRequire("bQWwW");

var $5HRxi = parcelRequire("5HRxi");

var $2hhQE = parcelRequire("2hhQE");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6cc27bb4c73249de$var$LazyLegacyPersonalSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jLQkY"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $6cc27bb4c73249de$export$89646e32fa7698db = (0, $6xToB.createEntry)((0, $9Ocri.personalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: (0, $bxWdr.GENERAL_PERSONAL_SETTINGS_PATH)
            }),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROFILE
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $k3OCS.createContactsResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $6wCSD.createNotificationPreferencesResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $igkn1.eocUserResource),
            (0, $j3mZ1.createMuteResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $j3mZ1.createQuietHoursResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            (0, $6wCSD.createForwardingRulesResource)((0, $5HRxi.checkConsolidationOnRouteDependency), [
                (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
            ]),
            ...(0, $hHbzj.getNavigationForgePersonalSettingsPageResources)(),
            ...(0, $2hhQE.getLabsResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $6cc27bb4c73249de$var$LazyLegacyPersonalSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-personal-settings-entries/src/personalSettingsRouteEntry.tsx',
                whichExportToUse: 'personalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9Ocri", function(module, exports) {
$parcel$export(module.exports, "personalSettingsRoute", () => $14fda5cb5a1c3334$export$176d0935b95c75e8);
const $14fda5cb5a1c3334$export$176d0935b95c75e8 = {
    name: 'personal-settings',
    path: '/secure/ViewPersonalSettings.jspa'
};

});

parcelRegister("5HRxi", function(module, exports) {
$parcel$export(module.exports, "checkConsolidationOnRouteDependency", () => $95d678804dd4af9e$export$ac86a769188afd33);

var $dI30d = parcelRequire("dI30d");

const $95d678804dd4af9e$export$ac86a769188afd33 = (dependencies)=>{
    const { data: data } = dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dI30d.checkShouldUseJSM)(data);
};

});

parcelRegister("jLQkY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("jmyQZ")
]).then(()=>parcelRequire('7xDLz'));

});


parcelRegister("d5Bb9", function(module, exports) {
$parcel$export(module.exports, "piCreateIssueEmbedRouteEntry", () => $b0dd566c4fdad3c0$export$7f9ffa2e2d102ba);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $aV23b = parcelRequire("aV23b");

var $1F9cm = parcelRequire("1F9cm");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $fJ3AM = parcelRequire("fJ3AM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b0dd566c4fdad3c0$var$LazyPICreateIssueEmbed = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2z6Vr")).then((module)=>module.CreateIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/create-issue/index.tsx"
});
const $b0dd566c4fdad3c0$var$PIIssueCreateEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b0dd566c4fdad3c0$var$LazyPICreateIssueEmbed,
        pageId: "spa-apps/pi-issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $b0dd566c4fdad3c0$export$7f9ffa2e2d102ba = (0, $6xToB.createEntry)((0, $fJ3AM.piCreateIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $b0dd566c4fdad3c0$var$PIIssueCreateEmbedLazy,
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            $b0dd566c4fdad3c0$var$LazyPICreateIssueEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-product-integrations-entries/src/piCreateIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'piCreateIssueEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fJ3AM", function(module, exports) {
$parcel$export(module.exports, "piCreateIssueEmbedRoute", () => $ff79665c583f0923$export$e38c7e6f5c65691b);
const $ff79665c583f0923$export$e38c7e6f5c65691b = {
    name: 'pi-issue-create-embed',
    path: '/jira/issues/create/pi/embed'
};

});

parcelRegister("2z6Vr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Sqz1").then(()=>parcelRequire('8sEmV'));

});


parcelRegister("jSGUL", function(module, exports) {
$parcel$export(module.exports, "piEditIssueEmbedRouteEntry", () => $fb4ddde01355fb1f$export$54fd859765926fb);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $gDv39 = parcelRequire("gDv39");

var $aV23b = parcelRequire("aV23b");

var $1F9cm = parcelRequire("1F9cm");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fb4ddde01355fb1f$var$LazyPIEditIssueEmbed = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jNOFB")).then((module)=>module.EditIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/edit-issue/index.tsx"
});
const $fb4ddde01355fb1f$var$PIIssueEditEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fb4ddde01355fb1f$var$LazyPIEditIssueEmbed,
        pageId: "spa-apps/pi-issue-edit-embed",
        shouldShowSpinner: true
    }));
};
const $fb4ddde01355fb1f$export$54fd859765926fb = (0, $6xToB.createEntry)((0, $gDv39.piEditIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $fb4ddde01355fb1f$var$PIIssueEditEmbedLazy,
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            $fb4ddde01355fb1f$var$LazyPIEditIssueEmbed
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-product-integrations-entries/src/piEditIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'piEditIssueEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gDv39", function(module, exports) {
$parcel$export(module.exports, "piEditIssueEmbedRoute", () => $fedc5372da6a666b$export$963ebe9ee36e7e80);
const $fedc5372da6a666b$export$963ebe9ee36e7e80 = {
    name: 'pi-issue-edit-embed',
    path: '/jira/issues/edit/pi/embed'
};

});

parcelRegister("jNOFB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kQxrB").then(()=>parcelRequire('hfWkk'));

});


parcelRegister("bJXfU", function(module, exports) {
$parcel$export(module.exports, "planExportPageRouteEntry", () => $f4c659427106761d$export$d751e3552b21c604);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $gmdNY = parcelRequire("gmdNY");

var $1F9cm = parcelRequire("1F9cm");

var $dIOB1 = parcelRequire("dIOB1");

var $iIcBn = parcelRequire("iIcBn");
/**
 * Export Page
 */ const $f4c659427106761d$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIOB1.LazyAdvancedRoadmapsPlanExport), null);
const $f4c659427106761d$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f4c659427106761d$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $f4c659427106761d$export$d751e3552b21c604 = (0, $6xToB.createEntry)((0, $gmdNY.planExportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario-export',
        component: $f4c659427106761d$var$ExportPage,
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planExportPageRouteEntry.tsx',
                whichExportToUse: 'planExportPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gmdNY", function(module, exports) {
$parcel$export(module.exports, "planExportPageRoute", () => $cc26ecc755c8471e$export$2ca5fe6f9ab466c1);
const $cc26ecc755c8471e$export$2ca5fe6f9ab466c1 = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};

});

parcelRegister("dIOB1", function(module, exports) {
$parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", () => $3e87659d9da32d1a$export$890fb5003e472449);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3e87659d9da32d1a$export$890fb5003e472449 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gXLXR"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
const $3e87659d9da32d1a$var$AsyncAdvancedRoadmapsPlanExport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3e87659d9da32d1a$export$890fb5003e472449,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });
var $3e87659d9da32d1a$export$2e2bcd8739ae039 = $3e87659d9da32d1a$var$AsyncAdvancedRoadmapsPlanExport;

});
parcelRegister("gXLXR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("axQy8")),
    $ewTvA("fliVL"),
    $ewTvA("i4pTJ")
]).then(()=>parcelRequire('5cOsz'));

});



parcelRegister("k3Rn6", function(module, exports) {
$parcel$export(module.exports, "planIncrementRouteEntry", () => $fea70cfa465a677a$export$a26fa5cabff8bc7c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $eK8LX = parcelRequire("eK8LX");

var $13KtK = parcelRequire("13KtK");

var $ezGKx = parcelRequire("ezGKx");
const $fea70cfa465a677a$export$a26fa5cabff8bc7c = (0, $6xToB.createEntry)((0, $eK8LX.planIncrementRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $13KtK.planIncrementPageEntryPoint),
        component: (0, $ezGKx.PlanIncrement),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ezGKx.LazyPlanIncrement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-spa-entries/src/planIncrementRouteEntry.tsx',
                whichExportToUse: 'planIncrementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("it9UZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d272233cb03b552$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $6d272233cb03b552$var$LazyPlanSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("2i5b6")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
const $6d272233cb03b552$var$PlanSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6d272233cb03b552$var$LazyPlanSidebar, null)));
$6d272233cb03b552$var$PlanSidebar.displayName = 'PlanSidebar';
var $6d272233cb03b552$export$2e2bcd8739ae039 = $6d272233cb03b552$var$PlanSidebar;

});
parcelRegister("2i5b6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("lElWU")),
    $ewTvA("fSTJQ")
]).then(()=>parcelRequire('gjEnH'));

});


parcelRegister("8vSr3", function(module, exports) {
$parcel$export(module.exports, "planLayout", () => $e59450c8fb0bbe82$export$94e1d79bf65579e2);

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

const $e59450c8fb0bbe82$export$b6292b5f7e5b5fad = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jGSoQ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});

const $e59450c8fb0bbe82$export$70238cd3868b67c9 = (0, $bJscI.componentWithFG)('quickstart_onboarding_in_jira_plans', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("9iXrv")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$e59450c8fb0bbe82$export$70238cd3868b67c9.displayName = 'Onboarding';

const $e59450c8fb0bbe82$export$f61c80ac3b95bc7d = (0, $bJscI.componentWithFG)('quickstart_onboarding_in_jira_plans', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("ebz2g")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$e59450c8fb0bbe82$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';
const $e59450c8fb0bbe82$export$94e1d79bf65579e2 = (0, $6dwgv.createLayout)({
    rightSidebars: [
        $e59450c8fb0bbe82$export$f61c80ac3b95bc7d
    ],
    globalComponents: [
        $e59450c8fb0bbe82$export$b6292b5f7e5b5fad,
        $e59450c8fb0bbe82$export$70238cd3868b67c9
    ]
});

});
parcelRegister("jGSoQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3YNLV").then(()=>parcelRequire('dNajn'));

});

parcelRegister("9iXrv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b4iDC").then(()=>parcelRequire('aR7pU'));

});

parcelRegister("ebz2g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bf9LE").then(()=>parcelRequire('b1qIP'));

});


parcelRegister("eK8LX", function(module, exports) {
$parcel$export(module.exports, "planIncrementRoute", () => $f9f8e3fb39feca43$export$ef33a75556fde209);
const $f9f8e3fb39feca43$export$ef33a75556fde209 = {
    name: 'software-plan-increment',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
    exact: true
};

});

parcelRegister("13KtK", function(module, exports) {
$parcel$export(module.exports, "planIncrementPageEntryPoint", () => $ed1c3f79a0bb918d$export$a87dd3f7b0d2f7c2);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $eDyDZ = parcelRequire("eDyDZ");

var $dGTIT = parcelRequire("dGTIT");
const $ed1c3f79a0bb918d$export$a87dd3f7b0d2f7c2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eDyDZ.planIncrementEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("dGTIT", function(module, exports) {
$parcel$export(module.exports, "plansHorizontalNavigationEntryPoint", () => $5fd8f9b4e9b35d81$export$172a11f0d118de01);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $3Bzqe = parcelRequire("3Bzqe");

var $hu2rE = parcelRequire("hu2rE");

var $3lQXJ = parcelRequire("3lQXJ");

var $7Bvm5 = parcelRequire("7Bvm5");
function $5fd8f9b4e9b35d81$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}

const $5fd8f9b4e9b35d81$export$172a11f0d118de01 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4VKJ8")), {
        moduleId: "8c821489",
        moduleName: "HorizontalNavPlans",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        const scenarioId = match.params.scenarioId;
        if (!planId) throw new Error('Plan Id is missing');
        if (!scenarioId) throw new Error('Scenario Id is missing');
        const planScenarioAri = $5fd8f9b4e9b35d81$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId,
            scenarioId: scenarioId
        });
        return {
            queries: {
                horizontalNavPlansQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3lQXJ.default,
                    variables: {
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE),
                        cloudId: cloudId,
                        containerNavigationInput: {
                            scopeId: planScenarioAri
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("3lQXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $44201a212c2f52b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d50b31430815e25d91a9a65380319>>
 * @relayHash 164c48c3824ef2f0755f6d70fb373e5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c
const $44201a212c2f52b2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c",
        "metadata": {},
        "name": "HorizontalNavPlansQuery",
        "operationKind": "query",
        "text": null
    }
};
var $44201a212c2f52b2$export$2e2bcd8739ae039 = $44201a212c2f52b2$var$node;

});

parcelRegister("4VKJ8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("jhcwv")),
    $ewTvA("fliVL"),
    $ewTvA("iE0nl")
]).then(()=>parcelRequire('4pkYY'));

});



parcelRegister("ezGKx", function(module, exports) {
$parcel$export(module.exports, "LazyPlanIncrement", () => $d4ad8d5b1c19c768$export$e7b9f83d442bac51);
$parcel$export(module.exports, "PlanIncrement", () => $d4ad8d5b1c19c768$export$5e1035d0876d64db);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d4ad8d5b1c19c768$export$e7b9f83d442bac51 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("qXO6i"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $d4ad8d5b1c19c768$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d4ad8d5b1c19c768$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });

});


parcelRegister("5DVEh", function(module, exports) {
$parcel$export(module.exports, "planIncrementsRouteEntry", () => $c0946d9248e930b4$export$f7abc47036ff7dd9);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $8Jq3e = parcelRequire("8Jq3e");

var $fQZh1 = parcelRequire("fQZh1");

var $h6iiZ = parcelRequire("h6iiZ");
const $c0946d9248e930b4$export$f7abc47036ff7dd9 = (0, $6xToB.createEntry)((0, $8Jq3e.planIncrementsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $h6iiZ.planProgramPageEntryPoint),
        component: (0, $fQZh1.PlanProgram),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fQZh1.LazyPlanProgram)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-spa-entries/src/planIncrementsRouteEntry.tsx',
                whichExportToUse: 'planIncrementsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8Jq3e", function(module, exports) {
$parcel$export(module.exports, "planIncrementsRoute", () => $4e0258a5d99799dd$export$d0986e4bd9568b30);
const $4e0258a5d99799dd$export$d0986e4bd9568b30 = {
    name: 'software-plan-increments',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program',
    exact: true
};

});

parcelRegister("fQZh1", function(module, exports) {
$parcel$export(module.exports, "LazyPlanProgram", () => $44d65e02d863e8a0$export$9da4d4d5c4d7f749);
$parcel$export(module.exports, "PlanProgram", () => $44d65e02d863e8a0$export$fb30c2b19a4f5d59);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $44d65e02d863e8a0$export$9da4d4d5c4d7f749 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("amvrS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index-old.tsx"
});
const $44d65e02d863e8a0$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $44d65e02d863e8a0$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });

});
parcelRegister("amvrS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("kxPvX")),
    $ewTvA("3VBt7")
]).then(()=>parcelRequire('lRkR4'));

});


parcelRegister("h6iiZ", function(module, exports) {
$parcel$export(module.exports, "planProgramPageEntryPoint", () => $d72f9c83b02c2f38$export$cb6ac90e8faddaeb);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jz9v9 = parcelRequire("jz9v9");

var $dGTIT = parcelRequire("dGTIT");
const $d72f9c83b02c2f38$export$cb6ac90e8faddaeb = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jz9v9.planProgramEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("jz9v9", function(module, exports) {
$parcel$export(module.exports, "planProgramEntryPoint", () => $d047f107752f73d5$export$da91c765d9841bae);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d047f107752f73d5$export$da91c765d9841bae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("18H6h")), {
        moduleId: "1b761aac",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("18H6h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("hGpNy")),
    $ewTvA("8Fof4")
]).then(()=>parcelRequire('kRz17'));

});




parcelRegister("jJEm7", function(module, exports) {
$parcel$export(module.exports, "planPageRouteEntry", () => $f568909fbeb06b81$export$f85a75f1604118ff);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $dCQ31 = parcelRequire("dCQ31");

var $6dwgv = parcelRequire("6dwgv");

var $8vSr3 = parcelRequire("8vSr3");

var $iIcBn = parcelRequire("iIcBn");

var $6xcVp = parcelRequire("6xcVp");
// This redirect is required to support legacy routes, it should never be deleted
const $f568909fbeb06b81$var$planPageRedirect = (0, $6xcVp.withRedirection)((0, $iIcBn.default), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $f568909fbeb06b81$export$f85a75f1604118ff = (0, $6xToB.createEntry)((0, $dCQ31.planPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario',
        component: $f568909fbeb06b81$var$planPageRedirect,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planPageRouteEntry.tsx',
                whichExportToUse: 'planPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dCQ31", function(module, exports) {
$parcel$export(module.exports, "planPageRoute", () => $5b9547f9e6814bdd$export$26495e043d80cccc);
const $5b9547f9e6814bdd$export$26495e043d80cccc = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};

});

parcelRegister("6xcVp", function(module, exports) {
$parcel$export(module.exports, "withRedirection", () => $0f261707661f001f$export$2c9e4550ef8bdea9);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");
function $0f261707661f001f$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $gCY1z.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}

});


parcelRegister("flxMn", function(module, exports) {
$parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", () => $6be661039b495821$export$9cbef73b51558ef);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $6rAsd = parcelRequire("6rAsd");

var $eyNFj = parcelRequire("eyNFj");

var $iIcBn = parcelRequire("iIcBn");
const $6be661039b495821$export$9cbef73b51558ef = (0, $6xToB.createEntry)((0, $6rAsd.planPageWithoutScenarioIdRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-plan',
        component: (0, $eyNFj.RedirectPlanPageWithoutScenarioIdLoadQuery),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planPageWithoutScenarioIdRouteEntry.tsx',
                whichExportToUse: 'planPageWithoutScenarioIdRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6rAsd", function(module, exports) {
$parcel$export(module.exports, "planPageWithoutScenarioIdRoute", () => $1b095408f7c3d976$export$610e14c9c89d0afb);
const $1b095408f7c3d976$export$610e14c9c89d0afb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId(\\d+)'
};

});


parcelRegister("iJbtQ", function(module, exports) {
$parcel$export(module.exports, "planReportPageRouteEntry", () => $0197c538340d0c1c$export$e71031acce6d7e47);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $2zLut = parcelRequire("2zLut");

var $dts4B = parcelRequire("dts4B");
const $0197c538340d0c1c$export$e71031acce6d7e47 = (0, $6xToB.createEntry)((0, $2zLut.planReportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-report',
        component: (0, $dts4B.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4KrIc.advancedRoadmapsPlanReportPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dts4B.LazyPlanReport)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planReportPageRouteEntry.tsx',
                whichExportToUse: 'planReportPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2zLut", function(module, exports) {
$parcel$export(module.exports, "planReportPageRoute", () => $fe6c4dfc2c704cf6$export$7c8c0761b1ba57bb);
const $fe6c4dfc2c704cf6$export$7c8c0761b1ba57bb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/reports/:reportId'
};

});

parcelRegister("dts4B", function(module, exports) {
$parcel$export(module.exports, "LazyPlanReport", () => $9f6ef3646c3dba25$export$fe1fc08f511671db);
$parcel$export(module.exports, "default", () => $9f6ef3646c3dba25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9f6ef3646c3dba25$export$fe1fc08f511671db = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aZmtX"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $9f6ef3646c3dba25$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9f6ef3646c3dba25$export$fe1fc08f511671db,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
var $9f6ef3646c3dba25$export$2e2bcd8739ae039 = $9f6ef3646c3dba25$var$PlanReport;

});
parcelRegister("aZmtX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("eEE1m")),
    $ewTvA("fliVL"),
    $ewTvA("4KSdv")
]).then(()=>parcelRequire('kwkQ2'));

});



parcelRegister("98Umx", function(module, exports) {
$parcel$export(module.exports, "plansDirectoryRouteEntry", () => $81b57271b28d1b61$export$4f9df77811fbdc1f);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $fZoD8 = parcelRequire("fZoD8");

var $iMFdk = parcelRequire("iMFdk");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $81b57271b28d1b61$var$LazyPlansDirectory = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("026Oa"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $81b57271b28d1b61$var$PlansDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $81b57271b28d1b61$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $81b57271b28d1b61$export$4f9df77811fbdc1f = (0, $6xToB.createEntry)((0, $fZoD8.plansDirectoryRoute), ()=>({
        group: 'directories',
        component: $81b57271b28d1b61$var$PlansDirectoryComponent,
        skeleton: (0, $iMFdk.PlansDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $81b57271b28d1b61$var$LazyPlansDirectory
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/plansDirectoryRouteEntry.tsx',
                whichExportToUse: 'plansDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("026Oa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("dUZI3")
]).then(()=>parcelRequire('4TzQ2'));

});


parcelRegister("33RDm", function(module, exports) {
$parcel$export(module.exports, "planSetupPageRouteEntry", () => $621f3a350ed066c3$export$2a24acea4e628148);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $gqQqR = parcelRequire("gqQqR");

var $6M5Br = parcelRequire("6M5Br");
const $621f3a350ed066c3$export$2a24acea4e628148 = (0, $6xToB.createEntry)((0, $gqQqR.planSetupPageRoute), ()=>({
        group: 'software',
        component: (0, $6M5Br.default),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6M5Br.LazyAdvancedRoadmapsSetup)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planSetupPageRouteEntry.tsx',
                whichExportToUse: 'planSetupPageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gqQqR", function(module, exports) {
$parcel$export(module.exports, "planSetupPageRoute", () => $ae880a552586841f$export$4815756bb523904e);
const $ae880a552586841f$export$4815756bb523904e = {
    name: 'software-advanced-roadmaps-setup',
    path: '/jira/plans/:planId/setup'
};

});

parcelRegister("6M5Br", function(module, exports) {
$parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", () => $cbee4b463574734d$export$46bb3a1779d7815b);
$parcel$export(module.exports, "default", () => $cbee4b463574734d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $cbee4b463574734d$export$46bb3a1779d7815b = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7YPwq"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
const $cbee4b463574734d$var$AsyncAdvancedRoadmapsSetup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cbee4b463574734d$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });
var $cbee4b463574734d$export$2e2bcd8739ae039 = $cbee4b463574734d$var$AsyncAdvancedRoadmapsSetup;

});
parcelRegister("7YPwq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fzz7R").then(()=>parcelRequire('agOcn'));

});



parcelRegister("9a7o3", function(module, exports) {
$parcel$export(module.exports, "planUpsellRouteEntry", () => $e6d7a1d218fbbe94$export$363894d991872cbf);

var $6xToB = parcelRequire("6xToB");

var $8ETQ8 = parcelRequire("8ETQ8");

var $5RW99 = parcelRequire("5RW99");

var $7h3uc = parcelRequire("7h3uc");

var $9NmsS = parcelRequire("9NmsS");

var $43NYh = parcelRequire("43NYh");
const $e6d7a1d218fbbe94$export$363894d991872cbf = (0, $6xToB.createEntry)((0, $8ETQ8.planUpsellRoute), ()=>({
        group: 'software',
        entryPoint () {
            return 0, $43NYh.planUpsellPageEntryPoint;
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planUpsellRouteEntry.tsx',
                whichExportToUse: 'planUpsellRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("43NYh", function(module, exports) {
$parcel$export(module.exports, "planUpsellPageEntryPoint", () => $d66a4a9fe9121626$export$7551fe27e3c0a4bf);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8QNrG = parcelRequire("8QNrG");
const $d66a4a9fe9121626$export$7551fe27e3c0a4bf = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8QNrG.planUpsellEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});

});


parcelRegister("7Al9R", function(module, exports) {
$parcel$export(module.exports, "planViewNotFoundRouteEntry", () => $a64b24249c951d85$export$19c7bb0eeda48c06);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $7UTBK = parcelRequire("7UTBK");

var $6dwgv = parcelRequire("6dwgv");

var $7h3uc = parcelRequire("7h3uc");

var $8vSr3 = parcelRequire("8vSr3");

var $it9UZ = parcelRequire("it9UZ");

var $aIYFK = parcelRequire("aIYFK");
const $a64b24249c951d85$export$19c7bb0eeda48c06 = (0, $6xToB.createEntry)((0, $7UTBK.planViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        entryPoint: ()=>(0, $aIYFK.planViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planViewNotFoundRouteEntry.tsx',
                whichExportToUse: 'planViewNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7UTBK", function(module, exports) {
$parcel$export(module.exports, "planViewNotFoundRoute", () => $fac6abfa4bf0a428$export$f2531e319f8b4274);
const $fac6abfa4bf0a428$export$f2531e319f8b4274 = {
    name: 'plan-view-not-found',
    path: '/jira/plans/:planId/scenarios/:scenarioId/not-found'
};

});

parcelRegister("aIYFK", function(module, exports) {
$parcel$export(module.exports, "planViewNotFoundPageEntrypoint", () => $996718f76a69fe38$export$18e8a0d930f394a2);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $nTAA5 = parcelRequire("nTAA5");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $dGTIT = parcelRequire("dGTIT");

const $996718f76a69fe38$var$main = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("e8m6A")), {
        moduleId: "f2ea0209",
        moduleName: "PlanViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        if (!planId) throw new Error('Plan Id is missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $nTAA5.default,
                    variables: {
                        planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
                    }
                }
            }
        };
    }
});
const $996718f76a69fe38$export$18e8a0d930f394a2 = (0, $g8uYY.createPageEntryPoint)({
    main: $996718f76a69fe38$var$main,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});

});
parcelRegister("nTAA5", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d7b2719ea0082b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f97e78ab59091e8012bd8a05696ce789>>
 * @relayHash c51281360f2d7bd5387e9bb058f11f6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229
const $a0d7b2719ea0082b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229",
        "metadata": {},
        "name": "PlanViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a0d7b2719ea0082b$export$2e2bcd8739ae039 = $a0d7b2719ea0082b$var$node;

});

parcelRegister("e8m6A", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lBjbF").then(()=>parcelRequire('5nmGk'));

});



parcelRegister("4p5og", function(module, exports) {
$parcel$export(module.exports, "polarisCollectionsRouteEntry", () => $a14b7285543f033b$export$a034dc25c21d1029);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $aQxDr = parcelRequire("aQxDr");

var $aK1hS = parcelRequire("aK1hS");
const $a14b7285543f033b$export$a034dc25c21d1029 = (0, $6xToB.createEntry)((0, $aQxDr.polarisCollectionsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.collections',
        component: (0, $aK1hS.default),
        layout: (0, $7h3uc.globalLayout),
        canTransitionIn: ()=>{
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aK1hS.LazyCollectionsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisCollectionsRouteEntry.tsx',
                whichExportToUse: 'polarisCollectionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aQxDr", function(module, exports) {
$parcel$export(module.exports, "polarisCollectionsRoute", () => $0750218039883055$export$d415b74f78a5f159);
const $0750218039883055$export$d415b74f78a5f159 = {
    name: 'polaris-collections',
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};

});

parcelRegister("aK1hS", function(module, exports) {
$parcel$export(module.exports, "LazyCollectionsPage", () => $6444e855eac9b9ce$export$f7960e7dbd7e5265);
$parcel$export(module.exports, "default", () => $6444e855eac9b9ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fRXNt = parcelRequire("fRXNt");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $koAZ4 = parcelRequire("koAZ4");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");

const $6444e855eac9b9ce$export$f7960e7dbd7e5265 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("i0unf"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $6444e855eac9b9ce$var$useJpdLicensed = ()=>{
    const context = (0, $koAZ4.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $6444e855eac9b9ce$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $6444e855eac9b9ce$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $fRXNt.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6444e855eac9b9ce$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $6444e855eac9b9ce$export$2e2bcd8739ae039 = $6444e855eac9b9ce$export$3bba33442c4150b1;

});
parcelRegister("i0unf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("akOxS")
]).then(()=>parcelRequire('LFaVG'));

});



parcelRegister("01dV2", function(module, exports) {
$parcel$export(module.exports, "polarisIdeasRouteEntry", () => $4d574276bc93dcbc$export$26631f98f007b2d2);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $jXAU3 = parcelRequire("jXAU3");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $f58ZR = parcelRequire("f58ZR");

var $6Kw7r = parcelRequire("6Kw7r");
const $4d574276bc93dcbc$export$26631f98f007b2d2 = (0, $6xToB.createEntry)((0, $f58ZR.polarisIdeasRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.project',
        layout: (0, $jXAU3.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint () {
            return 0, $6Kw7r.ideasPageEntryPoint;
        },
        preloadOptions: {
            earlyChunks: [
                'jpd-ideas-early-entry'
            ]
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisIdeasRouteEntry.tsx',
                whichExportToUse: 'polarisIdeasRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jXAU3", function(module, exports) {
$parcel$export(module.exports, "polarisProjectLayout", () => $9c466b8fcdf0c3fc$export$d5273c1a2e2fe212);

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $lOORm = parcelRequire("lOORm");
const $9c466b8fcdf0c3fc$var$rightSidebars = [
    (0, $lOORm.RightSidebars)
];
const $9c466b8fcdf0c3fc$export$d5273c1a2e2fe212 = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {
    rightSidebars: $9c466b8fcdf0c3fc$var$rightSidebars
});

});
parcelRegister("lOORm", function(module, exports) {
$parcel$export(module.exports, "RightSidebars", () => $78dafa3dae276cbf$export$f61c80ac3b95bc7d);

var $eJOHy = parcelRequire("eJOHy");

var $2Sdgb = parcelRequire("2Sdgb");

var $4cTDP = parcelRequire("4cTDP");
const $78dafa3dae276cbf$export$f61c80ac3b95bc7d = ()=>(0, $4cTDP.fg)('jpd_quickstart_onboarding-setup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Sdgb.QuickstartPanel), {
        key: "jpd-quickstart"
    }) : null;
$78dafa3dae276cbf$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

});
parcelRegister("2Sdgb", function(module, exports) {
$parcel$export(module.exports, "useQuickstartPanel", () => $28a681045a59099a$export$f010c8e91b6c23e4);
$parcel$export(module.exports, "QuickstartPanel", () => $28a681045a59099a$export$eae1599e559ec5b1);

var $eJOHy = parcelRequire("eJOHy");

var $dfP3D = parcelRequire("dfP3D");

var $5xmeX = parcelRequire("5xmeX");

var $lRq8t = parcelRequire("lRq8t");

var $h47gY = parcelRequire("h47gY");

var $fKUFY = parcelRequire("fKUFY");

var $3tYku = parcelRequire("3tYku");

var $7TGcD = parcelRequire("7TGcD");

var $2WOY7 = parcelRequire("2WOY7");

var $iErFI = parcelRequire("iErFI");
const $28a681045a59099a$export$f010c8e91b6c23e4 = ()=>{
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const openQuickstartPanel = (0, $3tYku.useOpenQuickstartPanel)();
    const { refreshAppState: refreshAppState } = (0, $7TGcD.useActions)();
    const isCollectionView = (0, $5xmeX.useIsCollectionView)();
    const panelVisibility = (0, $7TGcD.useVisibility)();
    // Close quickstart panel when other sidebar panels are opened
    (0, $3tYku.useCloseQuickstartPanelOnOtherPanelOpen)();
    (0, $eJOHy.useEffect)(()=>{
        if (isCollectionView || panelVisibility !== (0, $fKUFY.QUICKSTART_UI_STATUS_OPEN)) return;
        // Only open quickstart panel if no other panel is currently active or being opened
        // This prevents quickstart from reopening when user clicks to open another panel
        if (!panelId || panelId === (0, $fKUFY.QUICKSTART_PANEL_ID)) openQuickstartPanel();
        return ()=>{
            closeRightSidebar((0, $fKUFY.QUICKSTART_PANEL_ID));
        };
    }, [
        refreshAppState,
        closeRightSidebar,
        isCollectionView,
        panelVisibility,
        openQuickstartPanel,
        panelId
    ]);
};
const $28a681045a59099a$var$QuickstartPanelContent = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { closeCurrentTask: closeCurrentTask, setQuickstartBannerVisibility: setQuickstartBannerVisibility } = (0, $7TGcD.useActions)();
    const handleError = ()=>{
        closeCurrentTask();
        setQuickstartBannerVisibility({
            visibility: (0, $fKUFY.QUICKSTART_UI_STATUS_DISMISSED)
        });
        closeRightSidebar((0, $fKUFY.QUICKSTART_PANEL_ID));
    };
    const taskDictionary = (0, $2WOY7.allTasks).reduce((acc, task)=>{
        acc[task.id] = {
            id: task.id,
            title: formatMessage(task.title),
            children: task.description
        };
        return acc;
    }, {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "quickstart-panel",
        packageName: "atlassian/jira-polaris-component-quickstart",
        render: ()=>{
            handleError();
            return null;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iErFI.OnboardingCheckList), {
        taskDictionary: taskDictionary
    }));
};
const $28a681045a59099a$export$eae1599e559ec5b1 = ()=>{
    const { panelId: panelId } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const panelVisibility = (0, $7TGcD.useVisibility)();
    // Don't render if:
    // 1. Panel is dismissed
    // 2. Another panel is active (not quickstart)
    if (panelVisibility === (0, $fKUFY.QUICKSTART_UI_STATUS_DISMISSED) || panelId && panelId !== (0, $fKUFY.QUICKSTART_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($28a681045a59099a$var$QuickstartPanelContent, null);
};

});
parcelRegister("5xmeX", function(module, exports) {
$parcel$export(module.exports, "PolarisEnvironmentProvider", () => $4fc4ce8293658f41$export$95b1e1d8730969e);
$parcel$export(module.exports, "useIsEmbedded", () => $4fc4ce8293658f41$export$77140ffa938f9fd1);
$parcel$export(module.exports, "useIsSharedView", () => $4fc4ce8293658f41$export$19a346ab6c5052b2);
$parcel$export(module.exports, "useIsCollectionView", () => $4fc4ce8293658f41$export$653454b45dadb2a8);

var $eJOHy = parcelRequire("eJOHy");
const $4fc4ce8293658f41$var$initialState = {
    embedded: undefined,
    isSharedView: undefined,
    isCollectionView: undefined
};
const $4fc4ce8293658f41$var$PolarisEnvironmentContext = /*#__PURE__*/ (0, $eJOHy.createContext)($4fc4ce8293658f41$var$initialState);
const $4fc4ce8293658f41$export$95b1e1d8730969e = ({ children: children, embedded: embedded = false, isSharedView: isSharedView = false, isCollectionView: isCollectionView = false })=>{
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            embedded: embedded,
            isSharedView: isSharedView,
            isCollectionView: isCollectionView
        }), [
        embedded,
        isSharedView,
        isCollectionView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4fc4ce8293658f41$var$PolarisEnvironmentContext.Provider, {
        value: contextValue
    }, children);
};
const $4fc4ce8293658f41$export$77140ffa938f9fd1 = ()=>{
    const { embedded: embedded } = (0, $eJOHy.useContext)($4fc4ce8293658f41$var$PolarisEnvironmentContext);
    return embedded === true;
};
const $4fc4ce8293658f41$export$19a346ab6c5052b2 = ()=>{
    const { isSharedView: isSharedView } = (0, $eJOHy.useContext)($4fc4ce8293658f41$var$PolarisEnvironmentContext);
    return isSharedView === true;
};
const $4fc4ce8293658f41$export$653454b45dadb2a8 = ()=>{
    const { isCollectionView: isCollectionView } = (0, $eJOHy.useContext)($4fc4ce8293658f41$var$PolarisEnvironmentContext);
    return isCollectionView === true;
};

});

parcelRegister("fKUFY", function(module, exports) {
$parcel$export(module.exports, "QUICKSTART_UI_STATUS_NOT_LOADED", () => $e42fadc17b79d36b$export$fbb6edc7349ee1b);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS_OPEN", () => $e42fadc17b79d36b$export$2259760b7b6a85c2);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS_MINIMIZED", () => $e42fadc17b79d36b$export$e47f47912c2bf053);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS_DISMISSED", () => $e42fadc17b79d36b$export$47f7fe79dc6ea45b);
$parcel$export(module.exports, "PACKAGE_NAME", () => $e42fadc17b79d36b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e42fadc17b79d36b$export$2b3151a089bc8780);
$parcel$export(module.exports, "QUICKSTART_PANEL_ID", () => $e42fadc17b79d36b$export$2809088f031b41da);
$parcel$export(module.exports, "QUICKSTART_PANEL_WIDTH", () => $e42fadc17b79d36b$export$42d5fc65c6b1e83f);
$parcel$export(module.exports, "QUICKSTART_PANEL_VISIBILITY_STATE_KEY", () => $e42fadc17b79d36b$export$7d992372b25590c9);
$parcel$export(module.exports, "QUICKSTART_PANEL_OPEN_TASK_ID_STATE_KEY", () => $e42fadc17b79d36b$export$bad6d672c61d9f0);
$parcel$export(module.exports, "taskIdToStateKey", () => $e42fadc17b79d36b$export$5c23d1d00ff742cc);
$parcel$export(module.exports, "stateKeyToTaskId", () => $e42fadc17b79d36b$export$8c9a239069acf100);
$parcel$export(module.exports, "DEFAULT_QUICKSTART_UI_STATUS", () => $e42fadc17b79d36b$export$aeb2d150bb788c49);
const $e42fadc17b79d36b$export$fbb6edc7349ee1b = Symbol('NOT_LOADED');
const $e42fadc17b79d36b$export$2259760b7b6a85c2 = Symbol('OPEN');
const $e42fadc17b79d36b$export$e47f47912c2bf053 = Symbol('MINIMIZED');
const $e42fadc17b79d36b$export$47f7fe79dc6ea45b = Symbol('DISMISSED');
const $e42fadc17b79d36b$export$b8b9d90f9e5bd72b = 'jiraPolarisComponentQuickstart';
const $e42fadc17b79d36b$export$2b3151a089bc8780 = 'jpd-juno';
const $e42fadc17b79d36b$export$2809088f031b41da = 'jpd-quickstart';
const $e42fadc17b79d36b$export$42d5fc65c6b1e83f = 365;
const $e42fadc17b79d36b$export$7d992372b25590c9 = 'polaris.quickstart-panel-visibility-state';
const $e42fadc17b79d36b$export$bad6d672c61d9f0 = 'polaris.quickstart-open-task-id';
const $e42fadc17b79d36b$export$5c23d1d00ff742cc = {
    'explore-the-basics': 'polaris.quickstart-task-completed.explore-the-basics',
    'create-ideas': 'polaris.quickstart-task-completed.create-ideas',
    'prioritize-and-plan': 'polaris.quickstart-task-completed.prioritize-and-plan',
    'create-a-view': 'polaris.quickstart-task-completed.create-a-view',
    'share-and-collaborate': 'polaris.quickstart-task-completed.share-and-collaborate',
    'link-work-items': 'polaris.quickstart-task-completed.link-work-items'
};
const $e42fadc17b79d36b$export$8c9a239069acf100 = Object.fromEntries(Object.entries($e42fadc17b79d36b$export$5c23d1d00ff742cc).map(([taskId, stateKey])=>[
        stateKey,
        taskId
    ]));
const $e42fadc17b79d36b$export$aeb2d150bb788c49 = $e42fadc17b79d36b$export$e47f47912c2bf053;

});

parcelRegister("3tYku", function(module, exports) {
$parcel$export(module.exports, "useCloseQuickstartPanelOnOtherPanelOpen", () => $717999e784b6aa45$export$1ed528f3e576f6af);
$parcel$export(module.exports, "useOpenQuickstartPanel", () => $717999e784b6aa45$export$c152442bc520b5df);

var $eJOHy = parcelRequire("eJOHy");

var $dfP3D = parcelRequire("dfP3D");

var $fKUFY = parcelRequire("fKUFY");
const $717999e784b6aa45$export$1ed528f3e576f6af = ()=>{
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    (0, $eJOHy.useEffect)(()=>{
        if (panelId && panelId !== (0, $fKUFY.QUICKSTART_PANEL_ID) && !isCollapsed) closeRightSidebar((0, $fKUFY.QUICKSTART_PANEL_ID));
    }, [
        panelId,
        isCollapsed,
        closeRightSidebar
    ]);
};
const $717999e784b6aa45$export$c152442bc520b5df = ()=>{
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const openQuickstartPanel = (0, $eJOHy.useCallback)(()=>{
        // Close any other panel that's currently open before opening quickstart
        if (panelId && panelId !== (0, $fKUFY.QUICKSTART_PANEL_ID) && !isCollapsed) closeCurrentRightSidebar();
        openRightSidebar((0, $fKUFY.QUICKSTART_PANEL_ID), (0, $fKUFY.QUICKSTART_PANEL_WIDTH), false, true);
    }, [
        panelId,
        isCollapsed,
        openRightSidebar,
        closeCurrentRightSidebar
    ]);
    return openQuickstartPanel;
};

});

parcelRegister("7TGcD", function(module, exports) {
$parcel$export(module.exports, "useActions", () => $670e6bd0c5c5203c$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useTasks", () => $670e6bd0c5c5203c$export$ed5c3368304694);
$parcel$export(module.exports, "useVisibility", () => $670e6bd0c5c5203c$export$83920e874200e13a);
$parcel$export(module.exports, "useOpenTaskId", () => $670e6bd0c5c5203c$export$b2e97a2124f09164);
$parcel$export(module.exports, "useSpotlightStepId", () => $670e6bd0c5c5203c$export$cd9e98725c81ea44);
$parcel$export(module.exports, "useMountedSpotlightIds", () => $670e6bd0c5c5203c$export$5badc13e2ab5d64d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $FFeB1 = parcelRequire("FFeB1");

var $fKUFY = parcelRequire("fKUFY");
const $670e6bd0c5c5203c$var$initialState = {
    visibility: (0, $fKUFY.QUICKSTART_UI_STATUS_NOT_LOADED),
    openTaskId: null,
    spotlightStepId: null,
    mountedSpotlightIds: [],
    tasks: null,
    onEvent: null
};
const $670e6bd0c5c5203c$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'jpd-onboarding-quickstart',
    initialState: $670e6bd0c5c5203c$var$initialState,
    actions: $FFeB1.actions
});
const $670e6bd0c5c5203c$export$4b279f6879d7e7f1 = (0, $iJq0l.createHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9);
const $670e6bd0c5c5203c$export$bc923229a7fa61e7 = (0, $iJq0l.createActionsHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9);
const $670e6bd0c5c5203c$export$ed5c3368304694 = (0, $iJq0l.createStateHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9, {
    selector: (state)=>state.tasks
});
const $670e6bd0c5c5203c$export$83920e874200e13a = (0, $iJq0l.createStateHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9, {
    selector: (state)=>state.visibility
});
const $670e6bd0c5c5203c$export$b2e97a2124f09164 = (0, $iJq0l.createStateHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9, {
    selector: (state)=>state.openTaskId
});
const $670e6bd0c5c5203c$export$cd9e98725c81ea44 = (0, $iJq0l.createHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9, {
    selector: (state)=>state.spotlightStepId
});
const $670e6bd0c5c5203c$export$5badc13e2ab5d64d = (0, $iJq0l.createStateHook)($670e6bd0c5c5203c$export$6f57813fe9f31bf9, {
    selector: (state)=>state.mountedSpotlightIds
});

});
parcelRegister("FFeB1", function(module, exports) {
$parcel$export(module.exports, "actions", () => $14cb21de40667552$export$e324594224ef24da);

var $b5Lop = parcelRequire("b5Lop");

var $5Q9QA = parcelRequire("5Q9QA");

var $k732K = parcelRequire("k732K");

var $42JNL = parcelRequire("42JNL");

var $lIAjM = parcelRequire("lIAjM");

var $aStZj = parcelRequire("aStZj");

var $gTP4c = parcelRequire("gTP4c");

var $7ul0f = parcelRequire("7ul0f");

var $3WvJU = parcelRequire("3WvJU");

var $2X4Pi = parcelRequire("2X4Pi");

var $kuy9T = parcelRequire("kuy9T");

var $khKyC = parcelRequire("khKyC");

var $3pVoU = parcelRequire("3pVoU");
const $14cb21de40667552$export$e324594224ef24da = {
    setOpenTaskId: $5Q9QA.setOpenTaskId,
    closeCurrentTask: $b5Lop.closeCurrentTask,
    refreshAppState: $k732K.refreshAppState,
    completeTask: $42JNL.completeTask,
    openDeliveryTab: $khKyC.openDeliveryTab,
    completeTaskAndContinue: $lIAjM.completeTaskAndContinue,
    setQuickstartBannerVisibility: $aStZj.setQuickstartBannerVisibility,
    setSpotlightStepId: $gTP4c.setSpotlightStepId,
    closeCurrentSpotlightStep: $2X4Pi.closeCurrentSpotlightStep,
    addMountedSpotlight: $7ul0f.addMountedSpotlight,
    removeMountedSpotlight: $3WvJU.removeMountedSpotlight,
    setEventHandler: $kuy9T.setEventHandler,
    navigateToAllIdeas: $3pVoU.navigateToAllIdeas
};

});
parcelRegister("b5Lop", function(module, exports) {
$parcel$export(module.exports, "closeCurrentTask", () => $631ec47262eab6b5$export$2b9842b3a66ee447);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $12NGt = parcelRequire("12NGt");
const $631ec47262eab6b5$export$2b9842b3a66ee447 = ()=>({ setState: setState, dispatch: dispatch })=>{
        setState({
            openTaskId: null
        });
        dispatch((0, $12NGt.dispatchEvent)({
            type: 'opened-task-change',
            taskId: null
        }));
    };

});
parcelRegister("12NGt", function(module, exports) {
$parcel$export(module.exports, "dispatchEvent", () => $025e8185ea79a336$export$716a11175c03fb4e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $025e8185ea79a336$export$716a11175c03fb4e = (event)=>async ({ getState: getState })=>{
        getState().onEvent?.(event);
    };

});


parcelRegister("5Q9QA", function(module, exports) {
$parcel$export(module.exports, "setOpenTaskId", () => $4238555362159b74$export$3dcf62eb39c103);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $12NGt = parcelRequire("12NGt");
const $4238555362159b74$export$3dcf62eb39c103 = ({ id: id })=>async ({ setState: setState, dispatch: dispatch })=>{
        setState({
            openTaskId: id
        });
        dispatch((0, $12NGt.dispatchEvent)({
            type: 'opened-task-change',
            taskId: id
        }));
    };

});

parcelRegister("k732K", function(module, exports) {
$parcel$export(module.exports, "refreshAppState", () => $0020a7b974d49568$export$797c35e2e1d0d014);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0020a7b974d49568$export$797c35e2e1d0d014 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});

parcelRegister("42JNL", function(module, exports) {
$parcel$export(module.exports, "completeTask", () => $b2543983602b7287$export$f9b8f6c708100712);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $12NGt = parcelRequire("12NGt");
const $b2543983602b7287$export$f9b8f6c708100712 = ({ id: id })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { tasks: tasks } = getState();
        if (!tasks) return;
        let isDirty = false;
        const modifiedTasks = tasks.items.map((task)=>{
            if (task.id === id && !task.completed) {
                isDirty = true;
                return {
                    ...task,
                    completed: true
                };
            }
            return task;
        });
        if (!isDirty) return;
        setState({
            tasks: {
                ...tasks,
                items: modifiedTasks
            }
        });
        dispatch((0, $12NGt.dispatchEvent)({
            type: 'task-completed',
            taskId: id
        }));
    };

});

parcelRegister("lIAjM", function(module, exports) {
$parcel$export(module.exports, "completeTaskAndContinue", () => $c21070ab6cff5351$export$9166c2ff693714bf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $42JNL = parcelRequire("42JNL");

var $1guHq = parcelRequire("1guHq");
const $c21070ab6cff5351$export$9166c2ff693714bf = ({ id: id })=>({ dispatch: dispatch })=>{
        dispatch((0, $42JNL.completeTask)({
            id: id
        }));
        dispatch((0, $1guHq.continueToNextTask)());
    };

});
parcelRegister("1guHq", function(module, exports) {
$parcel$export(module.exports, "continueToNextTask", () => $f0530d02f0b9420a$export$67863ea877a600e8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5Q9QA = parcelRequire("5Q9QA");
const $f0530d02f0b9420a$export$67863ea877a600e8 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { tasks: tasks, openTaskId: openTaskId } = getState();
        if (!openTaskId || !tasks) return;
        const openTaskIndex = tasks.items.findIndex((task)=>task.id === openTaskId);
        if (openTaskIndex === -1) return;
        // Find the first uncompleted task after the current task
        for(let i = openTaskIndex + 1; i < tasks.items.length; i++){
            const task = tasks.items[i];
            if (!task.completed) {
                dispatch((0, $5Q9QA.setOpenTaskId)({
                    id: task.id
                }));
                return;
            }
        }
    };

});


parcelRegister("aStZj", function(module, exports) {
$parcel$export(module.exports, "setQuickstartBannerVisibility", () => $d57868cb2630dd2c$export$386e39459f0a8e20);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $12NGt = parcelRequire("12NGt");
const $d57868cb2630dd2c$export$386e39459f0a8e20 = ({ visibility: visibility })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { visibility: stateVisibility } = getState();
        if (visibility === stateVisibility) return;
        setState({
            visibility: visibility
        });
        dispatch((0, $12NGt.dispatchEvent)({
            type: 'visibility-change',
            visibility: visibility
        }));
    };

});

parcelRegister("gTP4c", function(module, exports) {
$parcel$export(module.exports, "setSpotlightStepId", () => $3d75c357023ecd4b$export$75135df0f73559b7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3d75c357023ecd4b$export$75135df0f73559b7 = (stepId)=>({ setState: setState })=>{
        setState({
            spotlightStepId: stepId
        });
    };

});

parcelRegister("7ul0f", function(module, exports) {
$parcel$export(module.exports, "addMountedSpotlight", () => $3ee20147e2cd1a6a$export$33d6d51c86575bf6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3ee20147e2cd1a6a$export$33d6d51c86575bf6 = (spotlightId)=>({ setState: setState, getState: getState })=>{
        if (getState().mountedSpotlightIds?.includes(spotlightId)) return;
        setState({
            mountedSpotlightIds: [
                ...getState().mountedSpotlightIds || [],
                spotlightId
            ]
        });
    };

});

parcelRegister("3WvJU", function(module, exports) {
$parcel$export(module.exports, "removeMountedSpotlight", () => $d08100a82870b397$export$4221c6c265f63253);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d08100a82870b397$export$4221c6c265f63253 = (spotlightId)=>({ setState: setState, getState: getState })=>{
        if (!getState().mountedSpotlightIds?.includes(spotlightId)) return;
        setState({
            mountedSpotlightIds: (getState().mountedSpotlightIds || []).filter((id)=>id !== spotlightId)
        });
    };

});

parcelRegister("2X4Pi", function(module, exports) {
$parcel$export(module.exports, "closeCurrentSpotlightStep", () => $789aa03b37ed4ebe$export$16316c452e3d6806);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $789aa03b37ed4ebe$export$16316c452e3d6806 = ()=>({ setState: setState })=>{
        setState({
            spotlightStepId: null
        });
    };

});

parcelRegister("kuy9T", function(module, exports) {
$parcel$export(module.exports, "setEventHandler", () => $ecf026312326b0e7$export$83bf6c314615d83d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $ecf026312326b0e7$export$83bf6c314615d83d = (onEvent)=>async ({ setState: setState })=>{
        setState({
            onEvent: onEvent
        });
    };

});

parcelRegister("khKyC", function(module, exports) {
$parcel$export(module.exports, "openDeliveryTab", () => $751d1b0265b9e54d$export$4e1ce5ac50ab4482);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $12NGt = parcelRequire("12NGt");
const $751d1b0265b9e54d$export$4e1ce5ac50ab4482 = ()=>async ({ dispatch: dispatch })=>{
        dispatch((0, $12NGt.dispatchEvent)({
            type: 'open-delivery-tab'
        }));
    };

});

parcelRegister("3pVoU", function(module, exports) {
$parcel$export(module.exports, "navigateToAllIdeas", () => $7ef046e45e2a1e7e$export$2249cca9a95a0b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $12NGt = parcelRequire("12NGt");
const $7ef046e45e2a1e7e$export$2249cca9a95a0b35 = ()=>async ({ dispatch: dispatch })=>{
        dispatch((0, $12NGt.dispatchEvent)({
            type: 'navigate-all-ideas'
        }));
    };

});



parcelRegister("2WOY7", function(module, exports) {
$parcel$export(module.exports, "allTasks", () => $e745cdb840ad99de$export$4f6e8359ebd466c2);

var $iepqB = parcelRequire("iepqB");

var $gS8cS = parcelRequire("gS8cS");

var $edV3I = parcelRequire("edV3I");

var $b5cxs = parcelRequire("b5cxs");

var $cCLxq = parcelRequire("cCLxq");

var $i7APR = parcelRequire("i7APR");
const $e745cdb840ad99de$export$4f6e8359ebd466c2 = [
    (0, $edV3I.exploreTheBasics),
    (0, $gS8cS.createIdeas),
    (0, $b5cxs.prioritizeAndPlan),
    (0, $iepqB.createAView),
    (0, $cCLxq.shareAndCollaborate),
    (0, $i7APR.linkWorkItems)
];

});
parcelRegister("iepqB", function(module, exports) {
$parcel$export(module.exports, "createAView", () => $90efa7a25522fba0$export$478e94b2ec035e52);

var $eJOHy = parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");

var $lRq8t = parcelRequire("lRq8t");

var $68etL = parcelRequire("68etL");

var $3VnMy = parcelRequire("3VnMy");

var $dfy3J = parcelRequire("dfy3J");

var $1Ritr = parcelRequire("1Ritr");

var $g8qL6 = parcelRequire("g8qL6");

var $4NsPm = parcelRequire("4NsPm");

const $90efa7a25522fba0$var$Description = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68etL.TaskDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        width: "100%",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1Ritr))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($g8qL6))),
        alt: formatMessage((0, $4NsPm.messages).title)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VnMy.TaskDescriptionParagraph), null, formatMessage((0, $4NsPm.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dfy3J.default), {
        taskId: (0, $e18ba2fd827b88a3$export$f816cf434e677dee)
    }));
};
const $90efa7a25522fba0$export$478e94b2ec035e52 = {
    id: (0, $e18ba2fd827b88a3$export$f816cf434e677dee),
    title: (0, $4NsPm.messages).title,
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($90efa7a25522fba0$var$Description, null)
};

});
parcelRegister("68etL", function(module, exports) {
$parcel$export(module.exports, "TaskDescription", () => $0ec884cef22f3f36$export$b873f81d43275cc7);
/* TaskDescription.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
const $0ec884cef22f3f36$var$styles = {
    root: "_1q51utpp"
};
const $0ec884cef22f3f36$export$b873f81d43275cc7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.150",
        xcss: $0ec884cef22f3f36$var$styles.root,
        alignInline: "start"
    }, children);
};

});

parcelRegister("3VnMy", function(module, exports) {
$parcel$export(module.exports, "TaskDescriptionParagraph", () => $7a0cfe87d7e38b21$export$b49306d5ecfb170);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");
const $7a0cfe87d7e38b21$export$b49306d5ecfb170 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        color: "color.text.subtle"
    }, children);
};

});

parcelRegister("dfy3J", function(module, exports) {
$parcel$export(module.exports, "default", () => $a708aaffe1b376d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $7TGcD = parcelRequire("7TGcD");

var $gMaoE = parcelRequire("gMaoE");
const $a708aaffe1b376d6$var$TaskCompleteButton = ({ taskId: taskId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { completeTaskAndContinue: completeTaskAndContinue } = (0, $7TGcD.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "discovery",
        onClick: ()=>completeTaskAndContinue({
                id: taskId
            })
    }, formatMessage((0, $gMaoE.default).completeButton));
};
var $a708aaffe1b376d6$export$2e2bcd8739ae039 = $a708aaffe1b376d6$var$TaskCompleteButton;

});
parcelRegister("gMaoE", function(module, exports) {
$parcel$export(module.exports, "default", () => $82b7f673379f1108$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $82b7f673379f1108$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    completeButton: {
        "id": "polaris-components-quickstart.task-complete-button.got-it.non-final",
        "defaultMessage": "Got it"
    }
});

});


parcelRegister("1Ritr", function(module, exports) {
module.exports = new URL("createViewLight.260d0208.svg", import.meta.url).toString();

});

parcelRegister("g8qL6", function(module, exports) {
module.exports = new URL("createViewDark.bbb69103.svg", import.meta.url).toString();

});

parcelRegister("4NsPm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6d49951115234961$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6d49951115234961$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-components-quickstart.tasks.create-a-view.title.non-final",
        "defaultMessage": "Create a view"
    },
    description: {
        "id": "polaris-components-quickstart.tasks.create-a-view.description.non-final",
        "defaultMessage": "Create and customize views to plan, prioritize, and roadmap for different audiences. Start with a board view for high-level planning."
    }
});

});

const $e18ba2fd827b88a3$export$f816cf434e677dee = 'create-a-view';
const $e18ba2fd827b88a3$export$30ad2951b1cf1b33 = 'create-ideas';
const $e18ba2fd827b88a3$export$8d9258d292f81935 = 'explore-the-basics';
const $e18ba2fd827b88a3$export$39af1a15320a84e2 = 'prioritize-and-plan';
const $e18ba2fd827b88a3$export$bd35b6e0e584664 = 'share-and-collaborate';
const $e18ba2fd827b88a3$export$6d534f87beed5245 = 'link-work-items';


parcelRegister("gS8cS", function(module, exports) {
$parcel$export(module.exports, "createIdeas", () => $9f9efbfbfca76c96$export$de73e985f7b7b3b0);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $68etL = parcelRequire("68etL");

var $3VnMy = parcelRequire("3VnMy");

var $3b57Z = parcelRequire("3b57Z");


var $7TGcD = parcelRequire("7TGcD");

var $5eSCY = parcelRequire("5eSCY");

const $9f9efbfbfca76c96$var$Description = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setSpotlightStepId: setSpotlightStepId } = (0, $7TGcD.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68etL.TaskDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VnMy.TaskDescriptionParagraph), null, formatMessage((0, $5eSCY.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3b57Z.default), {
        onClick: ()=>setSpotlightStepId((0, $0af1036be18b697e$export$849de9135b13f81c))
    }));
};
const $9f9efbfbfca76c96$export$de73e985f7b7b3b0 = {
    id: (0, $e18ba2fd827b88a3$export$30ad2951b1cf1b33),
    title: (0, $5eSCY.messages).title,
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f9efbfbfca76c96$var$Description, null)
};

});
parcelRegister("3b57Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7325305563031c9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $tAmun = parcelRequire("tAmun");
const $a7325305563031c9$var$ShowMeButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "discovery",
        onClick: onClick
    }, formatMessage((0, $tAmun.messages).showMeButton));
};
var $a7325305563031c9$export$2e2bcd8739ae039 = $a7325305563031c9$var$ShowMeButton;

});
parcelRegister("tAmun", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0df567b1f9bdefdc$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $0df567b1f9bdefdc$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    showMeButton: {
        "id": "polaris-components-quickstart.show-me-button.show-me-button.non-final",
        "defaultMessage": "Show me"
    }
});

});


const $0af1036be18b697e$export$d9300547121ff68 = 'create-ideas-tour-spotlight';
const $0af1036be18b697e$export$849de9135b13f81c = 'create-ideas-tour-step-1-spotlight';

parcelRegister("5eSCY", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0d06d0cdbafb80d8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $0d06d0cdbafb80d8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-components-quickstart.tasks.create-ideas.title.non-final",
        "defaultMessage": "Create ideas"
    },
    description: {
        "id": "polaris-components-quickstart.tasks.create-ideas.description.non-final",
        "defaultMessage": "Create new ideas separately, in bulk, or import existing ones using a form."
    }
});

});


parcelRegister("edV3I", function(module, exports) {
$parcel$export(module.exports, "exploreTheBasics", () => $80dc250b6a9ab382$export$5c35f5a3dd4cbc99);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $68etL = parcelRequire("68etL");

var $3VnMy = parcelRequire("3VnMy");

var $3b57Z = parcelRequire("3b57Z");


var $7TGcD = parcelRequire("7TGcD");

var $9CGdb = parcelRequire("9CGdb");

const $80dc250b6a9ab382$var$Description = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setSpotlightStepId: setSpotlightStepId, navigateToAllIdeas: navigateToAllIdeas } = (0, $7TGcD.useActions)();
    const handleShowMeClick = (0, $eJOHy.useCallback)(()=>{
        navigateToAllIdeas();
        setSpotlightStepId((0, $9acb89719e9af3ea$export$542834e2baac4f0d));
    }, [
        navigateToAllIdeas,
        setSpotlightStepId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68etL.TaskDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VnMy.TaskDescriptionParagraph), null, formatMessage((0, $9CGdb.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3b57Z.default), {
        onClick: handleShowMeClick
    }));
};
const $80dc250b6a9ab382$export$5c35f5a3dd4cbc99 = {
    id: (0, $e18ba2fd827b88a3$export$8d9258d292f81935),
    title: (0, $9CGdb.messages).title,
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($80dc250b6a9ab382$var$Description, null)
};

});
const $9acb89719e9af3ea$export$d026c895dd1f74f2 = 'explore-basics-tour-spotlight';
const $9acb89719e9af3ea$export$542834e2baac4f0d = 'explore-basics-tour-step-1-spotlight';
const $9acb89719e9af3ea$export$3afe4e8eeeb0051d = 'explore-basics-tour-step-2-spotlight';
const $9acb89719e9af3ea$export$b2894f6e02089d0f = 'explore-basics-tour-step-3-spotlight';

parcelRegister("9CGdb", function(module, exports) {
$parcel$export(module.exports, "messages", () => $71952b02e55217c3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $71952b02e55217c3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-components-quickstart.tasks.explore-the-basics.title.non-final",
        "defaultMessage": "Explore the basics"
    },
    description: {
        "id": "polaris-components-quickstart.tasks.explore-the-basics.description.non-final",
        "defaultMessage": "Collect ideas, add structure with custom fields, and tailor views with filters to focus on what matters most to your team."
    }
});

});


parcelRegister("b5cxs", function(module, exports) {
$parcel$export(module.exports, "prioritizeAndPlan", () => $ef3acaaef080273f$export$1dcbc9eab06dd4c8);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $68etL = parcelRequire("68etL");

var $3VnMy = parcelRequire("3VnMy");

var $bQE05 = parcelRequire("bQE05");

var $dfy3J = parcelRequire("dfy3J");

var $kdPcL = parcelRequire("kdPcL");

const $ef3acaaef080273f$var$Description = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68etL.TaskDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VnMy.TaskDescriptionParagraph), null, formatMessage((0, $kdPcL.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQE05.TaskDescriptionTip), null, formatMessage((0, $kdPcL.messages).tip)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dfy3J.default), {
        taskId: (0, $e18ba2fd827b88a3$export$39af1a15320a84e2)
    }));
};
const $ef3acaaef080273f$export$1dcbc9eab06dd4c8 = {
    id: (0, $e18ba2fd827b88a3$export$39af1a15320a84e2),
    title: (0, $kdPcL.messages).title,
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef3acaaef080273f$var$Description, null)
};

});
parcelRegister("bQE05", function(module, exports) {
$parcel$export(module.exports, "TaskDescriptionTip", () => $ee2154a1bd5ea227$export$be18e35fb7f5c38e);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");
const $ee2154a1bd5ea227$export$be18e35fb7f5c38e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtlest"
    }, children);
};

});

parcelRegister("kdPcL", function(module, exports) {
$parcel$export(module.exports, "messages", () => $822c3803c8c0ad16$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $822c3803c8c0ad16$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-components-quickstart.tasks.prioritize-and-plan.title.non-final",
        "defaultMessage": "Prioritize and plan"
    },
    description: {
        "id": "polaris-components-quickstart.tasks.prioritize-and-plan.description.non-final",
        "defaultMessage": "Use fields to develop your prioritization framework through team collaboration and flexible planning."
    },
    tip: {
        "id": "polaris-components-quickstart.tasks.prioritize-and-plan.tip.non-final",
        "defaultMessage": "Tip: You can use impact, effort, or other numeric fields. Try pre-built views to check other methods."
    }
});

});


parcelRegister("cCLxq", function(module, exports) {
$parcel$export(module.exports, "shareAndCollaborate", () => $8f2342a36357ab2d$export$c6de541c7b99d7d7);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $68etL = parcelRequire("68etL");

var $3VnMy = parcelRequire("3VnMy");

var $3b57Z = parcelRequire("3b57Z");


var $7TGcD = parcelRequire("7TGcD");

var $ccMt6 = parcelRequire("ccMt6");

const $8f2342a36357ab2d$var$Description = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setSpotlightStepId: setSpotlightStepId } = (0, $7TGcD.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68etL.TaskDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VnMy.TaskDescriptionParagraph), null, formatMessage((0, $ccMt6.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3b57Z.default), {
        onClick: ()=>setSpotlightStepId((0, $ed35dbc9f829e1e0$export$f766a539154e21d))
    }));
};
const $8f2342a36357ab2d$export$c6de541c7b99d7d7 = {
    id: (0, $e18ba2fd827b88a3$export$bd35b6e0e584664),
    title: (0, $ccMt6.messages).title,
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f2342a36357ab2d$var$Description, null)
};

});
const $ed35dbc9f829e1e0$export$bab23b15deb95b2d = 'share-and-collaborate-tour-spotlight';
const $ed35dbc9f829e1e0$export$f766a539154e21d = 'share-and-collaborate-tour-step-1-spotlight';

parcelRegister("ccMt6", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d33332dd1dce7f29$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d33332dd1dce7f29$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-components-quickstart.tasks.share-and-collaborate.title.non-final",
        "defaultMessage": "Share and collaborate"
    },
    description: {
        "id": "polaris-components-quickstart.tasks.share-and-collaborate.description.non-final",
        "defaultMessage": "Share views to engage teams and stakeholders through real-time collaboration, voting, and comments."
    }
});

});


parcelRegister("i7APR", function(module, exports) {
$parcel$export(module.exports, "linkWorkItems", () => $6a2f8a8388e4e11f$export$a9f6cac4e3db6929);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $68etL = parcelRequire("68etL");

var $3VnMy = parcelRequire("3VnMy");

var $bQE05 = parcelRequire("bQE05");

var $3b57Z = parcelRequire("3b57Z");

var $7TGcD = parcelRequire("7TGcD");

var $2voMI = parcelRequire("2voMI");

const $6a2f8a8388e4e11f$var$Description = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { openDeliveryTab: openDeliveryTab, completeTaskAndContinue: completeTaskAndContinue } = (0, $7TGcD.useActions)();
    const showMeButtonClickHandler = (0, $eJOHy.useCallback)(()=>{
        openDeliveryTab();
        completeTaskAndContinue({
            id: (0, $e18ba2fd827b88a3$export$6d534f87beed5245)
        });
    }, [
        openDeliveryTab,
        completeTaskAndContinue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68etL.TaskDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VnMy.TaskDescriptionParagraph), null, formatMessage((0, $2voMI.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQE05.TaskDescriptionTip), null, formatMessage((0, $2voMI.messages).tip)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3b57Z.default), {
        onClick: showMeButtonClickHandler
    }));
};
const $6a2f8a8388e4e11f$export$a9f6cac4e3db6929 = {
    id: (0, $e18ba2fd827b88a3$export$6d534f87beed5245),
    title: (0, $2voMI.messages).title,
    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a2f8a8388e4e11f$var$Description, null)
};

});
parcelRegister("2voMI", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4a71dbb85a8c16b5$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4a71dbb85a8c16b5$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "polaris-components-quickstart.tasks.link-work-items.title.non-final",
        "defaultMessage": "Link Jira work items"
    },
    description: {
        "id": "polaris-components-quickstart.tasks.link-work-items.description.non-final",
        "defaultMessage": "Move ideas forward with Jira work items to track the delivery progress."
    },
    tip: {
        "id": "polaris-components-quickstart.tasks.link-work-items.tip.non-final",
        "defaultMessage": "Tip: Add delivery progress field to your view."
    }
});

});



parcelRegister("iErFI", function(module, exports) {
$parcel$export(module.exports, "OnboardingCheckList", () => $a5509a26ab9a8bf1$export$de4ee3a2e71e8d75);

var $eJOHy = parcelRequire("eJOHy");

var $fC9MJ = parcelRequire("fC9MJ");

var $lRq8t = parcelRequire("lRq8t");

var $dfP3D = parcelRequire("dfP3D");

var $7TGcD = parcelRequire("7TGcD");

var $fKUFY = parcelRequire("fKUFY");

var $3PkyJ = parcelRequire("3PkyJ");

var $8rXz9 = parcelRequire("8rXz9");

var $1niiU = parcelRequire("1niiU");
const $a5509a26ab9a8bf1$export$de4ee3a2e71e8d75 = ({ taskDictionary: taskDictionary })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tasks = (0, $7TGcD.useTasks)();
    const openTaskId = (0, $7TGcD.useOpenTaskId)();
    const { closeCurrentTask: closeCurrentTask, setOpenTaskId: setOpenTaskId, setQuickstartBannerVisibility: setQuickstartBannerVisibility } = (0, $7TGcD.useActions)();
    const { closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const handleTaskExpand = (0, $eJOHy.useCallback)((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setOpenTaskId({
            id: id
        });
    }, [
        setOpenTaskId
    ]);
    if (!tasks) return null;
    const changeQuickstartBannerVisibility = ({ visibility: visibility })=>{
        closeCurrentTask();
        setQuickstartBannerVisibility({
            visibility: visibility
        });
        closeRightSidebar((0, $fKUFY.QUICKSTART_PANEL_ID));
    };
    // TODO: POL-17792 handle the case where the task is not in the taskDictionary
    const tasksToRender = tasks.items.map((task)=>{
        return {
            ...taskDictionary[task.id],
            completed: task.completed
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fC9MJ.default), {
        tasks: tasksToRender,
        isOpen: true,
        onClose: ()=>changeQuickstartBannerVisibility({
                visibility: (0, $fKUFY.QUICKSTART_UI_STATUS_MINIMIZED)
            }),
        title: formatMessage((0, $8rXz9.default).title),
        expandedTask: openTaskId ?? undefined,
        onTaskExpand: handleTaskExpand,
        postTasksComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1niiU.OnboardingCheckListPostTasks), null),
        footer: {
            wrapper: (0, $3PkyJ.OnboardingChecklistFooter),
            dismissTitle: formatMessage((0, $8rXz9.default).dismissQuickstart),
            onDismiss: ()=>changeQuickstartBannerVisibility({
                    visibility: (0, $fKUFY.QUICKSTART_UI_STATUS_DISMISSED)
                })
        }
    });
};

});
parcelRegister("fC9MJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cede7fb0346c8571$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $f5m0f = parcelRequire("f5m0f");

var $7auOG = parcelRequire("7auOG");
var $aS0V1 = parcelRequire("aS0V1");

var $jsybZ = parcelRequire("jsybZ");

var $6tjyh = parcelRequire("6tjyh");

var $aWyTc = parcelRequire("aWyTc");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $cede7fb0346c8571$var$checklistTitleContainerStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.250',
    paddingLeft: 'space.250',
    marginTop: 'space.0',
    marginBottom: 'space.200',
    textAlign: 'center'
});
var $cede7fb0346c8571$export$2e2bcd8739ae039 = (props)=>{
    const { title: title, isOpen: isOpen, onClose: onClose, footer: footer, shouldFocus: shouldFocus } = props;
    const { tasks: tasks, onTaskExpand: onTaskExpand, expandedTask: expandedTask } = props;
    const { header: header, postTasksComponent: postTasksComponent, progressBarAriaLabel: progressBarAriaLabel } = props;
    const completedTasks = tasks.reduce((acc, task)=>{
        return task.completed ? acc + 1 : acc;
    }, 0);
    const percentCompleted = completedTasks / tasks.length;
    const completed = percentCompleted === 1;
    const ChecklistTitle = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            xcss: $cede7fb0346c8571$var$checklistTitleContainerStyles,
            id: (0, $a0926f35acf8e3c4$export$beeaed0c9599147a),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                color: "color.text.inverse",
                size: "large",
                as: "h2",
                children: children
            })
        });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $f5m0f.OverflowWrapper), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $f5m0f.FlexContent), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f5m0f.Background), {
                            done: completed,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jsybZ.default), {})
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $f5m0f.ContentWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aWyTc.default), {
                                    header: header,
                                    onClose: onClose,
                                    shouldFocus: shouldFocus
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)(ChecklistTitle, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $f5m0f.BodyWrapper), {
                                    children: [
                                        !completed && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aS0V1.default), {
                                            value: percentCompleted,
                                            ariaLabel: progressBarAriaLabel || title
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7auOG.default), {
                                            tasks: tasks,
                                            expandedTask: expandedTask,
                                            onTaskExpand: onTaskExpand
                                        }),
                                        postTasksComponent && postTasksComponent
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                footer && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6tjyh.default), {
                    ...footer
                })
            ]
        })
    });
};

});
parcelRegister("f5m0f", function(module, exports) {
$parcel$export(module.exports, "CHECKLIST_BACKGROUND_HEIGHT", () => $fff977e3227f9cfc$export$d62444c2b7160692);
$parcel$export(module.exports, "OverflowWrapper", () => $fff977e3227f9cfc$export$5795aa5ceac6bdd8);
$parcel$export(module.exports, "Background", () => $fff977e3227f9cfc$export$668799e4797757a8);
$parcel$export(module.exports, "FlexContent", () => $fff977e3227f9cfc$export$d77e6273750b9257);
$parcel$export(module.exports, "ContentWrapper", () => $fff977e3227f9cfc$export$6ce170286acaa8d3);
$parcel$export(module.exports, "HeaderWrapper", () => $fff977e3227f9cfc$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $fff977e3227f9cfc$export$14966827497f4695);
$parcel$export(module.exports, "Footer", () => $fff977e3227f9cfc$export$a06f1c675e846f6f);
$parcel$export(module.exports, "FooterDismissLink", () => $fff977e3227f9cfc$export$e424914bc2c73edc);
$parcel$export(module.exports, "DismissButtonWrapper", () => $fff977e3227f9cfc$export$ecd302d445cfa633);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $jsybZ = parcelRequire("jsybZ");

function $fff977e3227f9cfc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fff977e3227f9cfc$var$dismissButtonWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $fff977e3227f9cfc$var$flexContentStyles = {
    name: "1doh296",
    styles: "position:relative;box-sizing:border-box;display:flex;flex-direction:column"
};
const $fff977e3227f9cfc$var$footerTitleStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.100'
});
const $fff977e3227f9cfc$var$FADE_DURATION = '0.5s';
const $fff977e3227f9cfc$export$d62444c2b7160692 = 140;
const $fff977e3227f9cfc$var$isSafari = ()=>/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var $fff977e3227f9cfc$var$_ref3 = {
    name: "7of5p8",
    styles: "overflow-y:auto;overflow-x:hidden;background:var(--ds-background-neutral, #f4f5f7);width:100%;height:100%;position:relative"
};
const $fff977e3227f9cfc$export$5795aa5ceac6bdd8 = ({ children: children, ...restProp })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $fff977e3227f9cfc$var$_ref3,
        role: "dialog",
        "aria-labelledby": (0, $a0926f35acf8e3c4$export$beeaed0c9599147a),
        ...restProp
    }, children);
const $fff977e3227f9cfc$export$668799e4797757a8 = ({ done: done, children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            width: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '#Rectangle': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                fill: done ? (0, $jsybZ.completeColors).mainFillColor : (0, $jsybZ.inProgressColors).mainFillColor,
                transition: `all ${$fff977e3227f9cfc$var$FADE_DURATION} ease-in-out`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '#linearGradient': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'stop:first-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    stopColor: done ? (0, $jsybZ.completeColors).gradientFillColor : (0, $jsybZ.inProgressColors).gradientFillColor,
                    transition: `all ${$fff977e3227f9cfc$var$FADE_DURATION} ease-in-out`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'stop:last-of-type': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    stopColor: done ? (0, $jsybZ.completeColors).gradientFillColor : (0, $jsybZ.inProgressColors).gradientFillColor,
                    transition: `all ${$fff977e3227f9cfc$var$FADE_DURATION} ease-in-out`
                }
            }
        })
    }, children);
const $fff977e3227f9cfc$export$d77e6273750b9257 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $fff977e3227f9cfc$var$flexContentStyles
    }, children);
const $fff977e3227f9cfc$export$6ce170286acaa8d3 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: $fff977e3227f9cfc$var$isSafari() ? 'initial' : 1,
            position: 'relative'
        })
    }, children);
var $fff977e3227f9cfc$var$_ref2 = {
    name: "12o4pcv",
    styles: "display:flex;align-items:flex-start;justify-content:space-between;padding:var(--ds-space-100, 8px)"
};
const $fff977e3227f9cfc$export$960a49cc3d27a090 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $fff977e3227f9cfc$var$_ref2
    }, children);
const $fff977e3227f9cfc$export$14966827497f4695 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-600, 48px)"}`
        })
    }, children);
var $fff977e3227f9cfc$var$_ref = {
    name: "8m06s8",
    styles: "background:var(--ds-background-neutral-subtle, #f4f5f7);padding-top:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-200, 16px);position:absolute;bottom:var(--ds-space-0, 0px);left:var(--ds-space-0, 0px);right:var(--ds-space-0, 0px);text-align:center;z-index:1"
};
const $fff977e3227f9cfc$export$a06f1c675e846f6f = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $fff977e3227f9cfc$var$_ref
    }, children);
const $fff977e3227f9cfc$export$53e4a0ea45e729a2 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        as: "p",
        xcss: $fff977e3227f9cfc$var$footerTitleStyles
    }, children);
const $fff977e3227f9cfc$export$e424914bc2c73edc = ({ children: children, href: href, onClick: onClick, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $1NIU8.jsx)("a", {
        href: href,
        onClick: onClick,
        ...rest,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            color: `var(--ds-text-discovery, ${(0, $7bb4c1736002a04a$exports).P300})`,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            '&:hover': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                color: `var(--ds-text-discovery, ${(0, $7bb4c1736002a04a$exports).P300})`,
                textDecoration: 'none'
            }
        })
    }, children);
const $fff977e3227f9cfc$export$ecd302d445cfa633 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $fff977e3227f9cfc$var$dismissButtonWrapperStyles
    }, children);

});
parcelRegister("jsybZ", function(module, exports) {
$parcel$export(module.exports, "completeColors", () => $93bf7b77f0ee4852$export$f5d31080b557ff0f);
$parcel$export(module.exports, "inProgressColors", () => $93bf7b77f0ee4852$export$92d5a795ccd8d470);
$parcel$export(module.exports, "default", () => $93bf7b77f0ee4852$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $f5m0f = parcelRequire("f5m0f");

const $93bf7b77f0ee4852$export$f5d31080b557ff0f = {
    mainFillColor: `var(--ds-background-accent-green-bolder, ${(0, $7bb4c1736002a04a$exports).G400})`,
    gradientFillColor: `var(--ds-background-accent-green-subtle, ${(0, $7bb4c1736002a04a$exports).G300})`
};
const $93bf7b77f0ee4852$export$92d5a795ccd8d470 = {
    mainFillColor: `var(--ds-background-accent-purple-bolder, ${(0, $7bb4c1736002a04a$exports).P500})`,
    gradientFillColor: `var(--ds-background-accent-purple-subtle, ${(0, $7bb4c1736002a04a$exports).P300})`
};
var $93bf7b77f0ee4852$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "100%",
        height: `${(0, $f5m0f.CHECKLIST_BACKGROUND_HEIGHT)}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 360 ${(0, $f5m0f.CHECKLIST_BACKGROUND_HEIGHT)}`,
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                id: "Rectangle",
                width: "100%",
                height: `${(0, $f5m0f.CHECKLIST_BACKGROUND_HEIGHT)}`,
                fill: `${$93bf7b77f0ee4852$export$92d5a795ccd8d470.mainFillColor}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M152.5 48.5C65.5 -9.5 -5.50005 61 0.999949 140H365V35.5C365 35.5 239.5 106.5 152.5 48.5Z",
                fill: "url(#linearGradient)",
                fillOpacity: "0.71"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                    id: "linearGradient",
                    x1: "360",
                    y1: "108.121",
                    x2: "97.062",
                    y2: "164.602",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                            offset: "0%",
                            stopColor: `${$93bf7b77f0ee4852$export$92d5a795ccd8d470.gradientFillColor}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                            offset: "100%",
                            stopColor: `${$93bf7b77f0ee4852$export$92d5a795ccd8d470.gradientFillColor}`,
                            stopOpacity: "0"
                        })
                    ]
                })
            })
        ]
    });

});

const $a0926f35acf8e3c4$export$beeaed0c9599147a = 'checklist-title';


parcelRegister("7auOG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c41c713ca7fa211$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bDjgN = parcelRequire("bDjgN");

var $8XIqi = parcelRequire("8XIqi");
var $gXIRa = parcelRequire("gXIRa");

var $axOsj = parcelRequire("axOsj");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
var $9c41c713ca7fa211$export$2e2bcd8739ae039 = ({ tasks: tasks, onTaskExpand: onTaskExpand, expandedTask: expandedTask })=>{
    const tasksJsx = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: tasks.map((task)=>{
            const isOpen = task.id === expandedTask;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8XIqi.default), {
                    expanded: isOpen,
                    id: task.id,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gXIRa.default), {
                            expanded: isOpen,
                            onClick: onTaskExpand,
                            ...task
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bDjgN.default), {
                            ...task,
                            expanded: isOpen
                        })
                    ]
                }, task.id)
            }, task.id);
        })
    });
    return (0, $eGOwo.fg)('jira_onboarding_a11y_fixes_for_quickstart') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "ul",
        xcss: $9c41c713ca7fa211$var$listStyles,
        children: tasksJsx
    }) : tasksJsx;
};
const $9c41c713ca7fa211$var$listStyles = (0, $1DXK0.xcss)({
    listStyle: 'none',
    marginTop: 'space.0',
    paddingLeft: 'space.0'
});

});
parcelRegister("bDjgN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0c41e4064abf83$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bIYSH = parcelRequire("bIYSH");

var $cVTCY = parcelRequire("cVTCY");
const $4f0c41e4064abf83$var$ANIMATION_DURATION = 200;
var $4f0c41e4064abf83$export$2e2bcd8739ae039 = ({ children: children, expanded: expanded })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cVTCY))), {
        duration: $4f0c41e4064abf83$var$ANIMATION_DURATION,
        easing: "ease",
        height: expanded ? 'auto' : 0,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIYSH.ChecklistDescriptionWrapper), {
            children: children
        })
    });

});
parcelRegister("bIYSH", function(module, exports) {
$parcel$export(module.exports, "ChecklistDescriptionWrapper", () => $caca537fdf984eb4$export$cce93cdcfd495091);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// This is needed for the animation to work properly in most browsers.
// It has to be an upper bound, but not too high or the animation will lag.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
const $caca537fdf984eb4$export$cce93cdcfd495091 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ew0mqjv0"
})({
    padding: `0 ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
});

});

parcelRegister("cVTCY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $96a5f5668814143a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $96a5f5668814143a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $96a5f5668814143a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $96a5f5668814143a$var$_react2 = $96a5f5668814143a$var$_interopRequireDefault($eJOHy);

var $cT3Ey = parcelRequire("cT3Ey");
var $96a5f5668814143a$var$_propTypes2 = $96a5f5668814143a$var$_interopRequireDefault($cT3Ey);

var $k9JrM = parcelRequire("k9JrM");
var $96a5f5668814143a$var$_classnames2 = $96a5f5668814143a$var$_interopRequireDefault($k9JrM);
function $96a5f5668814143a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $96a5f5668814143a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96a5f5668814143a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $96a5f5668814143a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $96a5f5668814143a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $96a5f5668814143a$var$ANIMATION_STATE_CLASSES = {
    animating: 'rah-animating',
    animatingUp: 'rah-animating--up',
    animatingDown: 'rah-animating--down',
    animatingToHeightZero: 'rah-animating--to-height-zero',
    animatingToHeightAuto: 'rah-animating--to-height-auto',
    animatingToHeightSpecific: 'rah-animating--to-height-specific',
    static: 'rah-static',
    staticHeightZero: 'rah-static--height-zero',
    staticHeightAuto: 'rah-static--height-auto',
    staticHeightSpecific: 'rah-static--height-specific'
};
var $96a5f5668814143a$var$PROPS_TO_OMIT = [
    'animateOpacity',
    'animationStateClasses',
    'applyInlineTransitions',
    'children',
    'contentClassName',
    'delay',
    'duration',
    'easing',
    'height',
    'onAnimationEnd',
    'onAnimationStart'
];
function $96a5f5668814143a$var$omit(obj) {
    for(var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)keys[_key - 1] = arguments[_key];
    if (!keys.length) return obj;
    var res = {};
    var objectKeys = Object.keys(obj);
    for(var i = 0; i < objectKeys.length; i++){
        var key = objectKeys[i];
        if (keys.indexOf(key) === -1) res[key] = obj[key];
    }
    return res;
}
// Start animation helper using nested requestAnimationFrames
function $96a5f5668814143a$var$startAnimationHelper(callback) {
    var requestAnimationFrameIDs = [];
    requestAnimationFrameIDs[0] = requestAnimationFrame(function() {
        requestAnimationFrameIDs[1] = requestAnimationFrame(function() {
            callback();
        });
    });
    return requestAnimationFrameIDs;
}
function $96a5f5668814143a$var$cancelAnimationFrames(requestAnimationFrameIDs) {
    requestAnimationFrameIDs.forEach(function(id) {
        return cancelAnimationFrame(id);
    });
}
function $96a5f5668814143a$var$isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $96a5f5668814143a$var$isPercentage(height) {
    // Percentage height
    return typeof height === 'string' && height.search('%') === height.length - 1 && $96a5f5668814143a$var$isNumber(height.substr(0, height.length - 1));
}
function $96a5f5668814143a$var$runCallback(callback, params) {
    if (callback && typeof callback === 'function') callback(params);
}
var $96a5f5668814143a$var$AnimateHeight = function(_React$Component) {
    $96a5f5668814143a$var$_inherits(AnimateHeight, _React$Component);
    function AnimateHeight(props) {
        $96a5f5668814143a$var$_classCallCheck(this, AnimateHeight);
        var _this = $96a5f5668814143a$var$_possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));
        _this.animationFrameIDs = [];
        var height = 'auto';
        var overflow = 'visible';
        if ($96a5f5668814143a$var$isNumber(props.height)) {
            // If value is string "0" make sure we convert it to number 0
            height = props.height < 0 || props.height === '0' ? 0 : props.height;
            overflow = 'hidden';
        } else if ($96a5f5668814143a$var$isPercentage(props.height)) {
            // If value is string "0%" make sure we convert it to number 0
            height = props.height === '0%' ? 0 : props.height;
            overflow = 'hidden';
        }
        _this.animationStateClasses = $96a5f5668814143a$var$_extends({}, $96a5f5668814143a$var$ANIMATION_STATE_CLASSES, props.animationStateClasses);
        var animationStateClasses = _this.getStaticStateClasses(height);
        var isBrowser = typeof window !== 'undefined';
        if (isBrowser && window.matchMedia) _this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
        _this.state = {
            animationStateClasses: animationStateClasses,
            height: height,
            overflow: overflow,
            shouldUseTransitions: false
        };
        return _this;
    }
    $96a5f5668814143a$var$_createClass(AnimateHeight, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var height = this.state.height;
                // Hide content if height is 0 (to prevent tabbing into it)
                // Check for contentElement is added cause this would fail in tests (react-test-renderer)
                // Read more here: https://github.com/Stanko/react-animate-height/issues/17
                if (this.contentElement && this.contentElement.style) this.hideContent(height);
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props = this.props, height = _props.height, onAnimationEnd = _props.onAnimationEnd, onAnimationStart = _props.onAnimationStart;
                var _getTimings = this.getTimings(), duration = _getTimings.duration, delay = _getTimings.delay;
                // Check if 'height' prop has changed
                if (this.contentElement && height !== prevProps.height) {
                    var _cx;
                    // Remove display: none from the content div
                    // if it was hidden to prevent tabbing into it
                    this.showContent(prevState.height);
                    // Cache content height
                    this.contentElement.style.overflow = 'hidden';
                    var contentHeight = this.contentElement.offsetHeight;
                    this.contentElement.style.overflow = '';
                    // set total animation time
                    var totalDuration = duration + delay;
                    var newHeight = null;
                    var timeoutState = {
                        height: null,
                        overflow: 'hidden'
                    };
                    var isCurrentHeightAuto = prevState.height === 'auto';
                    if ($96a5f5668814143a$var$isNumber(height)) {
                        // If value is string "0" make sure we convert it to number 0
                        newHeight = height < 0 || height === '0' ? 0 : height;
                        timeoutState.height = newHeight;
                    } else if ($96a5f5668814143a$var$isPercentage(height)) {
                        // If value is string "0%" make sure we convert it to number 0
                        newHeight = height === '0%' ? 0 : height;
                        timeoutState.height = newHeight;
                    } else {
                        // If not, animate to content height
                        // and then reset to auto
                        newHeight = contentHeight; // TODO solve contentHeight = 0
                        timeoutState.height = 'auto';
                        timeoutState.overflow = null;
                    }
                    if (isCurrentHeightAuto) {
                        // This is the height to be animated to
                        timeoutState.height = newHeight;
                        // If previous height was 'auto'
                        // set starting height explicitly to be able to use transition
                        newHeight = contentHeight;
                    }
                    // Animation classes
                    var animationStateClasses = (0, $96a5f5668814143a$var$_classnames2.default)((_cx = {}, $96a5f5668814143a$var$_defineProperty(_cx, this.animationStateClasses.animating, true), $96a5f5668814143a$var$_defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), $96a5f5668814143a$var$_defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), $96a5f5668814143a$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), $96a5f5668814143a$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), $96a5f5668814143a$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));
                    // Animation classes to be put after animation is complete
                    var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);
                    // Set starting height and animating classes
                    // We are safe to call set state as it will not trigger infinite loop
                    // because of the "height !== prevProps.height" check
                    this.setState({
                        animationStateClasses: animationStateClasses,
                        height: newHeight,
                        overflow: 'hidden',
                        // When animating from 'auto' we first need to set fixed height
                        // that change should be animated
                        shouldUseTransitions: !isCurrentHeightAuto
                    });
                    // Clear timeouts
                    clearTimeout(this.timeoutID);
                    clearTimeout(this.animationClassesTimeoutID);
                    if (isCurrentHeightAuto) {
                        // When animating from 'auto' we use a short timeout to start animation
                        // after setting fixed height above
                        timeoutState.shouldUseTransitions = true;
                        $96a5f5668814143a$var$cancelAnimationFrames(this.animationFrameIDs);
                        this.animationFrameIDs = $96a5f5668814143a$var$startAnimationHelper(function() {
                            _this2.setState(timeoutState);
                            // ANIMATION STARTS, run a callback if it exists
                            $96a5f5668814143a$var$runCallback(onAnimationStart, {
                                newHeight: timeoutState.height
                            });
                        });
                        // Set static classes and remove transitions when animation ends
                        this.animationClassesTimeoutID = setTimeout(function() {
                            _this2.setState({
                                animationStateClasses: timeoutAnimationStateClasses,
                                shouldUseTransitions: false
                            });
                            // ANIMATION ENDS
                            // Hide content if height is 0 (to prevent tabbing into it)
                            _this2.hideContent(timeoutState.height);
                            // Run a callback if it exists
                            $96a5f5668814143a$var$runCallback(onAnimationEnd, {
                                newHeight: timeoutState.height
                            });
                        }, totalDuration);
                    } else {
                        // ANIMATION STARTS, run a callback if it exists
                        $96a5f5668814143a$var$runCallback(onAnimationStart, {
                            newHeight: newHeight
                        });
                        // Set end height, classes and remove transitions when animation is complete
                        this.timeoutID = setTimeout(function() {
                            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
                            timeoutState.shouldUseTransitions = false;
                            _this2.setState(timeoutState);
                            // ANIMATION ENDS
                            // If height is auto, don't hide the content
                            // (case when element is empty, therefore height is 0)
                            if (height !== 'auto') // Hide content if height is 0 (to prevent tabbing into it)
                            _this2.hideContent(newHeight); // TODO solve newHeight = 0
                            // Run a callback if it exists
                            $96a5f5668814143a$var$runCallback(onAnimationEnd, {
                                newHeight: newHeight
                            });
                        }, totalDuration);
                    }
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                $96a5f5668814143a$var$cancelAnimationFrames(this.animationFrameIDs);
                clearTimeout(this.timeoutID);
                clearTimeout(this.animationClassesTimeoutID);
                this.timeoutID = null;
            }
        },
        {
            key: 'getTimings',
            value: function getTimings() {
                if (this.prefersReducedMotion) return {
                    delay: 0,
                    duration: 0
                };
                var _props2 = this.props, delay = _props2.delay, duration = _props2.duration;
                return {
                    delay: delay,
                    duration: duration
                };
            }
        },
        {
            key: 'showContent',
            value: function showContent(height) {
                if (height === 0) this.contentElement.style.display = '';
            }
        },
        {
            key: 'hideContent',
            value: function hideContent(newHeight) {
                if (newHeight === 0) this.contentElement.style.display = 'none';
            }
        },
        {
            key: 'getStaticStateClasses',
            value: function getStaticStateClasses(height) {
                var _cx2;
                return (0, $96a5f5668814143a$var$_classnames2.default)((_cx2 = {}, $96a5f5668814143a$var$_defineProperty(_cx2, this.animationStateClasses.static, true), $96a5f5668814143a$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), $96a5f5668814143a$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), $96a5f5668814143a$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _cx3, _this3 = this;
                var _props3 = this.props, animateOpacity = _props3.animateOpacity, applyInlineTransitions = _props3.applyInlineTransitions, children = _props3.children, className = _props3.className, contentClassName = _props3.contentClassName, easing = _props3.easing, id = _props3.id, style = _props3.style;
                var _state = this.state, height = _state.height, overflow = _state.overflow, animationStateClasses = _state.animationStateClasses, shouldUseTransitions = _state.shouldUseTransitions;
                var _getTimings2 = this.getTimings(), duration = _getTimings2.duration, delay = _getTimings2.delay;
                var componentStyle = $96a5f5668814143a$var$_extends({}, style, {
                    height: height,
                    overflow: overflow || style.overflow
                });
                if (shouldUseTransitions && applyInlineTransitions) {
                    componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
                    // Include transition passed through styles
                    if (style.transition) componentStyle.transition = style.transition + ', ' + componentStyle.transition;
                    // Add webkit vendor prefix still used by opera, blackberry...
                    componentStyle.WebkitTransition = componentStyle.transition;
                }
                var contentStyle = {};
                if (animateOpacity) {
                    contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
                    // Add webkit vendor prefix still used by opera, blackberry...
                    contentStyle.WebkitTransition = contentStyle.transition;
                    if (height === 0) contentStyle.opacity = 0;
                }
                var componentClasses = (0, $96a5f5668814143a$var$_classnames2.default)((_cx3 = {}, $96a5f5668814143a$var$_defineProperty(_cx3, animationStateClasses, true), $96a5f5668814143a$var$_defineProperty(_cx3, className, className), _cx3));
                // Check if user passed aria-hidden prop
                var hasAriaHiddenProp = typeof this.props['aria-hidden'] !== 'undefined';
                var ariaHidden = hasAriaHiddenProp ? this.props['aria-hidden'] : height === 0;
                return $96a5f5668814143a$var$_react2.default.createElement('div', $96a5f5668814143a$var$_extends({}, $96a5f5668814143a$var$omit.apply(undefined, [
                    this.props
                ].concat($96a5f5668814143a$var$PROPS_TO_OMIT)), {
                    'aria-hidden': ariaHidden,
                    className: componentClasses,
                    id: id,
                    style: componentStyle
                }), $96a5f5668814143a$var$_react2.default.createElement('div', {
                    className: contentClassName,
                    style: contentStyle,
                    ref: function ref(el) {
                        return _this3.contentElement = el;
                    }
                }, children));
            }
        }
    ]);
    return AnimateHeight;
}($96a5f5668814143a$var$_react2.default.Component);
var $96a5f5668814143a$var$heightPropType = function heightPropType(props, propName, componentName) {
    var value = props[propName];
    if (typeof value === 'number' && value >= 0 || $96a5f5668814143a$var$isPercentage(value) || value === 'auto') return null;
    return new TypeError('value "' + value + '" of type "' + (typeof value === 'undefined' ? 'undefined' : $96a5f5668814143a$var$_typeof(value)) + '" is invalid type for ' + propName + ' in ' + componentName + '. ' + 'It needs to be a positive number, string "auto" or percentage string (e.g. "15%").');
};
$96a5f5668814143a$var$AnimateHeight.propTypes = {
    'aria-hidden': $96a5f5668814143a$var$_propTypes2.default.bool,
    animateOpacity: $96a5f5668814143a$var$_propTypes2.default.bool,
    animationStateClasses: $96a5f5668814143a$var$_propTypes2.default.object,
    applyInlineTransitions: $96a5f5668814143a$var$_propTypes2.default.bool,
    children: $96a5f5668814143a$var$_propTypes2.default.any.isRequired,
    className: $96a5f5668814143a$var$_propTypes2.default.string,
    contentClassName: $96a5f5668814143a$var$_propTypes2.default.string,
    delay: $96a5f5668814143a$var$_propTypes2.default.number,
    duration: $96a5f5668814143a$var$_propTypes2.default.number,
    easing: $96a5f5668814143a$var$_propTypes2.default.string,
    height: $96a5f5668814143a$var$heightPropType,
    id: $96a5f5668814143a$var$_propTypes2.default.string,
    onAnimationEnd: $96a5f5668814143a$var$_propTypes2.default.func,
    onAnimationStart: $96a5f5668814143a$var$_propTypes2.default.func,
    style: $96a5f5668814143a$var$_propTypes2.default.object
};
$96a5f5668814143a$var$AnimateHeight.defaultProps = {
    animateOpacity: false,
    animationStateClasses: $96a5f5668814143a$var$ANIMATION_STATE_CLASSES,
    applyInlineTransitions: true,
    duration: 250,
    delay: 0,
    easing: 'ease',
    style: {}
};
module.exports.default = $96a5f5668814143a$var$AnimateHeight;

});
parcelRegister("k9JrM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});



parcelRegister("8XIqi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e330aeafe73d3ae3$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $849Zq = parcelRequire("849Zq");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $eGOwo = parcelRequire("eGOwo");
const $e330aeafe73d3ae3$export$1cad4f611a1c0229 = 100;
const $e330aeafe73d3ae3$export$1e9ee88f033039e9 = 200;
const $e330aeafe73d3ae3$var$AccordionItem = ({ id: id, expanded: expanded, children: children })=>{
    if ((0, $eGOwo.fg)('jira_onboarding_a11y_fixes_for_quickstart')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "li",
        xcss: $e330aeafe73d3ae3$var$accordionWrapperStyles,
        "data-test-expanded": expanded,
        testId: `checklist-accordion-item-${id}`,
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $849Zq.AccordionWrapper), {
        "data-testid": `checklist-accordion-item-${id}`,
        "data-test-expanded": expanded,
        children: children
    });
};
const $e330aeafe73d3ae3$var$accordionWrapperStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.raised',
    marginTop: 'space.0',
    listStyleType: 'none'
});
var $e330aeafe73d3ae3$export$2e2bcd8739ae039 = $e330aeafe73d3ae3$var$AccordionItem;

});
parcelRegister("849Zq", function(module, exports) {
$parcel$export(module.exports, "AccordionWrapper", () => $f7a230680176751d$export$9e191cf2548357c0);
$parcel$export(module.exports, "AccordionItemButtonText", () => $f7a230680176751d$export$9e616db79ee131ce);
$parcel$export(module.exports, "AccordionItemContainer", () => $f7a230680176751d$export$15bfaa8f05e387be);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points


var $aWILV = parcelRequire("aWILV");
function $f7a230680176751d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f7a230680176751d$export$9e191cf2548357c0 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1bnb24h5"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-surface-raised, ${(0, $7bb4c1736002a04a$exports).N0})`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    boxShadow: `var(--ds-shadow-raised, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `0 1px 1px ${(0, $7bb4c1736002a04a$exports).N50A}, 0 0 1px 1px ${(0, $7bb4c1736002a04a$exports).N40A}`})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        borderTopRightRadius: "var(--ds-radius-small, 4px)",
        borderTopLeftRadius: "var(--ds-radius-small, 4px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-of-type': {
        borderBottomRightRadius: "var(--ds-radius-small, 4px)",
        borderBottomLeftRadius: "var(--ds-radius-small, 4px)"
    }
});
const $f7a230680176751d$export$dde0636a009aba84 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1bnb24h4"
})({
    name: "stffh5",
    styles: "position:relative;font:var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $f7a230680176751d$export$9e616db79ee131ce = /*#__PURE__*/ (0, $aWILV.default)("p", {
    target: "e1bnb24h3"
})({
    name: "1j0dqtw",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
});
const $f7a230680176751d$export$15bfaa8f05e387be = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1bnb24h2"
})({
    name: "1nkbh87",
    styles: "padding:var(--ds-space-100, 8px);cursor:auto"
});
const $f7a230680176751d$export$202f11ff33e21c6b = /*#__PURE__*/ (0, $aWILV.default)("p", {
    target: "e1bnb24h1"
})({
    name: "rbkjwc",
    styles: "font-weight:var(--ds-font-weight-medium, 500)"
});
const $f7a230680176751d$export$827bc0234dda3cf7 = /*#__PURE__*/ (0, $aWILV.default)("p", {
    target: "e1bnb24h0"
})({
    name: "f9wtrf",
    styles: "padding-bottom:var(--ds-space-200, 16px)"
});

});


parcelRegister("gXIRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ad915e1d4993472$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3WhYV = parcelRequire("3WhYV");

var $3TFuO = parcelRequire("3TFuO");

var $1kTzc = parcelRequire("1kTzc");

var $806LH = parcelRequire("806LH");

var $eGOwo = parcelRequire("eGOwo");
const $3ad915e1d4993472$var$ANIMATION_DURATION = 200;
const $3ad915e1d4993472$var$ClosedIndicator = (0, $3WhYV.checklistClosedIndicator)($3ad915e1d4993472$var$ANIMATION_DURATION);
var $3ad915e1d4993472$export$2e2bcd8739ae039 = ({ completed: completed, title: title, id: id, expanded: expanded, onClick: onClick })=>{
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        onClick(expanded ? '' : id);
    }, [
        expanded,
        onClick,
        id
    ]);
    // Space should only register on key up, but
    // requires prevent default to prevent page scroll
    // See https://hello.atlassian.net/wiki/spaces/~240225626/pages/1469726230/Accessibility+in+atlassiansox+checklist+and+Focus+Outline+Styles#Keyboard-Interaction-Behaviours
    const handleKeyDown = (event)=>{
        // Enter or Space key
        if (event.keyCode === 13 || event.keyCode === 32) {
            event.preventDefault();
            // Enter Key
            if (event.keyCode === 13) handleClick();
        }
    };
    const handleKeyUp = (event)=>{
        // Space key
        if (event.keyCode === 32) {
            event.preventDefault();
            handleClick();
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3WhYV.AccordionToggleButton), {
        onClick: handleClick,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        "data-testid": `accordion-toggle-button-${id}`,
        "aria-expanded": expanded,
        type: "button",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3WhYV.ChecklistTitleWrapper), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3WhYV.ChecklistTaskDoneIndicator), {
                    done: completed,
                    "data-test-completed": completed,
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: "checked"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: "xsmall",
                    as: (0, $eGOwo.fg)('jira_improve_qs_checklist_item_title_accessibility') ? 'div' : 'h3',
                    children: title
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($3ad915e1d4993472$var$ClosedIndicator, {
                    expanded: expanded,
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1kTzc))), {
                        color: "currentColor",
                        label: "chevron",
                        size: "small"
                    })
                })
            ]
        })
    });
};

});
parcelRegister("3WhYV", function(module, exports) {
$parcel$export(module.exports, "AccordionToggleButton", () => $7f9aed2249bc588f$export$545aca2194046191);
$parcel$export(module.exports, "ChecklistTitleWrapper", () => $7f9aed2249bc588f$export$3974b9c0a84cf596);
$parcel$export(module.exports, "ChecklistTaskDoneIndicator", () => $7f9aed2249bc588f$export$39f183af3d88e3e0);
$parcel$export(module.exports, "checklistClosedIndicator", () => $7f9aed2249bc588f$export$9d7668293c0c7580);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points


var $aWILV = parcelRequire("aWILV");
const $7f9aed2249bc588f$export$545aca2194046191 = /*#__PURE__*/ (0, $aWILV.default)("button", {
    target: "eiet5uc3"
})({
    textAlign: 'left',
    cursor: 'pointer',
    padding: "var(--ds-space-200, 16px)",
    width: '100%',
    background: 'none',
    border: 'none',
    '@supports selector(*:focus-visible)': {
        '&:focus': {
            boxShadow: 'none'
        },
        '&:focus-visible': {
            outline: 'none',
            transform: 'translateZ(0)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            boxShadow: `0px 0px 0px 2px ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$exports).B100})`}`
        }
    }
});
const $7f9aed2249bc588f$export$3974b9c0a84cf596 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "eiet5uc2"
})({
    position: 'relative',
    padding: `0 ${"var(--ds-space-500, 40px)"}`
});
const $7f9aed2249bc588f$export$39f183af3d88e3e0 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "eiet5uc1"
})("display:block;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);color:", (props)=>props.done ? `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$exports).G300})` : `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$exports).N40})`, ";position:absolute;left:0;top:50%;border-radius:12px;transform:translateY(-50%);");
const $7f9aed2249bc588f$export$9d7668293c0c7580 = (animationDuration)=>/*#__PURE__*/ (0, $aWILV.default)("div", {
        target: "eiet5uc0"
    })("display:block;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);position:absolute;right:0;top:50%;transform:translateY(-50%);&>span{transform:", (props)=>props.expanded ? 'rotate(-90deg)' : 'rotate(90deg)', ";transition:transform ", animationDuration, "ms;}");

});

parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb3eee7b92db2782a45444d8dbb123a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});
parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});




parcelRegister("aS0V1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b88a815155b261b5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $c9qWp = parcelRequire("c9qWp");
var $b88a815155b261b5$export$2e2bcd8739ae039 = ({ value: value = 0, isIndeterminate: isIndeterminate = false, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        backgroundColor: "elevation.surface.raised",
        padding: "space.250",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c9qWp.default), {
            ariaLabel: ariaLabel,
            value: value,
            isIndeterminate: isIndeterminate
        })
    });
};

});
parcelRegister("c9qWp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f72ae726177d4e89$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $f72ae726177d4e89$var$MIN_VALUE = 0;
const $f72ae726177d4e89$var$MAX_VALUE = 1;
const $f72ae726177d4e89$var$increasingBarAnimation = null;
const $f72ae726177d4e89$var$decreasingBarAnimation = null;
const $f72ae726177d4e89$var$containerStyles = null;
const $f72ae726177d4e89$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $f72ae726177d4e89$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $f72ae726177d4e89$var$barStyles = null;
const $f72ae726177d4e89$var$determinateBarStyles = null;
const $f72ae726177d4e89$var$increasingBarStyles = null;
const $f72ae726177d4e89$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $f72ae726177d4e89$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $f72ae726177d4e89$var$MIN_VALUE : Math.max($f72ae726177d4e89$var$MIN_VALUE, Math.min(value, $f72ae726177d4e89$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $f72ae726177d4e89$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $f72ae726177d4e89$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $f72ae726177d4e89$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $f72ae726177d4e89$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hcewu.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $f72ae726177d4e89$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $f72ae726177d4e89$export$2e2bcd8739ae039 = $f72ae726177d4e89$var$ProgressBar;

});


parcelRegister("6tjyh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a308a41e6fe1f5cc$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $f5m0f = parcelRequire("f5m0f");

var $eGOwo = parcelRequire("eGOwo");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");
var $a308a41e6fe1f5cc$export$2e2bcd8739ae039 = ({ dismissTitle: dismissTitle, onDismiss: onDismiss, wrapper: wrapper })=>{
    const FooterWrapper = wrapper ? wrapper : (0, $f5m0f.Footer);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(FooterWrapper, {
        children: (0, $eGOwo.fg)('jira_onboarding_a11y_fixes_for_quickstart') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            xcss: $a308a41e6fe1f5cc$var$buttonStyles,
            testId: "checklist-footer-dismiss-link",
            onClick: onDismiss,
            children: dismissTitle
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f5m0f.FooterDismissLink), {
            "data-testid": "checklist-footer-dismiss-link",
            href: "#",
            onClick: onDismiss,
            children: dismissTitle
        })
    });
};
const $a308a41e6fe1f5cc$var$buttonStyles = (0, $1DXK0.xcss)({
    color: 'color.text.discovery',
    font: 'font.body',
    background: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});

});

parcelRegister("aWyTc", function(module, exports) {
$parcel$export(module.exports, "default", () => $7884b78671e14517$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $goZPP = parcelRequire("goZPP");

var $3qmlA = parcelRequire("3qmlA");

var $f5m0f = parcelRequire("f5m0f");
var $7884b78671e14517$export$2e2bcd8739ae039 = ({ header: header, onClose: onClose, shouldFocus: shouldFocus })=>{
    const minimisedButton = /*#__PURE__*/ (0, $eJOHy.createRef)();
    const havebeenFocused = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFocus && !havebeenFocused.current && minimisedButton?.current) {
            minimisedButton.current.focus();
            havebeenFocused.current = true;
        }
    }, [
        shouldFocus,
        minimisedButton
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $f5m0f.HeaderWrapper), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                children: header && header
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f5m0f.DismissButtonWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                    testId: "checklist-header-dismiss-link",
                    onClick: onClose,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3qmlA))), {
                        label: "minimize",
                        color: `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$exports).N0})`,
                        spacing: "spacious"
                    }),
                    ref: minimisedButton
                })
            })
        ]
    });
};

});
parcelRegister("3qmlA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::245341e514d0c6b4cbda5429c51d41c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27e52280fe3bc4ab$var$_react = $27e52280fe3bc4ab$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $27e52280fe3bc4ab$var$_shrinkDiagonal = $27e52280fe3bc4ab$var$_interopRequireDefault((parcelRequire("idu5j")));

var $27e52280fe3bc4ab$var$_fitToPage = $27e52280fe3bc4ab$var$_interopRequireDefault((parcelRequire("8lWE8")));
function $27e52280fe3bc4ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27e52280fe3bc4ab$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $27e52280fe3bc4ab$var$_react.default.createElement($27e52280fe3bc4ab$var$_shrinkDiagonal.default, Object.assign({
        name: "ShrinkDiagonalIcon",
        LEGACY_fallbackIcon: $27e52280fe3bc4ab$var$_fitToPage.default
    }, props));
$27e52280fe3bc4ab$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIconMigration';
var $27e52280fe3bc4ab$var$_default = module.exports.default = $27e52280fe3bc4ab$var$ShrinkDiagonalIcon;

});
parcelRegister("idu5j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f27ffcb10ef2f007258cc5c328ada66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d430c71ad3f6d10b$var$_react = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d430c71ad3f6d10b$var$_baseNew = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d430c71ad3f6d10b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d430c71ad3f6d10b$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $d430c71ad3f6d10b$var$_react.default.createElement($d430c71ad3f6d10b$var$_baseNew.default, Object.assign({
        name: "ShrinkDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$d430c71ad3f6d10b$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $d430c71ad3f6d10b$var$_default = module.exports.default = $d430c71ad3f6d10b$var$ShrinkDiagonalIcon;

});

parcelRegister("8lWE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $614dc6da480803f7$var$_react = $614dc6da480803f7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $614dc6da480803f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $614dc6da480803f7$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $614dc6da480803f7$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props));
$614dc6da480803f7$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $614dc6da480803f7$var$_default = module.exports.default = $614dc6da480803f7$var$MediaServicesFitToPageIcon;

});




parcelRegister("3PkyJ", function(module, exports) {
$parcel$export(module.exports, "OnboardingChecklistFooter", () => $372f83f9b51dca33$export$c84ac5bb1e59a6fc);
/* OnboardingChecklistFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $fbpl5 = parcelRequire("fbpl5");
const $372f83f9b51dca33$var$styles = {
    root: "_zulp1b66 _1rjcutpp _kqswstnw _94n5idpf _1ltvidpf _1xi2idpf _syaz10m5 _1pbyb4wl _bfhkvuon _uwhke4h9 _15a5nqa1 _1i53muej _1e0c1txw _2lx21bp4 _4cvr1h6o"
};
const $372f83f9b51dca33$export$c84ac5bb1e59a6fc = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $372f83f9b51dca33$var$styles.root
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage((0, $fbpl5.default).returnToItAnytime)));
};

});
parcelRegister("fbpl5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9a89d736ecaef3b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d9a89d736ecaef3b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    returnToItAnytime: {
        "id": "polaris-components-quickstart.onboarding-check-list.return-to-it-anytime",
        "defaultMessage": "Return to it anytime from your user profile."
    }
});

});


parcelRegister("8rXz9", function(module, exports) {
$parcel$export(module.exports, "default", () => $655d0616ec1b5929$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $655d0616ec1b5929$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    dismissQuickstart: {
        "id": "polaris-components-quickstart.onboarding-check-list.dismiss-pill.non-final",
        "defaultMessage": "Dismiss Quickstart"
    },
    title: {
        "id": "polaris-components-quickstart.onboarding-check-list.title.non-final",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("1niiU", function(module, exports) {
$parcel$export(module.exports, "OnboardingCheckListPostTasks", () => $f4cf564b32753887$export$a28e0a1bda5eedd6);
/* OnboardingCheckListPostTasks.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");

var $lmJ87 = parcelRequire("lmJ87");

var $hxN6p = parcelRequire("hxN6p");

var $fsFOy = parcelRequire("fsFOy");

var $lRq8t = parcelRequire("lRq8t");

var $hnc8M = parcelRequire("hnc8M");
const $f4cf564b32753887$var$postTasksButtonStyles = {
    root: "_1q5112x7 _85i5utpp",
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1rjc1b66 _1e0c1txw _19pk12x7 _4cvr1h6o",
    linkText: "_syaz14q2 _19bvu2gc"
};
const $f4cf564b32753887$export$a28e0a1bda5eedd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const quickstartLinks = (0, $eJOHy.useMemo)(()=>[
            {
                label: formatMessage((0, $hnc8M.default).productDiscoveryHandbook),
                href: 'https://www.atlassian.com/software/jira/product-discovery/resources/handbook/introduction#why-did-we-write-this-handbook',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
                    color: "var(--ds-link-pressed, #0055CC)",
                    label: formatMessage((0, $hnc8M.default).productDiscoveryHandbook)
                })
            },
            {
                label: formatMessage((0, $hnc8M.default).communityFaq),
                href: 'https://community.atlassian.com/forums/Jira-Product-Discovery-articles/Frequently-asked-questions-about-the-product-how-do-I/ba-p/2002378',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
                    color: "var(--ds-link-pressed, #0055CC)",
                    label: formatMessage((0, $hnc8M.default).communityFaq)
                })
            },
            {
                label: formatMessage((0, $hnc8M.default).courseDeepDive),
                href: 'https://community.atlassian.com/learning/path/get-the-most-out-of-jira-product-discovery',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsFOy))), {
                    color: "var(--ds-link-pressed, #0055CC)",
                    label: formatMessage((0, $hnc8M.default).courseDeepDive)
                })
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f4cf564b32753887$var$postTasksButtonStyles.root
    }, quickstartLinks.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            xcss: $f4cf564b32753887$var$postTasksButtonStyles.anchor,
            href: link.href,
            key: link.href,
            "aria-label": link.label,
            target: "_blank"
        }, link.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $f4cf564b32753887$var$postTasksButtonStyles.linkText
        }, link.label))));
};

});
parcelRegister("fsFOy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b419e807e3769102$var$_react = $b419e807e3769102$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b419e807e3769102$var$_baseNew = $b419e807e3769102$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b419e807e3769102$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b419e807e3769102$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $b419e807e3769102$var$_react.default.createElement($b419e807e3769102$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$b419e807e3769102$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $b419e807e3769102$var$_default = module.exports.default = $b419e807e3769102$var$BookWithBookmarkIcon;

});

parcelRegister("hnc8M", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca1cd5f9669aafe3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ca1cd5f9669aafe3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    productDiscoveryHandbook: {
        "id": "polaris-components-quickstart.onboarding-check-list-post-tasks.product-discovery-handbook.non-final",
        "defaultMessage": "Check out Product Discovery Handbook"
    },
    communityFaq: {
        "id": "polaris-components-quickstart.onboarding-check-list-post-tasks.community-faq.non-final",
        "defaultMessage": "Community FAQ"
    },
    courseDeepDive: {
        "id": "polaris-components-quickstart.onboarding-check-list-post-tasks.course-deep-dive.non-final",
        "defaultMessage": "Take a course"
    }
});

});






parcelRegister("f58ZR", function(module, exports) {
$parcel$export(module.exports, "polarisIdeasRoute", () => $0a2b0b5b270c777f$export$54c333cd4ed2d70e);
const $0a2b0b5b270c777f$export$54c333cd4ed2d70e = {
    name: 'polaris-ideas',
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    query: [
        'selectedIssue?',
        'issueViewLayout?'
    ],
    exact: true
};

});

parcelRegister("6Kw7r", function(module, exports) {
$parcel$export(module.exports, "ideasPageEntryPoint", () => $5aee234730b3e880$export$aa9a00411f9c3e39);

var $5RW99 = parcelRequire("5RW99");

var $g8uYY = parcelRequire("g8uYY");

var $cfmHv = parcelRequire("cfmHv");
const $5aee234730b3e880$export$aa9a00411f9c3e39 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cfmHv.ideasEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("cfmHv", function(module, exports) {
$parcel$export(module.exports, "ideasEntryPoint", () => $38687e9e7d1e4cfd$export$ffc470fa0659ba16);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $38687e9e7d1e4cfd$export$ffc470fa0659ba16 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("kalae")), {
        moduleId: "3b89e133",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kalae", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("bEpuS")
]).then(()=>parcelRequire('fZeB7'));

});




parcelRegister("eDNar", function(module, exports) {
$parcel$export(module.exports, "polarisOnboardingRouteEntry", () => $102706bdacd1f2f0$export$a297a71cb150e2af);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ho9E1 = parcelRequire("ho9E1");

var $loxDw = parcelRequire("loxDw");

var $flZs0 = parcelRequire("flZs0");
const $102706bdacd1f2f0$export$a297a71cb150e2af = (0, $6xToB.createEntry)((0, $loxDw.polarisOnboardingRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $flZs0.default),
        layout: (0, $7h3uc.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $ho9E1.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flZs0.LazyOnboardingPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisOnboardingRouteEntry.tsx',
                whichExportToUse: 'polarisOnboardingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("loxDw", function(module, exports) {
$parcel$export(module.exports, "polarisOnboardingRoute", () => $69cf92a3b53325d9$export$6696e9deb45fe980);
const $69cf92a3b53325d9$export$6696e9deb45fe980 = {
    name: 'polaris-onboarding',
    path: '/welcome/discovery',
    exact: true
};

});

parcelRegister("flZs0", function(module, exports) {
$parcel$export(module.exports, "LazyOnboardingPage", () => $ee1b86146c0a5089$export$13889cc3ce0d5a93);
$parcel$export(module.exports, "default", () => $ee1b86146c0a5089$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ee1b86146c0a5089$export$13889cc3ce0d5a93 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ah1d0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
const $ee1b86146c0a5089$var$AsyncOnboardingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ee1b86146c0a5089$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });
var $ee1b86146c0a5089$export$2e2bcd8739ae039 = $ee1b86146c0a5089$var$AsyncOnboardingPage;

});
parcelRegister("ah1d0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4AbT1").then(()=>parcelRequire('ehwUR'));

});



parcelRegister("cWeYh", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsAccessRouteEntry", () => $9d756e76cba4e28a$export$9c0f51630c25c3d);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $gxPYM = parcelRequire("gxPYM");

var $5nhXC = parcelRequire("5nhXC");
const $9d756e76cba4e28a$export$9c0f51630c25c3d = (0, $6xToB.createEntry)((0, $gxPYM.polarisSettingsAccessRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        component: (0, $5nhXC.AccessSettingsPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5nhXC.LazyAccessSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsAccessRouteEntry.tsx',
                whichExportToUse: 'polarisSettingsAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gxPYM", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsAccessRoute", () => $fb96dc846965fa87$export$bfdcdf76e802d67d);
const $fb96dc846965fa87$export$bfdcdf76e802d67d = {
    name: 'polaris-settings-access',
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};

});

parcelRegister("5nhXC", function(module, exports) {
$parcel$export(module.exports, "LazyAccessSettingsPage", () => $ee37dbdedb1d9a72$export$b66ea0dcd38af7f0);
$parcel$export(module.exports, "AccessSettingsPage", () => $ee37dbdedb1d9a72$export$d46497fe68b0853c);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ee37dbdedb1d9a72$export$b66ea0dcd38af7f0 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fI4G0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $ee37dbdedb1d9a72$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ee37dbdedb1d9a72$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });

});
parcelRegister("fI4G0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8VBC2").then(()=>parcelRequire('ctW5D'));

});



parcelRegister("0eLvf", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsDatesRouteEntry", () => $8851d351a21b736a$export$df39bbcec5c3d8fb);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2NgER = parcelRequire("2NgER");

var $b6rXY = parcelRequire("b6rXY");
const $8851d351a21b736a$export$df39bbcec5c3d8fb = (0, $6xToB.createEntry)((0, $2NgER.polarisSettingsDatesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $b6rXY.polarisProductFinancialYearSettingsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsDatesRouteEntry.tsx',
                whichExportToUse: 'polarisSettingsDatesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2NgER", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsDatesRoute", () => $6c040c4f7cf09229$export$41bd51b740ebfe25);
const $6c040c4f7cf09229$export$41bd51b740ebfe25 = {
    name: 'polaris-settings-financial-year',
    path: '/jira/settings/products/jira-product-discovery/dates',
    exact: true
};

});

parcelRegister("b6rXY", function(module, exports) {
$parcel$export(module.exports, "polarisProductFinancialYearSettingsPageEntryPoint", () => $3c67c836ee1ac3f9$export$b1c132cd756e9b86);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $02vUi = parcelRequire("02vUi");
const $3c67c836ee1ac3f9$export$b1c132cd756e9b86 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $02vUi.polarisProductFinancialYearSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("02vUi", function(module, exports) {
$parcel$export(module.exports, "polarisProductFinancialYearSettingsEntryPoint", () => $5012b89db90f0de9$export$2e0ef763d6b208ea);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $5012b89db90f0de9$export$2e0ef763d6b208ea = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("cqCld")), {
        moduleId: "47bc544f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cqCld", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("43mv2").then(()=>parcelRequire('36V1P'));

});




parcelRegister("avhOT", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRouteEntry", () => $66b928790495b2c4$export$986710683a071056);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $jMVo4 = parcelRequire("jMVo4");

var $40Wrm = parcelRequire("40Wrm");
const $66b928790495b2c4$export$986710683a071056 = (0, $6xToB.createEntry)((0, $jMVo4.polarisSettingsEarlyAccessFeaturesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $40Wrm.polarisProductEAPSettingsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsEarlyAccessFeaturesRouteEntry.tsx',
                whichExportToUse: 'polarisSettingsEarlyAccessFeaturesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jMVo4", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRoute", () => $f8b20274dbc348ac$export$19bd38107b2ac64b);
const $f8b20274dbc348ac$export$19bd38107b2ac64b = {
    name: 'polaris-settings-early-access-features',
    path: '/jira/settings/products/jira-product-discovery/early-access-features',
    exact: true
};

});

parcelRegister("40Wrm", function(module, exports) {
$parcel$export(module.exports, "polarisProductEAPSettingsPageEntryPoint", () => $296b6ddc14f74157$export$1bd9d2b1f32dc9ee);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $f994p = parcelRequire("f994p");
const $296b6ddc14f74157$export$1bd9d2b1f32dc9ee = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $f994p.polarisProductEAPSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("f994p", function(module, exports) {
$parcel$export(module.exports, "polarisProductEAPSettingsEntryPoint", () => $45e557a009fe89ce$export$92df711874ab564a);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $45e557a009fe89ce$export$92df711874ab564a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hyZJW")), {
        moduleId: "e4e16138",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hyZJW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fsiGA").then(()=>parcelRequire('9mEOd'));

});




parcelRegister("jXIBH", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", () => $22db189ea3edd0f3$export$e29465c661741392);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2MVvM = parcelRequire("2MVvM");

var $8kB6m = parcelRequire("8kB6m");
const $22db189ea3edd0f3$export$e29465c661741392 = (0, $6xToB.createEntry)((0, $2MVvM.polarisSettingsGlobalFieldsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $8kB6m.polarisProductGlobalFieldsSettingsPageEntryPoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsGlobalFieldsRouteEntry.tsx',
                whichExportToUse: 'polarisSettingsGlobalFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2MVvM", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", () => $84f1e8dd3752fa62$export$d1d77b6a84982ab8);
const $84f1e8dd3752fa62$export$d1d77b6a84982ab8 = {
    name: 'polaris-settings-global-fields',
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};

});

parcelRegister("8kB6m", function(module, exports) {
$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", () => $ab23368ee389dfed$export$c682ebcd2290352f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $l8hS0 = parcelRequire("l8hS0");
const $ab23368ee389dfed$export$c682ebcd2290352f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $l8hS0.polarisProductGlobalFieldsSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("l8hS0", function(module, exports) {
$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", () => $03ad3703d58cfb6d$export$f2f24531058bc251);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $03ad3703d58cfb6d$export$f2f24531058bc251 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3sZm4")), {
        moduleId: "fead11bc",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3sZm4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6YVCS").then(()=>parcelRequire('49xmL'));

});




parcelRegister("f0kp3", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsViewBlueprintsRouteEntry", () => $88bc143b1e8c96d7$export$3a434d3b47ab1779);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $4cTDP = parcelRequire("4cTDP");

var $9BJU1 = parcelRequire("9BJU1");

var $9NmsS = parcelRequire("9NmsS");

var $cVkb1 = parcelRequire("cVkb1");

var $8Cky9 = parcelRequire("8Cky9");
const $88bc143b1e8c96d7$export$3a434d3b47ab1779 = (0, $6xToB.createEntry)((0, $cVkb1.polarisSettingsViewBlueprintsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        component: (0, $9BJU1.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('jpd-view-templates-sample-project') ? (0, $8Cky9.polarisProductViewBlueprintsSettingsPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsViewBlueprintsRouteEntry.tsx',
                whichExportToUse: 'polarisSettingsViewBlueprintsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cVkb1", function(module, exports) {
$parcel$export(module.exports, "polarisSettingsViewBlueprintsRoute", () => $d752382140b053dc$export$8a86f742c99c33c);
const $d752382140b053dc$export$8a86f742c99c33c = {
    name: 'polaris-settings-view-blueprints',
    path: '/jira/settings/products/jira-product-discovery/view-blueprints',
    exact: true
};

});

parcelRegister("8Cky9", function(module, exports) {
$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsPageEntryPoint", () => $bd6a3e5257fb6968$export$b38d612b8eddc59a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3pvil = parcelRequire("3pvil");
const $bd6a3e5257fb6968$export$b38d612b8eddc59a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3pvil.polarisProductViewBlueprintsSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});

});
parcelRegister("3pvil", function(module, exports) {
$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsEntryPoint", () => $16c0d464d48543a1$export$39c56d81a6a3e673);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $16c0d464d48543a1$export$39c56d81a6a3e673 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cUth3")), {
        moduleId: "a9a1a8f1",
        moduleName: "PolarisViewBlueprintsSettingsPage",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cUth3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dZaRU").then(()=>parcelRequire('cmt3m'));

});




parcelRegister("1zTPx", function(module, exports) {
$parcel$export(module.exports, "polarisUnlicensedRouteEntry", () => $5f6321715f461ebe$export$f975154b9b0ce777);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ho9E1 = parcelRequire("ho9E1");

var $eOU53 = parcelRequire("eOU53");

var $Iw9hP = parcelRequire("Iw9hP");
const $5f6321715f461ebe$export$f975154b9b0ce777 = (0, $6xToB.createEntry)((0, $eOU53.polarisUnlicensedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $Iw9hP.default),
        layout: (0, $7h3uc.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $ho9E1.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $Iw9hP.LazyUnlicensedPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-polaris-entries/src/polarisUnlicensedRouteEntry.tsx',
                whichExportToUse: 'polarisUnlicensedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eOU53", function(module, exports) {
$parcel$export(module.exports, "polarisUnlicensedRoute", () => $e487e09687394076$export$32b1bc71501d2751);
const $e487e09687394076$export$32b1bc71501d2751 = {
    name: 'polaris-unlicensed',
    path: '/jira/polaris/unlicensed',
    exact: true
};

});

parcelRegister("Iw9hP", function(module, exports) {
$parcel$export(module.exports, "LazyUnlicensedPage", () => $d8e94c1162596627$export$394984ca86b38b8f);
$parcel$export(module.exports, "default", () => $d8e94c1162596627$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d8e94c1162596627$export$394984ca86b38b8f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("i9YoQ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
const $d8e94c1162596627$var$AsyncUnlicensedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d8e94c1162596627$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });
var $d8e94c1162596627$export$2e2bcd8739ae039 = $d8e94c1162596627$var$AsyncUnlicensedPage;

});
parcelRegister("i9YoQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2mruf").then(()=>parcelRequire('4eAP9'));

});



parcelRegister("hpFrr", function(module, exports) {
$parcel$export(module.exports, "productsJcsCustomerAccessRouteEntry", () => $5a003be32277141a$export$487fd1bbb9f3684e);

var $4cTDP = parcelRequire("4cTDP");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $hSYtN = parcelRequire("hSYtN");

var $1lFEV = parcelRequire("1lFEV");

var $9BJU1 = parcelRequire("9BJU1");

var $ahfWb = parcelRequire("ahfWb");

var $aIVyX = parcelRequire("aIVyX");
const $5a003be32277141a$var$productsJcsCustomerAccessEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: $1lFEV.productsJcsCustomerAccessEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $5a003be32277141a$export$487fd1bbb9f3684e = (0, $6xToB.createEntry)((0, $hSYtN.productsJcsCustomerAccessRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_master_flag') ? $5a003be32277141a$var$productsJcsCustomerAccessEntryPointPage : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $aIVyX.jsmGlobalCustomerAccessSettingsResource),
            (0, $ahfWb.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-jcs-customer-access-entries/src/productsJcsCustomerAccessRouteEntry.tsx',
                whichExportToUse: 'productsJcsCustomerAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hSYtN", function(module, exports) {
$parcel$export(module.exports, "productsJcsCustomerAccessRoute", () => $babde1fb28d35ab4$export$db5278559525ffee);
const $babde1fb28d35ab4$export$db5278559525ffee = {
    name: 'products-jcs-customer-access',
    path: '/jira/settings/products/customerservice/customer-access',
    exact: true
};

});

parcelRegister("1lFEV", function(module, exports) {
$parcel$export(module.exports, "productsJcsCustomerAccessEntryPoint", () => $44672c42270cfc54$export$a10305920ea7bd7);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $44672c42270cfc54$export$a10305920ea7bd7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("531aR")), {
        moduleId: "d1f6773e",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("531aR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6SkE8").then(()=>parcelRequire('gHrFG'));

});


parcelRegister("ahfWb", function(module, exports) {
$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $9619dcb374b8b212$export$f27acbd4701f5dfe);

var $l1VxS = parcelRequire("l1VxS");

const $9619dcb374b8b212$var$ONE_DAY_IN_MILLIS = 86400000;

const $9619dcb374b8b212$export$f27acbd4701f5dfe = (0, $l1VxS.createResource)({
    type: (0, $3df83461405be280$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("6ygQD")),
    maxAge: $9619dcb374b8b212$var$ONE_DAY_IN_MILLIS
});

});
const $3df83461405be280$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $3df83461405be280$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("6ygQD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("36y9m").then(()=>parcelRequire('60RsL'));

});


parcelRegister("aIVyX", function(module, exports) {
$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $d0ecaad6def73d7e$export$b1a50ad717b4ca61);

var $l1VxS = parcelRequire("l1VxS");

const $d0ecaad6def73d7e$var$ONE_DAY_IN_MILLIS = 86400000;

const $d0ecaad6def73d7e$export$b1a50ad717b4ca61 = (0, $l1VxS.createResource)({
    type: (0, $3df83461405be280$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("h0Xg5")),
    maxAge: $d0ecaad6def73d7e$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("h0Xg5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f4eLg").then(()=>parcelRequire('9Muer'));

});



parcelRegister("deNkw", function(module, exports) {
$parcel$export(module.exports, "productsJcsFormFieldsRouteEntry", () => $726ffe8edb0b2559$export$ce43ae01ccf4d9b6);

var $4cTDP = parcelRequire("4cTDP");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $etpAj = parcelRequire("etpAj");

var $91EJO = parcelRequire("91EJO");

var $9BJU1 = parcelRequire("9BJU1");

var $94sCg = parcelRequire("94sCg");
const $726ffe8edb0b2559$var$productsJcsFormFieldsEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: $91EJO.productsJcsFormFieldsEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $726ffe8edb0b2559$export$ce43ae01ccf4d9b6 = (0, $6xToB.createEntry)((0, $etpAj.productsJcsFormFieldsRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        component: (0, $9BJU1.default),
        entryPoint () {
            return (0, $4cTDP.fg)('jcs_forms_resiliency_fast_follows') ? $726ffe8edb0b2559$var$productsJcsFormFieldsEntryPointPage : undefined;
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $94sCg.formFieldsResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-jcs-form-fields-entries/src/productsJcsFormFieldsRouteEntry.tsx',
                whichExportToUse: 'productsJcsFormFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("etpAj", function(module, exports) {
$parcel$export(module.exports, "productsJcsFormFieldsRoute", () => $bccff6db6e0640a2$export$ace810399baa80ca);
const $bccff6db6e0640a2$export$ace810399baa80ca = {
    name: 'products-jcs-form-fields',
    path: '/jira/settings/products/customerservice/form-fields',
    exact: true
};

});

parcelRegister("91EJO", function(module, exports) {
$parcel$export(module.exports, "productsJcsFormFieldsEntryPoint", () => $4d8c7fe486443d5d$export$4afec7b2100b3396);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $4d8c7fe486443d5d$export$4afec7b2100b3396 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jTkbH")), {
        moduleId: "b263f162",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jTkbH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1hUWQ").then(()=>parcelRequire('ku91u'));

});


parcelRegister("94sCg", function(module, exports) {
$parcel$export(module.exports, "setSearchFieldsFormQuery", () => $6d924f0867c57d4a$export$52917d9e09f11230);
$parcel$export(module.exports, "formFieldsResource", () => $6d924f0867c57d4a$export$cf387af041de8a73);

var $l1VxS = parcelRequire("l1VxS");

var $hgi0g = parcelRequire("hgi0g");

var $erGGa = parcelRequire("erGGa");
const $6d924f0867c57d4a$export$2345ec6675b232f1 = {};
const $6d924f0867c57d4a$export$52917d9e09f11230 = (query)=>{
    $6d924f0867c57d4a$export$2345ec6675b232f1.query = query;
};
const $6d924f0867c57d4a$export$cf387af041de8a73 = (0, $l1VxS.createResource)({
    type: 'FORM_FIELDS_RESOURCE',
    // The query.page in getData() is cached, and only changes if getKey() returns a new value
    getKey: ({ query: query })=>`form-fields${query?.page || 1}`,
    getData: async ({ query: query })=>(0, $hgi0g.default)((0, $erGGa.getUrl)(query?.page, $6d924f0867c57d4a$export$2345ec6675b232f1.query)),
    maxAge: 0
});

});
parcelRegister("erGGa", function(module, exports) {
$parcel$export(module.exports, "PAGE_SIZE", () => $9ecf94d73a482182$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "getUrl", () => $9ecf94d73a482182$export$94df0e59ebebf4a7);
const $9ecf94d73a482182$export$8ec3d08588d2eeda = 50;
const $9ecf94d73a482182$var$getStartAt = (page)=>{
    const pageNum = Number(page);
    if (!page || Number.isNaN(pageNum)) return 0;
    return (pageNum - 1) * $9ecf94d73a482182$export$8ec3d08588d2eeda;
};
const $9ecf94d73a482182$export$94df0e59ebebf4a7 = (page, query)=>`/rest/jcs/admin/v1/request-intake/global-fields?startAt=${$9ecf94d73a482182$var$getStartAt(page)}${query ? `&query=${query}` : ''}`;

});



parcelRegister("b89Z5", function(module, exports) {
$parcel$export(module.exports, "productsJsmAuthenticationSettingsRouteEntry", () => $bec2eb907dbda6a2$export$de5cc5a334946074);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $8zxNY = parcelRequire("8zxNY");

var $9NmsS = parcelRequire("9NmsS");

var $7nP1r = parcelRequire("7nP1r");

var $9LwVv = parcelRequire("9LwVv");
const $bec2eb907dbda6a2$export$de5cc5a334946074 = (0, $6xToB.createEntry)((0, $7nP1r.productsJsmAuthenticationSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $9LwVv.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $8zxNY.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9LwVv.LazyAuthenticationSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-jsm-authentication-settings-entries/src/productsJsmAuthenticationSettingsRouteEntry.tsx',
                whichExportToUse: 'productsJsmAuthenticationSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8zxNY", function(module, exports) {
$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $dba45a17633e4999$export$73134c05a3c27bd);

var $l1VxS = parcelRequire("l1VxS");

var $aXJWD = parcelRequire("aXJWD");

const $dba45a17633e4999$export$73134c05a3c27bd = (0, $l1VxS.createResource)({
    type: (0, $aXJWD.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("5B2dM")),
    maxAge: (0, $aXJWD.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("aXJWD", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $5bd3ad00ba14ad29$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $5bd3ad00ba14ad29$export$5a00268156ea5027);
const $5bd3ad00ba14ad29$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $5bd3ad00ba14ad29$export$5a00268156ea5027 = 86400000;

});

parcelRegister("5B2dM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("UvuXg").then(()=>parcelRequire('31JhY'));

});


parcelRegister("7nP1r", function(module, exports) {
$parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", () => $ab26972f5d90ccba$export$6395086ce7e72e37);
const $ab26972f5d90ccba$export$6395086ce7e72e37 = {
    name: 'products-jsm-authentication-settings',
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};

});

parcelRegister("9LwVv", function(module, exports) {
$parcel$export(module.exports, "LazyAuthenticationSettings", () => $154d14dfb9d3f072$export$6cd59b0135f3fe86);
$parcel$export(module.exports, "default", () => $154d14dfb9d3f072$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $154d14dfb9d3f072$export$6cd59b0135f3fe86 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bmP71"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
const $154d14dfb9d3f072$var$AsyncAuthenticationSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $154d14dfb9d3f072$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });
var $154d14dfb9d3f072$export$2e2bcd8739ae039 = $154d14dfb9d3f072$var$AsyncAuthenticationSettings;

});
parcelRegister("bmP71", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("23fwe").then(()=>parcelRequire('az2Jc'));

});



parcelRegister("i7x71", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", () => $10e8e9e9f5c20c58$export$8b55e723205ec5f3);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $kaTH9 = parcelRequire("kaTH9");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $4Bp9F = parcelRequire("4Bp9F");
const $10e8e9e9f5c20c58$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $10e8e9e9f5c20c58$export$8b55e723205ec5f3 = (0, $6xToB.createEntry)((0, $kaTH9.productsJsmChatopsAndVideosToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $f2JN3.componentWithCondition)((0, $lopBx.isFedRamp) || (0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('hide_chatops_component_in_isolated_cloud'), (0, $9BJU1.default), (0, $4Bp9F.default)),
        layout: (0, $iRfwO.opsSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$10e8e9e9f5c20c58$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4Bp9F.LazyProductsJsmChatopsAndVideoTools)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4Bp9F.LazyProductsJsmChatopsAndVideoTools)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-chatops-and-videos-tools-entries/src/productsJsmChatopsAndVideosToolsRouteEntry.tsx',
                whichExportToUse: 'productsJsmChatopsAndVideosToolsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kaTH9", function(module, exports) {
$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", () => $e00d1fa7828f8587$export$7c663ddc097df1e8);
const $e00d1fa7828f8587$export$7c663ddc097df1e8 = {
    name: 'products-jsm-chatops-and-videos-tools',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};

});

parcelRegister("4Bp9F", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", () => $f74523e588532407$export$1b7f55251df02fe9);
$parcel$export(module.exports, "default", () => $f74523e588532407$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f74523e588532407$export$1b7f55251df02fe9 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lz5Kg"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
const $f74523e588532407$var$AsyncProductsJsmChatopsAndVideoTools = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f74523e588532407$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });
var $f74523e588532407$export$2e2bcd8739ae039 = $f74523e588532407$var$AsyncProductsJsmChatopsAndVideoTools;

});
parcelRegister("lz5Kg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("idH5H").then(()=>parcelRequire('a7dE6'));

});



parcelRegister("iifeU", function(module, exports) {
$parcel$export(module.exports, "productsJsmComplianceRouteEntry", () => $6cacc33288024805$export$9cc9423a3967333b);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i6IhW = parcelRequire("i6IhW");

var $jibk1 = parcelRequire("jibk1");
const $6cacc33288024805$export$9cc9423a3967333b = (0, $6xToB.createEntry)((0, $i6IhW.productsJsmComplianceRoute), ()=>({
        group: 'global-settings',
        component: (0, $jibk1.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jibk1.LazyProductsJsmCompliance)
        ],
        ufoName: 'admin.jsm-compliance',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-compliance-entries/src/productsJsmComplianceRouteEntry.tsx',
                whichExportToUse: 'productsJsmComplianceRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("i6IhW", function(module, exports) {
$parcel$export(module.exports, "productsJsmComplianceRoute", () => $7472dad0721ea8a7$export$6196bf08f64419da);
const $7472dad0721ea8a7$export$6196bf08f64419da = {
    name: 'products-jsm-compliance',
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};

});

parcelRegister("jibk1", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmCompliance", () => $f88b58239d879054$export$159d8c0e1862cd2b);
$parcel$export(module.exports, "default", () => $f88b58239d879054$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f88b58239d879054$export$159d8c0e1862cd2b = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("go7SY"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
const $f88b58239d879054$var$AsyncProductsJsmCompliance = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f88b58239d879054$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });
var $f88b58239d879054$export$2e2bcd8739ae039 = $f88b58239d879054$var$AsyncProductsJsmCompliance;

});
parcelRegister("go7SY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Sses").then(()=>parcelRequire('lWLYN'));

});



parcelRegister("6szZq", function(module, exports) {
$parcel$export(module.exports, "productsJsmConfigurationRouteEntry", () => $e26b049835a3ea5e$export$461f2b06a7a914db);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9SDiu = parcelRequire("9SDiu");

var $dHxg4 = parcelRequire("dHxg4");
const $e26b049835a3ea5e$export$461f2b06a7a914db = (0, $6xToB.createEntry)((0, $9SDiu.productsJsmConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration',
        component: (0, $dHxg4.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dHxg4.LazyProductsJsmConfiguration)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-configuration-entries/src/productsJsmConfigurationRouteEntry.tsx',
                whichExportToUse: 'productsJsmConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9SDiu", function(module, exports) {
$parcel$export(module.exports, "productsJsmConfigurationRoute", () => $ced3bdc4503d5ae7$export$2ad48fbde4743a97);
const $ced3bdc4503d5ae7$export$2ad48fbde4743a97 = {
    name: 'products-jsm-configuration',
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};

});

parcelRegister("dHxg4", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmConfiguration", () => $212a160e375066dc$export$aa3f3d5ca376f305);
$parcel$export(module.exports, "default", () => $212a160e375066dc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $212a160e375066dc$export$aa3f3d5ca376f305 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("LZWsG"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
const $212a160e375066dc$var$AsyncProductsJsmConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $212a160e375066dc$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });
var $212a160e375066dc$export$2e2bcd8739ae039 = $212a160e375066dc$var$AsyncProductsJsmConfiguration;

});
parcelRegister("LZWsG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lzuNx").then(()=>parcelRequire('6EsK2'));

});



parcelRegister("bWhAh", function(module, exports) {
$parcel$export(module.exports, "productsJsmCustomerAccessRouteEntry", () => $f81d4ec847013e7d$export$d014f5ba2dec6c16);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $ahfWb = parcelRequire("ahfWb");

var $aIVyX = parcelRequire("aIVyX");

var $9NmsS = parcelRequire("9NmsS");

var $kgwNf = parcelRequire("kgwNf");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f81d4ec847013e7d$var$LazyCustomerAccess = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ja7bx"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $f81d4ec847013e7d$var$ServiceDeskCustomerAccess = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f81d4ec847013e7d$var$LazyCustomerAccess,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $f81d4ec847013e7d$export$d014f5ba2dec6c16 = (0, $6xToB.createEntry)((0, $kgwNf.productsJsmCustomerAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-customer-access',
        component: $f81d4ec847013e7d$var$ServiceDeskCustomerAccess,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $aIVyX.jsmGlobalCustomerAccessSettingsResource),
            (0, $ahfWb.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $f81d4ec847013e7d$var$LazyCustomerAccess
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-jsm-customer-access-entries/src/productsJsmCustomerAccessRouteEntry.tsx',
                whichExportToUse: 'productsJsmCustomerAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kgwNf", function(module, exports) {
$parcel$export(module.exports, "productsJsmCustomerAccessRoute", () => $fa2fb26e28bbc0c4$export$b97e3b6231be8149);
const $fa2fb26e28bbc0c4$export$b97e3b6231be8149 = {
    name: 'products-jsm-customer-access',
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};

});

parcelRegister("ja7bx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("UrhAm").then(()=>parcelRequire('6faJr'));

});


parcelRegister("e8aTE", function(module, exports) {
$parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", () => $2bdefbfd0f952728$export$3f8d7424a47f4dd);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $3Lc9W = parcelRequire("3Lc9W");

var $10mYx = parcelRequire("10mYx");
const $2bdefbfd0f952728$export$3f8d7424a47f4dd = (0, $6xToB.createEntry)((0, $3Lc9W.productsJsmEmailRequestsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-email-requests',
        component: (0, $10mYx.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $10mYx.LazyProductsJsmEmailRequests)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-email-requests-entries/src/productsJsmEmailRequestsRouteEntry.tsx',
                whichExportToUse: 'productsJsmEmailRequestsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3Lc9W", function(module, exports) {
$parcel$export(module.exports, "productsJsmEmailRequestsRoute", () => $413e7c9d83f89f77$export$6288bb6ea42acf0c);
const $413e7c9d83f89f77$export$6288bb6ea42acf0c = {
    name: 'products-jsm-email-requests',
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};

});

parcelRegister("10mYx", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmEmailRequests", () => $897f8688e3c4c26f$export$4c9d90d0caf04d67);
$parcel$export(module.exports, "default", () => $897f8688e3c4c26f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $897f8688e3c4c26f$export$4c9d90d0caf04d67 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("d09Xq"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
const $897f8688e3c4c26f$var$AsyncProductsJsmEmailRequests = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $897f8688e3c4c26f$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });
var $897f8688e3c4c26f$export$2e2bcd8739ae039 = $897f8688e3c4c26f$var$AsyncProductsJsmEmailRequests;

});
parcelRegister("d09Xq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("58oyr").then(()=>parcelRequire('aWUbc'));

});



parcelRegister("iIHov", function(module, exports) {
$parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", () => $04835712f82e9b4c$export$80a3e4dda2dcd1a4);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $kY2I8 = parcelRequire("kY2I8");

var $ePaI2 = parcelRequire("ePaI2");

var $bb6oX = parcelRequire("bb6oX");
const $04835712f82e9b4c$export$80a3e4dda2dcd1a4 = (0, $6xToB.createEntry)((0, $kY2I8.productsJsmFeatureUsageRoute), ()=>({
        group: 'global-settings',
        component: (0, $bb6oX.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bb6oX.LazyProductsJsmFeatureUsage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-feature-usage-entries/src/productsJsmFeatureUsageRouteEntry.tsx',
                whichExportToUse: 'productsJsmFeatureUsageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kY2I8", function(module, exports) {
$parcel$export(module.exports, "productsJsmFeatureUsageRoute", () => $917783885bc19032$export$f98dec539fffaa15);
const $917783885bc19032$export$f98dec539fffaa15 = {
    name: 'products-jsm-feature-usage',
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};

});

parcelRegister("bb6oX", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmFeatureUsage", () => $eaf6457f4f0134b4$export$5ad1c1e822bd5d34);
$parcel$export(module.exports, "default", () => $eaf6457f4f0134b4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $eaf6457f4f0134b4$export$5ad1c1e822bd5d34 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hDZF8"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
const $eaf6457f4f0134b4$var$AsyncProductsJsmFeatureUsage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $eaf6457f4f0134b4$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });
var $eaf6457f4f0134b4$export$2e2bcd8739ae039 = $eaf6457f4f0134b4$var$AsyncProductsJsmFeatureUsage;

});
parcelRegister("hDZF8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("9ws3L")
]).then(()=>parcelRequire('gFzIn'));

});



parcelRegister("iuWdX", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRouteEntry", () => $831a426e56f151f9$export$289cc03f2eacd57a);

var $3LXmM = parcelRequire("3LXmM");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $feceW = parcelRequire("feceW");

var $dj700 = parcelRequire("dj700");
const $831a426e56f151f9$export$289cc03f2eacd57a = (0, $6xToB.createEntry)((0, $feceW.productsJsmGlobalOpsReportsRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $dj700.OpsReportsRedirect),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $3LXmM.resources)(),
            (0, $3LXmM.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dj700.LazyGlobalOpsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-global-ops-reports-entries/src/productsJsmGlobalOpsReportsRedirectRouteEntry.tsx',
                whichExportToUse: 'productsJsmGlobalOpsReportsRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("feceW", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRoute", () => $7fe9eb30ea5dc240$export$c6d42e4b4a63248d);
const $7fe9eb30ea5dc240$export$c6d42e4b4a63248d = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports',
    exact: true
};

});

parcelRegister("dj700", function(module, exports) {
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $1f2606b570edae39$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $1f2606b570edae39$export$66850ec5549adba6);
$parcel$export(module.exports, "OpsReportsRedirect", () => $1f2606b570edae39$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $1f2606b570edae39$export$648ddf2d1f8b1c3f);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1f2606b570edae39$export$2404f0e35deca592 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $1f2606b570edae39$export$d33ea1a773b744e = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $1f2606b570edae39$export$66850ec5549adba6 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2glcC")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $1f2606b570edae39$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f2606b570edae39$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $1f2606b570edae39$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f2606b570edae39$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $1f2606b570edae39$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f2606b570edae39$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });

});


parcelRegister("1hrj9", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", () => $8250c680c9a9f5f3$export$6a7fc41fb2523290);

var $3LXmM = parcelRequire("3LXmM");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $esB62 = parcelRequire("esB62");

var $dj700 = parcelRequire("dj700");
const $8250c680c9a9f5f3$export$6a7fc41fb2523290 = (0, $6xToB.createEntry)((0, $esB62.productsJsmGlobalOpsReportsRoute), ()=>({
        group: 'global-settings',
        component: (0, $dj700.GlobalOpsReports),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $3LXmM.resources)(),
            (0, $3LXmM.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dj700.LazyOpsReportsRedirect)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-global-ops-reports-entries/src/productsJsmGlobalOpsReportsRouteEntry.tsx',
                whichExportToUse: 'productsJsmGlobalOpsReportsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("esB62", function(module, exports) {
$parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", () => $0e7185d3fc20969c$export$d92d66762943b115);
const $0e7185d3fc20969c$export$d92d66762943b115 = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("aanGM", function(module, exports) {
$parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", () => $d8b9c9cbdf53af8a$export$773f8e3318be1dd5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ixJHn = parcelRequire("ixJHn");

var $hAARs = parcelRequire("hAARs");
const $d8b9c9cbdf53af8a$export$773f8e3318be1dd5 = (0, $6xToB.createEntry)((0, $ixJHn.productsJsmIncidentManagementToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $hAARs.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $hAARs.LazyProductsJsmIncidentManagementTools)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-incident-management-tools-entries/src/productsJsmIncidentManagementToolsRouteEntry.tsx',
                whichExportToUse: 'productsJsmIncidentManagementToolsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ixJHn", function(module, exports) {
$parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", () => $b65f029ad5edf478$export$da6d538ddabade32);
const $b65f029ad5edf478$export$da6d538ddabade32 = {
    name: 'products-jsm-incident-management-tools',
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};

});

parcelRegister("hAARs", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", () => $d6693f589420e9c1$export$f541eb9b8f00bfaf);
$parcel$export(module.exports, "default", () => $d6693f589420e9c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d6693f589420e9c1$export$f541eb9b8f00bfaf = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("l8C3x"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
const $d6693f589420e9c1$var$AsyncProductsJsmIncidentManagementTools = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d6693f589420e9c1$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });
var $d6693f589420e9c1$export$2e2bcd8739ae039 = $d6693f589420e9c1$var$AsyncProductsJsmIncidentManagementTools;

});
parcelRegister("l8C3x", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kTBMy").then(()=>parcelRequire('6Xyby'));

});



parcelRegister("35zIt", function(module, exports) {
$parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", () => $471fd988ccae382f$export$717e134eb971b450);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $lS0Ni = parcelRequire("lS0Ni");

var $8vM62 = parcelRequire("8vM62");
const $471fd988ccae382f$export$717e134eb971b450 = (0, $6xToB.createEntry)((0, $lS0Ni.productsJsmKbPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $8vM62.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8vM62.LazyProductsJsmKbPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-kb-permissions-entries/src/productsJsmKbPermissionsRouteEntry.tsx',
                whichExportToUse: 'productsJsmKbPermissionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lS0Ni", function(module, exports) {
$parcel$export(module.exports, "productsJsmKbPermissionsRoute", () => $ba25a073d185b219$export$339486410c7a783f);
const $ba25a073d185b219$export$339486410c7a783f = {
    name: 'products-jsm-kb-permissions',
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};

});

parcelRegister("8vM62", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmKbPermissions", () => $1e0ed0555920a229$export$a3e7bdc5dbf2d47e);
$parcel$export(module.exports, "default", () => $1e0ed0555920a229$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1e0ed0555920a229$export$a3e7bdc5dbf2d47e = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kcNfG"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
const $1e0ed0555920a229$var$AsyncProductsJsmKbPermissions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1e0ed0555920a229$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });
var $1e0ed0555920a229$export$2e2bcd8739ae039 = $1e0ed0555920a229$var$AsyncProductsJsmKbPermissions;

});
parcelRegister("kcNfG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c0bhz").then(()=>parcelRequire('chRFA'));

});



parcelRegister("7V5F5", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsDetailsRouteEntry", () => $399a4bc41718c68e$export$f7b6cda88404733e);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");

var $eAm8a = parcelRequire("eAm8a");

var $1JTub = parcelRequire("1JTub");

var $9NmsS = parcelRequire("9NmsS");

var $2RCde = parcelRequire("2RCde");

var $5qjxt = parcelRequire("5qjxt");
const $399a4bc41718c68e$export$f7b6cda88404733e = (0, $6xToB.createEntry)((0, $2RCde.productsJsmOrganizationsDetailsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $5qjxt.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $eAm8a.productsJsmOrganizationMembersResource),
            (0, $1JTub.productsJsmOrganizationListResource),
            (0, $czabB.jsmEmailDomainsListResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5qjxt.LazyProductsJsmOrganizationDetails)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-organizations-entries/src/productsJsmOrganizationsDetailsRouteEntry.tsx',
                whichExportToUse: 'productsJsmOrganizationsDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eAm8a", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $aab4d5617df7716d$export$65c7941bd3e14d00);

var $l1VxS = parcelRequire("l1VxS");

const $aab4d5617df7716d$var$TEN_SECONDS_IN_MILLIS = 10000;

const $aab4d5617df7716d$export$65c7941bd3e14d00 = (0, $l1VxS.createResource)({
    type: (0, $17b6b4e6f34ab8b9$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("eRh3e")),
    maxAge: $aab4d5617df7716d$var$TEN_SECONDS_IN_MILLIS
});

});
const $17b6b4e6f34ab8b9$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("eRh3e", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9KbcQ").then(()=>parcelRequire('7YOHo'));

});


parcelRegister("1JTub", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $ed81d61ea3d2ffc7$export$3e38a27ad406d7f7);

var $l1VxS = parcelRequire("l1VxS");

const $ed81d61ea3d2ffc7$var$TEN_SECONDS_IN_MILLIS = 10000;

const $ed81d61ea3d2ffc7$export$3e38a27ad406d7f7 = (0, $l1VxS.createResource)({
    type: (0, $6308f871c220737d$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("cSvfL")),
    maxAge: $ed81d61ea3d2ffc7$var$TEN_SECONDS_IN_MILLIS
});

});
const $6308f871c220737d$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("cSvfL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("700Vl").then(()=>parcelRequire('1pQ0C'));

});


parcelRegister("2RCde", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsDetailsRoute", () => $78b9b6cf901ae9e2$export$bc61991d01535831);
const $78b9b6cf901ae9e2$export$bc61991d01535831 = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};

});

parcelRegister("5qjxt", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", () => $de8c3e3ab2353fd7$export$ff149ceefa65ab70);
$parcel$export(module.exports, "default", () => $de8c3e3ab2353fd7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $de8c3e3ab2353fd7$export$ff149ceefa65ab70 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cdCo5"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/OrganizationDetailsPage.tsx"
});
const $de8c3e3ab2353fd7$var$AsyncProductsJsmOrganizationDetails = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $de8c3e3ab2353fd7$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });
var $de8c3e3ab2353fd7$export$2e2bcd8739ae039 = $de8c3e3ab2353fd7$var$AsyncProductsJsmOrganizationDetails;

});
parcelRegister("cdCo5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5bFnu").then(()=>parcelRequire('ihj3F'));

});



parcelRegister("lAyQF", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", () => $71c6011a22782edf$export$34d843946d3894aa);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $1JTub = parcelRequire("1JTub");

var $9NmsS = parcelRequire("9NmsS");

var $dpZfP = parcelRequire("dpZfP");

var $KQkQM = parcelRequire("KQkQM");
const $71c6011a22782edf$export$34d843946d3894aa = (0, $6xToB.createEntry)((0, $dpZfP.productsJsmOrganizationsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $KQkQM.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $1JTub.productsJsmOrganizationListResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $KQkQM.LazyProductsJsmOrganizations)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsm-organizations-entries/src/productsJsmOrganizationsRouteEntry.tsx',
                whichExportToUse: 'productsJsmOrganizationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dpZfP", function(module, exports) {
$parcel$export(module.exports, "productsJsmOrganizationsRoute", () => $6cf31810d295ba86$export$512fa30726e0049d);
const $6cf31810d295ba86$export$512fa30726e0049d = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};

});

parcelRegister("KQkQM", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJsmOrganizations", () => $0263ee56cbcce9bc$export$410bec6e06fd4723);
$parcel$export(module.exports, "default", () => $0263ee56cbcce9bc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $0263ee56cbcce9bc$export$410bec6e06fd4723 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cUjwG"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/OrganizationsListPage.tsx"
});
const $0263ee56cbcce9bc$var$AsyncProductsJsmOrganizations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0263ee56cbcce9bc$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });
var $0263ee56cbcce9bc$export$2e2bcd8739ae039 = $0263ee56cbcce9bc$var$AsyncProductsJsmOrganizations;

});
parcelRegister("cUjwG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dxc4F").then(()=>parcelRequire('bkp4a'));

});



parcelRegister("9Gw9x", function(module, exports) {
$parcel$export(module.exports, "productsJswConfigurationRouteEntry", () => $c921c85d99eb870a$export$2f65b1ec4ed05f91);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $vEsck = parcelRequire("vEsck");

var $gKS1S = parcelRequire("gKS1S");

var $330qz = parcelRequire("330qz");
const $c921c85d99eb870a$export$2f65b1ec4ed05f91 = (0, $6xToB.createEntry)((0, $gKS1S.productsJswConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration',
        component: (0, $330qz.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $vEsck.productsJswConfigurationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $330qz.LazyProductsJswConfiguration)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsw-configuration-entries/src/productsJswConfigurationRouteEntry.tsx',
                whichExportToUse: 'productsJswConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("vEsck", function(module, exports) {
$parcel$export(module.exports, "productsJswConfigurationResource", () => $67ddd663c88f9bfa$export$b6a5741c2b47fb17);

var $l1VxS = parcelRequire("l1VxS");


const $67ddd663c88f9bfa$export$b6a5741c2b47fb17 = (0, $l1VxS.createResource)({
    type: (0, $80696a591dc12263$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("782jZ"))
});

});
const $80696a591dc12263$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("782jZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i7y0D").then(()=>parcelRequire('e0i7w'));

});


parcelRegister("gKS1S", function(module, exports) {
$parcel$export(module.exports, "productsJswConfigurationRoute", () => $06ca798eb9d59f47$export$decdad53ba9b97af);
const $06ca798eb9d59f47$export$decdad53ba9b97af = {
    name: 'products-jsw-configuration',
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};

});

parcelRegister("330qz", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJswConfiguration", () => $1760e0706c541113$export$f9a32397033f9ced);
$parcel$export(module.exports, "default", () => $1760e0706c541113$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1760e0706c541113$export$f9a32397033f9ced = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jZTfI"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
const $1760e0706c541113$var$AsyncProductsJswConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1760e0706c541113$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });
var $1760e0706c541113$export$2e2bcd8739ae039 = $1760e0706c541113$var$AsyncProductsJswConfiguration;

});
parcelRegister("jZTfI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eQ2G5").then(()=>parcelRequire('c3Oit'));

});



parcelRegister("jhJLH", function(module, exports) {
$parcel$export(module.exports, "productsJswGuestAccessRouteEntry", () => $dad1ec25cd2015d3$export$58558abd1d50e682);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ew8ut = parcelRequire("ew8ut");

var $cf2xI = parcelRequire("cf2xI");
const $dad1ec25cd2015d3$export$58558abd1d50e682 = (0, $6xToB.createEntry)((0, $ew8ut.productsJswGuestAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.guest-access',
        entryPoint: ()=>(0, $cf2xI.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsw-configuration-entries/src/productsJswGuestAccessRouteEntry.tsx',
                whichExportToUse: 'productsJswGuestAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ew8ut", function(module, exports) {
$parcel$export(module.exports, "productsJswGuestAccessRoute", () => $2e9dedde2f739b38$export$87ff19b2c0cf5ebd);
const $2e9dedde2f739b38$export$87ff19b2c0cf5ebd = {
    name: 'products-jsw-guest-access',
    path: '/jira/settings/products/jira-software-configuration/guest-access',
    exact: true
};

});

parcelRegister("cf2xI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f86fb58544f47b47$export$2e2bcd8739ae039);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $j6kSb = parcelRequire("j6kSb");
const $f86fb58544f47b47$export$6dca12349ffe9ee6 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $j6kSb.guestAccessEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
var $f86fb58544f47b47$export$2e2bcd8739ae039 = $f86fb58544f47b47$export$6dca12349ffe9ee6;

});
parcelRegister("j6kSb", function(module, exports) {
$parcel$export(module.exports, "guestAccessEntrypoint", () => $c770ba596f573b37$export$fc4ce9091698e334);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $c770ba596f573b37$export$fc4ce9091698e334 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("FnUAR")), {
        moduleId: "80d36359",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("FnUAR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eID6R").then(()=>parcelRequire('6YYOX'));

});




parcelRegister("uS0Wn", function(module, exports) {
$parcel$export(module.exports, "productsJswStorageManagementRouteEntry", () => $4eb5364b56c64c9e$export$c62ca2d3fcc552a5);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $8lvaF = parcelRequire("8lvaF");

var $jDfS8 = parcelRequire("jDfS8");

var $b0iFV = parcelRequire("b0iFV");
const $4eb5364b56c64c9e$export$c62ca2d3fcc552a5 = (0, $6xToB.createEntry)((0, $jDfS8.productsJswStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.storage-management',
        component: (0, $b0iFV.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            (0, $8lvaF.productsJswStorageManagementResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b0iFV.LazyProductsJswStorageManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-products-jsw-configuration-entries/src/productsJswStorageManagementRouteEntry.tsx',
                whichExportToUse: 'productsJswStorageManagementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8lvaF", function(module, exports) {
$parcel$export(module.exports, "productsJswStorageManagementResource", () => $dfa0c0214398d952$export$2cd668845b3478bd);

var $l1VxS = parcelRequire("l1VxS");


const $dfa0c0214398d952$export$2cd668845b3478bd = (0, $l1VxS.createResource)({
    type: (0, $0b5197d9433321af$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("4gaLj"))
});

});
const $0b5197d9433321af$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("4gaLj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6bEGe").then(()=>parcelRequire('dK43S'));

});


parcelRegister("jDfS8", function(module, exports) {
$parcel$export(module.exports, "productsJswStorageManagementRoute", () => $d2475c32f47452c4$export$18f0044f00cc3996);
const $d2475c32f47452c4$export$18f0044f00cc3996 = {
    name: 'products-jsw-storage-management',
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("b0iFV", function(module, exports) {
$parcel$export(module.exports, "LazyProductsJswStorageManagement", () => $ac20c7f9847e6399$export$a4f5e12ce817cbb8);
$parcel$export(module.exports, "default", () => $ac20c7f9847e6399$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ac20c7f9847e6399$export$a4f5e12ce817cbb8 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4JB4L"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
const $ac20c7f9847e6399$var$AsyncProductsJswStorageManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ac20c7f9847e6399$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });
var $ac20c7f9847e6399$export$2e2bcd8739ae039 = $ac20c7f9847e6399$var$AsyncProductsJswStorageManagement;

});
parcelRegister("4JB4L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("kxSQb")
]).then(()=>parcelRequire('8su69'));

});



parcelRegister("3CKd6", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubCreateRouteEntry", () => $b2c19490c573bc5d$export$666a5dacd00ae9cf);

var $a5X6Q = parcelRequire("a5X6Q");

var $imQUn = parcelRequire("imQUn");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $yRJUA = parcelRequire("yRJUA");

var $4cTDP = parcelRequire("4cTDP");

var $7jwLG = parcelRequire("7jwLG");

var $9NmsS = parcelRequire("9NmsS");

var $7bnur = parcelRequire("7bnur");
const $b2c19490c573bc5d$var$productsOnboardingHubCreateEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a5X6Q.onboardingHubWizardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $b2c19490c573bc5d$var$productsOnboardingHubCreateWithDelegatedAdminEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $imQUn.onboardingHubWizardWithDelegatedAdminEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS,
    leftSidebar: {
        sidebar: (0, $7bnur.nav4SidebarGlobalProductsSettingsEntryPoint)
    }
});
const $b2c19490c573bc5d$export$666a5dacd00ae9cf = (0, $6xToB.createEntry)((0, $7jwLG.productsOnboardingHubCreateRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.products.onboarding-hub-create',
        meta: {
            reporting: {
                id: 'products-onboarding-hub-create',
                teamName: 'a4t-pandora',
                packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries'
            }
        },
        entryPoint () {
            if ((0, $4cTDP.fg)('jira-onboarding-hub-gate')) return (0, $4cTDP.fg)('jira-delegated-custom-onboarding') ? $b2c19490c573bc5d$var$productsOnboardingHubCreateWithDelegatedAdminEntryPoint : $b2c19490c573bc5d$var$productsOnboardingHubCreateEntryPoint;
            return undefined;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-onboarding-hub-entries/src/productsOnboardingHubCreateRouteEntry.tsx',
                whichExportToUse: 'productsOnboardingHubCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("a5X6Q", function(module, exports) {
$parcel$export(module.exports, "onboardingHubWizardEntryPoint", () => $37556b6382aa658c$export$fd5b175ebf56469c);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $37556b6382aa658c$export$fd5b175ebf56469c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eGMai")).then((module)=>module.OnboardingWizard), {
        moduleId: "9a7e01ab",
        moduleName: "OnboardingWizardInner",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                id: context.match.params?.id || ''
            }
        })
});

});
parcelRegister("eGMai", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("eMY1c")
]).then(()=>parcelRequire('kUVYw'));

});


parcelRegister("imQUn", function(module, exports) {
$parcel$export(module.exports, "onboardingHubWizardWithDelegatedAdminEntryPoint", () => $1824c1fc6c6239cc$export$9c435eb0e972772a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $cWkxS = parcelRequire("cWkxS");

const $1824c1fc6c6239cc$export$9c435eb0e972772a = (0, $3Bzqe.createEntryPoint)({
    // Using `JSResourceForInteraction` to avoid SSR
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eGMai")).then((module)=>module.OnboardingWizardWithDelegatedAdmin), {
        moduleId: "9a7e01ab",
        moduleName: "OnboardingWizardInner",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId, isAdmin: isAdmin, appEditions: appEditions } })=>({
            extraProps: {
                id: context.match.params?.id || ''
            },
            queries: {
                permissionsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $cWkxS.default),
                    variables: {
                        cloudId: cloudId,
                        // We can skip the permission check when:
                        // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                        // 2. Upsell is enabled (because upsell is only available to admins)
                        skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier')
                    }
                }
            }
        })
});

});
parcelRegister("cWkxS", function(module, exports) {
$parcel$export(module.exports, "default", () => $11754528ee970ad0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<139c2e4e111b57dde4d7dd803ba3be26>>
 * @relayHash e80b0a4466bb973c579a3be7e724aa26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10c26fee5a185705c6edc1cc504465a821bef8424513beeb6f40b39691874f32

var $37Ewn = parcelRequire("37Ewn");
const $11754528ee970ad0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ], v1 = [
        {
            "condition": "skipDelegatedAdminCheck",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canManageCustomOnboarding",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "MANAGE_CUSTOM_ONBOARDING"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasGlobalPermission"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OnboardingWizardInnerPermissionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OnboardingWizardInnerPermissionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "10c26fee5a185705c6edc1cc504465a821bef8424513beeb6f40b39691874f32",
            "metadata": {},
            "name": "OnboardingWizardInnerPermissionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$11754528ee970ad0$var$node.hash = "4a25465480268eec81b6f5dc0fde9fca";
(0, $37Ewn.PreloadableQueryRegistry).set($11754528ee970ad0$var$node.params.id, $11754528ee970ad0$var$node);
var $11754528ee970ad0$export$2e2bcd8739ae039 = $11754528ee970ad0$var$node;

});


parcelRegister("7jwLG", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubCreateRoute", () => $6a00e541f7f05ad2$export$a27be1bacf345707);
const $6a00e541f7f05ad2$export$a27be1bacf345707 = {
    name: 'products-onboarding-hub-create',
    path: '/jira/settings/products/onboarding/new'
};

});

parcelRegister("7bnur", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarGlobalProductsSettingsEntryPoint", () => $d7ad939b8f480e44$export$aa699a6476ee43d8);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $aYXFw = parcelRequire("aYXFw");

var $4cTDP = parcelRequire("4cTDP");

const $d7ad939b8f480e44$export$aa699a6476ee43d8 = (0, $3Bzqe.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("kA5R0"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "f06694bb",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps ({ tenantContext: { cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } }) {
        return {
            queries: {
                nav4SidebarGlobalProductsSettings: {
                    parameters: (0, $aYXFw.default),
                    variables: {
                        cloudId: cloudId,
                        // We can skip the permission check when:
                        // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                        // 2. Upsell is enabled (because upsell is only available to admins), or
                        // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone), or
                        // 4. The delegated admin gate is disabled (because only admins would be able to view the feature)
                        skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier') || !(0, $4cTDP.fg)('jira-onboarding-hub-gate') || !(0, $4cTDP.fg)('jira-delegated-custom-onboarding')
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});


parcelRegister("emNcb", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubEditRouteEntry", () => $90cf2cfa6a2b0a53$export$a51e527aeaa5756f);

var $a5X6Q = parcelRequire("a5X6Q");

var $imQUn = parcelRequire("imQUn");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $yRJUA = parcelRequire("yRJUA");

var $4cTDP = parcelRequire("4cTDP");

var $i0ttp = parcelRequire("i0ttp");

var $9NmsS = parcelRequire("9NmsS");

var $7bnur = parcelRequire("7bnur");
const $90cf2cfa6a2b0a53$var$productsOnboardingHubEditEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a5X6Q.onboardingHubWizardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS
});
const $90cf2cfa6a2b0a53$var$productsOnboardingHubEditWithDelegatedAdminEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $imQUn.onboardingHubWizardWithDelegatedAdminEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS,
    leftSidebar: {
        sidebar: (0, $7bnur.nav4SidebarGlobalProductsSettingsEntryPoint)
    }
});
const $90cf2cfa6a2b0a53$export$a51e527aeaa5756f = (0, $6xToB.createEntry)((0, $i0ttp.productsOnboardingHubEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.products.onboarding-hub-edit',
        meta: {
            reporting: {
                id: 'products-onboarding-hub-edit',
                teamName: 'a4t-pandora',
                packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries'
            }
        },
        entryPoint () {
            if ((0, $4cTDP.fg)('jira-onboarding-hub-gate')) return (0, $4cTDP.fg)('jira-delegated-custom-onboarding') ? $90cf2cfa6a2b0a53$var$productsOnboardingHubEditWithDelegatedAdminEntryPoint : $90cf2cfa6a2b0a53$var$productsOnboardingHubEditEntryPoint;
            return undefined;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-onboarding-hub-entries/src/productsOnboardingHubEditRouteEntry.tsx',
                whichExportToUse: 'productsOnboardingHubEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("i0ttp", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubEditRoute", () => $cb9c40e06f6c2ef7$export$28172feeb183ba94);
const $cb9c40e06f6c2ef7$export$28172feeb183ba94 = {
    name: 'products-onboarding-hub-edit',
    path: '/jira/settings/products/onboarding/:id/edit'
};

});


parcelRegister("bb3Kz", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubRouteEntry", () => $bd240a87609a2624$export$114fd427e3931043);

var $9Hebs = parcelRequire("9Hebs");

var $3MgfG = parcelRequire("3MgfG");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $yRJUA = parcelRequire("yRJUA");

var $4cTDP = parcelRequire("4cTDP");

var $2Kod9 = parcelRequire("2Kod9");

var $9NmsS = parcelRequire("9NmsS");

var $7bnur = parcelRequire("7bnur");
const $bd240a87609a2624$var$productsOnboardingHubEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9Hebs.onboardingHubEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
// When a user visits this page directly, the left sidebar comes from
// nav4SidebarGlobalProductsSettingsEntryPoint, but when they land on this page via
// the Global Settings Page Switcher, the left sidebar comes from the relay-resource-backed
// component: SidebarContentWithRelayResource.
// See @atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-products/src/ui/index.tsx.
const $bd240a87609a2624$var$productsOnboardingHubWithDelegatedAdminEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9Hebs.onboardingHubEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).SETTINGS,
    leftSidebar: {
        sidebar: (0, $7bnur.nav4SidebarGlobalProductsSettingsEntryPoint)
    }
});
const $bd240a87609a2624$export$114fd427e3931043 = (0, $6xToB.createEntry)((0, $2Kod9.productsOnboardingHubRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.products.onboarding-hub',
        meta: {
            reporting: {
                id: 'products-onboarding-hub',
                teamName: 'a4t-pandora',
                packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries'
            }
        },
        entryPoint () {
            if ((0, $4cTDP.fg)('jira-onboarding-hub-gate')) return (0, $4cTDP.fg)('jira-delegated-custom-onboarding') ? $bd240a87609a2624$var$productsOnboardingHubWithDelegatedAdminEntryPoint : $bd240a87609a2624$var$productsOnboardingHubEntryPoint;
            return undefined;
        },
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-onboarding-hub-entries/src/productsOnboardingHubRouteEntry.tsx',
                whichExportToUse: 'productsOnboardingHubRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9Hebs", function(module, exports) {
$parcel$export(module.exports, "onboardingHubEntryPoint", () => $ee08d91985265f8f$export$fbab93125af0feae);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $rRem1 = parcelRequire("rRem1");

const $ee08d91985265f8f$export$fbab93125af0feae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("cHK1n")), {
        moduleId: "7216e0de",
        moduleName: "OnboardingHubPageComponent",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>{
        const { appEditions: appEditions, cloudId: cloudId, isAdmin: isAdmin } = tenantContext;
        const queries = {
            onboardingHubQuery: {
                options: {
                    fetchPolicy: 'store-and-network'
                },
                parameters: (0, $rRem1.default),
                variables: {
                    cloudId: cloudId,
                    upsellEnabled: appEditions?.software !== 'PREMIUM_EDITION' && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier'),
                    hamsProductKey: 'jira-software.ondemand',
                    rollingIntervals: [
                        'DAYS_1',
                        'DAYS_7',
                        'DAYS_30',
                        'DAYS_90',
                        'DAYS_180'
                    ],
                    // We can skip the permission check when:
                    // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                    // 2. Upsell is enabled (because upsell is only available to admins), or
                    // 3. The delegated admin gate is disabled (because only admins would be able to view the feature)
                    skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' && (0, $4cTDP.fg)('restrict-custom-onboarding-to-premium-tier') || !(0, $4cTDP.fg)('jira-delegated-custom-onboarding')
                }
            }
        };
        return {
            queries: queries
        };
    }
});

});
parcelRegister("rRem1", function(module, exports) {
$parcel$export(module.exports, "default", () => $58abb13515eba98c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c3f80299688c7f902694a531b16a8e66>>
 * @relayHash d583c17c36ed08c3eea4b56872e85490
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26531098faaed35f92396951d199e959fada1d0eefbc108e9919a5d3f8f25005

var $37Ewn = parcelRequire("37Ewn");
const $58abb13515eba98c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rollingIntervals"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipDelegatedAdminCheck"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "upsellEnabled"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "condition": "skipDelegatedAdminCheck",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "alias": "canManageCustomOnboarding",
                        "args": [
                            v5 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "MANAGE_CUSTOM_ONBOARDING"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "hasGlobalPermission"
                    }
                ]
            }
        ]
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "OnboardingHubPageComponentQuery",
            "selections": [
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "OnboardingListTable"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "InsightsPanel"
                        }
                    ]
                },
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CustomOnboardingUpsell"
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "OnboardingHubPageComponentQuery",
            "selections": [
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "concreteType": "JiraOnboardingConfigConnection",
                            "kind": "LinkedField",
                            "name": "jira_onboardingConfigs",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraOnboardingConfigEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOnboardingConfig",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "onboardingConfigAri"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "targetValues"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updatedAt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDisabled"
                                                },
                                                {
                                                    "concreteType": "JiraOnboardingModal",
                                                    "kind": "LinkedField",
                                                    "name": "modals",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOnboardingStep",
                                                            "kind": "LinkedField",
                                                            "name": "steps",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOnboardingLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "text"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "tenantId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
                            "kind": "LinkedField",
                            "name": "growthUnifiedProfile_siteProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "rollingIntervals",
                                            "variableName": "rollingIntervals"
                                        }
                                    ],
                                    "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                                    "kind": "LinkedField",
                                    "name": "onboardingHubInsightsOverAll",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalViews"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalEngagements"
                                        },
                                        {
                                            "concreteType": "GrowthUnifiedProfileEngagementsSeries",
                                            "kind": "LinkedField",
                                            "name": "engagementsSeries",
                                            "plural": true,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "rollingInterval"
                                        },
                                        {
                                            "concreteType": "GrowthUnifiedProfileViewSeries",
                                            "kind": "LinkedField",
                                            "name": "viewsSeries",
                                            "plural": true,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "completionRate"
                                        },
                                        {
                                            "concreteType": "GrowthUnifiedProfileCompletionSeries",
                                            "kind": "LinkedField",
                                            "name": "completionsSeries",
                                            "plural": true,
                                            "selections": v7 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "upsellEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "hamsProductKey",
                                            "variableName": "hamsProductKey"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "offeringName",
                                                                    "value": "Premium"
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "experienceUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isAvailableToUser"
                                                                }
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "26531098faaed35f92396951d199e959fada1d0eefbc108e9919a5d3f8f25005",
            "metadata": {},
            "name": "OnboardingHubPageComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$58abb13515eba98c$var$node.hash = "848e05b413d7f414a4b31810b03b8c66";
(0, $37Ewn.PreloadableQueryRegistry).set($58abb13515eba98c$var$node.params.id, $58abb13515eba98c$var$node);
var $58abb13515eba98c$export$2e2bcd8739ae039 = $58abb13515eba98c$var$node;

});

parcelRegister("cHK1n", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("bUPwj")
]).then(()=>parcelRequire('4z8RD'));

});


parcelRegister("2Kod9", function(module, exports) {
$parcel$export(module.exports, "productsOnboardingHubRoute", () => $a626a147af55c538$export$6a9e8ece249577cc);
const $a626a147af55c538$export$6a9e8ece249577cc = {
    name: 'products-onboarding-hub',
    path: '/jira/settings/products/onboarding'
};

});


parcelRegister("fAxRm", function(module, exports) {
$parcel$export(module.exports, "proformaExportRouteEntry", () => $d1ffca1fc741593c$export$27be010fc1b30f6c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $iyCyU = parcelRequire("iyCyU");

var $UzU1b = parcelRequire("UzU1b");
const $d1ffca1fc741593c$export$27be010fc1b30f6c = (0, $6xToB.createEntry)((0, $iyCyU.proformaExportRoute), ()=>({
        group: 'proforma',
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        component: (0, $UzU1b.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $UzU1b.LazyProformaExport)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/proformaExportRouteEntry.tsx',
                whichExportToUse: 'proformaExportRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iyCyU", function(module, exports) {
$parcel$export(module.exports, "proformaExportRoute", () => $0e19409ed3fd7e40$export$5130d152b1cda229);
const $0e19409ed3fd7e40$export$5130d152b1cda229 = {
    name: 'proforma-export',
    path: '/jira/forms/export',
    exact: true
};

});

parcelRegister("UzU1b", function(module, exports) {
$parcel$export(module.exports, "LazyProformaExport", () => $668b9d64fc26885c$export$5e0d802a5d865352);
$parcel$export(module.exports, "default", () => $668b9d64fc26885c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $668b9d64fc26885c$export$5e0d802a5d865352 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("bAOb6")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
const $668b9d64fc26885c$var$AsyncProformaExport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $668b9d64fc26885c$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });
var $668b9d64fc26885c$export$2e2bcd8739ae039 = $668b9d64fc26885c$var$AsyncProformaExport;

});
parcelRegister("bAOb6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9tG6Z").then(()=>parcelRequire('Li5l0'));

});



parcelRegister("gLtBa", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsGeneralRouteEntry", () => $96cc83be2d5613e1$export$90d7a2fe9ba3bc11);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $krfFu = parcelRequire("krfFu");

var $gcV4I = parcelRequire("gcV4I");
const $96cc83be2d5613e1$export$90d7a2fe9ba3bc11 = (0, $6xToB.createEntry)((0, $krfFu.proformaIssueFormsGeneralRoute), ()=>({
        group: 'proforma',
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        component: (0, $gcV4I.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $gcV4I.LazyProformaIssueFormsGeneral)
        ],
        perfMetricKey: 'issue-forms-general',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/proformaIssueFormsGeneralRouteEntry.tsx',
                whichExportToUse: 'proformaIssueFormsGeneralRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("krfFu", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsGeneralRoute", () => $c0c7ff427ec69461$export$5e0c19066a4c3806);
const $c0c7ff427ec69461$export$5e0c19066a4c3806 = {
    name: 'proforma-issue-forms-general',
    path: '/jira/forms/create',
    exact: true
};

});

parcelRegister("gcV4I", function(module, exports) {
$parcel$export(module.exports, "LazyProformaIssueFormsGeneral", () => $c63c887e9367d456$export$7c16b09eb95f1c5d);
$parcel$export(module.exports, "default", () => $c63c887e9367d456$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c63c887e9367d456$export$7c16b09eb95f1c5d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("j8rBB")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
const $c63c887e9367d456$var$AsyncProformaIssueFormsGeneral = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c63c887e9367d456$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });
var $c63c887e9367d456$export$2e2bcd8739ae039 = $c63c887e9367d456$var$AsyncProformaIssueFormsGeneral;

});
parcelRegister("j8rBB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ha5h").then(()=>parcelRequire('2wveb'));

});



parcelRegister("3d0g1", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRedirectRouteEntry", () => $9738cb89159d4099$export$b498607b4440c4ef);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bL8CC = parcelRequire("bL8CC");

var $eRnC9 = parcelRequire("eRnC9");
const $9738cb89159d4099$export$b498607b4440c4ef = (0, $6xToB.createEntry)((0, $bL8CC.projectComponentsRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $eRnC9.ComponentsRedirect) : undefined,
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $aZ5HL.projectsComponentsResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-components-entries/src/projectComponentsRedirectRouteEntry.tsx',
                whichExportToUse: 'projectComponentsRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aZ5HL", function(module, exports) {
$parcel$export(module.exports, "projectsComponentsResource", () => $ae3accc88e2541d8$export$557cc3eff8939b3);

var $cJYBV = parcelRequire("cJYBV");

var $l1VxS = parcelRequire("l1VxS");


const $ae3accc88e2541d8$export$557cc3eff8939b3 = (0, $l1VxS.createResource)({
    type: (0, $42742cb606e40290$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("keDrA")),
    maxAge: (0, $cJYBV.MIN_MAX_AGE)
});

});
const $42742cb606e40290$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("keDrA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dA6mO").then(()=>parcelRequire('9fdve'));

});


parcelRegister("bL8CC", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRedirectRoute", () => $39e5f6263f4ac6d6$export$d370abe25253fa1b);

var $aWDzX = parcelRequire("aWDzX");
const $39e5f6263f4ac6d6$export$d370abe25253fa1b = {
    name: 'project-components-redirect',
    path: '/projects/:projectKey',
    query: (0, $aWDzX.PROJECTS_COMPONENTS_QUERY_PARAMS)
};

});
parcelRegister("aWDzX", function(module, exports) {
$parcel$export(module.exports, "PROJECTS_COMPONENTS_QUERY_PARAMS", () => $7045432d94598154$export$1d7a0c194c3e83f2);
const $7045432d94598154$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];

});


parcelRegister("eRnC9", function(module, exports) {
$parcel$export(module.exports, "ComponentsRedirect", () => $dda166f65f6bcbc3$export$9cf9ae84482ff18e);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $akJ5X = parcelRequire("akJ5X");
const $dda166f65f6bcbc3$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $3Q6BV.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akJ5X.RedirectToProjectType), {
        page: page
    });
};

});
parcelRegister("akJ5X", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $8b78b9af8d494d73$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $8b78b9af8d494d73$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $kRgKj.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $3lhVL.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $FhXEJ.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $FhXEJ.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("7mEsO", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRouteEntry", () => $9d1fbb9e0fa9d201$export$e60f53ff5ae626cd);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bwFUS = parcelRequire("bwFUS");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $6l2Aw = parcelRequire("6l2Aw");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $9d1fbb9e0fa9d201$var$projectComponentsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6l2Aw.projectComponentsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $9d1fbb9e0fa9d201$export$e60f53ff5ae626cd = (0, $6xToB.createEntry)((0, $bwFUS.projectComponentsRoute), ()=>({
        group: 'components',
        ufoName: 'project-components-view',
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $aZ5HL.projectsComponentsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
        ],
        entryPoint: ()=>$9d1fbb9e0fa9d201$var$projectComponentsPageEntryPoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-components-entries/src/projectComponentsRouteEntry.tsx',
                whichExportToUse: 'projectComponentsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bwFUS", function(module, exports) {
$parcel$export(module.exports, "projectComponentsRoute", () => $4f4abd4e8b3df111$export$f76189bea494b0b8);
const $4f4abd4e8b3df111$export$f76189bea494b0b8 = {
    name: 'project-components',
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};

});

parcelRegister("6l2Aw", function(module, exports) {
$parcel$export(module.exports, "projectComponentsEntrypoint", () => $20c948855b9573f6$export$d90db228c6acd520);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $20c948855b9573f6$export$d90db228c6acd520 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("cg243")), {
        moduleId: "f6db472c",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cg243", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("3iXzr")
]).then(()=>parcelRequire('kMIvJ'));

});



parcelRegister("j2UMI", function(module, exports) {
$parcel$export(module.exports, "projectDirectoryRedirectRouteEntry", () => $9402b743579a1fe5$export$f1f04e35fd5f4283);

var $eJOHy = parcelRequire("eJOHy");

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $kHlOR = parcelRequire("kHlOR");

var $3phEv = parcelRequire("3phEv");

var $7fTjp = parcelRequire("7fTjp");

var $7h3uc = parcelRequire("7h3uc");
const $9402b743579a1fe5$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/projects"
    });
const $9402b743579a1fe5$export$f1f04e35fd5f4283 = (0, $6xToB.createEntry)((0, $3phEv.projectDirectoryRedirectRoute), ()=>({
        group: 'classic-software',
        component: $9402b743579a1fe5$var$ProjectsDirectoryRedirect,
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/projectDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'projectDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3phEv", function(module, exports) {
$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $326a362e17ae685c$export$3913c8bee519225c);
const $326a362e17ae685c$export$3913c8bee519225c = {
    name: 'project-directory-redirect',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("l29cD", function(module, exports) {
$parcel$export(module.exports, "projectIssueNavigatorRouteEntry", () => $487eb24527a3e26f$export$d6b778af15db7d3);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4VIcO = parcelRequire("4VIcO");

var $71FJh = parcelRequire("71FJh");

var $gwH93 = parcelRequire("gwH93");


var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $bQFhw = parcelRequire("bQFhw");

var $d4NVH = parcelRequire("d4NVH");

var $fYGKn = parcelRequire("fYGKn");
const $487eb24527a3e26f$export$d6b778af15db7d3 = (0, $6xToB.createEntry)((0, $71FJh.projectIssueNavigatorRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        },
        skeleton: (0, $gwH93.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('empanada_nin_resource_audit_2025'), (0, $4VIcO.getConsolidationStateResource)())
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        entryPoint: ()=>(0, $fYGKn.issueNavigatorPinRedirectPageEntryPoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/projectIssueNavigatorRouteEntry.tsx',
                whichExportToUse: 'projectIssueNavigatorRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("71FJh", function(module, exports) {
$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $cbed4a6b99e05501$export$126b16ec65343bf);
const $cbed4a6b99e05501$export$126b16ec65343bf = {
    name: 'issue-navigator',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("eze04", function(module, exports) {
$parcel$export(module.exports, "projectNotFoundRouteEntry", () => $87ab8a7cd3b94462$export$beae48175e3016b8);

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $eQwye = parcelRequire("eQwye");

var $hceXq = parcelRequire("hceXq");
const $87ab8a7cd3b94462$var$projectNotFoundPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $hceXq.projectNotFoundEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $87ab8a7cd3b94462$export$beae48175e3016b8 = (0, $6xToB.createEntry)((0, $eQwye.projectNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint () {
            return $87ab8a7cd3b94462$var$projectNotFoundPageEntryPoint;
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        pageId: 'project-not-found-page-id',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-not-found-entries/src/projectNotFoundRouteEntry.tsx',
                whichExportToUse: 'projectNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eQwye", function(module, exports) {
$parcel$export(module.exports, "projectNotFoundRoute", () => $ad61ff49eaca5222$export$ad23ddca45852d02);
const $ad61ff49eaca5222$export$ad23ddca45852d02 = {
    name: 'project-not-found',
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
    exact: true
};

});

parcelRegister("hceXq", function(module, exports) {
$parcel$export(module.exports, "projectNotFoundEntryPoint", () => $ba3b5b2d880d29ad$export$6ffa2f426ba3b25a);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $ba3b5b2d880d29ad$export$6ffa2f426ba3b25a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4pIvp")), {
        moduleId: "51ed29c5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4pIvp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f8yPF").then(()=>parcelRequire('jg2EL'));

});



parcelRegister("9B4ho", function(module, exports) {
$parcel$export(module.exports, "projectPagesLegacyRouteEntry", () => $d25b8db25da4495b$export$5788c5f8c4e440b1);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jWQE3 = parcelRequire("jWQE3");

var $7CcYG = parcelRequire("7CcYG");
const $d25b8db25da4495b$export$5788c5f8c4e440b1 = (0, $6xToB.createEntry)((0, $jWQE3.projectPagesLegacyRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: !false ? (0, $7CcYG.PagesRedirect) : (0, $7CcYG.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7CcYG.LazyProjectPages)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-pages-entries/src/projectPagesLegacyRouteEntry.tsx',
                whichExportToUse: 'projectPagesLegacyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jWQE3", function(module, exports) {
$parcel$export(module.exports, "projectPagesLegacyRoute", () => $846d63863db70a86$export$a82cbb9b9c689c40);
const $846d63863db70a86$export$a82cbb9b9c689c40 = {
    name: 'project-pages-legacy',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};

});

parcelRegister("7CcYG", function(module, exports) {
$parcel$export(module.exports, "LazyProjectPages", () => $c8554474f623042e$export$c2115a649411f570);
$parcel$export(module.exports, "PagesRedirect", () => $c8554474f623042e$export$7c3b1828ada63555);
$parcel$export(module.exports, "default", () => $c8554474f623042e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $dGi3M = parcelRequire("dGi3M");

const $c8554474f623042e$export$c2115a649411f570 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("g9bkG"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $c8554474f623042e$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dGi3M.RedirectToProjectType), {
        page: "/pages"
    });
const $c8554474f623042e$var$AsyncProjectPages = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c8554474f623042e$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });
var $c8554474f623042e$export$2e2bcd8739ae039 = $c8554474f623042e$var$AsyncProjectPages;

});
parcelRegister("dGi3M", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $ebac16b69edfbbe3$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $ebac16b69edfbbe3$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $kRgKj.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $3lhVL.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $FhXEJ.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $FhXEJ.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("g9bkG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l2jdZ").then(()=>parcelRequire('9A00a'));

});



parcelRegister("dMtOC", function(module, exports) {
$parcel$export(module.exports, "projectPagesRouteEntry", () => $e6bbf17f835c69ac$export$babf32528ef518e9);

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $lzYaa = parcelRequire("lzYaa");

var $jom8W = parcelRequire("jom8W");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $cxKOj = parcelRequire("cxKOj");

var $7CcYG = parcelRequire("7CcYG");
const $e6bbf17f835c69ac$export$babf32528ef518e9 = (0, $6xToB.createEntry)((0, $lzYaa.projectPagesRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)() && (0, $cxKOj.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false) || (0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $7CcYG.default)),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7CcYG.LazyProjectPages)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-pages-entries/src/projectPagesRouteEntry.tsx',
                whichExportToUse: 'projectPagesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lzYaa", function(module, exports) {
$parcel$export(module.exports, "projectPagesRoute", () => $24f94fca506bee70$export$54a218ca6d1c056a);
const $24f94fca506bee70$export$54a218ca6d1c056a = {
    name: 'project-pages',
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};

});


parcelRegister("2cgig", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRouteEntry", () => $bf61e2687b10809e$export$78ff5b5f42b9de4);

var $kHlOR = parcelRequire("kHlOR");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i9ujx = parcelRequire("i9ujx");

var $h9tDf = parcelRequire("h9tDf");

var $iMFdk = parcelRequire("iMFdk");

var $7PT7e = parcelRequire("7PT7e");

var $4qnr5 = parcelRequire("4qnr5");
const $bf61e2687b10809e$export$78ff5b5f42b9de4 = (0, $6xToB.createEntry)((0, $h9tDf.projectsDirectoryLegacyPathRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $7PT7e.ProjectsDirectoryRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $i9ujx.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/projectsDirectoryLegacyPathRedirectRouteEntry.tsx',
                whichExportToUse: 'projectsDirectoryLegacyPathRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7PT7e", function(module, exports) {
$parcel$export(module.exports, "ProjectsDirectoryRedirect", () => $130cbc93d99de54c$export$b68dd6112a931c10);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $130cbc93d99de54c$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/projects"
    });

});


parcelRegister("9GvQT", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRedirectRouteEntry", () => $b9b55a61cd5407c7$export$c3c347e60b82f074);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9l6lo = parcelRequire("9l6lo");

var $iMFdk = parcelRequire("iMFdk");

var $lMQkR = parcelRequire("lMQkR");

var $9MwFx = parcelRequire("9MwFx");

var $4qnr5 = parcelRequire("4qnr5");
const $b9b55a61cd5407c7$export$c3c347e60b82f074 = (0, $6xToB.createEntry)((0, $9l6lo.projectsDirectoryManageRedirectRoute), ()=>({
        component: (0, $lMQkR.ProjectsDirectoryManageRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9MwFx.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/projectsDirectoryManageRedirectRouteEntry.tsx',
                whichExportToUse: 'projectsDirectoryManageRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9l6lo", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $6a42ac46fc6348ec$export$dbd3b6c012e8b6dc);
const $6a42ac46fc6348ec$export$dbd3b6c012e8b6dc = {
    name: 'projects-directory-manage-redirect',
    path: '/secure/project/ViewProjects.jspa'
};

});

parcelRegister("lMQkR", function(module, exports) {
$parcel$export(module.exports, "ProjectsDirectoryManageRedirect", () => $9b4f68af14c60f5d$export$74316a0a4963952b);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $9b4f68af14c60f5d$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

});


parcelRegister("65d18", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRouteEntry", () => $42b104f4bc1b1927$export$3f6ec3224d4c9da);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $3ACK3 = parcelRequire("3ACK3");

var $iMFdk = parcelRequire("iMFdk");

var $lMQkR = parcelRequire("lMQkR");

var $9MwFx = parcelRequire("9MwFx");

var $4qnr5 = parcelRequire("4qnr5");
const $42b104f4bc1b1927$export$3f6ec3224d4c9da = (0, $6xToB.createEntry)((0, $3ACK3.projectsDirectoryManageRootRedirectRoute), ()=>({
        component: (0, $lMQkR.ProjectsDirectoryManageRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9MwFx.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/projectsDirectoryManageRootRedirectRouteEntry.tsx',
                whichExportToUse: 'projectsDirectoryManageRootRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3ACK3", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $58de1c471b2134e5$export$4531e3b2e25fad23);
const $58de1c471b2134e5$export$4531e3b2e25fad23 = {
    name: 'projects-directory-manage-root-redirect',
    path: '/jira/settings/projects',
    exact: true
};

});


parcelRegister("7ucgW", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRedirectRouteEntry", () => $3444112c75a66fa5$export$8d9d65bb59f2354e);

var $kHlOR = parcelRequire("kHlOR");

var $1RKJf = parcelRequire("1RKJf");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i9ujx = parcelRequire("i9ujx");

var $eLgCf = parcelRequire("eLgCf");

var $iMFdk = parcelRequire("iMFdk");

var $7PT7e = parcelRequire("7PT7e");

var $4qnr5 = parcelRequire("4qnr5");
const $3444112c75a66fa5$export$8d9d65bb59f2354e = (0, $6xToB.createEntry)((0, $eLgCf.projectsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $7PT7e.ProjectsDirectoryRedirect),
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $1RKJf.homepageLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $i9ujx.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4qnr5.LazyProjectsDirectory)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/projectsDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'projectsDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eLgCf", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $d0a6e40b83c0e40c$export$d44f1be3782f0fde);
const $d0a6e40b83c0e40c$export$d44f1be3782f0fde = {
    name: 'projects-directory-redirect',
    path: '/projects',
    exact: true
};

});


parcelRegister("dVWks", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRouteEntry", () => $37b0dee9630da026$export$79292a834772288c);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $lWdYg = parcelRequire("lWdYg");

var $iMFdk = parcelRequire("iMFdk");

var $5TrFe = parcelRequire("5TrFe");
const $37b0dee9630da026$export$79292a834772288c = (0, $6xToB.createEntry)((0, $lWdYg.projectsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint () {
            return 0, $5TrFe.ProjectsDirectoryPageEntryPoint;
        },
        skeleton: (0, $iMFdk.ProjectsDirectorySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        ufoName: 'projects-directory-v3',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/projectsDirectoryRouteEntry.tsx',
                whichExportToUse: 'projectsDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("0MUFU", function(module, exports) {
$parcel$export(module.exports, "projectServiceDeskRouteEntry", () => $546ed11cb9687fd6$export$8810bfd4f6a0eb22);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $hoV2u = parcelRequire("hoV2u");

var $lzHTu = parcelRequire("lzHTu");

var $aQoXd = parcelRequire("aQoXd");
const $546ed11cb9687fd6$export$8810bfd4f6a0eb22 = (0, $6xToB.createEntry)((0, $lzHTu.projectServiceDeskRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-default-entries/src/projectServiceDeskRouteEntry.tsx',
                whichExportToUse: 'projectServiceDeskRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("1yqW3", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationCRouteEntry", () => $7f0e71e2d2ce1f95$export$8a6c5a399335fa16);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $HfFpQ = parcelRequire("HfFpQ");

var $8FCAy = parcelRequire("8FCAy");

var $ciVnR = parcelRequire("ciVnR");
const $7f0e71e2d2ce1f95$export$8a6c5a399335fa16 = (0, $6xToB.createEntry)((0, $HfFpQ.projectSettingsAutomationCRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings-automation-c',
        component: (0, $ciVnR.default),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ciVnR.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsAutomationCRouteEntry.tsx',
                whichExportToUse: 'projectSettingsAutomationCRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("HfFpQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationCRoute", () => $7fb662775c603c76$export$5337cc16f271a9cf);
const $7fb662775c603c76$export$5337cc16f271a9cf = {
    name: 'project-settings-automation',
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};

});

parcelRegister("ciVnR", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $c1355228edbf920b$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $c1355228edbf920b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c1355228edbf920b$export$dea5ad7e8eac12ae = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1jWG1")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $c1355228edbf920b$var$AsyncProjectSettingsJiraAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c1355228edbf920b$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });
var $c1355228edbf920b$export$2e2bcd8739ae039 = $c1355228edbf920b$var$AsyncProjectSettingsJiraAutomation;

});
parcelRegister("1jWG1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cFtS7").then(()=>parcelRequire('jsBpx'));

});



parcelRegister("9rb1x", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationRouteEntry", () => $1e42863e0b2b2bc6$export$a34f85c5b69f2c2f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $dcMoL = parcelRequire("dcMoL");

var $8FCAy = parcelRequire("8FCAy");

var $ciVnR = parcelRequire("ciVnR");

var $5JAAk = parcelRequire("5JAAk");
const $1e42863e0b2b2bc6$export$a34f85c5b69f2c2f = (0, $6xToB.createEntry)((0, $dcMoL.projectSettingsAutomationRoute), ()=>({
        group: 'project-settings-software',
        ufoName: `project-settings-automation-${0, $5JAAk.SOFTWARE_PRODUCT}`,
        component: (0, $ciVnR.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ciVnR.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsAutomationRouteEntry.tsx',
                whichExportToUse: 'projectSettingsAutomationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dcMoL", function(module, exports) {
$parcel$export(module.exports, "projectSettingsAutomationRoute", () => $9fcd294085d4933a$export$7809aa084868deea);
const $9fcd294085d4933a$export$7809aa084868deea = {
    name: 'project-settings-automation',
    path: '/jira/software/projects/:projectKey/settings/automate'
};

});


parcelRegister("af0ih", function(module, exports) {
$parcel$export(module.exports, "projectSettingsComponentsRouteEntry", () => $65fba3aa952511d5$export$72497f4e39dd0df4);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $oZbM4 = parcelRequire("oZbM4");

var $8tbnc = parcelRequire("8tbnc");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $6zEUu = parcelRequire("6zEUu");

var $5Fd8r = parcelRequire("5Fd8r");
const $65fba3aa952511d5$export$72497f4e39dd0df4 = (0, $6xToB.createEntry)((0, $oZbM4.projectSettingsComponentsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $aZ5HL.projectsComponentsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-project-isglobalcomponent-route-resource'), (0, $6zEUu.projectGlobalComponentsResource))
        ],
        component: (0, $5Fd8r.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5Fd8r.LazyProjectComponentsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-components-entries/src/projectSettingsComponentsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsComponentsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("oZbM4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $92c696193aff339d$export$79cbce13eeecd53);
const $92c696193aff339d$export$79cbce13eeecd53 = {
    name: 'project-settings-components',
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("5Fd8r", function(module, exports) {
$parcel$export(module.exports, "LazyProjectComponentsSettings", () => $c5460e096c4a9cb1$export$bb69d8c36391123);
$parcel$export(module.exports, "default", () => $c5460e096c4a9cb1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $4GPxY = parcelRequire("4GPxY");

const $c5460e096c4a9cb1$export$bb69d8c36391123 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cg243"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $c5460e096c4a9cb1$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $3Q6BV.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GPxY.RedirectToProjectType), {
        page: page
    });
};
const $c5460e096c4a9cb1$var$AsyncProjectComponentsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c5460e096c4a9cb1$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });
var $c5460e096c4a9cb1$export$2e2bcd8739ae039 = $c5460e096c4a9cb1$var$AsyncProjectComponentsSettings;

});
parcelRegister("4GPxY", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $8a76893e6d91688d$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $8a76893e6d91688d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $kRgKj.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $3lhVL.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $FhXEJ.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $FhXEJ.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("8Qqsd", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRouteEntry", () => $1197956214252f9a$export$36e1851c22975fc0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $6dcZw = parcelRequire("6dcZw");

var $2mHfh = parcelRequire("2mHfh");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $chHKe = parcelRequire("chHKe");
const $1197956214252f9a$export$36e1851c22975fc0 = (0, $6xToB.createEntry)((0, $6dcZw.projectSettingsCoreAccessRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                push: false
            }),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $chHKe.LazyPeopleSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreAccessRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreAccessRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6dcZw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $f6ee19dcce80b27f$export$59e3323ba0cc224a);
const $f6ee19dcce80b27f$export$59e3323ba0cc224a = {
    name: 'project-settings-core-access-redirect',
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("5bzOU", function(module, exports) {
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $49c2cb555626b18a$export$808691f5a412afa3);

var $hHbzj = parcelRequire("hHbzj");

var $cY5nO = parcelRequire("cY5nO");

var $1gbqq = parcelRequire("1gbqq");

var $5zQIb = parcelRequire("5zQIb");

var $dZRaT = parcelRequire("dZRaT");
const $49c2cb555626b18a$export$808691f5a412afa3 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $1gbqq.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource),
        (0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});

parcelRegister("chHKe", function(module, exports) {
$parcel$export(module.exports, "LazyPeopleSettings", () => $b5057500dcb8d4e3$export$7eee4f97b7a1273);

var $2dJFW = parcelRequire("2dJFW");

var $bQWwW = parcelRequire("bQWwW");

const $b5057500dcb8d4e3$export$7eee4f97b7a1273 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4R95R"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});

});
parcelRegister("4R95R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("K5X5J").then(()=>parcelRequire('aJyzh'));

});



parcelRegister("d1As4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRouteEntry", () => $4d3b88c54f79a5f2$export$8188648c76953df0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $3VgOR = parcelRequire("3VgOR");

var $bmwpE = parcelRequire("bmwpE");

var $1F9cm = parcelRequire("1F9cm");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $chHKe = parcelRequire("chHKe");
const $4d3b88c54f79a5f2$var$Access = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: (0, $chHKe.LazyPeopleSettings),
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
const $4d3b88c54f79a5f2$export$8188648c76953df0 = (0, $6xToB.createEntry)((0, $3VgOR.projectSettingsCoreAccessRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $4d3b88c54f79a5f2$var$Access,
        skeleton: (0, $bmwpE.ProjectSettingsAccessSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $chHKe.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreAccessRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3VgOR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $8a1da25dea9aa581$export$fe93051d5b7385a1);
const $8a1da25dea9aa581$export$fe93051d5b7385a1 = {
    name: 'project-settings-core-access',
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("9tjWC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreApprovalsRouteEntry", () => $3ea5dad70b7fed83$export$728033a86ab68014);

var $cEBDW = parcelRequire("cEBDW");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $3iQHO = parcelRequire("3iQHO");

var $kq7bW = parcelRequire("kq7bW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");
const $3ea5dad70b7fed83$var$approvalsProjectSettingsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $kq7bW.approvalsProjectSettingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $3ea5dad70b7fed83$export$728033a86ab68014 = (0, $6xToB.createEntry)((0, $3iQHO.projectSettingsCoreApprovalsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint () {
            return $3ea5dad70b7fed83$var$approvalsProjectSettingsPageEntryPoint;
        },
        ufoName: 'project-settings-approvals-core',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreApprovalsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreApprovalsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3iQHO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $570c758affb99c6d$export$ba11c8f378a2c121);
const $570c758affb99c6d$export$ba11c8f378a2c121 = {
    name: 'project-settings-core-approvals',
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};

});

parcelRegister("kq7bW", function(module, exports) {
$parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", () => $32be2780ad78a91d$export$1389a6ddf34f642e);

var $j7VfD = parcelRequire("j7VfD");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $32be2780ad78a91d$export$1389a6ddf34f642e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("e2nTL")), {
        moduleId: "83e2f2c2",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsSettingsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $j7VfD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("j7VfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fd2455a8cb64ed8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d871f3ede49d545d142f76fc4cdb7b72>>
 * @relayHash c1a8c3336b76570b82a8688f17264c3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f
const $1fd2455a8cb64ed8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1fd2455a8cb64ed8$export$2e2bcd8739ae039 = $1fd2455a8cb64ed8$var$node;

});

parcelRegister("e2nTL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("28vxS").then(()=>parcelRequire('55Rtn'));

});



parcelRegister("kwERN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRouteEntry", () => $e4251cc71e392b1f$export$7870a0b1630a504e);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $6ZxXy = parcelRequire("6ZxXy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $e4251cc71e392b1f$var$LazyConnectAppControlsSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lETKK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $e4251cc71e392b1f$var$ConnectAppControlsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e4251cc71e392b1f$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
const $e4251cc71e392b1f$export$7870a0b1630a504e = (0, $6xToB.createEntry)((0, $6ZxXy.projectSettingsCoreAppsFieldsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $e4251cc71e392b1f$var$ConnectAppControlsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $e4251cc71e392b1f$var$LazyConnectAppControlsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreAppsFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreAppsFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6ZxXy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $080dc427416057ad$export$1c7e75ffaa491922);
const $080dc427416057ad$export$1c7e75ffaa491922 = {
    name: 'project-settings-core-apps-fields',
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("lETKK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5p6PW").then(()=>parcelRequire('cyXr6'));

});


parcelRegister("773VE", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsRouteEntry", () => $e6120f533ef1b107$export$c038a2892f34f1a9);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8IBsx = parcelRequire("8IBsx");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $e6120f533ef1b107$var$LazyConnectAppsSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7LGN1"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $e6120f533ef1b107$var$ConnectAppsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e6120f533ef1b107$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
const $e6120f533ef1b107$export$c038a2892f34f1a9 = (0, $6xToB.createEntry)((0, $8IBsx.projectSettingsCoreAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $e6120f533ef1b107$var$ConnectAppsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $e6120f533ef1b107$var$LazyConnectAppsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8IBsx", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $cf077f098f8ddb1b$export$c7ac65fb0bbe767f);
const $cf077f098f8ddb1b$export$c7ac65fb0bbe767f = {
    name: 'project-settings-core-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("7LGN1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g8xuM").then(()=>parcelRequire('esCFD'));

});


parcelRegister("jiUh1", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationRouteEntry", () => $b1ff9d60d978fc78$export$a244870e56f5c9a3);

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8zN8Z = parcelRequire("8zN8Z");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $6rTIE = parcelRequire("6rTIE");
const $b1ff9d60d978fc78$export$a244870e56f5c9a3 = (0, $6xToB.createEntry)((0, $8zN8Z.projectSettingsCoreAutomationRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $6rTIE.AutomationLazyPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6rTIE.LazyProjectSettingsJiraAutomation)
        ],
        ufoName: 'project-settings-automation-core',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreAutomationRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreAutomationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8zN8Z", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $02f56a97b5d9c31c$export$65a4d727336c49f4);
const $02f56a97b5d9c31c$export$65a4d727336c49f4 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automation'
};

});

parcelRegister("6rTIE", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $be9afed948b0d963$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "AutomationLazyPage", () => $be9afed948b0d963$export$88eebe21cecb82db);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $be9afed948b0d963$export$dea5ad7e8eac12ae = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1jWG1")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $be9afed948b0d963$export$88eebe21cecb82db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $be9afed948b0d963$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("8Iv3H", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationV2RouteEntry", () => $20b78d4ec4d465f1$export$a2c8a6767edeeaed);

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $au58C = parcelRequire("au58C");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $6rTIE = parcelRequire("6rTIE");
const $20b78d4ec4d465f1$export$a2c8a6767edeeaed = (0, $6xToB.createEntry)((0, $au58C.projectSettingsCoreAutomationV2Route), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $6rTIE.AutomationLazyPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6rTIE.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreAutomationV2RouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreAutomationV2RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("au58C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $29de6e53cc1523c7$export$5437af2650f645e0);
const $29de6e53cc1523c7$export$5437af2650f645e0 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automate'
};

});


parcelRegister("f83an", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRouteEntry", () => $896c6ec82d349197$export$cf5194c476e8bcdb);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $eAb6T = parcelRequire("eAb6T");

var $bmwpE = parcelRequire("bmwpE");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $896c6ec82d349197$var$LazyDataClassificationsSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8kyMO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $896c6ec82d349197$var$DataClassifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $896c6ec82d349197$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
const $896c6ec82d349197$export$cf5194c476e8bcdb = (0, $6xToB.createEntry)((0, $eAb6T.projectSettingsCoreDataClassificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $896c6ec82d349197$var$DataClassifications,
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreDataClassificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreDataClassificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eAb6T", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $91083ef075cfb4b6$export$7aae1006c82a79c0);
const $91083ef075cfb4b6$export$7aae1006c82a79c0 = {
    name: 'project-settings-core-data-classifications',
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};

});


parcelRegister("cWPJr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRouteEntry", () => $4e292bcc9172851a$export$df1c02c3f28b7a95);

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $enZCh = parcelRequire("enZCh");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

var $iOK3U = parcelRequire("iOK3U");
const $4e292bcc9172851a$export$df1c02c3f28b7a95 = (0, $6xToB.createEntry)((0, $enZCh.projectSettingsCoreDefaultRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $iOK3U.ProjectSettingsRedirect),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreDefaultRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreDefaultRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("enZCh", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $01ed0bbfcd7d913f$export$322fe16ec991f12);
const $01ed0bbfcd7d913f$export$322fe16ec991f12 = {
    name: 'project-settings-core-redirect',
    path: '/jira/core/projects/:projectKey/settings'
};

});

parcelRegister("iOK3U", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsRedirect", () => $ff898726ca520125$export$72130cf40a3c3778);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $dSkLG = parcelRequire("dSkLG");

var $2mHfh = parcelRequire("2mHfh");
const $ff898726ca520125$export$72130cf40a3c3778 = ({ match: match })=>{
    const { data: data, loading: loading } = (0, $dSkLG.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    // Wait for nav data to be available before deciding where to redirect on cold loads
    if ((loading || !data) && (0, $4cTDP.fg)('vmc-52-settings-redirect-wait-till-data-received')) return null;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4cTDP.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};

});


parcelRegister("4BOoE", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDetailsRouteEntry", () => $68317367b53508d0$export$438a330ccc1e7a91);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $9GhPZ = parcelRequire("9GhPZ");

var $bmwpE = parcelRequire("bmwpE");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $68317367b53508d0$var$LazyDetailsSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4esLz"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $68317367b53508d0$var$Details = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $68317367b53508d0$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
const $68317367b53508d0$export$438a330ccc1e7a91 = (0, $6xToB.createEntry)((0, $9GhPZ.projectSettingsCoreDetailsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $68317367b53508d0$var$Details,
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $68317367b53508d0$var$LazyDetailsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreDetailsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9GhPZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $ac2160042ab41ffe$export$14535b40530c8690);
const $ac2160042ab41ffe$export$14535b40530c8690 = {
    name: 'project-settings-core-details',
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("h7Red", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreFieldsRouteEntry", () => $c607ef6e47cdb175$export$8d8dff75124dcebc);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $uKS5x = parcelRequire("uKS5x");

var $5kWLm = parcelRequire("5kWLm");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $c607ef6e47cdb175$var$LazyFieldsSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("e7wXq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $c607ef6e47cdb175$var$FieldsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c607ef6e47cdb175$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
const $c607ef6e47cdb175$export$8d8dff75124dcebc = (0, $6xToB.createEntry)((0, $5kWLm.projectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.jwm-tmp',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            (0, $uKS5x.fieldSettingsRelayResource)
        ],
        component: $c607ef6e47cdb175$var$FieldsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $c607ef6e47cdb175$var$LazyFieldsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("uKS5x", function(module, exports) {
$parcel$export(module.exports, "fieldSettingsRelayResource", () => $f44edc9542947688$export$68b4e700e00bad7a);

var $hndhS = parcelRequire("hndhS");

var $9FYIg = parcelRequire("9FYIg");

var $bBtQo = parcelRequire("bBtQo");
const $f44edc9542947688$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $f44edc9542947688$export$68b4e700e00bad7a = (0, $9FYIg.createRelayResource)({
    type: $f44edc9542947688$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        // Parse deep link parameters
        const fieldId = query.fieldId;
        const isValidSidebarId = [
            'EDIT'
        ].includes(query.sidebarId?.toUpperCase());
        const shouldPreloadField = Boolean(isValidSidebarId && !!fieldId);
        return {
            parameters: (0, $hndhS.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? '',
                preloadedFieldId: fieldId ?? 'UNUSED_STRING',
                shouldPreloadField: shouldPreloadField ?? false
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("hndhS", function(module, exports) {
$parcel$export(module.exports, "default", () => $197bea0b648269f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4713e0af20f8e5d4219359f0b5871b18>>
 * @relayHash 43777db503cf65426a8fc0aaeda390c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9324c0fa71a283227e33f8e09f7b92eaafb8314fe889c8edb69c5d748d2ac5bc

var $8uhLQ = parcelRequire("8uhLQ");

var $bud2F = parcelRequire("bud2F");

var $37Ewn = parcelRequire("37Ewn");
const $197bea0b648269f3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "preloadedFieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldPreloadField"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isExplicitFieldAssociationsEnabled"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "scope"
    }, v13 = {
        "kind": "ScalarField",
        "name": "typeName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "description"
    }, v15 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v16 = {
        "kind": "ScalarField",
        "name": "hasMissingConfiguration"
    }, v17 = {
        "kind": "ScalarField",
        "name": "canRemove"
    }, v18 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v19 = {
        "kind": "ScalarField",
        "name": "canModifyOptions"
    }, v20 = {
        "concreteType": "JiraFieldOptionConnection",
        "kind": "LinkedField",
        "name": "fieldOptions",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraFieldOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "optionId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "parentOptionId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v9 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "fieldFormatConfig",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "formatStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formatUnit"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formatDecimals"
                            }
                        ],
                        "type": "JiraNumberFieldFormatConfig"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FieldsPageContentQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "FieldsTable"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "FieldsPageHeader"
                                },
                                {
                                    "condition": "shouldPreloadField",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "preloadedFieldId",
                                                    "variableName": "preloadedFieldId"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "DeepLinkSidebar"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "FieldsPageContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "optionsPerFieldLimit"
                                },
                                {
                                    "concreteType": "JiraFieldTypeGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "projectFieldTypeGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldTypeGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldTypeGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsPerProjectLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedFieldsCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canDelete"
                                                                        },
                                                                        v18 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ ,
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFieldLocked"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": [
                                                "input"
                                            ],
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                {
                                    "condition": "shouldPreloadField",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectWithIssueTypeIds",
                                            "kind": "LinkedField",
                                            "name": "projectWithVisibleIssueTypeIds",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "preloadedField",
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fieldId",
                                                            "variableName": "preloadedFieldId"
                                                        }
                                                    ],
                                                    "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                    "kind": "LinkedField",
                                                    "name": "fieldAssociationWithIssueTypesByFieldId",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "field",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraFieldOperation",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOperation",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9324c0fa71a283227e33f8e09f7b92eaafb8314fe889c8edb69c5d748d2ac5bc",
            "metadata": {},
            "name": "FieldsPageContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": (0, $8uhLQ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": (0, $bud2F.default)
            }
        }
    };
}();
$197bea0b648269f3$var$node.hash = "87afe89a1e0f48de789ee2102d35f9c1";
(0, $37Ewn.PreloadableQueryRegistry).set($197bea0b648269f3$var$node.params.id, $197bea0b648269f3$var$node);
var $197bea0b648269f3$export$2e2bcd8739ae039 = $197bea0b648269f3$var$node;

});
parcelRegister("8uhLQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9eeae788af0ce2a$export$2e2bcd8739ae039);

var $g5wv4 = parcelRequire("g5wv4");
var $d9eeae788af0ce2a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $g5wv4.isSidebarFormatConfigEnabled)();
    }
};

});
parcelRegister("g5wv4", function(module, exports) {
$parcel$export(module.exports, "formatDecimal", () => $9f3ef12a68cb7fc4$export$845857f28dc08744);
$parcel$export(module.exports, "formatNumberField", () => $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01);
$parcel$export(module.exports, "transformToUI", () => $9f3ef12a68cb7fc4$export$ecbf259380af1f03);
$parcel$export(module.exports, "transformToServer", () => $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4);
$parcel$export(module.exports, "isSidebarFormatConfigEnabled", () => $9f3ef12a68cb7fc4$export$3c854a930069a447);
$parcel$export(module.exports, "formatConfigFromAggJiraNumberFieldFormatConfig", () => $9f3ef12a68cb7fc4$export$29f524126725ba4b);

var $4cTDP = parcelRequire("4cTDP");

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/supported-locales/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9f3ef12a68cb7fc4$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$a82896da99871ba4))).includes(currencyCode);
};
const $9f3ef12a68cb7fc4$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$83551de9ca24925e))).includes(unit);
};
const $9f3ef12a68cb7fc4$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $7b3dcdbff4fbb09a$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $7b3dcdbff4fbb09a$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = unit && $9f3ef12a68cb7fc4$var$isSupportedUnit(unit) ? {
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(config.locale), {
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4:
            return formatUnit ? $9f3ef12a68cb7fc4$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9:
            return $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e:
            return formatUnit ? $9f3ef12a68cb7fc4$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9f3ef12a68cb7fc4$export$845857f28dc08744(number);
    }
};
const $9f3ef12a68cb7fc4$export$ecbf259380af1f03 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>number && formatStyle === (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) && (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? number * 100 : number;
const $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>{
    if (!number || formatStyle !== (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) || !(0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage')) return number;
    // Use Number.EPSILON to avoid floating-point precision issues
    const result = number / 100;
    const factor = Math.pow(10, 8); // 8 decimal places should be sufficient for percentage precision
    return Math.round((result + Number.EPSILON) * factor) / factor;
};
const $9f3ef12a68cb7fc4$export$3c854a930069a447 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('frontier-currency-field-d1') && (0, $4cTDP.fg)('fields-settings-currency-field-display');
const $9f3ef12a68cb7fc4$var$formatStyleMapper = (jiraFormatStyle)=>{
    switch(jiraFormatStyle){
        case 'CURRENCY':
            return 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4;
        case 'PERCENT':
            return 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9;
        case 'UNIT':
            return 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e;
        default:
            return 0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea;
    }
};
const $9f3ef12a68cb7fc4$export$29f524126725ba4b = (gqlFormatConfig)=>{
    const { formatDecimals: formatDecimals, formatStyle: formatStyle, formatUnit: formatUnit } = gqlFormatConfig || {};
    return {
        formatStyle: $9f3ef12a68cb7fc4$var$formatStyleMapper(formatStyle),
        formatUnit: formatUnit || null,
        formatDecimals: formatDecimals ?? null
    };
};

});
const $7b3dcdbff4fbb09a$export$c852e1f5bb177898 = 'USD';
const $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $7b3dcdbff4fbb09a$export$768e3e8e60d01cea = 'DECIMAL';
const $7b3dcdbff4fbb09a$export$a82896da99871ba4 = 'CURRENCY';
const $7b3dcdbff4fbb09a$export$e50c15d5408652a9 = 'PERCENT';
const $7b3dcdbff4fbb09a$export$83551de9ca24925e = 'UNIT';
const $7b3dcdbff4fbb09a$export$e0f41b79f8d902b5 = 'liter';
const $7b3dcdbff4fbb09a$export$83a33c313ebf2c4a = 'meter';
const $7b3dcdbff4fbb09a$export$32fca264df3a7957 = 'kilogram';
const $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2 = 'percent';



parcelRegister("bud2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $589ac61571781861$export$2e2bcd8739ae039);

var $cxKOj = parcelRequire("cxKOj");
var $589ac61571781861$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cxKOj.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && (0, $cxKOj.expVal)('thor_colourful_single_select_fields_experiment', 'isColorfulSingleSelectEnabled', false);
    }
};

});



parcelRegister("5kWLm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreFieldsRoute", () => $4257bf508e06a94e$export$7c4ee74641923239);
const $4257bf508e06a94e$export$7c4ee74641923239 = {
    name: 'project-settings-core-fields',
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("e7wXq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("46n7v").then(()=>parcelRequire('kbmIh'));

});


parcelRegister("7Pdre", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreForgeAppsRouteEntry", () => $b44745a6260a38ee$export$1006fd9f5f02b1c2);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kWuKC = parcelRequire("kWuKC");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $b44745a6260a38ee$var$LazyForgeProjectSettingsPage = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dfvr4")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $b44745a6260a38ee$var$ForgeProjectSettingsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b44745a6260a38ee$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $b44745a6260a38ee$export$1006fd9f5f02b1c2 = (0, $6xToB.createEntry)((0, $kWuKC.projectSettingsCoreForgeAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $b44745a6260a38ee$var$ForgeProjectSettingsPage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $b44745a6260a38ee$var$LazyForgeProjectSettingsPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreForgeAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreForgeAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kWuKC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $b8e85e53e98fa473$export$b34160f55b6104e9);
const $b8e85e53e98fa473$export$b34160f55b6104e9 = {
    name: 'project-settings-core-forge-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("dfvr4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9BbYL").then(()=>parcelRequire('1rEKn'));

});


parcelRegister("20zzw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesRouteEntry", () => $810b238042a3d46b$export$95ecbacf0120fcfd);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $4Briw = parcelRequire("4Briw");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $810b238042a3d46b$var$LazyIssueTypeSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j5ufr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $810b238042a3d46b$var$IssueTypePage = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $810b238042a3d46b$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $810b238042a3d46b$export$95ecbacf0120fcfd = (0, $6xToB.createEntry)((0, $4Briw.projectSettingsCoreIssueTypesRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $810b238042a3d46b$var$IssueTypePage,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $810b238042a3d46b$var$LazyIssueTypeSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreIssueTypesRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreIssueTypesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4Briw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $b52961adde1b4dc4$export$c3a32433c580b9ff);
const $b52961adde1b4dc4$export$c3a32433c580b9ff = {
    name: 'project-settings-core-issuetypes',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});


parcelRegister("h4zAy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRouteEntry", () => $bf2af5f0accc24f0$export$1dfd4811b9065dd6);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $cxQGT = parcelRequire("cxQGT");

var $lb6FK = parcelRequire("lb6FK");

var $4366C = parcelRequire("4366C");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxKOj = parcelRequire("cxKOj");

var $cgXAH = parcelRequire("cgXAH");

var $5bzOU = parcelRequire("5bzOU");

const $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4Bnpx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $bf2af5f0accc24f0$var$WorkflowNavigationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
const $bf2af5f0accc24f0$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $cgXAH.workflowBuilderProvisioningResource)
    ];
const $bf2af5f0accc24f0$export$1dfd4811b9065dd6 = (0, $6xToB.createEntry)((0, $4366C.projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
        group: 'project-settings-core',
        navigation: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $cEBDW.coreProjectLayout),
        resources: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? [
            (0, $dZRaT.projectContextResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $lb6FK.rovoEntitlementResource),
            ...$bf2af5f0accc24f0$var$getWorkflowBuilderProvisioningResources()
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            ...$bf2af5f0accc24f0$var$getWorkflowBuilderProvisioningResources(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $bf2af5f0accc24f0$var$WorkflowNavigationPage,
        forPaint: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_business', 'isEnabled', true, false) ? [
            $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings
        ] : [
            (0, $kHlOR.LazyAtlassianNavigation),
            $bf2af5f0accc24f0$var$LazyWorkflowNavigationSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreIssueTypesWorkflowRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreIssueTypesWorkflowRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4366C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $1b7c0478f6f55054$export$9e79ee307216071b);
const $1b7c0478f6f55054$export$9e79ee307216071b = {
    name: 'project-settings-core-issuetypes-workflow',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("4Bnpx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("2ayvF")
]).then(()=>parcelRequire('79XtQ'));

});


parcelRegister("4WoRT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRouteEntry", () => $131266e2842e625f$export$da36a1671d868927);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $iieLc = parcelRequire("iieLc");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $131266e2842e625f$var$LazyProjectSettingsNotificationEmail = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hGlwH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $131266e2842e625f$var$EmailNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $131266e2842e625f$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
const $131266e2842e625f$export$da36a1671d868927 = (0, $6xToB.createEntry)((0, $iieLc.projectSettingsCoreNotificationsEmailRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $131266e2842e625f$var$EmailNotifications,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $131266e2842e625f$var$LazyProjectSettingsNotificationEmail
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreNotificationsEmailRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreNotificationsEmailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iieLc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $e802fd4cece3fd28$export$b546589f1b048dc);
const $e802fd4cece3fd28$export$b546589f1b048dc = {
    name: 'project-settings-core-notifications-notification-email',
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("hGlwH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2c1pi").then(()=>parcelRequire('coZXG'));

});


parcelRegister("im6xk", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRouteEntry", () => $a93d00cc87045434$export$e562140c482cb0c);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $jsl6f = parcelRequire("jsl6f");

var $9BdgC = parcelRequire("9BdgC");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");
const $a93d00cc87045434$var$emailNotificationsLogEntryPointPage = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9BdgC.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

const $a93d00cc87045434$var$LazyNotificationsIssueLogs = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("748mp"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $a93d00cc87045434$var$NotificationsIssueLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a93d00cc87045434$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
const $a93d00cc87045434$export$e562140c482cb0c = (0, $6xToB.createEntry)((0, $jsl6f.projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $a93d00cc87045434$var$NotificationsIssueLogs,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $a93d00cc87045434$var$LazyNotificationsIssueLogs
        ],
        entryPoint () {
            return $a93d00cc87045434$var$emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreNotificationsIssueLogsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreNotificationsIssueLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jsl6f", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", () => $4ead34731e522065$export$56a8a0b88329b044);
const $4ead34731e522065$export$56a8a0b88329b044 = {
    name: 'project-settings-core-notifications-issue-logs',
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("6P2Hr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsRouteEntry", () => $ecceeabad646c15f$export$ed481b03aa858542);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $heO95 = parcelRequire("heO95");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $ecceeabad646c15f$var$LazyNotificationsSettings = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lCl0m"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $ecceeabad646c15f$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ecceeabad646c15f$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
const $ecceeabad646c15f$export$ed481b03aa858542 = (0, $6xToB.createEntry)((0, $heO95.projectSettingsCoreNotificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $ecceeabad646c15f$var$Notifications,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $ecceeabad646c15f$var$LazyNotificationsSettings
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreNotificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("heO95", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $e152b432fb8df62a$export$a1ee80066685b98d);
const $e152b432fb8df62a$export$a1ee80066685b98d = {
    name: 'project-settings-core-notifications',
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("lCl0m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("alVwE").then(()=>parcelRequire('6HtX7'));

});


parcelRegister("lJuD5", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRouteEntry", () => $c245f3f88d60b7f9$export$46d6b55ebf21ccc);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $dINx0 = parcelRequire("dINx0");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $c245f3f88d60b7f9$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("87BMN")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $c245f3f88d60b7f9$var$ProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c245f3f88d60b7f9$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
const $c245f3f88d60b7f9$export$46d6b55ebf21ccc = (0, $6xToB.createEntry)((0, $dINx0.projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c245f3f88d60b7f9$var$ProformaJiraFormBuilder,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $c245f3f88d60b7f9$var$LazyProjectSettingsProformaJiraFormBuilder
        ],
        perfMetricKey: 'form-builder',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreProformaJiraFormBuilderRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreProformaJiraFormBuilderRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dINx0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $e1e3eeeaacb0fb7d$export$4e7ce7e6ced0f291);
const $e1e3eeeaacb0fb7d$export$4e7ce7e6ced0f291 = {
    name: 'project-settings-core-proforma-jira-form-builder',
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("kjUZx", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRouteEntry", () => $35d3e30ea0ace1d6$export$5e9e27f116094fdf);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $cEBDW = parcelRequire("cEBDW");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $hiOwQ = parcelRequire("hiOwQ");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $arxGf = parcelRequire("arxGf");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $8tbnc = parcelRequire("8tbnc");

var $5bzOU = parcelRequire("5bzOU");

const $35d3e30ea0ace1d6$var$LazyProjectSettingsProformaProjectForms = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hZVDr")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $35d3e30ea0ace1d6$var$ProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $35d3e30ea0ace1d6$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
const $35d3e30ea0ace1d6$export$5e9e27f116094fdf = (0, $6xToB.createEntry)((0, $arxGf.projectSettingsCoreProformaProjectFormsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $hiOwQ.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $cEBDW.coreProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5bzOU.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $35d3e30ea0ace1d6$var$ProformaProjectForms,
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $35d3e30ea0ace1d6$var$LazyProjectSettingsProformaProjectForms
        ],
        perfMetricKey: 'forms-settings',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-core-entries/src/projectSettingsCoreProformaProjectFormsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCoreProformaProjectFormsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("arxGf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $50305d44c5434a67$export$57fe8c5107a9c0de);
const $50305d44c5434a67$export$57fe8c5107a9c0de = {
    name: 'project-settings-core-proforma-project-forms',
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("4yidD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRouteEntry", () => $b474ea2d12e536db$export$e17f02db5d9c0485);

var $TgOcC = parcelRequire("TgOcC");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $g9kBK = parcelRequire("g9kBK");

var $9BJU1 = parcelRequire("9BJU1");

var $aQoXd = parcelRequire("aQoXd");

var $5nMhu = parcelRequire("5nMhu");
const $b474ea2d12e536db$export$e17f02db5d9c0485 = (0, $6xToB.createEntry)((0, $TgOcC.projectSettingsCustomerServiceFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.features',
        component: (0, $9BJU1.default),
        entryPoint () {
            return 0, $5nMhu.projectSettingFeaturesAppPageEntryPoint;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jcs-project-settings.features',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-customer-service-entries/src/projectSettingsCustomerServiceFeaturesRouteEntry.tsx',
                whichExportToUse: 'projectSettingsCustomerServiceFeaturesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("TgOcC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRoute", () => $350a52cebf8a6f8e$export$5498201d2eacd40d);
const $350a52cebf8a6f8e$export$5498201d2eacd40d = {
    name: 'project-settings-customer-service-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("5nMhu", function(module, exports) {
$parcel$export(module.exports, "projectSettingFeaturesAppPageEntryPoint", () => $60c5517c00398ff5$export$f5b640657f5a50a3);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9jhUW = parcelRequire("9jhUW");
const $60c5517c00398ff5$export$f5b640657f5a50a3 = (0, $g8uYY.createPageEntryPoint)({
    main: $9jhUW.projectSettingFeaturesAppEntryPoint,
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("9jhUW", function(module, exports) {
$parcel$export(module.exports, "projectSettingFeaturesAppEntryPoint", () => $5964a44b58d9149c$export$83a2217e7eee641e);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $5964a44b58d9149c$export$83a2217e7eee641e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("9ID1E")), {
        moduleId: "92e8308d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9ID1E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("56D7D").then(()=>parcelRequire('7dsYV'));

});




parcelRegister("ikmMT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRouteEntry", () => $bc8577501ac8c70a$export$872a0285d27dfa47);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $bCenk = parcelRequire("bCenk");

var $8FCAy = parcelRequire("8FCAy");

var $15K4j = parcelRequire("15K4j");

var $5JAAk = parcelRequire("5JAAk");
const $bc8577501ac8c70a$export$872a0285d27dfa47 = (0, $6xToB.createEntry)((0, $bCenk.projectSettingsForgeAppsNextgenRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $15K4j.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            ...(0, $15K4j.forgeProjectSettingsPageResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $15K4j.LazyForgeProjectSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsForgeAppsNextgenRouteEntry.tsx',
                whichExportToUse: 'projectSettingsForgeAppsNextgenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bCenk", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", () => $8e8aff77a4966b35$export$8559c4a0b692890e);
const $8e8aff77a4966b35$export$8559c4a0b692890e = {
    name: 'project-settings-software-apps-forge',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("15K4j", function(module, exports) {
$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $d48a6a4b849ef481$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "forgeProjectSettingsPageResources", () => $d48a6a4b849ef481$export$33d85a1b2211b38);
$parcel$export(module.exports, "default", () => $d48a6a4b849ef481$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hHbzj = parcelRequire("hHbzj");

var $dZRaT = parcelRequire("dZRaT");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d48a6a4b849ef481$export$ef66d3f49a9953d8 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dfvr4")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d48a6a4b849ef481$export$33d85a1b2211b38 = ()=>[
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource)
    ];
const $d48a6a4b849ef481$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d48a6a4b849ef481$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d48a6a4b849ef481$export$2e2bcd8739ae039 = $d48a6a4b849ef481$export$b943f48844c671a5;

});


parcelRegister("cw1uU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsRouteEntry", () => $ff4e1798a1d685a7$export$54d0d8466c8b40dc);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $fefiR = parcelRequire("fefiR");

var $8FCAy = parcelRequire("8FCAy");

var $15K4j = parcelRequire("15K4j");
const $ff4e1798a1d685a7$export$54d0d8466c8b40dc = (0, $6xToB.createEntry)((0, $fefiR.projectSettingsForgeAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $15K4j.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $15K4j.forgeProjectSettingsPageResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $15K4j.LazyForgeProjectSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsForgeAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsForgeAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fefiR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsForgeAppsRoute", () => $9468da00db699228$export$f74a0b1be9d5b9f6);
const $9468da00db699228$export$f74a0b1be9d5b9f6 = {
    name: 'project-settings-software-forge-apps',
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});


parcelRegister("3wFf4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsOpsgenieRouteEntry", () => $5017ba35f8e063f9$export$4b4bfb4318f5a98e);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9BJU1 = parcelRequire("9BJU1");

var $5ZDgv = parcelRequire("5ZDgv");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $jLc1n = parcelRequire("jLc1n");

var $5JAAk = parcelRequire("5JAAk");
const $5017ba35f8e063f9$export$4b4bfb4318f5a98e = (0, $6xToB.createEntry)((0, $5ZDgv.projectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $jLc1n.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jLc1n.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsOpsgenieRouteEntry.tsx',
                whichExportToUse: 'projectSettingsOpsgenieRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5ZDgv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsOpsgenieRoute", () => $88f4bb44415aa69f$export$c7039de5a4b78802);
const $88f4bb44415aa69f$export$c7039de5a4b78802 = {
    name: 'project-settings-software-link-opsgenie',
    path: '/jira/software/projects/:projectKey/settings/opsgenie',
    exact: true
};

});


parcelRegister("85Rgm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRouteEntry", () => $6893ced1fdd631e0$export$7a0e75d9ac8038aa);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gVukG = parcelRequire("gVukG");

var $aQoXd = parcelRequire("aQoXd");

var $7gEmY = parcelRequire("7gEmY");

var $gwoLH = parcelRequire("gwoLH");
const $6893ced1fdd631e0$export$7a0e75d9ac8038aa = (0, $6xToB.createEntry)((0, $gVukG.projectSettingsServicedeskAccessRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        isRedirect: true,
        component: (0, $7gEmY.peopleAccessRedirect)(`/jira/${(0, $gwoLH.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7gEmY.LazyPeopleSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskAccessRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAccessRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gVukG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRoute", () => $03a6b692b59c57cf$export$115667ee60b1ec74);
const $03a6b692b59c57cf$export$115667ee60b1ec74 = {
    name: 'project-settings-servicedesk-access-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("7gEmY", function(module, exports) {
$parcel$export(module.exports, "LazyPeopleSettings", () => $f8bfa63a1f44827c$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $f8bfa63a1f44827c$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $f8bfa63a1f44827c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");

const $f8bfa63a1f44827c$export$7eee4f97b7a1273 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4R95R"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $f8bfa63a1f44827c$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $f8bfa63a1f44827c$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8bfa63a1f44827c$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
const $f8bfa63a1f44827c$var$AsyncPeopleSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f8bfa63a1f44827c$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
var $f8bfa63a1f44827c$export$2e2bcd8739ae039 = $f8bfa63a1f44827c$var$AsyncPeopleSettings;

});

parcelRegister("gwoLH", function(module, exports) {
$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $e0380d4ed2642b4f$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $e0380d4ed2642b4f$export$c9b0516439c55d7a);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");

var $4cTDP = parcelRequire("4cTDP");

var $dSkLG = parcelRequire("dSkLG");
const $e0380d4ed2642b4f$export$5575497f0592ee94 = 'servicedesk';
const $e0380d4ed2642b4f$export$c9b0516439c55d7a = (product)=>({ match: match })=>{
        const { data: data, loading: loading } = (0, $dSkLG.useJiraServiceManagementProjectNavigation)();
        if (!(0, $4cTDP.fg)('vmc-11-manage-versions-permission')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
        // Wait for nav data to be available before deciding where to redirect on cold loads
        if ((loading || !data) && (0, $4cTDP.fg)('vmc-52-settings-redirect-wait-till-data-received')) return null;
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/plugins/servlet/project-config/${String(match.params.projectKey)}/administer-versions`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
    };

});


parcelRegister("2Uft0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRouteEntry", () => $525f705f51b6b77c$export$f7b56f6d0437146d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9CHTy = parcelRequire("9CHTy");

var $aQoXd = parcelRequire("aQoXd");

var $bmwpE = parcelRequire("bmwpE");

var $7gEmY = parcelRequire("7gEmY");
const $525f705f51b6b77c$export$f7b56f6d0437146d = (0, $6xToB.createEntry)((0, $9CHTy.projectSettingsServicedeskAccessRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $bmwpE.ProjectSettingsAccessSkeleton),
        component: (0, $7gEmY.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7gEmY.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskAccessRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAccessRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("jCXKu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRouteEntry", () => $429da193784bf774$export$12f064da36fbd279);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9zBC5 = parcelRequire("9zBC5");

var $aQoXd = parcelRequire("aQoXd");

var $bfOBR = parcelRequire("bfOBR");
const $429da193784bf774$export$12f064da36fbd279 = (0, $6xToB.createEntry)((0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bfOBR.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bfOBR.LazyConnectAppControlsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskAppsFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAppsFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bfOBR", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $08e4143173993014$export$246ec9cdadd2a163);
$parcel$export(module.exports, "ConnectAppsRedirect", () => $08e4143173993014$export$cc3414a2d9daf70d);
$parcel$export(module.exports, "default", () => $08e4143173993014$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $2aY2d = parcelRequire("2aY2d");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");

var $02Yn6 = parcelRequire("02Yn6");

const $08e4143173993014$export$246ec9cdadd2a163 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lETKK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $08e4143173993014$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $02Yn6.default), null);
};
const $08e4143173993014$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08e4143173993014$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
const $08e4143173993014$var$AsyncConnectAppControlsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $08e4143173993014$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
var $08e4143173993014$export$2e2bcd8739ae039 = $08e4143173993014$var$AsyncConnectAppControlsSettings;

});
parcelRegister("02Yn6", function(module, exports) {
$parcel$export(module.exports, "LazyAppDiscoverySettings", () => $dba3d5bd8ba089d9$export$fa3bc297af95f169);
$parcel$export(module.exports, "default", () => $dba3d5bd8ba089d9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $dba3d5bd8ba089d9$export$fa3bc297af95f169 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3aJhc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
const $dba3d5bd8ba089d9$var$AsyncAppDiscoverySettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $dba3d5bd8ba089d9$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });
var $dba3d5bd8ba089d9$export$2e2bcd8739ae039 = $dba3d5bd8ba089d9$var$AsyncAppDiscoverySettings;

});
parcelRegister("3aJhc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bnUV1").then(()=>parcelRequire('ceVmw'));

});




parcelRegister("k25kz", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsRouteEntry", () => $1f88f7ee16a6ec1f$export$d637c59982b0d896);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ihiVw = parcelRequire("ihiVw");

var $aQoXd = parcelRequire("aQoXd");

var $fnaXD = parcelRequire("fnaXD");
const $1f88f7ee16a6ec1f$export$d637c59982b0d896 = (0, $6xToB.createEntry)((0, $ihiVw.projectSettingsServicedeskAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $fnaXD.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fnaXD.LazyConnectAppsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ihiVw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsRoute", () => $2ae3cd8e363a0b78$export$ccc91c475c403d1a);
const $2ae3cd8e363a0b78$export$ccc91c475c403d1a = {
    name: 'project-settings-servicedesk-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("fnaXD", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppsSettings", () => $fd2dde59f6c54c3a$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $fd2dde59f6c54c3a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fd2dde59f6c54c3a$export$3633e017e520a1c2 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7LGN1"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $fd2dde59f6c54c3a$var$AsyncConnectAppsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fd2dde59f6c54c3a$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
var $fd2dde59f6c54c3a$export$2e2bcd8739ae039 = $fd2dde59f6c54c3a$var$AsyncConnectAppsSettings;

});


parcelRegister("ebqmN", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRouteEntry", () => $c4a82b72c69cbc80$export$1cfe280529d4ebf8);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $5JCiM = parcelRequire("5JCiM");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dbpJT = parcelRequire("dbpJT");
const $c4a82b72c69cbc80$export$1cfe280529d4ebf8 = (0, $6xToB.createEntry)((0, $5JCiM.projectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $dbpJT.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dbpJT.LazyProjectSettingsServiceDeskAutomationCopyRule)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskAutomationCopyRuleRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAutomationCopyRuleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5JCiM", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRoute", () => $dd3c3fb8e7544234$export$9aa8ef0c982cee2f);
const $dd3c3fb8e7544234$export$9aa8ef0c982cee2f = {
    name: 'project-settings-servicedesk-automation-copy-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("dbpJT", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", () => $ad45305132184954$export$4a3b5f6370555dbc);
$parcel$export(module.exports, "default", () => $ad45305132184954$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ad45305132184954$export$4a3b5f6370555dbc = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gM6nr")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
const $ad45305132184954$var$AsyncProjectSettingsServiceDeskAutomationCopyRule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ad45305132184954$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });
var $ad45305132184954$export$2e2bcd8739ae039 = $ad45305132184954$var$AsyncProjectSettingsServiceDeskAutomationCopyRule;

});
parcelRegister("gM6nr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dxGZN").then(()=>parcelRequire('iOY2m'));

});



parcelRegister("43NlL", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRouteEntry", () => $59b039746438f768$export$f1e32463088d9246);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $6zM03 = parcelRequire("6zM03");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $j1lyW = parcelRequire("j1lyW");
const $59b039746438f768$export$f1e32463088d9246 = (0, $6xToB.createEntry)((0, $6zM03.projectSettingsServicedeskAutomationCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.create-rule',
        component: (0, $j1lyW.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $j1lyW.LazyProjectSettingsServiceDeskAutomationCreateRule)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskAutomationCreateRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAutomationCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6zM03", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRoute", () => $d8bb8f7591b1fd9d$export$6f20ce2991881c20);
const $d8bb8f7591b1fd9d$export$6f20ce2991881c20 = {
    name: 'project-settings-servicedesk-automation-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("j1lyW", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", () => $813af77cadfe206d$export$5b197b51eb5ad982);
$parcel$export(module.exports, "default", () => $813af77cadfe206d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $813af77cadfe206d$export$5b197b51eb5ad982 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dsldH")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
const $813af77cadfe206d$var$AsyncProjectSettingsServiceDeskAutomationCreateRule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $813af77cadfe206d$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });
var $813af77cadfe206d$export$2e2bcd8739ae039 = $813af77cadfe206d$var$AsyncProjectSettingsServiceDeskAutomationCreateRule;

});
parcelRegister("dsldH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2UCLo").then(()=>parcelRequire('b8Vr3'));

});



parcelRegister("2LDVV", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRouteEntry", () => $6061b8febeecda20$export$568d8653c06c756e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $ck6WR = parcelRequire("ck6WR");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4cIMR = parcelRequire("4cIMR");
const $6061b8febeecda20$export$568d8653c06c756e = (0, $6xToB.createEntry)((0, $ck6WR.projectSettingsServicedeskAutomationEditRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $4cIMR.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4cIMR.LazyProjectSettingsServiceDeskAutomationEditRule)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskAutomationEditRuleRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAutomationEditRuleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ck6WR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRoute", () => $99bda15133495d58$export$9f1e5391e2d6f95);
const $99bda15133495d58$export$9f1e5391e2d6f95 = {
    name: 'project-settings-servicedesk-automation-edit-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});

parcelRegister("4cIMR", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", () => $8c64f30a5435a9db$export$c1c9a68738a9ab36);
$parcel$export(module.exports, "default", () => $8c64f30a5435a9db$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8c64f30a5435a9db$export$c1c9a68738a9ab36 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7s7sQ")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
const $8c64f30a5435a9db$var$AsyncProjectSettingsServiceDeskAutomationEditRule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8c64f30a5435a9db$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });
var $8c64f30a5435a9db$export$2e2bcd8739ae039 = $8c64f30a5435a9db$var$AsyncProjectSettingsServiceDeskAutomationEditRule;

});
parcelRegister("7s7sQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eA4Ts").then(()=>parcelRequire('fYqHn'));

});



parcelRegister("9RMhv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRouteEntry", () => $1e3ee2b56177675c$export$7a0b8ca27efc7201);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7xaze = parcelRequire("7xaze");

var $aQoXd = parcelRequire("aQoXd");

var $6eahc = parcelRequire("6eahc");

var $gwoLH = parcelRequire("gwoLH");
const $1e3ee2b56177675c$export$7a0b8ca27efc7201 = (0, $6xToB.createEntry)((0, $7xaze.projectSettingsServicedeskAutomationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: `project-settings-automation-${0, $gwoLH.SERVICE_DESK_PRODUCT}`,
        component: (0, $6eahc.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6eahc.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskAutomationRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAutomationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6eahc", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $3c1cceef4ab884be$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $3c1cceef4ab884be$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3c1cceef4ab884be$export$dea5ad7e8eac12ae = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1jWG1")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $3c1cceef4ab884be$var$AsyncProjectSettingsJiraAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3c1cceef4ab884be$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });
var $3c1cceef4ab884be$export$2e2bcd8739ae039 = $3c1cceef4ab884be$var$AsyncProjectSettingsJiraAutomation;

});


parcelRegister("h3kpF", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRouteEntry", () => $7885896878c7a4da$export$4d6e0242b09fef3b);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $flolB = parcelRequire("flolB");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $71ddd = parcelRequire("71ddd");
const $7885896878c7a4da$export$4d6e0242b09fef3b = (0, $6xToB.createEntry)((0, $flolB.projectSettingsServicedeskAutomationSummaryRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.summary',
        component: (0, $71ddd.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $71ddd.LazyProjectSettingsServiceDeskAutomationSummary)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskAutomationSummaryRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAutomationSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("71ddd", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", () => $047ecae84b6547da$export$2fc8c3fcbb365b89);
$parcel$export(module.exports, "default", () => $047ecae84b6547da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $047ecae84b6547da$export$2fc8c3fcbb365b89 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gEDnw")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
const $047ecae84b6547da$var$AsyncProjectSettingsServiceDeskAutomationSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $047ecae84b6547da$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });
var $047ecae84b6547da$export$2e2bcd8739ae039 = $047ecae84b6547da$var$AsyncProjectSettingsServiceDeskAutomationSummary;

});
parcelRegister("gEDnw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eU8IJ").then(()=>parcelRequire('hfe3g'));

});



parcelRegister("23ehb", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRouteEntry", () => $1b19201554765275$export$ddc45b708634b66);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $69J1v = parcelRequire("69J1v");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9Pq3q = parcelRequire("9Pq3q");
const $1b19201554765275$export$ddc45b708634b66 = (0, $6xToB.createEntry)((0, $69J1v.projectSettingsServicedeskAutomationViewLogRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.log',
        component: (0, $9Pq3q.default),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9Pq3q.LazyProjectSettingsServiceDeskAutomationViewLog)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskAutomationViewLogRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskAutomationViewLogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("69J1v", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRoute", () => $d3f08cfd387049df$export$ea3acd3ad4eb7d38);
const $d3f08cfd387049df$export$ea3acd3ad4eb7d38 = {
    name: 'project-settings-servicedesk-automation-view-log',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId'
};

});

parcelRegister("9Pq3q", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", () => $a240126197371616$export$db6c5cdbc65b2b4a);
$parcel$export(module.exports, "default", () => $a240126197371616$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a240126197371616$export$db6c5cdbc65b2b4a = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("14NUU")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
const $a240126197371616$var$AsyncProjectSettingsServiceDeskAutomationViewLog = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a240126197371616$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });
var $a240126197371616$export$2e2bcd8739ae039 = $a240126197371616$var$AsyncProjectSettingsServiceDeskAutomationViewLog;

});
parcelRegister("14NUU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("deU0o").then(()=>parcelRequire('9Kb0h'));

});



parcelRegister("70AS8", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRouteEntry", () => $2713d8dd5a98d787$export$a8eaf3cca1d5d936);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1ePRx = parcelRequire("1ePRx");

var $1PvPk = parcelRequire("1PvPk");

var $kgDPH = parcelRequire("kgDPH");

var $g9kBK = parcelRequire("g9kBK");

var $7g1XK = parcelRequire("7g1XK");

var $aQoXd = parcelRequire("aQoXd");

var $dEfqd = parcelRequire("dEfqd");

var $cg6Vz = parcelRequire("cg6Vz");
const $2713d8dd5a98d787$export$a8eaf3cca1d5d936 = (0, $6xToB.createEntry)((0, $7g1XK.projectSettingsServicedeskChangeManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.change-management-settings',
        component: (0, $cg6Vz.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $kgDPH.serviceDeskContextResource),
            (0, $dEfqd.changeManagementSettingsProjectConfigurationResource),
            (0, $1ePRx.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cg6Vz.LazyProjectSettingsServiceDeskChangeManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChangeManagementRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChangeManagementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1ePRx", function(module, exports) {
$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $b66a14e650dc966f$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $b66a14e650dc966f$export$dd3715dce02ee460);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $b66a14e650dc966f$var$getDataLoader = ()=>(parcelRequire("9TkyE"));
const $b66a14e650dc966f$export$315b6278d34861b4 = (0, $l1VxS.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: $b66a14e650dc966f$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $b66a14e650dc966f$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($b66a14e650dc966f$export$315b6278d34861b4);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("9TkyE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lGQGv").then(()=>parcelRequire('c4uEB'));

});


parcelRegister("dEfqd", function(module, exports) {
$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $fcb869bbdbbb9da4$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");
const $fcb869bbdbbb9da4$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $fcb869bbdbbb9da4$var$getDataLoader = ()=>(parcelRequire("eJHLV"));
const $fcb869bbdbbb9da4$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $fcb869bbdbbb9da4$export$2413ba18ec38282d = (0, $l1VxS.createResource)({
    type: $fcb869bbdbbb9da4$export$c0636b6062501e0b,
    getKey: $fcb869bbdbbb9da4$var$getKey,
    getDataLoader: $fcb869bbdbbb9da4$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("eJHLV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6AfiL").then(()=>parcelRequire('3T5bx'));

});


parcelRegister("cg6Vz", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", () => $d32605cb6bbc6b58$export$e674d93688e620b3);
$parcel$export(module.exports, "default", () => $d32605cb6bbc6b58$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d32605cb6bbc6b58$export$e674d93688e620b3 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jtQny"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
const $d32605cb6bbc6b58$var$AsyncProjectSettingsServiceDeskChangeManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d32605cb6bbc6b58$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });
var $d32605cb6bbc6b58$export$2e2bcd8739ae039 = $d32605cb6bbc6b58$var$AsyncProjectSettingsServiceDeskChangeManagement;

});
parcelRegister("jtQny", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("FAW7r").then(()=>parcelRequire('3UqVx'));

});



parcelRegister("ceWLf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRouteEntry", () => $0d19bbf5f4163584$export$aa27d235fc2eedf6);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $hCTNK = parcelRequire("hCTNK");

var $aQoXd = parcelRequire("aQoXd");

var $h3GVs = parcelRequire("h3GVs");

var $4kspE = parcelRequire("4kspE");
const $0d19bbf5f4163584$export$aa27d235fc2eedf6 = (0, $6xToB.createEntry)((0, $hCTNK.projectSettingsServicedeskChannelsChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $h3GVs.serviceDeskChatNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4kspE.LazyProjectSettingsServiceDeskChatSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsChatRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChannelsChatRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("h3GVs", function(module, exports) {
$parcel$export(module.exports, "serviceDeskChatNextGenRedirect", () => $f4f9420006bc3495$export$22c86ddb04b1359a);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $f4f9420006bc3495$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("4kspE", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", () => $4129669277c2532f$export$971347f9ac02f862);
$parcel$export(module.exports, "default", () => $4129669277c2532f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4129669277c2532f$export$971347f9ac02f862 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7siSr")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
const $4129669277c2532f$var$AsyncProjectSettingsServiceDeskChatSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4129669277c2532f$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });
var $4129669277c2532f$export$2e2bcd8739ae039 = $4129669277c2532f$var$AsyncProjectSettingsServiceDeskChatSettings;

});
parcelRegister("7siSr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iqDW3").then(()=>parcelRequire('ev8xC'));

});



parcelRegister("fKViZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRouteEntry", () => $98e20b568b44e473$export$b4590bec09451e4c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $krn2b = parcelRequire("krn2b");

var $aQoXd = parcelRequire("aQoXd");

var $bGv2Y = parcelRequire("bGv2Y");

var $itJJd = parcelRequire("itJJd");
const $98e20b568b44e473$export$b4590bec09451e4c = (0, $6xToB.createEntry)((0, $krn2b.projectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bGv2Y.serviceDeskEmailNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $itJJd.LazyProjectSettingsServiceDeskEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsEmailNextGenRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChannelsEmailNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("krn2b", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRoute", () => $7cb4164b89e9ea35$export$89c7bf2bac1464c2);
const $7cb4164b89e9ea35$export$89c7bf2bac1464c2 = {
    name: 'project-settings-servicedesk-channels-email-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
    exact: true
};

});

parcelRegister("bGv2Y", function(module, exports) {
$parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", () => $0ef36f3d1b9f1f7d$export$86c8da903fb97c4f);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $0ef36f3d1b9f1f7d$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("itJJd", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", () => $a614736546f927dd$export$66d0c668045080de);
$parcel$export(module.exports, "default", () => $a614736546f927dd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gQZrP = parcelRequire("gQZrP");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a614736546f927dd$export$66d0c668045080de = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cpKri")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
const $a614736546f927dd$var$AsyncProjectSettingsServiceDeskEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZrP.HelpCenterSettingsRedirect), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a614736546f927dd$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));
var $a614736546f927dd$export$2e2bcd8739ae039 = $a614736546f927dd$var$AsyncProjectSettingsServiceDeskEmail;

});
parcelRegister("gQZrP", function(module, exports) {
$parcel$export(module.exports, "HelpCenterSettingsRedirect", () => $8cb0090c6a93124f$export$a24ec33acfeae48d);

var $kOsSp = parcelRequire("kOsSp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $7fTjp = parcelRequire("7fTjp");

var $kfvK2 = parcelRequire("kfvK2");

var $2aY2d = parcelRequire("2aY2d");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $f2JN3 = parcelRequire("f2JN3");

var $5HWRC = parcelRequire("5HWRC");

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $15sI9 = parcelRequire("15sI9");

var $4zOR8 = parcelRequire("4zOR8");

var $kbAMe = parcelRequire("kbAMe");

var $eHGsn = parcelRequire("eHGsn");
const $8cb0090c6a93124f$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $8cb0090c6a93124f$export$2d1034e371a567c6 = (page, pathname, helpCenterId)=>{
    switch(page){
        case 'kb':
            return (0, $kbAMe.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true, helpCenterId);
        default:
            return (0, $kbAMe.getSettingsPath)(pathname, true, helpCenterId);
    }
};
const $8cb0090c6a93124f$var$useLocation = (0, $kfvK2.createRouterSelector)((state)=>state.location);
const $8cb0090c6a93124f$export$b90b599f4b180ba = ({ page: page, children: children })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const useLocationOld = (0, $kfvK2.createRouterSelector)((state)=>state.location);
    // eslint-disable-next-line react-hooks/react-compiler
    const location = useLocationOld();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const isJCS = (0, $4zOR8.useIsJCSProjectType)(projectContext?.projectType);
    (0, $eJOHy.useEffect)(()=>{
        if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) {
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $8cb0090c6a93124f$export$c224e724e933fbea(page, location.pathname)
            });
            showFlag({
                messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $eHGsn.default).errorTitle),
                description: formatMessage((0, $4cTDP.fg)('jcs_project_type_m3') ? (0, $eHGsn.default).description : (0, $eHGsn.default).errorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        isJCS,
        location.pathname,
        page,
        showFlag
    ]);
    if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/helpcenter"
    });
    return children;
};
const $8cb0090c6a93124f$export$4e0587d8c8738b4d = ({ page: page, children: children })=>{
    const location = $8cb0090c6a93124f$var$useLocation();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const isJCS = projectContext?.projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT);
    (0, $eJOHy.useEffect)(()=>{
        if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $8cb0090c6a93124f$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $15sI9.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8cb0090c6a93124f$export$b65700afa6ae3ae9, {
        page: page,
        pathname: location.pathname,
        projectId: projectContext.projectId
    });
    return children;
};
const $8cb0090c6a93124f$export$b65700afa6ae3ae9 = ({ page: page, pathname: pathname, projectId: projectId })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const activationId = (0, $f2sjT.useActivationId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const jiraProjectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const jiraWorkspaceAri = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const { helpCenter: { helpCenterByHoistedProjectIdRouted: helpCenter } } = (0, $j4oe4.useLazyLoadQuery)((0, $kOsSp.default), {
        cloudId: cloudId,
        jiraProjectAri: jiraProjectAri,
        jiraWorkspaceAri: jiraWorkspaceAri
    });
    if (helpCenter.__typename !== 'HelpCenter') {
        showFlag({
            messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $eHGsn.default).errorTitle),
            description: formatMessage((0, $eHGsn.default).errorDescription),
            isAutoDismiss: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
            to: "/jira/helpcenter"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: $8cb0090c6a93124f$export$2d1034e371a567c6(page, pathname, (0, $5HWRC.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId),
        persistSearchParams: true
    });
};
const $8cb0090c6a93124f$export$a24ec33acfeae48d = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jcs_project_type_m3'), $8cb0090c6a93124f$export$4e0587d8c8738b4d, $8cb0090c6a93124f$export$b90b599f4b180ba);

});
parcelRegister("kOsSp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8813aa3a96100861$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7e611d03592a210b9307a6be1be74000>>
 * @relayHash a0b6281ad8328e2adece33059d7b499e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 962b8856f333ff53b5c22613434dd482d1904e0e5e4341a8f7e1842d1be9743f
const $8813aa3a96100861$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraWorkspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "jiraProjectAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "jiraWorkspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HelpCenterSettingsRedirectOldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterByHoistedProjectIdRouted",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpCenter.helpCenterByHoistedProjectIdRouted"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpCenter"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HelpCenterSettingsRedirectOldQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterByHoistedProjectIdRouted",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "962b8856f333ff53b5c22613434dd482d1904e0e5e4341a8f7e1842d1be9743f",
            "metadata": {},
            "name": "HelpCenterSettingsRedirectOldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8813aa3a96100861$var$node.hash = "b019fafdbfbfb9dc730e8f23eaf51dbd";
var $8813aa3a96100861$export$2e2bcd8739ae039 = $8813aa3a96100861$var$node;

});

parcelRegister("5HWRC", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $427ea1049004db28$export$a75f3c98d930b258);

var $1gIyy = parcelRequire("1gIyy");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/help/help-center/manifest.ts
var $427ea1049004db28$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1gIyy.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $1gIyy.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $427ea1049004db28$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $427ea1049004db28$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $427ea1049004db28$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $427ea1049004db28$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("1gIyy", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $0ec9d9033d8aaf25$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $0ec9d9033d8aaf25$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $0ec9d9033d8aaf25$export$a4af98a27b4568ee = "help", $0ec9d9033d8aaf25$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("15sI9", function(module, exports) {
$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $8aef23fd68bfd597$export$bf8b98b87d485657);
$parcel$export(module.exports, "getHelpCenterUUIDFromPath", () => $8aef23fd68bfd597$export$73a9fbfd9155f593);

var $gRw8I = parcelRequire("gRw8I");

var $4cTDP = parcelRequire("4cTDP");
const $8aef23fd68bfd597$export$bf8b98b87d485657 = ()=>{
    (0, $gRw8I.di)(window);
    if (!(0, $4cTDP.fg)('jcs_master_flag')) return false;
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};
const $8aef23fd68bfd597$export$73a9fbfd9155f593 = ()=>{
    (0, $gRw8I.di)(window);
    if (!$8aef23fd68bfd597$export$bf8b98b87d485657()) return '';
    if (!false) return window.location.pathname.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/)?.[0];
    return '';
};

});

parcelRegister("4zOR8", function(module, exports) {
$parcel$export(module.exports, "useAsyncIsJCS", () => $03a8239df13c06d0$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSProjectType", () => $03a8239df13c06d0$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $03a8239df13c06d0$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $03a8239df13c06d0$export$afee907b7a66ef2b);

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $jHFs0 = parcelRequire("jHFs0");

var $FhXEJ = parcelRequire("FhXEJ");
const $03a8239df13c06d0$var$useIsJCSProjectTypeFallback = (projectType, isAsync)=>{
    const isJCS = $03a8239df13c06d0$export$3894a8f24b665478();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return isAsync ? isJCS : Boolean(isJCS);
};
const $03a8239df13c06d0$export$25e1541dd4631818 = (projectType)=>projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('jcs_project_type_m3');
const $03a8239df13c06d0$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || $03a8239df13c06d0$export$25e1541dd4631818(projectType);
const $03a8239df13c06d0$export$b78b0f34fdacd97a = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_project_type_m3'), $03a8239df13c06d0$export$25e1541dd4631818, $03a8239df13c06d0$var$useIsJCSProjectTypeFallback);
//
//  M2 helpers, deprecated
// ---------------------
const $03a8239df13c06d0$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $jHFs0.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $03a8239df13c06d0$export$927b5354181b3adf = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_master_flag'), $03a8239df13c06d0$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $03a8239df13c06d0$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $jHFs0.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $03a8239df13c06d0$export$3894a8f24b665478 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_master_flag'), $03a8239df13c06d0$var$useAsyncIsJCSUnderFF, ()=>false);
const $03a8239df13c06d0$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $03a8239df13c06d0$var$isJCSTemplateFallback = (template)=>false;
const $03a8239df13c06d0$export$afee907b7a66ef2b = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jcs_master_flag'), $03a8239df13c06d0$var$isJCSTemplateUnderFF, $03a8239df13c06d0$var$isJCSTemplateFallback);

});
parcelRegister("jHFs0", function(module, exports) {
$parcel$export(module.exports, "useProjectProperties", () => $8737631b384de95a$export$58be98885c2d686a);

var $eJOHy = parcelRequire("eJOHy");

var $bPWfC = parcelRequire("bPWfC");

var $cSmYj = parcelRequire("cSmYj");

var $9pL9Y = parcelRequire("9pL9Y");

var $eWzpp = parcelRequire("eWzpp");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $89kvn = parcelRequire("89kvn");
const $8737631b384de95a$export$d4c72bab9d6cc13a = {};
const $8737631b384de95a$var$Store = (0, $GtRbT.createStore)({
    name: 'project-properties',
    initialState: $8737631b384de95a$export$d4c72bab9d6cc13a,
    actions: $89kvn.actions
});
const $8737631b384de95a$export$eebf791068e870dd = (0, $iJq0l.createHook)($8737631b384de95a$var$Store);
const $8737631b384de95a$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $eWzpp.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $8737631b384de95a$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $6d9QY.usePrevious)(propertyKeys);
    (0, $eJOHy.useEffect)(()=>{
        if (projectId === undefined) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($bPWfC)))(propertyKeys, key)) : {};
};

});
parcelRegister("bPWfC", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");

var $7H30b = parcelRequire("7H30b");

var $l5Z0K = parcelRequire("l5Z0K");

var $c9FP3 = parcelRequire("c9FP3");

var $40zJW = parcelRequire("40zJW");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $89e1a48dc6c79c2b$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $89e1a48dc6c79c2b$var$includes(collection, value, fromIndex, guard) {
    collection = $7H30b(collection) ? collection : $40zJW(collection);
    fromIndex = fromIndex && !guard ? $c9FP3(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $89e1a48dc6c79c2b$var$nativeMax(length + fromIndex, 0);
    return $l5Z0K(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $kEE3x(collection, value, fromIndex) > -1;
}
module.exports = $89e1a48dc6c79c2b$var$includes;

});
parcelRegister("l5Z0K", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $f5b964216372e7cd$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f5b964216372e7cd$var$isString(value) {
    return typeof value == 'string' || !$4sprp(value) && $7gKgM(value) && $1O9y6(value) == $f5b964216372e7cd$var$stringTag;
}
module.exports = $f5b964216372e7cd$var$isString;

});

parcelRegister("40zJW", function(module, exports) {

var $i4555 = parcelRequire("i4555");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $2eb2e2b8281e82da$var$values(object) {
    return object == null ? [] : $i4555(object, $4c94y(object));
}
module.exports = $2eb2e2b8281e82da$var$values;

});
parcelRegister("i4555", function(module, exports) {

var $lylkU = parcelRequire("lylkU");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $d26c8ab99413555f$var$baseValues(object, props) {
    return $lylkU(props, function(key) {
        return object[key];
    });
}
module.exports = $d26c8ab99413555f$var$baseValues;

});



parcelRegister("89kvn", function(module, exports) {
$parcel$export(module.exports, "actions", () => $4e23de55f0dc6aa6$export$e324594224ef24da);

var $lah0B = parcelRequire("lah0B");
const $4e23de55f0dc6aa6$export$e324594224ef24da = {
    get: $lah0B.get
};

});
parcelRegister("lah0B", function(module, exports) {
$parcel$export(module.exports, "get", () => $fe45d3e1a1e07c68$export$3988ae62b71be9a3);

var $2zs80 = parcelRequire("2zs80");

var $6dPbw = parcelRequire("6dPbw");

var $4c94y = parcelRequire("4c94y");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $8wOps = parcelRequire("8wOps");
const $fe45d3e1a1e07c68$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))(currentProperties));
        missingProperties.length && ((0, $4cTDP.fg)('fix_for_sentry_alert_13071_on_project_properties') ? (0, $8wOps.default)({
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties?.[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        }).catch((error)=>{
            // Even on error, we should mark the properties as requested but failed
            // to differentiate from unrequested state
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        // Mark as null to indicate "requested but failed to load"
                        reducedResult[name] = null;
                        return reducedResult;
                    }, {})
                }
            });
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getProjectProperties',
                    packageName: 'jiraProjectPropertiesServices',
                    teamName: 'Sequoia'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }) : (0, $8wOps.default)({
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties?.[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        }));
    };

});
parcelRegister("8wOps", function(module, exports) {
$parcel$export(module.exports, "default", () => $39c6eaa9a82a8c67$export$2e2bcd8739ae039);

var $fnu0d = parcelRequire("fnu0d");
const $39c6eaa9a82a8c67$var$remoteGet = async ({ projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $fnu0d.get)({
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};
var $39c6eaa9a82a8c67$export$2e2bcd8739ae039 = $39c6eaa9a82a8c67$var$remoteGet;

});





parcelRegister("kbAMe", function(module, exports) {
$parcel$export(module.exports, "getSettingsPath", () => $4de62efb8d65a30f$export$67417cd3aaee582d);
const $4de62efb8d65a30f$export$67417cd3aaee582d = (path, isJCS, helpCenterId)=>{
    if (!helpCenterId) return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
    return path.replace('/jira/servicedesk/', '/jira/helpcenter/').replace('/settings', `/settings/${helpCenterId}`);
};

});

parcelRegister("eHGsn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4058617b77d67d0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e4058617b77d67d0$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-title",
        "defaultMessage": "This page has been moved"
    },
    errorDescription: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-description",
        "defaultMessage": "You can find the page you\u2019re looking for in a service hub."
    },
    description: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.description",
        "defaultMessage": "You can find the page you\u2019re looking for in a customer experience."
    }
});
var $e4058617b77d67d0$export$2e2bcd8739ae039 = $e4058617b77d67d0$var$messages;

});


parcelRegister("cpKri", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9JgMv").then(()=>parcelRequire('bz3yf'));

});



parcelRegister("5k4zE", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry", () => $e38a37dea8be38c8$export$65a2b00cdeff4516);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $393uA = parcelRequire("393uA");

var $kTJYz = parcelRequire("kTJYz");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $k4Fbw = parcelRequire("k4Fbw");

var $lHKQ7 = parcelRequire("lHKQ7");
const $e38a37dea8be38c8$export$65a2b00cdeff4516 = (0, $6xToB.createEntry)((0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $k4Fbw.customerPermissionsRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $393uA.customerPermissionsPageDataResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lHKQ7.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("393uA", function(module, exports) {
$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $77ff35771c349120$export$ae3446385906310c);

var $l1VxS = parcelRequire("l1VxS");


const $77ff35771c349120$export$ae3446385906310c = (0, $l1VxS.createResource)({
    type: (0, $aeecb035e15f59c4$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("griRX")),
    maxAge: Infinity
});

});
const $aeecb035e15f59c4$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("griRX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("er85J").then(()=>parcelRequire('eipTf'));

});


parcelRegister("k4Fbw", function(module, exports) {
$parcel$export(module.exports, "customerPermissionsRedirect", () => $559fc0f9b687d27f$export$59eedcca37dbbafd);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $559fc0f9b687d27f$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("lHKQ7", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", () => $a85ba1ba70aa3e84$export$5367e40a24f0bd54);
$parcel$export(module.exports, "default", () => $a85ba1ba70aa3e84$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a85ba1ba70aa3e84$export$5367e40a24f0bd54 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("1mV55"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
const $a85ba1ba70aa3e84$var$AsyncProjectSettingsServiceDeskCustomerPermissions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a85ba1ba70aa3e84$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });
var $a85ba1ba70aa3e84$export$2e2bcd8739ae039 = $a85ba1ba70aa3e84$var$AsyncProjectSettingsServiceDeskCustomerPermissions;

});
parcelRegister("1mV55", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2qt5r").then(()=>parcelRequire('ghfmm'));

});



parcelRegister("5w2Cj", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRouteEntry", () => $c7fd134a5a9d82ca$export$7b7294b50c70e50c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $3pUIh = parcelRequire("3pUIh");

var $azYhY = parcelRequire("azYhY");

var $aQoXd = parcelRequire("aQoXd");

var $l1xjV = parcelRequire("l1xjV");

var $9KQ6p = parcelRequire("9KQ6p");
const $c7fd134a5a9d82ca$export$7b7294b50c70e50c = (0, $6xToB.createEntry)((0, $azYhY.projectSettingsServicedeskChannelsPortalRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $9KQ6p.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $3pUIh.portalSettingsContextResource),
            (0, $l1xjV.serviceDeskPortalSettingsResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9KQ6p.LazyProjectSettingsServiceDeskPortalSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsPortalRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChannelsPortalRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3pUIh", function(module, exports) {
$parcel$export(module.exports, "portalSettingsContextResource", () => $cf274a567804ac90$export$4a3e29f235f3320c);

var $l1VxS = parcelRequire("l1VxS");
const $cf274a567804ac90$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $cf274a567804ac90$export$4a3e29f235f3320c = (0, $l1VxS.createResource)({
    type: $cf274a567804ac90$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("ln3hG"))
});

});
parcelRegister("ln3hG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1fpVy").then(()=>parcelRequire('cVpTe'));

});


parcelRegister("l1xjV", function(module, exports) {
$parcel$export(module.exports, "serviceDeskPortalSettingsResource", () => $f1b4420f26050bc4$export$ed977e313d34da4b);

var $9FYIg = parcelRequire("9FYIg");

var $k1XmU = parcelRequire("k1XmU");
const $f1b4420f26050bc4$export$ed977e313d34da4b = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SERVICE_DESK_PORTAL_SETTINGS`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $k1XmU.default),
            variables: {
                cloudIdString: cloudId,
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("k1XmU", function(module, exports) {
$parcel$export(module.exports, "default", () => $be082a121e89a5d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<559c3d37e4a98f768cccdc67e2fbd9a5>>
 * @relayHash 98d7f7fd9930e899dc9b03c10f35aa2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 881d1d8d29211658689325420e8c7ef222c43c80329551602680076850056533

var $4NG3g = parcelRequire("4NG3g");

var $kEBh8 = parcelRequire("kEBh8");
const $be082a121e89a5d2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdString"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudIdString"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyEditableAgents": true
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": v3 /*: any*/ ,
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
            {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    }
                ]
            },
            {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "AgentStudioAssistant",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "externalConfigReference"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "identityAccountId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "creatorType"
                            },
                            v4 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "cursor"
                    }
                ]
            }
        ]
    }, v6 = {
        "args": v3 /*: any*/ ,
        "filters": [
            "cloudId",
            "input"
        ],
        "handle": "connection",
        "key": "RovoAgent_agentStudio_getAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ServiceDeskPortalSettingsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "cloudIdString",
                            "variableName": "cloudIdString"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "CustomerPortalSettingsPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ServiceDeskPortalSettingsQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "atlassianStudio_userSiteContext",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "AtlassianStudioUserProductPermissions",
                                            "kind": "LinkedField",
                                            "name": "userPermissions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAbleToCreateAgents"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AtlassianStudioUserSiteContextOutput"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "881d1d8d29211658689325420e8c7ef222c43c80329551602680076850056533",
            "metadata": {},
            "name": "ServiceDeskPortalSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": (0, $kEBh8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": (0, $4NG3g.default)
            }
        }
    };
}();
$be082a121e89a5d2$var$node.hash = "eba27bb3ef600ddb29c1aba82b2a9c51";
var $be082a121e89a5d2$export$2e2bcd8739ae039 = $be082a121e89a5d2$var$node;

});
parcelRegister("4NG3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a90519af341b89a$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $6a90519af341b89a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('extract_rovo_agent_configuration_package');
    }
};

});

parcelRegister("kEBh8", function(module, exports) {
$parcel$export(module.exports, "default", () => $423071dd88fb4e5e$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $423071dd88fb4e5e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsm_portal_rovo_agent_config_experience');
    }
};

});



parcelRegister("9KQ6p", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", () => $194d1ca1f686a549$export$fdbd4b1e5ae0e422);
$parcel$export(module.exports, "default", () => $194d1ca1f686a549$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $194d1ca1f686a549$export$fdbd4b1e5ae0e422 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("2MO3B")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
const $194d1ca1f686a549$var$AsyncProjectSettingsServiceDeskPortalSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $194d1ca1f686a549$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });
var $194d1ca1f686a549$export$2e2bcd8739ae039 = $194d1ca1f686a549$var$AsyncProjectSettingsServiceDeskPortalSettings;

});
parcelRegister("2MO3B", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1Ww7M").then(()=>parcelRequire('e4Icc'));

});



parcelRegister("cq7wq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsRouteEntry", () => $71dfe6b50d35f92b$export$2d20001d3350adbc);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2fr4w = parcelRequire("2fr4w");

var $aQoXd = parcelRequire("aQoXd");

var $14hVA = parcelRequire("14hVA");
const $71dfe6b50d35f92b$export$2d20001d3350adbc = (0, $6xToB.createEntry)((0, $2fr4w.projectSettingsServicedeskChannelsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $14hVA.channelsRedirect)('customer-permissions'),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChannelsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2fr4w", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsRoute", () => $7f065328fdde9dbd$export$36e4210554830c2f);
const $7f065328fdde9dbd$export$36e4210554830c2f = {
    name: 'project-settings-servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels',
    exact: true
};

});

parcelRegister("14hVA", function(module, exports) {
$parcel$export(module.exports, "channelsRedirect", () => $cdecb553aa88fe31$export$c7e6c0ac0abe2336);

var $eJOHy = parcelRequire("eJOHy");

var $7lJUT = parcelRequire("7lJUT");

var $FhXEJ = parcelRequire("FhXEJ");

var $2mHfh = parcelRequire("2mHfh");
const $cdecb553aa88fe31$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("bBqyO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRouteEntry", () => $3eace7fe0145db1f$export$dcfc82c90a86b038);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cX4Fw = parcelRequire("cX4Fw");

var $aQoXd = parcelRequire("aQoXd");

var $ezDsV = parcelRequire("ezDsV");

var $9btIX = parcelRequire("9btIX");
const $3eace7fe0145db1f$export$dcfc82c90a86b038 = (0, $6xToB.createEntry)((0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $ezDsV.widgetsNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btIX.LazyProjectSettingsServiceDeskWidgetSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChannelsWidgetRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChannelsWidgetRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ezDsV", function(module, exports) {
$parcel$export(module.exports, "widgetsNextGenRedirect", () => $9c8e55a52c3fbbf2$export$8ba256148f9b998f);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $9c8e55a52c3fbbf2$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});

parcelRegister("9btIX", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", () => $7c30dfa00c9a467f$export$216a049c4d917b0);
$parcel$export(module.exports, "default", () => $7c30dfa00c9a467f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7c30dfa00c9a467f$export$216a049c4d917b0 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("akGAf")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
const $7c30dfa00c9a467f$var$AsyncProjectSettingsServiceDeskWidgetSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7c30dfa00c9a467f$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });
var $7c30dfa00c9a467f$export$2e2bcd8739ae039 = $7c30dfa00c9a467f$var$AsyncProjectSettingsServiceDeskWidgetSettings;

});
parcelRegister("akGAf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4DKjv").then(()=>parcelRequire('lqPYT'));

});



parcelRegister("cM5pJ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChatRouteEntry", () => $6bebb81557578ed6$export$f030ac1baa84c682);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $eaMHj = parcelRequire("eaMHj");

var $aQoXd = parcelRequire("aQoXd");

var $4kspE = parcelRequire("4kspE");
const $6bebb81557578ed6$export$f030ac1baa84c682 = (0, $6xToB.createEntry)((0, $eaMHj.projectSettingsServicedeskChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4kspE.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4kspE.LazyProjectSettingsServiceDeskChatSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskChatRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskChatRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("95uMc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRouteEntry", () => $9cd2edfb3fb74d72$export$aba71c4218b643ad);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $huYm9 = parcelRequire("huYm9");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $02Yn6 = parcelRequire("02Yn6");

var $bfOBR = parcelRequire("bfOBR");

var $gwoLH = parcelRequire("gwoLH");
const $9cd2edfb3fb74d72$export$aba71c4218b643ad = (0, $6xToB.createEntry)((0, $huYm9.projectSettingsServicedeskClassicAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.app-discovery',
        component: (0, $bfOBR.ConnectAppsRedirect)(`/jira/${(0, $gwoLH.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $02Yn6.LazyAppDiscoverySettings)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskClassicAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskClassicAppsRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("61kne", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRouteEntry", () => $d686ea5611775b5b$export$5a4abc64d2a82698);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cdHCV = parcelRequire("cdHCV");

var $aQoXd = parcelRequire("aQoXd");

var $1VT2J = parcelRequire("1VT2J");
const $d686ea5611775b5b$export$5a4abc64d2a82698 = (0, $6xToB.createEntry)((0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $1VT2J.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1VT2J.LazyProjectSettingsServiceDeskCustomerNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-customer-notifications-entries/src/projectSettingsServicedeskCustomerNotificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskCustomerNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1VT2J", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", () => $9a41abf4bbe3c762$export$c763ea321ade5f68);
$parcel$export(module.exports, "default", () => $9a41abf4bbe3c762$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gQZrP = parcelRequire("gQZrP");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9a41abf4bbe3c762$export$c763ea321ade5f68 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lJnsN")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
const $9a41abf4bbe3c762$var$AsyncProjectSettingsServiceDeskCustomerNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZrP.HelpCenterSettingsRedirect), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9a41abf4bbe3c762$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));
var $9a41abf4bbe3c762$export$2e2bcd8739ae039 = $9a41abf4bbe3c762$var$AsyncProjectSettingsServiceDeskCustomerNotifications;

});
parcelRegister("lJnsN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6pEqF").then(()=>parcelRequire('icLxk'));

});



parcelRegister("85bCZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRouteEntry", () => $9a78ac60977c017a$export$ed034e5245184767);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $393uA = parcelRequire("393uA");

var $kDkUg = parcelRequire("kDkUg");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $lHKQ7 = parcelRequire("lHKQ7");
const $9a78ac60977c017a$export$ed034e5245184767 = (0, $6xToB.createEntry)((0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $lHKQ7.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $393uA.customerPermissionsPageDataResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lHKQ7.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskCustomerPermissionsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskCustomerPermissionsRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("ihexr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRouteEntry", () => $48e299761b3b2824$export$5cea2172fd288382);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $759RV = parcelRequire("759RV");

var $aQoXd = parcelRequire("aQoXd");

var $bmwpE = parcelRequire("bmwpE");

var $aGIH8 = parcelRequire("aGIH8");
const $48e299761b3b2824$export$5cea2172fd288382 = (0, $6xToB.createEntry)((0, $759RV.projectSettingsServicedeskDataClassificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aGIH8.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aGIH8.LazyDataClassificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskDataClassificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskDataClassificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("759RV", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRoute", () => $ca3a953b1f6e506d$export$ec4d4f6583272cd);
const $ca3a953b1f6e506d$export$ec4d4f6583272cd = {
    name: 'project-settings-servicedesk-data-classifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("aGIH8", function(module, exports) {
$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $1cda1e259567f6de$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $1cda1e259567f6de$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1cda1e259567f6de$export$b8abcf8aa8f4df56 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8kyMO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $1cda1e259567f6de$var$AsyncDataClassificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1cda1e259567f6de$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
var $1cda1e259567f6de$export$2e2bcd8739ae039 = $1cda1e259567f6de$var$AsyncDataClassificationsSettings;

});


parcelRegister("3jDGC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDetailsRouteEntry", () => $b4cda2e55e868793$export$6b37ff6fd616f383);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $95JeU = parcelRequire("95JeU");

var $aQoXd = parcelRequire("aQoXd");

var $bmwpE = parcelRequire("bmwpE");

var $8YBTO = parcelRequire("8YBTO");
const $b4cda2e55e868793$export$6b37ff6fd616f383 = (0, $6xToB.createEntry)((0, $95JeU.projectSettingsServicedeskDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $8YBTO.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8YBTO.LazyDetailsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskDetailsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("95JeU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskDetailsRoute", () => $db1040706d45857c$export$23583c23687c31c7);
const $db1040706d45857c$export$23583c23687c31c7 = {
    name: 'project-settings-servicedesk-details',
    // /settings/details
    path: '/jira/servicedesk/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("8YBTO", function(module, exports) {
$parcel$export(module.exports, "LazyDetailsSettings", () => $51dbb5946e9cd5f0$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $51dbb5946e9cd5f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $51dbb5946e9cd5f0$export$6f16b5efddd5c646 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4esLz"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $51dbb5946e9cd5f0$var$AsyncDetailsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $51dbb5946e9cd5f0$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
var $51dbb5946e9cd5f0$export$2e2bcd8739ae039 = $51dbb5946e9cd5f0$var$AsyncDetailsSettings;

});


parcelRegister("kmfhe", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskEmailRouteEntry", () => $c9d53c7c163b6e62$export$676e8af036d3e9c1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9Box0 = parcelRequire("9Box0");

var $aQoXd = parcelRequire("aQoXd");

var $itJJd = parcelRequire("itJJd");
const $c9d53c7c163b6e62$export$676e8af036d3e9c1 = (0, $6xToB.createEntry)((0, $9Box0.projectSettingsServicedeskEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.settings.email-channels',
        component: (0, $itJJd.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $itJJd.LazyProjectSettingsServiceDeskEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskEmailRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskEmailRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("3VkWO", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRouteEntry", () => $1025c39b61c7e9a8$export$ca80e1d474f774d4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $g9kBK = parcelRequire("g9kBK");

var $306id = parcelRequire("306id");

var $aQoXd = parcelRequire("aQoXd");

var $jjsMG = parcelRequire("jjsMG");
const $1025c39b61c7e9a8$export$ca80e1d474f774d4 = (0, $6xToB.createEntry)((0, $306id.projectSettingsServicedeskExternalLinksRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jjsMG.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jjsMG.LazyProjectSettingsServiceDeskExternalLinks)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskExternalLinksRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskExternalLinksRouteEntry'
            },
            enabled: true
        },
        perfMetricKey: 'jsm-external-resources'
    }));

});
parcelRegister("jjsMG", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", () => $6b6994fd623f14b2$export$28482a53859ec466);
$parcel$export(module.exports, "default", () => $6b6994fd623f14b2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $6b6994fd623f14b2$export$28482a53859ec466 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jNDQ4"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
const $6b6994fd623f14b2$var$AsyncProjectSettingsServiceDeskExternalLinks = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6b6994fd623f14b2$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });
var $6b6994fd623f14b2$export$2e2bcd8739ae039 = $6b6994fd623f14b2$var$AsyncProjectSettingsServiceDeskExternalLinks;

});
parcelRegister("jNDQ4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lTv1B").then(()=>parcelRequire('4HuAu'));

});



parcelRegister("grzdo", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRouteEntry", () => $6ddff2e6e1266340$export$5c0731470c0dc065);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2TwJc = parcelRequire("2TwJc");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $78HKm = parcelRequire("78HKm");

var $eqrGz = parcelRequire("eqrGz");
const $6ddff2e6e1266340$export$5c0731470c0dc065 = (0, $6xToB.createEntry)((0, $2TwJc.projectSettingsServicedeskFeedbackRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $eqrGz.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $eqrGz.LazyProjectSettingsServiceDeskFeedbackSettings),
            (0, $78HKm.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskFeedbackRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskFeedbackRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("78HKm", function(module, exports) {
$parcel$export(module.exports, "LoadingComponent", () => $d408c10ee369f732$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $d408c10ee369f732$export$32eb62914bae0e84);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $bQWwW = parcelRequire("bQWwW");
const $d408c10ee369f732$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d408c10ee369f732$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }));

const $d408c10ee369f732$export$32eb62914bae0e84 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fpEkQ")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d408c10ee369f732$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpEkQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5eyT9").then(()=>parcelRequire('2Zp7K'));

});


parcelRegister("eqrGz", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", () => $5ff09dae1d5965ed$export$ff54bec6c7cb7d47);
$parcel$export(module.exports, "default", () => $5ff09dae1d5965ed$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");
const $5ff09dae1d5965ed$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $5ff09dae1d5965ed$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $5ff09dae1d5965ed$export$ff54bec6c7cb7d47 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("kVduI")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
const $5ff09dae1d5965ed$var$AsyncProjectSettingsServiceDeskFeedbackSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $5ff09dae1d5965ed$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });
var $5ff09dae1d5965ed$export$2e2bcd8739ae039 = $5ff09dae1d5965ed$var$AsyncProjectSettingsServiceDeskFeedbackSettings;

});
parcelRegister("kVduI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5sFoQ").then(()=>parcelRequire('ikxk8'));

});



parcelRegister("b29TL", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFieldsRouteEntry", () => $9d8b23ec9e2dc585$export$8a5eabbb292c5b39);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $uKS5x = parcelRequire("uKS5x");

var $1PvPk = parcelRequire("1PvPk");

var $84Gb2 = parcelRequire("84Gb2");

var $aQoXd = parcelRequire("aQoXd");

var $961JK = parcelRequire("961JK");
const $9d8b23ec9e2dc585$export$8a5eabbb292c5b39 = (0, $6xToB.createEntry)((0, $84Gb2.projectSettingsServicedeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-tmp',
        component: (0, $961JK.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $uKS5x.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $961JK.LazyFieldsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("961JK", function(module, exports) {
$parcel$export(module.exports, "LazyFieldsSettings", () => $29ec6aca051a27f4$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $29ec6aca051a27f4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $29ec6aca051a27f4$export$e309780f520d125a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("e7wXq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $29ec6aca051a27f4$var$AsyncFieldsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $29ec6aca051a27f4$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
var $29ec6aca051a27f4$export$2e2bcd8739ae039 = $29ec6aca051a27f4$var$AsyncFieldsSettings;

});


parcelRegister("csLF9", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRouteEntry", () => $ad7c13eb7d123bba$export$58e3b68d22b7a42b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $iJSzu = parcelRequire("iJSzu");

var $aQoXd = parcelRequire("aQoXd");

var $hHbzj = parcelRequire("hHbzj");

var $dZRaT = parcelRequire("dZRaT");

var $7j7sP = parcelRequire("7j7sP");
const $ad7c13eb7d123bba$export$58e3b68d22b7a42b = (0, $6xToB.createEntry)((0, $iJSzu.projectSettingsServicedeskForgeAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $7j7sP.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $hHbzj.forgeProjectSettingsModuleResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7j7sP.LazyForgeProjectSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskForgeAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskForgeAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iJSzu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $3c10eacac47d1aff$export$10bafd1256118bb8);
const $3c10eacac47d1aff$export$10bafd1256118bb8 = {
    name: 'project-settings-servicedesk-forge-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("7j7sP", function(module, exports) {
$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $63360e0ca663daa2$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "default", () => $63360e0ca663daa2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $63360e0ca663daa2$export$ef66d3f49a9953d8 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dfvr4")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $63360e0ca663daa2$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $63360e0ca663daa2$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $63360e0ca663daa2$export$2e2bcd8739ae039 = $63360e0ca663daa2$export$b943f48844c671a5;

});


parcelRegister("dTlAf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRouteEntry", () => $a960f273ccd8312c$export$95a73b5db67dd70a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $kgDPH = parcelRequire("kgDPH");

var $499r8 = parcelRequire("499r8");

var $aQoXd = parcelRequire("aQoXd");

var $c8VU3 = parcelRequire("c8VU3");
const $a960f273ccd8312c$export$95a73b5db67dd70a = (0, $6xToB.createEntry)((0, $499r8.projectSettingsServicedeskIncidentManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $c8VU3.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $kgDPH.serviceDeskContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c8VU3.LazyProjectSettingsServiceDeskIncidentManagement)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskIncidentManagementRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskIncidentManagementRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("c8VU3", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", () => $7113731f71e939b5$export$7796b6d080b8c187);
$parcel$export(module.exports, "default", () => $7113731f71e939b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7113731f71e939b5$export$7796b6d080b8c187 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hRpPB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
const $7113731f71e939b5$var$AsyncProjectSettingsServiceDeskIncidentManagement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7113731f71e939b5$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });
var $7113731f71e939b5$export$2e2bcd8739ae039 = $7113731f71e939b5$var$AsyncProjectSettingsServiceDeskIncidentManagement;

});
parcelRegister("hRpPB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("b5Q7f")
]).then(()=>parcelRequire('aVMo3'));

});



parcelRegister("dKx89", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRouteEntry", () => $a193934e2ac58a22$export$dfcd097af0ecd961);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ie5KY = parcelRequire("ie5KY");

var $aQoXd = parcelRequire("aQoXd");

var $ejTKN = parcelRequire("ejTKN");

var $21Rpn = parcelRequire("21Rpn");
const $a193934e2ac58a22$export$dfcd097af0ecd961 = (0, $6xToB.createEntry)((0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $21Rpn.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $21Rpn.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $ejTKN.LazyInternalNotificationSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskInternalNotificationsNextGenRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskInternalNotificationsNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ejTKN", function(module, exports) {
$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $c9e05b3be0968278$export$501979bd6d492c43);

var $bQWwW = parcelRequire("bQWwW");

const $c9e05b3be0968278$export$501979bd6d492c43 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("akHau")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
});

});
parcelRegister("akHau", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("11VQT").then(()=>parcelRequire('1ElO6'));

});


parcelRegister("21Rpn", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", () => $3ec1e94b1d511880$export$9c9d293dc6de29d0);
$parcel$export(module.exports, "default", () => $3ec1e94b1d511880$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3ec1e94b1d511880$export$9c9d293dc6de29d0 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lrn73"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
const $3ec1e94b1d511880$var$AsyncProjectSettingsServiceDeskInternalNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3ec1e94b1d511880$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });
var $3ec1e94b1d511880$export$2e2bcd8739ae039 = $3ec1e94b1d511880$var$AsyncProjectSettingsServiceDeskInternalNotifications;

});
parcelRegister("lrn73", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6M2Hw").then(()=>parcelRequire('8XEjR'));

});



parcelRegister("bWmUQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRouteEntry", () => $3982899b389cbd5e$export$cf4a5eaa3cb7522f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jUN5r = parcelRequire("jUN5r");

var $aQoXd = parcelRequire("aQoXd");

var $jiE34 = parcelRequire("jiE34");

var $cJ4L7 = parcelRequire("cJ4L7");
const $3982899b389cbd5e$export$cf4a5eaa3cb7522f = (0, $6xToB.createEntry)((0, $jUN5r.projectSettingsServicedeskIssuetypesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: (0, $cJ4L7.getUFOName)('project-settings-servicedesk-issuetypes'),
        component: (0, $jiE34.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jiE34.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskIssuetypesRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskIssuetypesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jiE34", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSettings", () => $a09543c4156b447e$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $a09543c4156b447e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a09543c4156b447e$export$36dcfb52d47cb93a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j5ufr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $a09543c4156b447e$var$AsyncIssueTypeSettings = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a09543c4156b447e$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
var $a09543c4156b447e$export$2e2bcd8739ae039 = $a09543c4156b447e$var$AsyncIssueTypeSettings;

});

parcelRegister("cJ4L7", function(module, exports) {
$parcel$export(module.exports, "getUFOName", () => $08fa2836826db87f$export$759ec9adbd19c936);
const $08fa2836826db87f$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $08fa2836826db87f$export$759ec9adbd19c936 = (name)=>$08fa2836826db87f$var$ufoNamesMap[name] || name;

});


parcelRegister("hT9aM", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRouteEntry", () => $f13b731f46475de6$export$a6c573e3904e9dbd);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4YHpZ = parcelRequire("4YHpZ");

var $dZRaT = parcelRequire("dZRaT");

var $cxQGT = parcelRequire("cxQGT");

var $lb6FK = parcelRequire("lb6FK");

var $aQoXd = parcelRequire("aQoXd");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxKOj = parcelRequire("cxKOj");

var $cgXAH = parcelRequire("cgXAH");

var $jiE34 = parcelRequire("jiE34");

var $i2X0L = parcelRequire("i2X0L");
const $f13b731f46475de6$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $cgXAH.workflowBuilderProvisioningResource)
    ];
const $f13b731f46475de6$export$a6c573e3904e9dbd = (0, $6xToB.createEntry)((0, $4YHpZ.projectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $i2X0L.default),
        layout: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $aQoXd.serviceProjectLayout),
        navigation: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? [
            (0, $dZRaT.projectContextResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $lb6FK.rovoEntitlementResource),
            ...$f13b731f46475de6$var$getWorkflowBuilderProvisioningResources()
        ] : [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            ...$f13b731f46475de6$var$getWorkflowBuilderProvisioningResources(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false) ? [
            (0, $i2X0L.LazyWorkflowNavigationSettings)
        ] : [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jiE34.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskIssuetypesWorkflowRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskIssuetypesWorkflowRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4YHpZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRoute", () => $71fcdf9d5291b697$export$959cd36cc49d3b76);
const $71fcdf9d5291b697$export$959cd36cc49d3b76 = {
    name: 'project-settings-servicedesk-issuetypes-workflow',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("i2X0L", function(module, exports) {
$parcel$export(module.exports, "LazyWorkflowNavigationSettings", () => $a1d3154877c5e5ef$export$cb608e3696682e76);
$parcel$export(module.exports, "default", () => $a1d3154877c5e5ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a1d3154877c5e5ef$export$cb608e3696682e76 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4Bnpx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $a1d3154877c5e5ef$var$AsyncWorkflowNavigationSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a1d3154877c5e5ef$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
var $a1d3154877c5e5ef$export$2e2bcd8739ae039 = $a1d3154877c5e5ef$var$AsyncWorkflowNavigationSettings;

});


parcelRegister("dpK5U", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRouteEntry", () => $ca8160bc73736266$export$40ca23d1e05da300);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $g9kBK = parcelRequire("g9kBK");

var $5vwG0 = parcelRequire("5vwG0");

var $aQoXd = parcelRequire("aQoXd");

var $batW3 = parcelRequire("batW3");
const $ca8160bc73736266$export$40ca23d1e05da300 = (0, $6xToB.createEntry)((0, $5vwG0.projectSettingsServicedeskItsmFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-features-settings',
        component: (0, $batW3.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $g9kBK.featuresResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $batW3.LazyProjectSettingsServiceDeskItsmFeatures)
        ],
        perfMetricKey: 'jsm-features-settings',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskItsmFeaturesRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskItsmFeaturesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5vwG0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRoute", () => $98c64db85c471351$export$e60ffa2990540464);
const $98c64db85c471351$export$e60ffa2990540464 = {
    name: 'project-settings-servicedesk-itsm-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
    exact: true
};

});

parcelRegister("batW3", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", () => $4db313fe520648ff$export$562be1021beb9882);
$parcel$export(module.exports, "default", () => $4db313fe520648ff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4db313fe520648ff$export$562be1021beb9882 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cddpP"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
const $4db313fe520648ff$var$AsyncProjectSettingsServiceDeskItsmFeatures = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4db313fe520648ff$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });
var $4db313fe520648ff$export$2e2bcd8739ae039 = $4db313fe520648ff$var$AsyncProjectSettingsServiceDeskItsmFeatures;

});
parcelRegister("cddpP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l6WEm").then(()=>parcelRequire('dAPjL'));

});



parcelRegister("f60wn", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry", () => $c56af183e57f7925$export$49692fb0973d60ca);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $JHxCO = parcelRequire("JHxCO");

var $1mIde = parcelRequire("1mIde");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jGlrf = parcelRequire("jGlrf");
const $c56af183e57f7925$export$49692fb0973d60ca = (0, $6xToB.createEntry)((0, $1mIde.projectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jGlrf.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jGlrf.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-ticket-type-fields-entries/src/projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1mIde", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRoute", () => $2977d780ce1dd0ae$export$1af0541fcb95547b);
const $2977d780ce1dd0ae$export$1af0541fcb95547b = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?'
};

});

parcelRegister("jGlrf", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", () => $62d67bc476e72bc7$export$471040ce01e559fc);
$parcel$export(module.exports, "default", () => $62d67bc476e72bc7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gQZrP = parcelRequire("gQZrP");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $62d67bc476e72bc7$export$471040ce01e559fc = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6cvTW")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
const $62d67bc476e72bc7$var$AsyncProjectSettingsServiceDeskTicketTypeFields = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZrP.HelpCenterSettingsRedirect), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $62d67bc476e72bc7$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));
var $62d67bc476e72bc7$export$2e2bcd8739ae039 = $62d67bc476e72bc7$var$AsyncProjectSettingsServiceDeskTicketTypeFields;

});
parcelRegister("6cvTW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8I61X").then(()=>parcelRequire('b2cpi'));

});



parcelRegister("18Mhr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRouteEntry", () => $f44ec38807b3d67e$export$9f40815b933b51ba);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $2Armd = parcelRequire("2Armd");

var $JHxCO = parcelRequire("JHxCO");

var $g9kBK = parcelRequire("g9kBK");

var $9pooG = parcelRequire("9pooG");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $23er7 = parcelRequire("23er7");

var $g8uYY = parcelRequire("g8uYY");

var $4sBtm = parcelRequire("4sBtm");
const $f44ec38807b3d67e$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $23er7.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f44ec38807b3d67e$export$9f40815b933b51ba = (0, $6xToB.createEntry)((0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4sBtm.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return $f44ec38807b3d67e$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $kEdwd.servicedeskIssueTypesResource),
            (0, $2Armd.servicedeskPortalGroupsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $g9kBK.featuresResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4sBtm.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-ticket-types-config-entries/src/projectSettingsServicedeskItsmTicketTypesConfigRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskItsmTicketTypesConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2Armd", function(module, exports) {
$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $2ac7c9d08da185de$export$c7fb28234b909b2f);

var $l1VxS = parcelRequire("l1VxS");


const $2ac7c9d08da185de$var$getDataLoader = ()=>(parcelRequire("5nEYt"));
const $2ac7c9d08da185de$var$ONE_DAY_IN_MILLIS = 86400000;
const $2ac7c9d08da185de$export$c7fb28234b909b2f = (0, $l1VxS.createResource)({
    type: (0, $ffbd6364c6cc38ce$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $2ac7c9d08da185de$var$getDataLoader,
    maxAge: $2ac7c9d08da185de$var$ONE_DAY_IN_MILLIS
});

});
const $ffbd6364c6cc38ce$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("5nEYt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("6vBbv")
]).then(()=>parcelRequire('lwnQ4'));

});


parcelRegister("23er7", function(module, exports) {
$parcel$export(module.exports, "TicketTypesConfigEntrypoint", () => $da99b6cac6465d23$export$85bc484c6bab022d);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $1Bir5 = parcelRequire("1Bir5");

const $da99b6cac6465d23$export$85bc484c6bab022d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("fsB5Y")), {
        moduleId: "d08c0344",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const cloudId = tenantContext.cloudId;
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $1Bir5.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("1Bir5", function(module, exports) {
$parcel$export(module.exports, "requestTypeTableEntrypoint", () => $dc64eb020400b9a9$export$ecbf0c880decd2ac);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $5IyoN = parcelRequire("5IyoN");

const $dc64eb020400b9a9$export$ecbf0c880decd2ac = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("kzz4I")).then((module)=>module.RequestTypesTable), {
        moduleId: "a11d4ec7",
        moduleName: "RequestTypesTable",
        priority: "userVisible"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>{
        return {
            queries: {
                tableSettings: {
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    parameters: $5IyoN.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("5IyoN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ded07a7e73a0d52e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7444bf78694ffa88e3b450b7571d85c>>
 * @relayHash 97c579efae3d53fdf04fb24bd9e41dec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a26df09afb87015beb814bd83b211612ea3e5234a6864a889c4060cda4a5e33c
const $ded07a7e73a0d52e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a26df09afb87015beb814bd83b211612ea3e5234a6864a889c4060cda4a5e33c",
        "metadata": {},
        "name": "RequestTypesTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ded07a7e73a0d52e$export$2e2bcd8739ae039 = $ded07a7e73a0d52e$var$node;

});

parcelRegister("kzz4I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bxAxf").then(()=>parcelRequire('2TK39'));

});


parcelRegister("fsB5Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("10HP2").then(()=>parcelRequire('cURTI'));

});


parcelRegister("4sBtm", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", () => $e31003dd2f5c840b$export$c26e63f8b7d3b52c);
$parcel$export(module.exports, "default", () => $e31003dd2f5c840b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gQZrP = parcelRequire("gQZrP");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e31003dd2f5c840b$export$c26e63f8b7d3b52c = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7u0um")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
const $e31003dd2f5c840b$var$AsyncProjectSettingsServiceDeskTicketTypesConfig = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZrP.HelpCenterSettingsRedirect), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e31003dd2f5c840b$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));
var $e31003dd2f5c840b$export$2e2bcd8739ae039 = $e31003dd2f5c840b$var$AsyncProjectSettingsServiceDeskTicketTypesConfig;

});
parcelRegister("7u0um", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dFwxF").then(()=>parcelRequire('6JNBC'));

});



parcelRegister("iCcmc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRouteEntry", () => $733e81f66b242acb$export$5cbb0a0098e65c64);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $aURSi = parcelRequire("aURSi");

var $aQoXd = parcelRequire("aQoXd");

var $3JiWp = parcelRequire("3JiWp");
const $733e81f66b242acb$export$5cbb0a0098e65c64 = (0, $6xToB.createEntry)((0, $aURSi.projectSettingsServicedeskJourneyConfigurationEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration-edit',
        entryPoint: ()=>(0, $3JiWp.journeyConfigEditPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-journeys-entries/src/projectSettingsServicedeskJourneyConfigurationEditRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskJourneyConfigurationEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aURSi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRoute", () => $1602c17bde8ba847$export$f80f582ef54900c6);
const $1602c17bde8ba847$export$f80f582ef54900c6 = {
    name: 'project-settings-servicedesk-journey-configuration-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
    exact: true
};

});

parcelRegister("3JiWp", function(module, exports) {
$parcel$export(module.exports, "journeyConfigEditPageEntryPoint", () => $7cedf9bb5f9ce252$export$7388ef888b9170a7);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $PC8KQ = parcelRequire("PC8KQ");
const $7cedf9bb5f9ce252$export$7388ef888b9170a7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $PC8KQ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("PC8KQ", function(module, exports) {
$parcel$export(module.exports, "journeyConfigEntryPoint", () => $67104edf5aa204f7$export$26f82de7820f0c3);

var $g2u6t = parcelRequire("g2u6t");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $67104edf5aa204f7$export$26f82de7820f0c3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9Q4Lv")), {
        moduleId: "6bffb775",
        moduleName: "JourneyConfigurationPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        return {
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $g2u6t.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        journeyId: context.match.params.journeyId ?? '',
                        isEditing: context.match.path?.includes('journeys/:journeyId/edit')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("g2u6t", function(module, exports) {
$parcel$export(module.exports, "default", () => $be417e0989f393e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<855b76c9ab562215b63c3760ba34ef5f>>
 * @relayHash e6cfff3d0243792430f3f390f0e67cc5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 550c6239545e723c66e1868034184978f6d813ad2fed0618d637fdbe4244fceb

var $c9kik = parcelRequire("c9kik");

var $Cy06u = parcelRequire("Cy06u");

var $fiIP7 = parcelRequire("fiIP7");
const $be417e0989f393e7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "550c6239545e723c66e1868034184978f6d813ad2fed0618d637fdbe4244fceb",
        "metadata": {},
        "name": "JourneyConfigurationPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": (0, $c9kik.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderrovointegrationrelayprovider": (0, $fiIP7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderparenttriggerconditionsrelayprovider": (0, $c9kik.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjourneybuildertemplateanalyticsferelayprovider": (0, $Cy06u.default)
        }
    }
};
var $be417e0989f393e7$export$2e2bcd8739ae039 = $be417e0989f393e7$var$node;

});
parcelRegister("c9kik", function(module, exports) {
$parcel$export(module.exports, "default", () => $95b5bd382ee7fe55$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $95b5bd382ee7fe55$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('start-3761_journey-builder-parent-conditions');
    }
};

});

parcelRegister("Cy06u", function(module, exports) {
$parcel$export(module.exports, "default", () => $eed4a4d935d5a9cb$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $eed4a4d935d5a9cb$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('journey_builder_template_analytics_fe');
    }
};

});

parcelRegister("fiIP7", function(module, exports) {
$parcel$export(module.exports, "default", () => $cce49d4a6339b30b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $cce49d4a6339b30b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('journey_builder_rovo_integration');
    }
};

});


parcelRegister("9Q4Lv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2rHxz").then(()=>parcelRequire('g5gkO'));

});




parcelRegister("f0hVi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRouteEntry", () => $80846fcba3949f85$export$7475316a4561dd76);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $ao76L = parcelRequire("ao76L");

var $aQoXd = parcelRequire("aQoXd");

var $aU6Ad = parcelRequire("aU6Ad");
const $80846fcba3949f85$export$7475316a4561dd76 = (0, $6xToB.createEntry)((0, $ao76L.projectSettingsServicedeskJourneyConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration',
        entryPoint: ()=>(0, $aU6Ad.journeyConfigPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-journeys-entries/src/projectSettingsServicedeskJourneyConfigurationRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskJourneyConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ao76L", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRoute", () => $08cc01901e712a96$export$9013e78604bfadb0);
const $08cc01901e712a96$export$9013e78604bfadb0 = {
    name: 'project-settings-servicedesk-journey-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("aU6Ad", function(module, exports) {
$parcel$export(module.exports, "journeyConfigPageEntryPoint", () => $1e4d95712143af28$export$35537410b0bf07ea);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $PC8KQ = parcelRequire("PC8KQ");
const $1e4d95712143af28$export$35537410b0bf07ea = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $PC8KQ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("j9UDw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneysRouteEntry", () => $c1cbda040f9975dd$export$6c014a8c741bf222);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $frar7 = parcelRequire("frar7");

var $aQoXd = parcelRequire("aQoXd");

var $8DVKx = parcelRequire("8DVKx");
const $c1cbda040f9975dd$export$6c014a8c741bf222 = (0, $6xToB.createEntry)((0, $frar7.projectSettingsServicedeskJourneysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journeys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('journeys-list'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journeys',
        entryPoint: ()=>(0, $8DVKx.journeysPageEntryPoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-journeys-entries/src/projectSettingsServicedeskJourneysRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskJourneysRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("frar7", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskJourneysRoute", () => $d351fab09a3db8fb$export$627d71a1dd7a9593);
const $d351fab09a3db8fb$export$627d71a1dd7a9593 = {
    name: 'project-settings-servicedesk-journeys',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};

});

parcelRegister("8DVKx", function(module, exports) {
$parcel$export(module.exports, "journeysPageEntryPoint", () => $16a00dc6910336cf$export$3b90f0eb27bdd52f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $62QKB = parcelRequire("62QKB");
const $16a00dc6910336cf$export$3b90f0eb27bdd52f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $62QKB.journeysEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("62QKB", function(module, exports) {
$parcel$export(module.exports, "journeysEntryPoint", () => $07bd4ccae6b495a7$export$4ded7f93dbe6eb63);

var $6OVqu = parcelRequire("6OVqu");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $07bd4ccae6b495a7$export$4ded7f93dbe6eb63 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("a7rnu")), {
        moduleId: "ab11e2ef",
        moduleName: "JourneysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                journeysPageQueryRef: {
                    parameters: $6OVqu.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || ''
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("6OVqu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae595d5f231617c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d7e12696d948836effbfd1e33431bf51>>
 * @relayHash 5afb699a706480ed40b8e21f7e3b2be4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ece22b9005eec1ca80fb5eb1d513ffda47e38ad08767589730d23363074f219b
const $ae595d5f231617c6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ece22b9005eec1ca80fb5eb1d513ffda47e38ad08767589730d23363074f219b",
        "metadata": {},
        "name": "JourneysPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ae595d5f231617c6$export$2e2bcd8739ae039 = $ae595d5f231617c6$var$node;

});

parcelRegister("a7rnu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kXjNG").then(()=>parcelRequire('jN0Pk'));

});




parcelRegister("fmhFi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskKbRouteEntry", () => $f71de991dce104c4$export$d43e914d37d059b8);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $idiiX = parcelRequire("idiiX");

var $aQoXd = parcelRequire("aQoXd");

var $hekHg = parcelRequire("hekHg");

var $cfhyn = parcelRequire("cfhyn");
const $f71de991dce104c4$export$d43e914d37d059b8 = (0, $6xToB.createEntry)((0, $idiiX.projectSettingsServicedeskKbRoute), ()=>({
        group: 'project-settings-servicedesk',
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $cfhyn.ServiceDeskKnowledgeBaseV2),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cfhyn.LazyProjectSettingsServiceDeskKnowledgeBaseV2)
        ],
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $hekHg.getKBExperimentResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-knowledge-base-entries/src/projectSettingsServicedeskKbRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskKbRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cfhyn", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", () => $50a04f829d91e94a$export$7c7186fdd8c56428);
$parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", () => $50a04f829d91e94a$export$6d92735e249274bb);

var $eJOHy = parcelRequire("eJOHy");

var $gQZrP = parcelRequire("gQZrP");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");
const $50a04f829d91e94a$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $50a04f829d91e94a$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $50a04f829d91e94a$export$583a442626bd3345 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3F6V7")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $50a04f829d91e94a$export$7c7186fdd8c56428 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("xxOBv"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $50a04f829d91e94a$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gQZrP.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $50a04f829d91e94a$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
const $50a04f829d91e94a$var$AsyncProjectSettingsServiceDeskKnowledgeBaseV2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $50a04f829d91e94a$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });
var $50a04f829d91e94a$export$2e2bcd8739ae039 = $50a04f829d91e94a$var$AsyncProjectSettingsServiceDeskKnowledgeBaseV2;

});
parcelRegister("3F6V7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kdONd").then(()=>parcelRequire('lxnHp'));

});

parcelRegister("xxOBv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8IC4b").then(()=>parcelRequire('3R5ta'));

});



parcelRegister("1Zxl4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRouteEntry", () => $bdde8c2052f059a4$export$db3a99044f906462);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aHHHc = parcelRequire("aHHHc");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $6VIPQ = parcelRequire("6VIPQ");

var $bwRpv = parcelRequire("bwRpv");
const $bdde8c2052f059a4$export$db3a99044f906462 = (0, $6xToB.createEntry)((0, $aHHHc.projectSettingsServicedeskLanguageKeyRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.translations',
        component: (0, $bwRpv.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $6VIPQ.languageTranslationsResource),
            (0, $6VIPQ.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-banana'
            }
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwRpv.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        perfMetricKey: 'jsm-language-translations',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskLanguageKeyRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLanguageKeyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aHHHc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRoute", () => $ff2a7730ea3efa27$export$194a3f27b07aafec);
const $ff2a7730ea3efa27$export$194a3f27b07aafec = {
    name: 'project-settings-servicedesk-language-key',
    path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?'
};

});

parcelRegister("6VIPQ", function(module, exports) {
$parcel$export(module.exports, "languageTranslationsResource", () => $d72c5d70b0ef9c22$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $d72c5d70b0ef9c22$export$c460156a7e6b85b2);

var $l1VxS = parcelRequire("l1VxS");
const $d72c5d70b0ef9c22$export$9f529be3aeae01ea = 'JSM Language Translations';
const $d72c5d70b0ef9c22$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $d72c5d70b0ef9c22$export$f51887e33895eab9 = (0, $l1VxS.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$d72c5d70b0ef9c22$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("71poE")),
    maxAge: Infinity
});

const $d72c5d70b0ef9c22$export$c460156a7e6b85b2 = (0, $l1VxS.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$d72c5d70b0ef9c22$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("c8DMQ")),
    maxAge: Infinity
});

});
parcelRegister("71poE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dehcl").then(()=>parcelRequire('l5F6h'));

});

parcelRegister("c8DMQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aMQwG").then(()=>parcelRequire('fsKGx'));

});


parcelRegister("bwRpv", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", () => $f80c5817021de235$export$c029d3f514c7b3e0);
$parcel$export(module.exports, "default", () => $f80c5817021de235$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f80c5817021de235$export$c029d3f514c7b3e0 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cRJQ2")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
const $f80c5817021de235$var$AsyncProjectSettingsServiceDeskLanguageTranslations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f80c5817021de235$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });
var $f80c5817021de235$export$2e2bcd8739ae039 = $f80c5817021de235$var$AsyncProjectSettingsServiceDeskLanguageTranslations;

});
parcelRegister("cRJQ2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("e7SBQ")
]).then(()=>parcelRequire('krw7z'));

});



parcelRegister("2rBHC", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageRouteEntry", () => $ea38399893f32964$export$576b048795cbefad);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $h0nMy = parcelRequire("h0nMy");

var $aQoXd = parcelRequire("aQoXd");

var $61hqg = parcelRequire("61hqg");

var $bwRpv = parcelRequire("bwRpv");
const $ea38399893f32964$export$576b048795cbefad = (0, $6xToB.createEntry)((0, $h0nMy.projectSettingsServicedeskLanguageRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.languages',
        component: (0, $61hqg.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bwRpv.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskLanguageRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLanguageRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("h0nMy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLanguageRoute", () => $01ab2f4fbae10b74$export$99b0bbae92462ac2);
const $01ab2f4fbae10b74$export$99b0bbae92462ac2 = {
    name: 'project-settings-servicedesk-language',
    path: '/jira/servicedesk/projects/:projectKey/settings/language',
    exact: true
};

});

parcelRegister("61hqg", function(module, exports) {
$parcel$export(module.exports, "default", () => $759d708f8a2f847e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $759d708f8a2f847e$export$213b8279037c9d98 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9jPv3"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
const $759d708f8a2f847e$var$AsyncProjectSettingsServiceDeskLanguageSupport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $759d708f8a2f847e$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });
var $759d708f8a2f847e$export$2e2bcd8739ae039 = $759d708f8a2f847e$var$AsyncProjectSettingsServiceDeskLanguageSupport;

});
parcelRegister("9jPv3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jWWt8").then(()=>parcelRequire('ksMlh'));

});



parcelRegister("lxP9C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry", () => $284d310929ea3792$export$dd52be928c274980);

var $6xToB = parcelRequire("6xToB");

var $7iMQu = parcelRequire("7iMQu");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $284d310929ea3792$export$dd52be928c274980 = (0, $6xToB.createEntry)((0, $7iMQu.projectSettingsServicedeskLegacyAutomationRedirectCopyRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('copy'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7iMQu", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRoute", () => $f89447819405c1b0$export$869afe63d0e077be);
const $f89447819405c1b0$export$869afe63d0e077be = {
    name: 'project-settings-servicedesk-automation-redirect-copy',
    path: '/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("lKSeb", function(module, exports) {
$parcel$export(module.exports, "automationRedirect", () => $3afc8dba29b6c62d$export$d6674bfa636b8090);

var $eJOHy = parcelRequire("eJOHy");

var $7lJUT = parcelRequire("7lJUT");

var $FhXEJ = parcelRequire("FhXEJ");

var $2mHfh = parcelRequire("2mHfh");
// uses empty string instead of actual baseUrl as router redirect handles it internally
const $3afc8dba29b6c62d$var$newAutomationUrl = ({ match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $3afc8dba29b6c62d$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: $3afc8dba29b6c62d$var$newAutomationUrl(routeContext, pageType),
            push: false
        });
    };

});


parcelRegister("etWAS", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry", () => $b638b0b7c05060c3$export$fc7d1f3302418153);

var $6xToB = parcelRequire("6xToB");

var $gWImf = parcelRequire("gWImf");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $b638b0b7c05060c3$export$fc7d1f3302418153 = (0, $6xToB.createEntry)((0, $gWImf.projectSettingsServicedeskLegacyAutomationRedirectCreateRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('create'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gWImf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRoute", () => $295c7318f3662b0a$export$c2a59dbe6d23efd4);
const $295c7318f3662b0a$export$c2a59dbe6d23efd4 = {
    name: 'project-settings-servicedesk-automation-redirect-create',
    path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});


parcelRegister("lMs1U", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry", () => $41045a8199c69378$export$cf95450a3eafe8ff);

var $6xToB = parcelRequire("6xToB");

var $jFbOX = parcelRequire("jFbOX");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $41045a8199c69378$export$cf95450a3eafe8ff = (0, $6xToB.createEntry)((0, $jFbOX.projectSettingsServicedeskLegacyAutomationRedirectEditRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('edit'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jFbOX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRoute", () => $75603592285f10d6$export$f61e79c14e9bc0a1);
const $75603592285f10d6$export$f61e79c14e9bc0a1 = {
    name: 'project-settings-servicedesk-automation-redirect-edit',
    path: '/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});


parcelRegister("apRSQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry", () => $81b6ba8507e3173d$export$d6873ef17e5a0ea5);

var $6xToB = parcelRequire("6xToB");

var $1fVC8 = parcelRequire("1fVC8");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $81b6ba8507e3173d$export$d6873ef17e5a0ea5 = (0, $6xToB.createEntry)((0, $1fVC8.projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('summary'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1fVC8", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute", () => $d541891b8c3672dd$export$fdd432d4e600f9);
const $d541891b8c3672dd$export$fdd432d4e600f9 = {
    name: 'project-settings-servicedesk-automation-redirect-summary',
    path: '/projects/:projectKey/settings/automation/'
};

});


parcelRegister("evzjc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry", () => $3036458d0faa0f7a$export$f0eaafcdee9dfa31);

var $6xToB = parcelRequire("6xToB");

var $eYgxG = parcelRequire("eYgxG");

var $5RW99 = parcelRequire("5RW99");

var $aQoXd = parcelRequire("aQoXd");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lKSeb = parcelRequire("lKSeb");
const $3036458d0faa0f7a$export$f0eaafcdee9dfa31 = (0, $6xToB.createEntry)((0, $eYgxG.projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $lKSeb.automationRedirect)('viewlog'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-automation-entries/src/projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eYgxG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute", () => $3edc675b300a297c$export$e6e772830a33ba0b);
const $3edc675b300a297c$export$e6e772830a33ba0b = {
    name: 'project-settings-servicedesk-automation-redirect-viewlog',
    path: '/projects/:projectKey/settings/automation/log/:ruleId'
};

});


parcelRegister("dG9Ao", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry", () => $02a782d67138c58b$export$b4d122e49516c10d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $csrcH = parcelRequire("csrcH");

var $aQoXd = parcelRequire("aQoXd");

var $49ofR = parcelRequire("49ofR");

var $1VT2J = parcelRequire("1VT2J");
const $02a782d67138c58b$export$b4d122e49516c10d = (0, $6xToB.createEntry)((0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        isRedirect: true,
        component: (0, $49ofR.ServiceDeskCustomerNotificationsNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1VT2J.LazyProjectSettingsServiceDeskCustomerNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-customer-notifications-entries/src/projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("49ofR", function(module, exports) {
$parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", () => $7e0ece118f90f104$export$8249a46a710af6da);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $7e0ece118f90f104$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});


parcelRegister("eksQM", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRouteEntry", () => $f19ec1337dff05c0$export$ec0ead95e321b800);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $6WtFe = parcelRequire("6WtFe");

var $aQoXd = parcelRequire("aQoXd");

var $89DK8 = parcelRequire("89DK8");
const $f19ec1337dff05c0$export$ec0ead95e321b800 = (0, $6xToB.createEntry)((0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $89DK8.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $89DK8.LazyProjectSettingsNotificationEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskNotificationsEmailRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskNotificationsEmailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("89DK8", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $ab186adeaea4324b$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $ab186adeaea4324b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ab186adeaea4324b$export$ea7d73c94d9369f4 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hGlwH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $ab186adeaea4324b$var$AsyncProjectSettingsNotificationEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ab186adeaea4324b$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
var $ab186adeaea4324b$export$2e2bcd8739ae039 = $ab186adeaea4324b$var$AsyncProjectSettingsNotificationEmail;

});


parcelRegister("a0D4V", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry", () => $ec6dc7a41a147a38$export$4a15f2c244cd196c);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $buW1x = parcelRequire("buW1x");

var $aQoXd = parcelRequire("aQoXd");

var $ejTKN = parcelRequire("ejTKN");

var $aGYZJ = parcelRequire("aGYZJ");

var $21Rpn = parcelRequire("21Rpn");
const $ec6dc7a41a147a38$export$4a15f2c244cd196c = (0, $6xToB.createEntry)((0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $aGYZJ.serviceDeskInternalNotificationsNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $21Rpn.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $ejTKN.LazyInternalNotificationSettingsPage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aGYZJ", function(module, exports) {
$parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", () => $d0a2a76c15b5581c$export$49625f83fe7ecc69);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $d0a2a76c15b5581c$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});


parcelRegister("7mKmY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRouteEntry", () => $3c3e9e2d2db5e2be$export$cc1164e0e5db595);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $iPhgi = parcelRequire("iPhgi");

var $aQoXd = parcelRequire("aQoXd");

var $89DK8 = parcelRequire("89DK8");

var $zt2zq = parcelRequire("zt2zq");
const $3c3e9e2d2db5e2be$export$cc1164e0e5db595 = (0, $6xToB.createEntry)((0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $zt2zq.ServiceDeskNotificationEmailNextGenRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $89DK8.LazyProjectSettingsNotificationEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskNotificationsNotificationEmailRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskNotificationsNotificationEmailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("zt2zq", function(module, exports) {
$parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", () => $bc23de3cd1331e8c$export$735e58642f560ddc);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $bc23de3cd1331e8c$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: url
    });
};

});


parcelRegister("5UnPY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRouteEntry", () => $175512a96a8bbead$export$20923f853e06d781);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $cK42t = parcelRequire("cK42t");

var $aQoXd = parcelRequire("aQoXd");

var $ipaDV = parcelRequire("ipaDV");
const $175512a96a8bbead$export$20923f853e06d781 = (0, $6xToB.createEntry)((0, $cK42t.projectSettingsServicedeskNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $ipaDV.notificationsRedirect)('customer-notifications'),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskNotificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cK42t", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRoute", () => $f9ccd1e5cc46db9e$export$dbc53740e1d7ff79);
const $f9ccd1e5cc46db9e$export$dbc53740e1d7ff79 = {
    name: 'project-settings-servicedesk-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("ipaDV", function(module, exports) {
$parcel$export(module.exports, "notificationsRedirect", () => $657d57b36eca46ef$export$59144dd4441639fa);

var $eJOHy = parcelRequire("eJOHy");

var $7lJUT = parcelRequire("7lJUT");

var $FhXEJ = parcelRequire("FhXEJ");

var $2mHfh = parcelRequire("2mHfh");
const $657d57b36eca46ef$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $7lJUT.getNextgenSettingsUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("dOUgk", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRouteEntry", () => $b71ef8069204d6e4$export$2f07a0943f4553c4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dOEVM = parcelRequire("dOEVM");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $kEhEs = parcelRequire("kEhEs");

var $cxsKb = parcelRequire("cxsKb");
const $b71ef8069204d6e4$export$2f07a0943f4553c4 = (0, $6xToB.createEntry)((0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cxsKb.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $kEhEs.serviceDeskPortalClassicSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cxsKb.LazyProjectSettingsServiceDeskClassicPortalSettings)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskPortalSettingsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskPortalSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kEhEs", function(module, exports) {
$parcel$export(module.exports, "serviceDeskPortalClassicSettingsResource", () => $3141dc52973d1c7d$export$2c58fa923657baed);

var $9FYIg = parcelRequire("9FYIg");

var $jEb7C = parcelRequire("jEb7C");
const $3141dc52973d1c7d$export$2c58fa923657baed = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SERVICE_DESK_PORTAL_CLASSIC_SETTINGS`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $jEb7C.default),
            variables: {
                cloudIdString: cloudId,
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("jEb7C", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea842b48bdaf8b87$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96759f58028e86a8ff8d7ebc378a340d>>
 * @relayHash b41cf629208c69eb2e1533d741a479ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b96fcf0cbb5b600a9fce1e81b438e97c3e32beb20189a2909f49d16d5578b7e9

var $4NG3g = parcelRequire("4NG3g");

var $kEBh8 = parcelRequire("kEBh8");
const $ea842b48bdaf8b87$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdString"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudIdString"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyEditableAgents": true
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": v3 /*: any*/ ,
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
            {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    }
                ]
            },
            {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "AgentStudioAssistant",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "externalConfigReference"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "identityAccountId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "creatorType"
                            },
                            v4 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "cursor"
                    }
                ]
            }
        ]
    }, v6 = {
        "args": v3 /*: any*/ ,
        "filters": [
            "cloudId",
            "input"
        ],
        "handle": "connection",
        "key": "RovoAgent_agentStudio_getAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ClassicPortalSettingsQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "cloudIdString",
                            "variableName": "cloudIdString"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PortalSettings"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ClassicPortalSettingsQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "atlassianStudio_userSiteContext",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "AtlassianStudioUserProductPermissions",
                                            "kind": "LinkedField",
                                            "name": "userPermissions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAbleToCreateAgents"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AtlassianStudioUserSiteContextOutput"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b96fcf0cbb5b600a9fce1e81b438e97c3e32beb20189a2909f49d16d5578b7e9",
            "metadata": {},
            "name": "ClassicPortalSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": (0, $kEBh8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": (0, $4NG3g.default)
            }
        }
    };
}();
$ea842b48bdaf8b87$var$node.hash = "f6bb257b47e1fe1b359c1df932c2a29f";
var $ea842b48bdaf8b87$export$2e2bcd8739ae039 = $ea842b48bdaf8b87$var$node;

});


parcelRegister("cxsKb", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", () => $ec991522ca4e9b2a$export$eb662b618d6247be);
$parcel$export(module.exports, "default", () => $ec991522ca4e9b2a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ec991522ca4e9b2a$export$eb662b618d6247be = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3a5fp"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx"
});
const $ec991522ca4e9b2a$var$AsyncProjectSettingsServiceDeskClassicPortalSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec991522ca4e9b2a$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });
var $ec991522ca4e9b2a$export$2e2bcd8739ae039 = $ec991522ca4e9b2a$var$AsyncProjectSettingsServiceDeskClassicPortalSettings;

});
parcelRegister("3a5fp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("K8dIZ").then(()=>parcelRequire('hePYz'));

});



parcelRegister("kxzOk", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRouteEntry", () => $c1f5291e9c274e3f$export$f7bbe7fb3eeb9258);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dWzDb = parcelRequire("dWzDb");

var $aQoXd = parcelRequire("aQoXd");

var $ff6mX = parcelRequire("ff6mX");
const $c1f5291e9c274e3f$export$f7bbe7fb3eeb9258 = (0, $6xToB.createEntry)((0, $dWzDb.projectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $ff6mX.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ff6mX.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskProformaJiraFormBuilderRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskProformaJiraFormBuilderRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dWzDb", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRoute", () => $476746b8998f854f$export$f2a7862c8cde472d);
const $476746b8998f854f$export$f2a7862c8cde472d = {
    name: 'project-settings-servicedesk-proforma-jira-form-builder',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("ff6mX", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $eb7b62859f8417fa$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $eb7b62859f8417fa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $eb7b62859f8417fa$export$a7d63246a10aedd = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("87BMN")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $eb7b62859f8417fa$var$AsyncProjectSettingsProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $eb7b62859f8417fa$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
var $eb7b62859f8417fa$export$2e2bcd8739ae039 = $eb7b62859f8417fa$var$AsyncProjectSettingsProformaJiraFormBuilder;

});


parcelRegister("3uU32", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRouteEntry", () => $70e17818bf649559$export$f0d9fbaec8a9f2a);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7B6GN = parcelRequire("7B6GN");

var $aQoXd = parcelRequire("aQoXd");

var $cOFxR = parcelRequire("cOFxR");
const $70e17818bf649559$export$f0d9fbaec8a9f2a = (0, $6xToB.createEntry)((0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cOFxR.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cOFxR.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskProformaProjectFormsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskProformaProjectFormsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cOFxR", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $ac6c25bcfe8ebf52$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $ac6c25bcfe8ebf52$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ac6c25bcfe8ebf52$export$38414b624a749cec = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hZVDr")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $ac6c25bcfe8ebf52$var$AsyncProjectSettingsProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ac6c25bcfe8ebf52$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
var $ac6c25bcfe8ebf52$export$2e2bcd8739ae039 = $ac6c25bcfe8ebf52$var$AsyncProjectSettingsProformaProjectForms;

});


parcelRegister("bpzvw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRedirectRouteEntry", () => $efced346f7bd31d3$export$a0279fafdeb78607);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $efnXG = parcelRequire("efnXG");

var $aQoXd = parcelRequire("aQoXd");

var $gwoLH = parcelRequire("gwoLH");
const $efced346f7bd31d3$export$a0279fafdeb78607 = (0, $6xToB.createEntry)((0, $efnXG.projectSettingsServicedeskRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        isRedirect: true,
        component: (0, $gwoLH.defaultRedirectForSettings)((0, $gwoLH.SERVICE_DESK_PRODUCT)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("efnXG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRedirectRoute", () => $bfc01b189be62c12$export$3fbe0a89e4d1e816);
const $bfc01b189be62c12$export$3fbe0a89e4d1e816 = {
    name: 'project-settings-servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings'
};

});


parcelRegister("ff2yD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoServiceAgentRouteEntry", () => $e180469ee0447e3a$export$9603f70010abac7d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4Qe88 = parcelRequire("4Qe88");

var $aQoXd = parcelRequire("aQoXd");

var $JPa8F = parcelRequire("JPa8F");
const $e180469ee0447e3a$export$9603f70010abac7d = (0, $6xToB.createEntry)((0, $4Qe88.projectSettingsServicedeskRovoServiceAgentRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-rovo-service-agent-settings',
        component: (0, $JPa8F.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $JPa8F.LazyProjectSettingsServiceDeskRovoServiceAgent)
        ],
        perfMetricKey: 'jsm-rovo-service-agent-settings',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskRovoServiceAgentRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskRovoServiceAgentRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4Qe88", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskRovoServiceAgentRoute", () => $f686fd472467a6e9$export$1a7cb35d9e086061);
const $f686fd472467a6e9$export$1a7cb35d9e086061 = {
    name: 'project-settings-servicedesk-rovo-service-agent',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent',
    exact: true
};

});

parcelRegister("JPa8F", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskRovoServiceAgent", () => $70834f8b7804866a$export$aea40d500709e2b5);
$parcel$export(module.exports, "default", () => $70834f8b7804866a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $70834f8b7804866a$export$aea40d500709e2b5 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("grA47"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-rovo-service-agent/src/ui/RovoServiceAgentView.tsx"
});
const $70834f8b7804866a$var$ServicedeskRovoServiceAgentComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $70834f8b7804866a$export$aea40d500709e2b5,
        pageId: "project-settings-rovo-service-agent",
        shouldShowSpinner: true
    });
var $70834f8b7804866a$export$2e2bcd8739ae039 = $70834f8b7804866a$var$ServicedeskRovoServiceAgentComponent;

});
parcelRegister("grA47", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lPUcx").then(()=>parcelRequire('6VJF5'));

});



parcelRegister("fHVxn", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskSurveysRouteEntry", () => $18c99c1b84194152$export$d54092e6e6547adc);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $4cTDP = parcelRequire("4cTDP");

var $6jHrB = parcelRequire("6jHrB");

var $aQoXd = parcelRequire("aQoXd");

var $fgmF7 = parcelRequire("fgmF7");
const $18c99c1b84194152$export$d54092e6e6547adc = (0, $6xToB.createEntry)((0, $6jHrB.projectSettingsServicedeskSurveysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.surveys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('surveys-list'),
                teamName: 'JSM Phoenix'
            }
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-surveys',
        entryPoint: ()=>(0, $4cTDP.fg)('phx-2293_add_surveys_routes_under_project_settings') ? (0, $fgmF7.surveysPageEntryPoint) : undefined,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-surveys-entries/src/projectSettingsServicedeskSurveysRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskSurveysRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6jHrB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskSurveysRoute", () => $1e2bd9e670b9fcde$export$b0746e83cd0ef60f);
const $1e2bd9e670b9fcde$export$b0746e83cd0ef60f = {
    name: 'project-settings-servicedesk-surveys',
    path: '/jira/servicedesk/projects/:projectKey/settings/surveys/:surveyId?'
};

});

parcelRegister("fgmF7", function(module, exports) {
$parcel$export(module.exports, "surveysPageEntryPoint", () => $d33886776e04a7b8$export$89090149a538f2bd);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jx1rw = parcelRequire("jx1rw");
const $d33886776e04a7b8$export$89090149a538f2bd = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jx1rw.surveysEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("jx1rw", function(module, exports) {
$parcel$export(module.exports, "surveysEntryPoint", () => $1a819897fdaf0df1$export$afe6a4612d77e23e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1a819897fdaf0df1$export$afe6a4612d77e23e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lJD68")), {
        moduleId: "999c80e9",
        moduleName: "SurveysPage",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                context: context
            }
        })
});

});
parcelRegister("lJD68", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4tlRi").then(()=>parcelRequire('5LmZi'));

});




parcelRegister("5Ojcr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRouteEntry", () => $d05ee6481ca3495f$export$30951c6038a30ec4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $JHxCO = parcelRequire("JHxCO");

var $73X9K = parcelRequire("73X9K");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jGlrf = parcelRequire("jGlrf");
const $d05ee6481ca3495f$export$30951c6038a30ec4 = (0, $6xToB.createEntry)((0, $73X9K.projectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jGlrf.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jGlrf.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-ticket-type-fields-entries/src/projectSettingsServicedeskTicketTypeFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskTicketTypeFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("73X9K", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRoute", () => $dd2f232fea3fd1cb$export$6c99c477ef7583ba);
const $dd2f232fea3fd1cb$export$6c99c477ef7583ba = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("3Yt6X", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRouteEntry", () => $3b9cbba88532f3e8$export$bcc0bb7cf7f75a0f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $2Armd = parcelRequire("2Armd");

var $JHxCO = parcelRequire("JHxCO");

var $g9kBK = parcelRequire("g9kBK");

var $jmJlK = parcelRequire("jmJlK");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $23er7 = parcelRequire("23er7");

var $g8uYY = parcelRequire("g8uYY");

var $4sBtm = parcelRequire("4sBtm");
const $3b9cbba88532f3e8$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $23er7.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $3b9cbba88532f3e8$export$bcc0bb7cf7f75a0f = (0, $6xToB.createEntry)((0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4sBtm.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $kEdwd.servicedeskIssueTypesResource),
            (0, $2Armd.servicedeskPortalGroupsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $g9kBK.featuresResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4sBtm.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        entryPoint () {
            return $3b9cbba88532f3e8$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-ticket-types-config-entries/src/projectSettingsServicedeskTicketTypesConfigRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskTicketTypesConfigRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("hAJ7N", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry", () => $db1e39ec6021d647$export$515ee5ae44539ca4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $JHxCO = parcelRequire("JHxCO");

var $boNcA = parcelRequire("boNcA");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jGlrf = parcelRequire("jGlrf");
const $db1e39ec6021d647$export$515ee5ae44539ca4 = (0, $6xToB.createEntry)((0, $boNcA.projectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $jGlrf.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jGlrf.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-ticket-type-fields-entries/src/projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("boNcA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRoute", () => $e89de84d8f540f5f$export$f7a986e844a111a6);
const $e89de84d8f540f5f$export$f7a986e844a111a6 = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("e9fEq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry", () => $5eea8950f1d4bbd6$export$6ba31a548ab77c4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $2Armd = parcelRequire("2Armd");

var $JHxCO = parcelRequire("JHxCO");

var $g9kBK = parcelRequire("g9kBK");

var $88a5z = parcelRequire("88a5z");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $23er7 = parcelRequire("23er7");

var $g8uYY = parcelRequire("g8uYY");

var $4sBtm = parcelRequire("4sBtm");
const $5eea8950f1d4bbd6$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $23er7.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $5eea8950f1d4bbd6$export$6ba31a548ab77c4 = (0, $6xToB.createEntry)((0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4sBtm.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $JHxCO.servicedeskPracticesResource),
            (0, $kEdwd.servicedeskIssueTypesResource),
            (0, $2Armd.servicedeskPortalGroupsResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $g9kBK.featuresResource)
        ],
        entryPoint () {
            return $5eea8950f1d4bbd6$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4sBtm.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-ticket-types-config-entries/src/projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("jxIae", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWidgetRouteEntry", () => $9a9ed069fc4c7c1a$export$d86db47c21552ca);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ihecD = parcelRequire("ihecD");

var $aQoXd = parcelRequire("aQoXd");

var $9btIX = parcelRequire("9btIX");
const $9a9ed069fc4c7c1a$export$d86db47c21552ca = (0, $6xToB.createEntry)((0, $ihecD.projectSettingsServicedeskWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $9btIX.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btIX.LazyProjectSettingsServiceDeskWidgetSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskWidgetRouteEntry.tsx',
                whichExportToUse: 'projectSettingsServicedeskWidgetRouteEntry'
            },
            enabled: true
        }
    }));

});

parcelRegister("19r4K", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRouteEntry", () => $eca8b990e5d6e664$export$99415df4033272f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $AmstK = parcelRequire("AmstK");

var $8FCAy = parcelRequire("8FCAy");

var $a0ftS = parcelRequire("a0ftS");

var $5JAAk = parcelRequire("5JAAk");
const $eca8b990e5d6e664$export$99415df4033272f = (0, $6xToB.createEntry)((0, $AmstK.projectSettingsSoftwareAccessRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $a0ftS.peopleAccessRedirect)(`/jira/${(0, $5JAAk.SOFTWARE_PRODUCT)}`),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a0ftS.LazyPeopleSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareAccessRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareAccessRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("AmstK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRoute", () => $a21d00e6cb269a17$export$55335c81a2be4654);
const $a21d00e6cb269a17$export$55335c81a2be4654 = {
    name: 'project-settings-software-access-redirect',
    path: '/jira/software/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("a0ftS", function(module, exports) {
$parcel$export(module.exports, "LazyPeopleSettings", () => $0e1df35189c810eb$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $0e1df35189c810eb$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $0e1df35189c810eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");

const $0e1df35189c810eb$export$7eee4f97b7a1273 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4R95R"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $0e1df35189c810eb$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $0e1df35189c810eb$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0e1df35189c810eb$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
const $0e1df35189c810eb$var$AsyncPeopleSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0e1df35189c810eb$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
var $0e1df35189c810eb$export$2e2bcd8739ae039 = $0e1df35189c810eb$var$AsyncPeopleSettings;

});


parcelRegister("1Dztl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRouteEntry", () => $add8e9c5eb5c357d$export$a5ead9d0de14b14b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $itaVS = parcelRequire("itaVS");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $a0ftS = parcelRequire("a0ftS");

var $5JAAk = parcelRequire("5JAAk");
const $add8e9c5eb5c357d$export$a5ead9d0de14b14b = (0, $6xToB.createEntry)((0, $itaVS.projectSettingsSoftwareAccessRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $bmwpE.ProjectSettingsAccessSkeleton),
        component: (0, $a0ftS.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a0ftS.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareAccessRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareAccessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("itaVS", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAccessRoute", () => $e7e217966d5db1d1$export$db689602f90567d8);
const $e7e217966d5db1d1$export$db689602f90567d8 = {
    name: 'project-settings-software-access',
    path: '/jira/software/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("1O3Ea", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRouteEntry", () => $1effd20da3507d2b$export$78d9c4be1503dd23);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $j9joM = parcelRequire("j9joM");

var $8FCAy = parcelRequire("8FCAy");

var $44K8H = parcelRequire("44K8H");

var $5JAAk = parcelRequire("5JAAk");
const $1effd20da3507d2b$export$78d9c4be1503dd23 = (0, $6xToB.createEntry)((0, $j9joM.projectSettingsSoftwareAppsFieldsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $44K8H.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $44K8H.LazyConnectAppControlsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareAppsFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareAppsFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("j9joM", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRoute", () => $e7281b621552f46e$export$333c94a9ec1a1535);
const $e7281b621552f46e$export$333c94a9ec1a1535 = {
    name: 'project-settings-software-apps-fields',
    path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("44K8H", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $56bfed5227fc70c1$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $56bfed5227fc70c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $56bfed5227fc70c1$export$246ec9cdadd2a163 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lETKK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $56bfed5227fc70c1$var$AsyncConnectAppControlsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $56bfed5227fc70c1$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
var $56bfed5227fc70c1$export$2e2bcd8739ae039 = $56bfed5227fc70c1$var$AsyncConnectAppControlsSettings;

});


parcelRegister("e9Gfy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsRouteEntry", () => $a5684f9b54699d69$export$290fcdffa80c48ce);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9sw1i = parcelRequire("9sw1i");

var $8FCAy = parcelRequire("8FCAy");

var $aoTfc = parcelRequire("aoTfc");

var $5JAAk = parcelRequire("5JAAk");
const $a5684f9b54699d69$export$290fcdffa80c48ce = (0, $6xToB.createEntry)((0, $9sw1i.projectSettingsSoftwareAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $aoTfc.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aoTfc.LazyConnectAppsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareAppsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareAppsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9sw1i", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAppsRoute", () => $9d5f34930bd0eff8$export$aece357f5f434121);
const $9d5f34930bd0eff8$export$aece357f5f434121 = {
    name: 'project-settings-software-apps',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("aoTfc", function(module, exports) {
$parcel$export(module.exports, "LazyConnectAppsSettings", () => $52a3e6213c7bbeb6$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $52a3e6213c7bbeb6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $52a3e6213c7bbeb6$export$3633e017e520a1c2 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("7LGN1"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $52a3e6213c7bbeb6$var$AsyncConnectAppsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $52a3e6213c7bbeb6$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
var $52a3e6213c7bbeb6$export$2e2bcd8739ae039 = $52a3e6213c7bbeb6$var$AsyncConnectAppsSettings;

});


parcelRegister("7RDKl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAutomationRouteEntry", () => $1ce021a445899fcc$export$fb1f0477184046c5);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $drvCc = parcelRequire("drvCc");

var $8FCAy = parcelRequire("8FCAy");

var $ciVnR = parcelRequire("ciVnR");

var $5JAAk = parcelRequire("5JAAk");
const $1ce021a445899fcc$export$fb1f0477184046c5 = (0, $6xToB.createEntry)((0, $drvCc.projectSettingsSoftwareAutomationRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $ciVnR.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ciVnR.LazyProjectSettingsJiraAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareAutomationRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareAutomationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("drvCc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", () => $bdbd1f967e44e700$export$4d430aeb28b702f8);
const $bdbd1f967e44e700$export$4d430aeb28b702f8 = {
    name: 'project-settings-software-automation',
    path: '/jira/software/projects/:projectKey/settings/automation',
    exact: true
};

});


parcelRegister("b2ykh", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRouteEntry", () => $666732fd1f3bb024$export$ca616a5516b2e16d);

var $5W8Xv = parcelRequire("5W8Xv");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $2OwuX = parcelRequire("2OwuX");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $9100b = parcelRequire("9100b");
const $666732fd1f3bb024$export$ca616a5516b2e16d = (0, $6xToB.createEntry)((0, $2OwuX.projectSettingsSoftwareBoardsCardRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $9100b.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $5W8Xv.cardCoverImageResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9100b.LazyCard)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareBoardsCardRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareBoardsCardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5W8Xv", function(module, exports) {
$parcel$export(module.exports, "cardCoverImageResource", () => $cba19a2cccf3fb98$export$f37f52e28126ce75);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $lRcId = parcelRequire("lRcId");
const $cba19a2cccf3fb98$var$RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';
const $cba19a2cccf3fb98$export$f37f52e28126ce75 = (0, $9FYIg.createRelayResource)({
    type: $cba19a2cccf3fb98$var$RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $lRcId.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("lRcId", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb94b41ae2ff437$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52de87b56e2bb32df43481ea989439e2>>
 * @relayHash 139fae60f7b439ca7bbb2ae98032bdd1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e236e8096731e034049b4c120abe65ae117a620f5e0a8023028cb0064f1b65e
const $dcb94b41ae2ff437$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CardCoverPageContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "CardPreview"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CardCoverPageContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "3e236e8096731e034049b4c120abe65ae117a620f5e0a8023028cb0064f1b65e",
            "metadata": {},
            "name": "CardCoverPageContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dcb94b41ae2ff437$var$node.hash = "d86a54c6a42dc0ffbbcab92ac932cf91";
var $dcb94b41ae2ff437$export$2e2bcd8739ae039 = $dcb94b41ae2ff437$var$node;

});


parcelRegister("2OwuX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", () => $06c755143651aab7$export$d3f185a361401db7);
const $06c755143651aab7$export$d3f185a361401db7 = {
    name: 'project-settings-software-boards-card',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
    exact: true
};

});

parcelRegister("9100b", function(module, exports) {
$parcel$export(module.exports, "LazyCard", () => $611ba7f62ba67427$export$40ff283c032abbc4);
$parcel$export(module.exports, "default", () => $611ba7f62ba67427$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $611ba7f62ba67427$export$40ff283c032abbc4 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6mMYg")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
const $611ba7f62ba67427$var$AsyncCard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $611ba7f62ba67427$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });
var $611ba7f62ba67427$export$2e2bcd8739ae039 = $611ba7f62ba67427$var$AsyncCard;

});
parcelRegister("6mMYg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("6BFaI")),
    $ewTvA("kIhjz")
]).then(()=>parcelRequire('hCcnT'));

});



parcelRegister("g8YQf", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRouteEntry", () => $f3a6a68938c61a15$export$7a31e42733ba05a0);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $eSDVj = parcelRequire("eSDVj");

var $8FCAy = parcelRequire("8FCAy");

var $bKZ40 = parcelRequire("bKZ40");

var $5JAAk = parcelRequire("5JAAk");
const $f3a6a68938c61a15$export$7a31e42733ba05a0 = (0, $6xToB.createEntry)((0, $eSDVj.projectSettingsSoftwareBoardsCsmRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $bKZ40.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bKZ40.LazyCsmSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareBoardsCsmRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareBoardsCsmRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eSDVj", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", () => $7fec64f300556675$export$88e68eb447e3db49);
const $7fec64f300556675$export$88e68eb447e3db49 = {
    name: 'project-settings-software-boards-csm',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
    exact: true
};

});

parcelRegister("bKZ40", function(module, exports) {
$parcel$export(module.exports, "LazyCsmSettings", () => $8bd9f312c30150fe$export$de293ea44d0410ca);
$parcel$export(module.exports, "default", () => $8bd9f312c30150fe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8bd9f312c30150fe$export$de293ea44d0410ca = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jtoET"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
const $8bd9f312c30150fe$var$AsyncCsmSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8bd9f312c30150fe$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });
var $8bd9f312c30150fe$export$2e2bcd8739ae039 = $8bd9f312c30150fe$var$AsyncCsmSettings;

});
parcelRegister("jtoET", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("6jMBi")),
    $ewTvA("hsF7T")
]).then(()=>parcelRequire('gCEEF'));

});



parcelRegister("4OHhm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRouteEntry", () => $a3b688a9312ca1b4$export$6332ad3e1d8d721);

var $itXmR = parcelRequire("itXmR");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $d257s = parcelRequire("d257s");

var $8FCAy = parcelRequire("8FCAy");

var $9bYiw = parcelRequire("9bYiw");

var $5JAAk = parcelRequire("5JAAk");
const $a3b688a9312ca1b4$export$6332ad3e1d8d721 = (0, $6xToB.createEntry)((0, $d257s.projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.custom-filters',
        component: (0, $9bYiw.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $itXmR.customFiltersResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9bYiw.LazyCustomFiltersSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareBoardsCustomFiltersRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareBoardsCustomFiltersRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("itXmR", function(module, exports) {
$parcel$export(module.exports, "customFiltersResource", () => $719476bab6bcf1ab$export$3e390340716755de);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $jY58K = parcelRequire("jY58K");
const $719476bab6bcf1ab$var$RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
const $719476bab6bcf1ab$export$3e390340716755de = (0, $9FYIg.createRelayResource)({
    type: $719476bab6bcf1ab$var$RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $jY58K.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("jY58K", function(module, exports) {
$parcel$export(module.exports, "default", () => $c73681c29fcc8585$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7cad008263546a970a215307458695c5>>
 * @relayHash 3e127a8a0f105d7dd3ffaf6658d29ff9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21aece67f1d4694a9ebcffa7e9910b5c638b92b86e44e42e66847c971c685c75
const $c73681c29fcc8585$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomFiltersLoaderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "CardCustomFiltersFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "CardCustomFilterBoardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ExpandedCardCustomFilterBoardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomFiltersLoaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "21aece67f1d4694a9ebcffa7e9910b5c638b92b86e44e42e66847c971c685c75",
            "metadata": {},
            "name": "CustomFiltersLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c73681c29fcc8585$var$node.hash = "9a24a10cb36d4bf37d5ade9f70e0437e";
var $c73681c29fcc8585$export$2e2bcd8739ae039 = $c73681c29fcc8585$var$node;

});


parcelRegister("d257s", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", () => $d41829c4c2ebff91$export$9bc9b345958a301c);
const $d41829c4c2ebff91$export$9bc9b345958a301c = {
    name: 'project-settings-software-boards-custom-filters',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
    exact: true
};

});

parcelRegister("9bYiw", function(module, exports) {
$parcel$export(module.exports, "LazyCustomFiltersSettings", () => $9912f484a3377ff4$export$7e21d36a9d4548e6);
$parcel$export(module.exports, "default", () => $9912f484a3377ff4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9912f484a3377ff4$export$7e21d36a9d4548e6 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6rbiX")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
const $9912f484a3377ff4$var$AsyncCustomFiltersSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9912f484a3377ff4$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });
var $9912f484a3377ff4$export$2e2bcd8739ae039 = $9912f484a3377ff4$var$AsyncCustomFiltersSettings;

});
parcelRegister("6rbiX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jNUXl").then(()=>parcelRequire('fx0K9'));

});



parcelRegister("3qny0", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRouteEntry", () => $eda55a7d7f657a4e$export$cb6169207ddfd1b2);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $7uOHY = parcelRequire("7uOHY");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");

var $5JAAk = parcelRequire("5JAAk");
const $eda55a7d7f657a4e$export$cb6169207ddfd1b2 = (0, $6xToB.createEntry)((0, $7uOHY.projectSettingsSoftwareBoardsRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bMm2d.BoardSettingsRedirectToCSM),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareBoardsRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareBoardsRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7uOHY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", () => $12f7b3f7e0482667$export$989ca67485551616);
const $12f7b3f7e0482667$export$989ca67485551616 = {
    name: 'project-settings-software-boards-redirect',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
    exact: true
};

});


parcelRegister("yk8YA", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRouteEntry", () => $3a766fb49c8d76d3$export$6d5eadd440c430f5);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6ZOOP = parcelRequire("6ZOOP");

var $aQRnD = parcelRequire("aQRnD");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");

var $5JAAk = parcelRequire("5JAAk");

var $eawym = parcelRequire("eawym");
const $3a766fb49c8d76d3$export$6d5eadd440c430f5 = (0, $6xToB.createEntry)((0, $aQRnD.projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bMm2d.RoadmapSettingsRedirectToTimelineSettings),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $6ZOOP.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $eawym.LazyRoadmap)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareBoardsRoadmapRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareBoardsRoadmapRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6ZOOP", function(module, exports) {
$parcel$export(module.exports, "roadmapSettingsResource", () => $1e1651d8dbf744cf$export$7901a008bd73bf46);

var $dVkWN = parcelRequire("dVkWN");

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

const $1e1651d8dbf744cf$export$7901a008bd73bf46 = (0, $9FYIg.createRelayResource)({
    type: (0, $0a39a0a4006d2a49$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $dVkWN.default),
            variables: {
                sourceAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("dVkWN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f37224856cc79fd2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e8f0f896e36576b608edd9ae307be70>>
 * @relayHash 843eef387f7f0cb53cf3fed2191cc36d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 769504860593365a143aeea3bd2de7134a061619ea7fbf34c3f188189dfb1e9f
const $f37224856cc79fd2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RoadmapPageLoaderQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ChildIssuesSchedulingToggle"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ChildIssuesSchedulingPreview"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RoadmapPageLoaderQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "769504860593365a143aeea3bd2de7134a061619ea7fbf34c3f188189dfb1e9f",
            "metadata": {},
            "name": "RoadmapPageLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f37224856cc79fd2$var$node.hash = "315e874b325a4c87e0fd376eaa279ef0";
var $f37224856cc79fd2$export$2e2bcd8739ae039 = $f37224856cc79fd2$var$node;

});

const $0a39a0a4006d2a49$export$75dfa03544a19422 = 'ROADMAP';
const $0a39a0a4006d2a49$export$e3b1cd17bd82de3d = 'CLASSIC_ROADMAP';
const $0a39a0a4006d2a49$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';


parcelRegister("aQRnD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", () => $0bdf58350e54cd01$export$17ccdaa366ec26b8);
const $0bdf58350e54cd01$export$17ccdaa366ec26b8 = {
    name: 'project-settings-software-boards-roadmap',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
    exact: true
};

});

parcelRegister("eawym", function(module, exports) {
$parcel$export(module.exports, "LazyRoadmap", () => $90a67a71c73c441d$export$8eca5454e72ee961);
$parcel$export(module.exports, "default", () => $90a67a71c73c441d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $90a67a71c73c441d$export$8eca5454e72ee961 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fygcw")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
const $90a67a71c73c441d$var$AsyncProjectSettingsRoadmap = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "project-settings.roadmap",
        teamName: "chronos",
        attributes: {
            isSynthetic: (0, $4cTDP.fg)('is_synthetic_tenant') || (0, $hWeHP.default)('ajs-is-synthetic') === 'true'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $90a67a71c73c441d$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    }));
var $90a67a71c73c441d$export$2e2bcd8739ae039 = $90a67a71c73c441d$var$AsyncProjectSettingsRoadmap;

});
parcelRegister("fygcw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2vh0p").then(()=>parcelRequire('lGnF5'));

});



parcelRegister("kt0QB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRouteEntry", () => $785be944363ad166$export$cc224b8b7595975b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6ZOOP = parcelRequire("6ZOOP");

var $fsWIZ = parcelRequire("fsWIZ");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $eawym = parcelRequire("eawym");
const $785be944363ad166$export$cc224b8b7595975b = (0, $6xToB.createEntry)((0, $fsWIZ.projectSettingsSoftwareBoardsTimelineRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $eawym.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $6ZOOP.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $eawym.LazyRoadmap)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareBoardsTimelineRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareBoardsTimelineRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fsWIZ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", () => $e470e87a8e8934bd$export$e116d6b2a5f71426);
const $e470e87a8e8934bd$export$e116d6b2a5f71426 = {
    name: 'project-settings-software-boards-timeline',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
    exact: true
};

});


parcelRegister("9oXBQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRouteEntry", () => $d02aad3df65bde67$export$cc932462de184b27);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $7HkyI = parcelRequire("7HkyI");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $8sWTO = parcelRequire("8sWTO");

var $5JAAk = parcelRequire("5JAAk");
const $d02aad3df65bde67$export$cc932462de184b27 = (0, $6xToB.createEntry)((0, $7HkyI.projectSettingsSoftwareDataClassificationsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8sWTO.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8sWTO.LazyDataClassificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareDataClassificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareDataClassificationsRouteEntry'
            },
            enabled: true
        }
    })); /**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */ 

});
parcelRegister("7HkyI", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRoute", () => $ddb54c51bf5075f2$export$af525a8f93b72cc7);
const $ddb54c51bf5075f2$export$af525a8f93b72cc7 = {
    name: 'project-settings-software-data-classifications',
    path: '/jira/software/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("8sWTO", function(module, exports) {
$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $4cb7d7173ce2f963$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $4cb7d7173ce2f963$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4cb7d7173ce2f963$export$b8abcf8aa8f4df56 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8kyMO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $4cb7d7173ce2f963$var$AsyncDataClassificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4cb7d7173ce2f963$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
var $4cb7d7173ce2f963$export$2e2bcd8739ae039 = $4cb7d7173ce2f963$var$AsyncDataClassificationsSettings;

});


parcelRegister("iBuWD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDetailsRouteEntry", () => $b8ef082464936346$export$8440d3384846d9b8);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $bKD4m = parcelRequire("bKD4m");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $4cTDP = parcelRequire("4cTDP");

var $g8uYY = parcelRequire("g8uYY");

var $1OM5U = parcelRequire("1OM5U");

var $5L7qx = parcelRequire("5L7qx");

var $kFQUu = parcelRequire("kFQUu");

var $g6q5m = parcelRequire("g6q5m");

var $fLSSb = parcelRequire("fLSSb");

var $5JAAk = parcelRequire("5JAAk");
const $b8ef082464936346$var$projectSettingsSoftwareDetailsPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1OM5U.projectDetailsPageEntrypoint)
});
const $b8ef082464936346$export$8440d3384846d9b8 = (0, $6xToB.createEntry)((0, $bKD4m.projectSettingsSoftwareDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $fLSSb.default),
        skeleton: (0, $bmwpE.ProjectSettingsDetailsSkeleton),
        layout: (0, $8FCAy.softwareProjectLayout),
        entryPoint: ()=>(0, $4cTDP.fg)('jira_project_details_settings_refresh') ? $b8ef082464936346$var$projectSettingsSoftwareDetailsPageEntrypoint : undefined,
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira_project_details_settings_refresh'), (0, $kFQUu.softwareOnboardingGetStartedIntegrationsStatusResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira_project_details_settings_refresh'), (0, $g6q5m.fetchUserTraitsResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fLSSb.LazyDetailsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareDetailsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bKD4m", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareDetailsRoute", () => $490c2fcd02ca458b$export$8760347e2b0955eb);
const $490c2fcd02ca458b$export$8760347e2b0955eb = {
    name: 'project-settings-software-details',
    path: '/jira/software/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("jLhoT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareFieldsRouteEntry", () => $a203c8909d07104c$export$e6b200b5a1ce3063);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $uKS5x = parcelRequire("uKS5x");

var $8lV5C = parcelRequire("8lV5C");

var $8FCAy = parcelRequire("8FCAy");

var $3uXSV = parcelRequire("3uXSV");

var $5JAAk = parcelRequire("5JAAk");
const $a203c8909d07104c$export$e6b200b5a1ce3063 = (0, $6xToB.createEntry)((0, $8lV5C.projectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-tmp',
        component: (0, $3uXSV.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $uKS5x.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3uXSV.LazyFieldsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareFieldsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8lV5C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareFieldsRoute", () => $810a57ebc01fe683$export$1ab9d3299fbc789b);
const $810a57ebc01fe683$export$1ab9d3299fbc789b = {
    name: 'project-settings-software-fields',
    path: '/jira/software/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("3uXSV", function(module, exports) {
$parcel$export(module.exports, "LazyFieldsSettings", () => $785e1d3d8e053734$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $785e1d3d8e053734$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $785e1d3d8e053734$export$e309780f520d125a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("e7wXq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $785e1d3d8e053734$var$AsyncFieldsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $785e1d3d8e053734$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
var $785e1d3d8e053734$export$2e2bcd8739ae039 = $785e1d3d8e053734$var$AsyncFieldsSettings;

});


parcelRegister("6Lgr4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRouteEntry", () => $1ad80e164a5cc198$export$84a9a2dce32d93aa);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $jnN0b = parcelRequire("jnN0b");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");

var $jCMY4 = parcelRequire("jCMY4");

var $5JAAk = parcelRequire("5JAAk");
const $1ad80e164a5cc198$export$84a9a2dce32d93aa = (0, $6xToB.createEntry)((0, $jnN0b.projectSettingsSoftwareIssuetypesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: (0, $bMm2d.getUFOName)('project-settings-software-issuetypes'),
        component: (0, $jCMY4.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jCMY4.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareIssuetypesRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareIssuetypesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jnN0b", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRoute", () => $e7dc23b1c11a2277$export$7f26edefe51efc38);
const $e7dc23b1c11a2277$export$7f26edefe51efc38 = {
    name: 'project-settings-software-issuetypes',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("jCMY4", function(module, exports) {
$parcel$export(module.exports, "LazyIssueTypeSettings", () => $916c97ed5e1b51e8$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $916c97ed5e1b51e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $916c97ed5e1b51e8$export$36dcfb52d47cb93a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("j5ufr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $916c97ed5e1b51e8$var$AsyncIssueTypeSettings = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $916c97ed5e1b51e8$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
var $916c97ed5e1b51e8$export$2e2bcd8739ae039 = $916c97ed5e1b51e8$var$AsyncIssueTypeSettings;

});


parcelRegister("4KZfr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRouteEntry", () => $a6f8dfb78aaaa30a$export$58ca33ed538911cb);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $8QFYS = parcelRequire("8QFYS");

var $cxQGT = parcelRequire("cxQGT");

var $lb6FK = parcelRequire("lb6FK");

var $8FCAy = parcelRequire("8FCAy");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxKOj = parcelRequire("cxKOj");

var $cgXAH = parcelRequire("cgXAH");

var $5YJN5 = parcelRequire("5YJN5");

var $dZRaT = parcelRequire("dZRaT");

var $jCMY4 = parcelRequire("jCMY4");

var $5JAAk = parcelRequire("5JAAk");

var $7vZpL = parcelRequire("7vZpL");
const $a6f8dfb78aaaa30a$var$getWorkflowBuilderProvisioningResources = ()=>[
        (0, $cgXAH.workflowBuilderProvisioningResource)
    ];
const $a6f8dfb78aaaa30a$export$58ca33ed538911cb = (0, $6xToB.createEntry)((0, $8QFYS.projectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $7vZpL.default),
        layout: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? (0, $7K5Ea.chromelessLayout) : (0, $8FCAy.softwareProjectLayout),
        navigation: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? undefined : {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? [
            // Delete this resource after hix-7127_wfe_layout_to_chromeless_for_software experiment is over
            (0, $dZRaT.projectContextResource),
            (0, $5YJN5.projectWorkflowContextResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $lb6FK.rovoEntitlementResource),
            ...$a6f8dfb78aaaa30a$var$getWorkflowBuilderProvisioningResources()
        ] : [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            ...$a6f8dfb78aaaa30a$var$getWorkflowBuilderProvisioningResources(),
            (0, $cgXAH.workflowBuilderProvisioningResource)
        ],
        forPaint: (0, $cxKOj.expValEquals)('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false) ? [
            (0, $7vZpL.LazyWorkflowNavigationSettings)
        ] : [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jCMY4.LazyIssueTypeSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareIssuetypesWorkflowRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareIssuetypesWorkflowRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8QFYS", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRoute", () => $34f017735b7c24ba$export$de010d824a551ec);
const $34f017735b7c24ba$export$de010d824a551ec = {
    name: 'project-settings-software-issuetypes-workflow',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("5YJN5", function(module, exports) {
$parcel$export(module.exports, "projectWorkflowContextResource", () => $615430558ee111de$export$622567128573c92f);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $615430558ee111de$var$getDataLoader = ()=>(parcelRequire("8Ll58"));
const $615430558ee111de$export$622567128573c92f = (0, $l1VxS.createResource)({
    type: (0, $9db76909bd388890$export$1be4077e1912f05d),
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: $615430558ee111de$var$getDataLoader,
    maxAge: 1800000,
    isCritical: true,
    isBrowserOnly: true
});
const $615430558ee111de$export$80419a93f26d85e1 = ()=>(0, $eJrcF.useResource)($615430558ee111de$export$622567128573c92f);

});
const $9db76909bd388890$export$1be4077e1912f05d = 'PROJECT_WORKFLOW_CONTEXT';

parcelRegister("8Ll58", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3hu3X").then(()=>parcelRequire('azjDO'));

});


parcelRegister("7vZpL", function(module, exports) {
$parcel$export(module.exports, "LazyWorkflowNavigationSettings", () => $d3ed430bfe6130b8$export$cb608e3696682e76);
$parcel$export(module.exports, "default", () => $d3ed430bfe6130b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d3ed430bfe6130b8$export$cb608e3696682e76 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("4Bnpx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $d3ed430bfe6130b8$var$AsyncWorkflowNavigationSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d3ed430bfe6130b8$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
var $d3ed430bfe6130b8$export$2e2bcd8739ae039 = $d3ed430bfe6130b8$var$AsyncWorkflowNavigationSettings;

});


parcelRegister("b7rZt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRouteEntry", () => $00b85432d35f8347$export$81067f5196099c81);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $jQLrI = parcelRequire("jQLrI");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $13jD0 = parcelRequire("13jD0");

var $5JAAk = parcelRequire("5JAAk");
const $00b85432d35f8347$export$81067f5196099c81 = (0, $6xToB.createEntry)((0, $jQLrI.projectSettingsSoftwareNextGenFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.next-gen-features',
        component: (0, $13jD0.default),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $13jD0.LazyFeaturesSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareNextGenFeaturesRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareNextGenFeaturesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jQLrI", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRoute", () => $ec992699611d5646$export$12c7a1737b594a28);
const $ec992699611d5646$export$12c7a1737b594a28 = {
    name: 'project-settings-software-next-gen-features',
    path: '/jira/software/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("13jD0", function(module, exports) {
$parcel$export(module.exports, "LazyFeaturesSettings", () => $69ea107c6d51ec4d$export$da4d608b99858bfc);
$parcel$export(module.exports, "default", () => $69ea107c6d51ec4d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $69ea107c6d51ec4d$export$da4d608b99858bfc = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lHURw"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
const $69ea107c6d51ec4d$var$AsyncFeaturesSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $69ea107c6d51ec4d$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });
var $69ea107c6d51ec4d$export$2e2bcd8739ae039 = $69ea107c6d51ec4d$var$AsyncFeaturesSettings;

});
parcelRegister("lHURw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ikh28").then(()=>parcelRequire('1BNgi'));

});



parcelRegister("5QSRE", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRouteEntry", () => $0617eba4efbb02c5$export$9bb08b8e1b39d15f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $1ra19 = parcelRequire("1ra19");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $gJ40u = parcelRequire("gJ40u");

var $jjUOC = parcelRequire("jjUOC");
const $0617eba4efbb02c5$export$9bb08b8e1b39d15f = (0, $6xToB.createEntry)((0, $1ra19.projectSettingsSoftwareNotificationEmailCRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gJ40u.default),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jjUOC.LazySoftwareClassicFeatures),
            (0, $gJ40u.LazyProjectSettingsNotificationEmail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareNotificationEmailCRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareNotificationEmailCRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1ra19", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRoute", () => $fb17ec44a0198b81$export$dda91725b6c4a039);
const $fb17ec44a0198b81$export$dda91725b6c4a039 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("gJ40u", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $1f720ecbed768347$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $1f720ecbed768347$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1f720ecbed768347$export$ea7d73c94d9369f4 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hGlwH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $1f720ecbed768347$var$AsyncProjectSettingsNotificationEmail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1f720ecbed768347$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
var $1f720ecbed768347$export$2e2bcd8739ae039 = $1f720ecbed768347$var$AsyncProjectSettingsNotificationEmail;

});


parcelRegister("02HAY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRouteEntry", () => $b87adc14f724cc9c$export$8a17783c300fca11);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $i15aR = parcelRequire("i15aR");

var $bmwpE = parcelRequire("bmwpE");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");
const $b87adc14f724cc9c$export$8a17783c300fca11 = (0, $6xToB.createEntry)((0, $i15aR.projectSettingsSoftwareNotificationEmailRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5JAAk.RedirectForSettings),
        skeleton: (0, $bmwpE.ProjectSettingsFeaturesSkeleton),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareNotificationEmailRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareNotificationEmailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("i15aR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", () => $7c32d89ec3bc10b2$export$d4ed083331cb6e00);
const $7c32d89ec3bc10b2$export$d4ed083331cb6e00 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});


parcelRegister("9QPcQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $639b4a3511d27c69$export$9c37d834dfe46ebf);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $7bWyj = parcelRequire("7bWyj");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $6qzZB = parcelRequire("6qzZB");
const $639b4a3511d27c69$export$9c37d834dfe46ebf = (0, $6xToB.createEntry)((0, $7bWyj.projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $6qzZB.SoftwareNotificationsIssueLogs),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6qzZB.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $6qzZB.emailNotificationsLogEntryPointPage;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareNotificationsIssueLogsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareNotificationsIssueLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7bWyj", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", () => $e867f382a48cf966$export$ff4977f79c273b29);
const $e867f382a48cf966$export$ff4977f79c273b29 = {
    name: 'project-settings-software-notifications-issue-logs',
    path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("aZHdl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRouteEntry", () => $96cd91e79e45713e$export$1c340fa0c9022252);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $aftFt = parcelRequire("aftFt");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $1eXWM = parcelRequire("1eXWM");
const $96cd91e79e45713e$export$1c340fa0c9022252 = (0, $6xToB.createEntry)((0, $aftFt.projectSettingsSoftwareNotificationsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications',
        component: (0, $1eXWM.default),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1eXWM.LazySoftwareNotificationsSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareNotificationsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aftFt", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", () => $c245d986ac8e7a90$export$c1d1892d6c07135a);
const $c245d986ac8e7a90$export$c1d1892d6c07135a = {
    name: 'project-settings-software-notifications',
    path: '/jira/software/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("1eXWM", function(module, exports) {
$parcel$export(module.exports, "LazySoftwareNotificationsSettings", () => $b2e1837ea41236f8$export$69a64a29d67ca160);
$parcel$export(module.exports, "default", () => $b2e1837ea41236f8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $b2e1837ea41236f8$export$69a64a29d67ca160 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lCl0m"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $b2e1837ea41236f8$var$AsyncSoftwareNotificationsSettings = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b2e1837ea41236f8$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
var $b2e1837ea41236f8$export$2e2bcd8739ae039 = $b2e1837ea41236f8$var$AsyncSoftwareNotificationsSettings;

});


parcelRegister("307rd", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRouteEntry", () => $5f27c05213b316f7$export$5606059eca31e30);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4tyo9 = parcelRequire("4tyo9");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $flSSv = parcelRequire("flSSv");
const $5f27c05213b316f7$export$5606059eca31e30 = (0, $6xToB.createEntry)((0, $4tyo9.projectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $flSSv.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flSSv.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareProformaJiraFormBuilderRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareProformaJiraFormBuilderRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4tyo9", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRoute", () => $dfd34dc3ad1ed90f$export$cf33294d9d90a855);
const $dfd34dc3ad1ed90f$export$cf33294d9d90a855 = {
    name: 'project-settings-software-proforma-jira-form-builder',
    path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("cLEqv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRouteEntry", () => $25fd5a8e3e282347$export$ea77a3e974b26072);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $f4LUQ = parcelRequire("f4LUQ");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");

var $7BRGK = parcelRequire("7BRGK");
const $25fd5a8e3e282347$export$ea77a3e974b26072 = (0, $6xToB.createEntry)((0, $f4LUQ.projectSettingsSoftwareProformaProjectFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $7BRGK.default),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7BRGK.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareProformaProjectFormsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareProformaProjectFormsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("f4LUQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRoute", () => $088fd1a233d3dadb$export$750dec948cc98062);
const $088fd1a233d3dadb$export$750dec948cc98062 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("i0o2E", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareRedirectRouteEntry", () => $c18db11c05ae7c88$export$e5caf0892d6025c9);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");


var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $4HwCR = parcelRequire("4HwCR");

var $8FCAy = parcelRequire("8FCAy");

var $5JAAk = parcelRequire("5JAAk");
const $c18db11c05ae7c88$export$e5caf0892d6025c9 = (0, $6xToB.createEntry)((0, $4HwCR.projectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        isRedirect: true,
        component: (0, $5JAAk.RedirectForSettings),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareRedirectRouteEntry.tsx',
                whichExportToUse: 'projectSettingsSoftwareRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4HwCR", function(module, exports) {
$parcel$export(module.exports, "projectSettingsSoftwareRedirectRoute", () => $c0df11c9b0223c6f$export$168cc8ed4398c230);
const $c0df11c9b0223c6f$export$168cc8ed4398c230 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'project-settings-software-redirect',
    path: '/jira/software/projects/:projectKey/settings'
};

});


parcelRegister("fQjCK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsToolchainRouteEntry", () => $051f64e1870b7ff1$export$dd97d29f96b25d09);

var $kHlOR = parcelRequire("kHlOR");

var $6qDrV = parcelRequire("6qDrV");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $aaqFB = parcelRequire("aaqFB");

var $9BJU1 = parcelRequire("9BJU1");

var $bDouB = parcelRequire("bDouB");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $1a7Aj = parcelRequire("1a7Aj");

var $5JAAk = parcelRequire("5JAAk");
const $051f64e1870b7ff1$export$dd97d29f96b25d09 = (0, $6xToB.createEntry)((0, $bDouB.projectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $6qDrV.default)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $1a7Aj.default)),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $5JAAk.getSettingsNavigationResources)(),
            (0, $aaqFB.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1a7Aj.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsToolchainRouteEntry.tsx',
                whichExportToUse: 'projectSettingsToolchainRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bDouB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsToolchainRoute", () => $15e2ebd41f5ef8dc$export$e3e3877ec9c5e840);
const $15e2ebd41f5ef8dc$export$e3e3877ec9c5e840 = {
    name: 'project-settings-software-toolchain-team-managed',
    path: '/jira/software/projects/:projectKey/settings/toolchain',
    exact: true
};

});


parcelRegister("kDBV4", function(module, exports) {
$parcel$export(module.exports, "projectSettingsVersionsRouteEntry", () => $f20ad773ddf4aa1a$export$4791201b4877aa5d);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $PZ4Ji = parcelRequire("PZ4Ji");

var $bTfc4 = parcelRequire("bTfc4");

var $7Rvy6 = parcelRequire("7Rvy6");

var $8tbnc = parcelRequire("8tbnc");

var $8ziHo = parcelRequire("8ziHo");
const $f20ad773ddf4aa1a$export$4791201b4877aa5d = (0, $6xToB.createEntry)((0, $7Rvy6.projectSettingsVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $PZ4Ji.projectVersionsRelayResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $8ziHo.RelayVersions),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8ziHo.LazyRelayProjectVersions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-versions-entries/src/projectSettingsVersionsRouteEntry.tsx',
                whichExportToUse: 'projectSettingsVersionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("PZ4Ji", function(module, exports) {
$parcel$export(module.exports, "projectVersionsRelayResource", () => $cac17e3ec9a369b4$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");


var $cYcBU = parcelRequire("cYcBU");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");

var $kzPuE = parcelRequire("kzPuE");

var $l1VxS = parcelRequire("l1VxS");

var $4cTDP = parcelRequire("4cTDP");

const $cac17e3ec9a369b4$export$7e8aa1360f86345c = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $de70b073378ece45$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $kzPuE.default), {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $cYcBU.transformStatusFromParam)(query[0, $5e130dc454373f11$export$3e8168848b996f7]),
            searchString: query[0, $5e130dc454373f11$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $cYcBU.transformSortFieldFromParam)(query[0, $5e130dc454373f11$export$a3482d3a8df0e725]),
                order: (0, $cYcBU.transformSortOrderFromParam)(query[0, $5e130dc454373f11$export$71089821f361e881])
            },
            isManageVersionsPermissionEnabled: (0, $4cTDP.fg)('vmc-11-manage-versions-permission')
        }, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $5e130dc454373f11$export$a181206198b7f50c = 'contains';
const $5e130dc454373f11$export$3e8168848b996f7 = 'status';
const $5e130dc454373f11$export$71089821f361e881 = 'orderDirection';
const $5e130dc454373f11$export$a3482d3a8df0e725 = 'orderField';
const $5e130dc454373f11$export$3c5e605ca7ade9f2 = 'NAME';
const $5e130dc454373f11$export$50241fe906e4f94e = 'RELEASE_DATE';
const $5e130dc454373f11$export$99a467bcc22b8df9 = 'START_DATE';
const $5e130dc454373f11$export$d44826c816b5619b = 'DESCRIPTION';
const $5e130dc454373f11$export$34694f8d8b23ee2a = 'SEQUENCE';
const $5e130dc454373f11$export$cb638d1fae624fbf = 20;
const $5e130dc454373f11$export$bbcbc202f2dfa28c = 3;
const $5e130dc454373f11$export$b983f2cb1f658a55 = 'RELEASED';
const $5e130dc454373f11$export$cb459d726a8530a5 = 'UNRELEASED';
const $5e130dc454373f11$export$c936349447a77fe0 = 'ARCHIVED';
const $5e130dc454373f11$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("cYcBU", function(module, exports) {
$parcel$export(module.exports, "transformStatusFromParam", () => $f25f67743d1604be$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $f25f67743d1604be$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $f25f67743d1604be$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $f25f67743d1604be$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $f25f67743d1604be$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $f25f67743d1604be$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $f25f67743d1604be$export$5a6eeb16be7dd21d);


var $e4t5W = parcelRequire("e4t5W");

var $frPES = parcelRequire("frPES");

const $f25f67743d1604be$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $frPES.RELEASED),
                (0, $frPES.UNRELEASED),
                (0, $frPES.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $frPES.RELEASED),
                (0, $frPES.UNRELEASED),
                (0, $frPES.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $frPES.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $frPES.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $frPES.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $frPES.UNRELEASED)
                ];
            }
    }
};
const $f25f67743d1604be$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $frPES.RELEASED)) && [
                'released'
            ],
            input.includes((0, $frPES.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $frPES.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $f25f67743d1604be$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $88c5923de10af20c$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $88c5923de10af20c$export$b6abcf7fa1d94f65;
        default:
            return 0, $88c5923de10af20c$export$b6abcf7fa1d94f65;
    }
};
const $f25f67743d1604be$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $5e130dc454373f11$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $5e130dc454373f11$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $5e130dc454373f11$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $5e130dc454373f11$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $5e130dc454373f11$export$34694f8d8b23ee2a;
        default:
            return 0, $5e130dc454373f11$export$34694f8d8b23ee2a;
    }
};
const $f25f67743d1604be$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $frPES.RELEASED),
                (0, $frPES.UNRELEASED),
                (0, $frPES.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $frPES.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $frPES.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $frPES.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $frPES.UNRELEASED)
                ];
            }
    }
};
const $f25f67743d1604be$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $5e130dc454373f11$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $f25f67743d1604be$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $e4t5W.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
const $88c5923de10af20c$export$1dee026a19752d6b = 'ASC';
const $88c5923de10af20c$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("e4t5W", function(module, exports) {
$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $bf615e51c363d101$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $bf615e51c363d101$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("frPES", function(module, exports) {
$parcel$export(module.exports, "RELEASED", () => $8aa2131c0941c313$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $8aa2131c0941c313$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $8aa2131c0941c313$export$c936349447a77fe0);
const $8aa2131c0941c313$export$b983f2cb1f658a55 = 'RELEASED';
const $8aa2131c0941c313$export$cb459d726a8530a5 = 'UNRELEASED';
const $8aa2131c0941c313$export$c936349447a77fe0 = 'ARCHIVED';
const $8aa2131c0941c313$var$statuses = [
    $8aa2131c0941c313$export$b983f2cb1f658a55,
    $8aa2131c0941c313$export$cb459d726a8530a5,
    $8aa2131c0941c313$export$c936349447a77fe0
];
var $8aa2131c0941c313$export$2e2bcd8739ae039 = $8aa2131c0941c313$var$statuses;

});


parcelRegister("kzPuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c03de956579829ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6ae44fd11772903154fa2ff10aa6ce>>
 * @relayHash f6deebf30059f6281cb9bf02e6322b7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395
const $c03de956579829ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isManageVersionsPermissionEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "MANAGE_VERSIONS"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v14 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v15 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v16 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "initialLoadCount"
    }, v23 = [
        v14 /*: any*/ ,
        v22 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "id"
    }, v25 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isManageVersionsPermissionEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "canEditVersions",
                                                    "args": v12 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v13 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v14 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v17 /*: any*/ ,
                                                            v18 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v19 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v20 /*: any*/ ,
                                                    v21 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        v14 /*: any*/ ,
                        v22 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isManageVersionsPermissionEnabled",
                            "variableName": "isManageVersionsPermissionEnabled"
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "condition": "isManageVersionsPermissionEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "canEditVersions",
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ 
                                            ],
                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                        }
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v9 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c03de956579829ee$var$node.hash = "d200347d20dfa0c568d719d21b96cc62";
var $c03de956579829ee$export$2e2bcd8739ae039 = $c03de956579829ee$var$node;

});

const $de70b073378ece45$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("7Rvy6", function(module, exports) {
$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $28b9577f82c55763$export$cc9450e5d7579b99);
const $28b9577f82c55763$export$cc9450e5d7579b99 = {
    name: 'project-settings-versions',
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("8ziHo", function(module, exports) {
$parcel$export(module.exports, "LazyRelayProjectVersions", () => $ab0d1ae18bcd281e$export$9036da4fa9f7a66f);
$parcel$export(module.exports, "RelayVersions", () => $ab0d1ae18bcd281e$export$9aff7dab80671d9);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ab0d1ae18bcd281e$export$9036da4fa9f7a66f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9QkhH"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $ab0d1ae18bcd281e$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ab0d1ae18bcd281e$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });

});
parcelRegister("9QkhH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eSWeE").then(()=>parcelRequire('kLWhg'));

});



parcelRegister("3gALM", function(module, exports) {
$parcel$export(module.exports, "projectsRedirectRouteEntry", () => $93520232aa18f88b$export$56f9921db324f30);

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $hoV2u = parcelRequire("hoV2u");

var $gwhEz = parcelRequire("gwhEz");
const $93520232aa18f88b$export$56f9921db324f30 = (0, $6xToB.createEntry)((0, $gwhEz.projectsRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-projects-redirect-entries/src/projectsRedirectRouteEntry.tsx',
                whichExportToUse: 'projectsRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gwhEz", function(module, exports) {
$parcel$export(module.exports, "projectsRedirectRoute", () => $210d4f34607aed1b$export$e6bc3ea427ddafb8);
const $210d4f34607aed1b$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("6l8wI", function(module, exports) {
$parcel$export(module.exports, "projectVersionsRouteEntry", () => $0a1e862d0941e89e$export$982bc443ef89cc3f);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $kRv8K = parcelRequire("kRv8K");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $PZ4Ji = parcelRequire("PZ4Ji");

var $bTfc4 = parcelRequire("bTfc4");

var $ijegf = parcelRequire("ijegf");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $0a1e862d0941e89e$var$LazyRelayProjectVersions = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9QkhH"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $0a1e862d0941e89e$var$RelayVersions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $0a1e862d0941e89e$var$LazyRelayProjectVersions,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $0a1e862d0941e89e$export$982bc443ef89cc3f = (0, $6xToB.createEntry)((0, $ijegf.projectVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $PZ4Ji.projectVersionsRelayResource)
        ],
        component: $0a1e862d0941e89e$var$RelayVersions,
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $0a1e862d0941e89e$var$LazyRelayProjectVersions
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-projects-versions-entries/src/projectVersionsRouteEntry.tsx',
                whichExportToUse: 'projectVersionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ijegf", function(module, exports) {
$parcel$export(module.exports, "projectVersionsRoute", () => $1f4dd792c454a9fd$export$fb5516756c3eba40);

var $8U5L0 = parcelRequire("8U5L0");
const $1f4dd792c454a9fd$export$fb5516756c3eba40 = {
    name: 'project-versions',
    path: '/projects/:projectKey',
    query: (0, $8U5L0.PROJECTS_VERSIONS_QUERY_PARAMS)
};

});
parcelRegister("8U5L0", function(module, exports) {
$parcel$export(module.exports, "PROJECTS_VERSIONS_QUERY_PARAMS", () => $ae1627e0d54e3c6c$export$ad46185437bb571a);
const $ae1627e0d54e3c6c$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];

});



parcelRegister("kzJod", function(module, exports) {
$parcel$export(module.exports, "promotionsRouteEntry", () => $b49e27e077669a06$export$875d88a44b1ff74c);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $d2yKs = parcelRequire("d2yKs");

var $ixFkc = parcelRequire("ixFkc");
const $b49e27e077669a06$export$875d88a44b1ff74c = (0, $6xToB.createEntry)((0, $d2yKs.promotionsRoute), ()=>({
        group: 'marketplace',
        component: (0, $ixFkc.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ixFkc.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-marketplace-entries/src/promotionsRouteEntry.tsx',
                whichExportToUse: 'promotionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("d2yKs", function(module, exports) {
$parcel$export(module.exports, "promotionsRoute", () => $e6593ea95980eb90$export$45df65bfacbf9a2a);
const $e6593ea95980eb90$export$45df65bfacbf9a2a = {
    name: 'marketplace-promotions',
    path: '/jira/marketplace/manage/promotions'
};

});


parcelRegister("2jzeY", function(module, exports) {
$parcel$export(module.exports, "rapidboardBacklog1RouteEntry", () => $0d645fa50bc99e20$export$ee2385c1acba53f2);

var $6xToB = parcelRequire("6xToB");

var $kbZYB = parcelRequire("kbZYB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $eJe5A = parcelRequire("eJe5A");

var $grWOk = parcelRequire("grWOk");

var $9ZjGp = parcelRequire("9ZjGp");

var $6dwgv = parcelRequire("6dwgv");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $b4jBr = parcelRequire("b4jBr");

var $kHlOR = parcelRequire("kHlOR");

var $4sNzw = parcelRequire("4sNzw");

const $0d645fa50bc99e20$export$ee2385c1acba53f2 = (0, $6xToB.createEntry)((0, $4sNzw.rapidboardBacklog1Route), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardBacklog1RouteEntry.tsx',
                whichExportToUse: 'rapidboardBacklog1RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4sNzw", function(module, exports) {
$parcel$export(module.exports, "rapidboardBacklog1Route", () => $9ee3d028f8529fbc$export$ff874528b0b33a61);
const $9ee3d028f8529fbc$export$ff874528b0b33a61 = {
    name: 'rapidboard-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};

});


parcelRegister("80YBd", function(module, exports) {
$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRouteEntry", () => $7f229794e42917d4$export$420f86cfd239da4d);

var $6xToB = parcelRequire("6xToB");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $kHlOR = parcelRequire("kHlOR");

var $cYzeN = parcelRequire("cYzeN");

var $hoV2u = parcelRequire("hoV2u");
const $7f229794e42917d4$export$420f86cfd239da4d = (0, $6xToB.createEntry)((0, $cYzeN.rapidboardLastVisitedProjectRedirectRoute), ()=>({
        group: 'classic-software',
        component: (0, $hoV2u.RedirectToLastVisitedProjectPage),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        isRedirect: true,
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardLastVisitedProjectRedirectRouteEntry.tsx',
                whichExportToUse: 'rapidboardLastVisitedProjectRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cYzeN", function(module, exports) {
$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $2c088233e87c120f$export$991b1be164057e91);
const $2c088233e87c120f$export$991b1be164057e91 = {
    name: 'rapidboard-last-visited-project-redirect',
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ],
    __unsafeOrder: 1
};

});


parcelRegister("lfdJB", function(module, exports) {
$parcel$export(module.exports, "rapidboardReport1RouteEntry", () => $2cea65dfe88bd06a$export$7e8c0a9f6d68837);

var $6xToB = parcelRequire("6xToB");

var $kbZYB = parcelRequire("kbZYB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $eJe5A = parcelRequire("eJe5A");

var $grWOk = parcelRequire("grWOk");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $b4jBr = parcelRequire("b4jBr");

var $kHlOR = parcelRequire("kHlOR");

var $eb6le = parcelRequire("eb6le");

var $c3Di2 = parcelRequire("c3Di2");

var $awzH2 = parcelRequire("awzH2");
const $2cea65dfe88bd06a$export$7e8c0a9f6d68837 = (0, $6xToB.createEntry)((0, $eb6le.rapidboardReport1Route), ()=>({
        group: 'classic-software',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $c3Di2.ClassicReportSkeleton),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $awzH2.getReportsCommonResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardReport1RouteEntry.tsx',
                whichExportToUse: 'rapidboardReport1RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eb6le", function(module, exports) {
$parcel$export(module.exports, "rapidboardReport1Route", () => $8249f1ffba1a21f4$export$d27f9ad2fc277ff9);
const $8249f1ffba1a21f4$export$d27f9ad2fc277ff9 = {
    name: 'rapidboard-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("c3Di2", function(module, exports) {
$parcel$export(module.exports, "ClassicReportSkeleton", () => $4bc382652cc5ad21$export$d7667341f4db3b8d);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $grUOg = parcelRequire("grUOg");
const $4bc382652cc5ad21$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($grUOg)))
    });

});
parcelRegister("grUOg", function(module, exports) {
module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();

});



parcelRegister("d8BX1", function(module, exports) {
$parcel$export(module.exports, "rapidboardReportRouteEntry", () => $a48346ca5684aaf7$export$745f1d5a2458a2d9);

var $6xToB = parcelRequire("6xToB");

var $b7HVj = parcelRequire("b7HVj");

var $kbZYB = parcelRequire("kbZYB");

var $c3Di2 = parcelRequire("c3Di2");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $alzbz = parcelRequire("alzbz");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $grWOk = parcelRequire("grWOk");

var $awzH2 = parcelRequire("awzH2");

var $e0Ji4 = parcelRequire("e0Ji4");
const $a48346ca5684aaf7$export$745f1d5a2458a2d9 = (0, $6xToB.createEntry)((0, $b7HVj.rapidboardReportRoute), ()=>({
        group: 'classic-software',
        component: (0, $kbZYB.RapidBoardSpaPage),
        skeleton: (0, $c3Di2.ClassicReportSkeleton),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $awzH2.getReportsCommonResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kbZYB.LazyRapidBoard),
            (0, $kbZYB.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        entryPoint: ()=>(0, $e0Ji4.reportPageProjectEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardReportRouteEntry.tsx',
                whichExportToUse: 'rapidboardReportRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("b7HVj", function(module, exports) {
$parcel$export(module.exports, "rapidboardReportRoute", () => $1f38f67ed088a445$export$d37f637b09fb9fda);
const $1f38f67ed088a445$export$d37f637b09fb9fda = {
    name: 'rapidboard-report',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};

});

parcelRegister("e0Ji4", function(module, exports) {
$parcel$export(module.exports, "reportPageEntrypoint", () => $030bf664c930e9c5$export$73cecf7395943edd);
$parcel$export(module.exports, "reportPageProjectEntrypoint", () => $030bf664c930e9c5$export$bf3e4f038f61a19c);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $c4lqF = parcelRequire("c4lqF");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $030bf664c930e9c5$export$73cecf7395943edd = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c4lqF.rapidBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $030bf664c930e9c5$export$bf3e4f038f61a19c = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c4lqF.rapidBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("c4lqF", function(module, exports) {
$parcel$export(module.exports, "rapidBoardEntryPoint", () => $946dcba1f75fba3a$export$15991360ec37fcaf);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $946dcba1f75fba3a$export$15991360ec37fcaf = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4RBg6")), {
        moduleId: "4d7ce9a3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("4RBg6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("69Svh").then(()=>parcelRequire('gEw1T'));

});




parcelRegister("hDTQX", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserBacklogRouteEntry", () => $51da1fe8702ba6ff$export$ccde3c1d7a857b27);

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $dcS0z = parcelRequire("dcS0z");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $fbgOh = parcelRequire("fbgOh");

var $27Owl = parcelRequire("27Owl");

var $eJe5A = parcelRequire("eJe5A");

var $grWOk = parcelRequire("grWOk");

var $3956v = parcelRequire("3956v");

var $9ZjGp = parcelRequire("9ZjGp");

var $6dwgv = parcelRequire("6dwgv");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $hS1gr = parcelRequire("hS1gr");

var $5L7qx = parcelRequire("5L7qx");

var $9NmsS = parcelRequire("9NmsS");

var $kMi77 = parcelRequire("kMi77");

var $ag8Tg = parcelRequire("ag8Tg");
const $51da1fe8702ba6ff$export$ccde3c1d7a857b27 = (0, $6xToB.createEntry)((0, $3956v.rapidboardUserBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-user-backlog',
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getUIFBacklogDataResource)(true),
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('backlog-preload-epics-lite'), (0, $dcS0z.epicsLiteResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $ag8Tg.backlogPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $kMi77.classicBacklogCapability)
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardUserBacklogRouteEntry.tsx',
                whichExportToUse: 'rapidboardUserBacklogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3956v", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $a097d7ac6b9cdf6d$export$79c2d9718e914f91);
const $a097d7ac6b9cdf6d$export$79c2d9718e914f91 = {
    name: 'rapidboard-user-backlog',
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};

});

parcelRegister("kMi77", function(module, exports) {
$parcel$export(module.exports, "classicBacklogCapability", () => $f2f0681e90285d31$export$10a7bb102137d92b);

const $f2f0681e90285d31$export$10a7bb102137d92b = !false ? (0, $652f5f63189f3e2a$export$571692eec8a399e1) : (0, $652f5f63189f3e2a$export$93104dc4eba58ba4);

});

parcelRegister("ag8Tg", function(module, exports) {
$parcel$export(module.exports, "backlogPageEntrypoint", () => $b112677a0f4958a4$export$1ccf08591607897d);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $cw1BI = parcelRequire("cw1BI");
const $b112677a0f4958a4$export$1ccf08591607897d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cw1BI.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("3NN4E", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportRouteEntry", () => $e5dcc50abdecc89d$export$374d78dc1cde7b56);

var $6xToB = parcelRequire("6xToB");

var $alzbz = parcelRequire("alzbz");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $eJe5A = parcelRequire("eJe5A");

var $grWOk = parcelRequire("grWOk");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $6fTv5 = parcelRequire("6fTv5");

var $c3Di2 = parcelRequire("c3Di2");

var $awzH2 = parcelRequire("awzH2");

var $e0Ji4 = parcelRequire("e0Ji4");
const $e5dcc50abdecc89d$export$374d78dc1cde7b56 = (0, $6xToB.createEntry)((0, $6fTv5.rapidboardUserReportRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $c3Di2.ClassicReportSkeleton),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            ...(0, $awzH2.getReportsCommonResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $e0Ji4.reportPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardUserReportRouteEntry.tsx',
                whichExportToUse: 'rapidboardUserReportRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6fTv5", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportRoute", () => $b412fbcec0c262f7$export$7b85bca17717def6);
const $b412fbcec0c262f7$export$7b85bca17717def6 = {
    name: 'rapidboard-user-report',
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};

});


parcelRegister("6034y", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportsOverviewRouteEntry", () => $2efbaf5219925a24$export$721c38d3152f9625);

var $6xToB = parcelRequire("6xToB");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $aTYS8 = parcelRequire("aTYS8");

var $ioHIu = parcelRequire("ioHIu");

var $hS1gr = parcelRequire("hS1gr");

var $g8uYY = parcelRequire("g8uYY");

var $aDtWM = parcelRequire("aDtWM");

var $alzbz = parcelRequire("alzbz");

var $9n5I0 = parcelRequire("9n5I0");

var $bTfc4 = parcelRequire("bTfc4");

var $9NmsS = parcelRequire("9NmsS");

var $lvjEc = parcelRequire("lvjEc");
const $2efbaf5219925a24$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $2efbaf5219925a24$export$721c38d3152f9625 = (0, $6xToB.createEntry)((0, $aTYS8.rapidboardUserReportsOverviewRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4cTDP.fg)('reports-overview-page-migration') ? $2efbaf5219925a24$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            ...(0, $alzbz.getRapidboardResources)()
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/rapidboardUserReportsOverviewRouteEntry.tsx',
                whichExportToUse: 'rapidboardUserReportsOverviewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aTYS8", function(module, exports) {
$parcel$export(module.exports, "rapidboardUserReportsOverviewRoute", () => $d69dfc0bbc23df77$export$6101ec4dca41c740);
const $d69dfc0bbc23df77$export$6101ec4dca41c740 = {
    name: 'rapidboard-user-reports-overview',
    path: '/jira/people/:accountId/boards/:boardId/reports'
};

});


parcelRegister("lCqer", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationDetailRouteEntry", () => $91fc81d2e805a87b$export$565325825b04cec6);

var $hJ2na = parcelRequire("hJ2na");

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $fSq6c = parcelRequire("fSq6c");

var $94jGb = parcelRequire("94jGb");

var $cjTtV = parcelRequire("cjTtV");
const $91fc81d2e805a87b$export$565325825b04cec6 = (0, $6xToB.createEntry)((0, $fSq6c.roleBasedNotificationDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $94jGb.RoleBasedNotificationsComponent),
        layout: (0, $yRJUA.globalSettingsLayout),
        slot: (0, $cjTtV.RoleBasedNotificationDetail),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $hJ2na.resources)[0],
            (0, $hJ2na.resources)[1],
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        forPaint: [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $94jGb.LazyRoleBasedNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-role-based-notifications-entries/src/roleBasedNotificationDetailRouteEntry.tsx',
                whichExportToUse: 'roleBasedNotificationDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hJ2na", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationsResource", () => $e1706eee30e6e3b3$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $e1706eee30e6e3b3$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $e1706eee30e6e3b3$export$bc99aaabaf7b70a7);

var $l1VxS = parcelRequire("l1VxS");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $iKS7X = parcelRequire("iKS7X");
const $e1706eee30e6e3b3$export$9a716bf20d804ec3 = (0, $l1VxS.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $iKS7X.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $e1706eee30e6e3b3$export$8ad8a0a20fd0ed5a = (0, $l1VxS.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $cyz90.assert)(!!settingId, new (0, $gLoFN.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $iKS7X.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $e1706eee30e6e3b3$export$bc99aaabaf7b70a7 = [
    $e1706eee30e6e3b3$export$9a716bf20d804ec3,
    $e1706eee30e6e3b3$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("iKS7X", function(module, exports) {
$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $122efa4456f81922$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $122efa4456f81922$export$5522446e6d3ee73);

var $9ppkU = parcelRequire("9ppkU");
const $122efa4456f81922$export$db67dfe9fe98cd49 = ()=>(0, $9ppkU.eocFetch)(`/v1/role-based-notifications`);
const $122efa4456f81922$export$5522446e6d3ee73 = (settingId)=>(0, $9ppkU.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("fSq6c", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationDetailRoute", () => $1cb6004d03e4407c$export$10ec812f053317c9);
const $1cb6004d03e4407c$export$10ec812f053317c9 = {
    name: 'eoc-role-based-notifications-detail',
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};

});

parcelRegister("94jGb", function(module, exports) {
$parcel$export(module.exports, "LazyRoleBasedNotifications", () => $1bb1c5fe35d368eb$export$15a244aba8f3b406);
$parcel$export(module.exports, "RoleBasedNotificationsComponent", () => $1bb1c5fe35d368eb$export$8994be6f8ad6a04a);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1bb1c5fe35d368eb$export$15a244aba8f3b406 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("d8Qnu")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $1bb1c5fe35d368eb$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1bb1c5fe35d368eb$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});
parcelRegister("d8Qnu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("bl6hv")
]).then(()=>parcelRequire('5lvpt'));

});


parcelRegister("cjTtV", function(module, exports) {
$parcel$export(module.exports, "RoleBasedNotificationDetail", () => $c9419f7e9b73b669$export$445112c3a1089cc5);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c9419f7e9b73b669$export$5211e5a7ed694f98 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("d8Qnu")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $c9419f7e9b73b669$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c9419f7e9b73b669$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("4YOsq", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationsRouteEntry", () => $d0e3c65e0fdd34ae$export$60de9875bb8ef1d6);

var $hJ2na = parcelRequire("hJ2na");

var $kHlOR = parcelRequire("kHlOR");

var $iRfwO = parcelRequire("iRfwO");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $cAdCW = parcelRequire("cAdCW");

var $fc9ma = parcelRequire("fc9ma");

var $17wyZ = parcelRequire("17wyZ");

var $4cTDP = parcelRequire("4cTDP");

var $fXF6E = parcelRequire("fXF6E");

var $94jGb = parcelRequire("94jGb");
const $d0e3c65e0fdd34ae$var$getNavigationSpecifications = ()=>{
    return (0, $4cTDP.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $5RW99.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $fc9ma.default),
        horizontal: (0, $17wyZ.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $d0e3c65e0fdd34ae$export$60de9875bb8ef1d6 = (0, $6xToB.createEntry)((0, $cAdCW.roleBasedNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $94jGb.RoleBasedNotificationsComponent),
        layout: (0, $iRfwO.opsSettingsLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $hJ2na.resources)[0],
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            ...$d0e3c65e0fdd34ae$var$getNavigationSpecifications()
        },
        forPaint: (0, $4cTDP.fg)('operations_nav4_remaining_items') ? [
            (0, $fXF6E.LazySidebarContent),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $94jGb.LazyRoleBasedNotifications)
        ] : [
            (0, $17wyZ.LazyHorizontalOperationsConfigurationNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $94jGb.LazyRoleBasedNotifications)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-role-based-notifications-entries/src/roleBasedNotificationsRouteEntry.tsx',
                whichExportToUse: 'roleBasedNotificationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cAdCW", function(module, exports) {
$parcel$export(module.exports, "roleBasedNotificationsRoute", () => $496f8b17fab16e7c$export$5a10092825ee32e4);
const $496f8b17fab16e7c$export$5a10092825ee32e4 = {
    name: 'eoc-role-based-notifications',
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};

});


parcelRegister("3Rt1x", function(module, exports) {
$parcel$export(module.exports, "rovoSearchRouteEntry", () => $c11a58d690f29b8d$export$64c44018a429a3ed);

var $eJOHy = parcelRequire("eJOHy");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $7Bu6h = parcelRequire("7Bu6h");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c11a58d690f29b8d$var$LazyRovoSearchPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("f1eus"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $c11a58d690f29b8d$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c11a58d690f29b8d$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $c11a58d690f29b8d$export$64c44018a429a3ed = (0, $6xToB.createEntry)((0, $7Bu6h.rovoSearchRoute), ()=>({
        group: 'search',
        component: $c11a58d690f29b8d$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            $c11a58d690f29b8d$var$LazyRovoSearchPage
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-rovo-search-entries/src/rovoSearchRouteEntry.tsx',
                whichExportToUse: 'rovoSearchRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7Bu6h", function(module, exports) {
$parcel$export(module.exports, "rovoSearchRoute", () => $fbbd18239f0fbf85$export$c45b7c601eb1ba93);
const $fbbd18239f0fbf85$export$c45b7c601eb1ba93 = {
    name: 'jira-rovo-search',
    path: '/jira/cross-product-search',
    exact: true
};

});


parcelRegister("6cbbu", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRouteEntry", () => $61ebdb34a3132775$export$95bd68c4f26980ed);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $g8uYY = parcelRequire("g8uYY");

var $9NmsS = parcelRequire("9NmsS");

var $4cTDP = parcelRequire("4cTDP");

var $kSeQy = parcelRequire("kSeQy");

var $a9kHc = parcelRequire("a9kHc");

var $5RW99 = parcelRequire("5RW99");

var $cEyqp = parcelRequire("cEyqp");
const $61ebdb34a3132775$var$sandboxBundlerBifrostPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cEyqp.sandboxBundlerBifrostEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $61ebdb34a3132775$export$95bd68c4f26980ed = (0, $6xToB.createEntry)((0, $a9kHc.sandboxBundlerBifrostEntrypointsRoute), ()=>({
        group: 'sandbox',
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        ufoName: 'sandbox-bundler',
        entryPoint: ()=>(0, $4cTDP.fg)('conditional_import_sandbox_bifrost') ? $61ebdb34a3132775$var$sandboxBundlerBifrostPageEntryPoint : (0, $kSeQy.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'not-deployed',
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostEntrypointsRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostEntrypointsRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("a9kHc", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRoute", () => $8bd0e2b2bcfc0245$export$1e4fe7eb44ddb2fd);
const $8bd0e2b2bcfc0245$export$1e4fe7eb44ddb2fd = {
    name: 'sandbox-bundler-bifrost-entrypoints',
    path: '/jira/software/sandbox/bundler-bifrost/entrypoints',
    exact: true
};

});

parcelRegister("cEyqp", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerBifrostEntryPoint", () => $0791eb6c2467b2f0$export$e6bb5cf1b802d157);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $0791eb6c2467b2f0$export$e6bb5cf1b802d157 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8NWl4")), {
        moduleId: "ce1b1bd6",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8NWl4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('test_conditional_imports', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $ewTvA("xCwVx")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("iqAAe")
                ]);
            }),
            $ewTvA("2StxK")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $ewTvA("xCwVx")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("iqAAe")
                ]);
            }),
            $ewTvA("8sImn")
        ]);
    }),
    $ewTvA("iT4Ag")
]).then(()=>parcelRequire('6JhVg'));

});



parcelRegister("bSbiO", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerBifrostRLLRouteEntry", () => $93c84e7192b9b61c$export$e0dd38ef6ff677e7);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $jVgoQ = parcelRequire("jVgoQ");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $93c84e7192b9b61c$var$LazySandboxBundlerPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8NWl4"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $93c84e7192b9b61c$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $93c84e7192b9b61c$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler-bifrost",
        shouldShowSpinner: true
    });
const $93c84e7192b9b61c$export$e0dd38ef6ff677e7 = (0, $6xToB.createEntry)((0, $jVgoQ.sandboxBundlerBifrostRLLRoute), ()=>({
        group: 'sandbox',
        component: (0, $bJscI.componentWithFG)('conditional_import_sandbox_bifrost', $93c84e7192b9b61c$var$SandboxBundler, (0, $9BJU1.default)),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $93c84e7192b9b61c$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bifrostGroup: 'not-deployed',
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostRLLRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("jVgoQ", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerBifrostRLLRoute", () => $eff0ee4362f7531d$export$c21fd836e6493cee);
const $eff0ee4362f7531d$export$c21fd836e6493cee = {
    name: 'sandbox-bundler-bifrost-rll',
    path: '/jira/software/sandbox/bundler-bifrost/rll',
    exact: true
};

});


parcelRegister("2M4fN", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerRouteEntry", () => $7f28bc2a325d0899$export$71497b88db8291d0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $bJscI = parcelRequire("bJscI");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $9BJU1 = parcelRequire("9BJU1");

var $9laIn = parcelRequire("9laIn");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $7f28bc2a325d0899$var$LazySandboxBundlerPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8NWl4"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $7f28bc2a325d0899$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $7f28bc2a325d0899$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler",
        shouldShowSpinner: true
    });
const $7f28bc2a325d0899$export$71497b88db8291d0 = (0, $6xToB.createEntry)((0, $9laIn.sandboxBundlerRoute), ()=>({
        group: 'sandbox',
        component: (0, $bJscI.componentWithFG)('conditional_import_sandbox', $7f28bc2a325d0899$var$SandboxBundler, (0, $9BJU1.default)),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $7f28bc2a325d0899$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9laIn", function(module, exports) {
$parcel$export(module.exports, "sandboxBundlerRoute", () => $e9053c64bfe9f59c$export$3891624aac454ec2);
const $e9053c64bfe9f59c$export$3891624aac454ec2 = {
    name: 'sandbox-bundler',
    path: '/jira/software/sandbox/bundler',
    exact: true
};

});


parcelRegister("kqm46", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRouteEntry", () => $adbabcc5a5197adb$export$38fc3637f21e26b2);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $l556O = parcelRequire("l556O");

var $48g3M = parcelRequire("48g3M");

var $kSeQy = parcelRequire("kSeQy");

var $4cTDP = parcelRequire("4cTDP");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $adbabcc5a5197adb$var$sandboxRelayEchoPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $48g3M.sandboxEchoPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $adbabcc5a5197adb$export$38fc3637f21e26b2 = (0, $6xToB.createEntry)((0, $l556O.sandboxRelayEchoPageUsingEntryPointRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $4cTDP.fg)('jfp-magma-support-defer') ? $adbabcc5a5197adb$var$sandboxRelayEchoPageEntryPoint : (0, $kSeQy.notFoundPageEntrypoint),
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-echo',
        // eslint-disable-next-line jira/route-definitions/entry-standards
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingEntryPointRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingEntryPointRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json',
            bifrostGroup: 'not-deployed'
        }
    }));

});
parcelRegister("l556O", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRoute", () => $6a45f6f09ed3e758$export$eaecd670f9df9fd6);
const $6a45f6f09ed3e758$export$eaecd670f9df9fd6 = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("48g3M", function(module, exports) {
$parcel$export(module.exports, "sandboxEchoPageEntryPoint", () => $0c21780928bef493$export$d3ff1e280a8985f3);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $d2CP0 = parcelRequire("d2CP0");

const $0c21780928bef493$export$d3ff1e280a8985f3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("gwrJk")), {
        moduleId: "73542e71",
        moduleName: "SandboxEchoPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: routerContext })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $d2CP0.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
                        skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("d2CP0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ceefef7557d9945$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f43786c95d21554e6525e62ba3fbbd95>>
 * @relayHash 34217eab0f370d5568f7c0ae333e556f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9
const $9ceefef7557d9945$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipLongQuery"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "alias": "criticalMessage",
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "echo"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer1"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer2"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer3"
                                    }
                                ]
                            },
                            {
                                "condition": "skipLongQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "Defer",
                                        "selections": [
                                            {
                                                "args": v2 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "SandboxEchoVeryLongQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer1",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 500
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer2",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 700
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
                            "selections": [
                                {
                                    "alias": "defer3",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 900
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                },
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "nestedImmediate",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer1",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer2",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "skipLongQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoPageQuery$defer$SandboxEchoVeryLongQuery_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "wasItWorthTheWait",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 5000
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9",
            "metadata": {},
            "name": "SandboxEchoPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9ceefef7557d9945$var$node.hash = "6c4aa6e81890a1b652ce97e525a243a3";
var $9ceefef7557d9945$export$2e2bcd8739ae039 = $9ceefef7557d9945$var$node;

});

parcelRegister("gwrJk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8KVl7").then(()=>parcelRequire('6Yq66'));

});



parcelRegister("8LN4T", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRouteEntry", () => $b3a5afa822cb0045$export$3981404cc747e85);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $iJZf8 = parcelRequire("iJZf8");

var $aBKJ5 = parcelRequire("aBKJ5");

var $5RW99 = parcelRequire("5RW99");

var $hS1gr = parcelRequire("hS1gr");

var $i9aex = parcelRequire("i9aex");

var $huHh8 = parcelRequire("huHh8");
const $b3a5afa822cb0045$export$3981404cc747e85 = (0, $6xToB.createEntry)((0, $iJZf8.sandboxRelayEchoPageUsingRLLRoute), ()=>({
        group: 'sandbox',
        layout: (0, $7h3uc.globalLayout),
        skeleton: (0, $huHh8.Skeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $aBKJ5.AsyncSandboxEchoPage),
        lazyForPaint: [
            (0, $aBKJ5.AsyncSandboxEchoPage)
        ],
        resources: [
            (0, $i9aex.sandboxEchoPageRelayResource)
        ],
        ufoName: 'sandbox-relay-echo',
        // eslint-disable-next-line jira/route-definitions/entry-standards
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingRLLRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json',
            bifrostGroup: 'not-deployed'
        }
    }));

});
parcelRegister("iJZf8", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRoute", () => $fee3df7c662b432a$export$382892be07e8f9fc);
const $fee3df7c662b432a$export$382892be07e8f9fc = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("aBKJ5", function(module, exports) {
$parcel$export(module.exports, "AsyncSandboxEchoPage", () => $4ae2d78610286e52$export$3e76bcb04553d279);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bQWwW = parcelRequire("bQWwW");

var $9FYIg = parcelRequire("9FYIg");

var $2dJFW = parcelRequire("2dJFW");

var $d2CP0 = parcelRequire("d2CP0");

var $2imLM = parcelRequire("2imLM");

var $i9aex = parcelRequire("i9aex");

const $4ae2d78610286e52$export$cc4c54c1ebe3736c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gwrJk"))), {
    moduleId: "./src/packages/spa-apps/sandbox/relay/src/ui/SandboxEchoPage.tsx"
});
const $4ae2d78610286e52$export$131119b9314343c7 = ()=>{
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $d2CP0.default));
    if (queryReference == null) {
        loadQuery({
            cloudId: '7088b486-bbf4-4e1f-9195-412bfac4be28',
            enableDefer: true,
            skipLongQuery: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, "Triggering query...");
    }
    const props = {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, "Self-starting sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "self-starting-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ae2d78610286e52$export$cc4c54c1ebe3736c, props)));
};
const $4ae2d78610286e52$export$3e76bcb04553d279 = ()=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $i9aex.sandboxEchoPageRelayResource));
    const props = queryReference ? {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("small", null, "Async sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, props && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ae2d78610286e52$export$cc4c54c1ebe3736c, props)));
};

});
parcelRegister("i9aex", function(module, exports) {
$parcel$export(module.exports, "sandboxEchoPageRelayResource", () => $f42ea47258f0a957$export$1d94b7b81d2cfb0c);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $l1VxS = parcelRequire("l1VxS");

var $d2CP0 = parcelRequire("d2CP0");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");
const $f42ea47258f0a957$export$1d94b7b81d2cfb0c = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SANDBOX_RELAY_DEFER_ECHO`,
    getKey: ()=>'sandbox-relay-defer-echo',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        // Bail if the request opted out of SSR rendering
        if (false && 'ssr' in routerContext.query && routerContext.query.ssr === 'false') return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
            skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
        };
        const options = {
            fetchPolicy: 'store-and-network'
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $d2CP0.default), variables, options);
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});


parcelRegister("huHh8", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $48632f96d614d640$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");
const $48632f96d614d640$export$8f31e4c4a37b8e9c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, "Loading the sandbox page...");
};

});


parcelRegister("27YPb", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayJiraPageRouteEntry", () => $a7922aefb0f5eb52$export$c19004b7e7b87ab0);

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $j0eFT = parcelRequire("j0eFT");

var $3MJtg = parcelRequire("3MJtg");

var $kSeQy = parcelRequire("kSeQy");

var $4cTDP = parcelRequire("4cTDP");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $a7922aefb0f5eb52$var$sandboxRelayJiraPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3MJtg.sandboxJiraPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $a7922aefb0f5eb52$export$c19004b7e7b87ab0 = (0, $6xToB.createEntry)((0, $j0eFT.sandboxRelayJiraPageRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $4cTDP.fg)('jfp-magma-support-defer') ? $a7922aefb0f5eb52$var$sandboxRelayJiraPageEntryPoint : (0, $kSeQy.notFoundPageEntrypoint),
        layout: (0, $7h3uc.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-jirasearch',
        // eslint-disable-next-line jira/route-definitions/entry-standards
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayJiraPageRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayJiraPageRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json',
            bifrostGroup: 'not-deployed'
        }
    }));

});
parcelRegister("j0eFT", function(module, exports) {
$parcel$export(module.exports, "sandboxRelayJiraPageRoute", () => $3f0eb6e010329da2$export$71a894fccabfdcfa);
const $3f0eb6e010329da2$export$71a894fccabfdcfa = {
    name: 'sandbox-relay-defer-jira',
    path: '/jira/software/sandbox/relay/jirasearch',
    exact: true
};

});

parcelRegister("3MJtg", function(module, exports) {
$parcel$export(module.exports, "sandboxJiraPageEntryPoint", () => $0e440ef96c50961e$export$d56ccd62431eaba5);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $9hrB6 = parcelRequire("9hrB6");

const $0e440ef96c50961e$export$d56ccd62431eaba5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bO8pA")), {
        moduleId: "ea0eea54",
        moduleName: "SandboxJiraPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $9hrB6.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("9hrB6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e77b7f52d9094b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79cda9a8a207ac397a141bd7897c3537>>
 * @relayHash 3037c8cb08fdd5bd0f2bb8885e4a147b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4
const $8e77b7f52d9094b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "SandboxJiraCriticalData"
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraUserPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraAiStuff"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraIssueSearch"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "childIssuesLimit"
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraUserPreferences_PVNZy",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isIssueViewCrossFlowBannerDismissed"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCustomNavBarThemeFlagDismissed"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraAiStuff_PVNZy",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "atlassianIntelligenceProductFeatureInput",
                                            "value": {
                                                "product": "JIRA_SOFTWARE"
                                            }
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "shouldShowAtlassianIntelligence"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "isRovoEnabled"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraIssueSearch_1jcU60",
                            "selections": [
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "issueSearchInput",
                                            "value": {
                                                "jql": "ORDER BY created DESC"
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "idsOrAliases",
                                                                    "value": [
                                                                        "assignee",
                                                                        "reporter",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "fieldsByIdOrAlias",
                                                            "plural": true,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "if": "enableDefer",
                                                                    "kind": "Defer",
                                                                    "label": "SandboxJiraIssueWithDeferCard$defer$SandboxJiraIssueFieldEditability",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isEditableInIssueView"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                }
                                                            ],
                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"assignee\",\"reporter\",\"status\"])"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4",
            "metadata": {},
            "name": "SandboxJiraPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8e77b7f52d9094b2$var$node.hash = "1a8ba1e200e80a9f80ac57367382ae4b";
var $8e77b7f52d9094b2$export$2e2bcd8739ae039 = $8e77b7f52d9094b2$var$node;

});

parcelRegister("bO8pA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b5AzK").then(()=>parcelRequire('b0htF'));

});



parcelRegister("5tYtA", function(module, exports) {
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", () => $fb2741403521e011$export$c2ec350ee9e78717);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $jBMV2 = parcelRequire("jBMV2");

var $9NmsS = parcelRequire("9NmsS");

var $hiLFH = parcelRequire("hiLFH");

var $iMFdk = parcelRequire("iMFdk");

var $alJZi = parcelRequire("alJZi");
const $fb2741403521e011$export$c2ec350ee9e78717 = (0, $6xToB.createEntry)((0, $hiLFH.secureFiltersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $jBMV2.filtersDirectoryResource)
        ],
        component: !false ? (0, $alJZi.FiltersDirectoryRedirect) : (0, $alJZi.FiltersDirectoryComponent),
        skeleton: (0, $iMFdk.FiltersDirectorySkeleton),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $alJZi.LazyFiltersDirectory)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-directories-entries/src/secureFiltersDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'secureFiltersDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hiLFH", function(module, exports) {
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $47c22521a29ff53a$export$50796f2aecd63181);
const $47c22521a29ff53a$export$50796f2aecd63181 = {
    name: 'filters-directory-secure-redirect',
    path: '/secure/ManageFilters.jspa'
};

});


parcelRegister("BcNEN", function(module, exports) {
$parcel$export(module.exports, "selectedDashboardRouteEntry", () => $e0db47cbd2b285a3$export$ac09a8d3ecbafc5);

var $kHlOR = parcelRequire("kHlOR");


var $grWOk = parcelRequire("grWOk");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $aDdiI = parcelRequire("aDdiI");

var $doZ3p = parcelRequire("doZ3p");

var $en43l = parcelRequire("en43l");
const $e0db47cbd2b285a3$export$ac09a8d3ecbafc5 = (0, $6xToB.createEntry)((0, $aDdiI.selectedDashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $doZ3p.DashboardRedirect),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $en43l.dashboardResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $en43l.LazyDashboardView)
        ],
        meta: {
            capability: (0, $652f5f63189f3e2a$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/selectedDashboardRouteEntry.tsx',
                whichExportToUse: 'selectedDashboardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aDdiI", function(module, exports) {
$parcel$export(module.exports, "selectedDashboardRoute", () => $a7a3525a27418403$export$b32070ee9554c3fb);
const $a7a3525a27418403$export$b32070ee9554c3fb = {
    name: 'dashboard-selected',
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};

});


parcelRegister("2uDzR", function(module, exports) {
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRouteEntry", () => $2d3698a226f9318f$export$94d6674b63b9d647);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $4dwN1 = parcelRequire("4dwN1");

var $1PvPk = parcelRequire("1PvPk");

var $685d7 = parcelRequire("685d7");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $cH29p = parcelRequire("cH29p");
const $2d3698a226f9318f$export$94d6674b63b9d647 = (0, $6xToB.createEntry)((0, $685d7.servicedeskAtlassianAnalyticsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cH29p.AtlassianAnalytics),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4dwN1.servicedeskAtlassianAnalyticsResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cH29p.LazyAtlassianAnalytics)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskAtlassianAnalyticsRouteEntry.tsx',
                whichExportToUse: 'servicedeskAtlassianAnalyticsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4dwN1", function(module, exports) {
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $be90a76c40395ac5$export$eb2deca89cf3fb61);

var $l1VxS = parcelRequire("l1VxS");


const $be90a76c40395ac5$var$getDataLoader = ()=>(parcelRequire("9rwNc"));
const $be90a76c40395ac5$export$eb2deca89cf3fb61 = (0, $l1VxS.createResource)({
    type: (0, $69de02b4dca0179d$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $be90a76c40395ac5$var$getDataLoader,
    isBrowserOnly: true
});

});
const $69de02b4dca0179d$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("9rwNc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iTHC8").then(()=>parcelRequire('1bupc'));

});


parcelRegister("685d7", function(module, exports) {
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $0ea22067db16111a$export$399ef3a2d4288bba);
const $0ea22067db16111a$export$399ef3a2d4288bba = {
    name: 'servicedesk-atlassian-analytics',
    path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
    exact: true
};

});

parcelRegister("cH29p", function(module, exports) {
$parcel$export(module.exports, "LazyAtlassianAnalytics", () => $a0b47ff3992b08c5$export$78ffe2f6530d45d1);
$parcel$export(module.exports, "AtlassianAnalytics", () => $a0b47ff3992b08c5$export$6d23a188bb96b7ab);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a0b47ff3992b08c5$export$78ffe2f6530d45d1 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("e4OF5"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $a0b47ff3992b08c5$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a0b47ff3992b08c5$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });

});
parcelRegister("e4OF5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9WetC").then(()=>parcelRequire('efGEo'));

});



parcelRegister("8hfgf", function(module, exports) {
$parcel$export(module.exports, "servicedeskCalendarRouteEntry", () => $1c40f7abe281227e$export$301bfcedbd0983b7);

var $iWUAX = parcelRequire("iWUAX");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5FSZM = parcelRequire("5FSZM");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $cW37W = parcelRequire("cW37W");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $F9BvL = parcelRequire("F9BvL");

var $3NCrh = parcelRequire("3NCrh");
const $1c40f7abe281227e$export$301bfcedbd0983b7 = (0, $6xToB.createEntry)((0, $cW37W.servicedeskCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm-calendar',
        component: ()=>null,
        skeleton: (0, $F9BvL.ClassicCalendarSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $iWUAX.AsyncViewsNav)
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5FSZM.getCalendarFilterFieldsResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!false, (0, $c0h8V.uifBoardResource))
        ],
        entryPoint: ()=>(0, $3NCrh.calendarPageEntryPoint),
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-calendar-entries/src/servicedeskCalendarRouteEntry.tsx',
                whichExportToUse: 'servicedeskCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cW37W", function(module, exports) {
$parcel$export(module.exports, "servicedeskCalendarRoute", () => $6a52e1413cb61025$export$28a386a00670c893);
const $6a52e1413cb61025$export$28a386a00670c893 = {
    name: 'servicedesk-calendar',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};

});

parcelRegister("3NCrh", function(module, exports) {
$parcel$export(module.exports, "calendarPageEntryPoint", () => $eb7b4ca967c641ff$export$eda0c2fb67f7d7e7);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4mfV8 = parcelRequire("4mfV8");
const $eb7b4ca967c641ff$export$eda0c2fb67f7d7e7 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4mfV8.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("57C4N", function(module, exports) {
$parcel$export(module.exports, "servicedeskChangeCalendarRouteEntry", () => $a58eb1942729acea$export$de5b915e23c7ce7d);

var $kHlOR = parcelRequire("kHlOR");

var $8rDuZ = parcelRequire("8rDuZ");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3tvzo = parcelRequire("3tvzo");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $2GFiz = parcelRequire("2GFiz");

var $hQazK = parcelRequire("hQazK");

var $b3PSq = parcelRequire("b3PSq");
const $a58eb1942729acea$export$de5b915e23c7ce7d = (0, $6xToB.createEntry)((0, $3tvzo.servicedeskChangeCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.change-calendar',
        component: (0, $b3PSq.default),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $8rDuZ.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $2GFiz.changeCalendarViewSettingsResource),
            (0, $hQazK.changeCalendarFilterSettingsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b3PSq.LazyChangeCalendar),
            (0, $8rDuZ.LazyJSMOperationsHorizontalNav)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-change-calendar-entries/src/servicedeskChangeCalendarRouteEntry.tsx',
                whichExportToUse: 'servicedeskChangeCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8rDuZ", function(module, exports) {
$parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", () => $5f371d9b400d2df5$export$d9802671a2b1aa20);
$parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", () => $5f371d9b400d2df5$export$d4493569f106c71);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $5f371d9b400d2df5$export$d9802671a2b1aa20 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dIpvk")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
});
const $5f371d9b400d2df5$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f371d9b400d2df5$export$d9802671a2b1aa20, null)));

});
parcelRegister("dIpvk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1q7nt").then(()=>parcelRequire('8mRWC'));

});


parcelRegister("3tvzo", function(module, exports) {
$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $fdafd4bc56333276$export$3dbc16ae422c469);
const $fdafd4bc56333276$export$3dbc16ae422c469 = {
    name: 'servicedesk-change-calendar',
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("2GFiz", function(module, exports) {
$parcel$export(module.exports, "changeCalendarViewSettingsResource", () => $ffd75187e7726871$export$30950a4228efde07);

var $l1VxS = parcelRequire("l1VxS");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $ffd75187e7726871$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    const { projectKey: projectKey } = routerContext.match.params;
    try {
        const response = await (0, $3ugTQ.performGetRequest)(`/gateway/api/jsm/change-management/view/api/v1/cloudId/${cloudId}/settings/project/${projectKey}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getChangeCalendarViewSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $ffd75187e7726871$export$30950a4228efde07 = (0, $l1VxS.createResource)({
    getData: $ffd75187e7726871$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ()=>'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE'
});

});

parcelRegister("hQazK", function(module, exports) {
$parcel$export(module.exports, "changeCalendarFilterSettingsResource", () => $e6a97725cc84fd93$export$2ec0cc3aa9fdf030);

var $l1VxS = parcelRequire("l1VxS");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $e6a97725cc84fd93$var$getData = async (routerContext, { tenantContext: tenantContext })=>{
    if (!routerContext.match.params.projectKey) return;
    const { cloudId: cloudId } = tenantContext;
    if (!routerContext.query.filterId) return;
    const { filterId: filterId } = routerContext.query;
    try {
        const response = await (0, $3ugTQ.performGetRequest)(`/gateway/api/jsm/calendar/cloudid/${cloudId}/v1/change-calendar/filters/${filterId}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getChangeCalendarFilterSettings',
                packageName: 'jiraRouterResourcesJsmChangeCalendar',
                teamName: 'jenga'
            },
            error: error
        });
        throw error;
    }
};
const $e6a97725cc84fd93$export$2ec0cc3aa9fdf030 = (0, $l1VxS.createResource)({
    getData: $e6a97725cc84fd93$var$getData,
    isBrowserOnly: true,
    type: 'CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE',
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    getKey: ({ query: query })=>`CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE-${query.filterId}`
});

});

parcelRegister("b3PSq", function(module, exports) {
$parcel$export(module.exports, "LazyChangeCalendar", () => $05524ec0ecd6d6f3$export$a6cec2d1c2e631eb);
$parcel$export(module.exports, "default", () => $05524ec0ecd6d6f3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $05524ec0ecd6d6f3$export$a6cec2d1c2e631eb = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8xY9u"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
const $05524ec0ecd6d6f3$var$AsyncChangeCalendar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $05524ec0ecd6d6f3$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });
var $05524ec0ecd6d6f3$export$2e2bcd8739ae039 = $05524ec0ecd6d6f3$var$AsyncChangeCalendar;

});
parcelRegister("8xY9u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dFR0m").then(()=>parcelRequire('dY9zr'));

});



parcelRegister("9vC5r", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry", () => $b402e719dae1bbc4$export$b0a16a66af58eb25);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $jW57K = parcelRequire("jW57K");

var $ePaI2 = parcelRequire("ePaI2");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $gy2Qg = parcelRequire("gy2Qg");

var $HGK5Q = parcelRequire("HGK5Q");

var $c72E0 = parcelRequire("c72E0");
const $b402e719dae1bbc4$export$b0a16a66af58eb25 = (0, $6xToB.createEntry)((0, $jW57K.servicedeskCmdbAssetsAnalyticsDataViewCreateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $HGK5Q.AssetsAnalyticsDataViewCreate),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $HGK5Q.LazyServicedeskCmdbAssetsAnalyticsDataViewCreate)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-create',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_CREATE_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsAnalyticsDataViewCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jW57K", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewCreateRoute", () => $49e1e26bc6018617$export$ab4f147f1c700ecd);
const $49e1e26bc6018617$export$ab4f147f1c700ecd = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-create',
    path: '/jira/servicedesk/assets/analytics/data-view/create',
    exact: true
};

});

parcelRegister("HGK5Q", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewList", () => $6861df218fcd0df3$export$1a5a30b71ec01594);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewCreate", () => $6861df218fcd0df3$export$dd5cf457fb6402f7);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsAnalyticsDataViewDetails", () => $6861df218fcd0df3$export$df3c79bc4a19edf1);
$parcel$export(module.exports, "AssetsAnalyticsDataViewList", () => $6861df218fcd0df3$export$a7db3f7bf80b4eb7);
$parcel$export(module.exports, "AssetsAnalyticsDataViewCreate", () => $6861df218fcd0df3$export$fa1e0b9fb89de9d0);
$parcel$export(module.exports, "AssetsAnalyticsDataViewDetails", () => $6861df218fcd0df3$export$3de2c3601c3c1cca);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $6861df218fcd0df3$export$1a5a30b71ec01594 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4OflD")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewList), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-custom-metrics/src/index.tsx"
});

const $6861df218fcd0df3$export$dd5cf457fb6402f7 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4OflD")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewCreate), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-custom-metrics/src/index.tsx"
});

const $6861df218fcd0df3$export$df3c79bc4a19edf1 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4OflD")).then((exportedMembers)=>exportedMembers.CmdbAssetsAnalyticsDataViewDetails), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-custom-metrics/src/index.tsx"
});
const $6861df218fcd0df3$export$a7db3f7bf80b4eb7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6861df218fcd0df3$export$1a5a30b71ec01594,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list",
        shouldShowSpinner: true
    });
const $6861df218fcd0df3$export$fa1e0b9fb89de9d0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6861df218fcd0df3$export$dd5cf457fb6402f7,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create",
        shouldShowSpinner: true
    });
};
const $6861df218fcd0df3$export$3de2c3601c3c1cca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6861df218fcd0df3$export$df3c79bc4a19edf1,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details",
        shouldShowSpinner: true
    });

});
parcelRegister("4OflD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7FeRF").then(()=>parcelRequire('2s0Tm'));

});


parcelRegister("c72E0", function(module, exports) {
$parcel$export(module.exports, "AssetsAppRedirect", () => $0a528a52baf56a38$export$5d5d166a9477289f);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $2mHfh = parcelRequire("2mHfh");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $bYOuG = parcelRequire("bYOuG");

var $4cTDP = parcelRequire("4cTDP");
const $0a528a52baf56a38$export$2197c8adbafa78d4 = (match, query)=>{
    const pattern = /\/jira\/servicedesk\/(assets|insight)/;
    // We are intentionally using a new regex for being extra safe and not to disturb original regex used for majority of the app routes
    const objectPathPattern = /\/jira\/servicedesk\/insight\/assets/;
    let redirectionUrl;
    if (match.url.match(objectPathPattern) && (0, $4cTDP.fg)('assets_object_route_redirection_fix')) redirectionUrl = match.url.replace(objectPathPattern, (0, $bYOuG.ASSETS_APP_OBJECT_ROUTE_PREFIX));
    else redirectionUrl = match.url.replace(pattern, (0, $bYOuG.ASSETS_APP_ROUTE_PREFIX));
    if (Object.keys(query).length > 0) redirectionUrl += `?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(query)}`;
    return redirectionUrl;
};
const $0a528a52baf56a38$export$5d5d166a9477289f = ({ match: match, query: query })=>{
    const redirectionUrl = $0a528a52baf56a38$export$2197c8adbafa78d4(match, query);
    const analyticsAttributes = {
        matchedRoute: match.path
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "assetsAppRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: redirectionUrl,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: analyticsAttributes
    }));
};

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';



parcelRegister("4XaE0", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry", () => $51bec44cb3cf7f69$export$cb82af0ec920487e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $lCkAD = parcelRequire("lCkAD");

var $ePaI2 = parcelRequire("ePaI2");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $gy2Qg = parcelRequire("gy2Qg");

var $HGK5Q = parcelRequire("HGK5Q");

var $c72E0 = parcelRequire("c72E0");
const $51bec44cb3cf7f69$export$cb82af0ec920487e = (0, $6xToB.createEntry)((0, $lCkAD.servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $HGK5Q.AssetsAnalyticsDataViewDetails),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $HGK5Q.LazyServicedeskCmdbAssetsAnalyticsDataViewDetails)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-details',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_DETAILS_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsAnalyticsDataViewDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lCkAD", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute", () => $9c8a514cc3f2866f$export$b024a0a636d7f43e);
const $9c8a514cc3f2866f$export$b024a0a636d7f43e = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-details',
    path: '/jira/servicedesk/assets/analytics/data-view/:dataViewId',
    exact: true
};

});


parcelRegister("3OnXm", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry", () => $701754a710e60c11$export$79ee0c9fe260269a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $dzfT8 = parcelRequire("dzfT8");

var $ePaI2 = parcelRequire("ePaI2");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $gy2Qg = parcelRequire("gy2Qg");

var $HGK5Q = parcelRequire("HGK5Q");

var $c72E0 = parcelRequire("c72E0");
const $701754a710e60c11$export$79ee0c9fe260269a = (0, $6xToB.createEntry)((0, $dzfT8.servicedeskCmdbAssetsAnalyticsDataViewListRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $HGK5Q.AssetsAnalyticsDataViewList),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $HGK5Q.LazyServicedeskCmdbAssetsAnalyticsDataViewList)
        ],
        meta: {
            reporting: {
                id: 'insight-assets-analytics-data-view-list',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsAnalyticsDataViewListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dzfT8", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsAnalyticsDataViewListRoute", () => $a99e99e3d00ab016$export$9134bfe87d382f51);
const $a99e99e3d00ab016$export$9134bfe87d382f51 = {
    name: 'servicedesk-cmdb-assets-analytics-data-view-list',
    path: '/jira/servicedesk/assets/analytics/data-view',
    exact: true
};

});


parcelRegister("4qGpF", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsDetailRouteEntry", () => $4408143e6341c3d5$export$65208ca229cf3450);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $lQAm3 = parcelRequire("lQAm3");

var $ePaI2 = parcelRequire("ePaI2");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $2mHfh = parcelRequire("2mHfh");

var $iPsB5 = parcelRequire("iPsB5");

var $eMVa2 = parcelRequire("eMVa2");

var $dF368 = parcelRequire("dF368");

var $gy2Qg = parcelRequire("gy2Qg");

var $c1dkq = parcelRequire("c1dkq");
const $4408143e6341c3d5$var$DashboardsDetailPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dF368.AssetsAppBase), {
        appName: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS
    }, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eMVa2.DashboardEditable), {
            workspaceId: workspaceId
        }));
const $4408143e6341c3d5$export$65208ca229cf3450 = (0, $6xToB.createEntry)((0, $lQAm3.servicedeskCmdbAssetsDashboardsDetailRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $iPsB5.isNewReportsNavExperienceEnabled)() ? (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $4408143e6341c3d5$var$DashboardsDetailPage, (0, $c1dkq.AssetsReportsNav4HomePage)) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                to: "/jira/servicedesk/assets/reports"
            }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsDashboardsDetailRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsDashboardsDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lQAm3", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsDetailRoute", () => $b971cdd7b3198492$export$d8486f1b228287be);
const $b971cdd7b3198492$export$d8486f1b228287be = {
    name: 'servicedesk-cmdb-assets-dashboards-detail',
    path: '/jira/servicedesk/assets/dashboards/:templateId',
    exact: true
};

});

parcelRegister("iPsB5", function(module, exports) {
$parcel$export(module.exports, "isNewReportsNavExperienceEnabled", () => $5328af267d6a68c2$export$47ecf2612742e601);
$parcel$export(module.exports, "isEAPEnabled", () => $5328af267d6a68c2$export$9b7963d512920ccb);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $5328af267d6a68c2$export$b8215a2c67e2e65d = {
    main: 'assets-reports-and-dashboard-navigation',
    permission: 'jsm_reporting_enable_new_permission_check_flow',
    eap: 'new_assets_reports_avp_experience'
};
const $5328af267d6a68c2$export$87e0f7dd6dec932f = (key)=>Boolean((0, $4cTDP.fg)(key));
const $5328af267d6a68c2$export$3ffa4c816d3c03c1 = ()=>$5328af267d6a68c2$export$87e0f7dd6dec932f($5328af267d6a68c2$export$b8215a2c67e2e65d.main);
const $5328af267d6a68c2$export$1963b85f49b84306 = ()=>$5328af267d6a68c2$export$87e0f7dd6dec932f($5328af267d6a68c2$export$b8215a2c67e2e65d.permission);
const $5328af267d6a68c2$export$47ecf2612742e601 = ()=>$5328af267d6a68c2$export$87e0f7dd6dec932f($5328af267d6a68c2$export$b8215a2c67e2e65d.main) && $5328af267d6a68c2$export$87e0f7dd6dec932f($5328af267d6a68c2$export$b8215a2c67e2e65d.permission) && $5328af267d6a68c2$export$87e0f7dd6dec932f($5328af267d6a68c2$export$b8215a2c67e2e65d.eap);
const $5328af267d6a68c2$export$9b7963d512920ccb = ()=>$5328af267d6a68c2$export$87e0f7dd6dec932f($5328af267d6a68c2$export$b8215a2c67e2e65d.eap);
const $5328af267d6a68c2$export$f4ca7621f04b1c1c = ()=>(0, $eJOHy.useMemo)(()=>{
        const mainGateEnabled = $5328af267d6a68c2$export$3ffa4c816d3c03c1();
        const permissionGateEnabled = $5328af267d6a68c2$export$1963b85f49b84306();
        return {
            mainGateEnabled: mainGateEnabled,
            permissionGateEnabled: permissionGateEnabled,
            dashboardsVisibleForNonAdmin: mainGateEnabled && permissionGateEnabled
        };
    }, []);

});

parcelRegister("eMVa2", function(module, exports) {
$parcel$export(module.exports, "DashboardEditable", () => $fb31076aec92f6c1$export$33b9febc64bdf6bf);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $b59tJ = parcelRequire("b59tJ");

var $2mHfh = parcelRequire("2mHfh");
var $2FqDG = parcelRequire("2FqDG");

var $cHtIB = parcelRequire("cHtIB");

var $5Ouxk = parcelRequire("5Ouxk");

var $2b5QU = parcelRequire("2b5QU");
const $fb31076aec92f6c1$export$33b9febc64bdf6bf = ({ workspaceId: workspaceId })=>{
    const [slug] = (0, $2FqDG.usePathParam)('templateId');
    const cloudId = (0, $cHtIB.useCloudId)();
    if (!slug) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/servicedesk/assets/reports"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2b5QU.PreferenceBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fb31076aec92f6c1$var$dashboardEditableWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b59tJ.DashboardEditableLazy), {
        hostingProduct: (0, $5Ouxk.getHostingProduct)(),
        slug: slug,
        workspaceId: workspaceId,
        allowGlobalFilters: true,
        cloudId: cloudId
    })));
};
const $fb31076aec92f6c1$var$dashboardEditableWrapper = (0, $1DXK0.xcss)({
    marginLeft: 'space.400',
    marginRight: 'space.400'
});

});
parcelRegister("b59tJ", function(module, exports) {
$parcel$export(module.exports, "DashboardEditableLazy", () => $1cad82f604d976f8$export$db714d458a872ac3);
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");

const $1cad82f604d976f8$export$db714d458a872ac3 = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("8ungs")).then(({ DashboardEditable: DashboardEditable })=>DashboardEditable), {
    ssr: false
});

});
parcelRegister("bn7wb", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("aAuez")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("aAuez")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("aAuez")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $MkKnc = parcelRequire("MkKnc");

var $aAuez = parcelRequire("aAuez");
parcelRequire("4XKbm");
var $7eb8v = parcelRequire("7eb8v");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $7qz8r = parcelRequire("7qz8r");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");

var $hrq5I = parcelRequire("hrq5I");

});
parcelRegister("7veda", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $576673b9f1b70022$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $576673b9f1b70022$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8V4xR")).MODE);

var $8V4xR = parcelRequire("8V4xR");
const $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN = undefined;
const $576673b9f1b70022$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $576673b9f1b70022$var$DEFAULT_MODE = (0, $8V4xR.MODE).HYDRATE;
const $576673b9f1b70022$var$DEFAULT_RETRY = 2;
const $576673b9f1b70022$var$config = {
    crossOrigin: $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN,
    manifest: $576673b9f1b70022$var$DEFAULT_MANIFEST,
    mode: $576673b9f1b70022$var$DEFAULT_MODE,
    retry: $576673b9f1b70022$var$DEFAULT_RETRY
};
const $576673b9f1b70022$export$44487a86467333c3 = ()=>$576673b9f1b70022$var$config;
const $576673b9f1b70022$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $576673b9f1b70022$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN;
    $576673b9f1b70022$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $576673b9f1b70022$var$DEFAULT_MANIFEST;
    $576673b9f1b70022$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $576673b9f1b70022$var$DEFAULT_MODE;
    $576673b9f1b70022$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $576673b9f1b70022$var$DEFAULT_RETRY;
};

});
parcelRegister("8V4xR", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $67e72c25add85f29$export$e48589d9e4824227);
const $67e72c25add85f29$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("MkKnc", function(module, exports) {

var $8h7zW = parcelRequire("8h7zW");

var $7veda = parcelRequire("7veda");
parcelRequire("1llka");
var $eGDOl = parcelRequire("eGDOl");
var $l7ep7 = parcelRequire("l7ep7");

var $a1Dox = parcelRequire("a1Dox");
const $091493b8f27d5831$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $7veda.setConfig)(config);
        (0, $eGDOl.LISTENERS).length = 0;
        (0, $l7ep7.setCurrent)(0);
        if (!(0, $a1Dox.isNodeEnvironment)()) (0, $8h7zW.collect)();
    }
};

});
parcelRegister("8h7zW", function(module, exports) {
$parcel$export(module.exports, "collect", () => $6065ca3c1e226813$export$bb44f104e3c54dae);

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");

var $9WyUY = parcelRequire("9WyUY");

var $1NKbK = parcelRequire("1NKbK");
const $6065ca3c1e226813$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $7veda.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8V4xR.MODE).RENDER ? (0, $9WyUY.cloneElements)(markers[i], lazyBegin) : (0, $1NKbK.refElements)(markers[i], lazyBegin);
        if ((0, $bzDJE.COLLECTED).has(lazyBegin)) (0, $bzDJE.COLLECTED).get(lazyBegin).push(value);
        else (0, $bzDJE.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("bzDJE", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $86d1c92cf7d83ac0$export$4831ef3968ea94ef);
const $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $86d1c92cf7d83ac0$export$4831ef3968ea94ef = new Map();

});

parcelRegister("9WyUY", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $73d49dd0c38c2a1c$export$c42217d53a7ebafb);
const $73d49dd0c38c2a1c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("1NKbK", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $14fe3218cc4e45c4$export$c69443129766a7fc);
const $14fe3218cc4e45c4$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1llka", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("l7ep7")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("l7ep7")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("eGDOl")).LISTENERS);

var $l7ep7 = parcelRequire("l7ep7");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");

});
parcelRegister("l7ep7", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $f5f56cc3db1024b3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $f5f56cc3db1024b3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $f5f56cc3db1024b3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $bzDJE = parcelRequire("bzDJE");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");
let $f5f56cc3db1024b3$var$CURRENT_PHASE = (0, $bzDJE.PHASE).PAINT;
const $f5f56cc3db1024b3$export$5f80f094fd31fffd = (phase)=>{
    $f5f56cc3db1024b3$var$CURRENT_PHASE = phase;
    (0, $eGDOl.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $f5f56cc3db1024b3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $7Peej.createSubscribe)((0, $eGDOl.LISTENERS)),
    currentValue: ()=>$f5f56cc3db1024b3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).PAINT)
    }
});
const $f5f56cc3db1024b3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($f5f56cc3db1024b3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("eGDOl", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $ab13de8c68717d57$export$81b9c458a026d68f);
const $ab13de8c68717d57$export$81b9c458a026d68f = [];

});

parcelRegister("7Peej", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $5b2855963721e7ea$export$364097d812234b3f);
const $5b2855963721e7ea$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("a1Dox", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $74c88e574846d6bd$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $74c88e574846d6bd$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $74c88e574846d6bd$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $74c88e574846d6bd$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("ed3y6")).default);

var $ed3y6 = parcelRequire("ed3y6");
const $74c88e574846d6bd$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $74c88e574846d6bd$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $74c88e574846d6bd$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $74c88e574846d6bd$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("ed3y6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5850857827bd3c9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a5850857827bd3c9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("aAuez", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $7b54b80385d7fc57$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $7b54b80385d7fc57$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $7b54b80385d7fc57$export$488013bae63b21da);

var $j5vcn = parcelRequire("j5vcn");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");

var $a1Dox = parcelRequire("a1Dox");
var $ed3y6 = parcelRequire("ed3y6");

var $b8XF0 = parcelRequire("b8XF0");

var $jA7rF = parcelRequire("jA7rF");

var $c7s3I = parcelRequire("c7s3I");

var $iFrYh = parcelRequire("iFrYh");

var $dcrQD = parcelRequire("dcrQD");

var $dcUz2 = parcelRequire("dcUz2");

var $2f83m = parcelRequire("2f83m");
function $7b54b80385d7fc57$var$_extends() {
    $7b54b80385d7fc57$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b54b80385d7fc57$var$_extends.apply(this, arguments);
}
function $7b54b80385d7fc57$var$lazyProxy(_loader, { defer: defer = (0, $bzDJE.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $a1Dox.isNodeEnvironment)();
    const dataLazyId = (0, $ed3y6.default)(moduleId);
    const LazyInternal = isServer ? (0, $c7s3I.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jA7rF.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $iFrYh.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $7veda.getConfig)();
                return (0, $dcUz2.retry)(_loader, {
                    delay: (0, $b8XF0.RETRY_DELAY),
                    factor: (0, $b8XF0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $a1Dox.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $7veda.getConfig)();
        return (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $bzDJE.PHASE).PAINT ? (0, $b8XF0.PRIORITY).HIGH : (0, $b8XF0.PRIORITY).LOW;
        return (0, $dcrQD.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $7b54b80385d7fc57$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $bzDJE.PHASE).LAZY
    }
};
function $7b54b80385d7fc57$export$c952e5f94576010e(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $7b54b80385d7fc57$export$291dd592399bdafa(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $7b54b80385d7fc57$export$488013bae63b21da(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("j5vcn", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $de56af5358c8f987$export$303f43e55cf1ef2f);
const $de56af5358c8f987$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("b8XF0", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $81ceb864b052c80d$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $81ceb864b052c80d$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $81ceb864b052c80d$export$ba64c908e55507fe);
const $81ceb864b052c80d$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $81ceb864b052c80d$export$a339266ad71b2447 = 300;
const $81ceb864b052c80d$export$ba64c908e55507fe = 1;

});

parcelRegister("jA7rF", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $e417279bde8da3e7$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $2f83m = parcelRequire("2f83m");

var $bVeRl = parcelRequire("bVeRl");

var $7fZLe = parcelRequire("7fZLe");

var $hrq5I = parcelRequire("hrq5I");

var $9qVNk = parcelRequire("9qVNk");
function $e417279bde8da3e7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $2f83m.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $9qVNk.useSubscription)({
            context: (0, $esFTx.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $bzDJE.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $9qVNk.useSubscription)({
            context: (0, $l7ep7.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        (0, $eJOHy.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $bzDJE.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $7veda.getConfig)().mode === (0, $8V4xR.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bVeRl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fZLe.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("4XKbm", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("esFTx")).WaitContext);

var $esFTx = parcelRequire("esFTx");

var $7eb8v = parcelRequire("7eb8v");

});
parcelRegister("esFTx", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $a8742da03f685732$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $ddxDA = parcelRequire("ddxDA");
const $a8742da03f685732$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $ddxDA.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ddxDA", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $99f694f5596397af$export$276c7dbda7675aec);
const $99f694f5596397af$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("7eb8v", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $esFTx = parcelRequire("esFTx");
const $54327a9f9e29fe04$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esFTx.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("jv91R", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("4XL9N")).LazySuspenseContext);

var $7qz8r = parcelRequire("7qz8r");

var $4XL9N = parcelRequire("4XL9N");

});
parcelRegister("7qz8r", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $56863736a86894e9$export$256c542058532d6f);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");

var $4XL9N = parcelRequire("4XL9N");
class $56863736a86894e9$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $a1Dox.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("4XL9N", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $39d1408803878497$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");
const $39d1408803878497$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("2f83m", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $1a233ab151dd1ee2$export$c73a6a6f0bf7d425);
const $1a233ab151dd1ee2$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $1a233ab151dd1ee2$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$1a233ab151dd1ee2$export$6aa69c1258005366]: true
    });
    return error;
};
const $1a233ab151dd1ee2$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($1a233ab151dd1ee2$export$6aa69c1258005366);

});

parcelRegister("bVeRl", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $8ae08b5f412b712d$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $hrq5I = parcelRequire("hrq5I");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");
function $8ae08b5f412b712d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $8ae08b5f412b712d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($8ae08b5f412b712d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $8ae08b5f412b712d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $8ae08b5f412b712d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("hrq5I", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cb29326da0127013$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cb29326da0127013$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $cb29326da0127013$export$e2d53c0cbedd2710 = {
    current: null
};
const $cb29326da0127013$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $eJOHy.createContext)($cb29326da0127013$export$e2d53c0cbedd2710);

});


parcelRegister("7fZLe", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $5489d785fce022f5$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");
function $5489d785fce022f5$var$_extends() {
    $5489d785fce022f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5489d785fce022f5$var$_extends.apply(this, arguments);
}
const $5489d785fce022f5$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $a1Dox.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), $5489d785fce022f5$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("9qVNk", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $6de35f980c3d94e0$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $6de35f980c3d94e0$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("c7s3I", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $8d2be766ecc6ab62$export$eb2e4b04351cdd9e);

var $j5vcn = parcelRequire("j5vcn");

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $a1Dox = parcelRequire("a1Dox");

var $2f83m = parcelRequire("2f83m");
function $8d2be766ecc6ab62$var$load(moduleId, loader) {
    try {
        return (0, $a1Dox.getExport)(loader());
    } catch (err) {
        throw (0, $2f83m.createLoaderError)(err);
    }
}
function $8d2be766ecc6ab62$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $8d2be766ecc6ab62$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $7veda.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $bzDJE.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $bzDJE.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("iFrYh", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $0381d5b0cf615548$export$e673efccd97e4223);
const $0381d5b0cf615548$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("dcrQD", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $99c1ff5e48fc9639$export$25bad4aa00c45355);

var $j5vcn = parcelRequire("j5vcn");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");

var $a1Dox = parcelRequire("a1Dox");

var $b8XF0 = parcelRequire("b8XF0");

var $dfXT0 = parcelRequire("dfXT0");

var $hrq5I = parcelRequire("hrq5I");
function $99c1ff5e48fc9639$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $7veda.getConfig)();
    const assets = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dfXT0.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $99c1ff5e48fc9639$var$fakePromise = {
    then: ()=>$99c1ff5e48fc9639$var$fakePromise,
    catch: ()=>$99c1ff5e48fc9639$var$fakePromise,
    finally: ()=>$99c1ff5e48fc9639$var$fakePromise
};
function $99c1ff5e48fc9639$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dfXT0.insertLinkTag)(href, rel));
        return $99c1ff5e48fc9639$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $99c1ff5e48fc9639$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ddxDA.noopCleanup;
}
function $99c1ff5e48fc9639$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $a1Dox.isNodeEnvironment)()) return 0, $ddxDA.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $b8XF0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $99c1ff5e48fc9639$export$3af04dbcb01bad4d,
        $99c1ff5e48fc9639$export$1046fd6a49d5e7a,
        $99c1ff5e48fc9639$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $ddxDA.noopCleanup;
}

});
parcelRegister("dfXT0", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $9a6b213a2be2821b$export$6610512821c8a4ce);

var $hrq5I = parcelRequire("hrq5I");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");
function $9a6b213a2be2821b$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ddxDA.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $7veda.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("dcUz2", function(module, exports) {
$parcel$export(module.exports, "retry", () => $99d845ced60c5b28$export$9369b12211e1fce4);
const $99d845ced60c5b28$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $99d845ced60c5b28$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $99d845ced60c5b28$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $99d845ced60c5b28$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $99d845ced60c5b28$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $99d845ced60c5b28$var$calculateDelay(context, policy);
        if (delay) await $99d845ced60c5b28$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("8ungs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("gl2Sq")),
    $ewTvA("fliVL"),
    $ewTvA("fuCxJ")
]).then(()=>parcelRequire('jZjAt'));

});


parcelRegister("5Ouxk", function(module, exports) {
$parcel$export(module.exports, "getHostingProduct", () => $07d02ec960ac7e75$export$4ac9b8bbf7bb869);

var $4cTDP = parcelRequire("4cTDP");
const $07d02ec960ac7e75$export$4ac9b8bbf7bb869 = ()=>(0, $4cTDP.fg)('provide-hosting-product-for-assets') ? 'jira-servicedesk' : 'jsm-cmdb';

});

parcelRegister("2b5QU", function(module, exports) {
$parcel$export(module.exports, "PreferenceBanner", () => $3a8f330600f78775$export$414648a648c28f83);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $6HUl7 = parcelRequire("6HUl7");

var $83DiZ = parcelRequire("83DiZ");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iPsB5 = parcelRequire("iPsB5");

var $TzT2p = parcelRequire("TzT2p");
const $3a8f330600f78775$export$414648a648c28f83 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { updatePreferences: updatePreferences } = (0, $6HUl7.usePreferencesContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { replace: replace } = (0, $83DiZ.useRouterActions)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const updatePreferencesAndRedirect = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'reportsNewExperienceButton'
        });
        (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'reportsNewExperienceButton toggled', {
            source: 'In-product AVP Assets Reports',
            toggleState: 'Disabled'
        });
        updatePreferences(false, ()=>{
            replace(`/jira/servicedesk/assets/reports?t=${new Date().getTime()}`);
        });
    };
    const openAssetsReportsFeedbackCollector = ()=>{
        openFeedbackCollector({
            entrypointId: (0, $gdeTc.ENTRY_POINT_ID_JSM_ASSETS_REPORTING)
        });
    };
    if ((0, $iPsB5.isNewReportsNavExperienceEnabled)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3a8f330600f78775$var$preferenceBannerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "moved",
        isBold: true
    }, formatMessage((0, $TzT2p.messages).eapLozengeTitle)), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $TzT2p.messages).bannerTitle, {
        feedbackLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                xcss: $3a8f330600f78775$var$linkStyles,
                onClick: openAssetsReportsFeedbackCollector
            }, chunks),
        previousExperienceLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                xcss: $3a8f330600f78775$var$linkStyles,
                onClick: updatePreferencesAndRedirect
            }, chunks)
    })));
};
const $3a8f330600f78775$var$preferenceBannerWrapper = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #091E4224)",
    backgroundColor: 'elevation.surface.sunken'
});
const $3a8f330600f78775$var$linkStyles = (0, $1DXK0.xcss)({
    color: 'color.link',
    background: 'none',
    padding: '0',
    margin: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("6HUl7", function(module, exports) {
$parcel$export(module.exports, "PreferencesProvider", () => $fe9c90cc7b4e6ea1$export$3d5a0a3e1b7bc50c);
$parcel$export(module.exports, "usePreferencesContext", () => $fe9c90cc7b4e6ea1$export$db2d0224cbb00da8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kn8Am = parcelRequire("kn8Am");
const $fe9c90cc7b4e6ea1$var$PreferencesContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $fe9c90cc7b4e6ea1$export$3d5a0a3e1b7bc50c = ({ children: children, featureGateKey: featureGateKey, workspaceId: workspaceId })=>{
    const preferences = (0, $kn8Am.usePreferences)(featureGateKey, workspaceId);
    const value = {
        ...preferences,
        workspaceId: workspaceId
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($fe9c90cc7b4e6ea1$var$PreferencesContext.Provider, {
        value: value,
        children: children
    });
};
const $fe9c90cc7b4e6ea1$export$db2d0224cbb00da8 = ()=>{
    const context = (0, $eJOHy.useContext)($fe9c90cc7b4e6ea1$var$PreferencesContext);
    if (context === undefined) throw new Error('usePreferencesContext must be used within a PreferencesProvider');
    return context;
};

});
parcelRegister("kn8Am", function(module, exports) {
$parcel$export(module.exports, "usePreferences", () => $3e536ec4a864f30d$export$bbd7d970555e2952);

var $eJOHy = parcelRequire("eJOHy");

var $4Z1vj = parcelRequire("4Z1vj");

var $4daT2 = parcelRequire("4daT2");

var $4SouH = parcelRequire("4SouH");
const $3e536ec4a864f30d$export$bbd7d970555e2952 = (featureGateKey, workspaceId)=>{
    const { fireOperationalEvent: fireOperationalEvent } = (0, $4SouH.useAnalytics)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $4Z1vj.default)((0, $4daT2.getPreferences), [
        workspaceId,
        featureGateKey,
        fireOperationalEvent
    ]);
    const updatePreferences = (0, $eJOHy.useCallback)(async (value, callback)=>{
        await (0, $4daT2.updatePreferences)(workspaceId, featureGateKey, value, fireOperationalEvent);
        refetch();
        if (callback) callback();
    }, [
        workspaceId,
        featureGateKey,
        fireOperationalEvent,
        refetch
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        updatePreferences: updatePreferences
    };
};

});
parcelRegister("4Z1vj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cd92774c991425e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $4cd92774c991425e$var$useFetch(fetcher, args, { enabled: enabled = true } = {}) {
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(enabled);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        let isActive = true;
        setData(null);
        setLoading(true);
        setError(null);
        try {
            const result = await fetcher(...args);
            if (isActive) setData(result);
        } catch (err) {
            if (isActive) setError(err instanceof Error ? err : new Error('Unknown error'));
        } finally{
            if (isActive) setLoading(false);
        }
        return ()=>{
            isActive = false;
        };
    // eslint says "React Hook useEffect has a missing dependency: 'args'". We already have spread args in the dependency array.
    }, [
        fetcher,
        setLoading,
        setData,
        setError,
        ...args
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const refetch = (0, $eJOHy.useCallback)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!enabled) {
            setLoading(false);
            setData(null);
            setError(null);
            return;
        }
        fetchData();
    }, [
        enabled,
        fetchData,
        setLoading,
        setData,
        setError
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        refetch: refetch
    };
}
var $4cd92774c991425e$export$2e2bcd8739ae039 = $4cd92774c991425e$var$useFetch;

});

parcelRegister("4daT2", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $d82439fc00dba013$export$1de6a888ae076ff8);
$parcel$export(module.exports, "updatePreferences", () => $d82439fc00dba013$export$7bb3e177c1a1e841);

var $fFEl8 = parcelRequire("fFEl8");

var $dWaXN = parcelRequire("dWaXN");
const $d82439fc00dba013$export$1de6a888ae076ff8 = async (workspaceId, featureGateKey, fireOperationalEvent)=>{
    try {
        return await (0, $fFEl8.performReportsGetRequest)((0, $dWaXN.getPreferencesUrl)(workspaceId, featureGateKey), undefined, {
            analyticsPayload: {
                actionSubject: 'preferencesRequest'
            },
            fireOperationalEvent: fireOperationalEvent
        });
    } catch (error) {
        throw new Error(`[Preferences API] Failed to get preferences: ${error}`);
    }
};
const $d82439fc00dba013$export$7bb3e177c1a1e841 = async (workspaceId, featureGateKey, value, fireOperationalEvent)=>{
    try {
        return await (0, $fFEl8.performReportsPutRequest)((0, $dWaXN.updatePreferencesUrl)(workspaceId, featureGateKey), {
            selectedValue: value
        }, undefined, {
            analyticsPayload: {
                actionSubject: 'preferencesUpdate'
            },
            fireOperationalEvent: fireOperationalEvent
        });
    } catch (error) {
        throw new Error(`[Preferences API] Failed to update preferences: ${error}`);
    }
};

});
parcelRegister("fFEl8", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $579291db93566abb$export$26e841bcf1aeb894);
$parcel$export(module.exports, "performReportsGetRequest", () => $579291db93566abb$export$f0b17c8b664b54f2);
$parcel$export(module.exports, "performReportsPostRequest", () => $579291db93566abb$export$24007b9f63749e35);
$parcel$export(module.exports, "performReportsPutRequest", () => $579291db93566abb$export$b6d7142899083503);
const $579291db93566abb$var$BASE_REQUEST_HEADERS = {
    'X-Request-Source': 'jsm-reporting-frontend',
    'Content-Type': 'application/json'
};
const $579291db93566abb$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
class $579291db93566abb$export$26e841bcf1aeb894 extends Error {
    constructor(message, status, payload){
        super(message);
        this.status = status;
        this.payload = payload;
    }
}
const $579291db93566abb$var$performRequest = async (url, method, options = {})=>{
    const { maxRetries: maxRetries = 1, retryDelayMs: retryDelayMs = 1000, ...requestOptions } = options;
    const requestConfig = {
        method: method,
        ...requestOptions,
        headers: {
            ...$579291db93566abb$var$BASE_REQUEST_HEADERS,
            ...requestOptions.headers
        }
    };
    let attempt = 1;
    while(attempt <= maxRetries)try {
        const response = await fetch(url, requestConfig);
        // Handle non-ok responses
        if (!response.ok) {
            if (attempt < maxRetries) {
                await $579291db93566abb$var$sleep(retryDelayMs);
                attempt++;
                continue;
            }
            const payload = await response.json().catch(()=>response.text());
            throw new $579291db93566abb$export$26e841bcf1aeb894('[performRequest] Request failed', response.status, payload);
        }
        // Success - parse and return
        return response.json();
    } catch (error) {
        // Handle fetch errors (network issues, CORS, etc.)
        if (attempt < maxRetries) {
            await $579291db93566abb$var$sleep(retryDelayMs);
            attempt++;
            continue;
        }
        throw error; // Re-throw the original error after all retries exhausted
    }
    // This should never be reached in practice since the while loop will always either:
    // 1. Return successfully (response.ok === true)
    // 2. Throw an error (after all retries exhausted)
    // However, TypeScript's static analysis cannot prove this, so we need this fallback
    throw new Error('Unexpected end of retry loop');
};
const $579291db93566abb$var$withAnalytics = async (requestFn, analyticsOptions)=>{
    try {
        const result = await requestFn();
        analyticsOptions?.fireOperationalEvent({
            action: 'succeeded',
            ...analyticsOptions.analyticsPayload
        });
        return result;
    } catch (error) {
        analyticsOptions?.fireOperationalEvent({
            action: 'failed',
            ...analyticsOptions.analyticsPayload
        });
        throw error;
    }
};
const $579291db93566abb$export$23780ef4bc6c4514 = async (url, method, body, options, analyticsOptions)=>{
    const requestOptions = {
        ...options
    };
    if (body) requestOptions.body = JSON.stringify(body);
    return $579291db93566abb$var$withAnalytics(()=>$579291db93566abb$var$performRequest(url, method, requestOptions), analyticsOptions);
};
const $579291db93566abb$export$f0b17c8b664b54f2 = async (url, options, analyticsOptions)=>$579291db93566abb$export$23780ef4bc6c4514(url, 'GET', undefined, options, analyticsOptions);
const $579291db93566abb$export$24007b9f63749e35 = async (url, body, options, analyticsOptions)=>$579291db93566abb$export$23780ef4bc6c4514(url, 'POST', body, options, analyticsOptions);
const $579291db93566abb$export$b6d7142899083503 = async (url, body, options, analyticsOptions)=>$579291db93566abb$export$23780ef4bc6c4514(url, 'PUT', body, options, analyticsOptions);

});

parcelRegister("dWaXN", function(module, exports) {
$parcel$export(module.exports, "getProductMetricsUrl", () => $d634cf36c6d5b4bb$export$965df6beb7563c63);
$parcel$export(module.exports, "getChartConfigurationsUrl", () => $d634cf36c6d5b4bb$export$97eee691d79e8eec);
$parcel$export(module.exports, "getValuesDetailsUrl", () => $d634cf36c6d5b4bb$export$f50e21cb79be52e3);
$parcel$export(module.exports, "getValuesUrls", () => $d634cf36c6d5b4bb$export$ebcc9b3c85502c2);
$parcel$export(module.exports, "getChartDataUrl", () => $d634cf36c6d5b4bb$export$88e98f1ef28677aa);
$parcel$export(module.exports, "getChartDataV2Url", () => $d634cf36c6d5b4bb$export$289c282f4840e5c2);
$parcel$export(module.exports, "getPreferencesUrl", () => $d634cf36c6d5b4bb$export$1f278467af720e0b);
$parcel$export(module.exports, "updatePreferencesUrl", () => $d634cf36c6d5b4bb$export$7ba6d479e75b6845);
$parcel$export(module.exports, "getHydrateUrl", () => $d634cf36c6d5b4bb$export$68468939dbb4640d);
const $d634cf36c6d5b4bb$export$2c7426b9b4a68ed7 = (workspaceId)=>`/gateway/api/jsm/reporting/assets/workspace/${workspaceId}`;
const $d634cf36c6d5b4bb$export$965df6beb7563c63 = (workspaceId, products)=>{
    const queryString = products.length ? `?${products.map((product)=>`product=${product}`).join('&')}` : '';
    return `${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/metrics${queryString}`;
};
const $d634cf36c6d5b4bb$export$97eee691d79e8eec = (workspaceId, metricId)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/metrics/${metricId}/chart-configurations`;
const $d634cf36c6d5b4bb$export$f50e21cb79be52e3 = (workspaceId)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/values/details`;
const $d634cf36c6d5b4bb$export$ebcc9b3c85502c2 = (workspaceId)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/values`;
const $d634cf36c6d5b4bb$export$88e98f1ef28677aa = (workspaceId)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/chart`;
const $d634cf36c6d5b4bb$export$289c282f4840e5c2 = (workspaceId)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/v2/chart`;
const $d634cf36c6d5b4bb$export$1f278467af720e0b = (workspaceId, featureGateKey)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/preferences?featureGateKey=${featureGateKey}`;
const $d634cf36c6d5b4bb$export$7ba6d479e75b6845 = (workspaceId, featureGateKey)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/preferences/${featureGateKey}?featureGateKey=${featureGateKey}`;
const $d634cf36c6d5b4bb$export$68468939dbb4640d = (workspaceId)=>`${$d634cf36c6d5b4bb$export$2c7426b9b4a68ed7(workspaceId)}/hydrate`;

});


parcelRegister("4SouH", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $ffc2c5b417053076$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $eJr3A = parcelRequire("eJr3A");
const $ffc2c5b417053076$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>{
        const fireAnalytics = (eventPayload, analyticsType)=>{
            createAnalyticsEvent({
                analyticsType: analyticsType,
                ...eventPayload
            }).fire((0, $eJr3A.ANALYTICS_CHANNEL));
        };
        return {
            fireUIEvent: (event)=>fireAnalytics(event, (0, $e9db81972dce4ebc$export$a1562d08625f5d7e)),
            fireOperationalEvent: (event)=>fireAnalytics(event, (0, $e9db81972dce4ebc$export$12346a674644c156)),
            fireTrackEvent: (event)=>fireAnalytics(event, (0, $e9db81972dce4ebc$export$947dac6c72b26f81)),
            fireScreenEvent: (event)=>fireAnalytics(event, (0, $e9db81972dce4ebc$export$f1d537d508d2945a))
        };
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("eJr3A", function(module, exports) {
$parcel$export(module.exports, "VIEW_TYPE_THUMBNAIL", () => $d0249290ff54870b$export$c5ccaba974d9b5b6);
$parcel$export(module.exports, "VIEW_TYPE_LIST", () => $d0249290ff54870b$export$9586318477fbfa73);
$parcel$export(module.exports, "BUTTON_ICONS", () => $d0249290ff54870b$export$41781e3872b2c76f);
$parcel$export(module.exports, "FORM_FIELDS", () => $d0249290ff54870b$export$99a39ef6a9d2490c);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $d0249290ff54870b$export$85183a312807388d);
$parcel$export(module.exports, "ARI_ENTITY_PREFIX", () => $d0249290ff54870b$export$3ec028ec5d6b6d06);
$parcel$export(module.exports, "GLOBAL_FILTERS_DIALOG_MIN_BOTTOM_GAP", () => $d0249290ff54870b$export$c3340ed088d9b474);
$parcel$export(module.exports, "GLOBAL_FILTERS_DIALOG_PADDING", () => $d0249290ff54870b$export$b5f46830d8810f78);
$parcel$export(module.exports, "GLOBAL_FILTERS_CTA_FOOTER_HEIGHT", () => $d0249290ff54870b$export$35555a8058c99818);

var $kMmrb = parcelRequire("kMmrb");
const $d0249290ff54870b$export$c5ccaba974d9b5b6 = 'THUMBNAIL';
const $d0249290ff54870b$export$9586318477fbfa73 = 'LIST';
const $d0249290ff54870b$export$41781e3872b2c76f = {
    plus: (0, (/*@__PURE__*/$parcel$interopDefault($kMmrb)))
};
const $d0249290ff54870b$export$d78e350e65a56112 = 'clientSettings.options';
const $d0249290ff54870b$export$99a39ef6a9d2490c = {
    chartType: 'chartType',
    metric: 'metric',
    title: 'title',
    description: 'description',
    rowsPerPage: 'rowsPerPage',
    isChartConfigurationPending: 'isChartConfigurationPending',
    pendingAsyncActionsCount: 'pendingAsyncActionsCount',
    isSelectedMetricDeprecated: 'isSelectedMetricDeprecated',
    placeholderValidator: 'placeholderValidator'
};
const $d0249290ff54870b$export$85183a312807388d = 'jsmReporting';
const $d0249290ff54870b$export$3ec028ec5d6b6d06 = 'ari:';
const $d0249290ff54870b$export$c3340ed088d9b474 = 20;
const $d0249290ff54870b$export$b5f46830d8810f78 = 24;
const $d0249290ff54870b$export$35555a8058c99818 = 40;

});
parcelRegister("kMmrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14c96c4885e6c927729e770a6ffb9e6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f209b1f071890324$var$_react = $f209b1f071890324$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f209b1f071890324$var$_add = $f209b1f071890324$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $f209b1f071890324$var$_add2 = $f209b1f071890324$var$_interopRequireDefault((parcelRequire("bKq60")));
function $f209b1f071890324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f209b1f071890324$var$AddIcon = (props)=>/*#__PURE__*/ $f209b1f071890324$var$_react.default.createElement($f209b1f071890324$var$_add.default, Object.assign({
        name: "AddIcon",
        LEGACY_fallbackIcon: $f209b1f071890324$var$_add2.default
    }, props));
$f209b1f071890324$var$AddIcon.displayName = 'AddIconMigration';
var $f209b1f071890324$var$_default = module.exports.default = $f209b1f071890324$var$AddIcon;

});
parcelRegister("bKq60", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88d83ba8c9217cfe$var$_react = $88d83ba8c9217cfe$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $88d83ba8c9217cfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88d83ba8c9217cfe$var$EditorAddIcon = (props)=>/*#__PURE__*/ $88d83ba8c9217cfe$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props));
$88d83ba8c9217cfe$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $88d83ba8c9217cfe$var$_default = module.exports.default = $88d83ba8c9217cfe$var$EditorAddIcon;

});






parcelRegister("TzT2p", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ddbb050a3ce04d67$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ddbb050a3ce04d67$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    eapLozengeTitle: {
        "id": "servicedesk-insight-reports-v2.preference-banner.eap-lozenge-title",
        "defaultMessage": "EAP"
    },
    bannerTitle: {
        "id": "servicedesk-insight-reports-v2.preference-banner.banner-title",
        "defaultMessage": "Try the new Assets dashboards available on your site and give us <feedbackLink>your feedback</feedbackLink>. To access your existing reports, return to the <previousExperienceLink>previous experience</previousExperienceLink>."
    }
});

});



parcelRegister("dF368", function(module, exports) {
$parcel$export(module.exports, "AssetsAppBase", () => $62373716cdde4802$export$603e3eacf9be07ce);
$parcel$export(module.exports, "InsightAppBaseV2", () => $62373716cdde4802$export$c9b1085d6a7138ac);

var $eJOHy = parcelRequire("eJOHy");

var $bwFO8 = parcelRequire("bwFO8");

var $d129d = parcelRequire("d129d");

var $kGj4V = parcelRequire("kGj4V");
var $ftN6c = parcelRequire("ftN6c");

var $2wyE1 = parcelRequire("2wyE1");

var $gy2Qg = parcelRequire("gy2Qg");

var $6FAEa = parcelRequire("6FAEa");

var $dMpy6 = parcelRequire("dMpy6");

var $6T4ti = parcelRequire("6T4ti");

var $7cSYk = parcelRequire("7cSYk");

var $8XHsn = parcelRequire("8XHsn");

var $jopyG = parcelRequire("jopyG");

var $cZTMg = parcelRequire("cZTMg");

var $koAZ4 = parcelRequire("koAZ4");

var $2mHfh = parcelRequire("2mHfh");

var $gfvms = parcelRequire("gfvms");

var $g9Vr6 = parcelRequire("g9Vr6");

var $e6YEs = parcelRequire("e6YEs");

var $gdBQP = parcelRequire("gdBQP");

var $4cTDP = parcelRequire("4cTDP");

var $eZPRH = parcelRequire("eZPRH");

var $99r1L = parcelRequire("99r1L");
const $62373716cdde4802$export$603e3eacf9be07ce = ({ appName: appName, children: children, pageStyle: pageStyle = (0, $d129d.default), onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: (0, $gy2Qg.toPackageName)(appName),
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62373716cdde4802$export$9bb1b82b8c44ae62, {
        pageStyle: pageStyle,
        onExperienceFailure: onExperienceFailure,
        onExperienceAbort: onExperienceAbort
    }, children))));
const $62373716cdde4802$export$9bb1b82b8c44ae62 = ({ children: children, pageStyle: PageWrapper, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $8XHsn.useWorkspaceContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const licenceState = (0, $jopyG.getUserJsmLicenceState)(tenantContext);
    const hasInsightPermission = (0, $8XHsn.useInsightVisibility)();
    const userId = (0, $e6YEs.useAccountId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { isAssetsDataManagerUnauthorizedUser: isAssetsDataManagerUnauthorizedUser } = (0, $gdBQP.useAssetsDataManagerUserAuth)();
    const shouldHideAssetsReports = (0, $99r1L.useHideAssetsReportsInIsolatedCloud)();
    (0, $eJOHy.useEffect)(()=>{
        if (onExperienceFailure && onExperienceAbort && (0, $4cTDP.fg)('assets_sla_for_view_page_experiences')) {
            if (workspaceId === null && !loading && !error) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onExperienceFailure('assets-app-base', (0, $bwFO8.getErrorAttributes)(new Error('Workspace ID is not set')));
            else if (error && !(0, $bwFO8.isClientNetworkError)(error)) {
                const trackerFunction = (0, $bwFO8.isHttpClientErrorResponse)(error) ? onExperienceAbort : onExperienceFailure;
                trackerFunction?.('assets-app-base', (0, $bwFO8.getErrorAttributes)(error));
            }
        }
    }, [
        onExperienceFailure,
        onExperienceAbort,
        workspaceId,
        loading,
        error
    ]);
    if (!(0, $7cSYk.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null);
    if (!licenceState.siteHasJsmInstalled || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/"
    });
    if (!licenceState.siteIsPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FAEa.AsyncCmdbUpsellPage), null);
    if (!licenceState.userLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZPRH.NoAccessErrorPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null) : null;
    if (!hasInsightPermission || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.GenericPermissionErrorPageAsync), null);
    if (isAssetsDataManagerUnauthorizedUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZPRH.NoAccessErrorPage), null);
    if (shouldHideAssetsReports) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfvms.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        userId: userId,
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T4ti.CmdbArchitectureContainer), {
        workspaceId: workspaceId
    }, children({
        workspaceId: workspaceId
    }))));
};
const $62373716cdde4802$export$c9b1085d6a7138ac = ({ children: children })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $8XHsn.useWorkspaceContext)();
    const hasInsightPermission = (0, $8XHsn.useInsightVisibility)();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    if (!(0, $7cSYk.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null);
    if (!(0, $jopyG.isLicensedPremiumUser)(tenantContext)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FAEa.AsyncCmdbUpsellPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null) : null;
    if (hasInsightPermission === false || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.GenericPermissionErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d129d.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T4ti.CmdbArchitectureContainer), {
        workspaceId: workspaceId
    }, children({
        workspaceId: workspaceId
    })));
};

});
parcelRegister("bwFO8", function(module, exports) {
$parcel$export(module.exports, "getErrorAttributes", () => $f4bba13dabf66838$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $f4bba13dabf66838$export$2b62e563f0fadcee);
$parcel$export(module.exports, "isClientNetworkError", () => $f4bba13dabf66838$export$dc0d2c5fff67f524);

var $9Dhvc = parcelRequire("9Dhvc");

var $dMM78 = parcelRequire("dMM78");

var $8s9Wj = parcelRequire("8s9Wj");

const $f4bba13dabf66838$var$extractGraphQLExtensionErrorName = (error)=>{
    const graphqlErrorExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions'
    ], null);
    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(graphqlErrorExtensions, [
        'errorType'
    ]);
    if (errorType) return errorType;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(graphqlErrorExtensions, [
        'operationName'
    ]);
};
const $f4bba13dabf66838$var$extractErrorName = (error)=>{
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError'
    ]);
    if (networkError) return (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(networkError, [
        'name'
    ], (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'name'
    ], (0, $dc94124f16777481$export$ba068cc3610b559d)));
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'graphQLErrors'
    ], []);
    if (graphQLErrors && graphQLErrors.length > 0) {
        const graphqlErrorExtensionsName = $f4bba13dabf66838$var$extractGraphQLExtensionErrorName((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(graphQLErrors, [
            0
        ]));
        if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    }
    const graphqlErrorExtensionsName = $f4bba13dabf66838$var$extractGraphQLExtensionErrorName(error);
    if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'name'
    ], (0, $dc94124f16777481$export$ba068cc3610b559d));
};
const $f4bba13dabf66838$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'graphQLErrors',
        0,
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions',
        'status'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'status'
    ]) || (0, $dc94124f16777481$export$ba068cc3610b559d);
const $f4bba13dabf66838$export$f3626cbbcad37421 = (error)=>{
    const statusCode = Number($f4bba13dabf66838$export$1fdf7c1c0741a7e7(error));
    if (!statusCode) return 0, $dc94124f16777481$export$ba068cc3610b559d;
    if (statusCode >= 100 && statusCode < 200) return 0, $dc94124f16777481$export$d441f436c87942f5;
    if (statusCode >= 300 && statusCode < 400) return 0, $dc94124f16777481$export$b29a3bb66f63d888;
    if (statusCode >= 400 && statusCode < 500) return 0, $dc94124f16777481$export$16e7f409a0d3529f;
    if (statusCode >= 500 && statusCode < 600) return 0, $dc94124f16777481$export$549a32621a554e7c;
    return 0, $dc94124f16777481$export$78244dbb77cfa6b6;
};
const $f4bba13dabf66838$var$extractTraceId = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions',
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions',
        'request_id'
    ], (0, $dc94124f16777481$export$ba068cc3610b559d)) || (0, $dc94124f16777481$export$ba068cc3610b559d);
const $f4bba13dabf66838$var$extractErrorMessage = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions',
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'extensions',
        'userMessage'
    ], (0, $dc94124f16777481$export$ba068cc3610b559d));
const $f4bba13dabf66838$var$extractErrorStack = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'stack'
    ], (0, $dc94124f16777481$export$ba068cc3610b559d));
const $f4bba13dabf66838$export$6ad9e7706a4ee0f8 = (error)=>({
        errorName: $f4bba13dabf66838$var$extractErrorName(error),
        errorMessage: $f4bba13dabf66838$var$extractErrorMessage(error),
        errorStack: $f4bba13dabf66838$var$extractErrorStack(error),
        statusCode: $f4bba13dabf66838$export$1fdf7c1c0741a7e7(error),
        statusCodeGroup: $f4bba13dabf66838$export$f3626cbbcad37421(error),
        traceId: $f4bba13dabf66838$var$extractTraceId(error)
    });
const $f4bba13dabf66838$export$2b62e563f0fadcee = (error)=>{
    const statusCode = Number($f4bba13dabf66838$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode >= 400 && statusCode < 500;
};
const $f4bba13dabf66838$export$dc0d2c5fff67f524 = (error)=>(0, $dMM78.isClientFetchError)(error);
const $f4bba13dabf66838$export$2ab75c18c9535885 = (error)=>!$f4bba13dabf66838$export$dc0d2c5fff67f524(error) && !$f4bba13dabf66838$export$2b62e563f0fadcee(error);
const $f4bba13dabf66838$export$9d73d6caff63cf52 = (error)=>{
    const statusCode = Number($f4bba13dabf66838$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode === 429;
};
const $f4bba13dabf66838$export$35ef4ce2961027c7 = (error)=>{
    const statusCode = Number($f4bba13dabf66838$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode === 409;
};
const $f4bba13dabf66838$export$7916ec13418094a3 = (attributes = {})=>({
        synthetic: (0, $8s9Wj.isSynthetic)(),
        isUIF: true,
        isClassic: false,
        ...attributes
    });

});
const $dc94124f16777481$export$ba068cc3610b559d = 'NOT_PRESENT';
const $dc94124f16777481$export$78244dbb77cfa6b6 = 'unknown';
const $dc94124f16777481$export$d441f436c87942f5 = '1xx';
const $dc94124f16777481$export$b29a3bb66f63d888 = '3xx';
const $dc94124f16777481$export$16e7f409a0d3529f = '4xx';
const $dc94124f16777481$export$549a32621a554e7c = '5xx';


parcelRegister("d129d", function(module, exports) {
$parcel$export(module.exports, "default", () => $c38f7cfd5c482255$export$2e2bcd8739ae039);

var $48Odo = parcelRequire("48Odo");

var $8yEMd = parcelRequire("8yEMd");

var $IhqEd = parcelRequire("IhqEd");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$c38f7cfd5c482255$export$2e2bcd8739ae039 = (0, $48Odo.default);

});
parcelRegister("48Odo", function(module, exports) {
$parcel$export(module.exports, "default", () => $19c04a0f0cb92a46$export$2e2bcd8739ae039);
/* page.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h4HIG = parcelRequire("h4HIG");
const $19c04a0f0cb92a46$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $19c04a0f0cb92a46$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $h4HIG.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $19c04a0f0cb92a46$var$styles.wrapper
        ]),
        children: [
            banner ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: {
                    height: isBannerOpen ? `${bannerHeight}px` : '0'
                },
                "aria-hidden": !isBannerOpen,
                "data-testid": testId ? `${testId}--banner-container` : undefined,
                className: (0, $hcewu.default)([
                    $19c04a0f0cb92a46$var$styles.bannerContainer
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $19c04a0f0cb92a46$var$styles.banner
                    ]),
                    children: banner
                })
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    $19c04a0f0cb92a46$var$styles.mainContainer
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $19c04a0f0cb92a46$var$styles.navigation
                        ]),
                        children: navigation
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $19c04a0f0cb92a46$var$styles.pageContent
                        ]),
                        children: children
                    })
                ]
            })
        ]
    });
};
var $19c04a0f0cb92a46$export$2e2bcd8739ae039 = $19c04a0f0cb92a46$var$Page;

});
parcelRegister("h4HIG", function(module, exports) {
$parcel$export(module.exports, "defaultGridColumns", () => $0bf3286651dcbf00$export$74797698e12f8baa);
$parcel$export(module.exports, "spacingMapping", () => $0bf3286651dcbf00$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $0bf3286651dcbf00$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $0bf3286651dcbf00$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $0bf3286651dcbf00$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $0bf3286651dcbf00$export$2303d2bd9eeff99a);
const $0bf3286651dcbf00$var$defaultGridSize = 8;
const $0bf3286651dcbf00$export$74797698e12f8baa = 12;
const $0bf3286651dcbf00$export$b8241a1616ab1b96 = $0bf3286651dcbf00$var$defaultGridSize * 10;
const $0bf3286651dcbf00$export$2a89a65a43bab52d = {
    comfortable: $0bf3286651dcbf00$var$defaultGridSize * 5,
    cosy: $0bf3286651dcbf00$var$defaultGridSize * 2,
    compact: $0bf3286651dcbf00$var$defaultGridSize * 0.5
};
const $0bf3286651dcbf00$export$8ec7372efd74b753 = 'cosy';
const $0bf3286651dcbf00$export$d77f83c3d17a7b8a = 52;
const $0bf3286651dcbf00$export$f8725d21f81f3e01 = 0;
const $0bf3286651dcbf00$export$2303d2bd9eeff99a = 'fixed';
const $0bf3286651dcbf00$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $0bf3286651dcbf00$export$8b7e31f391e6e681 = '--ds-column-span';
const $0bf3286651dcbf00$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("8yEMd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7ae0f3f994e81d7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $h4HIG = parcelRequire("h4HIG");

var $jh5Nk = parcelRequire("jh5Nk");

var $IhqEd = parcelRequire("IhqEd");

var $4cctD = parcelRequire("4cctD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $b7ae0f3f994e81d7$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eJOHy.useContext)((0, $4cctD.GridContext));
    const { medium: medium } = (0, $eJOHy.useContext)((0, $IhqEd.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $h4HIG.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $h4HIG.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cctD.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jh5Nk.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $b7ae0f3f994e81d7$export$2e2bcd8739ae039 = $b7ae0f3f994e81d7$var$GridWrapper;

});
parcelRegister("jh5Nk", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $a6ea171a1de7fa22$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h4HIG = parcelRequire("h4HIG");

var $4cctD = parcelRequire("4cctD");
const $a6ea171a1de7fa22$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ const $a6ea171a1de7fa22$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ const $a6ea171a1de7fa22$var$varGridSpacing = '--ds-grid-spacing';
const $a6ea171a1de7fa22$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
const $a6ea171a1de7fa22$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
const $a6ea171a1de7fa22$export$ef2184bd89960b14 = ({ layout: layout = (0, $h4HIG.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eJOHy.useContext)((0, $4cctD.GridContext));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$a6ea171a1de7fa22$var$varColumnsNum]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$a6ea171a1de7fa22$var$varGridSpacing]: `${(0, $h4HIG.spacingMapping)[spacing]}px`
        },
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $a6ea171a1de7fa22$var$styles.grid,
            $a6ea171a1de7fa22$var$gridLayoutMapStyles[layout],
            isNested && $a6ea171a1de7fa22$var$styles.nestedGrid
        ]),
        children: children
    });
};

});
parcelRegister("4cctD", function(module, exports) {
$parcel$export(module.exports, "GridContext", () => $9c511fcea308e0a6$export$11cae3e04ab99fae);

var $eJOHy = parcelRequire("eJOHy");

var $h4HIG = parcelRequire("h4HIG");
const $9c511fcea308e0a6$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $h4HIG.defaultSpacing),
    columns: (0, $h4HIG.defaultGridColumns)
});

});


parcelRegister("IhqEd", function(module, exports) {
$parcel$export(module.exports, "GridColumnContext", () => $9eb926f4db2de6e4$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $9eb926f4db2de6e4$export$2e2bcd8739ae039);
/* grid-column.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h4HIG = parcelRequire("h4HIG");

var $4cctD = parcelRequire("4cctD");
/**
 * Determines the method by which column width is calculated.
 */ var $9eb926f4db2de6e4$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($9eb926f4db2de6e4$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ const $9eb926f4db2de6e4$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ const $9eb926f4db2de6e4$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $9eb926f4db2de6e4$var$singleColumnWidth = `(99.9999% / var(--ds-columns-num))`;
const $9eb926f4db2de6e4$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
const $9eb926f4db2de6e4$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
const $9eb926f4db2de6e4$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $h4HIG.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
const $9eb926f4db2de6e4$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    medium: (0, $h4HIG.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $9eb926f4db2de6e4$var$GridColumn = ({ medium: medium = (0, $h4HIG.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eJOHy.useContext)((0, $4cctD.GridContext));
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $9eb926f4db2de6e4$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9eb926f4db2de6e4$export$1229ad7112b989f5.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            style: {
                /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ [$9eb926f4db2de6e4$var$varColumnSpan]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId,
            className: (0, $hcewu.default)([
                $9eb926f4db2de6e4$var$styles.gridColumn,
                $9eb926f4db2de6e4$var$gridColumnWidthMapStyles[variant]
            ]),
            children: children
        })
    });
};
var $9eb926f4db2de6e4$export$2e2bcd8739ae039 = $9eb926f4db2de6e4$var$GridColumn;

});



parcelRegister("6T4ti", function(module, exports) {
$parcel$export(module.exports, "CmdbArchitectureContainer", () => $278900f3b89d4452$export$9f2b76d50d1e5752);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $dLR8J = parcelRequire("dLR8J");

var $dMpy6 = parcelRequire("dMpy6");

var $4cTDP = parcelRequire("4cTDP");

var $qs50V = parcelRequire("qs50V");

var $cnSR0 = parcelRequire("cnSR0");
const $278900f3b89d4452$export$9f2b76d50d1e5752 = ({ workspaceId: workspaceId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $4cTDP.fg)('assets_rearch_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cnSR0.CmdbArchitectureStoreContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($278900f3b89d4452$export$a94168bcf4c80e75, null, children)) : children;
};
const $278900f3b89d4452$export$a94168bcf4c80e75 = ({ children: children })=>{
    const { loading: loading, error: error, migrationStatus: migrationStatus } = (0, $cnSR0.useCmdbArchitectureStore)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.JSErrorPageAsync), null);
    if (loading || !migrationStatus) return (0, $4cTDP.fg)('add_ufo_hold_to_assets_schema_page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "migration-status"
    }) : null;
    if (migrationStatus.blockWriteTraffic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $qs50V.MaintenanceModePage), null);
    return children;
};

});
parcelRegister("qs50V", function(module, exports) {
$parcel$export(module.exports, "MaintenanceModePage", () => $6ed35b7233747c8a$export$407ffafe578d3c20);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $6MnLl = parcelRequire("6MnLl");

var $8M5QU = parcelRequire("8M5QU");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $9SilS = parcelRequire("9SilS");
const $6ed35b7233747c8a$var$contactSupportLink = 'https://support.atlassian.com/contact/#/';
const $6ed35b7233747c8a$export$407ffafe578d3c20 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $8M5QU.default))({
            imageWidth: 275,
            maxImageWidth: 275,
            maxImageHeight: 275
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        width: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $9SilS.messages).errorTitle),
        description: formatMessage((0, $9SilS.messages).errorDescription, {
            break: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null)
        }),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: $6ed35b7233747c8a$var$contactSupportLink,
            target: "_blank"
        }, formatMessage((0, $9SilS.messages).contactMessage)),
        testId: "cmdb-maintenance-page.ui.cmdb-maintenance-page"
    });
};

});
parcelRegister("8M5QU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7d2674278b9f684$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $QyCdY = parcelRequire("QyCdY");
const $a7d2674278b9f684$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($QyCdY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($QyCdY))
});
var $a7d2674278b9f684$export$2e2bcd8739ae039 = $a7d2674278b9f684$var$Illustration;
const $a7d2674278b9f684$export$a179c88182cb9d56 = [
    0,
    0,
    276,
    276
];

});
parcelRegister("QyCdY", function(module, exports) {
module.exports = new URL("infrastructure-crane.3c8e069d.svg", import.meta.url).toString();

});


parcelRegister("9SilS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $48a12e7e1f7c86dc$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $48a12e7e1f7c86dc$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-title",
        "defaultMessage": "Be right back"
    },
    errorDescription: {
        "id": "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-description",
        "defaultMessage": "Assets is currently under maintenance and will return shortly. <break></break> Please try again later."
    },
    contactMessage: {
        "id": "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.contact-message",
        "defaultMessage": "Contact support"
    }
});

});


parcelRegister("cnSR0", function(module, exports) {
$parcel$export(module.exports, "CmdbArchitectureStoreContainer", () => $b18ace1fd4b48bad$export$3e99e0b586e9bd20);
$parcel$export(module.exports, "useCmdbArchitectureStore", () => $b18ace1fd4b48bad$export$cb0396e44d69a170);
$parcel$export(module.exports, "useIsNewCmdbArchitecture", () => $b18ace1fd4b48bad$export$cb6873bd1bfb6e11);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $d9kQh = parcelRequire("d9kQh");
const $b18ace1fd4b48bad$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    migrationStatus: undefined
};
const $b18ace1fd4b48bad$var$store = (0, $GtRbT.createStore)({
    initialState: $b18ace1fd4b48bad$export$d4c72bab9d6cc13a,
    actions: {}
});
const $b18ace1fd4b48bad$export$3e99e0b586e9bd20 = (0, $6E16M.createContainer)($b18ace1fd4b48bad$var$store, {
    onInit: (0, $d9kQh.fetchInitialStatus)
});
const $b18ace1fd4b48bad$export$cb0396e44d69a170 = (0, $iJq0l.createStateHook)($b18ace1fd4b48bad$var$store);
const $b18ace1fd4b48bad$export$cb6873bd1bfb6e11 = (0, $iJq0l.createStateHook)($b18ace1fd4b48bad$var$store, {
    selector: ({ migrationStatus: migrationStatus })=>migrationStatus?.routeToTempeh ?? false
});

});
parcelRegister("d9kQh", function(module, exports) {
$parcel$export(module.exports, "fetchInitialStatus", () => $40ea40856970fad3$export$888156f6db906499);

var $0ceUS = parcelRequire("0ceUS");
const $40ea40856970fad3$export$888156f6db906499 = ()=>({ getState: getState, dispatch: dispatch })=>{
        if (!getState().loading && !getState().migrationStatus) dispatch((0, $0ceUS.fetchMigrationStatus)());
    };

});
parcelRegister("0ceUS", function(module, exports) {
$parcel$export(module.exports, "fetchMigrationStatus", () => $4abe552fc6d72ec6$export$7edd275ea1b9d090);

var $u4YbY = parcelRequire("u4YbY");

var $fcqPZ = parcelRequire("fcqPZ");

var $kRgKj = parcelRequire("kRgKj");

var $9pTd3 = parcelRequire("9pTd3");
const $4abe552fc6d72ec6$export$f955a5fc47a6bbba = async (workspaceId)=>(0, $u4YbY.performCmdbGetRequest)((0, $fcqPZ.getCmdbTempehMigrationUrl)(workspaceId));
const $4abe552fc6d72ec6$export$7edd275ea1b9d090 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading) return;
        setState({
            loading: true
        });
        try {
            const { blockWriteTraffic: blockWriteTraffic, routeToTempeh: routeToTempeh } = await $4abe552fc6d72ec6$export$f955a5fc47a6bbba(workspaceId);
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMigrationStatus succeeded');
            setState({
                loading: false,
                migrationStatus: {
                    blockWriteTraffic: blockWriteTraffic,
                    routeToTempeh: routeToTempeh
                }
            });
        } catch (error) {
            const typedError = error instanceof Error ? error : undefined;
            // We intentionally don't use fireCmdbErrorAnalytics because it's dependent on this store
            (0, $9pTd3.fireErrorAnalytics)({
                error: typedError,
                meta: {
                    id: 'fetchMigrationStatus',
                    packageName: 'jiraServicedeskCmdbArchitecture',
                    teamName: 'aurum'
                }
            });
            setState({
                loading: false,
                error: typedError
            });
        }
    };

});
parcelRegister("fcqPZ", function(module, exports) {
$parcel$export(module.exports, "getCmdbTempehMigrationUrl", () => $0ad0e90dc80761b0$export$4699309ef0b4ff76);

var $1qZG3 = parcelRequire("1qZG3");
const $0ad0e90dc80761b0$export$af33bbc68a181bd6 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/tempeh`;
const $0ad0e90dc80761b0$export$4699309ef0b4ff76 = (workspaceId)=>`${$0ad0e90dc80761b0$export$af33bbc68a181bd6(workspaceId)}/migration`;

});





parcelRegister("cZTMg", function(module, exports) {
$parcel$export(module.exports, "SubProductUpdater", () => $e3e218a75c21102a$export$eb40d3df56aa5c53);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $figsJ = parcelRequire("figsJ");

var $5nYJB = parcelRequire("5nYJB");

var $aO6tw = parcelRequire("aO6tw");

var $adiVF = parcelRequire("adiVF");
const $e3e218a75c21102a$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $adiVF.isSubProductProps)(props) ? props.subProduct : (0, $figsJ.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
        op: (0, $aO6tw.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5nYJB.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("5nYJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $82e051cbb2adac57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3aa9n = parcelRequire("3aa9n");

var $8VfmF = parcelRequire("8VfmF");
const $82e051cbb2adac57$var$TagMauEvent = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: (0, $8VfmF.default),
        args: [
            subProduct
        ]
    });
var $82e051cbb2adac57$export$2e2bcd8739ae039 = $82e051cbb2adac57$var$TagMauEvent;

});
parcelRegister("8VfmF", function(module, exports) {
$parcel$export(module.exports, "default", () => $811461c69dc55236$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $3ugTQ = parcelRequire("3ugTQ");
const $811461c69dc55236$var$tagMauEvent = (subProduct)=>{
    (0, $3ugTQ.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};
var $811461c69dc55236$export$2e2bcd8739ae039 = $811461c69dc55236$var$tagMauEvent;

});


parcelRegister("aO6tw", function(module, exports) {
$parcel$export(module.exports, "default", () => $53a2c520c0b2b632$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");


var $eSnSE = parcelRequire("eSnSE");

var $2Mqjh = parcelRequire("2Mqjh");
const $53a2c520c0b2b632$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
const $53a2c520c0b2b632$var$setCurrentSubProduct = async (subProduct, allowMonolithDeferral)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $c2258fadc4095860$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $53a2c520c0b2b632$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4T9yL.waitForHeritage)() : null, ()=>(0, $97BGz.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ],
            // jira/analytics/sub-product-resolver is not using any heritage code
            isolatedFromHeritage: true
        }), ()=>(0, $iyT45.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };
var $53a2c520c0b2b632$export$2e2bcd8739ae039 = $53a2c520c0b2b632$var$setCurrentSubProduct;

});
const $c2258fadc4095860$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("adiVF", function(module, exports) {
$parcel$export(module.exports, "isSubProductProps", () => $b41c599c0dbb9c69$export$c3063d6d7a8c075f);
const $b41c599c0dbb9c69$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("gdBQP", function(module, exports) {
$parcel$export(module.exports, "useAssetsDataManagerUserAuth", () => $a7c47fda845932e6$export$7b8e9d8ead51323e);

var $8rGQ0 = parcelRequire("8rGQ0");

var $gfvms = parcelRequire("gfvms");

var $4cTDP = parcelRequire("4cTDP");

var $kfvK2 = parcelRequire("kfvK2");

var $jDA8U = parcelRequire("jDA8U");
const $a7c47fda845932e6$export$305222dff575c4e3 = (0, $kfvK2.createRouterSelector)(({ match: match })=>match.url);
const $a7c47fda845932e6$export$7b8e9d8ead51323e = ()=>{
    const url = $a7c47fda845932e6$export$305222dff575c4e3();
    const isSiteAdmin = (0, $8rGQ0.useIsSiteAdmin)();
    const [{ dataManager: dataManager, loading: isInsightGlobalConfigLoading }] = (0, $gfvms.useInsightGlobalConfig)();
    const { isProvisioned: isDataManagerProvisioned, provisioningLoading: provisioningLoading, myRoles: myRoles, myRolesLoading: myRolesLoading } = dataManager ?? {};
    const isLoading = isInsightGlobalConfigLoading || myRolesLoading || provisioningLoading;
    if (!url.startsWith('/jira/assets/data-manager') || isLoading || !(0, $4cTDP.fg)('assets_data_manager_jira_spa')) return {
        isAssetsDataManagerUnauthorizedUser: false
    };
    let allowedRoles = [];
    let isAuthorized = false;
    if (url.startsWith('/jira/assets/data-manager/getting-started')) {
        allowedRoles = (0, $jDA8U.ASSETS_DATA_MANAGER_ROLES_BY_PAGE).GettingStartedPage;
        isAuthorized = myRoles?.some((role)=>allowedRoles.includes(role)) || isSiteAdmin;
    }
    if (url.startsWith('/jira/assets/data-manager/object-classes/view')) {
        allowedRoles = (0, $jDA8U.ASSETS_DATA_MANAGER_ROLES_BY_PAGE).ObjectClassView;
        isAuthorized = myRoles?.some((role)=>allowedRoles.includes(role)) || isSiteAdmin;
    }
    if (url.startsWith('/jira/assets/data-manager/object-classes')) {
        allowedRoles = (0, $jDA8U.ASSETS_DATA_MANAGER_ROLES_BY_PAGE).DataSource;
        isAuthorized = myRoles?.some((role)=>allowedRoles.includes(role)) || isSiteAdmin;
    }
    return {
        isAssetsDataManagerUnauthorizedUser: !isAuthorized || !isDataManagerProvisioned
    };
};

});
parcelRegister("jDA8U", function(module, exports) {
$parcel$export(module.exports, "ASSETS_DATA_MANAGER_ROLES_BY_PAGE", () => $0ab8c7ae0d2a0ecd$export$a9203dbe33e7e1a3);
$parcel$export(module.exports, "OBJECT_LIST_VIEW_LIST", () => $0ab8c7ae0d2a0ecd$export$3256612e142ece97);
$parcel$export(module.exports, "OBJECT_LIST_VIEW_DATA_SOURCE_BY_DATA_SOURCE", () => $0ab8c7ae0d2a0ecd$export$56830e9e6d5ce766);
$parcel$export(module.exports, "OBJECT_LIST_VIEW_ATTRIBUTE_BY_DATA_SOURCE", () => $0ab8c7ae0d2a0ecd$export$c43608d00395aa57);

var $17vsL = parcelRequire("17vsL");
const $0ab8c7ae0d2a0ecd$var$GettingStartedRoles = [
    (0, $17vsL.DATA_MANAGER_ADMIN),
    (0, $17vsL.DATA_MANAGER_ADAPTERS_ADMIN)
];
const $0ab8c7ae0d2a0ecd$var$DataSourceRoles = [
    (0, $17vsL.DATA_MANAGER_ADMIN),
    (0, $17vsL.DATA_MANAGER_ADAPTERS_ADMIN)
];
const $0ab8c7ae0d2a0ecd$var$ObjectClassViewRoles = [
    (0, $17vsL.DATA_MANAGER_ADMIN),
    (0, $17vsL.DATA_MANAGER_ADAPTERS_ADMIN)
];
const $0ab8c7ae0d2a0ecd$export$a9203dbe33e7e1a3 = {
    GettingStartedPage: $0ab8c7ae0d2a0ecd$var$GettingStartedRoles,
    DataSource: $0ab8c7ae0d2a0ecd$var$DataSourceRoles,
    ObjectClassView: $0ab8c7ae0d2a0ecd$var$ObjectClassViewRoles
};
const $0ab8c7ae0d2a0ecd$export$3256612e142ece97 = 'list';
const $0ab8c7ae0d2a0ecd$export$56830e9e6d5ce766 = 'data-source-by-data-source';
const $0ab8c7ae0d2a0ecd$export$c43608d00395aa57 = 'attribute-by-data-source';

});


parcelRegister("eZPRH", function(module, exports) {
$parcel$export(module.exports, "NoAccessErrorPage", () => $a245e5d4cf773085$export$8126b1d7463b1f82);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lRq8t = parcelRequire("lRq8t");

var $3T0Af = parcelRequire("3T0Af");

var $dHXcz = parcelRequire("dHXcz");
const $a245e5d4cf773085$export$8126b1d7463b1f82 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a245e5d4cf773085$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3T0Af))),
        header: formatMessage((0, $dHXcz.messages).errorTitle),
        description: formatMessage((0, $dHXcz.messages).errorDescription),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: "https://home.atlassian.com"
        }, formatMessage((0, $dHXcz.messages).goToHomeLinkLabel))
    }));
};
const $a245e5d4cf773085$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '100%',
    placeItems: 'center'
});

});
parcelRegister("3T0Af", function(module, exports) {
module.exports = new URL("lock.bb0ac3af.svg", import.meta.url).toString();

});

parcelRegister("dHXcz", function(module, exports) {
$parcel$export(module.exports, "messages", () => $af06801633a8c5b5$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $af06801633a8c5b5$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "spa-assets-app-base.no-access-error-page.error-title",
        "defaultMessage": "You need permission to access this page"
    },
    errorDescription: {
        "id": "spa-assets-app-base.no-access-error-page.error-description",
        "defaultMessage": "If you think you should have access, contact your admin."
    },
    goToHomeLinkLabel: {
        "id": "spa-assets-app-base.no-access-error-page.go-to-home-link-label",
        "defaultMessage": "Go to Atlassian Home"
    }
});

});


parcelRegister("99r1L", function(module, exports) {
$parcel$export(module.exports, "useHideAssetsReportsInIsolatedCloud", () => $cec17ccdd9f02132$export$8156ab4e157cd35f);

var $4cTDP = parcelRequire("4cTDP");

var $kfvK2 = parcelRequire("kfvK2");

var $7pw1V = parcelRequire("7pw1V");
const $cec17ccdd9f02132$export$305222dff575c4e3 = (0, $kfvK2.createRouterSelector)(({ match: match })=>match.url);
const $cec17ccdd9f02132$export$8156ab4e157cd35f = ()=>{
    const url = $cec17ccdd9f02132$export$305222dff575c4e3();
    const isIsolatedCloudEnv = (0, $7pw1V.isIsolatedCloud)();
    const isReportsUrl = url.startsWith('/jira/assets/reports');
    if (isReportsUrl && isIsolatedCloudEnv && (0, $4cTDP.fg)('hide-reports-ic-env')) return true;
    return false;
};

});



parcelRegister("cBUST", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsRouteEntry", () => $6fa1fcf5989d0ed5$export$d897a26c40956416);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $71FT1 = parcelRequire("71FT1");

var $ePaI2 = parcelRequire("ePaI2");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $2mHfh = parcelRequire("2mHfh");

var $iPsB5 = parcelRequire("iPsB5");

var $hQ0T3 = parcelRequire("hQ0T3");

var $dF368 = parcelRequire("dF368");

var $gy2Qg = parcelRequire("gy2Qg");

var $c1dkq = parcelRequire("c1dkq");
const $6fa1fcf5989d0ed5$var$DashboardsListPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dF368.AssetsAppBase), {
        appName: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS
    }, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hQ0T3.DashboardList), {
            workspaceId: workspaceId
        }));
const $6fa1fcf5989d0ed5$export$d897a26c40956416 = (0, $6xToB.createEntry)((0, $71FT1.servicedeskCmdbAssetsDashboardsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $iPsB5.isNewReportsNavExperienceEnabled)() ? (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $6fa1fcf5989d0ed5$var$DashboardsListPage, (0, $c1dkq.AssetsReportsNav4HomePage)) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                to: "/jira/servicedesk/assets/reports"
            }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsDashboardsRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsDashboardsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("71FT1", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsDashboardsRoute", () => $4141b8796d53a79a$export$95b52976fd861816);
const $4141b8796d53a79a$export$95b52976fd861816 = {
    name: 'servicedesk-cmdb-assets-dashboards',
    path: '/jira/servicedesk/assets/dashboards',
    exact: true
};

});

parcelRegister("hQ0T3", function(module, exports) {
$parcel$export(module.exports, "DashboardList", () => $523bd52358ac6f07$export$e8c763ce66dab6c9);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $aESSb = parcelRequire("aESSb");

var $5Ouxk = parcelRequire("5Ouxk");

var $2b5QU = parcelRequire("2b5QU");

var $iPsB5 = parcelRequire("iPsB5");
const $523bd52358ac6f07$export$e8c763ce66dab6c9 = ({ workspaceId: workspaceId })=>{
    const apiPrefix = `/gateway/api/avp/embed/workspaceId/${workspaceId}`;
    const dashboardEditableBaseUrl = (0, $iPsB5.isNewReportsNavExperienceEnabled)() ? '/jira/assets/dashboards' : '/jira/assets/reports';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2b5QU.PreferenceBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aESSb.DashboardListLazy), {
        workspaceId: workspaceId,
        apiPrefix: apiPrefix,
        hostingProduct: (0, $5Ouxk.getHostingProduct)(),
        dashboardEditableBaseUrl: dashboardEditableBaseUrl,
        ...(0, $4cTDP.fg)('template_details_api_flow') && {
            templatePlaceholderReplacementsApiPath: `/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/template-details`
        }
    }));
};

});
parcelRegister("aESSb", function(module, exports) {
$parcel$export(module.exports, "DashboardListLazy", () => $c936692510fb245f$export$d4759ded8d5ec0e);
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");

const $c936692510fb245f$export$d4759ded8d5ec0e = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("3OKsR")).then(({ DashboardList: DashboardList })=>DashboardList), {
    ssr: false
});

});
parcelRegister("3OKsR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("3Flbb")),
    $ewTvA("fliVL"),
    $ewTvA("6Jr7s")
]).then(()=>parcelRequire('gmCLN'));

});




parcelRegister("bGvUH", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRouteEntry", () => $fbe506eaa77b0566$export$6755c90e62150ca0);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $c9q3g = parcelRequire("c9q3g");

var $gy2Qg = parcelRequire("gy2Qg");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9PWlz = parcelRequire("9PWlz");

var $c72E0 = parcelRequire("c72E0");
const $fbe506eaa77b0566$export$6755c90e62150ca0 = (0, $6xToB.createEntry)((0, $c9q3g.servicedeskCmdbAssetsGlobalConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9PWlz.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9PWlz.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsGlobalConfigurationRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsGlobalConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("c9q3g", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRoute", () => $5ac6a1d23dbbe619$export$b28679181cd68abd);
const $5ac6a1d23dbbe619$export$b28679181cd68abd = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/assets/configure/global'
};

});

parcelRegister("9PWlz", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", () => $26df75383e148d5d$export$b80bd807bad3fd0a);
$parcel$export(module.exports, "default", () => $26df75383e148d5d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $26df75383e148d5d$export$b80bd807bad3fd0a = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1jmZA")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $26df75383e148d5d$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $26df75383e148d5d$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $26df75383e148d5d$export$2e2bcd8739ae039 = $26df75383e148d5d$var$GlobalConfigure;

});


parcelRegister("aWhYZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRouteEntry", () => $6ad6dc5569918d4d$export$ed571153b6c25586);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $7PjwP = parcelRequire("7PjwP");

var $6AQho = parcelRequire("6AQho");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $615A2 = parcelRequire("615A2");

var $c72E0 = parcelRequire("c72E0");
const $6ad6dc5569918d4d$export$ed571153b6c25586 = (0, $6xToB.createEntry)((0, $6AQho.servicedeskCmdbAssetsObjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $615A2.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $f1zun.getCmdbResources)(),
            (0, $7PjwP.insightObjectResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $615A2.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsObjectRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsObjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6AQho", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRoute", () => $4a363485ef74a60c$export$bf02944216c526ff);
const $4a363485ef74a60c$export$bf02944216c526ff = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/assets/object/:objectId'
};

});

parcelRegister("615A2", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", () => $ac66cb2ec20f00a5$export$411c1981ced22249);
$parcel$export(module.exports, "InsightCmdbObjectViewV2", () => $ac66cb2ec20f00a5$export$3c208f927c6178ee);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ac66cb2ec20f00a5$export$411c1981ced22249 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1IkfC")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $ac66cb2ec20f00a5$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ac66cb2ec20f00a5$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $ac66cb2ec20f00a5$export$2e2bcd8739ae039 = $ac66cb2ec20f00a5$export$3c208f927c6178ee;

});


parcelRegister("6S0Dc", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry", () => $02ca52f465a03c42$export$ce7f2af5016c6aa9);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $gBOsl = parcelRequire("gBOsl");

var $fTaqz = parcelRequire("fTaqz");

var $gy2Qg = parcelRequire("gy2Qg");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $drF7O = parcelRequire("drF7O");

var $c72E0 = parcelRequire("c72E0");
const $02ca52f465a03c42$export$ce7f2af5016c6aa9 = (0, $6xToB.createEntry)((0, $fTaqz.servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $drF7O.default),
        resources: [
            ...(0, $f1zun.getCmdbResources)(),
            (0, $gBOsl.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $drF7O.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fTaqz", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", () => $328acf7f8457dbbe$export$b4a150d67181752);
const $328acf7f8457dbbe$export$b4a150d67181752 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("drF7O", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", () => $c29065276e0fd4ea$export$8305a1bc1c5bee45);
$parcel$export(module.exports, "default", () => $c29065276e0fd4ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c29065276e0fd4ea$export$8305a1bc1c5bee45 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iCpq7")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $c29065276e0fd4ea$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c29065276e0fd4ea$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $c29065276e0fd4ea$export$2e2bcd8739ae039 = $c29065276e0fd4ea$var$ObjectSchemaConfiguration;

});


parcelRegister("hGerI", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRouteEntry", () => $5a5c2569a2c40a1f$export$d9dc7083d0a34d11);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $f2URm = parcelRequire("f2URm");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ofVNb = parcelRequire("ofVNb");

var $c72E0 = parcelRequire("c72E0");
const $5a5c2569a2c40a1f$export$d9dc7083d0a34d11 = (0, $6xToB.createEntry)((0, $f2URm.servicedeskCmdbAssetsObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ofVNb.ObjectSchemaV2),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ofVNb.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsObjectSchemaRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsObjectSchemaRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("f2URm", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRoute", () => $55573dbd66668d92$export$6f86804eb594cd29);
const $55573dbd66668d92$export$6f86804eb594cd29 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};

});


parcelRegister("6mL7K", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry", () => $57ba5ce0bc54933f$export$d45b927987c92c0e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $knzIT = parcelRequire("knzIT");

var $gy2Qg = parcelRequire("gy2Qg");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9e1BD = parcelRequire("9e1BD");

var $c72E0 = parcelRequire("c72E0");
const $57ba5ce0bc54933f$export$d45b927987c92c0e = (0, $6xToB.createEntry)((0, $knzIT.servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9e1BD.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9e1BD.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("knzIT", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", () => $2d8fc2c68284b2fa$export$73b901e16d5e5a02);
const $2d8fc2c68284b2fa$export$73b901e16d5e5a02 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("9e1BD", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", () => $21c33c356c37a482$export$926956539e1f72ba);
$parcel$export(module.exports, "default", () => $21c33c356c37a482$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $21c33c356c37a482$export$926956539e1f72ba = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3Ng8O")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $21c33c356c37a482$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $21c33c356c37a482$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $21c33c356c37a482$export$2e2bcd8739ae039 = $21c33c356c37a482$var$InsightConfigureObjectType;

});


parcelRegister("5S3BI", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRouteEntry", () => $8feeee187aa08a00$export$2621677b40f03d6c);

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $6zXPf = parcelRequire("6zXPf");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $lnqtD = parcelRequire("lnqtD");

var $gy2Qg = parcelRequire("gy2Qg");

var $ePaI2 = parcelRequire("ePaI2");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $c1dkq = parcelRequire("c1dkq");

var $c72E0 = parcelRequire("c72E0");
const $8feeee187aa08a00$export$2621677b40f03d6c = (0, $6xToB.createEntry)((0, $lnqtD.servicedeskCmdbAssetsReportsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $c1dkq.AssetsReportsNav4HomePage), (0, $c1dkq.AssetsReportingDefaultRedirect)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1dkq.LazyServicedeskCmdbDefaultReportsRedirect),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReportsNav4HomePage)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsReportsRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsReportsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lnqtD", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", () => $f9fa15d83ba0dce8$export$a075d8b7c4c55c41);
const $f9fa15d83ba0dce8$export$a075d8b7c4c55c41 = {
    name: 'servicedesk-cmdb-assets-reports-default-redirect',
    path: '/jira/servicedesk/assets/reports',
    exact: true
};

});


parcelRegister("6gpWo", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRouteEntry", () => $65e2dc2fec3b80f9$export$51d27be4bd1db6ce);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $5gQb9 = parcelRequire("5gQb9");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $dqVqR = parcelRequire("dqVqR");

var $gy2Qg = parcelRequire("gy2Qg");

var $ePaI2 = parcelRequire("ePaI2");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $c1dkq = parcelRequire("c1dkq");

var $c72E0 = parcelRequire("c72E0");
const $65e2dc2fec3b80f9$export$51d27be4bd1db6ce = (0, $6xToB.createEntry)((0, $dqVqR.servicedeskCmdbAssetsReportsTemplateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $c1dkq.AssetsReports),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $5gQb9.default)
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsReportsTemplateRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsReportsTemplateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dqVqR", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRoute", () => $b2ca85993999d53a$export$9482cb7f11a7730);
const $b2ca85993999d53a$export$9482cb7f11a7730 = {
    name: 'servicedesk-cmdb-assets-reports',
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};

});


parcelRegister("iUcGR", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRouteEntry", () => $418b5ece5bfd6164$export$5842852f274cd739);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1PvPk = parcelRequire("1PvPk");

var $8PssM = parcelRequire("8PssM");

var $gy2Qg = parcelRequire("gy2Qg");

var $ePaI2 = parcelRequire("ePaI2");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $c1dkq = parcelRequire("c1dkq");

var $c72E0 = parcelRequire("c72E0");
const $418b5ece5bfd6164$export$5842852f274cd739 = (0, $6xToB.createEntry)((0, $8PssM.servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $c1dkq.AssetsReportsUnsubscribe),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c1dkq.LazyServicedeskCmdbAssetsReportsUnsubscribe)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsReportsUnsubscribeRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsReportsUnsubscribeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8PssM", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", () => $cc84e72415fde3d6$export$66ab60d374e8e458);
const $cc84e72415fde3d6$export$66ab60d374e8e458 = {
    name: 'servicedesk-cmdb-assets-reports-unsubscribe',
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("2n5BQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRouteEntry", () => $4682ddaa8d2f142d$export$70a75f8d403c935a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $eqqzA = parcelRequire("eqqzA");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ipGD4 = parcelRequire("ipGD4");

var $c72E0 = parcelRequire("c72E0");
const $4682ddaa8d2f142d$export$70a75f8d403c935a = (0, $6xToB.createEntry)((0, $eqqzA.servicedeskCmdbAssetsSchemasRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ipGD4.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ipGD4.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbAssetsSchemasRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbAssetsSchemasRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eqqzA", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRoute", () => $2d7056b98269bd98$export$118f7c2ddb756e80);
const $2d7056b98269bd98$export$118f7c2ddb756e80 = {
    name: 'servicedesk-cmdb-assets',
    path: '/jira/servicedesk/assets',
    exact: true
};

});

parcelRegister("ipGD4", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", () => $9991e7ecbfe44830$export$f6c79e6ff37913ee);
$parcel$export(module.exports, "default", () => $9991e7ecbfe44830$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9991e7ecbfe44830$export$f6c79e6ff37913ee = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("l14fz")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $9991e7ecbfe44830$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9991e7ecbfe44830$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $9991e7ecbfe44830$export$2e2bcd8739ae039 = $9991e7ecbfe44830$var$LandingPage;

});


parcelRegister("fToBW", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRouteEntry", () => $cb8e43e290123184$export$69b479583cd0d13f);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $aXZNL = parcelRequire("aXZNL");

var $gy2Qg = parcelRequire("gy2Qg");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9PWlz = parcelRequire("9PWlz");

var $c72E0 = parcelRequire("c72E0");
const $cb8e43e290123184$export$69b479583cd0d13f = (0, $6xToB.createEntry)((0, $aXZNL.servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9PWlz.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9PWlz.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightConfigureGlobalRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightConfigureGlobalRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aXZNL", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", () => $cf33a2baf362ebf9$export$96e5da52356f214c);
const $cf33a2baf362ebf9$export$96e5da52356f214c = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure/global'
};

});


parcelRegister("jcgn0", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRouteEntry", () => $2f48f6ced1838a60$export$277a55a31c82cf0e);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $bVcMD = parcelRequire("bVcMD");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $giUPy = parcelRequire("giUPy");

var $c72E0 = parcelRequire("c72E0");
const $2f48f6ced1838a60$export$277a55a31c82cf0e = (0, $6xToB.createEntry)((0, $bVcMD.servicedeskCmdbInsightConfigureRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $giUPy.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $giUPy.LazyServicedeskCmdbConfigure)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightConfigureRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightConfigureRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bVcMD", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", () => $b762b8e73d6734e0$export$e960ab4fcd3e80b6);
const $b762b8e73d6734e0$export$e960ab4fcd3e80b6 = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure'
};

});

parcelRegister("giUPy", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCmdbConfigure", () => $551d5d4ddc929d78$export$8075d4042713bf6d);
$parcel$export(module.exports, "default", () => $551d5d4ddc929d78$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $551d5d4ddc929d78$export$8075d4042713bf6d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jc2Ut")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $551d5d4ddc929d78$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $551d5d4ddc929d78$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $551d5d4ddc929d78$export$2e2bcd8739ae039 = $551d5d4ddc929d78$var$InsightConfigure;

});
parcelRegister("jc2Ut", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aHZse").then(()=>parcelRequire('ax5Nk'));

});



parcelRegister("apCqz", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObject4RouteEntry", () => $0e44f0616802f4ba$export$95574c3333e559d3);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $7PjwP = parcelRequire("7PjwP");

var $e9wXL = parcelRequire("e9wXL");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $615A2 = parcelRequire("615A2");

var $c72E0 = parcelRequire("c72E0");
const $0e44f0616802f4ba$export$95574c3333e559d3 = (0, $6xToB.createEntry)((0, $e9wXL.servicedeskCmdbInsightObject4Route), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $615A2.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $f1zun.getCmdbResources)(),
            (0, $7PjwP.insightObjectResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $615A2.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightObject4RouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightObject4RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("e9wXL", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", () => $a2c99b6006f7ed34$export$223f5bacfd3d39fd);
const $a2c99b6006f7ed34$export$223f5bacfd3d39fd = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/insight/assets/:objectId'
};

});


parcelRegister("lkzh1", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry", () => $93af2de688a1eeb7$export$261e9b5115dfbb0a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $hhBy7 = parcelRequire("hhBy7");

var $gy2Qg = parcelRequire("gy2Qg");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $drF7O = parcelRequire("drF7O");

var $c72E0 = parcelRequire("c72E0");
const $93af2de688a1eeb7$export$261e9b5115dfbb0a = (0, $6xToB.createEntry)((0, $hhBy7.servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $drF7O.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $drF7O.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hhBy7", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", () => $8833a27b3c426f28$export$f6b688a8729943b3);
const $8833a27b3c426f28$export$f6b688a8729943b3 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("1tJbT", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRouteEntry", () => $e6d6211e734953b5$export$192b200c13b0b76a);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $5VsX3 = parcelRequire("5VsX3");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ofVNb = parcelRequire("ofVNb");

var $c72E0 = parcelRequire("c72E0");
const $e6d6211e734953b5$export$192b200c13b0b76a = (0, $6xToB.createEntry)((0, $5VsX3.servicedeskCmdbInsightObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ofVNb.ObjectSchemaV2),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ofVNb.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightObjectSchemaRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightObjectSchemaRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5VsX3", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", () => $f6b100f9a383d9eb$export$fcde60ded71d4ae6);
const $f6b100f9a383d9eb$export$fcde60ded71d4ae6 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};

});


parcelRegister("1p45F", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRouteEntry", () => $ff2c06999c8b7fe6$export$de4ab140a5dbd984);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $iKdZi = parcelRequire("iKdZi");

var $gy2Qg = parcelRequire("gy2Qg");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $9e1BD = parcelRequire("9e1BD");

var $c72E0 = parcelRequire("c72E0");
const $ff2c06999c8b7fe6$export$de4ab140a5dbd984 = (0, $6xToB.createEntry)((0, $iKdZi.servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $9e1BD.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9e1BD.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightObjectTypeConfigurationRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightObjectTypeConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iKdZi", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", () => $06c8b24580c74bd8$export$12e89d5d79d59785);
const $06c8b24580c74bd8$export$12e89d5d79d59785 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};

});


parcelRegister("1IT3x", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightRouteEntry", () => $62b3791ddc46d810$export$3befca4eb012b818);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $5Oo9O = parcelRequire("5Oo9O");

var $4cTDP = parcelRequire("4cTDP");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $f1zun = parcelRequire("f1zun");

var $ipGD4 = parcelRequire("ipGD4");

var $c72E0 = parcelRequire("c72E0");
const $62b3791ddc46d810$export$3befca4eb012b818 = (0, $6xToB.createEntry)((0, $5Oo9O.servicedeskCmdbInsightRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).INSIGHT
        },
        component: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $c72E0.AssetsAppRedirect) : (0, $ipGD4.default),
        resources: (0, $f1zun.getCmdbResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ipGD4.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/servicedeskCmdbInsightRouteEntry.tsx',
                whichExportToUse: 'servicedeskCmdbInsightRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5Oo9O", function(module, exports) {
$parcel$export(module.exports, "servicedeskCmdbInsightRoute", () => $566f9346b91d2df6$export$1efada07b7203f2d);
const $566f9346b91d2df6$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: '/jira/servicedesk/insight',
    exact: true
};

});


parcelRegister("eXAfa", function(module, exports) {
$parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", () => $11b88f4bf539bb4e$export$72138a83eeba68eb);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7uDgr = parcelRequire("7uDgr");

var $aQoXd = parcelRequire("aQoXd");

var $d8BiX = parcelRequire("d8BiX");

var $dzuEl = parcelRequire("dzuEl");
const $11b88f4bf539bb4e$export$72138a83eeba68eb = (0, $6xToB.createEntry)((0, $7uDgr.servicedeskConnectProjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $d8BiX.getProjectConnectRouteDefaultResources)(),
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        ufoName: 'jira-connect',
        entryPoint: ()=>(0, $dzuEl.connectProjectsWithoutHorizontalNavPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-connect-entries/src/servicedeskConnectProjectRouteEntry.tsx',
                whichExportToUse: 'servicedeskConnectProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7uDgr", function(module, exports) {
$parcel$export(module.exports, "servicedeskConnectProjectRoute", () => $0cc01ac14d8708f5$export$148fcbe26061b2c9);

var $avJUJ = parcelRequire("avJUJ");
const $0cc01ac14d8708f5$export$148fcbe26061b2c9 = {
    name: 'servicedesk-connect-project',
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $avJUJ.CONNECT_PROJECT_QUERY_PARAMS),
    exact: true
};

});


parcelRegister("WBDy8", function(module, exports) {
$parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", () => $48e0ea5eddeb89c0$export$ac25abe07ac3f570);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $ekxFp = parcelRequire("ekxFp");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $48e0ea5eddeb89c0$var$LazyServiceDeskCreateProject = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7Fumr")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $48e0ea5eddeb89c0$var$ServiceDeskCreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $48e0ea5eddeb89c0$var$LazyServiceDeskCreateProject,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $48e0ea5eddeb89c0$export$ac25abe07ac3f570 = (0, $6xToB.createEntry)((0, $ekxFp.servicedeskCreateProjectRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $48e0ea5eddeb89c0$var$ServiceDeskCreateProject,
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $48e0ea5eddeb89c0$var$LazyServiceDeskCreateProject
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CREATE_PROJECT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CREATE_PROJECT),
                teamName: 'Sequoia'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-create-project-entries/src/servicedeskCreateProjectRouteEntry.tsx',
                whichExportToUse: 'servicedeskCreateProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ekxFp", function(module, exports) {
$parcel$export(module.exports, "servicedeskCreateProjectRoute", () => $850004015d5f6476$export$1f409a894343952a);
const $850004015d5f6476$export$1f409a894343952a = {
    name: 'servicedesk-create-project',
    path: '/jira/servicedesk/create-project',
    exact: true
};

});

parcelRegister("7Fumr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("902Qs").then(()=>parcelRequire('50IoF'));

});


parcelRegister("d0HTh", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomerDetailsRouteEntry", () => $7a254a84f15ea428$export$97ee6e9bb7f7bd31);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $izOHw = parcelRequire("izOHw");

var $3UyX6 = parcelRequire("3UyX6");

var $j5ihh = parcelRequire("j5ihh");

var $gy2Qg = parcelRequire("gy2Qg");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $dTgRN = parcelRequire("dTgRN");
const $7a254a84f15ea428$export$97ee6e9bb7f7bd31 = (0, $6xToB.createEntry)((0, $j5ihh.servicedeskCustomerDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        component: (0, $dTgRN.ServicedeskCustomerDetails),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dTgRN.LazyServicedeskCustomerDetails)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $izOHw.EntitlementsQueryResource),
            (0, $3UyX6.CustomerDetailsPageQueryResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-customers-entries/src/servicedeskCustomerDetailsRouteEntry.tsx',
                whichExportToUse: 'servicedeskCustomerDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("j5ihh", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $ea312d5b7212e930$export$42c0f04d04ecd1f8);
const $ea312d5b7212e930$export$42c0f04d04ecd1f8 = {
    name: 'servicedesk-customer-details',
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("dTgRN", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskCustomerDetails", () => $e525c2e3d295a5a4$export$6c5749ec31de847d);
$parcel$export(module.exports, "ServicedeskCustomerDetails", () => $e525c2e3d295a5a4$export$2412523c0e3657cc);
$parcel$export(module.exports, "ServiceDeskContacts", () => $e525c2e3d295a5a4$export$db9de32a8b149a29);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e525c2e3d295a5a4$export$55118fe902ecc07a = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("9ZyER")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});

const $e525c2e3d295a5a4$export$6c5749ec31de847d = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("fnzwL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $e525c2e3d295a5a4$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e525c2e3d295a5a4$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });
const $e525c2e3d295a5a4$export$db9de32a8b149a29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e525c2e3d295a5a4$export$55118fe902ecc07a,
        pageId: "spa-apps/servicedesk/contacts",
        shouldShowSpinner: true
    });

});
parcelRegister("9ZyER", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("gEhfc")
]).then(()=>parcelRequire('64wtY'));

});

parcelRegister("fnzwL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("jros8")
]).then(()=>parcelRequire('fpjBU'));

});



parcelRegister("43iIQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomersV2RouteEntry", () => $29da80ea3498e911$export$e1fa279356610d18);

var $jwPAS = parcelRequire("jwPAS");

var $kHlOR = parcelRequire("kHlOR");

var $s2Zja = parcelRequire("s2Zja");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $do8sA = parcelRequire("do8sA");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $dTgRN = parcelRequire("dTgRN");
const $29da80ea3498e911$export$e1fa279356610d18 = (0, $6xToB.createEntry)((0, $do8sA.servicedeskCustomersV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $jwPAS.csmCustomerContextTenantMigratedStatusResource)
        ],
        component: (0, $dTgRN.ServiceDeskContacts),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $s2Zja.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-customers-entries/src/servicedeskCustomersV2RouteEntry.tsx',
                whichExportToUse: 'servicedeskCustomersV2RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("s2Zja", function(module, exports) {
$parcel$export(module.exports, "AsyncDirectoryNav", () => $a5663a17c7d615f7$export$a237f415539577a5);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");


const $a5663a17c7d615f7$var$LazyDirectoryNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hauQw")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
});
const $a5663a17c7d615f7$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5663a17c7d615f7$var$LazyDirectoryNav, null));

});
parcelRegister("hauQw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eqY2L").then(()=>parcelRequire('aoP5b'));

});


parcelRegister("do8sA", function(module, exports) {
$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $88e458035e58b62a$export$89e9e350610ee31e);
const $88e458035e58b62a$export$89e9e350610ee31e = {
    name: 'servicedesk-customers-v2',
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};

});


parcelRegister("70DsH", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRouteEntry", () => $dcab3c0d94f4f97d$export$e4e0491275df7c2d);

var $g8uYY = parcelRequire("g8uYY");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $9pJMP = parcelRequire("9pJMP");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $kEdwd = parcelRequire("kEdwd");

var $9BJU1 = parcelRequire("9BJU1");

var $cZGEd = parcelRequire("cZGEd");

var $aQoXd = parcelRequire("aQoXd");

var $6kIK7 = parcelRequire("6kIK7");

var $bY77X = parcelRequire("bY77X");
const $dcab3c0d94f4f97d$var$gettingStartedPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bY77X.gettingStartedEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $dcab3c0d94f4f97d$export$e4e0491275df7c2d = (0, $6xToB.createEntry)((0, $cZGEd.servicedeskGettingStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-page-load',
        skeleton: (0, $6kIK7.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $kEdwd.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('gsp_production_rollout') ? $dcab3c0d94f4f97d$var$gettingStartedPageEntryPoint : undefined;
        },
        component: (0, $9BJU1.default),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-getting-started-page-entries/src/servicedeskGettingStartedRouteEntry.tsx',
                whichExportToUse: 'servicedeskGettingStartedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cZGEd", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRoute", () => $07e0505073aabd09$export$165249c1c8f2e713);
const $07e0505073aabd09$export$165249c1c8f2e713 = {
    name: 'servicedesk-getting-started-page',
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});

parcelRegister("bY77X", function(module, exports) {
$parcel$export(module.exports, "gettingStartedEntryPoint", () => $c7866e05e3966a7e$export$a91a58d8bb93ad8e);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $c7866e05e3966a7e$export$a91a58d8bb93ad8e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8ZR00")), {
        moduleId: "99c912b0",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8ZR00", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("fat9k")
]).then(()=>parcelRequire('9fBrm'));

});



parcelRegister("4ZKoO", function(module, exports) {
$parcel$export(module.exports, "servicedeskIssueRouteEntry", () => $2b335429284ca985$export$a4bd7206a6659ad3);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $g3m5X = parcelRequire("g3m5X");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $BkBVx = parcelRequire("BkBVx");
const $2b335429284ca985$export$a4bd7206a6659ad3 = (0, $6xToB.createEntry)((0, $g3m5X.servicedeskIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $BkBVx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            ...(0, $1PvPk.getIssueViewResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $BkBVx.LazyServicedeskQueuesIssueViewRedirect)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskIssueRouteEntry.tsx',
                whichExportToUse: 'servicedeskIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("g3m5X", function(module, exports) {
$parcel$export(module.exports, "servicedeskIssueRoute", () => $72d1de5122ecf119$export$e146d4ae5415aa9);
const $72d1de5122ecf119$export$e146d4ae5415aa9 = {
    name: 'servicedesk-issue',
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};

});

parcelRegister("BkBVx", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", () => $9848d7602f788974$export$52593b5917c5e179);
$parcel$export(module.exports, "default", () => $9848d7602f788974$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9848d7602f788974$export$52593b5917c5e179 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("8Zxv5")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
const $9848d7602f788974$var$AsyncServicedeskQueuesIssueViewRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9848d7602f788974$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });
var $9848d7602f788974$export$2e2bcd8739ae039 = $9848d7602f788974$var$AsyncServicedeskQueuesIssueViewRedirect;

});
parcelRegister("8Zxv5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8vJE0").then(()=>parcelRequire('aARrG'));

});



parcelRegister("ebcb6", function(module, exports) {
$parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", () => $a0a6bcb029e5061c$export$61ad481262acd4e6);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bMuMb = parcelRequire("bMuMb");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a0a6bcb029e5061c$var$LazyItsmSampleSpace = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("elyNB")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $a0a6bcb029e5061c$var$ItsmSampleSpace = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a0a6bcb029e5061c$var$LazyItsmSampleSpace,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $a0a6bcb029e5061c$export$61ad481262acd4e6 = (0, $6xToB.createEntry)((0, $bMuMb.servicedeskItsmSampleSpaceRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $a0a6bcb029e5061c$var$ItsmSampleSpace,
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $a0a6bcb029e5061c$var$LazyItsmSampleSpace
        ],
        perfMetricKey: 'jsm-sample-space-landing-page',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ITSM_SAMPLE_SPACE,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ITSM_SAMPLE_SPACE),
                teamName: 'Sequoia'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-itsm-sample-space-entries/src/servicedeskItsmSampleSpaceRouteEntry.tsx',
                whichExportToUse: 'servicedeskItsmSampleSpaceRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bMuMb", function(module, exports) {
$parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", () => $86b90d7f0d324d35$export$5bc288fedb880892);
const $86b90d7f0d324d35$export$5bc288fedb880892 = {
    name: 'servicedesk-itsm-sample-space',
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};

});

parcelRegister("elyNB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aDA8k").then(()=>parcelRequire('bpPEC'));

});


parcelRegister("7HZi8", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReports2RouteEntry", () => $2df397c096f6d062$export$c4c0806ea684088);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $c2Apz = parcelRequire("c2Apz");

var $aQoXd = parcelRequire("aQoXd");

var $fAgY2 = parcelRequire("fAgY2");
const $2df397c096f6d062$export$c4c0806ea684088 = (0, $6xToB.createEntry)((0, $c2Apz.servicedeskKbRequestsReports2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $fAgY2.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fAgY2.LazyServicedeskKbRequestsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskKbRequestsReports2RouteEntry.tsx',
                whichExportToUse: 'servicedeskKbRequestsReports2RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("c2Apz", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $9ec97f82d08b7a6d$export$276e2ed89304d21c);
const $9ec97f82d08b7a6d$export$276e2ed89304d21c = {
    name: 'servicedesk-kb-requests-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)'
};

});

parcelRegister("fAgY2", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskKbRequestsReports", () => $333192f636e993ee$export$f86e12b111395ad);
$parcel$export(module.exports, "default", () => $333192f636e993ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $333192f636e993ee$export$f86e12b111395ad = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("iM16u"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
const $333192f636e993ee$var$AsyncServicedeskKbRequestsReports = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $333192f636e993ee$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};
var $333192f636e993ee$export$2e2bcd8739ae039 = $333192f636e993ee$var$AsyncServicedeskKbRequestsReports;

});
parcelRegister("iM16u", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("8TITE")
]).then(()=>parcelRequire('7WEsL'));

});



parcelRegister("lw128", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRouteEntry", () => $7902c6bcfd4f4b56$export$280a79a8f002dd58);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gSBJH = parcelRequire("gSBJH");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $dsXZq = parcelRequire("dsXZq");
const $7902c6bcfd4f4b56$export$280a79a8f002dd58 = (0, $6xToB.createEntry)((0, $gSBJH.servicedeskKbRequestsReportsIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dsXZq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dsXZq.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskKbRequestsReportsIssueRouteEntry.tsx',
                whichExportToUse: 'servicedeskKbRequestsReportsIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gSBJH", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $69ac7bff90e8d811$export$296aa46068d40f43);
const $69ac7bff90e8d811$export$296aa46068d40f43 = {
    name: 'servicedesk-kb-requests-reports-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("dsXZq", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsIssueView", () => $3da8fb6fdee0e38c$export$c2f0d3c59c9d3bf3);
$parcel$export(module.exports, "default", () => $3da8fb6fdee0e38c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3da8fb6fdee0e38c$export$c2f0d3c59c9d3bf3 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4XRwV")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
/**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ const $3da8fb6fdee0e38c$var$AsyncServicedeskReportsIssueView = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3da8fb6fdee0e38c$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};
var $3da8fb6fdee0e38c$export$2e2bcd8739ae039 = $3da8fb6fdee0e38c$var$AsyncServicedeskReportsIssueView;

});
parcelRegister("4XRwV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lpNub")
]).then(()=>parcelRequire('3nhuO'));

});



parcelRegister("hAgX3", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRouteEntry", () => $85ebf8f8bc712cde$export$1c6b1e308d58ca8b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $fOFx7 = parcelRequire("fOFx7");

var $aQoXd = parcelRequire("aQoXd");

var $fAgY2 = parcelRequire("fAgY2");
const $85ebf8f8bc712cde$export$1c6b1e308d58ca8b = (0, $6xToB.createEntry)((0, $fOFx7.servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $fAgY2.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fAgY2.LazyServicedeskKbRequestsReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskKbRequestsReportsTimeScaleRouteEntry.tsx',
                whichExportToUse: 'servicedeskKbRequestsReportsTimeScaleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fOFx7", function(module, exports) {
$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $03dcde3e23deddd8$export$1585b6f8f1838e19);
const $03dcde3e23deddd8$export$1585b6f8f1838e19 = {
    name: 'servicedesk-kb-requests-reports-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId'
};

});


parcelRegister("5xDmP", function(module, exports) {
$parcel$export(module.exports, "servicedeskOncallScheduleRouteEntry", () => $eb6dae7facdd0579$export$36994f6fd22da90e);

var $kHlOR = parcelRequire("kHlOR");

var $8rDuZ = parcelRequire("8rDuZ");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $29Aa1 = parcelRequire("29Aa1");

var $aQoXd = parcelRequire("aQoXd");

var $1Sdgw = parcelRequire("1Sdgw");
const $eb6dae7facdd0579$export$36994f6fd22da90e = (0, $6xToB.createEntry)((0, $29Aa1.servicedeskOncallScheduleRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.on-call-schedule',
        component: (0, $1Sdgw.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $8rDuZ.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1Sdgw.LazyServicedeskOpsgenieSchedule),
            (0, $8rDuZ.LazyJSMOperationsHorizontalNav)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-oncall-entries/src/servicedeskOncallScheduleRouteEntry.tsx',
                whichExportToUse: 'servicedeskOncallScheduleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("29Aa1", function(module, exports) {
$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $bfc7e65a2db60a5c$export$740e6e5e982b48a9);
const $bfc7e65a2db60a5c$export$740e6e5e982b48a9 = {
    name: 'servicedesk-oncall-schedule',
    path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
    exact: true
};

});

parcelRegister("1Sdgw", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", () => $52a7395995ee09ea$export$e8392650fdcd92d5);
$parcel$export(module.exports, "default", () => $52a7395995ee09ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $52a7395995ee09ea$export$e8392650fdcd92d5 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("hDAs5")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
const $52a7395995ee09ea$var$AsyncServicedeskOpsgenieSchedule = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $52a7395995ee09ea$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });
var $52a7395995ee09ea$export$2e2bcd8739ae039 = $52a7395995ee09ea$var$AsyncServicedeskOpsgenieSchedule;

});
parcelRegister("hDAs5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lUmpc").then(()=>parcelRequire('bPPZx'));

});



parcelRegister("fKnCL", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationDetailsRouteEntry", () => $8d9bc2bab1187e70$export$a9452a74fdc4d74f);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");

var $2rGHH = parcelRequire("2rGHH");

var $2rHmc = parcelRequire("2rHmc");

var $4bbnu = parcelRequire("4bbnu");

var $gy2Qg = parcelRequire("gy2Qg");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $c9Ddi = parcelRequire("c9Ddi");
const $8d9bc2bab1187e70$export$a9452a74fdc4d74f = (0, $6xToB.createEntry)((0, $4bbnu.servicedeskOrganizationDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        component: (0, $c9Ddi.ServicedeskOrganizationDetails),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c9Ddi.LazyServicedeskOrganizationDetails)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $2rGHH.EntitlementsEntitlementsQueryResource),
            (0, $2rHmc.OrganizationDetailsPageQueryResource),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $czabB.jsmEmailDomainsListResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-organizations-entries/src/servicedeskOrganizationDetailsRouteEntry.tsx',
                whichExportToUse: 'servicedeskOrganizationDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4bbnu", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $d82b0e98245fb755$export$eacc4723293cbc36);
const $d82b0e98245fb755$export$eacc4723293cbc36 = {
    name: 'servicedesk-organization-details',
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("c9Ddi", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskOrganizations", () => $921e1612af0b1641$export$b40b4bfa472057b9);
$parcel$export(module.exports, "ServiceDeskOrganizations", () => $921e1612af0b1641$export$4abec67d7b34dda2);
$parcel$export(module.exports, "LazyServicedeskOrganizationDetails", () => $921e1612af0b1641$export$4a01866152e4a375);
$parcel$export(module.exports, "ServicedeskOrganizationDetails", () => $921e1612af0b1641$export$709be875ca0a7ead);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $921e1612af0b1641$export$b40b4bfa472057b9 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("hfEoG"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $921e1612af0b1641$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $921e1612af0b1641$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $921e1612af0b1641$export$4a01866152e4a375 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("daqAQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $921e1612af0b1641$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $921e1612af0b1641$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("hfEoG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("aLKAp")
]).then(()=>parcelRequire('i6O3K'));

});

parcelRegister("daqAQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("eNFJX")
]).then(()=>parcelRequire('aEKbH'));

});



parcelRegister("39J1B", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationsRouteEntry", () => $9cade4b21667ac39$export$cf20fe731144ca3b);

var $jwPAS = parcelRequire("jwPAS");

var $kHlOR = parcelRequire("kHlOR");

var $s2Zja = parcelRequire("s2Zja");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6pHN3 = parcelRequire("6pHN3");

var $gy2Qg = parcelRequire("gy2Qg");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aQoXd = parcelRequire("aQoXd");

var $c9Ddi = parcelRequire("c9Ddi");
const $9cade4b21667ac39$export$cf20fe731144ca3b = (0, $6xToB.createEntry)((0, $6pHN3.servicedeskOrganizationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $jwPAS.csmCustomerContextTenantMigratedStatusResource)
        ],
        component: (0, $c9Ddi.ServiceDeskOrganizations),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c9Ddi.LazyServicedeskOrganizations)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $s2Zja.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-organizations-entries/src/servicedeskOrganizationsRouteEntry.tsx',
                whichExportToUse: 'servicedeskOrganizationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6pHN3", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $f51d0f804cc19e99$export$d4a712c5bc3c3434);
const $f51d0f804cc19e99$export$d4a712c5bc3c3434 = {
    name: 'servicedesk-organizations',
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};

});


parcelRegister("7Toln", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationV2RouteEntry", () => $6d7eb1b58c0db1e7$export$1b6ea96c35c2472c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $czabB = parcelRequire("czabB");

var $3OsCM = parcelRequire("3OsCM");

var $1PvPk = parcelRequire("1PvPk");

var $at4wb = parcelRequire("at4wb");

var $lEhpY = parcelRequire("lEhpY");

var $aQoXd = parcelRequire("aQoXd");

var $bZvzu = parcelRequire("bZvzu");
const $6d7eb1b58c0db1e7$export$1b6ea96c35c2472c = (0, $6xToB.createEntry)((0, $lEhpY.servicedeskOrganizationV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $at4wb.serviceDeskOrganizationPanelForgeDataResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $3OsCM.productsJsmOrganizationDetailsResource),
            (0, $czabB.jsmEmailDomainsListResource)
        ],
        component: (0, $bZvzu.ServiceDeskOrganizationV2),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bZvzu.LazyServicedeskOrganizationV2)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-organization-entries/src/servicedeskOrganizationV2RouteEntry.tsx',
                whichExportToUse: 'servicedeskOrganizationV2RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("at4wb", function(module, exports) {
$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $e01ad29c35e7b58c$export$f3c46a19f3594363);

var $l1VxS = parcelRequire("l1VxS");


const $e01ad29c35e7b58c$var$getDataLoader = ()=>(parcelRequire("2UiO0"));
const $e01ad29c35e7b58c$export$f3c46a19f3594363 = (0, $l1VxS.createResource)({
    type: (0, $73af164514e152ad$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $e01ad29c35e7b58c$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $73af164514e152ad$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("2UiO0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i1HRw").then(()=>parcelRequire('8pPPY'));

});


parcelRegister("lEhpY", function(module, exports) {
$parcel$export(module.exports, "servicedeskOrganizationV2Route", () => $153c62dfd8829b5d$export$7f878f9aeac61f1e);
const $153c62dfd8829b5d$export$7f878f9aeac61f1e = {
    name: 'servicedesk-organization_v2',
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};

});

parcelRegister("bZvzu", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskOrganizationV2", () => $ebf7c027900b582d$export$1c7fcdb58f42db03);
$parcel$export(module.exports, "ServiceDeskOrganizationV2", () => $ebf7c027900b582d$export$5f69663d85db303d);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ebf7c027900b582d$export$1c7fcdb58f42db03 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("g5voW"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $ebf7c027900b582d$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ebf7c027900b582d$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });

});
parcelRegister("g5voW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("7b7XW")
]).then(()=>parcelRequire('8Ib5W'));

});



parcelRegister("cTtTO", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksEditRouteEntry", () => $d87196730a6a7af9$export$abfa8cd64fabd80e);

var $7mF43 = parcelRequire("7mF43");

var $lopBx = parcelRequire("lopBx");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $k97SW = parcelRequire("k97SW");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $92nFX = parcelRequire("92nFX");

var $g8uYY = parcelRequire("g8uYY");

var $5HjWp = parcelRequire("5HjWp");

var $kSeQy = parcelRequire("kSeQy");
const $d87196730a6a7af9$var$editEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $92nFX.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d87196730a6a7af9$export$abfa8cd64fabd80e = (0, $6xToB.createEntry)((0, $k97SW.servicedeskPlaybooksEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return $d87196730a6a7af9$var$editEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-edit',
        skeleton: (0, $5HjWp.PlaybookEditSkeleton),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksEditRouteEntry.tsx',
                whichExportToUse: 'servicedeskPlaybooksEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k97SW", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $1f795a91a29828c8$export$5920ce3a2ccf6e2b);
const $1f795a91a29828c8$export$5920ce3a2ccf6e2b = {
    name: 'project-settings-playbooks-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
    exact: true
};

});

parcelRegister("92nFX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae50ecd7c33eb0e5$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $LN12I = parcelRequire("LN12I");

var $4cTDP = parcelRequire("4cTDP");

/**
 * NOTE - Please update src/packages/playbooks/edit-screen/src/entrypoint.tsx
 * as that is used in integration test and ideally both should be same except queries
 */ const $ae50ecd7c33eb0e5$var$playbookEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bILu0")), {
        moduleId: "15e5be42",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, playbookId: playbookId = '' } = context.match.params;
        const { fromPlaybookId: fromPlaybookId = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const isNewPlaybook = !!playbookId?.includes($ae50ecd7c33eb0e5$var$NEW_PLAYBOOK_IDENTIFIER);
        const callablePlaybookId = $ae50ecd7c33eb0e5$var$getPlaybookId(playbookId, fromPlaybookId);
        const playbookAri = $ae50ecd7c33eb0e5$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: callablePlaybookId
        });
        const isNewPlaybookCheck = isNewPlaybook && !fromPlaybookId;
        if (isNewPlaybookCheck) // This is complete new playbook creation
        return {
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new'
            }
        };
        return {
            queries: {
                PlaybookDetailQuery: {
                    parameters: (0, $LN12I.default),
                    variables: {
                        playbookAri: playbookAri,
                        jqlFilterSupportEnabled: (0, $4cTDP.fg)('bif-2073-jql-filter-support-playbook')
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: false,
                variant: isNewPlaybook && !!fromPlaybookId ? 'copy' : 'edit'
            }
        };
    }
});
var $ae50ecd7c33eb0e5$export$2e2bcd8739ae039 = $ae50ecd7c33eb0e5$var$playbookEditViewEntryPoint;
function $ae50ecd7c33eb0e5$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
const $ae50ecd7c33eb0e5$var$getPlaybookId = (playbookId, fromPlaybookId)=>{
    if (fromPlaybookId) return fromPlaybookId;
    return playbookId || '';
};
const $ae50ecd7c33eb0e5$var$NEW_PLAYBOOK_IDENTIFIER = '_new_';

});
parcelRegister("LN12I", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c986001d4f10581$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<444071c619041b3d6a89f4a396acaa25>>
 * @relayHash 0b6eb0c8d9d0e7bfb63f1062d281d3f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57f97595099b71ac1a1c7e242a7bb13434487e7d2465c74fd6a2f9cfff0258db
const $7c986001d4f10581$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "57f97595099b71ac1a1c7e242a7bb13434487e7d2465c74fd6a2f9cfff0258db",
        "metadata": {},
        "name": "PlaybookDetailQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7c986001d4f10581$export$2e2bcd8739ae039 = $7c986001d4f10581$var$node;

});

parcelRegister("bILu0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("1SCgz")
]).then(()=>parcelRequire('hcWmc'));

});


parcelRegister("5HjWp", function(module, exports) {
$parcel$export(module.exports, "PlaybookEditSkeleton", () => $f02ebd704904094e$export$8e181e27312cd7a4);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $5bY40 = parcelRequire("5bY40");

var $jjS5D = parcelRequire("jjS5D");

var $gHI4w = parcelRequire("gHI4w");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $dQvP5 = parcelRequire("dQvP5");
const $f02ebd704904094e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    returnToList: {
        "id": "playbooks-edit-screen.playbook-item.skeleton.return-to-list",
        "defaultMessage": "Return to list"
    }
});
const $f02ebd704904094e$export$8e181e27312cd7a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [playbookListLink] = (0, $dQvP5.useReturnToListUrl)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
        appearance: "subtle",
        href: playbookListLink
    }, formatMessage($f02ebd704904094e$export$defe85febe8b728c.returnToList)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $f02ebd704904094e$var$containerStyle,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        actions: actions,
        disableTitleStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.300",
        direction: "row",
        justifyContent: "space-between",
        xcss: $f02ebd704904094e$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $f02ebd704904094e$var$stepCards,
        alignBlock: "start",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $f02ebd704904094e$var$addButton,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: "40px",
        width: "40px",
        isShimmering: true,
        borderRadius: "40px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f02ebd704904094e$var$detailStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: "520px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }))));
};
const $f02ebd704904094e$var$containerStyle = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    paddingLeft: 'space.300',
    paddingRight: 'space.500',
    height: '100vh'
});
const $f02ebd704904094e$var$detailStyle = (0, $1DXK0.xcss)({
    maxWidth: '800px',
    minWidth: '440px',
    width: '45%'
});
const $f02ebd704904094e$var$contentStyles = (0, $1DXK0.xcss)({
    width: '100%',
    paddingTop: 'space.400'
});
const $f02ebd704904094e$var$stepCards = (0, $1DXK0.xcss)({
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '30%',
    maxWidth: '600px'
});
const $f02ebd704904094e$var$addButton = (0, $1DXK0.xcss)({
    height: '52px'
});

});
parcelRegister("dQvP5", function(module, exports) {
$parcel$export(module.exports, "getStepData", () => $90c00a6d3602dc90$export$f1427121561aecf8);
$parcel$export(module.exports, "isStep", () => $90c00a6d3602dc90$export$21684750287da054);
$parcel$export(module.exports, "getJiraPlaybookIdFromARI", () => $90c00a6d3602dc90$export$191a8b6475837449);
$parcel$export(module.exports, "useReturnToListUrl", () => $90c00a6d3602dc90$export$565f39f00aacdb73);
$parcel$export(module.exports, "useGoToTemplatesUrl", () => $90c00a6d3602dc90$export$1f8e220103c2030d);
$parcel$export(module.exports, "getIsDescriptionEmpty", () => $90c00a6d3602dc90$export$f11d072d2cef989a);
$parcel$export(module.exports, "getStepsOrder", () => $90c00a6d3602dc90$export$812421dcb7983dd1);
$parcel$export(module.exports, "getStepsDetail", () => $90c00a6d3602dc90$export$aa46de8dc426f402);

var $clRM1 = parcelRequire("clRM1");

var $a8h6X = parcelRequire("a8h6X");

var $2FqDG = parcelRequire("2FqDG");

var $4cTDP = parcelRequire("4cTDP");

var $gSuah = parcelRequire("gSuah");
const $90c00a6d3602dc90$export$f1427121561aecf8 = (id, name, type, index)=>{
    return {
        stepId: id,
        name: name,
        index: index,
        type: type
    };
};
const $90c00a6d3602dc90$export$21684750287da054 = (data)=>{
    if (data) {
        const { type: type } = data;
        return type === 'INSTRUCTIONAL_RULE' || type === 'AUTOMATION_RULE';
    }
    return false;
};
const $90c00a6d3602dc90$export$cf6e5a5e05d437ad = (cloudId, activationId, playbookId)=>{
    return (0, $a8h6X.JiraPlaybookAri).create({
        siteId: cloudId,
        activationId: activationId,
        playbookId: playbookId
    }).toString();
};
const $90c00a6d3602dc90$export$191a8b6475837449 = (playbookAri)=>{
    return (0, $a8h6X.JiraPlaybookAri).parse(playbookAri).playbookId;
};
const $90c00a6d3602dc90$export$565f39f00aacdb73 = ()=>{
    const [projectKey = ''] = (0, $2FqDG.usePathParam)('projectKey');
    const playbookListLink = (0, $gSuah.getProjectSettingsPageUrl)(projectKey, (0, $4cTDP.fg)('phantom-3633-playbook-routes-migration') ? 'playbooks/list' : 'playbooks');
    return [
        playbookListLink
    ];
};
const $90c00a6d3602dc90$export$1f8e220103c2030d = ()=>{
    const [projectKey = ''] = (0, $2FqDG.usePathParam)('projectKey');
    const playbookTemplatesLink = (0, $gSuah.getProjectSettingsPageUrl)(projectKey, 'playbooks/templates');
    return [
        playbookTemplatesLink
    ];
};
const $90c00a6d3602dc90$export$f11d072d2cef989a = (description)=>{
    if (description && Object.keys(description).length > 0) return JSON.stringify(description) === JSON.stringify((0, $clRM1.getEmptyADF)());
    return true;
};
const $90c00a6d3602dc90$export$812421dcb7983dd1 = (data)=>{
    return data.map((step)=>step.stepId);
};
const $90c00a6d3602dc90$export$aa46de8dc426f402 = (data)=>{
    const acc = {};
    data.forEach((step)=>{
        acc[step.stepId] = step;
    });
    return acc;
};

});
parcelRegister("clRM1", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $5304529a0b87b9ee$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $i429R = parcelRequire("i429R");
const $5304529a0b87b9ee$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("i429R", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $f633a00593707962$export$dd1bc94b04021eeb);
const $f633a00593707962$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("a8h6X", function(module, exports) {
$parcel$export(module.exports, "JiraPlaybookAri", () => $7607ecaf31f00add$export$2b27259a6ef92c74);

var $3o7lc = parcelRequire("3o7lc");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/playbook/manifest.ts
var $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $3o7lc.JiraPlaybookAriResourceOwner),
    resourceType: (0, $3o7lc.JiraPlaybookAriResourceType),
    resourceIdSlug: "activation/{activationId}/{playbookId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/playbook/index.ts
var $7607ecaf31f00add$export$2b27259a6ef92c74 = class _JiraPlaybookAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get playbookId() {
        return this._playbookId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.qualifier,
            platformQualifier: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.resourceOwner,
            resourceType: $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                playbookId: opts.playbookId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $7607ecaf31f00add$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            playbookId: this.playbookId
        };
    }
};

});
parcelRegister("3o7lc", function(module, exports) {
$parcel$export(module.exports, "JiraPlaybookAriResourceOwner", () => $27794eba312f7687$export$91235105b4a9ebd9);
$parcel$export(module.exports, "JiraPlaybookAriResourceType", () => $27794eba312f7687$export$5af5bf4e6f11326f);
// src/jira/playbook/types.ts
var $27794eba312f7687$export$91235105b4a9ebd9 = "jira", $27794eba312f7687$export$5af5bf4e6f11326f = "playbook";

});


parcelRegister("gSuah", function(module, exports) {
$parcel$export(module.exports, "getProjectUrl", () => $617ab16f323338b8$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $617ab16f323338b8$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $617ab16f323338b8$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $617ab16f323338b8$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $617ab16f323338b8$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $617ab16f323338b8$export$c2a8139910ee6c);
$parcel$export(module.exports, "getWorkflowSettingsUrlNew", () => $617ab16f323338b8$export$b5a78daf48bc2ce7);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $617ab16f323338b8$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $617ab16f323338b8$export$13f39b40814e5f3e);

var $7lJUT = parcelRequire("7lJUT");

var $FhXEJ = parcelRequire("FhXEJ");

var $dFfRj = parcelRequire("dFfRj");

var $jmJlK = parcelRequire("jmJlK");

var $gwhEz = parcelRequire("gwhEz");

var $02kpm = parcelRequire("02kpm");
const $617ab16f323338b8$export$951b86b8e730b952 = (projectKey)=>(0, $02kpm.generatePath)((0, $gwhEz.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $617ab16f323338b8$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $7lJUT.getNextgenSettingsIssueTypesUrl)((0, $FhXEJ.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $617ab16f323338b8$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : (0, $02kpm.generatePath)((0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $617ab16f323338b8$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : `${$617ab16f323338b8$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $617ab16f323338b8$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $617ab16f323338b8$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $617ab16f323338b8$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : (0, $02kpm.generatePath)((0, $dFfRj.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $617ab16f323338b8$export$b5a78daf48bc2ce7 = (projectKey, issueTypeId, isSimplified = false)=>{
    if (isSimplified) return $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey, issueTypeId || undefined);
    // For non-simplified, the URL does not depend on issueTypeId
    return (0, $02kpm.generatePath)((0, $dFfRj.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
};
const $617ab16f323338b8$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $617ab16f323338b8$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("dFfRj", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $d6f76bba36af0fd3$export$b03606cedffdadf6);
const $d6f76bba36af0fd3$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});





parcelRegister("hyqfi", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksListOnlyRouteEntry", () => $6ded14d639ac80cf$export$f9e5d9d800421777);

var $7mF43 = parcelRequire("7mF43");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $aFLr9 = parcelRequire("aFLr9");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $jse9r = parcelRequire("jse9r");

var $g8uYY = parcelRequire("g8uYY");

var $heGmm = parcelRequire("heGmm");

var $kSeQy = parcelRequire("kSeQy");

var $lopBx = parcelRequire("lopBx");

var $5eLuu = parcelRequire("5eLuu");

var $1Cn8t = parcelRequire("1Cn8t");

var $4cTDP = parcelRequire("4cTDP");
const $6ded14d639ac80cf$var$listOnlyEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jse9r.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $5eLuu.default)
});
const $6ded14d639ac80cf$export$f9e5d9d800421777 = (0, $6xToB.createEntry)((0, $aFLr9.servicedeskPlaybooksListOnlyRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)() || !(0, $4cTDP.fg)('phantom-3633-playbook-routes-migration')) return 0, $kSeQy.notFoundPageEntrypoint;
            return $6ded14d639ac80cf$var$listOnlyEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $heGmm.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.list-only-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-list-only'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-list-only',
        skeleton: (0, $1Cn8t.PlaybookWrappedListLoadingView),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksListOnlyRouteEntry.tsx',
                whichExportToUse: 'servicedeskPlaybooksListOnlyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aFLr9", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksListOnlyRoute", () => $b14ac360f6586b44$export$22e68595bc191dc2);
const $b14ac360f6586b44$export$22e68595bc191dc2 = {
    name: 'project-settings-playbooks-list-only',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/list',
    exact: true
};

});

parcelRegister("jse9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $0687332ef2ce6534$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $hYpFY = parcelRequire("hYpFY");

var $4cTDP = parcelRequire("4cTDP");

const $0687332ef2ce6534$var$playbookListOnlyViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4IuBL")), {
        moduleId: "f2788638",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { name: name = '', status: status } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $hYpFY.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        first: $0687332ef2ce6534$var$PLAYBOOK_LIST_FIRST_COUNT,
                        filter: $0687332ef2ce6534$var$getFilters(name, status),
                        isFetchingLabels: (0, $4cTDP.fg)('phantom-3292-playbook-labels')
                    }
                }
            },
            extraProps: {
                projectKey: context.match.params.projectKey
            }
        };
    }
});
var $0687332ef2ce6534$export$2e2bcd8739ae039 = $0687332ef2ce6534$var$playbookListOnlyViewEntryPoint;
const $0687332ef2ce6534$var$getFilters = (name, status)=>{
    if ((0, $4cTDP.fg)('phantom-playbook-save-as-draft')) {
        const filter = {};
        const state = $0687332ef2ce6534$var$getStateFromStatus(status);
        if (name) filter.name = name;
        if (state) filter.state = state;
        return Object.values(filter).some(Boolean) ? filter : null;
    }
    return name ? {
        name: name
    } : null;
};
const $0687332ef2ce6534$var$PLAYBOOK_LIST_FIRST_COUNT = 20;
const $0687332ef2ce6534$var$getStateFromStatus = (status)=>{
    switch(status){
        case 'on':
            return 'ENABLED';
        case 'off':
            return 'DISABLED';
        case 'draft':
            return 'DRAFT';
        default:
            return undefined;
    }
};

});
parcelRegister("hYpFY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b61c51f4dac2b90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d39a0c2462d19df68c0191f4833efd7>>
 * @relayHash d788a2aeb0fae4e4d80ce25d45d7e74f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdf7c38cb5d05b42232405fd538e660889cd2b346e28cb4ec030b80fd1714083
const $7b61c51f4dac2b90$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fdf7c38cb5d05b42232405fd538e660889cd2b346e28cb4ec030b80fd1714083",
        "metadata": {},
        "name": "PlaybookListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7b61c51f4dac2b90$export$2e2bcd8739ae039 = $7b61c51f4dac2b90$var$node;

});

parcelRegister("4IuBL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h2YqG").then(()=>parcelRequire('7gC33'));

});


parcelRegister("heGmm", function(module, exports) {
$parcel$export(module.exports, "playbooksListRequestTypesResource", () => $fdcc282ddf971443$export$43f774aa05fabd18);

var $l1VxS = parcelRequire("l1VxS");


var $5j85B = parcelRequire("5j85B");

var $3ugTQ = parcelRequire("3ugTQ");
const $fdcc282ddf971443$export$43f774aa05fabd18 = (0, $l1VxS.createResource)({
    type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListRequestTypesResource-${projectKey}`;
    },
    getData: async ({ dependencies: dependencies })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { projectId: projectId } = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        return (0, $3ugTQ.performGetRequest)($fdcc282ddf971443$var$getRequestTypesUrl(projectId)).then((response)=>response.ticketTypes);
    },
    maxAge: 300000,
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ]
});
const $fdcc282ddf971443$var$getRequestTypesUrl = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;

});

parcelRegister("5eLuu", function(module, exports) {
$parcel$export(module.exports, "default", () => $09c056776c70447a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $09c056776c70447a$var$playbooksHorizontalNavEntrypoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("aFDIK")), {
        moduleId: "5a337f54",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: { match: match } })=>{
        // Extract projectKey from route parameters
        const projectKey = match.params.projectKey;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            extraProps: {
                projectKey: projectKey
            }
        };
    }
});
var $09c056776c70447a$export$2e2bcd8739ae039 = $09c056776c70447a$var$playbooksHorizontalNavEntrypoint;

});
parcelRegister("aFDIK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Mm3C8").then(()=>parcelRequire('fJhua'));

});


parcelRegister("1Cn8t", function(module, exports) {
$parcel$export(module.exports, "PlaybookListLoadingView", () => $bf6c06d4f9c9f8cf$export$987a3a981b9fa390);
$parcel$export(module.exports, "PlaybookWrappedListLoadingView", () => $bf6c06d4f9c9f8cf$export$5e3fd9b5c5190a9a);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $e2T4R = parcelRequire("e2T4R");
const $bf6c06d4f9c9f8cf$export$987a3a981b9fa390 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.250",
        grow: "fill",
        xcss: $bf6c06d4f9c9f8cf$var$wrapperStyles,
        testId: "playbooks-list-screen.ui.playbook-list.edge-cases.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: 240,
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: 120,
        borderRadius: 4,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf6c06d4f9c9f8cf$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf6c06d4f9c9f8cf$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf6c06d4f9c9f8cf$var$LoadingRow, null)));
const $bf6c06d4f9c9f8cf$var$LoadingRow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "30%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "18%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "18%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "18%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "6%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "10%",
        borderRadius: 4,
        isShimmering: true
    }));
const $bf6c06d4f9c9f8cf$export$5e3fd9b5c5190a9a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2T4R.TabContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf6c06d4f9c9f8cf$export$987a3a981b9fa390, null));
const $bf6c06d4f9c9f8cf$var$wrapperStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.300'
});

});
parcelRegister("e2T4R", function(module, exports) {
$parcel$export(module.exports, "TabContainer", () => $f97e558d3ebc5ea7$export$eed545bf41e40386);
/* TabContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $8yEMd = parcelRequire("8yEMd");
var $IhqEd = parcelRequire("IhqEd");
const $f97e558d3ebc5ea7$export$eed545bf41e40386 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $f97e558d3ebc5ea7$var$styles.tabContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8yEMd.default), {
        layout: "fluid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $IhqEd.default), null, children)));
};
const $f97e558d3ebc5ea7$var$styles = {
    tabContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _ca0qze3t _u5f31ejb _n3tdze3t _19bv1ejb _4t3i1osq"
};

});



parcelRegister("dP6oq", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksListRouteEntry", () => $b6854d45556a380c$export$19177b8fa44e5e4d);

var $7mF43 = parcelRequire("7mF43");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9AagY = parcelRequire("9AagY");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $1TMtj = parcelRequire("1TMtj");

var $g8uYY = parcelRequire("g8uYY");

var $heGmm = parcelRequire("heGmm");

var $kSeQy = parcelRequire("kSeQy");

var $4cTDP = parcelRequire("4cTDP");

var $lopBx = parcelRequire("lopBx");

var $b10lc = parcelRequire("b10lc");
const $b6854d45556a380c$var$listEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1TMtj.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $b6854d45556a380c$export$19177b8fa44e5e4d = (0, $6xToB.createEntry)((0, $9AagY.servicedeskPlaybooksListRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            if ((0, $4cTDP.fg)('phantom-3633-playbook-routes-migration')) return undefined;
            return $b6854d45556a380c$var$listEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $heGmm.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-list-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-list'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $b10lc.RedirectToListOnlyPage),
        ufoName: 'playbook-list',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksListRouteEntry.tsx',
                whichExportToUse: 'servicedeskPlaybooksListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9AagY", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksListRoute", () => $e1335324213a53e9$export$cbed08b5b0671f5f);
const $e1335324213a53e9$export$cbed08b5b0671f5f = {
    name: 'project-settings-playbooks-list',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks',
    exact: true
};

});

parcelRegister("1TMtj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3ce5834aa35721d$export$2e2bcd8739ae039);

var $3onAA = parcelRequire("3onAA");

var $k36i1 = parcelRequire("k36i1");

var $dix9C = parcelRequire("dix9C");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");
// This is for filters on type JiraPlaybookListFilter
const $a3ce5834aa35721d$var$getListFilters = (name, label)=>{
    const filters = {};
    if (name) filters.name = name;
    if (label) filters.labels = [
        label
    ];
    return Object.keys(filters).length > 0 ? filters : null;
};
function $a3ce5834aa35721d$var$getUsageFilter({ name: name, status: status }) {
    const filter = {
        endTime: null,
        name: null,
        startTime: null,
        state: null,
        stepStatus: null,
        stepType: null
    };
    if (name) filter.name = name;
    if (status === 'ENABLED' || status === 'DISABLED') filter.state = status;
    const cleanedFilter = Object.fromEntries(Object.entries(filter).filter(([_, v])=>v !== null));
    return Object.values(cleanedFilter).some(Boolean) ? cleanedFilter : null;
}
function $a3ce5834aa35721d$var$getListPageEntrypoint(tab, cloudId, projectKey, name, label, usageFilter, getFilter) {
    switch(tab){
        case 'logs':
            return {
                preloadedPlaybookLogsEntryPoint: {
                    entryPoint: (0, $k36i1.playbookLogsEntryPoint),
                    entryPointParams: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        first: 20,
                        filter: name ? {
                            name: name
                        } : null
                    }
                }
            };
        case 'usage':
            return {
                preloadedPlaybookUsageEntryPoint: {
                    entryPoint: (0, $dix9C.playbookUsageEntryPoint),
                    entryPointParams: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        first: 20,
                        usageFilter: usageFilter
                    }
                }
            };
        default:
            return {
                preloadedPlaybookListEntryPoint: {
                    entryPoint: (0, $3onAA.playbookListEntryPoint),
                    entryPointParams: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        first: 20,
                        ...(0, $4cTDP.fg)('phantom-3292-playbook-labels') ? {
                            filters: $a3ce5834aa35721d$var$getListFilters(name, label)
                        } : {
                            filter: getFilter()
                        },
                        isFetchingLabels: (0, $4cTDP.fg)('phantom-3292-playbook-labels')
                    }
                }
            };
    }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Argument of type '{ root: ...; getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => any; }' is not assignable to parameter of type 'never'
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $a3ce5834aa35721d$var$playbookListViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("k2rk2")), {
        moduleId: "a498670b",
        priority: "interaction"
    }),
    // This has been causing build errors in unrelated code. Broadening type to fix build.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { tab: tab = 'list', name: name = '', status: status, label: label = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        const getFilter = ()=>{
            if ((0, $4cTDP.fg)('phantom-playbook-save-as-draft')) {
                const filter = {};
                const state = $a3ce5834aa35721d$var$getStateFromStatus(status);
                if (name) filter.name = name;
                if (state) filter.state = state;
                return Object.values(filter).some(Boolean) ? filter : null;
            }
            return name ? {
                name: name
            } : null;
        };
        const usageFilter = (0, $4cTDP.fg)('enable_usage_tab') ? $a3ce5834aa35721d$var$getUsageFilter({
            name: name,
            status: status
        }) : null;
        let entryPoints;
        if ((0, $4cTDP.fg)('enable_usage_tab')) entryPoints = $a3ce5834aa35721d$var$getListPageEntrypoint(tab, tenantContext.cloudId, projectKey, name, label, usageFilter, getFilter);
        else // In case where tab is logs, we need to load the logs entry point
        // For other cases, fallback to the list entry point. This matches the current logic in the UI component.
        entryPoints = tab === 'logs' ? {
            preloadedPlaybookLogsEntryPoint: {
                entryPoint: (0, $k36i1.playbookLogsEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        } : {
            preloadedPlaybookListEntryPoint: {
                entryPoint: (0, $3onAA.playbookListEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    ...(0, $4cTDP.fg)('phantom-3292-playbook-labels') ? {
                        filters: $a3ce5834aa35721d$var$getListFilters(name, label)
                    } : {
                        filter: getFilter()
                    },
                    isFetchingLabels: (0, $4cTDP.fg)('phantom-3292-playbook-labels')
                }
            }
        };
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectId: context.query.projectId,
                projectKey: context.match.params.projectKey
            },
            entryPoints: entryPoints
        };
    }
});
var $a3ce5834aa35721d$export$2e2bcd8739ae039 = $a3ce5834aa35721d$var$playbookListViewEntryPoint;
const $a3ce5834aa35721d$var$getStateFromStatus = (status)=>{
    switch(status){
        case 'on':
            return 'ENABLED';
        case 'off':
            return 'DISABLED';
        case 'draft':
            return 'DRAFT';
        default:
            return undefined;
    }
};

});
parcelRegister("3onAA", function(module, exports) {
$parcel$export(module.exports, "playbookListEntryPoint", () => $03d10095880dc7de$export$d7be5d3b24f1d526);

var $hYpFY = parcelRequire("hYpFY");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $03d10095880dc7de$export$d7be5d3b24f1d526 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8uYav")).then((module)=>module.PlaybookList), {
        moduleId: "3f3b7cb0",
        moduleName: "PlaybookList",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $hYpFY.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("8uYav", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1xmlT").then(()=>parcelRequire('eJKC4'));

});


parcelRegister("k36i1", function(module, exports) {
$parcel$export(module.exports, "playbookLogsEntryPoint", () => $c74f3dd1ab1fa184$export$7ebe0f850472ea07);

var $hu2rE = parcelRequire("hu2rE");

var $cNVVt = parcelRequire("cNVVt");

var $3Bzqe = parcelRequire("3Bzqe");

const $c74f3dd1ab1fa184$export$7ebe0f850472ea07 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3YrqB")), {
        moduleId: "c3ca80f1",
        moduleName: "PlaybookLogs",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $cNVVt.default),
                    variables: variables
                }
            }
        })
});

});
parcelRegister("cNVVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $abfd91f921f593b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<15280667f706316750b55d64796fb790>>
 * @relayHash c197bbece789e4cb329e128453687570
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2
const $abfd91f921f593b8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "565606802eb0a72ceab02256a296b8539bab587a529cc4b38118031f77bf14d2",
        "metadata": {},
        "name": "PlaybookLogsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $abfd91f921f593b8$export$2e2bcd8739ae039 = $abfd91f921f593b8$var$node;

});

parcelRegister("3YrqB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jDtf9").then(()=>parcelRequire('9rDEK'));

});


parcelRegister("dix9C", function(module, exports) {
$parcel$export(module.exports, "playbookUsageEntryPoint", () => $2eb01bbc5748d004$export$acf5774377e79928);

var $5eTWL = parcelRequire("5eTWL");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $2eb01bbc5748d004$export$acf5774377e79928 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("iNAV2")).then((module)=>module.PlaybookUsage), {
        moduleId: "f44e79ab",
        moduleName: "PlaybookUsage",
        priority: "userVisible"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookUsageQuery: {
                    parameters: (0, $5eTWL.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("5eTWL", function(module, exports) {
$parcel$export(module.exports, "default", () => $32a6a38dfdb1d392$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7ba598fab94e932f31527824e7866a2>>
 * @relayHash c76a0108f60c565783452e6658a3cf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ec0a456168b3b9b4a9c87ab77c8fe13240bb085fd5d2df1530d3abc4c6d359f
const $32a6a38dfdb1d392$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1ec0a456168b3b9b4a9c87ab77c8fe13240bb085fd5d2df1530d3abc4c6d359f",
        "metadata": {},
        "name": "PlaybookUsageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32a6a38dfdb1d392$export$2e2bcd8739ae039 = $32a6a38dfdb1d392$var$node;

});

parcelRegister("iNAV2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kLl1H").then(()=>parcelRequire('kn9Jn'));

});


parcelRegister("k2rk2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eYAf0").then(()=>parcelRequire('dEERs'));

});


parcelRegister("b10lc", function(module, exports) {
$parcel$export(module.exports, "RedirectToListOnlyPage", () => $259660630aef3083$export$986a104af516fe0a);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");

var $gCY1z = parcelRequire("gCY1z");

var $9BJU1 = parcelRequire("9BJU1");
const $259660630aef3083$export$986a104af516fe0a = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const projectKey = match?.params?.projectKey;
    if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9BJU1.default), null);
    const redirectPath = `/jira/servicedesk/projects/${projectKey}/settings/playbooks/list`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: redirectPath
    });
};

});


parcelRegister("fpNbL", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksLogsRouteEntry", () => $b187dedaa02fe6b6$export$556757ffa43b9345);

var $7mF43 = parcelRequire("7mF43");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $kM9ck = parcelRequire("kM9ck");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $dK7BY = parcelRequire("dK7BY");

var $g8uYY = parcelRequire("g8uYY");

var $heGmm = parcelRequire("heGmm");

var $kSeQy = parcelRequire("kSeQy");

var $lopBx = parcelRequire("lopBx");

var $5eLuu = parcelRequire("5eLuu");

var $jKp1l = parcelRequire("jKp1l");

var $4cTDP = parcelRequire("4cTDP");
const $b187dedaa02fe6b6$var$logsEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dK7BY.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $5eLuu.default)
});
const $b187dedaa02fe6b6$export$556757ffa43b9345 = (0, $6xToB.createEntry)((0, $kM9ck.servicedeskPlaybooksLogsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)() || !(0, $4cTDP.fg)('phantom-3633-playbook-routes-migration')) return 0, $kSeQy.notFoundPageEntrypoint;
            return $b187dedaa02fe6b6$var$logsEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $heGmm.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.logs-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-logs'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-logs',
        skeleton: (0, $jKp1l.PlaybookWrappedLogsLoadingView),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksLogsRouteEntry.tsx',
                whichExportToUse: 'servicedeskPlaybooksLogsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kM9ck", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksLogsRoute", () => $b8f18630bd32495e$export$7fdae29617c2cd73);
const $b8f18630bd32495e$export$7fdae29617c2cd73 = {
    name: 'project-settings-playbooks-logs',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/logs',
    exact: true
};

});

parcelRegister("dK7BY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee73d120ca7538d$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $cNVVt = parcelRequire("cNVVt");

const $6ee73d120ca7538d$var$playbookLogsViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7TzBt")), {
        moduleId: "68fab46c",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $cNVVt.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        first: $6ee73d120ca7538d$var$PLAYBOOK_LOGS_FIRST_COUNT,
                        filter: name ? {
                            name: name
                        } : null
                    }
                }
            },
            extraProps: {
                projectKey: context.match.params.projectKey
            }
        };
    }
});
const $6ee73d120ca7538d$var$PLAYBOOK_LOGS_FIRST_COUNT = 20;
var $6ee73d120ca7538d$export$2e2bcd8739ae039 = $6ee73d120ca7538d$var$playbookLogsViewEntryPoint;

});
parcelRegister("7TzBt", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kwG70").then(()=>parcelRequire('gGFAO'));

});


parcelRegister("jKp1l", function(module, exports) {
$parcel$export(module.exports, "PlaybookLogsLoadingView", () => $d70a7c1899b1dc57$export$42f7712c79c4d758);
$parcel$export(module.exports, "PlaybookWrappedLogsLoadingView", () => $d70a7c1899b1dc57$export$18253d58aa9bc94a);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $e2T4R = parcelRequire("e2T4R");
const $d70a7c1899b1dc57$export$42f7712c79c4d758 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        testId: "playbooks-list-screen.ui.playbook-logs.edge-cases.loading",
        space: "space.250",
        grow: "fill",
        xcss: $d70a7c1899b1dc57$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: 240,
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: 40,
        borderRadius: 4,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d70a7c1899b1dc57$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d70a7c1899b1dc57$var$LoadingRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d70a7c1899b1dc57$var$LoadingRow, null)));
const $d70a7c1899b1dc57$var$LoadingRow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "22%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "16%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "16%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "16%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "10%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "10%",
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: "10%",
        borderRadius: 4,
        isShimmering: true
    }));
const $d70a7c1899b1dc57$export$18253d58aa9bc94a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2T4R.TabContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d70a7c1899b1dc57$export$42f7712c79c4d758, null));
const $d70a7c1899b1dc57$var$wrapperStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.300'
});

});


parcelRegister("kYXsc", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplateCreateRouteEntry", () => $e26f330482e79bd6$export$e693d2e428384d7);

var $7mF43 = parcelRequire("7mF43");

var $lopBx = parcelRequire("lopBx");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $8BEG2 = parcelRequire("8BEG2");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

var $bcNBu = parcelRequire("bcNBu");

var $g8uYY = parcelRequire("g8uYY");

var $5HjWp = parcelRequire("5HjWp");

var $kSeQy = parcelRequire("kSeQy");
const $e26f330482e79bd6$var$playbookTemplateCreateEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bcNBu.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $e26f330482e79bd6$export$e693d2e428384d7 = (0, $6xToB.createEntry)((0, $8BEG2.servicedeskPlaybooksTemplateCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)() && !(0, $4cTDP.fg)('phantom-3577-playbook-templates')) return 0, $kSeQy.notFoundPageEntrypoint;
            return $e26f330482e79bd6$var$playbookTemplateCreateEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-template-create-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-template-create'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-template-create',
        skeleton: (0, $5HjWp.PlaybookEditSkeleton),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksTemplateCreateRouteEntry.tsx',
                whichExportToUse: 'servicedeskPlaybooksTemplateCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8BEG2", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplateCreateRoute", () => $27f0b61ba91b0516$export$b8c33038909d50ad);
const $27f0b61ba91b0516$export$b8c33038909d50ad = {
    name: 'project-settings-playbooks-template-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/template/:templateId',
    exact: true
};

});

parcelRegister("bcNBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $beccf5c834c0b61d$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4EgWW = parcelRequire("4EgWW");

const $beccf5c834c0b61d$var$playbookTemplateCreateViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8oGCY")), {
        moduleId: "ca785691",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, templateId: templateId = '' } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const playbookAri = $beccf5c834c0b61d$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: ''
        });
        return {
            queries: {
                PlaybookTemplateCreateQuery: {
                    parameters: (0, $4EgWW.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        templateId: templateId ?? ''
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new',
                templateId: templateId ?? ''
            }
        };
    }
});
var $beccf5c834c0b61d$export$2e2bcd8739ae039 = $beccf5c834c0b61d$var$playbookTemplateCreateViewEntryPoint;
function $beccf5c834c0b61d$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}

});
parcelRegister("4EgWW", function(module, exports) {
$parcel$export(module.exports, "default", () => $98a341a66a20dca6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b530973bff90fff079483bdd8a37e142>>
 * @relayHash 84c2c1e346b9a26f93ec271062299f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 990ee6cb15a97d6610be8c786bb0db24d16f77a6df01554ca9f374ec6a6a765b
const $98a341a66a20dca6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "990ee6cb15a97d6610be8c786bb0db24d16f77a6df01554ca9f374ec6a6a765b",
        "metadata": {},
        "name": "PlaybookTemplateCreateQuery",
        "operationKind": "query",
        "text": null
    }
};
var $98a341a66a20dca6$export$2e2bcd8739ae039 = $98a341a66a20dca6$var$node;

});

parcelRegister("8oGCY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("gTmR2")
]).then(()=>parcelRequire('dVSum'));

});



parcelRegister("g3St3", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplatesRouteEntry", () => $a826322b42c83038$export$68af602a86f0318a);

var $7mF43 = parcelRequire("7mF43");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $9BJU1 = parcelRequire("9BJU1");

var $574Q5 = parcelRequire("574Q5");

var $aQoXd = parcelRequire("aQoXd");

var $5RW99 = parcelRequire("5RW99");

var $3IHEX = parcelRequire("3IHEX");

var $g8uYY = parcelRequire("g8uYY");

var $heGmm = parcelRequire("heGmm");

var $kSeQy = parcelRequire("kSeQy");

var $lopBx = parcelRequire("lopBx");

var $5eLuu = parcelRequire("5eLuu");

var $gkIOc = parcelRequire("gkIOc");

var $4cTDP = parcelRequire("4cTDP");
const $a826322b42c83038$var$templatesEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3IHEX.default),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $5eLuu.default)
});
const $a826322b42c83038$export$68af602a86f0318a = (0, $6xToB.createEntry)((0, $574Q5.servicedeskPlaybooksTemplatesRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)() || !(0, $4cTDP.fg)('phantom-3577-playbook-templates')) return 0, $kSeQy.notFoundPageEntrypoint;
            return $a826322b42c83038$var$templatesEntryPoint;
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $heGmm.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.templates-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('project-settings-playbooks-templates'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $9BJU1.default),
        ufoName: 'playbook-templates',
        skeleton: (0, $gkIOc.PlaybookTemplatesLoadingView),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksTemplatesRouteEntry.tsx',
                whichExportToUse: 'servicedeskPlaybooksTemplatesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("574Q5", function(module, exports) {
$parcel$export(module.exports, "servicedeskPlaybooksTemplatesRoute", () => $b52eaf6dd0ff62fd$export$db0eaacc419e5ad7);
const $b52eaf6dd0ff62fd$export$db0eaacc419e5ad7 = {
    name: 'project-settings-playbooks-templates',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/templates',
    exact: true
};

});

parcelRegister("3IHEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $57622930f7f27423$export$2e2bcd8739ae039);

var $elsWv = parcelRequire("elsWv");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $57622930f7f27423$var$playbookTemplatesEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lpaYo")), {
        moduleId: "02360511",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                PlaybookTemplatesQuery: {
                    parameters: (0, $elsWv.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        filters: name ? {
                            name: name
                        } : null
                    }
                }
            },
            extraProps: {
                projectKey: context.match.params.projectKey
            }
        };
    }
});
var $57622930f7f27423$export$2e2bcd8739ae039 = $57622930f7f27423$var$playbookTemplatesEntryPoint;

});
parcelRegister("elsWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4c0b8cbc5a0666a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b53b9d18368de703071dd445a9192e8>>
 * @relayHash 67388e2ca589ea71c5bc78019291f753
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0aeae55c60694692712eb6fb1202579f75a724cf46da8cdbad6c77c475c9a5a2
const $f4c0b8cbc5a0666a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0aeae55c60694692712eb6fb1202579f75a724cf46da8cdbad6c77c475c9a5a2",
        "metadata": {},
        "name": "PlaybookTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f4c0b8cbc5a0666a$export$2e2bcd8739ae039 = $f4c0b8cbc5a0666a$var$node;

});

parcelRegister("lpaYo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gbJJs").then(()=>parcelRequire('gjJ2S'));

});


parcelRegister("gkIOc", function(module, exports) {
$parcel$export(module.exports, "PlaybookTemplatesLoadingView", () => $b40aa3da8d3d9955$export$cc6c6f45cef7ebe);
/* PlaybookTemplatesLoadingView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $jjS5D = parcelRequire("jjS5D");

var $e2T4R = parcelRequire("e2T4R");

var $3ow6d = parcelRequire("3ow6d");
const $b40aa3da8d3d9955$var$styles = {
    wrapper: "_ca0q1ejb"
};
const $b40aa3da8d3d9955$export$cc6c6f45cef7ebe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2T4R.TabContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        testId: "playbooks-list-screen.ui.playbook-templates.edge-cases.loading",
        space: "space.250",
        grow: "fill",
        xcss: $b40aa3da8d3d9955$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 32,
        width: 240,
        borderRadius: 4,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ow6d.TemplatesListLoadingView), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ow6d.TemplatesListLoadingView), null))));

});
parcelRegister("3ow6d", function(module, exports) {
$parcel$export(module.exports, "TemplatesListLoadingView", () => $c5846dc34a6e2ec8$export$24c3e442327746dc);

var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $jjS5D = parcelRequire("jjS5D");
const $c5846dc34a6e2ec8$export$24c3e442327746dc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200",
        testId: "playbooks-list-screen.ui.playbook-templates.edge-cases.templates-list-loading-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 20,
        width: 220,
        borderRadius: 4,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 282,
        width: 272,
        borderRadius: 8,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        height: 282,
        width: 272,
        borderRadius: 8,
        isShimmering: true
    })));

});



parcelRegister("1cWr6", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeEditRouteEntry", () => $5e57647a9d2d6ff1$export$5d9efd0f838d30a1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $kUiQk = parcelRequire("kUiQk");

var $aQoXd = parcelRequire("aQoXd");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $6sU1E = parcelRequire("6sU1E");

var $5NcGG = parcelRequire("5NcGG");

var $eOSoz = parcelRequire("eOSoz");
const $5e57647a9d2d6ff1$export$5d9efd0f838d30a1 = (0, $6xToB.createEntry)((0, $kUiQk.servicedeskPracticeEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $5NcGG.ServicedeskQueuesConfig), (0, $6sU1E.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $5NcGG.LazyServicedeskQueuesConfig) : (0, $6sU1E.LazyServicedeskQueuesEditView)
        ],
        pageId: ({ query: query, match: match })=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeEditRouteEntry.tsx',
                whichExportToUse: 'servicedeskPracticeEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kUiQk", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeEditRoute", () => $68064f83de6ba407$export$dfaa99f66db1aa2);
const $68064f83de6ba407$export$dfaa99f66db1aa2 = {
    name: 'servicedesk-practice-edit',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("6sU1E", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesEditView", () => $cfee4b7b9daa6dd6$export$5bb02347e0261e6a);
$parcel$export(module.exports, "default", () => $cfee4b7b9daa6dd6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $cfee4b7b9daa6dd6$export$5bb02347e0261e6a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("97KiD"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
/**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */ const $cfee4b7b9daa6dd6$var$AsyncServicedeskQueuesEditView = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cfee4b7b9daa6dd6$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};
var $cfee4b7b9daa6dd6$export$2e2bcd8739ae039 = $cfee4b7b9daa6dd6$var$AsyncServicedeskQueuesEditView;

});
parcelRegister("97KiD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fgjrS").then(()=>parcelRequire('3mMPp'));

});


parcelRegister("5NcGG", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesConfig", () => $6c90f90f2236a9c9$export$8bc01f18d5db1178);
$parcel$export(module.exports, "ServicedeskQueuesConfig", () => $6c90f90f2236a9c9$export$ac10b7696844d33);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $2mHfh = parcelRequire("2mHfh");

const $6c90f90f2236a9c9$export$8bc01f18d5db1178 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cay8J")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $6c90f90f2236a9c9$export$ac10b7696844d33 = (props)=>{
    const { query: query } = props;
    // If URL is from edit queue, then redirect to the new URL with config query param
    if (!query.config) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: {
                pathname: `${props.location.pathname}`,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
                    ...restQuery,
                    config: 'queueConfig'
                })
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $6c90f90f2236a9c9$export$8bc01f18d5db1178,
        pageId: `spa-apps/servicedesk/queues/config/${query.config}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("cay8J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9Z3Uz").then(()=>parcelRequire('8zm0a'));

});


parcelRegister("eOSoz", function(module, exports) {
$parcel$export(module.exports, "serviceDeskQueuesConfigPageEntryPoint", () => $d5f3ccd5f8ac5b8e$export$2a7296eb9b68414);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8WAqO = parcelRequire("8WAqO");
const $d5f3ccd5f8ac5b8e$export$2a7296eb9b68414 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8WAqO.queuesConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("8WAqO", function(module, exports) {
$parcel$export(module.exports, "queuesConfigEntrypoint", () => $e6a30f8a0d69b8d6$export$bc016338e2032123);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $2BUDW = parcelRequire("2BUDW");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $6B4c3 = parcelRequire("6B4c3");

const $e6a30f8a0d69b8d6$export$bc016338e2032123 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>{
        return (parcelRequire("cay8J"));
    }, {
        moduleId: "2bb3c6f1",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        const queueAri = queueId ? (0, $2BUDW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                SettingsContainerContentQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $6B4c3.default),
                    variables: {
                        input: input,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            },
            extraProps: {
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("6B4c3", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9a667a9b9fbc731$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3570d8768a281b3ea8b89ba127bd0b62>>
 * @relayHash 02d4124590c433b0c9de4e4aa3c91197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6ae4e96640fd92369f5f9abdc58c10451a3c13851e720cd775c3f1b446b2651
const $c9a667a9b9fbc731$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SettingsContainerContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.navigationItems.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.navigationItems.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SettingsContainerContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v10 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c6ae4e96640fd92369f5f9abdc58c10451a3c13851e720cd775c3f1b446b2651",
            "metadata": {},
            "name": "SettingsContainerContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9a667a9b9fbc731$var$node.hash = "f661aeee5eaa80513a6a6aee41ee162d";
var $c9a667a9b9fbc731$export$2e2bcd8739ae039 = $c9a667a9b9fbc731$var$node;

});




parcelRegister("e2eAj", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeIssueRouteEntry", () => $9e4b655f1cc669e8$export$ff51f5ad948cb987);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lBzUC = parcelRequire("lBzUC");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $agdZX = parcelRequire("agdZX");
const $9e4b655f1cc669e8$export$ff51f5ad948cb987 = (0, $6xToB.createEntry)((0, $lBzUC.servicedeskPracticeIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $agdZX.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            ...(0, $1PvPk.getIssueViewResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $agdZX.LazyServicedeskQueuesIssueView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeIssueRouteEntry.tsx',
                whichExportToUse: 'servicedeskPracticeIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lBzUC", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeIssueRoute", () => $281b9b0e67e830ce$export$38a6ee0f22e74bf3);
const $281b9b0e67e830ce$export$38a6ee0f22e74bf3 = {
    name: 'servicedesk-practice-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};

});

parcelRegister("agdZX", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesIssueView", () => $836d24b8148d73e9$export$164f2dfdd8dc056b);
$parcel$export(module.exports, "default", () => $836d24b8148d73e9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $836d24b8148d73e9$export$164f2dfdd8dc056b = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("5dM6a")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
/**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ const $836d24b8148d73e9$var$AsyncServicedeskQueuesIssueView = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $836d24b8148d73e9$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};
var $836d24b8148d73e9$export$2e2bcd8739ae039 = $836d24b8148d73e9$var$AsyncServicedeskQueuesIssueView;

});
parcelRegister("5dM6a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("j6pHx")
]).then(()=>parcelRequire('cR5Ec'));

});



parcelRegister("hhVkJ", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeLandingRouteEntry", () => $fcc0b74cb2aae620$export$881d545af6c177f1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $04ZHJ = parcelRequire("04ZHJ");

var $aQoXd = parcelRequire("aQoXd");

var $iY8Cx = parcelRequire("iY8Cx");
const $fcc0b74cb2aae620$export$881d545af6c177f1 = (0, $6xToB.createEntry)((0, $04ZHJ.servicedeskPracticeLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $iY8Cx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iY8Cx.LazyServicedeskQueuesLanding)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeLandingRouteEntry.tsx',
                whichExportToUse: 'servicedeskPracticeLandingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("04ZHJ", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeLandingRoute", () => $1e58439fa4c850cc$export$3c859c71be33b36c);
const $1e58439fa4c850cc$export$3c859c71be33b36c = {
    name: 'servicedesk-practice-landing',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};

});

parcelRegister("iY8Cx", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesLanding", () => $4fe67311b7d50fbd$export$bdf522692228bb6f);
$parcel$export(module.exports, "default", () => $4fe67311b7d50fbd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4fe67311b7d50fbd$export$bdf522692228bb6f = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("h15iC")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
const $4fe67311b7d50fbd$var$AsyncServicedeskQueuesLanding = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4fe67311b7d50fbd$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });
var $4fe67311b7d50fbd$export$2e2bcd8739ae039 = $4fe67311b7d50fbd$var$AsyncServicedeskQueuesLanding;

});
parcelRegister("h15iC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("iIOsE")
]).then(()=>parcelRequire('9SG4h'));

});



parcelRegister("kD0Ge", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeManageViewRouteEntry", () => $5f03f95b3578a6f9$export$4e1b0df2a8fcae78);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $eZFVv = parcelRequire("eZFVv");

var $aQoXd = parcelRequire("aQoXd");

var $9btrJ = parcelRequire("9btrJ");
const $5f03f95b3578a6f9$export$4e1b0df2a8fcae78 = (0, $6xToB.createEntry)((0, $eZFVv.servicedeskPracticeManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9btrJ.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: (0, $1PvPk.getQueuesResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btrJ.LazyServicedeskQueuesManageView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeManageViewRouteEntry.tsx',
                whichExportToUse: 'servicedeskPracticeManageViewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eZFVv", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $d84c7900692414fc$export$125e0ab662806584);
const $d84c7900692414fc$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("9btrJ", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesManageView", () => $e7e908cf8bd7d464$export$9f1e189198f08c4a);
$parcel$export(module.exports, "default", () => $e7e908cf8bd7d464$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $e7e908cf8bd7d464$export$9f1e189198f08c4a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("b40B6"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
const $e7e908cf8bd7d464$var$AsyncServicedeskQueuesManageView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $e7e908cf8bd7d464$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });
var $e7e908cf8bd7d464$export$2e2bcd8739ae039 = $e7e908cf8bd7d464$var$AsyncServicedeskQueuesManageView;

});
parcelRegister("b40B6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bqaEy").then(()=>parcelRequire('eONcC'));

});



parcelRegister("gEBbt", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeNewRouteEntry", () => $32d4fbcd3f9e60a7$export$50a04ec00cb8039);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5SFrC = parcelRequire("5SFrC");

var $aQoXd = parcelRequire("aQoXd");

var $96Gso = parcelRequire("96Gso");
const $32d4fbcd3f9e60a7$export$50a04ec00cb8039 = (0, $6xToB.createEntry)((0, $5SFrC.servicedeskPracticeNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $96Gso.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96Gso.LazyServicedeskQueuesCreateView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeNewRouteEntry.tsx',
                whichExportToUse: 'servicedeskPracticeNewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5SFrC", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeNewRoute", () => $995883df4293705a$export$8595a5452f93a1fd);
const $995883df4293705a$export$8595a5452f93a1fd = {
    name: 'servicedesk-practice-new',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("96Gso", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesCreateView", () => $79eb422bb41dddf8$export$c050b699bf9e3e40);
$parcel$export(module.exports, "default", () => $79eb422bb41dddf8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $79eb422bb41dddf8$export$c050b699bf9e3e40 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lyEJn"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
const $79eb422bb41dddf8$var$AsyncServicedeskQueuesCreateView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $79eb422bb41dddf8$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });
var $79eb422bb41dddf8$export$2e2bcd8739ae039 = $79eb422bb41dddf8$var$AsyncServicedeskQueuesCreateView;

});
parcelRegister("lyEJn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lyGo1").then(()=>parcelRequire('9bkHc'));

});



parcelRegister("2PL7S", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeViewsConfigRouteEntry", () => $96e25e34844225aa$export$101c882abd4d051);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $gmklX = parcelRequire("gmklX");

var $aQoXd = parcelRequire("aQoXd");

var $dZRaT = parcelRequire("dZRaT");

var $4cTDP = parcelRequire("4cTDP");

var $9BJU1 = parcelRequire("9BJU1");

var $f2JN3 = parcelRequire("f2JN3");

var $eOSoz = parcelRequire("eOSoz");

var $igFet = parcelRequire("igFet");
const $96e25e34844225aa$export$101c882abd4d051 = (0, $6xToB.createEntry)((0, $gmklX.servicedeskPracticeViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            ...(0, $1PvPk.getQueueViewConfigResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igFet.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $igFet.ServicedeskQueuesViewsConfig), (0, $9BJU1.default)),
        pageId: ({ query: query, match: match })=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeViewsConfigRouteEntry.tsx',
                whichExportToUse: 'servicedeskPracticeViewsConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gmklX", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeViewsConfigRoute", () => $f8c82471fd191327$export$e8e807e90d20fe7b);
const $f8c82471fd191327$export$e8e807e90d20fe7b = {
    name: 'servicedesk-practice-views-config',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
    query: [
        'config'
    ],
    exact: true
};

});

parcelRegister("igFet", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesViewsConfig", () => $56fc48d919941e1c$export$12b9e920fc614605);
$parcel$export(module.exports, "ServicedeskQueuesViewsConfig", () => $56fc48d919941e1c$export$666845896df029ad);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $56fc48d919941e1c$export$12b9e920fc614605 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("cay8J")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $56fc48d919941e1c$export$666845896df029ad = (props)=>{
    const { query: query } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $56fc48d919941e1c$export$12b9e920fc614605,
        pageId: `spa-apps/servicedesk/queues/views-config/${query.config}`,
        shouldShowSpinner: true
    });
};

});


parcelRegister("4GWTX", function(module, exports) {
$parcel$export(module.exports, "serviceDeskProductsRouteEntry", () => $d396a6d9b42e6816$export$a422b7dc1738c58f);

var $eJOHy = parcelRequire("eJOHy");

var $jwPAS = parcelRequire("jwPAS");

var $kHlOR = parcelRequire("kHlOR");

var $s2Zja = parcelRequire("s2Zja");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $ig3cl = parcelRequire("ig3cl");

var $lKeRV = parcelRequire("lKeRV");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d396a6d9b42e6816$var$LazyServicedeskCustomerServiceProducts = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("l0BI0"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $d396a6d9b42e6816$var$ServicedeskCustomerServiceProducts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d396a6d9b42e6816$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $d396a6d9b42e6816$export$a422b7dc1738c58f = (0, $6xToB.createEntry)((0, $lKeRV.serviceDeskProductsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $s2Zja.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ig3cl.customerServiceProductsQueryResource),
            (0, $jwPAS.csmCustomerContextTenantMigratedStatusResource)
        ],
        component: $d396a6d9b42e6816$var$ServicedeskCustomerServiceProducts,
        perfMetricKey: 'jsm-customer-service-products-component-load',
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $d396a6d9b42e6816$var$LazyServicedeskCustomerServiceProducts
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                teamName: 'boysenberry'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-customer-service-products-entries/src/serviceDeskProductsRouteEntry.tsx',
                whichExportToUse: 'serviceDeskProductsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ig3cl", function(module, exports) {
$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $017f65ea37d42132$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $017f65ea37d42132$export$f9257217f5333b1a);

var $9FYIg = parcelRequire("9FYIg");

var $1fzJt = parcelRequire("1fzJt");
const $017f65ea37d42132$export$9e59a0b3e9d74a99 = 50;
const $017f65ea37d42132$export$f9257217f5333b1a = (0, $9FYIg.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $1fzJt.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $017f65ea37d42132$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("1fzJt", function(module, exports) {
$parcel$export(module.exports, "default", () => $4797f53cdf7e76f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7ef1e614f87710debd541e8302f5d5c>>
 * @relayHash 2f2525f72b335b5d911e7fb1e6f7b2df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6

var $37Ewn = parcelRequire("37Ewn");
const $4797f53cdf7e76f3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProductsAppQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProductsPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProductsAppQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6",
            "metadata": {},
            "name": "ProductsAppQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4797f53cdf7e76f3$var$node.hash = "49ec283be936d856f639396ab852c52d";
(0, $37Ewn.PreloadableQueryRegistry).set($4797f53cdf7e76f3$var$node.params.id, $4797f53cdf7e76f3$var$node);
var $4797f53cdf7e76f3$export$2e2bcd8739ae039 = $4797f53cdf7e76f3$var$node;

});


parcelRegister("lKeRV", function(module, exports) {
$parcel$export(module.exports, "serviceDeskProductsRoute", () => $9a2cc1f1c59190bb$export$bd8225ca9fa6533b);
const $9a2cc1f1c59190bb$export$bd8225ca9fa6533b = {
    name: 'servicedesk-customer-service-products',
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("l0BI0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9D49i").then(()=>parcelRequire('3oVAl'));

});


parcelRegister("agCim", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRouteEntry", () => $b1364b18da2faed3$export$2792607788ca81db);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $d2EHA = parcelRequire("d2EHA");

var $kWsG7 = parcelRequire("kWsG7");
const $b1364b18da2faed3$export$2792607788ca81db = (0, $6xToB.createEntry)((0, $d2EHA.servicedeskProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        component: (0, $kWsG7.default),
        forPaint: [
            (0, $kWsG7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/servicedeskProformaIssueFormsDirectEmbedRouteEntry.tsx',
                whichExportToUse: 'servicedeskProformaIssueFormsDirectEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("d2EHA", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRoute", () => $75653deedab7964d$export$bf24763c9fc04bde);
const $75653deedab7964d$export$bf24763c9fc04bde = {
    name: 'servicedesk-proforma-issue-forms-direct-embed',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("cnG0j", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRouteEntry", () => $f135212708c3e5aa$export$f249c6e19ad4181e);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $gqzIM = parcelRequire("gqzIM");

var $aQoXd = parcelRequire("aQoXd");

var $d017r = parcelRequire("d017r");
const $f135212708c3e5aa$export$f249c6e19ad4181e = (0, $6xToB.createEntry)((0, $gqzIM.servicedeskProformaIssueFormsDirectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $d017r.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/servicedeskProformaIssueFormsDirectRouteEntry.tsx',
                whichExportToUse: 'servicedeskProformaIssueFormsDirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gqzIM", function(module, exports) {
$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRoute", () => $b0562226df2b8eaf$export$9b51b0994bb4b8f0);
const $b0562226df2b8eaf$export$9b51b0994bb4b8f0 = {
    name: 'servicedesk-proforma-issue-forms-direct',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("ghBxE", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectDashboardsEditableRouteEntry", () => $04aa311eec8115f1$export$a74c7ae68710fdc7);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $eyUVe = parcelRequire("eyUVe");

var $aQoXd = parcelRequire("aQoXd");

var $8IGm4 = parcelRequire("8IGm4");
const $04aa311eec8115f1$export$a74c7ae68710fdc7 = (0, $6xToB.createEntry)((0, $eyUVe.servicedeskProjectDashboardsEditableRoute), ()=>({
        group: 'servicedesk',
        component: (0, $8IGm4.ProjectDashboardsEditable),
        perfMetricKey: 'service-management.project-dashboards.dashboard-list',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8IGm4.LazyServicedeskProjectDashboardsEditable)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-project-dashboards-entries/src/servicedeskProjectDashboardsEditableRouteEntry.tsx',
                whichExportToUse: 'servicedeskProjectDashboardsEditableRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eyUVe", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectDashboardsEditableRoute", () => $26359e305ab21ef4$export$e1b9572169ced05e);
const $26359e305ab21ef4$export$e1b9572169ced05e = {
    name: 'servicedesk-avp-project-dashboards-editable',
    path: '/jira/servicedesk/projects/:projectKey/dashboards/:dashboardId'
};

});

parcelRegister("8IGm4", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskProjectDashboardsEditable", () => $dc37e61d2f4c410e$export$cab0bd21e2c67be7);
$parcel$export(module.exports, "ProjectDashboardsEditable", () => $dc37e61d2f4c410e$export$65f0b3d2f1a55263);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $dc37e61d2f4c410e$export$cab0bd21e2c67be7 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cwjFD")).then((module)=>module.DashboardEditableSpaWrapper)), {
    moduleId: "./src/packages/spa-apps/servicedesk/project-dashboards/src/index.tsx"
});
const $dc37e61d2f4c410e$export$65f0b3d2f1a55263 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $dc37e61d2f4c410e$export$cab0bd21e2c67be7,
        pageId: "spa-apps/servicedesk-project-dashboards-editable",
        shouldShowSpinner: true
    });

});
parcelRegister("cwjFD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("2cur5")),
    $ewTvA("fliVL"),
    $ewTvA("9XxSP")
]).then(()=>parcelRequire('cK7eh'));

});



parcelRegister("lMO7Z", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectDashboardsListRouteEntry", () => $d739c4dbd17e2e0f$export$eaf3433859cfed23);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8Q5ov = parcelRequire("8Q5ov");

var $aQoXd = parcelRequire("aQoXd");

var $6ahCL = parcelRequire("6ahCL");
const $d739c4dbd17e2e0f$export$eaf3433859cfed23 = (0, $6xToB.createEntry)((0, $8Q5ov.servicedeskProjectDashboardsListRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6ahCL.ProjectDashboardsList),
        perfMetricKey: 'service-management.project-dashboards.dashboard-list',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6ahCL.LazyServicedeskProjectDashboardsList)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-project-dashboards-entries/src/servicedeskProjectDashboardsListRouteEntry.tsx',
                whichExportToUse: 'servicedeskProjectDashboardsListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8Q5ov", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectDashboardsListRoute", () => $974951619e1c7f4b$export$ff671f43f5c6b309);
const $974951619e1c7f4b$export$ff671f43f5c6b309 = {
    name: 'servicedesk-avp-project-dashboards-list',
    path: '/jira/servicedesk/projects/:projectKey/dashboards'
};

});

parcelRegister("6ahCL", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskProjectDashboardsList", () => $8ade08da966f3277$export$fea8ad531d3abdc3);
$parcel$export(module.exports, "ProjectDashboardsList", () => $8ade08da966f3277$export$86ab4708fa0d87fa);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8ade08da966f3277$export$fea8ad531d3abdc3 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cwjFD")).then((module)=>module.DashboardList)), {
    moduleId: "./src/packages/spa-apps/servicedesk/project-dashboards/src/index.tsx"
});
const $8ade08da966f3277$export$86ab4708fa0d87fa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8ade08da966f3277$export$fea8ad531d3abdc3,
        pageId: "spa-apps/servicedesk-project-dashboards-list",
        shouldShowSpinner: true
    });

});


parcelRegister("fvFxE", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectSummaryRouteEntry", () => $87b5fdcb96a6d790$export$a24d68fcf82b16bb);

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2fpoV = parcelRequire("2fpoV");

var $aQoXd = parcelRequire("aQoXd");

var $5L7qx = parcelRequire("5L7qx");

var $gy2Qg = parcelRequire("gy2Qg");

var $lx2dR = parcelRequire("lx2dR");

var $eMyNf = parcelRequire("eMyNf");

var $fJ5dc = parcelRequire("fJ5dc");
const $87b5fdcb96a6d790$export$a24d68fcf82b16bb = (0, $6xToB.createEntry)((0, $2fpoV.servicedeskProjectSummaryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.project-summary',
        component: ()=>null,
        skeleton: (0, $lx2dR.ProjectSummarySkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('jsm_project_summary_avp'), (0, $eMyNf.getProjectSummaryFilterFieldsResource)())
        ],
        entryPoint: ()=>(0, $fJ5dc.projectSummaryPageEntryPoint),
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-project-summary-entries/src/servicedeskProjectSummaryRouteEntry.tsx',
                whichExportToUse: 'servicedeskProjectSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2fpoV", function(module, exports) {
$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $ce3486d6069a4f97$export$a23b752ff24027ae);
const $ce3486d6069a4f97$export$a23b752ff24027ae = {
    path: '/jira/servicedesk/projects/:projectKey/summary',
    name: 'servicedesk-project-summary'
};

});

parcelRegister("lx2dR", function(module, exports) {
$parcel$export(module.exports, "ProjectSummarySkeleton", () => $3b30c9ad0a7ce8c7$export$93a223cf4712c63d);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $fHkZt = parcelRequire("fHkZt");
const $3b30c9ad0a7ce8c7$export$93a223cf4712c63d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fHkZt)))
    });

});
parcelRegister("fHkZt", function(module, exports) {
module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();

});


parcelRegister("eMyNf", function(module, exports) {
$parcel$export(module.exports, "getProjectSummaryFilterFieldsResource", () => $28929482cb0982b0$export$efafab65f8d3c3b6);
$parcel$export(module.exports, "useGetProjectSummaryFilterFields", () => $28929482cb0982b0$export$e6baafb2e3d74187);
$parcel$export(module.exports, "useRequestTypeJqlTerm", () => $28929482cb0982b0$export$1bb1552d41afd41f);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $dMM78 = parcelRequire("dMM78");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $28929482cb0982b0$var$RESOURCE_NAME = 'projectSummaryFilterFieldResource';
const $28929482cb0982b0$export$6f0555de4f60e84e = 'RESOURCE_TYPE_JSM_PROJECT_SUMMARY_FILTERS';
const $28929482cb0982b0$var$REQUEST_TYPE_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';
const $28929482cb0982b0$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $28929482cb0982b0$var$createdField = {
    displayName: 'Created',
    fieldType: 'created',
    jqlTerm: 'created',
    operators: [
        'LESS_THAN_OR_EQUAL',
        'GREATER_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'LESS_THAN',
        'GREATER_THAN',
        'EQUALS',
        'IS',
        'IN',
        'NOT_EQUALS'
    ],
    searchTemplate: 'created',
    type: 'created'
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $28929482cb0982b0$var$priorityField = {
    displayName: 'Priority',
    fieldType: 'priority',
    jqlTerm: 'priority',
    operators: [
        'GREATER_THAN_OR_EQUAL',
        'LESS_THAN',
        'GREATER_THAN',
        'WAS_NOT',
        'IS',
        'IN',
        'CHANGED',
        'LESS_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'WAS_NOT_IN',
        'EQUALS',
        'WAS_IN',
        'WAS',
        'NOT_EQUALS'
    ],
    searchTemplate: 'priority',
    type: 'priority'
};
const $28929482cb0982b0$var$reportError = ({ error: error, id: id })=>(0, $9pTd3.fireErrorAnalytics)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: id ? `${$28929482cb0982b0$var$RESOURCE_NAME}.${id}` : $28929482cb0982b0$var$RESOURCE_NAME,
            packageName: (0, $0bd75f18b7489379$export$b8b9d90f9e5bd72b),
            teamName: (0, $0bd75f18b7489379$export$d57b6b390e78d90f)
        }
    });
const $28929482cb0982b0$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $42f9b927391b9e5b$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: {
                        jqlTerms: [
                            (0, $0bd75f18b7489379$export$2c388650eabddf5e),
                            (0, $0bd75f18b7489379$export$2fcf90614ee15858),
                            (0, $0bd75f18b7489379$export$43482ff574598f59)
                        ]
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        const tryGetField = ({ data: data, type: type, searchTemplate: searchTemplate, displayName: displayName })=>{
            const edges = data?.jira?.jqlBuilder?.fields?.edges;
            const field = edges?.find((edge)=>edge?.node?.type === type && edge?.node?.searchTemplate?.key === searchTemplate)?.node;
            return field ? {
                ...field,
                searchTemplate: field.searchTemplate.key,
                fieldType: field.type,
                displayName: displayName ?? field.displayName
            } : undefined;
        };
        return {
            requestTypeField: tryGetField({
                data: response.data,
                type: $28929482cb0982b0$var$REQUEST_TYPE_FILTER_TYPE,
                searchTemplate: $28929482cb0982b0$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE
            })
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) $28929482cb0982b0$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $28929482cb0982b0$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $42f9b927391b9e5b$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return {
            requestTypeField: undefined
        };
        return {
            requestTypeField: {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate?.key,
                fieldType: requestTypeField.type,
                displayName: requestTypeField.displayName
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $dMM78.isHttpClientErrorResponse)(error)) $28929482cb0982b0$var$reportError({
            error: error,
            id: 'fetchFields'
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $28929482cb0982b0$var$getProjectKeyOrId = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $28929482cb0982b0$var$filterFieldsResource = (0, $l1VxS.createResource)({
    type: $28929482cb0982b0$export$6f0555de4f60e84e,
    getKey: ({ match: match, query: query })=>$28929482cb0982b0$export$6f0555de4f60e84e + $28929482cb0982b0$var$getProjectKeyOrId(match, query),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const jqlContext = `project = '${$28929482cb0982b0$var$getProjectKeyOrId(match, query)}'`;
        return (0, $4cTDP.fg)('move_jsm_views_rt_filter_to_new_query') ? $28929482cb0982b0$var$fetchFilterFields(cloudId) : $28929482cb0982b0$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $28929482cb0982b0$export$efafab65f8d3c3b6 = ()=>$28929482cb0982b0$var$filterFieldsResource;
const $28929482cb0982b0$export$e6baafb2e3d74187 = ()=>{
    const { data: filterResource } = (0, $eJrcF.useResource)($28929482cb0982b0$var$filterFieldsResource);
    const useFilterFields = (0, $eJOHy.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                {
                    ...$28929482cb0982b0$var$priorityField,
                    ...priorityDisplayName && {
                        displayName: priorityDisplayName
                    }
                },
                {
                    ...$28929482cb0982b0$var$createdField,
                    ...createdDisplayName && {
                        displayName: createdDisplayName
                    }
                }
            ];
        }, [
        filterResource
    ]);
    return useFilterFields;
};
const $28929482cb0982b0$export$1bb1552d41afd41f = ({ jqlTerm: jqlTerm })=>{
    const { data: filterResource, loading: loading } = (0, $eJrcF.useResource)($28929482cb0982b0$var$filterFieldsResource);
    const term = jqlTerm ?? filterResource?.requestTypeField?.jqlTerm;
    const hasError = !loading && !term;
    (0, $eJOHy.useEffect)(()=>{
        if (hasError) $28929482cb0982b0$var$reportError({
            error: new Error('Error while getting request type jql term.'),
            id: 'rtJqlTerm'
        });
    }, [
        hasError
    ]);
    return term;
};

});
const $0bd75f18b7489379$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskProjectSummary';
const $0bd75f18b7489379$export$d57b6b390e78d90f = 'jsd-shield';
const $0bd75f18b7489379$export$2c388650eabddf5e = 'request type';
const $0bd75f18b7489379$export$2fcf90614ee15858 = 'service desk origin';
const $0bd75f18b7489379$export$43482ff574598f59 = 'cf[10010]';

const $42f9b927391b9e5b$export$546e90157aa718d4 = `
query findFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $42f9b927391b9e5b$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;


parcelRegister("fJ5dc", function(module, exports) {
$parcel$export(module.exports, "projectSummaryPageEntryPoint", () => $46870e29bf457de0$export$ae7c241893e7dab9);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $11R8p = parcelRequire("11R8p");
const $46870e29bf457de0$export$ae7c241893e7dab9 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $11R8p.projectSummaryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("11R8p", function(module, exports) {
$parcel$export(module.exports, "projectSummaryEntryPoint", () => $9bca175a61886899$export$95a2fe4e495efca5);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $9bca175a61886899$export$95a2fe4e495efca5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4xYI4")), {
        moduleId: "ac794fd1",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4xYI4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("7vOfv")),
    $ewTvA("fliVL"),
    $ewTvA("e5hMu")
]).then(()=>parcelRequire('hSsJp'));

});




parcelRegister("dut0s", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesAddonRouteEntry", () => $3e9b2605dd3ac19b$export$23a16f20b48235b3);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $ldq55 = parcelRequire("ldq55");

var $aQoXd = parcelRequire("aQoXd");

var $8VBYs = parcelRequire("8VBYs");
const $3e9b2605dd3ac19b$export$23a16f20b48235b3 = (0, $6xToB.createEntry)((0, $ldq55.servicedeskQueuesAddonRoute), ()=>({
        group: 'servicedesk',
        component: (0, $8VBYs.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8VBYs.LazyServicedeskQueuesAddonView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesAddonRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesAddonRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ldq55", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesAddonRoute", () => $6f4fd92a4be5db43$export$1465f05b88a63f13);
const $6f4fd92a4be5db43$export$1465f05b88a63f13 = {
    name: 'servicedesk-queues-addon',
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};

});

parcelRegister("8VBYs", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskQueuesAddonView", () => $8d94c4424336b5f0$export$451a7cce84b6b1e6);
$parcel$export(module.exports, "default", () => $8d94c4424336b5f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8d94c4424336b5f0$export$451a7cce84b6b1e6 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dmVQ4")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
const $8d94c4424336b5f0$var$AsyncServicedeskQueuesAddonView = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8d94c4424336b5f0$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};
var $8d94c4424336b5f0$export$2e2bcd8739ae039 = $8d94c4424336b5f0$var$AsyncServicedeskQueuesAddonView;

});
parcelRegister("dmVQ4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("XVtLY").then(()=>parcelRequire('gl9mP'));

});



parcelRegister("jUCVx", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesEditRouteEntry", () => $a74f7bf5770ccdab$export$ae7b71ac953d95bf);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $2sgSn = parcelRequire("2sgSn");

var $aQoXd = parcelRequire("aQoXd");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $6sU1E = parcelRequire("6sU1E");

var $5NcGG = parcelRequire("5NcGG");

var $eOSoz = parcelRequire("eOSoz");
const $a74f7bf5770ccdab$export$ae7b71ac953d95bf = (0, $6xToB.createEntry)((0, $2sgSn.servicedeskQueuesEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $5NcGG.ServicedeskQueuesConfig), (0, $6sU1E.default)),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getIssueListSsrResource)(),
            ...(0, $1PvPk.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $5NcGG.LazyServicedeskQueuesConfig) : (0, $6sU1E.LazyServicedeskQueuesEditView)
        ],
        ufoName: 'service-management.queues.edit',
        pageId: ({ query: query, match: match })=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesEditRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2sgSn", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesEditRoute", () => $1ed2945b87561a61$export$f8fd3a1f8c33aff8);
const $1ed2945b87561a61$export$f8fd3a1f8c33aff8 = {
    name: 'servicedesk-queues-edit',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});


parcelRegister("fBXou", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesIssueRouteEntry", () => $91c504e19cabc48a$export$2e4931acac9270fc);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4AdSe = parcelRequire("4AdSe");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $agdZX = parcelRequire("agdZX");
const $91c504e19cabc48a$export$2e4931acac9270fc = (0, $6xToB.createEntry)((0, $4AdSe.servicedeskQueuesIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $agdZX.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            ...(0, $1PvPk.getKnowledgeBaseResources)(),
            ...(0, $1PvPk.getInsightResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)(),
            ...(0, $1PvPk.getIssueViewResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $agdZX.LazyServicedeskQueuesIssueView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesIssueRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4AdSe", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesIssueRoute", () => $4d6f79fa426e9eb4$export$52a24b9cf42d208b);
const $4d6f79fa426e9eb4$export$52a24b9cf42d208b = {
    name: 'servicedesk-queues-issue',
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("28WgX", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesLandingRouteEntry", () => $48defd3eae31c60a$export$4242a81237c45c7d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $dLY60 = parcelRequire("dLY60");

var $aQoXd = parcelRequire("aQoXd");

var $iY8Cx = parcelRequire("iY8Cx");
const $48defd3eae31c60a$export$4242a81237c45c7d = (0, $6xToB.createEntry)((0, $dLY60.servicedeskQueuesLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $iY8Cx.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iY8Cx.LazyServicedeskQueuesLanding)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesLandingRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesLandingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dLY60", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesLandingRoute", () => $9ec641c326b4c107$export$52b4c044e4929ebc);
const $9ec641c326b4c107$export$52b4c044e4929ebc = {
    name: 'servicedesk-queues-landing',
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});


parcelRegister("ekqRf", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesManageViewRouteEntry", () => $f051a68b43a3d3d6$export$7e9e2984a94a07b0);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $1tbYm = parcelRequire("1tbYm");

var $aQoXd = parcelRequire("aQoXd");

var $9btrJ = parcelRequire("9btrJ");
const $f051a68b43a3d3d6$export$7e9e2984a94a07b0 = (0, $6xToB.createEntry)((0, $1tbYm.servicedeskQueuesManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $9btrJ.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: (0, $1PvPk.getQueuesResources)(),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9btrJ.LazyServicedeskQueuesManageView)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesManageViewRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesManageViewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1tbYm", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $8dcc08deb10df733$export$7f30d40b906894c5);
const $8dcc08deb10df733$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});


parcelRegister("fPxUZ", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesNewRouteEntry", () => $5d91902509562084$export$9f7cc3294b3141b1);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $l3Qgv = parcelRequire("l3Qgv");

var $aQoXd = parcelRequire("aQoXd");

var $96Gso = parcelRequire("96Gso");
const $5d91902509562084$export$9f7cc3294b3141b1 = (0, $6xToB.createEntry)((0, $l3Qgv.servicedeskQueuesNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $96Gso.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96Gso.LazyServicedeskQueuesCreateView)
        ],
        ufoName: 'service-management.queues.new',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesNewRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesNewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("l3Qgv", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesNewRoute", () => $c1aa695ea886f7a2$export$c1908994722d1e73);
const $c1aa695ea886f7a2$export$c1908994722d1e73 = {
    name: 'servicedesk-queues-new',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("gqwG0", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesViewsConfigRouteEntry", () => $0849a57e91a980b7$export$a5000d326f347afb);

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8eSoC = parcelRequire("8eSoC");

var $aQoXd = parcelRequire("aQoXd");

var $dZRaT = parcelRequire("dZRaT");

var $4cTDP = parcelRequire("4cTDP");

var $9BJU1 = parcelRequire("9BJU1");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $fbgOh = parcelRequire("fbgOh");

var $eOSoz = parcelRequire("eOSoz");

var $igFet = parcelRequire("igFet");
const $0849a57e91a980b7$export$a5000d326f347afb = (0, $6xToB.createEntry)((0, $8eSoC.servicedeskQueuesViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getQueuesResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            ...(0, $1PvPk.getQueueViewConfigResource)(),
            (0, $fbgOh.getEditModelResource)(),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $igFet.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag'), (0, $igFet.ServicedeskQueuesViewsConfig), (0, $9BJU1.default)),
        pageId: ({ query: query, match: match })=>(0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4cTDP.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $eOSoz.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskQueuesViewsConfigRouteEntry.tsx',
                whichExportToUse: 'servicedeskQueuesViewsConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8eSoC", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesViewsConfigRoute", () => $53cc1a88c632276b$export$eea17b09d67a7980);
const $53cc1a88c632276b$export$eea17b09d67a7980 = {
    name: 'servicedesk-queues-views-config',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
    query: [
        'config?'
    ],
    exact: true
};

});


parcelRegister("8CLhe", function(module, exports) {
$parcel$export(module.exports, "servicedeskReports1RouteEntry", () => $551f6c55cc81b799$export$8055c8b2162cf5bd);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $6zXPf = parcelRequire("6zXPf");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $13axY = parcelRequire("13axY");

var $aQoXd = parcelRequire("aQoXd");

var $2mHfh = parcelRequire("2mHfh");


var $7G9Jw = parcelRequire("7G9Jw");

var $hv2KL = parcelRequire("hv2KL");
const $551f6c55cc81b799$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $f57740b93b9bf8e8$export$ddc580d759168f88)}`
    });
const $551f6c55cc81b799$export$8055c8b2162cf5bd = (0, $6xToB.createEntry)((0, $13axY.servicedeskReports1Route), ()=>({
        group: 'servicedesk',
        component: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hv2KL.default), $551f6c55cc81b799$var$DefaultReportsRedirect),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $7G9Jw.getReportsWithKbResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $hv2KL.LazyServicedeskReportsHomePage)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReports1RouteEntry.tsx',
                whichExportToUse: 'servicedeskReports1RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("13axY", function(module, exports) {
$parcel$export(module.exports, "servicedeskReports1Route", () => $4269b3d8c3a8ca1f$export$f5adfd681a4e85ad);
const $4269b3d8c3a8ca1f$export$f5adfd681a4e85ad = {
    name: 'servicedesk-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports',
    exact: true
};

});

const $f57740b93b9bf8e8$export$e4c007d05145b8c2 = '/reports/all-rating';
const $f57740b93b9bf8e8$export$ddc580d759168f88 = '/reports/workload';
const $f57740b93b9bf8e8$export$13bdc187fca9c33e = '/reports';

parcelRegister("7G9Jw", function(module, exports) {
$parcel$export(module.exports, "getReportsWithKbResources", () => $1674ce2fc5697ee1$export$1a63e9cdf8268e40);

var $85Ze9 = parcelRequire("85Ze9");

var $1PvPk = parcelRequire("1PvPk");
const $1674ce2fc5697ee1$export$1a63e9cdf8268e40 = ()=>[
        ...(0, $1PvPk.getServicedeskPageContextResources)(),
        (0, $85Ze9.kbConfluenceContextResource)
    ];

});

parcelRegister("hv2KL", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsHomePage", () => $8c18fd454e6d69a2$export$121b9cfb2b001a53);
$parcel$export(module.exports, "default", () => $8c18fd454e6d69a2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");


const $8c18fd454e6d69a2$export$121b9cfb2b001a53 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eoskY"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
});
const $8c18fd454e6d69a2$var$AsyncServicedeskReportsHomePage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8c18fd454e6d69a2$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $f57740b93b9bf8e8$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });
var $8c18fd454e6d69a2$export$2e2bcd8739ae039 = $8c18fd454e6d69a2$var$AsyncServicedeskReportsHomePage;

});
parcelRegister("eoskY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ei6X4").then(()=>parcelRequire('iAmkR'));

});



parcelRegister("d3dv3", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustom4RouteEntry", () => $e0cdfbcd0097506f$export$5ef62fad7280cd08);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $5xu11 = parcelRequire("5xu11");

var $aQoXd = parcelRequire("aQoXd");

var $ZPF1t = parcelRequire("ZPF1t");
const $e0cdfbcd0097506f$export$5ef62fad7280cd08 = (0, $6xToB.createEntry)((0, $5xu11.servicedeskReportsCustom4Route), ()=>({
        group: 'servicedesk',
        component: (0, $ZPF1t.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ZPF1t.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsCustom4RouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsCustom4RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5xu11", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $1e925efc5e5b93c3$export$39325072940fb58c);
const $1e925efc5e5b93c3$export$39325072940fb58c = {
    name: 'servicedesk-reports-custom',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId'
};

});

parcelRegister("ZPF1t", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsCustom", () => $03e63ef9506cc9fb$export$3ec5c3d7729889b9);
$parcel$export(module.exports, "default", () => $03e63ef9506cc9fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $03e63ef9506cc9fb$export$3ec5c3d7729889b9 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lSgM3"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
const $03e63ef9506cc9fb$var$AsyncServicedeskReportsCustom = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $03e63ef9506cc9fb$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};
var $03e63ef9506cc9fb$export$2e2bcd8739ae039 = $03e63ef9506cc9fb$var$AsyncServicedeskReportsCustom;

});
parcelRegister("lSgM3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("7vJ1d")
]).then(()=>parcelRequire('fcyuR'));

});



parcelRegister("izixQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomCreateRouteEntry", () => $d6b028ada9d65ba8$export$b806d1abc9172b6d);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3hVFo = parcelRequire("3hVFo");

var $aQoXd = parcelRequire("aQoXd");

var $61hEw = parcelRequire("61hEw");
const $d6b028ada9d65ba8$export$b806d1abc9172b6d = (0, $6xToB.createEntry)((0, $3hVFo.servicedeskReportsCustomCreateRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $61hEw.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $61hEw.LazyServicedeskReportsCustomCreate)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsCustomCreateRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsCustomCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3hVFo", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $76bb61216459ac82$export$333e623d5eb41af0);
const $76bb61216459ac82$export$333e623d5eb41af0 = {
    name: 'servicedesk-reports-custom-create',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/new'
};

});

parcelRegister("61hEw", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", () => $2084475c9f57a500$export$821b8201b24f8b7d);
$parcel$export(module.exports, "default", () => $2084475c9f57a500$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $2084475c9f57a500$export$821b8201b24f8b7d = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ioa4X"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
const $2084475c9f57a500$var$AsyncServicedeskReportsCustomCreate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2084475c9f57a500$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });
var $2084475c9f57a500$export$2e2bcd8739ae039 = $2084475c9f57a500$var$AsyncServicedeskReportsCustomCreate;

});
parcelRegister("ioa4X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gu7Yq").then(()=>parcelRequire('85UpT'));

});



parcelRegister("gZq43", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomEditRouteEntry", () => $10f23d5e001aa6e0$export$c4c3dcf824e7036e);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $aGjJ2 = parcelRequire("aGjJ2");

var $aQoXd = parcelRequire("aQoXd");

var $9nZlY = parcelRequire("9nZlY");
const $10f23d5e001aa6e0$export$c4c3dcf824e7036e = (0, $6xToB.createEntry)((0, $aGjJ2.servicedeskReportsCustomEditRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $9nZlY.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9nZlY.LazyServicedeskReportsCustomEdit)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsCustomEditRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsCustomEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aGjJ2", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $06d5e4805a57e63d$export$3b6b3105a9ef9b83);
const $06d5e4805a57e63d$export$3b6b3105a9ef9b83 = {
    name: 'servicedesk-reports-custom-edit',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit'
};

});

parcelRegister("9nZlY", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", () => $439c03f9484ddcec$export$53def03ace9a6c5b);
$parcel$export(module.exports, "default", () => $439c03f9484ddcec$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $439c03f9484ddcec$export$53def03ace9a6c5b = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kP9Rp"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
const $439c03f9484ddcec$var$AsyncServicedeskReportsCustomEdit = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $439c03f9484ddcec$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};
var $439c03f9484ddcec$export$2e2bcd8739ae039 = $439c03f9484ddcec$var$AsyncServicedeskReportsCustomEdit;

});
parcelRegister("kP9Rp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dstJL").then(()=>parcelRequire('blaFr'));

});



parcelRegister("9uidf", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomIssueRouteEntry", () => $69fe67613c59ffae$export$222c6398b69dbc6d);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $rKG3R = parcelRequire("rKG3R");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $dsXZq = parcelRequire("dsXZq");
const $69fe67613c59ffae$export$222c6398b69dbc6d = (0, $6xToB.createEntry)((0, $rKG3R.servicedeskReportsCustomIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dsXZq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dsXZq.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsCustomIssueRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsCustomIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("rKG3R", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $092cd251c5406435$export$1cfe539c854438e8);
const $092cd251c5406435$export$1cfe539c854438e8 = {
    name: 'servicedesk-reports-custom-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("lHdES", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRouteEntry", () => $d275633bf5b9223f$export$508d5e1a59322a54);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $lyDxh = parcelRequire("lyDxh");

var $aQoXd = parcelRequire("aQoXd");

var $ZPF1t = parcelRequire("ZPF1t");
const $d275633bf5b9223f$export$508d5e1a59322a54 = (0, $6xToB.createEntry)((0, $lyDxh.servicedeskReportsCustomTimeScaleRoute), ()=>({
        group: 'servicedesk',
        component: (0, $ZPF1t.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ZPF1t.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsCustomTimeScaleRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsCustomTimeScaleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lyDxh", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $bbe48c9bada8af71$export$eae9a65fe3f035ef);
const $bbe48c9bada8af71$export$eae9a65fe3f035ef = {
    name: 'servicedesk-reports-custom-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId'
};

});


parcelRegister("8gAuW", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfaction2RouteEntry", () => $7de484313564e1e2$export$d6fb66bfd4a40ef);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $7NlI4 = parcelRequire("7NlI4");

var $aQoXd = parcelRequire("aQoXd");

var $b2D0H = parcelRequire("b2D0H");
const $7de484313564e1e2$export$d6fb66bfd4a40ef = (0, $6xToB.createEntry)((0, $7NlI4.servicedeskReportsSatisfaction2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $b2D0H.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b2D0H.LazyServicedeskReportsSatisfaction)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsSatisfaction2RouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsSatisfaction2RouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7NlI4", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $de33d10e8b2cbc09$export$22fd25b495033fdf);
const $de33d10e8b2cbc09$export$22fd25b495033fdf = {
    name: 'servicedesk-reports-satisfaction',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating'
};

});

parcelRegister("b2D0H", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", () => $cc61ac2d1c6d5141$export$8edc7b9d922cd22f);
$parcel$export(module.exports, "default", () => $cc61ac2d1c6d5141$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");


const $cc61ac2d1c6d5141$export$8edc7b9d922cd22f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("h1fpw"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
const $cc61ac2d1c6d5141$var$AsyncServicedeskReportsSatisfaction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cc61ac2d1c6d5141$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $f57740b93b9bf8e8$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });
var $cc61ac2d1c6d5141$export$2e2bcd8739ae039 = $cc61ac2d1c6d5141$var$AsyncServicedeskReportsSatisfaction;

});
parcelRegister("h1fpw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("83hRt")
]).then(()=>parcelRequire('kSbNs'));

});



parcelRegister("jgRv0", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRouteEntry", () => $fd016a0d038c0b93$export$6b98300c0f2ab048);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $bC1pm = parcelRequire("bC1pm");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $dsXZq = parcelRequire("dsXZq");
const $fd016a0d038c0b93$export$6b98300c0f2ab048 = (0, $6xToB.createEntry)((0, $bC1pm.servicedeskReportsSatisfactionIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dsXZq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dsXZq.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsSatisfactionIssueRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsSatisfactionIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bC1pm", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $60c5c0ccf4ee7e43$export$da606765550c7e7);
const $60c5c0ccf4ee7e43$export$da606765550c7e7 = {
    name: 'servicedesk-reports-satisfaction-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("iBcSa", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRouteEntry", () => $af9cac09f3adfb4b$export$8d7026b8c74a8be8);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $a70DC = parcelRequire("a70DC");

var $aQoXd = parcelRequire("aQoXd");

var $b2D0H = parcelRequire("b2D0H");
const $af9cac09f3adfb4b$export$8d7026b8c74a8be8 = (0, $6xToB.createEntry)((0, $a70DC.servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $b2D0H.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b2D0H.LazyServicedeskReportsSatisfaction)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsSatisfactionTimeScaleRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsSatisfactionTimeScaleRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("a70DC", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $48815a74eb4d4417$export$64ae70b2d6b34c4e);
const $48815a74eb4d4417$export$64ae70b2d6b34c4e = {
    name: 'servicedesk-reports-satisfaction-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId'
};

});


parcelRegister("bJiYi", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsTypeRouteEntry", () => $0f1490c3cc3f6edf$export$bc47b2df6d39fd3f);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $ieQb1 = parcelRequire("ieQb1");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4kpMv = parcelRequire("4kpMv");

var $aQoXd = parcelRequire("aQoXd");

var $5nfTh = parcelRequire("5nfTh");

var $7G9Jw = parcelRequire("7G9Jw");

var $a2QDq = parcelRequire("a2QDq");
const $0f1490c3cc3f6edf$export$bc47b2df6d39fd3f = (0, $6xToB.createEntry)((0, $4kpMv.servicedeskReportsTypeRoute), ()=>({
        group: 'servicedesk',
        component: (0, $a2QDq.default),
        layout: (0, $6dwgv.composeLayouts)((0, $aQoXd.serviceProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $7G9Jw.getReportsWithKbResources)(),
            (0, $ieQb1.newIssueViewLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...(0, $5nfTh.getAIContextPanelResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $a2QDq.LazyServicedeskReports)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsTypeRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsTypeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4kpMv", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $8bd962dfa1123299$export$b955ac7f09c5dbb);
const $8bd962dfa1123299$export$b955ac7f09c5dbb = {
    name: 'servicedesk-reports-type',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?',
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("a2QDq", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReports", () => $be7c5421343376b1$export$75e043cf7a4e3661);
$parcel$export(module.exports, "default", () => $be7c5421343376b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $be7c5421343376b1$export$75e043cf7a4e3661 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gWXtf")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
/**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ const $be7c5421343376b1$var$AsyncServicedeskReports = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $be7c5421343376b1$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};
var $be7c5421343376b1$export$2e2bcd8739ae039 = $be7c5421343376b1$var$AsyncServicedeskReports;

});
parcelRegister("gWXtf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("qMTFl").then(()=>parcelRequire('jgLAY'));

});



parcelRegister("9NWq7", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsWorkloadRouteEntry", () => $25d788556d086de5$export$793ba749f18b4dd4);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8vMpR = parcelRequire("8vMpR");

var $aQoXd = parcelRequire("aQoXd");

var $6VsbM = parcelRequire("6VsbM");
const $25d788556d086de5$export$793ba749f18b4dd4 = (0, $6xToB.createEntry)((0, $8vMpR.servicedeskReportsWorkloadRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6VsbM.default),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6VsbM.LazyServicedeskReportsWorkload)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsWorkloadRouteEntry.tsx',
                whichExportToUse: 'servicedeskReportsWorkloadRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8vMpR", function(module, exports) {
$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $ad733e0550e439cb$export$ce9b409ccf53e93c);
const $ad733e0550e439cb$export$ce9b409ccf53e93c = {
    name: 'servicedesk-reports-workload',
    path: '/jira/servicedesk/projects/:projectKey/reports/workload',
    exact: true
};

});

parcelRegister("6VsbM", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskReportsWorkload", () => $544e9b94745fff6c$export$e805fb47fdcd991);
$parcel$export(module.exports, "default", () => $544e9b94745fff6c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");


const $544e9b94745fff6c$export$e805fb47fdcd991 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lT7fe"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
const $544e9b94745fff6c$var$AsyncServicedeskReportsWorkload = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $544e9b94745fff6c$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $f57740b93b9bf8e8$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });
var $544e9b94745fff6c$export$2e2bcd8739ae039 = $544e9b94745fff6c$var$AsyncServicedeskReportsWorkload;

});
parcelRegister("lT7fe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("7t4XR")
]).then(()=>parcelRequire('mEhhU'));

});



parcelRegister("hnYNr", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceDetailsRouteEntry", () => $00afac8ec962371b$export$48af7c0b8f21929b);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $79Ghk = parcelRequire("79Ghk");

var $aQoXd = parcelRequire("aQoXd");

var $5gvIY = parcelRequire("5gvIY");
const $00afac8ec962371b$export$48af7c0b8f21929b = (0, $6xToB.createEntry)((0, $79Ghk.servicedeskServiceDetailsRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details',
        component: (0, $5gvIY.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $5gvIY.LazyServicedeskServiceDetailsWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-services-entries/src/servicedeskServiceDetailsRouteEntry.tsx',
                whichExportToUse: 'servicedeskServiceDetailsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("79Ghk", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $15d8d61b27289c0f$export$fe5fe00b6d5eab87);
const $15d8d61b27289c0f$export$fe5fe00b6d5eab87 = {
    name: 'servicedesk-service-details',
    path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri'
};

});

parcelRegister("5gvIY", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", () => $ea17f08be7017d11$export$b154597f29589502);
$parcel$export(module.exports, "default", () => $ea17f08be7017d11$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ea17f08be7017d11$export$b154597f29589502 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8rAHX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
const $ea17f08be7017d11$var$AsyncServicedeskServiceDetailsWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ea17f08be7017d11$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });
var $ea17f08be7017d11$export$2e2bcd8739ae039 = $ea17f08be7017d11$var$AsyncServicedeskServiceDetailsWithProjectContext;

});
parcelRegister("8rAHX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("9BfG7")
]).then(()=>parcelRequire('9AdN4'));

});



parcelRegister("gSlgn", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRouteEntry", () => $a94d0bbd44e10c80$export$de2e645f69483ce);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $5AOEW = parcelRequire("5AOEW");

var $fSkHJ = parcelRequire("fSkHJ");
const $a94d0bbd44e10c80$export$de2e645f69483ce = (0, $6xToB.createEntry)((0, $5AOEW.serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details-without-project',
        component: (0, $fSkHJ.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $fSkHJ.LazyServicedeskServiceDetailsWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-service-details-without-project',
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-services-entries/src/serviceDeskServiceDetailsWithoutProjectRouteEntry.tsx',
                whichExportToUse: 'serviceDeskServiceDetailsWithoutProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5AOEW", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $8a43f77fceee2a10$export$25e1d58db18a7c8b);
const $8a43f77fceee2a10$export$25e1d58db18a7c8b = {
    name: 'servicedesk-service-details-without-project',
    path: '/jira/servicedesk/services/:serviceAri'
};

});

parcelRegister("fSkHJ", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", () => $d15ce4ba34a89a13$export$ba1931edde0ce20c);
$parcel$export(module.exports, "default", () => $d15ce4ba34a89a13$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $d15ce4ba34a89a13$export$ba1931edde0ce20c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("h3wTk"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
const $d15ce4ba34a89a13$var$AsyncServicedeskServiceDetailsWithoutProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $d15ce4ba34a89a13$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });
var $d15ce4ba34a89a13$export$2e2bcd8739ae039 = $d15ce4ba34a89a13$var$AsyncServicedeskServiceDetailsWithoutProjectContext;

});
parcelRegister("h3wTk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("f8c8f")
]).then(()=>parcelRequire('aABDg'));

});



parcelRegister("cENRX", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalEditRouteEntry", () => $b607b283991c2282$export$5698449b623d4af);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $dZqwQ = parcelRequire("dZqwQ");

var $aQoXd = parcelRequire("aQoXd");

var $1ILcj = parcelRequire("1ILcj");
const $b607b283991c2282$export$5698449b623d4af = (0, $6xToB.createEntry)((0, $dZqwQ.servicedeskServiceModalEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1ILcj.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $1ILcj.LazyServiceUpdateModalWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-services-entries/src/servicedeskServiceModalEditRouteEntry.tsx',
                whichExportToUse: 'servicedeskServiceModalEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dZqwQ", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $14c2f2afdcb283d2$export$319fbbab5eb49cbf);
const $14c2f2afdcb283d2$export$319fbbab5eb49cbf = {
    name: 'servicedesk-service-modal-edit',
    path: '/jira/servicedesk/service-modal/:serviceAri'
};

});

parcelRegister("1ILcj", function(module, exports) {
$parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", () => $b2db2b8efacb9515$export$8984aadca7e15d1);
$parcel$export(module.exports, "default", () => $b2db2b8efacb9515$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $b2db2b8efacb9515$export$8984aadca7e15d1 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7PnXf")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
const $b2db2b8efacb9515$var$AsyncServiceUpdateModalWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b2db2b8efacb9515$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });
var $b2db2b8efacb9515$export$2e2bcd8739ae039 = $b2db2b8efacb9515$var$AsyncServiceUpdateModalWithProjectContext;

});
parcelRegister("7PnXf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3DZ25").then(()=>parcelRequire('1UoO4'));

});



parcelRegister("f0Lah", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalNewRouteEntry", () => $5b24e81971b22b88$export$75c24699abe8e616);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $1PvPk = parcelRequire("1PvPk");

var $ajYrT = parcelRequire("ajYrT");

var $aQoXd = parcelRequire("aQoXd");

var $jqwxn = parcelRequire("jqwxn");
const $5b24e81971b22b88$export$75c24699abe8e616 = (0, $6xToB.createEntry)((0, $ajYrT.servicedeskServiceModalNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $jqwxn.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jqwxn.LazyServiceCreateModalWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-services-entries/src/servicedeskServiceModalNewRouteEntry.tsx',
                whichExportToUse: 'servicedeskServiceModalNewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ajYrT", function(module, exports) {
$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $35fbc3635db8acab$export$5b5ea97286af2784);
const $35fbc3635db8acab$export$5b5ea97286af2784 = {
    name: 'servicedesk-service-modal-new',
    path: '/jira/servicedesk/service-modal',
    exact: true
};

});

parcelRegister("jqwxn", function(module, exports) {
$parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", () => $9182c78be0917279$export$7f4092c8e7b7d3ec);
$parcel$export(module.exports, "default", () => $9182c78be0917279$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $9182c78be0917279$export$7f4092c8e7b7d3ec = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1eIXi")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
const $9182c78be0917279$var$AsyncServiceCreateModalWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $9182c78be0917279$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });
var $9182c78be0917279$export$2e2bcd8739ae039 = $9182c78be0917279$var$AsyncServiceCreateModalWithProjectContext;

});
parcelRegister("1eIXi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gx4db").then(()=>parcelRequire('1FtPF'));

});



parcelRegister("5psoN", function(module, exports) {
$parcel$export(module.exports, "servicedeskServicesRouteEntry", () => $c0b6c1a06fc90883$export$5df203501090bc7f);

var $kHlOR = parcelRequire("kHlOR");

var $8rDuZ = parcelRequire("8rDuZ");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $4sInV = parcelRequire("4sInV");

var $aQoXd = parcelRequire("aQoXd");

var $3wAw4 = parcelRequire("3wAw4");
const $c0b6c1a06fc90883$export$5df203501090bc7f = (0, $6xToB.createEntry)((0, $4sInV.servicedeskServicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services',
        component: (0, $3wAw4.default),
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            horizontal: (0, $8rDuZ.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskNavigationResources)(),
            ...(0, $1PvPk.getServicedeskPageContextResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8rDuZ.LazyJSMOperationsHorizontalNav),
            (0, $3wAw4.LazyServicedeskServicesWithProjectContext)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-services-entries/src/servicedeskServicesRouteEntry.tsx',
                whichExportToUse: 'servicedeskServicesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4sInV", function(module, exports) {
$parcel$export(module.exports, "servicedeskServicesRoute", () => $305cdadd1f4abb12$export$4a800381bda6d53c);
const $305cdadd1f4abb12$export$4a800381bda6d53c = {
    name: 'servicedesk-services',
    path: '/jira/servicedesk/projects/:projectKey/services',
    exact: true
};

});

parcelRegister("3wAw4", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", () => $038ecf0527590e0e$export$4aa60213b3477cf6);
$parcel$export(module.exports, "default", () => $038ecf0527590e0e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $038ecf0527590e0e$export$4aa60213b3477cf6 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jHYNb")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
const $038ecf0527590e0e$var$AsyncServicedeskServicesWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $038ecf0527590e0e$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });
var $038ecf0527590e0e$export$2e2bcd8739ae039 = $038ecf0527590e0e$var$AsyncServicedeskServicesWithProjectContext;

});
parcelRegister("jHYNb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6kCXg").then(()=>parcelRequire('01pGG'));

});



parcelRegister("1kaFK", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRouteEntry", () => $bd8e45aaeda080de$export$7031f96c25be5e14);

var $kHlOR = parcelRequire("kHlOR");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $8JPxs = parcelRequire("8JPxs");

var $cEzES = parcelRequire("cEzES");
const $bd8e45aaeda080de$export$7031f96c25be5e14 = (0, $6xToB.createEntry)((0, $8JPxs.serviceDeskServicesWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services-without-project',
        component: (0, $cEzES.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cEzES.LazyServicedeskServicesWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-services-without-project',
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-servicedesk-services-entries/src/serviceDeskServicesWithoutProjectRouteEntry.tsx',
                whichExportToUse: 'serviceDeskServicesWithoutProjectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8JPxs", function(module, exports) {
$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $3971f3d82c3b4181$export$3210e7c54c21be97);
const $3971f3d82c3b4181$export$3210e7c54c21be97 = {
    name: 'servicedesk-services-without-project',
    path: '/jira/servicedesk/services',
    exact: true
};

});

parcelRegister("cEzES", function(module, exports) {
$parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", () => $26888c8245e85d33$export$fc385e1392a8e28);
$parcel$export(module.exports, "default", () => $26888c8245e85d33$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $26888c8245e85d33$export$fc385e1392a8e28 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("37QEV")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
const $26888c8245e85d33$var$AsyncServicedeskServicesWithoutProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $26888c8245e85d33$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });
var $26888c8245e85d33$export$2e2bcd8739ae039 = $26888c8245e85d33$var$AsyncServicedeskServicesWithoutProjectContext;

});
parcelRegister("37QEV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dhv29").then(()=>parcelRequire('3MZo0'));

});



parcelRegister("kRlsB", function(module, exports) {
$parcel$export(module.exports, "servicedeskSlaSettingsRouteEntry", () => $8f63217d9286cc79$export$472949ed4e9ddfb0);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $khUom = parcelRequire("khUom");

var $hsEQN = parcelRequire("hsEQN");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $b1D7S = parcelRequire("b1D7S");
const $8f63217d9286cc79$export$472949ed4e9ddfb0 = (0, $6xToB.createEntry)((0, $hsEQN.servicedeskSlaSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $b1D7S.ServiceDeskSlaSettings),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $khUom.slaMetricsDataResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b1D7S.LazyProjectSettingsServiceDeskSlaSettings)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-sla-settings-entries/src/servicedeskSlaSettingsRouteEntry.tsx',
                whichExportToUse: 'servicedeskSlaSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("khUom", function(module, exports) {
$parcel$export(module.exports, "slaMetricsDataResource", () => $09c09289e12893aa$export$6cdfca3e816e9661);

var $l1VxS = parcelRequire("l1VxS");
const $09c09289e12893aa$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $09c09289e12893aa$export$6cdfca3e816e9661 = (0, $l1VxS.createResource)({
    type: $09c09289e12893aa$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("HGwzx")),
    maxAge: Infinity
});

});
parcelRegister("HGwzx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6hgQv").then(()=>parcelRequire('8MiMS'));

});


parcelRegister("b1D7S", function(module, exports) {
$parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", () => $c3089fab82ff5c6f$export$a6694c07cb5be8c1);
$parcel$export(module.exports, "ServiceDeskSlaSettings", () => $c3089fab82ff5c6f$export$c56fde3803c5a1a3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $4EKqI = parcelRequire("4EKqI");

var $bQWwW = parcelRequire("bQWwW");

const $c3089fab82ff5c6f$export$a6694c07cb5be8c1 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("nRIRo"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $c3089fab82ff5c6f$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c3089fab82ff5c6f$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));

});
parcelRegister("nRIRo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eRqqW").then(()=>parcelRequire('auMmF'));

});



parcelRegister("cK5xr", function(module, exports) {
$parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", () => $bb839972f7d7949d$export$212f7f79630d5adc);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $jOpgR = parcelRequire("jOpgR");

var $aQoXd = parcelRequire("aQoXd");

var $iTAO8 = parcelRequire("iTAO8");
const $bb839972f7d7949d$var$workflowSchemeConfigPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iTAO8.workflowSchemeConfigEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $bb839972f7d7949d$export$212f7f79630d5adc = (0, $6xToB.createEntry)((0, $jOpgR.servicedeskWorkflowConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint () {
            return $bb839972f7d7949d$var$workflowSchemeConfigPageEntrypoint;
        },
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $dZRaT.projectContextResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.workflow-scheme-config',
                packageName: 'projectSettingsWorkflowSchemeConfig',
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-workflow-scheme-config',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-workflow-scheme-config-entries/src/servicedeskWorkflowConfigRouteEntry.tsx',
                whichExportToUse: 'servicedeskWorkflowConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iTAO8", function(module, exports) {
$parcel$export(module.exports, "workflowSchemeConfigEntrypoint", () => $f6ce23326fb8eb0c$export$12ccdf1d30de8ac);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $f6ce23326fb8eb0c$export$12ccdf1d30de8ac = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9UQQB")), {
        moduleId: "6be3e66b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9UQQB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fnkTE").then(()=>parcelRequire('h5RId'));

});



parcelRegister("43qOr", function(module, exports) {
$parcel$export(module.exports, "settingsAutomationRouteEntry", () => $bbbfcd07506793c7$export$4df9f9dcaf8565c9);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $2UlkX = parcelRequire("2UlkX");

var $5fjzQ = parcelRequire("5fjzQ");

var $bhnHT = parcelRequire("bhnHT");
const $bbbfcd07506793c7$export$4df9f9dcaf8565c9 = (0, $6xToB.createEntry)((0, $2UlkX.settingsAutomationRoute), ()=>({
        group: 'global-settings',
        component: (0, $bhnHT.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bhnHT.LazyGlobalAutomation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-settings-automation-entries/src/settingsAutomationRouteEntry.tsx',
                whichExportToUse: 'settingsAutomationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2UlkX", function(module, exports) {
$parcel$export(module.exports, "settingsAutomationRoute", () => $92b8636abff4a3a7$export$b314ab31b2da625b);
const $92b8636abff4a3a7$export$b314ab31b2da625b = {
    name: 'global-automation',
    path: '/jira/settings/automation',
    exact: true
};

});

parcelRegister("bhnHT", function(module, exports) {
$parcel$export(module.exports, "LazyGlobalAutomation", () => $1c58a18722fba62a$export$4189991a2992b828);
$parcel$export(module.exports, "default", () => $1c58a18722fba62a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $91g62 = parcelRequire("91g62");

const $1c58a18722fba62a$export$4189991a2992b828 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("iVnbz"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $1c58a18722fba62a$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $3Q6BV.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $91g62.RedirectToProjectType), {
        page: page
    });
};
const $1c58a18722fba62a$var$AsyncGlobalAutomation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1c58a18722fba62a$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });
var $1c58a18722fba62a$export$2e2bcd8739ae039 = $1c58a18722fba62a$var$AsyncGlobalAutomation;

});
parcelRegister("91g62", function(module, exports) {
$parcel$export(module.exports, "RedirectToProjectType", () => $e899c557b5b01570$export$8a3df560509448b8);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");
const $e899c557b5b01570$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $2mHfh.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $kRgKj.fireUIAnalytics), page: page, useAnalyticsEvents: // eslint-disable-next-line react-hooks/react-compiler
useAnalyticsEvents = (0, $ftN6c.useAnalyticsEvents), useResource: // eslint-disable-next-line react-hooks/react-compiler
useResource = (0, $eJrcF.useResource), useRouter: // eslint-disable-next-line react-hooks/react-compiler
useRouter = (0, $gCY1z.useRouter), useSpaStateTransition: // eslint-disable-next-line react-hooks/react-compiler
useSpaStateTransition = (0, $3lhVL.useSpaStateTransition) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ match: match, query: query, route: route }] = useRouter();
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data } = useResource((0, $dZRaT.projectContextResource));
    // eslint-disable-next-line react-hooks/react-compiler
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $FhXEJ.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $FhXEJ.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("iVnbz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cBsb5").then(()=>parcelRequire('gpOYK'));

});



parcelRegister("gYfl3", function(module, exports) {
$parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", () => $adcda12683ff0089$export$c68a412f25295511);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $7CgsF = parcelRequire("7CgsF");

var $ePaI2 = parcelRequire("ePaI2");

var $9871O = parcelRequire("9871O");
const $adcda12683ff0089$export$c68a412f25295511 = (0, $6xToB.createEntry)((0, $7CgsF.settingsCmdbFieldConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.cmdb-field-config',
        component: (0, $9871O.AsyncCmdbFieldConfigPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $ePaI2.workspaceResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $9871O.LazyCMDBFieldConfigAdmin)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-settings-cmdb-field-config-entries/src/settingsCmdbFieldConfigRouteEntry.tsx',
                whichExportToUse: 'settingsCmdbFieldConfigRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7CgsF", function(module, exports) {
$parcel$export(module.exports, "settingsCmdbFieldConfigRoute", () => $a9db28a7b62798b9$export$5097bfaa68f86ca6);
const $a9db28a7b62798b9$export$5097bfaa68f86ca6 = {
    name: 'global-settings-issues-cmdb-field-config',
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};

});

parcelRegister("9871O", function(module, exports) {
$parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", () => $1912288813b3af7b$export$ccc6da5137e23637);
$parcel$export(module.exports, "AsyncCmdbFieldConfigPage", () => $1912288813b3af7b$export$8dfbe255f554ebab);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $1912288813b3af7b$export$ccc6da5137e23637 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("eCC0p"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $1912288813b3af7b$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $1912288813b3af7b$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });

});
parcelRegister("eCC0p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cpfd5").then(()=>parcelRequire('a6mRS'));

});



parcelRegister("jo8cE", function(module, exports) {
$parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", () => $c9dcac9b1618c585$export$d1c67ceb7c5e2d6a);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $6xToB = parcelRequire("6xToB");

var $g3UVq = parcelRequire("g3UVq");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $9W50L = parcelRequire("9W50L");

var $8PGkM = parcelRequire("8PGkM");
const $c9dcac9b1618c585$export$d1c67ceb7c5e2d6a = (0, $6xToB.createEntry)((0, $9W50L.settingsOauthCredentialsRoute), ()=>({
        group: 'global-settings',
        component: (0, $8PGkM.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $g3UVq.adminOauthCredentialsResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8PGkM.LazyOAuthCredentialsAdmin)
        ],
        ufoName: 'admin.oauth-credentials',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-settings-oauth-credentials-entries/src/settingsOauthCredentialsRouteEntry.tsx',
                whichExportToUse: 'settingsOauthCredentialsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("g3UVq", function(module, exports) {
$parcel$export(module.exports, "adminOauthCredentialsResource", () => $072ab8081c2d6bff$export$870d7919c1ca4482);

var $l1VxS = parcelRequire("l1VxS");
const $072ab8081c2d6bff$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $072ab8081c2d6bff$export$870d7919c1ca4482 = (0, $l1VxS.createResource)({
    type: $072ab8081c2d6bff$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("lPEkz"))
});

});
parcelRegister("lPEkz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8BJYY").then(()=>parcelRequire('lHApX'));

});


parcelRegister("9W50L", function(module, exports) {
$parcel$export(module.exports, "settingsOauthCredentialsRoute", () => $37d6367249c470a6$export$c0ee28def7ef8783);
const $37d6367249c470a6$export$c0ee28def7ef8783 = {
    name: 'admin-oauth-credentials',
    path: '/secure/admin/oauth-credentials'
};

});

parcelRegister("8PGkM", function(module, exports) {
$parcel$export(module.exports, "LazyOAuthCredentialsAdmin", () => $ccc03c004161bf3e$export$101baa25055633e8);
$parcel$export(module.exports, "default", () => $ccc03c004161bf3e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ccc03c004161bf3e$export$101baa25055633e8 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("cs6C0"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
const $ccc03c004161bf3e$var$AsyncOAuthCredentialsAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ccc03c004161bf3e$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });
var $ccc03c004161bf3e$export$2e2bcd8739ae039 = $ccc03c004161bf3e$var$AsyncOAuthCredentialsAdmin;

});
parcelRegister("cs6C0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2qEpG").then(()=>parcelRequire('d0bjG'));

});



parcelRegister("kKMOG", function(module, exports) {
$parcel$export(module.exports, "settingsRouteEntry", () => $346d0e15f71a3dee$export$1d28e19560927106);

var $3MgfG = parcelRequire("3MgfG");

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $8Ewej = parcelRequire("8Ewej");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $7i1ou = parcelRequire("7i1ou");

var $g8uYY = parcelRequire("g8uYY");

var $eN8Nn = parcelRequire("eN8Nn");

var $cAYFR = parcelRequire("cAYFR");
const $346d0e15f71a3dee$var$settingsPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eN8Nn.settingsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $346d0e15f71a3dee$export$1d28e19560927106 = (0, $6xToB.createEntry)((0, $8Ewej.settingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $346d0e15f71a3dee$var$settingsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7i1ou.VirtualAgentSettingsSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/settingsRouteEntry.tsx',
                whichExportToUse: 'settingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8Ewej", function(module, exports) {
$parcel$export(module.exports, "settingsRoute", () => $7d6cb131d28dfa23$export$847a7c378c11c645);
const $7d6cb131d28dfa23$export$847a7c378c11c645 = {
    name: 'project-settings-servicedesk-virtualagent-settings',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
};

});

parcelRegister("7i1ou", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentSettingsSkeleton", () => $d66400ba919edfd7$export$429c43ddcb09c14c);
/* VirtualAgentSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $hympS = parcelRequire("hympS");
const $d66400ba919edfd7$var$customCssStyles = null;
const $d66400ba919edfd7$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hympS))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("hympS", function(module, exports) {
module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();

});


parcelRegister("eN8Nn", function(module, exports) {
$parcel$export(module.exports, "settingsEntryPoint", () => $1cede4a6264e1977$export$d34e7816b7ac181a);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hVET0 = parcelRequire("hVET0");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $inQqC = parcelRequire("inQqC");

const $1cede4a6264e1977$export$d34e7816b7ac181a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(0, $inQqC.clientSideOnly)((parcelRequire("9Ys7N"))), {
        moduleId: "c39498b8",
        moduleName: "VirtualAgentSettingsPage",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $hVET0.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("hVET0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c20386f035db5cf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad15fcd60a898fb5f8da7c1293945a09>>
 * @relayHash 8f178f632eb52a31c30a19a1eba85d2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9f22d148e47809e20b4dee6fe181b1331a8c5617512b553498f6ed2c329a4fa

var $be7rL = parcelRequire("be7rL");

var $bXR9c = parcelRequire("bXR9c");

var $Ic6R7 = parcelRequire("Ic6R7");
const $c20386f035db5cf5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f9f22d148e47809e20b4dee6fe181b1331a8c5617512b553498f6ed2c329a4fa",
        "metadata": {},
        "name": "VirtualAgentSettingsPageQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, $be7rL.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $Ic6R7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $c20386f035db5cf5$export$2e2bcd8739ae039 = $c20386f035db5cf5$var$node;

});
parcelRegister("be7rL", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb6c68a3b3294a2b$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $bb6c68a3b3294a2b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jsm_va_enable_ai_answers_page');
    }
};

});


parcelRegister("9Ys7N", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("o5IuS").then(()=>parcelRequire('hxNsI'));

});



parcelRegister("aNCbW", function(module, exports) {
$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry", () => $c5f3a1cd0ce4a0a8$export$4652a26319dca4d0);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $1rAxS = parcelRequire("1rAxS");

var $7fTjp = parcelRequire("7fTjp");

var $iIcBn = parcelRequire("iIcBn");
const $c5f3a1cd0ce4a0a8$export$4652a26319dca4d0 = (0, $6xToB.createEntry)((0, $1rAxS.softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
        group: 'software',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry.tsx',
                whichExportToUse: 'softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1rAxS", function(module, exports) {
$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $5bbae3dea39fe9e8$export$38c76ea9ddc85b3);
const $5bbae3dea39fe9e8$export$38c76ea9ddc85b3 = {
    name: 'software-advanced-roadmaps-getting-started-redirect',
    path: '/secure/PortfolioGettingStarted.jspa'
};

});


parcelRegister("2AYKc", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", () => $9e4ad6e06a75fe7d$export$7cd14dee22609378);


var $4cTDP = parcelRequire("4cTDP");

var $eJe5A = parcelRequire("eJe5A");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $90zcE = parcelRequire("90zcE");

var $gujXH = parcelRequire("gujXH");

var $dcS0z = parcelRequire("dcS0z");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $kAY5R = parcelRequire("kAY5R");

var $e1vE6 = parcelRequire("e1vE6");

var $5L7qx = parcelRequire("5L7qx");

var $cxKOj = parcelRequire("cxKOj");

var $v9AFd = parcelRequire("v9AFd");

var $2KSGq = parcelRequire("2KSGq");
const $9e4ad6e06a75fe7d$export$7cd14dee22609378 = (0, $6xToB.createEntry)((0, $kAY5R.softwareBacklogEmbedRoute), ()=>({
        group: 'software',
        component: (0, $2KSGq.BacklogPage),
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $90zcE.backlogResource),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $cxKOj.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $v9AFd.customFiltersResource)),
            (0, $gujXH.backlogFilterRefinementResource),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $e1vE6.aiEntitlementResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('backlog-preload-epics-lite'), (0, $dcS0z.epicsLiteResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $2KSGq.LazyBacklogPage)
        ],
        ufoName: 'next-gen-backlog-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$c17f34c425972af1)
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-backlog-entries/src/softwareBacklogEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareBacklogEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("90zcE", function(module, exports) {
$parcel$export(module.exports, "backlogResource", () => $58e7789c76a50fcb$export$31d171ba71468137);

var $l1VxS = parcelRequire("l1VxS");


const $58e7789c76a50fcb$export$31d171ba71468137 = (0, $l1VxS.createResource)({
    type: (0, $8740982aac8b017b$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("h9cVJ")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
const $8740982aac8b017b$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $8740982aac8b017b$export$214238a9ff4636a = 'NEXTGEN_BACKLOG_FILTER_REFINEMENT';
const $8740982aac8b017b$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';

parcelRegister("h9cVJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8JSWM").then(()=>parcelRequire('jhz3p'));

});


parcelRegister("gujXH", function(module, exports) {
$parcel$export(module.exports, "backlogFilterRefinementResource", () => $977032b4b33698a9$export$f9d71cb27b4dd1d8);

var $j4oe4 = parcelRequire("j4oe4");

var $5L7qx = parcelRequire("5L7qx");

var $cxKOj = parcelRequire("cxKOj");

var $8oKDI = parcelRequire("8oKDI");

var $5EQLQ = parcelRequire("5EQLQ");

var $l1VxS = parcelRequire("l1VxS");

var $7zZ4w = parcelRequire("7zZ4w");

const $977032b4b33698a9$export$f9d71cb27b4dd1d8 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $cxKOj.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $l1VxS.createResource)({
    type: (0, $8740982aac8b017b$export$214238a9ff4636a),
    getKey: ()=>'backlog-filter-refinement-relay',
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const variables = {
            cloudId: tenantContext.cloudId,
            jql: query.jql ?? '',
            boardId: (0, $8oKDI.createAri)({
                resourceOwner: 'jira-software',
                cloudId: tenantContext.cloudId,
                resourceType: 'board',
                resourceId: String(match.params.boardId)
            }),
            filterRefinementScope: {
                backlog: {
                    boardId: Number(match.params.boardId)
                }
            }
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $5EQLQ.default), variables, {
            fetchPolicy: 'store-and-network'
        });
        return queryReference;
    },
    isBrowserOnly: true,
    maxAge: 0
}));

});
parcelRegister("5EQLQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b11829064dc24ace$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ee13655924f5a35af050b8b877a967c>>
 * @relayHash ba6d684cf52c39f4ae2f3df43c85672b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f11c713a96724e751e78f3213b049b7d422e35c18f6ceb2d703da611c377ebc
const $b11829064dc24ace$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2f11c713a96724e751e78f3213b049b7d422e35c18f6ceb2d703da611c377ebc",
        "metadata": {},
        "name": "backlogFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b11829064dc24ace$export$2e2bcd8739ae039 = $b11829064dc24ace$var$node;

});


parcelRegister("kAY5R", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $8ec0d0dc88b6fdf8$export$bc022a39c42aba2f);
const $8ec0d0dc88b6fdf8$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("v9AFd", function(module, exports) {
$parcel$export(module.exports, "customFiltersResource", () => $980e206f0066c16a$export$3e390340716755de);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $1WHGo = parcelRequire("1WHGo");

const $980e206f0066c16a$export$3e390340716755de = (0, $9FYIg.createRelayResource)({
    type: (0, $8740982aac8b017b$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $1WHGo.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isBrowserOnly: true
});

});
parcelRegister("1WHGo", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ce06bc2d802e83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $72ce06bc2d802e83$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$72ce06bc2d802e83$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $72ce06bc2d802e83$export$2e2bcd8739ae039 = $72ce06bc2d802e83$var$node;

});


parcelRegister("2KSGq", function(module, exports) {
$parcel$export(module.exports, "LazyBacklogPage", () => $cf6cd6155216962a$export$edb4b8cf67d7d767);
$parcel$export(module.exports, "BacklogPage", () => $cf6cd6155216962a$export$471ffbe87b75af04);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $e4c90 = parcelRequire("e4c90");

const $cf6cd6155216962a$export$edb4b8cf67d7d767 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6bmnz"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $cf6cd6155216962a$export$471ffbe87b75af04 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cf6cd6155216962a$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $e4c90.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("e4c90", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $480069ddc1b8be2e$export$557c2f222778cea6);

var $b5RwB = parcelRequire("b5RwB");
const $480069ddc1b8be2e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(location.search);
    return rapidView;
};

});



parcelRegister("cJqhS", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogRouteEntry", () => $1f110322ba1d3ae8$export$a5f8ba02d2755510);


var $4cTDP = parcelRequire("4cTDP");

var $hS1gr = parcelRequire("hS1gr");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $90zcE = parcelRequire("90zcE");

var $dcS0z = parcelRequire("dcS0z");

var $gujXH = parcelRequire("gujXH");

var $dZRaT = parcelRequire("dZRaT");

var $6nGIP = parcelRequire("6nGIP");

var $9ZjGp = parcelRequire("9ZjGp");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $e1vE6 = parcelRequire("e1vE6");

var $cxKOj = parcelRequire("cxKOj");

var $v9AFd = parcelRequire("v9AFd");

var $63moR = parcelRequire("63moR");
const $1f110322ba1d3ae8$export$a5f8ba02d2755510 = (0, $6xToB.createEntry)((0, $6nGIP.softwareBacklogRoute), ()=>({
        group: 'software',
        skeleton: (0, $9ZjGp.NextGenBacklogSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $90zcE.backlogResource),
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $cxKOj.expVal)('filter_refinement_in_tmp_backlog', 'isEnabled', false), (0, $v9AFd.customFiltersResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('backlog-preload-epics-lite'), (0, $dcS0z.epicsLiteResource)),
            (0, $gujXH.backlogFilterRefinementResource),
            (0, $hHbzj.forgeBacklogModuleResource),
            (0, $hHbzj.forgeSprintModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $e1vE6.aiEntitlementResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-backlog-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: 'next-gen-backlog',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$c17f34c425972af1)
        },
        entryPoint: ()=>(0, $63moR.backlogPageEntrypoint),
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('tmp-backlog-hydrate-root'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-backlog-entries/src/softwareBacklogRouteEntry.tsx',
                whichExportToUse: 'softwareBacklogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6nGIP", function(module, exports) {
$parcel$export(module.exports, "softwareBacklogRoute", () => $ae3d39c5830d8333$export$fb454ec14936c0ab);
const $ae3d39c5830d8333$export$fb454ec14936c0ab = {
    name: 'software-backlog',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("63moR", function(module, exports) {
$parcel$export(module.exports, "backlogPageEntrypoint", () => $81d0d04f32a7298c$export$1ccf08591607897d);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $cw1BI = parcelRequire("cw1BI");
const $81d0d04f32a7298c$export$1ccf08591607897d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cw1BI.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("ejo5K", function(module, exports) {
$parcel$export(module.exports, "softwareBoardEmbedRouteEntry", () => $8de7d489f7b08ccf$export$ff8632c8a0f5d984);


var $eJe5A = parcelRequire("eJe5A");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4f4nP = parcelRequire("4f4nP");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $eLjrd = parcelRequire("eLjrd");

var $lM6Lx = parcelRequire("lM6Lx");

var $dOwkS = parcelRequire("dOwkS");

var $kjtKR = parcelRequire("kjtKR");

var $b8mAd = parcelRequire("b8mAd");

var $5ObVX = parcelRequire("5ObVX");
const $8de7d489f7b08ccf$export$ff8632c8a0f5d984 = (0, $6xToB.createEntry)((0, $eLjrd.softwareBoardEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $lM6Lx.conditionalBoardNBTOptInResource),
            (0, $kjtKR.conditionalBoardResource),
            (0, $dOwkS.conditionalBoardRelayResource),
            (0, $4f4nP.boardFilterRefinementResource),
            (0, $b8mAd.conditionalCustomFiltersResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $hHbzj.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $5ObVX.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board-embed',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f364828958cffad0)
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-board-entries/src/softwareBoardEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareBoardEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4f4nP", function(module, exports) {
$parcel$export(module.exports, "boardResource", () => $380e54478f9157ea$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $380e54478f9157ea$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $380e54478f9157ea$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $380e54478f9157ea$export$81ac23db76b1f935);

var $cxKOj = parcelRequire("cxKOj");

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $bzefi = parcelRequire("bzefi");

var $iAXqa = parcelRequire("iAXqa");

var $cOAoV = parcelRequire("cOAoV");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");


const $380e54478f9157ea$export$286b76e0f2661cfb = (0, $l1VxS.createResource)({
    type: (0, $611489349b87bf12$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("dYIfY")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});
const $380e54478f9157ea$export$3e390340716755de = (0, $9FYIg.createRelayResource)({
    type: (0, $611489349b87bf12$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $iAXqa.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});
const $380e54478f9157ea$export$283d16e3e02421f0 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $cxKOj.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $9FYIg.createRelayResource)({
    type: (0, $611489349b87bf12$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $cOAoV.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $380e54478f9157ea$export$81ac23db76b1f935 = (0, $9FYIg.createRelayResource)({
    type: (0, $611489349b87bf12$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bzefi.default),
            variables: {
                boardId: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
});

});
parcelRegister("bzefi", function(module, exports) {
$parcel$export(module.exports, "default", () => $7106240e15f77311$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e5605c892abb7aa66b2c2fcbdf11c5c>>
 * @relayHash 9f8e28d0f8d18bbce68dbc943123a0ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08efba67f706c4b8c3e987443bffc477163e8297cc227d6b595636f7a410cd63
const $7106240e15f77311$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "08efba67f706c4b8c3e987443bffc477163e8297cc227d6b595636f7a410cd63",
        "metadata": {},
        "name": "BoardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7106240e15f77311$export$2e2bcd8739ae039 = $7106240e15f77311$var$node;

});

parcelRegister("iAXqa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c84fb719b191c9eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $c84fb719b191c9eb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c84fb719b191c9eb$export$2e2bcd8739ae039 = $c84fb719b191c9eb$var$node;

});

parcelRegister("cOAoV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd6dbaf9d10d522$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1c82b1fec5c3204ab5f57422ea4b2a5>>
 * @relayHash 99d6679ddf7932f021d6474b947c4ccf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8642e2b2ef16420f84a8d4ea1d4c89c873c4de0ed82cd27a3c1ccad231cf49b
const $7dd6dbaf9d10d522$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d8642e2b2ef16420f84a8d4ea1d4c89c873c4de0ed82cd27a3c1ccad231cf49b",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7dd6dbaf9d10d522$export$2e2bcd8739ae039 = $7dd6dbaf9d10d522$var$node;

});

const $611489349b87bf12$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $611489349b87bf12$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $611489349b87bf12$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $611489349b87bf12$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';

parcelRegister("dYIfY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bBLb1").then(()=>parcelRequire('5P2oX'));

});


parcelRegister("eLjrd", function(module, exports) {
$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $228b49f1be9e4c68$export$f55626b64e3fcb4f);
const $228b49f1be9e4c68$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("lM6Lx", function(module, exports) {
$parcel$export(module.exports, "conditionalBoardNBTOptInResource", () => $77bca784f22b7832$export$3cdaa13b878c3c59);

var $lopBx = parcelRequire("lopBx");

var $b8mPY = parcelRequire("b8mPY");

var $5L7qx = parcelRequire("5L7qx");
const $77bca784f22b7832$export$3cdaa13b878c3c59 = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $lopBx.isFedRamp)(), (0, $b8mPY.nextBestTaskFeatureResource));

});

parcelRegister("dOwkS", function(module, exports) {
$parcel$export(module.exports, "conditionalBoardRelayResource", () => $563e2ea3976e600f$export$ce009bf1a33fb264);

var $4cTDP = parcelRequire("4cTDP");

var $4f4nP = parcelRequire("4f4nP");

var $5L7qx = parcelRequire("5L7qx");
const $563e2ea3976e600f$export$ce009bf1a33fb264 = (0, $5L7qx.resourceWithCondition)(()=>(0, $4cTDP.fg)('critical_board_query_with_relay'), (0, $4f4nP.boardRelayResource));

});

parcelRegister("kjtKR", function(module, exports) {
$parcel$export(module.exports, "conditionalBoardResource", () => $c527a3878e878781$export$2ba7dfd4089a1a57);

var $4cTDP = parcelRequire("4cTDP");

var $4f4nP = parcelRequire("4f4nP");

var $5L7qx = parcelRequire("5L7qx");
const $c527a3878e878781$export$2ba7dfd4089a1a57 = (0, $5L7qx.resourceWithCondition)(()=>!(0, $4cTDP.fg)('critical_board_query_with_relay'), (0, $4f4nP.boardResource));

});

parcelRegister("b8mAd", function(module, exports) {
$parcel$export(module.exports, "conditionalCustomFiltersResource", () => $71e03cdfec5f880f$export$ad9ac1bd5f72148c);

var $cxKOj = parcelRequire("cxKOj");

var $4f4nP = parcelRequire("4f4nP");

var $5L7qx = parcelRequire("5L7qx");
const $71e03cdfec5f880f$export$ad9ac1bd5f72148c = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $cxKOj.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $4f4nP.customFiltersResource));

});

parcelRegister("5ObVX", function(module, exports) {
$parcel$export(module.exports, "softwareBoardPageEntrypoint", () => $2cb160a154536b24$export$89009c28cae628ae);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $iJnZt = parcelRequire("iJnZt");

var $5RW99 = parcelRequire("5RW99");
const $2cb160a154536b24$export$89009c28cae628ae = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iJnZt.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("hnRYr", function(module, exports) {
$parcel$export(module.exports, "softwareBoardRouteEntry", () => $32f85b5eedeef97d$export$2964ea1cdd5afa39);


var $hS1gr = parcelRequire("hS1gr");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4f4nP = parcelRequire("4f4nP");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $jmzgU = parcelRequire("jmzgU");

var $h1VgH = parcelRequire("h1VgH");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $8FCAy = parcelRequire("8FCAy");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $8vmEP = parcelRequire("8vmEP");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $5fjzQ = parcelRequire("5fjzQ");

var $lM6Lx = parcelRequire("lM6Lx");

var $dOwkS = parcelRequire("dOwkS");

var $kjtKR = parcelRequire("kjtKR");

var $b8mAd = parcelRequire("b8mAd");

var $5ObVX = parcelRequire("5ObVX");
const $32f85b5eedeef97d$var$getColoredLabelsResource = ()=>{
    return (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? [
        (0, $8vmEP.coloredLabelsResource)
    ] : [];
};
const $32f85b5eedeef97d$export$2964ea1cdd5afa39 = (0, $6xToB.createEntry)((0, $jmzgU.softwareBoardRoute), ()=>({
        group: 'software',
        skeleton: (0, $h1VgH.NextGenBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kjtKR.conditionalBoardResource),
            (0, $b8mAd.conditionalCustomFiltersResource),
            (0, $4f4nP.boardFilterRefinementResource),
            (0, $dOwkS.conditionalBoardRelayResource),
            (0, $lM6Lx.conditionalBoardNBTOptInResource),
            (0, $hHbzj.forgeBoardModuleResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource)),
            ...$32f85b5eedeef97d$var$getColoredLabelsResource(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('jira-issue-view-twc-spotlight-tour-ssr'), (0, $5fjzQ.postOfficeJiraIssueViewTwcSpotlightTourResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-board-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $5ObVX.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board',
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f364828958cffad0)
        },
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('tmp-board-hydrate-root'),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-board-entries/src/softwareBoardRouteEntry.tsx',
                whichExportToUse: 'softwareBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("h1VgH", function(module, exports) {
$parcel$export(module.exports, "NextGenBoardSkeleton", () => $74b97cceeddc70ee$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $9FhiI = parcelRequire("9FhiI");
const $74b97cceeddc70ee$var$customCssStyles = null;
const $74b97cceeddc70ee$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9FhiI))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("9FhiI", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});



parcelRegister("88nEe", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRouteEntry", () => $ef672e9ab2c49de9$export$bdd0e204be6866cd);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8Dimt = parcelRequire("8Dimt");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $38Nv8 = parcelRequire("38Nv8");
const $ef672e9ab2c49de9$export$bdd0e204be6866cd = (0, $6xToB.createEntry)((0, $8Dimt.softwareBoardViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $38Nv8.boardViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-view-not-found-entries/src/softwareBoardViewNotFoundClassicRouteEntry.tsx',
                whichExportToUse: 'softwareBoardViewNotFoundClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8Dimt", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRoute", () => $8c3566b128826553$export$b31cf885abe93fbf);
const $8c3566b128826553$export$b31cf885abe93fbf = {
    name: 'software-board-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found'
};

});

parcelRegister("38Nv8", function(module, exports) {
$parcel$export(module.exports, "boardViewNotFoundPageEntrypoint", () => $59e711c8d04a000f$export$7f51979492148d53);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $f3Kvz = parcelRequire("f3Kvz");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

const $59e711c8d04a000f$var$main = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3KOfw")), {
        moduleId: "83a02129",
        moduleName: "BoardViewNotFound",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const boardId = context.match.params.boardId;
        if (boardId == null) throw new Error('Board id missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $f3Kvz.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${cloudId}:board/${boardId}`
                    }
                }
            }
        };
    }
});
const $59e711c8d04a000f$export$7f51979492148d53 = (0, $g8uYY.createPageEntryPoint)({
    main: $59e711c8d04a000f$var$main,
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("f3Kvz", function(module, exports) {
$parcel$export(module.exports, "default", () => $972ecde19466b0e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b4c2382e9edb79ca18ee82cc3dcb5e>>
 * @relayHash c015acb85644d3bee5c8b2cb145b1d66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51
const $972ecde19466b0e4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51",
        "metadata": {},
        "name": "BoardViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $972ecde19466b0e4$export$2e2bcd8739ae039 = $972ecde19466b0e4$var$node;

});

parcelRegister("3KOfw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kWUqT").then(()=>parcelRequire('cU5Kj'));

});



parcelRegister("4nTz0", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundRouteEntry", () => $bd94b282acc6ce41$export$70fda0ba037c81ca);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $eCRwp = parcelRequire("eCRwp");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $38Nv8 = parcelRequire("38Nv8");
const $bd94b282acc6ce41$export$70fda0ba037c81ca = (0, $6xToB.createEntry)((0, $eCRwp.softwareBoardViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $38Nv8.boardViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-view-not-found-entries/src/softwareBoardViewNotFoundRouteEntry.tsx',
                whichExportToUse: 'softwareBoardViewNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eCRwp", function(module, exports) {
$parcel$export(module.exports, "softwareBoardViewNotFoundRoute", () => $8fbbb35e24a43ebd$export$4c5eaffb9e70d071);
const $8fbbb35e24a43ebd$export$4c5eaffb9e70d071 = {
    name: 'software-board-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("8W2c8", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicCustomEmbedRouteEntry", () => $20639c7a493d5f77$export$406edd4ac84413cc);

var $6xToB = parcelRequire("6xToB");

var $4DCrA = parcelRequire("4DCrA");

var $dsh9d = parcelRequire("dsh9d");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $4cTDP = parcelRequire("4cTDP");

var $hXFFJ = parcelRequire("hXFFJ");
const $20639c7a493d5f77$export$406edd4ac84413cc = (0, $6xToB.createEntry)((0, $4DCrA.softwareCalendarClassicCustomEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $hXFFJ.softwareCalendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCalendarClassicCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCalendarClassicCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4DCrA", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicCustomEmbedRoute", () => $04236a0a1bec0b5a$export$15e88f3b033926ec);
const $04236a0a1bec0b5a$export$15e88f3b033926ec = {
    name: 'software-calendar-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("hXFFJ", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $58d826ffc1c36292$export$83b1b9036cc7961a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $eAYvp = parcelRequire("eAYvp");

var $9n5I0 = parcelRequire("9n5I0");
const $58d826ffc1c36292$export$83b1b9036cc7961a = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eAYvp.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("eAYvp", function(module, exports) {
$parcel$export(module.exports, "calendarEntryPoint", () => $36959cde1662fa07$export$19cf4b398f638dc6);

var $3hRxq = parcelRequire("3hRxq");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lpUQd = parcelRequire("lpUQd");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $36959cde1662fa07$var$storageProvider = typeof window !== 'undefined' ? (0, $3hRxq.createLocalStorageProvider)('', false) : undefined;
const $36959cde1662fa07$var$DEFAULT_CALENDAR_BOARD_SETTINGS = {
    additionalFilterQuery: ''
};
const $36959cde1662fa07$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
/**
 * Must append boardId to the storage key to avoid conflicts with other boards.
 *
 * @example
 * const boardSpecificKey = `${CALENDAR_BOARD_SETTINGS_STORAGE_KEY}:${boardId}`;
 */ const $36959cde1662fa07$var$CALENDAR_BOARD_SETTINGS_STORAGE_KEY = 'calendar:settings:software:board';
function $36959cde1662fa07$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $36959cde1662fa07$var$getCalendarBoardSettingsFromLocalStorage = (boardId)=>{
    const boardSpecificKey = `${$36959cde1662fa07$var$CALENDAR_BOARD_SETTINGS_STORAGE_KEY}:${boardId}`;
    const settings = $36959cde1662fa07$var$storageProvider?.get(boardSpecificKey);
    return {
        additionalFilterQuery: settings?.additionalFilterQuery ?? $36959cde1662fa07$var$DEFAULT_CALENDAR_BOARD_SETTINGS.additionalFilterQuery
    };
};
function $36959cde1662fa07$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $36959cde1662fa07$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $36959cde1662fa07$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $36959cde1662fa07$var$SOFTWARE_CALENDAR = 'software-calendar';
const $36959cde1662fa07$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $36959cde1662fa07$var$SOFTWARE_CALENDAR_CUSTOM_EMBED = 'software-calendar-custom-embed';
const $36959cde1662fa07$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $36959cde1662fa07$var$SOFTWARE_CALENDAR,
    $36959cde1662fa07$var$SOFTWARE_CALENDAR_EMBED,
    $36959cde1662fa07$var$SOFTWARE_CALENDAR_CUSTOM_EMBED
];
function $36959cde1662fa07$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $36959cde1662fa07$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $36959cde1662fa07$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $36959cde1662fa07$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    if ((0, $4cTDP.fg)('jira_calendar_load_more_pagination') || scope.projectKeys && scope.projectKeys.length > 0) return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
    return scopeInput;
}
function $36959cde1662fa07$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $36959cde1662fa07$var$toViewRange(mode) {
    switch(mode){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $36959cde1662fa07$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $36959cde1662fa07$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $36959cde1662fa07$var$toMidnightUTCString(selectedDate),
        mode: $36959cde1662fa07$var$toViewMode(viewRange),
        weekStart: $36959cde1662fa07$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
function $36959cde1662fa07$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $36959cde1662fa07$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $36959cde1662fa07$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $36959cde1662fa07$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $36959cde1662fa07$export$19cf4b398f638dc6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2El0S")), {
        moduleId: "57ee20a5",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $36959cde1662fa07$var$createScope(entryPointRouteParams);
        const { date: date, viewRange: viewRangeQueryParam, filter: filterQueryParam } = context.query;
        const selectedDate = $36959cde1662fa07$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const settings = (0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? $36959cde1662fa07$var$getViewSettings($36959cde1662fa07$var$SETTINGS_STORAGE_KEY) : undefined;
        const calendarBoardSettings = (0, $4cTDP.fg)('yurree_jjj2_calendar') ? $36959cde1662fa07$var$getCalendarBoardSettingsFromLocalStorage(boardId) : $36959cde1662fa07$var$DEFAULT_CALENDAR_BOARD_SETTINGS;
        const issuesSearchInput = (0, $4cTDP.fg)('yurree_jjj2_calendar') ? {
            additionalFilterQuery: filterQueryParam ?? calendarBoardSettings.additionalFilterQuery
        } : $36959cde1662fa07$var$buildIssuesSearchInput();
        const viewRange = (0, $4cTDP.fg)('jira_calendar_day_grid_week_view') ? $36959cde1662fa07$var$toViewRange(viewRangeQueryParam ?? 'month') : 'month';
        const weekStartsOn = (0, $4cTDP.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lpUQd.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $36959cde1662fa07$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $36959cde1662fa07$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: 200,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $36959cde1662fa07$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $36959cde1662fa07$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $36959cde1662fa07$var$buildSprintsSearchInput(),
                        includeRecurrenceIndicator: true,
                        skipSprintSearch: false,
                        viewId: null,
                        pageLoadMoreEnabled: (0, $4cTDP.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV2Search: false,
                        pageLoadMoreEnabledViewSettings: (0, $4cTDP.fg)('jira_calendar_load_more_pagination_view_settings'),
                        skipUserPreferences: false,
                        hasSavedFilterCapability: (0, $cxKOj.expValEquals)('atlas-96240_saved_views_calendar', 'enabled', true, false)
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId,
                hasRecurrenceItemIndicator: true
            }
        };
    }
});

});
parcelRegister("2El0S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hoRNa").then(()=>parcelRequire('7IGR2'));

});




parcelRegister("5gnJR", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicEmbedRouteEntry", () => $b3792522cdd81cc5$export$6a544072729c1964);

var $6xToB = parcelRequire("6xToB");

var $8Q4qB = parcelRequire("8Q4qB");

var $dsh9d = parcelRequire("dsh9d");

var $7K5Ea = parcelRequire("7K5Ea");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $4cTDP = parcelRequire("4cTDP");

var $hXFFJ = parcelRequire("hXFFJ");
const $b3792522cdd81cc5$export$6a544072729c1964 = (0, $6xToB.createEntry)((0, $8Q4qB.softwareCalendarClassicEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $hXFFJ.softwareCalendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCalendarClassicEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCalendarClassicEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8Q4qB", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $8889ea7696c77d51$export$ced2612fe5124ff8);
const $8889ea7696c77d51$export$ced2612fe5124ff8 = {
    name: 'software-calendar-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});


parcelRegister("gkm2X", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicRouteEntry", () => $8d695f3e68aff2e9$export$17ea82bdc641d5ce);

var $6xToB = parcelRequire("6xToB");

var $4cTDP = parcelRequire("4cTDP");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $buqv4 = parcelRequire("buqv4");

var $dsh9d = parcelRequire("dsh9d");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $hXFFJ = parcelRequire("hXFFJ");
const $8d695f3e68aff2e9$export$17ea82bdc641d5ce = (0, $6xToB.createEntry)((0, $buqv4.softwareCalendarClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dsh9d.CalendarSkeleton),
        component: (0, $dsh9d.CalendarSkeleton),
        entryPoint () {
            // TODO: Adopt sidebar entrypoints when calender route enables SSR
            return 0, $hXFFJ.softwareCalendarRouteEntry;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCalendarClassicRouteEntry.tsx',
                whichExportToUse: 'softwareCalendarClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("buqv4", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $f71d2edc535c1029$export$f2c3b99639d54eb8);
const $f71d2edc535c1029$export$f2c3b99639d54eb8 = {
    name: 'software-calendar-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId?',
    query: [
        'date?'
    ]
};

});


parcelRegister("csjBW", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarCustomEmbedRouteEntry", () => $3dd664dc7cf1ee31$export$bfbf26d8d634e108);

var $7K5Ea = parcelRequire("7K5Ea");

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $2xzsN = parcelRequire("2xzsN");

var $dsh9d = parcelRequire("dsh9d");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $918ZE = parcelRequire("918ZE");
const $3dd664dc7cf1ee31$export$bfbf26d8d634e108 = (0, $6xToB.createEntry)((0, $2xzsN.softwareCalendarCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $918ZE.calendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-calendar-entries/src/softwareCalendarCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCalendarCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2xzsN", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarCustomEmbedRoute", () => $0266de42d58cebf1$export$c933cc18934d5dbd);
const $0266de42d58cebf1$export$c933cc18934d5dbd = {
    name: 'software-calendar-custom-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("918ZE", function(module, exports) {
$parcel$export(module.exports, "calendarRouteEntry", () => $9c81707e353f7761$export$d154630e8966be91);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $eAYvp = parcelRequire("eAYvp");

var $9n5I0 = parcelRequire("9n5I0");
const $9c81707e353f7761$export$d154630e8966be91 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $eAYvp.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("lj5Av", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", () => $1c02e8919743f490$export$24fc07c22f0d06);

var $7K5Ea = parcelRequire("7K5Ea");

var $4cTDP = parcelRequire("4cTDP");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $8OUu2 = parcelRequire("8OUu2");

var $dsh9d = parcelRequire("dsh9d");

var $918ZE = parcelRequire("918ZE");
const $1c02e8919743f490$export$24fc07c22f0d06 = (0, $6xToB.createEntry)((0, $8OUu2.softwareCalendarEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $dsh9d.CalendarEmbedSkeleton),
        component: (0, $dsh9d.CalendarEmbedSkeleton),
        entryPoint () {
            return 0, $918ZE.calendarRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-calendar-entries/src/softwareCalendarEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCalendarEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8OUu2", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarEmbedRoute", () => $5b181687afcf3816$export$b55c4d4efb097c1c);
const $5b181687afcf3816$export$b55c4d4efb097c1c = {
    name: 'software-calendar-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});


parcelRegister("byNoq", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $20ad68e0a08bd95e$export$83b1b9036cc7961a);

var $kHlOR = parcelRequire("kHlOR");

var $4cTDP = parcelRequire("4cTDP");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2wgfj = parcelRequire("2wgfj");

var $dsh9d = parcelRequire("dsh9d");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $918ZE = parcelRequire("918ZE");
const $20ad68e0a08bd95e$export$83b1b9036cc7961a = (0, $6xToB.createEntry)((0, $2wgfj.softwareCalendarRoute), ()=>({
        group: 'software',
        skeleton: (0, $dsh9d.CalendarSkeleton),
        component: (0, $dsh9d.CalendarSkeleton),
        entryPoint () {
            // TODO: Adopt sidebar entrypoints when calender route enables SSR
            return 0, $918ZE.calendarRouteEntry;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-calendar',
        EXPERIMENTAL__shouldReload: ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-calendar-entries/src/softwareCalendarRouteEntry.tsx',
                whichExportToUse: 'softwareCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2wgfj", function(module, exports) {
$parcel$export(module.exports, "softwareCalendarRoute", () => $93c04b7043a930e3$export$d6730f103a4ad844);
const $93c04b7043a930e3$export$d6730f103a4ad844 = {
    name: 'software-calendar',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId?',
    query: [
        'date?'
    ]
};

});


parcelRegister("4aSHo", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicCustomEmbedRouteEntry", () => $a4c212b2ad95e277$export$b0187ea44509bc53);

var $6xToB = parcelRequire("6xToB");

var $b8dFX = parcelRequire("b8dFX");

var $4T7iD = parcelRequire("4T7iD");

var $7K5Ea = parcelRequire("7K5Ea");

var $cxQGT = parcelRequire("cxQGT");

var $36zWJ = parcelRequire("36zWJ");
const $a4c212b2ad95e277$export$b0187ea44509bc53 = (0, $6xToB.createEntry)((0, $b8dFX.softwareCapacityClassicCustomEmbedRoute), ()=>({
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCapacityClassicCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCapacityClassicCustomEmbedRouteEntry'
            },
            enabled: true
        },
        component: (0, $4T7iD.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $36zWJ.softwareCapacityRouteEntry;
        },
        group: 'classic-software',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        skeleton: (0, $4T7iD.CapacityEmbedSkeleton),
        ufoName: 'classic-capacity-embed'
    }));

});
parcelRegister("b8dFX", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicCustomEmbedRoute", () => $e4081cdfb5337267$export$45b14c1b91c44a67);
const $e4081cdfb5337267$export$45b14c1b91c44a67 = {
    name: 'software-capacity-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/:itemId/embed'
};

});

parcelRegister("4T7iD", function(module, exports) {
$parcel$export(module.exports, "CapacitySkeleton", () => $2d60b56c36f63984$export$79fcfa58dbcaf030);
$parcel$export(module.exports, "CapacityEmbedSkeleton", () => $2d60b56c36f63984$export$27d33e13f167f420);
$parcel$export(module.exports, "EntryPointCapacitySkeleton", () => $2d60b56c36f63984$export$e3ff95f25d1f2f36);
/* CapacitySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $hAhpw = parcelRequire("hAhpw");

var $byIOL = parcelRequire("byIOL");

var $lgIFN = parcelRequire("lgIFN");
const $2d60b56c36f63984$export$79fcfa58dbcaf030 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hAhpw))),
        className: (0, $hcewu.default)([
            $2d60b56c36f63984$var$styles.compensateTemplateBorder
        ])
    });
const $2d60b56c36f63984$export$27d33e13f167f420 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($byIOL))),
        className: (0, $hcewu.default)([
            $2d60b56c36f63984$var$styles.compensateTemplateBorder
        ])
    });
const $2d60b56c36f63984$export$a0dc4c0a6f5a9296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lgIFN))),
        className: (0, $hcewu.default)([
            $2d60b56c36f63984$var$styles.noBorder,
            $2d60b56c36f63984$var$styles.compensateTemplateBorder
        ])
    });
const $2d60b56c36f63984$export$e3ff95f25d1f2f36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $2d60b56c36f63984$var$styles.entryPointStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d60b56c36f63984$export$79fcfa58dbcaf030, null));
const $2d60b56c36f63984$var$styles = {
    compensateTemplateBorder: "_t6vdidpf _hr4jidpf _l82tidpf _j7o0idpf",
    entryPointStyles: "_1reo15vq _18m915vq _1rjc1ejb _bozgxy5q _16jlkb7n",
    noBorder: "_1wgmglyw"
};

});
parcelRegister("hAhpw", function(module, exports) {
module.exports = new URL("capacity-app-skeleton.tpl.61191f22.svg", import.meta.url).toString();

});

parcelRegister("byIOL", function(module, exports) {
module.exports = new URL("capacity-embed-app-skeleton.tpl.61191f22.svg", import.meta.url).toString();

});

parcelRegister("lgIFN", function(module, exports) {
module.exports = new URL("capacity-no-header-skeleton.tpl.61191f22.svg", import.meta.url).toString();

});


parcelRegister("36zWJ", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityRouteEntry", () => $010cc877d1fbace0$export$7c0a73481693ad26);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $ctnaK = parcelRequire("ctnaK");

var $9n5I0 = parcelRequire("9n5I0");
const $010cc877d1fbace0$export$7c0a73481693ad26 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $ctnaK.capacityEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("ctnaK", function(module, exports) {
$parcel$export(module.exports, "capacityEntryPoint", () => $b64c2ecdacfcfb4c$export$2ea9514c195131bd);

var $8oKDI = parcelRequire("8oKDI");

var $bdhwY = parcelRequire("bdhwY");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $b64c2ecdacfcfb4c$export$2ea9514c195131bd = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eAwr2")), {
        moduleId: "b5f200d9",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: { match: match }, tenantContext: tenantContext } = entryPointRouteParams;
        const sourceAri = (0, $8oKDI.createAri)({
            resourceOwner: 'jira-software',
            cloudId: tenantContext.cloudId,
            resourceType: 'board',
            resourceId: match.params.boardId ?? ''
        });
        return {
            queries: {
                capacityData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bdhwY.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        id: sourceAri
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                tenantContext: tenantContext
            }
        };
    }
});

});
parcelRegister("bdhwY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0222775157c27924$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bbc039c92ebf3b5f4db0197880b4bd2>>
 * @relayHash c78c24ccfea65d024c1681405fc16940
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 655f8681f6878752f03c9433ed501b192e0197f2e27b417f4ea55d05f54efbd0
const $0222775157c27924$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "655f8681f6878752f03c9433ed501b192e0197f2e27b417f4ea55d05f54efbd0",
        "metadata": {},
        "name": "ui_jiraCapacityQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0222775157c27924$export$2e2bcd8739ae039 = $0222775157c27924$var$node;

});

parcelRegister("eAwr2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2mxQA").then(()=>parcelRequire('1lRYl'));

});




parcelRegister("aNXAx", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicEmbedRouteEntry", () => $3802f50d66c48a89$export$f12fd69ec90efefe);

var $6xToB = parcelRequire("6xToB");

var $efgOq = parcelRequire("efgOq");

var $7K5Ea = parcelRequire("7K5Ea");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $cxQGT = parcelRequire("cxQGT");

var $4T7iD = parcelRequire("4T7iD");

var $36zWJ = parcelRequire("36zWJ");
const $3802f50d66c48a89$export$f12fd69ec90efefe = (0, $6xToB.createEntry)((0, $efgOq.softwareCapacityClassicEmbedRoute), ()=>({
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCapacityClassicEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCapacityClassicEmbedRouteEntry'
            },
            enabled: true
        },
        component: (0, $4T7iD.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $36zWJ.softwareCapacityRouteEntry;
        },
        group: 'classic-software',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource)
        ],
        skeleton: (0, $4T7iD.CapacityEmbedSkeleton),
        ufoName: 'classic-capacity-embed'
    }));

});
parcelRegister("efgOq", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicEmbedRoute", () => $60fba331e17af5dc$export$89fff60bfb87c96f);
const $60fba331e17af5dc$export$89fff60bfb87c96f = {
    name: 'software-capacity-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/embed'
};

});


parcelRegister("jueBm", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicRouteEntry", () => $c5cb9a01f68cf016$export$d503898bb2c92461);

var $eJe5A = parcelRequire("eJe5A");

var $6xToB = parcelRequire("6xToB");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $jxU5i = parcelRequire("jxU5i");

var $8FCAy = parcelRequire("8FCAy");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $kHlOR = parcelRequire("kHlOR");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $4T7iD = parcelRequire("4T7iD");

var $36zWJ = parcelRequire("36zWJ");
const $c5cb9a01f68cf016$export$d503898bb2c92461 = (0, $6xToB.createEntry)((0, $jxU5i.softwareCapacityClassicRoute), ()=>({
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCapacityClassicRouteEntry.tsx',
                whichExportToUse: 'softwareCapacityClassicRouteEntry'
            },
            enabled: true
        },
        component: (0, $4T7iD.CapacitySkeleton),
        entryPoint: ()=>{
            if (false) return undefined;
            return 0, $36zWJ.softwareCapacityRouteEntry;
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        group: 'classic-software',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        skeleton: (0, $4T7iD.CapacitySkeleton),
        supportsPreviewPanel: true,
        ufoName: 'classic-capacity'
    }));

});
parcelRegister("jxU5i", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityClassicRoute", () => $29a17db06845d7d0$export$df4c9b5e5502344a);
const $29a17db06845d7d0$export$df4c9b5e5502344a = {
    name: 'software-capacity-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/:itemId?',
    query: []
};

});


parcelRegister("lMawn", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityCustomEmbedRouteEntry", () => $e4455247d96e426a$export$f0fad2bbd5fe5686);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $92GIJ = parcelRequire("92GIJ");

var $4T7iD = parcelRequire("4T7iD");

var $cxQGT = parcelRequire("cxQGT");

var $hwf64 = parcelRequire("hwf64");
const $e4455247d96e426a$export$f0fad2bbd5fe5686 = (0, $6xToB.createEntry)((0, $92GIJ.softwareCapacityCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $4T7iD.CapacityEmbedSkeleton),
        component: (0, $4T7iD.CapacityEmbedSkeleton),
        entryPoint () {
            return 0, $hwf64.capacityRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        ufoName: 'next-gen-capacity-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-capacity-entries/src/softwareCapacityCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCapacityCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("92GIJ", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityCustomEmbedRoute", () => $c733dd404ab724a1$export$8664e61943fd500b);
const $c733dd404ab724a1$export$8664e61943fd500b = {
    name: 'software-capacity-custom-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:itemId/embed',
    query: []
};

});

parcelRegister("hwf64", function(module, exports) {
$parcel$export(module.exports, "capacityRouteEntry", () => $1bbc471d32e6e232$export$721be00e430c45e);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $ctnaK = parcelRequire("ctnaK");

var $9n5I0 = parcelRequire("9n5I0");
const $1bbc471d32e6e232$export$721be00e430c45e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $ctnaK.capacityEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("hK8mq", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityEmbedRouteEntry", () => $dfe056c5da77a155$export$cb54c8dddff6b9ec);

var $7K5Ea = parcelRequire("7K5Ea");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cxQGT = parcelRequire("cxQGT");

var $cAVBV = parcelRequire("cAVBV");

var $4T7iD = parcelRequire("4T7iD");

var $hwf64 = parcelRequire("hwf64");
const $dfe056c5da77a155$export$cb54c8dddff6b9ec = (0, $6xToB.createEntry)((0, $cAVBV.softwareCapacityEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $4T7iD.CapacityEmbedSkeleton),
        component: (0, $4T7iD.CapacityEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $hwf64.capacityRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cxQGT.themePreferenceResource)
        ],
        ufoName: 'next-gen-capacity-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-capacity-entries/src/softwareCapacityEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareCapacityEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("cAVBV", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityEmbedRoute", () => $deb13b96ce3baf6e$export$110f0eb799e55036);
const $deb13b96ce3baf6e$export$110f0eb799e55036 = {
    name: 'software-capacity-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/embed',
    query: []
};

});


parcelRegister("33rS9", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityRouteEntry", () => $04c34d38079b626f$export$7c0a73481693ad26);

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5dG6f = parcelRequire("5dG6f");

var $4T7iD = parcelRequire("4T7iD");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $hwf64 = parcelRequire("hwf64");
const $04c34d38079b626f$export$7c0a73481693ad26 = (0, $6xToB.createEntry)((0, $5dG6f.softwareCapacityRoute), ()=>({
        group: 'software',
        skeleton: (0, $4T7iD.EntryPointCapacitySkeleton),
        component: (0, $4T7iD.EntryPointCapacitySkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $hwf64.capacityRouteEntry;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-capacity',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-capacity-entries/src/softwareCapacityRouteEntry.tsx',
                whichExportToUse: 'softwareCapacityRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5dG6f", function(module, exports) {
$parcel$export(module.exports, "softwareCapacityRoute", () => $e6505fe1f858e9cb$export$57ddb8414c776aa1);
const $e6505fe1f858e9cb$export$57ddb8414c776aa1 = {
    name: 'software-capacity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:itemId?',
    query: []
};

});


parcelRegister("6PPxR", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRouteEntry", () => $b63b5b0e2ecb1474$export$fdc2679a6c96e9fa);

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $57pa9 = parcelRequire("57pa9");

var $7K5Ea = parcelRequire("7K5Ea");

var $cuS8Q = parcelRequire("cuS8Q");
const $b63b5b0e2ecb1474$export$fdc2679a6c96e9fa = (0, $6xToB.createEntry)((0, $57pa9.softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-software',
        component: (0, $cuS8Q.default),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $cuS8Q.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareClassicProformaIssueFormsDirectEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareClassicProformaIssueFormsDirectEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("57pa9", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $826edc65664f9b16$export$16987cdd084cceba);
const $826edc65664f9b16$export$16987cdd084cceba = {
    name: 'classic-software-proforma-issue-forms-direct-embed',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("cuS8Q", function(module, exports) {
$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $3155c18e256636f9$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $3155c18e256636f9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $3155c18e256636f9$export$22681210aaeb910f = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eEKFl")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
const $3155c18e256636f9$var$AsyncProformaIssueFormsDirectEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $3155c18e256636f9$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });
var $3155c18e256636f9$export$2e2bcd8739ae039 = $3155c18e256636f9$var$AsyncProformaIssueFormsDirectEmbed;

});


parcelRegister("5JTZa", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRouteEntry", () => $3abe2c698c8344e5$export$8fd8b0cbd2b8730d);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $4W8oE = parcelRequire("4W8oE");

var $8FCAy = parcelRequire("8FCAy");

var $dZRaT = parcelRequire("dZRaT");

var $eSmGL = parcelRequire("eSmGL");
const $3abe2c698c8344e5$export$8fd8b0cbd2b8730d = (0, $6xToB.createEntry)((0, $4W8oE.softwareClassicProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-software',
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        entryPoint: ()=>(0, $eSmGL.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareClassicProformaIssueFormsDirectRouteEntry.tsx',
                whichExportToUse: 'softwareClassicProformaIssueFormsDirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4W8oE", function(module, exports) {
$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $6bdce9ddbe68bb44$export$92f34907c6bf7007);
const $6bdce9ddbe68bb44$export$92f34907c6bf7007 = {
    name: 'classic-software-proforma-issue-forms-direct',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("eSmGL", function(module, exports) {
$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $a5339dfb4f906c10$export$dc0bb5719ae7aab4);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $cZ31R = parcelRequire("cZ31R");
const $a5339dfb4f906c10$export$dc0bb5719ae7aab4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $cZ31R.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("jSZVk", function(module, exports) {
$parcel$export(module.exports, "softwareCodeClassicRouteEntry", () => $c4dc8daca42ff91d$export$6acfada96c85cfaa);

var $6xToB = parcelRequire("6xToB");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $5RW99 = parcelRequire("5RW99");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $2t6re = parcelRequire("2t6re");

var $69OMV = parcelRequire("69OMV");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $k6duF = parcelRequire("k6duF");

var $kSeQy = parcelRequire("kSeQy");

var $4cTDP = parcelRequire("4cTDP");

var $5L7qx = parcelRequire("5L7qx");

var $9yLWd = parcelRequire("9yLWd");
const $c4dc8daca42ff91d$export$6acfada96c85cfaa = (0, $6xToB.createEntry)((0, $2t6re.softwareCodeClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('jira-code-page-to-ugs-v2'), (0, $69OMV.codePageResource))
        ],
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        entryPoint: ()=>{
            if ((0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $9yLWd.softwareCodeClassicPageEntrypoint;
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareCodeClassicRouteEntry.tsx',
                whichExportToUse: 'softwareCodeClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2t6re", function(module, exports) {
$parcel$export(module.exports, "softwareCodeClassicRoute", () => $2c7f122e1ae77465$export$d92cd77785d00ff);
const $2c7f122e1ae77465$export$d92cd77785d00ff = {
    name: 'software-code-classic',
    path: '/jira/software/c/projects/:projectKey/code'
};

});

parcelRegister("69OMV", function(module, exports) {
$parcel$export(module.exports, "codePageResource", () => $3422c76a34780ba7$export$642ce64cf3689406);

var $9FYIg = parcelRequire("9FYIg");

var $1TmXY = parcelRequire("1TmXY");

var $6Izrp = parcelRequire("6Izrp");

let $3422c76a34780ba7$var$numPullRequestsToFetch = 0;
const $3422c76a34780ba7$export$642ce64cf3689406 = (0, $9FYIg.createRelayResource)({
    type: (0, $7139579265915770$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === 'software-code' || name === 'software-code-classic';
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$3422c76a34780ba7$var$numPullRequestsToFetch && isCodeRoute) $3422c76a34780ba7$var$numPullRequestsToFetch = (0, $6Izrp.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $3422c76a34780ba7$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $1TmXY.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $6Izrp.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $3422c76a34780ba7$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("1TmXY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0151ffd755126d1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47b8b8a8f37a9be189f9a9d2007adc77>>
 * @relayHash a6304167807bdf56ba40777b77417189
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed53692ec0f4476991e46cd6ebd1b8793ca4cf16afd5f07cf1785471b8ec988f
const $0151ffd755126d1a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = [
        v7 /*: any*/ 
    ], v14 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v8 /*: any*/ 
    ], v15 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v16 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        v11 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CodePageRootQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "configState",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v13 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v13 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SoftwareMainPagePage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CodePageRootQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v18 /*: any*/ 
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v17 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v23 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ed53692ec0f4476991e46cd6ebd1b8793ca4cf16afd5f07cf1785471b8ec988f",
            "metadata": {},
            "name": "CodePageRootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0151ffd755126d1a$var$node.hash = "ecd6b48636b1c53faca86fa3012183b9";
var $0151ffd755126d1a$export$2e2bcd8739ae039 = $0151ffd755126d1a$var$node;

});

parcelRegister("6Izrp", function(module, exports) {
$parcel$export(module.exports, "isBitbucketProvider", () => $019a3c4cc0709d97$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $019a3c4cc0709d97$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $019a3c4cc0709d97$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $019a3c4cc0709d97$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $019a3c4cc0709d97$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $019a3c4cc0709d97$export$a837c7c9c7670570);

var $eJOHy = parcelRequire("eJOHy");

var $2Cxb3 = parcelRequire("2Cxb3");

var $2InI0 = parcelRequire("2InI0");
var $8XZn3 = parcelRequire("8XZn3");

var $9soX0 = parcelRequire("9soX0");

var $jqVmJ = parcelRequire("jqVmJ");
const $019a3c4cc0709d97$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $jqVmJ.RepositoryTypes).REPO_BITBUCKET;
const $019a3c4cc0709d97$export$1f508885be28c4e = (providerId)=>providerId === (0, $9soX0.VcsProviderIds).BITBUCKET || providerId === (0, $9soX0.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $9soX0.DataDepotProviderIds).BITBUCKET_STG;
const $019a3c4cc0709d97$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $9soX0.nonCriticalGqlErrors),
        ...(0, $9soX0.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $019a3c4cc0709d97$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $019a3c4cc0709d97$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $019a3c4cc0709d97$export$36fdccbdcd093523 = (url)=>(0, $2Cxb3.sanitizeUrl)(url);
const $019a3c4cc0709d97$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $019a3c4cc0709d97$export$3784bdf6b4807521 = ()=>(0, $2InI0.default)((0, $8XZn3.default)(new Date(), {
        days: (0, $9soX0.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $019a3c4cc0709d97$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $9soX0.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $9soX0.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $9soX0.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("2Cxb3", function(module, exports) {
'use strict';
var $1e88ddb581a2ec8f$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $1e88ddb581a2ec8f$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $1e88ddb581a2ec8f$var$urlSchemeRegex = /^([^:]+):/gm;
var $1e88ddb581a2ec8f$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $1e88ddb581a2ec8f$var$isRelativeUrl(url) {
    return $1e88ddb581a2ec8f$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $1e88ddb581a2ec8f$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($1e88ddb581a2ec8f$var$ctrlCharactersRegex, '');
    if ($1e88ddb581a2ec8f$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($1e88ddb581a2ec8f$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($1e88ddb581a2ec8f$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $1e88ddb581a2ec8f$var$sanitizeUrl
};

});

parcelRegister("9soX0", function(module, exports) {
$parcel$export(module.exports, "nonCriticalGqlErrors", () => $08bf2cda6ff24883$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $08bf2cda6ff24883$export$687544614e0812da);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $08bf2cda6ff24883$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $08bf2cda6ff24883$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $08bf2cda6ff24883$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $08bf2cda6ff24883$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $08bf2cda6ff24883$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $08bf2cda6ff24883$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $08bf2cda6ff24883$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $08bf2cda6ff24883$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $08bf2cda6ff24883$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $08bf2cda6ff24883$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $08bf2cda6ff24883$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $08bf2cda6ff24883$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $08bf2cda6ff24883$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $08bf2cda6ff24883$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $08bf2cda6ff24883$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $08bf2cda6ff24883$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $08bf2cda6ff24883$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $08bf2cda6ff24883$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $08bf2cda6ff24883$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $08bf2cda6ff24883$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $08bf2cda6ff24883$export$a46febdd3fe90de0);
$parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", () => $08bf2cda6ff24883$export$333db4cac7ee017);
$parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", () => $08bf2cda6ff24883$export$5cbae081959768bd);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $08bf2cda6ff24883$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $08bf2cda6ff24883$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $08bf2cda6ff24883$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $08bf2cda6ff24883$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $08bf2cda6ff24883$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $08bf2cda6ff24883$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $08bf2cda6ff24883$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $08bf2cda6ff24883$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $08bf2cda6ff24883$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $08bf2cda6ff24883$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $08bf2cda6ff24883$export$7912a169c18abe9d);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $08bf2cda6ff24883$export$74189cec821240a6);
$parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", () => $08bf2cda6ff24883$export$3f3fc252f5066c72);
$parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", () => $08bf2cda6ff24883$export$9ce5b1bba5f17875);
$parcel$export(module.exports, "CODE_TAB_NAMESPACE", () => $08bf2cda6ff24883$export$f3873cacb48e85d4);
$parcel$export(module.exports, "LOCAL_STORAGE_GO_TO_DEVELOPMENT_KEY", () => $08bf2cda6ff24883$export$e9ce282f5e635322);
$parcel$export(module.exports, "CODE_TAB_MIGRATION_ANALYTICS", () => $08bf2cda6ff24883$export$49902d80a065c2d5);
const $08bf2cda6ff24883$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $08bf2cda6ff24883$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $08bf2cda6ff24883$export$7527a73da794030d = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)";
const $08bf2cda6ff24883$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $08bf2cda6ff24883$export$f84c6b6609a3dd30 = 1000;
const $08bf2cda6ff24883$export$ea15b38f3901f518 = 12;
const $08bf2cda6ff24883$export$2b8b0a4489f9147b = 30;
const $08bf2cda6ff24883$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $08bf2cda6ff24883$export$256a9f141103f328 = 'repository-list-header';
const $08bf2cda6ff24883$export$b0d4e90e40369b80 = 'repository-list-description';
const $08bf2cda6ff24883$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $08bf2cda6ff24883$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $08bf2cda6ff24883$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $08bf2cda6ff24883$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $08bf2cda6ff24883$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $08bf2cda6ff24883$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $08bf2cda6ff24883$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $08bf2cda6ff24883$export$4ed9a8a7faf641f = `${$08bf2cda6ff24883$export$f69d7aa9c5e17d55}.title-link`;
const $08bf2cda6ff24883$export$c5322e755fd1028d = `${$08bf2cda6ff24883$export$f69d7aa9c5e17d55}.target-branch-link`;
const $08bf2cda6ff24883$export$72fcd104fde041d6 = `${$08bf2cda6ff24883$export$f69d7aa9c5e17d55}.repository-link`;
const $08bf2cda6ff24883$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $08bf2cda6ff24883$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $08bf2cda6ff24883$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $08bf2cda6ff24883$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $08bf2cda6ff24883$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $08bf2cda6ff24883$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $08bf2cda6ff24883$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
const $08bf2cda6ff24883$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
const $08bf2cda6ff24883$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $08bf2cda6ff24883$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $08bf2cda6ff24883$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $08bf2cda6ff24883$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $08bf2cda6ff24883$export$39983b6fb040a5eb = 'summaryFilter';
const $08bf2cda6ff24883$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $08bf2cda6ff24883$export$8a8927c29ab32b10 = 'reviewersFilter';
const $08bf2cda6ff24883$export$3e8168848b996f7 = 'statusFilter';
const $08bf2cda6ff24883$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $08bf2cda6ff24883$export$6da773286c35ef41 = 'sortKey';
const $08bf2cda6ff24883$export$810a1f7ed2facfcb = 'sortOrder';
const $08bf2cda6ff24883$export$ba75fb5089c0eb0b = [
    $08bf2cda6ff24883$export$39983b6fb040a5eb,
    $08bf2cda6ff24883$export$3d96f5f9ccd35be6,
    $08bf2cda6ff24883$export$8a8927c29ab32b10,
    $08bf2cda6ff24883$export$3e8168848b996f7,
    $08bf2cda6ff24883$export$4adc519ba40b72a6,
    $08bf2cda6ff24883$export$6da773286c35ef41,
    $08bf2cda6ff24883$export$810a1f7ed2facfcb
];
const $08bf2cda6ff24883$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $08bf2cda6ff24883$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
    GITHUB_PROD: 'com.github.integration.production',
    GITHUB_STG: 'com.github.integration.staging'
};
const $08bf2cda6ff24883$export$74189cec821240a6 = 'jsw.code.page.header';
const $08bf2cda6ff24883$export$3f3fc252f5066c72 = [
    'NOT_CONFIGURED',
    'NOT_SET',
    'PARTIALLY_CONFIGURED'
];
const $08bf2cda6ff24883$export$9ce5b1bba5f17875 = [
    'CONFIGURED',
    'PROVIDER_ACTION_CONFIGURED',
    'PROVIDER_ACTION_NOT_CONFIGURED'
];
const $08bf2cda6ff24883$export$f3873cacb48e85d4 = 'jira-software-code-tab';
const $08bf2cda6ff24883$export$e9ce282f5e635322 = 'clickedGoToDevelopment';
const $08bf2cda6ff24883$export$49902d80a065c2d5 = 'jiraCodePageMigrationModal';

});

parcelRegister("jqVmJ", function(module, exports) {
$parcel$export(module.exports, "numberToTimestamp", () => $dd855e50f62453b1$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $dd855e50f62453b1$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $dd855e50f62453b1$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $dd855e50f62453b1$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $dd855e50f62453b1$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $dd855e50f62453b1$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $dd855e50f62453b1$var$VcsProviderNamespaces = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $7139579265915770$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("9yLWd", function(module, exports) {
$parcel$export(module.exports, "softwareCodeClassicPageEntrypoint", () => $19ad5b2dbdf460d4$export$10463031c8017b);

var $8BZWz = parcelRequire("8BZWz");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $19ad5b2dbdf460d4$export$10463031c8017b = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8BZWz.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8BZWz", function(module, exports) {
$parcel$export(module.exports, "softwareCodeEntrypoint", () => $13570c8fe94ae953$export$7dbaba2b508f1f10);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

const $13570c8fe94ae953$export$7dbaba2b508f1f10 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8ZfXv")).then(({ default: CodeSpa, CodeSpaV2: CodeSpaV2 })=>{
            if ((0, $4cTDP.fg)('jira-code-page-to-ugs-v2')) return CodeSpaV2;
            return CodeSpa;
        }), {
        moduleId: "ba9a9980",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8ZfXv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9fQbt").then(()=>parcelRequire('4oP0D'));

});




parcelRegister("8JIqa", function(module, exports) {
$parcel$export(module.exports, "softwareCodeRouteEntry", () => $7b3764e94a4ccc52$export$eac18b7aea4cb524);

var $kHlOR = parcelRequire("kHlOR");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $69OMV = parcelRequire("69OMV");

var $bTfc4 = parcelRequire("bTfc4");

var $9BJU1 = parcelRequire("9BJU1");

var $jG8Tx = parcelRequire("jG8Tx");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $4cTDP = parcelRequire("4cTDP");

var $kSeQy = parcelRequire("kSeQy");

var $5L7qx = parcelRequire("5L7qx");

var $flbHM = parcelRequire("flbHM");

var $f2u3c = parcelRequire("f2u3c");
const $7b3764e94a4ccc52$var$getHorizontalNavResource = ()=>(0, $4cTDP.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $b4jBr.horizontalNavJiraResource)
    ];
const $7b3764e94a4ccc52$export$eac18b7aea4cb524 = (0, $6xToB.createEntry)((0, $jG8Tx.softwareCodeRoute), ()=>({
        group: 'software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $flbHM.CodePageNextGen)),
        layout: (0, $8FCAy.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            ...$7b3764e94a4ccc52$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>!(0, $4cTDP.fg)('jira-code-page-to-ugs-v2'), (0, $69OMV.codePageResource))
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $flbHM.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $4cTDP.fg)('entrypoint_migration_for_software_code')) return (0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $f2u3c.softwareCodeNextGenPageEntrypoint);
            return undefined;
        },
        ufoName: 'next-gen-code',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareCodeRouteEntry.tsx',
                whichExportToUse: 'softwareCodeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jG8Tx", function(module, exports) {
$parcel$export(module.exports, "softwareCodeRoute", () => $8320cfb3935b8230$export$9d24fc75b0f1d9a0);
const $8320cfb3935b8230$export$9d24fc75b0f1d9a0 = {
    name: 'software-code',
    path: '/jira/software/projects/:projectKey/code'
};

});

parcelRegister("flbHM", function(module, exports) {
$parcel$export(module.exports, "LazyCode", () => $4912de0d99590b51$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageNextGen", () => $4912de0d99590b51$export$d9e8184332f86b53);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $jKFLP = parcelRequire("jKFLP");

const $4912de0d99590b51$export$4beafd9dbad29bff = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bLTzM"))), {
    moduleId: "./src/packages/spa-apps/code/src/ui/index-old.tsx"
});
const $4912de0d99590b51$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4912de0d99590b51$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $jKFLP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("jKFLP", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $d146cc2717f20ff5$export$557c2f222778cea6);

var $b5RwB = parcelRequire("b5RwB");
const $d146cc2717f20ff5$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(location.search);
    return rapidView;
};

});

parcelRegister("bLTzM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2bwO4").then(()=>parcelRequire('ipuf7'));

});


parcelRegister("f2u3c", function(module, exports) {
$parcel$export(module.exports, "softwareCodeNextGenPageEntrypoint", () => $6bf2061c65d8ce3b$export$bba7318d4079a95);

var $3MgfG = parcelRequire("3MgfG");

var $8BZWz = parcelRequire("8BZWz");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");
const $6bf2061c65d8ce3b$export$bba7318d4079a95 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8BZWz.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("bTXFE", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", () => $e1dfb90c5fd4fe56$export$dcf1f9ba660dedf6);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kFkcB = parcelRequire("kFkcB");

var $bTfc4 = parcelRequire("bTfc4");

var $96VSM = parcelRequire("96VSM");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $kylqU = parcelRequire("kylqU");
const $e1dfb90c5fd4fe56$export$dcf1f9ba660dedf6 = (0, $6xToB.createEntry)((0, $96VSM.softwareDeploymentsClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kFkcB.deploymentPreconditionRelayResource),
            (0, $dZRaT.projectContextResource)
        ],
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        entryPoint: ()=>(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $kylqU.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-deployments-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-deployments-entries/src/softwareDeploymentsClassicRouteEntry.tsx',
                whichExportToUse: 'softwareDeploymentsClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kFkcB", function(module, exports) {
$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $9ffc505b6a6bfcb8$export$50e4eedb9e6127c8);

var $9FYIg = parcelRequire("9FYIg");

var $2BkdW = parcelRequire("2BkdW");

var $l1VxS = parcelRequire("l1VxS");


const $9ffc505b6a6bfcb8$export$a1c09d7f7318f85c = (0, $l1VxS.createResource)({
    type: (0, $65b5c35a4ec942b1$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("7SO8B")),
    maxAge: 60000
});
const $9ffc505b6a6bfcb8$export$50e4eedb9e6127c8 = (0, $9FYIg.createRelayResource)({
    type: (0, $65b5c35a4ec942b1$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2BkdW.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("2BkdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1e9fc8e8b3f01de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $c1e9fc8e8b3f01de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c1e9fc8e8b3f01de$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $c1e9fc8e8b3f01de$export$2e2bcd8739ae039 = $c1e9fc8e8b3f01de$var$node;

});

const $65b5c35a4ec942b1$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $65b5c35a4ec942b1$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("7SO8B", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("k1CW8").then(()=>parcelRequire('gzIjF'));

});


parcelRegister("96VSM", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsClassicRoute", () => $98821db9f1d4db09$export$485e4a7b82f29d70);
const $98821db9f1d4db09$export$485e4a7b82f29d70 = {
    name: 'software-deployments-classic',
    path: '/jira/software/c/projects/:projectKey/deployments'
};

});

parcelRegister("kylqU", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsPageEntrypoint", () => $6dda230467864fac$export$44d7744645dea53c);

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $5RW99 = parcelRequire("5RW99");

var $k6TPZ = parcelRequire("k6TPZ");
const $6dda230467864fac$export$44d7744645dea53c = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $k6TPZ.softwareDeploymentsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("k6TPZ", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsEntrypoint", () => $6e18ab705d1455cf$export$c51c7780e55a0186);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $6e18ab705d1455cf$export$c51c7780e55a0186 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8dz3h")), {
        moduleId: "12d277d5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8dz3h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("93Hs0").then(()=>parcelRequire('8pGkY'));

});




parcelRegister("exjbO", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", () => $6403acfa15eb01d4$export$7e5ccb20ad8e1612);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kFkcB = parcelRequire("kFkcB");

var $bTfc4 = parcelRequire("bTfc4");

var $bQ4pb = parcelRequire("bQ4pb");

var $jom8W = parcelRequire("jom8W");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $kylqU = parcelRequire("kylqU");
const $6403acfa15eb01d4$export$7e5ccb20ad8e1612 = (0, $6xToB.createEntry)((0, $bQ4pb.softwareDeploymentsNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kFkcB.deploymentPreconditionRelayResource),
            (0, $dZRaT.projectContextResource)
        ],
        entryPoint: ()=>(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $kylqU.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-deployments'),
                teamName: 'fusion-solaris'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-deployments-entries/src/softwareDeploymentsNextGenRouteEntry.tsx',
                whichExportToUse: 'softwareDeploymentsNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bQ4pb", function(module, exports) {
$parcel$export(module.exports, "softwareDeploymentsNextGenRoute", () => $968c98efc1239f57$export$4b0939825a323ea5);
const $968c98efc1239f57$export$4b0939825a323ea5 = {
    name: 'software-deployments',
    path: '/jira/software/projects/:projectKey/deployments'
};

});


parcelRegister("37n4w", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderClassicRouteEntry", () => $a5b197477aa02b32$export$96aa488380334044);

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $6m3Bu = parcelRequire("6m3Bu");

var $8MGdZ = parcelRequire("8MGdZ");

var $9n5I0 = parcelRequire("9n5I0");

var $8FCAy = parcelRequire("8FCAy");

var $k6duF = parcelRequire("k6duF");

var $g8uYY = parcelRequire("g8uYY");

var $6zXPf = parcelRequire("6zXPf");

var $hS1gr = parcelRequire("hS1gr");

var $ebuR2 = parcelRequire("ebuR2");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $a5b197477aa02b32$var$formBuilderPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8MGdZ.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $a5b197477aa02b32$export$96aa488380334044 = (0, $6xToB.createEntry)((0, $6m3Bu.softwareFormBuilderClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-builder',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>$a5b197477aa02b32$var$formBuilderPageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareFormBuilderClassicRouteEntry.tsx',
                whichExportToUse: 'softwareFormBuilderClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6m3Bu", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $ee3a4667f2706e1b$export$f6cfee0232aa1e);
const $ee3a4667f2706e1b$export$f6cfee0232aa1e = {
    name: 'software-form-builder-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("8MGdZ", function(module, exports) {
$parcel$export(module.exports, "formBuilderEntrypoint", () => $c0d821b26f00e7c8$export$6d3c9fa7232f412c);

var $7Przm = parcelRequire("7Przm");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $c0d821b26f00e7c8$export$6d3c9fa7232f412c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2Zf5v")), {
        moduleId: "db75fa46",
        moduleName: "JiraSoftwareFormBuilderApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7Przm.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("7Przm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0b749ff372c13be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5152123c5deccf99b1d648d9eba4f49d>>
 * @relayHash 494d8258faf52b56ead95e20e76dd5f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 61c7c3c454dc6822fea33b1b6d5c9002b0be0f4002aa1362d23caf71e7dba486
const $f0b749ff372c13be$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "61c7c3c454dc6822fea33b1b6d5c9002b0be0f4002aa1362d23caf71e7dba486",
        "metadata": {},
        "name": "JiraSoftwareFormBuilderAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f0b749ff372c13be$export$2e2bcd8739ae039 = $f0b749ff372c13be$var$node;

});

parcelRegister("2Zf5v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ed8Gs").then(()=>parcelRequire('6qIoF'));

});



parcelRegister("l7Kcl", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderRouteEntry", () => $61d7218194c95f0b$export$e8dede7671fad23d);

var $3MgfG = parcelRequire("3MgfG");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kSeQy = parcelRequire("kSeQy");

var $h6XNG = parcelRequire("h6XNG");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $8MGdZ = parcelRequire("8MGdZ");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");
const $61d7218194c95f0b$var$formBuilderPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8MGdZ.formBuilderEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $61d7218194c95f0b$export$e8dede7671fad23d = (0, $6xToB.createEntry)((0, $h6XNG.softwareFormBuilderRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-builder',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $cxKOj.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $61d7218194c95f0b$var$formBuilderPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-form-builder-entries/src/softwareFormBuilderRouteEntry.tsx',
                whichExportToUse: 'softwareFormBuilderRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("h6XNG", function(module, exports) {
$parcel$export(module.exports, "softwareFormBuilderRoute", () => $9cbe7e4d60be9b83$export$c5589046ee2a390d);
const $9cbe7e4d60be9b83$export$c5589046ee2a390d = {
    name: 'software-form-builder',
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("kbvuM", function(module, exports) {
$parcel$export(module.exports, "softwareFormClassicRouteEntry", () => $75b37ca109f0b5ff$export$4bb0f20ad6471148);

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $9n5I0 = parcelRequire("9n5I0");

var $ebuR2 = parcelRequire("ebuR2");

var $fZgSW = parcelRequire("fZgSW");

var $a7sAc = parcelRequire("a7sAc");

var $g8uYY = parcelRequire("g8uYY");

var $8FCAy = parcelRequire("8FCAy");

var $k6duF = parcelRequire("k6duF");

var $6zXPf = parcelRequire("6zXPf");

var $hS1gr = parcelRequire("hS1gr");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $75b37ca109f0b5ff$var$formPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7sAc.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $75b37ca109f0b5ff$export$4bb0f20ad6471148 = (0, $6xToB.createEntry)((0, $fZgSW.softwareFormClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>$75b37ca109f0b5ff$var$formPageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareFormClassicRouteEntry.tsx',
                whichExportToUse: 'softwareFormClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fZgSW", function(module, exports) {
$parcel$export(module.exports, "softwareFormClassicRoute", () => $eba04b6d56c03ae9$export$ae560ee5b676193d);
const $eba04b6d56c03ae9$export$ae560ee5b676193d = {
    name: 'software-form-classic',
    path: '/jira/software/c/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("a7sAc", function(module, exports) {
$parcel$export(module.exports, "formEntrypoint", () => $898b31bc54797eaa$export$b931eb60522f687a);

var $3NsVt = parcelRequire("3NsVt");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $898b31bc54797eaa$export$b931eb60522f687a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("1bn1c")), {
        moduleId: "16293cbe",
        moduleName: "JiraSoftwareFormApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3NsVt.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("3NsVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $2360fc5d80006b1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cb6ec97b5d80f17cf95a2ad98f1f0a7>>
 * @relayHash 3e504c2a5cd0303a43a0d4f9f1731b08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c7d3d77866ff1cede55d066114d2d3a2ca66881db35990578af056b96d50101
const $2360fc5d80006b1a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0c7d3d77866ff1cede55d066114d2d3a2ca66881db35990578af056b96d50101",
        "metadata": {},
        "name": "JiraSoftwareFormAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2360fc5d80006b1a$export$2e2bcd8739ae039 = $2360fc5d80006b1a$var$node;

});

parcelRegister("1bn1c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dNaIr").then(()=>parcelRequire('jDcuT'));

});



parcelRegister("1XNI6", function(module, exports) {
$parcel$export(module.exports, "softwareFormRouteEntry", () => $703a9c7badaed8d3$export$563e3b39911993a0);

var $3MgfG = parcelRequire("3MgfG");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kSeQy = parcelRequire("kSeQy");

var $eIYCl = parcelRequire("eIYCl");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $a7sAc = parcelRequire("a7sAc");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");
const $703a9c7badaed8d3$var$formPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7sAc.formEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $703a9c7badaed8d3$export$563e3b39911993a0 = (0, $6xToB.createEntry)((0, $eIYCl.softwareFormRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), (0, $hS1gr.AsyncHorizontalNavJira), ()=>null),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingM2Enabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $cxKOj.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $703a9c7badaed8d3$var$formPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-form-entries/src/softwareFormRouteEntry.tsx',
                whichExportToUse: 'softwareFormRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eIYCl", function(module, exports) {
$parcel$export(module.exports, "softwareFormRoute", () => $216549ad7f75ac2f$export$a46217d369231a5);
const $216549ad7f75ac2f$export$a46217d369231a5 = {
    name: 'software-form',
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("8RT9n", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicPublicRouteEntry", () => $896536a7fbfeb4e7$export$df7e146d38db5cc0);

var $6xToB = parcelRequire("6xToB");

var $kSeQy = parcelRequire("kSeQy");

var $cxKOj = parcelRequire("cxKOj");

var $lahED = parcelRequire("lahED");

var $cxQGT = parcelRequire("cxQGT");

var $7K5Ea = parcelRequire("7K5Ea");

var $7TTbh = parcelRequire("7TTbh");
const $896536a7fbfeb4e7$export$df7e146d38db5cc0 = (0, $6xToB.createEntry)((0, $lahED.softwareFormSubmitClassicPublicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-public',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        // This public route should not include
        // DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
        // remove all usages of projectKey.
        entryPoint: ()=>(0, $cxKOj.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $7TTbh.formSubmitPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareFormSubmitClassicPublicRouteEntry.tsx',
                whichExportToUse: 'softwareFormSubmitClassicPublicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lahED", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicPublicRoute", () => $cc78b2ecc013efd7$export$c66ba06e288dec3f);
const $cc78b2ecc013efd7$export$c66ba06e288dec3f = {
    name: 'software-form-submit-classic-public',
    path: '/jira/software/c/form/:formUuid',
    exact: true
};

});


parcelRegister("9kqeg", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicRouteEntry", () => $70ca0463cf4e995d$export$a7c8812838762453);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $kSeQy = parcelRequire("kSeQy");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $aoaVN = parcelRequire("aoaVN");

var $g8uYY = parcelRequire("g8uYY");

var $cxKOj = parcelRequire("cxKOj");

var $ebuR2 = parcelRequire("ebuR2");

var $ckYat = parcelRequire("ckYat");

var $7K5Ea = parcelRequire("7K5Ea");
const $70ca0463cf4e995d$var$formSubmitPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aoaVN.formSubmitEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $70ca0463cf4e995d$export$a7c8812838762453 = (0, $6xToB.createEntry)((0, $ckYat.softwareFormSubmitClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $cxKOj.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $70ca0463cf4e995d$var$formSubmitPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareFormSubmitClassicRouteEntry.tsx',
                whichExportToUse: 'softwareFormSubmitClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aoaVN", function(module, exports) {
$parcel$export(module.exports, "formSubmitEntrypoint", () => $54930d830c3d9282$export$d33b8db02e0a0cb5);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $54930d830c3d9282$export$d33b8db02e0a0cb5 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3ksNF")), {
        moduleId: "3c821c06",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3ksNF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1lm4z").then(()=>parcelRequire('geWLV'));

});


parcelRegister("ckYat", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $bb161fe5a17a8e14$export$91d6851bf27349);
const $bb161fe5a17a8e14$export$91d6851bf27349 = {
    name: 'software-form-submit-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("hRXMa", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRouteEntry", () => $f63f40f2e0871124$export$ffc85d68201bbe35);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $ebuR2 = parcelRequire("ebuR2");

var $7K5Ea = parcelRequire("7K5Ea");

var $16OA8 = parcelRequire("16OA8");

var $9j04o = parcelRequire("9j04o");

var $g8uYY = parcelRequire("g8uYY");
const $f63f40f2e0871124$var$formSubmitEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9j04o.formSubmitEmbedEntrypoint)
});
const $f63f40f2e0871124$export$ffc85d68201bbe35 = (0, $6xToB.createEntry)((0, $16OA8.softwareFormSubmitEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        // eslint-disable-next-line camelcase
        resources: [
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $f63f40f2e0871124$var$formSubmitEmbedPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareFormSubmitEmbedClassicRouteEntry.tsx',
                whichExportToUse: 'softwareFormSubmitEmbedClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("16OA8", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRoute", () => $8e9c0ddaa7da9036$export$812703a022333f7c);
const $8e9c0ddaa7da9036$export$812703a022333f7c = {
    name: 'software-form-submit-classic-embed',
    path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("9j04o", function(module, exports) {
$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $ed5c84a8270281c4$export$4c748d8ca82fc24);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $ed5c84a8270281c4$export$4c748d8ca82fc24 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("8fHpn")), {
        moduleId: "d6417f2e",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8fHpn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9VX13").then(()=>parcelRequire('1VFmu'));

});



parcelRegister("lPhuN", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedRouteEntry", () => $482b5af550825591$export$ac2e374edf86801f);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $apFR8 = parcelRequire("apFR8");

var $9j04o = parcelRequire("9j04o");

var $g8uYY = parcelRequire("g8uYY");
const $482b5af550825591$var$formSubmitEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $9j04o.formSubmitEmbedEntrypoint)
});
const $482b5af550825591$export$ac2e374edf86801f = (0, $6xToB.createEntry)((0, $apFR8.softwareFormSubmitEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        // eslint-disable-next-line camelcase
        resources: [
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return $482b5af550825591$var$formSubmitEmbedPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-form-submit-embed-entries/src/softwareFormSubmitEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareFormSubmitEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("apFR8", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitEmbedRoute", () => $2bba8b7741d3b01b$export$2bee26f083dc2946);
const $2bba8b7741d3b01b$export$2bee26f083dc2946 = {
    name: 'software-form-submit-embed',
    path: '/jira/software/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("4Cdj7", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitPublicRouteEntry", () => $6a0a3672e2de4170$export$70893a47a5c041fd);

var $6xToB = parcelRequire("6xToB");

var $kSeQy = parcelRequire("kSeQy");

var $cxKOj = parcelRequire("cxKOj");

var $4PECA = parcelRequire("4PECA");

var $7K5Ea = parcelRequire("7K5Ea");

var $7TTbh = parcelRequire("7TTbh");

var $cxQGT = parcelRequire("cxQGT");
const $6a0a3672e2de4170$export$70893a47a5c041fd = (0, $6xToB.createEntry)((0, $4PECA.softwareFormSubmitPublicRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-public',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $cxQGT.themePreferenceResource)
        ],
        // This public route should not include
        // DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
        // remove all usages of projectKey.
        entryPoint: ()=>{
            return (0, $cxKOj.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $7TTbh.formSubmitPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-form-submit-public-entries/src/softwareFormSubmitPublicRouteEntry.tsx',
                whichExportToUse: 'softwareFormSubmitPublicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4PECA", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitPublicRoute", () => $31da028c314c8c30$export$d238522bd96fb720);
const $31da028c314c8c30$export$d238522bd96fb720 = {
    name: 'software-form-submit-public',
    path: '/jira/software/form/:formUuid',
    exact: true
};

});


parcelRegister("lxvYO", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitRouteEntry", () => $9737d374115af89f$export$752724866670c36);

var $7K5Ea = parcelRequire("7K5Ea");

var $cxKOj = parcelRequire("cxKOj");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $kSeQy = parcelRequire("kSeQy");

var $kYILW = parcelRequire("kYILW");

var $aoaVN = parcelRequire("aoaVN");

var $g8uYY = parcelRequire("g8uYY");
const $9737d374115af89f$var$formSubmitPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $aoaVN.formSubmitEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $9737d374115af89f$export$752724866670c36 = (0, $6xToB.createEntry)((0, $kYILW.softwareFormSubmitRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit',
        layout: (0, $7K5Ea.chromelessLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $cxKOj.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $9737d374115af89f$var$formSubmitPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint);
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-form-submit-entries/src/softwareFormSubmitRouteEntry.tsx',
                whichExportToUse: 'softwareFormSubmitRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kYILW", function(module, exports) {
$parcel$export(module.exports, "softwareFormSubmitRoute", () => $692ae5036e20b0c9$export$75b28ee1c7f02f00);
const $692ae5036e20b0c9$export$75b28ee1c7f02f00 = {
    name: 'software-form-submit',
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("6XvFv", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsClassicRouteEntry", () => $cd936b756ae58dd5$export$58d10390fc181fcf);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $fOnfM = parcelRequire("fOnfM");

var $4mGMh = parcelRequire("4mGMh");
const $cd936b756ae58dd5$export$58d10390fc181fcf = (0, $6xToB.createEntry)((0, $fOnfM.softwareGoalsClassicRoute), ()=>({
        group: 'classic-software',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $4mGMh.softwareGoalsClassicPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareGoalsClassicRouteEntry.tsx',
                whichExportToUse: 'softwareGoalsClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fOnfM", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $9780f726a01368f9$export$d12f3924cf53b545);
const $9780f726a01368f9$export$d12f3924cf53b545 = {
    name: 'software-goals-classic',
    path: '/jira/software/c/projects/:projectKey/goals'
};

});

parcelRegister("4mGMh", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsClassicPageEntrypoint", () => $ffec8a7226240934$export$6c6f7e606a16292);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $gH6fd = parcelRequire("gH6fd");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $ffec8a7226240934$export$6c6f7e606a16292 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gH6fd.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gH6fd", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsEntrypoint", () => $51e615ef72ff06ac$export$a75f86449cc34a72);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $51e615ef72ff06ac$export$a75f86449cc34a72 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3Pg5b")), {
        moduleId: "a5f3007b",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3Pg5b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ekAXv").then(()=>parcelRequire('7zEKu'));

});




parcelRegister("jZv6V", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsRouteEntry", () => $09cbb40265f2eee4$export$d3fcc412edfa2068);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $ldZEd = parcelRequire("ldZEd");

var $hS1gr = parcelRequire("hS1gr");

var $39DKk = parcelRequire("39DKk");
const $09cbb40265f2eee4$export$d3fcc412edfa2068 = (0, $6xToB.createEntry)((0, $ldZEd.softwareGoalsRoute), ()=>({
        group: 'software',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $39DKk.softwareGoalsPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-goals-entries/src/softwareGoalsRouteEntry.tsx',
                whichExportToUse: 'softwareGoalsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ldZEd", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsRoute", () => $7cd62da4d350af82$export$2328fed7ebee3cce);
const $7cd62da4d350af82$export$2328fed7ebee3cce = {
    name: 'software-goals',
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};

});

parcelRegister("39DKk", function(module, exports) {
$parcel$export(module.exports, "softwareGoalsPageEntrypoint", () => $3e4b808774818d32$export$6c63903b420029c0);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $gH6fd = parcelRequire("gH6fd");
const $3e4b808774818d32$export$6c63903b420029c0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gH6fd.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("b5gw6", function(module, exports) {
$parcel$export(module.exports, "softwareInboxClassicRouteEntry", () => $ee645864532557ea$export$ca6aeb36a7b6211d);

var $7mF43 = parcelRequire("7mF43");

var $6OkvA = parcelRequire("6OkvA");

var $4cTDP = parcelRequire("4cTDP");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4jA39 = parcelRequire("4jA39");

var $hS1gr = parcelRequire("hS1gr");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $36VZX = parcelRequire("36VZX");
const $ee645864532557ea$export$ca6aeb36a7b6211d = (0, $6xToB.createEntry)((0, $6OkvA.softwareInboxClassicRoute), ()=>({
        group: 'classic-software',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $4jA39.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)),
        entryPoint: ()=>(0, $4cTDP.fg)('jcs_developer_escalations') ? (0, $36VZX.inboxPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-inbox-entries/src/softwareInboxClassicRouteEntry.tsx',
                whichExportToUse: 'softwareInboxClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6OkvA", function(module, exports) {
$parcel$export(module.exports, "softwareInboxClassicRoute", () => $72f32152ce37bb03$export$a3612f128eff4e3c);
const $72f32152ce37bb03$export$a3612f128eff4e3c = {
    name: 'inbox-classic',
    path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?'
};

});

parcelRegister("4jA39", function(module, exports) {
$parcel$export(module.exports, "InboxViewTableSkeleton", () => $55c791cd780e415e$export$24aae43683500596);
/* InboxViewTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $8mes6 = parcelRequire("8mes6");
const $55c791cd780e415e$var$customCssStyles = null;
const $55c791cd780e415e$var$containerStyles = {
    height: '448px'
};
const $55c791cd780e415e$export$24aae43683500596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8mes6))),
        containerStyles: $55c791cd780e415e$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("8mes6", function(module, exports) {
module.exports = new URL("inbox-view-table-skeleton.tpl.3e3d3620.svg", import.meta.url).toString();

});


parcelRegister("36VZX", function(module, exports) {
$parcel$export(module.exports, "inboxPageEntryPoint", () => $048efea0d807b562$export$6da9e4ae87b73009);
// eslint-disable-next-line jira/import/file-extension-required

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $gzDVg = parcelRequire("gzDVg");
const $048efea0d807b562$export$6da9e4ae87b73009 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $gzDVg.customerServiceInboxPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gzDVg", function(module, exports) {
$parcel$export(module.exports, "customerServiceInboxPageEntrypoint", () => $265dab3b08058bf8$export$bf72eb0f567836ce);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $265dab3b08058bf8$export$bf72eb0f567836ce = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("erTf2")), {
        moduleId: "9cc840e3",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("erTf2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("868fr")
]).then(()=>parcelRequire('3rHYj'));

});




parcelRegister("2YbyC", function(module, exports) {
$parcel$export(module.exports, "softwareInboxNextGenRouteEntry", () => $b60c0ea8a781935e$export$22d61f7936797fc0);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $4cTDP = parcelRequire("4cTDP");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $3l4Y5 = parcelRequire("3l4Y5");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $4jA39 = parcelRequire("4jA39");

var $kSeQy = parcelRequire("kSeQy");

var $bQFhw = parcelRequire("bQFhw");

var $36VZX = parcelRequire("36VZX");
const $b60c0ea8a781935e$export$22d61f7936797fc0 = (0, $6xToB.createEntry)((0, $3l4Y5.softwareInboxNextGenRoute), ()=>({
        group: 'software',
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $4jA39.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.ForPaintSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $bQFhw.getCommonProjectResources)()
        ],
        layout: (0, $6dwgv.createLayout)((0, $8FCAy.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $4cTDP.fg)('jcs_developer_escalations') ? (0, $36VZX.inboxPageEntryPoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-inbox-entries/src/softwareInboxNextGenRouteEntry.tsx',
                whichExportToUse: 'softwareInboxNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3l4Y5", function(module, exports) {
$parcel$export(module.exports, "softwareInboxNextGenRoute", () => $57961f30aea50012$export$e44454ed868d0941);
const $57961f30aea50012$export$e44454ed868d0941 = {
    name: 'inbox',
    path: '/jira/software/projects/:projectKey/inbox/:issueKey?'
};

});


parcelRegister("hykoI", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", () => $0a569651542444d3$export$c7d98bfe75274932);

var $7mF43 = parcelRequire("7mF43");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6RR4t = parcelRequire("6RR4t");

var $7nY0O = parcelRequire("7nY0O");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $8hufg = parcelRequire("8hufg");

var $2L04M = parcelRequire("2L04M");
const $0a569651542444d3$export$c7d98bfe75274932 = (0, $6xToB.createEntry)((0, $6RR4t.softwareIncidentsClassicRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4cTDP.fg)('corex_operandi_incidents_page_in_jira') ? (0, $8hufg.entryPoint) : (0, $2L04M.entryPointDeprecated);
        },
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        skeleton: (0, $7nY0O.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $bTfc4.incidentsInitialPageChecksResource),
            (0, $bTfc4.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-incidents-classic'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-incidents-entries/src/softwareIncidentsClassicRouteEntry.tsx',
                whichExportToUse: 'softwareIncidentsClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6RR4t", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsClassicRoute", () => $59ff647f7edd0c65$export$3356a7870a2717f4);
const $59ff647f7edd0c65$export$3356a7870a2717f4 = {
    name: 'software-incidents-classic',
    path: '/jira/software/c/projects/:projectKey/incidents'
};

});

parcelRegister("7nY0O", function(module, exports) {
$parcel$export(module.exports, "IncidentsPageSkeleton", () => $5367e10b141c586b$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $5367e10b141c586b$export$7092b8ea63ebf9be);
/* IncidentsPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $bYPFo = parcelRequire("bYPFo");

var $etTGu = parcelRequire("etTGu");
const $5367e10b141c586b$var$incidentsPageSkeletonStyles = null;
const $5367e10b141c586b$var$incidentsTableSkeletonStyles = null;
const $5367e10b141c586b$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $hcewu.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bYPFo)))
    }));
const $5367e10b141c586b$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($etTGu)))
    }));

});
parcelRegister("bYPFo", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("etTGu", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("8hufg", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $5da3e540de98aaf6$export$6333901e831d7af0);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3uujZ = parcelRequire("3uujZ");

var $9n5I0 = parcelRequire("9n5I0");
const $5da3e540de98aaf6$export$6333901e831d7af0 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3uujZ.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("3uujZ", function(module, exports) {
$parcel$export(module.exports, "incidentsPageEntryPoint", () => $03cfa6df2508a282$export$a59477eea6e8cd7f);

var $egj7Q = parcelRequire("egj7Q");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $03cfa6df2508a282$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $03cfa6df2508a282$var$QUERY_PARAM_SEARCH = 'search';
const $03cfa6df2508a282$var$QUERY_PARAM_PRIORITY = 'priority';
const $03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $03cfa6df2508a282$var$QUERY_PARAM_STATUS = 'status';
const $03cfa6df2508a282$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $03cfa6df2508a282$var$STATUS_SORT_KEY = 'status';
const $03cfa6df2508a282$var$CREATED_SORT_KEY = 'created';
const $03cfa6df2508a282$var$PRIORITY_SORT_KEY = 'priority';
const $03cfa6df2508a282$var$SUMMARY_SORT_KEY = 'key';
const $03cfa6df2508a282$var$ASC_SORT_KEY = 'ASC';
const $03cfa6df2508a282$var$DESC_SORT_KEY = 'DESC';
function $03cfa6df2508a282$var$notEmpty(value) {
    return Boolean(value);
}
const $03cfa6df2508a282$var$isPriority = $03cfa6df2508a282$var$notEmpty;
const $03cfa6df2508a282$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $03cfa6df2508a282$var$isSortBy = (val)=>val === $03cfa6df2508a282$var$STATUS_SORT_KEY || val === $03cfa6df2508a282$var$CREATED_SORT_KEY || val === $03cfa6df2508a282$var$PRIORITY_SORT_KEY || val === $03cfa6df2508a282$var$SUMMARY_SORT_KEY;
const $03cfa6df2508a282$var$isSortOrder = (val)=>val === $03cfa6df2508a282$var$ASC_SORT_KEY || val === $03cfa6df2508a282$var$DESC_SORT_KEY;
const $03cfa6df2508a282$var$isAffectedService = $03cfa6df2508a282$var$notEmpty;
function $03cfa6df2508a282$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $03cfa6df2508a282$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY]: paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] && $03cfa6df2508a282$var$isSortBy(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] : $03cfa6df2508a282$var$CREATED_SORT_KEY,
        [$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER] && $03cfa6df2508a282$var$isSortOrder(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER] : $03cfa6df2508a282$var$DESC_SORT_KEY
    };
    result[$03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE] = $03cfa6df2508a282$var$parseParameter(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE], $03cfa6df2508a282$var$isAffectedService);
    result[$03cfa6df2508a282$var$QUERY_PARAM_STATUS] = $03cfa6df2508a282$var$parseParameter(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_STATUS], $03cfa6df2508a282$var$isStatus);
    result[$03cfa6df2508a282$var$QUERY_PARAM_SEARCH] = paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$03cfa6df2508a282$var$QUERY_PARAM_PRIORITY] = $03cfa6df2508a282$var$parseParameter(paramsRaw[$03cfa6df2508a282$var$QUERY_PARAM_PRIORITY], $03cfa6df2508a282$var$isPriority);
    return result;
};
const $03cfa6df2508a282$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $03cfa6df2508a282$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $03cfa6df2508a282$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $03cfa6df2508a282$var$getFilterValue($03cfa6df2508a282$var$parseStatusToFilterValues(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $03cfa6df2508a282$var$getFilterValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $03cfa6df2508a282$var$getFilterValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $03cfa6df2508a282$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC;
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $03cfa6df2508a282$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $03cfa6df2508a282$var$parseSortDirection(sortOrder, $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $03cfa6df2508a282$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC;
        case $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $03cfa6df2508a282$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $03cfa6df2508a282$var$parseInverseSortDirection(sortOrder, $03cfa6df2508a282$var$AriGraphSortOrderInput.ASC)
    });
const $03cfa6df2508a282$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $03cfa6df2508a282$var$AriGraphSortOrderInput.DESC
        },
        ...$03cfa6df2508a282$var$STATUS_SORT_KEY === parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $03cfa6df2508a282$var$getSortValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$03cfa6df2508a282$var$PRIORITY_SORT_KEY === parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $03cfa6df2508a282$var$getInverseSortValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$03cfa6df2508a282$var$CREATED_SORT_KEY === parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $03cfa6df2508a282$var$getSortValue(parsedQueryParams[$03cfa6df2508a282$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $03cfa6df2508a282$export$a59477eea6e8cd7f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("loIWa")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $egj7Q.default,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $03cfa6df2508a282$var$getGqlFiltersFromQueryParams($03cfa6df2508a282$var$parseQueryParams(context.query)),
                        sort: $03cfa6df2508a282$var$getGraphStoreSortFromQueryParams($03cfa6df2508a282$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});

});
parcelRegister("egj7Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7271a6c53691feb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<535af53561736a2d836fc81ae5b4bf2f>>
 * @relayHash ab315f9ffdcbe8bd8ba7b5de061e5649
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137
const $b7271a6c53691feb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b7271a6c53691feb$export$2e2bcd8739ae039 = $b7271a6c53691feb$var$node;

});

parcelRegister("loIWa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("90blN").then(()=>parcelRequire('4Muh9'));

});



parcelRegister("2L04M", function(module, exports) {
$parcel$export(module.exports, "entryPointDeprecated", () => $d5d3b4f6512fd8ee$export$821fec5ea5acc81d);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $do0fs = parcelRequire("do0fs");

var $9n5I0 = parcelRequire("9n5I0");
const $d5d3b4f6512fd8ee$export$821fec5ea5acc81d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $do0fs.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("do0fs", function(module, exports) {
$parcel$export(module.exports, "incidentsPageEntryPoint", () => $f5481b44e016e698$export$a59477eea6e8cd7f);

var $cOFzb = parcelRequire("cOFzb");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $f5481b44e016e698$export$a59477eea6e8cd7f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("9pIUV")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459",
        priority: "userVisible"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cOFzb.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("cOFzb", function(module, exports) {
$parcel$export(module.exports, "default", () => $470733dd7cdc1a43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $470733dd7cdc1a43$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $470733dd7cdc1a43$export$2e2bcd8739ae039 = $470733dd7cdc1a43$var$node;

});

parcelRegister("9pIUV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("64v3H").then(()=>parcelRequire('3wXGb'));

});




parcelRegister("2dAZL", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", () => $006e613ff5d52bac$export$fd29243dbe4103);

var $7mF43 = parcelRequire("7mF43");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $eyX6G = parcelRequire("eyX6G");

var $7nY0O = parcelRequire("7nY0O");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $8hufg = parcelRequire("8hufg");

var $2L04M = parcelRequire("2L04M");
const $006e613ff5d52bac$export$fd29243dbe4103 = (0, $6xToB.createEntry)((0, $eyX6G.softwareIncidentsNextGenRoute), ()=>({
        group: 'software',
        entryPoint () {
            return (0, $4cTDP.fg)('corex_operandi_incidents_page_in_jira') ? (0, $8hufg.entryPoint) : (0, $2L04M.entryPointDeprecated);
        },
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        skeleton: (0, $7nY0O.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $bTfc4.incidentsInitialPageChecksResource),
            (0, $bTfc4.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-incidents'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-incidents-entries/src/softwareIncidentsNextGenRouteEntry.tsx',
                whichExportToUse: 'softwareIncidentsNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eyX6G", function(module, exports) {
$parcel$export(module.exports, "softwareIncidentsNextGenRoute", () => $e8081ff7de272d80$export$12e1ca6c7cfdfd49);
const $e8081ff7de272d80$export$12e1ca6c7cfdfd49 = {
    name: 'software-incidents',
    path: '/jira/software/projects/:projectKey/incidents'
};

});


parcelRegister("6Rmp2", function(module, exports) {
$parcel$export(module.exports, "softwareListClassicRouteEntry", () => $dc36dcb442488afe$export$4e2a0a97feb715a5);

var $6xToB = parcelRequire("6xToB");

var $5S55b = parcelRequire("5S55b");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $jt5VP = parcelRequire("jt5VP");

var $hS1gr = parcelRequire("hS1gr");

var $ho9E1 = parcelRequire("ho9E1");

var $cV98p = parcelRequire("cV98p");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $ebWJz = parcelRequire("ebWJz");

var $eJe5A = parcelRequire("eJe5A");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $4cTDP = parcelRequire("4cTDP");


var $d4NVH = parcelRequire("d4NVH");

var $gwH93 = parcelRequire("gwH93");

var $fYGKn = parcelRequire("fYGKn");

var $ioHIu = parcelRequire("ioHIu");

var $bQFhw = parcelRequire("bQFhw");

var $4a0D4 = parcelRequire("4a0D4");
const $dc36dcb442488afe$export$4e2a0a97feb715a5 = (0, $6xToB.createEntry)((0, $jt5VP.softwareListClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $gwH93.ProjectIssueNavigatorSkeleton) : (0, $5S55b.ListSkeleton),
        entryPoint () {
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorPageEntryPointWithNested;
            return 0, $4a0D4.softwareListRouteEntry;
        },
        layout: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $6dwgv.createLayout)((0, $ioHIu.genericProjectLayout)) : (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareListClassicRouteEntry.tsx',
                whichExportToUse: 'softwareListClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4cTDP.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        navigation: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        } : {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
        //  with .
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? [
            ...(0, $bQFhw.getCommonProjectResources)({
                isUsingSidebarEntrypoint: true
            })
        ] : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $ho9E1.projectCreatePermissionsResource),
            (0, $cV98p.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $ebWJz.fieldsResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        afterPaint: (0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'classic-list-nin' : 'classic-list',
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $4cTDP.fg)('nin-full-page-hydrate-root') : false
    }));

});
parcelRegister("5S55b", function(module, exports) {
$parcel$export(module.exports, "ListSkeleton", () => $44111d7f433e10a3$export$cbc3335f7a517046);
$parcel$export(module.exports, "ListEmbedSkeleton", () => $44111d7f433e10a3$export$2638f1c98fe91c13);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $7T9Vs = parcelRequire("7T9Vs");

var $aSN4H = parcelRequire("aSN4H");
const $44111d7f433e10a3$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7T9Vs)))
    });
const $44111d7f433e10a3$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aSN4H)))
    });

});
parcelRegister("7T9Vs", function(module, exports) {
module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();

});

parcelRegister("aSN4H", function(module, exports) {
module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();

});


parcelRegister("jt5VP", function(module, exports) {
$parcel$export(module.exports, "softwareListClassicRoute", () => $e15439174684b802$export$1bf758507ca6b2);
const $e15439174684b802$export$1bf758507ca6b2 = {
    name: 'software-list-classic',
    path: '/jira/software/c/projects/:projectKey/list/:navigationItemId?'
};

});

parcelRegister("4a0D4", function(module, exports) {
$parcel$export(module.exports, "softwareListRouteEntry", () => $4885cc90f98ee7d9$export$f30a66efa682bf2d);
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $4885cc90f98ee7d9$export$1099e0e49394fa9a);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $7nbE3 = parcelRequire("7nbE3");

var $9n5I0 = parcelRequire("9n5I0");

var $iyUFz = parcelRequire("iyUFz");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $4885cc90f98ee7d9$export$e844b8d1d10f4a38 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyUFz.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $4885cc90f98ee7d9$export$f30a66efa682bf2d = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyUFz.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $4885cc90f98ee7d9$export$1099e0e49394fa9a = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7nbE3.listEmbedEntryPoint)
});

});
parcelRegister("7nbE3", function(module, exports) {
$parcel$export(module.exports, "listEmbedEntryPoint", () => $ee75376db34fe720$export$519bb55e1612f243);

var $37SCz = parcelRequire("37SCz");

var $cE6SX = parcelRequire("cE6SX");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $ee75376db34fe720$var$FORMAT_RULES_FIRST = 20;

const $ee75376db34fe720$export$519bb55e1612f243 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("abn8T")), {
        moduleId: "07204381",
        moduleName: "JiraSoftwareListEmbedApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: false
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cE6SX.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $37SCz.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $ee75376db34fe720$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("cE6SX", function(module, exports) {
$parcel$export(module.exports, "default", () => $98c3a6cc4aa49f0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3500cfecd427ec65579b6a4b3203fec6>>
 * @relayHash 3655b37dd3864d793297734223e1a23d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afeccd4f43a43f7631a12856b95e0eef6364d7142f3237afc4f7c879052f8ec9
const $98c3a6cc4aa49f0d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "afeccd4f43a43f7631a12856b95e0eef6364d7142f3237afc4f7c879052f8ec9",
        "metadata": {},
        "name": "JiraSoftwareListEmbedAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $98c3a6cc4aa49f0d$export$2e2bcd8739ae039 = $98c3a6cc4aa49f0d$var$node;

});

parcelRegister("abn8T", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jf7jK").then(()=>parcelRequire('co8Yt'));

});


parcelRegister("iyUFz", function(module, exports) {
$parcel$export(module.exports, "listEntryPoint", () => $959b649eb5b17e7a$export$6be4f10150ff6073);

var $37SCz = parcelRequire("37SCz");

var $bvZbm = parcelRequire("bvZbm");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");
const $959b649eb5b17e7a$var$FORMAT_RULES_FIRST = 20;

const $959b649eb5b17e7a$export$6be4f10150ff6073 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("7Xg69")), {
        moduleId: "32ed646f",
        moduleName: "JiraSoftwareListApp",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: false
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bvZbm.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $37SCz.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $959b649eb5b17e7a$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("bvZbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce484c683d9211c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74761e0b4acfb233791f797bb40c2c6a>>
 * @relayHash 4f20791385a608198c3c70f8004fcf06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edae287bf0a189b6f61065cc1aa81346178e3cd40deae82f2991be07eb0e059a
const $ce484c683d9211c0$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "edae287bf0a189b6f61065cc1aa81346178e3cd40deae82f2991be07eb0e059a",
        "metadata": {},
        "name": "JiraSoftwareListAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ce484c683d9211c0$export$2e2bcd8739ae039 = $ce484c683d9211c0$var$node;

});

parcelRegister("7Xg69", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8iQSy").then(()=>parcelRequire('9c7ho'));

});




parcelRegister("3FQCK", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedClassicRouteEntry", () => $923e3c6a829c6ce2$export$1bf6c018ccb88bd6);

var $6xToB = parcelRequire("6xToB");

var $jVX4d = parcelRequire("jVX4d");

var $5S55b = parcelRequire("5S55b");

var $7K5Ea = parcelRequire("7K5Ea");

var $ho9E1 = parcelRequire("ho9E1");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $ebWJz = parcelRequire("ebWJz");

var $eJe5A = parcelRequire("eJe5A");

var $cV98p = parcelRequire("cV98p");


var $d4NVH = parcelRequire("d4NVH");

var $bQFhw = parcelRequire("bQFhw");

var $hFWLB = parcelRequire("hFWLB");

var $fYGKn = parcelRequire("fYGKn");

var $4cTDP = parcelRequire("4cTDP");

var $ebuR2 = parcelRequire("ebuR2");

var $4a0D4 = parcelRequire("4a0D4");
const $923e3c6a829c6ce2$export$1bf6c018ccb88bd6 = (0, $6xToB.createEntry)((0, $jVX4d.softwareListCustomEmbedClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorEmbedPageEntryPoint;
            return 0, $4a0D4.softwareListEmbedRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        // eslint-disable-next-line jira/ff/no-preconditioning
        isHydrateRootEnabled: (0, $4cTDP.fg)('jira_list_nin_merge') && (0, $4cTDP.fg)('nin-full-page-hydrate-root'),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $ho9E1.projectCreatePermissionsResource),
            (0, $cV98p.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $ebWJz.fieldsResource)
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'classic-list-custom-nin-embed' : 'classic-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareListCustomEmbedClassicRouteEntry.tsx',
                whichExportToUse: 'softwareListCustomEmbedClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jVX4d", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedClassicRoute", () => $33b99cc7997b9313$export$1273c580eb34bde5);
const $33b99cc7997b9313$export$1273c580eb34bde5 = {
    name: 'software-list-classic-custom-embed',
    path: '/jira/software/c/projects/:projectKey/list/:navigationItemId/embed'
};

});


parcelRegister("5v5xs", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedRouteEntry", () => $6144b1a1e33a7014$export$4387d360bb5b569b);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $k451s = parcelRequire("k451s");

var $5S55b = parcelRequire("5S55b");

var $7nbE3 = parcelRequire("7nbE3");

var $hFWLB = parcelRequire("hFWLB");

var $4VIcO = parcelRequire("4VIcO");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $4cTDP = parcelRequire("4cTDP");

var $5EAnX = parcelRequire("5EAnX");
const $6144b1a1e33a7014$var$listEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7nbE3.listEmbedEntryPoint)
});
const $6144b1a1e33a7014$export$4387d360bb5b569b = (0, $6xToB.createEntry)((0, $k451s.softwareListCustomEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorEmbedPageEntryPoint;
            return $6144b1a1e33a7014$var$listEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $5EAnX.getListProjectResources)()
        ],
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'software-list-custom-nin-embed' : 'next-gen-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-list-entries/src/softwareListCustomEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareListCustomEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k451s", function(module, exports) {
$parcel$export(module.exports, "softwareListCustomEmbedRoute", () => $04f35509239ad479$export$2565ab956bab3afb);
const $04f35509239ad479$export$2565ab956bab3afb = {
    name: 'software-list-custom-embed',
    path: '/jira/software/projects/:projectKey/list/:navigationItemId/embed'
};

});

parcelRegister("5EAnX", function(module, exports) {
$parcel$export(module.exports, "getListProjectResources", () => $63a87f99e1fe46e6$export$7bd00eef349a268a);

var $ebWJz = parcelRequire("ebWJz");

var $cV98p = parcelRequire("cV98p");

var $ebuR2 = parcelRequire("ebuR2");

var $ho9E1 = parcelRequire("ho9E1");
const $63a87f99e1fe46e6$export$7bd00eef349a268a = ()=>[
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $ebWJz.fieldsResource)
    ];

});


parcelRegister("9vlCj", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedClassicRouteEntry", () => $2b73652cc806b11b$export$bdb096e193b6e97b);

var $6xToB = parcelRequire("6xToB");

var $2qTdf = parcelRequire("2qTdf");

var $5S55b = parcelRequire("5S55b");

var $7K5Ea = parcelRequire("7K5Ea");

var $ho9E1 = parcelRequire("ho9E1");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $ebWJz = parcelRequire("ebWJz");

var $eJe5A = parcelRequire("eJe5A");

var $cV98p = parcelRequire("cV98p");

var $ebuR2 = parcelRequire("ebuR2");

var $4cTDP = parcelRequire("4cTDP");


var $d4NVH = parcelRequire("d4NVH");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $hFWLB = parcelRequire("hFWLB");

var $4a0D4 = parcelRequire("4a0D4");
const $2b73652cc806b11b$export$bdb096e193b6e97b = (0, $6xToB.createEntry)((0, $2qTdf.softwareListEmbedClassicRoute), ()=>({
        group: 'classic-software',
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorEmbedPageEntryPoint;
            return 0, $4a0D4.softwareListEmbedRouteEntry;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $ho9E1.projectCreatePermissionsResource),
            (0, $cV98p.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $ebWJz.fieldsResource)
        ],
        // eslint-disable-next-line jira/ff/no-preconditioning
        isHydrateRootEnabled: (0, $4cTDP.fg)('nin-full-page-hydrate-root') && (0, $4cTDP.fg)('jira_list_nin_merge'),
        afterPaint: (0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'classic-list-nin-embed' : 'classic-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareListEmbedClassicRouteEntry.tsx',
                whichExportToUse: 'softwareListEmbedClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2qTdf", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $caddb762ada20d2e$export$de5fcecec40b3c98);
const $caddb762ada20d2e$export$de5fcecec40b3c98 = {
    name: 'software-list-classic-embed',
    path: '/jira/software/c/projects/:projectKey/list/embed'
};

});


parcelRegister("algSY", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $1034395cbcfb7fb6$export$1099e0e49394fa9a);

var $7K5Ea = parcelRequire("7K5Ea");

var $g8uYY = parcelRequire("g8uYY");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $jw1kr = parcelRequire("jw1kr");

var $5S55b = parcelRequire("5S55b");

var $7nbE3 = parcelRequire("7nbE3");

var $hFWLB = parcelRequire("hFWLB");

var $4VIcO = parcelRequire("4VIcO");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $4cTDP = parcelRequire("4cTDP");

var $5EAnX = parcelRequire("5EAnX");
const $1034395cbcfb7fb6$var$listEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $7nbE3.listEmbedEntryPoint)
});
const $1034395cbcfb7fb6$export$1099e0e49394fa9a = (0, $6xToB.createEntry)((0, $jw1kr.softwareListEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $hFWLB.EmbedIssueNavigatorSkeleton) : (0, $5S55b.ListEmbedSkeleton),
        entryPoint () {
            if ((0, $4cTDP.fg)('jira_list_nin_merge')) return 0, $fYGKn.issueNavigatorEmbedPageEntryPoint;
            return $1034395cbcfb7fb6$var$listEmbedPageEntrypoint;
        },
        layout: (0, $7K5Ea.chromelessLayout),
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? [
            ...(0, $bQFhw.getCommonProjectResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ] : [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $5EAnX.getListProjectResources)()
        ],
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'software-list-nin-embed' : 'next-gen-list-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-list-entries/src/softwareListEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareListEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jw1kr", function(module, exports) {
$parcel$export(module.exports, "softwareListEmbedRoute", () => $ab3952bf527f58c5$export$70dd8df584442004);
const $ab3952bf527f58c5$export$70dd8df584442004 = {
    name: 'software-list-embed',
    path: '/jira/software/projects/:projectKey/list/embed'
};

});


parcelRegister("chmwv", function(module, exports) {
$parcel$export(module.exports, "softwareListRouteEntry", () => $664d587836ff333f$export$f30a66efa682bf2d);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5UsLt = parcelRequire("5UsLt");

var $5S55b = parcelRequire("5S55b");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $iyUFz = parcelRequire("iyUFz");

var $9n5I0 = parcelRequire("9n5I0");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $4cTDP = parcelRequire("4cTDP");

var $gwH93 = parcelRequire("gwH93");


var $d4NVH = parcelRequire("d4NVH");

var $bQFhw = parcelRequire("bQFhw");

var $fYGKn = parcelRequire("fYGKn");

var $5EAnX = parcelRequire("5EAnX");
const $664d587836ff333f$var$listPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyUFz.listEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $664d587836ff333f$export$f30a66efa682bf2d = (0, $6xToB.createEntry)((0, $5UsLt.softwareListRoute), ()=>({
        group: 'software',
        skeleton: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $gwH93.ProjectIssueNavigatorSkeleton) : (0, $5S55b.ListSkeleton),
        entryPoint () {
            return (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $fYGKn.issueNavigatorPageEntryPoint) : $664d587836ff333f$var$listPageEntrypoint;
        },
        meta: (0, $4cTDP.fg)('jira_list_nin_merge') ? {
            capability: (0, $652f5f63189f3e2a$export$d0ad1160bb95ce50),
            reporting: (0, $d4NVH.getRouteReporting)()
        } : undefined,
        bifrost: {
            bifrostGroup: 'issue-navigator',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-list-entries/src/softwareListRouteEntry.tsx',
                whichExportToUse: 'softwareListRouteEntry'
            },
            manifestName: 'jira-spa-issue-navigator.json',
            enabled: true
        },
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $bQFhw.getCommonProjectResources)() : [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $5EAnX.getListProjectResources)(),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        afterPaint: (0, $4cTDP.fg)('jira_list_nin_merge') ? undefined : [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: (0, $4cTDP.fg)('jira_list_nin_merge') ? 'software-list-nin' : 'next-gen-list',
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('jira_list_nin_merge') ? (0, $4cTDP.fg)('nin-full-page-hydrate-root') : false
    }));

});
parcelRegister("5UsLt", function(module, exports) {
$parcel$export(module.exports, "softwareListRoute", () => $b86fcd0eabaec86d$export$f3a5b1b732315e13);
const $b86fcd0eabaec86d$export$f3a5b1b732315e13 = {
    name: 'software-list',
    path: '/jira/software/projects/:projectKey/list/:navigationItemId?'
};

});


parcelRegister("ilU7w", function(module, exports) {
$parcel$export(module.exports, "softwareNextgenRedirectRouteEntry", () => $5d875391cc80dcd3$export$e328d22412aeb5cf);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dUnSO = parcelRequire("dUnSO");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $2mHfh = parcelRequire("2mHfh");

var $bQWwW = parcelRequire("bQWwW");

var $2dJFW = parcelRequire("2dJFW");

var $jmnFB = parcelRequire("jmnFB");
const $5d875391cc80dcd3$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: (0, $jmnFB.pickNextGenView)(location)
    });

const $5d875391cc80dcd3$var$LazyBoardPage = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("iclWv"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $5d875391cc80dcd3$export$e328d22412aeb5cf = (0, $6xToB.createEntry)((0, $dUnSO.softwareNextgenRedirectRoute), ()=>({
        group: 'software',
        component: $5d875391cc80dcd3$var$SoftwareNextgenRedirectComponent,
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            $5d875391cc80dcd3$var$LazyBoardPage
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareNextgenRedirectRouteEntry.tsx',
                whichExportToUse: 'softwareNextgenRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dUnSO", function(module, exports) {
$parcel$export(module.exports, "softwareNextgenRedirectRoute", () => $72f8b419477b36bd$export$6072946fe7f2d45a);
const $72f8b419477b36bd$export$6072946fe7f2d45a = {
    name: 'software-nextgen-redirect',
    path: '/secure/NextGen.jspa'
};

});

parcelRegister("jmnFB", function(module, exports) {
$parcel$export(module.exports, "pickNextGenView", () => $cec8248a7320298f$export$8c47088cd9b527ba);

var $b5RwB = parcelRequire("b5RwB");
const $cec8248a7320298f$var$PLAN = 'planning';
const $cec8248a7320298f$var$REPORTING = 'reporting';
const $cec8248a7320298f$var$REPORTS = 'reports';
const $cec8248a7320298f$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($cec8248a7320298f$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($cec8248a7320298f$var$REPORTING) || view.startsWith($cec8248a7320298f$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $cec8248a7320298f$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $cec8248a7320298f$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(Object.entries(queryParams).filter(([k])=>!$cec8248a7320298f$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $cec8248a7320298f$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $cec8248a7320298f$var$forwardUnknownQueryParams($cec8248a7320298f$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $cec8248a7320298f$var$forwardUnknownQueryParams(url, searchResult);
};

});


parcelRegister("jP8P4", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingGetStartedRouteEntry", () => $9fac1bd6c0964acb$export$f08156edd0ce3853);

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $13dFG = parcelRequire("13dFG");

var $8FCAy = parcelRequire("8FCAy");

var $5RW99 = parcelRequire("5RW99");

var $g8uYY = parcelRequire("g8uYY");

var $c6EGr = parcelRequire("c6EGr");

var $9NmsS = parcelRequire("9NmsS");

var $kFQUu = parcelRequire("kFQUu");

var $4cTDP = parcelRequire("4cTDP");

var $kSeQy = parcelRequire("kSeQy");

var $dZRaT = parcelRequire("dZRaT");

var $g6q5m = parcelRequire("g6q5m");
const $9fac1bd6c0964acb$var$softwareOnboardingGetStartedPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $c6EGr.softwareOnboardingGetStartedEntrypoint)
});
const $9fac1bd6c0964acb$export$f08156edd0ce3853 = (0, $6xToB.createEntry)((0, $13dFG.softwareOnboardingGetStartedRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $4cTDP.fg)('jira_get_started_route') ? $9fac1bd6c0964acb$var$softwareOnboardingGetStartedPageEntrypoint : (0, $kSeQy.notFoundPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $g6q5m.fetchUserTraitsResource),
            (0, $dZRaT.projectContextResourceWithCache),
            (0, $kFQUu.softwareOnboardingGetStartedIntegrationsStatusResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-onboarding-entries/src/softwareOnboardingGetStartedRouteEntry.tsx',
                whichExportToUse: 'softwareOnboardingGetStartedRouteEntry'
            },
            enabled: true
        },
        canTransitionIn: ()=>true
    }));

});
parcelRegister("13dFG", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingGetStartedRoute", () => $51762a773f56de7e$export$c25273c48ccc0eb9);
const $51762a773f56de7e$export$c25273c48ccc0eb9 = {
    name: 'software-onboarding-get-started',
    path: '/jira/software/projects/:projectKey/get-started',
    exact: true
};

});

parcelRegister("c6EGr", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingGetStartedEntrypoint", () => $26021b52f9bdcc2a$export$a78f6d16d840b215);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $iT5jS = parcelRequire("iT5jS");

const $26021b52f9bdcc2a$export$a78f6d16d840b215 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("2IAty")), {
        moduleId: "bac2d4a3",
        priority: "interaction"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                onboardingGetStartedPageData: {
                    parameters: $iT5jS.default,
                    variables: {
                        siteAri: `ari:cloud:jira::site/${tenantContext.cloudId}`,
                        cloudId: tenantContext.cloudId
                    }
                }
            },
            // Optional - Any nested EntryPoints you wish to also load
            entryPoints: {},
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {}
        })
});

});
parcelRegister("iT5jS", function(module, exports) {
$parcel$export(module.exports, "default", () => $807a148f808ff736$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30011c2473182d64abb23914a7830230>>
 * @relayHash 3d666e4550087a85d1fd03eff6d75db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID debceaeb7e53a1b935780cd30c900627efd1b1f17abdf65b4458c6256adba0a2
const $807a148f808ff736$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "concreteType": "JiraConfigStateConnection",
            "kind": "LinkedField",
            "name": "config",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraConfigState",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiOnboardingGetStartedPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "CodeSection_codeIntegrationData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiOnboardingGetStartedPageQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "siteAri"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "providerTypes",
                                    "value": [
                                        "DEV_INFO"
                                    ]
                                }
                            ],
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v6 /*: any*/ 
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "appId",
                                            "value": "bitbucket"
                                        },
                                        v3 /*: any*/ 
                                    ],
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "debceaeb7e53a1b935780cd30c900627efd1b1f17abdf65b4458c6256adba0a2",
            "metadata": {},
            "name": "uiOnboardingGetStartedPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$807a148f808ff736$var$node.hash = "b249f917d1cb2119715301e4ae9e0d44";
var $807a148f808ff736$export$2e2bcd8739ae039 = $807a148f808ff736$var$node;

});

parcelRegister("2IAty", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6YVGh").then(()=>parcelRequire('lns8o'));

});



parcelRegister("1DVzF", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingRouteEntry", () => $a98ae10c4a769c67$export$bb72a943d2340466);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $a0jfQ = parcelRequire("a0jfQ");

var $cxQGT = parcelRequire("cxQGT");

var $ghDQJ = parcelRequire("ghDQJ");

var $ho9E1 = parcelRequire("ho9E1");

var $7GmqV = parcelRequire("7GmqV");
const $a98ae10c4a769c67$export$bb72a943d2340466 = (0, $6xToB.createEntry)((0, $ghDQJ.softwareOnboardingRoute), ()=>({
        group: 'software',
        component: (0, $7GmqV.SoftwareOnboardingPage),
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $a0jfQ.jswOnboardingResource),
            (0, $cxQGT.themePreferenceResource),
            (0, $ho9E1.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $7GmqV.LazySoftwareOnboardingPage)
        ],
        canTransitionIn: ()=>false,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-onboarding-entries/src/softwareOnboardingRouteEntry.tsx',
                whichExportToUse: 'softwareOnboardingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("a0jfQ", function(module, exports) {
$parcel$export(module.exports, "jswOnboardingResource", () => $0f3f44fb824b4a6b$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $0f3f44fb824b4a6b$export$83f546a45ad58d0a);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $0f3f44fb824b4a6b$export$be21a2d8a350a80 = (0, $l1VxS.createResource)({
    type: (0, $550128173520f259$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("2Nkoe"))
});
const $0f3f44fb824b4a6b$export$83f546a45ad58d0a = ()=>(0, $eJrcF.useResource)($0f3f44fb824b4a6b$export$be21a2d8a350a80);

});
const $550128173520f259$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("2Nkoe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dCQnN").then(()=>parcelRequire('3u0fx'));

});


parcelRegister("ghDQJ", function(module, exports) {
$parcel$export(module.exports, "softwareOnboardingRoute", () => $288e5ff1ef6a8f93$export$5e6c92d2f34c1e48);
const $288e5ff1ef6a8f93$export$5e6c92d2f34c1e48 = {
    name: 'software-onboarding',
    path: '/welcome/software',
    exact: true
};

});

parcelRegister("7GmqV", function(module, exports) {
$parcel$export(module.exports, "LazySoftwareOnboardingPage", () => $b08568a458389499$export$31e9f06d3389e445);
$parcel$export(module.exports, "SoftwareOnboardingPage", () => $b08568a458389499$export$ee768d69c6e3a8bd);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $b08568a458389499$export$31e9f06d3389e445 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("i36uA"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});
const $b08568a458389499$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b08568a458389499$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("i36uA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bjHsW").then(()=>parcelRequire('jrWYq'));

});



parcelRegister("7ccps", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", () => $abbad57df163322a$export$d7d49c1a51b3c0a9);

var $7mF43 = parcelRequire("7mF43");

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $ihgGc = parcelRequire("ihgGc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8Duuj = parcelRequire("8Duuj");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $lb6FK = parcelRequire("lb6FK");

var $iQ6xi = parcelRequire("iQ6xi");
const $abbad57df163322a$export$d7d49c1a51b3c0a9 = (0, $6xToB.createEntry)((0, $8Duuj.softwarePeriscopeClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $ihgGc.Skeleton),
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $lb6FK.rovoEntitlementResource)
        ],
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        entryPoint: ()=>{
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $iQ6xi.periscopeEntryPoint;
        },
        meta: {
            reporting: {
                id: 'software-periscope-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-periscope-classic'),
                teamName: 'jolt'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-periscope-entries/src/softwarePeriscopeClassicRouteEntry.tsx',
                whichExportToUse: 'softwarePeriscopeClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ihgGc", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $6dd3ea49a6940f01$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $6dd3ea49a6940f01$export$dd0b74c715df3275);
$parcel$export(module.exports, "SuggestionsSkeleton", () => $6dd3ea49a6940f01$export$91f27b306afd627b);
$parcel$export(module.exports, "WorkItemsSkeleton", () => $6dd3ea49a6940f01$export$1660f3159b79b22b);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $6dd3ea49a6940f01$export$5aea7d4ed03d6ea6);
$parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", () => $6dd3ea49a6940f01$export$ff38ee81427877e9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $lRq8t = parcelRequire("lRq8t");

var $bq5gY = parcelRequire("bq5gY");

var $6snra = parcelRequire("6snra");
const $6dd3ea49a6940f01$var$styles = {
    mainContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _1e0c1txw _vchhusvi",
    leftColumn: "_16jlcs5v _1o9zkb7n _i0dlf1ug",
    rightColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    suggestionsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3istmo _vchhusvi",
    insightsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1iym _vchhusvi",
    workItemsContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1ogm _vchhusvi",
    workItemsVulnTabContainer: "_1reo15vq _18m915vq _1bsb1osq _4t3i1pna _vchhusvi"
};
const $6dd3ea49a6940f01$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $6dd3ea49a6940f01$var$styles.mainContainer,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $6snra.default).label),
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $6dd3ea49a6940f01$var$styles.leftColumn,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.insightsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeInsightsSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeWorkItemsSkeleton), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $6dd3ea49a6940f01$var$styles.rightColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.suggestionsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeSuggestionsSkeleton), null))));
};
const $6dd3ea49a6940f01$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.insightsContainer,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage((0, $6snra.default).insightsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeInsightsSkeleton), null));
};
const $6dd3ea49a6940f01$export$91f27b306afd627b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.suggestionsContainer,
        "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
        "aria-label": formatMessage((0, $6snra.default).suggestionsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeSuggestionsSkeleton), null));
}; // Extend this for loading screen
const $6dd3ea49a6940f01$export$1660f3159b79b22b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsContainer,
        "aria-label": formatMessage((0, $6snra.default).workItemsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.PeriscopeWorkItemsSkeleton), null));
};
const $6dd3ea49a6940f01$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsVulnTabContainer,
        "aria-label": formatMessage((0, $6snra.default).workItemsVulnTabLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
const $6dd3ea49a6940f01$export$ff38ee81427877e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6dd3ea49a6940f01$var$styles.workItemsContainer,
        "aria-label": formatMessage((0, $6snra.default).workItemsDeploymentTabLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bq5gY.DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
};

});
parcelRegister("bq5gY", function(module, exports) {
$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $21284f9e6dec4f7d$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $21284f9e6dec4f7d$export$afb44f298901be44);
$parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", () => $21284f9e6dec4f7d$export$298a6b6a251923c2);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $21284f9e6dec4f7d$export$8940e0b80e4066d6);
$parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", () => $21284f9e6dec4f7d$export$2f5ed71a7df2d4e6);
$parcel$export(module.exports, "DevelopmentPageCodeAgentsTabSkeleton", () => $21284f9e6dec4f7d$export$e3f7fac0f7e53296);
/* PeriscopeSuggestionsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $KyBGN = parcelRequire("KyBGN");

var $79os8 = parcelRequire("79os8");

var $8OFhd = parcelRequire("8OFhd");

var $hOtLs = parcelRequire("hOtLs");

var $lFtDO = parcelRequire("lFtDO");

var $ixHwy = parcelRequire("ixHwy");

var $afoz3 = parcelRequire("afoz3");

var $1rini = parcelRequire("1rini");
const $21284f9e6dec4f7d$var$PeriscopePageSkeletonStyles = null;
const $21284f9e6dec4f7d$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hOtLs)))
    }));
const $21284f9e6dec4f7d$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lFtDO)))
    }));
const $21284f9e6dec4f7d$export$afb44f298901be44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($79os8)))
    }));
const $21284f9e6dec4f7d$export$298a6b6a251923c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($afoz3)))
    }));
const $21284f9e6dec4f7d$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ixHwy)))
    }));
const $21284f9e6dec4f7d$export$2f5ed71a7df2d4e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($KyBGN)))
    }));
const $21284f9e6dec4f7d$export$e70f5fa3451855e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8OFhd)))
    }));
const $21284f9e6dec4f7d$export$e3f7fac0f7e53296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.code-agents-tab-skeleton",
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1rini)))
    }));

});
parcelRegister("KyBGN", function(module, exports) {
module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();

});

parcelRegister("79os8", function(module, exports) {
module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();

});

parcelRegister("8OFhd", function(module, exports) {
module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();

});

parcelRegister("hOtLs", function(module, exports) {
module.exports = new URL("periscope-page-full-layout.tpl.762dcdba.svg", import.meta.url).toString();

});

parcelRegister("lFtDO", function(module, exports) {
module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();

});

parcelRegister("ixHwy", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();

});

parcelRegister("afoz3", function(module, exports) {
module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();

});

parcelRegister("1rini", function(module, exports) {
module.exports = new URL("code-agents-tab-skeleton.tpl.874ad579.svg", import.meta.url).toString();

});


parcelRegister("6snra", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1f4839c9651f4bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c1f4839c9651f4bd$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "periscope.skeleton.label",
        "defaultMessage": "Loading"
    },
    suggestionsLabel: {
        "id": "periscope.suggestions-skeleton.label",
        "defaultMessage": "Suggestions loading"
    },
    insightsLabel: {
        "id": "periscope.insights-skeleton.label",
        "defaultMessage": "Developer insights loading"
    },
    workItemsLabel: {
        "id": "periscope.work-items-skeleton.work-items-label",
        "defaultMessage": "Work items loading"
    },
    workItemsVulnTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-vuln-tab-label",
        "defaultMessage": "Work items vulnerability tab loading"
    },
    workItemsDeploymentTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-deployment-tab-label",
        "defaultMessage": "Work items deployment tab loading"
    },
    onCallPanelLabel: {
        "id": "periscope.on-call-skeleton.label",
        "defaultMessage": "On call panel loading"
    }
});
var $c1f4839c9651f4bd$export$2e2bcd8739ae039 = $c1f4839c9651f4bd$var$messages;

});


parcelRegister("8Duuj", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeClassicRoute", () => $b296b78af627ca8d$export$cb5cec74f302b3c6);
const $b296b78af627ca8d$export$cb5cec74f302b3c6 = {
    name: 'software-periscope-classic',
    path: '/jira/software/c/projects/:projectKey/development'
};

});

parcelRegister("iQ6xi", function(module, exports) {
$parcel$export(module.exports, "periscopeEntryPoint", () => $8713fae315175651$export$5a8cf468a1d46d4);

var $5Z0i1 = parcelRequire("5Z0i1");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $8713fae315175651$export$5a8cf468a1d46d4 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $5Z0i1.periscopeEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5Z0i1", function(module, exports) {
$parcel$export(module.exports, "periscopeEntrypoint", () => $9542f40912d211bc$export$89ba9048c6fd23c6);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $9542f40912d211bc$export$89ba9048c6fd23c6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("jMmvz")), {
        moduleId: "11456a6c",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jMmvz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("jKDWa")
]).then(()=>parcelRequire('jRIB1'));

});




parcelRegister("1Pj99", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", () => $f6c1a3e1213b5a6a$export$7db4d910357a4d89);

var $7mF43 = parcelRequire("7mF43");

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $ihgGc = parcelRequire("ihgGc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5Gd4r = parcelRequire("5Gd4r");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $lb6FK = parcelRequire("lb6FK");

var $iQ6xi = parcelRequire("iQ6xi");
const $f6c1a3e1213b5a6a$export$7db4d910357a4d89 = (0, $6xToB.createEntry)((0, $5Gd4r.softwarePeriscopeNextGenRoute), ()=>({
        group: 'software',
        skeleton: (0, $ihgGc.Skeleton),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $lb6FK.rovoEntitlementResource)
        ],
        entryPoint: ()=>{
            return (0, $lopBx.isFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $iQ6xi.periscopeEntryPoint);
        },
        meta: {
            reporting: {
                id: 'software-periscope',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-periscope'),
                teamName: 'jolt'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-periscope-entries/src/softwarePeriscopeNextGenRouteEntry.tsx',
                whichExportToUse: 'softwarePeriscopeNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5Gd4r", function(module, exports) {
$parcel$export(module.exports, "softwarePeriscopeNextGenRoute", () => $6eacf1339da179d9$export$9d0f329211395c25);
const $6eacf1339da179d9$export$9d0f329211395c25 = {
    name: 'software-periscope',
    path: '/jira/software/projects/:projectKey/development'
};

});


parcelRegister("ff5dM", function(module, exports) {
$parcel$export(module.exports, "softwarePlanCalendarRouteEntry", () => $8ea2ef86e0348cc9$export$67c64fea9be584ed);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");


var $k8mcw = parcelRequire("k8mcw");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $18dXS = parcelRequire("18dXS");

var $dsh9d = parcelRequire("dsh9d");

var $5C8kQ = parcelRequire("5C8kQ");
const $8ea2ef86e0348cc9$export$67c64fea9be584ed = (0, $6xToB.createEntry)((0, $18dXS.softwarePlanCalendarRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dsh9d.CalendarSkeleton), null),
        entryPoint () {
            (0, $k8mcw.setCapability)((0, $652f5f63189f3e2a$export$f999749ac7a2cd1));
            return 0, $5C8kQ.planCalendarPageEntryPoint;
        },
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            capability: (0, $652f5f63189f3e2a$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanCalendarRouteEntry.tsx',
                whichExportToUse: 'softwarePlanCalendarRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("18dXS", function(module, exports) {
$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $8b0145615736bea4$export$ca4c39d60ec156a2);
const $8b0145615736bea4$export$ca4c39d60ec156a2 = {
    name: 'software-plan-calendar',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};

});

parcelRegister("5C8kQ", function(module, exports) {
$parcel$export(module.exports, "planCalendarPageEntryPoint", () => $c6647949b071ac81$export$6e8a1c5de1f63c61);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $i9Kzd = parcelRequire("i9Kzd");

var $dGTIT = parcelRequire("dGTIT");
const $c6647949b071ac81$export$6e8a1c5de1f63c61 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $i9Kzd.calendarEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("aLXiu", function(module, exports) {
$parcel$export(module.exports, "softwarePlanDependenciesRouteEntry", () => $7c3bee9d98118448$export$103062f08086fba0);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $6DfBR = parcelRequire("6DfBR");

var $bNk7b = parcelRequire("bNk7b");

var $2WqIS = parcelRequire("2WqIS");
const $7c3bee9d98118448$export$103062f08086fba0 = (0, $6xToB.createEntry)((0, $6DfBR.softwarePlanDependenciesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $2WqIS.planDependenciesReportPageEntryPoint),
        component: (0, $bNk7b.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $bNk7b.LazyPlanDependenciesReport)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanDependenciesRouteEntry.tsx',
                whichExportToUse: 'softwarePlanDependenciesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6DfBR", function(module, exports) {
$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $3d92c2ce628de7b9$export$ad8296aa5394f696);
const $3d92c2ce628de7b9$export$ad8296aa5394f696 = {
    name: 'software-plan-dependencies',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};

});

parcelRegister("bNk7b", function(module, exports) {
$parcel$export(module.exports, "LazyPlanDependenciesReport", () => $8b7896f3a2fbf85d$export$d4669c7a2f17c261);
$parcel$export(module.exports, "default", () => $8b7896f3a2fbf85d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $8b7896f3a2fbf85d$export$d4669c7a2f17c261 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bJJn2"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
const $8b7896f3a2fbf85d$var$AsyncPlanDependenciesReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $8b7896f3a2fbf85d$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });
var $8b7896f3a2fbf85d$export$2e2bcd8739ae039 = $8b7896f3a2fbf85d$var$AsyncPlanDependenciesReport;

});

parcelRegister("2WqIS", function(module, exports) {
$parcel$export(module.exports, "planDependenciesReportPageEntryPoint", () => $04f834ad566e4087$export$1d873335adb647af);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $3nt6g = parcelRequire("3nt6g");

var $dGTIT = parcelRequire("dGTIT");
const $04f834ad566e4087$export$1d873335adb647af = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $3nt6g.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("kHsPZ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanReleasesRouteEntry", () => $ae86115cee0664c5$export$b874fabd66f10ff4);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $k4JTJ = parcelRequire("k4JTJ");

var $awsZY = parcelRequire("awsZY");

var $iHLLP = parcelRequire("iHLLP");
const $ae86115cee0664c5$export$b874fabd66f10ff4 = (0, $6xToB.createEntry)((0, $k4JTJ.softwarePlanReleasesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $iHLLP.planReleasesPageEntryPoint),
        component: (0, $awsZY.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $awsZY.LazyPlanReleases)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanReleasesRouteEntry.tsx',
                whichExportToUse: 'softwarePlanReleasesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("k4JTJ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $d1e7a57f049a4400$export$850236b64b0aa28b);
const $d1e7a57f049a4400$export$850236b64b0aa28b = {
    name: 'software-plan-releases',
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};

});

parcelRegister("awsZY", function(module, exports) {
$parcel$export(module.exports, "LazyPlanReleases", () => $88a9c1780c47d6b1$export$749f5d2513e04ec0);
$parcel$export(module.exports, "default", () => $88a9c1780c47d6b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $88a9c1780c47d6b1$export$749f5d2513e04ec0 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lKDjI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index-old.tsx"
});
const $88a9c1780c47d6b1$var$AsyncPlanReleases = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $88a9c1780c47d6b1$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });
var $88a9c1780c47d6b1$export$2e2bcd8739ae039 = $88a9c1780c47d6b1$var$AsyncPlanReleases;

});
parcelRegister("lKDjI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("iHplQ")),
    $ewTvA("9r5vw")
]).then(()=>parcelRequire('kR6P1'));

});


parcelRegister("iHLLP", function(module, exports) {
$parcel$export(module.exports, "planReleasesPageEntryPoint", () => $9e9f8fc1cf847fdb$export$accb0033190d648e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $a7imf = parcelRequire("a7imf");

var $dGTIT = parcelRequire("dGTIT");
const $9e9f8fc1cf847fdb$export$accb0033190d648e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $a7imf.planReleasesEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("a7imf", function(module, exports) {
$parcel$export(module.exports, "planReleasesEntryPoint", () => $87c1d93c31895bf7$export$4e18896acd7f3236);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $87c1d93c31895bf7$export$4e18896acd7f3236 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8WfpL")), {
        moduleId: "e3e1145d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8WfpL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("ilXL7")),
    $ewTvA("jtKOB")
]).then(()=>parcelRequire('2IyKF'));

});




parcelRegister("30PHd", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRouteEntry", () => $ebe2d9db7034294d$export$fc7007717398c727);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $eJBj5 = parcelRequire("eJBj5");

var $7AOfB = parcelRequire("7AOfB");
const $ebe2d9db7034294d$export$fc7007717398c727 = (0, $6xToB.createEntry)((0, $eJBj5.softwarePlanSettingsAutoSchedulerRoute), ()=>({
        group: 'software',
        component: (0, $7AOfB.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $7AOfB.LazyPlanSettingsAutoScheduler)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsAutoSchedulerRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsAutoSchedulerRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eJBj5", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $bf574ac126f3c13e$export$e44088b2cc0206cf);
const $bf574ac126f3c13e$export$e44088b2cc0206cf = {
    name: 'plan-settings-auto-scheduler',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};

});

parcelRegister("7AOfB", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", () => $96272ebfe2b6bb42$export$8bcf7155849993f5);
$parcel$export(module.exports, "default", () => $96272ebfe2b6bb42$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $96272ebfe2b6bb42$export$8bcf7155849993f5 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("a6FGL"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
const $96272ebfe2b6bb42$var$AsyncPlanSettingsAutoScheduler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $96272ebfe2b6bb42$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });
var $96272ebfe2b6bb42$export$2e2bcd8739ae039 = $96272ebfe2b6bb42$var$AsyncPlanSettingsAutoScheduler;

});
parcelRegister("a6FGL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("Obloc")),
    $ewTvA("hRljJ")
]).then(()=>parcelRequire('aIwYI'));

});



parcelRegister("aGFMx", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRouteEntry", () => $a3f3b097c6b64180$export$89472d9db6946668);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $hoP2D = parcelRequire("hoP2D");

var $hYyEK = parcelRequire("hYyEK");
const $a3f3b097c6b64180$export$89472d9db6946668 = (0, $6xToB.createEntry)((0, $hoP2D.softwarePlanSettingsCustomFieldsRoute), ()=>({
        group: 'software',
        component: (0, $hYyEK.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $hYyEK.LazyPlanSettingsCustomFields)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsCustomFieldsRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsCustomFieldsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hoP2D", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $ce6b53953112c5de$export$2634cd63c73f7a35);
const $ce6b53953112c5de$export$2634cd63c73f7a35 = {
    name: 'plan-settings-custom-fields',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};

});

parcelRegister("hYyEK", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsCustomFields", () => $500352ce4889d822$export$72bf44dbae2383e5);
$parcel$export(module.exports, "default", () => $500352ce4889d822$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $500352ce4889d822$export$72bf44dbae2383e5 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jHs2N"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
const $500352ce4889d822$var$AsyncPlanSettingsCustomFields = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $500352ce4889d822$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });
var $500352ce4889d822$export$2e2bcd8739ae039 = $500352ce4889d822$var$AsyncPlanSettingsCustomFields;

});
parcelRegister("jHs2N", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("1XLq2")),
    $ewTvA("497Y2")
]).then(()=>parcelRequire('hk4tW'));

});



parcelRegister("fFZgu", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRouteEntry", () => $265bba88c56b1ffd$export$cd1b612d0c014154);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $jjFZG = parcelRequire("jjFZG");

var $edgkW = parcelRequire("edgkW");
const $265bba88c56b1ffd$export$cd1b612d0c014154 = (0, $6xToB.createEntry)((0, $jjFZG.softwarePlanSettingsExclusionRulesRoute), ()=>({
        group: 'software',
        component: (0, $edgkW.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $edgkW.LazyPlanSettingsExclusionRules)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsExclusionRulesRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsExclusionRulesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jjFZG", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $0e7e623baf5dec5c$export$358b0ca69a4bd731);
const $0e7e623baf5dec5c$export$358b0ca69a4bd731 = {
    name: 'plan-settings-exclusion-rules',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};

});

parcelRegister("edgkW", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsExclusionRules", () => $c9345d7804a4ef5d$export$78f61b03c267e6d9);
$parcel$export(module.exports, "default", () => $c9345d7804a4ef5d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $c9345d7804a4ef5d$export$78f61b03c267e6d9 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bqXkD"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
const $c9345d7804a4ef5d$var$AsyncPlanSettingsExclusionRules = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $c9345d7804a4ef5d$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });
var $c9345d7804a4ef5d$export$2e2bcd8739ae039 = $c9345d7804a4ef5d$var$AsyncPlanSettingsExclusionRules;

});
parcelRegister("bqXkD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("iI4Mf")),
    $ewTvA("hBF5o")
]).then(()=>parcelRequire('jIXzu'));

});



parcelRegister("hAVk6", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFeaturesRouteEntry", () => $89f75d6f39c73a44$export$591e778de9bccacd);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $cxKOj = parcelRequire("cxKOj");

var $3jB8o = parcelRequire("3jB8o");

var $1S3r8 = parcelRequire("1S3r8");
const $89f75d6f39c73a44$export$591e778de9bccacd = (0, $6xToB.createEntry)((0, $3jB8o.softwarePlanSettingsFeaturesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? (0, $1S3r8.planSettingsFeaturesRouteEntry) : undefined,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsFeaturesRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsFeaturesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3jB8o", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFeaturesRoute", () => $758ef62398fd6fce$export$2e79af7413eb4921);
const $758ef62398fd6fce$export$2e79af7413eb4921 = {
    name: 'plan-settings-features',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features'
};

});

parcelRegister("1S3r8", function(module, exports) {
$parcel$export(module.exports, "planSettingsFeaturesRouteEntry", () => $a09cd3e6d9fa9196$export$2cf26c8369ef29cd);

var $g8uYY = parcelRequire("g8uYY");

var $9GNeY = parcelRequire("9GNeY");

var $5RW99 = parcelRequire("5RW99");
const $a09cd3e6d9fa9196$export$2cf26c8369ef29cd = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $9GNeY.planSettingsFeaturesEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});

});
parcelRegister("9GNeY", function(module, exports) {
$parcel$export(module.exports, "planSettingsFeaturesEntryPoint", () => $5074ac9e656339bd$export$ae1839f07bffa153);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $eozQK = parcelRequire("eozQK");

const $5074ac9e656339bd$export$ae1839f07bffa153 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("2cFql")), {
        moduleId: "3d5245c7",
        priority: "userVisible"
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                preLoadFeaturesEntryPoint: {
                    entryPoint: (0, $eozQK.featuresEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("eozQK", function(module, exports) {
$parcel$export(module.exports, "featuresEntryPoint", () => $2ef2594cc5316609$export$e283e7092d12783d);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $bvWVK = parcelRequire("bvWVK");

var $4cTDP = parcelRequire("4cTDP");
const $2ef2594cc5316609$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>{
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

const $2ef2594cc5316609$export$e283e7092d12783d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("6IzlI")), {
        moduleId: "2bffebe5",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>{
        return {
            queries: {
                plan: {
                    variables: {
                        planId: $2ef2594cc5316609$var$toPlanAri({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            planId: String(match.params.planId)
                        }),
                        releasesFeatureGateEnabled: (0, $4cTDP.fg)('simple-plans-m2-release-feature-toggle'),
                        planSettingRefreshEnabled: (0, $4cTDP.fg)('plan_settings_refresh')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $bvWVK.default
                }
            }
        };
    }
});

});
parcelRegister("bvWVK", function(module, exports) {
$parcel$export(module.exports, "default", () => $149737881f2fbdc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ba327901bde6343f0f8977263495a61>>
 * @relayHash 3005ddf30678cbf39055c070ff7f15ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea
const $149737881f2fbdc9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea",
        "metadata": {},
        "name": "uiFeaturesPlansSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $149737881f2fbdc9$export$2e2bcd8739ae039 = $149737881f2fbdc9$var$node;

});

parcelRegister("6IzlI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("esUfm")),
    $ewTvA("20nMe")
]).then(()=>parcelRequire('j5C3s'));

});


parcelRegister("2cFql", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("a2EUO")),
    $ewTvA("9IXKO")
]).then(()=>parcelRequire('4POhN'));

});




parcelRegister("72a1U", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRouteEntry", () => $07600df33fa9e5d1$export$2f975c505121e139);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $8gYxy = parcelRequire("8gYxy");

var $lNE5T = parcelRequire("lNE5T");
const $07600df33fa9e5d1$export$2f975c505121e139 = (0, $6xToB.createEntry)((0, $8gYxy.softwarePlanSettingsFindYourIssueRoute), ()=>({
        group: 'software',
        component: (0, $lNE5T.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lNE5T.LazyPlanSettingsFindYourIssue)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsFindYourIssueRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsFindYourIssueRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8gYxy", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $3e705bf91ee82323$export$ab61883f74eb27c2);
const $3e705bf91ee82323$export$ab61883f74eb27c2 = {
    name: 'plan-settings-find-your-issue',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};

});

parcelRegister("lNE5T", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", () => $2becb75d109e50ab$export$731998664b7d5e72);
$parcel$export(module.exports, "default", () => $2becb75d109e50ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $2becb75d109e50ab$export$731998664b7d5e72 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("lf7RP"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
const $2becb75d109e50ab$var$AsyncPlanSettingsFindYourIssue = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $2becb75d109e50ab$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });
var $2becb75d109e50ab$export$2e2bcd8739ae039 = $2becb75d109e50ab$var$AsyncPlanSettingsFindYourIssue;

});
parcelRegister("lf7RP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("bN0OL")),
    $ewTvA("6es7M")
]).then(()=>parcelRequire('7g6vL'));

});



parcelRegister("luRFY", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRouteEntry", () => $25304d26e67fc6ad$export$f0b7e9788ab79be0);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $aaSxy = parcelRequire("aaSxy");

var $54xqO = parcelRequire("54xqO");
const $25304d26e67fc6ad$export$f0b7e9788ab79be0 = (0, $6xToB.createEntry)((0, $aaSxy.softwarePlanSettingsIssueSourcesRoute), ()=>({
        group: 'software',
        component: (0, $54xqO.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $54xqO.LazyPlanSettingsIssueSources)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsIssueSourcesRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsIssueSourcesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aaSxy", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $be54de734395d2e7$export$fa18324265e4400c);
const $be54de734395d2e7$export$fa18324265e4400c = {
    name: 'plan-settings-issue-sources',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};

});

parcelRegister("54xqO", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsIssueSources", () => $ec2c571598fcd399$export$7ba4b487efcedeb3);
$parcel$export(module.exports, "default", () => $ec2c571598fcd399$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ec2c571598fcd399$export$7ba4b487efcedeb3 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("99p93"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
const $ec2c571598fcd399$var$AsyncPlanSettingsIssueSources = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec2c571598fcd399$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: !(0, $4cTDP.fg)('plan_settings_refresh')
    });
var $ec2c571598fcd399$export$2e2bcd8739ae039 = $ec2c571598fcd399$var$AsyncPlanSettingsIssueSources;

});
parcelRegister("99p93", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("hBbNs")),
    $ewTvA("gHNgE")
]).then(()=>parcelRequire('2F6ud'));

});



parcelRegister("3dqLQ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPermissionsRouteEntry", () => $9c524ee5be436c95$export$1afc7a9efa99340);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $gcKb3 = parcelRequire("gcKb3");

var $ljkv8 = parcelRequire("ljkv8");
const $9c524ee5be436c95$export$1afc7a9efa99340 = (0, $6xToB.createEntry)((0, $gcKb3.softwarePlanSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $ljkv8.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ljkv8.LazyPlanSettingsPermissions)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsPermissionsRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsPermissionsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gcKb3", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $ed8fa3156ca6cb63$export$6734c29372722a5e);
const $ed8fa3156ca6cb63$export$6734c29372722a5e = {
    name: 'plan-settings-permissions',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};

});

parcelRegister("ljkv8", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsPermissions", () => $4424f64bc52cfe12$export$49f5b76ad5c06a42);
$parcel$export(module.exports, "default", () => $4424f64bc52cfe12$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4424f64bc52cfe12$export$49f5b76ad5c06a42 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bI0Pm"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
const $4424f64bc52cfe12$var$AsyncPlanSettingsPermissions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4424f64bc52cfe12$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });
var $4424f64bc52cfe12$export$2e2bcd8739ae039 = $4424f64bc52cfe12$var$AsyncPlanSettingsPermissions;

});
parcelRegister("bI0Pm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("cyD0Q")),
    $ewTvA("jRsxG")
]).then(()=>parcelRequire('iNQES'));

});



parcelRegister("gxAJV", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRouteEntry", () => $3891a8b9ceef0222$export$1d6300da0c837e02);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $aWIMa = parcelRequire("aWIMa");

var $g3zm3 = parcelRequire("g3zm3");
const $3891a8b9ceef0222$export$1d6300da0c837e02 = (0, $6xToB.createEntry)((0, $aWIMa.softwarePlanSettingsPlanInfoRoute), ()=>({
        group: 'software',
        component: (0, $g3zm3.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $g3zm3.LazyPlanSettingsPlanInfo)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsPlanInfoRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsPlanInfoRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("aWIMa", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $361c0444b958f959$export$76e6bdc959f6fa97);
const $361c0444b958f959$export$76e6bdc959f6fa97 = {
    name: 'plan-settings-plan-info',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};

});

parcelRegister("g3zm3", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsPlanInfo", () => $a4d3dcfb1f50f946$export$c1344fd7d24991b3);
$parcel$export(module.exports, "default", () => $a4d3dcfb1f50f946$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

const $a4d3dcfb1f50f946$export$c1344fd7d24991b3 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("6NfxZ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
const $a4d3dcfb1f50f946$var$AsyncPlanSettingsPlanInfo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a4d3dcfb1f50f946$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: !(0, $4cTDP.fg)('plan_settings_refresh')
    });
var $a4d3dcfb1f50f946$export$2e2bcd8739ae039 = $a4d3dcfb1f50f946$var$AsyncPlanSettingsPlanInfo;

});
parcelRegister("6NfxZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("khhOP")),
    $ewTvA("1KcmF")
]).then(()=>parcelRequire('kRwCG'));

});



parcelRegister("dLExR", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRouteEntry", () => $27f2bf42140fda69$export$be96222796ad98f0);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $97z4K = parcelRequire("97z4K");

var $kfMVX = parcelRequire("kfMVX");
const $27f2bf42140fda69$export$be96222796ad98f0 = (0, $6xToB.createEntry)((0, $97z4K.softwarePlanSettingsProgramBoardsRoute), ()=>({
        group: 'software',
        component: (0, $kfMVX.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kfMVX.LazyPlanSettingsProgramBoards)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsProgramBoardsRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsProgramBoardsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("97z4K", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $51968d20998f144d$export$3d54c48a91a178c0);
const $51968d20998f144d$export$3d54c48a91a178c0 = {
    name: 'plan-settings-program-boards',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};

});

parcelRegister("kfMVX", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsProgramBoards", () => $ec6a0e983d42f556$export$ffdec728a47c437c);
$parcel$export(module.exports, "default", () => $ec6a0e983d42f556$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ec6a0e983d42f556$export$ffdec728a47c437c = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9oxHO"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
const $ec6a0e983d42f556$var$AsyncPlanSettingsProgramBoards = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec6a0e983d42f556$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });
var $ec6a0e983d42f556$export$2e2bcd8739ae039 = $ec6a0e983d42f556$var$AsyncPlanSettingsProgramBoards;

});
parcelRegister("9oxHO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("1cveg")),
    $ewTvA("l5P22")
]).then(()=>parcelRequire('egoXV'));

});



parcelRegister("5zVch", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRouteEntry", () => $1d419df2ff4a54b2$export$53a9ea0e0b05ceb5);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $9AdMQ = parcelRequire("9AdMQ");

var $jVxAw = parcelRequire("jVxAw");
const $1d419df2ff4a54b2$export$53a9ea0e0b05ceb5 = (0, $6xToB.createEntry)((0, $9AdMQ.softwarePlanSettingsRemovedIssuesRoute), ()=>({
        group: 'software',
        component: (0, $jVxAw.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $jVxAw.LazyPlanSettingsRemovedIssues)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsRemovedIssuesRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsRemovedIssuesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("9AdMQ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $d8656b48bf5bac26$export$8b77532ba9798e64);
const $d8656b48bf5bac26$export$8b77532ba9798e64 = {
    name: 'plan-settings-removed-issues',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};

});

parcelRegister("jVxAw", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", () => $4ee08e20301e5255$export$759df6301ec72119);
$parcel$export(module.exports, "default", () => $4ee08e20301e5255$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $4ee08e20301e5255$export$759df6301ec72119 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("61ZTE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
const $4ee08e20301e5255$var$AsyncPlanSettingsRemovedIssues = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $4ee08e20301e5255$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });
var $4ee08e20301e5255$export$2e2bcd8739ae039 = $4ee08e20301e5255$var$AsyncPlanSettingsRemovedIssues;

});
parcelRegister("61ZTE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("bDV3G")),
    $ewTvA("7FKyf")
]).then(()=>parcelRequire('atQfO'));

});



parcelRegister("2ZnyJ", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRouteEntry", () => $4dd2f754021029da$export$64d5b46da2e58194);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $bbCSS = parcelRequire("bbCSS");

var $c6UN7 = parcelRequire("c6UN7");
const $4dd2f754021029da$export$64d5b46da2e58194 = (0, $6xToB.createEntry)((0, $bbCSS.softwarePlanSettingsSavedViewsRoute), ()=>({
        group: 'software',
        component: (0, $c6UN7.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $c6UN7.LazyPlanSettingsSavedViews)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsSavedViewsRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsSavedViewsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bbCSS", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $248b0510532bb809$export$a0fec30f475e8756);
const $248b0510532bb809$export$a0fec30f475e8756 = {
    name: 'plan-settings-saved-views',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};

});

parcelRegister("c6UN7", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsSavedViews", () => $473181a46b14ce3b$export$a5398542699d356a);
$parcel$export(module.exports, "default", () => $473181a46b14ce3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $4cTDP = parcelRequire("4cTDP");

const $473181a46b14ce3b$export$a5398542699d356a = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("dDwIS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
const $473181a46b14ce3b$var$AsyncPlanSettingsSavedViews = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $473181a46b14ce3b$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: !(0, $4cTDP.fg)('plan_settings_refresh')
    });
var $473181a46b14ce3b$export$2e2bcd8739ae039 = $473181a46b14ce3b$var$AsyncPlanSettingsSavedViews;

});
parcelRegister("dDwIS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("2NyIr")),
    $ewTvA("9VlbJ")
]).then(()=>parcelRequire('dkKSy'));

});



parcelRegister("lGz7G", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsScenariosRouteEntry", () => $1f4048c57f0fce3c$export$9b6e6b5d471b90f);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $dQz6Y = parcelRequire("dQz6Y");

var $6FXeu = parcelRequire("6FXeu");
const $1f4048c57f0fce3c$export$9b6e6b5d471b90f = (0, $6xToB.createEntry)((0, $dQz6Y.softwarePlanSettingsScenariosRoute), ()=>({
        group: 'software',
        component: (0, $6FXeu.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6FXeu.LazyPlanSettingsScenarios)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsScenariosRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsScenariosRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dQz6Y", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $7bd5cf26036d351a$export$d32efeefb944c6b7);
const $7bd5cf26036d351a$export$d32efeefb944c6b7 = {
    name: 'plan-settings-scenarios',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};

});

parcelRegister("6FXeu", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsScenarios", () => $fa8d70102ba2fe73$export$94104fcc1a6f460f);
$parcel$export(module.exports, "default", () => $fa8d70102ba2fe73$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fa8d70102ba2fe73$export$94104fcc1a6f460f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("kOssr"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
const $fa8d70102ba2fe73$var$AsyncPlanSettingsScenarios = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fa8d70102ba2fe73$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });
var $fa8d70102ba2fe73$export$2e2bcd8739ae039 = $fa8d70102ba2fe73$var$AsyncPlanSettingsScenarios;

});
parcelRegister("kOssr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("1hjFd")),
    $ewTvA("kOjn4")
]).then(()=>parcelRequire('bwkSx'));

});



parcelRegister("aPs1z", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSchedulingRouteEntry", () => $b5f6b3aa4894cdd9$export$c1319dec79812860);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $12tkp = parcelRequire("12tkp");

var $8mUfY = parcelRequire("8mUfY");
const $b5f6b3aa4894cdd9$export$c1319dec79812860 = (0, $6xToB.createEntry)((0, $12tkp.softwarePlanSettingsSchedulingRoute), ()=>({
        group: 'software',
        component: (0, $8mUfY.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8mUfY.LazyPlanSettingsScheduling)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSettingsSchedulingRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSettingsSchedulingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("12tkp", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $ac65e04ce8614138$export$a215ef374dd2a8a9);
const $ac65e04ce8614138$export$a215ef374dd2a8a9 = {
    name: 'plan-settings-scheduling',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};

});

parcelRegister("8mUfY", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSettingsScheduling", () => $51c6b5d8e750230c$export$3bf11db1bbeae73e);
$parcel$export(module.exports, "default", () => $51c6b5d8e750230c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $4cTDP = parcelRequire("4cTDP");

var $bQWwW = parcelRequire("bQWwW");

const $51c6b5d8e750230c$export$3bf11db1bbeae73e = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("jqazl"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
const $51c6b5d8e750230c$var$AsyncPlanSettingsScheduling = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $51c6b5d8e750230c$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: !(0, $4cTDP.fg)('plan_settings_refresh')
    });
var $51c6b5d8e750230c$export$2e2bcd8739ae039 = $51c6b5d8e750230c$var$AsyncPlanSettingsScheduling;

});
parcelRegister("jqazl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");



module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("lzeUg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6swty")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("eIeA2")),
    $ewTvA("fliVL"),
    $ewTvA("rnfHx")
]).then(()=>parcelRequire('h4lm7'));

});



parcelRegister("91LPB", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSummaryRouteEntry", () => $8599f2df48e20cd0$export$4bc10767887a84cc);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $jmv36 = parcelRequire("jmv36");

var $9NmsS = parcelRequire("9NmsS");

var $4made = parcelRequire("4made");

var $8LEOe = parcelRequire("8LEOe");

var $3IEdy = parcelRequire("3IEdy");
const $8599f2df48e20cd0$export$4bc10767887a84cc = (0, $6xToB.createEntry)((0, $4made.softwarePlanSummaryRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $3IEdy.planSummaryPageEntryPoint),
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $8LEOe.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $jmv36.advancedRoadmapsSummaryDataResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8LEOe.LazyPlanSummary)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanSummaryRouteEntry.tsx',
                whichExportToUse: 'softwarePlanSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("4made", function(module, exports) {
$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $c93c14dbb7c5a41f$export$25a8cf27557a612d);
const $c93c14dbb7c5a41f$export$25a8cf27557a612d = {
    name: 'software-plan-summary',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};

});

parcelRegister("8LEOe", function(module, exports) {
$parcel$export(module.exports, "LazyPlanSummary", () => $db2e9315c0d2e007$export$c717f0d9d7f11b49);
$parcel$export(module.exports, "default", () => $db2e9315c0d2e007$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $db2e9315c0d2e007$export$c717f0d9d7f11b49 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("5QPfy"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $db2e9315c0d2e007$var$AsyncPlanSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $db2e9315c0d2e007$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });
var $db2e9315c0d2e007$export$2e2bcd8739ae039 = $db2e9315c0d2e007$var$AsyncPlanSummary;

});

parcelRegister("3IEdy", function(module, exports) {
$parcel$export(module.exports, "planSummaryPageEntryPoint", () => $2c4236ffd8d0ff93$export$a3858cce1e973f19);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $legH4 = parcelRequire("legH4");

var $dGTIT = parcelRequire("dGTIT");
const $2c4236ffd8d0ff93$export$a3858cce1e973f19 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $legH4.planSummaryEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("e6ehT", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTeamsRouteEntry", () => $2b87ec832fba9563$export$cc5b7d3f8546a313);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $2ibNL = parcelRequire("2ibNL");

var $FENpN = parcelRequire("FENpN");

var $2NmIZ = parcelRequire("2NmIZ");
const $2b87ec832fba9563$export$cc5b7d3f8546a313 = (0, $6xToB.createEntry)((0, $2ibNL.softwarePlanTeamsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $2NmIZ.planTeamsPageEntryPoint),
        component: (0, $FENpN.default),
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $FENpN.LazyPlanTeams)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanTeamsRouteEntry.tsx',
                whichExportToUse: 'softwarePlanTeamsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2ibNL", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $02246c8c6d90d7a6$export$fc66f5c0de18ddc7);
const $02246c8c6d90d7a6$export$fc66f5c0de18ddc7 = {
    name: 'software-plan-teams',
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};

});

parcelRegister("FENpN", function(module, exports) {
$parcel$export(module.exports, "LazyPlanTeams", () => $53f9b9a1089de614$export$f85952f98f28fed0);
$parcel$export(module.exports, "default", () => $53f9b9a1089de614$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $53f9b9a1089de614$export$f85952f98f28fed0 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("ajvzE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index-old.tsx"
});
const $53f9b9a1089de614$var$AsyncPlanTeams = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $53f9b9a1089de614$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });
var $53f9b9a1089de614$export$2e2bcd8739ae039 = $53f9b9a1089de614$var$AsyncPlanTeams;

});
parcelRegister("ajvzE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("h3my9")),
    $ewTvA("7YIDy")
]).then(()=>parcelRequire('jeqsm'));

});


parcelRegister("2NmIZ", function(module, exports) {
$parcel$export(module.exports, "planTeamsPageEntryPoint", () => $962e8dac00cd052f$export$e75b3c6626974862);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1zgTH = parcelRequire("1zgTH");

var $dGTIT = parcelRequire("dGTIT");
const $962e8dac00cd052f$export$e75b3c6626974862 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1zgTH.planTeamsEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});
parcelRegister("1zgTH", function(module, exports) {
$parcel$export(module.exports, "planTeamsEntryPoint", () => $65620f7d12f16aed$export$afd1c95955e9abac);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $65620f7d12f16aed$export$afd1c95955e9abac = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cBjWn")), {
        moduleId: "8c4bf459",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cBjWn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("fZLUz")),
    $ewTvA("e6Ioi")
]).then(()=>parcelRequire('lNSe1'));

});




parcelRegister("gAUgF", function(module, exports) {
$parcel$export(module.exports, "softwarePlanTimelineRouteEntry", () => $2fda052cc6ca3459$export$c5b46ecd4d9a8abd);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $it9UZ = parcelRequire("it9UZ");

var $8vSr3 = parcelRequire("8vSr3");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $4cTDP = parcelRequire("4cTDP");

var $4KrIc = parcelRequire("4KrIc");

var $9NmsS = parcelRequire("9NmsS");

var $iArJs = parcelRequire("iArJs");

var $8EnAV = parcelRequire("8EnAV");

var $iIcBn = parcelRequire("iIcBn");

var $9iLyn = parcelRequire("9iLyn");
const $2fda052cc6ca3459$export$c5b46ecd4d9a8abd = (0, $6xToB.createEntry)((0, $iArJs.softwarePlanTimelineRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $9iLyn.planTimelinePageEntryPoint),
        component: (0, $iIcBn.default),
        skeleton: (0, $4cTDP.fg)('plan_timeline_skeleton') ? (0, $8EnAV.PlanTimelineSkeleton) : undefined,
        layout: (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), (0, $8vSr3.planLayout)),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarPlanResources)(),
            (0, $4KrIc.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $4KrIc.advancedRoadmapsReduxStoreStateResource),
            (0, $4KrIc.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS,
            sidebar: (0, $it9UZ.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $iIcBn.LazyPlanTimeline)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-entries/src/softwarePlanTimelineRouteEntry.tsx',
                whichExportToUse: 'softwarePlanTimelineRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("8EnAV", function(module, exports) {
$parcel$export(module.exports, "PlanTimelineSkeleton", () => $e067c1983f0bd80f$export$66cb34f8935c5b02);
$parcel$export(module.exports, "PlanTimelineSkeletonWithoutPadding", () => $e067c1983f0bd80f$export$f811d7dfe6fc560);
/* PlanTimelineSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $13Hpj = parcelRequire("13Hpj");

var $1O4Mu = parcelRequire("1O4Mu");
const $e067c1983f0bd80f$var$customCssStyles = null;
const $e067c1983f0bd80f$var$customCssStylesWithPadding = null;
const $e067c1983f0bd80f$export$66cb34f8935c5b02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($13Hpj))),
        className: (0, $hcewu.default)([
            "_slt81tcg _2zz1idpf"
        ])
    });
const $e067c1983f0bd80f$export$f811d7dfe6fc560 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($13Hpj))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });
const $e067c1983f0bd80f$export$5310e44384026686 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1O4Mu))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("13Hpj", function(module, exports) {
module.exports = new URL("plan-timeline-skeleton.tpl.184c1195.svg", import.meta.url).toString();

});

parcelRegister("1O4Mu", function(module, exports) {
module.exports = new URL("plan-timeline-without-filters-skeleton.tpl.745bd011.svg", import.meta.url).toString();

});


parcelRegister("9iLyn", function(module, exports) {
$parcel$export(module.exports, "planTimelinePageEntryPoint", () => $411c11165b1d57e9$export$7ee5b399f9530a72);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $iyaX4 = parcelRequire("iyaX4");

var $dGTIT = parcelRequire("dGTIT");
const $411c11165b1d57e9$export$7ee5b399f9530a72 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iyaX4.planTimelineEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS,
    horizontalNavigation: (0, $dGTIT.plansHorizontalNavigationEntryPoint)
});

});


parcelRegister("7eIYH", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRouteEntry", () => $f024ecf422071a5c$export$6df3cef5dab31b3b);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $kHymb = parcelRequire("kHymb");

var $kWsG7 = parcelRequire("kWsG7");
const $f024ecf422071a5c$export$6df3cef5dab31b3b = (0, $6xToB.createEntry)((0, $kHymb.softwareProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        component: (0, $kWsG7.default),
        forPaint: [
            (0, $kWsG7.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/softwareProformaIssueFormsDirectEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareProformaIssueFormsDirectEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kHymb", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRoute", () => $19fff290c5a771c2$export$6d1b944aeb758fdb);
const $19fff290c5a771c2$export$6d1b944aeb758fdb = {
    name: 'software-proforma-issue-forms-direct-embed',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("6dPXJ", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectRouteEntry", () => $6c7e0fc2c82459ef$export$552db754a91368f3);

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $6lBzs = parcelRequire("6lBzs");

var $8FCAy = parcelRequire("8FCAy");

var $d017r = parcelRequire("d017r");
const $6c7e0fc2c82459ef$export$552db754a91368f3 = (0, $6xToB.createEntry)((0, $6lBzs.softwareProformaIssueFormsDirectRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        resources: [
            (0, $dZRaT.projectContextResource)
        ],
        entryPoint: ()=>(0, $d017r.proformaIssueFormsDirectPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        perfMetricKey: 'issue-forms-direct',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-proforma-entries/src/softwareProformaIssueFormsDirectRouteEntry.tsx',
                whichExportToUse: 'softwareProformaIssueFormsDirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6lBzs", function(module, exports) {
$parcel$export(module.exports, "softwareProformaIssueFormsDirectRoute", () => $19c8fa51ef1b7123$export$69db7046ead228b9);
const $19c8fa51ef1b7123$export$69db7046ead228b9 = {
    name: 'software-proforma-issue-forms-direct',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("k80dv", function(module, exports) {
$parcel$export(module.exports, "softwareReleaseNotesRouteEntry", () => $7b06764fef8eab48$export$543aad2020051ecb);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $7aNAF = parcelRequire("7aNAF");

var $8FCAy = parcelRequire("8FCAy");

var $bMm2d = parcelRequire("bMm2d");
const $7b06764fef8eab48$export$543aad2020051ecb = (0, $6xToB.createEntry)((0, $7aNAF.softwareReleaseNotesRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $dZRaT.projectContextResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        component: (0, $bMm2d.SpaReleaseNoteRedirectToVersionDetails),
        layout: (0, $8FCAy.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/softwareReleaseNotesRouteEntry.tsx',
                whichExportToUse: 'softwareReleaseNotesRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7aNAF", function(module, exports) {
$parcel$export(module.exports, "softwareReleaseNotesRoute", () => $e99ebbe378b89573$export$a0223091962262d4);
const $e99ebbe378b89573$export$a0223091962262d4 = {
    name: 'software-release-notes',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};

});


parcelRegister("dw2ce", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurndownRouteEntry", () => $886379cbecc8f508$export$c54d6c6781ad5beb);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $iJuQx = parcelRequire("iJuQx");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $8Q6IF = parcelRequire("8Q6IF");
const $886379cbecc8f508$export$c54d6c6781ad5beb = (0, $6xToB.createEntry)((0, $iJuQx.softwareReportsBurndownRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burndown-chart',
        entryPoint: ()=>(0, $8Q6IF.BurnDownReportPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsBurndownRouteEntry.tsx',
                whichExportToUse: 'softwareReportsBurndownRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iJuQx", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurndownRoute", () => $1c25666ba02dff6f$export$e0d8c26cb1430ae4);
const $1c25666ba02dff6f$export$e0d8c26cb1430ae4 = {
    name: 'software-reports-burndown',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};

});

parcelRegister("3dfhx", function(module, exports) {
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $f157f2314f14e946$export$f234446c23dc22a);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $f157f2314f14e946$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $f157f2314f14e946$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});

parcelRegister("8Q6IF", function(module, exports) {
$parcel$export(module.exports, "BurnDownReportPageEntrypoint", () => $e0fcf0f663f86f08$export$4cba13cb70183e0e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $kYF9G = parcelRequire("kYF9G");
const $e0fcf0f663f86f08$export$4cba13cb70183e0e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $kYF9G.burnDownReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("kYF9G", function(module, exports) {
$parcel$export(module.exports, "burnDownReportEntrypoint", () => $0e28d81199b47059$export$ca10f29d444e87e0);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $0e28d81199b47059$export$ca10f29d444e87e0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("heEkO")), {
        moduleId: "24e2d8d6",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("heEkO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9BnO7").then(()=>parcelRequire('dk4Fo'));

});




parcelRegister("eSIYo", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurnupRouteEntry", () => $07e110ef487292bf$export$e53193d8a7e7d068);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $7XWOG = parcelRequire("7XWOG");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $bmAy4 = parcelRequire("bmAy4");
const $07e110ef487292bf$export$e53193d8a7e7d068 = (0, $6xToB.createEntry)((0, $7XWOG.softwareReportsBurnupRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burnup-chart',
        entryPoint: ()=>(0, $bmAy4.BurnUpReportPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsBurnupRouteEntry.tsx',
                whichExportToUse: 'softwareReportsBurnupRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7XWOG", function(module, exports) {
$parcel$export(module.exports, "softwareReportsBurnupRoute", () => $ff38cc37be870bc6$export$5b818a6914ca8376);
const $ff38cc37be870bc6$export$5b818a6914ca8376 = {
    name: 'software-reports-burnup',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};

});

parcelRegister("bmAy4", function(module, exports) {
$parcel$export(module.exports, "BurnUpReportPageEntrypoint", () => $c55c58b92207cefb$export$5901b46abc65034e);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $4BOCg = parcelRequire("4BOCg");
const $c55c58b92207cefb$export$5901b46abc65034e = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $4BOCg.burnUpReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("4BOCg", function(module, exports) {
$parcel$export(module.exports, "burnUpReportEntrypoint", () => $99bff690215a4f22$export$dfec2f14e71954f6);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $99bff690215a4f22$export$dfec2f14e71954f6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bqf12")), {
        moduleId: "a1ebcc2d",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bqf12", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Yxt8").then(()=>parcelRequire('4e6Iv'));

});




parcelRegister("gLWOL", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlRouteEntry", () => $a1b0a281a03b8537$export$3cb9570ca242f2a2);

var $7mF43 = parcelRequire("7mF43");

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $gc43N = parcelRequire("gc43N");

var $kSeQy = parcelRequire("kSeQy");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $cF2st = parcelRequire("cF2st");
const $a1b0a281a03b8537$export$3cb9570ca242f2a2 = (0, $6xToB.createEntry)((0, $gc43N.softwareReportsControlRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.control-chart',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>!(0, $4cTDP.fg)('jsw_enable_avp_control_chart') || (0, $jom8W.isDevopsFeatureDisabledInFedRamp)() ? (0, $kSeQy.notFoundPageEntrypoint) : (0, $cF2st.softwareReportsControlPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-reports-control',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-control'),
                teamName: 'helios'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsControlRouteEntry.tsx',
                whichExportToUse: 'softwareReportsControlRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gc43N", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlRoute", () => $e9071b86792dced4$export$8c91815cd4b1c078);
const $e9071b86792dced4$export$8c91815cd4b1c078 = {
    name: 'software-reports-control',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};

});

parcelRegister("cF2st", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlPageEntrypoint", () => $34c60a09339837cb$export$a35d50a33df2f6d5);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $elSyw = parcelRequire("elSyw");
const $34c60a09339837cb$export$a35d50a33df2f6d5 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $elSyw.softwareReportsControlEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("elSyw", function(module, exports) {
$parcel$export(module.exports, "softwareReportsControlEntrypoint", () => $5de751e2909da174$export$240870c8f3915828);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $5de751e2909da174$export$240870c8f3915828 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("bhs7q")), {
        moduleId: "00c05b16",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bhs7q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");


module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    (parcelRequire("c5iyL"))((parcelRequire("iTG8W")).resolve("hZtDb")),
    $ewTvA("fliVL"),
    $ewTvA("73GNs")
]).then(()=>parcelRequire('90UZu'));

});




parcelRegister("YXwcg", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCumulativeRouteEntry", () => $04be22af72b1ce63$export$7ace4d0363d78b41);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $Cx6WS = parcelRequire("Cx6WS");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $9zSDE = parcelRequire("9zSDE");
const $04be22af72b1ce63$export$7ace4d0363d78b41 = (0, $6xToB.createEntry)((0, $Cx6WS.softwareReportsCumulativeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.cumulative-flow-diagram',
        entryPoint: ()=>(0, $9zSDE.CumulativeReportPageEntrypoint),
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsCumulativeRouteEntry.tsx',
                whichExportToUse: 'softwareReportsCumulativeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("Cx6WS", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCumulativeRoute", () => $8aa53e8f2d3e5994$export$3c48ddd40d00b0d2);
const $8aa53e8f2d3e5994$export$3c48ddd40d00b0d2 = {
    name: 'software-reports-cumulative',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};

});

parcelRegister("9zSDE", function(module, exports) {
$parcel$export(module.exports, "CumulativeReportPageEntrypoint", () => $5e1de5498f5ca52d$export$2f3ad380ae691fb5);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8SPy1 = parcelRequire("8SPy1");
const $5e1de5498f5ca52d$export$2f3ad380ae691fb5 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $8SPy1.cumulativeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});
parcelRegister("8SPy1", function(module, exports) {
$parcel$export(module.exports, "cumulativeReportEntrypoint", () => $5bfd1c5e0dd3c442$export$f01a8d84f5a47478);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $5bfd1c5e0dd3c442$export$f01a8d84f5a47478 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("cocqf")), {
        moduleId: "d640aef5",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cocqf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i5sxz").then(()=>parcelRequire('38vJk'));

});




parcelRegister("lFKeR", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRouteEntry", () => $2cff0793907edbb0$export$9c40eb459ce6a0bc);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $fMdRQ = parcelRequire("fMdRQ");

var $f2JN3 = parcelRequire("f2JN3");

var $jom8W = parcelRequire("jom8W");

var $9BJU1 = parcelRequire("9BJU1");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $gzlQL = parcelRequire("gzlQL");

var $kHlOR = parcelRequire("kHlOR");

var $lopBx = parcelRequire("lopBx");

var $kSeQy = parcelRequire("kSeQy");

var $3FUST = parcelRequire("3FUST");

var $awzH2 = parcelRequire("awzH2");

var $sXRDv = parcelRequire("sXRDv");
const $2cff0793907edbb0$export$9c40eb459ce6a0bc = (0, $6xToB.createEntry)((0, $fMdRQ.softwareReportsCycleTimeClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $3FUST.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $sXRDv.cycleTimeReportClassicPageEntrypoint;
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $3FUST.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3FUST.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-cycle-time-classic'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsCycleTimeClassicBoardRouteEntry.tsx',
                whichExportToUse: 'softwareReportsCycleTimeClassicBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("fMdRQ", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRoute", () => $c07f7815a00490db$export$12423e360eb5fa9d);
const $c07f7815a00490db$export$12423e360eb5fa9d = {
    name: 'software-reports-cycle-time-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
    exact: true
};

});

parcelRegister("gzlQL", function(module, exports) {
$parcel$export(module.exports, "devOpsProviderResource", () => $1272457585d4dae5$export$19e58e21b24ae0d8);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $1272457585d4dae5$export$19e58e21b24ae0d8 = (0, $l1VxS.createResource)({
    type: (0, $c723c3992e1330b3$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("7luda")),
    maxAge: 60000
});
const $1272457585d4dae5$export$b80f5852c41a5ca8 = ()=>(0, $eJrcF.useResource)($1272457585d4dae5$export$19e58e21b24ae0d8);

});
const $c723c3992e1330b3$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $c723c3992e1330b3$export$d7f081d6dd0e72fc = 'bitbucket';
const $c723c3992e1330b3$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $c723c3992e1330b3$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("7luda", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2vYpt").then(()=>parcelRequire('jMyUD'));

});


parcelRegister("3FUST", function(module, exports) {
$parcel$export(module.exports, "LazyCycleTimeReport", () => $086a5c0618ce384d$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportClassic", () => $086a5c0618ce384d$export$237924ba64065cc3);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $086a5c0618ce384d$export$956f830ed027f1fb = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eNgIJ")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/ui/index-old.tsx"
});
const $086a5c0618ce384d$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $086a5c0618ce384d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $086a5c0618ce384d$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $086a5c0618ce384d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("eNgIJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ekBDv").then(()=>parcelRequire('8jisX'));

});


parcelRegister("sXRDv", function(module, exports) {
$parcel$export(module.exports, "cycleTimeReportClassicPageEntrypoint", () => $120412b894561719$export$2dba7a1bad1f01b2);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jHE2Y = parcelRequire("jHE2Y");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $120412b894561719$export$2dba7a1bad1f01b2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jHE2Y.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("jHE2Y", function(module, exports) {
$parcel$export(module.exports, "cycleTimeReportEntrypoint", () => $559d3e6fe810deb2$export$a4c2e42865ef5d9d);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $559d3e6fe810deb2$export$a4c2e42865ef5d9d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hvqd1")), {
        moduleId: "4e89963f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hvqd1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("apdMw").then(()=>parcelRequire('3M9k7'));

});




parcelRegister("1xutc", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicRouteEntry", () => $1a2920e61c54804f$export$1bbbe71c256ed1d0);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $kKxRa = parcelRequire("kKxRa");

var $f2JN3 = parcelRequire("f2JN3");

var $jom8W = parcelRequire("jom8W");

var $9BJU1 = parcelRequire("9BJU1");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $gzlQL = parcelRequire("gzlQL");

var $kHlOR = parcelRequire("kHlOR");

var $lopBx = parcelRequire("lopBx");

var $kSeQy = parcelRequire("kSeQy");

var $3FUST = parcelRequire("3FUST");

var $awzH2 = parcelRequire("awzH2");

var $sXRDv = parcelRequire("sXRDv");
const $1a2920e61c54804f$export$1bbbe71c256ed1d0 = (0, $6xToB.createEntry)((0, $kKxRa.softwareReportsCycleTimeClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $3FUST.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $sXRDv.cycleTimeReportClassicPageEntrypoint;
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $3FUST.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3FUST.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-cycle-time-classic'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsCycleTimeClassicRouteEntry.tsx',
                whichExportToUse: 'softwareReportsCycleTimeClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("kKxRa", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $bed42164d105061a$export$1e5e610e11119ea7);
const $bed42164d105061a$export$1e5e610e11119ea7 = {
    name: 'software-reports-cycle-time-classic',
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
    exact: true
};

});


parcelRegister("ed2hW", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeRouteEntry", () => $87c505443e4f25dc$export$8aee4b14556485d5);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $kSeQy = parcelRequire("kSeQy");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $gzlQL = parcelRequire("gzlQL");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $l0iSy = parcelRequire("l0iSy");

var $jom8W = parcelRequire("jom8W");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $4xORh = parcelRequire("4xORh");
const $87c505443e4f25dc$export$8aee4b14556485d5 = (0, $6xToB.createEntry)((0, $l0iSy.softwareReportsCycleTimeRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        entryPoint: ()=>{
            if ((0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $4xORh.cycleTimeReportPageEntrypoint;
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-cycle-time'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsCycleTimeRouteEntry.tsx',
                whichExportToUse: 'softwareReportsCycleTimeRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("l0iSy", function(module, exports) {
$parcel$export(module.exports, "softwareReportsCycleTimeRoute", () => $93c4e645cb3314ae$export$c777bb8f2591081);
const $93c4e645cb3314ae$export$c777bb8f2591081 = {
    name: 'software-reports-cycle-time',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};

});

parcelRegister("4xORh", function(module, exports) {
$parcel$export(module.exports, "cycleTimeReportPageEntrypoint", () => $9056a57a889fc21c$export$465717d84afb3d8f);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $jHE2Y = parcelRequire("jHE2Y");
const $9056a57a889fc21c$export$465717d84afb3d8f = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jHE2Y.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("9iKlG", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRouteEntry", () => $b0ce4f346a28d976$export$e0c7b9ad9dd8b956);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $9BJU1 = parcelRequire("9BJU1");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $kHlOR = parcelRequire("kHlOR");

var $b7Xft = parcelRequire("b7Xft");

var $jom8W = parcelRequire("jom8W");

var $ioHIu = parcelRequire("ioHIu");

var $aDtWM = parcelRequire("aDtWM");

var $gzlQL = parcelRequire("gzlQL");

var $lopBx = parcelRequire("lopBx");

var $kSeQy = parcelRequire("kSeQy");

var $6A5Fj = parcelRequire("6A5Fj");

var $awzH2 = parcelRequire("awzH2");

var $2xG2I = parcelRequire("2xG2I");
const $b0ce4f346a28d976$export$e0c7b9ad9dd8b956 = (0, $6xToB.createEntry)((0, $b7Xft.softwareReportsDeploymentFrequencyClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $6A5Fj.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $2xG2I.deploymentFrequencyReportPageEntrypoint;
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsDeploymentFrequencyClassicBoardRouteEntry.tsx',
                whichExportToUse: 'softwareReportsDeploymentFrequencyClassicBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("b7Xft", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRoute", () => $4752db660fb86ac9$export$56d4754499615215);
const $4752db660fb86ac9$export$56d4754499615215 = {
    name: 'software-reports-deployment-frequency-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
    exact: true
};

});

parcelRegister("6A5Fj", function(module, exports) {
$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $588f28ff82bfbb44$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportClassic", () => $588f28ff82bfbb44$export$655707e8ae1053d3);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $588f28ff82bfbb44$export$5113b2b19ec1fb53 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3aZMu")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $588f28ff82bfbb44$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $588f28ff82bfbb44$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $588f28ff82bfbb44$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $588f28ff82bfbb44$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("3aZMu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aOtuZ").then(()=>parcelRequire('9Qu19'));

});


parcelRegister("2xG2I", function(module, exports) {
$parcel$export(module.exports, "deploymentFrequencyReportPageEntrypoint", () => $9bd95bbe0ff6fc20$export$2a837f21eaa534d9);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $htIIj = parcelRequire("htIIj");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $9bd95bbe0ff6fc20$export$2a837f21eaa534d9 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $htIIj.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    }
});

});
parcelRegister("htIIj", function(module, exports) {
$parcel$export(module.exports, "deploymentFrequencyReportEntrypoint", () => $f66fd7583b1cb90a$export$7377438ce2792970);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $f66fd7583b1cb90a$export$7377438ce2792970 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("iORfD")), {
        moduleId: "1be0b680",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iORfD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kEZOi").then(()=>parcelRequire('10Q59'));

});




parcelRegister("dfVfw", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRouteEntry", () => $e9ea6db22e38de60$export$e5eaafb1fb588922);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $f2JN3 = parcelRequire("f2JN3");

var $9BJU1 = parcelRequire("9BJU1");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $kHlOR = parcelRequire("kHlOR");

var $3mkiQ = parcelRequire("3mkiQ");

var $jom8W = parcelRequire("jom8W");

var $ioHIu = parcelRequire("ioHIu");

var $aDtWM = parcelRequire("aDtWM");

var $gzlQL = parcelRequire("gzlQL");

var $lopBx = parcelRequire("lopBx");

var $kSeQy = parcelRequire("kSeQy");

var $6A5Fj = parcelRequire("6A5Fj");

var $awzH2 = parcelRequire("awzH2");

var $2xG2I = parcelRequire("2xG2I");
const $e9ea6db22e38de60$export$e5eaafb1fb588922 = (0, $6xToB.createEntry)((0, $3mkiQ.softwareReportsDeploymentFrequencyClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $f2JN3.componentWithCondition)((0, $jom8W.isDevopsFeatureDisabledInFedRamp), (0, $9BJU1.default), (0, $6A5Fj.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $2xG2I.deploymentFrequencyReportPageEntrypoint;
        },
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $awzH2.getReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $6A5Fj.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-deployment-frequency-classic'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsDeploymentFrequencyClassicRouteEntry.tsx',
                whichExportToUse: 'softwareReportsDeploymentFrequencyClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3mkiQ", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $b1309c22ec4c6966$export$312c410cb3b49afe);
const $b1309c22ec4c6966$export$312c410cb3b49afe = {
    name: 'software-reports-deployment-frequency-classic',
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
    exact: true
};

});


parcelRegister("fWDhV", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRouteEntry", () => $7cef6b32dc1a62ce$export$c87b25c0997e584d);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $gzlQL = parcelRequire("gzlQL");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $hz88a = parcelRequire("hz88a");

var $lopBx = parcelRequire("lopBx");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $3dfhx = parcelRequire("3dfhx");

var $bYZ9r = parcelRequire("bYZ9r");
const $7cef6b32dc1a62ce$export$c87b25c0997e584d = (0, $6xToB.createEntry)((0, $hz88a.softwareReportsDeploymentFrequencyRoute), ()=>({
        group: 'software',
        entryPoint: ()=>{
            if ((0, $lopBx.isFedRamp)()) return 0, $kSeQy.notFoundPageEntrypoint;
            return 0, $bYZ9r.DeploymentFrequencyPageEntrypoint;
        },
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)(),
            (0, $gzlQL.devOpsProviderResource)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-reports-deployment-frequency'),
                teamName: 'compass-devdogs'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsDeploymentFrequencyRouteEntry.tsx',
                whichExportToUse: 'softwareReportsDeploymentFrequencyRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hz88a", function(module, exports) {
$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", () => $1b79a97a1b727ec4$export$bbf45ab0423b990);
const $1b79a97a1b727ec4$export$bbf45ab0423b990 = {
    name: 'software-reports-deployment-frequency',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};

});

parcelRegister("bYZ9r", function(module, exports) {
$parcel$export(module.exports, "DeploymentFrequencyPageEntrypoint", () => $3bc6abe94725b005$export$76cc51683254a696);

var $g8uYY = parcelRequire("g8uYY");

var $htIIj = parcelRequire("htIIj");

var $5RW99 = parcelRequire("5RW99");
const $3bc6abe94725b005$export$76cc51683254a696 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $htIIj.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});

});


parcelRegister("khKzX", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewBoardlessRouteEntry", () => $371cacbbea6193ab$export$1341f3a3578e9e4);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

var $k6duF = parcelRequire("k6duF");

var $eaH7J = parcelRequire("eaH7J");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $hS1gr = parcelRequire("hS1gr");

var $g8uYY = parcelRequire("g8uYY");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $ho3Tv = parcelRequire("ho3Tv");

var $8FCAy = parcelRequire("8FCAy");

var $dZRaT = parcelRequire("dZRaT");

var $lvjEc = parcelRequire("lvjEc");

var $9n5I0 = parcelRequire("9n5I0");

var $jKVxM = parcelRequire("jKVxM");
const $371cacbbea6193ab$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $371cacbbea6193ab$export$1341f3a3578e9e4 = (0, $6xToB.createEntry)((0, $eaH7J.softwareReportsOverviewBoardlessRoute), ()=>({
        group: 'software-reports-boardless',
        skeleton: (0, $jKVxM.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4cTDP.fg)('reports-overview-page-migration') ? $371cacbbea6193ab$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $ho3Tv.staticSidebarJSWReportsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsOverviewBoardlessRouteEntry.tsx',
                whichExportToUse: 'softwareReportsOverviewBoardlessRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eaH7J", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewBoardlessRoute", () => $90592983eb49cde1$export$e2f371bced79a0e4);
const $90592983eb49cde1$export$e2f371bced79a0e4 = {
    name: 'software-reports-boardless',
    path: '/jira/software/c/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("jKVxM", function(module, exports) {
$parcel$export(module.exports, "ReportsOverviewSkeleton", () => $3b4ee2f5bd5730b4$export$c70e702bcad58c36);
/* ReportsOverviewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $gQNnH = parcelRequire("gQNnH");
const $3b4ee2f5bd5730b4$var$containerStyles = {
    maxWidth: '100%'
};
const $3b4ee2f5bd5730b4$var$customCssStyles = null;
const $3b4ee2f5bd5730b4$export$c70e702bcad58c36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gQNnH))),
        containerStyles: $3b4ee2f5bd5730b4$var$containerStyles,
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("gQNnH", function(module, exports) {
module.exports = new URL("report-categories-skeleton.tpl.5b53a8d3.svg", import.meta.url).toString();

});



parcelRegister("kzxfE", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewRouteEntry", () => $0e7b01ecb44cfb16$export$705071d2eca06bf9);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $4cTDP = parcelRequire("4cTDP");

var $k6duF = parcelRequire("k6duF");

var $gMeDw = parcelRequire("gMeDw");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $hS1gr = parcelRequire("hS1gr");

var $g8uYY = parcelRequire("g8uYY");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $8FCAy = parcelRequire("8FCAy");

var $dZRaT = parcelRequire("dZRaT");

var $lvjEc = parcelRequire("lvjEc");

var $9n5I0 = parcelRequire("9n5I0");

var $jKVxM = parcelRequire("jKVxM");
const $0e7b01ecb44cfb16$var$reportsOverviewPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $0e7b01ecb44cfb16$export$705071d2eca06bf9 = (0, $6xToB.createEntry)((0, $gMeDw.softwareReportsOverviewRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $jKVxM.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4cTDP.fg)('reports-overview-page-migration') ? $0e7b01ecb44cfb16$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsOverviewRouteEntry.tsx',
                whichExportToUse: 'softwareReportsOverviewRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gMeDw", function(module, exports) {
$parcel$export(module.exports, "softwareReportsOverviewRoute", () => $c2b35267a6214f58$export$f38928477442c9cf);
const $c2b35267a6214f58$export$f38928477442c9cf = {
    name: 'software-reports',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports'
};

});


parcelRegister("eF6xc", function(module, exports) {
$parcel$export(module.exports, "softwareReportsRouteEntry", () => $f29ab9272aada8c6$export$2eee2f4f773d5b1f);

var $3MgfG = parcelRequire("3MgfG");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $ahPxX = parcelRequire("ahPxX");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $lvjEc = parcelRequire("lvjEc");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $4cTDP = parcelRequire("4cTDP");

var $3dfhx = parcelRequire("3dfhx");

var $iG7PY = parcelRequire("iG7PY");
const $f29ab9272aada8c6$var$tmpReportsOverviewPageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $lvjEc.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $f29ab9272aada8c6$export$2eee2f4f773d5b1f = (0, $6xToB.createEntry)((0, $ahPxX.softwareReportsRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        entryPoint () {
            return (0, $4cTDP.fg)('uxissue_545_migrate_tmp_reports_overview_page') ? $f29ab9272aada8c6$var$tmpReportsOverviewPageEntrypoint : (0, $iG7PY.reportsOverviewPageEntrypoint);
        },
        ufoName: 'software-reports.overview',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsRouteEntry.tsx',
                whichExportToUse: 'softwareReportsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ahPxX", function(module, exports) {
$parcel$export(module.exports, "softwareReportsRoute", () => $fe91805d7867e83d$export$5bf75a5d8c554930);
const $fe91805d7867e83d$export$5bf75a5d8c554930 = {
    name: 'software-reports',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("iG7PY", function(module, exports) {
$parcel$export(module.exports, "reportsOverviewPageEntrypoint", () => $d1f26e1e2f56c173$export$d9a1db2306b376e2);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $bcil9 = parcelRequire("bcil9");
const $d1f26e1e2f56c173$export$d9a1db2306b376e2 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $bcil9.reportsOverviewEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("bcil9", function(module, exports) {
$parcel$export(module.exports, "reportsOverviewEntrypoint", () => $d317074d693e2940$export$bb9acba529741f89);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $d317074d693e2940$export$bb9acba529741f89 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("7KMeO")), {
        moduleId: "6be6e255",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7KMeO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfnHV").then(()=>parcelRequire('eT9yw'));

});




parcelRegister("7wJLb", function(module, exports) {
$parcel$export(module.exports, "softwareReportsVelocityRouteEntry", () => $345adc2cf37b98b1$export$7d814f4300d0e318);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $l7qZA = parcelRequire("l7qZA");

var $8FCAy = parcelRequire("8FCAy");

var $3dfhx = parcelRequire("3dfhx");

var $8iZ3C = parcelRequire("8iZ3C");
const $345adc2cf37b98b1$export$7d814f4300d0e318 = (0, $6xToB.createEntry)((0, $l7qZA.softwareReportsVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3dfhx.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $8iZ3C.velocityReportPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareReportsVelocityRouteEntry.tsx',
                whichExportToUse: 'softwareReportsVelocityRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("l7qZA", function(module, exports) {
$parcel$export(module.exports, "softwareReportsVelocityRoute", () => $3c0e8e01898141a2$export$cde83a6497756848);
const $3c0e8e01898141a2$export$cde83a6497756848 = {
    name: 'software-reports-velocity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};

});


parcelRegister("hN6Yh", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapClassicRouteEntry", () => $640ae557c113772a$export$17cff822dd3757db);

var $6xToB = parcelRequire("6xToB");

var $eXgQz = parcelRequire("eXgQz");

var $dZ1hs = parcelRequire("dZ1hs");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $b4jBr = parcelRequire("b4jBr");

var $5AZok = parcelRequire("5AZok");

var $eJe5A = parcelRequire("eJe5A");

var $kHlOR = parcelRequire("kHlOR");

var $66fuO = parcelRequire("66fuO");

var $aUtR9 = parcelRequire("aUtR9");
const $640ae557c113772a$export$17cff822dd3757db = (0, $6xToB.createEntry)((0, $eXgQz.softwareRoadmapClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $66fuO.TimelineRedirect),
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5AZok.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $aUtR9.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareRoadmapClassicRouteEntry.tsx',
                whichExportToUse: 'softwareRoadmapClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("eXgQz", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $cba708c24b5f6176$export$79089e2853f04197);
const $cba708c24b5f6176$export$79089e2853f04197 = {
    name: 'software-roadmap-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("dZ1hs", function(module, exports) {
$parcel$export(module.exports, "RoadmapSkeleton", () => $c9db1b5a08dde725$export$66a1e8bb48359566);
/* RoadmapSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6umqd = parcelRequire("6umqd");

var $dJLe9 = parcelRequire("dJLe9");
const $c9db1b5a08dde725$var$customCssStyles = null;
const $c9db1b5a08dde725$export$66a1e8bb48359566 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9db1b5a08dde725$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dJLe9))),
        className: (0, $hcewu.default)([
            "_2zz1idpf"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c9db1b5a08dde725$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dJLe9", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});


parcelRegister("5AZok", function(module, exports) {
$parcel$export(module.exports, "classicRoadmapResource", () => $eb43dc5ccade4bc8$export$e755913caca1ab8e);

var $l1VxS = parcelRequire("l1VxS");


const $eb43dc5ccade4bc8$export$e755913caca1ab8e = (0, $l1VxS.createResource)({
    type: (0, $0a39a0a4006d2a49$export$e3b1cd17bd82de3d),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("22cpp")),
    isBrowserOnly: true
});

});
parcelRegister("22cpp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3kBPc").then(()=>parcelRequire('5X6Mk'));

});


parcelRegister("66fuO", function(module, exports) {
$parcel$export(module.exports, "TimelineRedirect", () => $8b10fa8925fc70ad$export$c70b8d9ef0c891b2);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $8b10fa8925fc70ad$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $gCY1z.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};

});

parcelRegister("aUtR9", function(module, exports) {
$parcel$export(module.exports, "LazyRoadmapViewClassic", () => $ff5085c44ca1869d$export$84165bb08bf42eef);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ff5085c44ca1869d$export$84165bb08bf42eef = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aL7qT"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index-old.tsx"
});
/** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */ const $ff5085c44ca1869d$var$AsyncRoadmapViewClassic = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ff5085c44ca1869d$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};
var $ff5085c44ca1869d$export$2e2bcd8739ae039 = $ff5085c44ca1869d$var$AsyncRoadmapViewClassic;

});
parcelRegister("aL7qT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6rWzC").then(()=>parcelRequire('5zjoc'));

});



parcelRegister("5dzzd", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRedirectRouteEntry", () => $d090343e177b9d37$export$4180bde2c4464aed);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $kHlOR = parcelRequire("kHlOR");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $93J6P = parcelRequire("93J6P");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $2mHfh = parcelRequire("2mHfh");

var $4LGud = parcelRequire("4LGud");
const $d090343e177b9d37$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(restQuery)
        }
    });
};
const $d090343e177b9d37$export$4180bde2c4464aed = (0, $6xToB.createEntry)((0, $93J6P.softwareRoadmapRedirectRoute), ()=>({
        group: 'software',
        component: $d090343e177b9d37$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $4LGud.LazyNextGenRoadmap)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-next-gen-entries/src/softwareRoadmapRedirectRouteEntry.tsx',
                whichExportToUse: 'softwareRoadmapRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("93J6P", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRedirectRoute", () => $d0c162cea111bf8b$export$866215abd09c0f4d);
const $d0c162cea111bf8b$export$866215abd09c0f4d = {
    name: 'software-roadmap-redirect',
    path: '/secure/Roadmap.jspa'
};

});

parcelRegister("4LGud", function(module, exports) {
$parcel$export(module.exports, "LazyNextGenRoadmap", () => $f82715ba08d30b86$export$1339c847cf4ab57);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f82715ba08d30b86$export$1339c847cf4ab57 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3MCgO"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
const $f82715ba08d30b86$var$AsyncNextGenRoadmap = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f82715ba08d30b86$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });
var $f82715ba08d30b86$export$2e2bcd8739ae039 = $f82715ba08d30b86$var$AsyncNextGenRoadmap;

});
parcelRegister("3MCgO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4V5Gj").then(()=>parcelRequire('6KC4T'));

});



parcelRegister("eyWIM", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRouteEntry", () => $92fa8a9c26166803$export$c1d875e34d537389);

var $eJOHy = parcelRequire("eJOHy");

var $kHlOR = parcelRequire("kHlOR");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $b4jBr = parcelRequire("b4jBr");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $gVZAI = parcelRequire("gVZAI");

var $i7iuH = parcelRequire("i7iuH");

var $dZ1hs = parcelRequire("dZ1hs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $2mHfh = parcelRequire("2mHfh");

var $96amU = parcelRequire("96amU");
const $92fa8a9c26166803$var$SoftwareTimelineRedirect = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $92fa8a9c26166803$export$c1d875e34d537389 = (0, $6xToB.createEntry)((0, $i7iuH.softwareRoadmapRoute), ()=>({
        group: 'software',
        component: $92fa8a9c26166803$var$SoftwareTimelineRedirect,
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gVZAI.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $96amU.LazyNextGenRoadmap)
        ],
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-roadmap-entries/src/softwareRoadmapRouteEntry.tsx',
                whichExportToUse: 'softwareRoadmapRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gVZAI", function(module, exports) {
$parcel$export(module.exports, "nextGenRoadmapResource", () => $0c00376fc9bc583d$export$2750f87d68dfb02a);

var $l1VxS = parcelRequire("l1VxS");


const $0c00376fc9bc583d$export$2750f87d68dfb02a = (0, $l1VxS.createResource)({
    type: (0, $0a39a0a4006d2a49$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("kKtZw")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("kKtZw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("97af4").then(()=>parcelRequire('Qdom1'));

});


parcelRegister("i7iuH", function(module, exports) {
$parcel$export(module.exports, "softwareRoadmapRoute", () => $f49120ba3bc21202$export$a4a573c36fc75b30);
const $f49120ba3bc21202$export$a4a573c36fc75b30 = {
    name: 'software-roadmap',
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("96amU", function(module, exports) {
$parcel$export(module.exports, "LazyNextGenRoadmap", () => $f258a8020d4f8f78$export$1339c847cf4ab57);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $f258a8020d4f8f78$export$1339c847cf4ab57 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("3MCgO"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
const $f258a8020d4f8f78$var$AsyncNextGenRoadmap = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $f258a8020d4f8f78$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });
var $f258a8020d4f8f78$export$2e2bcd8739ae039 = $f258a8020d4f8f78$var$AsyncNextGenRoadmap;

});


parcelRegister("5OhH5", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityClassicRouteEntry", () => $b89e1ae3273c2965$export$8acfebad16c9d6f2);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $j9Woh = parcelRequire("j9Woh");

var $bjzwt = parcelRequire("bjzwt");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $aw3pZ = parcelRequire("aw3pZ");

var $1CTcA = parcelRequire("1CTcA");
const $b89e1ae3273c2965$export$8acfebad16c9d6f2 = (0, $6xToB.createEntry)((0, $bjzwt.softwareSecurityClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $j9Woh.securityPageResource)
        ],
        ufoName: 'software-security-combined',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: 'software-security-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-security-classic'),
                teamName: 'jolt'
            }
        },
        entryPoint: ()=>(0, $aw3pZ.isSecurityPageEnabled)() ? (0, $1CTcA.securityPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-security-entries/src/softwareSecurityClassicRouteEntry.tsx',
                whichExportToUse: 'softwareSecurityClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("j9Woh", function(module, exports) {
$parcel$export(module.exports, "securityPageResource", () => $b9560db29d07486a$export$2c5e3c161b8fe98);

var $8oKDI = parcelRequire("8oKDI");

var $9FYIg = parcelRequire("9FYIg");

var $4cTDP = parcelRequire("4cTDP");

var $lGgMT = parcelRequire("lGgMT");

var $kCapU = parcelRequire("kCapU");

const $b9560db29d07486a$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $b9560db29d07486a$var$getNumberOfSecurityContainersToFetch = ()=>100;
let $b9560db29d07486a$var$filters;
const $b9560db29d07486a$export$2c5e3c161b8fe98 = (0, $9FYIg.createRelayResource)({
    type: (0, $392f4051a7d4e158$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === 'software-security' || name === 'software-security-classic';
        // Set filters on initial call only and not on every query param change
        if (!$b9560db29d07486a$var$filters && isSecRoute) {
            const connectionAri = (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $b9560db29d07486a$var$filters = (0, $kCapU.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $b9560db29d07486a$var$filters = undefined;
        return {
            parameters: (0, $lGgMT.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $b9560db29d07486a$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $b9560db29d07486a$var$getNumberOfSecurityContainersToFetch(),
                filter: $b9560db29d07486a$var$filters,
                isVulnsListFixEnabled: (0, $4cTDP.fg)('jira-security-vulns-list-fix-enabled')
            }
        };
    }
});

});
parcelRegister("lGgMT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e75e22b5bae4767f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa025ac439b416a5321ca0c6f97dc5bd>>
 * @relayHash fcc81036b313cdc379e986cf0a3136da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cc10cd43053a8820b5cdd778d95d9c93f16c20b4910bb0240ea20f73dbdfb458
const $e75e22b5bae4767f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVulnsListFixEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = {
        "kind": "InlineFragment",
        "selections": v13 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v16 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v17 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v16 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v18 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v19 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v20 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = [
        v18 /*: any*/ 
    ], v23 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraAutodevJob"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": v22 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v36 = [
        v9 /*: any*/ ,
        v16 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "kind": "ScalarField",
        "name": "key"
    }, v39 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v40 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v41 = [
        {
            "concreteType": "GraphJiraVulnerabilityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "GraphJiraVulnerability",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                            "kind": "LinkedField",
                            "name": "vulnerability",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v18 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isVulnsListFixEnabled",
                                                "variableName": "isVulnsListFixEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v10 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v17 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v13 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v21 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v18 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v9 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v18 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v18 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v15 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isVulnsListFixEnabled",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectHaveVulnerabilityCheckFirst",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1
                                                }
                                            ],
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": v41 /*: any*/ ,
                                            "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isVulnsListFixEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectHaveVulnerabilityCheck",
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": v41 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v21 /*: any*/ 
            ]
        },
        "params": {
            "id": "cc10cd43053a8820b5cdd778d95d9c93f16c20b4910bb0240ea20f73dbdfb458",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e75e22b5bae4767f$var$node.hash = "13b399a98e02ad00fbb7180d9f2cb96e";
var $e75e22b5bae4767f$export$2e2bcd8739ae039 = $e75e22b5bae4767f$var$node;

});

parcelRegister("kCapU", function(module, exports) {
$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $d9ad221b33bcb19d$export$2af359d48d48e5f1);

var $6u3tP = parcelRequire("6u3tP");

var $bC2b5 = parcelRequire("bC2b5");

var $9FOZi = parcelRequire("9FOZi");
const $d9ad221b33bcb19d$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $bC2b5.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $bC2b5.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $9FOZi.parseSortDirection)(sortOrder, (0, $6u3tP.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9ad221b33bcb19d$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $d9ad221b33bcb19d$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $d9ad221b33bcb19d$var$getOrDefault((0, $9FOZi.connectionQueryParamToFilter)(queryParams[0, $bC2b5.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $bC2b5.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $9FOZi.arrayQueryParamToFilter)(queryParams[0, $bC2b5.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $6u3tP.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $d9ad221b33bcb19d$var$getFilterValue($d9ad221b33bcb19d$var$getOrDefault((0, $9FOZi.arrayQueryParamToFilter)(queryParams[0, $bC2b5.QUERY_PARAM_SEVERITY]).map((0, $9FOZi.parseSeverity)).filter(Boolean), (0, $bC2b5.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $bC2b5.QUERY_PARAM_SORT_KEY], queryParams[0, $bC2b5.QUERY_PARAM_SORT_ORDER]),
                to_status: $d9ad221b33bcb19d$var$getFilterValue(statusQueryParams.includes((0, $bC2b5.NO_FILTER_VULN_STATUS)) ? [] : $d9ad221b33bcb19d$var$getOrDefault(statusQueryParams.map((0, $9FOZi.parseStatus)).filter(Boolean), (0, $bC2b5.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $bC2b5.QUERY_PARAM_SORT_KEY], queryParams[0, $bC2b5.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $bC2b5.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $9FOZi.parseSortDirection)(queryParams[0, $bC2b5.QUERY_PARAM_SORT_ORDER], (0, $6u3tP.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("6u3tP", function(module, exports) {
$parcel$export(module.exports, "AriGraphSortOrderInput", () => $1a6d09a85edfc6f2$export$3b69903df4cd6048);
const $1a6d09a85edfc6f2$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("bC2b5", function(module, exports) {
$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $aef224468a7f8afa$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $aef224468a7f8afa$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $aef224468a7f8afa$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $aef224468a7f8afa$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $aef224468a7f8afa$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $aef224468a7f8afa$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $aef224468a7f8afa$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $aef224468a7f8afa$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $aef224468a7f8afa$export$e9b4ea84d666c490);
const $aef224468a7f8afa$export$a181206198b7f50c = 'search';
const $aef224468a7f8afa$export$3873b20ffa21b004 = 'container';
const $aef224468a7f8afa$export$af01a3d59250f3d3 = 'severity';
const $aef224468a7f8afa$export$c315695f017955dc = 'vulnerabilityStatus';
const $aef224468a7f8afa$export$2e69a24fe65d4109 = 'issueStatus';
const $aef224468a7f8afa$export$6da773286c35ef41 = 'sortKey';
const $aef224468a7f8afa$export$810a1f7ed2facfcb = 'sortOrder';
const $aef224468a7f8afa$export$d8115099d465de4c = 'NO-FILTERS';
const $aef224468a7f8afa$var$initialVulnerabilityTableFilters = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $aef224468a7f8afa$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$aef224468a7f8afa$var$initialVulnerabilityTableFilters
};

});

parcelRegister("9FOZi", function(module, exports) {
$parcel$export(module.exports, "arrayQueryParamToFilter", () => $62d341b4235d71c0$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $62d341b4235d71c0$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $62d341b4235d71c0$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $62d341b4235d71c0$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $62d341b4235d71c0$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $62d341b4235d71c0$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $62d341b4235d71c0$export$85cf5c73b48a482e);

var $5FdZg = parcelRequire("5FdZg");

var $79hL0 = parcelRequire("79hL0");

var $6u3tP = parcelRequire("6u3tP");

var $5mYxp = parcelRequire("5mYxp");
const $62d341b4235d71c0$var$DELIMITER = ',';
const $62d341b4235d71c0$var$ENCODED_DELIMITER = encodeURIComponent($62d341b4235d71c0$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $62d341b4235d71c0$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($62d341b4235d71c0$var$DELIMITER, 'g');
    return input.replace(regex, $62d341b4235d71c0$var$ENCODED_DELIMITER);
};
const $62d341b4235d71c0$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($62d341b4235d71c0$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $62d341b4235d71c0$var$DELIMITER);
};
const $62d341b4235d71c0$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($62d341b4235d71c0$var$DELIMITER)?.map($62d341b4235d71c0$var$decodeDelimiter) ?? [];
const $62d341b4235d71c0$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$62d341b4235d71c0$var$encodeDelimiter(entity)).join($62d341b4235d71c0$var$DELIMITER);
};
const $62d341b4235d71c0$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $62d341b4235d71c0$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FdZg)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $62d341b4235d71c0$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $5mYxp.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $5mYxp.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).HIGH;
        case (0, $5mYxp.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).LOW;
        case (0, $5mYxp.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $5mYxp.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $5mYxp.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $62d341b4235d71c0$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $5mYxp.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).OPEN;
        case (0, $5mYxp.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $5mYxp.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).CLOSED;
        case (0, $5mYxp.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $5mYxp.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $62d341b4235d71c0$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $6u3tP.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $6u3tP.AriGraphSortOrderInput).ASC;
        case (0, $6u3tP.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $6u3tP.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("5FdZg", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $79hL0 = parcelRequire("79hL0");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $41fba19db79c4e52$var$flatMap(collection, iteratee) {
    return $72Qfa($79hL0(collection, iteratee), 1);
}
module.exports = $41fba19db79c4e52$var$flatMap;

});
parcelRegister("79hL0", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $4sprp = parcelRequire("4sprp");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $534725d937053460$var$map(collection, iteratee) {
    var func = $4sprp(collection) ? $lylkU : $k0Eii;
    return func(collection, $1lM9j(iteratee, 3));
}
module.exports = $534725d937053460$var$map;

});
parcelRegister("k0Eii", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");

var $7H30b = parcelRequire("7H30b");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e9131047aaeaff47$var$baseMap(collection, iteratee) {
    var index = -1, result = $7H30b(collection) ? Array(collection.length) : [];
    $c3u3c(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e9131047aaeaff47$var$baseMap;

});



parcelRegister("5mYxp", function(module, exports) {
$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $7f64af12791e5419$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $7f64af12791e5419$export$2d6749bded378262);
const $7f64af12791e5419$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $7f64af12791e5419$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $7f64af12791e5419$var$VulnerabilityTypeEnums = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $392f4051a7d4e158$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("bjzwt", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityClassicRoute", () => $7db17db105cc905d$export$b7285748f1151353);
const $7db17db105cc905d$export$b7285748f1151353 = {
    name: 'software-security-classic',
    path: '/jira/software/c/projects/:projectKey/security'
};

});

parcelRegister("aw3pZ", function(module, exports) {
$parcel$export(module.exports, "isSecurityPageEnabled", () => $f49535f297d83487$export$f99b2868577ed515);

var $4cTDP = parcelRequire("4cTDP");

var $jom8W = parcelRequire("jom8W");
const $f49535f297d83487$export$f99b2868577ed515 = ()=>!(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && (0, $4cTDP.fg)('isotopes-security-page-in-jira-enabled-v2');

});

parcelRegister("1CTcA", function(module, exports) {
$parcel$export(module.exports, "securityPageEntrypoint", () => $3c47774a85afa42a$export$5f2f9dbf41e3e769);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $1P5CH = parcelRequire("1P5CH");

var $9n5I0 = parcelRequire("9n5I0");
const $3c47774a85afa42a$export$5f2f9dbf41e3e769 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1P5CH.securityEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1P5CH", function(module, exports) {
$parcel$export(module.exports, "securityEntrypoint", () => $beb98f489acbae48$export$63f7fc80f88b035a);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $beb98f489acbae48$export$63f7fc80f88b035a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("5qnXA")), {
        moduleId: "c02ceeea",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5qnXA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i03Dd").then(()=>parcelRequire('2OTd5'));

});




parcelRegister("eOJip", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", () => $9f7db4d6db645085$export$a8dcfae475505e7a);

var $7mF43 = parcelRequire("7mF43");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $j9Woh = parcelRequire("j9Woh");

var $jg3Gs = parcelRequire("jg3Gs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $kSeQy = parcelRequire("kSeQy");

var $aw3pZ = parcelRequire("aw3pZ");

var $1CTcA = parcelRequire("1CTcA");
const $9f7db4d6db645085$export$a8dcfae475505e7a = (0, $6xToB.createEntry)((0, $jg3Gs.softwareSecurityNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        ufoName: 'software-security-combined',
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dZRaT.projectContextResource),
            (0, $j9Woh.securityPageResource)
        ],
        meta: {
            reporting: {
                id: 'software-security',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-security'),
                teamName: 'jolt'
            }
        },
        entryPoint: ()=>(0, $aw3pZ.isSecurityPageEnabled)() ? (0, $1CTcA.securityPageEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-security-entries/src/softwareSecurityNextGenRouteEntry.tsx',
                whichExportToUse: 'softwareSecurityNextGenRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jg3Gs", function(module, exports) {
$parcel$export(module.exports, "softwareSecurityNextGenRoute", () => $111df9a77319612f$export$a2aed78ebacc3233);
const $111df9a77319612f$export$a2aed78ebacc3233 = {
    name: 'software-security',
    path: '/jira/software/projects/:projectKey/security'
};

});


parcelRegister("jG7gV", function(module, exports) {
$parcel$export(module.exports, "softwareStaffingRouteEntry", () => $8ae2acec77d84478$export$71a3a4cc27cbe00a);

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $kSeQy = parcelRequire("kSeQy");

var $dZRaT = parcelRequire("dZRaT");

var $gVZAI = parcelRequire("gVZAI");

var $bTfc4 = parcelRequire("bTfc4");

var $5QMeL = parcelRequire("5QMeL");

var $dZ1hs = parcelRequire("dZ1hs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $4cTDP = parcelRequire("4cTDP");

var $kRcgT = parcelRequire("kRcgT");
const $8ae2acec77d84478$export$71a3a4cc27cbe00a = (0, $6xToB.createEntry)((0, $5QMeL.softwareStaffingRoute), ()=>({
        group: 'software',
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gVZAI.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $4cTDP.fg)('staffing') ? (0, $kRcgT.staffingRouteEntrypoint) : (0, $kSeQy.notFoundPageEntrypoint),
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-staffing-entries/src/softwareStaffingRouteEntry.tsx',
                whichExportToUse: 'softwareStaffingRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5QMeL", function(module, exports) {
$parcel$export(module.exports, "softwareStaffingRoute", () => $be49f3a1685b518a$export$aa817709e0cb3b6d);
const $be49f3a1685b518a$export$aa817709e0cb3b6d = {
    name: 'software-staffing',
    path: '/jira/software/projects/:projectKey/boards/:boardId/staffing',
    query: [
        'issueKey?'
    ]
};

});

parcelRegister("kRcgT", function(module, exports) {
$parcel$export(module.exports, "staffingRouteEntrypoint", () => $2ca0dfc58ba98ae8$export$3a16ef365bcb8560);

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9n5I0 = parcelRequire("9n5I0");

var $jYjM2 = parcelRequire("jYjM2");
const $2ca0dfc58ba98ae8$export$3a16ef365bcb8560 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jYjM2.staffingEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("jYjM2", function(module, exports) {
$parcel$export(module.exports, "staffingEntrypoint", () => $9150db313441eed0$export$94a659cc78d2756a);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $9150db313441eed0$export$94a659cc78d2756a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("eVYml")), {
        moduleId: "39c7d120",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eVYml", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4L60i").then(()=>parcelRequire('ei39Q'));

});




parcelRegister("P4w4L", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryClassicRouteEntry", () => $60452c0180eff06d$export$f81c7c178a9483e8);

var $6xToB = parcelRequire("6xToB");

var $5RW99 = parcelRequire("5RW99");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $6zZVV = parcelRequire("6zZVV");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $gSnkQ = parcelRequire("gSnkQ");

var $8FCAy = parcelRequire("8FCAy");

var $1tc80 = parcelRequire("1tc80");

var $9n5I0 = parcelRequire("9n5I0");

var $g8uYY = parcelRequire("g8uYY");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $60452c0180eff06d$var$summarySoftwarePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1tc80.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $60452c0180eff06d$export$f81c7c178a9483e8 = (0, $6xToB.createEntry)((0, $gSnkQ.softwareSummaryClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        layout: (0, $8FCAy.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        entryPoint: ()=>$60452c0180eff06d$var$summarySoftwarePageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareSummaryClassicRouteEntry.tsx',
                whichExportToUse: 'softwareSummaryClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gSnkQ", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryClassicRoute", () => $19cfe75a59dcddc0$export$b5046fccf399983f);
const $19cfe75a59dcddc0$export$b5046fccf399983f = {
    name: 'software-summary-classic',
    path: '/jira/software/c/projects/:projectKey/summary'
};

});

parcelRegister("1tc80", function(module, exports) {
$parcel$export(module.exports, "summarySoftwareEntrypoint", () => $ff01ce3b8769d54f$export$6c7cf31fcbd213b8);

var $jsDjZ = parcelRequire("jsDjZ");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $ff01ce3b8769d54f$export$6c7cf31fcbd213b8 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("kUe4L")), {
        moduleId: "509fadc1",
        moduleName: "JiraSoftwareSummaryApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jsDjZ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("jsDjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a9cb49e4728a194$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<067c7b281961be390f373c6079d10870>>
 * @relayHash c364d4091993eebcae6bd6d01b4947d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99b9c23cf845dc0a36dacd9fa97fdd236f700d39fc2d1913e16976519ede7542
const $4a9cb49e4728a194$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "99b9c23cf845dc0a36dacd9fa97fdd236f700d39fc2d1913e16976519ede7542",
        "metadata": {},
        "name": "JiraSoftwareSummaryAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4a9cb49e4728a194$export$2e2bcd8739ae039 = $4a9cb49e4728a194$var$node;

});

parcelRegister("kUe4L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("4WpVv")
]).then(()=>parcelRequire('8fEoF'));

});



parcelRegister("8mw4w", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedClassicRouteEntry", () => $aff05c9a79c12694$export$1dc5e581d8ca39ac);

var $6xToB = parcelRequire("6xToB");

var $bTfc4 = parcelRequire("bTfc4");

var $dZRaT = parcelRequire("dZRaT");

var $hHbzj = parcelRequire("hHbzj");

var $klcPs = parcelRequire("klcPs");

var $7K5Ea = parcelRequire("7K5Ea");

var $6HzGw = parcelRequire("6HzGw");

var $g8uYY = parcelRequire("g8uYY");
const $aff05c9a79c12694$var$summarySoftwareEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6HzGw.summarySoftwareEmbedEntrypoint)
});
const $aff05c9a79c12694$export$1dc5e581d8ca39ac = (0, $6xToB.createEntry)((0, $klcPs.softwareSummaryEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource)
        ],
        entryPoint: ()=>{
            return $aff05c9a79c12694$var$summarySoftwareEmbedPageEntrypoint;
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareSummaryEmbedClassicRouteEntry.tsx',
                whichExportToUse: 'softwareSummaryEmbedClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("klcPs", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedClassicRoute", () => $6383f16946545167$export$7fa3d3891ccec782);
const $6383f16946545167$export$7fa3d3891ccec782 = {
    name: 'software-summary-classic-embed',
    path: '/jira/software/c/projects/:projectKey/summary/embed'
};

});

parcelRegister("6HzGw", function(module, exports) {
$parcel$export(module.exports, "summarySoftwareEmbedEntrypoint", () => $05a7199529b59515$export$4eeb5d2e0e9b94b6);

var $amP13 = parcelRequire("amP13");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $05a7199529b59515$export$4eeb5d2e0e9b94b6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("4WoJ4")), {
        moduleId: "baf99c5e",
        moduleName: "JiraSoftwareSummaryEmbedApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $amP13.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("amP13", function(module, exports) {
$parcel$export(module.exports, "default", () => $308c993bfc255b33$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdf401725a79bf7d20d26bebeeaedf77>>
 * @relayHash eba1c502749083d7858f23a8a4380f36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3b9d98ccf886b12917104f999ff14f90165d6108a2547ca1fbf4ca98d929e1e
const $308c993bfc255b33$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b3b9d98ccf886b12917104f999ff14f90165d6108a2547ca1fbf4ca98d929e1e",
        "metadata": {},
        "name": "JiraSoftwareSummaryEmbedAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $308c993bfc255b33$export$2e2bcd8739ae039 = $308c993bfc255b33$var$node;

});

parcelRegister("4WoJ4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("5aQ58")
]).then(()=>parcelRequire('adU7i'));

});



parcelRegister("gJeDi", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedRouteEntry", () => $4acec4b40dd21904$export$d0dcb1130082d8e);

var $7mF43 = parcelRequire("7mF43");

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $lqXVd = parcelRequire("lqXVd");

var $hHbzj = parcelRequire("hHbzj");

var $dZRaT = parcelRequire("dZRaT");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $6HzGw = parcelRequire("6HzGw");

var $g8uYY = parcelRequire("g8uYY");
const $4acec4b40dd21904$var$summarySoftwareEmbedPageEntrypoint = (0, $g8uYY.createChromelessEntryPoint)({
    main: (0, $6HzGw.summarySoftwareEmbedEntrypoint)
});
const $4acec4b40dd21904$export$d0dcb1130082d8e = (0, $6xToB.createEntry)((0, $lqXVd.softwareSummaryEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary-embed',
        layout: (0, $7K5Ea.chromelessLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource)
        ],
        meta: {
            reporting: {
                id: 'software-summary-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-summary-embed'),
                teamName: 'helios'
            }
        },
        entryPoint: ()=>$4acec4b40dd21904$var$summarySoftwareEmbedPageEntrypoint,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-summary-embed-entries/src/softwareSummaryEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareSummaryEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lqXVd", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryEmbedRoute", () => $21733fd4911a9716$export$11863f01f5694529);
const $21733fd4911a9716$export$11863f01f5694529 = {
    name: 'software-summary-embed',
    path: '/jira/software/projects/:projectKey/summary/embed'
};

});


parcelRegister("sK3EH", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryRouteEntry", () => $a04a5c9ffa7e9f47$export$a2560b0baf928c49);

var $7mF43 = parcelRequire("7mF43");

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jnf2p = parcelRequire("jnf2p");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $1tc80 = parcelRequire("1tc80");

var $9n5I0 = parcelRequire("9n5I0");

var $5L7qx = parcelRequire("5L7qx");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");
const $a04a5c9ffa7e9f47$var$summarySoftwarePageEntrypoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $1tc80.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});
const $a04a5c9ffa7e9f47$export$a2560b0baf928c49 = (0, $6xToB.createEntry)((0, $jnf2p.softwareSummaryRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource))
        ],
        meta: {
            reporting: {
                id: 'software-summary',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-summary'),
                teamName: 'helios'
            }
        },
        entryPoint: ()=>$a04a5c9ffa7e9f47$var$summarySoftwarePageEntrypoint,
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-summary-entries/src/softwareSummaryRouteEntry.tsx',
                whichExportToUse: 'softwareSummaryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jnf2p", function(module, exports) {
$parcel$export(module.exports, "softwareSummaryRoute", () => $75af821138bed7de$export$c6629202e90df62a);
const $75af821138bed7de$export$c6629202e90df62a = {
    name: 'software-summary',
    path: '/jira/software/projects/:projectKey/summary'
};

});


parcelRegister("cOBeu", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineClassicRouteEntry", () => $2e392201bb2d8213$export$a822ee67d4c66296);

var $6xToB = parcelRequire("6xToB");

var $7K3zE = parcelRequire("7K3zE");

var $dZ1hs = parcelRequire("dZ1hs");

var $6dwgv = parcelRequire("6dwgv");

var $8FCAy = parcelRequire("8FCAy");

var $iIsIs = parcelRequire("iIsIs");

var $5RW99 = parcelRequire("5RW99");

var $k6duF = parcelRequire("k6duF");

var $hS1gr = parcelRequire("hS1gr");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $5ddA0 = parcelRequire("5ddA0");

var $9pJMP = parcelRequire("9pJMP");

var $5AZok = parcelRequire("5AZok");

var $eJe5A = parcelRequire("eJe5A");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $10HnM = parcelRequire("10HnM");
const $2e392201bb2d8213$export$a822ee67d4c66296 = (0, $6xToB.createEntry)((0, $7K3zE.softwareTimelineClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $k6duF.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $5RW99.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)({
                isUsingSidebarEntrypoint: true
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5AZok.classicRoadmapResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        ufoName: 'classic-roadmap',
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') && (0, $cxKOj.expValEquals)('jira_timeline_harmonisation_m3', 'isEnabled', true) ? (0, $10HnM.softwareHarmonisedTimelineClassicPageEntrypoint) : (0, $10HnM.roadmapViewClassicPageEntrypoint),
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/softwareTimelineClassicRouteEntry.tsx',
                whichExportToUse: 'softwareTimelineClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("7K3zE", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $87a72ac71d826c06$export$ce5173f7e8fa932b);
const $87a72ac71d826c06$export$ce5173f7e8fa932b = {
    name: 'software-timeline-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("10HnM", function(module, exports) {
$parcel$export(module.exports, "roadmapViewClassicPageEntrypoint", () => $19e4ed228bf9a578$export$af2674d32463682f);
$parcel$export(module.exports, "softwareHarmonisedTimelineClassicPageEntrypoint", () => $19e4ed228bf9a578$export$8e39ce9fdb72723);

var $deUmF = parcelRequire("deUmF");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $9l6MC = parcelRequire("9l6MC");

var $9n5I0 = parcelRequire("9n5I0");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $5DQfo = parcelRequire("5DQfo");
const $19e4ed228bf9a578$var$pageEntrypointConfig = {
    main: (0, $9l6MC.roadmapViewClassicEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $5DQfo.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
};
const $19e4ed228bf9a578$export$af2674d32463682f = (0, $g8uYY.createPageEntryPoint)($19e4ed228bf9a578$var$pageEntrypointConfig);
const $19e4ed228bf9a578$export$8e39ce9fdb72723 = (0, $g8uYY.createPageEntryPoint)({
    ...$19e4ed228bf9a578$var$pageEntrypointConfig,
    main: (0, $deUmF.softwareTimelineEntrypoint)
});

});
parcelRegister("deUmF", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $af6940ed02947e84$export$85a905c235ac34bb);

var $4cTDP = parcelRequire("4cTDP");

var $joets = parcelRequire("joets");

var $fCagM = parcelRequire("fCagM");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $cxKOj = parcelRequire("cxKOj");
const $af6940ed02947e84$var$NAMESPACE = 'TIMELINE';
const $af6940ed02947e84$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $af6940ed02947e84$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $af6940ed02947e84$var$buildJql = (projectKey = '')=>{
    const project = $af6940ed02947e84$var$getProjectJql(projectKey);
    return `${$af6940ed02947e84$var$and([
        project
    ])} ORDER BY rank ASC`;
};
// should be equivalent to the getToday function in jira/src/packages/software/roadmap/utils/src/utils/dates.tsx
const $af6940ed02947e84$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};
const $af6940ed02947e84$var$parseQueryParamValue = (str)=>{
    try {
        return str ? JSON.parse(str) : undefined;
    } catch (e) {
    // Do nothing - ignore invalid values
    }
};
const $af6940ed02947e84$var$toStaticViewInput = (settings)=>{
    return {
        isGroupingEnabled: !!settings.groupBy,
        isHideDoneEnabled: settings.hideDone,
        isHierarchyEnabled: settings.hierarchyEnabled
    };
};

const $af6940ed02947e84$export$85a905c235ac34bb = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("ky617")), {
        moduleId: "cf18649f",
        moduleName: "JiraSoftwareTimelineApp",
        priority: "userVisible"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const { hideDone: hideDone } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const prevFieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'timeline'
        ];
        // TODO hardcoded fieldsetIds will be replaced with fieldSets from BE
        const newFieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'assignee',
            'status',
            'timeline'
        ];
        const fieldSetIds = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? newFieldSetIds : prevFieldSetIds;
        const scope = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? {
            operationScope: 'TIMELINE_PROJECT',
            projectKey: projectKey
        } : undefined;
        const jql = $af6940ed02947e84$var$buildJql(projectKey);
        const settings = {
            groupBy: null,
            hideDone: $af6940ed02947e84$var$parseQueryParamValue(hideDone) ?? false,
            hierarchyEnabled: true,
            jql: jql
        };
        // JiraIssueSearchSettings will replace JiraIssueSearchStaticViewInput
        // as part of the saved views project, so we'll use it as the source of
        // truth
        const staticViewInput = $af6940ed02947e84$var$toStaticViewInput(settings);
        return {
            extraProps: {
                today: $af6940ed02947e84$var$getToday(),
                isTimelineHarmonisationM2Enabled: (0, $cxKOj.expValEquals)('timeline_harmonisation_m2', 'isEnabled', true, false)
            },
            queries: {
                softwareTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $joets.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $fCagM.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: {
                            fieldSetIds: fieldSetIds
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: {
                            jql: jql
                        },
                        namespace: $af6940ed02947e84$var$NAMESPACE,
                        projectKey: projectKey,
                        settings: settings,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: true,
                        scope: scope,
                        staticViewInput: staticViewInput,
                        viewConfigInput: {
                            staticViewInput: staticViewInput
                        },
                        viewQueryInput: {
                            projectKeyAndItemIdQuery: {
                                cloudId: cloudId,
                                projectKey: projectKey,
                                itemId: 'timeline'
                            }
                        },
                        viewId: (0, $4cTDP.fg)('jira_timeline_graphql_view_type') ? 'timeline_default' : 'list_default',
                        isInlineEditingEnabled: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')
                    }
                }
            }
        };
    }
});

});
parcelRegister("joets", function(module, exports) {
$parcel$export(module.exports, "default", () => $035bf5892e1c5fbb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2b5e2b1390947ebe31c6e6ea5a56034>>
 * @relayHash c3c465f8a459dc7491b4e4a8eae7839c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 985759d3ae3a2c9abd4eaaab23c29b0b1bb53e14207151f087a6aeb785f2614a
const $035bf5892e1c5fbb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "985759d3ae3a2c9abd4eaaab23c29b0b1bb53e14207151f087a6aeb785f2614a",
        "metadata": {},
        "name": "JiraSoftwareTimelineAppQuery",
        "operationKind": "query",
        "text": null
    }
};
var $035bf5892e1c5fbb$export$2e2bcd8739ae039 = $035bf5892e1c5fbb$var$node;

});

parcelRegister("ky617", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("2WwYx")
]).then(()=>parcelRequire('6nOV4'));

});


parcelRegister("9l6MC", function(module, exports) {
$parcel$export(module.exports, "roadmapViewClassicEntrypoint", () => $0627e011b9c3909f$export$583357f75b3be3a7);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $0627e011b9c3909f$export$583357f75b3be3a7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("hgLl8")), {
        moduleId: "7a5c4192",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hgLl8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jtON9").then(()=>parcelRequire('cfAGP'));

});




parcelRegister("b4ktm", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineRouteEntry", () => $2ae5fd59ddeb8280$export$ace6a996c7e99f3);

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $gVZAI = parcelRequire("gVZAI");

var $6200o = parcelRequire("6200o");

var $dZ1hs = parcelRequire("dZ1hs");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $5L7qx = parcelRequire("5L7qx");

var $e1vE6 = parcelRequire("e1vE6");

var $1G20J = parcelRequire("1G20J");

var $1302Y = parcelRequire("1302Y");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $9HMp0 = parcelRequire("9HMp0");
const $2ae5fd59ddeb8280$export$ace6a996c7e99f3 = (0, $6xToB.createEntry)((0, $6200o.softwareTimelineRoute), ()=>({
        group: 'software',
        skeleton: (0, $dZ1hs.RoadmapSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $8FCAy.softwareProjectLayoutCode), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dZRaT.projectContextResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gVZAI.nextGenRoadmapResource),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $1302Y.getIsSoftwareThemingEnabled)(), (0, $1G20J.projectThemeResource)),
            (0, $5L7qx.resourceWithCondition2)(()=>(0, $4cTDP.fg)('ai_sprint_goal_gate'), (0, $e1vE6.aiEntitlementResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        entryPoint: ()=>// eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') && (0, $cxKOj.expValEquals)('jira_timeline_harmonisation_m3', 'isEnabled', true) ? (0, $9HMp0.softwareHarmonisedTimelinePageEntrypoint) : (0, $9HMp0.softwareTimelinePageEntrypoint),
        ufoName: 'next-gen-roadmap',
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-timeline-entries/src/softwareTimelineRouteEntry.tsx',
                whichExportToUse: 'softwareTimelineRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("6200o", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineRoute", () => $add6335d703ccc5e$export$d25dafcda96d5af9);
const $add6335d703ccc5e$export$d25dafcda96d5af9 = {
    name: 'software-timeline',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("9HMp0", function(module, exports) {
$parcel$export(module.exports, "softwareTimelinePageEntrypoint", () => $6639053e514fce7b$export$3315ee4fac32ee8);
$parcel$export(module.exports, "softwareHarmonisedTimelinePageEntrypoint", () => $6639053e514fce7b$export$f20e0eee7b207ac6);

var $3MgfG = parcelRequire("3MgfG");

var $deUmF = parcelRequire("deUmF");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $5RW99 = parcelRequire("5RW99");

var $lixcc = parcelRequire("lixcc");

var $baOTS = parcelRequire("baOTS");

var $1tNcH = parcelRequire("1tNcH");
const $6639053e514fce7b$var$pageEntryPointConfig = {
    main: (0, $1tNcH.softwareTimelineEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $lixcc.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $baOTS.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
};
const $6639053e514fce7b$export$3315ee4fac32ee8 = (0, $g8uYY.createPageEntryPoint)($6639053e514fce7b$var$pageEntryPointConfig);
const $6639053e514fce7b$export$f20e0eee7b207ac6 = (0, $g8uYY.createPageEntryPoint)({
    ...$6639053e514fce7b$var$pageEntryPointConfig,
    main: (0, $deUmF.softwareTimelineEntrypoint)
});

});
parcelRegister("1tNcH", function(module, exports) {
$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $99541c1075010b47$export$85a905c235ac34bb);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $99541c1075010b47$export$85a905c235ac34bb = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3MCgO")), {
        moduleId: "7e6b0610",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("bbpTw", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", () => $4efa1afec1282a7c$export$83102a6097008c79);

var $7mF43 = parcelRequire("7mF43");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $e8qID = parcelRequire("e8qID");

var $biYD4 = parcelRequire("biYD4");

var $pXQf9 = parcelRequire("pXQf9");

var $b9TxA = parcelRequire("b9TxA");
const $4efa1afec1282a7c$export$83102a6097008c79 = (0, $6xToB.createEntry)((0, $biYD4.softwareVersionDetailEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page-embed',
        component: (0, $b9TxA.VersionDetailPage),
        skeleton: (0, $pXQf9.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $6dwgv.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $e8qID.versionDetailsRelayResourceCustom),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $b9TxA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-version-detail-embed'),
                teamName: 'jolt'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-versions-entries/src/softwareVersionDetailEmbedRouteEntry.tsx',
                whichExportToUse: 'softwareVersionDetailEmbedRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("e8qID", function(module, exports) {
$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $093af761ad29e12a$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $j4oe4 = parcelRequire("j4oe4");

var $8oKDI = parcelRequire("8oKDI");

var $7zZ4w = parcelRequire("7zZ4w");

var $jjfy5 = parcelRequire("jjfy5");

var $9FYIg = parcelRequire("9FYIg");

var $4cTDP = parcelRequire("4cTDP");

var $gxaZP = parcelRequire("gxaZP");

var $jom8W = parcelRequire("jom8W");

var $lmneG = parcelRequire("lmneG");

var $aV23b = parcelRequire("aV23b");

var $l1VxS = parcelRequire("l1VxS");

const $093af761ad29e12a$export$c56c5b19da4d0fd1 = (0, $l1VxS.createResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${(0, $c2c2624ba1e66154$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId, projectKey: projectKey } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $lmneG.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            cloudAri: (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $aV23b.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
            cloudId: tenantContext.cloudId,
            projectKey: projectKey || '',
            isReleasesUpdateStatusPermissionFixEnabled: (0, $4cTDP.fg)('jira-releases-update-status-permission-fix')
        };
        const queryReference = (0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), (0, $gxaZP.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $jjfy5.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("gxaZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $910b8eb3fcf5cae4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d80440392fbc1a8dc71584d6ecd98b2>>
 * @relayHash a880580d17ea37c1ecf818a2e8b64373
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114
const $910b8eb3fcf5cae4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $910b8eb3fcf5cae4$export$2e2bcd8739ae039 = $910b8eb3fcf5cae4$var$node;

});

parcelRegister("lmneG", function(module, exports) {
$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $453b056fc5ef9815$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $453b056fc5ef9815$export$3d12d3ffbce57135);

var $9TL1j = parcelRequire("9TL1j");


var $lFI9l = parcelRequire("lFI9l");

var $fnAle = parcelRequire("fnAle");
const $453b056fc5ef9815$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $453b056fc5ef9815$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $fnAle.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013] != null ? parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013].filter((0, $lFI9l.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $453b056fc5ef9815$var$accountIdToAriStr(parsedQueryParams[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $453b056fc5ef9815$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $9TL1j.useQueryParams)((0, $3b2c8cea68e59ddc$export$e39925d10cebc0b), (0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac), (0, $3b2c8cea68e59ddc$export$c307007520232013), (0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd), (0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2), (0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6), (0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb));
    return $453b056fc5ef9815$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("9TL1j", function(module, exports) {
$parcel$export(module.exports, "useQueryParams", () => $9b93c18fc273cb0f$export$b37ee0d76c6d2fbc);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $jPROM = parcelRequire("jPROM");

var $4lYQk = parcelRequire("4lYQk");

var $b5RwB = parcelRequire("b5RwB");

var $hrKgE = parcelRequire("hrKgE");

var $gCY1z = parcelRequire("gCY1z");
const $9b93c18fc273cb0f$export$b37ee0d76c6d2fbc = (...unstableQueryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $gCY1z.useRouter)();
    const queryParamsRef = (0, $eJOHy.useRef)({});
    // ensure queryParamsToWatch is not a new array on every invocation
    const queryParamsToWatch = (0, $hrKgE.useShallowStableReference)(unstableQueryParamsToWatch);
    const parsedQueryParams = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $eJOHy.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $3b2c8cea68e59ddc$export$e39925d10cebc0b = 'text';
const $3b2c8cea68e59ddc$export$b98a7875ddbefaac = 'epics';
const $3b2c8cea68e59ddc$export$c307007520232013 = 'statusCategory';
const $3b2c8cea68e59ddc$export$2552faed9df6a2cd = 'warnings';
const $3b2c8cea68e59ddc$export$f78d8c81fcad32a2 = 'assignee';
const $3b2c8cea68e59ddc$export$13d5b2891ca65cd6 = 'sortBy';
const $3b2c8cea68e59ddc$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("lFI9l", function(module, exports) {
$parcel$export(module.exports, "isWarningsFilterValue", () => $f1972a48dcbcd304$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $f1972a48dcbcd304$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $f1972a48dcbcd304$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $f1972a48dcbcd304$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $f1972a48dcbcd304$export$dfece8cb679d32a3);

var $jx0Vw = parcelRequire("jx0Vw");
const $f1972a48dcbcd304$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $f1972a48dcbcd304$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($f1972a48dcbcd304$export$5c25bcf27380084);
const $f1972a48dcbcd304$export$3af93bbba0d4241a = (val)=>val === (0, $jx0Vw.TODO) || val === (0, $jx0Vw.IN_PROGRESS) || val === (0, $jx0Vw.DONE);
const $f1972a48dcbcd304$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $f1972a48dcbcd304$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("jx0Vw", function(module, exports) {
$parcel$export(module.exports, "UNDEFINED", () => $89523e1d4dcff547$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $89523e1d4dcff547$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $89523e1d4dcff547$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $89523e1d4dcff547$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $89523e1d4dcff547$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $89523e1d4dcff547$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $89523e1d4dcff547$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $89523e1d4dcff547$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $89523e1d4dcff547$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $89523e1d4dcff547$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $89523e1d4dcff547$export$d928f247c903643a);
const $89523e1d4dcff547$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $89523e1d4dcff547$export$aa456a5030160740 = 'TODO';
const $89523e1d4dcff547$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $89523e1d4dcff547$export$71efb3495f6084f2 = 'DONE';
const $89523e1d4dcff547$export$d9119300f9d9a815 = [
    $89523e1d4dcff547$export$6db089fe7b26f5b6,
    $89523e1d4dcff547$export$aa456a5030160740,
    $89523e1d4dcff547$export$5a9ac66c2785cc13,
    $89523e1d4dcff547$export$71efb3495f6084f2
];
const $89523e1d4dcff547$var$statusCategories = [
    {
        id: '1',
        statusCategory: $89523e1d4dcff547$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $89523e1d4dcff547$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $89523e1d4dcff547$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $89523e1d4dcff547$export$71efb3495f6084f2
    }
];
const $89523e1d4dcff547$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $89523e1d4dcff547$export$3f42f49c284d5b58 = Object.freeze({
    [$89523e1d4dcff547$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.NEW]: 2,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.DONE]: 3,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $89523e1d4dcff547$export$f3f919dc0f56d9eb = Object.values($89523e1d4dcff547$export$5d42a08d46cffe7);
const $89523e1d4dcff547$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $89523e1d4dcff547$export$6db089fe7b26f5b6;
};
const $89523e1d4dcff547$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $89523e1d4dcff547$export$d928f247c903643a = (key)=>$89523e1d4dcff547$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("fnAle", function(module, exports) {
$parcel$export(module.exports, "isAnyFilterApplied", () => $3d595c70b0b1b789$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $3d595c70b0b1b789$export$67c4cee80a3410cd);

var $2QZBX = parcelRequire("2QZBX");


var $lFI9l = parcelRequire("lFI9l");
const $3d595c70b0b1b789$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$c307007520232013].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2].length > 0;
const $3d595c70b0b1b789$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $2QZBX.toIssueId));
const $3d595c70b0b1b789$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $lFI9l.isVersionStatusCategory));
const $3d595c70b0b1b789$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $lFI9l.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $3d595c70b0b1b789$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $2QZBX.toAccountId)(str.trim()));
const $3d595c70b0b1b789$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b] = paramsRaw[0, $3b2c8cea68e59ddc$export$e39925d10cebc0b];
    result[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac] = $3d595c70b0b1b789$export$2a2e94972ab280d4(paramsRaw[0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac]);
    result[0, $3b2c8cea68e59ddc$export$c307007520232013] = $3d595c70b0b1b789$export$fb136b568c6d78b5(paramsRaw[0, $3b2c8cea68e59ddc$export$c307007520232013]);
    result[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] = $3d595c70b0b1b789$export$5cb324c621ca24e8(paramsRaw[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd]);
    result[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2] = $3d595c70b0b1b789$export$6c8eda0352c7cf5(paramsRaw[0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2]);
    result[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] = paramsRaw[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] && (0, $lFI9l.isSortBy)(paramsRaw[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6]) ? paramsRaw[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] = paramsRaw[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] && (0, $lFI9l.isSortOrder)(paramsRaw[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb]) ? paramsRaw[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $c2c2624ba1e66154$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("biYD4", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailEmbedRoute", () => $db2f0457e0cd0a5e$export$78d11017d9c9ed74);
const $db2f0457e0cd0a5e$export$78d11017d9c9ed74 = {
    name: 'software-version-detail-embed',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
    exact: true
};

});

parcelRegister("pXQf9", function(module, exports) {
$parcel$export(module.exports, "VersionDetailSkeleton", () => $57678ade70775797$export$b3661a594ba34350);

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $6ngdy = parcelRequire("6ngdy");
const $57678ade70775797$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6ngdy)))
    });

});
parcelRegister("6ngdy", function(module, exports) {
module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();

});


parcelRegister("b9TxA", function(module, exports) {
$parcel$export(module.exports, "LazyVersionDetail", () => $b47f0cbc811edfc4$export$2d31f5f47e6584e0);
$parcel$export(module.exports, "VersionDetailPage", () => $b47f0cbc811edfc4$export$231cc5186b991031);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $b47f0cbc811edfc4$export$2d31f5f47e6584e0 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("iI4MY"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $b47f0cbc811edfc4$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $b47f0cbc811edfc4$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("iI4MY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("hKgWQ")
]).then(()=>parcelRequire('dHrmQ'));

});



parcelRegister("hSovm", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", () => $7deeca3407c19851$export$f29aafdff734071c);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $i5UPO = parcelRequire("i5UPO");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $b9TxA = parcelRequire("b9TxA");

var $6sjNg = parcelRequire("6sjNg");
const $7deeca3407c19851$export$f29aafdff734071c = (0, $6xToB.createEntry)((0, $i5UPO.softwareVersionDetailLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $6sjNg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ],
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b9TxA.LazyVersionDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-versions-entries/src/softwareVersionDetailLegacyRedirectRouteEntry.tsx',
                whichExportToUse: 'softwareVersionDetailLegacyRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("i5UPO", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRoute", () => $a0f678f2aeb0b7bf$export$3fc8dbcec208bca0);
const $a0f678f2aeb0b7bf$export$3fc8dbcec208bca0 = {
    name: 'software-version-detail-legacy-redirect',
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("6sjNg", function(module, exports) {
$parcel$export(module.exports, "VersionDetailPageLegacyRedirect", () => $8e2c5568143424b0$export$8524eef1a0d9339);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
const $8e2c5568143424b0$export$8524eef1a0d9339 = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};

});


parcelRegister("bwfaS", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", () => $7489c06f979d3a22$export$28d16aae32969765);

var $kHlOR = parcelRequire("kHlOR");

var $hS1gr = parcelRequire("hS1gr");

var $5RW99 = parcelRequire("5RW99");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $luYFh = parcelRequire("luYFh");

var $8FCAy = parcelRequire("8FCAy");

var $b9TxA = parcelRequire("b9TxA");

var $6sjNg = parcelRequire("6sjNg");
const $7489c06f979d3a22$export$28d16aae32969765 = (0, $6xToB.createEntry)((0, $luYFh.softwareVersionDetailNoTabPathRedirectRoute), ()=>({
        group: 'software',
        component: (0, $6sjNg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ],
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b9TxA.LazyVersionDetail)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-versions-entries/src/softwareVersionDetailNoTabPathRedirectRouteEntry.tsx',
                whichExportToUse: 'softwareVersionDetailNoTabPathRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("luYFh", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRoute", () => $487375562c86a47b$export$f22288f2d2f1b9ea);
const $487375562c86a47b$export$f22288f2d2f1b9ea = {
    name: 'software-version-detail-no-tab-path',
    path: '/projects/:projectKey/versions/:versionId'
};

});


parcelRegister("3B2tH", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailRouteEntry", () => $056260fcccda16c0$export$c97dabcfe9d495fa);

var $7mF43 = parcelRequire("7mF43");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $k6duF = parcelRequire("k6duF");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $e8qID = parcelRequire("e8qID");

var $jGzvY = parcelRequire("jGzvY");

var $pXQf9 = parcelRequire("pXQf9");

var $8FCAy = parcelRequire("8FCAy");

var $b9TxA = parcelRequire("b9TxA");
const $056260fcccda16c0$export$c97dabcfe9d495fa = (0, $6xToB.createEntry)((0, $jGzvY.softwareVersionDetailRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page',
        component: (0, $b9TxA.VersionDetailPage),
        skeleton: (0, $pXQf9.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $8FCAy.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: [
                (0, $gHEJe.default),
                (0, $k6duF.default)
            ]
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $e8qID.versionDetailsRelayResourceCustom),
            (0, $dZRaT.projectContextResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $b9TxA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))('software-version-detail'),
                teamName: 'jolt'
            }
        },
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-versions-entries/src/softwareVersionDetailRouteEntry.tsx',
                whichExportToUse: 'softwareVersionDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jGzvY", function(module, exports) {
$parcel$export(module.exports, "softwareVersionDetailRoute", () => $c01056ae20384729$export$eb3633614d0521b0);
const $c01056ae20384729$export$eb3633614d0521b0 = {
    name: 'software-version-detail',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab'
};

});


parcelRegister("k5ls9", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundClassicRouteEntry", () => $4613376441cf04e1$export$191700cbad42b1f0);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $iUszy = parcelRequire("iUszy");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $lqm4V = parcelRequire("lqm4V");
const $4613376441cf04e1$export$191700cbad42b1f0 = (0, $6xToB.createEntry)((0, $iUszy.softwareViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $lqm4V.projectViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-view-not-found-entries/src/softwareViewNotFoundClassicRouteEntry.tsx',
                whichExportToUse: 'softwareViewNotFoundClassicRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("iUszy", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundClassicRoute", () => $1971c449be2d04e5$export$7d9d54603ab2405d);
const $1971c449be2d04e5$export$7d9d54603ab2405d = {
    name: 'software-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/not-found'
};

});


parcelRegister("4MZMG", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundRouteEntry", () => $d56fcee8471bd245$export$7dab5fe9ccb76142);

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $gHEJe = parcelRequire("gHEJe");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $lMlAU = parcelRequire("lMlAU");

var $hS1gr = parcelRequire("hS1gr");

var $8FCAy = parcelRequire("8FCAy");

var $lqm4V = parcelRequire("lqm4V");
const $d56fcee8471bd245$export$7dab5fe9ccb76142 = (0, $6xToB.createEntry)((0, $lMlAU.softwareViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $8FCAy.softwareProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $gHEJe.default),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $lqm4V.projectViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-view-not-found-entries/src/softwareViewNotFoundRouteEntry.tsx',
                whichExportToUse: 'softwareViewNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("lMlAU", function(module, exports) {
$parcel$export(module.exports, "softwareViewNotFoundRoute", () => $f907c0d8f3b26026$export$d72ea457f192511a);
const $f907c0d8f3b26026$export$d72ea457f192511a = {
    name: 'software-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/not-found'
};

});


parcelRegister("24gKw", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRedirectRouteEntry", () => $2ee8742bdcb17b15$export$7c2e1ea4fc4a192f);

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $aNm4v = parcelRequire("aNm4v");

var $bIKjp = parcelRequire("bIKjp");

var $ddnsq = parcelRequire("ddnsq");
const $2ee8742bdcb17b15$export$7c2e1ea4fc4a192f = (0, $6xToB.createEntry)((0, $bIKjp.systemConfigurationRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $ddnsq.default),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aNm4v.systemConfigurationGeneralResource)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-system-configuration-entries/src/systemConfigurationRedirectRouteEntry.tsx',
                whichExportToUse: 'systemConfigurationRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("bIKjp", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRedirectRoute", () => $3c632af1592fd7a2$export$fe4807c49c838619);
const $3c632af1592fd7a2$export$fe4807c49c838619 = {
    name: 'system-configuration-general-redirect',
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("ddnsq", function(module, exports) {
$parcel$export(module.exports, "default", () => $15de031707fe4265$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7fTjp = parcelRequire("7fTjp");
const $15de031707fe4265$var$SystemConfigurationGeneralRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });
var $15de031707fe4265$export$2e2bcd8739ae039 = $15de031707fe4265$var$SystemConfigurationGeneralRedirect;

});


parcelRegister("g09EF", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRouteEntry", () => $ebc71916855bf4f7$export$360a82088f35f2f);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $aNm4v = parcelRequire("aNm4v");

var $abqtT = parcelRequire("abqtT");

var $5fjzQ = parcelRequire("5fjzQ");

var $lglN2 = parcelRequire("lglN2");
const $ebc71916855bf4f7$export$360a82088f35f2f = (0, $6xToB.createEntry)((0, $abqtT.systemConfigurationRoute), ()=>({
        group: 'global-settings',
        component: (0, $lglN2.default),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $aNm4v.systemConfigurationGeneralResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $lglN2.LazySystemConfigurationGeneral)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-admin-pages-system-configuration-entries/src/systemConfigurationRouteEntry.tsx',
                whichExportToUse: 'systemConfigurationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("abqtT", function(module, exports) {
$parcel$export(module.exports, "systemConfigurationRoute", () => $874d4d0fe60ce0f1$export$6823cb5626e61bc7);
const $874d4d0fe60ce0f1$export$6823cb5626e61bc7 = {
    name: 'system-configuration-general',
    path: '/jira/settings/system/general-configuration',
    exact: true
};

});

parcelRegister("lglN2", function(module, exports) {
$parcel$export(module.exports, "LazySystemConfigurationGeneral", () => $a9db316bd4d3ce4b$export$c452a8c622781ccd);
$parcel$export(module.exports, "default", () => $a9db316bd4d3ce4b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $a9db316bd4d3ce4b$export$c452a8c622781ccd = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("bCdgu"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
const $a9db316bd4d3ce4b$var$AsyncSystemConfigurationGeneral = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $a9db316bd4d3ce4b$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });
var $a9db316bd4d3ce4b$export$2e2bcd8739ae039 = $a9db316bd4d3ce4b$var$AsyncSystemConfigurationGeneral;

});
parcelRegister("bCdgu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("440Mx").then(()=>parcelRequire('r0ivy'));

});



parcelRegister("as2yW", function(module, exports) {
$parcel$export(module.exports, "systemDashboardEditRouteEntry", () => $144f46dad9ea25f5$export$15f76f1b0d2d671);

var $kHlOR = parcelRequire("kHlOR");

var $7IYIF = parcelRequire("7IYIF");

var $grWOk = parcelRequire("grWOk");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $jlaZM = parcelRequire("jlaZM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $5iRTf = parcelRequire("5iRTf");

var $en43l = parcelRequire("en43l");
const $144f46dad9ea25f5$export$15f76f1b0d2d671 = (0, $6xToB.createEntry)((0, $5iRTf.systemDashboardEditRoute), ()=>({
        group: 'dashboard',
        component: (0, $en43l.SystemDashboardEditPage),
        layout: (0, $6dwgv.composeLayouts)((0, $yRJUA.globalSettingsLayout), (0, $7IYIF.dashboardBackgroundScriptsLayout)),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            // IMPORTANT - SSR requires wrm resource must come first
            ...(0, $en43l.dashboardResources)(),
            (0, $jlaZM.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $en43l.LazySystemDashboardEdit),
            (0, $en43l.LazyForPaintBackgroundScripts),
            (0, $en43l.LazyForPaintConnectJsApi)
        ],
        earlyAssets: (0, $grWOk.NORMAL_EARLY_ASSET_STRATEGY),
        wrmMode: 'early',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-dashboard-entries/src/systemDashboardEditRouteEntry.tsx',
                whichExportToUse: 'systemDashboardEditRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("5iRTf", function(module, exports) {
$parcel$export(module.exports, "systemDashboardEditRoute", () => $b761190ac823a0c8$export$7367fb465296c7dd);
const $b761190ac823a0c8$export$7367fb465296c7dd = {
    name: 'system-dashboard-edit',
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});


parcelRegister("jlw0X", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationCreateRouteEntry", () => $979152fb4a409e56$export$83aea99d18750f08);

var $37Rs8 = parcelRequire("37Rs8");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $duKeY = parcelRequire("duKeY");

var $9bIMK = parcelRequire("9bIMK");

var $cbgXG = parcelRequire("cbgXG");

var $h5q0o = parcelRequire("h5q0o");
const $979152fb4a409e56$export$83aea99d18750f08 = (0, $6xToB.createEntry)((0, $duKeY.teamIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $cbgXG.IntegrationCreate),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).integrationListResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/teamIntegrationCreateRouteEntry.tsx',
                whichExportToUse: 'teamIntegrationCreateRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("duKeY", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationCreateRoute", () => $ccfe59fd8411d71c$export$a2ec7da6c43acbbf);
const $ccfe59fd8411d71c$export$a2ec7da6c43acbbf = {
    name: 'eoc-team-integration-create',
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};

});


parcelRegister("VMQYl", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationDetailRouteEntry", () => $71d5a5878a50c5c7$export$7e0b6b79953422c1);

var $37Rs8 = parcelRequire("37Rs8");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $gdMif = parcelRequire("gdMif");

var $9bIMK = parcelRequire("9bIMK");

var $6M51H = parcelRequire("6M51H");

var $h5q0o = parcelRequire("h5q0o");
const $71d5a5878a50c5c7$export$7e0b6b79953422c1 = (0, $6xToB.createEntry)((0, $gdMif.teamIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $6M51H.IntegrationDetail),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/teamIntegrationDetailRouteEntry.tsx',
                whichExportToUse: 'teamIntegrationDetailRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gdMif", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationDetailRoute", () => $684ec74b48219eb6$export$72169399df792b7c);
const $684ec74b48219eb6$export$72169399df792b7c = {
    name: 'eoc-team-integration-detail',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};

});


parcelRegister("8t3Bs", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationListRouteEntry", () => $710d56bcd50cac17$export$52ee366e7b51f38d);

var $37Rs8 = parcelRequire("37Rs8");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $2KkZM = parcelRequire("2KkZM");

var $9bIMK = parcelRequire("9bIMK");

var $juImm = parcelRequire("juImm");

var $h5q0o = parcelRequire("h5q0o");
const $710d56bcd50cac17$export$52ee366e7b51f38d = (0, $6xToB.createEntry)((0, $2KkZM.teamIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: (0, $juImm.IntegrationList),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $37Rs8.resources).integrationListResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/teamIntegrationListRouteEntry.tsx',
                whichExportToUse: 'teamIntegrationListRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("2KkZM", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationListRoute", () => $e9f54f716c255223$export$b8218f375778e6d7);
const $e9f54f716c255223$export$b8218f375778e6d7 = {
    name: 'eoc-team-integration-list',
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};

});


parcelRegister("gqlkg", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationLogRouteEntry", () => $4364bc433855a188$export$d5e169223d2a5d1d);

var $cVewO = parcelRequire("cVewO");

var $37Rs8 = parcelRequire("37Rs8");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $88S91 = parcelRequire("88S91");

var $9bIMK = parcelRequire("9bIMK");

var $1MNgS = parcelRequire("1MNgS");

var $h5q0o = parcelRequire("h5q0o");
const $4364bc433855a188$export$d5e169223d2a5d1d = (0, $6xToB.createEntry)((0, $88S91.teamIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        slot: (0, $1MNgS.IntegrationLog),
        layout: (0, $igwPu.opsTeamLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            ...(0, $cVewO.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/teamIntegrationLogRouteEntry.tsx',
                whichExportToUse: 'teamIntegrationLogRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("88S91", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationLogRoute", () => $5d4695307e8439a2$export$ca02d7b2c7df3d60);
const $5d4695307e8439a2$export$ca02d7b2c7df3d60 = {
    name: 'eoc-team-integration-log',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};

});


parcelRegister("4W2Ve", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationsRouteEntry", () => $64bd8ddf48bac1a1$export$ded9494f81dd2a4d);

var $37Rs8 = parcelRequire("37Rs8");

var $dEcKp = parcelRequire("dEcKp");

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $c1Kop = parcelRequire("c1Kop");

var $GnSwp = parcelRequire("GnSwp");

var $igwPu = parcelRequire("igwPu");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $3nX4f = parcelRequire("3nX4f");

var $9bIMK = parcelRequire("9bIMK");

var $h5q0o = parcelRequire("h5q0o");
const $64bd8ddf48bac1a1$export$ded9494f81dd2a4d = (0, $6xToB.createEntry)((0, $3nX4f.teamIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $9bIMK.IntegrationAutomation),
        layout: (0, $igwPu.opsTeamLayout),
        slot: null,
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $dEcKp.resources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            (0, $37Rs8.resources).configuredIntegrationsResource,
            (0, $37Rs8.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PEOPLE,
            sidebar: (0, $c1Kop.default),
            horizontal: (0, $GnSwp.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $GnSwp.LazyHorizontalOperationsNav),
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $h5q0o.LazyIntegrationAutomation),
            (0, $c1Kop.LazyTeamDashboardSidebar)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-integration-automation-entries/src/teamIntegrationsRouteEntry.tsx',
                whichExportToUse: 'teamIntegrationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3nX4f", function(module, exports) {
$parcel$export(module.exports, "teamIntegrationsRoute", () => $897708057bb41356$export$400ead354c81dee3);
const $897708057bb41356$export$400ead354c81dee3 = {
    name: 'eoc-team-integrations',
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};

});


parcelRegister("2qWaR", function(module, exports) {
$parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", () => $9b6487b6b97ef74d$export$dbcd0bd16f12397d);

var $kHlOR = parcelRequire("kHlOR");

var $7h3uc = parcelRequire("7h3uc");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $d0o9Z = parcelRequire("d0o9Z");

var $3C9Q1 = parcelRequire("3C9Q1");
const $9b6487b6b97ef74d$export$dbcd0bd16f12397d = (0, $6xToB.createEntry)((0, $d0o9Z.trashedPlanDirectLinkRoute), ()=>({
        group: 'software',
        component: (0, $3C9Q1.TrashedPlanDirectLink),
        layout: (0, $7h3uc.globalLayout),
        resources: [
            ...(0, $9NmsS.getNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3C9Q1.LazyTrashedPlanDirectLink)
        ],
        ufoName: 'plan-trashed',
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-spa-entries/src/trashedPlanDirectLinkRouteEntry.tsx',
                whichExportToUse: 'trashedPlanDirectLinkRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("d0o9Z", function(module, exports) {
$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $9c159671bcfb1c40$export$1a9edb72cd49ca79);
const $9c159671bcfb1c40$export$1a9edb72cd49ca79 = {
    name: 'trashed-plan-direct-link',
    path: '/jira/plans/plan-trashed',
    exact: true
};

});

parcelRegister("3C9Q1", function(module, exports) {
$parcel$export(module.exports, "LazyTrashedPlanDirectLink", () => $fafa1802058f3c13$export$20a71ac28e6a3c8f);
$parcel$export(module.exports, "TrashedPlanDirectLink", () => $fafa1802058f3c13$export$38f3a061bb1fceee);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $fafa1802058f3c13$export$20a71ac28e6a3c8f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("gcqxl"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $fafa1802058f3c13$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fafa1802058f3c13$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });

});
parcelRegister("gcqxl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eioKP").then(()=>parcelRequire('6Ivy0'));

});



parcelRegister("1rAP5", function(module, exports) {
$parcel$export(module.exports, "trashPlansRouteEntry", () => $f8fc780667250079$export$eabcbe4dd6fc9f1f);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $gbuVC = parcelRequire("gbuVC");

var $dPDum = parcelRequire("dPDum");
const $f8fc780667250079$export$eabcbe4dd6fc9f1f = (0, $6xToB.createEntry)((0, $gbuVC.trashPlansRoute), ()=>({
        group: 'software',
        component: (0, $dPDum.TrashedPlansDirectory),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $dPDum.LazyTrashedPlans)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-advanced-roadmaps-spa-entries/src/trashPlansRouteEntry.tsx',
                whichExportToUse: 'trashPlansRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("gbuVC", function(module, exports) {
$parcel$export(module.exports, "trashPlansRoute", () => $cbeed289af2ec573$export$6f5b50c5dc090fd1);
const $cbeed289af2ec573$export$6f5b50c5dc090fd1 = {
    name: 'trash-plans-directory',
    path: '/jira/plans/settings/trash',
    exact: true
};

});

parcelRegister("dPDum", function(module, exports) {
$parcel$export(module.exports, "LazyTrashedPlans", () => $cf22b7bcbd5e853d$export$6ac18b311b7e51a1);
$parcel$export(module.exports, "TrashedPlansDirectory", () => $cf22b7bcbd5e853d$export$b145fa65818ff157);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $cf22b7bcbd5e853d$export$6ac18b311b7e51a1 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("2Rxc1")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $cf22b7bcbd5e853d$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cf22b7bcbd5e853d$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("2Rxc1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("a3BEG")
]).then(()=>parcelRequire('7nySO'));

});



parcelRegister("4MsHe", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRedirectRouteEntry", () => $605eb15b2e7b45d8$export$8ea64bac0a832a5c);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $g0FMn = parcelRequire("g0FMn");

var $w3dqA = parcelRequire("w3dqA");

var $kIClG = parcelRequire("kIClG");
const $605eb15b2e7b45d8$export$8ea64bac0a832a5c = (0, $6xToB.createEntry)((0, $g0FMn.trashProjectsDirectoryRedirectRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $w3dqA.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kIClG.LazyTrashedProjectsAdmin)
        ],
        isRedirect: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-trash-projects-directory-entries/src/trashProjectsDirectoryRedirectRouteEntry.tsx',
                whichExportToUse: 'trashProjectsDirectoryRedirectRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("g0FMn", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRedirectRoute", () => $18a05d65567ca0ae$export$6eafffd4489b3d4);
const $18a05d65567ca0ae$export$6eafffd4489b3d4 = {
    name: 'trash-projects-directory',
    path: '/secure/projects/trash',
    exact: true
};

});

parcelRegister("w3dqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $358bdfe51ee3c740$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $2mHfh = parcelRequire("2mHfh");
const $358bdfe51ee3c740$var$RedirectToPrettyUrlTrashDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
var $358bdfe51ee3c740$export$2e2bcd8739ae039 = $358bdfe51ee3c740$var$RedirectToPrettyUrlTrashDirectory;

});

parcelRegister("kIClG", function(module, exports) {
$parcel$export(module.exports, "LazyTrashedProjectsAdmin", () => $ec446fe789f8875f$export$dd65a8ee0a9ac24f);
$parcel$export(module.exports, "default", () => $ec446fe789f8875f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $ec446fe789f8875f$export$dd65a8ee0a9ac24f = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("8LlQN"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
const $ec446fe789f8875f$var$AsyncTrashedProjectsAdmin = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $ec446fe789f8875f$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });
var $ec446fe789f8875f$export$2e2bcd8739ae039 = $ec446fe789f8875f$var$AsyncTrashedProjectsAdmin;

});
parcelRegister("8LlQN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("4yYgJ")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("6Z32B")
        ]);
    }),
    $ewTvA("fliVL"),
    $ewTvA("5Yiax")
]).then(()=>parcelRequire('7G6RL'));

});



parcelRegister("ASOiD", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", () => $a8c661d1e519471b$export$27d1f352c2f7acae);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $1sNDy = parcelRequire("1sNDy");

var $kIClG = parcelRequire("kIClG");
const $a8c661d1e519471b$export$27d1f352c2f7acae = (0, $6xToB.createEntry)((0, $1sNDy.trashProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $kIClG.default),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $kIClG.LazyTrashedProjectsAdmin)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-trash-projects-directory-entries/src/trashProjectsDirectoryRouteEntry.tsx',
                whichExportToUse: 'trashProjectsDirectoryRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1sNDy", function(module, exports) {
$parcel$export(module.exports, "trashProjectsDirectoryRoute", () => $3bcd89231fd04722$export$74ec9fecd42fa96e);
const $3bcd89231fd04722$export$74ec9fecd42fa96e = {
    name: 'trash-projects-directory',
    path: '/jira/settings/projects/trash',
    exact: true
};

});


parcelRegister("bxGoH", function(module, exports) {
$parcel$export(module.exports, "unlockOperationsRouteEntry", () => $85ea48dda587c266$export$c058f4d1c0667ce1);

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $6xToB = parcelRequire("6xToB");

var $f2vqd = parcelRequire("f2vqd");

var $9NmsS = parcelRequire("9NmsS");

var $fVIsa = parcelRequire("fVIsa");

var $3eS82 = parcelRequire("3eS82");
const $85ea48dda587c266$export$c058f4d1c0667ce1 = (0, $6xToB.createEntry)((0, $fVIsa.unlockOperationsRoute), ()=>({
        group: 'eoc',
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        component: (0, $3eS82.default),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
            ...(0, $f2vqd.resources)()
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $3eS82.LazyUnlockOperations)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-unlock-operations-entries/src/unlockOperationsRouteEntry.tsx',
                whichExportToUse: 'unlockOperationsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("f2vqd", function(module, exports) {
$parcel$export(module.exports, "resources", () => $dbc35bf824907b7b$export$bc99aaabaf7b70a7);

var $f20Ew = parcelRequire("f20Ew");

const $dbc35bf824907b7b$export$bc99aaabaf7b70a7 = ()=>[
        (0, $f20Ew.transitioningDetailsResource)
    ];

});
parcelRegister("f20Ew", function(module, exports) {
$parcel$export(module.exports, "transitioningDetailsResource", () => $bba77ebbf0bab0ad$export$850d76e0c9ffbdeb);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
const $bba77ebbf0bab0ad$export$7985153d37586c9a = (cloudId)=>(0, $3ugTQ.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $bba77ebbf0bab0ad$export$850d76e0c9ffbdeb = (0, $l1VxS.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$bba77ebbf0bab0ad$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("fVIsa", function(module, exports) {
$parcel$export(module.exports, "unlockOperationsRoute", () => $9fab4d9817e1d941$export$30306de7e00bc5a2);
const $9fab4d9817e1d941$export$30306de7e00bc5a2 = {
    name: 'eoc-unlock-operations',
    path: '/jira/settings/products/ops/unlock',
    exact: true
};

});

parcelRegister("3eS82", function(module, exports) {
$parcel$export(module.exports, "LazyUnlockOperations", () => $bced93423642f8ef$export$55e4754d556d072);
$parcel$export(module.exports, "default", () => $bced93423642f8ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $bced93423642f8ef$export$55e4754d556d072 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1oqpl")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
const $bced93423642f8ef$var$AsyncUnlockOperations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $bced93423642f8ef$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });
var $bced93423642f8ef$export$2e2bcd8739ae039 = $bced93423642f8ef$var$AsyncUnlockOperations;

});
parcelRegister("1oqpl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dQsRO").then(()=>parcelRequire('gwOgn'));

});



parcelRegister("7dAIb", function(module, exports) {
$parcel$export(module.exports, "userBoardRouteEntry", () => $e55a384a1e4ec903$export$cde4dacc737dc0f1);

var $grWOk = parcelRequire("grWOk");

var $ioHIu = parcelRequire("ioHIu");

var $iIsIs = parcelRequire("iIsIs");

var $eJe5A = parcelRequire("eJe5A");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $6dwgv = parcelRequire("6dwgv");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $5PY5j = parcelRequire("5PY5j");

var $zNGiI = parcelRequire("zNGiI");

var $hS1gr = parcelRequire("hS1gr");

var $1iLM1 = parcelRequire("1iLM1");
const $e55a384a1e4ec903$export$cde4dacc737dc0f1 = (0, $6xToB.createEntry)((0, $5PY5j.userBoardRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        layout: (0, $6dwgv.composeLayouts)((0, $ioHIu.genericProjectLayout), (0, $iIsIs.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $eJe5A.LazyIssueApp)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        earlyAssets: (0, $grWOk.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        entryPoint: ()=>(0, $1iLM1.userBoardPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-user-board-entries/src/userBoardRouteEntry.tsx',
                whichExportToUse: 'userBoardRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("1iLM1", function(module, exports) {
$parcel$export(module.exports, "userBoardPageEntrypoint", () => $4fbbdeaf51ac3b77$export$606f36f7912a11ef);

var $3MgfG = parcelRequire("3MgfG");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $iJnZt = parcelRequire("iJnZt");

var $5RW99 = parcelRequire("5RW99");
const $4fbbdeaf51ac3b77$export$606f36f7912a11ef = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $iJnZt.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint),
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});


parcelRegister("53Ske", function(module, exports) {
$parcel$export(module.exports, "userBoardSettingsRouteEntry", () => $c8ec312a14fc7a1e$export$f8e56ba3f544195d);

var $ioHIu = parcelRequire("ioHIu");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6xToB = parcelRequire("6xToB");

var $27Owl = parcelRequire("27Owl");

var $fbgOh = parcelRequire("fbgOh");

var $alzbz = parcelRequire("alzbz");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $c0h8V = parcelRequire("c0h8V");

var $5L7qx = parcelRequire("5L7qx");

var $enr75 = parcelRequire("enr75");

var $zNGiI = parcelRequire("zNGiI");

var $a4jDB = parcelRequire("a4jDB");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");
const $c8ec312a14fc7a1e$export$f8e56ba3f544195d = (0, $6xToB.createEntry)((0, $enr75.userBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $zNGiI.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $a4jDB.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).BOARD_SETTINGS
        },
        layout: (0, $ioHIu.genericProjectLayout),
        // This list is based on the resources needed by ./userBoardRouteEntry.tsx
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $alzbz.getRapidboardResources)(),
            (0, $alzbz.getRapidBoardDataResource)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)(),
            (0, $5L7qx.resourceWithCondition2)((0, $alzbz.shouldLoadUIFBoardResources), (0, $c0h8V.uifBoardResource)),
            (0, $fbgOh.getEditModelResource)(),
            (0, $27Owl.getBoardDetailsResource)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-user-board-entries/src/userBoardSettingsRouteEntry.tsx',
                whichExportToUse: 'userBoardSettingsRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("enr75", function(module, exports) {
$parcel$export(module.exports, "userBoardSettingsRoute", () => $406f872a5975d70b$export$a6e04dfbb956c677);
const $406f872a5975d70b$export$a6e04dfbb956c677 = {
    name: 'rapidboard-user-board-settings',
    path: '/jira/people/:accountId/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});


parcelRegister("l6W7I", function(module, exports) {
$parcel$export(module.exports, "userBoardVelocityRouteEntry", () => $7f61842d2f1b4d7b$export$ba0f726701b9e407);

var $kHlOR = parcelRequire("kHlOR");

var $5RW99 = parcelRequire("5RW99");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $9NmsS = parcelRequire("9NmsS");

var $ioHIu = parcelRequire("ioHIu");

var $ctYnk = parcelRequire("ctYnk");

var $ftHHz = parcelRequire("ftHHz");
const $7f61842d2f1b4d7b$export$ba0f726701b9e407 = (0, $6xToB.createEntry)((0, $ctYnk.userBoardVelocityRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-reports.velocity-report-cmp',
        component: (0, $ftHHz.default),
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            ...(0, $9NmsS.getUserBoardNavigationResources)()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $ftHHz.LazyNextGenVelocityReport)
        ],
        supportsPreviewPanel: true,
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-classic-projects-entries/src/userBoardVelocityRouteEntry.tsx',
                whichExportToUse: 'userBoardVelocityRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("ctYnk", function(module, exports) {
$parcel$export(module.exports, "userBoardVelocityRoute", () => $5fb890b5d4a064a4$export$57431a0e4f3a32e8);
const $5fb890b5d4a064a4$export$57431a0e4f3a32e8 = {
    name: 'software-reports-velocity-user-board',
    path: '/jira/people/:accountId/boards/:boardId/reports/velocity'
};

});

parcelRegister("ftHHz", function(module, exports) {
$parcel$export(module.exports, "LazyNextGenVelocityReport", () => $adbe3280275e9b37$export$a2ca519c668b2f72);
$parcel$export(module.exports, "default", () => $adbe3280275e9b37$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

var $jKFLP = parcelRequire("jKFLP");

const $adbe3280275e9b37$export$a2ca519c668b2f72 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("9O9PP"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index-old.tsx"
});
/** @deprecated delete file after all usages have been migrated to use entry points */ const $adbe3280275e9b37$var$AsyncNextGenVelocityReport = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $adbe3280275e9b37$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $jKFLP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
var $adbe3280275e9b37$export$2e2bcd8739ae039 = $adbe3280275e9b37$var$AsyncNextGenVelocityReport;

});
parcelRegister("9O9PP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ezQBv").then(()=>parcelRequire('aD5wE'));

});



parcelRegister("77YbO", function(module, exports) {
$parcel$export(module.exports, "userBoardViewNotFoundRouteEntry", () => $126b9e2a62933b1e$export$a2bfa34d08651f6d);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $6xToB = parcelRequire("6xToB");

var $dZRaT = parcelRequire("dZRaT");

var $9NmsS = parcelRequire("9NmsS");

var $bTfc4 = parcelRequire("bTfc4");

var $hLmQ9 = parcelRequire("hLmQ9");

var $hS1gr = parcelRequire("hS1gr");

var $38Nv8 = parcelRequire("38Nv8");
const $126b9e2a62933b1e$export$a2bfa34d08651f6d = (0, $6xToB.createEntry)((0, $hLmQ9.userBoardViewNotFoundRoute), ()=>({
        group: 'classic-software',
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $38Nv8.boardViewNotFoundPageEntrypoint),
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-user-board-entries/src/userBoardViewNotFoundRouteEntry.tsx',
                whichExportToUse: 'userBoardViewNotFoundRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("hLmQ9", function(module, exports) {
$parcel$export(module.exports, "userBoardViewNotFoundRoute", () => $5cc754400276a6f5$export$ad6b96e14e735ed7);
const $5cc754400276a6f5$export$ad6b96e14e735ed7 = {
    name: 'rapidboard-user-board-view-not-found',
    path: '/jira/people/:accountId/boards/:boardId/not-found'
};

});


parcelRegister("dNIAB", function(module, exports) {
$parcel$export(module.exports, "userSegmentationRouteEntry", () => $0603f41bf05dd551$export$2af76482b576a135);

var $7K5Ea = parcelRequire("7K5Ea");

var $6xToB = parcelRequire("6xToB");

var $dEVZB = parcelRequire("dEVZB");

var $eY3tt = parcelRequire("eY3tt");
const $0603f41bf05dd551$export$2af76482b576a135 = (0, $6xToB.createEntry)((0, $dEVZB.userSegmentationRoute), ()=>({
        ufoName: 'user-segmentation',
        component: (0, $eY3tt.UserSegmentation),
        layout: (0, $7K5Ea.chromelessLayout),
        forPaint: [
            (0, $eY3tt.LazyUserSegmentation)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-user-segmentation-entries/src/userSegmentationRouteEntry.tsx',
                whichExportToUse: 'userSegmentationRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("dEVZB", function(module, exports) {
$parcel$export(module.exports, "userSegmentationRoute", () => $26a7b7b3b5d63a29$export$b0b13170cadf6395);
const $26a7b7b3b5d63a29$export$b0b13170cadf6395 = {
    name: 'user-segmentation',
    path: '/jira/get-started',
    exact: true
};

});

parcelRegister("eY3tt", function(module, exports) {
$parcel$export(module.exports, "LazyUserSegmentation", () => $cba88a776b834181$export$bf9c9e0729c919f5);
$parcel$export(module.exports, "UserSegmentation", () => $cba88a776b834181$export$15f8c5ccbb9c7ec3);

var $eJOHy = parcelRequire("eJOHy");

var $2dJFW = parcelRequire("2dJFW");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $cba88a776b834181$export$bf9c9e0729c919f5 = (0, $bQWwW.lazyForPaint)(()=>(0, $2dJFW.markAsProductBundleReady)((parcelRequire("aK1sC"))), {
    moduleId: "./src/packages/user-segmentation/src/index.tsx"
});
const $cba88a776b834181$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $cba88a776b834181$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });

});
parcelRegister("aK1sC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2OUd3").then(()=>parcelRequire('821j5'));

});



parcelRegister("zhYLc", function(module, exports) {
$parcel$export(module.exports, "viewIntentRouteEntry", () => $aab34f17fed1aeeb$export$e693459ab8454027);

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $3RrQa = parcelRequire("3RrQa");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $jQAEu = parcelRequire("jQAEu");

var $6PeVL = parcelRequire("6PeVL");

var $g8uYY = parcelRequire("g8uYY");

var $cAYFR = parcelRequire("cAYFR");
const $aab34f17fed1aeeb$var$viewIntentPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $6PeVL.viewIntentEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $aab34f17fed1aeeb$export$e693459ab8454027 = (0, $6xToB.createEntry)((0, $3RrQa.viewIntentRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $aab34f17fed1aeeb$var$viewIntentPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $jQAEu.VirtualAgentViewIntentSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/viewIntentRouteEntry.tsx',
                whichExportToUse: 'viewIntentRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("3RrQa", function(module, exports) {
$parcel$export(module.exports, "viewIntentRoute", () => $351e6af2b89773e7$export$bf8131fb060d0e73);
const $351e6af2b89773e7$export$bf8131fb060d0e73 = {
    name: 'project-settings-servicedesk-virtualagent-view-intent',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
};

});

parcelRegister("jQAEu", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", () => $2e6f43333d437777$export$72b20c10a0f18a2f);
/* VirtualAgentViewIntentSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $1eBd1 = parcelRequire("1eBd1");
const $2e6f43333d437777$var$customCssStyles = null;
const $2e6f43333d437777$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1eBd1))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("1eBd1", function(module, exports) {
module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();

});


parcelRegister("6PeVL", function(module, exports) {
$parcel$export(module.exports, "viewIntentEntryPoint", () => $9c17a74ebb05f28c$export$f51df662bd71ce39);

var $hwPfO = parcelRequire("hwPfO");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9c17a74ebb05f28c$export$f51df662bd71ce39 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("k7TMn")), {
        moduleId: "11f1bf6b",
        moduleName: "VirtualAgentViewIntent",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $hwPfO.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("hwPfO", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b187d8c10253566$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7012544dbd91a229a434fdd3788a25e1>>
 * @relayHash 91887a9e3573303ceca2f07967fb5178
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d8810639e582d4804789963246644a36f4a4dbd630082e7d05e701a633bf346

var $bXR9c = parcelRequire("bXR9c");
const $2b187d8c10253566$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0d8810639e582d4804789963246644a36f4a4dbd630082e7d05e701a633bf346",
        "metadata": {},
        "name": "VirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $2b187d8c10253566$export$2e2bcd8739ae039 = $2b187d8c10253566$var$node;

});

parcelRegister("k7TMn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ePdrf").then(()=>parcelRequire('cAzT1'));

});



parcelRegister("kZdpv", function(module, exports) {
$parcel$export(module.exports, "viewStandardFlowRouteEntry", () => $d954ddb264861fd9$export$84dc2dfc944b0434);

var $lopBx = parcelRequire("lopBx");

var $5RW99 = parcelRequire("5RW99");

var $1f2LE = parcelRequire("1f2LE");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $1PvPk = parcelRequire("1PvPk");

var $jrJ8D = parcelRequire("jrJ8D");

var $aQoXd = parcelRequire("aQoXd");

var $gy2Qg = parcelRequire("gy2Qg");

var $8kk2y = parcelRequire("8kk2y");

var $g8uYY = parcelRequire("g8uYY");

var $dCreL = parcelRequire("dCreL");

var $cAYFR = parcelRequire("cAYFR");
const $d954ddb264861fd9$var$viewStandardFlowPageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $dCreL.viewStandardFlowEntryPoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d954ddb264861fd9$export$84dc2dfc944b0434 = (0, $6xToB.createEntry)((0, $jrJ8D.viewStandardFlowRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $lopBx.isFedRamp)()) return undefined;
            return $d954ddb264861fd9$var$viewStandardFlowPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $cAYFR.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $8kk2y.VirtualAgentViewStandardFlowSkeleton),
        resources: [
            ...(0, $1PvPk.getServiceDeskSettingsResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $gy2Qg.toPackageName)((0, $gy2Qg.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        },
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-project-settings-service-desk-virtual-agent-entries/src/viewStandardFlowRouteEntry.tsx',
                whichExportToUse: 'viewStandardFlowRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("jrJ8D", function(module, exports) {
$parcel$export(module.exports, "viewStandardFlowRoute", () => $a0de3a8c88387eae$export$c74dca8be49046ea);
const $a0de3a8c88387eae$export$c74dca8be49046ea = {
    name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
};

});

parcelRegister("8kk2y", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", () => $36de680e203abb4c$export$c6d3f04e6931e3f6);
/* VirtualAgentViewStandardFlowSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $6rZUg = parcelRequire("6rZUg");
const $36de680e203abb4c$var$customCssStyles = null;
const $36de680e203abb4c$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6rZUg))),
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("6rZUg", function(module, exports) {
module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();

});


parcelRegister("dCreL", function(module, exports) {
$parcel$export(module.exports, "viewStandardFlowEntryPoint", () => $608dd8acb516b7cf$export$4fd7bf09308d4abd);

var $5xFO7 = parcelRequire("5xFO7");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

const $608dd8acb516b7cf$export$4fd7bf09308d4abd = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3SamU")), {
        moduleId: "ea7fb563",
        moduleName: "VirtualAgentViewStandardFlow",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $5xFO7.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        offerEscalationEnabled: (0, $4cTDP.fg)('toggle_offer_escalation_standard_flow_feature') ?? false
                    }
                }
            }
        })
});

});
parcelRegister("5xFO7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d668bf3d811cc37$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<21d4e958c59832aa544cb53e16441030>>
 * @relayHash d34404ea0f67a7a51972f5eff2c30868
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a8bf3dcd28ad0cdb3103facc55cfc33e1ff1cbe25d41b9ceb8b0600065afba06

var $bXR9c = parcelRequire("bXR9c");
const $8d668bf3d811cc37$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a8bf3dcd28ad0cdb3103facc55cfc33e1ff1cbe25d41b9ceb8b0600065afba06",
        "metadata": {},
        "name": "VirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $8d668bf3d811cc37$export$2e2bcd8739ae039 = $8d668bf3d811cc37$var$node;

});

parcelRegister("3SamU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cehAI").then(()=>parcelRequire('4xObW'));

});



parcelRegister("g70C8", function(module, exports) {
$parcel$export(module.exports, "whoIsOnCallRouteEntry", () => $a978136123c31dea$export$fee33ca9661e49dd);

var $hIzUD = parcelRequire("hIzUD");

var $kHlOR = parcelRequire("kHlOR");

var $fz8gQ = parcelRequire("fz8gQ");

var $6xToB = parcelRequire("6xToB");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $h2Unl = parcelRequire("h2Unl");

var $cUt8w = parcelRequire("cUt8w");
const $a978136123c31dea$var$getWhoIsOnCallResources = ()=>(0, $hIzUD.resources);
const $a978136123c31dea$export$fee33ca9661e49dd = (0, $6xToB.createEntry)((0, $h2Unl.whoIsOnCallRoute), ()=>({
        group: 'eoc',
        layout: (0, $fz8gQ.eocChangeboardingLayout),
        component: (0, $cUt8w.WhoIsOnCallComponent),
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $4VIcO.getConsolidationStateResource)(),
            ...$a978136123c31dea$var$getWhoIsOnCallResources()
        ],
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $cUt8w.LazyWhoIsOnCall)
        ],
        bifrost: {
            bifrostGroup: 'shell-only',
            bundling: {
                packageName: '@atlassian/jira-router-routes-eoc-who-is-on-call-entries/src/whoIsOnCallRouteEntry.tsx',
                whichExportToUse: 'whoIsOnCallRouteEntry'
            },
            enabled: true
        }
    }));

});
parcelRegister("h2Unl", function(module, exports) {
$parcel$export(module.exports, "whoIsOnCallRoute", () => $2a0b4e97ee858f6e$export$26b06efd7311586b);
const $2a0b4e97ee858f6e$export$26b06efd7311586b = {
    name: 'eoc-who-is-on-call',
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("cUt8w", function(module, exports) {
$parcel$export(module.exports, "LazyWhoIsOnCall", () => $14f758de812bc6b6$export$7b03e7437c5d4f77);
$parcel$export(module.exports, "WhoIsOnCallComponent", () => $14f758de812bc6b6$export$51430a0cf6ef3c09);

var $eJOHy = parcelRequire("eJOHy");

var $1F9cm = parcelRequire("1F9cm");

var $bQWwW = parcelRequire("bQWwW");

const $14f758de812bc6b6$export$7b03e7437c5d4f77 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lS6yE")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $14f758de812bc6b6$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $14f758de812bc6b6$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("lS6yE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9PiEU").then(()=>parcelRequire('iJQmu'));

});



parcelRegister("ckYTZ", function(module, exports) {
$parcel$export(module.exports, "workItemRouteEntry", () => $5504bb4056a8d605$export$2fea809b4007e17d);

var $4cTDP = parcelRequire("4cTDP");

var $5RW99 = parcelRequire("5RW99");

var $6xToB = parcelRequire("6xToB");

var $5H8cn = parcelRequire("5H8cn");

var $aDtWM = parcelRequire("aDtWM");

var $9NmsS = parcelRequire("9NmsS");

var $lPVME = parcelRequire("lPVME");

var $9xJ2e = parcelRequire("9xJ2e");

var $gmPbY = parcelRequire("gmPbY");
const $5504bb4056a8d605$export$2fea809b4007e17d = (0, $6xToB.createEntry)((0, $5H8cn.workItemRoute), ()=>({
        group: 'work-item',
        navigation: {
            sidebar: (0, $aDtWM.genericProjectSidebars),
            menuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        // bifrost property is set up, which is required for Bifrost SSR onboarding
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-work-items-entries/src/workItemRouteEntry.tsx',
                whichExportToUse: 'workItemRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        },
        meta: {
            capability: 'WORK_ITEM_VIEW'
        },
        resources: [
            (0, $lPVME.issueGiraDataResource),
            ...(0, $9NmsS.getNavigationResourcesForWorkItem)(),
            // List view resources (loaded when ?hasList=true)
            (0, $9xJ2e.workItemConditionalListResources).conditionalIssueNavigatorResource,
            (0, $9xJ2e.workItemConditionalListResources).conditionalFieldsResource,
            (0, $9xJ2e.workItemConditionalListResources).conditionalProjectContextResource
        ],
        entryPoint: ()=>(0, $gmPbY.workItemPageEntrypoint),
        ufoName: 'work-item',
        supportsPreviewPanel: true,
        isHydrateRootEnabled: (0, $4cTDP.fg)('work-item-hydrate-root')
    }));

});
parcelRegister("5H8cn", function(module, exports) {
$parcel$export(module.exports, "workItemRoute", () => $ecc9b08418ae3378$export$cdf7747c91065c7f);
const $ecc9b08418ae3378$export$cdf7747c91065c7f = {
    name: 'work-item',
    exact: true,
    path: '/browse/work-item/:issueKey(\\w+-\\d+)(.*)?'
};

});

parcelRegister("9xJ2e", function(module, exports) {
$parcel$export(module.exports, "workItemConditionalListResources", () => $e66e70449f393ebb$export$b1102804bd8952da);

var $l1VxS = parcelRequire("l1VxS");

var $8k1uC = parcelRequire("8k1uC");

var $ebWJz = parcelRequire("ebWJz");

var $dZRaT = parcelRequire("dZRaT");
/**
 * Extract project key from issue key (e.g., "ABC-123" → "ABC")
 */ const $e66e70449f393ebb$var$extractProjectKeyFromIssueKey = (issueKey)=>{
    if (!issueKey) return null;
    const parts = issueKey.split('-');
    return parts.length >= 2 ? parts[0] : null;
};
/**
 * Creates a conditional resource wrapper that only loads when hasList query param is true.
 * This allows SSR to conditionally load list view resources without impacting default work item performance.
 *
 * For work-item routes, this also extracts projectKey from the issueKey param to ensure proper JQL scoping.
 */ function $e66e70449f393ebb$var$createConditionalListResource(baseResource, resourceName) {
    return (0, $l1VxS.createResource)({
        type: `work-item-list-${resourceName}`,
        getKey: ()=>`work-item-list-${resourceName}`,
        getData: async (routerContext, resourceContext)=>{
            // Only load if hasList query param is explicitly set to 'true'
            if (routerContext.query?.hasList === 'true') {
                // Extract projectKey from issueKey for work-item routes
                const issueKey = routerContext.match.params.issueKey;
                const projectKey = issueKey ? $e66e70449f393ebb$var$extractProjectKeyFromIssueKey(issueKey) : null;
                // Create a modified context with projectKey for resources that need it
                const modifiedContext = {
                    ...routerContext,
                    match: {
                        ...routerContext.match,
                        params: {
                            ...routerContext.match.params,
                            ...projectKey && {
                                projectKey: projectKey
                            }
                        }
                    }
                };
                return baseResource.getData(modifiedContext, resourceContext);
            }
            // Return null to skip loading when not needed
            return null;
        },
        maxAge: baseResource.maxAge || 0
    });
}
/**
 * issue navigator relay resource.
 */ const $e66e70449f393ebb$var$conditionalIssueNavigatorResource = $e66e70449f393ebb$var$createConditionalListResource((0, $8k1uC.issueNavigatorRelayResource), 'issue-navigator');
/**
 * fields resource.
 */ const $e66e70449f393ebb$var$conditionalFieldsResource = $e66e70449f393ebb$var$createConditionalListResource((0, $ebWJz.fieldsResource), 'fields');
/**
 * project context resource.
 */ const $e66e70449f393ebb$var$conditionalProjectContextResource = $e66e70449f393ebb$var$createConditionalListResource((0, $dZRaT.projectContextResource), 'project-context');
const $e66e70449f393ebb$export$b1102804bd8952da = {
    conditionalProjectContextResource: $e66e70449f393ebb$var$conditionalProjectContextResource,
    conditionalFieldsResource: $e66e70449f393ebb$var$conditionalFieldsResource,
    conditionalIssueNavigatorResource: $e66e70449f393ebb$var$conditionalIssueNavigatorResource
};

});

parcelRegister("gmPbY", function(module, exports) {
$parcel$export(module.exports, "workItemPageEntrypoint", () => $15c6244449723ce2$export$16cd62cd4baaf460);

var $3MgfG = parcelRequire("3MgfG");

var $k46A3 = parcelRequire("k46A3");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");
const $15c6244449723ce2$export$16cd62cd4baaf460 = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $k46A3.workItemEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).WORK_ITEM,
    redirect: (0, $3MgfG.userSegRedirectEntrypoint)
});

});
parcelRegister("k46A3", function(module, exports) {
$parcel$export(module.exports, "workItemEntrypoint", () => $db2e192c7fe6ed75$export$7776ba0e0fd82365);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $5cBwY = parcelRequire("5cBwY");
const $db2e192c7fe6ed75$var$getIssueKey = (match)=>{
    return match?.params?.issueKey?.length ? match.params.issueKey : null;
};
const $db2e192c7fe6ed75$var$extractProjectKey = (issueKey)=>issueKey.split('-')[0];

const $db2e192c7fe6ed75$export$7776ba0e0fd82365 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("icccT")), {
        moduleId: "d3baaed3",
        moduleName: "WorkItemSanitisedEntrypoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = context;
        const issueKey = $db2e192c7fe6ed75$var$getIssueKey(match);
        const projectKey = issueKey ? $db2e192c7fe6ed75$var$extractProjectKey(issueKey) : '';
        // Construct JQL to search for issues in this project
        const jql = projectKey ? `project = "${projectKey}"` : '';
        const queryVariables = {
            cloudId: cloudId || '',
            issueKey: issueKey || '',
            projectKey: projectKey,
            jql: jql
        };
        return {
            queries: {
                workItemQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        ...queryVariables
                    },
                    parameters: $5cBwY.default
                }
            }
        };
    }
});

});
parcelRegister("5cBwY", function(module, exports) {
$parcel$export(module.exports, "default", () => $541e14cccb5a6122$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7a8bd10d2a52430e03769d9dda83dde>>
 * @relayHash 79f7543e7b7fcb23f4e4b7b02904a09e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1dcbf8199ff5882d63b20976c16ebfc5227e99088cb86d8ab225363b61ba07ef

var $1NHqW = parcelRequire("1NHqW");

var $1PjiU = parcelRequire("1PjiU");

var $bU8Sj = parcelRequire("bU8Sj");

var $jLDgo = parcelRequire("jLDgo");

var $2INXH = parcelRequire("2INXH");

var $gVub6 = parcelRequire("gVub6");
const $541e14cccb5a6122$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1dcbf8199ff5882d63b20976c16ebfc5227e99088cb86d8ab225363b61ba07ef",
        "metadata": {},
        "name": "WorkItemEntrypointUiQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": (0, $jLDgo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": (0, $gVub6.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $2INXH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": (0, $1NHqW.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default)
        }
    }
};
var $541e14cccb5a6122$export$2e2bcd8739ae039 = $541e14cccb5a6122$var$node;

});

parcelRegister("icccT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("9NARI")
]).then(()=>parcelRequire('25xkK'));

});







//# sourceMappingURL=async-route-map.36720c36.js.map
